// @ts-nocheck
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  bytea: any;
  date: any;
  float8: any;
  json: any;
  jsonb: any;
  numeric: any;
  point: any;
  timestamp: any;
  timestamptz: any;
  uuid: any;
};

export type AcceptOrgInviteOutput = {
  __typename?: 'AcceptOrgInviteOutput';
  error?: Maybe<Scalars['Boolean']>;
  errorMessage?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
};

/** A Field Group registered by ACF */
export type AcfFieldGroup = {
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
};

/** ACF Link field */
export type AcfLink = {
  __typename?: 'AcfLink';
  /** The target of the link (_blank, etc) */
  target?: Maybe<Scalars['String']>;
  /** The title of the link */
  title?: Maybe<Scalars['String']>;
  /** The url of the link */
  url?: Maybe<Scalars['String']>;
};

export type Address = {
  __typename?: 'Address';
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
};

export type AppMembershipData = {
  __typename?: 'AppMembershipData';
  hasAccess?: Maybe<Scalars['Boolean']>;
  id: Scalars['String'];
  organisations: Array<SsoOrganisation>;
  package?: Maybe<Scalars['String']>;
  registered: Scalars['Boolean'];
  roles: Array<SsoRole>;
};

export type ApproveCourseInput = {
  courseId: Scalars['Int'];
  reason: Scalars['String'];
};

export type ApproveCourseOutput = {
  __typename?: 'ApproveCourseOutput';
  error?: Maybe<CourseApprovalError>;
  success: Scalars['Boolean'];
};

export type ArloCallbackInput = {
  url: Scalars['String'];
};

export type ArloCallbackOutput = {
  __typename?: 'ArloCallbackOutput';
  status: Scalars['Boolean'];
};

/** Avatars are profile images for users. WordPress by default uses the Gravatar service to host and fetch avatars from. */
export type Avatar = {
  __typename?: 'Avatar';
  /** URL for the default image or a default type. Accepts &#039;404&#039; (return a 404 instead of a default image), &#039;retro&#039; (8bit), &#039;monsterid&#039; (monster), &#039;wavatar&#039; (cartoon face), &#039;indenticon&#039; (the &#039;quilt&#039;), &#039;mystery&#039;, &#039;mm&#039;, or &#039;mysteryman&#039; (The Oyster Man), &#039;blank&#039; (transparent GIF), or &#039;gravatar_default&#039; (the Gravatar logo). */
  default?: Maybe<Scalars['String']>;
  /** HTML attributes to insert in the IMG element. Is not sanitized. */
  extraAttr?: Maybe<Scalars['String']>;
  /** Whether to always show the default image, never the Gravatar. */
  forceDefault?: Maybe<Scalars['Boolean']>;
  /** Whether the avatar was successfully found. */
  foundAvatar?: Maybe<Scalars['Boolean']>;
  /** Height of the avatar image. */
  height?: Maybe<Scalars['Int']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** What rating to display avatars up to. Accepts &#039;G&#039;, &#039;PG&#039;, &#039;R&#039;, &#039;X&#039;, and are judged in that order. */
  rating?: Maybe<Scalars['String']>;
  /** Type of url scheme to use. Typically HTTP vs. HTTPS. */
  scheme?: Maybe<Scalars['String']>;
  /** The size of the avatar in pixels. A value of 96 will match a 96px x 96px gravatar image. */
  size?: Maybe<Scalars['Int']>;
  /** URL for the gravatar image source. */
  url?: Maybe<Scalars['String']>;
  /** Width of the avatar image. */
  width?: Maybe<Scalars['Int']>;
};

/** What rating to display avatars up to. Accepts 'G', 'PG', 'R', 'X', and are judged in that order. Default is the value of the 'avatar_rating' option */
export enum AvatarRatingEnum {
  /** Indicates a G level avatar rating level. */
  G = 'G',
  /** Indicates a PG level avatar rating level. */
  Pg = 'PG',
  /** Indicates an R level avatar rating level. */
  R = 'R',
  /** Indicates an X level avatar rating level. */
  X = 'X'
}

export enum BildStrategy {
  NonRestrictiveTertiary = 'NON_RESTRICTIVE_TERTIARY',
  Primary = 'PRIMARY',
  RestrictiveTertiaryAdvanced = 'RESTRICTIVE_TERTIARY_ADVANCED',
  RestrictiveTertiaryIntermediate = 'RESTRICTIVE_TERTIARY_INTERMEDIATE',
  Secondary = 'SECONDARY'
}

export enum BillingInterval {
  Day = 'day',
  Month = 'month',
  Week = 'week',
  Year = 'year'
}

export type BlendedLearningAttendeeExportData = {
  __typename?: 'BlendedLearningAttendeeExportData';
  blendedLearningEndDate?: Maybe<Scalars['String']>;
  blendedLearningPass: Scalars['String'];
  blendedLearningStartDate: Scalars['String'];
  blendedLearningStatus: Scalars['String'];
  email: Scalars['String'];
  userName: Scalars['String'];
};

export type BlendedLearningExportDataInput = {
  courseId: Scalars['Int'];
};

export type BlendedLearningExportDataOutput = {
  __typename?: 'BlendedLearningExportDataOutput';
  attendees: Array<BlendedLearningAttendeeExportData>;
  commissioningOrganisationName: Scalars['String'];
  courseCode: Scalars['String'];
  courseEndDate: Scalars['String'];
  courseName: Scalars['String'];
  courseStartDate: Scalars['String'];
  leadTrainerName: Scalars['String'];
};

/** Boolean expression to compare columns of type "Boolean". All fields are combined with logical 'AND'. */
export type Boolean_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Boolean']>;
  _gt?: InputMaybe<Scalars['Boolean']>;
  _gte?: InputMaybe<Scalars['Boolean']>;
  _in?: InputMaybe<Array<Scalars['Boolean']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Boolean']>;
  _lte?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Scalars['Boolean']>;
  _nin?: InputMaybe<Array<Scalars['Boolean']>>;
};

export type CanApplyPromoCodeInput = {
  code: Scalars['String'];
  courseId: Scalars['Int'];
};

export type CanApplyPromoCodeOutput = {
  __typename?: 'CanApplyPromoCodeOutput';
  result?: Maybe<PromoCodeOutput>;
};

export enum CancelIndividualFromCourseError {
  Go1EnrollmentNotFound = 'GO1_ENROLLMENT_NOT_FOUND',
  Go1EnrollmentStarted = 'GO1_ENROLLMENT_STARTED'
}

export type CancelIndividualFromCourseOutput = {
  __typename?: 'CancelIndividualFromCourseOutput';
  error?: Maybe<CancelIndividualFromCourseError>;
  success: Scalars['Boolean'];
};

export enum CancelIndividualFromCourseWaitlistError {
  CourseNotFound = 'COURSE_NOT_FOUND',
  WaitlistNotFound = 'WAITLIST_NOT_FOUND'
}

export type CancelIndividualFromCourseWaitlistInput = {
  courseId: Scalars['Int'];
  waitlistId: Scalars['uuid'];
};

export type CancelIndividualFromCourseWaitlistOutput = {
  __typename?: 'CancelIndividualFromCourseWaitlistOutput';
  error?: Maybe<CancelIndividualFromCourseWaitlistError>;
  success: Scalars['Boolean'];
};

export enum CancelMyselfFromCourseWaitlistError {
  CancellationSecretInvalid = 'CANCELLATION_SECRET_INVALID',
  CourseNotFound = 'COURSE_NOT_FOUND'
}

export type CancelMyselfFromCourseWaitlistInput = {
  cancellationSecret: Scalars['uuid'];
  courseId: Scalars['Int'];
};

export type CancelMyselfFromCourseWaitlistOutput = {
  __typename?: 'CancelMyselfFromCourseWaitlistOutput';
  error?: Maybe<CancelMyselfFromCourseWaitlistError>;
  success: Scalars['Boolean'];
};

export enum CancellationFeeType {
  ApplyCancellationTerms = 'APPLY_CANCELLATION_TERMS',
  CustomFee = 'CUSTOM_FEE',
  NoFees = 'NO_FEES'
}

/** The category type */
export type Category = DatabaseIdentifier & HierarchicalTermNode & MenuItemLinkable & Node & TermNode & UniformResourceIdentifiable & {
  __typename?: 'Category';
  /** The ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<CategoryToAncestorsCategoryConnection>;
  /** The id field matches the WP_Post-&gt;ID field. */
  categoryId?: Maybe<Scalars['Int']>;
  /** Connection between the category type and its children categories. */
  children?: Maybe<CategoryToCategoryConnection>;
  /** Connection between the Category type and the ContentNode type */
  contentNodes?: Maybe<CategoryToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The unique resource identifier path */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** Connection between the category type and its parent category. */
  parent?: Maybe<CategoryToParentCategoryConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
  /** Connection between the Category type and the post type */
  posts?: Maybe<CategoryToPostConnection>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the Category type and the Taxonomy type */
  taxonomy?: Maybe<CategoryToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The category type */
export type CategoryAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The category type */
export type CategoryChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryToCategoryConnectionWhereArgs>;
};


/** The category type */
export type CategoryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryToContentNodeConnectionWhereArgs>;
};


/** The category type */
export type CategoryEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The category type */
export type CategoryEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The category type */
export type CategoryPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CategoryToPostConnectionWhereArgs>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum CategoryIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the Category type and the category type */
export type CategoryToAncestorsCategoryConnection = {
  __typename?: 'CategoryToAncestorsCategoryConnection';
  /** Edges for the CategoryToAncestorsCategoryConnection connection */
  edges?: Maybe<Array<Maybe<CategoryToAncestorsCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Category>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type CategoryToAncestorsCategoryConnectionEdge = {
  __typename?: 'CategoryToAncestorsCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Category>;
};

/** Connection between the Category type and the category type */
export type CategoryToCategoryConnection = {
  __typename?: 'CategoryToCategoryConnection';
  /** Edges for the CategoryToCategoryConnection connection */
  edges?: Maybe<Array<Maybe<CategoryToCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Category>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type CategoryToCategoryConnectionEdge = {
  __typename?: 'CategoryToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Category>;
};

/** Arguments for filtering the CategoryToCategoryConnection connection */
export type CategoryToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Category type and the ContentNode type */
export type CategoryToContentNodeConnection = {
  __typename?: 'CategoryToContentNodeConnection';
  /** Edges for the CategoryToContentNodeConnection connection */
  edges?: Maybe<Array<Maybe<CategoryToContentNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type CategoryToContentNodeConnectionEdge = {
  __typename?: 'CategoryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentNode>;
};

/** Arguments for filtering the CategoryToContentNodeConnection connection */
export type CategoryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfCategoryEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Category type and the category type */
export type CategoryToParentCategoryConnectionEdge = {
  __typename?: 'CategoryToParentCategoryConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Category>;
};

/** Connection between the Category type and the post type */
export type CategoryToPostConnection = {
  __typename?: 'CategoryToPostConnection';
  /** Edges for the CategoryToPostConnection connection */
  edges?: Maybe<Array<Maybe<CategoryToPostConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Post>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type CategoryToPostConnectionEdge = {
  __typename?: 'CategoryToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Post>;
};

/** Arguments for filtering the CategoryToPostConnection connection */
export type CategoryToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Category type and the Taxonomy type */
export type CategoryToTaxonomyConnectionEdge = {
  __typename?: 'CategoryToTaxonomyConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Taxonomy>;
};

export type CheckTtClientsInput = {
  course: Scalars['Int'];
  emailList: Array<Scalars['String']>;
};

export type CheckTtClientsOutput = {
  __typename?: 'CheckTTClientsOutput';
  clientEmails: Array<Scalars['String']>;
  nonClientEmails: Array<Scalars['String']>;
};

/** A Comment object */
export type Comment = DatabaseIdentifier & Node & {
  __typename?: 'Comment';
  /** User agent used to post the comment. This field is equivalent to WP_Comment-&gt;comment_agent and the value matching the &quot;comment_agent&quot; column in SQL. */
  agent?: Maybe<Scalars['String']>;
  /** The approval status of the comment. This field is equivalent to WP_Comment-&gt;comment_approved and the value matching the &quot;comment_approved&quot; column in SQL. */
  approved?: Maybe<Scalars['Boolean']>;
  /** The author of the comment */
  author?: Maybe<CommentToCommenterConnectionEdge>;
  /** IP address for the author. This field is equivalent to WP_Comment-&gt;comment_author_IP and the value matching the &quot;comment_author_IP&quot; column in SQL. */
  authorIp?: Maybe<Scalars['String']>;
  /** ID for the comment, unique among comments. */
  commentId?: Maybe<Scalars['Int']>;
  /** Connection between the Comment type and the ContentNode type */
  commentedOn?: Maybe<CommentToContentNodeConnectionEdge>;
  /** Content of the comment. This field is equivalent to WP_Comment-&gt;comment_content and the value matching the &quot;comment_content&quot; column in SQL. */
  content?: Maybe<Scalars['String']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** Date the comment was posted in local time. This field is equivalent to WP_Comment-&gt;date and the value matching the &quot;date&quot; column in SQL. */
  date?: Maybe<Scalars['String']>;
  /** Date the comment was posted in GMT. This field is equivalent to WP_Comment-&gt;date_gmt and the value matching the &quot;date_gmt&quot; column in SQL. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The globally unique identifier for the comment object */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Karma value for the comment. This field is equivalent to WP_Comment-&gt;comment_karma and the value matching the &quot;comment_karma&quot; column in SQL. */
  karma?: Maybe<Scalars['Int']>;
  /** Connection between the Comment type and the Comment type */
  parent?: Maybe<CommentToParentCommentConnectionEdge>;
  /** The database id of the parent comment node or null if it is the root comment */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent comment node. */
  parentId?: Maybe<Scalars['ID']>;
  /** Connection between the Comment type and the Comment type */
  replies?: Maybe<CommentToCommentConnection>;
  /** Type of comment. This field is equivalent to WP_Comment-&gt;comment_type and the value matching the &quot;comment_type&quot; column in SQL. */
  type?: Maybe<Scalars['String']>;
};


/** A Comment object */
export type CommentContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** A Comment object */
export type CommentParentArgs = {
  where?: InputMaybe<CommentToParentCommentConnectionWhereArgs>;
};


/** A Comment object */
export type CommentRepliesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<CommentToCommentConnectionWhereArgs>;
};

/** A Comment Author object */
export type CommentAuthor = Commenter & Node & {
  __typename?: 'CommentAuthor';
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  avatar?: Maybe<Avatar>;
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int'];
  /** The email for the comment author */
  email?: Maybe<Scalars['String']>;
  /** The globally unique identifier for the comment author object */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** The name for the comment author. */
  name?: Maybe<Scalars['String']>;
  /** The url the comment author. */
  url?: Maybe<Scalars['String']>;
};


/** A Comment Author object */
export type CommentAuthorAvatarArgs = {
  forceDefault?: InputMaybe<Scalars['Boolean']>;
  rating?: InputMaybe<AvatarRatingEnum>;
  size?: InputMaybe<Scalars['Int']>;
};

/** The Type of Identifier used to fetch a single comment node. Default is "ID". To be used along with the "id" field. */
export enum CommentNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID'
}

/** Connection between the Comment type and the Comment type */
export type CommentToCommentConnection = {
  __typename?: 'CommentToCommentConnection';
  /** Edges for the CommentToCommentConnection connection */
  edges?: Maybe<Array<Maybe<CommentToCommentConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Comment>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type CommentToCommentConnectionEdge = {
  __typename?: 'CommentToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Comment>;
};

/** Arguments for filtering the CommentToCommentConnection connection */
export type CommentToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the Comment type and the Commenter type */
export type CommentToCommenterConnectionEdge = {
  __typename?: 'CommentToCommenterConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Commenter>;
};

/** Connection between the Comment type and the ContentNode type */
export type CommentToContentNodeConnectionEdge = {
  __typename?: 'CommentToContentNodeConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<ContentNode>;
};

/** Connection between the Comment type and the Comment type */
export type CommentToParentCommentConnectionEdge = {
  __typename?: 'CommentToParentCommentConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Comment>;
};

/** Arguments for filtering the CommentToParentCommentConnection connection */
export type CommentToParentCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** The author of a comment */
export type Commenter = {
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  avatar?: Maybe<Avatar>;
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int'];
  /** The email address of the author of a comment. */
  email?: Maybe<Scalars['String']>;
  /** The globally unique identifier for the comment author. */
  id: Scalars['ID'];
  /** Whether the author information is considered restricted. (not fully public) */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** The name of the author of a comment. */
  name?: Maybe<Scalars['String']>;
  /** The url of the author of a comment. */
  url?: Maybe<Scalars['String']>;
};

/** Options for ordering the connection */
export enum CommentsConnectionOrderbyEnum {
  /** Order by browser user agent of the commenter. */
  CommentAgent = 'COMMENT_AGENT',
  /** Order by true/false approval of the comment. */
  CommentApproved = 'COMMENT_APPROVED',
  /** Order by name of the comment author. */
  CommentAuthor = 'COMMENT_AUTHOR',
  /** Order by e-mail of the comment author. */
  CommentAuthorEmail = 'COMMENT_AUTHOR_EMAIL',
  /** Order by IP address of the comment author. */
  CommentAuthorIp = 'COMMENT_AUTHOR_IP',
  /** Order by URL address of the comment author. */
  CommentAuthorUrl = 'COMMENT_AUTHOR_URL',
  /** Order by the comment contents. */
  CommentContent = 'COMMENT_CONTENT',
  /** Order by date/time timestamp of the comment. */
  CommentDate = 'COMMENT_DATE',
  /** Order by GMT timezone date/time timestamp of the comment. */
  CommentDateGmt = 'COMMENT_DATE_GMT',
  /** Order by the globally unique identifier for the comment object */
  CommentId = 'COMMENT_ID',
  /** Order by the array list of comment IDs listed in the where clause. */
  CommentIn = 'COMMENT_IN',
  /** Order by the comment karma score. */
  CommentKarma = 'COMMENT_KARMA',
  /** Order by the comment parent ID. */
  CommentParent = 'COMMENT_PARENT',
  /** Order by the post object ID. */
  CommentPostId = 'COMMENT_POST_ID',
  /** Order by the the type of comment, such as 'comment', 'pingback', or 'trackback'. */
  CommentType = 'COMMENT_TYPE',
  /** Order by the user ID. */
  UserId = 'USER_ID'
}

export type ConnectOrganization = {
  __typename?: 'ConnectOrganization';
  address: Scalars['jsonb'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  urn?: Maybe<Scalars['String']>;
};

export type ConnectProfile = {
  __typename?: 'ConnectProfile';
  _family_name?: Maybe<Scalars['String']>;
  _given_name?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  dob?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  jobTitle?: Maybe<Scalars['String']>;
  organizations: Array<ConnectProfileOrganization>;
  phone?: Maybe<Scalars['String']>;
  roles: Array<ConnectProfileRole>;
  updatedAt: Scalars['timestamptz'];
};

export type ConnectProfileOrganization = {
  __typename?: 'ConnectProfileOrganization';
  id: Scalars['uuid'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  organization: ConnectOrganization;
};

export type ConnectProfileRole = {
  __typename?: 'ConnectProfileRole';
  role: ConnectRole;
};

export type ConnectRole = {
  __typename?: 'ConnectRole';
  name: Scalars['String'];
  rank?: Maybe<Scalars['Int']>;
};

/** Nodes used to manage content */
export type ContentNode = {
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The ID of the node in the database. */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** The template assigned to a node of content */
  template?: Maybe<ContentTemplate>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** Nodes used to manage content */
export type ContentNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Nodes used to manage content */
export type ContentNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum ContentNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Connection between the ContentNode type and the ContentType type */
export type ContentNodeToContentTypeConnectionEdge = {
  __typename?: 'ContentNodeToContentTypeConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<ContentType>;
};

/** Connection between the ContentNode type and the User type */
export type ContentNodeToEditLastConnectionEdge = {
  __typename?: 'ContentNodeToEditLastConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<User>;
};

/** Connection between the ContentNode type and the User type */
export type ContentNodeToEditLockConnectionEdge = {
  __typename?: 'ContentNodeToEditLockConnectionEdge';
  /** The timestamp for when the node was last edited */
  lockTimestamp?: Maybe<Scalars['String']>;
  /** The node of the connection, without the edges */
  node?: Maybe<User>;
};

/** Connection between the ContentNode type and the EnqueuedScript type */
export type ContentNodeToEnqueuedScriptConnection = {
  __typename?: 'ContentNodeToEnqueuedScriptConnection';
  /** Edges for the ContentNodeToEnqueuedScriptConnection connection */
  edges?: Maybe<Array<Maybe<ContentNodeToEnqueuedScriptConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<EnqueuedScript>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ContentNodeToEnqueuedScriptConnectionEdge = {
  __typename?: 'ContentNodeToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<EnqueuedScript>;
};

/** Connection between the ContentNode type and the EnqueuedStylesheet type */
export type ContentNodeToEnqueuedStylesheetConnection = {
  __typename?: 'ContentNodeToEnqueuedStylesheetConnection';
  /** Edges for the ContentNodeToEnqueuedStylesheetConnection connection */
  edges?: Maybe<Array<Maybe<ContentNodeToEnqueuedStylesheetConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<EnqueuedStylesheet>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ContentNodeToEnqueuedStylesheetConnectionEdge = {
  __typename?: 'ContentNodeToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<EnqueuedStylesheet>;
};

/** A union of Content Node Types that support revisions */
export type ContentRevisionUnion = Page | Post;

/** The template assigned to a node of content */
export type ContentTemplate = {
  /** The name of the template */
  templateName?: Maybe<Scalars['String']>;
};

/** An Post Type object */
export type ContentType = Node & UniformResourceIdentifiable & {
  __typename?: 'ContentType';
  /** Whether this content type should can be exported. */
  canExport?: Maybe<Scalars['Boolean']>;
  /** Connection between the ContentType type and the Taxonomy type */
  connectedTaxonomies?: Maybe<ContentTypeToTaxonomyConnection>;
  /** Connection between the ContentType type and the ContentNode type */
  contentNodes?: Maybe<ContentTypeToContentNodeConnection>;
  /** Whether content of this type should be deleted when the author of it is deleted from the system. */
  deleteWithUser?: Maybe<Scalars['Boolean']>;
  /** Description of the content type. */
  description?: Maybe<Scalars['String']>;
  /** Whether to exclude nodes of this content type from front end search results. */
  excludeFromSearch?: Maybe<Scalars['Boolean']>;
  /** The plural name of the content type within the GraphQL Schema. */
  graphqlPluralName?: Maybe<Scalars['String']>;
  /** The singular name of the content type within the GraphQL Schema. */
  graphqlSingleName?: Maybe<Scalars['String']>;
  /** Whether this content type should have archives. Content archives are generated by type and by date. */
  hasArchive?: Maybe<Scalars['Boolean']>;
  /** Whether the content type is hierarchical, for example pages. */
  hierarchical?: Maybe<Scalars['Boolean']>;
  /** The globally unique identifier of the post-type object. */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether this page is set to the static front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether this page is set to the blog posts page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** Display name of the content type. */
  label?: Maybe<Scalars['String']>;
  /** Details about the content type labels. */
  labels?: Maybe<PostTypeLabelDetails>;
  /** The name of the icon file to display as a menu icon. */
  menuIcon?: Maybe<Scalars['String']>;
  /** The position of this post type in the menu. Only applies if show_in_menu is true. */
  menuPosition?: Maybe<Scalars['Int']>;
  /** The internal name of the post type. This should not be used for display purposes. */
  name?: Maybe<Scalars['String']>;
  /** Whether a content type is intended for use publicly either via the admin interface or by front-end users. While the default settings of exclude_from_search, publicly_queryable, show_ui, and show_in_nav_menus are inherited from public, each does not rely on this relationship and controls a very specific intention. */
  public?: Maybe<Scalars['Boolean']>;
  /** Whether queries can be performed on the front end for the content type as part of parse_request(). */
  publiclyQueryable?: Maybe<Scalars['Boolean']>;
  /** Name of content type to display in REST API &quot;wp/v2&quot; namespace. */
  restBase?: Maybe<Scalars['String']>;
  /** The REST Controller class assigned to handling this content type. */
  restControllerClass?: Maybe<Scalars['String']>;
  /** Makes this content type available via the admin bar. */
  showInAdminBar?: Maybe<Scalars['Boolean']>;
  /** Whether to add the content type to the GraphQL Schema. */
  showInGraphql?: Maybe<Scalars['Boolean']>;
  /** Where to show the content type in the admin menu. To work, $show_ui must be true. If true, the post type is shown in its own top level menu. If false, no menu is shown. If a string of an existing top level menu (eg. &quot;tools.php&quot; or &quot;edit.php?post_type=page&quot;), the post type will be placed as a sub-menu of that. */
  showInMenu?: Maybe<Scalars['Boolean']>;
  /** Makes this content type available for selection in navigation menus. */
  showInNavMenus?: Maybe<Scalars['Boolean']>;
  /** Whether the content type is associated with a route under the the REST API &quot;wp/v2&quot; namespace. */
  showInRest?: Maybe<Scalars['Boolean']>;
  /** Whether to generate and allow a UI for managing this content type in the admin. */
  showUi?: Maybe<Scalars['Boolean']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** An Post Type object */
export type ContentTypeConnectedTaxonomiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** An Post Type object */
export type ContentTypeContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ContentTypeToContentNodeConnectionWhereArgs>;
};

/** Allowed Content Types */
export enum ContentTypeEnum {
  /** The Type of Content object */
  Attachment = 'ATTACHMENT',
  /** The Type of Content object */
  Ebooks = 'EBOOKS',
  /** The Type of Content object */
  Page = 'PAGE',
  /** The Type of Content object */
  Post = 'POST',
  /** The Type of Content object */
  ResearchSummary = 'RESEARCH_SUMMARY',
  /** The Type of Content object */
  Resource = 'RESOURCE',
  /** The Type of Content object */
  VideoSeries = 'VIDEO_SERIES',
  /** The Type of Content object */
  Webinar = 'WEBINAR'
}

/** The Type of Identifier used to fetch a single Content Type node. To be used along with the "id" field. Default is "ID". */
export enum ContentTypeIdTypeEnum {
  /** The globally unique ID */
  Id = 'ID',
  /** The name of the content type. */
  Name = 'NAME'
}

/** Connection between the ContentType type and the ContentNode type */
export type ContentTypeToContentNodeConnection = {
  __typename?: 'ContentTypeToContentNodeConnection';
  /** Edges for the ContentTypeToContentNodeConnection connection */
  edges?: Maybe<Array<Maybe<ContentTypeToContentNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ContentTypeToContentNodeConnectionEdge = {
  __typename?: 'ContentTypeToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentNode>;
};

/** Arguments for filtering the ContentTypeToContentNodeConnection connection */
export type ContentTypeToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the ContentType type and the Taxonomy type */
export type ContentTypeToTaxonomyConnection = {
  __typename?: 'ContentTypeToTaxonomyConnection';
  /** Edges for the ContentTypeToTaxonomyConnection connection */
  edges?: Maybe<Array<Maybe<ContentTypeToTaxonomyConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Taxonomy>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ContentTypeToTaxonomyConnectionEdge = {
  __typename?: 'ContentTypeToTaxonomyConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Taxonomy>;
};

/** Allowed Content Types of the Category taxonomy. */
export enum ContentTypesOfCategoryEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the EbooksCategory taxonomy. */
export enum ContentTypesOfEbooksCategoryEnum {
  /** The Type of Content object */
  Ebooks = 'EBOOKS'
}

/** Allowed Content Types of the PostFormat taxonomy. */
export enum ContentTypesOfPostFormatEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the ResearchSummariesCategory taxonomy. */
export enum ContentTypesOfResearchSummariesCategoryEnum {
  /** The Type of Content object */
  ResearchSummary = 'RESEARCH_SUMMARY'
}

/** Allowed Content Types of the ResourceCategory taxonomy. */
export enum ContentTypesOfResourceCategoryEnum {
  /** The Type of Content object */
  Resource = 'RESOURCE'
}

/** Allowed Content Types of the Tag taxonomy. */
export enum ContentTypesOfTagEnum {
  /** The Type of Content object */
  Post = 'POST'
}

/** Allowed Content Types of the VideoSeriesCategory taxonomy. */
export enum ContentTypesOfVideoSeriesCategoryEnum {
  /** The Type of Content object */
  VideoSeries = 'VIDEO_SERIES'
}

/** Allowed Content Types of the WebinarsCategory taxonomy. */
export enum ContentTypesOfWebinarsCategoryEnum {
  /** The Type of Content object */
  Webinar = 'WEBINAR'
}

export enum CourseApprovalError {
  CourseNotFound = 'COURSE_NOT_FOUND',
  GenericError = 'GENERIC_ERROR',
  InvalidCourseId = 'INVALID_COURSE_ID',
  InvalidStatus = 'INVALID_STATUS',
  NoAuditFound = 'NO_AUDIT_FOUND',
  TrainerNotFound = 'TRAINER_NOT_FOUND'
}

export type CourseCertificateLevel = {
  __typename?: 'CourseCertificateLevel';
  courseLevel: CourseLevel;
  expiryDate: Scalars['date'];
};

export enum CourseDeliveryType {
  F2F = 'F2F',
  Mixed = 'MIXED',
  Virtual = 'VIRTUAL'
}

export type CourseInvite = {
  __typename?: 'CourseInvite';
  courseId: Scalars['String'];
  courseName: Scalars['String'];
  deliveryType?: Maybe<CourseDeliveryType>;
  description?: Maybe<Scalars['String']>;
  endDate: Scalars['String'];
  id: Scalars['String'];
  startDate: Scalars['String'];
  status: InviteStatus;
  timeZone?: Maybe<Scalars['String']>;
  trainerName: Scalars['String'];
  venueAddress?: Maybe<Address>;
  venueCoordinates?: Maybe<Scalars['String']>;
  venueName: Scalars['String'];
};

export enum CourseLevel {
  Advanced = 'ADVANCED',
  AdvancedModulesEverydayObjectsAndGroundAssaults = 'ADVANCED_MODULES_EVERYDAY_OBJECTS_AND_GROUND_ASSAULTS',
  AdvancedModulesGroundSupportAndResponseToDeadWeight = 'ADVANCED_MODULES_GROUND_SUPPORT_AND_RESPONSE_TO_DEAD_WEIGHT',
  AdvancedTrainer = 'ADVANCED_TRAINER',
  AdvancedTrainerEverydayObjectsAndGroundAssaults = 'ADVANCED_TRAINER_EVERYDAY_OBJECTS_AND_GROUND_ASSAULTS',
  AdvancedTrainerGroundSupport = 'ADVANCED_TRAINER_GROUND_SUPPORT',
  AdvancedTrainerGroundSupportAndResponseToDeadWeight = 'ADVANCED_TRAINER_GROUND_SUPPORT_AND_RESPONSE_TO_DEAD_WEIGHT',
  AdvancedTrainerObjectsUsedAsWeapons = 'ADVANCED_TRAINER_OBJECTS_USED_AS_WEAPONS',
  BildAdvancedTrainer = 'BILD_ADVANCED_TRAINER',
  BildIntermediateTrainer = 'BILD_INTERMEDIATE_TRAINER',
  BildRegular = 'BILD_REGULAR',
  FoundationTrainer = 'FOUNDATION_TRAINER',
  FoundationTrainerPlus = 'FOUNDATION_TRAINER_PLUS',
  InclusionPracticesAdhd = 'INCLUSION_PRACTICES_ADHD',
  InclusionPracticesAutism = 'INCLUSION_PRACTICES_AUTISM',
  IntermediateTrainer = 'INTERMEDIATE_TRAINER',
  Level_1 = 'LEVEL_1',
  Level_1Bs = 'LEVEL_1_BS',
  Level_1Np = 'LEVEL_1_NP',
  Level_2 = 'LEVEL_2'
}

export enum CourseTrainerType {
  Assistant = 'ASSISTANT',
  Leader = 'LEADER',
  Moderator = 'MODERATOR'
}

export enum CourseType {
  Closed = 'CLOSED',
  Indirect = 'INDIRECT',
  Open = 'OPEN'
}

export type CreateAppUserInput = {
  acceptTnc: Scalars['Boolean'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  dob?: InputMaybe<Scalars['String']>;
  firstName: Scalars['String'];
  jobTitle: Scalars['String'];
  lastName: Scalars['String'];
  orgId?: InputMaybe<Scalars['String']>;
  password: Scalars['String'];
  phone?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
};

/** Input for the createCategory mutation */
export type CreateCategoryInput = {
  /** The slug that the category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the category object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the category object to mutate */
  name: Scalars['String'];
  /** The ID of the category that should be set as the parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createCategory mutation */
export type CreateCategoryPayload = {
  __typename?: 'CreateCategoryPayload';
  /** The created category */
  category?: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Input for the createComment mutation */
export type CreateCommentInput = {
  /** The approval status of the comment. */
  approved?: InputMaybe<Scalars['String']>;
  /** The name of the comment's author. */
  author?: InputMaybe<Scalars['String']>;
  /** The email of the comment's author. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** The url of the comment's author. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The database ID of the post object the comment belongs to. */
  commentOn?: InputMaybe<Scalars['Int']>;
  /** Content of the comment. */
  content?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day ( e.g. 01/31/2017 ) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** Parent comment ID of current comment. */
  parent?: InputMaybe<Scalars['ID']>;
  /** Type of comment. */
  type?: InputMaybe<Scalars['String']>;
};

/** The payload for the createComment mutation */
export type CreateCommentPayload = {
  __typename?: 'CreateCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The comment that was created */
  comment?: Maybe<Comment>;
  /** Whether the mutation succeeded. If the comment is not approved, the server will not return the comment to a non authenticated user, but a success message can be returned if the create succeeded, and the client can optimistically add the comment to the client cache */
  success?: Maybe<Scalars['Boolean']>;
};

/** Input for the createEbook mutation */
export type CreateEbookInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** Set connections between the Ebook and EbooksCategories */
  ebooksCategories?: InputMaybe<EbookEbooksCategoriesInput>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the createEbook mutation */
export type CreateEbookPayload = {
  __typename?: 'CreateEbookPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  ebook?: Maybe<Ebook>;
};

/** Input for the createEbooksCategory mutation */
export type CreateEbooksCategoryInput = {
  /** The slug that the ebooks_category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the ebooks_category object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the ebooks_category object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createEbooksCategory mutation */
export type CreateEbooksCategoryPayload = {
  __typename?: 'CreateEbooksCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created ebooks_category */
  ebooksCategory?: Maybe<EbooksCategory>;
};

/** Input for the createMediaItem mutation */
export type CreateMediaItemInput = {
  /** Alternative text to display when mediaItem is not displayed */
  altText?: InputMaybe<Scalars['String']>;
  /** The userId to assign as the author of the mediaItem */
  authorId?: InputMaybe<Scalars['ID']>;
  /** The caption for the mediaItem */
  caption?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment status for the mediaItem */
  commentStatus?: InputMaybe<Scalars['String']>;
  /** The date of the mediaItem */
  date?: InputMaybe<Scalars['String']>;
  /** The date (in GMT zone) of the mediaItem */
  dateGmt?: InputMaybe<Scalars['String']>;
  /** Description of the mediaItem */
  description?: InputMaybe<Scalars['String']>;
  /** The file name of the mediaItem */
  filePath?: InputMaybe<Scalars['String']>;
  /** The file type of the mediaItem */
  fileType?: InputMaybe<MimeTypeEnum>;
  /** The ID of the parent object */
  parentId?: InputMaybe<Scalars['ID']>;
  /** The ping status for the mediaItem */
  pingStatus?: InputMaybe<Scalars['String']>;
  /** The slug of the mediaItem */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the mediaItem */
  status?: InputMaybe<MediaItemStatusEnum>;
  /** The title of the mediaItem */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the createMediaItem mutation */
export type CreateMediaItemPayload = {
  __typename?: 'CreateMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The MediaItem object mutation type. */
  mediaItem?: Maybe<MediaItem>;
};

export enum CreateOrderError {
  CourseNotFound = 'COURSE_NOT_FOUND',
  InternalError = 'INTERNAL_ERROR',
  NoSpaceOnCourse = 'NO_SPACE_ON_COURSE',
  NumberOfRegistrantsAndQuantityValue = 'NUMBER_OF_REGISTRANTS_AND_QUANTITY_VALUE',
  OrderNotCreated = 'ORDER_NOT_CREATED',
  PricingNotFound = 'PRICING_NOT_FOUND',
  ProfileNotFound = 'PROFILE_NOT_FOUND',
  PromocodesNotApplicable = 'PROMOCODES_NOT_APPLICABLE',
  UserRegisteredOnCourse = 'USER_REGISTERED_ON_COURSE'
}

export type CreateOrderInput = {
  billingAddress: Scalars['String'];
  billingEmail: Scalars['String'];
  billingFamilyName: Scalars['String'];
  billingGivenName: Scalars['String'];
  billingPhone: Scalars['String'];
  bookingContact?: InputMaybe<Scalars['jsonb']>;
  clientPurchaseOrder: Scalars['String'];
  courseId: Scalars['Int'];
  organizationId: Scalars['String'];
  paymentMethod: PaymentMethod;
  promoCodes: Array<Scalars['String']>;
  quantity: Scalars['Int'];
  registrants: Array<CreateOrderParticipantInput>;
  salesRepresentativeId?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

export type CreateOrderOutput = {
  __typename?: 'CreateOrderOutput';
  error?: Maybe<CreateOrderError>;
  id?: Maybe<Scalars['uuid']>;
  success: Scalars['Boolean'];
};

export type CreateOrderParticipantInput = {
  addressLine1?: InputMaybe<Scalars['String']>;
  addressLine2?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  lastName: Scalars['String'];
  postCode?: InputMaybe<Scalars['String']>;
  residingCountry?: InputMaybe<Scalars['String']>;
  residingCountryCode?: InputMaybe<Scalars['String']>;
};

/** Input for the createPage mutation */
export type CreatePageInput = {
  /** The userId to assign as the author of the object */
  authorId?: InputMaybe<Scalars['ID']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment status for the object */
  commentStatus?: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The ID of the parent object */
  parentId?: InputMaybe<Scalars['ID']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the createPage mutation */
export type CreatePagePayload = {
  __typename?: 'CreatePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  page?: Maybe<Page>;
};

/** Input for the createPostFormat mutation */
export type CreatePostFormatInput = {
  /** The slug that the post_format will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the post_format object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the post_format object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createPostFormat mutation */
export type CreatePostFormatPayload = {
  __typename?: 'CreatePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created post_format */
  postFormat?: Maybe<PostFormat>;
};

/** Input for the createPost mutation */
export type CreatePostInput = {
  /** The userId to assign as the author of the object */
  authorId?: InputMaybe<Scalars['ID']>;
  /** Set connections between the post and categories */
  categories?: InputMaybe<PostCategoriesInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment status for the object */
  commentStatus?: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The ping status for the object */
  pingStatus?: InputMaybe<Scalars['String']>;
  /** URLs that have been pinged. */
  pinged?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Set connections between the post and postFormats */
  postFormats?: InputMaybe<PostPostFormatsInput>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** Set connections between the post and tags */
  tags?: InputMaybe<PostTagsInput>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
  /** URLs queued to be pinged. */
  toPing?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The payload for the createPost mutation */
export type CreatePostPayload = {
  __typename?: 'CreatePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  post?: Maybe<Post>;
};

/** Input for the createResearchSummariesCategory mutation */
export type CreateResearchSummariesCategoryInput = {
  /** The slug that the research_summaries_category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the research_summaries_category object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the research_summaries_category object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createResearchSummariesCategory mutation */
export type CreateResearchSummariesCategoryPayload = {
  __typename?: 'CreateResearchSummariesCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created research_summaries_category */
  researchSummariesCategory?: Maybe<ResearchSummariesCategory>;
};

/** Input for the createResearchSummary mutation */
export type CreateResearchSummaryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** Set connections between the ResearchSummary and ResearchSummariesCategories */
  researchSummariesCategories?: InputMaybe<ResearchSummaryResearchSummariesCategoriesInput>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the createResearchSummary mutation */
export type CreateResearchSummaryPayload = {
  __typename?: 'CreateResearchSummaryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  researchSummary?: Maybe<ResearchSummary>;
};

/** Input for the createResourceCategory mutation */
export type CreateResourceCategoryInput = {
  /** The slug that the resource_category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the resource_category object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the resource_category object to mutate */
  name: Scalars['String'];
  /** The ID of the resource_category that should be set as the parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createResourceCategory mutation */
export type CreateResourceCategoryPayload = {
  __typename?: 'CreateResourceCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created resource_category */
  resourceCategory?: Maybe<ResourceCategory>;
};

/** Input for the createResource mutation */
export type CreateResourceInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** Set connections between the Resource and ResourceCategories */
  resourceCategories?: InputMaybe<ResourceResourceCategoriesInput>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the createResource mutation */
export type CreateResourcePayload = {
  __typename?: 'CreateResourcePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  resource?: Maybe<Resource>;
};

/** Input for the createTag mutation */
export type CreateTagInput = {
  /** The slug that the post_tag will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the post_tag object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the post_tag object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createTag mutation */
export type CreateTagPayload = {
  __typename?: 'CreateTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created post_tag */
  tag?: Maybe<Tag>;
};

/** Input for the createUser mutation */
export type CreateUserInput = {
  /** User's AOL IM account. */
  aim?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A string containing content about the user. */
  description?: InputMaybe<Scalars['String']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  displayName?: InputMaybe<Scalars['String']>;
  /** A string containing the user's email address. */
  email?: InputMaybe<Scalars['String']>;
  /** 	The user's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** User's Jabber account. */
  jabber?: InputMaybe<Scalars['String']>;
  /** The user's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** User's locale. */
  locale?: InputMaybe<Scalars['String']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  nicename?: InputMaybe<Scalars['String']>;
  /** The user's nickname, defaults to the user's username. */
  nickname?: InputMaybe<Scalars['String']>;
  /** A string that contains the plain text password for the user. */
  password?: InputMaybe<Scalars['String']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  registered?: InputMaybe<Scalars['String']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  richEditing?: InputMaybe<Scalars['String']>;
  /** An array of roles to be assigned to the user. */
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A string that contains the user's username for logging in. */
  username: Scalars['String'];
  /** A string containing the user's URL for the user's web site. */
  websiteUrl?: InputMaybe<Scalars['String']>;
  /** User's Yahoo IM account. */
  yim?: InputMaybe<Scalars['String']>;
};

export type CreateUserOutput = {
  __typename?: 'CreateUserOutput';
  cognitoId: Scalars['String'];
  email: Scalars['String'];
  profileId: Scalars['String'];
};

/** The payload for the createUser mutation */
export type CreateUserPayload = {
  __typename?: 'CreateUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The User object mutation type. */
  user?: Maybe<User>;
};

/** Input for the createVideoSeriesCategory mutation */
export type CreateVideoSeriesCategoryInput = {
  /** The slug that the video_series_category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the video_series_category object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the video_series_category object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createVideoSeriesCategory mutation */
export type CreateVideoSeriesCategoryPayload = {
  __typename?: 'CreateVideoSeriesCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created video_series_category */
  videoSeriesCategory?: Maybe<VideoSeriesCategory>;
};

/** Input for the createVideoSeriesItem mutation */
export type CreateVideoSeriesItemInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
  /** Set connections between the VideoSeriesItem and VideoSeriesCategories */
  videoSeriesCategories?: InputMaybe<VideoSeriesItemVideoSeriesCategoriesInput>;
};

/** The payload for the createVideoSeriesItem mutation */
export type CreateVideoSeriesItemPayload = {
  __typename?: 'CreateVideoSeriesItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  videoSeriesItem?: Maybe<VideoSeriesItem>;
};

/** Input for the createWebinar mutation */
export type CreateWebinarInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
  /** Set connections between the Webinar and WebinarsCategories */
  webinarsCategories?: InputMaybe<WebinarWebinarsCategoriesInput>;
};

/** The payload for the createWebinar mutation */
export type CreateWebinarPayload = {
  __typename?: 'CreateWebinarPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  webinar?: Maybe<Webinar>;
};

/** Input for the createWebinarsCategory mutation */
export type CreateWebinarsCategoryInput = {
  /** The slug that the webinars_category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the webinars_category object */
  description?: InputMaybe<Scalars['String']>;
  /** The name of the webinars_category object to mutate */
  name: Scalars['String'];
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the createWebinarsCategory mutation */
export type CreateWebinarsCategoryPayload = {
  __typename?: 'CreateWebinarsCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created webinars_category */
  webinarsCategory?: Maybe<WebinarsCategory>;
};

export enum Currency {
  Aud = 'AUD',
  Eur = 'EUR',
  Gbp = 'GBP',
  Nzd = 'NZD',
  Usd = 'USD'
}

/** Object that can be identified with a Database ID */
export type DatabaseIdentifier = {
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
};

/** Date values */
export type DateInput = {
  /** Day of the month (from 1 to 31) */
  day?: InputMaybe<Scalars['Int']>;
  /** Month number (from 1 to 12) */
  month?: InputMaybe<Scalars['Int']>;
  /** 4 digit year (e.g. 2017) */
  year?: InputMaybe<Scalars['Int']>;
};

/** Filter the connection based on input */
export type DateQueryInput = {
  /** Nodes should be returned after this date */
  after?: InputMaybe<DateInput>;
  /** Nodes should be returned before this date */
  before?: InputMaybe<DateInput>;
  /** Column to query against */
  column?: InputMaybe<PostObjectsConnectionDateColumnEnum>;
  /** For after/before, whether exact value should be matched or not */
  compare?: InputMaybe<Scalars['String']>;
  /** Day of the month (from 1 to 31) */
  day?: InputMaybe<Scalars['Int']>;
  /** Hour (from 0 to 23) */
  hour?: InputMaybe<Scalars['Int']>;
  /** For after/before, whether exact value should be matched or not */
  inclusive?: InputMaybe<Scalars['Boolean']>;
  /** Minute (from 0 to 59) */
  minute?: InputMaybe<Scalars['Int']>;
  /** Month number (from 1 to 12) */
  month?: InputMaybe<Scalars['Int']>;
  /** OR or AND, how the sub-arrays should be compared */
  relation?: InputMaybe<RelationEnum>;
  /** Second (0 to 59) */
  second?: InputMaybe<Scalars['Int']>;
  /** Week of the year (from 0 to 53) */
  week?: InputMaybe<Scalars['Int']>;
  /** 4 digit year (e.g. 2017) */
  year?: InputMaybe<Scalars['Int']>;
};

export type DbCleanOutput = {
  __typename?: 'DbCleanOutput';
  message: Scalars['String'];
};

export type DeclineInviteOutput = {
  __typename?: 'DeclineInviteOutput';
  status: Scalars['Boolean'];
};

/** The template assigned to the node */
export type DefaultTemplate = ContentTemplate & {
  __typename?: 'DefaultTemplate';
  /** The name of the template */
  templateName?: Maybe<Scalars['String']>;
};

/** Input for the deleteCategory mutation */
export type DeleteCategoryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the category to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteCategory mutation */
export type DeleteCategoryPayload = {
  __typename?: 'DeleteCategoryPayload';
  /** The deteted term object */
  category?: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
};

/** Input for the deleteComment mutation */
export type DeleteCommentInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the comment should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The deleted comment ID */
  id: Scalars['ID'];
};

/** The payload for the deleteComment mutation */
export type DeleteCommentPayload = {
  __typename?: 'DeleteCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The deleted comment object */
  comment?: Maybe<Comment>;
  /** The deleted comment ID */
  deletedId?: Maybe<Scalars['ID']>;
};

/** Input for the deleteEbook mutation */
export type DeleteEbookInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the Ebook to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteEbook mutation */
export type DeleteEbookPayload = {
  __typename?: 'DeleteEbookPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  ebook?: Maybe<Ebook>;
};

/** Input for the deleteEbooksCategory mutation */
export type DeleteEbooksCategoryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the EbooksCategory to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteEbooksCategory mutation */
export type DeleteEbooksCategoryPayload = {
  __typename?: 'DeleteEbooksCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deteted term object */
  ebooksCategory?: Maybe<EbooksCategory>;
};

/** Input for the deleteMediaItem mutation */
export type DeleteMediaItemInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the mediaItem should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the mediaItem to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteMediaItem mutation */
export type DeleteMediaItemPayload = {
  __typename?: 'DeleteMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted mediaItem */
  deletedId?: Maybe<Scalars['ID']>;
  /** The mediaItem before it was deleted */
  mediaItem?: Maybe<MediaItem>;
};

export type DeleteMeetingOutput = {
  __typename?: 'DeleteMeetingOutput';
  success: Scalars['Boolean'];
};

export type DeleteOrganisationOutput = {
  __typename?: 'DeleteOrganisationOutput';
  success: Scalars['Boolean'];
};

/** Input for the deletePage mutation */
export type DeletePageInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the page to delete */
  id: Scalars['ID'];
};

/** The payload for the deletePage mutation */
export type DeletePagePayload = {
  __typename?: 'DeletePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  page?: Maybe<Page>;
};

/** Input for the deletePostFormat mutation */
export type DeletePostFormatInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the postFormat to delete */
  id: Scalars['ID'];
};

/** The payload for the deletePostFormat mutation */
export type DeletePostFormatPayload = {
  __typename?: 'DeletePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deteted term object */
  postFormat?: Maybe<PostFormat>;
};

/** Input for the deletePost mutation */
export type DeletePostInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the post to delete */
  id: Scalars['ID'];
};

/** The payload for the deletePost mutation */
export type DeletePostPayload = {
  __typename?: 'DeletePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  post?: Maybe<Post>;
};

/** Input for the deleteResearchSummariesCategory mutation */
export type DeleteResearchSummariesCategoryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the ResearchSummariesCategory to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteResearchSummariesCategory mutation */
export type DeleteResearchSummariesCategoryPayload = {
  __typename?: 'DeleteResearchSummariesCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deteted term object */
  researchSummariesCategory?: Maybe<ResearchSummariesCategory>;
};

/** Input for the deleteResearchSummary mutation */
export type DeleteResearchSummaryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the ResearchSummary to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteResearchSummary mutation */
export type DeleteResearchSummaryPayload = {
  __typename?: 'DeleteResearchSummaryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  researchSummary?: Maybe<ResearchSummary>;
};

/** Input for the deleteResourceCategory mutation */
export type DeleteResourceCategoryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the ResourceCategory to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteResourceCategory mutation */
export type DeleteResourceCategoryPayload = {
  __typename?: 'DeleteResourceCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deteted term object */
  resourceCategory?: Maybe<ResourceCategory>;
};

/** Input for the deleteResource mutation */
export type DeleteResourceInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the Resource to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteResource mutation */
export type DeleteResourcePayload = {
  __typename?: 'DeleteResourcePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  resource?: Maybe<Resource>;
};

/** Input for the deleteTag mutation */
export type DeleteTagInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the tag to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteTag mutation */
export type DeleteTagPayload = {
  __typename?: 'DeleteTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deteted term object */
  tag?: Maybe<Tag>;
};

export enum DeleteUserError {
  CertExist = 'CERT_EXIST',
  GeneralError = 'GENERAL_ERROR',
  PendingCourse = 'PENDING_COURSE',
  SelfDelete = 'SELF_DELETE',
  UserTrainer = 'USER_TRAINER'
}

/** Input for the deleteUser mutation */
export type DeleteUserInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the user you want to delete */
  id: Scalars['ID'];
  /** Reassign posts and links to new User ID. */
  reassignId?: InputMaybe<Scalars['ID']>;
};

export type DeleteUserOutput = {
  __typename?: 'DeleteUserOutput';
  courseIds?: Maybe<Scalars['String']>;
  error?: Maybe<DeleteUserError>;
  hasGo1Account?: Maybe<Scalars['Boolean']>;
  success: Scalars['Boolean'];
};

/** The payload for the deleteUser mutation */
export type DeleteUserPayload = {
  __typename?: 'DeleteUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the user that you just deleted */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deleted user object */
  user?: Maybe<User>;
};

/** Input for the deleteVideoSeriesCategory mutation */
export type DeleteVideoSeriesCategoryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the VideoSeriesCategory to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteVideoSeriesCategory mutation */
export type DeleteVideoSeriesCategoryPayload = {
  __typename?: 'DeleteVideoSeriesCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deteted term object */
  videoSeriesCategory?: Maybe<VideoSeriesCategory>;
};

/** Input for the deleteVideoSeriesItem mutation */
export type DeleteVideoSeriesItemInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the VideoSeriesItem to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteVideoSeriesItem mutation */
export type DeleteVideoSeriesItemPayload = {
  __typename?: 'DeleteVideoSeriesItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  videoSeriesItem?: Maybe<VideoSeriesItem>;
};

/** Input for the deleteWebinar mutation */
export type DeleteWebinarInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Whether the object should be force deleted instead of being moved to the trash */
  forceDelete?: InputMaybe<Scalars['Boolean']>;
  /** The ID of the Webinar to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteWebinar mutation */
export type DeleteWebinarPayload = {
  __typename?: 'DeleteWebinarPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The object before it was deleted */
  webinar?: Maybe<Webinar>;
};

/** Input for the deleteWebinarsCategory mutation */
export type DeleteWebinarsCategoryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the WebinarsCategory to delete */
  id: Scalars['ID'];
};

/** The payload for the deleteWebinarsCategory mutation */
export type DeleteWebinarsCategoryPayload = {
  __typename?: 'DeleteWebinarsCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The ID of the deleted object */
  deletedId?: Maybe<Scalars['ID']>;
  /** The deteted term object */
  webinarsCategory?: Maybe<WebinarsCategory>;
};

/** The discussion setting type */
export type DiscussionSettings = {
  __typename?: 'DiscussionSettings';
  /** Allow people to submit comments on new posts. */
  defaultCommentStatus?: Maybe<Scalars['String']>;
  /** Allow link notifications from other blogs (pingbacks and trackbacks) on new articles. */
  defaultPingStatus?: Maybe<Scalars['String']>;
};

/** The Ebook type */
export type Ebook = ContentNode & DatabaseIdentifier & MenuItemLinkable & Node & NodeWithExcerpt & NodeWithFeaturedImage & NodeWithTemplate & NodeWithTitle & UniformResourceIdentifiable & {
  __typename?: 'Ebook';
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Downloads&quot; was set to Show in GraphQL. */
  downloads?: Maybe<Ebook_Downloads>;
  /** The id field matches the WP_Post-&gt;ID field. */
  ebookId: Scalars['Int'];
  /** Connection between the Ebook type and the EbooksCategory type */
  ebooksCategories?: Maybe<EbookToEbooksCategoryConnection>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The excerpt of the post. */
  excerpt?: Maybe<Scalars['String']>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the ebooks object. */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /** Connection between the Ebook type and the Ebook type */
  preview?: Maybe<EbookToPreviewConnectionEdge>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
  /** Connection between the Ebook type and the TermNode type */
  terms?: Maybe<EbookToTermNodeConnection>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The Ebook type */
export type EbookEbooksCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EbookToEbooksCategoryConnectionWhereArgs>;
};


/** The Ebook type */
export type EbookEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The Ebook type */
export type EbookEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The Ebook type */
export type EbookExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The Ebook type */
export type EbookTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EbookToTermNodeConnectionWhereArgs>;
};


/** The Ebook type */
export type EbookTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Set relationships between the Ebook to EbooksCategories */
export type EbookEbooksCategoriesInput = {
  /** If true, this will append the EbooksCategory to existing related EbooksCategories. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<EbookEbooksCategoriesNodeInput>>>;
};

/** List of EbooksCategories to connect the Ebook to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type EbookEbooksCategoriesNodeInput = {
  /** The description of the EbooksCategory. This field is used to set a description of the EbooksCategory if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the EbooksCategory. If present, this will be used to connect to the Ebook. If no existing EbooksCategory exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the EbooksCategory. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the EbooksCategory. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum EbookIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Connection between the Ebook type and the EbooksCategory type */
export type EbookToEbooksCategoryConnection = {
  __typename?: 'EbookToEbooksCategoryConnection';
  /** Edges for the EbookToEbooksCategoryConnection connection */
  edges?: Maybe<Array<Maybe<EbookToEbooksCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<EbooksCategory>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type EbookToEbooksCategoryConnectionEdge = {
  __typename?: 'EbookToEbooksCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<EbooksCategory>;
};

/** Arguments for filtering the EbookToEbooksCategoryConnection connection */
export type EbookToEbooksCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Ebook type and the Ebook type */
export type EbookToPreviewConnectionEdge = {
  __typename?: 'EbookToPreviewConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Ebook>;
};

/** Connection between the Ebook type and the TermNode type */
export type EbookToTermNodeConnection = {
  __typename?: 'EbookToTermNodeConnection';
  /** Edges for the EbookToTermNodeConnection connection */
  edges?: Maybe<Array<Maybe<EbookToTermNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<TermNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type EbookToTermNodeConnectionEdge = {
  __typename?: 'EbookToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<TermNode>;
};

/** Arguments for filtering the EbookToTermNodeConnection connection */
export type EbookToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies?: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Field Group */
export type Ebook_Downloads = AcfFieldGroup & {
  __typename?: 'Ebook_Downloads';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  file?: Maybe<MediaItem>;
};

/** The EbooksCategory type */
export type EbooksCategory = DatabaseIdentifier & MenuItemLinkable & Node & TermNode & UniformResourceIdentifiable & {
  __typename?: 'EbooksCategory';
  /** Connection between the EbooksCategory type and the ContentNode type */
  contentNodes?: Maybe<EbooksCategoryToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the EbooksCategory type and the Ebook type */
  ebooks?: Maybe<EbooksCategoryToEbookConnection>;
  /** The id field matches the WP_Post-&gt;ID field. */
  ebooksCategoryId?: Maybe<Scalars['Int']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The unique resource identifier path */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the EbooksCategory type and the Taxonomy type */
  taxonomy?: Maybe<EbooksCategoryToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The EbooksCategory type */
export type EbooksCategoryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EbooksCategoryToContentNodeConnectionWhereArgs>;
};


/** The EbooksCategory type */
export type EbooksCategoryEbooksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<EbooksCategoryToEbookConnectionWhereArgs>;
};


/** The EbooksCategory type */
export type EbooksCategoryEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The EbooksCategory type */
export type EbooksCategoryEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum EbooksCategoryIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the EbooksCategory type and the ContentNode type */
export type EbooksCategoryToContentNodeConnection = {
  __typename?: 'EbooksCategoryToContentNodeConnection';
  /** Edges for the EbooksCategoryToContentNodeConnection connection */
  edges?: Maybe<Array<Maybe<EbooksCategoryToContentNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type EbooksCategoryToContentNodeConnectionEdge = {
  __typename?: 'EbooksCategoryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentNode>;
};

/** Arguments for filtering the EbooksCategoryToContentNodeConnection connection */
export type EbooksCategoryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfEbooksCategoryEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the EbooksCategory type and the Ebook type */
export type EbooksCategoryToEbookConnection = {
  __typename?: 'EbooksCategoryToEbookConnection';
  /** Edges for the EbooksCategoryToEbookConnection connection */
  edges?: Maybe<Array<Maybe<EbooksCategoryToEbookConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Ebook>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type EbooksCategoryToEbookConnectionEdge = {
  __typename?: 'EbooksCategoryToEbookConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Ebook>;
};

/** Arguments for filtering the EbooksCategoryToEbookConnection connection */
export type EbooksCategoryToEbookConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the EbooksCategory type and the Taxonomy type */
export type EbooksCategoryToTaxonomyConnectionEdge = {
  __typename?: 'EbooksCategoryToTaxonomyConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Taxonomy>;
};

/** Asset enqueued by the CMS */
export type EnqueuedAsset = {
  /** @todo */
  args?: Maybe<Scalars['Boolean']>;
  /** Dependencies needed to use this asset */
  dependencies?: Maybe<Array<Maybe<EnqueuedScript>>>;
  /** Extra information needed for the script */
  extra?: Maybe<Scalars['String']>;
  /** The handle of the enqueued asset */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the enqueued asset */
  id: Scalars['ID'];
  /** The source of the asset */
  src?: Maybe<Scalars['String']>;
  /** The version of the enqueued asset */
  version?: Maybe<Scalars['String']>;
};

/** Script enqueued by the CMS */
export type EnqueuedScript = EnqueuedAsset & Node & {
  __typename?: 'EnqueuedScript';
  /** @todo */
  args?: Maybe<Scalars['Boolean']>;
  /** Dependencies needed to use this asset */
  dependencies?: Maybe<Array<Maybe<EnqueuedScript>>>;
  /** Extra information needed for the script */
  extra?: Maybe<Scalars['String']>;
  /** The handle of the enqueued asset */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the enqueued asset */
  id: Scalars['ID'];
  /** The source of the asset */
  src?: Maybe<Scalars['String']>;
  /** The version of the enqueued asset */
  version?: Maybe<Scalars['String']>;
};

/** Stylesheet enqueued by the CMS */
export type EnqueuedStylesheet = EnqueuedAsset & Node & {
  __typename?: 'EnqueuedStylesheet';
  /** @todo */
  args?: Maybe<Scalars['Boolean']>;
  /** Dependencies needed to use this asset */
  dependencies?: Maybe<Array<Maybe<EnqueuedScript>>>;
  /** Extra information needed for the script */
  extra?: Maybe<Scalars['String']>;
  /** The handle of the enqueued asset */
  handle?: Maybe<Scalars['String']>;
  /** The ID of the enqueued asset */
  id: Scalars['ID'];
  /** The source of the asset */
  src?: Maybe<Scalars['String']>;
  /** The version of the enqueued asset */
  version?: Maybe<Scalars['String']>;
};

/** Boolean expression to compare columns of type "Float". All fields are combined with logical 'AND'. */
export type Float_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Float']>;
  _gt?: InputMaybe<Scalars['Float']>;
  _gte?: InputMaybe<Scalars['Float']>;
  _in?: InputMaybe<Array<Scalars['Float']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Float']>;
  _lte?: InputMaybe<Scalars['Float']>;
  _neq?: InputMaybe<Scalars['Float']>;
  _nin?: InputMaybe<Array<Scalars['Float']>>;
};

export enum Go1EnrollmentStatus {
  Completed = 'COMPLETED',
  Inprogress = 'INPROGRESS'
}

export type Go1LearningObject = {
  __typename?: 'GO1LearningObject';
  id: Scalars['Int'];
  title: Scalars['String'];
};

/** The general setting type */
export type GeneralSettings = {
  __typename?: 'GeneralSettings';
  /** A date format for all date strings. */
  dateFormat?: Maybe<Scalars['String']>;
  /** Site tagline. */
  description?: Maybe<Scalars['String']>;
  /** This address is used for admin purposes, like new user notification. */
  email?: Maybe<Scalars['String']>;
  /** WordPress locale code. */
  language?: Maybe<Scalars['String']>;
  /** A day number of the week that the week should start on. */
  startOfWeek?: Maybe<Scalars['Int']>;
  /** A time format for all time strings. */
  timeFormat?: Maybe<Scalars['String']>;
  /** A city in the same timezone as you. */
  timezone?: Maybe<Scalars['String']>;
  /** Site title. */
  title?: Maybe<Scalars['String']>;
  /** Site URL. */
  url?: Maybe<Scalars['String']>;
};

export type GetCoursePricingInput = {
  courseId: Scalars['Int'];
};

export type GetCoursePricingOutput = {
  __typename?: 'GetCoursePricingOutput';
  blended?: Maybe<Scalars['Boolean']>;
  level?: Maybe<CourseLevel>;
  priceAmount: Scalars['Float'];
  priceCurrency: Currency;
  reaccreditation?: Maybe<Scalars['Boolean']>;
  type?: Maybe<CourseType>;
  xeroCode: Scalars['String'];
};

export type GetSsoUserDataInput = {
  email: Scalars['String'];
  ssoCognitoUserId: Scalars['uuid'];
};

export type GetSsoUserDataOutput = {
  __typename?: 'GetSSOUserDataOutput';
  connectProfile?: Maybe<ConnectProfile>;
  ssoProfile?: Maybe<SsoUserProfile>;
};

export type GetUserGo1Enrollment = {
  __typename?: 'GetUserGO1Enrollment';
  id: Scalars['Int'];
  learningObject?: Maybe<Go1LearningObject>;
  status?: Maybe<Go1EnrollmentStatus>;
};

export type GetUserGo1EnrollmentsOutput = {
  __typename?: 'GetUserGO1EnrollmentsOutput';
  enrollments: Array<GetUserGo1Enrollment>;
  success: Scalars['Boolean'];
};

export enum Go1ChangeError {
  GenericError = 'GENERIC_ERROR',
  InvalidInvoice = 'INVALID_INVOICE',
  InvoiceNotAuthorized = 'INVOICE_NOT_AUTHORIZED',
  InvoicePaid = 'INVOICE_PAID'
}

export enum Go1ChangeType {
  LicensesAdded = 'LICENSES_ADDED',
  LicensesPurchased = 'LICENSES_PURCHASED',
  LicensesReleased = 'LICENSES_RELEASED',
  LicensesRemoved = 'LICENSES_REMOVED',
  LicenseIssued = 'LICENSE_ISSUED',
  LicenseRevoked = 'LICENSE_REVOKED'
}

export type Go1EnrollmentsSyncOutput = {
  __typename?: 'Go1EnrollmentsSyncOutput';
  message?: Maybe<Scalars['String']>;
};

export type Go1LicensesChangeInput = {
  amount: Scalars['Int'];
  orgId: Scalars['uuid'];
  payload?: InputMaybe<Scalars['jsonb']>;
  type: Go1ChangeType;
};

export type Go1LicensesChangeOutput = {
  __typename?: 'Go1LicensesChangeOutput';
  error?: Maybe<Go1ChangeError>;
  success: Scalars['Boolean'];
};

export type GradedOnSyncInput = {
  participantIds: Array<Scalars['uuid']>;
};

export type GradedOnSyncOutput = {
  __typename?: 'GradedOnSyncOutput';
  notSyncedCount: Scalars['Int'];
  syncedCount: Scalars['Int'];
};

/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNode = {
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  children?: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** The parent of the node. The parent object can be of various types */
  parent?: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
};


/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNodeAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};


/** Content node with hierarchical (parent/child) relationships */
export type HierarchicalContentNodeChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToContentNodeAncestorsConnection = {
  __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnection';
  /** Edges for the HierarchicalContentNodeToContentNodeAncestorsConnection connection */
  edges?: Maybe<Array<Maybe<HierarchicalContentNodeToContentNodeAncestorsConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionEdge = {
  __typename?: 'HierarchicalContentNodeToContentNodeAncestorsConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentNode>;
};

/** Arguments for filtering the HierarchicalContentNodeToContentNodeAncestorsConnection connection */
export type HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToContentNodeChildrenConnection = {
  __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnection';
  /** Edges for the HierarchicalContentNodeToContentNodeChildrenConnection connection */
  edges?: Maybe<Array<Maybe<HierarchicalContentNodeToContentNodeChildrenConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type HierarchicalContentNodeToContentNodeChildrenConnectionEdge = {
  __typename?: 'HierarchicalContentNodeToContentNodeChildrenConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentNode>;
};

/** Arguments for filtering the HierarchicalContentNodeToContentNodeChildrenConnection connection */
export type HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the HierarchicalContentNode type and the ContentNode type */
export type HierarchicalContentNodeToParentContentNodeConnectionEdge = {
  __typename?: 'HierarchicalContentNodeToParentContentNodeConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<ContentNode>;
};

/** Term node with hierarchical (parent/child) relationships */
export type HierarchicalTermNode = {
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
};

export type ImportArloCertificatesOutput = {
  __typename?: 'ImportArloCertificatesOutput';
  added?: Maybe<Scalars['Int']>;
  error?: Maybe<Scalars['String']>;
  invalid?: Maybe<Scalars['Int']>;
  invalidEntries?: Maybe<Array<Maybe<InvalidEntries>>>;
  processed?: Maybe<Scalars['Int']>;
};

export enum ImportLegacyCertificateError {
  AlreadyImported = 'ALREADY_IMPORTED',
  CertificateNotFound = 'CERTIFICATE_NOT_FOUND',
  GenericError = 'GENERIC_ERROR',
  ProfileNoMatch = 'PROFILE_NO_MATCH',
  UnsupportedLevel = 'UNSUPPORTED_LEVEL'
}

export type ImportLegacyCertificateInput = {
  code: Scalars['String'];
  profileId?: InputMaybe<Scalars['uuid']>;
};

export type ImportLegacyCertificateOutput = {
  __typename?: 'ImportLegacyCertificateOutput';
  error?: Maybe<ImportLegacyCertificateError>;
  success: Scalars['Boolean'];
  trainerRoleAdded: Scalars['Boolean'];
};

export type ImportOrganisationsConfig = {
  addressLine1: Scalars['String'];
  addressLine2?: InputMaybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  email: Scalars['String'];
  mainContactEmail?: InputMaybe<Scalars['String']>;
  mainContactFirstName?: InputMaybe<Scalars['String']>;
  mainContactSetting?: InputMaybe<Scalars['String']>;
  mainContactSurname?: InputMaybe<Scalars['String']>;
  mainOrganisation?: InputMaybe<Scalars['String']>;
  name: Scalars['String'];
  organisationAdminEmail?: InputMaybe<Scalars['String']>;
  phone: Scalars['String'];
  postcode: Scalars['String'];
  sector: Scalars['String'];
  state: Scalars['String'];
  type: Scalars['String'];
  website?: InputMaybe<Scalars['String']>;
};

export type ImportOrganisationsInput = {
  config: ImportOrganisationsConfig;
  data: Scalars['String'];
};

export type ImportOrganisationsOutput = {
  __typename?: 'ImportOrganisationsOutput';
  error?: Maybe<Scalars['String']>;
  jobId?: Maybe<Scalars['String']>;
};

export type ImportUsersConfig = {
  certificateNumberColumn: Scalars['String'];
  emailColumn: Scalars['String'];
  firstNameColumn: Scalars['String'];
  lastNameColumn: Scalars['String'];
};

export type ImportUsersInput = {
  config: ImportUsersConfig;
  data: Scalars['String'];
};

export type ImportUsersOutput = {
  __typename?: 'ImportUsersOutput';
  jobId: Scalars['String'];
};

export type InitAuthOutput = {
  __typename?: 'InitAuthOutput';
  authChallenge: Scalars['String'];
  email: Scalars['String'];
};

/** Boolean expression to compare columns of type "Int". All fields are combined with logical 'AND'. */
export type Int_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['Int']>;
  _gt?: InputMaybe<Scalars['Int']>;
  _gte?: InputMaybe<Scalars['Int']>;
  _in?: InputMaybe<Array<Scalars['Int']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['Int']>;
  _lte?: InputMaybe<Scalars['Int']>;
  _neq?: InputMaybe<Scalars['Int']>;
  _nin?: InputMaybe<Array<Scalars['Int']>>;
};

export type InvalidEntries = {
  __typename?: 'InvalidEntries';
  email: Scalars['String'];
};

export type Invite = {
  email: Scalars['String'];
  expiresIn?: InputMaybe<Scalars['String']>;
  invitedAfterCourseHasEnded: Scalars['Boolean'];
  inviter_id?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Scalars['String']>;
};

export enum InviteStatus {
  Accepted = 'ACCEPTED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

export type JoinWaitlistInput = {
  courseId: Scalars['Int'];
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  orgName: Scalars['String'];
  phone: Scalars['String'];
  recaptchaToken: Scalars['String'];
};

export type JoinWaitlistOutput = {
  __typename?: 'JoinWaitlistOutput';
  success: Scalars['Boolean'];
};

export type KnowledgeHubResource = {
  __typename?: 'KnowledgeHubResource';
  authors?: Maybe<Array<Scalars['String']>>;
  description: Scalars['String'];
  id: Scalars['String'];
  imageUrl: Scalars['String'];
  publishedDate: Scalars['String'];
  srcSet?: Maybe<Scalars['String']>;
  title: Scalars['String'];
  type: KnowledgeHubResourceType;
  url: Scalars['String'];
};

export enum KnowledgeHubResourceType {
  Article = 'ARTICLE',
  Download = 'DOWNLOAD',
  Podcast = 'PODCAST',
  Video = 'VIDEO'
}

export type KnowledgeHubResourcesOutput = {
  __typename?: 'KnowledgeHubResourcesOutput';
  resources: Array<KnowledgeHubResource>;
};

/** File details for a Media Item */
export type MediaDetails = {
  __typename?: 'MediaDetails';
  /** The filename of the mediaItem */
  file?: Maybe<Scalars['String']>;
  /** The height of the mediaItem */
  height?: Maybe<Scalars['Int']>;
  /** Meta information associated with the mediaItem */
  meta?: Maybe<MediaItemMeta>;
  /** The available sizes of the mediaItem */
  sizes?: Maybe<Array<Maybe<MediaSize>>>;
  /** The width of the mediaItem */
  width?: Maybe<Scalars['Int']>;
};


/** File details for a Media Item */
export type MediaDetailsSizesArgs = {
  exclude?: InputMaybe<Array<InputMaybe<MediaItemSizeEnum>>>;
  include?: InputMaybe<Array<InputMaybe<MediaItemSizeEnum>>>;
};

/** The mediaItem type */
export type MediaItem = ContentNode & DatabaseIdentifier & HierarchicalContentNode & Node & NodeWithAuthor & NodeWithComments & NodeWithTemplate & NodeWithTitle & UniformResourceIdentifiable & {
  __typename?: 'MediaItem';
  /** Alternative text to display when resource is not displayed */
  altText?: Maybe<Scalars['String']>;
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the author of the node */
  authorId?: Maybe<Scalars['ID']>;
  /** The caption for the resource */
  caption?: Maybe<Scalars['String']>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  children?: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount?: Maybe<Scalars['Int']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus?: Maybe<Scalars['String']>;
  /** Connection between the MediaItem type and the Comment type */
  comments?: Maybe<MediaItemToCommentConnection>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** Description of the image (stored as post_content) */
  description?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The filesize in bytes of the resource */
  fileSize?: Maybe<Scalars['Int']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the attachment object. */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** Details about the mediaItem */
  mediaDetails?: Maybe<MediaDetails>;
  /** The id field matches the WP_Post-&gt;ID field. */
  mediaItemId: Scalars['Int'];
  /** Url of the mediaItem */
  mediaItemUrl?: Maybe<Scalars['String']>;
  /** Type of resource */
  mediaType?: Maybe<Scalars['String']>;
  /** The mime type of the mediaItem */
  mimeType?: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /** The parent of the node. The parent object can be of various types */
  parent?: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** The sizes attribute value for an image. */
  sizes?: Maybe<Scalars['String']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** Url of the mediaItem */
  sourceUrl?: Maybe<Scalars['String']>;
  /** The srcset attribute specifies the URL of the image to use in different situations. It is a comma separated string of urls and their widths. */
  srcSet?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The mediaItem type */
export type MediaItemAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};


/** The mediaItem type */
export type MediaItemCaptionArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The mediaItem type */
export type MediaItemChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};


/** The mediaItem type */
export type MediaItemCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MediaItemToCommentConnectionWhereArgs>;
};


/** The mediaItem type */
export type MediaItemDescriptionArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The mediaItem type */
export type MediaItemEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The mediaItem type */
export type MediaItemEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The mediaItem type */
export type MediaItemFileSizeArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** The mediaItem type */
export type MediaItemSizesArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** The mediaItem type */
export type MediaItemSourceUrlArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** The mediaItem type */
export type MediaItemSrcSetArgs = {
  size?: InputMaybe<MediaItemSizeEnum>;
};


/** The mediaItem type */
export type MediaItemTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum MediaItemIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a media item by its source url */
  SourceUrl = 'SOURCE_URL',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Meta connected to a MediaItem */
export type MediaItemMeta = {
  __typename?: 'MediaItemMeta';
  /** Aperture measurement of the media item. */
  aperture?: Maybe<Scalars['Float']>;
  /** Information about the camera used to create the media item. */
  camera?: Maybe<Scalars['String']>;
  /** The text string description associated with the media item. */
  caption?: Maybe<Scalars['String']>;
  /** Copyright information associated with the media item. */
  copyright?: Maybe<Scalars['String']>;
  /** The date/time when the media was created. */
  createdTimestamp?: Maybe<Scalars['Int']>;
  /** The original creator of the media item. */
  credit?: Maybe<Scalars['String']>;
  /** The focal length value of the media item. */
  focalLength?: Maybe<Scalars['Float']>;
  /** The ISO (International Organization for Standardization) value of the media item. */
  iso?: Maybe<Scalars['Int']>;
  /** List of keywords used to describe or identfy the media item. */
  keywords?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The vertical or horizontal aspect of the media item. */
  orientation?: Maybe<Scalars['String']>;
  /** The shutter speed information of the media item. */
  shutterSpeed?: Maybe<Scalars['Float']>;
  /** A useful title for the media item. */
  title?: Maybe<Scalars['String']>;
};

/** The size of the media item object. */
export enum MediaItemSizeEnum {
  /** MediaItem with the blog-large size */
  BlogLarge = 'BLOG_LARGE',
  /** MediaItem with the blog-medium size */
  BlogMedium = 'BLOG_MEDIUM',
  /** MediaItem with the fusion-200 size */
  Fusion_200 = 'FUSION_200',
  /** MediaItem with the fusion-400 size */
  Fusion_400 = 'FUSION_400',
  /** MediaItem with the fusion-600 size */
  Fusion_600 = 'FUSION_600',
  /** MediaItem with the fusion-800 size */
  Fusion_800 = 'FUSION_800',
  /** MediaItem with the fusion-1200 size */
  Fusion_1200 = 'FUSION_1200',
  /** MediaItem with the large size */
  Large = 'LARGE',
  /** MediaItem with the medium size */
  Medium = 'MEDIUM',
  /** MediaItem with the medium_large size */
  MediumLarge = 'MEDIUM_LARGE',
  /** MediaItem with the recent-posts size */
  RecentPosts = 'RECENT_POSTS',
  /** MediaItem with the recent-works-thumbnail size */
  RecentWorksThumbnail = 'RECENT_WORKS_THUMBNAIL',
  /** MediaItem with the thumbnail size */
  Thumbnail = 'THUMBNAIL',
  /** MediaItem with the 1536x1536 size */
  '1536X1536' = '_1536X1536',
  /** MediaItem with the 2048x2048 size */
  '2048X2048' = '_2048X2048'
}

/** The status of the media item object. */
export enum MediaItemStatusEnum {
  /** Objects with the auto-draft status */
  AutoDraft = 'AUTO_DRAFT',
  /** Objects with the inherit status */
  Inherit = 'INHERIT',
  /** Objects with the private status */
  Private = 'PRIVATE',
  /** Objects with the trash status */
  Trash = 'TRASH'
}

/** Connection between the MediaItem type and the Comment type */
export type MediaItemToCommentConnection = {
  __typename?: 'MediaItemToCommentConnection';
  /** Edges for the MediaItemToCommentConnection connection */
  edges?: Maybe<Array<Maybe<MediaItemToCommentConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Comment>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type MediaItemToCommentConnectionEdge = {
  __typename?: 'MediaItemToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Comment>;
};

/** Arguments for filtering the MediaItemToCommentConnection connection */
export type MediaItemToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Details of an available size for a media item */
export type MediaSize = {
  __typename?: 'MediaSize';
  /** The filename of the referenced size */
  file?: Maybe<Scalars['String']>;
  /** The filesize of the resource */
  fileSize?: Maybe<Scalars['Int']>;
  /** The height of the referenced size */
  height?: Maybe<Scalars['String']>;
  /** The mime type of the referenced size */
  mimeType?: Maybe<Scalars['String']>;
  /** The referenced size name */
  name?: Maybe<Scalars['String']>;
  /** The url of the referenced size */
  sourceUrl?: Maybe<Scalars['String']>;
  /** The width of the referenced size */
  width?: Maybe<Scalars['String']>;
};

/** Menus are the containers for navigation items. Menus can be assigned to menu locations, which are typically registered by the active theme. */
export type Menu = DatabaseIdentifier & Node & {
  __typename?: 'Menu';
  /** The number of items in the menu */
  count?: Maybe<Scalars['Int']>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** The globally unique identifier of the nav menu object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** The locations a menu is assigned to */
  locations?: Maybe<Array<Maybe<MenuLocationEnum>>>;
  /** WP ID of the nav menu. */
  menuId?: Maybe<Scalars['Int']>;
  /** Connection between the Menu type and the MenuItem type */
  menuItems?: Maybe<MenuToMenuItemConnection>;
  /** Display name of the menu. Equivalent to WP_Term-&gt;name. */
  name?: Maybe<Scalars['String']>;
  /** The url friendly name of the menu. Equivalent to WP_Term-&gt;slug */
  slug?: Maybe<Scalars['String']>;
};


/** Menus are the containers for navigation items. Menus can be assigned to menu locations, which are typically registered by the active theme. */
export type MenuMenuItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MenuToMenuItemConnectionWhereArgs>;
};

/** Navigation menu items are the individual items assigned to a menu. These are rendered as the links in a navigation menu. */
export type MenuItem = DatabaseIdentifier & Node & {
  __typename?: 'MenuItem';
  /** Connection between the MenuItem type and the MenuItem type */
  childItems?: Maybe<MenuItemToMenuItemConnection>;
  /** Connection from MenuItem to it&#039;s connected node */
  connectedNode?: Maybe<MenuItemToMenuItemLinkableConnectionEdge>;
  /** The object connected to this menu item. */
  connectedObject?: Maybe<MenuItemObjectUnion>;
  /** Class attribute for the menu item link */
  cssClasses?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The unique identifier stored in the database */
  databaseId: Scalars['Int'];
  /** Description of the menu item. */
  description?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the nav menu item object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Label or title of the menu item. */
  label?: Maybe<Scalars['String']>;
  /** Link relationship (XFN) of the menu item. */
  linkRelationship?: Maybe<Scalars['String']>;
  /** The locations the menu item&#039;s Menu is assigned to */
  locations?: Maybe<Array<Maybe<MenuLocationEnum>>>;
  /** The Menu a MenuItem is part of */
  menu?: Maybe<MenuItemToMenuConnectionEdge>;
  /** WP ID of the menu item. */
  menuItemId?: Maybe<Scalars['Int']>;
  /** Menu item order */
  order?: Maybe<Scalars['Int']>;
  /** The database id of the parent menu item or null if it is the root */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent nav menu item object. */
  parentId?: Maybe<Scalars['ID']>;
  /** Path for the resource. Relative path for internal resources. Absolute path for external resources. */
  path?: Maybe<Scalars['String']>;
  /** Target attribute for the menu item link. */
  target?: Maybe<Scalars['String']>;
  /** Title attribute for the menu item link */
  title?: Maybe<Scalars['String']>;
  /** The uri of the resource the menu item links to */
  uri?: Maybe<Scalars['String']>;
  /** URL or destination of the menu item. */
  url?: Maybe<Scalars['String']>;
};


/** Navigation menu items are the individual items assigned to a menu. These are rendered as the links in a navigation menu. */
export type MenuItemChildItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<MenuItemToMenuItemConnectionWhereArgs>;
};

/** Nodes that can be linked to as Menu Items */
export type MenuItemLinkable = {
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** The unique resource identifier path */
  id: Scalars['ID'];
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};

/** The Type of Identifier used to fetch a single node. Default is "ID". To be used along with the "id" field. */
export enum MenuItemNodeIdTypeEnum {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID'
}

/** Deprecated in favor of MenuItemLinkeable Interface */
export type MenuItemObjectUnion = Category | Ebook | EbooksCategory | Page | Post | PostFormat | ResearchSummariesCategory | ResearchSummary | Resource | ResourceCategory | Tag | VideoSeriesCategory | VideoSeriesItem | Webinar | WebinarsCategory;

/** Connection between the MenuItem type and the Menu type */
export type MenuItemToMenuConnectionEdge = {
  __typename?: 'MenuItemToMenuConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Menu>;
};

/** Connection between the MenuItem type and the MenuItem type */
export type MenuItemToMenuItemConnection = {
  __typename?: 'MenuItemToMenuItemConnection';
  /** Edges for the MenuItemToMenuItemConnection connection */
  edges?: Maybe<Array<Maybe<MenuItemToMenuItemConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<MenuItem>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type MenuItemToMenuItemConnectionEdge = {
  __typename?: 'MenuItemToMenuItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<MenuItem>;
};

/** Arguments for filtering the MenuItemToMenuItemConnection connection */
export type MenuItemToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** The menu location for the menu being queried */
  location?: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  parentDatabaseId?: InputMaybe<Scalars['Int']>;
  /** The ID of the parent menu object */
  parentId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the MenuItem type and the MenuItemLinkable type */
export type MenuItemToMenuItemLinkableConnectionEdge = {
  __typename?: 'MenuItemToMenuItemLinkableConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<MenuItemLinkable>;
};

/** Registered menu locations */
export enum MenuLocationEnum {
  /** Put the menu in the main_navigation location */
  MainNavigation = 'MAIN_NAVIGATION',
  /** Put the menu in the mobile_navigation location */
  MobileNavigation = 'MOBILE_NAVIGATION',
  /** Put the menu in the sticky_navigation location */
  StickyNavigation = 'STICKY_NAVIGATION',
  /** Put the menu in the top_navigation location */
  TopNavigation = 'TOP_NAVIGATION',
  /** Put the menu in the 404_pages location */
  '404Pages' = '_404_PAGES'
}

/** The Type of Identifier used to fetch a single node. Default is "ID". To be used along with the "id" field. */
export enum MenuNodeIdTypeEnum {
  /** Identify a menu node by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a menu node by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a menu node by the slug of menu location to which it is assigned */
  Location = 'LOCATION',
  /** Identify a menu node by its name */
  Name = 'NAME',
  /** Identify a menu node by its slug */
  Slug = 'SLUG'
}

/** Connection between the Menu type and the MenuItem type */
export type MenuToMenuItemConnection = {
  __typename?: 'MenuToMenuItemConnection';
  /** Edges for the MenuToMenuItemConnection connection */
  edges?: Maybe<Array<Maybe<MenuToMenuItemConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<MenuItem>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type MenuToMenuItemConnectionEdge = {
  __typename?: 'MenuToMenuItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<MenuItem>;
};

/** Arguments for filtering the MenuToMenuItemConnection connection */
export type MenuToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** The menu location for the menu being queried */
  location?: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  parentDatabaseId?: InputMaybe<Scalars['Int']>;
  /** The ID of the parent menu object */
  parentId?: InputMaybe<Scalars['ID']>;
};

export type MergeOrganisationsInput = {
  main: Scalars['uuid'];
  merge: Array<InputMaybe<Scalars['uuid']>>;
};

export type MergeOrganisationsOutput = {
  __typename?: 'MergeOrganisationsOutput';
  message: Scalars['String'];
  status: MergeOrganisationsStatus;
};

export enum MergeOrganisationsStatus {
  Fail = 'FAIL',
  Success = 'SUCCESS'
}

export enum MergeUserError {
  GeneralError = 'GENERAL_ERROR'
}

export type MergeUserOutput = {
  __typename?: 'MergeUserOutput';
  error?: Maybe<MergeUserError>;
  success: Scalars['Boolean'];
};

/** The MimeType of the object */
export enum MimeTypeEnum {
  /** MimeType application/java */
  ApplicationJava = 'APPLICATION_JAVA',
  /** MimeType application/json */
  ApplicationJson = 'APPLICATION_JSON',
  /** MimeType application/msword */
  ApplicationMsword = 'APPLICATION_MSWORD',
  /** MimeType application/octet-stream */
  ApplicationOctetStream = 'APPLICATION_OCTET_STREAM',
  /** MimeType application/onenote */
  ApplicationOnenote = 'APPLICATION_ONENOTE',
  /** MimeType application/oxps */
  ApplicationOxps = 'APPLICATION_OXPS',
  /** MimeType application/pdf */
  ApplicationPdf = 'APPLICATION_PDF',
  /** MimeType application/rar */
  ApplicationRar = 'APPLICATION_RAR',
  /** MimeType application/rtf */
  ApplicationRtf = 'APPLICATION_RTF',
  /** MimeType application/ttaf+xml */
  ApplicationTtafXml = 'APPLICATION_TTAF_XML',
  /** MimeType application/vnd.apple.keynote */
  ApplicationVndAppleKeynote = 'APPLICATION_VND_APPLE_KEYNOTE',
  /** MimeType application/vnd.apple.numbers */
  ApplicationVndAppleNumbers = 'APPLICATION_VND_APPLE_NUMBERS',
  /** MimeType application/vnd.apple.pages */
  ApplicationVndApplePages = 'APPLICATION_VND_APPLE_PAGES',
  /** MimeType application/vnd.ms-access */
  ApplicationVndMsAccess = 'APPLICATION_VND_MS_ACCESS',
  /** MimeType application/vnd.ms-excel */
  ApplicationVndMsExcel = 'APPLICATION_VND_MS_EXCEL',
  /** MimeType application/vnd.ms-excel.addin.macroEnabled.12 */
  ApplicationVndMsExcelAddinMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_ADDIN_MACROENABLED_12',
  /** MimeType application/vnd.ms-excel.sheet.binary.macroEnabled.12 */
  ApplicationVndMsExcelSheetBinaryMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_SHEET_BINARY_MACROENABLED_12',
  /** MimeType application/vnd.ms-excel.sheet.macroEnabled.12 */
  ApplicationVndMsExcelSheetMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_SHEET_MACROENABLED_12',
  /** MimeType application/vnd.ms-excel.template.macroEnabled.12 */
  ApplicationVndMsExcelTemplateMacroenabled_12 = 'APPLICATION_VND_MS_EXCEL_TEMPLATE_MACROENABLED_12',
  /** MimeType application/vnd.ms-powerpoint */
  ApplicationVndMsPowerpoint = 'APPLICATION_VND_MS_POWERPOINT',
  /** MimeType application/vnd.ms-powerpoint.addin.macroEnabled.12 */
  ApplicationVndMsPowerpointAddinMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_ADDIN_MACROENABLED_12',
  /** MimeType application/vnd.ms-powerpoint.presentation.macroEnabled.12 */
  ApplicationVndMsPowerpointPresentationMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_PRESENTATION_MACROENABLED_12',
  /** MimeType application/vnd.ms-powerpoint.slideshow.macroEnabled.12 */
  ApplicationVndMsPowerpointSlideshowMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_SLIDESHOW_MACROENABLED_12',
  /** MimeType application/vnd.ms-powerpoint.slide.macroEnabled.12 */
  ApplicationVndMsPowerpointSlideMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_SLIDE_MACROENABLED_12',
  /** MimeType application/vnd.ms-powerpoint.template.macroEnabled.12 */
  ApplicationVndMsPowerpointTemplateMacroenabled_12 = 'APPLICATION_VND_MS_POWERPOINT_TEMPLATE_MACROENABLED_12',
  /** MimeType application/vnd.ms-project */
  ApplicationVndMsProject = 'APPLICATION_VND_MS_PROJECT',
  /** MimeType application/vnd.ms-word.document.macroEnabled.12 */
  ApplicationVndMsWordDocumentMacroenabled_12 = 'APPLICATION_VND_MS_WORD_DOCUMENT_MACROENABLED_12',
  /** MimeType application/vnd.ms-word.template.macroEnabled.12 */
  ApplicationVndMsWordTemplateMacroenabled_12 = 'APPLICATION_VND_MS_WORD_TEMPLATE_MACROENABLED_12',
  /** MimeType application/vnd.ms-write */
  ApplicationVndMsWrite = 'APPLICATION_VND_MS_WRITE',
  /** MimeType application/vnd.ms-xpsdocument */
  ApplicationVndMsXpsdocument = 'APPLICATION_VND_MS_XPSDOCUMENT',
  /** MimeType application/vnd.oasis.opendocument.chart */
  ApplicationVndOasisOpendocumentChart = 'APPLICATION_VND_OASIS_OPENDOCUMENT_CHART',
  /** MimeType application/vnd.oasis.opendocument.database */
  ApplicationVndOasisOpendocumentDatabase = 'APPLICATION_VND_OASIS_OPENDOCUMENT_DATABASE',
  /** MimeType application/vnd.oasis.opendocument.formula */
  ApplicationVndOasisOpendocumentFormula = 'APPLICATION_VND_OASIS_OPENDOCUMENT_FORMULA',
  /** MimeType application/vnd.oasis.opendocument.graphics */
  ApplicationVndOasisOpendocumentGraphics = 'APPLICATION_VND_OASIS_OPENDOCUMENT_GRAPHICS',
  /** MimeType application/vnd.oasis.opendocument.presentation */
  ApplicationVndOasisOpendocumentPresentation = 'APPLICATION_VND_OASIS_OPENDOCUMENT_PRESENTATION',
  /** MimeType application/vnd.oasis.opendocument.spreadsheet */
  ApplicationVndOasisOpendocumentSpreadsheet = 'APPLICATION_VND_OASIS_OPENDOCUMENT_SPREADSHEET',
  /** MimeType application/vnd.oasis.opendocument.text */
  ApplicationVndOasisOpendocumentText = 'APPLICATION_VND_OASIS_OPENDOCUMENT_TEXT',
  /** MimeType application/vnd.openxmlformats-officedocument.presentationml.presentation */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlPresentation = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_PRESENTATION',
  /** MimeType application/vnd.openxmlformats-officedocument.presentationml.slide */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlide = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDE',
  /** MimeType application/vnd.openxmlformats-officedocument.presentationml.slideshow */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlSlideshow = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_SLIDESHOW',
  /** MimeType application/vnd.openxmlformats-officedocument.presentationml.template */
  ApplicationVndOpenxmlformatsOfficedocumentPresentationmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_PRESENTATIONML_TEMPLATE',
  /** MimeType application/vnd.openxmlformats-officedocument.spreadsheetml.sheet */
  ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlSheet = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_SHEET',
  /** MimeType application/vnd.openxmlformats-officedocument.spreadsheetml.template */
  ApplicationVndOpenxmlformatsOfficedocumentSpreadsheetmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_SPREADSHEETML_TEMPLATE',
  /** MimeType application/vnd.openxmlformats-officedocument.wordprocessingml.document */
  ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlDocument = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_DOCUMENT',
  /** MimeType application/vnd.openxmlformats-officedocument.wordprocessingml.template */
  ApplicationVndOpenxmlformatsOfficedocumentWordprocessingmlTemplate = 'APPLICATION_VND_OPENXMLFORMATS_OFFICEDOCUMENT_WORDPROCESSINGML_TEMPLATE',
  /** MimeType application/wordperfect */
  ApplicationWordperfect = 'APPLICATION_WORDPERFECT',
  /** MimeType application/x-7z-compressed */
  ApplicationX_7ZCompressed = 'APPLICATION_X_7Z_COMPRESSED',
  /** MimeType application/x-gzip */
  ApplicationXGzip = 'APPLICATION_X_GZIP',
  /** MimeType application/x-tar */
  ApplicationXTar = 'APPLICATION_X_TAR',
  /** MimeType application/zip */
  ApplicationZip = 'APPLICATION_ZIP',
  /** MimeType audio/aac */
  AudioAac = 'AUDIO_AAC',
  /** MimeType audio/flac */
  AudioFlac = 'AUDIO_FLAC',
  /** MimeType audio/midi */
  AudioMidi = 'AUDIO_MIDI',
  /** MimeType audio/mpeg */
  AudioMpeg = 'AUDIO_MPEG',
  /** MimeType audio/ogg */
  AudioOgg = 'AUDIO_OGG',
  /** MimeType audio/wav */
  AudioWav = 'AUDIO_WAV',
  /** MimeType audio/x-matroska */
  AudioXMatroska = 'AUDIO_X_MATROSKA',
  /** MimeType audio/x-ms-wax */
  AudioXMsWax = 'AUDIO_X_MS_WAX',
  /** MimeType audio/x-ms-wma */
  AudioXMsWma = 'AUDIO_X_MS_WMA',
  /** MimeType audio/x-realaudio */
  AudioXRealaudio = 'AUDIO_X_REALAUDIO',
  /** MimeType image/avif */
  ImageAvif = 'IMAGE_AVIF',
  /** MimeType image/bmp */
  ImageBmp = 'IMAGE_BMP',
  /** MimeType image/gif */
  ImageGif = 'IMAGE_GIF',
  /** MimeType image/heic */
  ImageHeic = 'IMAGE_HEIC',
  /** MimeType image/heic-sequence */
  ImageHeicSequence = 'IMAGE_HEIC_SEQUENCE',
  /** MimeType image/heif */
  ImageHeif = 'IMAGE_HEIF',
  /** MimeType image/heif-sequence */
  ImageHeifSequence = 'IMAGE_HEIF_SEQUENCE',
  /** MimeType image/jpeg */
  ImageJpeg = 'IMAGE_JPEG',
  /** MimeType image/png */
  ImagePng = 'IMAGE_PNG',
  /** MimeType image/tiff */
  ImageTiff = 'IMAGE_TIFF',
  /** MimeType image/webp */
  ImageWebp = 'IMAGE_WEBP',
  /** MimeType image/x-icon */
  ImageXIcon = 'IMAGE_X_ICON',
  /** MimeType text/calendar */
  TextCalendar = 'TEXT_CALENDAR',
  /** MimeType text/css */
  TextCss = 'TEXT_CSS',
  /** MimeType text/csv */
  TextCsv = 'TEXT_CSV',
  /** MimeType text/plain */
  TextPlain = 'TEXT_PLAIN',
  /** MimeType text/richtext */
  TextRichtext = 'TEXT_RICHTEXT',
  /** MimeType text/tab-separated-values */
  TextTabSeparatedValues = 'TEXT_TAB_SEPARATED_VALUES',
  /** MimeType text/vtt */
  TextVtt = 'TEXT_VTT',
  /** MimeType video/3gpp */
  Video_3Gpp = 'VIDEO_3GPP',
  /** MimeType video/3gpp2 */
  Video_3Gpp2 = 'VIDEO_3GPP2',
  /** MimeType video/avi */
  VideoAvi = 'VIDEO_AVI',
  /** MimeType video/divx */
  VideoDivx = 'VIDEO_DIVX',
  /** MimeType video/mp4 */
  VideoMp4 = 'VIDEO_MP4',
  /** MimeType video/mpeg */
  VideoMpeg = 'VIDEO_MPEG',
  /** MimeType video/ogg */
  VideoOgg = 'VIDEO_OGG',
  /** MimeType video/quicktime */
  VideoQuicktime = 'VIDEO_QUICKTIME',
  /** MimeType video/webm */
  VideoWebm = 'VIDEO_WEBM',
  /** MimeType video/x-flv */
  VideoXFlv = 'VIDEO_X_FLV',
  /** MimeType video/x-matroska */
  VideoXMatroska = 'VIDEO_X_MATROSKA',
  /** MimeType video/x-ms-asf */
  VideoXMsAsf = 'VIDEO_X_MS_ASF',
  /** MimeType video/x-ms-wm */
  VideoXMsWm = 'VIDEO_X_MS_WM',
  /** MimeType video/x-ms-wmv */
  VideoXMsWmv = 'VIDEO_X_MS_WMV',
  /** MimeType video/x-ms-wmx */
  VideoXMsWmx = 'VIDEO_X_MS_WMX'
}

/** An object with an ID */
export type Node = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** A node that can have an author assigned to it */
export type NodeWithAuthor = {
  /** Connection between the NodeWithAuthor type and the User type */
  author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the author of the node */
  authorId?: Maybe<Scalars['ID']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** Connection between the NodeWithAuthor type and the User type */
export type NodeWithAuthorToUserConnectionEdge = {
  __typename?: 'NodeWithAuthorToUserConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<User>;
};

/** A node that can have comments associated with it */
export type NodeWithComments = {
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount?: Maybe<Scalars['Int']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus?: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** A node that supports the content editor */
export type NodeWithContentEditor = {
  /** The content of the post. */
  content?: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};


/** A node that supports the content editor */
export type NodeWithContentEditorContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A node that can have an excerpt */
export type NodeWithExcerpt = {
  /** The excerpt of the post. */
  excerpt?: Maybe<Scalars['String']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};


/** A node that can have an excerpt */
export type NodeWithExcerptExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A node that can have a featured image set */
export type NodeWithFeaturedImage = {
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']>;
  /** The globally unique ID for the object */
  id: Scalars['ID'];
};

/** Connection between the NodeWithFeaturedImage type and the MediaItem type */
export type NodeWithFeaturedImageToMediaItemConnectionEdge = {
  __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<MediaItem>;
};

/** A node that can have page attributes */
export type NodeWithPageAttributes = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: Maybe<Scalars['Int']>;
};

/** A node that can have revisions */
export type NodeWithRevisions = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** True if the node is a revision of another node */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  revisionOf?: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
};

/** Connection between the NodeWithRevisions type and the ContentNode type */
export type NodeWithRevisionsToContentNodeConnectionEdge = {
  __typename?: 'NodeWithRevisionsToContentNodeConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<ContentNode>;
};

/** A node that can have a template associated with it */
export type NodeWithTemplate = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
};

/** A node that NodeWith a title */
export type NodeWithTitle = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
};


/** A node that NodeWith a title */
export type NodeWithTitleTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** A node that can have trackbacks and pingbacks */
export type NodeWithTrackbacks = {
  /** The globally unique ID for the object */
  id: Scalars['ID'];
  /** Whether the pings are open or closed for this particular post. */
  pingStatus?: Maybe<Scalars['String']>;
  /** URLs that have been pinged. */
  pinged?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** URLs queued to be pinged. */
  toPing?: Maybe<Array<Maybe<Scalars['String']>>>;
};

export type NotifyCourseEditOutput = {
  __typename?: 'NotifyCourseEditOutput';
  status: Scalars['Int'];
};

export type NotifyCourseInput = {
  courseId: Scalars['Int'];
  endDate: Scalars['date'];
  level: CourseLevel;
  parkingInstructions: Scalars['String'];
  specialInstructions: Scalars['String'];
  startDate: Scalars['date'];
  venueId?: InputMaybe<Scalars['uuid']>;
  virtualLink?: InputMaybe<Scalars['String']>;
};

export type NotifyCourseTrainerInput = {
  id: Scalars['uuid'];
  type: CourseTrainerType;
};

export type NotifyInternalUsersOfInviteAttemptInput = {
  course: Scalars['Int'];
  invitedBy: Scalars['uuid'];
  inviteesList: Array<Scalars['String']>;
};

export type NotifyInternalUsersOfInviteAttemptOutput = {
  __typename?: 'NotifyInternalUsersOfInviteAttemptOutput';
  success: Scalars['Boolean'];
};

export enum OrderDirection {
  Asc = 'ASC',
  Desc = 'DESC'
}

/** The cardinality of the connection order */
export enum OrderEnum {
  /** Sort the query result set in an ascending order */
  Asc = 'ASC',
  /** Sort the query result set in a descending order */
  Desc = 'DESC'
}

export type Ordering = {
  direction?: InputMaybe<OrderDirection>;
};

export type OrgInvite = {
  __typename?: 'OrgInvite';
  id: Scalars['String'];
  orgId: Scalars['String'];
  orgName: Scalars['String'];
};

/** The page type */
export type Page = ContentNode & DatabaseIdentifier & HierarchicalContentNode & MenuItemLinkable & Node & NodeWithAuthor & NodeWithComments & NodeWithContentEditor & NodeWithFeaturedImage & NodeWithPageAttributes & NodeWithRevisions & NodeWithTemplate & NodeWithTitle & UniformResourceIdentifiable & {
  __typename?: 'Page';
  /** Returns ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<HierarchicalContentNodeToContentNodeAncestorsConnection>;
  /** Connection between the NodeWithAuthor type and the User type */
  author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the author of the node */
  authorId?: Maybe<Scalars['ID']>;
  /** Connection between the HierarchicalContentNode type and the ContentNode type */
  children?: Maybe<HierarchicalContentNodeToContentNodeChildrenConnection>;
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount?: Maybe<Scalars['Int']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus?: Maybe<Scalars['String']>;
  /** Connection between the Page type and the Comment type */
  comments?: Maybe<PageToCommentConnection>;
  /** The content of the post. */
  content?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the page object. */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether this page is set to the static front page. */
  isFrontPage: Scalars['Boolean'];
  /** Whether this page is set to the blog posts page. */
  isPostsPage: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether this page is set to the privacy page. */
  isPrivacyPage: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** True if the node is a revision of another node */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: Maybe<Scalars['Int']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /** The id field matches the WP_Post-&gt;ID field. */
  pageId: Scalars['Int'];
  /** The parent of the node. The parent object can be of various types */
  parent?: Maybe<HierarchicalContentNodeToParentContentNodeConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
  /** Connection between the Page type and the page type */
  preview?: Maybe<PageToPreviewConnectionEdge>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  revisionOf?: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
  /** Connection between the Page type and the page type */
  revisions?: Maybe<PageToRevisionConnection>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The page type */
export type PageAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeAncestorsConnectionWhereArgs>;
};


/** The page type */
export type PageChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<HierarchicalContentNodeToContentNodeChildrenConnectionWhereArgs>;
};


/** The page type */
export type PageCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageToCommentConnectionWhereArgs>;
};


/** The page type */
export type PageContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The page type */
export type PageEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The page type */
export type PageEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The page type */
export type PageRevisionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PageToRevisionConnectionWhereArgs>;
};


/** The page type */
export type PageTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum PageIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Connection between the Page type and the Comment type */
export type PageToCommentConnection = {
  __typename?: 'PageToCommentConnection';
  /** Edges for the PageToCommentConnection connection */
  edges?: Maybe<Array<Maybe<PageToCommentConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Comment>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type PageToCommentConnectionEdge = {
  __typename?: 'PageToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Comment>;
};

/** Arguments for filtering the PageToCommentConnection connection */
export type PageToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the Page type and the page type */
export type PageToPreviewConnectionEdge = {
  __typename?: 'PageToPreviewConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Page>;
};

/** Connection between the Page type and the page type */
export type PageToRevisionConnection = {
  __typename?: 'PageToRevisionConnection';
  /** Edges for the PageToRevisionConnection connection */
  edges?: Maybe<Array<Maybe<PageToRevisionConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Page>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type PageToRevisionConnectionEdge = {
  __typename?: 'PageToRevisionConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Page>;
};

/** Arguments for filtering the PageToRevisionConnection connection */
export type PageToRevisionConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

export type Paging = {
  page?: InputMaybe<Scalars['Int']>;
  perPage?: InputMaybe<Scalars['Int']>;
};

export enum PaymentMethod {
  Cc = 'CC',
  Invoice = 'INVOICE'
}

export type PlanObject = {
  __typename?: 'PlanObject';
  active?: Maybe<Scalars['Boolean']>;
  billingInterval?: Maybe<Scalars['String']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  productName?: Maybe<Scalars['String']>;
  unitAmount?: Maybe<Scalars['Int']>;
};

export type PlansCreateInput = {
  amount: Scalars['Int'];
  currency: Scalars['String'];
  name: Scalars['String'];
  recurring_count: Scalars['Int'];
  recurring_type: BillingInterval;
  trial_count: Scalars['Int'];
  trial_type: BillingInterval;
};

export type PlansCreateResult = {
  __typename?: 'PlansCreateResult';
  id: Scalars['String'];
};

/** An plugin object */
export type Plugin = Node & {
  __typename?: 'Plugin';
  /** Name of the plugin author(s), may also be a company name. */
  author?: Maybe<Scalars['String']>;
  /** URI for the related author(s)/company website. */
  authorUri?: Maybe<Scalars['String']>;
  /** Description of the plugin. */
  description?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the plugin object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Display name of the plugin. */
  name?: Maybe<Scalars['String']>;
  /** Plugin path. */
  path?: Maybe<Scalars['String']>;
  /** URI for the plugin website. This is useful for directing users for support requests etc. */
  pluginUri?: Maybe<Scalars['String']>;
  /** Current version of the plugin. */
  version?: Maybe<Scalars['String']>;
};

/** The status of the WordPress plugin. */
export enum PluginStatusEnum {
  /** The plugin is currently active. */
  Active = 'ACTIVE',
  /** The plugin is a drop-in plugin. */
  DropIn = 'DROP_IN',
  /** The plugin is currently inactive. */
  Inactive = 'INACTIVE',
  /** The plugin is a must-use plugin. */
  MustUse = 'MUST_USE',
  /** The plugin is technically active but was paused while loading. */
  Paused = 'PAUSED',
  /** The plugin was active recently. */
  RecentlyActive = 'RECENTLY_ACTIVE',
  /** The plugin has an upgrade available. */
  Upgrade = 'UPGRADE'
}

export type Podcast = {
  __typename?: 'Podcast';
  author: Scalars['String'];
  description?: Maybe<Scalars['String']>;
  episodeNumber: Scalars['Int'];
  id: Scalars['String'];
  mediaUrl: Scalars['String'];
  name: Scalars['String'];
  publishedDate: Scalars['String'];
  thumbnail: Scalars['String'];
};

export type PodcastPayload = {
  __typename?: 'PodcastPayload';
  podcast?: Maybe<Podcast>;
};

export type PodcastsInput = {
  order?: InputMaybe<Ordering>;
  paging?: InputMaybe<Paging>;
  term?: InputMaybe<Scalars['String']>;
};

export type PodcastsPayload = {
  __typename?: 'PodcastsPayload';
  records: Array<Podcast>;
  total: Scalars['Int'];
};

/** The post type */
export type Post = ContentNode & DatabaseIdentifier & MenuItemLinkable & Node & NodeWithAuthor & NodeWithComments & NodeWithContentEditor & NodeWithExcerpt & NodeWithFeaturedImage & NodeWithRevisions & NodeWithTemplate & NodeWithTitle & NodeWithTrackbacks & UniformResourceIdentifiable & {
  __typename?: 'Post';
  /** Connection between the NodeWithAuthor type and the User type */
  author?: Maybe<NodeWithAuthorToUserConnectionEdge>;
  /** The database identifier of the author of the node */
  authorDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the author of the node */
  authorId?: Maybe<Scalars['ID']>;
  /** Connection between the Post type and the category type */
  categories?: Maybe<PostToCategoryConnection>;
  /** The number of comments. Even though WPGraphQL denotes this field as an integer, in WordPress this field should be saved as a numeric string for compatibility. */
  commentCount?: Maybe<Scalars['Int']>;
  /** Whether the comments are open or closed for this particular post. */
  commentStatus?: Maybe<Scalars['String']>;
  /** Connection between the Post type and the Comment type */
  comments?: Maybe<PostToCommentConnection>;
  /** The content of the post. */
  content?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Author (Hub)&quot; was set to Show in GraphQL. */
  customAuthor?: Maybe<Post_Customauthor>;
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The excerpt of the post. */
  excerpt?: Maybe<Scalars['String']>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the post object. */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** True if the node is a revision of another node */
  isRevision?: Maybe<Scalars['Boolean']>;
  /** Whether this page is sticky */
  isSticky: Scalars['Boolean'];
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /** Whether the pings are open or closed for this particular post. */
  pingStatus?: Maybe<Scalars['String']>;
  /** URLs that have been pinged. */
  pinged?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Connection between the Post type and the postFormat type */
  postFormats?: Maybe<PostToPostFormatConnection>;
  /** The id field matches the WP_Post-&gt;ID field. */
  postId: Scalars['Int'];
  /** Connection between the Post type and the post type */
  preview?: Maybe<PostToPreviewConnectionEdge>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** If the current node is a revision, this field exposes the node this is a revision of. Returns null if the node is not a revision of another node. */
  revisionOf?: Maybe<NodeWithRevisionsToContentNodeConnectionEdge>;
  /** Connection between the Post type and the post type */
  revisions?: Maybe<PostToRevisionConnection>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** Connection between the Post type and the tag type */
  tags?: Maybe<PostToTagConnection>;
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
  /** Connection between the Post type and the TermNode type */
  terms?: Maybe<PostToTermNodeConnection>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
  /** URLs queued to be pinged. */
  toPing?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The post type */
export type PostCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToCategoryConnectionWhereArgs>;
};


/** The post type */
export type PostCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToCommentConnectionWhereArgs>;
};


/** The post type */
export type PostContentArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The post type */
export type PostEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The post type */
export type PostEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The post type */
export type PostExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The post type */
export type PostPostFormatsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToPostFormatConnectionWhereArgs>;
};


/** The post type */
export type PostRevisionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToRevisionConnectionWhereArgs>;
};


/** The post type */
export type PostTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToTagConnectionWhereArgs>;
};


/** The post type */
export type PostTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostToTermNodeConnectionWhereArgs>;
};


/** The post type */
export type PostTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** Set relationships between the post to categories */
export type PostCategoriesInput = {
  /** If true, this will append the category to existing related categories. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostCategoriesNodeInput>>>;
};

/** List of categories to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostCategoriesNodeInput = {
  /** The description of the category. This field is used to set a description of the category if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the category. If present, this will be used to connect to the post. If no existing category exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the category. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the category. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The postFormat type */
export type PostFormat = DatabaseIdentifier & MenuItemLinkable & Node & TermNode & UniformResourceIdentifiable & {
  __typename?: 'PostFormat';
  /** Connection between the PostFormat type and the ContentNode type */
  contentNodes?: Maybe<PostFormatToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The unique resource identifier path */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** The id field matches the WP_Post-&gt;ID field. */
  postFormatId?: Maybe<Scalars['Int']>;
  /** Connection between the PostFormat type and the post type */
  posts?: Maybe<PostFormatToPostConnection>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the PostFormat type and the Taxonomy type */
  taxonomy?: Maybe<PostFormatToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The postFormat type */
export type PostFormatContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostFormatToContentNodeConnectionWhereArgs>;
};


/** The postFormat type */
export type PostFormatEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The postFormat type */
export type PostFormatEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The postFormat type */
export type PostFormatPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<PostFormatToPostConnectionWhereArgs>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum PostFormatIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the PostFormat type and the ContentNode type */
export type PostFormatToContentNodeConnection = {
  __typename?: 'PostFormatToContentNodeConnection';
  /** Edges for the PostFormatToContentNodeConnection connection */
  edges?: Maybe<Array<Maybe<PostFormatToContentNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type PostFormatToContentNodeConnectionEdge = {
  __typename?: 'PostFormatToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentNode>;
};

/** Arguments for filtering the PostFormatToContentNodeConnection connection */
export type PostFormatToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfPostFormatEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the PostFormat type and the post type */
export type PostFormatToPostConnection = {
  __typename?: 'PostFormatToPostConnection';
  /** Edges for the PostFormatToPostConnection connection */
  edges?: Maybe<Array<Maybe<PostFormatToPostConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Post>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type PostFormatToPostConnectionEdge = {
  __typename?: 'PostFormatToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Post>;
};

/** Arguments for filtering the PostFormatToPostConnection connection */
export type PostFormatToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the PostFormat type and the Taxonomy type */
export type PostFormatToTaxonomyConnectionEdge = {
  __typename?: 'PostFormatToTaxonomyConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Taxonomy>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum PostIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** The format of post field data. */
export enum PostObjectFieldFormatEnum {
  /** Provide the field value directly from database. Null on unauthenticated requests. */
  Raw = 'RAW',
  /** Provide the field value as rendered by WordPress. Default. */
  Rendered = 'RENDERED'
}

/** The column to use when filtering by date */
export enum PostObjectsConnectionDateColumnEnum {
  /** The date the comment was created in local time. */
  Date = 'DATE',
  /** The most recent modification date of the comment. */
  Modified = 'MODIFIED'
}

/** Field to order the connection by */
export enum PostObjectsConnectionOrderbyEnum {
  /** Order by author */
  Author = 'AUTHOR',
  /** Order by the number of comments it has acquired */
  CommentCount = 'COMMENT_COUNT',
  /** Order by publish date */
  Date = 'DATE',
  /** Preserve the ID order given in the IN array */
  In = 'IN',
  /** Order by the menu order value */
  MenuOrder = 'MENU_ORDER',
  /** Order by last modified date */
  Modified = 'MODIFIED',
  /** Preserve slug order given in the NAME_IN array */
  NameIn = 'NAME_IN',
  /** Order by parent ID */
  Parent = 'PARENT',
  /** Order by slug */
  Slug = 'SLUG',
  /** Order by title */
  Title = 'TITLE'
}

/** Options for ordering the connection */
export type PostObjectsConnectionOrderbyInput = {
  /** The field to order the connection by */
  field: PostObjectsConnectionOrderbyEnum;
  /** Possible directions in which to order a list of items */
  order: OrderEnum;
};

/** Set relationships between the post to postFormats */
export type PostPostFormatsInput = {
  /** If true, this will append the postFormat to existing related postFormats. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostPostFormatsNodeInput>>>;
};

/** List of postFormats to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostPostFormatsNodeInput = {
  /** The description of the postFormat. This field is used to set a description of the postFormat if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the postFormat. If present, this will be used to connect to the post. If no existing postFormat exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the postFormat. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the postFormat. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The status of the object. */
export enum PostStatusEnum {
  /** Objects with the acf-disabled status */
  AcfDisabled = 'ACF_DISABLED',
  /** Objects with the auto-draft status */
  AutoDraft = 'AUTO_DRAFT',
  /** Objects with the draft status */
  Draft = 'DRAFT',
  /** Objects with the email_failed status */
  EmailFailed = 'EMAIL_FAILED',
  /** Objects with the email_scheduled status */
  EmailScheduled = 'EMAIL_SCHEDULED',
  /** Objects with the email_sent status */
  EmailSent = 'EMAIL_SENT',
  /** Objects with the future status */
  Future = 'FUTURE',
  /** Objects with the inherit status */
  Inherit = 'INHERIT',
  /** Objects with the pending status */
  Pending = 'PENDING',
  /** Objects with the private status */
  Private = 'PRIVATE',
  /** Objects with the publish status */
  Publish = 'PUBLISH',
  /** Objects with the request-completed status */
  RequestCompleted = 'REQUEST_COMPLETED',
  /** Objects with the request-confirmed status */
  RequestConfirmed = 'REQUEST_CONFIRMED',
  /** Objects with the request-failed status */
  RequestFailed = 'REQUEST_FAILED',
  /** Objects with the request-pending status */
  RequestPending = 'REQUEST_PENDING',
  /** Objects with the trash status */
  Trash = 'TRASH'
}

/** Set relationships between the post to tags */
export type PostTagsInput = {
  /** If true, this will append the tag to existing related tags. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<PostTagsNodeInput>>>;
};

/** List of tags to connect the post to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type PostTagsNodeInput = {
  /** The description of the tag. This field is used to set a description of the tag if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the tag. If present, this will be used to connect to the post. If no existing tag exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the tag. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the tag. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** Connection between the Post type and the category type */
export type PostToCategoryConnection = {
  __typename?: 'PostToCategoryConnection';
  /** Edges for the PostToCategoryConnection connection */
  edges?: Maybe<Array<Maybe<PostToCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Category>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type PostToCategoryConnectionEdge = {
  __typename?: 'PostToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Category>;
};

/** Arguments for filtering the PostToCategoryConnection connection */
export type PostToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the Comment type */
export type PostToCommentConnection = {
  __typename?: 'PostToCommentConnection';
  /** Edges for the PostToCommentConnection connection */
  edges?: Maybe<Array<Maybe<PostToCommentConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Comment>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type PostToCommentConnectionEdge = {
  __typename?: 'PostToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Comment>;
};

/** Arguments for filtering the PostToCommentConnection connection */
export type PostToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the Post type and the postFormat type */
export type PostToPostFormatConnection = {
  __typename?: 'PostToPostFormatConnection';
  /** Edges for the PostToPostFormatConnection connection */
  edges?: Maybe<Array<Maybe<PostToPostFormatConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<PostFormat>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type PostToPostFormatConnectionEdge = {
  __typename?: 'PostToPostFormatConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<PostFormat>;
};

/** Arguments for filtering the PostToPostFormatConnection connection */
export type PostToPostFormatConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the post type */
export type PostToPreviewConnectionEdge = {
  __typename?: 'PostToPreviewConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Post>;
};

/** Connection between the Post type and the post type */
export type PostToRevisionConnection = {
  __typename?: 'PostToRevisionConnection';
  /** Edges for the PostToRevisionConnection connection */
  edges?: Maybe<Array<Maybe<PostToRevisionConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Post>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type PostToRevisionConnectionEdge = {
  __typename?: 'PostToRevisionConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Post>;
};

/** Arguments for filtering the PostToRevisionConnection connection */
export type PostToRevisionConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Post type and the tag type */
export type PostToTagConnection = {
  __typename?: 'PostToTagConnection';
  /** Edges for the PostToTagConnection connection */
  edges?: Maybe<Array<Maybe<PostToTagConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Tag>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type PostToTagConnectionEdge = {
  __typename?: 'PostToTagConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Tag>;
};

/** Arguments for filtering the PostToTagConnection connection */
export type PostToTagConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Post type and the TermNode type */
export type PostToTermNodeConnection = {
  __typename?: 'PostToTermNodeConnection';
  /** Edges for the PostToTermNodeConnection connection */
  edges?: Maybe<Array<Maybe<PostToTermNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<TermNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type PostToTermNodeConnectionEdge = {
  __typename?: 'PostToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<TermNode>;
};

/** Arguments for filtering the PostToTermNodeConnection connection */
export type PostToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies?: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Details for labels of the PostType */
export type PostTypeLabelDetails = {
  __typename?: 'PostTypeLabelDetails';
  /** Default is ‘Add New’ for both hierarchical and non-hierarchical types. */
  addNew?: Maybe<Scalars['String']>;
  /** Label for adding a new singular item. */
  addNewItem?: Maybe<Scalars['String']>;
  /** Label to signify all items in a submenu link. */
  allItems?: Maybe<Scalars['String']>;
  /** Label for archives in nav menus */
  archives?: Maybe<Scalars['String']>;
  /** Label for the attributes meta box. */
  attributes?: Maybe<Scalars['String']>;
  /** Label for editing a singular item. */
  editItem?: Maybe<Scalars['String']>;
  /** Label for the Featured Image meta box title. */
  featuredImage?: Maybe<Scalars['String']>;
  /** Label for the table views hidden heading. */
  filterItemsList?: Maybe<Scalars['String']>;
  /** Label for the media frame button. */
  insertIntoItem?: Maybe<Scalars['String']>;
  /** Label for the table hidden heading. */
  itemsList?: Maybe<Scalars['String']>;
  /** Label for the table pagination hidden heading. */
  itemsListNavigation?: Maybe<Scalars['String']>;
  /** Label for the menu name. */
  menuName?: Maybe<Scalars['String']>;
  /** General name for the post type, usually plural. */
  name?: Maybe<Scalars['String']>;
  /** Label for the new item page title. */
  newItem?: Maybe<Scalars['String']>;
  /** Label used when no items are found. */
  notFound?: Maybe<Scalars['String']>;
  /** Label used when no items are in the trash. */
  notFoundInTrash?: Maybe<Scalars['String']>;
  /** Label used to prefix parents of hierarchical items. */
  parentItemColon?: Maybe<Scalars['String']>;
  /** Label for removing the featured image. */
  removeFeaturedImage?: Maybe<Scalars['String']>;
  /** Label for searching plural items. */
  searchItems?: Maybe<Scalars['String']>;
  /** Label for setting the featured image. */
  setFeaturedImage?: Maybe<Scalars['String']>;
  /** Name for one object of this post type. */
  singularName?: Maybe<Scalars['String']>;
  /** Label for the media frame filter. */
  uploadedToThisItem?: Maybe<Scalars['String']>;
  /** Label in the media frame for using a featured image. */
  useFeaturedImage?: Maybe<Scalars['String']>;
  /** Label for viewing a singular item. */
  viewItem?: Maybe<Scalars['String']>;
  /** Label for viewing post type archives. */
  viewItems?: Maybe<Scalars['String']>;
};

/** Field Group */
export type Post_Customauthor = AcfFieldGroup & {
  __typename?: 'Post_Customauthor';
  authorName?: Maybe<Scalars['String']>;
  displayAuthor?: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
};

export type PromoCodeOutput = {
  __typename?: 'PromoCodeOutput';
  amount: Scalars['Int'];
  code: Scalars['String'];
  type: Scalars['String'];
};

export type PurchaseMaterialsInput = {
  currency: Scalars['String'];
  delivery_city: Scalars['String'];
  delivery_country: Scalars['String'];
  delivery_email: Scalars['String'];
  delivery_first_name: Scalars['String'];
  delivery_last_name: Scalars['String'];
  delivery_line1: Scalars['String'];
  delivery_line2?: InputMaybe<Scalars['String']>;
  delivery_postcode: Scalars['String'];
  invoice_email?: InputMaybe<Scalars['String']>;
  invoice_first_name?: InputMaybe<Scalars['String']>;
  invoice_last_name?: InputMaybe<Scalars['String']>;
  invoice_organization_id: Scalars['uuid'];
  invoice_phone?: InputMaybe<Scalars['String']>;
  invoice_phone_country_code?: InputMaybe<Scalars['String']>;
  invoice_purchase_order?: InputMaybe<Scalars['String']>;
  order_due: Scalars['Float'];
  organization_id: Scalars['uuid'];
  payment_method: Scalars['String'];
  placed_by: Scalars['uuid'];
  purchased: Array<PurchasedBundle>;
};

export type PurchaseMaterialsOutput = {
  __typename?: 'PurchaseMaterialsOutput';
  error?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['String']>;
  success: Scalars['Boolean'];
};

export enum PurchaseType {
  Course = 'COURSE',
  Material = 'MATERIAL'
}

export type PurchasedBundle = {
  bundle_option: Scalars['String'];
  quantity: Scalars['Int'];
};

/** The reading setting type */
export type ReadingSettings = {
  __typename?: 'ReadingSettings';
  /** The ID of the page that should display the latest posts */
  pageForPosts?: Maybe<Scalars['Int']>;
  /** The ID of the page that should be displayed on the front page */
  pageOnFront?: Maybe<Scalars['Int']>;
  /** Blog pages show at most. */
  postsPerPage?: Maybe<Scalars['Int']>;
  /** What to show on the front page */
  showOnFront?: Maybe<Scalars['String']>;
};

/** Input for the registerUser mutation */
export type RegisterUserInput = {
  /** User's AOL IM account. */
  aim?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A string containing content about the user. */
  description?: InputMaybe<Scalars['String']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  displayName?: InputMaybe<Scalars['String']>;
  /** A string containing the user's email address. */
  email?: InputMaybe<Scalars['String']>;
  /** 	The user's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** User's Jabber account. */
  jabber?: InputMaybe<Scalars['String']>;
  /** The user's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** User's locale. */
  locale?: InputMaybe<Scalars['String']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  nicename?: InputMaybe<Scalars['String']>;
  /** The user's nickname, defaults to the user's username. */
  nickname?: InputMaybe<Scalars['String']>;
  /** A string that contains the plain text password for the user. */
  password?: InputMaybe<Scalars['String']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  registered?: InputMaybe<Scalars['String']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  richEditing?: InputMaybe<Scalars['String']>;
  /** A string that contains the user's username. */
  username: Scalars['String'];
  /** A string containing the user's URL for the user's web site. */
  websiteUrl?: InputMaybe<Scalars['String']>;
  /** User's Yahoo IM account. */
  yim?: InputMaybe<Scalars['String']>;
};

/** The payload for the registerUser mutation */
export type RegisterUserPayload = {
  __typename?: 'RegisterUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The User object mutation type. */
  user?: Maybe<User>;
};

export type RejectCourseInput = {
  courseId: Scalars['Int'];
  reason: Scalars['String'];
};

export type RejectCourseOutput = {
  __typename?: 'RejectCourseOutput';
  error?: Maybe<CourseApprovalError>;
  success: Scalars['Boolean'];
};

/** The logical relation between each item in the array when there are more than one. */
export enum RelationEnum {
  /** The logical AND condition returns true if both operands are true, otherwise, it returns false. */
  And = 'AND',
  /** The logical OR condition returns false if both operands are false, otherwise, it returns true. */
  Or = 'OR'
}

export enum ReplaceParticipantError {
  GenericError = 'GENERIC_ERROR',
  InvalidEmail = 'INVALID_EMAIL',
  NotAuthorized = 'NOT_AUTHORIZED',
  NoParticipant = 'NO_PARTICIPANT'
}

export type ReplaceParticipantInput = {
  inviteeAddressLine1?: InputMaybe<Scalars['String']>;
  inviteeAddressLine2?: InputMaybe<Scalars['String']>;
  inviteeCity?: InputMaybe<Scalars['String']>;
  inviteeCountry?: InputMaybe<Scalars['String']>;
  inviteeEmail: Scalars['String'];
  inviteeFirstName: Scalars['String'];
  inviteeLastName: Scalars['String'];
  inviteePostCode?: InputMaybe<Scalars['String']>;
  participantId: Scalars['uuid'];
};

export type ReplaceParticipantOutput = {
  __typename?: 'ReplaceParticipantOutput';
  error?: Maybe<ReplaceParticipantError>;
  success: Scalars['Boolean'];
};

/** The ResearchSummariesCategory type */
export type ResearchSummariesCategory = DatabaseIdentifier & MenuItemLinkable & Node & TermNode & UniformResourceIdentifiable & {
  __typename?: 'ResearchSummariesCategory';
  /** Connection between the ResearchSummariesCategory type and the ContentNode type */
  contentNodes?: Maybe<ResearchSummariesCategoryToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The unique resource identifier path */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** Connection between the ResearchSummariesCategory type and the ResearchSummary type */
  researchSummaries?: Maybe<ResearchSummariesCategoryToResearchSummaryConnection>;
  /** The id field matches the WP_Post-&gt;ID field. */
  researchSummariesCategoryId?: Maybe<Scalars['Int']>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the ResearchSummariesCategory type and the Taxonomy type */
  taxonomy?: Maybe<ResearchSummariesCategoryToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The ResearchSummariesCategory type */
export type ResearchSummariesCategoryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResearchSummariesCategoryToContentNodeConnectionWhereArgs>;
};


/** The ResearchSummariesCategory type */
export type ResearchSummariesCategoryEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The ResearchSummariesCategory type */
export type ResearchSummariesCategoryEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The ResearchSummariesCategory type */
export type ResearchSummariesCategoryResearchSummariesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResearchSummariesCategoryToResearchSummaryConnectionWhereArgs>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum ResearchSummariesCategoryIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the ResearchSummariesCategory type and the ContentNode type */
export type ResearchSummariesCategoryToContentNodeConnection = {
  __typename?: 'ResearchSummariesCategoryToContentNodeConnection';
  /** Edges for the ResearchSummariesCategoryToContentNodeConnection connection */
  edges?: Maybe<Array<Maybe<ResearchSummariesCategoryToContentNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ResearchSummariesCategoryToContentNodeConnectionEdge = {
  __typename?: 'ResearchSummariesCategoryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentNode>;
};

/** Arguments for filtering the ResearchSummariesCategoryToContentNodeConnection connection */
export type ResearchSummariesCategoryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfResearchSummariesCategoryEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the ResearchSummariesCategory type and the ResearchSummary type */
export type ResearchSummariesCategoryToResearchSummaryConnection = {
  __typename?: 'ResearchSummariesCategoryToResearchSummaryConnection';
  /** Edges for the ResearchSummariesCategoryToResearchSummaryConnection connection */
  edges?: Maybe<Array<Maybe<ResearchSummariesCategoryToResearchSummaryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ResearchSummary>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ResearchSummariesCategoryToResearchSummaryConnectionEdge = {
  __typename?: 'ResearchSummariesCategoryToResearchSummaryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ResearchSummary>;
};

/** Arguments for filtering the ResearchSummariesCategoryToResearchSummaryConnection connection */
export type ResearchSummariesCategoryToResearchSummaryConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the ResearchSummariesCategory type and the Taxonomy type */
export type ResearchSummariesCategoryToTaxonomyConnectionEdge = {
  __typename?: 'ResearchSummariesCategoryToTaxonomyConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Taxonomy>;
};

/** The ResearchSummary type */
export type ResearchSummary = ContentNode & DatabaseIdentifier & MenuItemLinkable & Node & NodeWithExcerpt & NodeWithFeaturedImage & NodeWithTemplate & NodeWithTitle & UniformResourceIdentifiable & {
  __typename?: 'ResearchSummary';
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Downloads&quot; was set to Show in GraphQL. */
  downloads?: Maybe<ResearchSummary_Downloads>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The excerpt of the post. */
  excerpt?: Maybe<Scalars['String']>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the research-summary object. */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /** Connection between the ResearchSummary type and the ResearchSummary type */
  preview?: Maybe<ResearchSummaryToPreviewConnectionEdge>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** Connection between the ResearchSummary type and the ResearchSummariesCategory type */
  researchSummariesCategories?: Maybe<ResearchSummaryToResearchSummariesCategoryConnection>;
  /** The id field matches the WP_Post-&gt;ID field. */
  researchSummaryId: Scalars['Int'];
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
  /** Connection between the ResearchSummary type and the TermNode type */
  terms?: Maybe<ResearchSummaryToTermNodeConnection>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The ResearchSummary type */
export type ResearchSummaryEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The ResearchSummary type */
export type ResearchSummaryEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The ResearchSummary type */
export type ResearchSummaryExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The ResearchSummary type */
export type ResearchSummaryResearchSummariesCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResearchSummaryToResearchSummariesCategoryConnectionWhereArgs>;
};


/** The ResearchSummary type */
export type ResearchSummaryTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResearchSummaryToTermNodeConnectionWhereArgs>;
};


/** The ResearchSummary type */
export type ResearchSummaryTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum ResearchSummaryIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Set relationships between the ResearchSummary to ResearchSummariesCategories */
export type ResearchSummaryResearchSummariesCategoriesInput = {
  /** If true, this will append the ResearchSummariesCategory to existing related ResearchSummariesCategories. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<ResearchSummaryResearchSummariesCategoriesNodeInput>>>;
};

/** List of ResearchSummariesCategories to connect the ResearchSummary to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type ResearchSummaryResearchSummariesCategoriesNodeInput = {
  /** The description of the ResearchSummariesCategory. This field is used to set a description of the ResearchSummariesCategory if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the ResearchSummariesCategory. If present, this will be used to connect to the ResearchSummary. If no existing ResearchSummariesCategory exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the ResearchSummariesCategory. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the ResearchSummariesCategory. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** Connection between the ResearchSummary type and the ResearchSummary type */
export type ResearchSummaryToPreviewConnectionEdge = {
  __typename?: 'ResearchSummaryToPreviewConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<ResearchSummary>;
};

/** Connection between the ResearchSummary type and the ResearchSummariesCategory type */
export type ResearchSummaryToResearchSummariesCategoryConnection = {
  __typename?: 'ResearchSummaryToResearchSummariesCategoryConnection';
  /** Edges for the ResearchSummaryToResearchSummariesCategoryConnection connection */
  edges?: Maybe<Array<Maybe<ResearchSummaryToResearchSummariesCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ResearchSummariesCategory>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ResearchSummaryToResearchSummariesCategoryConnectionEdge = {
  __typename?: 'ResearchSummaryToResearchSummariesCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ResearchSummariesCategory>;
};

/** Arguments for filtering the ResearchSummaryToResearchSummariesCategoryConnection connection */
export type ResearchSummaryToResearchSummariesCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the ResearchSummary type and the TermNode type */
export type ResearchSummaryToTermNodeConnection = {
  __typename?: 'ResearchSummaryToTermNodeConnection';
  /** Edges for the ResearchSummaryToTermNodeConnection connection */
  edges?: Maybe<Array<Maybe<ResearchSummaryToTermNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<TermNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ResearchSummaryToTermNodeConnectionEdge = {
  __typename?: 'ResearchSummaryToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<TermNode>;
};

/** Arguments for filtering the ResearchSummaryToTermNodeConnection connection */
export type ResearchSummaryToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies?: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Field Group */
export type ResearchSummary_Downloads = AcfFieldGroup & {
  __typename?: 'ResearchSummary_Downloads';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  file?: Maybe<MediaItem>;
};

/** Input for the resetUserPassword mutation */
export type ResetUserPasswordInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Password reset key */
  key?: InputMaybe<Scalars['String']>;
  /** The user's login (username). */
  login?: InputMaybe<Scalars['String']>;
  /** The new password. */
  password?: InputMaybe<Scalars['String']>;
};

/** The payload for the resetUserPassword mutation */
export type ResetUserPasswordPayload = {
  __typename?: 'ResetUserPasswordPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The User object mutation type. */
  user?: Maybe<User>;
};

/** The Resource type */
export type Resource = ContentNode & DatabaseIdentifier & MenuItemLinkable & Node & NodeWithFeaturedImage & NodeWithTemplate & NodeWithTitle & UniformResourceIdentifiable & {
  __typename?: 'Resource';
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the resource object. */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /** Connection between the Resource type and the Resource type */
  preview?: Maybe<ResourceToPreviewConnectionEdge>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Resource Attachment&quot; was set to Show in GraphQL. */
  resourceAttachment?: Maybe<Resource_Resourceattachment>;
  /** Connection between the Resource type and the ResourceCategory type */
  resourceCategories?: Maybe<ResourceToResourceCategoryConnection>;
  /** The id field matches the WP_Post-&gt;ID field. */
  resourceId: Scalars['Int'];
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Resource permissions&quot; was set to Show in GraphQL. */
  resourcePermissions?: Maybe<Resource_Resourcepermissions>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
  /** Connection between the Resource type and the TermNode type */
  terms?: Maybe<ResourceToTermNodeConnection>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The Resource type */
export type ResourceEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The Resource type */
export type ResourceEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The Resource type */
export type ResourceResourceCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceToResourceCategoryConnectionWhereArgs>;
};


/** The Resource type */
export type ResourceTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceToTermNodeConnectionWhereArgs>;
};


/** The Resource type */
export type ResourceTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};

/** The ResourceCategory type */
export type ResourceCategory = DatabaseIdentifier & HierarchicalTermNode & MenuItemLinkable & Node & TermNode & UniformResourceIdentifiable & {
  __typename?: 'ResourceCategory';
  /** The ancestors of the node. Default ordered as lowest (closest to the child) to highest (closest to the root). */
  ancestors?: Maybe<ResourceCategoryToAncestorsResourceCategoryConnection>;
  /** Connection between the ResourceCategory type and its children ResourceCategories. */
  children?: Maybe<ResourceCategoryToResourceCategoryConnection>;
  /** Connection between the ResourceCategory type and the ContentNode type */
  contentNodes?: Maybe<ResourceCategoryToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The unique resource identifier path */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** Connection between the ResourceCategory type and its parent ResourceCategory. */
  parent?: Maybe<ResourceCategoryToParentResourceCategoryConnectionEdge>;
  /** Database id of the parent node */
  parentDatabaseId?: Maybe<Scalars['Int']>;
  /** The globally unique identifier of the parent node. */
  parentId?: Maybe<Scalars['ID']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Resource icon&quot; was set to Show in GraphQL. */
  resouceIcon?: Maybe<ResourceCategory_Resouceicon>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Resource area&quot; was set to Show in GraphQL. */
  resourceArea?: Maybe<ResourceCategory_Resourcearea>;
  /** The id field matches the WP_Post-&gt;ID field. */
  resourceCategoryId?: Maybe<Scalars['Int']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Resource permissions&quot; was set to Show in GraphQL. */
  resourcePermissions?: Maybe<ResourceCategory_Resourcepermissions>;
  /** Connection between the ResourceCategory type and the Resource type */
  resources?: Maybe<ResourceCategoryToResourceConnection>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the ResourceCategory type and the Taxonomy type */
  taxonomy?: Maybe<ResourceCategoryToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The ResourceCategory type */
export type ResourceCategoryAncestorsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The ResourceCategory type */
export type ResourceCategoryChildrenArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceCategoryToResourceCategoryConnectionWhereArgs>;
};


/** The ResourceCategory type */
export type ResourceCategoryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceCategoryToContentNodeConnectionWhereArgs>;
};


/** The ResourceCategory type */
export type ResourceCategoryEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The ResourceCategory type */
export type ResourceCategoryEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The ResourceCategory type */
export type ResourceCategoryResourcesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<ResourceCategoryToResourceConnectionWhereArgs>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum ResourceCategoryIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the ResourceCategory type and the ResourceCategory type */
export type ResourceCategoryToAncestorsResourceCategoryConnection = {
  __typename?: 'ResourceCategoryToAncestorsResourceCategoryConnection';
  /** Edges for the ResourceCategoryToAncestorsResourceCategoryConnection connection */
  edges?: Maybe<Array<Maybe<ResourceCategoryToAncestorsResourceCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ResourceCategory>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ResourceCategoryToAncestorsResourceCategoryConnectionEdge = {
  __typename?: 'ResourceCategoryToAncestorsResourceCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ResourceCategory>;
};

/** Connection between the ResourceCategory type and the ContentNode type */
export type ResourceCategoryToContentNodeConnection = {
  __typename?: 'ResourceCategoryToContentNodeConnection';
  /** Edges for the ResourceCategoryToContentNodeConnection connection */
  edges?: Maybe<Array<Maybe<ResourceCategoryToContentNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ResourceCategoryToContentNodeConnectionEdge = {
  __typename?: 'ResourceCategoryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentNode>;
};

/** Arguments for filtering the ResourceCategoryToContentNodeConnection connection */
export type ResourceCategoryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfResourceCategoryEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the ResourceCategory type and the ResourceCategory type */
export type ResourceCategoryToParentResourceCategoryConnectionEdge = {
  __typename?: 'ResourceCategoryToParentResourceCategoryConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<ResourceCategory>;
};

/** Connection between the ResourceCategory type and the ResourceCategory type */
export type ResourceCategoryToResourceCategoryConnection = {
  __typename?: 'ResourceCategoryToResourceCategoryConnection';
  /** Edges for the ResourceCategoryToResourceCategoryConnection connection */
  edges?: Maybe<Array<Maybe<ResourceCategoryToResourceCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ResourceCategory>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ResourceCategoryToResourceCategoryConnectionEdge = {
  __typename?: 'ResourceCategoryToResourceCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ResourceCategory>;
};

/** Arguments for filtering the ResourceCategoryToResourceCategoryConnection connection */
export type ResourceCategoryToResourceCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the ResourceCategory type and the Resource type */
export type ResourceCategoryToResourceConnection = {
  __typename?: 'ResourceCategoryToResourceConnection';
  /** Edges for the ResourceCategoryToResourceConnection connection */
  edges?: Maybe<Array<Maybe<ResourceCategoryToResourceConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Resource>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ResourceCategoryToResourceConnectionEdge = {
  __typename?: 'ResourceCategoryToResourceConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Resource>;
};

/** Arguments for filtering the ResourceCategoryToResourceConnection connection */
export type ResourceCategoryToResourceConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the ResourceCategory type and the Taxonomy type */
export type ResourceCategoryToTaxonomyConnectionEdge = {
  __typename?: 'ResourceCategoryToTaxonomyConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Taxonomy>;
};

/** Field Group */
export type ResourceCategory_Resouceicon = AcfFieldGroup & {
  __typename?: 'ResourceCategory_Resouceicon';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  resourceicon?: Maybe<Scalars['String']>;
};

/** Field Group */
export type ResourceCategory_Resourcearea = AcfFieldGroup & {
  __typename?: 'ResourceCategory_Resourcearea';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  /** Whether it will appear on Resources main page as a basic Resource or an Additional Resource */
  resourcearea?: Maybe<Scalars['String']>;
};

/** Field Group */
export type ResourceCategory_Resourcepermissions = AcfFieldGroup & {
  __typename?: 'ResourceCategory_Resourcepermissions';
  allowAccessDayBeforeCourseStart?: Maybe<Scalars['Boolean']>;
  certificateLevels?: Maybe<Array<Maybe<Scalars['String']>>>;
  courseInProgress?: Maybe<Scalars['Boolean']>;
  etaTrainer?: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  principalTrainer?: Maybe<Scalars['Boolean']>;
  seniorTrainer?: Maybe<Scalars['Boolean']>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum ResourceIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

export enum ResourcePacksAddErrorEnum {
  GenericError = 'GENERIC_ERROR',
  InvalidAmount = 'INVALID_AMOUNT',
  NotAllowed = 'NOT_ALLOWED',
  OrganizationNotFound = 'ORGANIZATION_NOT_FOUND'
}

export type ResourcePacksAddInput = {
  amount: Scalars['Int'];
  invoiceNumber: Scalars['String'];
  note?: InputMaybe<Scalars['String']>;
  orgId: Scalars['uuid'];
  resourcePackType: ResourcePacksTypeEnum;
};

export type ResourcePacksAddOutput = {
  __typename?: 'ResourcePacksAddOutput';
  error?: Maybe<ResourcePacksAddErrorEnum>;
  success: Scalars['Boolean'];
  totalResourcePacks?: Maybe<Scalars['Int']>;
};

export enum ResourcePacksReserveErrorEnum {
  GenericError = 'GENERIC_ERROR',
  InsufficientResourcePacksAvailable = 'INSUFFICIENT_RESOURCE_PACKS_AVAILABLE',
  InvalidAmount = 'INVALID_AMOUNT',
  NotAllowed = 'NOT_ALLOWED',
  OrganizationNotFound = 'ORGANIZATION_NOT_FOUND'
}

export type ResourcePacksReserveInput = {
  courseId: Scalars['Int'];
  orgId: Scalars['uuid'];
  quantity: Scalars['Int'];
  resourcePackType: ResourcePacksTypeEnum;
};

export type ResourcePacksReserveOutput = {
  __typename?: 'ResourcePacksReserveOutput';
  error?: Maybe<ResourcePacksReserveErrorEnum>;
  success: Scalars['Boolean'];
  totalResourcePacks?: Maybe<Scalars['Int']>;
};

export enum ResourcePacksTypeEnum {
  DigitalWorkbook = 'DIGITAL_WORKBOOK',
  PrintWorkbook = 'PRINT_WORKBOOK'
}

/** Set relationships between the Resource to ResourceCategories */
export type ResourceResourceCategoriesInput = {
  /** If true, this will append the ResourceCategory to existing related ResourceCategories. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<ResourceResourceCategoriesNodeInput>>>;
};

/** List of ResourceCategories to connect the Resource to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type ResourceResourceCategoriesNodeInput = {
  /** The description of the ResourceCategory. This field is used to set a description of the ResourceCategory if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the ResourceCategory. If present, this will be used to connect to the Resource. If no existing ResourceCategory exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the ResourceCategory. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the ResourceCategory. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** Connection between the Resource type and the Resource type */
export type ResourceToPreviewConnectionEdge = {
  __typename?: 'ResourceToPreviewConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Resource>;
};

/** Connection between the Resource type and the ResourceCategory type */
export type ResourceToResourceCategoryConnection = {
  __typename?: 'ResourceToResourceCategoryConnection';
  /** Edges for the ResourceToResourceCategoryConnection connection */
  edges?: Maybe<Array<Maybe<ResourceToResourceCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ResourceCategory>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ResourceToResourceCategoryConnectionEdge = {
  __typename?: 'ResourceToResourceCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ResourceCategory>;
};

/** Arguments for filtering the ResourceToResourceCategoryConnection connection */
export type ResourceToResourceCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Resource type and the TermNode type */
export type ResourceToTermNodeConnection = {
  __typename?: 'ResourceToTermNodeConnection';
  /** Edges for the ResourceToTermNodeConnection connection */
  edges?: Maybe<Array<Maybe<ResourceToTermNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<TermNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type ResourceToTermNodeConnectionEdge = {
  __typename?: 'ResourceToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<TermNode>;
};

/** Arguments for filtering the ResourceToTermNodeConnection connection */
export type ResourceToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies?: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Field Group */
export type Resource_Resourceattachment = AcfFieldGroup & {
  __typename?: 'Resource_Resourceattachment';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  file?: Maybe<MediaItem>;
  link?: Maybe<AcfLink>;
  resourcetype?: Maybe<Scalars['String']>;
  videourl?: Maybe<Scalars['String']>;
};

/** Field Group */
export type Resource_Resourcepermissions = AcfFieldGroup & {
  __typename?: 'Resource_Resourcepermissions';
  allowAccessDayBeforeCourseStart?: Maybe<Scalars['Boolean']>;
  certificateLevels?: Maybe<Array<Maybe<Scalars['String']>>>;
  courseInProgress?: Maybe<Scalars['Boolean']>;
  etaTrainer?: Maybe<Scalars['Boolean']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  principalTrainer?: Maybe<Scalars['Boolean']>;
  seniorTrainer?: Maybe<Scalars['Boolean']>;
};

/** Input for the restoreComment mutation */
export type RestoreCommentInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The ID of the comment to be restored */
  id: Scalars['ID'];
};

/** The payload for the restoreComment mutation */
export type RestoreCommentPayload = {
  __typename?: 'RestoreCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The restored comment object */
  comment?: Maybe<Comment>;
  /** The ID of the restored comment */
  restoredId?: Maybe<Scalars['ID']>;
};

/** Connection between the RootQuery type and the category type */
export type RootQueryToCategoryConnection = {
  __typename?: 'RootQueryToCategoryConnection';
  /** Edges for the RootQueryToCategoryConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Category>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToCategoryConnectionEdge = {
  __typename?: 'RootQueryToCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Category>;
};

/** Arguments for filtering the RootQueryToCategoryConnection connection */
export type RootQueryToCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the Comment type */
export type RootQueryToCommentConnection = {
  __typename?: 'RootQueryToCommentConnection';
  /** Edges for the RootQueryToCommentConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToCommentConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Comment>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToCommentConnectionEdge = {
  __typename?: 'RootQueryToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Comment>;
};

/** Arguments for filtering the RootQueryToCommentConnection connection */
export type RootQueryToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the RootQuery type and the ContentNode type */
export type RootQueryToContentNodeConnection = {
  __typename?: 'RootQueryToContentNodeConnection';
  /** Edges for the RootQueryToContentNodeConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToContentNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToContentNodeConnectionEdge = {
  __typename?: 'RootQueryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentNode>;
};

/** Arguments for filtering the RootQueryToContentNodeConnection connection */
export type RootQueryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the ContentRevisionUnion type */
export type RootQueryToContentRevisionUnionConnection = {
  __typename?: 'RootQueryToContentRevisionUnionConnection';
  /** Edges for the RootQueryToContentRevisionUnionConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToContentRevisionUnionConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentRevisionUnion>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToContentRevisionUnionConnectionEdge = {
  __typename?: 'RootQueryToContentRevisionUnionConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentRevisionUnion>;
};

/** Arguments for filtering the RootQueryToContentRevisionUnionConnection connection */
export type RootQueryToContentRevisionUnionConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the ContentType type */
export type RootQueryToContentTypeConnection = {
  __typename?: 'RootQueryToContentTypeConnection';
  /** Edges for the RootQueryToContentTypeConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToContentTypeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentType>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToContentTypeConnectionEdge = {
  __typename?: 'RootQueryToContentTypeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentType>;
};

/** Connection between the RootQuery type and the Ebook type */
export type RootQueryToEbookConnection = {
  __typename?: 'RootQueryToEbookConnection';
  /** Edges for the RootQueryToEbookConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToEbookConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Ebook>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToEbookConnectionEdge = {
  __typename?: 'RootQueryToEbookConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Ebook>;
};

/** Arguments for filtering the RootQueryToEbookConnection connection */
export type RootQueryToEbookConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the EbooksCategory type */
export type RootQueryToEbooksCategoryConnection = {
  __typename?: 'RootQueryToEbooksCategoryConnection';
  /** Edges for the RootQueryToEbooksCategoryConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToEbooksCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<EbooksCategory>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToEbooksCategoryConnectionEdge = {
  __typename?: 'RootQueryToEbooksCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<EbooksCategory>;
};

/** Arguments for filtering the RootQueryToEbooksCategoryConnection connection */
export type RootQueryToEbooksCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the EnqueuedScript type */
export type RootQueryToEnqueuedScriptConnection = {
  __typename?: 'RootQueryToEnqueuedScriptConnection';
  /** Edges for the RootQueryToEnqueuedScriptConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToEnqueuedScriptConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<EnqueuedScript>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToEnqueuedScriptConnectionEdge = {
  __typename?: 'RootQueryToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<EnqueuedScript>;
};

/** Connection between the RootQuery type and the EnqueuedStylesheet type */
export type RootQueryToEnqueuedStylesheetConnection = {
  __typename?: 'RootQueryToEnqueuedStylesheetConnection';
  /** Edges for the RootQueryToEnqueuedStylesheetConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToEnqueuedStylesheetConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<EnqueuedStylesheet>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToEnqueuedStylesheetConnectionEdge = {
  __typename?: 'RootQueryToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<EnqueuedStylesheet>;
};

/** Connection between the RootQuery type and the mediaItem type */
export type RootQueryToMediaItemConnection = {
  __typename?: 'RootQueryToMediaItemConnection';
  /** Edges for the RootQueryToMediaItemConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToMediaItemConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<MediaItem>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToMediaItemConnectionEdge = {
  __typename?: 'RootQueryToMediaItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<MediaItem>;
};

/** Arguments for filtering the RootQueryToMediaItemConnection connection */
export type RootQueryToMediaItemConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the Menu type */
export type RootQueryToMenuConnection = {
  __typename?: 'RootQueryToMenuConnection';
  /** Edges for the RootQueryToMenuConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToMenuConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Menu>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToMenuConnectionEdge = {
  __typename?: 'RootQueryToMenuConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Menu>;
};

/** Arguments for filtering the RootQueryToMenuConnection connection */
export type RootQueryToMenuConnectionWhereArgs = {
  /** The database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** The menu location for the menu being queried */
  location?: InputMaybe<MenuLocationEnum>;
  /** The slug of the menu to query items for */
  slug?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the MenuItem type */
export type RootQueryToMenuItemConnection = {
  __typename?: 'RootQueryToMenuItemConnection';
  /** Edges for the RootQueryToMenuItemConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToMenuItemConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<MenuItem>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToMenuItemConnectionEdge = {
  __typename?: 'RootQueryToMenuItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<MenuItem>;
};

/** Arguments for filtering the RootQueryToMenuItemConnection connection */
export type RootQueryToMenuItemConnectionWhereArgs = {
  /** The database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** The menu location for the menu being queried */
  location?: InputMaybe<MenuLocationEnum>;
  /** The database ID of the parent menu object */
  parentDatabaseId?: InputMaybe<Scalars['Int']>;
  /** The ID of the parent menu object */
  parentId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the RootQuery type and the page type */
export type RootQueryToPageConnection = {
  __typename?: 'RootQueryToPageConnection';
  /** Edges for the RootQueryToPageConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToPageConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Page>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToPageConnectionEdge = {
  __typename?: 'RootQueryToPageConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Page>;
};

/** Arguments for filtering the RootQueryToPageConnection connection */
export type RootQueryToPageConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the Plugin type */
export type RootQueryToPluginConnection = {
  __typename?: 'RootQueryToPluginConnection';
  /** Edges for the RootQueryToPluginConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToPluginConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Plugin>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToPluginConnectionEdge = {
  __typename?: 'RootQueryToPluginConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Plugin>;
};

/** Arguments for filtering the RootQueryToPluginConnection connection */
export type RootQueryToPluginConnectionWhereArgs = {
  /** Show plugin based on a keyword search. */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve plugins where plugin status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PluginStatusEnum>>>;
  /** Show plugins with a specific status. */
  status?: InputMaybe<PluginStatusEnum>;
};

/** Connection between the RootQuery type and the post type */
export type RootQueryToPostConnection = {
  __typename?: 'RootQueryToPostConnection';
  /** Edges for the RootQueryToPostConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToPostConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Post>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToPostConnectionEdge = {
  __typename?: 'RootQueryToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Post>;
};

/** Arguments for filtering the RootQueryToPostConnection connection */
export type RootQueryToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the postFormat type */
export type RootQueryToPostFormatConnection = {
  __typename?: 'RootQueryToPostFormatConnection';
  /** Edges for the RootQueryToPostFormatConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToPostFormatConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<PostFormat>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToPostFormatConnectionEdge = {
  __typename?: 'RootQueryToPostFormatConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<PostFormat>;
};

/** Arguments for filtering the RootQueryToPostFormatConnection connection */
export type RootQueryToPostFormatConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the ResearchSummariesCategory type */
export type RootQueryToResearchSummariesCategoryConnection = {
  __typename?: 'RootQueryToResearchSummariesCategoryConnection';
  /** Edges for the RootQueryToResearchSummariesCategoryConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToResearchSummariesCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ResearchSummariesCategory>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToResearchSummariesCategoryConnectionEdge = {
  __typename?: 'RootQueryToResearchSummariesCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ResearchSummariesCategory>;
};

/** Arguments for filtering the RootQueryToResearchSummariesCategoryConnection connection */
export type RootQueryToResearchSummariesCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the ResearchSummary type */
export type RootQueryToResearchSummaryConnection = {
  __typename?: 'RootQueryToResearchSummaryConnection';
  /** Edges for the RootQueryToResearchSummaryConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToResearchSummaryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ResearchSummary>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToResearchSummaryConnectionEdge = {
  __typename?: 'RootQueryToResearchSummaryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ResearchSummary>;
};

/** Arguments for filtering the RootQueryToResearchSummaryConnection connection */
export type RootQueryToResearchSummaryConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the ResourceCategory type */
export type RootQueryToResourceCategoryConnection = {
  __typename?: 'RootQueryToResourceCategoryConnection';
  /** Edges for the RootQueryToResourceCategoryConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToResourceCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ResourceCategory>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToResourceCategoryConnectionEdge = {
  __typename?: 'RootQueryToResourceCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ResourceCategory>;
};

/** Arguments for filtering the RootQueryToResourceCategoryConnection connection */
export type RootQueryToResourceCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the Resource type */
export type RootQueryToResourceConnection = {
  __typename?: 'RootQueryToResourceConnection';
  /** Edges for the RootQueryToResourceConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToResourceConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Resource>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToResourceConnectionEdge = {
  __typename?: 'RootQueryToResourceConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Resource>;
};

/** Arguments for filtering the RootQueryToResourceConnection connection */
export type RootQueryToResourceConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the tag type */
export type RootQueryToTagConnection = {
  __typename?: 'RootQueryToTagConnection';
  /** Edges for the RootQueryToTagConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToTagConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Tag>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToTagConnectionEdge = {
  __typename?: 'RootQueryToTagConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Tag>;
};

/** Arguments for filtering the RootQueryToTagConnection connection */
export type RootQueryToTagConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the Taxonomy type */
export type RootQueryToTaxonomyConnection = {
  __typename?: 'RootQueryToTaxonomyConnection';
  /** Edges for the RootQueryToTaxonomyConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToTaxonomyConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Taxonomy>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToTaxonomyConnectionEdge = {
  __typename?: 'RootQueryToTaxonomyConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Taxonomy>;
};

/** Connection between the RootQuery type and the TermNode type */
export type RootQueryToTermNodeConnection = {
  __typename?: 'RootQueryToTermNodeConnection';
  /** Edges for the RootQueryToTermNodeConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToTermNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<TermNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToTermNodeConnectionEdge = {
  __typename?: 'RootQueryToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<TermNode>;
};

/** Arguments for filtering the RootQueryToTermNodeConnection connection */
export type RootQueryToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies?: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the Theme type */
export type RootQueryToThemeConnection = {
  __typename?: 'RootQueryToThemeConnection';
  /** Edges for the RootQueryToThemeConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToThemeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Theme>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToThemeConnectionEdge = {
  __typename?: 'RootQueryToThemeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Theme>;
};

/** Connection between the RootQuery type and the User type */
export type RootQueryToUserConnection = {
  __typename?: 'RootQueryToUserConnection';
  /** Edges for the RootQueryToUserConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToUserConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<User>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToUserConnectionEdge = {
  __typename?: 'RootQueryToUserConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<User>;
};

/** Arguments for filtering the RootQueryToUserConnection connection */
export type RootQueryToUserConnectionWhereArgs = {
  /** Array of userIds to exclude. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** Pass an array of post types to filter results to users who have published posts in those post types. */
  hasPublishedPosts?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of userIds to include. */
  include?: InputMaybe<Array<InputMaybe<Scalars['Int']>>>;
  /** The user login. */
  login?: InputMaybe<Scalars['String']>;
  /** An array of logins to include. Users matching one of these logins will be included in results. */
  loginIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** An array of logins to exclude. Users matching one of these logins will not be included in results. */
  loginNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The user nicename. */
  nicename?: InputMaybe<Scalars['String']>;
  /** An array of nicenames to include. Users matching one of these nicenames will be included in results. */
  nicenameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** An array of nicenames to exclude. Users matching one of these nicenames will not be included in results. */
  nicenameNotIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<UsersConnectionOrderbyInput>>>;
  /** An array of role names that users must match to be included in results. Note that this is an inclusive list: users must match *each* role. */
  role?: InputMaybe<UserRoleEnum>;
  /** An array of role names. Matched users must have at least one of these roles. */
  roleIn?: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
  /** An array of role names to exclude. Users matching one or more of these roles will not be included in results. */
  roleNotIn?: InputMaybe<Array<InputMaybe<UserRoleEnum>>>;
  /** Search keyword. Searches for possible string matches on columns. When "searchColumns" is left empty, it tries to determine which column to search in based on search string. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of column names to be searched. Accepts 'ID', 'login', 'nicename', 'email', 'url'. */
  searchColumns?: InputMaybe<Array<InputMaybe<UsersConnectionSearchColumnEnum>>>;
};

/** Connection between the RootQuery type and the UserRole type */
export type RootQueryToUserRoleConnection = {
  __typename?: 'RootQueryToUserRoleConnection';
  /** Edges for the RootQueryToUserRoleConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToUserRoleConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<UserRole>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToUserRoleConnectionEdge = {
  __typename?: 'RootQueryToUserRoleConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<UserRole>;
};

/** Connection between the RootQuery type and the VideoSeriesCategory type */
export type RootQueryToVideoSeriesCategoryConnection = {
  __typename?: 'RootQueryToVideoSeriesCategoryConnection';
  /** Edges for the RootQueryToVideoSeriesCategoryConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToVideoSeriesCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<VideoSeriesCategory>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToVideoSeriesCategoryConnectionEdge = {
  __typename?: 'RootQueryToVideoSeriesCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<VideoSeriesCategory>;
};

/** Arguments for filtering the RootQueryToVideoSeriesCategoryConnection connection */
export type RootQueryToVideoSeriesCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the RootQuery type and the VideoSeriesItem type */
export type RootQueryToVideoSeriesItemConnection = {
  __typename?: 'RootQueryToVideoSeriesItemConnection';
  /** Edges for the RootQueryToVideoSeriesItemConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToVideoSeriesItemConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<VideoSeriesItem>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToVideoSeriesItemConnectionEdge = {
  __typename?: 'RootQueryToVideoSeriesItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<VideoSeriesItem>;
};

/** Arguments for filtering the RootQueryToVideoSeriesItemConnection connection */
export type RootQueryToVideoSeriesItemConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the Webinar type */
export type RootQueryToWebinarConnection = {
  __typename?: 'RootQueryToWebinarConnection';
  /** Edges for the RootQueryToWebinarConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToWebinarConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Webinar>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToWebinarConnectionEdge = {
  __typename?: 'RootQueryToWebinarConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Webinar>;
};

/** Arguments for filtering the RootQueryToWebinarConnection connection */
export type RootQueryToWebinarConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the RootQuery type and the WebinarsCategory type */
export type RootQueryToWebinarsCategoryConnection = {
  __typename?: 'RootQueryToWebinarsCategoryConnection';
  /** Edges for the RootQueryToWebinarsCategoryConnection connection */
  edges?: Maybe<Array<Maybe<RootQueryToWebinarsCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<WebinarsCategory>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type RootQueryToWebinarsCategoryConnectionEdge = {
  __typename?: 'RootQueryToWebinarsCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<WebinarsCategory>;
};

/** Arguments for filtering the RootQueryToWebinarsCategoryConnection connection */
export type RootQueryToWebinarsCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

export type SsoAppMemberships = {
  __typename?: 'SSOAppMemberships';
  beSmart?: Maybe<AppMembershipData>;
  connect?: Maybe<AppMembershipData>;
  knowledgeHub?: Maybe<AppMembershipData>;
};

export type SsoOrganisation = {
  __typename?: 'SSOOrganisation';
  addressLine1: Scalars['String'];
  addressLine2?: Maybe<Scalars['String']>;
  addressLine3?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  id: Scalars['String'];
  isAdmin: Scalars['Boolean'];
  isPrimary: Scalars['Boolean'];
  name: Scalars['String'];
  postcode: Scalars['String'];
  urn?: Maybe<Scalars['String']>;
};

export type SsoRole = {
  __typename?: 'SSORole';
  name: Scalars['String'];
  rank: Scalars['Float'];
};

export type SsoUserProfile = {
  __typename?: 'SSOUserProfile';
  appMemberships: SsoAppMemberships;
  dateOfBirth?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  jobTitle?: Maybe<Scalars['String']>;
  lastName: Scalars['String'];
  phone?: Maybe<Scalars['String']>;
  residingCountry?: Maybe<Scalars['String']>;
};

export type SampleOutput = {
  __typename?: 'SampleOutput';
  error?: Maybe<SaveOrgInviteError>;
  success: Scalars['Boolean'];
};

export enum SaveOrgInviteError {
  GeneralError = 'GENERAL_ERROR',
  OrgMemberAlreadyExists = 'ORG_MEMBER_ALREADY_EXISTS'
}

export type SaveOrgInviteInput = {
  isAdmin: Scalars['Boolean'];
  orgId: Scalars['String'];
  profileEmail: Scalars['String'];
};

export type SearchTrainer = {
  __typename?: 'SearchTrainer';
  availability?: Maybe<SearchTrainerAvailability>;
  avatar?: Maybe<Scalars['String']>;
  email: Scalars['String'];
  fullName: Scalars['String'];
  id: Scalars['uuid'];
  levels: Array<CourseCertificateLevel>;
  trainer_role_types: Array<TrainerRoleType>;
  translatedFamilyName?: Maybe<Scalars['String']>;
  translatedGivenName?: Maybe<Scalars['String']>;
};

export enum SearchTrainerAvailability {
  Available = 'AVAILABLE',
  Expired = 'EXPIRED',
  Pending = 'PENDING',
  Unavailable = 'UNAVAILABLE'
}

export type SearchTrainersInput = {
  bildStrategies?: InputMaybe<Array<BildStrategy>>;
  courseEnd?: InputMaybe<Scalars['date']>;
  courseLevel?: InputMaybe<CourseLevel>;
  courseStart?: InputMaybe<Scalars['date']>;
  courseType?: InputMaybe<CourseType>;
  query?: InputMaybe<Scalars['String']>;
  trainerType?: InputMaybe<CourseTrainerType>;
  useAOL?: InputMaybe<Scalars['Boolean']>;
};

export enum SendCourseEvaluationReminderError {
  AttendeeListIsEmpty = 'ATTENDEE_LIST_IS_EMPTY',
  AttendeeNotFound = 'ATTENDEE_NOT_FOUND',
  CourseNotFound = 'COURSE_NOT_FOUND'
}

export type SendCourseEvaluationReminderOutput = {
  __typename?: 'SendCourseEvaluationReminderOutput';
  error?: Maybe<SendCourseEvaluationReminderError>;
  success: Scalars['Boolean'];
};

export enum SendCourseInformationError {
  AttendeeListIsEmpty = 'ATTENDEE_LIST_IS_EMPTY',
  AttendeeNotFound = 'ATTENDEE_NOT_FOUND',
  CourseNotFound = 'COURSE_NOT_FOUND'
}

export type SendCourseInformationOutput = {
  __typename?: 'SendCourseInformationOutput';
  error?: Maybe<SendCourseInformationError>;
  success: Scalars['Boolean'];
};

/** Input for the sendPasswordResetEmail mutation */
export type SendPasswordResetEmailInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A string that contains the user's username or email address. */
  username: Scalars['String'];
};

/** The payload for the sendPasswordResetEmail mutation */
export type SendPasswordResetEmailPayload = {
  __typename?: 'SendPasswordResetEmailPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Whether the mutation completed successfully. This does NOT necessarily mean that an email was sent. */
  success?: Maybe<Scalars['Boolean']>;
  /** The user that the password reset email was sent to */
  user?: Maybe<User>;
};

/** All of the registered settings */
export type Settings = {
  __typename?: 'Settings';
  /** Settings of the the string Settings Group */
  discussionSettingsDefaultCommentStatus?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  discussionSettingsDefaultPingStatus?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsDateFormat?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsDescription?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsEmail?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsLanguage?: Maybe<Scalars['String']>;
  /** Settings of the the integer Settings Group */
  generalSettingsStartOfWeek?: Maybe<Scalars['Int']>;
  /** Settings of the the string Settings Group */
  generalSettingsTimeFormat?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsTimezone?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsTitle?: Maybe<Scalars['String']>;
  /** Settings of the the string Settings Group */
  generalSettingsUrl?: Maybe<Scalars['String']>;
  /** Settings of the the integer Settings Group */
  readingSettingsPageForPosts?: Maybe<Scalars['Int']>;
  /** Settings of the the integer Settings Group */
  readingSettingsPageOnFront?: Maybe<Scalars['Int']>;
  /** Settings of the the integer Settings Group */
  readingSettingsPostsPerPage?: Maybe<Scalars['Int']>;
  /** Settings of the the string Settings Group */
  readingSettingsShowOnFront?: Maybe<Scalars['String']>;
  /** Settings of the the integer Settings Group */
  writingSettingsDefaultCategory?: Maybe<Scalars['Int']>;
  /** Settings of the the string Settings Group */
  writingSettingsDefaultPostFormat?: Maybe<Scalars['String']>;
  /** Settings of the the boolean Settings Group */
  writingSettingsUseSmilies?: Maybe<Scalars['Boolean']>;
};

export type SignUpInput = {
  acceptTnc: Scalars['Boolean'];
  country: Scalars['String'];
  countryCode: Scalars['String'];
  courseId?: InputMaybe<Scalars['Int']>;
  dob?: InputMaybe<Scalars['date']>;
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  jobTitle?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  recaptchaToken: Scalars['String'];
  sector?: InputMaybe<Scalars['String']>;
};

export type SignUpOutput = {
  __typename?: 'SignUpOutput';
  success: Scalars['Boolean'];
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Array_Comparison_Exp = {
  /** is the array contained in the given array value */
  _contained_in?: InputMaybe<Array<Scalars['String']>>;
  /** does the array contain the given value */
  _contains?: InputMaybe<Array<Scalars['String']>>;
  _eq?: InputMaybe<Array<Scalars['String']>>;
  _gt?: InputMaybe<Array<Scalars['String']>>;
  _gte?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Array<Scalars['String']>>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Array<Scalars['String']>>;
  _lte?: InputMaybe<Array<Scalars['String']>>;
  _neq?: InputMaybe<Array<Scalars['String']>>;
  _nin?: InputMaybe<Array<Array<Scalars['String']>>>;
};

/** Boolean expression to compare columns of type "String". All fields are combined with logical 'AND'. */
export type String_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['String']>;
  _gt?: InputMaybe<Scalars['String']>;
  _gte?: InputMaybe<Scalars['String']>;
  /** does the column match the given case-insensitive pattern */
  _ilike?: InputMaybe<Scalars['String']>;
  _in?: InputMaybe<Array<Scalars['String']>>;
  /** does the column match the given POSIX regular expression, case insensitive */
  _iregex?: InputMaybe<Scalars['String']>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  /** does the column match the given pattern */
  _like?: InputMaybe<Scalars['String']>;
  _lt?: InputMaybe<Scalars['String']>;
  _lte?: InputMaybe<Scalars['String']>;
  _neq?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given case-insensitive pattern */
  _nilike?: InputMaybe<Scalars['String']>;
  _nin?: InputMaybe<Array<Scalars['String']>>;
  /** does the column NOT match the given POSIX regular expression, case insensitive */
  _niregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given pattern */
  _nlike?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given POSIX regular expression, case sensitive */
  _nregex?: InputMaybe<Scalars['String']>;
  /** does the column NOT match the given SQL regular expression */
  _nsimilar?: InputMaybe<Scalars['String']>;
  /** does the column match the given POSIX regular expression, case sensitive */
  _regex?: InputMaybe<Scalars['String']>;
  /** does the column match the given SQL regular expression */
  _similar?: InputMaybe<Scalars['String']>;
};

export type StripeCreatePaymentIntentInput = {
  orderId: Scalars['String'];
  purchaseType?: InputMaybe<PurchaseType>;
};

export type StripeCreatePaymentIntentOutput = {
  __typename?: 'StripeCreatePaymentIntentOutput';
  amount: Scalars['Float'];
  clientSecret: Scalars['String'];
  currency: Currency;
};

/** The tag type */
export type Tag = DatabaseIdentifier & MenuItemLinkable & Node & TermNode & UniformResourceIdentifiable & {
  __typename?: 'Tag';
  /** Connection between the Tag type and the ContentNode type */
  contentNodes?: Maybe<TagToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The unique resource identifier path */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** Connection between the Tag type and the post type */
  posts?: Maybe<TagToPostConnection>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** The id field matches the WP_Post-&gt;ID field. */
  tagId?: Maybe<Scalars['Int']>;
  /** Connection between the Tag type and the Taxonomy type */
  taxonomy?: Maybe<TagToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** The tag type */
export type TagContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagToContentNodeConnectionWhereArgs>;
};


/** The tag type */
export type TagEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The tag type */
export type TagEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The tag type */
export type TagPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<TagToPostConnectionWhereArgs>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum TagIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the Tag type and the ContentNode type */
export type TagToContentNodeConnection = {
  __typename?: 'TagToContentNodeConnection';
  /** Edges for the TagToContentNodeConnection connection */
  edges?: Maybe<Array<Maybe<TagToContentNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type TagToContentNodeConnectionEdge = {
  __typename?: 'TagToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentNode>;
};

/** Arguments for filtering the TagToContentNodeConnection connection */
export type TagToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfTagEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Tag type and the post type */
export type TagToPostConnection = {
  __typename?: 'TagToPostConnection';
  /** Edges for the TagToPostConnection connection */
  edges?: Maybe<Array<Maybe<TagToPostConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Post>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type TagToPostConnectionEdge = {
  __typename?: 'TagToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Post>;
};

/** Arguments for filtering the TagToPostConnection connection */
export type TagToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the Tag type and the Taxonomy type */
export type TagToTaxonomyConnectionEdge = {
  __typename?: 'TagToTaxonomyConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Taxonomy>;
};

/** A taxonomy object */
export type Taxonomy = Node & {
  __typename?: 'Taxonomy';
  /** List of Content Types associated with the Taxonomy */
  connectedContentTypes?: Maybe<TaxonomyToContentTypeConnection>;
  /** Description of the taxonomy. This field is equivalent to WP_Taxonomy-&gt;description */
  description?: Maybe<Scalars['String']>;
  /** The plural name of the post type within the GraphQL Schema. */
  graphqlPluralName?: Maybe<Scalars['String']>;
  /** The singular name of the post type within the GraphQL Schema. */
  graphqlSingleName?: Maybe<Scalars['String']>;
  /** Whether the taxonomy is hierarchical */
  hierarchical?: Maybe<Scalars['Boolean']>;
  /** The globally unique identifier of the taxonomy object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Name of the taxonomy shown in the menu. Usually plural. */
  label?: Maybe<Scalars['String']>;
  /** The display name of the taxonomy. This field is equivalent to WP_Taxonomy-&gt;label */
  name?: Maybe<Scalars['String']>;
  /** Whether the taxonomy is publicly queryable */
  public?: Maybe<Scalars['Boolean']>;
  /** Name of content type to diplay in REST API &quot;wp/v2&quot; namespace. */
  restBase?: Maybe<Scalars['String']>;
  /** The REST Controller class assigned to handling this content type. */
  restControllerClass?: Maybe<Scalars['String']>;
  /** Whether to show the taxonomy as part of a tag cloud widget. This field is equivalent to WP_Taxonomy-&gt;show_tagcloud */
  showCloud?: Maybe<Scalars['Boolean']>;
  /** Whether to display a column for the taxonomy on its post type listing screens. */
  showInAdminColumn?: Maybe<Scalars['Boolean']>;
  /** Whether to add the post type to the GraphQL Schema. */
  showInGraphql?: Maybe<Scalars['Boolean']>;
  /** Whether to show the taxonomy in the admin menu */
  showInMenu?: Maybe<Scalars['Boolean']>;
  /** Whether the taxonomy is available for selection in navigation menus. */
  showInNavMenus?: Maybe<Scalars['Boolean']>;
  /** Whether to show the taxonomy in the quick/bulk edit panel. */
  showInQuickEdit?: Maybe<Scalars['Boolean']>;
  /** Whether to add the post type route in the REST API &quot;wp/v2&quot; namespace. */
  showInRest?: Maybe<Scalars['Boolean']>;
  /** Whether to generate and allow a UI for managing terms in this taxonomy in the admin */
  showUi?: Maybe<Scalars['Boolean']>;
};


/** A taxonomy object */
export type TaxonomyConnectedContentTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** Allowed taxonomies */
export enum TaxonomyEnum {
  /** Taxonomy enum category */
  Category = 'CATEGORY',
  /** Taxonomy enum ebooks_category */
  Ebookscategory = 'EBOOKSCATEGORY',
  /** Taxonomy enum post_format */
  Postformat = 'POSTFORMAT',
  /** Taxonomy enum research_summaries_category */
  Researchsummariescategory = 'RESEARCHSUMMARIESCATEGORY',
  /** Taxonomy enum resource_category */
  Resourcecategory = 'RESOURCECATEGORY',
  /** Taxonomy enum post_tag */
  Tag = 'TAG',
  /** Taxonomy enum video_series_category */
  Videoseriescategory = 'VIDEOSERIESCATEGORY',
  /** Taxonomy enum webinars_category */
  Webinarscategory = 'WEBINARSCATEGORY'
}

/** The Type of Identifier used to fetch a single Taxonomy node. To be used along with the "id" field. Default is "ID". */
export enum TaxonomyIdTypeEnum {
  /** The globally unique ID */
  Id = 'ID',
  /** The name of the taxonomy */
  Name = 'NAME'
}

/** Connection between the Taxonomy type and the ContentType type */
export type TaxonomyToContentTypeConnection = {
  __typename?: 'TaxonomyToContentTypeConnection';
  /** Edges for the TaxonomyToContentTypeConnection connection */
  edges?: Maybe<Array<Maybe<TaxonomyToContentTypeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentType>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type TaxonomyToContentTypeConnectionEdge = {
  __typename?: 'TaxonomyToContentTypeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentType>;
};

/** The template assigned to the node */
export type Template_100Width = ContentTemplate & {
  __typename?: 'Template_100Width';
  /** The name of the template */
  templateName?: Maybe<Scalars['String']>;
};

/** The template assigned to the node */
export type Template_BlankPage = ContentTemplate & {
  __typename?: 'Template_BlankPage';
  /** The name of the template */
  templateName?: Maybe<Scalars['String']>;
};

/** The template assigned to the node */
export type Template_Contact = ContentTemplate & {
  __typename?: 'Template_Contact';
  /** The name of the template */
  templateName?: Maybe<Scalars['String']>;
};

/** Terms are nodes within a Taxonomy, used to group and relate other nodes. */
export type TermNode = {
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The unique resource identifier path */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};


/** Terms are nodes within a Taxonomy, used to group and relate other nodes. */
export type TermNodeEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** Terms are nodes within a Taxonomy, used to group and relate other nodes. */
export type TermNodeEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The Type of Identifier used to fetch a single resource. Default is "ID". To be used along with the "id" field. */
export enum TermNodeIdTypeEnum {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the TermNode type and the EnqueuedScript type */
export type TermNodeToEnqueuedScriptConnection = {
  __typename?: 'TermNodeToEnqueuedScriptConnection';
  /** Edges for the TermNodeToEnqueuedScriptConnection connection */
  edges?: Maybe<Array<Maybe<TermNodeToEnqueuedScriptConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<EnqueuedScript>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type TermNodeToEnqueuedScriptConnectionEdge = {
  __typename?: 'TermNodeToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<EnqueuedScript>;
};

/** Connection between the TermNode type and the EnqueuedStylesheet type */
export type TermNodeToEnqueuedStylesheetConnection = {
  __typename?: 'TermNodeToEnqueuedStylesheetConnection';
  /** Edges for the TermNodeToEnqueuedStylesheetConnection connection */
  edges?: Maybe<Array<Maybe<TermNodeToEnqueuedStylesheetConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<EnqueuedStylesheet>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type TermNodeToEnqueuedStylesheetConnectionEdge = {
  __typename?: 'TermNodeToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<EnqueuedStylesheet>;
};

/** Options for ordering the connection by */
export enum TermObjectsConnectionOrderbyEnum {
  /** Order the connection by item count. */
  Count = 'COUNT',
  /** Order the connection by description. */
  Description = 'DESCRIPTION',
  /** Order the connection by name. */
  Name = 'NAME',
  /** Order the connection by slug. */
  Slug = 'SLUG',
  /** Order the connection by term group. */
  TermGroup = 'TERM_GROUP',
  /** Order the connection by term id. */
  TermId = 'TERM_ID',
  /** Order the connection by term order. */
  TermOrder = 'TERM_ORDER'
}

/** A theme object */
export type Theme = Node & {
  __typename?: 'Theme';
  /** Name of the theme author(s), could also be a company name. This field is equivalent to WP_Theme-&gt;get( &quot;Author&quot; ). */
  author?: Maybe<Scalars['String']>;
  /** URI for the author/company website. This field is equivalent to WP_Theme-&gt;get( &quot;AuthorURI&quot; ). */
  authorUri?: Maybe<Scalars['String']>;
  /** The description of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Description&quot; ). */
  description?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the theme object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Display name of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Name&quot; ). */
  name?: Maybe<Scalars['String']>;
  /** The URL of the screenshot for the theme. The screenshot is intended to give an overview of what the theme looks like. This field is equivalent to WP_Theme-&gt;get_screenshot(). */
  screenshot?: Maybe<Scalars['String']>;
  /** The theme slug is used to internally match themes. Theme slugs can have subdirectories like: my-theme/sub-theme. This field is equivalent to WP_Theme-&gt;get_stylesheet(). */
  slug?: Maybe<Scalars['String']>;
  /** URI for the author/company website. This field is equivalent to WP_Theme-&gt;get( &quot;Tags&quot; ). */
  tags?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** A URI if the theme has a website associated with it. The Theme URI is handy for directing users to a theme site for support etc. This field is equivalent to WP_Theme-&gt;get( &quot;ThemeURI&quot; ). */
  themeUri?: Maybe<Scalars['String']>;
  /** The current version of the theme. This field is equivalent to WP_Theme-&gt;get( &quot;Version&quot; ). */
  version?: Maybe<Scalars['String']>;
};

export type TrainerRoleType = {
  __typename?: 'TrainerRoleType';
  trainer_role_type?: Maybe<TrainerRoleTypeObj>;
};

export type TrainerRoleTypeObj = {
  __typename?: 'TrainerRoleTypeObj';
  id: Scalars['String'];
  name: Scalars['String'];
};

export type TransferCourse = {
  __typename?: 'TransferCourse';
  courseCode: Scalars['String'];
  courseResidingCountry?: Maybe<Scalars['String']>;
  deliveryType: CourseDeliveryType;
  endDate: Scalars['String'];
  freeSlots: Scalars['Int'];
  id: Scalars['Int'];
  level?: Maybe<CourseLevel>;
  reaccreditation: Scalars['Boolean'];
  startDate: Scalars['String'];
  timezone?: Maybe<Scalars['String']>;
  type: CourseType;
  venue?: Maybe<Scalars['String']>;
  venueCity?: Maybe<Scalars['String']>;
  venueCountry?: Maybe<Scalars['String']>;
  venueName?: Maybe<Scalars['String']>;
  virtualLink?: Maybe<Scalars['String']>;
};

export type TransferFee = {
  customFee?: InputMaybe<Scalars['Float']>;
  type: TransferFeeType;
};

export enum TransferFeeType {
  ApplyTerms = 'APPLY_TERMS',
  CustomFee = 'CUSTOM_FEE',
  Free = 'FREE'
}

export type TransferInput = {
  fee: TransferFee;
  inviteeAddressLine1?: InputMaybe<Scalars['String']>;
  inviteeAddressLine2?: InputMaybe<Scalars['String']>;
  inviteeCity?: InputMaybe<Scalars['String']>;
  inviteeCountry?: InputMaybe<Scalars['String']>;
  inviteePostCode?: InputMaybe<Scalars['String']>;
  participantId: Scalars['uuid'];
  reason: Scalars['String'];
  toCourseId: Scalars['Int'];
};

export enum TransferParticipantError {
  CourseNotFound = 'COURSE_NOT_FOUND',
  GeneralError = 'GENERAL_ERROR',
  NotEligibleForTransfer = 'NOT_ELIGIBLE_FOR_TRANSFER',
  NotEnoughSpaces = 'NOT_ENOUGH_SPACES',
  ParticipantGraded = 'PARTICIPANT_GRADED',
  ParticipantNotFound = 'PARTICIPANT_NOT_FOUND',
  TransferNotAllowed = 'TRANSFER_NOT_ALLOWED',
  WrongCourseType = 'WRONG_COURSE_TYPE'
}

export type TransferParticipantOutput = {
  __typename?: 'TransferParticipantOutput';
  error?: Maybe<TransferParticipantError>;
  success: Scalars['Boolean'];
};

/** Any node that has a URI */
export type UniformResourceIdentifiable = {
  /** The unique resource identifier path */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
};

export type UpdateAvatarResponse = {
  __typename?: 'UpdateAvatarResponse';
  avatar: Scalars['String'];
};

/** Input for the UpdateCategory mutation */
export type UpdateCategoryInput = {
  /** The slug that the category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the category object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the category object to update */
  id: Scalars['ID'];
  /** The name of the category object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the category that should be set as the parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the UpdateCategory mutation */
export type UpdateCategoryPayload = {
  __typename?: 'UpdateCategoryPayload';
  /** The created category */
  category?: Maybe<Category>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
};

/** Input for the updateComment mutation */
export type UpdateCommentInput = {
  /** The approval status of the comment. */
  approved?: InputMaybe<Scalars['String']>;
  /** The name of the comment's author. */
  author?: InputMaybe<Scalars['String']>;
  /** The email of the comment's author. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** The url of the comment's author. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The database ID of the post object the comment belongs to. */
  commentOn?: InputMaybe<Scalars['Int']>;
  /** Content of the comment. */
  content?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day ( e.g. 01/31/2017 ) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The ID of the comment being updated. */
  id: Scalars['ID'];
  /** Parent comment ID of current comment. */
  parent?: InputMaybe<Scalars['ID']>;
  /** Type of comment. */
  type?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateComment mutation */
export type UpdateCommentPayload = {
  __typename?: 'UpdateCommentPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The comment that was created */
  comment?: Maybe<Comment>;
  /** Whether the mutation succeeded. If the comment is not approved, the server will not return the comment to a non authenticated user, but a success message can be returned if the create succeeded, and the client can optimistically add the comment to the client cache */
  success?: Maybe<Scalars['Boolean']>;
};

/** Input for the updateEbook mutation */
export type UpdateEbookInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** Set connections between the Ebook and EbooksCategories */
  ebooksCategories?: InputMaybe<EbookEbooksCategoriesInput>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']>;
  /** The ID of the Ebook object */
  id: Scalars['ID'];
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateEbook mutation */
export type UpdateEbookPayload = {
  __typename?: 'UpdateEbookPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  ebook?: Maybe<Ebook>;
};

/** Input for the UpdateEbooksCategory mutation */
export type UpdateEbooksCategoryInput = {
  /** The slug that the ebooks_category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the ebooks_category object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the EbooksCategory object to update */
  id: Scalars['ID'];
  /** The name of the ebooks_category object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the UpdateEbooksCategory mutation */
export type UpdateEbooksCategoryPayload = {
  __typename?: 'UpdateEbooksCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created ebooks_category */
  ebooksCategory?: Maybe<EbooksCategory>;
};

/** Input for the updateMediaItem mutation */
export type UpdateMediaItemInput = {
  /** Alternative text to display when mediaItem is not displayed */
  altText?: InputMaybe<Scalars['String']>;
  /** The userId to assign as the author of the mediaItem */
  authorId?: InputMaybe<Scalars['ID']>;
  /** The caption for the mediaItem */
  caption?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment status for the mediaItem */
  commentStatus?: InputMaybe<Scalars['String']>;
  /** The date of the mediaItem */
  date?: InputMaybe<Scalars['String']>;
  /** The date (in GMT zone) of the mediaItem */
  dateGmt?: InputMaybe<Scalars['String']>;
  /** Description of the mediaItem */
  description?: InputMaybe<Scalars['String']>;
  /** The file name of the mediaItem */
  filePath?: InputMaybe<Scalars['String']>;
  /** The file type of the mediaItem */
  fileType?: InputMaybe<MimeTypeEnum>;
  /** The ID of the mediaItem object */
  id: Scalars['ID'];
  /** The ID of the parent object */
  parentId?: InputMaybe<Scalars['ID']>;
  /** The ping status for the mediaItem */
  pingStatus?: InputMaybe<Scalars['String']>;
  /** The slug of the mediaItem */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the mediaItem */
  status?: InputMaybe<MediaItemStatusEnum>;
  /** The title of the mediaItem */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateMediaItem mutation */
export type UpdateMediaItemPayload = {
  __typename?: 'UpdateMediaItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The MediaItem object mutation type. */
  mediaItem?: Maybe<MediaItem>;
};

/** Input for the updatePage mutation */
export type UpdatePageInput = {
  /** The userId to assign as the author of the object */
  authorId?: InputMaybe<Scalars['ID']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment status for the object */
  commentStatus?: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The ID of the page object */
  id: Scalars['ID'];
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The ID of the parent object */
  parentId?: InputMaybe<Scalars['ID']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the updatePage mutation */
export type UpdatePagePayload = {
  __typename?: 'UpdatePagePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  page?: Maybe<Page>;
};

/** Input for the UpdatePostFormat mutation */
export type UpdatePostFormatInput = {
  /** The slug that the post_format will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the post_format object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the postFormat object to update */
  id: Scalars['ID'];
  /** The name of the post_format object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the UpdatePostFormat mutation */
export type UpdatePostFormatPayload = {
  __typename?: 'UpdatePostFormatPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created post_format */
  postFormat?: Maybe<PostFormat>;
};

/** Input for the updatePost mutation */
export type UpdatePostInput = {
  /** The userId to assign as the author of the object */
  authorId?: InputMaybe<Scalars['ID']>;
  /** Set connections between the post and categories */
  categories?: InputMaybe<PostCategoriesInput>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The comment status for the object */
  commentStatus?: InputMaybe<Scalars['String']>;
  /** The content of the object */
  content?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']>;
  /** The ID of the post object */
  id: Scalars['ID'];
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The ping status for the object */
  pingStatus?: InputMaybe<Scalars['String']>;
  /** URLs that have been pinged. */
  pinged?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Set connections between the post and postFormats */
  postFormats?: InputMaybe<PostPostFormatsInput>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** Set connections between the post and tags */
  tags?: InputMaybe<PostTagsInput>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
  /** URLs queued to be pinged. */
  toPing?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
};

/** The payload for the updatePost mutation */
export type UpdatePostPayload = {
  __typename?: 'UpdatePostPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  post?: Maybe<Post>;
};

/** Input for the UpdateResearchSummariesCategory mutation */
export type UpdateResearchSummariesCategoryInput = {
  /** The slug that the research_summaries_category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the research_summaries_category object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the ResearchSummariesCategory object to update */
  id: Scalars['ID'];
  /** The name of the research_summaries_category object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the UpdateResearchSummariesCategory mutation */
export type UpdateResearchSummariesCategoryPayload = {
  __typename?: 'UpdateResearchSummariesCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created research_summaries_category */
  researchSummariesCategory?: Maybe<ResearchSummariesCategory>;
};

/** Input for the updateResearchSummary mutation */
export type UpdateResearchSummaryInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']>;
  /** The ID of the ResearchSummary object */
  id: Scalars['ID'];
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** Set connections between the ResearchSummary and ResearchSummariesCategories */
  researchSummariesCategories?: InputMaybe<ResearchSummaryResearchSummariesCategoriesInput>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateResearchSummary mutation */
export type UpdateResearchSummaryPayload = {
  __typename?: 'UpdateResearchSummaryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  researchSummary?: Maybe<ResearchSummary>;
};

/** Input for the UpdateResourceCategory mutation */
export type UpdateResourceCategoryInput = {
  /** The slug that the resource_category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the resource_category object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the ResourceCategory object to update */
  id: Scalars['ID'];
  /** The name of the resource_category object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** The ID of the resource_category that should be set as the parent */
  parentId?: InputMaybe<Scalars['ID']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the UpdateResourceCategory mutation */
export type UpdateResourceCategoryPayload = {
  __typename?: 'UpdateResourceCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created resource_category */
  resourceCategory?: Maybe<ResourceCategory>;
};

/** Input for the updateResource mutation */
export type UpdateResourceInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The ID of the Resource object */
  id: Scalars['ID'];
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** Set connections between the Resource and ResourceCategories */
  resourceCategories?: InputMaybe<ResourceResourceCategoriesInput>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateResource mutation */
export type UpdateResourcePayload = {
  __typename?: 'UpdateResourcePayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  resource?: Maybe<Resource>;
};

/** Input for the updateSettings mutation */
export type UpdateSettingsInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** Allow people to submit comments on new posts. */
  discussionSettingsDefaultCommentStatus?: InputMaybe<Scalars['String']>;
  /** Allow link notifications from other blogs (pingbacks and trackbacks) on new articles. */
  discussionSettingsDefaultPingStatus?: InputMaybe<Scalars['String']>;
  /** A date format for all date strings. */
  generalSettingsDateFormat?: InputMaybe<Scalars['String']>;
  /** Site tagline. */
  generalSettingsDescription?: InputMaybe<Scalars['String']>;
  /** This address is used for admin purposes, like new user notification. */
  generalSettingsEmail?: InputMaybe<Scalars['String']>;
  /** WordPress locale code. */
  generalSettingsLanguage?: InputMaybe<Scalars['String']>;
  /** A day number of the week that the week should start on. */
  generalSettingsStartOfWeek?: InputMaybe<Scalars['Int']>;
  /** A time format for all time strings. */
  generalSettingsTimeFormat?: InputMaybe<Scalars['String']>;
  /** A city in the same timezone as you. */
  generalSettingsTimezone?: InputMaybe<Scalars['String']>;
  /** Site title. */
  generalSettingsTitle?: InputMaybe<Scalars['String']>;
  /** Site URL. */
  generalSettingsUrl?: InputMaybe<Scalars['String']>;
  /** The ID of the page that should display the latest posts */
  readingSettingsPageForPosts?: InputMaybe<Scalars['Int']>;
  /** The ID of the page that should be displayed on the front page */
  readingSettingsPageOnFront?: InputMaybe<Scalars['Int']>;
  /** Blog pages show at most. */
  readingSettingsPostsPerPage?: InputMaybe<Scalars['Int']>;
  /** What to show on the front page */
  readingSettingsShowOnFront?: InputMaybe<Scalars['String']>;
  /** Default post category. */
  writingSettingsDefaultCategory?: InputMaybe<Scalars['Int']>;
  /** Default post format. */
  writingSettingsDefaultPostFormat?: InputMaybe<Scalars['String']>;
  /** Convert emoticons like :-) and :-P to graphics on display. */
  writingSettingsUseSmilies?: InputMaybe<Scalars['Boolean']>;
};

/** The payload for the updateSettings mutation */
export type UpdateSettingsPayload = {
  __typename?: 'UpdateSettingsPayload';
  /** Update all settings. */
  allSettings?: Maybe<Settings>;
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** Update the DiscussionSettings setting. */
  discussionSettings?: Maybe<DiscussionSettings>;
  /** Update the GeneralSettings setting. */
  generalSettings?: Maybe<GeneralSettings>;
  /** Update the ReadingSettings setting. */
  readingSettings?: Maybe<ReadingSettings>;
  /** Update the WritingSettings setting. */
  writingSettings?: Maybe<WritingSettings>;
};

/** Input for the UpdateTag mutation */
export type UpdateTagInput = {
  /** The slug that the post_tag will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the post_tag object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the tag object to update */
  id: Scalars['ID'];
  /** The name of the post_tag object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the UpdateTag mutation */
export type UpdateTagPayload = {
  __typename?: 'UpdateTagPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created post_tag */
  tag?: Maybe<Tag>;
};

/** Input for the updateUser mutation */
export type UpdateUserInput = {
  /** User's AOL IM account. */
  aim?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** A string containing content about the user. */
  description?: InputMaybe<Scalars['String']>;
  /** A string that will be shown on the site. Defaults to user's username. It is likely that you will want to change this, for both appearance and security through obscurity (that is if you dont use and delete the default admin user). */
  displayName?: InputMaybe<Scalars['String']>;
  /** A string containing the user's email address. */
  email?: InputMaybe<Scalars['String']>;
  /** 	The user's first name. */
  firstName?: InputMaybe<Scalars['String']>;
  /** The ID of the user */
  id: Scalars['ID'];
  /** User's Jabber account. */
  jabber?: InputMaybe<Scalars['String']>;
  /** The user's last name. */
  lastName?: InputMaybe<Scalars['String']>;
  /** User's locale. */
  locale?: InputMaybe<Scalars['String']>;
  /** A string that contains a URL-friendly name for the user. The default is the user's username. */
  nicename?: InputMaybe<Scalars['String']>;
  /** The user's nickname, defaults to the user's username. */
  nickname?: InputMaybe<Scalars['String']>;
  /** A string that contains the plain text password for the user. */
  password?: InputMaybe<Scalars['String']>;
  /** The date the user registered. Format is Y-m-d H:i:s. */
  registered?: InputMaybe<Scalars['String']>;
  /** A string for whether to enable the rich editor or not. False if not empty. */
  richEditing?: InputMaybe<Scalars['String']>;
  /** An array of roles to be assigned to the user. */
  roles?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** A string containing the user's URL for the user's web site. */
  websiteUrl?: InputMaybe<Scalars['String']>;
  /** User's Yahoo IM account. */
  yim?: InputMaybe<Scalars['String']>;
};

/** The payload for the updateUser mutation */
export type UpdateUserPayload = {
  __typename?: 'UpdateUserPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The User object mutation type. */
  user?: Maybe<User>;
};

export type UpdateUserProfileInput = {
  avatar?: InputMaybe<Scalars['String']>;
  canAccessKnowledgeHub?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  dietaryRestrictions?: InputMaybe<Scalars['String']>;
  disabilities?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  profileId: Scalars['uuid'];
};

/** Input for the UpdateVideoSeriesCategory mutation */
export type UpdateVideoSeriesCategoryInput = {
  /** The slug that the video_series_category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the video_series_category object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the VideoSeriesCategory object to update */
  id: Scalars['ID'];
  /** The name of the video_series_category object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the UpdateVideoSeriesCategory mutation */
export type UpdateVideoSeriesCategoryPayload = {
  __typename?: 'UpdateVideoSeriesCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created video_series_category */
  videoSeriesCategory?: Maybe<VideoSeriesCategory>;
};

/** Input for the updateVideoSeriesItem mutation */
export type UpdateVideoSeriesItemInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']>;
  /** The ID of the VideoSeriesItem object */
  id: Scalars['ID'];
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
  /** Set connections between the VideoSeriesItem and VideoSeriesCategories */
  videoSeriesCategories?: InputMaybe<VideoSeriesItemVideoSeriesCategoriesInput>;
};

/** The payload for the updateVideoSeriesItem mutation */
export type UpdateVideoSeriesItemPayload = {
  __typename?: 'UpdateVideoSeriesItemPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  videoSeriesItem?: Maybe<VideoSeriesItem>;
};

/** Input for the updateWebinar mutation */
export type UpdateWebinarInput = {
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The date of the object. Preferable to enter as year/month/day (e.g. 01/31/2017) as it will rearrange date as fit if it is not specified. Incomplete dates may have unintended results for example, "2017" as the input will use current date with timestamp 20:17  */
  date?: InputMaybe<Scalars['String']>;
  /** The excerpt of the object */
  excerpt?: InputMaybe<Scalars['String']>;
  /** The ID of the Webinar object */
  id: Scalars['ID'];
  /** A field used for ordering posts. This is typically used with nav menu items or for special ordering of hierarchical content types. */
  menuOrder?: InputMaybe<Scalars['Int']>;
  /** The password used to protect the content of the object */
  password?: InputMaybe<Scalars['String']>;
  /** The slug of the object */
  slug?: InputMaybe<Scalars['String']>;
  /** The status of the object */
  status?: InputMaybe<PostStatusEnum>;
  /** The title of the object */
  title?: InputMaybe<Scalars['String']>;
  /** Set connections between the Webinar and WebinarsCategories */
  webinarsCategories?: InputMaybe<WebinarWebinarsCategoriesInput>;
};

/** The payload for the updateWebinar mutation */
export type UpdateWebinarPayload = {
  __typename?: 'UpdateWebinarPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The Post object mutation type. */
  webinar?: Maybe<Webinar>;
};

/** Input for the UpdateWebinarsCategory mutation */
export type UpdateWebinarsCategoryInput = {
  /** The slug that the webinars_category will be an alias of */
  aliasOf?: InputMaybe<Scalars['String']>;
  /** This is an ID that can be passed to a mutation by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  /** The description of the webinars_category object */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the WebinarsCategory object to update */
  id: Scalars['ID'];
  /** The name of the webinars_category object to mutate */
  name?: InputMaybe<Scalars['String']>;
  /** If this argument exists then the slug will be checked to see if it is not an existing valid term. If that check succeeds (it is not a valid term), then it is added and the term id is given. If it fails, then a check is made to whether the taxonomy is hierarchical and the parent argument is not empty. If the second check succeeds, the term will be inserted and the term id will be given. If the slug argument is empty, then it will be calculated from the term name. */
  slug?: InputMaybe<Scalars['String']>;
};

/** The payload for the UpdateWebinarsCategory mutation */
export type UpdateWebinarsCategoryPayload = {
  __typename?: 'UpdateWebinarsCategoryPayload';
  /** If a &#039;clientMutationId&#039; input is provided to the mutation, it will be returned as output on the mutation. This ID can be used by the client to track the progress of mutations and catch possible duplicate mutation submissions. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** The created webinars_category */
  webinarsCategory?: Maybe<WebinarsCategory>;
};

export type UpsertZoomMeetingInput = {
  id?: InputMaybe<Scalars['Float']>;
  /** ISO 8601 date string, e.g. '2022-04-18T16:48:04.836Z' */
  startTime?: InputMaybe<Scalars['String']>;
  /** Timezone string, e.g. Europe/London */
  timezone?: InputMaybe<Scalars['String']>;
  /** Optional user id to create the meeting for */
  userId?: InputMaybe<Scalars['String']>;
};

export type UpsertZoomMeetingPayload = {
  __typename?: 'UpsertZoomMeetingPayload';
  meeting?: Maybe<ZoomMeeting>;
  success: Scalars['Boolean'];
  userError?: Maybe<ZoomMeetingNotFoundError>;
};

/** A User object */
export type User = Commenter & DatabaseIdentifier & Node & UniformResourceIdentifiable & {
  __typename?: 'User';
  /** Avatar object for user. The avatar object can be retrieved in different sizes by specifying the size argument. */
  avatar?: Maybe<Avatar>;
  /** User metadata option name. Usually it will be &quot;wp_capabilities&quot;. */
  capKey?: Maybe<Scalars['String']>;
  /** A list of capabilities (permissions) granted to the user */
  capabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** Connection between the User type and the Comment type */
  comments?: Maybe<UserToCommentConnection>;
  /** Identifies the primary key from the database. */
  databaseId: Scalars['Int'];
  /** Description of the user. */
  description?: Maybe<Scalars['String']>;
  /** Email address of the user. This is equivalent to the WP_User-&gt;user_email property. */
  email?: Maybe<Scalars['String']>;
  /** Connection between the User type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<UserToEnqueuedScriptConnection>;
  /** Connection between the User type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<UserToEnqueuedStylesheetConnection>;
  /** A complete list of capabilities including capabilities inherited from a role. This is equivalent to the array keys of WP_User-&gt;allcaps. */
  extraCapabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** First name of the user. This is equivalent to the WP_User-&gt;user_first_name property. */
  firstName?: Maybe<Scalars['String']>;
  /** The globally unique identifier for the user object. */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** Last name of the user. This is equivalent to the WP_User-&gt;user_last_name property. */
  lastName?: Maybe<Scalars['String']>;
  /** The preferred language locale set for the user. Value derived from get_user_locale(). */
  locale?: Maybe<Scalars['String']>;
  /** Connection between the User type and the mediaItem type */
  mediaItems?: Maybe<UserToMediaItemConnection>;
  /** Display name of the user. This is equivalent to the WP_User-&gt;dispaly_name property. */
  name?: Maybe<Scalars['String']>;
  /** The nicename for the user. This field is equivalent to WP_User-&gt;user_nicename */
  nicename?: Maybe<Scalars['String']>;
  /** Nickname of the user. */
  nickname?: Maybe<Scalars['String']>;
  /** Connection between the User type and the page type */
  pages?: Maybe<UserToPageConnection>;
  /** Connection between the User type and the post type */
  posts?: Maybe<UserToPostConnection>;
  /** The date the user registered or was created. The field follows a full ISO8601 date string format. */
  registeredDate?: Maybe<Scalars['String']>;
  /** Connection between the User and Revisions authored by the user */
  revisions?: Maybe<UserToContentRevisionUnionConnection>;
  /** Connection between the User type and the UserRole type */
  roles?: Maybe<UserToUserRoleConnection>;
  /** The slug for the user. This field is equivalent to WP_User-&gt;user_nicename */
  slug?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
  /** A website url that is associated with the user. */
  url?: Maybe<Scalars['String']>;
  /** The Id of the user. Equivalent to WP_User-&gt;ID */
  userId?: Maybe<Scalars['Int']>;
  /** Username for the user. This field is equivalent to WP_User-&gt;user_login. */
  username?: Maybe<Scalars['String']>;
};


/** A User object */
export type UserAvatarArgs = {
  forceDefault?: InputMaybe<Scalars['Boolean']>;
  rating?: InputMaybe<AvatarRatingEnum>;
  size?: InputMaybe<Scalars['Int']>;
};


/** A User object */
export type UserCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserToCommentConnectionWhereArgs>;
};


/** A User object */
export type UserEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A User object */
export type UserEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** A User object */
export type UserMediaItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserToMediaItemConnectionWhereArgs>;
};


/** A User object */
export type UserPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserToPageConnectionWhereArgs>;
};


/** A User object */
export type UserPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserToPostConnectionWhereArgs>;
};


/** A User object */
export type UserRevisionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<UserToContentRevisionUnionConnectionWhereArgs>;
};


/** A User object */
export type UserRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};

/** The Type of Identifier used to fetch a single User node. To be used along with the "id" field. Default is "ID". */
export enum UserNodeIdTypeEnum {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The Email of the User */
  Email = 'EMAIL',
  /** The hashed Global ID */
  Id = 'ID',
  /** The slug of the User */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI',
  /** The username the User uses to login with */
  Username = 'USERNAME'
}

/** A user role object */
export type UserRole = Node & {
  __typename?: 'UserRole';
  /** The capabilities that belong to this role */
  capabilities?: Maybe<Array<Maybe<Scalars['String']>>>;
  /** The display name of the role */
  displayName?: Maybe<Scalars['String']>;
  /** The globally unique identifier for the user role object. */
  id: Scalars['ID'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** The registered name of the role */
  name?: Maybe<Scalars['String']>;
};

/** Names of available user roles */
export enum UserRoleEnum {
  /** User role with specific capabilities */
  Administrator = 'ADMINISTRATOR',
  /** User role with specific capabilities */
  Author = 'AUTHOR',
  /** User role with specific capabilities */
  Contributor = 'CONTRIBUTOR',
  /** User role with specific capabilities */
  Editor = 'EDITOR',
  /** User role with specific capabilities */
  SeoEditor = 'SEO_EDITOR',
  /** User role with specific capabilities */
  SeoManager = 'SEO_MANAGER',
  /** User role with specific capabilities */
  Subscriber = 'SUBSCRIBER'
}

/** Connection between the User type and the Comment type */
export type UserToCommentConnection = {
  __typename?: 'UserToCommentConnection';
  /** Edges for the UserToCommentConnection connection */
  edges?: Maybe<Array<Maybe<UserToCommentConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Comment>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type UserToCommentConnectionEdge = {
  __typename?: 'UserToCommentConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Comment>;
};

/** Arguments for filtering the UserToCommentConnection connection */
export type UserToCommentConnectionWhereArgs = {
  /** Comment author email address. */
  authorEmail?: InputMaybe<Scalars['String']>;
  /** Array of author IDs to include comments for. */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to exclude comments for. */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Comment author URL. */
  authorUrl?: InputMaybe<Scalars['String']>;
  /** Array of comment IDs to include. */
  commentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of IDs of users whose unapproved comments will be returned by the query regardless of status. */
  commentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Include comments of a given type. */
  commentType?: InputMaybe<Scalars['String']>;
  /** Include comments from a given array of comment types. */
  commentTypeIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Exclude comments from a given array of comment types. */
  commentTypeNotIn?: InputMaybe<Scalars['String']>;
  /** Content object author ID to limit results by. */
  contentAuthor?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs to retrieve comments for. */
  contentAuthorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of author IDs *not* to retrieve comments for. */
  contentAuthorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Limit results to those affiliated with a given content object ID. */
  contentId?: InputMaybe<Scalars['ID']>;
  /** Array of content object IDs to include affiliated comments for. */
  contentIdIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of content object IDs to exclude affiliated comments for. */
  contentIdNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Content object name (i.e. slug ) to retrieve affiliated comments for. */
  contentName?: InputMaybe<Scalars['String']>;
  /** Content Object parent ID to retrieve affiliated comments for. */
  contentParent?: InputMaybe<Scalars['Int']>;
  /** Array of content object statuses to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentStatus?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Content object type or array of types to retrieve affiliated comments for. Pass 'any' to match any value. */
  contentType?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Array of IDs or email addresses of users whose unapproved comments will be returned by the query regardless of $status. Default empty */
  includeUnapproved?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Karma score to retrieve matching comments for. */
  karma?: InputMaybe<Scalars['Int']>;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
  /** Field to order the comments by. */
  orderby?: InputMaybe<CommentsConnectionOrderbyEnum>;
  /** Parent ID of comment to retrieve children of. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Array of parent IDs of comments to retrieve children for. */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of parent IDs of comments *not* to retrieve children for. */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Search term(s) to retrieve matching comments for. */
  search?: InputMaybe<Scalars['String']>;
  /** Comment status to limit results by. */
  status?: InputMaybe<Scalars['String']>;
  /** Include comments for a specific user ID. */
  userId?: InputMaybe<Scalars['ID']>;
};

/** Connection between the User type and the ContentRevisionUnion type */
export type UserToContentRevisionUnionConnection = {
  __typename?: 'UserToContentRevisionUnionConnection';
  /** Edges for the UserToContentRevisionUnionConnection connection */
  edges?: Maybe<Array<Maybe<UserToContentRevisionUnionConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentRevisionUnion>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type UserToContentRevisionUnionConnectionEdge = {
  __typename?: 'UserToContentRevisionUnionConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentRevisionUnion>;
};

/** Arguments for filtering the UserToContentRevisionUnionConnection connection */
export type UserToContentRevisionUnionConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypeEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the User type and the EnqueuedScript type */
export type UserToEnqueuedScriptConnection = {
  __typename?: 'UserToEnqueuedScriptConnection';
  /** Edges for the UserToEnqueuedScriptConnection connection */
  edges?: Maybe<Array<Maybe<UserToEnqueuedScriptConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<EnqueuedScript>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type UserToEnqueuedScriptConnectionEdge = {
  __typename?: 'UserToEnqueuedScriptConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<EnqueuedScript>;
};

/** Connection between the User type and the EnqueuedStylesheet type */
export type UserToEnqueuedStylesheetConnection = {
  __typename?: 'UserToEnqueuedStylesheetConnection';
  /** Edges for the UserToEnqueuedStylesheetConnection connection */
  edges?: Maybe<Array<Maybe<UserToEnqueuedStylesheetConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<EnqueuedStylesheet>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type UserToEnqueuedStylesheetConnectionEdge = {
  __typename?: 'UserToEnqueuedStylesheetConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<EnqueuedStylesheet>;
};

/** Connection between the User type and the mediaItem type */
export type UserToMediaItemConnection = {
  __typename?: 'UserToMediaItemConnection';
  /** Edges for the UserToMediaItemConnection connection */
  edges?: Maybe<Array<Maybe<UserToMediaItemConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<MediaItem>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type UserToMediaItemConnectionEdge = {
  __typename?: 'UserToMediaItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<MediaItem>;
};

/** Arguments for filtering the UserToMediaItemConnection connection */
export type UserToMediaItemConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the User type and the page type */
export type UserToPageConnection = {
  __typename?: 'UserToPageConnection';
  /** Edges for the UserToPageConnection connection */
  edges?: Maybe<Array<Maybe<UserToPageConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Page>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type UserToPageConnectionEdge = {
  __typename?: 'UserToPageConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Page>;
};

/** Arguments for filtering the UserToPageConnection connection */
export type UserToPageConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the User type and the post type */
export type UserToPostConnection = {
  __typename?: 'UserToPostConnection';
  /** Edges for the UserToPostConnection connection */
  edges?: Maybe<Array<Maybe<UserToPostConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Post>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type UserToPostConnectionEdge = {
  __typename?: 'UserToPostConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Post>;
};

/** Arguments for filtering the UserToPostConnection connection */
export type UserToPostConnectionWhereArgs = {
  /** The user that's connected as the author of the object. Use the userId for the author object. */
  author?: InputMaybe<Scalars['Int']>;
  /** Find objects connected to author(s) in the array of author's userIds */
  authorIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Find objects connected to the author by the author's nicename */
  authorName?: InputMaybe<Scalars['String']>;
  /** Find objects NOT connected to author(s) in the array of author's userIds */
  authorNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Category ID */
  categoryId?: InputMaybe<Scalars['Int']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Use Category Slug */
  categoryName?: InputMaybe<Scalars['String']>;
  /** Array of category IDs, used to display objects from one category OR another */
  categoryNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Tag Slug */
  tag?: InputMaybe<Scalars['String']>;
  /** Use Tag ID */
  tagId?: InputMaybe<Scalars['String']>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag IDs, used to display objects from one tag OR another */
  tagNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of tag slugs, used to display objects from one tag AND another */
  tagSlugAnd?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of tag slugs, used to include objects in ANY specified tags */
  tagSlugIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the User type and the UserRole type */
export type UserToUserRoleConnection = {
  __typename?: 'UserToUserRoleConnection';
  /** Edges for the UserToUserRoleConnection connection */
  edges?: Maybe<Array<Maybe<UserToUserRoleConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<UserRole>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type UserToUserRoleConnectionEdge = {
  __typename?: 'UserToUserRoleConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<UserRole>;
};

/** Field to order the connection by */
export enum UsersConnectionOrderbyEnum {
  /** Order by display name */
  DisplayName = 'DISPLAY_NAME',
  /** Order by email address */
  Email = 'EMAIL',
  /** Order by login */
  Login = 'LOGIN',
  /** Preserve the login order given in the LOGIN_IN array */
  LoginIn = 'LOGIN_IN',
  /** Order by nice name */
  NiceName = 'NICE_NAME',
  /** Preserve the nice name order given in the NICE_NAME_IN array */
  NiceNameIn = 'NICE_NAME_IN',
  /** Order by registration date */
  Registered = 'REGISTERED',
  /** Order by URL */
  Url = 'URL'
}

/** Options for ordering the connection */
export type UsersConnectionOrderbyInput = {
  /** The field name used to sort the results. */
  field: UsersConnectionOrderbyEnum;
  /** The cardinality of the order of the connection */
  order?: InputMaybe<OrderEnum>;
};

/** Column used for searching for users. */
export enum UsersConnectionSearchColumnEnum {
  /** The user's email address. */
  Email = 'EMAIL',
  /** The globally unique ID. */
  Id = 'ID',
  /** The username the User uses to login with. */
  Login = 'LOGIN',
  /** A URL-friendly name for the user. The default is the user's username. */
  Nicename = 'NICENAME',
  /** The URL of the user\s website. */
  Url = 'URL'
}

export enum ValidateAndDispatchInvitesForIndirectCourseError {
  InsufficientNumberOfResources = 'INSUFFICIENT_NUMBER_OF_RESOURCES',
  InternalServerError = 'INTERNAL_SERVER_ERROR',
  Unauthorized = 'UNAUTHORIZED'
}

export type ValidateAndDispatchInvitesForIndirectCourseInput = {
  courseId: Scalars['Int'];
  invites: Array<Invite>;
};

export type ValidateAndDispatchInvitesForIndirectCourseOutput = {
  __typename?: 'ValidateAndDispatchInvitesForIndirectCourseOutput';
  error?: Maybe<ValidateAndDispatchInvitesForIndirectCourseError>;
  extraLicensesRequiredToBuy?: Maybe<Scalars['Int']>;
  extraResourcePacksRequiredToBuy?: Maybe<Scalars['Int']>;
  success: Scalars['Boolean'];
};

/** The VideoSeriesCategory type */
export type VideoSeriesCategory = DatabaseIdentifier & MenuItemLinkable & Node & TermNode & UniformResourceIdentifiable & {
  __typename?: 'VideoSeriesCategory';
  /** Connection between the VideoSeriesCategory type and the ContentNode type */
  contentNodes?: Maybe<VideoSeriesCategoryToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The unique resource identifier path */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the VideoSeriesCategory type and the Taxonomy type */
  taxonomy?: Maybe<VideoSeriesCategoryToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
  /** The id field matches the WP_Post-&gt;ID field. */
  videoSeriesCategoryId?: Maybe<Scalars['Int']>;
  /** Connection between the VideoSeriesCategory type and the VideoSeriesItem type */
  videoSeriesItems?: Maybe<VideoSeriesCategoryToVideoSeriesItemConnection>;
};


/** The VideoSeriesCategory type */
export type VideoSeriesCategoryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VideoSeriesCategoryToContentNodeConnectionWhereArgs>;
};


/** The VideoSeriesCategory type */
export type VideoSeriesCategoryEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The VideoSeriesCategory type */
export type VideoSeriesCategoryEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The VideoSeriesCategory type */
export type VideoSeriesCategoryVideoSeriesItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VideoSeriesCategoryToVideoSeriesItemConnectionWhereArgs>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum VideoSeriesCategoryIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the VideoSeriesCategory type and the ContentNode type */
export type VideoSeriesCategoryToContentNodeConnection = {
  __typename?: 'VideoSeriesCategoryToContentNodeConnection';
  /** Edges for the VideoSeriesCategoryToContentNodeConnection connection */
  edges?: Maybe<Array<Maybe<VideoSeriesCategoryToContentNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type VideoSeriesCategoryToContentNodeConnectionEdge = {
  __typename?: 'VideoSeriesCategoryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentNode>;
};

/** Arguments for filtering the VideoSeriesCategoryToContentNodeConnection connection */
export type VideoSeriesCategoryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfVideoSeriesCategoryEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the VideoSeriesCategory type and the Taxonomy type */
export type VideoSeriesCategoryToTaxonomyConnectionEdge = {
  __typename?: 'VideoSeriesCategoryToTaxonomyConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Taxonomy>;
};

/** Connection between the VideoSeriesCategory type and the VideoSeriesItem type */
export type VideoSeriesCategoryToVideoSeriesItemConnection = {
  __typename?: 'VideoSeriesCategoryToVideoSeriesItemConnection';
  /** Edges for the VideoSeriesCategoryToVideoSeriesItemConnection connection */
  edges?: Maybe<Array<Maybe<VideoSeriesCategoryToVideoSeriesItemConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<VideoSeriesItem>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type VideoSeriesCategoryToVideoSeriesItemConnectionEdge = {
  __typename?: 'VideoSeriesCategoryToVideoSeriesItemConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<VideoSeriesItem>;
};

/** Arguments for filtering the VideoSeriesCategoryToVideoSeriesItemConnection connection */
export type VideoSeriesCategoryToVideoSeriesItemConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** The VideoSeriesItem type */
export type VideoSeriesItem = ContentNode & DatabaseIdentifier & MenuItemLinkable & Node & NodeWithExcerpt & NodeWithFeaturedImage & NodeWithTemplate & NodeWithTitle & UniformResourceIdentifiable & {
  __typename?: 'VideoSeriesItem';
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;Downloads&quot; was set to Show in GraphQL. */
  downloads?: Maybe<VideoSeriesItem_Downloads>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The excerpt of the post. */
  excerpt?: Maybe<Scalars['String']>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the video-series object. */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /** Connection between the VideoSeriesItem type and the VideoSeriesItem type */
  preview?: Maybe<VideoSeriesItemToPreviewConnectionEdge>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
  /** Connection between the VideoSeriesItem type and the TermNode type */
  terms?: Maybe<VideoSeriesItemToTermNodeConnection>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
  /** Connection between the VideoSeriesItem type and the VideoSeriesCategory type */
  videoSeriesCategories?: Maybe<VideoSeriesItemToVideoSeriesCategoryConnection>;
  /** The id field matches the WP_Post-&gt;ID field. */
  videoSeriesItemId: Scalars['Int'];
  /** Added to the GraphQL Schema because the ACF Field Group &quot;YouTube&quot; was set to Show in GraphQL. */
  youtube?: Maybe<VideoSeriesItem_Youtube>;
};


/** The VideoSeriesItem type */
export type VideoSeriesItemEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The VideoSeriesItem type */
export type VideoSeriesItemEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The VideoSeriesItem type */
export type VideoSeriesItemExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The VideoSeriesItem type */
export type VideoSeriesItemTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VideoSeriesItemToTermNodeConnectionWhereArgs>;
};


/** The VideoSeriesItem type */
export type VideoSeriesItemTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The VideoSeriesItem type */
export type VideoSeriesItemVideoSeriesCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<VideoSeriesItemToVideoSeriesCategoryConnectionWhereArgs>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum VideoSeriesItemIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Connection between the VideoSeriesItem type and the VideoSeriesItem type */
export type VideoSeriesItemToPreviewConnectionEdge = {
  __typename?: 'VideoSeriesItemToPreviewConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<VideoSeriesItem>;
};

/** Connection between the VideoSeriesItem type and the TermNode type */
export type VideoSeriesItemToTermNodeConnection = {
  __typename?: 'VideoSeriesItemToTermNodeConnection';
  /** Edges for the VideoSeriesItemToTermNodeConnection connection */
  edges?: Maybe<Array<Maybe<VideoSeriesItemToTermNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<TermNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type VideoSeriesItemToTermNodeConnectionEdge = {
  __typename?: 'VideoSeriesItemToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<TermNode>;
};

/** Arguments for filtering the VideoSeriesItemToTermNodeConnection connection */
export type VideoSeriesItemToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies?: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the VideoSeriesItem type and the VideoSeriesCategory type */
export type VideoSeriesItemToVideoSeriesCategoryConnection = {
  __typename?: 'VideoSeriesItemToVideoSeriesCategoryConnection';
  /** Edges for the VideoSeriesItemToVideoSeriesCategoryConnection connection */
  edges?: Maybe<Array<Maybe<VideoSeriesItemToVideoSeriesCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<VideoSeriesCategory>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type VideoSeriesItemToVideoSeriesCategoryConnectionEdge = {
  __typename?: 'VideoSeriesItemToVideoSeriesCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<VideoSeriesCategory>;
};

/** Arguments for filtering the VideoSeriesItemToVideoSeriesCategoryConnection connection */
export type VideoSeriesItemToVideoSeriesCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Set relationships between the VideoSeriesItem to VideoSeriesCategories */
export type VideoSeriesItemVideoSeriesCategoriesInput = {
  /** If true, this will append the VideoSeriesCategory to existing related VideoSeriesCategories. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<VideoSeriesItemVideoSeriesCategoriesNodeInput>>>;
};

/** List of VideoSeriesCategories to connect the VideoSeriesItem to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type VideoSeriesItemVideoSeriesCategoriesNodeInput = {
  /** The description of the VideoSeriesCategory. This field is used to set a description of the VideoSeriesCategory if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the VideoSeriesCategory. If present, this will be used to connect to the VideoSeriesItem. If no existing VideoSeriesCategory exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the VideoSeriesCategory. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the VideoSeriesCategory. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** Field Group */
export type VideoSeriesItem_Downloads = AcfFieldGroup & {
  __typename?: 'VideoSeriesItem_Downloads';
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  file?: Maybe<MediaItem>;
};

/** Field Group */
export type VideoSeriesItem_Youtube = AcfFieldGroup & {
  __typename?: 'VideoSeriesItem_Youtube';
  /** Duration of the video in seconds */
  duration?: Maybe<Scalars['Float']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  /** A link to the YouTube video */
  url?: Maybe<Scalars['String']>;
};

/** Information about pagination in a connection. */
export type WpPageInfo = {
  __typename?: 'WPPageInfo';
  /** When paginating forwards, the cursor to continue. */
  endCursor?: Maybe<Scalars['String']>;
  /** When paginating forwards, are there more items? */
  hasNextPage: Scalars['Boolean'];
  /** When paginating backwards, are there more items? */
  hasPreviousPage: Scalars['Boolean'];
  /** When paginating backwards, the cursor to continue. */
  startCursor?: Maybe<Scalars['String']>;
};

/** The Webinar type */
export type Webinar = ContentNode & DatabaseIdentifier & MenuItemLinkable & Node & NodeWithExcerpt & NodeWithFeaturedImage & NodeWithTemplate & NodeWithTitle & UniformResourceIdentifiable & {
  __typename?: 'Webinar';
  /** Connection between the ContentNode type and the ContentType type */
  contentType?: Maybe<ContentNodeToContentTypeConnectionEdge>;
  /** The name of the Content Type the node belongs to */
  contentTypeName: Scalars['String'];
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** Post publishing date. */
  date?: Maybe<Scalars['String']>;
  /** The publishing date set in GMT. */
  dateGmt?: Maybe<Scalars['String']>;
  /** The desired slug of the post */
  desiredSlug?: Maybe<Scalars['String']>;
  /** If a user has edited the node within the past 15 seconds, this will return the user that last edited. Null if the edit lock doesn&#039;t exist or is greater than 15 seconds */
  editingLockedBy?: Maybe<ContentNodeToEditLockConnectionEdge>;
  /** The RSS enclosure for the object */
  enclosure?: Maybe<Scalars['String']>;
  /** Connection between the ContentNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<ContentNodeToEnqueuedScriptConnection>;
  /** Connection between the ContentNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<ContentNodeToEnqueuedStylesheetConnection>;
  /** The excerpt of the post. */
  excerpt?: Maybe<Scalars['String']>;
  /** Connection between the NodeWithFeaturedImage type and the MediaItem type */
  featuredImage?: Maybe<NodeWithFeaturedImageToMediaItemConnectionEdge>;
  /** The database identifier for the featured image node assigned to the content node */
  featuredImageDatabaseId?: Maybe<Scalars['Int']>;
  /** Globally unique ID of the featured image assigned to the node */
  featuredImageId?: Maybe<Scalars['ID']>;
  /** The global unique identifier for this post. This currently matches the value stored in WP_Post-&gt;guid and the guid column in the &quot;post_objects&quot; database table. */
  guid?: Maybe<Scalars['String']>;
  /** The globally unique identifier of the webinar object. */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is a node in the preview state */
  isPreview?: Maybe<Scalars['Boolean']>;
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The user that most recently edited the node */
  lastEditedBy?: Maybe<ContentNodeToEditLastConnectionEdge>;
  /** The permalink of the post */
  link?: Maybe<Scalars['String']>;
  /** The local modified time for a post. If a post was recently updated the modified field will change to match the corresponding time. */
  modified?: Maybe<Scalars['String']>;
  /** The GMT modified time for a post. If a post was recently updated the modified field will change to match the corresponding time in GMT. */
  modifiedGmt?: Maybe<Scalars['String']>;
  /** Connection between the Webinar type and the Webinar type */
  preview?: Maybe<WebinarToPreviewConnectionEdge>;
  /** The database id of the preview node */
  previewRevisionDatabaseId?: Maybe<Scalars['Int']>;
  /** Whether the object is a node in the preview state */
  previewRevisionId?: Maybe<Scalars['ID']>;
  /** The uri slug for the post. This is equivalent to the WP_Post-&gt;post_name field and the post_name column in the database for the &quot;post_objects&quot; table. */
  slug?: Maybe<Scalars['String']>;
  /** The current status of the object */
  status?: Maybe<Scalars['String']>;
  /** The template assigned to the node */
  template?: Maybe<ContentTemplate>;
  /** Connection between the Webinar type and the TermNode type */
  terms?: Maybe<WebinarToTermNodeConnection>;
  /** The title of the post. This is currently just the raw title. An amendment to support rendered title needs to be made. */
  title?: Maybe<Scalars['String']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
  /** The id field matches the WP_Post-&gt;ID field. */
  webinarId: Scalars['Int'];
  /** Connection between the Webinar type and the WebinarsCategory type */
  webinarsCategories?: Maybe<WebinarToWebinarsCategoryConnection>;
  /** Added to the GraphQL Schema because the ACF Field Group &quot;YouTube&quot; was set to Show in GraphQL. */
  youtube?: Maybe<Webinar_Youtube>;
};


/** The Webinar type */
export type WebinarEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The Webinar type */
export type WebinarEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The Webinar type */
export type WebinarExcerptArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The Webinar type */
export type WebinarTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WebinarToTermNodeConnectionWhereArgs>;
};


/** The Webinar type */
export type WebinarTitleArgs = {
  format?: InputMaybe<PostObjectFieldFormatEnum>;
};


/** The Webinar type */
export type WebinarWebinarsCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WebinarToWebinarsCategoryConnectionWhereArgs>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum WebinarIdType {
  /** Identify a resource by the Database ID. */
  DatabaseId = 'DATABASE_ID',
  /** Identify a resource by the (hashed) Global ID. */
  Id = 'ID',
  /** Identify a resource by the slug. Available to non-hierarchcial Types where the slug is a unique identifier. */
  Slug = 'SLUG',
  /** Identify a resource by the URI. */
  Uri = 'URI'
}

/** Connection between the Webinar type and the Webinar type */
export type WebinarToPreviewConnectionEdge = {
  __typename?: 'WebinarToPreviewConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Webinar>;
};

/** Connection between the Webinar type and the TermNode type */
export type WebinarToTermNodeConnection = {
  __typename?: 'WebinarToTermNodeConnection';
  /** Edges for the WebinarToTermNodeConnection connection */
  edges?: Maybe<Array<Maybe<WebinarToTermNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<TermNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type WebinarToTermNodeConnectionEdge = {
  __typename?: 'WebinarToTermNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<TermNode>;
};

/** Arguments for filtering the WebinarToTermNodeConnection connection */
export type WebinarToTermNodeConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** The Taxonomy to filter terms by */
  taxonomies?: InputMaybe<Array<InputMaybe<TaxonomyEnum>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Connection between the Webinar type and the WebinarsCategory type */
export type WebinarToWebinarsCategoryConnection = {
  __typename?: 'WebinarToWebinarsCategoryConnection';
  /** Edges for the WebinarToWebinarsCategoryConnection connection */
  edges?: Maybe<Array<Maybe<WebinarToWebinarsCategoryConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<WebinarsCategory>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type WebinarToWebinarsCategoryConnectionEdge = {
  __typename?: 'WebinarToWebinarsCategoryConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<WebinarsCategory>;
};

/** Arguments for filtering the WebinarToWebinarsCategoryConnection connection */
export type WebinarToWebinarsCategoryConnectionWhereArgs = {
  /** Unique cache key to be produced when this query is stored in an object cache. Default is 'core'. */
  cacheDomain?: InputMaybe<Scalars['String']>;
  /** Term ID to retrieve child terms of. If multiple taxonomies are passed, $child_of is ignored. Default 0. */
  childOf?: InputMaybe<Scalars['Int']>;
  /** True to limit results to terms that have no children. This parameter has no effect on non-hierarchical taxonomies. Default false. */
  childless?: InputMaybe<Scalars['Boolean']>;
  /** Retrieve terms where the description is LIKE the input value. Default empty. */
  descriptionLike?: InputMaybe<Scalars['String']>;
  /** Array of term ids to exclude. If $include is non-empty, $exclude is ignored. Default empty array. */
  exclude?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term ids to exclude along with all of their descendant terms. If $include is non-empty, $exclude_tree is ignored. Default empty array. */
  excludeTree?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to hide terms not assigned to any posts. Accepts true or false. Default false */
  hideEmpty?: InputMaybe<Scalars['Boolean']>;
  /** Whether to include terms that have non-empty descendants (even if $hide_empty is set to true). Default true. */
  hierarchical?: InputMaybe<Scalars['Boolean']>;
  /** Array of term ids to include. Default empty array. */
  include?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of names to return term(s) for. Default empty. */
  name?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Retrieve terms where the name is LIKE the input value. Default empty. */
  nameLike?: InputMaybe<Scalars['String']>;
  /** Array of object IDs. Results will be limited to terms associated with these objects. */
  objectIds?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Direction the connection should be ordered in */
  order?: InputMaybe<OrderEnum>;
  /** Field(s) to order terms by. Defaults to 'name'. */
  orderby?: InputMaybe<TermObjectsConnectionOrderbyEnum>;
  /** Whether to pad the quantity of a term's children in the quantity of each term's "count" object variable. Default false. */
  padCounts?: InputMaybe<Scalars['Boolean']>;
  /** Parent term ID to retrieve direct-child terms of. Default empty. */
  parent?: InputMaybe<Scalars['Int']>;
  /** Search criteria to match terms. Will be SQL-formatted with wildcards before and after. Default empty. */
  search?: InputMaybe<Scalars['String']>;
  /** Array of slugs to return term(s) for. Default empty. */
  slug?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Array of term taxonomy IDs, to match when querying terms. */
  termTaxonomyId?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Whether to prime meta caches for matched terms. Default true. */
  updateTermMetaCache?: InputMaybe<Scalars['Boolean']>;
};

/** Set relationships between the Webinar to WebinarsCategories */
export type WebinarWebinarsCategoriesInput = {
  /** If true, this will append the WebinarsCategory to existing related WebinarsCategories. If false, this will replace existing relationships. Default true. */
  append?: InputMaybe<Scalars['Boolean']>;
  /** The input list of items to set. */
  nodes?: InputMaybe<Array<InputMaybe<WebinarWebinarsCategoriesNodeInput>>>;
};

/** List of WebinarsCategories to connect the Webinar to. If an ID is set, it will be used to create the connection. If not, it will look for a slug. If neither are valid existing terms, and the site is configured to allow terms to be created during post mutations, a term will be created using the Name if it exists in the input, then fallback to the slug if it exists. */
export type WebinarWebinarsCategoriesNodeInput = {
  /** The description of the WebinarsCategory. This field is used to set a description of the WebinarsCategory if a new one is created during the mutation. */
  description?: InputMaybe<Scalars['String']>;
  /** The ID of the WebinarsCategory. If present, this will be used to connect to the Webinar. If no existing WebinarsCategory exists with this ID, no connection will be made. */
  id?: InputMaybe<Scalars['ID']>;
  /** The name of the WebinarsCategory. This field is used to create a new term, if term creation is enabled in nested mutations, and if one does not already exist with the provided slug or ID or if a slug or ID is not provided. If no name is included and a term is created, the creation will fallback to the slug field. */
  name?: InputMaybe<Scalars['String']>;
  /** The slug of the WebinarsCategory. If no ID is present, this field will be used to make a connection. If no existing term exists with this slug, this field will be used as a fallback to the Name field when creating a new term to connect to, if term creation is enabled as a nested mutation. */
  slug?: InputMaybe<Scalars['String']>;
};

/** Field Group */
export type Webinar_Youtube = AcfFieldGroup & {
  __typename?: 'Webinar_Youtube';
  /** Duration of the video in seconds */
  duration?: Maybe<Scalars['Float']>;
  /** The name of the ACF Field Group */
  fieldGroupName?: Maybe<Scalars['String']>;
  /** A link to the YouTube video */
  url?: Maybe<Scalars['String']>;
};

/** The WebinarsCategory type */
export type WebinarsCategory = DatabaseIdentifier & MenuItemLinkable & Node & TermNode & UniformResourceIdentifiable & {
  __typename?: 'WebinarsCategory';
  /** Connection between the WebinarsCategory type and the ContentNode type */
  contentNodes?: Maybe<WebinarsCategoryToContentNodeConnection>;
  /** The number of objects connected to the object */
  count?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  databaseId: Scalars['Int'];
  /** The description of the object */
  description?: Maybe<Scalars['String']>;
  /** Connection between the TermNode type and the EnqueuedScript type */
  enqueuedScripts?: Maybe<TermNodeToEnqueuedScriptConnection>;
  /** Connection between the TermNode type and the EnqueuedStylesheet type */
  enqueuedStylesheets?: Maybe<TermNodeToEnqueuedStylesheetConnection>;
  /** The unique resource identifier path */
  id: Scalars['ID'];
  /** Whether the node is a Content Node */
  isContentNode: Scalars['Boolean'];
  /** Whether the object is restricted from the current viewer */
  isRestricted?: Maybe<Scalars['Boolean']>;
  /** Whether the node is a Term */
  isTermNode: Scalars['Boolean'];
  /** The link to the term */
  link?: Maybe<Scalars['String']>;
  /** The human friendly name of the object. */
  name?: Maybe<Scalars['String']>;
  /** An alphanumeric identifier for the object unique to its type. */
  slug?: Maybe<Scalars['String']>;
  /** Connection between the WebinarsCategory type and the Taxonomy type */
  taxonomy?: Maybe<WebinarsCategoryToTaxonomyConnectionEdge>;
  /** The name of the taxonomy that the object is associated with */
  taxonomyName?: Maybe<Scalars['String']>;
  /** The ID of the term group that this term object belongs to */
  termGroupId?: Maybe<Scalars['Int']>;
  /** The taxonomy ID that the object is associated with */
  termTaxonomyId?: Maybe<Scalars['Int']>;
  /** The unique resource identifier path */
  uri?: Maybe<Scalars['String']>;
  /** Connection between the WebinarsCategory type and the Webinar type */
  webinars?: Maybe<WebinarsCategoryToWebinarConnection>;
  /** The id field matches the WP_Post-&gt;ID field. */
  webinarsCategoryId?: Maybe<Scalars['Int']>;
};


/** The WebinarsCategory type */
export type WebinarsCategoryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WebinarsCategoryToContentNodeConnectionWhereArgs>;
};


/** The WebinarsCategory type */
export type WebinarsCategoryEnqueuedScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The WebinarsCategory type */
export type WebinarsCategoryEnqueuedStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


/** The WebinarsCategory type */
export type WebinarsCategoryWebinarsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<WebinarsCategoryToWebinarConnectionWhereArgs>;
};

/** The Type of Identifier used to fetch a single resource. Default is ID. */
export enum WebinarsCategoryIdType {
  /** The Database ID for the node */
  DatabaseId = 'DATABASE_ID',
  /** The hashed Global ID */
  Id = 'ID',
  /** The name of the node */
  Name = 'NAME',
  /** Url friendly name of the node */
  Slug = 'SLUG',
  /** The URI for the node */
  Uri = 'URI'
}

/** Connection between the WebinarsCategory type and the ContentNode type */
export type WebinarsCategoryToContentNodeConnection = {
  __typename?: 'WebinarsCategoryToContentNodeConnection';
  /** Edges for the WebinarsCategoryToContentNodeConnection connection */
  edges?: Maybe<Array<Maybe<WebinarsCategoryToContentNodeConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<ContentNode>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type WebinarsCategoryToContentNodeConnectionEdge = {
  __typename?: 'WebinarsCategoryToContentNodeConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<ContentNode>;
};

/** Arguments for filtering the WebinarsCategoryToContentNodeConnection connection */
export type WebinarsCategoryToContentNodeConnectionWhereArgs = {
  /** The Types of content to filter */
  contentTypes?: InputMaybe<Array<InputMaybe<ContentTypesOfWebinarsCategoryEnum>>>;
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** Connection between the WebinarsCategory type and the Taxonomy type */
export type WebinarsCategoryToTaxonomyConnectionEdge = {
  __typename?: 'WebinarsCategoryToTaxonomyConnectionEdge';
  /** The node of the connection, without the edges */
  node?: Maybe<Taxonomy>;
};

/** Connection between the WebinarsCategory type and the Webinar type */
export type WebinarsCategoryToWebinarConnection = {
  __typename?: 'WebinarsCategoryToWebinarConnection';
  /** Edges for the WebinarsCategoryToWebinarConnection connection */
  edges?: Maybe<Array<Maybe<WebinarsCategoryToWebinarConnectionEdge>>>;
  /** The nodes of the connection, without the edges */
  nodes?: Maybe<Array<Maybe<Webinar>>>;
  /** Information about pagination in a connection. */
  pageInfo?: Maybe<WpPageInfo>;
};

/** An edge in a connection */
export type WebinarsCategoryToWebinarConnectionEdge = {
  __typename?: 'WebinarsCategoryToWebinarConnectionEdge';
  /** A cursor for use in pagination */
  cursor?: Maybe<Scalars['String']>;
  /** The item at the end of the edge */
  node?: Maybe<Webinar>;
};

/** Arguments for filtering the WebinarsCategoryToWebinarConnection connection */
export type WebinarsCategoryToWebinarConnectionWhereArgs = {
  /** Filter the connection based on dates */
  dateQuery?: InputMaybe<DateQueryInput>;
  /** True for objects with passwords; False for objects without passwords; null for all objects with or without passwords */
  hasPassword?: InputMaybe<Scalars['Boolean']>;
  /** Specific database ID of the object */
  id?: InputMaybe<Scalars['Int']>;
  /** Array of IDs for the objects to retrieve */
  in?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Get objects with a specific mimeType property */
  mimeType?: InputMaybe<MimeTypeEnum>;
  /** Slug / post_name of the object */
  name?: InputMaybe<Scalars['String']>;
  /** Specify objects to retrieve. Use slugs */
  nameIn?: InputMaybe<Array<InputMaybe<Scalars['String']>>>;
  /** Specify IDs NOT to retrieve. If this is used in the same query as "in", it will be ignored */
  notIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** What paramater to use to order the objects by. */
  orderby?: InputMaybe<Array<InputMaybe<PostObjectsConnectionOrderbyInput>>>;
  /** Use ID to return only children. Use 0 to return only top-level items */
  parent?: InputMaybe<Scalars['ID']>;
  /** Specify objects whose parent is in an array */
  parentIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Specify posts whose parent is not in an array */
  parentNotIn?: InputMaybe<Array<InputMaybe<Scalars['ID']>>>;
  /** Show posts with a specific password. */
  password?: InputMaybe<Scalars['String']>;
  /** Show Posts based on a keyword search */
  search?: InputMaybe<Scalars['String']>;
  /** Retrieve posts where post status is in an array. */
  stati?: InputMaybe<Array<InputMaybe<PostStatusEnum>>>;
  /** Show posts with a specific status. */
  status?: InputMaybe<PostStatusEnum>;
  /** Title of the object */
  title?: InputMaybe<Scalars['String']>;
};

/** The writing setting type */
export type WritingSettings = {
  __typename?: 'WritingSettings';
  /** Default post category. */
  defaultCategory?: Maybe<Scalars['Int']>;
  /** Default post format. */
  defaultPostFormat?: Maybe<Scalars['String']>;
  /** Convert emoticons like :-) and :-P to graphics on display. */
  useSmilies?: Maybe<Scalars['Boolean']>;
};

export type XeroAddress = {
  __typename?: 'XeroAddress';
  addressLine1?: Maybe<Scalars['String']>;
  addressLine2?: Maybe<Scalars['String']>;
  addressType?: Maybe<XeroAddressType>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  postalCode?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
};

export enum XeroAddressType {
  Pobox = 'POBOX',
  Street = 'STREET'
}

export type XeroCallbackInput = {
  url: Scalars['String'];
};

export type XeroCallbackOutput = {
  __typename?: 'XeroCallbackOutput';
  status: Scalars['Boolean'];
};

export type XeroConnectOutput = {
  __typename?: 'XeroConnectOutput';
  consentUrl?: Maybe<Scalars['String']>;
};

export type XeroContact = {
  __typename?: 'XeroContact';
  addresses?: Maybe<Array<Maybe<XeroAddress>>>;
  contactID: Scalars['ID'];
  contactStatus: XeroContactStatus;
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  isCustomer?: Maybe<Scalars['Boolean']>;
  lastName?: Maybe<Scalars['String']>;
  name: Scalars['String'];
  phones?: Maybe<Array<Maybe<XeroPhone>>>;
  updatedDateUTC?: Maybe<Scalars['date']>;
};

export type XeroContactSearchInput = {
  searchTerm: Scalars['String'];
};

export type XeroContactSearchOutput = {
  __typename?: 'XeroContactSearchOutput';
  contacts: Array<XeroContact>;
};

export enum XeroContactStatus {
  Active = 'ACTIVE',
  Archived = 'ARCHIVED',
  Gdprrequest = 'GDPRREQUEST'
}

export type XeroDisconnectOutput = {
  __typename?: 'XeroDisconnectOutput';
  connected: Scalars['Boolean'];
};

export type XeroInvoice = {
  __typename?: 'XeroInvoice';
  amountDue?: Maybe<Scalars['String']>;
  amountPaid?: Maybe<Scalars['String']>;
  contact: XeroContact;
  currencyCode: Currency;
  date: Scalars['String'];
  dueDate?: Maybe<Scalars['String']>;
  fullyPaidOnDate?: Maybe<Scalars['String']>;
  invoiceID: Scalars['ID'];
  invoiceNumber?: Maybe<Scalars['String']>;
  lineItems: Array<Maybe<XeroLineItem>>;
  reference?: Maybe<Scalars['String']>;
  status: XeroInvoiceStatus;
  subTotal?: Maybe<Scalars['Float']>;
  total: Scalars['Float'];
  totalTax?: Maybe<Scalars['Float']>;
  type: Scalars['String'];
};

export enum XeroInvoiceStatus {
  Authorised = 'AUTHORISED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Submitted = 'SUBMITTED',
  Unknown = 'UNKNOWN',
  Voided = 'VOIDED'
}

export type XeroInvoiceStatusKv = {
  __typename?: 'XeroInvoiceStatusKV';
  invoiceNumber: Scalars['String'];
  status: XeroInvoiceStatus;
};

export type XeroInvoiceSyncOutput = {
  __typename?: 'XeroInvoiceSyncOutput';
  message?: Maybe<Scalars['String']>;
};

export type XeroInvoicesStatusInput = {
  invoiceNumberContains?: InputMaybe<Scalars['String']>;
  invoiceNumbers: Array<InputMaybe<Scalars['String']>>;
  statuses?: InputMaybe<Array<InputMaybe<XeroInvoiceStatus>>>;
};

export type XeroInvoicesStatusOutput = {
  __typename?: 'XeroInvoicesStatusOutput';
  invoices: Array<Maybe<XeroInvoiceStatusKv>>;
};

export type XeroItem = {
  __typename?: 'XeroItem';
  code: Scalars['String'];
  itemID: Scalars['String'];
};

export type XeroLineItem = {
  __typename?: 'XeroLineItem';
  accountCode?: Maybe<Scalars['String']>;
  description?: Maybe<Scalars['String']>;
  item?: Maybe<XeroItem>;
  itemCode: Scalars['String'];
  lineAmount: Scalars['Float'];
  quantity: Scalars['Int'];
  taxAmount: Scalars['Float'];
  taxType: Scalars['String'];
  tracking?: Maybe<Array<XeroTrackingCategory>>;
  unitAmount: Scalars['Float'];
};

export type XeroPhone = {
  __typename?: 'XeroPhone';
  phoneAreaCode?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  phoneNumber?: Maybe<Scalars['String']>;
  phoneType: XeroPhoneType;
};

export enum XeroPhoneType {
  Ddi = 'DDI',
  Default = 'DEFAULT',
  Fax = 'FAX',
  Mobile = 'MOBILE'
}

export type XeroTrackingCategory = {
  __typename?: 'XeroTrackingCategory';
  name: Scalars['String'];
  option: Scalars['String'];
  trackingCategoryID: Scalars['String'];
};

export type ZoomMeeting = {
  __typename?: 'ZoomMeeting';
  id: Scalars['Int'];
  joinUrl: Scalars['String'];
};

export type ZoomMeetingNotFoundError = {
  __typename?: 'ZoomMeetingNotFoundError';
  id: Scalars['String'];
};

export type ZoomUser = {
  __typename?: 'ZoomUser';
  displayName: Scalars['String'];
  email: Scalars['String'];
  firstName: Scalars['String'];
  id: Scalars['String'];
  lastName: Scalars['String'];
};

export type ZoomUsersResponse = {
  __typename?: 'ZoomUsersResponse';
  data?: Maybe<ZoomUsersResponseData>;
  success?: Maybe<Scalars['Boolean']>;
};

export type ZoomUsersResponseData = {
  __typename?: 'ZoomUsersResponseData';
  current: Scalars['String'];
  users?: Maybe<Array<ZoomUser>>;
};

/** Scheduled events for sending about training survey email to certified users */
export type About_Training_Email_Scheduled_Events = {
  __typename?: 'about_training_email_scheduled_events';
  course_participant_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  event_id: Scalars['uuid'];
  id: Scalars['uuid'];
};

/** aggregated selection of "about_training_email_scheduled_events" */
export type About_Training_Email_Scheduled_Events_Aggregate = {
  __typename?: 'about_training_email_scheduled_events_aggregate';
  aggregate?: Maybe<About_Training_Email_Scheduled_Events_Aggregate_Fields>;
  nodes: Array<About_Training_Email_Scheduled_Events>;
};

/** aggregate fields of "about_training_email_scheduled_events" */
export type About_Training_Email_Scheduled_Events_Aggregate_Fields = {
  __typename?: 'about_training_email_scheduled_events_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<About_Training_Email_Scheduled_Events_Max_Fields>;
  min?: Maybe<About_Training_Email_Scheduled_Events_Min_Fields>;
};


/** aggregate fields of "about_training_email_scheduled_events" */
export type About_Training_Email_Scheduled_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<About_Training_Email_Scheduled_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "about_training_email_scheduled_events". All fields are combined with a logical 'AND'. */
export type About_Training_Email_Scheduled_Events_Bool_Exp = {
  _and?: InputMaybe<Array<About_Training_Email_Scheduled_Events_Bool_Exp>>;
  _not?: InputMaybe<About_Training_Email_Scheduled_Events_Bool_Exp>;
  _or?: InputMaybe<Array<About_Training_Email_Scheduled_Events_Bool_Exp>>;
  course_participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "about_training_email_scheduled_events" */
export enum About_Training_Email_Scheduled_Events_Constraint {
  /** unique or primary key constraint on columns "course_participant_id" */
  AboutTrainingEmailScheduledEventsCourseParticipantIdKey = 'about_training_email_scheduled_events_course_participant_id_key',
  /** unique or primary key constraint on columns "event_id" */
  AboutTrainingEmailScheduledEventsEventIdKey = 'about_training_email_scheduled_events_event_id_key',
  /** unique or primary key constraint on columns "id" */
  AboutTrainingEmailScheduledEventsPkey = 'about_training_email_scheduled_events_pkey'
}

/** input type for inserting data into table "about_training_email_scheduled_events" */
export type About_Training_Email_Scheduled_Events_Insert_Input = {
  course_participant_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type About_Training_Email_Scheduled_Events_Max_Fields = {
  __typename?: 'about_training_email_scheduled_events_max_fields';
  course_participant_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type About_Training_Email_Scheduled_Events_Min_Fields = {
  __typename?: 'about_training_email_scheduled_events_min_fields';
  course_participant_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "about_training_email_scheduled_events" */
export type About_Training_Email_Scheduled_Events_Mutation_Response = {
  __typename?: 'about_training_email_scheduled_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<About_Training_Email_Scheduled_Events>;
};

/** input type for inserting object relation for remote table "about_training_email_scheduled_events" */
export type About_Training_Email_Scheduled_Events_Obj_Rel_Insert_Input = {
  data: About_Training_Email_Scheduled_Events_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<About_Training_Email_Scheduled_Events_On_Conflict>;
};

/** on_conflict condition type for table "about_training_email_scheduled_events" */
export type About_Training_Email_Scheduled_Events_On_Conflict = {
  constraint: About_Training_Email_Scheduled_Events_Constraint;
  update_columns?: Array<About_Training_Email_Scheduled_Events_Update_Column>;
  where?: InputMaybe<About_Training_Email_Scheduled_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "about_training_email_scheduled_events". */
export type About_Training_Email_Scheduled_Events_Order_By = {
  course_participant_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: about_training_email_scheduled_events */
export type About_Training_Email_Scheduled_Events_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "about_training_email_scheduled_events" */
export enum About_Training_Email_Scheduled_Events_Select_Column {
  /** column name */
  CourseParticipantId = 'course_participant_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "about_training_email_scheduled_events" */
export type About_Training_Email_Scheduled_Events_Set_Input = {
  course_participant_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "about_training_email_scheduled_events" */
export type About_Training_Email_Scheduled_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: About_Training_Email_Scheduled_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type About_Training_Email_Scheduled_Events_Stream_Cursor_Value_Input = {
  course_participant_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "about_training_email_scheduled_events" */
export enum About_Training_Email_Scheduled_Events_Update_Column {
  /** column name */
  CourseParticipantId = 'course_participant_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id'
}

export type About_Training_Email_Scheduled_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<About_Training_Email_Scheduled_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: About_Training_Email_Scheduled_Events_Bool_Exp;
};

/** This table stores user absorb course enrolments and certificate details */
export type Absorb_Enrolment = {
  __typename?: 'absorb_enrolment';
  absorb_certificate_id?: Maybe<Scalars['uuid']>;
  certificate_awarded?: Maybe<Scalars['Boolean']>;
  certificate_awarded_date?: Maybe<Scalars['date']>;
  certificate_expiry_date?: Maybe<Scalars['date']>;
  enrolment_date: Scalars['date'];
  enrolment_id?: Maybe<Scalars['uuid']>;
  enrolment_information?: Maybe<Scalars['jsonb']>;
  enrolment_status?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  profile_id: Scalars['uuid'];
};


/** This table stores user absorb course enrolments and certificate details */
export type Absorb_EnrolmentEnrolment_InformationArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "absorb_enrolment" */
export type Absorb_Enrolment_Aggregate = {
  __typename?: 'absorb_enrolment_aggregate';
  aggregate?: Maybe<Absorb_Enrolment_Aggregate_Fields>;
  nodes: Array<Absorb_Enrolment>;
};

/** aggregate fields of "absorb_enrolment" */
export type Absorb_Enrolment_Aggregate_Fields = {
  __typename?: 'absorb_enrolment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Absorb_Enrolment_Max_Fields>;
  min?: Maybe<Absorb_Enrolment_Min_Fields>;
};


/** aggregate fields of "absorb_enrolment" */
export type Absorb_Enrolment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Absorb_Enrolment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Absorb_Enrolment_Append_Input = {
  enrolment_information?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "absorb_enrolment". All fields are combined with a logical 'AND'. */
export type Absorb_Enrolment_Bool_Exp = {
  _and?: InputMaybe<Array<Absorb_Enrolment_Bool_Exp>>;
  _not?: InputMaybe<Absorb_Enrolment_Bool_Exp>;
  _or?: InputMaybe<Array<Absorb_Enrolment_Bool_Exp>>;
  absorb_certificate_id?: InputMaybe<Uuid_Comparison_Exp>;
  certificate_awarded?: InputMaybe<Boolean_Comparison_Exp>;
  certificate_awarded_date?: InputMaybe<Date_Comparison_Exp>;
  certificate_expiry_date?: InputMaybe<Date_Comparison_Exp>;
  enrolment_date?: InputMaybe<Date_Comparison_Exp>;
  enrolment_id?: InputMaybe<Uuid_Comparison_Exp>;
  enrolment_information?: InputMaybe<Jsonb_Comparison_Exp>;
  enrolment_status?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "absorb_enrolment" */
export enum Absorb_Enrolment_Constraint {
  /** unique or primary key constraint on columns "absorb_certificate_id" */
  AbsorbEnrolmentAbsorbCertificateIdKey = 'absorb_enrolment_absorb_certificate_id_key',
  /** unique or primary key constraint on columns "id" */
  AbsorbEnrolmentPkey = 'absorb_enrolment_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Absorb_Enrolment_Delete_At_Path_Input = {
  enrolment_information?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Absorb_Enrolment_Delete_Elem_Input = {
  enrolment_information?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Absorb_Enrolment_Delete_Key_Input = {
  enrolment_information?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "absorb_enrolment" */
export type Absorb_Enrolment_Insert_Input = {
  absorb_certificate_id?: InputMaybe<Scalars['uuid']>;
  certificate_awarded?: InputMaybe<Scalars['Boolean']>;
  certificate_awarded_date?: InputMaybe<Scalars['date']>;
  certificate_expiry_date?: InputMaybe<Scalars['date']>;
  enrolment_date?: InputMaybe<Scalars['date']>;
  enrolment_id?: InputMaybe<Scalars['uuid']>;
  enrolment_information?: InputMaybe<Scalars['jsonb']>;
  enrolment_status?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Absorb_Enrolment_Max_Fields = {
  __typename?: 'absorb_enrolment_max_fields';
  absorb_certificate_id?: Maybe<Scalars['uuid']>;
  certificate_awarded_date?: Maybe<Scalars['date']>;
  certificate_expiry_date?: Maybe<Scalars['date']>;
  enrolment_date?: Maybe<Scalars['date']>;
  enrolment_id?: Maybe<Scalars['uuid']>;
  enrolment_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Absorb_Enrolment_Min_Fields = {
  __typename?: 'absorb_enrolment_min_fields';
  absorb_certificate_id?: Maybe<Scalars['uuid']>;
  certificate_awarded_date?: Maybe<Scalars['date']>;
  certificate_expiry_date?: Maybe<Scalars['date']>;
  enrolment_date?: Maybe<Scalars['date']>;
  enrolment_id?: Maybe<Scalars['uuid']>;
  enrolment_status?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "absorb_enrolment" */
export type Absorb_Enrolment_Mutation_Response = {
  __typename?: 'absorb_enrolment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Absorb_Enrolment>;
};

/** on_conflict condition type for table "absorb_enrolment" */
export type Absorb_Enrolment_On_Conflict = {
  constraint: Absorb_Enrolment_Constraint;
  update_columns?: Array<Absorb_Enrolment_Update_Column>;
  where?: InputMaybe<Absorb_Enrolment_Bool_Exp>;
};

/** Ordering options when selecting data from "absorb_enrolment". */
export type Absorb_Enrolment_Order_By = {
  absorb_certificate_id?: InputMaybe<Order_By>;
  certificate_awarded?: InputMaybe<Order_By>;
  certificate_awarded_date?: InputMaybe<Order_By>;
  certificate_expiry_date?: InputMaybe<Order_By>;
  enrolment_date?: InputMaybe<Order_By>;
  enrolment_id?: InputMaybe<Order_By>;
  enrolment_information?: InputMaybe<Order_By>;
  enrolment_status?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: absorb_enrolment */
export type Absorb_Enrolment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Absorb_Enrolment_Prepend_Input = {
  enrolment_information?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "absorb_enrolment" */
export enum Absorb_Enrolment_Select_Column {
  /** column name */
  AbsorbCertificateId = 'absorb_certificate_id',
  /** column name */
  CertificateAwarded = 'certificate_awarded',
  /** column name */
  CertificateAwardedDate = 'certificate_awarded_date',
  /** column name */
  CertificateExpiryDate = 'certificate_expiry_date',
  /** column name */
  EnrolmentDate = 'enrolment_date',
  /** column name */
  EnrolmentId = 'enrolment_id',
  /** column name */
  EnrolmentInformation = 'enrolment_information',
  /** column name */
  EnrolmentStatus = 'enrolment_status',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id'
}

/** input type for updating data in table "absorb_enrolment" */
export type Absorb_Enrolment_Set_Input = {
  absorb_certificate_id?: InputMaybe<Scalars['uuid']>;
  certificate_awarded?: InputMaybe<Scalars['Boolean']>;
  certificate_awarded_date?: InputMaybe<Scalars['date']>;
  certificate_expiry_date?: InputMaybe<Scalars['date']>;
  enrolment_date?: InputMaybe<Scalars['date']>;
  enrolment_id?: InputMaybe<Scalars['uuid']>;
  enrolment_information?: InputMaybe<Scalars['jsonb']>;
  enrolment_status?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "absorb_enrolment" */
export type Absorb_Enrolment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Absorb_Enrolment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Absorb_Enrolment_Stream_Cursor_Value_Input = {
  absorb_certificate_id?: InputMaybe<Scalars['uuid']>;
  certificate_awarded?: InputMaybe<Scalars['Boolean']>;
  certificate_awarded_date?: InputMaybe<Scalars['date']>;
  certificate_expiry_date?: InputMaybe<Scalars['date']>;
  enrolment_date?: InputMaybe<Scalars['date']>;
  enrolment_id?: InputMaybe<Scalars['uuid']>;
  enrolment_information?: InputMaybe<Scalars['jsonb']>;
  enrolment_status?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "absorb_enrolment" */
export enum Absorb_Enrolment_Update_Column {
  /** column name */
  AbsorbCertificateId = 'absorb_certificate_id',
  /** column name */
  CertificateAwarded = 'certificate_awarded',
  /** column name */
  CertificateAwardedDate = 'certificate_awarded_date',
  /** column name */
  CertificateExpiryDate = 'certificate_expiry_date',
  /** column name */
  EnrolmentDate = 'enrolment_date',
  /** column name */
  EnrolmentId = 'enrolment_id',
  /** column name */
  EnrolmentInformation = 'enrolment_information',
  /** column name */
  EnrolmentStatus = 'enrolment_status',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id'
}

export type Absorb_Enrolment_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Absorb_Enrolment_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Absorb_Enrolment_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Absorb_Enrolment_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Absorb_Enrolment_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Absorb_Enrolment_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Absorb_Enrolment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Absorb_Enrolment_Bool_Exp;
};

/** columns and relationships of "accreditors" */
export type Accreditors = {
  __typename?: 'accreditors';
  name: Scalars['String'];
};

/** aggregated selection of "accreditors" */
export type Accreditors_Aggregate = {
  __typename?: 'accreditors_aggregate';
  aggregate?: Maybe<Accreditors_Aggregate_Fields>;
  nodes: Array<Accreditors>;
};

/** aggregate fields of "accreditors" */
export type Accreditors_Aggregate_Fields = {
  __typename?: 'accreditors_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Accreditors_Max_Fields>;
  min?: Maybe<Accreditors_Min_Fields>;
};


/** aggregate fields of "accreditors" */
export type Accreditors_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Accreditors_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "accreditors". All fields are combined with a logical 'AND'. */
export type Accreditors_Bool_Exp = {
  _and?: InputMaybe<Array<Accreditors_Bool_Exp>>;
  _not?: InputMaybe<Accreditors_Bool_Exp>;
  _or?: InputMaybe<Array<Accreditors_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "accreditors" */
export enum Accreditors_Constraint {
  /** unique or primary key constraint on columns "name" */
  AccreditorsNameKey = 'accreditors_name_key',
  /** unique or primary key constraint on columns "name" */
  AccreditorsPkey = 'accreditors_pkey'
}

export enum Accreditors_Enum {
  Bild = 'BILD',
  Icm = 'ICM',
  NoAccreditation = 'NO_ACCREDITATION'
}

/** Boolean expression to compare columns of type "accreditors_enum". All fields are combined with logical 'AND'. */
export type Accreditors_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Accreditors_Enum>;
  _in?: InputMaybe<Array<Accreditors_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Accreditors_Enum>;
  _nin?: InputMaybe<Array<Accreditors_Enum>>;
};

/** input type for inserting data into table "accreditors" */
export type Accreditors_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Accreditors_Max_Fields = {
  __typename?: 'accreditors_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Accreditors_Min_Fields = {
  __typename?: 'accreditors_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "accreditors" */
export type Accreditors_Mutation_Response = {
  __typename?: 'accreditors_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Accreditors>;
};

/** on_conflict condition type for table "accreditors" */
export type Accreditors_On_Conflict = {
  constraint: Accreditors_Constraint;
  update_columns?: Array<Accreditors_Update_Column>;
  where?: InputMaybe<Accreditors_Bool_Exp>;
};

/** Ordering options when selecting data from "accreditors". */
export type Accreditors_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: accreditors */
export type Accreditors_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "accreditors" */
export enum Accreditors_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "accreditors" */
export type Accreditors_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "accreditors" */
export type Accreditors_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Accreditors_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Accreditors_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "accreditors" */
export enum Accreditors_Update_Column {
  /** column name */
  Name = 'name'
}

export type Accreditors_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Accreditors_Set_Input>;
  /** filter the rows which have to be updated */
  where: Accreditors_Bool_Exp;
};

/** columns and relationships of "availability" */
export type Availability = {
  __typename?: 'availability';
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  end: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  profile: Profile;
  profileId: Scalars['uuid'];
  start: Scalars['timestamptz'];
  type: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "availability" */
export type Availability_Aggregate = {
  __typename?: 'availability_aggregate';
  aggregate?: Maybe<Availability_Aggregate_Fields>;
  nodes: Array<Availability>;
};

/** aggregate fields of "availability" */
export type Availability_Aggregate_Fields = {
  __typename?: 'availability_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Availability_Max_Fields>;
  min?: Maybe<Availability_Min_Fields>;
};


/** aggregate fields of "availability" */
export type Availability_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Availability_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "availability". All fields are combined with a logical 'AND'. */
export type Availability_Bool_Exp = {
  _and?: InputMaybe<Array<Availability_Bool_Exp>>;
  _not?: InputMaybe<Availability_Bool_Exp>;
  _or?: InputMaybe<Array<Availability_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  end?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profileId?: InputMaybe<Uuid_Comparison_Exp>;
  start?: InputMaybe<Timestamptz_Comparison_Exp>;
  type?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "availability" */
export enum Availability_Constraint {
  /** unique or primary key constraint on columns "id" */
  AvailabilityPkey = 'availability_pkey'
}

/** input type for inserting data into table "availability" */
export type Availability_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profileId?: InputMaybe<Scalars['uuid']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Availability_Max_Fields = {
  __typename?: 'availability_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  profileId?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Availability_Min_Fields = {
  __typename?: 'availability_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  profileId?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  type?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "availability" */
export type Availability_Mutation_Response = {
  __typename?: 'availability_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Availability>;
};

/** on_conflict condition type for table "availability" */
export type Availability_On_Conflict = {
  constraint: Availability_Constraint;
  update_columns?: Array<Availability_Update_Column>;
  where?: InputMaybe<Availability_Bool_Exp>;
};

/** Ordering options when selecting data from "availability". */
export type Availability_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profileId?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: availability */
export type Availability_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "availability" */
export enum Availability_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  Start = 'start',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "availability" */
export type Availability_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "availability" */
export type Availability_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Availability_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Availability_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  type?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "availability" */
export enum Availability_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  Start = 'start',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Availability_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Availability_Set_Input>;
  /** filter the rows which have to be updated */
  where: Availability_Bool_Exp;
};

/** columns and relationships of "bild_strategy" */
export type Bild_Strategy = {
  __typename?: 'bild_strategy';
  duration?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  modules: Scalars['jsonb'];
  name: Scalars['String'];
  shortName: Scalars['String'];
  sort?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "bild_strategy" */
export type Bild_StrategyModulesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "bild_strategy" */
export type Bild_Strategy_Aggregate = {
  __typename?: 'bild_strategy_aggregate';
  aggregate?: Maybe<Bild_Strategy_Aggregate_Fields>;
  nodes: Array<Bild_Strategy>;
};

/** aggregate fields of "bild_strategy" */
export type Bild_Strategy_Aggregate_Fields = {
  __typename?: 'bild_strategy_aggregate_fields';
  avg?: Maybe<Bild_Strategy_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Bild_Strategy_Max_Fields>;
  min?: Maybe<Bild_Strategy_Min_Fields>;
  stddev?: Maybe<Bild_Strategy_Stddev_Fields>;
  stddev_pop?: Maybe<Bild_Strategy_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Bild_Strategy_Stddev_Samp_Fields>;
  sum?: Maybe<Bild_Strategy_Sum_Fields>;
  var_pop?: Maybe<Bild_Strategy_Var_Pop_Fields>;
  var_samp?: Maybe<Bild_Strategy_Var_Samp_Fields>;
  variance?: Maybe<Bild_Strategy_Variance_Fields>;
};


/** aggregate fields of "bild_strategy" */
export type Bild_Strategy_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Bild_Strategy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Bild_Strategy_Append_Input = {
  modules?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Bild_Strategy_Avg_Fields = {
  __typename?: 'bild_strategy_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "bild_strategy". All fields are combined with a logical 'AND'. */
export type Bild_Strategy_Bool_Exp = {
  _and?: InputMaybe<Array<Bild_Strategy_Bool_Exp>>;
  _not?: InputMaybe<Bild_Strategy_Bool_Exp>;
  _or?: InputMaybe<Array<Bild_Strategy_Bool_Exp>>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  modules?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  shortName?: InputMaybe<String_Comparison_Exp>;
  sort?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "bild_strategy" */
export enum Bild_Strategy_Constraint {
  /** unique or primary key constraint on columns "name" */
  BildStrategyNameKey = 'bild_strategy_name_key',
  /** unique or primary key constraint on columns "id" */
  BildStrategyPkey = 'bild_strategy_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Bild_Strategy_Delete_At_Path_Input = {
  modules?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Bild_Strategy_Delete_Elem_Input = {
  modules?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Bild_Strategy_Delete_Key_Input = {
  modules?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "bild_strategy" */
export type Bild_Strategy_Inc_Input = {
  duration?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "bild_strategy" */
export type Bild_Strategy_Insert_Input = {
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  modules?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Bild_Strategy_Max_Fields = {
  __typename?: 'bild_strategy_max_fields';
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Bild_Strategy_Min_Fields = {
  __typename?: 'bild_strategy_min_fields';
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  shortName?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "bild_strategy" */
export type Bild_Strategy_Mutation_Response = {
  __typename?: 'bild_strategy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Bild_Strategy>;
};

/** on_conflict condition type for table "bild_strategy" */
export type Bild_Strategy_On_Conflict = {
  constraint: Bild_Strategy_Constraint;
  update_columns?: Array<Bild_Strategy_Update_Column>;
  where?: InputMaybe<Bild_Strategy_Bool_Exp>;
};

/** Ordering options when selecting data from "bild_strategy". */
export type Bild_Strategy_Order_By = {
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modules?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  shortName?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** primary key columns input for table: bild_strategy */
export type Bild_Strategy_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Bild_Strategy_Prepend_Input = {
  modules?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "bild_strategy" */
export enum Bild_Strategy_Select_Column {
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  Modules = 'modules',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Sort = 'sort'
}

/** input type for updating data in table "bild_strategy" */
export type Bild_Strategy_Set_Input = {
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  modules?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Bild_Strategy_Stddev_Fields = {
  __typename?: 'bild_strategy_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Bild_Strategy_Stddev_Pop_Fields = {
  __typename?: 'bild_strategy_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Bild_Strategy_Stddev_Samp_Fields = {
  __typename?: 'bild_strategy_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "bild_strategy" */
export type Bild_Strategy_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Bild_Strategy_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Bild_Strategy_Stream_Cursor_Value_Input = {
  duration?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  modules?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  shortName?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Bild_Strategy_Sum_Fields = {
  __typename?: 'bild_strategy_sum_fields';
  duration?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
};

/** update columns of table "bild_strategy" */
export enum Bild_Strategy_Update_Column {
  /** column name */
  Duration = 'duration',
  /** column name */
  Id = 'id',
  /** column name */
  Modules = 'modules',
  /** column name */
  Name = 'name',
  /** column name */
  ShortName = 'shortName',
  /** column name */
  Sort = 'sort'
}

export type Bild_Strategy_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Bild_Strategy_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Bild_Strategy_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Bild_Strategy_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Bild_Strategy_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Bild_Strategy_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Bild_Strategy_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Bild_Strategy_Set_Input>;
  /** filter the rows which have to be updated */
  where: Bild_Strategy_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Bild_Strategy_Var_Pop_Fields = {
  __typename?: 'bild_strategy_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Bild_Strategy_Var_Samp_Fields = {
  __typename?: 'bild_strategy_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Bild_Strategy_Variance_Fields = {
  __typename?: 'bild_strategy_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** status enum for go1 course/module */
export type Blended_Learning_Status = {
  __typename?: 'blended_learning_status';
  name: Scalars['String'];
};

/** aggregated selection of "blended_learning_status" */
export type Blended_Learning_Status_Aggregate = {
  __typename?: 'blended_learning_status_aggregate';
  aggregate?: Maybe<Blended_Learning_Status_Aggregate_Fields>;
  nodes: Array<Blended_Learning_Status>;
};

/** aggregate fields of "blended_learning_status" */
export type Blended_Learning_Status_Aggregate_Fields = {
  __typename?: 'blended_learning_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Blended_Learning_Status_Max_Fields>;
  min?: Maybe<Blended_Learning_Status_Min_Fields>;
};


/** aggregate fields of "blended_learning_status" */
export type Blended_Learning_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Blended_Learning_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "blended_learning_status". All fields are combined with a logical 'AND'. */
export type Blended_Learning_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Blended_Learning_Status_Bool_Exp>>;
  _not?: InputMaybe<Blended_Learning_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Blended_Learning_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "blended_learning_status" */
export enum Blended_Learning_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  BlendedLearningStatusPkey = 'blended_learning_status_pkey'
}

export enum Blended_Learning_Status_Enum {
  Assigned = 'ASSIGNED',
  Completed = 'COMPLETED',
  InProgress = 'IN_PROGRESS',
  NotStarted = 'NOT_STARTED'
}

/** Boolean expression to compare columns of type "blended_learning_status_enum". All fields are combined with logical 'AND'. */
export type Blended_Learning_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Blended_Learning_Status_Enum>;
  _in?: InputMaybe<Array<Blended_Learning_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Blended_Learning_Status_Enum>;
  _nin?: InputMaybe<Array<Blended_Learning_Status_Enum>>;
};

/** input type for inserting data into table "blended_learning_status" */
export type Blended_Learning_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Blended_Learning_Status_Max_Fields = {
  __typename?: 'blended_learning_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Blended_Learning_Status_Min_Fields = {
  __typename?: 'blended_learning_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "blended_learning_status" */
export type Blended_Learning_Status_Mutation_Response = {
  __typename?: 'blended_learning_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Blended_Learning_Status>;
};

/** on_conflict condition type for table "blended_learning_status" */
export type Blended_Learning_Status_On_Conflict = {
  constraint: Blended_Learning_Status_Constraint;
  update_columns?: Array<Blended_Learning_Status_Update_Column>;
  where?: InputMaybe<Blended_Learning_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "blended_learning_status". */
export type Blended_Learning_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: blended_learning_status */
export type Blended_Learning_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "blended_learning_status" */
export enum Blended_Learning_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "blended_learning_status" */
export type Blended_Learning_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "blended_learning_status" */
export type Blended_Learning_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Blended_Learning_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Blended_Learning_Status_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "blended_learning_status" */
export enum Blended_Learning_Status_Update_Column {
  /** column name */
  Name = 'name'
}

export type Blended_Learning_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Blended_Learning_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Blended_Learning_Status_Bool_Exp;
};

/** columns and relationships of "certificate_expired_notification_jobs" */
export type Certificate_Expired_Notification_Jobs = {
  __typename?: 'certificate_expired_notification_jobs';
  course_certificate_id: Scalars['uuid'];
  id: Scalars['uuid'];
  job_id: Scalars['uuid'];
};

/** aggregated selection of "certificate_expired_notification_jobs" */
export type Certificate_Expired_Notification_Jobs_Aggregate = {
  __typename?: 'certificate_expired_notification_jobs_aggregate';
  aggregate?: Maybe<Certificate_Expired_Notification_Jobs_Aggregate_Fields>;
  nodes: Array<Certificate_Expired_Notification_Jobs>;
};

/** aggregate fields of "certificate_expired_notification_jobs" */
export type Certificate_Expired_Notification_Jobs_Aggregate_Fields = {
  __typename?: 'certificate_expired_notification_jobs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Certificate_Expired_Notification_Jobs_Max_Fields>;
  min?: Maybe<Certificate_Expired_Notification_Jobs_Min_Fields>;
};


/** aggregate fields of "certificate_expired_notification_jobs" */
export type Certificate_Expired_Notification_Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Certificate_Expired_Notification_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "certificate_expired_notification_jobs". All fields are combined with a logical 'AND'. */
export type Certificate_Expired_Notification_Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Certificate_Expired_Notification_Jobs_Bool_Exp>>;
  _not?: InputMaybe<Certificate_Expired_Notification_Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Certificate_Expired_Notification_Jobs_Bool_Exp>>;
  course_certificate_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "certificate_expired_notification_jobs" */
export enum Certificate_Expired_Notification_Jobs_Constraint {
  /** unique or primary key constraint on columns "job_id", "course_certificate_id" */
  CertificateExpiredNotificatiCourseCertificateIdJobIdKey = 'certificate_expired_notificati_course_certificate_id_job_id_key',
  /** unique or primary key constraint on columns "id" */
  CertificateExpiredNotificationJobsPkey = 'certificate_expired_notification_jobs_pkey'
}

/** input type for inserting data into table "certificate_expired_notification_jobs" */
export type Certificate_Expired_Notification_Jobs_Insert_Input = {
  course_certificate_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Certificate_Expired_Notification_Jobs_Max_Fields = {
  __typename?: 'certificate_expired_notification_jobs_max_fields';
  course_certificate_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  job_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Certificate_Expired_Notification_Jobs_Min_Fields = {
  __typename?: 'certificate_expired_notification_jobs_min_fields';
  course_certificate_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  job_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "certificate_expired_notification_jobs" */
export type Certificate_Expired_Notification_Jobs_Mutation_Response = {
  __typename?: 'certificate_expired_notification_jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Certificate_Expired_Notification_Jobs>;
};

/** on_conflict condition type for table "certificate_expired_notification_jobs" */
export type Certificate_Expired_Notification_Jobs_On_Conflict = {
  constraint: Certificate_Expired_Notification_Jobs_Constraint;
  update_columns?: Array<Certificate_Expired_Notification_Jobs_Update_Column>;
  where?: InputMaybe<Certificate_Expired_Notification_Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "certificate_expired_notification_jobs". */
export type Certificate_Expired_Notification_Jobs_Order_By = {
  course_certificate_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: certificate_expired_notification_jobs */
export type Certificate_Expired_Notification_Jobs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "certificate_expired_notification_jobs" */
export enum Certificate_Expired_Notification_Jobs_Select_Column {
  /** column name */
  CourseCertificateId = 'course_certificate_id',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id'
}

/** input type for updating data in table "certificate_expired_notification_jobs" */
export type Certificate_Expired_Notification_Jobs_Set_Input = {
  course_certificate_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "certificate_expired_notification_jobs" */
export type Certificate_Expired_Notification_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Certificate_Expired_Notification_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Certificate_Expired_Notification_Jobs_Stream_Cursor_Value_Input = {
  course_certificate_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "certificate_expired_notification_jobs" */
export enum Certificate_Expired_Notification_Jobs_Update_Column {
  /** column name */
  CourseCertificateId = 'course_certificate_id',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id'
}

export type Certificate_Expired_Notification_Jobs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Certificate_Expired_Notification_Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Certificate_Expired_Notification_Jobs_Bool_Exp;
};

/** Stores scheduled jobs ids for the certificate expiry notification */
export type Certificate_Expiry_Notification_Jobs = {
  __typename?: 'certificate_expiry_notification_jobs';
  course_certificate_id: Scalars['uuid'];
  id: Scalars['uuid'];
  job_id: Scalars['uuid'];
  timeframe: Certificate_Expiry_Notification_Timeframe_Enum;
};

/** aggregated selection of "certificate_expiry_notification_jobs" */
export type Certificate_Expiry_Notification_Jobs_Aggregate = {
  __typename?: 'certificate_expiry_notification_jobs_aggregate';
  aggregate?: Maybe<Certificate_Expiry_Notification_Jobs_Aggregate_Fields>;
  nodes: Array<Certificate_Expiry_Notification_Jobs>;
};

/** aggregate fields of "certificate_expiry_notification_jobs" */
export type Certificate_Expiry_Notification_Jobs_Aggregate_Fields = {
  __typename?: 'certificate_expiry_notification_jobs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Certificate_Expiry_Notification_Jobs_Max_Fields>;
  min?: Maybe<Certificate_Expiry_Notification_Jobs_Min_Fields>;
};


/** aggregate fields of "certificate_expiry_notification_jobs" */
export type Certificate_Expiry_Notification_Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Certificate_Expiry_Notification_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "certificate_expiry_notification_jobs". All fields are combined with a logical 'AND'. */
export type Certificate_Expiry_Notification_Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Certificate_Expiry_Notification_Jobs_Bool_Exp>>;
  _not?: InputMaybe<Certificate_Expiry_Notification_Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Certificate_Expiry_Notification_Jobs_Bool_Exp>>;
  course_certificate_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job_id?: InputMaybe<Uuid_Comparison_Exp>;
  timeframe?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "certificate_expiry_notification_jobs" */
export enum Certificate_Expiry_Notification_Jobs_Constraint {
  /** unique or primary key constraint on columns "job_id", "timeframe", "course_certificate_id" */
  CertificateExpiryNotificatiCourseCertificateIdJobIdKey = 'certificate_expiry_notificati_course_certificate_id_job_id__key',
  /** unique or primary key constraint on columns "id" */
  CertificateExpiryNotificationJobsPkey = 'certificate_expiry_notification_jobs_pkey'
}

/** input type for inserting data into table "certificate_expiry_notification_jobs" */
export type Certificate_Expiry_Notification_Jobs_Insert_Input = {
  course_certificate_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
  timeframe?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Enum>;
};

/** aggregate max on columns */
export type Certificate_Expiry_Notification_Jobs_Max_Fields = {
  __typename?: 'certificate_expiry_notification_jobs_max_fields';
  course_certificate_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  job_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Certificate_Expiry_Notification_Jobs_Min_Fields = {
  __typename?: 'certificate_expiry_notification_jobs_min_fields';
  course_certificate_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  job_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "certificate_expiry_notification_jobs" */
export type Certificate_Expiry_Notification_Jobs_Mutation_Response = {
  __typename?: 'certificate_expiry_notification_jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Certificate_Expiry_Notification_Jobs>;
};

/** on_conflict condition type for table "certificate_expiry_notification_jobs" */
export type Certificate_Expiry_Notification_Jobs_On_Conflict = {
  constraint: Certificate_Expiry_Notification_Jobs_Constraint;
  update_columns?: Array<Certificate_Expiry_Notification_Jobs_Update_Column>;
  where?: InputMaybe<Certificate_Expiry_Notification_Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "certificate_expiry_notification_jobs". */
export type Certificate_Expiry_Notification_Jobs_Order_By = {
  course_certificate_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
  timeframe?: InputMaybe<Order_By>;
};

/** primary key columns input for table: certificate_expiry_notification_jobs */
export type Certificate_Expiry_Notification_Jobs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "certificate_expiry_notification_jobs" */
export enum Certificate_Expiry_Notification_Jobs_Select_Column {
  /** column name */
  CourseCertificateId = 'course_certificate_id',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id',
  /** column name */
  Timeframe = 'timeframe'
}

/** input type for updating data in table "certificate_expiry_notification_jobs" */
export type Certificate_Expiry_Notification_Jobs_Set_Input = {
  course_certificate_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
  timeframe?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Enum>;
};

/** Streaming cursor of the table "certificate_expiry_notification_jobs" */
export type Certificate_Expiry_Notification_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Certificate_Expiry_Notification_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Certificate_Expiry_Notification_Jobs_Stream_Cursor_Value_Input = {
  course_certificate_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
  timeframe?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Enum>;
};

/** update columns of table "certificate_expiry_notification_jobs" */
export enum Certificate_Expiry_Notification_Jobs_Update_Column {
  /** column name */
  CourseCertificateId = 'course_certificate_id',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id',
  /** column name */
  Timeframe = 'timeframe'
}

export type Certificate_Expiry_Notification_Jobs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Certificate_Expiry_Notification_Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Certificate_Expiry_Notification_Jobs_Bool_Exp;
};

/** Timeframe of the notification sent to the user about an expiring certificate */
export type Certificate_Expiry_Notification_Timeframe = {
  __typename?: 'certificate_expiry_notification_timeframe';
  name: Scalars['String'];
};

/** aggregated selection of "certificate_expiry_notification_timeframe" */
export type Certificate_Expiry_Notification_Timeframe_Aggregate = {
  __typename?: 'certificate_expiry_notification_timeframe_aggregate';
  aggregate?: Maybe<Certificate_Expiry_Notification_Timeframe_Aggregate_Fields>;
  nodes: Array<Certificate_Expiry_Notification_Timeframe>;
};

/** aggregate fields of "certificate_expiry_notification_timeframe" */
export type Certificate_Expiry_Notification_Timeframe_Aggregate_Fields = {
  __typename?: 'certificate_expiry_notification_timeframe_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Certificate_Expiry_Notification_Timeframe_Max_Fields>;
  min?: Maybe<Certificate_Expiry_Notification_Timeframe_Min_Fields>;
};


/** aggregate fields of "certificate_expiry_notification_timeframe" */
export type Certificate_Expiry_Notification_Timeframe_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "certificate_expiry_notification_timeframe". All fields are combined with a logical 'AND'. */
export type Certificate_Expiry_Notification_Timeframe_Bool_Exp = {
  _and?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Bool_Exp>>;
  _not?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Bool_Exp>;
  _or?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "certificate_expiry_notification_timeframe" */
export enum Certificate_Expiry_Notification_Timeframe_Constraint {
  /** unique or primary key constraint on columns "name" */
  CertificateExpiryNotificationTimeframePkey = 'certificate_expiry_notification_timeframe_pkey'
}

export enum Certificate_Expiry_Notification_Timeframe_Enum {
  OneMonth = 'ONE_MONTH',
  SixMonths = 'SIX_MONTHS',
  ThreeMonths = 'THREE_MONTHS',
  TwelveMonths = 'TWELVE_MONTHS'
}

/** Boolean expression to compare columns of type "certificate_expiry_notification_timeframe_enum". All fields are combined with logical 'AND'. */
export type Certificate_Expiry_Notification_Timeframe_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Enum>;
  _in?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Enum>;
  _nin?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Enum>>;
};

/** input type for inserting data into table "certificate_expiry_notification_timeframe" */
export type Certificate_Expiry_Notification_Timeframe_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Certificate_Expiry_Notification_Timeframe_Max_Fields = {
  __typename?: 'certificate_expiry_notification_timeframe_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Certificate_Expiry_Notification_Timeframe_Min_Fields = {
  __typename?: 'certificate_expiry_notification_timeframe_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "certificate_expiry_notification_timeframe" */
export type Certificate_Expiry_Notification_Timeframe_Mutation_Response = {
  __typename?: 'certificate_expiry_notification_timeframe_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Certificate_Expiry_Notification_Timeframe>;
};

/** on_conflict condition type for table "certificate_expiry_notification_timeframe" */
export type Certificate_Expiry_Notification_Timeframe_On_Conflict = {
  constraint: Certificate_Expiry_Notification_Timeframe_Constraint;
  update_columns?: Array<Certificate_Expiry_Notification_Timeframe_Update_Column>;
  where?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Bool_Exp>;
};

/** Ordering options when selecting data from "certificate_expiry_notification_timeframe". */
export type Certificate_Expiry_Notification_Timeframe_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: certificate_expiry_notification_timeframe */
export type Certificate_Expiry_Notification_Timeframe_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "certificate_expiry_notification_timeframe" */
export enum Certificate_Expiry_Notification_Timeframe_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "certificate_expiry_notification_timeframe" */
export type Certificate_Expiry_Notification_Timeframe_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "certificate_expiry_notification_timeframe" */
export type Certificate_Expiry_Notification_Timeframe_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Certificate_Expiry_Notification_Timeframe_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Certificate_Expiry_Notification_Timeframe_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "certificate_expiry_notification_timeframe" */
export enum Certificate_Expiry_Notification_Timeframe_Update_Column {
  /** column name */
  Name = 'name'
}

export type Certificate_Expiry_Notification_Timeframe_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Set_Input>;
  /** filter the rows which have to be updated */
  where: Certificate_Expiry_Notification_Timeframe_Bool_Exp;
};

/** columns and relationships of "certificate_status" */
export type Certificate_Status = {
  __typename?: 'certificate_status';
  name: Scalars['String'];
};

/** aggregated selection of "certificate_status" */
export type Certificate_Status_Aggregate = {
  __typename?: 'certificate_status_aggregate';
  aggregate?: Maybe<Certificate_Status_Aggregate_Fields>;
  nodes: Array<Certificate_Status>;
};

/** aggregate fields of "certificate_status" */
export type Certificate_Status_Aggregate_Fields = {
  __typename?: 'certificate_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Certificate_Status_Max_Fields>;
  min?: Maybe<Certificate_Status_Min_Fields>;
};


/** aggregate fields of "certificate_status" */
export type Certificate_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Certificate_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "certificate_status". All fields are combined with a logical 'AND'. */
export type Certificate_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Certificate_Status_Bool_Exp>>;
  _not?: InputMaybe<Certificate_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Certificate_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "certificate_status" */
export enum Certificate_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  CertificateStatusPkey = 'certificate_status_pkey'
}

export enum Certificate_Status_Enum {
  Active = 'ACTIVE',
  Expired = 'EXPIRED',
  ExpiredRecently = 'EXPIRED_RECENTLY',
  ExpiringSoon = 'EXPIRING_SOON',
  Inactive = 'INACTIVE',
  OnHold = 'ON_HOLD',
  Revoked = 'REVOKED'
}

/** Boolean expression to compare columns of type "certificate_status_enum". All fields are combined with logical 'AND'. */
export type Certificate_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Certificate_Status_Enum>;
  _in?: InputMaybe<Array<Certificate_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Certificate_Status_Enum>;
  _nin?: InputMaybe<Array<Certificate_Status_Enum>>;
};

/** input type for inserting data into table "certificate_status" */
export type Certificate_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Certificate_Status_Max_Fields = {
  __typename?: 'certificate_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Certificate_Status_Min_Fields = {
  __typename?: 'certificate_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "certificate_status" */
export type Certificate_Status_Mutation_Response = {
  __typename?: 'certificate_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Certificate_Status>;
};

/** on_conflict condition type for table "certificate_status" */
export type Certificate_Status_On_Conflict = {
  constraint: Certificate_Status_Constraint;
  update_columns?: Array<Certificate_Status_Update_Column>;
  where?: InputMaybe<Certificate_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "certificate_status". */
export type Certificate_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: certificate_status */
export type Certificate_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "certificate_status" */
export enum Certificate_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "certificate_status" */
export type Certificate_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "certificate_status" */
export type Certificate_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Certificate_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Certificate_Status_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "certificate_status" */
export enum Certificate_Status_Update_Column {
  /** column name */
  Name = 'name'
}

export type Certificate_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Certificate_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Certificate_Status_Bool_Exp;
};

/** columns and relationships of "color" */
export type Color = {
  __typename?: 'color';
  name: Scalars['String'];
};

/** aggregated selection of "color" */
export type Color_Aggregate = {
  __typename?: 'color_aggregate';
  aggregate?: Maybe<Color_Aggregate_Fields>;
  nodes: Array<Color>;
};

/** aggregate fields of "color" */
export type Color_Aggregate_Fields = {
  __typename?: 'color_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Color_Max_Fields>;
  min?: Maybe<Color_Min_Fields>;
};


/** aggregate fields of "color" */
export type Color_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Color_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "color". All fields are combined with a logical 'AND'. */
export type Color_Bool_Exp = {
  _and?: InputMaybe<Array<Color_Bool_Exp>>;
  _not?: InputMaybe<Color_Bool_Exp>;
  _or?: InputMaybe<Array<Color_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "color" */
export enum Color_Constraint {
  /** unique or primary key constraint on columns "name" */
  ColorPkey = 'color_pkey'
}

export enum Color_Enum {
  Fuschia = 'fuschia',
  Grey = 'grey',
  Lime = 'lime',
  Navy = 'navy',
  Purple = 'purple',
  Teal = 'teal',
  Yellow = 'yellow'
}

/** Boolean expression to compare columns of type "color_enum". All fields are combined with logical 'AND'. */
export type Color_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Color_Enum>;
  _in?: InputMaybe<Array<Color_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Color_Enum>;
  _nin?: InputMaybe<Array<Color_Enum>>;
};

/** input type for inserting data into table "color" */
export type Color_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Color_Max_Fields = {
  __typename?: 'color_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Color_Min_Fields = {
  __typename?: 'color_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "color" */
export type Color_Mutation_Response = {
  __typename?: 'color_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Color>;
};

/** on_conflict condition type for table "color" */
export type Color_On_Conflict = {
  constraint: Color_Constraint;
  update_columns?: Array<Color_Update_Column>;
  where?: InputMaybe<Color_Bool_Exp>;
};

/** Ordering options when selecting data from "color". */
export type Color_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: color */
export type Color_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "color" */
export enum Color_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "color" */
export type Color_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "color" */
export type Color_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Color_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Color_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "color" */
export enum Color_Update_Column {
  /** column name */
  Name = 'name'
}

export type Color_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Color_Set_Input>;
  /** filter the rows which have to be updated */
  where: Color_Bool_Exp;
};

export type Consume_License_And_Log_Args = {
  p_course_id?: InputMaybe<Scalars['Int']>;
  p_event?: InputMaybe<Scalars['String']>;
  p_org_id?: InputMaybe<Scalars['uuid']>;
  p_payload?: InputMaybe<Scalars['jsonb']>;
  p_resource_pack_type?: InputMaybe<Scalars['String']>;
};

export type ContentRootMutation = {
  __typename?: 'contentRootMutation';
  /** The payload for the createCategory mutation */
  createCategory?: Maybe<CreateCategoryPayload>;
  /** The payload for the createComment mutation */
  createComment?: Maybe<CreateCommentPayload>;
  /** The payload for the createEbook mutation */
  createEbook?: Maybe<CreateEbookPayload>;
  /** The payload for the createEbooksCategory mutation */
  createEbooksCategory?: Maybe<CreateEbooksCategoryPayload>;
  /** The payload for the createMediaItem mutation */
  createMediaItem?: Maybe<CreateMediaItemPayload>;
  /** The payload for the createPage mutation */
  createPage?: Maybe<CreatePagePayload>;
  /** The payload for the createPost mutation */
  createPost?: Maybe<CreatePostPayload>;
  /** The payload for the createPostFormat mutation */
  createPostFormat?: Maybe<CreatePostFormatPayload>;
  /** The payload for the createResearchSummariesCategory mutation */
  createResearchSummariesCategory?: Maybe<CreateResearchSummariesCategoryPayload>;
  /** The payload for the createResearchSummary mutation */
  createResearchSummary?: Maybe<CreateResearchSummaryPayload>;
  /** The payload for the createResource mutation */
  createResource?: Maybe<CreateResourcePayload>;
  /** The payload for the createResourceCategory mutation */
  createResourceCategory?: Maybe<CreateResourceCategoryPayload>;
  /** The payload for the createTag mutation */
  createTag?: Maybe<CreateTagPayload>;
  /** The payload for the createUser mutation */
  createUser?: Maybe<CreateUserPayload>;
  /** The payload for the createVideoSeriesCategory mutation */
  createVideoSeriesCategory?: Maybe<CreateVideoSeriesCategoryPayload>;
  /** The payload for the createVideoSeriesItem mutation */
  createVideoSeriesItem?: Maybe<CreateVideoSeriesItemPayload>;
  /** The payload for the createWebinar mutation */
  createWebinar?: Maybe<CreateWebinarPayload>;
  /** The payload for the createWebinarsCategory mutation */
  createWebinarsCategory?: Maybe<CreateWebinarsCategoryPayload>;
  /** The payload for the deleteCategory mutation */
  deleteCategory?: Maybe<DeleteCategoryPayload>;
  /** The payload for the deleteComment mutation */
  deleteComment?: Maybe<DeleteCommentPayload>;
  /** The payload for the deleteEbook mutation */
  deleteEbook?: Maybe<DeleteEbookPayload>;
  /** The payload for the deleteEbooksCategory mutation */
  deleteEbooksCategory?: Maybe<DeleteEbooksCategoryPayload>;
  /** The payload for the deleteMediaItem mutation */
  deleteMediaItem?: Maybe<DeleteMediaItemPayload>;
  /** The payload for the deletePage mutation */
  deletePage?: Maybe<DeletePagePayload>;
  /** The payload for the deletePost mutation */
  deletePost?: Maybe<DeletePostPayload>;
  /** The payload for the deletePostFormat mutation */
  deletePostFormat?: Maybe<DeletePostFormatPayload>;
  /** The payload for the deleteResearchSummariesCategory mutation */
  deleteResearchSummariesCategory?: Maybe<DeleteResearchSummariesCategoryPayload>;
  /** The payload for the deleteResearchSummary mutation */
  deleteResearchSummary?: Maybe<DeleteResearchSummaryPayload>;
  /** The payload for the deleteResource mutation */
  deleteResource?: Maybe<DeleteResourcePayload>;
  /** The payload for the deleteResourceCategory mutation */
  deleteResourceCategory?: Maybe<DeleteResourceCategoryPayload>;
  /** The payload for the deleteTag mutation */
  deleteTag?: Maybe<DeleteTagPayload>;
  /** The payload for the deleteUser mutation */
  deleteUser?: Maybe<DeleteUserPayload>;
  /** The payload for the deleteVideoSeriesCategory mutation */
  deleteVideoSeriesCategory?: Maybe<DeleteVideoSeriesCategoryPayload>;
  /** The payload for the deleteVideoSeriesItem mutation */
  deleteVideoSeriesItem?: Maybe<DeleteVideoSeriesItemPayload>;
  /** The payload for the deleteWebinar mutation */
  deleteWebinar?: Maybe<DeleteWebinarPayload>;
  /** The payload for the deleteWebinarsCategory mutation */
  deleteWebinarsCategory?: Maybe<DeleteWebinarsCategoryPayload>;
  /** Increase the count. */
  increaseCount?: Maybe<Scalars['Int']>;
  /** The payload for the registerUser mutation */
  registerUser?: Maybe<RegisterUserPayload>;
  /** The payload for the resetUserPassword mutation */
  resetUserPassword?: Maybe<ResetUserPasswordPayload>;
  /** The payload for the restoreComment mutation */
  restoreComment?: Maybe<RestoreCommentPayload>;
  /** The payload for the sendPasswordResetEmail mutation */
  sendPasswordResetEmail?: Maybe<SendPasswordResetEmailPayload>;
  /** The payload for the UpdateCategory mutation */
  updateCategory?: Maybe<UpdateCategoryPayload>;
  /** The payload for the updateComment mutation */
  updateComment?: Maybe<UpdateCommentPayload>;
  /** The payload for the updateEbook mutation */
  updateEbook?: Maybe<UpdateEbookPayload>;
  /** The payload for the UpdateEbooksCategory mutation */
  updateEbooksCategory?: Maybe<UpdateEbooksCategoryPayload>;
  /** The payload for the updateMediaItem mutation */
  updateMediaItem?: Maybe<UpdateMediaItemPayload>;
  /** The payload for the updatePage mutation */
  updatePage?: Maybe<UpdatePagePayload>;
  /** The payload for the updatePost mutation */
  updatePost?: Maybe<UpdatePostPayload>;
  /** The payload for the UpdatePostFormat mutation */
  updatePostFormat?: Maybe<UpdatePostFormatPayload>;
  /** The payload for the UpdateResearchSummariesCategory mutation */
  updateResearchSummariesCategory?: Maybe<UpdateResearchSummariesCategoryPayload>;
  /** The payload for the updateResearchSummary mutation */
  updateResearchSummary?: Maybe<UpdateResearchSummaryPayload>;
  /** The payload for the updateResource mutation */
  updateResource?: Maybe<UpdateResourcePayload>;
  /** The payload for the UpdateResourceCategory mutation */
  updateResourceCategory?: Maybe<UpdateResourceCategoryPayload>;
  /** The payload for the updateSettings mutation */
  updateSettings?: Maybe<UpdateSettingsPayload>;
  /** The payload for the UpdateTag mutation */
  updateTag?: Maybe<UpdateTagPayload>;
  /** The payload for the updateUser mutation */
  updateUser?: Maybe<UpdateUserPayload>;
  /** The payload for the UpdateVideoSeriesCategory mutation */
  updateVideoSeriesCategory?: Maybe<UpdateVideoSeriesCategoryPayload>;
  /** The payload for the updateVideoSeriesItem mutation */
  updateVideoSeriesItem?: Maybe<UpdateVideoSeriesItemPayload>;
  /** The payload for the updateWebinar mutation */
  updateWebinar?: Maybe<UpdateWebinarPayload>;
  /** The payload for the UpdateWebinarsCategory mutation */
  updateWebinarsCategory?: Maybe<UpdateWebinarsCategoryPayload>;
};


export type ContentRootMutationCreateCategoryArgs = {
  input: CreateCategoryInput;
};


export type ContentRootMutationCreateCommentArgs = {
  input: CreateCommentInput;
};


export type ContentRootMutationCreateEbookArgs = {
  input: CreateEbookInput;
};


export type ContentRootMutationCreateEbooksCategoryArgs = {
  input: CreateEbooksCategoryInput;
};


export type ContentRootMutationCreateMediaItemArgs = {
  input: CreateMediaItemInput;
};


export type ContentRootMutationCreatePageArgs = {
  input: CreatePageInput;
};


export type ContentRootMutationCreatePostArgs = {
  input: CreatePostInput;
};


export type ContentRootMutationCreatePostFormatArgs = {
  input: CreatePostFormatInput;
};


export type ContentRootMutationCreateResearchSummariesCategoryArgs = {
  input: CreateResearchSummariesCategoryInput;
};


export type ContentRootMutationCreateResearchSummaryArgs = {
  input: CreateResearchSummaryInput;
};


export type ContentRootMutationCreateResourceArgs = {
  input: CreateResourceInput;
};


export type ContentRootMutationCreateResourceCategoryArgs = {
  input: CreateResourceCategoryInput;
};


export type ContentRootMutationCreateTagArgs = {
  input: CreateTagInput;
};


export type ContentRootMutationCreateUserArgs = {
  input: CreateUserInput;
};


export type ContentRootMutationCreateVideoSeriesCategoryArgs = {
  input: CreateVideoSeriesCategoryInput;
};


export type ContentRootMutationCreateVideoSeriesItemArgs = {
  input: CreateVideoSeriesItemInput;
};


export type ContentRootMutationCreateWebinarArgs = {
  input: CreateWebinarInput;
};


export type ContentRootMutationCreateWebinarsCategoryArgs = {
  input: CreateWebinarsCategoryInput;
};


export type ContentRootMutationDeleteCategoryArgs = {
  input: DeleteCategoryInput;
};


export type ContentRootMutationDeleteCommentArgs = {
  input: DeleteCommentInput;
};


export type ContentRootMutationDeleteEbookArgs = {
  input: DeleteEbookInput;
};


export type ContentRootMutationDeleteEbooksCategoryArgs = {
  input: DeleteEbooksCategoryInput;
};


export type ContentRootMutationDeleteMediaItemArgs = {
  input: DeleteMediaItemInput;
};


export type ContentRootMutationDeletePageArgs = {
  input: DeletePageInput;
};


export type ContentRootMutationDeletePostArgs = {
  input: DeletePostInput;
};


export type ContentRootMutationDeletePostFormatArgs = {
  input: DeletePostFormatInput;
};


export type ContentRootMutationDeleteResearchSummariesCategoryArgs = {
  input: DeleteResearchSummariesCategoryInput;
};


export type ContentRootMutationDeleteResearchSummaryArgs = {
  input: DeleteResearchSummaryInput;
};


export type ContentRootMutationDeleteResourceArgs = {
  input: DeleteResourceInput;
};


export type ContentRootMutationDeleteResourceCategoryArgs = {
  input: DeleteResourceCategoryInput;
};


export type ContentRootMutationDeleteTagArgs = {
  input: DeleteTagInput;
};


export type ContentRootMutationDeleteUserArgs = {
  input: DeleteUserInput;
};


export type ContentRootMutationDeleteVideoSeriesCategoryArgs = {
  input: DeleteVideoSeriesCategoryInput;
};


export type ContentRootMutationDeleteVideoSeriesItemArgs = {
  input: DeleteVideoSeriesItemInput;
};


export type ContentRootMutationDeleteWebinarArgs = {
  input: DeleteWebinarInput;
};


export type ContentRootMutationDeleteWebinarsCategoryArgs = {
  input: DeleteWebinarsCategoryInput;
};


export type ContentRootMutationIncreaseCountArgs = {
  count?: InputMaybe<Scalars['Int']>;
};


export type ContentRootMutationRegisterUserArgs = {
  input: RegisterUserInput;
};


export type ContentRootMutationResetUserPasswordArgs = {
  input: ResetUserPasswordInput;
};


export type ContentRootMutationRestoreCommentArgs = {
  input: RestoreCommentInput;
};


export type ContentRootMutationSendPasswordResetEmailArgs = {
  input: SendPasswordResetEmailInput;
};


export type ContentRootMutationUpdateCategoryArgs = {
  input: UpdateCategoryInput;
};


export type ContentRootMutationUpdateCommentArgs = {
  input: UpdateCommentInput;
};


export type ContentRootMutationUpdateEbookArgs = {
  input: UpdateEbookInput;
};


export type ContentRootMutationUpdateEbooksCategoryArgs = {
  input: UpdateEbooksCategoryInput;
};


export type ContentRootMutationUpdateMediaItemArgs = {
  input: UpdateMediaItemInput;
};


export type ContentRootMutationUpdatePageArgs = {
  input: UpdatePageInput;
};


export type ContentRootMutationUpdatePostArgs = {
  input: UpdatePostInput;
};


export type ContentRootMutationUpdatePostFormatArgs = {
  input: UpdatePostFormatInput;
};


export type ContentRootMutationUpdateResearchSummariesCategoryArgs = {
  input: UpdateResearchSummariesCategoryInput;
};


export type ContentRootMutationUpdateResearchSummaryArgs = {
  input: UpdateResearchSummaryInput;
};


export type ContentRootMutationUpdateResourceArgs = {
  input: UpdateResourceInput;
};


export type ContentRootMutationUpdateResourceCategoryArgs = {
  input: UpdateResourceCategoryInput;
};


export type ContentRootMutationUpdateSettingsArgs = {
  input: UpdateSettingsInput;
};


export type ContentRootMutationUpdateTagArgs = {
  input: UpdateTagInput;
};


export type ContentRootMutationUpdateUserArgs = {
  input: UpdateUserInput;
};


export type ContentRootMutationUpdateVideoSeriesCategoryArgs = {
  input: UpdateVideoSeriesCategoryInput;
};


export type ContentRootMutationUpdateVideoSeriesItemArgs = {
  input: UpdateVideoSeriesItemInput;
};


export type ContentRootMutationUpdateWebinarArgs = {
  input: UpdateWebinarInput;
};


export type ContentRootMutationUpdateWebinarsCategoryArgs = {
  input: UpdateWebinarsCategoryInput;
};

export type ContentRootQuery = {
  __typename?: 'contentRootQuery';
  /** Entry point to get all settings for the site */
  allSettings?: Maybe<Settings>;
  /** Connection between the RootQuery type and the category type */
  categories?: Maybe<RootQueryToCategoryConnection>;
  /** A 0bject */
  category?: Maybe<Category>;
  /** Returns a Comment */
  comment?: Maybe<Comment>;
  /** Connection between the RootQuery type and the Comment type */
  comments?: Maybe<RootQueryToCommentConnection>;
  /** A node used to manage content */
  contentNode?: Maybe<ContentNode>;
  /** Connection between the RootQuery type and the ContentNode type */
  contentNodes?: Maybe<RootQueryToContentNodeConnection>;
  /** Fetch a Content Type node by unique Identifier */
  contentType?: Maybe<ContentType>;
  /** Connection between the RootQuery type and the ContentType type */
  contentTypes?: Maybe<RootQueryToContentTypeConnection>;
  /** Fields of the &#039;DiscussionSettings&#039; settings group */
  discussionSettings?: Maybe<DiscussionSettings>;
  /** An object of the Ebook Type.  */
  ebook?: Maybe<Ebook>;
  /** A Ebook object */
  ebookBy?: Maybe<Ebook>;
  /** Connection between the RootQuery type and the Ebook type */
  ebooks?: Maybe<RootQueryToEbookConnection>;
  /** Connection between the RootQuery type and the EbooksCategory type */
  ebooksCategories?: Maybe<RootQueryToEbooksCategoryConnection>;
  /** A 0bject */
  ebooksCategory?: Maybe<EbooksCategory>;
  /** Fields of the &#039;GeneralSettings&#039; settings group */
  generalSettings?: Maybe<GeneralSettings>;
  /** An object of the mediaItem Type.  */
  mediaItem?: Maybe<MediaItem>;
  /** A mediaItem object */
  mediaItemBy?: Maybe<MediaItem>;
  /** Connection between the RootQuery type and the mediaItem type */
  mediaItems?: Maybe<RootQueryToMediaItemConnection>;
  /** A WordPress navigation menu */
  menu?: Maybe<Menu>;
  /** A WordPress navigation menu item */
  menuItem?: Maybe<MenuItem>;
  /** Connection between the RootQuery type and the MenuItem type */
  menuItems?: Maybe<RootQueryToMenuItemConnection>;
  /** Connection between the RootQuery type and the Menu type */
  menus?: Maybe<RootQueryToMenuConnection>;
  /** Fetches an object given its ID */
  node?: Maybe<Node>;
  /** Fetches an object given its Unique Resource Identifier */
  nodeByUri?: Maybe<UniformResourceIdentifiable>;
  /** An object of the page Type.  */
  page?: Maybe<Page>;
  /** A page object */
  pageBy?: Maybe<Page>;
  /** Connection between the RootQuery type and the page type */
  pages?: Maybe<RootQueryToPageConnection>;
  /** A WordPress plugin */
  plugin?: Maybe<Plugin>;
  /** Connection between the RootQuery type and the Plugin type */
  plugins?: Maybe<RootQueryToPluginConnection>;
  /** An object of the post Type.  */
  post?: Maybe<Post>;
  /** A post object */
  postBy?: Maybe<Post>;
  /** A 0bject */
  postFormat?: Maybe<PostFormat>;
  /** Connection between the RootQuery type and the postFormat type */
  postFormats?: Maybe<RootQueryToPostFormatConnection>;
  /** Connection between the RootQuery type and the post type */
  posts?: Maybe<RootQueryToPostConnection>;
  /** Fields of the &#039;ReadingSettings&#039; settings group */
  readingSettings?: Maybe<ReadingSettings>;
  /** Connection between the RootQuery type and the EnqueuedScript type */
  registeredScripts?: Maybe<RootQueryToEnqueuedScriptConnection>;
  /** Connection between the RootQuery type and the EnqueuedStylesheet type */
  registeredStylesheets?: Maybe<RootQueryToEnqueuedStylesheetConnection>;
  /** Connection between the RootQuery type and the ResearchSummary type */
  researchSummaries?: Maybe<RootQueryToResearchSummaryConnection>;
  /** Connection between the RootQuery type and the ResearchSummariesCategory type */
  researchSummariesCategories?: Maybe<RootQueryToResearchSummariesCategoryConnection>;
  /** A 0bject */
  researchSummariesCategory?: Maybe<ResearchSummariesCategory>;
  /** An object of the ResearchSummary Type.  */
  researchSummary?: Maybe<ResearchSummary>;
  /** A ResearchSummary object */
  researchSummaryBy?: Maybe<ResearchSummary>;
  /** An object of the Resource Type.  */
  resource?: Maybe<Resource>;
  /** A Resource object */
  resourceBy?: Maybe<Resource>;
  /** Connection between the RootQuery type and the ResourceCategory type */
  resourceCategories?: Maybe<RootQueryToResourceCategoryConnection>;
  /** A 0bject */
  resourceCategory?: Maybe<ResourceCategory>;
  /** Connection between the RootQuery type and the Resource type */
  resources?: Maybe<RootQueryToResourceConnection>;
  /** Connection between the RootQuery type and the ContentRevisionUnion type */
  revisions?: Maybe<RootQueryToContentRevisionUnionConnection>;
  /** A 0bject */
  tag?: Maybe<Tag>;
  /** Connection between the RootQuery type and the tag type */
  tags?: Maybe<RootQueryToTagConnection>;
  /** Connection between the RootQuery type and the Taxonomy type */
  taxonomies?: Maybe<RootQueryToTaxonomyConnection>;
  /** Fetch a Taxonomy node by unique Identifier */
  taxonomy?: Maybe<Taxonomy>;
  /** A node in a taxonomy used to group and relate content nodes */
  termNode?: Maybe<TermNode>;
  /** Connection between the RootQuery type and the TermNode type */
  terms?: Maybe<RootQueryToTermNodeConnection>;
  /** A Theme object */
  theme?: Maybe<Theme>;
  /** Connection between the RootQuery type and the Theme type */
  themes?: Maybe<RootQueryToThemeConnection>;
  /** Returns a user */
  user?: Maybe<User>;
  /** Returns a user role */
  userRole?: Maybe<UserRole>;
  /** Connection between the RootQuery type and the UserRole type */
  userRoles?: Maybe<RootQueryToUserRoleConnection>;
  /** Connection between the RootQuery type and the User type */
  users?: Maybe<RootQueryToUserConnection>;
  /** Connection between the RootQuery type and the VideoSeriesCategory type */
  videoSeriesCategories?: Maybe<RootQueryToVideoSeriesCategoryConnection>;
  /** A 0bject */
  videoSeriesCategory?: Maybe<VideoSeriesCategory>;
  /** An object of the VideoSeriesItem Type.  */
  videoSeriesItem?: Maybe<VideoSeriesItem>;
  /** A VideoSeriesItem object */
  videoSeriesItemBy?: Maybe<VideoSeriesItem>;
  /** Connection between the RootQuery type and the VideoSeriesItem type */
  videoSeriesItems?: Maybe<RootQueryToVideoSeriesItemConnection>;
  /** Returns the current user */
  viewer?: Maybe<User>;
  /** An object of the Webinar Type.  */
  webinar?: Maybe<Webinar>;
  /** A Webinar object */
  webinarBy?: Maybe<Webinar>;
  /** Connection between the RootQuery type and the Webinar type */
  webinars?: Maybe<RootQueryToWebinarConnection>;
  /** Connection between the RootQuery type and the WebinarsCategory type */
  webinarsCategories?: Maybe<RootQueryToWebinarsCategoryConnection>;
  /** A 0bject */
  webinarsCategory?: Maybe<WebinarsCategory>;
  /** Fields of the &#039;WritingSettings&#039; settings group */
  writingSettings?: Maybe<WritingSettings>;
};


export type ContentRootQueryCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToCategoryConnectionWhereArgs>;
};


export type ContentRootQueryCategoryArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<CategoryIdType>;
};


export type ContentRootQueryCommentArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<CommentNodeIdTypeEnum>;
};


export type ContentRootQueryCommentsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToCommentConnectionWhereArgs>;
};


export type ContentRootQueryContentNodeArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  contentType?: InputMaybe<ContentTypeEnum>;
  id: Scalars['ID'];
  idType?: InputMaybe<ContentNodeIdTypeEnum>;
};


export type ContentRootQueryContentNodesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToContentNodeConnectionWhereArgs>;
};


export type ContentRootQueryContentTypeArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<ContentTypeIdTypeEnum>;
};


export type ContentRootQueryContentTypesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ContentRootQueryEbookArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType?: InputMaybe<EbookIdType>;
};


export type ContentRootQueryEbookByArgs = {
  ebookId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};


export type ContentRootQueryEbooksArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToEbookConnectionWhereArgs>;
};


export type ContentRootQueryEbooksCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToEbooksCategoryConnectionWhereArgs>;
};


export type ContentRootQueryEbooksCategoryArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<EbooksCategoryIdType>;
};


export type ContentRootQueryMediaItemArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType?: InputMaybe<MediaItemIdType>;
};


export type ContentRootQueryMediaItemByArgs = {
  id?: InputMaybe<Scalars['ID']>;
  mediaItemId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};


export type ContentRootQueryMediaItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToMediaItemConnectionWhereArgs>;
};


export type ContentRootQueryMenuArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<MenuNodeIdTypeEnum>;
};


export type ContentRootQueryMenuItemArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<MenuItemNodeIdTypeEnum>;
};


export type ContentRootQueryMenuItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToMenuItemConnectionWhereArgs>;
};


export type ContentRootQueryMenusArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToMenuConnectionWhereArgs>;
};


export type ContentRootQueryNodeArgs = {
  id?: InputMaybe<Scalars['ID']>;
};


export type ContentRootQueryNodeByUriArgs = {
  uri: Scalars['String'];
};


export type ContentRootQueryPageArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType?: InputMaybe<PageIdType>;
};


export type ContentRootQueryPageByArgs = {
  id?: InputMaybe<Scalars['ID']>;
  pageId?: InputMaybe<Scalars['Int']>;
  uri?: InputMaybe<Scalars['String']>;
};


export type ContentRootQueryPagesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToPageConnectionWhereArgs>;
};


export type ContentRootQueryPluginArgs = {
  id: Scalars['ID'];
};


export type ContentRootQueryPluginsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToPluginConnectionWhereArgs>;
};


export type ContentRootQueryPostArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType?: InputMaybe<PostIdType>;
};


export type ContentRootQueryPostByArgs = {
  id?: InputMaybe<Scalars['ID']>;
  postId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};


export type ContentRootQueryPostFormatArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<PostFormatIdType>;
};


export type ContentRootQueryPostFormatsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToPostFormatConnectionWhereArgs>;
};


export type ContentRootQueryPostsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToPostConnectionWhereArgs>;
};


export type ContentRootQueryRegisteredScriptsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ContentRootQueryRegisteredStylesheetsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ContentRootQueryResearchSummariesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToResearchSummaryConnectionWhereArgs>;
};


export type ContentRootQueryResearchSummariesCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToResearchSummariesCategoryConnectionWhereArgs>;
};


export type ContentRootQueryResearchSummariesCategoryArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<ResearchSummariesCategoryIdType>;
};


export type ContentRootQueryResearchSummaryArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType?: InputMaybe<ResearchSummaryIdType>;
};


export type ContentRootQueryResearchSummaryByArgs = {
  id?: InputMaybe<Scalars['ID']>;
  researchSummaryId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};


export type ContentRootQueryResourceArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType?: InputMaybe<ResourceIdType>;
};


export type ContentRootQueryResourceByArgs = {
  id?: InputMaybe<Scalars['ID']>;
  resourceId?: InputMaybe<Scalars['Int']>;
  slug?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
};


export type ContentRootQueryResourceCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToResourceCategoryConnectionWhereArgs>;
};


export type ContentRootQueryResourceCategoryArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<ResourceCategoryIdType>;
};


export type ContentRootQueryResourcesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToResourceConnectionWhereArgs>;
};


export type ContentRootQueryRevisionsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToContentRevisionUnionConnectionWhereArgs>;
};


export type ContentRootQueryTagArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<TagIdType>;
};


export type ContentRootQueryTagsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToTagConnectionWhereArgs>;
};


export type ContentRootQueryTaxonomiesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ContentRootQueryTaxonomyArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<TaxonomyIdTypeEnum>;
};


export type ContentRootQueryTermNodeArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<TermNodeIdTypeEnum>;
  taxonomy?: InputMaybe<TaxonomyEnum>;
};


export type ContentRootQueryTermsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToTermNodeConnectionWhereArgs>;
};


export type ContentRootQueryThemeArgs = {
  id: Scalars['ID'];
};


export type ContentRootQueryThemesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ContentRootQueryUserArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<UserNodeIdTypeEnum>;
};


export type ContentRootQueryUserRoleArgs = {
  id: Scalars['ID'];
};


export type ContentRootQueryUserRolesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
};


export type ContentRootQueryUsersArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToUserConnectionWhereArgs>;
};


export type ContentRootQueryVideoSeriesCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToVideoSeriesCategoryConnectionWhereArgs>;
};


export type ContentRootQueryVideoSeriesCategoryArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<VideoSeriesCategoryIdType>;
};


export type ContentRootQueryVideoSeriesItemArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType?: InputMaybe<VideoSeriesItemIdType>;
};


export type ContentRootQueryVideoSeriesItemByArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
  videoSeriesItemId?: InputMaybe<Scalars['Int']>;
};


export type ContentRootQueryVideoSeriesItemsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToVideoSeriesItemConnectionWhereArgs>;
};


export type ContentRootQueryWebinarArgs = {
  asPreview?: InputMaybe<Scalars['Boolean']>;
  id: Scalars['ID'];
  idType?: InputMaybe<WebinarIdType>;
};


export type ContentRootQueryWebinarByArgs = {
  id?: InputMaybe<Scalars['ID']>;
  slug?: InputMaybe<Scalars['String']>;
  uri?: InputMaybe<Scalars['String']>;
  webinarId?: InputMaybe<Scalars['Int']>;
};


export type ContentRootQueryWebinarsArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToWebinarConnectionWhereArgs>;
};


export type ContentRootQueryWebinarsCategoriesArgs = {
  after?: InputMaybe<Scalars['String']>;
  before?: InputMaybe<Scalars['String']>;
  first?: InputMaybe<Scalars['Int']>;
  last?: InputMaybe<Scalars['Int']>;
  where?: InputMaybe<RootQueryToWebinarsCategoryConnectionWhereArgs>;
};


export type ContentRootQueryWebinarsCategoryArgs = {
  id: Scalars['ID'];
  idType?: InputMaybe<WebinarsCategoryIdType>;
};

/** columns and relationships of "country" */
export type Country = {
  __typename?: 'country';
  name: Scalars['String'];
};

/** aggregated selection of "country" */
export type Country_Aggregate = {
  __typename?: 'country_aggregate';
  aggregate?: Maybe<Country_Aggregate_Fields>;
  nodes: Array<Country>;
};

/** aggregate fields of "country" */
export type Country_Aggregate_Fields = {
  __typename?: 'country_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Country_Max_Fields>;
  min?: Maybe<Country_Min_Fields>;
};


/** aggregate fields of "country" */
export type Country_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Country_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "country". All fields are combined with a logical 'AND'. */
export type Country_Bool_Exp = {
  _and?: InputMaybe<Array<Country_Bool_Exp>>;
  _not?: InputMaybe<Country_Bool_Exp>;
  _or?: InputMaybe<Array<Country_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "country" */
export enum Country_Constraint {
  /** unique or primary key constraint on columns "name" */
  CountryPkey = 'country_pkey'
}

/** input type for inserting data into table "country" */
export type Country_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Country_Max_Fields = {
  __typename?: 'country_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Country_Min_Fields = {
  __typename?: 'country_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "country" */
export type Country_Mutation_Response = {
  __typename?: 'country_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Country>;
};

/** on_conflict condition type for table "country" */
export type Country_On_Conflict = {
  constraint: Country_Constraint;
  update_columns?: Array<Country_Update_Column>;
  where?: InputMaybe<Country_Bool_Exp>;
};

/** Ordering options when selecting data from "country". */
export type Country_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: country */
export type Country_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** columns and relationships of "country_region" */
export type Country_Region = {
  __typename?: 'country_region';
  country: Scalars['String'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "country_region" */
export type Country_Region_Aggregate = {
  __typename?: 'country_region_aggregate';
  aggregate?: Maybe<Country_Region_Aggregate_Fields>;
  nodes: Array<Country_Region>;
};

/** aggregate fields of "country_region" */
export type Country_Region_Aggregate_Fields = {
  __typename?: 'country_region_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Country_Region_Max_Fields>;
  min?: Maybe<Country_Region_Min_Fields>;
};


/** aggregate fields of "country_region" */
export type Country_Region_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Country_Region_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "country_region". All fields are combined with a logical 'AND'. */
export type Country_Region_Bool_Exp = {
  _and?: InputMaybe<Array<Country_Region_Bool_Exp>>;
  _not?: InputMaybe<Country_Region_Bool_Exp>;
  _or?: InputMaybe<Array<Country_Region_Bool_Exp>>;
  country?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "country_region" */
export enum Country_Region_Constraint {
  /** unique or primary key constraint on columns "country", "name" */
  CountryRegionCountryNameKey = 'country_region_country_name_key',
  /** unique or primary key constraint on columns "id" */
  CountryRegionPkey = 'country_region_pkey'
}

/** input type for inserting data into table "country_region" */
export type Country_Region_Insert_Input = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Country_Region_Max_Fields = {
  __typename?: 'country_region_max_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Country_Region_Min_Fields = {
  __typename?: 'country_region_min_fields';
  country?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "country_region" */
export type Country_Region_Mutation_Response = {
  __typename?: 'country_region_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Country_Region>;
};

/** on_conflict condition type for table "country_region" */
export type Country_Region_On_Conflict = {
  constraint: Country_Region_Constraint;
  update_columns?: Array<Country_Region_Update_Column>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};

/** Ordering options when selecting data from "country_region". */
export type Country_Region_Order_By = {
  country?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: country_region */
export type Country_Region_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "country_region" */
export enum Country_Region_Select_Column {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "country_region" */
export type Country_Region_Set_Input = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "country_region" */
export type Country_Region_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Country_Region_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Country_Region_Stream_Cursor_Value_Input = {
  country?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "country_region" */
export enum Country_Region_Update_Column {
  /** column name */
  Country = 'country',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Country_Region_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Country_Region_Set_Input>;
  /** filter the rows which have to be updated */
  where: Country_Region_Bool_Exp;
};

/** select columns of table "country" */
export enum Country_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "country" */
export type Country_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "country" */
export type Country_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Country_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Country_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "country" */
export enum Country_Update_Column {
  /** column name */
  Name = 'name'
}

export type Country_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Country_Set_Input>;
  /** filter the rows which have to be updated */
  where: Country_Bool_Exp;
};

/** columns and relationships of "course" */
export type Course = {
  __typename?: 'course';
  accountCode?: Maybe<Scalars['String']>;
  accreditedBy: Accreditors_Enum;
  aolCostOfCourse?: Maybe<Scalars['numeric']>;
  aolCountry?: Maybe<Scalars['String']>;
  aolRegion?: Maybe<Scalars['String']>;
  arloReferenceId?: Maybe<Scalars['String']>;
  /** An array relationship */
  bildModules: Array<Course_Bild_Module>;
  /** An aggregate relationship */
  bildModules_aggregate: Course_Bild_Module_Aggregate;
  /** An array relationship */
  bildStrategies: Array<Course_Bild_Strategy>;
  /** An aggregate relationship */
  bildStrategies_aggregate: Course_Bild_Strategy_Aggregate;
  /** An object relationship */
  bookingContact?: Maybe<Profile>;
  bookingContactInviteData?: Maybe<Scalars['jsonb']>;
  bookingContactProfileId?: Maybe<Scalars['uuid']>;
  cancellationFee?: Maybe<Scalars['Float']>;
  cancellationFeeType?: Maybe<Course_Cancellation_Fee_Type_Enum>;
  cancellationReason?: Maybe<Scalars['String']>;
  /** An object relationship */
  cancellationRequest?: Maybe<Course_Cancellation_Request>;
  /** An array relationship */
  certificates: Array<Course_Certificate>;
  /** An aggregate relationship */
  certificates_aggregate: Course_Certificate_Aggregate;
  conversion?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  courseExceptions: Array<Course_Exceptions>;
  /** An aggregate relationship */
  courseExceptions_aggregate: Course_Exceptions_Aggregate;
  /** An array relationship */
  course_audits: Array<Course_Audit>;
  /** An aggregate relationship */
  course_audits_aggregate: Course_Audit_Aggregate;
  /** A computed field, executes function "course_code" */
  course_code?: Maybe<Scalars['String']>;
  /** An array relationship */
  course_course_participant_audits: Array<Course_Participant_Audit>;
  /** An aggregate relationship */
  course_course_participant_audits_aggregate: Course_Participant_Audit_Aggregate;
  /** An array relationship */
  course_invites: Array<Course_Invites>;
  /** An aggregate relationship */
  course_invites_aggregate: Course_Invites_Aggregate;
  createdAt: Scalars['timestamptz'];
  /** An object relationship */
  createdBy?: Maybe<Profile>;
  createdById?: Maybe<Scalars['uuid']>;
  curriculum?: Maybe<Scalars['jsonb']>;
  deliveryType: Course_Delivery_Type_Enum;
  description?: Maybe<Scalars['String']>;
  displayOnWebsite?: Maybe<Scalars['Boolean']>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  end_date?: Maybe<Scalars['date']>;
  /** An array relationship */
  evaluation_answers: Array<Course_Evaluation_Answers>;
  /** An aggregate relationship */
  evaluation_answers_aggregate: Course_Evaluation_Answers_Aggregate;
  exceptionsPending: Scalars['Boolean'];
  /** An array relationship */
  expenses: Array<Course_Expenses>;
  /** An aggregate relationship */
  expenses_aggregate: Course_Expenses_Aggregate;
  /** A computed field, executes function "course_free_slots" */
  freeSlots?: Maybe<Scalars['Int']>;
  freeSpaces?: Maybe<Scalars['Int']>;
  free_course_materials?: Maybe<Scalars['Int']>;
  go1Integration: Scalars['Boolean'];
  gradingConfirmed: Scalars['Boolean'];
  gradingStarted: Scalars['Boolean'];
  grading_completed_on?: Maybe<Scalars['timestamptz']>;
  hubspot_deal_id?: Maybe<Scalars['String']>;
  id: Scalars['Int'];
  includeVAT?: Maybe<Scalars['Boolean']>;
  isDraft?: Maybe<Scalars['Boolean']>;
  is_tender: Scalars['Boolean'];
  level: Course_Level_Enum;
  /** An object relationship */
  materials_organization?: Maybe<Organization>;
  materials_organization_id?: Maybe<Scalars['uuid']>;
  max_participants: Scalars['Int'];
  min_participants: Scalars['Int'];
  /** An array relationship */
  modules: Array<Course_Module>;
  modulesDuration: Scalars['Int'];
  /** An aggregate relationship */
  modules_aggregate: Course_Module_Aggregate;
  name: Scalars['String'];
  /** An array relationship */
  orders: Array<Course_Order>;
  /** An aggregate relationship */
  orders_aggregate: Course_Order_Aggregate;
  /** An object relationship */
  organization?: Maybe<Organization>;
  /** An object relationship */
  organizationKeyContact?: Maybe<Profile>;
  organizationKeyContactInviteData?: Maybe<Scalars['jsonb']>;
  organizationKeyContactProfileId?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  parking_instructions?: Maybe<Scalars['String']>;
  /** An array relationship */
  participants: Array<Course_Participant>;
  /** An aggregate relationship */
  participants_aggregate: Course_Participant_Aggregate;
  price?: Maybe<Scalars['numeric']>;
  priceCurrency?: Maybe<Scalars['String']>;
  /** An array relationship */
  promo_codes: Array<Course_Promo_Code>;
  /** An aggregate relationship */
  promo_codes_aggregate: Course_Promo_Code_Aggregate;
  reaccreditation?: Maybe<Scalars['Boolean']>;
  region?: Maybe<Scalars['String']>;
  renewalCycle?: Maybe<Course_Renewal_Cycle_Enum>;
  /** A computed field, executes function "course_reserved_go1_licenses" */
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  /** A computed field returns the total count of reserved resource packs for a course, derived from resource pack reservation events in the organization's resource pack management history. */
  reservedResourcePacks?: Maybe<Scalars['Int']>;
  residingCountry?: Maybe<Scalars['String']>;
  resourcePacksDeliveryType?: Maybe<Resource_Packs_Delivery_Type_Enum>;
  resourcePacksType?: Maybe<Resource_Packs_Type_Enum>;
  /** An array relationship */
  schedule: Array<Course_Schedule>;
  /** An aggregate relationship */
  schedule_aggregate: Course_Schedule_Aggregate;
  search_fields?: Maybe<Scalars['String']>;
  source?: Maybe<Course_Source_Enum>;
  special_instructions?: Maybe<Scalars['String']>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  start_date?: Maybe<Scalars['date']>;
  /** A computed field, executes function "course_state" */
  state?: Maybe<Scalars['String']>;
  status?: Maybe<Course_Status_Enum>;
  /** An array relationship */
  tempOrders: Array<Order_Temp>;
  /** An aggregate relationship */
  tempOrders_aggregate: Order_Temp_Aggregate;
  /** An array relationship */
  trainers: Array<Course_Trainer>;
  /** An aggregate relationship */
  trainers_aggregate: Course_Trainer_Aggregate;
  type: Course_Type_Enum;
  updatedAt: Scalars['timestamptz'];
  /** An array relationship */
  waitlists: Array<Waitlist>;
  /** An aggregate relationship */
  waitlists_aggregate: Waitlist_Aggregate;
};


/** columns and relationships of "course" */
export type CourseBildModulesArgs = {
  distinct_on?: InputMaybe<Array<Course_Bild_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Bild_Module_Order_By>>;
  where?: InputMaybe<Course_Bild_Module_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseBildModules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Bild_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Bild_Module_Order_By>>;
  where?: InputMaybe<Course_Bild_Module_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseBildStrategiesArgs = {
  distinct_on?: InputMaybe<Array<Course_Bild_Strategy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Bild_Strategy_Order_By>>;
  where?: InputMaybe<Course_Bild_Strategy_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseBildStrategies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Bild_Strategy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Bild_Strategy_Order_By>>;
  where?: InputMaybe<Course_Bild_Strategy_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseBookingContactInviteDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "course" */
export type CourseCertificatesArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Order_By>>;
  where?: InputMaybe<Course_Certificate_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCertificates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Order_By>>;
  where?: InputMaybe<Course_Certificate_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourseExceptionsArgs = {
  distinct_on?: InputMaybe<Array<Course_Exceptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Exceptions_Order_By>>;
  where?: InputMaybe<Course_Exceptions_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourseExceptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Exceptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Exceptions_Order_By>>;
  where?: InputMaybe<Course_Exceptions_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_AuditsArgs = {
  distinct_on?: InputMaybe<Array<Course_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Audit_Order_By>>;
  where?: InputMaybe<Course_Audit_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_Audits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Audit_Order_By>>;
  where?: InputMaybe<Course_Audit_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_Course_Participant_AuditsArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Audit_Order_By>>;
  where?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_Course_Participant_Audits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Audit_Order_By>>;
  where?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_InvitesArgs = {
  distinct_on?: InputMaybe<Array<Course_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Invites_Order_By>>;
  where?: InputMaybe<Course_Invites_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCourse_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Invites_Order_By>>;
  where?: InputMaybe<Course_Invites_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseCurriculumArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "course" */
export type CourseEvaluation_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Answers_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseEvaluation_Answers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Answers_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseExpensesArgs = {
  distinct_on?: InputMaybe<Array<Course_Expenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Expenses_Order_By>>;
  where?: InputMaybe<Course_Expenses_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseExpenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Expenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Expenses_Order_By>>;
  where?: InputMaybe<Course_Expenses_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseModulesArgs = {
  distinct_on?: InputMaybe<Array<Course_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Module_Order_By>>;
  where?: InputMaybe<Course_Module_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseModules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Module_Order_By>>;
  where?: InputMaybe<Course_Module_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseOrdersArgs = {
  distinct_on?: InputMaybe<Array<Course_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_Order_By>>;
  where?: InputMaybe<Course_Order_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_Order_By>>;
  where?: InputMaybe<Course_Order_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseOrganizationKeyContactInviteDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "course" */
export type CourseParticipantsArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Order_By>>;
  where?: InputMaybe<Course_Participant_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseParticipants_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Order_By>>;
  where?: InputMaybe<Course_Participant_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CoursePromo_CodesArgs = {
  distinct_on?: InputMaybe<Array<Course_Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Promo_Code_Order_By>>;
  where?: InputMaybe<Course_Promo_Code_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CoursePromo_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Promo_Code_Order_By>>;
  where?: InputMaybe<Course_Promo_Code_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseScheduleArgs = {
  distinct_on?: InputMaybe<Array<Course_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Schedule_Order_By>>;
  where?: InputMaybe<Course_Schedule_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseSchedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Schedule_Order_By>>;
  where?: InputMaybe<Course_Schedule_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseTempOrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Temp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Temp_Order_By>>;
  where?: InputMaybe<Order_Temp_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseTempOrders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Temp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Temp_Order_By>>;
  where?: InputMaybe<Order_Temp_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseTrainersArgs = {
  distinct_on?: InputMaybe<Array<Course_Trainer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Trainer_Order_By>>;
  where?: InputMaybe<Course_Trainer_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseTrainers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Trainer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Trainer_Order_By>>;
  where?: InputMaybe<Course_Trainer_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseWaitlistsArgs = {
  distinct_on?: InputMaybe<Array<Waitlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Waitlist_Order_By>>;
  where?: InputMaybe<Waitlist_Bool_Exp>;
};


/** columns and relationships of "course" */
export type CourseWaitlists_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Waitlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Waitlist_Order_By>>;
  where?: InputMaybe<Waitlist_Bool_Exp>;
};

/** aggregated selection of "course" */
export type Course_Aggregate = {
  __typename?: 'course_aggregate';
  aggregate?: Maybe<Course_Aggregate_Fields>;
  nodes: Array<Course>;
};

export type Course_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Course_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Course_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Course_Aggregate_Bool_Exp_Count>;
};

export type Course_Aggregate_Bool_Exp_Bool_And = {
  arguments: Course_Select_Column_Course_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Course_Select_Column_Course_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course" */
export type Course_Aggregate_Fields = {
  __typename?: 'course_aggregate_fields';
  avg?: Maybe<Course_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Max_Fields>;
  min?: Maybe<Course_Min_Fields>;
  stddev?: Maybe<Course_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Sum_Fields>;
  var_pop?: Maybe<Course_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Var_Samp_Fields>;
  variance?: Maybe<Course_Variance_Fields>;
};


/** aggregate fields of "course" */
export type Course_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course" */
export type Course_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Max_Order_By>;
  min?: InputMaybe<Course_Min_Order_By>;
  stddev?: InputMaybe<Course_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Course_Append_Input = {
  bookingContactInviteData?: InputMaybe<Scalars['jsonb']>;
  curriculum?: InputMaybe<Scalars['jsonb']>;
  organizationKeyContactInviteData?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "course" */
export type Course_Arr_Rel_Insert_Input = {
  data: Array<Course_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_On_Conflict>;
};

/** columns and relationships of "course_audit" */
export type Course_Audit = {
  __typename?: 'course_audit';
  /** An object relationship */
  authorizedBy?: Maybe<Profile>;
  authorized_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  course: Course;
  course_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  payload: Scalars['jsonb'];
  /** A computed field, executes function "merge_course_audit_rows" */
  searchFields?: Maybe<Scalars['String']>;
  type: Course_Audit_Type_Enum;
  updated_at: Scalars['timestamptz'];
  xero_invoice_number?: Maybe<Scalars['String']>;
};


/** columns and relationships of "course_audit" */
export type Course_AuditPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "course_audit" */
export type Course_Audit_Aggregate = {
  __typename?: 'course_audit_aggregate';
  aggregate?: Maybe<Course_Audit_Aggregate_Fields>;
  nodes: Array<Course_Audit>;
};

export type Course_Audit_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Audit_Aggregate_Bool_Exp_Count>;
};

export type Course_Audit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Audit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_audit" */
export type Course_Audit_Aggregate_Fields = {
  __typename?: 'course_audit_aggregate_fields';
  avg?: Maybe<Course_Audit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Audit_Max_Fields>;
  min?: Maybe<Course_Audit_Min_Fields>;
  stddev?: Maybe<Course_Audit_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Audit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Audit_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Audit_Sum_Fields>;
  var_pop?: Maybe<Course_Audit_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Audit_Var_Samp_Fields>;
  variance?: Maybe<Course_Audit_Variance_Fields>;
};


/** aggregate fields of "course_audit" */
export type Course_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_audit" */
export type Course_Audit_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Audit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Audit_Max_Order_By>;
  min?: InputMaybe<Course_Audit_Min_Order_By>;
  stddev?: InputMaybe<Course_Audit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Audit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Audit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Audit_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Audit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Audit_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Audit_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Course_Audit_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "course_audit" */
export type Course_Audit_Arr_Rel_Insert_Input = {
  data: Array<Course_Audit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Audit_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Audit_Avg_Fields = {
  __typename?: 'course_audit_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_audit" */
export type Course_Audit_Avg_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_audit". All fields are combined with a logical 'AND'. */
export type Course_Audit_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Audit_Bool_Exp>>;
  _not?: InputMaybe<Course_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Audit_Bool_Exp>>;
  authorizedBy?: InputMaybe<Profile_Bool_Exp>;
  authorized_by?: InputMaybe<Uuid_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  searchFields?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Course_Audit_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  xero_invoice_number?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_audit" */
export enum Course_Audit_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseAuditPkey = 'course_audit_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Course_Audit_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Course_Audit_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Course_Audit_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "course_audit" */
export type Course_Audit_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_audit" */
export type Course_Audit_Insert_Input = {
  authorizedBy?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  authorized_by?: InputMaybe<Scalars['uuid']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Course_Audit_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  xero_invoice_number?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Audit_Max_Fields = {
  __typename?: 'course_audit_max_fields';
  authorized_by?: Maybe<Scalars['uuid']>;
  course_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "merge_course_audit_rows" */
  searchFields?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  xero_invoice_number?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "course_audit" */
export type Course_Audit_Max_Order_By = {
  authorized_by?: InputMaybe<Order_By>;
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xero_invoice_number?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Audit_Min_Fields = {
  __typename?: 'course_audit_min_fields';
  authorized_by?: Maybe<Scalars['uuid']>;
  course_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "merge_course_audit_rows" */
  searchFields?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  xero_invoice_number?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "course_audit" */
export type Course_Audit_Min_Order_By = {
  authorized_by?: InputMaybe<Order_By>;
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xero_invoice_number?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_audit" */
export type Course_Audit_Mutation_Response = {
  __typename?: 'course_audit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Audit>;
};

/** on_conflict condition type for table "course_audit" */
export type Course_Audit_On_Conflict = {
  constraint: Course_Audit_Constraint;
  update_columns?: Array<Course_Audit_Update_Column>;
  where?: InputMaybe<Course_Audit_Bool_Exp>;
};

/** Ordering options when selecting data from "course_audit". */
export type Course_Audit_Order_By = {
  authorizedBy?: InputMaybe<Profile_Order_By>;
  authorized_by?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  searchFields?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xero_invoice_number?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_audit */
export type Course_Audit_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Course_Audit_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "course_audit" */
export enum Course_Audit_Select_Column {
  /** column name */
  AuthorizedBy = 'authorized_by',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  XeroInvoiceNumber = 'xero_invoice_number'
}

/** input type for updating data in table "course_audit" */
export type Course_Audit_Set_Input = {
  authorized_by?: InputMaybe<Scalars['uuid']>;
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Course_Audit_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  xero_invoice_number?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Course_Audit_Stddev_Fields = {
  __typename?: 'course_audit_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_audit" */
export type Course_Audit_Stddev_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Audit_Stddev_Pop_Fields = {
  __typename?: 'course_audit_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_audit" */
export type Course_Audit_Stddev_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Audit_Stddev_Samp_Fields = {
  __typename?: 'course_audit_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_audit" */
export type Course_Audit_Stddev_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_audit" */
export type Course_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Audit_Stream_Cursor_Value_Input = {
  authorized_by?: InputMaybe<Scalars['uuid']>;
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Course_Audit_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  xero_invoice_number?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Course_Audit_Sum_Fields = {
  __typename?: 'course_audit_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_audit" */
export type Course_Audit_Sum_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_audit_type" */
export type Course_Audit_Type = {
  __typename?: 'course_audit_type';
  name: Scalars['String'];
};

/** aggregated selection of "course_audit_type" */
export type Course_Audit_Type_Aggregate = {
  __typename?: 'course_audit_type_aggregate';
  aggregate?: Maybe<Course_Audit_Type_Aggregate_Fields>;
  nodes: Array<Course_Audit_Type>;
};

/** aggregate fields of "course_audit_type" */
export type Course_Audit_Type_Aggregate_Fields = {
  __typename?: 'course_audit_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Audit_Type_Max_Fields>;
  min?: Maybe<Course_Audit_Type_Min_Fields>;
};


/** aggregate fields of "course_audit_type" */
export type Course_Audit_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Audit_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_audit_type". All fields are combined with a logical 'AND'. */
export type Course_Audit_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Audit_Type_Bool_Exp>>;
  _not?: InputMaybe<Course_Audit_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Audit_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_audit_type" */
export enum Course_Audit_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseAuditTypePkey = 'course_audit_type_pkey'
}

export enum Course_Audit_Type_Enum {
  Approved = 'APPROVED',
  Cancellation = 'CANCELLATION',
  Completed = 'COMPLETED',
  Rejected = 'REJECTED',
  Reschedule = 'RESCHEDULE'
}

/** Boolean expression to compare columns of type "course_audit_type_enum". All fields are combined with logical 'AND'. */
export type Course_Audit_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Audit_Type_Enum>;
  _in?: InputMaybe<Array<Course_Audit_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Audit_Type_Enum>;
  _nin?: InputMaybe<Array<Course_Audit_Type_Enum>>;
};

/** input type for inserting data into table "course_audit_type" */
export type Course_Audit_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Audit_Type_Max_Fields = {
  __typename?: 'course_audit_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Audit_Type_Min_Fields = {
  __typename?: 'course_audit_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_audit_type" */
export type Course_Audit_Type_Mutation_Response = {
  __typename?: 'course_audit_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Audit_Type>;
};

/** on_conflict condition type for table "course_audit_type" */
export type Course_Audit_Type_On_Conflict = {
  constraint: Course_Audit_Type_Constraint;
  update_columns?: Array<Course_Audit_Type_Update_Column>;
  where?: InputMaybe<Course_Audit_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "course_audit_type". */
export type Course_Audit_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_audit_type */
export type Course_Audit_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "course_audit_type" */
export enum Course_Audit_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_audit_type" */
export type Course_Audit_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_audit_type" */
export type Course_Audit_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Audit_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Audit_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_audit_type" */
export enum Course_Audit_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Audit_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Audit_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Audit_Type_Bool_Exp;
};

/** update columns of table "course_audit" */
export enum Course_Audit_Update_Column {
  /** column name */
  AuthorizedBy = 'authorized_by',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  XeroInvoiceNumber = 'xero_invoice_number'
}

export type Course_Audit_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Course_Audit_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Course_Audit_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Course_Audit_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Course_Audit_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Audit_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Course_Audit_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Audit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Audit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Audit_Var_Pop_Fields = {
  __typename?: 'course_audit_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_audit" */
export type Course_Audit_Var_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Audit_Var_Samp_Fields = {
  __typename?: 'course_audit_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_audit" */
export type Course_Audit_Var_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Audit_Variance_Fields = {
  __typename?: 'course_audit_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_audit" */
export type Course_Audit_Variance_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Course_Avg_Fields = {
  __typename?: 'course_avg_fields';
  aolCostOfCourse?: Maybe<Scalars['Float']>;
  cancellationFee?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_free_slots" */
  freeSlots?: Maybe<Scalars['Int']>;
  freeSpaces?: Maybe<Scalars['Float']>;
  free_course_materials?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
  modulesDuration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_reserved_go1_licenses" */
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  /** A computed field returns the total count of reserved resource packs for a course, derived from resource pack reservation events in the organization's resource pack management history. */
  reservedResourcePacks?: Maybe<Scalars['Int']>;
};

/** order by avg() on columns of table "course" */
export type Course_Avg_Order_By = {
  aolCostOfCourse?: InputMaybe<Order_By>;
  cancellationFee?: InputMaybe<Order_By>;
  freeSpaces?: InputMaybe<Order_By>;
  free_course_materials?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_participants?: InputMaybe<Order_By>;
  min_participants?: InputMaybe<Order_By>;
  modulesDuration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_bild_module" */
export type Course_Bild_Module = {
  __typename?: 'course_bild_module';
  course_id: Scalars['Int'];
  id: Scalars['uuid'];
  modules: Scalars['jsonb'];
};


/** columns and relationships of "course_bild_module" */
export type Course_Bild_ModuleModulesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "course_bild_module" */
export type Course_Bild_Module_Aggregate = {
  __typename?: 'course_bild_module_aggregate';
  aggregate?: Maybe<Course_Bild_Module_Aggregate_Fields>;
  nodes: Array<Course_Bild_Module>;
};

export type Course_Bild_Module_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Bild_Module_Aggregate_Bool_Exp_Count>;
};

export type Course_Bild_Module_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Bild_Module_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Bild_Module_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_bild_module" */
export type Course_Bild_Module_Aggregate_Fields = {
  __typename?: 'course_bild_module_aggregate_fields';
  avg?: Maybe<Course_Bild_Module_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Bild_Module_Max_Fields>;
  min?: Maybe<Course_Bild_Module_Min_Fields>;
  stddev?: Maybe<Course_Bild_Module_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Bild_Module_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Bild_Module_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Bild_Module_Sum_Fields>;
  var_pop?: Maybe<Course_Bild_Module_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Bild_Module_Var_Samp_Fields>;
  variance?: Maybe<Course_Bild_Module_Variance_Fields>;
};


/** aggregate fields of "course_bild_module" */
export type Course_Bild_Module_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Bild_Module_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_bild_module" */
export type Course_Bild_Module_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Bild_Module_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Bild_Module_Max_Order_By>;
  min?: InputMaybe<Course_Bild_Module_Min_Order_By>;
  stddev?: InputMaybe<Course_Bild_Module_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Bild_Module_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Bild_Module_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Bild_Module_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Bild_Module_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Bild_Module_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Bild_Module_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Course_Bild_Module_Append_Input = {
  modules?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "course_bild_module" */
export type Course_Bild_Module_Arr_Rel_Insert_Input = {
  data: Array<Course_Bild_Module_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Bild_Module_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Bild_Module_Avg_Fields = {
  __typename?: 'course_bild_module_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_bild_module" */
export type Course_Bild_Module_Avg_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_bild_module". All fields are combined with a logical 'AND'. */
export type Course_Bild_Module_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Bild_Module_Bool_Exp>>;
  _not?: InputMaybe<Course_Bild_Module_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Bild_Module_Bool_Exp>>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  modules?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_bild_module" */
export enum Course_Bild_Module_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseBildModulePkey = 'course_bild_module_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Course_Bild_Module_Delete_At_Path_Input = {
  modules?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Course_Bild_Module_Delete_Elem_Input = {
  modules?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Course_Bild_Module_Delete_Key_Input = {
  modules?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "course_bild_module" */
export type Course_Bild_Module_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_bild_module" */
export type Course_Bild_Module_Insert_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  modules?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Course_Bild_Module_Max_Fields = {
  __typename?: 'course_bild_module_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "course_bild_module" */
export type Course_Bild_Module_Max_Order_By = {
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Bild_Module_Min_Fields = {
  __typename?: 'course_bild_module_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "course_bild_module" */
export type Course_Bild_Module_Min_Order_By = {
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_bild_module" */
export type Course_Bild_Module_Mutation_Response = {
  __typename?: 'course_bild_module_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Bild_Module>;
};

/** on_conflict condition type for table "course_bild_module" */
export type Course_Bild_Module_On_Conflict = {
  constraint: Course_Bild_Module_Constraint;
  update_columns?: Array<Course_Bild_Module_Update_Column>;
  where?: InputMaybe<Course_Bild_Module_Bool_Exp>;
};

/** Ordering options when selecting data from "course_bild_module". */
export type Course_Bild_Module_Order_By = {
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  modules?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_bild_module */
export type Course_Bild_Module_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Course_Bild_Module_Prepend_Input = {
  modules?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "course_bild_module" */
export enum Course_Bild_Module_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  Modules = 'modules'
}

/** input type for updating data in table "course_bild_module" */
export type Course_Bild_Module_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  modules?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Course_Bild_Module_Stddev_Fields = {
  __typename?: 'course_bild_module_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_bild_module" */
export type Course_Bild_Module_Stddev_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Bild_Module_Stddev_Pop_Fields = {
  __typename?: 'course_bild_module_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_bild_module" */
export type Course_Bild_Module_Stddev_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Bild_Module_Stddev_Samp_Fields = {
  __typename?: 'course_bild_module_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_bild_module" */
export type Course_Bild_Module_Stddev_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_bild_module" */
export type Course_Bild_Module_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Bild_Module_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Bild_Module_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  modules?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type Course_Bild_Module_Sum_Fields = {
  __typename?: 'course_bild_module_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_bild_module" */
export type Course_Bild_Module_Sum_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** update columns of table "course_bild_module" */
export enum Course_Bild_Module_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  Modules = 'modules'
}

export type Course_Bild_Module_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Course_Bild_Module_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Course_Bild_Module_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Course_Bild_Module_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Course_Bild_Module_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Bild_Module_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Course_Bild_Module_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Bild_Module_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Bild_Module_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Bild_Module_Var_Pop_Fields = {
  __typename?: 'course_bild_module_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_bild_module" */
export type Course_Bild_Module_Var_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Bild_Module_Var_Samp_Fields = {
  __typename?: 'course_bild_module_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_bild_module" */
export type Course_Bild_Module_Var_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Bild_Module_Variance_Fields = {
  __typename?: 'course_bild_module_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_bild_module" */
export type Course_Bild_Module_Variance_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_bild_strategy" */
export type Course_Bild_Strategy = {
  __typename?: 'course_bild_strategy';
  course_id: Scalars['Int'];
  id: Scalars['uuid'];
  strategyName: Scalars['String'];
};

/** aggregated selection of "course_bild_strategy" */
export type Course_Bild_Strategy_Aggregate = {
  __typename?: 'course_bild_strategy_aggregate';
  aggregate?: Maybe<Course_Bild_Strategy_Aggregate_Fields>;
  nodes: Array<Course_Bild_Strategy>;
};

export type Course_Bild_Strategy_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Bild_Strategy_Aggregate_Bool_Exp_Count>;
};

export type Course_Bild_Strategy_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Bild_Strategy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Bild_Strategy_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_bild_strategy" */
export type Course_Bild_Strategy_Aggregate_Fields = {
  __typename?: 'course_bild_strategy_aggregate_fields';
  avg?: Maybe<Course_Bild_Strategy_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Bild_Strategy_Max_Fields>;
  min?: Maybe<Course_Bild_Strategy_Min_Fields>;
  stddev?: Maybe<Course_Bild_Strategy_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Bild_Strategy_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Bild_Strategy_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Bild_Strategy_Sum_Fields>;
  var_pop?: Maybe<Course_Bild_Strategy_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Bild_Strategy_Var_Samp_Fields>;
  variance?: Maybe<Course_Bild_Strategy_Variance_Fields>;
};


/** aggregate fields of "course_bild_strategy" */
export type Course_Bild_Strategy_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Bild_Strategy_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_bild_strategy" */
export type Course_Bild_Strategy_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Bild_Strategy_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Bild_Strategy_Max_Order_By>;
  min?: InputMaybe<Course_Bild_Strategy_Min_Order_By>;
  stddev?: InputMaybe<Course_Bild_Strategy_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Bild_Strategy_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Bild_Strategy_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Bild_Strategy_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Bild_Strategy_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Bild_Strategy_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Bild_Strategy_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_bild_strategy" */
export type Course_Bild_Strategy_Arr_Rel_Insert_Input = {
  data: Array<Course_Bild_Strategy_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Bild_Strategy_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Bild_Strategy_Avg_Fields = {
  __typename?: 'course_bild_strategy_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_bild_strategy" */
export type Course_Bild_Strategy_Avg_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_bild_strategy". All fields are combined with a logical 'AND'. */
export type Course_Bild_Strategy_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Bild_Strategy_Bool_Exp>>;
  _not?: InputMaybe<Course_Bild_Strategy_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Bild_Strategy_Bool_Exp>>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  strategyName?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_bild_strategy" */
export enum Course_Bild_Strategy_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseBildStrategyPkey = 'course_bild_strategy_pkey'
}

/** input type for incrementing numeric columns in table "course_bild_strategy" */
export type Course_Bild_Strategy_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_bild_strategy" */
export type Course_Bild_Strategy_Insert_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  strategyName?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Bild_Strategy_Max_Fields = {
  __typename?: 'course_bild_strategy_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  strategyName?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "course_bild_strategy" */
export type Course_Bild_Strategy_Max_Order_By = {
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  strategyName?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Bild_Strategy_Min_Fields = {
  __typename?: 'course_bild_strategy_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  strategyName?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "course_bild_strategy" */
export type Course_Bild_Strategy_Min_Order_By = {
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  strategyName?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_bild_strategy" */
export type Course_Bild_Strategy_Mutation_Response = {
  __typename?: 'course_bild_strategy_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Bild_Strategy>;
};

/** on_conflict condition type for table "course_bild_strategy" */
export type Course_Bild_Strategy_On_Conflict = {
  constraint: Course_Bild_Strategy_Constraint;
  update_columns?: Array<Course_Bild_Strategy_Update_Column>;
  where?: InputMaybe<Course_Bild_Strategy_Bool_Exp>;
};

/** Ordering options when selecting data from "course_bild_strategy". */
export type Course_Bild_Strategy_Order_By = {
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  strategyName?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_bild_strategy */
export type Course_Bild_Strategy_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_bild_strategy" */
export enum Course_Bild_Strategy_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  StrategyName = 'strategyName'
}

/** input type for updating data in table "course_bild_strategy" */
export type Course_Bild_Strategy_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  strategyName?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Course_Bild_Strategy_Stddev_Fields = {
  __typename?: 'course_bild_strategy_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_bild_strategy" */
export type Course_Bild_Strategy_Stddev_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Bild_Strategy_Stddev_Pop_Fields = {
  __typename?: 'course_bild_strategy_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_bild_strategy" */
export type Course_Bild_Strategy_Stddev_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Bild_Strategy_Stddev_Samp_Fields = {
  __typename?: 'course_bild_strategy_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_bild_strategy" */
export type Course_Bild_Strategy_Stddev_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_bild_strategy" */
export type Course_Bild_Strategy_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Bild_Strategy_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Bild_Strategy_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  strategyName?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Course_Bild_Strategy_Sum_Fields = {
  __typename?: 'course_bild_strategy_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_bild_strategy" */
export type Course_Bild_Strategy_Sum_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** update columns of table "course_bild_strategy" */
export enum Course_Bild_Strategy_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  StrategyName = 'strategyName'
}

export type Course_Bild_Strategy_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Bild_Strategy_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Bild_Strategy_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Bild_Strategy_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Bild_Strategy_Var_Pop_Fields = {
  __typename?: 'course_bild_strategy_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_bild_strategy" */
export type Course_Bild_Strategy_Var_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Bild_Strategy_Var_Samp_Fields = {
  __typename?: 'course_bild_strategy_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_bild_strategy" */
export type Course_Bild_Strategy_Var_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Bild_Strategy_Variance_Fields = {
  __typename?: 'course_bild_strategy_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_bild_strategy" */
export type Course_Bild_Strategy_Variance_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course". All fields are combined with a logical 'AND'. */
export type Course_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Bool_Exp>>;
  _not?: InputMaybe<Course_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Bool_Exp>>;
  accountCode?: InputMaybe<String_Comparison_Exp>;
  accreditedBy?: InputMaybe<Accreditors_Enum_Comparison_Exp>;
  aolCostOfCourse?: InputMaybe<Numeric_Comparison_Exp>;
  aolCountry?: InputMaybe<String_Comparison_Exp>;
  aolRegion?: InputMaybe<String_Comparison_Exp>;
  arloReferenceId?: InputMaybe<String_Comparison_Exp>;
  bildModules?: InputMaybe<Course_Bild_Module_Bool_Exp>;
  bildModules_aggregate?: InputMaybe<Course_Bild_Module_Aggregate_Bool_Exp>;
  bildStrategies?: InputMaybe<Course_Bild_Strategy_Bool_Exp>;
  bildStrategies_aggregate?: InputMaybe<Course_Bild_Strategy_Aggregate_Bool_Exp>;
  bookingContact?: InputMaybe<Profile_Bool_Exp>;
  bookingContactInviteData?: InputMaybe<Jsonb_Comparison_Exp>;
  bookingContactProfileId?: InputMaybe<Uuid_Comparison_Exp>;
  cancellationFee?: InputMaybe<Float_Comparison_Exp>;
  cancellationFeeType?: InputMaybe<Course_Cancellation_Fee_Type_Enum_Comparison_Exp>;
  cancellationReason?: InputMaybe<String_Comparison_Exp>;
  cancellationRequest?: InputMaybe<Course_Cancellation_Request_Bool_Exp>;
  certificates?: InputMaybe<Course_Certificate_Bool_Exp>;
  certificates_aggregate?: InputMaybe<Course_Certificate_Aggregate_Bool_Exp>;
  conversion?: InputMaybe<Boolean_Comparison_Exp>;
  courseExceptions?: InputMaybe<Course_Exceptions_Bool_Exp>;
  courseExceptions_aggregate?: InputMaybe<Course_Exceptions_Aggregate_Bool_Exp>;
  course_audits?: InputMaybe<Course_Audit_Bool_Exp>;
  course_audits_aggregate?: InputMaybe<Course_Audit_Aggregate_Bool_Exp>;
  course_code?: InputMaybe<String_Comparison_Exp>;
  course_course_participant_audits?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
  course_course_participant_audits_aggregate?: InputMaybe<Course_Participant_Audit_Aggregate_Bool_Exp>;
  course_invites?: InputMaybe<Course_Invites_Bool_Exp>;
  course_invites_aggregate?: InputMaybe<Course_Invites_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Profile_Bool_Exp>;
  createdById?: InputMaybe<Uuid_Comparison_Exp>;
  curriculum?: InputMaybe<Jsonb_Comparison_Exp>;
  deliveryType?: InputMaybe<Course_Delivery_Type_Enum_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  displayOnWebsite?: InputMaybe<Boolean_Comparison_Exp>;
  end_date?: InputMaybe<Date_Comparison_Exp>;
  evaluation_answers?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
  evaluation_answers_aggregate?: InputMaybe<Course_Evaluation_Answers_Aggregate_Bool_Exp>;
  exceptionsPending?: InputMaybe<Boolean_Comparison_Exp>;
  expenses?: InputMaybe<Course_Expenses_Bool_Exp>;
  expenses_aggregate?: InputMaybe<Course_Expenses_Aggregate_Bool_Exp>;
  freeSlots?: InputMaybe<Int_Comparison_Exp>;
  freeSpaces?: InputMaybe<Int_Comparison_Exp>;
  free_course_materials?: InputMaybe<Int_Comparison_Exp>;
  go1Integration?: InputMaybe<Boolean_Comparison_Exp>;
  gradingConfirmed?: InputMaybe<Boolean_Comparison_Exp>;
  gradingStarted?: InputMaybe<Boolean_Comparison_Exp>;
  grading_completed_on?: InputMaybe<Timestamptz_Comparison_Exp>;
  hubspot_deal_id?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  includeVAT?: InputMaybe<Boolean_Comparison_Exp>;
  isDraft?: InputMaybe<Boolean_Comparison_Exp>;
  is_tender?: InputMaybe<Boolean_Comparison_Exp>;
  level?: InputMaybe<Course_Level_Enum_Comparison_Exp>;
  materials_organization?: InputMaybe<Organization_Bool_Exp>;
  materials_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  max_participants?: InputMaybe<Int_Comparison_Exp>;
  min_participants?: InputMaybe<Int_Comparison_Exp>;
  modules?: InputMaybe<Course_Module_Bool_Exp>;
  modulesDuration?: InputMaybe<Int_Comparison_Exp>;
  modules_aggregate?: InputMaybe<Course_Module_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  orders?: InputMaybe<Course_Order_Bool_Exp>;
  orders_aggregate?: InputMaybe<Course_Order_Aggregate_Bool_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationKeyContact?: InputMaybe<Profile_Bool_Exp>;
  organizationKeyContactInviteData?: InputMaybe<Jsonb_Comparison_Exp>;
  organizationKeyContactProfileId?: InputMaybe<Uuid_Comparison_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  parking_instructions?: InputMaybe<String_Comparison_Exp>;
  participants?: InputMaybe<Course_Participant_Bool_Exp>;
  participants_aggregate?: InputMaybe<Course_Participant_Aggregate_Bool_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  priceCurrency?: InputMaybe<String_Comparison_Exp>;
  promo_codes?: InputMaybe<Course_Promo_Code_Bool_Exp>;
  promo_codes_aggregate?: InputMaybe<Course_Promo_Code_Aggregate_Bool_Exp>;
  reaccreditation?: InputMaybe<Boolean_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  renewalCycle?: InputMaybe<Course_Renewal_Cycle_Enum_Comparison_Exp>;
  reservedGo1Licenses?: InputMaybe<Int_Comparison_Exp>;
  reservedResourcePacks?: InputMaybe<Int_Comparison_Exp>;
  residingCountry?: InputMaybe<String_Comparison_Exp>;
  resourcePacksDeliveryType?: InputMaybe<Resource_Packs_Delivery_Type_Enum_Comparison_Exp>;
  resourcePacksType?: InputMaybe<Resource_Packs_Type_Enum_Comparison_Exp>;
  schedule?: InputMaybe<Course_Schedule_Bool_Exp>;
  schedule_aggregate?: InputMaybe<Course_Schedule_Aggregate_Bool_Exp>;
  search_fields?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<Course_Source_Enum_Comparison_Exp>;
  special_instructions?: InputMaybe<String_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
  state?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<Course_Status_Enum_Comparison_Exp>;
  tempOrders?: InputMaybe<Order_Temp_Bool_Exp>;
  tempOrders_aggregate?: InputMaybe<Order_Temp_Aggregate_Bool_Exp>;
  trainers?: InputMaybe<Course_Trainer_Bool_Exp>;
  trainers_aggregate?: InputMaybe<Course_Trainer_Aggregate_Bool_Exp>;
  type?: InputMaybe<Course_Type_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  waitlists?: InputMaybe<Waitlist_Bool_Exp>;
  waitlists_aggregate?: InputMaybe<Waitlist_Aggregate_Bool_Exp>;
};

/** columns and relationships of "course_cancellation_fee_type" */
export type Course_Cancellation_Fee_Type = {
  __typename?: 'course_cancellation_fee_type';
  name: Scalars['String'];
};

/** aggregated selection of "course_cancellation_fee_type" */
export type Course_Cancellation_Fee_Type_Aggregate = {
  __typename?: 'course_cancellation_fee_type_aggregate';
  aggregate?: Maybe<Course_Cancellation_Fee_Type_Aggregate_Fields>;
  nodes: Array<Course_Cancellation_Fee_Type>;
};

/** aggregate fields of "course_cancellation_fee_type" */
export type Course_Cancellation_Fee_Type_Aggregate_Fields = {
  __typename?: 'course_cancellation_fee_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Cancellation_Fee_Type_Max_Fields>;
  min?: Maybe<Course_Cancellation_Fee_Type_Min_Fields>;
};


/** aggregate fields of "course_cancellation_fee_type" */
export type Course_Cancellation_Fee_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Cancellation_Fee_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_cancellation_fee_type". All fields are combined with a logical 'AND'. */
export type Course_Cancellation_Fee_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Cancellation_Fee_Type_Bool_Exp>>;
  _not?: InputMaybe<Course_Cancellation_Fee_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Cancellation_Fee_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_cancellation_fee_type" */
export enum Course_Cancellation_Fee_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseCancellationFeeTypePkey = 'course_cancellation_fee_type_pkey'
}

export enum Course_Cancellation_Fee_Type_Enum {
  ApplyCancellationTerms = 'APPLY_CANCELLATION_TERMS',
  CustomFee = 'CUSTOM_FEE',
  NoFees = 'NO_FEES'
}

/** Boolean expression to compare columns of type "course_cancellation_fee_type_enum". All fields are combined with logical 'AND'. */
export type Course_Cancellation_Fee_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Cancellation_Fee_Type_Enum>;
  _in?: InputMaybe<Array<Course_Cancellation_Fee_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Cancellation_Fee_Type_Enum>;
  _nin?: InputMaybe<Array<Course_Cancellation_Fee_Type_Enum>>;
};

/** input type for inserting data into table "course_cancellation_fee_type" */
export type Course_Cancellation_Fee_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Cancellation_Fee_Type_Max_Fields = {
  __typename?: 'course_cancellation_fee_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Cancellation_Fee_Type_Min_Fields = {
  __typename?: 'course_cancellation_fee_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_cancellation_fee_type" */
export type Course_Cancellation_Fee_Type_Mutation_Response = {
  __typename?: 'course_cancellation_fee_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Cancellation_Fee_Type>;
};

/** on_conflict condition type for table "course_cancellation_fee_type" */
export type Course_Cancellation_Fee_Type_On_Conflict = {
  constraint: Course_Cancellation_Fee_Type_Constraint;
  update_columns?: Array<Course_Cancellation_Fee_Type_Update_Column>;
  where?: InputMaybe<Course_Cancellation_Fee_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "course_cancellation_fee_type". */
export type Course_Cancellation_Fee_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_cancellation_fee_type */
export type Course_Cancellation_Fee_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "course_cancellation_fee_type" */
export enum Course_Cancellation_Fee_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_cancellation_fee_type" */
export type Course_Cancellation_Fee_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_cancellation_fee_type" */
export type Course_Cancellation_Fee_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Cancellation_Fee_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Cancellation_Fee_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_cancellation_fee_type" */
export enum Course_Cancellation_Fee_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Cancellation_Fee_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Cancellation_Fee_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Cancellation_Fee_Type_Bool_Exp;
};

/** columns and relationships of "course_cancellation_request" */
export type Course_Cancellation_Request = {
  __typename?: 'course_cancellation_request';
  /** An object relationship */
  course: Course;
  course_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  profile: Profile;
  reason: Scalars['String'];
  requested_by: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "course_cancellation_request" */
export type Course_Cancellation_Request_Aggregate = {
  __typename?: 'course_cancellation_request_aggregate';
  aggregate?: Maybe<Course_Cancellation_Request_Aggregate_Fields>;
  nodes: Array<Course_Cancellation_Request>;
};

/** aggregate fields of "course_cancellation_request" */
export type Course_Cancellation_Request_Aggregate_Fields = {
  __typename?: 'course_cancellation_request_aggregate_fields';
  avg?: Maybe<Course_Cancellation_Request_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Cancellation_Request_Max_Fields>;
  min?: Maybe<Course_Cancellation_Request_Min_Fields>;
  stddev?: Maybe<Course_Cancellation_Request_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Cancellation_Request_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Cancellation_Request_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Cancellation_Request_Sum_Fields>;
  var_pop?: Maybe<Course_Cancellation_Request_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Cancellation_Request_Var_Samp_Fields>;
  variance?: Maybe<Course_Cancellation_Request_Variance_Fields>;
};


/** aggregate fields of "course_cancellation_request" */
export type Course_Cancellation_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Cancellation_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Course_Cancellation_Request_Avg_Fields = {
  __typename?: 'course_cancellation_request_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "course_cancellation_request". All fields are combined with a logical 'AND'. */
export type Course_Cancellation_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Cancellation_Request_Bool_Exp>>;
  _not?: InputMaybe<Course_Cancellation_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Cancellation_Request_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
  requested_by?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_cancellation_request" */
export enum Course_Cancellation_Request_Constraint {
  /** unique or primary key constraint on columns "course_id" */
  CourseCancellationRequestCourseIdKey = 'course_cancellation_request_course_id_key',
  /** unique or primary key constraint on columns "id" */
  CourseCancellationRequestPkey = 'course_cancellation_request_pkey'
}

/** input type for incrementing numeric columns in table "course_cancellation_request" */
export type Course_Cancellation_Request_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_cancellation_request" */
export type Course_Cancellation_Request_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  reason?: InputMaybe<Scalars['String']>;
  requested_by?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Cancellation_Request_Max_Fields = {
  __typename?: 'course_cancellation_request_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  requested_by?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Course_Cancellation_Request_Min_Fields = {
  __typename?: 'course_cancellation_request_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  reason?: Maybe<Scalars['String']>;
  requested_by?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "course_cancellation_request" */
export type Course_Cancellation_Request_Mutation_Response = {
  __typename?: 'course_cancellation_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Cancellation_Request>;
};

/** input type for inserting object relation for remote table "course_cancellation_request" */
export type Course_Cancellation_Request_Obj_Rel_Insert_Input = {
  data: Course_Cancellation_Request_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Cancellation_Request_On_Conflict>;
};

/** on_conflict condition type for table "course_cancellation_request" */
export type Course_Cancellation_Request_On_Conflict = {
  constraint: Course_Cancellation_Request_Constraint;
  update_columns?: Array<Course_Cancellation_Request_Update_Column>;
  where?: InputMaybe<Course_Cancellation_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "course_cancellation_request". */
export type Course_Cancellation_Request_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  reason?: InputMaybe<Order_By>;
  requested_by?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_cancellation_request */
export type Course_Cancellation_Request_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_cancellation_request" */
export enum Course_Cancellation_Request_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  RequestedBy = 'requested_by',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "course_cancellation_request" */
export type Course_Cancellation_Request_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  requested_by?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Cancellation_Request_Stddev_Fields = {
  __typename?: 'course_cancellation_request_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Course_Cancellation_Request_Stddev_Pop_Fields = {
  __typename?: 'course_cancellation_request_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Course_Cancellation_Request_Stddev_Samp_Fields = {
  __typename?: 'course_cancellation_request_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "course_cancellation_request" */
export type Course_Cancellation_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Cancellation_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Cancellation_Request_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  reason?: InputMaybe<Scalars['String']>;
  requested_by?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Cancellation_Request_Sum_Fields = {
  __typename?: 'course_cancellation_request_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "course_cancellation_request" */
export enum Course_Cancellation_Request_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Reason = 'reason',
  /** column name */
  RequestedBy = 'requested_by',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Course_Cancellation_Request_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Cancellation_Request_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Cancellation_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Cancellation_Request_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Cancellation_Request_Var_Pop_Fields = {
  __typename?: 'course_cancellation_request_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Course_Cancellation_Request_Var_Samp_Fields = {
  __typename?: 'course_cancellation_request_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Course_Cancellation_Request_Variance_Fields = {
  __typename?: 'course_cancellation_request_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "course_certificate" */
export type Course_Certificate = {
  __typename?: 'course_certificate';
  blendedLearning?: Maybe<Scalars['Boolean']>;
  certificationDate: Scalars['date'];
  /** An object relationship */
  course?: Maybe<Course>;
  courseAccreditedBy?: Maybe<Accreditors_Enum>;
  courseId?: Maybe<Scalars['Int']>;
  courseLevel: Scalars['String'];
  courseName: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  expiryDate: Scalars['date'];
  /** A computed field, executes function "course_certificate_grade" */
  grade?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  isRevoked: Scalars['Boolean'];
  legacyCourseCode?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  /** An object relationship */
  participant?: Maybe<Course_Participant>;
  /** An object relationship */
  profile?: Maybe<Profile>;
  profileId: Scalars['uuid'];
  reaccreditation?: Maybe<Scalars['Boolean']>;
  status?: Maybe<Certificate_Status_Enum>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "course_certificate" */
export type Course_Certificate_Aggregate = {
  __typename?: 'course_certificate_aggregate';
  aggregate?: Maybe<Course_Certificate_Aggregate_Fields>;
  nodes: Array<Course_Certificate>;
};

export type Course_Certificate_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Course_Certificate_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Course_Certificate_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Course_Certificate_Aggregate_Bool_Exp_Count>;
};

export type Course_Certificate_Aggregate_Bool_Exp_Bool_And = {
  arguments: Course_Certificate_Select_Column_Course_Certificate_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Certificate_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Certificate_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Course_Certificate_Select_Column_Course_Certificate_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Certificate_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Certificate_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Certificate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Certificate_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_certificate" */
export type Course_Certificate_Aggregate_Fields = {
  __typename?: 'course_certificate_aggregate_fields';
  avg?: Maybe<Course_Certificate_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Certificate_Max_Fields>;
  min?: Maybe<Course_Certificate_Min_Fields>;
  stddev?: Maybe<Course_Certificate_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Certificate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Certificate_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Certificate_Sum_Fields>;
  var_pop?: Maybe<Course_Certificate_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Certificate_Var_Samp_Fields>;
  variance?: Maybe<Course_Certificate_Variance_Fields>;
};


/** aggregate fields of "course_certificate" */
export type Course_Certificate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Certificate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_certificate" */
export type Course_Certificate_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Certificate_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Certificate_Max_Order_By>;
  min?: InputMaybe<Course_Certificate_Min_Order_By>;
  stddev?: InputMaybe<Course_Certificate_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Certificate_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Certificate_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Certificate_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Certificate_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Certificate_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Certificate_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_certificate" */
export type Course_Certificate_Arr_Rel_Insert_Input = {
  data: Array<Course_Certificate_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Certificate_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Certificate_Avg_Fields = {
  __typename?: 'course_certificate_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_certificate" */
export type Course_Certificate_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_certificate". All fields are combined with a logical 'AND'. */
export type Course_Certificate_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Certificate_Bool_Exp>>;
  _not?: InputMaybe<Course_Certificate_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Certificate_Bool_Exp>>;
  blendedLearning?: InputMaybe<Boolean_Comparison_Exp>;
  certificationDate?: InputMaybe<Date_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseAccreditedBy?: InputMaybe<Accreditors_Enum_Comparison_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  courseLevel?: InputMaybe<String_Comparison_Exp>;
  courseName?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiryDate?: InputMaybe<Date_Comparison_Exp>;
  grade?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isRevoked?: InputMaybe<Boolean_Comparison_Exp>;
  legacyCourseCode?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  participant?: InputMaybe<Course_Participant_Bool_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profileId?: InputMaybe<Uuid_Comparison_Exp>;
  reaccreditation?: InputMaybe<Boolean_Comparison_Exp>;
  status?: InputMaybe<Certificate_Status_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "course_certificate_changelog" */
export type Course_Certificate_Changelog = {
  __typename?: 'course_certificate_changelog';
  /** An object relationship */
  author: Profile;
  authorId: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  participant: Course_Participant;
  participantId: Scalars['uuid'];
  payload?: Maybe<Scalars['jsonb']>;
  type: Course_Certificate_Changelog_Type_Enum;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "course_certificate_changelog" */
export type Course_Certificate_ChangelogPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "course_certificate_changelog" */
export type Course_Certificate_Changelog_Aggregate = {
  __typename?: 'course_certificate_changelog_aggregate';
  aggregate?: Maybe<Course_Certificate_Changelog_Aggregate_Fields>;
  nodes: Array<Course_Certificate_Changelog>;
};

export type Course_Certificate_Changelog_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Certificate_Changelog_Aggregate_Bool_Exp_Count>;
};

export type Course_Certificate_Changelog_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Certificate_Changelog_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Certificate_Changelog_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_certificate_changelog" */
export type Course_Certificate_Changelog_Aggregate_Fields = {
  __typename?: 'course_certificate_changelog_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Certificate_Changelog_Max_Fields>;
  min?: Maybe<Course_Certificate_Changelog_Min_Fields>;
};


/** aggregate fields of "course_certificate_changelog" */
export type Course_Certificate_Changelog_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Certificate_Changelog_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_certificate_changelog" */
export type Course_Certificate_Changelog_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Certificate_Changelog_Max_Order_By>;
  min?: InputMaybe<Course_Certificate_Changelog_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Course_Certificate_Changelog_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "course_certificate_changelog" */
export type Course_Certificate_Changelog_Arr_Rel_Insert_Input = {
  data: Array<Course_Certificate_Changelog_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Certificate_Changelog_On_Conflict>;
};

/** Boolean expression to filter rows from the table "course_certificate_changelog". All fields are combined with a logical 'AND'. */
export type Course_Certificate_Changelog_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Certificate_Changelog_Bool_Exp>>;
  _not?: InputMaybe<Course_Certificate_Changelog_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Certificate_Changelog_Bool_Exp>>;
  author?: InputMaybe<Profile_Bool_Exp>;
  authorId?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  participant?: InputMaybe<Course_Participant_Bool_Exp>;
  participantId?: InputMaybe<Uuid_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<Course_Certificate_Changelog_Type_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_certificate_changelog" */
export enum Course_Certificate_Changelog_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseCertificateChangelogPkey = 'course_certificate_changelog_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Course_Certificate_Changelog_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Course_Certificate_Changelog_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Course_Certificate_Changelog_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "course_certificate_changelog" */
export type Course_Certificate_Changelog_Insert_Input = {
  author?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  authorId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  participant?: InputMaybe<Course_Participant_Obj_Rel_Insert_Input>;
  participantId?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Course_Certificate_Changelog_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Certificate_Changelog_Max_Fields = {
  __typename?: 'course_certificate_changelog_max_fields';
  authorId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  participantId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_certificate_changelog" */
export type Course_Certificate_Changelog_Max_Order_By = {
  authorId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Certificate_Changelog_Min_Fields = {
  __typename?: 'course_certificate_changelog_min_fields';
  authorId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  participantId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_certificate_changelog" */
export type Course_Certificate_Changelog_Min_Order_By = {
  authorId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_certificate_changelog" */
export type Course_Certificate_Changelog_Mutation_Response = {
  __typename?: 'course_certificate_changelog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Certificate_Changelog>;
};

/** on_conflict condition type for table "course_certificate_changelog" */
export type Course_Certificate_Changelog_On_Conflict = {
  constraint: Course_Certificate_Changelog_Constraint;
  update_columns?: Array<Course_Certificate_Changelog_Update_Column>;
  where?: InputMaybe<Course_Certificate_Changelog_Bool_Exp>;
};

/** Ordering options when selecting data from "course_certificate_changelog". */
export type Course_Certificate_Changelog_Order_By = {
  author?: InputMaybe<Profile_Order_By>;
  authorId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participant?: InputMaybe<Course_Participant_Order_By>;
  participantId?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_certificate_changelog */
export type Course_Certificate_Changelog_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Course_Certificate_Changelog_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "course_certificate_changelog" */
export enum Course_Certificate_Changelog_Select_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParticipantId = 'participantId',
  /** column name */
  Payload = 'payload',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "course_certificate_changelog" */
export type Course_Certificate_Changelog_Set_Input = {
  authorId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  participantId?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Course_Certificate_Changelog_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "course_certificate_changelog" */
export type Course_Certificate_Changelog_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Certificate_Changelog_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Certificate_Changelog_Stream_Cursor_Value_Input = {
  authorId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  participantId?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Course_Certificate_Changelog_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** columns and relationships of "course_certificate_changelog_type" */
export type Course_Certificate_Changelog_Type = {
  __typename?: 'course_certificate_changelog_type';
  name: Scalars['String'];
};

/** aggregated selection of "course_certificate_changelog_type" */
export type Course_Certificate_Changelog_Type_Aggregate = {
  __typename?: 'course_certificate_changelog_type_aggregate';
  aggregate?: Maybe<Course_Certificate_Changelog_Type_Aggregate_Fields>;
  nodes: Array<Course_Certificate_Changelog_Type>;
};

/** aggregate fields of "course_certificate_changelog_type" */
export type Course_Certificate_Changelog_Type_Aggregate_Fields = {
  __typename?: 'course_certificate_changelog_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Certificate_Changelog_Type_Max_Fields>;
  min?: Maybe<Course_Certificate_Changelog_Type_Min_Fields>;
};


/** aggregate fields of "course_certificate_changelog_type" */
export type Course_Certificate_Changelog_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Certificate_Changelog_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_certificate_changelog_type". All fields are combined with a logical 'AND'. */
export type Course_Certificate_Changelog_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Certificate_Changelog_Type_Bool_Exp>>;
  _not?: InputMaybe<Course_Certificate_Changelog_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Certificate_Changelog_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_certificate_changelog_type" */
export enum Course_Certificate_Changelog_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseCertificateChangelogTypePkey = 'course_certificate_changelog_type_pkey'
}

export enum Course_Certificate_Changelog_Type_Enum {
  GradeModified = 'GRADE_MODIFIED',
  PutOnHold = 'PUT_ON_HOLD',
  Revoked = 'REVOKED',
  Unrevoked = 'UNREVOKED'
}

/** Boolean expression to compare columns of type "course_certificate_changelog_type_enum". All fields are combined with logical 'AND'. */
export type Course_Certificate_Changelog_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Certificate_Changelog_Type_Enum>;
  _in?: InputMaybe<Array<Course_Certificate_Changelog_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Certificate_Changelog_Type_Enum>;
  _nin?: InputMaybe<Array<Course_Certificate_Changelog_Type_Enum>>;
};

/** input type for inserting data into table "course_certificate_changelog_type" */
export type Course_Certificate_Changelog_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Certificate_Changelog_Type_Max_Fields = {
  __typename?: 'course_certificate_changelog_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Certificate_Changelog_Type_Min_Fields = {
  __typename?: 'course_certificate_changelog_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_certificate_changelog_type" */
export type Course_Certificate_Changelog_Type_Mutation_Response = {
  __typename?: 'course_certificate_changelog_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Certificate_Changelog_Type>;
};

/** on_conflict condition type for table "course_certificate_changelog_type" */
export type Course_Certificate_Changelog_Type_On_Conflict = {
  constraint: Course_Certificate_Changelog_Type_Constraint;
  update_columns?: Array<Course_Certificate_Changelog_Type_Update_Column>;
  where?: InputMaybe<Course_Certificate_Changelog_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "course_certificate_changelog_type". */
export type Course_Certificate_Changelog_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_certificate_changelog_type */
export type Course_Certificate_Changelog_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "course_certificate_changelog_type" */
export enum Course_Certificate_Changelog_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_certificate_changelog_type" */
export type Course_Certificate_Changelog_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_certificate_changelog_type" */
export type Course_Certificate_Changelog_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Certificate_Changelog_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Certificate_Changelog_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_certificate_changelog_type" */
export enum Course_Certificate_Changelog_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Certificate_Changelog_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Certificate_Changelog_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Certificate_Changelog_Type_Bool_Exp;
};

/** update columns of table "course_certificate_changelog" */
export enum Course_Certificate_Changelog_Update_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ParticipantId = 'participantId',
  /** column name */
  Payload = 'payload',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Course_Certificate_Changelog_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Course_Certificate_Changelog_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Course_Certificate_Changelog_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Course_Certificate_Changelog_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Course_Certificate_Changelog_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Course_Certificate_Changelog_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Certificate_Changelog_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Certificate_Changelog_Bool_Exp;
};

/** unique or primary key constraints on table "course_certificate" */
export enum Course_Certificate_Constraint {
  /** unique or primary key constraint on columns "number" */
  CourseCertificateNumberKey = 'course_certificate_number_key',
  /** unique or primary key constraint on columns "id" */
  CourseCertificatePkey = 'course_certificate_pkey'
}

/** columns and relationships of "course_certificate_hold_request" */
export type Course_Certificate_Hold_Request = {
  __typename?: 'course_certificate_hold_request';
  /** An object relationship */
  certificate: Course_Certificate;
  certificate_id: Scalars['uuid'];
  changelog_id: Scalars['uuid'];
  expiry_date: Scalars['timestamp'];
  id: Scalars['uuid'];
  start_date: Scalars['date'];
};

/** aggregated selection of "course_certificate_hold_request" */
export type Course_Certificate_Hold_Request_Aggregate = {
  __typename?: 'course_certificate_hold_request_aggregate';
  aggregate?: Maybe<Course_Certificate_Hold_Request_Aggregate_Fields>;
  nodes: Array<Course_Certificate_Hold_Request>;
};

/** aggregate fields of "course_certificate_hold_request" */
export type Course_Certificate_Hold_Request_Aggregate_Fields = {
  __typename?: 'course_certificate_hold_request_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Certificate_Hold_Request_Max_Fields>;
  min?: Maybe<Course_Certificate_Hold_Request_Min_Fields>;
};


/** aggregate fields of "course_certificate_hold_request" */
export type Course_Certificate_Hold_Request_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Certificate_Hold_Request_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_certificate_hold_request". All fields are combined with a logical 'AND'. */
export type Course_Certificate_Hold_Request_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Certificate_Hold_Request_Bool_Exp>>;
  _not?: InputMaybe<Course_Certificate_Hold_Request_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Certificate_Hold_Request_Bool_Exp>>;
  certificate?: InputMaybe<Course_Certificate_Bool_Exp>;
  certificate_id?: InputMaybe<Uuid_Comparison_Exp>;
  changelog_id?: InputMaybe<Uuid_Comparison_Exp>;
  expiry_date?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  start_date?: InputMaybe<Date_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_certificate_hold_request" */
export enum Course_Certificate_Hold_Request_Constraint {
  /** unique or primary key constraint on columns "certificate_id" */
  CourseCertificateHoldRequestCertificateIdKey = 'course_certificate_hold_request_certificate_id_key',
  /** unique or primary key constraint on columns "changelog_id" */
  CourseCertificateHoldRequestChangelogIdKey = 'course_certificate_hold_request_changelog_id_key',
  /** unique or primary key constraint on columns "id" */
  CourseCertificateHoldRequestPkey = 'course_certificate_hold_request_pkey'
}

/** input type for inserting data into table "course_certificate_hold_request" */
export type Course_Certificate_Hold_Request_Insert_Input = {
  certificate?: InputMaybe<Course_Certificate_Obj_Rel_Insert_Input>;
  certificate_id?: InputMaybe<Scalars['uuid']>;
  changelog_id?: InputMaybe<Scalars['uuid']>;
  expiry_date?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  start_date?: InputMaybe<Scalars['date']>;
};

/** aggregate max on columns */
export type Course_Certificate_Hold_Request_Max_Fields = {
  __typename?: 'course_certificate_hold_request_max_fields';
  certificate_id?: Maybe<Scalars['uuid']>;
  changelog_id?: Maybe<Scalars['uuid']>;
  expiry_date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['date']>;
};

/** aggregate min on columns */
export type Course_Certificate_Hold_Request_Min_Fields = {
  __typename?: 'course_certificate_hold_request_min_fields';
  certificate_id?: Maybe<Scalars['uuid']>;
  changelog_id?: Maybe<Scalars['uuid']>;
  expiry_date?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  start_date?: Maybe<Scalars['date']>;
};

/** response of any mutation on the table "course_certificate_hold_request" */
export type Course_Certificate_Hold_Request_Mutation_Response = {
  __typename?: 'course_certificate_hold_request_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Certificate_Hold_Request>;
};

/** on_conflict condition type for table "course_certificate_hold_request" */
export type Course_Certificate_Hold_Request_On_Conflict = {
  constraint: Course_Certificate_Hold_Request_Constraint;
  update_columns?: Array<Course_Certificate_Hold_Request_Update_Column>;
  where?: InputMaybe<Course_Certificate_Hold_Request_Bool_Exp>;
};

/** Ordering options when selecting data from "course_certificate_hold_request". */
export type Course_Certificate_Hold_Request_Order_By = {
  certificate?: InputMaybe<Course_Certificate_Order_By>;
  certificate_id?: InputMaybe<Order_By>;
  changelog_id?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_certificate_hold_request */
export type Course_Certificate_Hold_Request_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_certificate_hold_request" */
export enum Course_Certificate_Hold_Request_Select_Column {
  /** column name */
  CertificateId = 'certificate_id',
  /** column name */
  ChangelogId = 'changelog_id',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  StartDate = 'start_date'
}

/** input type for updating data in table "course_certificate_hold_request" */
export type Course_Certificate_Hold_Request_Set_Input = {
  certificate_id?: InputMaybe<Scalars['uuid']>;
  changelog_id?: InputMaybe<Scalars['uuid']>;
  expiry_date?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  start_date?: InputMaybe<Scalars['date']>;
};

/** Streaming cursor of the table "course_certificate_hold_request" */
export type Course_Certificate_Hold_Request_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Certificate_Hold_Request_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Certificate_Hold_Request_Stream_Cursor_Value_Input = {
  certificate_id?: InputMaybe<Scalars['uuid']>;
  changelog_id?: InputMaybe<Scalars['uuid']>;
  expiry_date?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  start_date?: InputMaybe<Scalars['date']>;
};

/** update columns of table "course_certificate_hold_request" */
export enum Course_Certificate_Hold_Request_Update_Column {
  /** column name */
  CertificateId = 'certificate_id',
  /** column name */
  ChangelogId = 'changelog_id',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  StartDate = 'start_date'
}

export type Course_Certificate_Hold_Request_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Certificate_Hold_Request_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Certificate_Hold_Request_Bool_Exp;
};

/** input type for incrementing numeric columns in table "course_certificate" */
export type Course_Certificate_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_certificate" */
export type Course_Certificate_Insert_Input = {
  blendedLearning?: InputMaybe<Scalars['Boolean']>;
  certificationDate?: InputMaybe<Scalars['date']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseAccreditedBy?: InputMaybe<Accreditors_Enum>;
  courseId?: InputMaybe<Scalars['Int']>;
  courseLevel?: InputMaybe<Scalars['String']>;
  courseName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiryDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isRevoked?: InputMaybe<Scalars['Boolean']>;
  legacyCourseCode?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  participant?: InputMaybe<Course_Participant_Obj_Rel_Insert_Input>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profileId?: InputMaybe<Scalars['uuid']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Certificate_Status_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Certificate_Max_Fields = {
  __typename?: 'course_certificate_max_fields';
  certificationDate?: Maybe<Scalars['date']>;
  courseId?: Maybe<Scalars['Int']>;
  courseLevel?: Maybe<Scalars['String']>;
  courseName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiryDate?: Maybe<Scalars['date']>;
  /** A computed field, executes function "course_certificate_grade" */
  grade?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  legacyCourseCode?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_certificate" */
export type Course_Certificate_Max_Order_By = {
  certificationDate?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  courseLevel?: InputMaybe<Order_By>;
  courseName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiryDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyCourseCode?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Certificate_Min_Fields = {
  __typename?: 'course_certificate_min_fields';
  certificationDate?: Maybe<Scalars['date']>;
  courseId?: Maybe<Scalars['Int']>;
  courseLevel?: Maybe<Scalars['String']>;
  courseName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  expiryDate?: Maybe<Scalars['date']>;
  /** A computed field, executes function "course_certificate_grade" */
  grade?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  legacyCourseCode?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_certificate" */
export type Course_Certificate_Min_Order_By = {
  certificationDate?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  courseLevel?: InputMaybe<Order_By>;
  courseName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiryDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  legacyCourseCode?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_certificate" */
export type Course_Certificate_Mutation_Response = {
  __typename?: 'course_certificate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Certificate>;
};

/** input type for inserting object relation for remote table "course_certificate" */
export type Course_Certificate_Obj_Rel_Insert_Input = {
  data: Course_Certificate_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Certificate_On_Conflict>;
};

/** on_conflict condition type for table "course_certificate" */
export type Course_Certificate_On_Conflict = {
  constraint: Course_Certificate_Constraint;
  update_columns?: Array<Course_Certificate_Update_Column>;
  where?: InputMaybe<Course_Certificate_Bool_Exp>;
};

/** Ordering options when selecting data from "course_certificate". */
export type Course_Certificate_Order_By = {
  blendedLearning?: InputMaybe<Order_By>;
  certificationDate?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseAccreditedBy?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  courseLevel?: InputMaybe<Order_By>;
  courseName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  expiryDate?: InputMaybe<Order_By>;
  grade?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isRevoked?: InputMaybe<Order_By>;
  legacyCourseCode?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  participant?: InputMaybe<Course_Participant_Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profileId?: InputMaybe<Order_By>;
  reaccreditation?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_certificate */
export type Course_Certificate_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_certificate" */
export enum Course_Certificate_Select_Column {
  /** column name */
  BlendedLearning = 'blendedLearning',
  /** column name */
  CertificationDate = 'certificationDate',
  /** column name */
  CourseAccreditedBy = 'courseAccreditedBy',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CourseLevel = 'courseLevel',
  /** column name */
  CourseName = 'courseName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiryDate = 'expiryDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsRevoked = 'isRevoked',
  /** column name */
  LegacyCourseCode = 'legacyCourseCode',
  /** column name */
  Number = 'number',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  Reaccreditation = 'reaccreditation',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "course_certificate_aggregate_bool_exp_bool_and_arguments_columns" columns of table "course_certificate" */
export enum Course_Certificate_Select_Column_Course_Certificate_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  BlendedLearning = 'blendedLearning',
  /** column name */
  IsRevoked = 'isRevoked',
  /** column name */
  Reaccreditation = 'reaccreditation'
}

/** select "course_certificate_aggregate_bool_exp_bool_or_arguments_columns" columns of table "course_certificate" */
export enum Course_Certificate_Select_Column_Course_Certificate_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  BlendedLearning = 'blendedLearning',
  /** column name */
  IsRevoked = 'isRevoked',
  /** column name */
  Reaccreditation = 'reaccreditation'
}

/** input type for updating data in table "course_certificate" */
export type Course_Certificate_Set_Input = {
  blendedLearning?: InputMaybe<Scalars['Boolean']>;
  certificationDate?: InputMaybe<Scalars['date']>;
  courseAccreditedBy?: InputMaybe<Accreditors_Enum>;
  courseId?: InputMaybe<Scalars['Int']>;
  courseLevel?: InputMaybe<Scalars['String']>;
  courseName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiryDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isRevoked?: InputMaybe<Scalars['Boolean']>;
  legacyCourseCode?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Certificate_Status_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Certificate_Stddev_Fields = {
  __typename?: 'course_certificate_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_certificate" */
export type Course_Certificate_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Certificate_Stddev_Pop_Fields = {
  __typename?: 'course_certificate_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_certificate" */
export type Course_Certificate_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Certificate_Stddev_Samp_Fields = {
  __typename?: 'course_certificate_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_certificate" */
export type Course_Certificate_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_certificate" */
export type Course_Certificate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Certificate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Certificate_Stream_Cursor_Value_Input = {
  blendedLearning?: InputMaybe<Scalars['Boolean']>;
  certificationDate?: InputMaybe<Scalars['date']>;
  courseAccreditedBy?: InputMaybe<Accreditors_Enum>;
  courseId?: InputMaybe<Scalars['Int']>;
  courseLevel?: InputMaybe<Scalars['String']>;
  courseName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  expiryDate?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  isRevoked?: InputMaybe<Scalars['Boolean']>;
  legacyCourseCode?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  status?: InputMaybe<Certificate_Status_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Certificate_Sum_Fields = {
  __typename?: 'course_certificate_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_certificate" */
export type Course_Certificate_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** update columns of table "course_certificate" */
export enum Course_Certificate_Update_Column {
  /** column name */
  BlendedLearning = 'blendedLearning',
  /** column name */
  CertificationDate = 'certificationDate',
  /** column name */
  CourseAccreditedBy = 'courseAccreditedBy',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CourseLevel = 'courseLevel',
  /** column name */
  CourseName = 'courseName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  ExpiryDate = 'expiryDate',
  /** column name */
  Id = 'id',
  /** column name */
  IsRevoked = 'isRevoked',
  /** column name */
  LegacyCourseCode = 'legacyCourseCode',
  /** column name */
  Number = 'number',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  Reaccreditation = 'reaccreditation',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Course_Certificate_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Certificate_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Certificate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Certificate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Certificate_Var_Pop_Fields = {
  __typename?: 'course_certificate_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_certificate" */
export type Course_Certificate_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Certificate_Var_Samp_Fields = {
  __typename?: 'course_certificate_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_certificate" */
export type Course_Certificate_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Certificate_Variance_Fields = {
  __typename?: 'course_certificate_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_certificate" */
export type Course_Certificate_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** unique or primary key constraints on table "course" */
export enum Course_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseAutoincrementalIdKey = 'course_autoincremental_id_key',
  /** unique or primary key constraint on columns "hubspot_deal_id" */
  CourseHubspotDealIdKey = 'course_hubspot_deal_id_key',
  /** unique or primary key constraint on columns "id" */
  CoursePkey = 'course_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Course_Delete_At_Path_Input = {
  bookingContactInviteData?: InputMaybe<Array<Scalars['String']>>;
  curriculum?: InputMaybe<Array<Scalars['String']>>;
  organizationKeyContactInviteData?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Course_Delete_Elem_Input = {
  bookingContactInviteData?: InputMaybe<Scalars['Int']>;
  curriculum?: InputMaybe<Scalars['Int']>;
  organizationKeyContactInviteData?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Course_Delete_Key_Input = {
  bookingContactInviteData?: InputMaybe<Scalars['String']>;
  curriculum?: InputMaybe<Scalars['String']>;
  organizationKeyContactInviteData?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "course_delivery_type" */
export type Course_Delivery_Type = {
  __typename?: 'course_delivery_type';
  name: Scalars['String'];
};

/** aggregated selection of "course_delivery_type" */
export type Course_Delivery_Type_Aggregate = {
  __typename?: 'course_delivery_type_aggregate';
  aggregate?: Maybe<Course_Delivery_Type_Aggregate_Fields>;
  nodes: Array<Course_Delivery_Type>;
};

/** aggregate fields of "course_delivery_type" */
export type Course_Delivery_Type_Aggregate_Fields = {
  __typename?: 'course_delivery_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Delivery_Type_Max_Fields>;
  min?: Maybe<Course_Delivery_Type_Min_Fields>;
};


/** aggregate fields of "course_delivery_type" */
export type Course_Delivery_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Delivery_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_delivery_type". All fields are combined with a logical 'AND'. */
export type Course_Delivery_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Delivery_Type_Bool_Exp>>;
  _not?: InputMaybe<Course_Delivery_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Delivery_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_delivery_type" */
export enum Course_Delivery_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseDeliveryTypePkey = 'course_delivery_type_pkey'
}

export enum Course_Delivery_Type_Enum {
  F2F = 'F2F',
  Mixed = 'MIXED',
  Virtual = 'VIRTUAL'
}

/** Boolean expression to compare columns of type "course_delivery_type_enum". All fields are combined with logical 'AND'. */
export type Course_Delivery_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Delivery_Type_Enum>;
  _in?: InputMaybe<Array<Course_Delivery_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Delivery_Type_Enum>;
  _nin?: InputMaybe<Array<Course_Delivery_Type_Enum>>;
};

/** input type for inserting data into table "course_delivery_type" */
export type Course_Delivery_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Delivery_Type_Max_Fields = {
  __typename?: 'course_delivery_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Delivery_Type_Min_Fields = {
  __typename?: 'course_delivery_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_delivery_type" */
export type Course_Delivery_Type_Mutation_Response = {
  __typename?: 'course_delivery_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Delivery_Type>;
};

/** on_conflict condition type for table "course_delivery_type" */
export type Course_Delivery_Type_On_Conflict = {
  constraint: Course_Delivery_Type_Constraint;
  update_columns?: Array<Course_Delivery_Type_Update_Column>;
  where?: InputMaybe<Course_Delivery_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "course_delivery_type". */
export type Course_Delivery_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_delivery_type */
export type Course_Delivery_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** Course delivery types with their prefixes (used to generate course codes) */
export type Course_Delivery_Type_Prefix = {
  __typename?: 'course_delivery_type_prefix';
  id: Scalars['uuid'];
  name: Course_Delivery_Type_Enum;
  prefix: Scalars['String'];
};

/** aggregated selection of "course_delivery_type_prefix" */
export type Course_Delivery_Type_Prefix_Aggregate = {
  __typename?: 'course_delivery_type_prefix_aggregate';
  aggregate?: Maybe<Course_Delivery_Type_Prefix_Aggregate_Fields>;
  nodes: Array<Course_Delivery_Type_Prefix>;
};

/** aggregate fields of "course_delivery_type_prefix" */
export type Course_Delivery_Type_Prefix_Aggregate_Fields = {
  __typename?: 'course_delivery_type_prefix_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Delivery_Type_Prefix_Max_Fields>;
  min?: Maybe<Course_Delivery_Type_Prefix_Min_Fields>;
};


/** aggregate fields of "course_delivery_type_prefix" */
export type Course_Delivery_Type_Prefix_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Delivery_Type_Prefix_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_delivery_type_prefix". All fields are combined with a logical 'AND'. */
export type Course_Delivery_Type_Prefix_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Delivery_Type_Prefix_Bool_Exp>>;
  _not?: InputMaybe<Course_Delivery_Type_Prefix_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Delivery_Type_Prefix_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<Course_Delivery_Type_Enum_Comparison_Exp>;
  prefix?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_delivery_type_prefix" */
export enum Course_Delivery_Type_Prefix_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseDeliveryTypePrefixNameKey = 'course_delivery_type_prefix_name_key',
  /** unique or primary key constraint on columns "id" */
  CourseDeliveryTypePrefixPkey = 'course_delivery_type_prefix_pkey',
  /** unique or primary key constraint on columns "prefix" */
  CourseDeliveryTypePrefixPrefixKey = 'course_delivery_type_prefix_prefix_key'
}

/** input type for inserting data into table "course_delivery_type_prefix" */
export type Course_Delivery_Type_Prefix_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Course_Delivery_Type_Enum>;
  prefix?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Delivery_Type_Prefix_Max_Fields = {
  __typename?: 'course_delivery_type_prefix_max_fields';
  id?: Maybe<Scalars['uuid']>;
  prefix?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Delivery_Type_Prefix_Min_Fields = {
  __typename?: 'course_delivery_type_prefix_min_fields';
  id?: Maybe<Scalars['uuid']>;
  prefix?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_delivery_type_prefix" */
export type Course_Delivery_Type_Prefix_Mutation_Response = {
  __typename?: 'course_delivery_type_prefix_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Delivery_Type_Prefix>;
};

/** on_conflict condition type for table "course_delivery_type_prefix" */
export type Course_Delivery_Type_Prefix_On_Conflict = {
  constraint: Course_Delivery_Type_Prefix_Constraint;
  update_columns?: Array<Course_Delivery_Type_Prefix_Update_Column>;
  where?: InputMaybe<Course_Delivery_Type_Prefix_Bool_Exp>;
};

/** Ordering options when selecting data from "course_delivery_type_prefix". */
export type Course_Delivery_Type_Prefix_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  prefix?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_delivery_type_prefix */
export type Course_Delivery_Type_Prefix_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_delivery_type_prefix" */
export enum Course_Delivery_Type_Prefix_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Prefix = 'prefix'
}

/** input type for updating data in table "course_delivery_type_prefix" */
export type Course_Delivery_Type_Prefix_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Course_Delivery_Type_Enum>;
  prefix?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_delivery_type_prefix" */
export type Course_Delivery_Type_Prefix_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Delivery_Type_Prefix_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Delivery_Type_Prefix_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Course_Delivery_Type_Enum>;
  prefix?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_delivery_type_prefix" */
export enum Course_Delivery_Type_Prefix_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Prefix = 'prefix'
}

export type Course_Delivery_Type_Prefix_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Delivery_Type_Prefix_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Delivery_Type_Prefix_Bool_Exp;
};

/** select columns of table "course_delivery_type" */
export enum Course_Delivery_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_delivery_type" */
export type Course_Delivery_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_delivery_type" */
export type Course_Delivery_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Delivery_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Delivery_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_delivery_type" */
export enum Course_Delivery_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Delivery_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Delivery_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Delivery_Type_Bool_Exp;
};

/** Stores course drafts */
export type Course_Draft = {
  __typename?: 'course_draft';
  courseType: Scalars['String'];
  createdAt: Scalars['timestamp'];
  data?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  name?: Maybe<Scalars['String']>;
  /** An object relationship */
  profile: Profile;
  profileId: Scalars['uuid'];
  updatedAt: Scalars['timestamp'];
};


/** Stores course drafts */
export type Course_DraftDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "course_draft" */
export type Course_Draft_Aggregate = {
  __typename?: 'course_draft_aggregate';
  aggregate?: Maybe<Course_Draft_Aggregate_Fields>;
  nodes: Array<Course_Draft>;
};

/** aggregate fields of "course_draft" */
export type Course_Draft_Aggregate_Fields = {
  __typename?: 'course_draft_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Draft_Max_Fields>;
  min?: Maybe<Course_Draft_Min_Fields>;
};


/** aggregate fields of "course_draft" */
export type Course_Draft_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Draft_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Course_Draft_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "course_draft". All fields are combined with a logical 'AND'. */
export type Course_Draft_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Draft_Bool_Exp>>;
  _not?: InputMaybe<Course_Draft_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Draft_Bool_Exp>>;
  courseType?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamp_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profileId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamp_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_draft" */
export enum Course_Draft_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseDraftPkey = 'course_draft_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Course_Draft_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Course_Draft_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Course_Draft_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "course_draft" */
export type Course_Draft_Insert_Input = {
  courseType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** aggregate max on columns */
export type Course_Draft_Max_Fields = {
  __typename?: 'course_draft_max_fields';
  courseType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Course_Draft_Min_Fields = {
  __typename?: 'course_draft_min_fields';
  courseType?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "course_draft" */
export type Course_Draft_Mutation_Response = {
  __typename?: 'course_draft_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Draft>;
};

/** on_conflict condition type for table "course_draft" */
export type Course_Draft_On_Conflict = {
  constraint: Course_Draft_Constraint;
  update_columns?: Array<Course_Draft_Update_Column>;
  where?: InputMaybe<Course_Draft_Bool_Exp>;
};

/** Ordering options when selecting data from "course_draft". */
export type Course_Draft_Order_By = {
  courseType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profileId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_draft */
export type Course_Draft_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Course_Draft_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "course_draft" */
export enum Course_Draft_Select_Column {
  /** column name */
  CourseType = 'courseType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "course_draft" */
export type Course_Draft_Set_Input = {
  courseType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** Streaming cursor of the table "course_draft" */
export type Course_Draft_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Draft_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Draft_Stream_Cursor_Value_Input = {
  courseType?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamp']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamp']>;
};

/** update columns of table "course_draft" */
export enum Course_Draft_Update_Column {
  /** column name */
  CourseType = 'courseType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Course_Draft_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Course_Draft_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Course_Draft_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Course_Draft_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Course_Draft_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Course_Draft_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Draft_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Draft_Bool_Exp;
};

/** Stores scheduled jobs ids for courses */
export type Course_End_Jobs = {
  __typename?: 'course_end_jobs';
  course_id: Scalars['Int'];
  id: Scalars['uuid'];
  job_id: Scalars['uuid'];
};

/** aggregated selection of "course_end_jobs" */
export type Course_End_Jobs_Aggregate = {
  __typename?: 'course_end_jobs_aggregate';
  aggregate?: Maybe<Course_End_Jobs_Aggregate_Fields>;
  nodes: Array<Course_End_Jobs>;
};

/** aggregate fields of "course_end_jobs" */
export type Course_End_Jobs_Aggregate_Fields = {
  __typename?: 'course_end_jobs_aggregate_fields';
  avg?: Maybe<Course_End_Jobs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_End_Jobs_Max_Fields>;
  min?: Maybe<Course_End_Jobs_Min_Fields>;
  stddev?: Maybe<Course_End_Jobs_Stddev_Fields>;
  stddev_pop?: Maybe<Course_End_Jobs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_End_Jobs_Stddev_Samp_Fields>;
  sum?: Maybe<Course_End_Jobs_Sum_Fields>;
  var_pop?: Maybe<Course_End_Jobs_Var_Pop_Fields>;
  var_samp?: Maybe<Course_End_Jobs_Var_Samp_Fields>;
  variance?: Maybe<Course_End_Jobs_Variance_Fields>;
};


/** aggregate fields of "course_end_jobs" */
export type Course_End_Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_End_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Course_End_Jobs_Avg_Fields = {
  __typename?: 'course_end_jobs_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "course_end_jobs". All fields are combined with a logical 'AND'. */
export type Course_End_Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Course_End_Jobs_Bool_Exp>>;
  _not?: InputMaybe<Course_End_Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Course_End_Jobs_Bool_Exp>>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_end_jobs" */
export enum Course_End_Jobs_Constraint {
  /** unique or primary key constraint on columns "job_id", "course_id" */
  CourseEndJobsCourseIdJobIdKey = 'course_end_jobs_course_id_job_id_key',
  /** unique or primary key constraint on columns "id" */
  CourseEndJobsPkey = 'course_end_jobs_pkey'
}

/** input type for incrementing numeric columns in table "course_end_jobs" */
export type Course_End_Jobs_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_end_jobs" */
export type Course_End_Jobs_Insert_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Course_End_Jobs_Max_Fields = {
  __typename?: 'course_end_jobs_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  job_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Course_End_Jobs_Min_Fields = {
  __typename?: 'course_end_jobs_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  job_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "course_end_jobs" */
export type Course_End_Jobs_Mutation_Response = {
  __typename?: 'course_end_jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_End_Jobs>;
};

/** on_conflict condition type for table "course_end_jobs" */
export type Course_End_Jobs_On_Conflict = {
  constraint: Course_End_Jobs_Constraint;
  update_columns?: Array<Course_End_Jobs_Update_Column>;
  where?: InputMaybe<Course_End_Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "course_end_jobs". */
export type Course_End_Jobs_Order_By = {
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_end_jobs */
export type Course_End_Jobs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_end_jobs" */
export enum Course_End_Jobs_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id'
}

/** input type for updating data in table "course_end_jobs" */
export type Course_End_Jobs_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Course_End_Jobs_Stddev_Fields = {
  __typename?: 'course_end_jobs_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Course_End_Jobs_Stddev_Pop_Fields = {
  __typename?: 'course_end_jobs_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Course_End_Jobs_Stddev_Samp_Fields = {
  __typename?: 'course_end_jobs_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "course_end_jobs" */
export type Course_End_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_End_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_End_Jobs_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Course_End_Jobs_Sum_Fields = {
  __typename?: 'course_end_jobs_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "course_end_jobs" */
export enum Course_End_Jobs_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id'
}

export type Course_End_Jobs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_End_Jobs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_End_Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_End_Jobs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_End_Jobs_Var_Pop_Fields = {
  __typename?: 'course_end_jobs_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Course_End_Jobs_Var_Samp_Fields = {
  __typename?: 'course_end_jobs_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Course_End_Jobs_Variance_Fields = {
  __typename?: 'course_end_jobs_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Enquiries about open courses */
export type Course_Enquiry = {
  __typename?: 'course_enquiry';
  /** An object relationship */
  course: Course;
  courseId: Scalars['Int'];
  created_at?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['uuid'];
  interest: Scalars['String'];
  message?: Maybe<Scalars['String']>;
  orgName: Scalars['String'];
  phone: Scalars['String'];
  sector: Scalars['String'];
  source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "course_enquiry" */
export type Course_Enquiry_Aggregate = {
  __typename?: 'course_enquiry_aggregate';
  aggregate?: Maybe<Course_Enquiry_Aggregate_Fields>;
  nodes: Array<Course_Enquiry>;
};

/** aggregate fields of "course_enquiry" */
export type Course_Enquiry_Aggregate_Fields = {
  __typename?: 'course_enquiry_aggregate_fields';
  avg?: Maybe<Course_Enquiry_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Enquiry_Max_Fields>;
  min?: Maybe<Course_Enquiry_Min_Fields>;
  stddev?: Maybe<Course_Enquiry_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Enquiry_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Enquiry_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Enquiry_Sum_Fields>;
  var_pop?: Maybe<Course_Enquiry_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Enquiry_Var_Samp_Fields>;
  variance?: Maybe<Course_Enquiry_Variance_Fields>;
};


/** aggregate fields of "course_enquiry" */
export type Course_Enquiry_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Enquiry_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Course_Enquiry_Avg_Fields = {
  __typename?: 'course_enquiry_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "course_enquiry". All fields are combined with a logical 'AND'. */
export type Course_Enquiry_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Enquiry_Bool_Exp>>;
  _not?: InputMaybe<Course_Enquiry_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Enquiry_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  familyName?: InputMaybe<String_Comparison_Exp>;
  givenName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  interest?: InputMaybe<String_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  orgName?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  sector?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_enquiry" */
export enum Course_Enquiry_Constraint {
  /** unique or primary key constraint on columns "email", "course_id" */
  CourseEnquiryEmailCourseIdKey = 'course_enquiry_email_course_id_key',
  /** unique or primary key constraint on columns "id" */
  CourseEnquiryPkey = 'course_enquiry_pkey'
}

/** input type for incrementing numeric columns in table "course_enquiry" */
export type Course_Enquiry_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_enquiry" */
export type Course_Enquiry_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  interest?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  orgName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Enquiry_Max_Fields = {
  __typename?: 'course_enquiry_max_fields';
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  interest?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  orgName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Enquiry_Min_Fields = {
  __typename?: 'course_enquiry_min_fields';
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  interest?: Maybe<Scalars['String']>;
  message?: Maybe<Scalars['String']>;
  orgName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_enquiry" */
export type Course_Enquiry_Mutation_Response = {
  __typename?: 'course_enquiry_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Enquiry>;
};

/** on_conflict condition type for table "course_enquiry" */
export type Course_Enquiry_On_Conflict = {
  constraint: Course_Enquiry_Constraint;
  update_columns?: Array<Course_Enquiry_Update_Column>;
  where?: InputMaybe<Course_Enquiry_Bool_Exp>;
};

/** Ordering options when selecting data from "course_enquiry". */
export type Course_Enquiry_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  familyName?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  interest?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  orgName?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  sector?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_enquiry */
export type Course_Enquiry_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_enquiry" */
export enum Course_Enquiry_Select_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  Interest = 'interest',
  /** column name */
  Message = 'message',
  /** column name */
  OrgName = 'orgName',
  /** column name */
  Phone = 'phone',
  /** column name */
  Sector = 'sector',
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "course_enquiry" */
export type Course_Enquiry_Set_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  interest?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  orgName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Course_Enquiry_Stddev_Fields = {
  __typename?: 'course_enquiry_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Course_Enquiry_Stddev_Pop_Fields = {
  __typename?: 'course_enquiry_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Course_Enquiry_Stddev_Samp_Fields = {
  __typename?: 'course_enquiry_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "course_enquiry" */
export type Course_Enquiry_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Enquiry_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Enquiry_Stream_Cursor_Value_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  interest?: InputMaybe<Scalars['String']>;
  message?: InputMaybe<Scalars['String']>;
  orgName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Course_Enquiry_Sum_Fields = {
  __typename?: 'course_enquiry_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
};

/** update columns of table "course_enquiry" */
export enum Course_Enquiry_Update_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  Interest = 'interest',
  /** column name */
  Message = 'message',
  /** column name */
  OrgName = 'orgName',
  /** column name */
  Phone = 'phone',
  /** column name */
  Sector = 'sector',
  /** column name */
  Source = 'source'
}

export type Course_Enquiry_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Enquiry_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Enquiry_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Enquiry_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Enquiry_Var_Pop_Fields = {
  __typename?: 'course_enquiry_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Course_Enquiry_Var_Samp_Fields = {
  __typename?: 'course_enquiry_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Course_Enquiry_Variance_Fields = {
  __typename?: 'course_enquiry_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "course_evaluation_answers" */
export type Course_Evaluation_Answers = {
  __typename?: 'course_evaluation_answers';
  answer?: Maybe<Scalars['String']>;
  /** An object relationship */
  course: Course;
  courseId: Scalars['Int'];
  id: Scalars['uuid'];
  /** An object relationship */
  participant?: Maybe<Course_Participant>;
  /** An object relationship */
  profile: Profile;
  profileId: Scalars['uuid'];
  /** An object relationship */
  question: Course_Evaluation_Questions;
  questionId: Scalars['uuid'];
};

/** aggregated selection of "course_evaluation_answers" */
export type Course_Evaluation_Answers_Aggregate = {
  __typename?: 'course_evaluation_answers_aggregate';
  aggregate?: Maybe<Course_Evaluation_Answers_Aggregate_Fields>;
  nodes: Array<Course_Evaluation_Answers>;
};

export type Course_Evaluation_Answers_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Evaluation_Answers_Aggregate_Bool_Exp_Count>;
};

export type Course_Evaluation_Answers_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Evaluation_Answers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_evaluation_answers" */
export type Course_Evaluation_Answers_Aggregate_Fields = {
  __typename?: 'course_evaluation_answers_aggregate_fields';
  avg?: Maybe<Course_Evaluation_Answers_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Evaluation_Answers_Max_Fields>;
  min?: Maybe<Course_Evaluation_Answers_Min_Fields>;
  stddev?: Maybe<Course_Evaluation_Answers_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Evaluation_Answers_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Evaluation_Answers_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Evaluation_Answers_Sum_Fields>;
  var_pop?: Maybe<Course_Evaluation_Answers_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Evaluation_Answers_Var_Samp_Fields>;
  variance?: Maybe<Course_Evaluation_Answers_Variance_Fields>;
};


/** aggregate fields of "course_evaluation_answers" */
export type Course_Evaluation_Answers_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Evaluation_Answers_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Evaluation_Answers_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Evaluation_Answers_Max_Order_By>;
  min?: InputMaybe<Course_Evaluation_Answers_Min_Order_By>;
  stddev?: InputMaybe<Course_Evaluation_Answers_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Evaluation_Answers_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Evaluation_Answers_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Evaluation_Answers_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Evaluation_Answers_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Evaluation_Answers_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Evaluation_Answers_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Arr_Rel_Insert_Input = {
  data: Array<Course_Evaluation_Answers_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Evaluation_Answers_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Evaluation_Answers_Avg_Fields = {
  __typename?: 'course_evaluation_answers_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_evaluation_answers". All fields are combined with a logical 'AND'. */
export type Course_Evaluation_Answers_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Evaluation_Answers_Bool_Exp>>;
  _not?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Evaluation_Answers_Bool_Exp>>;
  answer?: InputMaybe<String_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  participant?: InputMaybe<Course_Participant_Bool_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profileId?: InputMaybe<Uuid_Comparison_Exp>;
  question?: InputMaybe<Course_Evaluation_Questions_Bool_Exp>;
  questionId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_evaluation_answers" */
export enum Course_Evaluation_Answers_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseEvaluationAnswersPkey = 'course_evaluation_answers_pkey'
}

/** input type for incrementing numeric columns in table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Insert_Input = {
  answer?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  participant?: InputMaybe<Course_Participant_Obj_Rel_Insert_Input>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profileId?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Course_Evaluation_Questions_Obj_Rel_Insert_Input>;
  questionId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Course_Evaluation_Answers_Max_Fields = {
  __typename?: 'course_evaluation_answers_max_fields';
  answer?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  profileId?: Maybe<Scalars['uuid']>;
  questionId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Max_Order_By = {
  answer?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Evaluation_Answers_Min_Fields = {
  __typename?: 'course_evaluation_answers_min_fields';
  answer?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  profileId?: Maybe<Scalars['uuid']>;
  questionId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Min_Order_By = {
  answer?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  questionId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Mutation_Response = {
  __typename?: 'course_evaluation_answers_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Evaluation_Answers>;
};

/** on_conflict condition type for table "course_evaluation_answers" */
export type Course_Evaluation_Answers_On_Conflict = {
  constraint: Course_Evaluation_Answers_Constraint;
  update_columns?: Array<Course_Evaluation_Answers_Update_Column>;
  where?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
};

/** Ordering options when selecting data from "course_evaluation_answers". */
export type Course_Evaluation_Answers_Order_By = {
  answer?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  participant?: InputMaybe<Course_Participant_Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profileId?: InputMaybe<Order_By>;
  question?: InputMaybe<Course_Evaluation_Questions_Order_By>;
  questionId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_evaluation_answers */
export type Course_Evaluation_Answers_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_evaluation_answers" */
export enum Course_Evaluation_Answers_Select_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  QuestionId = 'questionId'
}

/** input type for updating data in table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Set_Input = {
  answer?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  questionId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Course_Evaluation_Answers_Stddev_Fields = {
  __typename?: 'course_evaluation_answers_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Evaluation_Answers_Stddev_Pop_Fields = {
  __typename?: 'course_evaluation_answers_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Evaluation_Answers_Stddev_Samp_Fields = {
  __typename?: 'course_evaluation_answers_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Evaluation_Answers_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Evaluation_Answers_Stream_Cursor_Value_Input = {
  answer?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  questionId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Course_Evaluation_Answers_Sum_Fields = {
  __typename?: 'course_evaluation_answers_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** update columns of table "course_evaluation_answers" */
export enum Course_Evaluation_Answers_Update_Column {
  /** column name */
  Answer = 'answer',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  QuestionId = 'questionId'
}

export type Course_Evaluation_Answers_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Evaluation_Answers_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Evaluation_Answers_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Evaluation_Answers_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Evaluation_Answers_Var_Pop_Fields = {
  __typename?: 'course_evaluation_answers_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Evaluation_Answers_Var_Samp_Fields = {
  __typename?: 'course_evaluation_answers_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Evaluation_Answers_Variance_Fields = {
  __typename?: 'course_evaluation_answers_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_evaluation_answers" */
export type Course_Evaluation_Answers_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_evaluation_question_group" */
export type Course_Evaluation_Question_Group = {
  __typename?: 'course_evaluation_question_group';
  name: Scalars['String'];
};

/** aggregated selection of "course_evaluation_question_group" */
export type Course_Evaluation_Question_Group_Aggregate = {
  __typename?: 'course_evaluation_question_group_aggregate';
  aggregate?: Maybe<Course_Evaluation_Question_Group_Aggregate_Fields>;
  nodes: Array<Course_Evaluation_Question_Group>;
};

/** aggregate fields of "course_evaluation_question_group" */
export type Course_Evaluation_Question_Group_Aggregate_Fields = {
  __typename?: 'course_evaluation_question_group_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Evaluation_Question_Group_Max_Fields>;
  min?: Maybe<Course_Evaluation_Question_Group_Min_Fields>;
};


/** aggregate fields of "course_evaluation_question_group" */
export type Course_Evaluation_Question_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Evaluation_Question_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_evaluation_question_group". All fields are combined with a logical 'AND'. */
export type Course_Evaluation_Question_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Evaluation_Question_Group_Bool_Exp>>;
  _not?: InputMaybe<Course_Evaluation_Question_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Evaluation_Question_Group_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_evaluation_question_group" */
export enum Course_Evaluation_Question_Group_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseEvaluationQuestionGroupPkey = 'course_evaluation_question_group_pkey'
}

export enum Course_Evaluation_Question_Group_Enum {
  MaterialsAndVenue = 'MATERIALS_AND_VENUE',
  TrainerStandards = 'TRAINER_STANDARDS',
  TrainingRating = 'TRAINING_RATING',
  TrainingRelevance = 'TRAINING_RELEVANCE',
  Ungrouped = 'UNGROUPED'
}

/** Boolean expression to compare columns of type "course_evaluation_question_group_enum". All fields are combined with logical 'AND'. */
export type Course_Evaluation_Question_Group_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Evaluation_Question_Group_Enum>;
  _in?: InputMaybe<Array<Course_Evaluation_Question_Group_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Evaluation_Question_Group_Enum>;
  _nin?: InputMaybe<Array<Course_Evaluation_Question_Group_Enum>>;
};

/** input type for inserting data into table "course_evaluation_question_group" */
export type Course_Evaluation_Question_Group_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Evaluation_Question_Group_Max_Fields = {
  __typename?: 'course_evaluation_question_group_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Evaluation_Question_Group_Min_Fields = {
  __typename?: 'course_evaluation_question_group_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_evaluation_question_group" */
export type Course_Evaluation_Question_Group_Mutation_Response = {
  __typename?: 'course_evaluation_question_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Evaluation_Question_Group>;
};

/** on_conflict condition type for table "course_evaluation_question_group" */
export type Course_Evaluation_Question_Group_On_Conflict = {
  constraint: Course_Evaluation_Question_Group_Constraint;
  update_columns?: Array<Course_Evaluation_Question_Group_Update_Column>;
  where?: InputMaybe<Course_Evaluation_Question_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "course_evaluation_question_group". */
export type Course_Evaluation_Question_Group_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_evaluation_question_group */
export type Course_Evaluation_Question_Group_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "course_evaluation_question_group" */
export enum Course_Evaluation_Question_Group_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_evaluation_question_group" */
export type Course_Evaluation_Question_Group_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_evaluation_question_group" */
export type Course_Evaluation_Question_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Evaluation_Question_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Evaluation_Question_Group_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_evaluation_question_group" */
export enum Course_Evaluation_Question_Group_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Evaluation_Question_Group_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Evaluation_Question_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Evaluation_Question_Group_Bool_Exp;
};

/** columns and relationships of "course_evaluation_question_type" */
export type Course_Evaluation_Question_Type = {
  __typename?: 'course_evaluation_question_type';
  name: Scalars['String'];
};

/** aggregated selection of "course_evaluation_question_type" */
export type Course_Evaluation_Question_Type_Aggregate = {
  __typename?: 'course_evaluation_question_type_aggregate';
  aggregate?: Maybe<Course_Evaluation_Question_Type_Aggregate_Fields>;
  nodes: Array<Course_Evaluation_Question_Type>;
};

/** aggregate fields of "course_evaluation_question_type" */
export type Course_Evaluation_Question_Type_Aggregate_Fields = {
  __typename?: 'course_evaluation_question_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Evaluation_Question_Type_Max_Fields>;
  min?: Maybe<Course_Evaluation_Question_Type_Min_Fields>;
};


/** aggregate fields of "course_evaluation_question_type" */
export type Course_Evaluation_Question_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Evaluation_Question_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_evaluation_question_type". All fields are combined with a logical 'AND'. */
export type Course_Evaluation_Question_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Evaluation_Question_Type_Bool_Exp>>;
  _not?: InputMaybe<Course_Evaluation_Question_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Evaluation_Question_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_evaluation_question_type" */
export enum Course_Evaluation_Question_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseEvaluationQuestionTypePkey = 'course_evaluation_question_type_pkey'
}

export enum Course_Evaluation_Question_Type_Enum {
  Boolean = 'BOOLEAN',
  BooleanReasonN = 'BOOLEAN_REASON_N',
  BooleanReasonY = 'BOOLEAN_REASON_Y',
  Rating = 'RATING',
  Text = 'TEXT'
}

/** Boolean expression to compare columns of type "course_evaluation_question_type_enum". All fields are combined with logical 'AND'. */
export type Course_Evaluation_Question_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Evaluation_Question_Type_Enum>;
  _in?: InputMaybe<Array<Course_Evaluation_Question_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Evaluation_Question_Type_Enum>;
  _nin?: InputMaybe<Array<Course_Evaluation_Question_Type_Enum>>;
};

/** input type for inserting data into table "course_evaluation_question_type" */
export type Course_Evaluation_Question_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Evaluation_Question_Type_Max_Fields = {
  __typename?: 'course_evaluation_question_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Evaluation_Question_Type_Min_Fields = {
  __typename?: 'course_evaluation_question_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_evaluation_question_type" */
export type Course_Evaluation_Question_Type_Mutation_Response = {
  __typename?: 'course_evaluation_question_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Evaluation_Question_Type>;
};

/** on_conflict condition type for table "course_evaluation_question_type" */
export type Course_Evaluation_Question_Type_On_Conflict = {
  constraint: Course_Evaluation_Question_Type_Constraint;
  update_columns?: Array<Course_Evaluation_Question_Type_Update_Column>;
  where?: InputMaybe<Course_Evaluation_Question_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "course_evaluation_question_type". */
export type Course_Evaluation_Question_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_evaluation_question_type */
export type Course_Evaluation_Question_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "course_evaluation_question_type" */
export enum Course_Evaluation_Question_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_evaluation_question_type" */
export type Course_Evaluation_Question_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_evaluation_question_type" */
export type Course_Evaluation_Question_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Evaluation_Question_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Evaluation_Question_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_evaluation_question_type" */
export enum Course_Evaluation_Question_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Evaluation_Question_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Evaluation_Question_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Evaluation_Question_Type_Bool_Exp;
};

/** Table for storing text and references of course evaluation questions */
export type Course_Evaluation_Questions = {
  __typename?: 'course_evaluation_questions';
  displayOrder: Scalars['Int'];
  group?: Maybe<Course_Evaluation_Question_Group_Enum>;
  id: Scalars['uuid'];
  question: Scalars['String'];
  questionKey?: Maybe<Scalars['String']>;
  required: Scalars['Boolean'];
  type?: Maybe<Course_Evaluation_Question_Type_Enum>;
};

/** aggregated selection of "course_evaluation_questions" */
export type Course_Evaluation_Questions_Aggregate = {
  __typename?: 'course_evaluation_questions_aggregate';
  aggregate?: Maybe<Course_Evaluation_Questions_Aggregate_Fields>;
  nodes: Array<Course_Evaluation_Questions>;
};

/** aggregate fields of "course_evaluation_questions" */
export type Course_Evaluation_Questions_Aggregate_Fields = {
  __typename?: 'course_evaluation_questions_aggregate_fields';
  avg?: Maybe<Course_Evaluation_Questions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Evaluation_Questions_Max_Fields>;
  min?: Maybe<Course_Evaluation_Questions_Min_Fields>;
  stddev?: Maybe<Course_Evaluation_Questions_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Evaluation_Questions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Evaluation_Questions_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Evaluation_Questions_Sum_Fields>;
  var_pop?: Maybe<Course_Evaluation_Questions_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Evaluation_Questions_Var_Samp_Fields>;
  variance?: Maybe<Course_Evaluation_Questions_Variance_Fields>;
};


/** aggregate fields of "course_evaluation_questions" */
export type Course_Evaluation_Questions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Evaluation_Questions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Course_Evaluation_Questions_Avg_Fields = {
  __typename?: 'course_evaluation_questions_avg_fields';
  displayOrder?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "course_evaluation_questions". All fields are combined with a logical 'AND'. */
export type Course_Evaluation_Questions_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Evaluation_Questions_Bool_Exp>>;
  _not?: InputMaybe<Course_Evaluation_Questions_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Evaluation_Questions_Bool_Exp>>;
  displayOrder?: InputMaybe<Int_Comparison_Exp>;
  group?: InputMaybe<Course_Evaluation_Question_Group_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  question?: InputMaybe<String_Comparison_Exp>;
  questionKey?: InputMaybe<String_Comparison_Exp>;
  required?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<Course_Evaluation_Question_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_evaluation_questions" */
export enum Course_Evaluation_Questions_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseEvaluationQuestionsPkey = 'course_evaluation_questions_pkey',
  /** unique or primary key constraint on columns "question_key" */
  CourseEvaluationQuestionsQuestionKeyKey = 'course_evaluation_questions_question_key_key'
}

/** input type for incrementing numeric columns in table "course_evaluation_questions" */
export type Course_Evaluation_Questions_Inc_Input = {
  displayOrder?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_evaluation_questions" */
export type Course_Evaluation_Questions_Insert_Input = {
  displayOrder?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Course_Evaluation_Question_Group_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
  questionKey?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Course_Evaluation_Question_Type_Enum>;
};

/** aggregate max on columns */
export type Course_Evaluation_Questions_Max_Fields = {
  __typename?: 'course_evaluation_questions_max_fields';
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  questionKey?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Evaluation_Questions_Min_Fields = {
  __typename?: 'course_evaluation_questions_min_fields';
  displayOrder?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  question?: Maybe<Scalars['String']>;
  questionKey?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_evaluation_questions" */
export type Course_Evaluation_Questions_Mutation_Response = {
  __typename?: 'course_evaluation_questions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Evaluation_Questions>;
};

/** input type for inserting object relation for remote table "course_evaluation_questions" */
export type Course_Evaluation_Questions_Obj_Rel_Insert_Input = {
  data: Course_Evaluation_Questions_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Evaluation_Questions_On_Conflict>;
};

/** on_conflict condition type for table "course_evaluation_questions" */
export type Course_Evaluation_Questions_On_Conflict = {
  constraint: Course_Evaluation_Questions_Constraint;
  update_columns?: Array<Course_Evaluation_Questions_Update_Column>;
  where?: InputMaybe<Course_Evaluation_Questions_Bool_Exp>;
};

/** Ordering options when selecting data from "course_evaluation_questions". */
export type Course_Evaluation_Questions_Order_By = {
  displayOrder?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  question?: InputMaybe<Order_By>;
  questionKey?: InputMaybe<Order_By>;
  required?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_evaluation_questions */
export type Course_Evaluation_Questions_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_evaluation_questions" */
export enum Course_Evaluation_Questions_Select_Column {
  /** column name */
  DisplayOrder = 'displayOrder',
  /** column name */
  Group = 'group',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  QuestionKey = 'questionKey',
  /** column name */
  Required = 'required',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "course_evaluation_questions" */
export type Course_Evaluation_Questions_Set_Input = {
  displayOrder?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Course_Evaluation_Question_Group_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
  questionKey?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Course_Evaluation_Question_Type_Enum>;
};

/** aggregate stddev on columns */
export type Course_Evaluation_Questions_Stddev_Fields = {
  __typename?: 'course_evaluation_questions_stddev_fields';
  displayOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Course_Evaluation_Questions_Stddev_Pop_Fields = {
  __typename?: 'course_evaluation_questions_stddev_pop_fields';
  displayOrder?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Course_Evaluation_Questions_Stddev_Samp_Fields = {
  __typename?: 'course_evaluation_questions_stddev_samp_fields';
  displayOrder?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "course_evaluation_questions" */
export type Course_Evaluation_Questions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Evaluation_Questions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Evaluation_Questions_Stream_Cursor_Value_Input = {
  displayOrder?: InputMaybe<Scalars['Int']>;
  group?: InputMaybe<Course_Evaluation_Question_Group_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  question?: InputMaybe<Scalars['String']>;
  questionKey?: InputMaybe<Scalars['String']>;
  required?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Course_Evaluation_Question_Type_Enum>;
};

/** aggregate sum on columns */
export type Course_Evaluation_Questions_Sum_Fields = {
  __typename?: 'course_evaluation_questions_sum_fields';
  displayOrder?: Maybe<Scalars['Int']>;
};

/** update columns of table "course_evaluation_questions" */
export enum Course_Evaluation_Questions_Update_Column {
  /** column name */
  DisplayOrder = 'displayOrder',
  /** column name */
  Group = 'group',
  /** column name */
  Id = 'id',
  /** column name */
  Question = 'question',
  /** column name */
  QuestionKey = 'questionKey',
  /** column name */
  Required = 'required',
  /** column name */
  Type = 'type'
}

export type Course_Evaluation_Questions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Evaluation_Questions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Evaluation_Questions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Evaluation_Questions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Evaluation_Questions_Var_Pop_Fields = {
  __typename?: 'course_evaluation_questions_var_pop_fields';
  displayOrder?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Course_Evaluation_Questions_Var_Samp_Fields = {
  __typename?: 'course_evaluation_questions_var_samp_fields';
  displayOrder?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Course_Evaluation_Questions_Variance_Fields = {
  __typename?: 'course_evaluation_questions_variance_fields';
  displayOrder?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "course_evaluation_scheduled_event" */
export type Course_Evaluation_Scheduled_Event = {
  __typename?: 'course_evaluation_scheduled_event';
  /** An object relationship */
  course: Course;
  course_id: Scalars['Int'];
  /** An object relationship */
  course_participant: Profile;
  event_id: Scalars['uuid'];
  id: Scalars['uuid'];
  profile_id: Scalars['uuid'];
};

/** aggregated selection of "course_evaluation_scheduled_event" */
export type Course_Evaluation_Scheduled_Event_Aggregate = {
  __typename?: 'course_evaluation_scheduled_event_aggregate';
  aggregate?: Maybe<Course_Evaluation_Scheduled_Event_Aggregate_Fields>;
  nodes: Array<Course_Evaluation_Scheduled_Event>;
};

/** aggregate fields of "course_evaluation_scheduled_event" */
export type Course_Evaluation_Scheduled_Event_Aggregate_Fields = {
  __typename?: 'course_evaluation_scheduled_event_aggregate_fields';
  avg?: Maybe<Course_Evaluation_Scheduled_Event_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Evaluation_Scheduled_Event_Max_Fields>;
  min?: Maybe<Course_Evaluation_Scheduled_Event_Min_Fields>;
  stddev?: Maybe<Course_Evaluation_Scheduled_Event_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Evaluation_Scheduled_Event_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Evaluation_Scheduled_Event_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Evaluation_Scheduled_Event_Sum_Fields>;
  var_pop?: Maybe<Course_Evaluation_Scheduled_Event_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Evaluation_Scheduled_Event_Var_Samp_Fields>;
  variance?: Maybe<Course_Evaluation_Scheduled_Event_Variance_Fields>;
};


/** aggregate fields of "course_evaluation_scheduled_event" */
export type Course_Evaluation_Scheduled_Event_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Evaluation_Scheduled_Event_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Course_Evaluation_Scheduled_Event_Avg_Fields = {
  __typename?: 'course_evaluation_scheduled_event_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "course_evaluation_scheduled_event". All fields are combined with a logical 'AND'. */
export type Course_Evaluation_Scheduled_Event_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Evaluation_Scheduled_Event_Bool_Exp>>;
  _not?: InputMaybe<Course_Evaluation_Scheduled_Event_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Evaluation_Scheduled_Event_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  course_participant?: InputMaybe<Profile_Bool_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_evaluation_scheduled_event" */
export enum Course_Evaluation_Scheduled_Event_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseEvaluationScheduledEventPkey = 'course_evaluation_scheduled_event_pkey'
}

/** input type for incrementing numeric columns in table "course_evaluation_scheduled_event" */
export type Course_Evaluation_Scheduled_Event_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_evaluation_scheduled_event" */
export type Course_Evaluation_Scheduled_Event_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['Int']>;
  course_participant?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Course_Evaluation_Scheduled_Event_Max_Fields = {
  __typename?: 'course_evaluation_scheduled_event_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Course_Evaluation_Scheduled_Event_Min_Fields = {
  __typename?: 'course_evaluation_scheduled_event_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "course_evaluation_scheduled_event" */
export type Course_Evaluation_Scheduled_Event_Mutation_Response = {
  __typename?: 'course_evaluation_scheduled_event_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Evaluation_Scheduled_Event>;
};

/** on_conflict condition type for table "course_evaluation_scheduled_event" */
export type Course_Evaluation_Scheduled_Event_On_Conflict = {
  constraint: Course_Evaluation_Scheduled_Event_Constraint;
  update_columns?: Array<Course_Evaluation_Scheduled_Event_Update_Column>;
  where?: InputMaybe<Course_Evaluation_Scheduled_Event_Bool_Exp>;
};

/** Ordering options when selecting data from "course_evaluation_scheduled_event". */
export type Course_Evaluation_Scheduled_Event_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  course_id?: InputMaybe<Order_By>;
  course_participant?: InputMaybe<Profile_Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_evaluation_scheduled_event */
export type Course_Evaluation_Scheduled_Event_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_evaluation_scheduled_event" */
export enum Course_Evaluation_Scheduled_Event_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id'
}

/** input type for updating data in table "course_evaluation_scheduled_event" */
export type Course_Evaluation_Scheduled_Event_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Course_Evaluation_Scheduled_Event_Stddev_Fields = {
  __typename?: 'course_evaluation_scheduled_event_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Course_Evaluation_Scheduled_Event_Stddev_Pop_Fields = {
  __typename?: 'course_evaluation_scheduled_event_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Course_Evaluation_Scheduled_Event_Stddev_Samp_Fields = {
  __typename?: 'course_evaluation_scheduled_event_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "course_evaluation_scheduled_event" */
export type Course_Evaluation_Scheduled_Event_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Evaluation_Scheduled_Event_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Evaluation_Scheduled_Event_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Course_Evaluation_Scheduled_Event_Sum_Fields = {
  __typename?: 'course_evaluation_scheduled_event_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "course_evaluation_scheduled_event" */
export enum Course_Evaluation_Scheduled_Event_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id'
}

export type Course_Evaluation_Scheduled_Event_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Evaluation_Scheduled_Event_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Evaluation_Scheduled_Event_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Evaluation_Scheduled_Event_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Evaluation_Scheduled_Event_Var_Pop_Fields = {
  __typename?: 'course_evaluation_scheduled_event_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Course_Evaluation_Scheduled_Event_Var_Samp_Fields = {
  __typename?: 'course_evaluation_scheduled_event_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Course_Evaluation_Scheduled_Event_Variance_Fields = {
  __typename?: 'course_evaluation_scheduled_event_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Enum table for course exceptions */
export type Course_Exception = {
  __typename?: 'course_exception';
  exception: Scalars['String'];
};

/** aggregated selection of "course_exception" */
export type Course_Exception_Aggregate = {
  __typename?: 'course_exception_aggregate';
  aggregate?: Maybe<Course_Exception_Aggregate_Fields>;
  nodes: Array<Course_Exception>;
};

/** aggregate fields of "course_exception" */
export type Course_Exception_Aggregate_Fields = {
  __typename?: 'course_exception_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Exception_Max_Fields>;
  min?: Maybe<Course_Exception_Min_Fields>;
};


/** aggregate fields of "course_exception" */
export type Course_Exception_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Exception_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_exception". All fields are combined with a logical 'AND'. */
export type Course_Exception_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Exception_Bool_Exp>>;
  _not?: InputMaybe<Course_Exception_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Exception_Bool_Exp>>;
  exception?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_exception" */
export enum Course_Exception_Constraint {
  /** unique or primary key constraint on columns "exception" */
  CourseExceptionPkey = 'course_exception_pkey'
}

export enum Course_Exception_Enum {
  AdvisedTimeExceeded = 'ADVISED_TIME_EXCEEDED',
  LeadTrainerInGracePeriod = 'LEAD_TRAINER_IN_GRACE_PERIOD',
  OutsideNoticePeriod = 'OUTSIDE_NOTICE_PERIOD',
  TrainerRatioNotMet = 'TRAINER_RATIO_NOT_MET'
}

/** Boolean expression to compare columns of type "course_exception_enum". All fields are combined with logical 'AND'. */
export type Course_Exception_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Exception_Enum>;
  _in?: InputMaybe<Array<Course_Exception_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Exception_Enum>;
  _nin?: InputMaybe<Array<Course_Exception_Enum>>;
};

/** input type for inserting data into table "course_exception" */
export type Course_Exception_Insert_Input = {
  exception?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Exception_Max_Fields = {
  __typename?: 'course_exception_max_fields';
  exception?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Exception_Min_Fields = {
  __typename?: 'course_exception_min_fields';
  exception?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_exception" */
export type Course_Exception_Mutation_Response = {
  __typename?: 'course_exception_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Exception>;
};

/** on_conflict condition type for table "course_exception" */
export type Course_Exception_On_Conflict = {
  constraint: Course_Exception_Constraint;
  update_columns?: Array<Course_Exception_Update_Column>;
  where?: InputMaybe<Course_Exception_Bool_Exp>;
};

/** Ordering options when selecting data from "course_exception". */
export type Course_Exception_Order_By = {
  exception?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_exception */
export type Course_Exception_Pk_Columns_Input = {
  exception: Scalars['String'];
};

/** select columns of table "course_exception" */
export enum Course_Exception_Select_Column {
  /** column name */
  Exception = 'exception'
}

/** input type for updating data in table "course_exception" */
export type Course_Exception_Set_Input = {
  exception?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_exception" */
export type Course_Exception_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Exception_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Exception_Stream_Cursor_Value_Input = {
  exception?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_exception" */
export enum Course_Exception_Update_Column {
  /** column name */
  Exception = 'exception'
}

export type Course_Exception_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Exception_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Exception_Bool_Exp;
};

/** columns and relationships of "course_exceptions" */
export type Course_Exceptions = {
  __typename?: 'course_exceptions';
  courseId: Scalars['Int'];
  exception: Course_Exception_Enum;
  reason?: Maybe<Scalars['String']>;
};

/** aggregated selection of "course_exceptions" */
export type Course_Exceptions_Aggregate = {
  __typename?: 'course_exceptions_aggregate';
  aggregate?: Maybe<Course_Exceptions_Aggregate_Fields>;
  nodes: Array<Course_Exceptions>;
};

export type Course_Exceptions_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Exceptions_Aggregate_Bool_Exp_Count>;
};

export type Course_Exceptions_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Exceptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Exceptions_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_exceptions" */
export type Course_Exceptions_Aggregate_Fields = {
  __typename?: 'course_exceptions_aggregate_fields';
  avg?: Maybe<Course_Exceptions_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Exceptions_Max_Fields>;
  min?: Maybe<Course_Exceptions_Min_Fields>;
  stddev?: Maybe<Course_Exceptions_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Exceptions_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Exceptions_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Exceptions_Sum_Fields>;
  var_pop?: Maybe<Course_Exceptions_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Exceptions_Var_Samp_Fields>;
  variance?: Maybe<Course_Exceptions_Variance_Fields>;
};


/** aggregate fields of "course_exceptions" */
export type Course_Exceptions_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Exceptions_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_exceptions" */
export type Course_Exceptions_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Exceptions_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Exceptions_Max_Order_By>;
  min?: InputMaybe<Course_Exceptions_Min_Order_By>;
  stddev?: InputMaybe<Course_Exceptions_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Exceptions_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Exceptions_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Exceptions_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Exceptions_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Exceptions_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Exceptions_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_exceptions" */
export type Course_Exceptions_Arr_Rel_Insert_Input = {
  data: Array<Course_Exceptions_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Exceptions_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Exceptions_Avg_Fields = {
  __typename?: 'course_exceptions_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_exceptions" */
export type Course_Exceptions_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_exceptions". All fields are combined with a logical 'AND'. */
export type Course_Exceptions_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Exceptions_Bool_Exp>>;
  _not?: InputMaybe<Course_Exceptions_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Exceptions_Bool_Exp>>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  exception?: InputMaybe<Course_Exception_Enum_Comparison_Exp>;
  reason?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_exceptions" */
export enum Course_Exceptions_Constraint {
  /** unique or primary key constraint on columns "exception", "course_id" */
  CourseExceptionsPkey = 'course_exceptions_pkey'
}

/** input type for incrementing numeric columns in table "course_exceptions" */
export type Course_Exceptions_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_exceptions" */
export type Course_Exceptions_Insert_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  exception?: InputMaybe<Course_Exception_Enum>;
  reason?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Exceptions_Max_Fields = {
  __typename?: 'course_exceptions_max_fields';
  courseId?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "course_exceptions" */
export type Course_Exceptions_Max_Order_By = {
  courseId?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Exceptions_Min_Fields = {
  __typename?: 'course_exceptions_min_fields';
  courseId?: Maybe<Scalars['Int']>;
  reason?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "course_exceptions" */
export type Course_Exceptions_Min_Order_By = {
  courseId?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_exceptions" */
export type Course_Exceptions_Mutation_Response = {
  __typename?: 'course_exceptions_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Exceptions>;
};

/** on_conflict condition type for table "course_exceptions" */
export type Course_Exceptions_On_Conflict = {
  constraint: Course_Exceptions_Constraint;
  update_columns?: Array<Course_Exceptions_Update_Column>;
  where?: InputMaybe<Course_Exceptions_Bool_Exp>;
};

/** Ordering options when selecting data from "course_exceptions". */
export type Course_Exceptions_Order_By = {
  courseId?: InputMaybe<Order_By>;
  exception?: InputMaybe<Order_By>;
  reason?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_exceptions */
export type Course_Exceptions_Pk_Columns_Input = {
  courseId: Scalars['Int'];
  exception: Course_Exception_Enum;
};

/** select columns of table "course_exceptions" */
export enum Course_Exceptions_Select_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Exception = 'exception',
  /** column name */
  Reason = 'reason'
}

/** input type for updating data in table "course_exceptions" */
export type Course_Exceptions_Set_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  exception?: InputMaybe<Course_Exception_Enum>;
  reason?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Course_Exceptions_Stddev_Fields = {
  __typename?: 'course_exceptions_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_exceptions" */
export type Course_Exceptions_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Exceptions_Stddev_Pop_Fields = {
  __typename?: 'course_exceptions_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_exceptions" */
export type Course_Exceptions_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Exceptions_Stddev_Samp_Fields = {
  __typename?: 'course_exceptions_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_exceptions" */
export type Course_Exceptions_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_exceptions" */
export type Course_Exceptions_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Exceptions_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Exceptions_Stream_Cursor_Value_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  exception?: InputMaybe<Course_Exception_Enum>;
  reason?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Course_Exceptions_Sum_Fields = {
  __typename?: 'course_exceptions_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_exceptions" */
export type Course_Exceptions_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** update columns of table "course_exceptions" */
export enum Course_Exceptions_Update_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Exception = 'exception',
  /** column name */
  Reason = 'reason'
}

export type Course_Exceptions_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Exceptions_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Exceptions_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Exceptions_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Exceptions_Var_Pop_Fields = {
  __typename?: 'course_exceptions_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_exceptions" */
export type Course_Exceptions_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Exceptions_Var_Samp_Fields = {
  __typename?: 'course_exceptions_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_exceptions" */
export type Course_Exceptions_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Exceptions_Variance_Fields = {
  __typename?: 'course_exceptions_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_exceptions" */
export type Course_Exceptions_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_expenses" */
export type Course_Expenses = {
  __typename?: 'course_expenses';
  /** An object relationship */
  course: Course;
  courseId: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  data: Scalars['jsonb'];
  id: Scalars['uuid'];
  /** An object relationship */
  trainer?: Maybe<Profile>;
  trainerId?: Maybe<Scalars['uuid']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "course_expenses" */
export type Course_ExpensesDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "course_expenses" */
export type Course_Expenses_Aggregate = {
  __typename?: 'course_expenses_aggregate';
  aggregate?: Maybe<Course_Expenses_Aggregate_Fields>;
  nodes: Array<Course_Expenses>;
};

export type Course_Expenses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Expenses_Aggregate_Bool_Exp_Count>;
};

export type Course_Expenses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Expenses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Expenses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_expenses" */
export type Course_Expenses_Aggregate_Fields = {
  __typename?: 'course_expenses_aggregate_fields';
  avg?: Maybe<Course_Expenses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Expenses_Max_Fields>;
  min?: Maybe<Course_Expenses_Min_Fields>;
  stddev?: Maybe<Course_Expenses_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Expenses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Expenses_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Expenses_Sum_Fields>;
  var_pop?: Maybe<Course_Expenses_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Expenses_Var_Samp_Fields>;
  variance?: Maybe<Course_Expenses_Variance_Fields>;
};


/** aggregate fields of "course_expenses" */
export type Course_Expenses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Expenses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_expenses" */
export type Course_Expenses_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Expenses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Expenses_Max_Order_By>;
  min?: InputMaybe<Course_Expenses_Min_Order_By>;
  stddev?: InputMaybe<Course_Expenses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Expenses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Expenses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Expenses_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Expenses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Expenses_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Expenses_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Course_Expenses_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "course_expenses" */
export type Course_Expenses_Arr_Rel_Insert_Input = {
  data: Array<Course_Expenses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Expenses_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Expenses_Avg_Fields = {
  __typename?: 'course_expenses_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_expenses" */
export type Course_Expenses_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_expenses". All fields are combined with a logical 'AND'. */
export type Course_Expenses_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Expenses_Bool_Exp>>;
  _not?: InputMaybe<Course_Expenses_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Expenses_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  trainer?: InputMaybe<Profile_Bool_Exp>;
  trainerId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_expenses" */
export enum Course_Expenses_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseExpensesPkey = 'course_expenses_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Course_Expenses_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Course_Expenses_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Course_Expenses_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "course_expenses" */
export type Course_Expenses_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_expenses" */
export type Course_Expenses_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  trainer?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  trainerId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Expenses_Max_Fields = {
  __typename?: 'course_expenses_max_fields';
  courseId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  trainerId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_expenses" */
export type Course_Expenses_Max_Order_By = {
  courseId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trainerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Expenses_Min_Fields = {
  __typename?: 'course_expenses_min_fields';
  courseId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  trainerId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_expenses" */
export type Course_Expenses_Min_Order_By = {
  courseId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trainerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_expenses" */
export type Course_Expenses_Mutation_Response = {
  __typename?: 'course_expenses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Expenses>;
};

/** on_conflict condition type for table "course_expenses" */
export type Course_Expenses_On_Conflict = {
  constraint: Course_Expenses_Constraint;
  update_columns?: Array<Course_Expenses_Update_Column>;
  where?: InputMaybe<Course_Expenses_Bool_Exp>;
};

/** Ordering options when selecting data from "course_expenses". */
export type Course_Expenses_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  trainer?: InputMaybe<Profile_Order_By>;
  trainerId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_expenses */
export type Course_Expenses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Course_Expenses_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "course_expenses" */
export enum Course_Expenses_Select_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  TrainerId = 'trainerId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "course_expenses" */
export type Course_Expenses_Set_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  trainerId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Expenses_Stddev_Fields = {
  __typename?: 'course_expenses_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_expenses" */
export type Course_Expenses_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Expenses_Stddev_Pop_Fields = {
  __typename?: 'course_expenses_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_expenses" */
export type Course_Expenses_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Expenses_Stddev_Samp_Fields = {
  __typename?: 'course_expenses_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_expenses" */
export type Course_Expenses_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_expenses" */
export type Course_Expenses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Expenses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Expenses_Stream_Cursor_Value_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  trainerId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Expenses_Sum_Fields = {
  __typename?: 'course_expenses_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_expenses" */
export type Course_Expenses_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** update columns of table "course_expenses" */
export enum Course_Expenses_Update_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  TrainerId = 'trainerId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Course_Expenses_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Course_Expenses_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Course_Expenses_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Course_Expenses_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Course_Expenses_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Expenses_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Course_Expenses_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Expenses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Expenses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Expenses_Var_Pop_Fields = {
  __typename?: 'course_expenses_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_expenses" */
export type Course_Expenses_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Expenses_Var_Samp_Fields = {
  __typename?: 'course_expenses_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_expenses" */
export type Course_Expenses_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Expenses_Variance_Fields = {
  __typename?: 'course_expenses_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_expenses" */
export type Course_Expenses_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "course" */
export type Course_Inc_Input = {
  aolCostOfCourse?: InputMaybe<Scalars['numeric']>;
  cancellationFee?: InputMaybe<Scalars['Float']>;
  freeSpaces?: InputMaybe<Scalars['Int']>;
  free_course_materials?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  max_participants?: InputMaybe<Scalars['Int']>;
  min_participants?: InputMaybe<Scalars['Int']>;
  modulesDuration?: InputMaybe<Scalars['Int']>;
  price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "course" */
export type Course_Insert_Input = {
  accountCode?: InputMaybe<Scalars['String']>;
  accreditedBy?: InputMaybe<Accreditors_Enum>;
  aolCostOfCourse?: InputMaybe<Scalars['numeric']>;
  aolCountry?: InputMaybe<Scalars['String']>;
  aolRegion?: InputMaybe<Scalars['String']>;
  arloReferenceId?: InputMaybe<Scalars['String']>;
  bildModules?: InputMaybe<Course_Bild_Module_Arr_Rel_Insert_Input>;
  bildStrategies?: InputMaybe<Course_Bild_Strategy_Arr_Rel_Insert_Input>;
  bookingContact?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  bookingContactInviteData?: InputMaybe<Scalars['jsonb']>;
  bookingContactProfileId?: InputMaybe<Scalars['uuid']>;
  cancellationFee?: InputMaybe<Scalars['Float']>;
  cancellationFeeType?: InputMaybe<Course_Cancellation_Fee_Type_Enum>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  cancellationRequest?: InputMaybe<Course_Cancellation_Request_Obj_Rel_Insert_Input>;
  certificates?: InputMaybe<Course_Certificate_Arr_Rel_Insert_Input>;
  conversion?: InputMaybe<Scalars['Boolean']>;
  courseExceptions?: InputMaybe<Course_Exceptions_Arr_Rel_Insert_Input>;
  course_audits?: InputMaybe<Course_Audit_Arr_Rel_Insert_Input>;
  course_course_participant_audits?: InputMaybe<Course_Participant_Audit_Arr_Rel_Insert_Input>;
  course_invites?: InputMaybe<Course_Invites_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  createdById?: InputMaybe<Scalars['uuid']>;
  curriculum?: InputMaybe<Scalars['jsonb']>;
  deliveryType?: InputMaybe<Course_Delivery_Type_Enum>;
  description?: InputMaybe<Scalars['String']>;
  displayOnWebsite?: InputMaybe<Scalars['Boolean']>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  end_date?: InputMaybe<Scalars['date']>;
  evaluation_answers?: InputMaybe<Course_Evaluation_Answers_Arr_Rel_Insert_Input>;
  exceptionsPending?: InputMaybe<Scalars['Boolean']>;
  expenses?: InputMaybe<Course_Expenses_Arr_Rel_Insert_Input>;
  freeSpaces?: InputMaybe<Scalars['Int']>;
  free_course_materials?: InputMaybe<Scalars['Int']>;
  go1Integration?: InputMaybe<Scalars['Boolean']>;
  gradingConfirmed?: InputMaybe<Scalars['Boolean']>;
  gradingStarted?: InputMaybe<Scalars['Boolean']>;
  grading_completed_on?: InputMaybe<Scalars['timestamptz']>;
  hubspot_deal_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  includeVAT?: InputMaybe<Scalars['Boolean']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  is_tender?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Course_Level_Enum>;
  materials_organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  materials_organization_id?: InputMaybe<Scalars['uuid']>;
  max_participants?: InputMaybe<Scalars['Int']>;
  min_participants?: InputMaybe<Scalars['Int']>;
  modules?: InputMaybe<Course_Module_Arr_Rel_Insert_Input>;
  modulesDuration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  orders?: InputMaybe<Course_Order_Arr_Rel_Insert_Input>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationKeyContact?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  organizationKeyContactInviteData?: InputMaybe<Scalars['jsonb']>;
  organizationKeyContactProfileId?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  parking_instructions?: InputMaybe<Scalars['String']>;
  participants?: InputMaybe<Course_Participant_Arr_Rel_Insert_Input>;
  price?: InputMaybe<Scalars['numeric']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  promo_codes?: InputMaybe<Course_Promo_Code_Arr_Rel_Insert_Input>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Scalars['String']>;
  renewalCycle?: InputMaybe<Course_Renewal_Cycle_Enum>;
  residingCountry?: InputMaybe<Scalars['String']>;
  resourcePacksDeliveryType?: InputMaybe<Resource_Packs_Delivery_Type_Enum>;
  resourcePacksType?: InputMaybe<Resource_Packs_Type_Enum>;
  schedule?: InputMaybe<Course_Schedule_Arr_Rel_Insert_Input>;
  search_fields?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Course_Source_Enum>;
  special_instructions?: InputMaybe<Scalars['String']>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  start_date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Course_Status_Enum>;
  tempOrders?: InputMaybe<Order_Temp_Arr_Rel_Insert_Input>;
  trainers?: InputMaybe<Course_Trainer_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Course_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  waitlists?: InputMaybe<Waitlist_Arr_Rel_Insert_Input>;
};

/** Enums for status of course registration invites */
export type Course_Invite_Status = {
  __typename?: 'course_invite_status';
  name: Scalars['String'];
};

/** aggregated selection of "course_invite_status" */
export type Course_Invite_Status_Aggregate = {
  __typename?: 'course_invite_status_aggregate';
  aggregate?: Maybe<Course_Invite_Status_Aggregate_Fields>;
  nodes: Array<Course_Invite_Status>;
};

/** aggregate fields of "course_invite_status" */
export type Course_Invite_Status_Aggregate_Fields = {
  __typename?: 'course_invite_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Invite_Status_Max_Fields>;
  min?: Maybe<Course_Invite_Status_Min_Fields>;
};


/** aggregate fields of "course_invite_status" */
export type Course_Invite_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Invite_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_invite_status". All fields are combined with a logical 'AND'. */
export type Course_Invite_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Invite_Status_Bool_Exp>>;
  _not?: InputMaybe<Course_Invite_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Invite_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_invite_status" */
export enum Course_Invite_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseInviteStatusPkey = 'course_invite_status_pkey'
}

export enum Course_Invite_Status_Enum {
  Accepted = 'ACCEPTED',
  Cancelled = 'CANCELLED',
  Declined = 'DECLINED',
  Pending = 'PENDING'
}

/** Boolean expression to compare columns of type "course_invite_status_enum". All fields are combined with logical 'AND'. */
export type Course_Invite_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Invite_Status_Enum>;
  _in?: InputMaybe<Array<Course_Invite_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Invite_Status_Enum>;
  _nin?: InputMaybe<Array<Course_Invite_Status_Enum>>;
};

/** input type for inserting data into table "course_invite_status" */
export type Course_Invite_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Invite_Status_Max_Fields = {
  __typename?: 'course_invite_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Invite_Status_Min_Fields = {
  __typename?: 'course_invite_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_invite_status" */
export type Course_Invite_Status_Mutation_Response = {
  __typename?: 'course_invite_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Invite_Status>;
};

/** on_conflict condition type for table "course_invite_status" */
export type Course_Invite_Status_On_Conflict = {
  constraint: Course_Invite_Status_Constraint;
  update_columns?: Array<Course_Invite_Status_Update_Column>;
  where?: InputMaybe<Course_Invite_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "course_invite_status". */
export type Course_Invite_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_invite_status */
export type Course_Invite_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "course_invite_status" */
export enum Course_Invite_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_invite_status" */
export type Course_Invite_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_invite_status" */
export type Course_Invite_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Invite_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Invite_Status_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_invite_status" */
export enum Course_Invite_Status_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Invite_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Invite_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Invite_Status_Bool_Exp;
};

/** Represents course registration invitations */
export type Course_Invites = {
  __typename?: 'course_invites';
  /** An object relationship */
  course: Course;
  course_id: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  email?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  invited_after_course_end?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  inviter?: Maybe<Profile>;
  inviter_id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  /** An object relationship */
  participant?: Maybe<Course_Participant>;
  status?: Maybe<Course_Invite_Status_Enum>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "course_invites" */
export type Course_Invites_Aggregate = {
  __typename?: 'course_invites_aggregate';
  aggregate?: Maybe<Course_Invites_Aggregate_Fields>;
  nodes: Array<Course_Invites>;
};

export type Course_Invites_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Course_Invites_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Course_Invites_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Course_Invites_Aggregate_Bool_Exp_Count>;
};

export type Course_Invites_Aggregate_Bool_Exp_Bool_And = {
  arguments: Course_Invites_Select_Column_Course_Invites_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Invites_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Invites_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Course_Invites_Select_Column_Course_Invites_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Invites_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Invites_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Invites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Invites_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_invites" */
export type Course_Invites_Aggregate_Fields = {
  __typename?: 'course_invites_aggregate_fields';
  avg?: Maybe<Course_Invites_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Invites_Max_Fields>;
  min?: Maybe<Course_Invites_Min_Fields>;
  stddev?: Maybe<Course_Invites_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Invites_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Invites_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Invites_Sum_Fields>;
  var_pop?: Maybe<Course_Invites_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Invites_Var_Samp_Fields>;
  variance?: Maybe<Course_Invites_Variance_Fields>;
};


/** aggregate fields of "course_invites" */
export type Course_Invites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Invites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_invites" */
export type Course_Invites_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Invites_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Invites_Max_Order_By>;
  min?: InputMaybe<Course_Invites_Min_Order_By>;
  stddev?: InputMaybe<Course_Invites_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Invites_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Invites_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Invites_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Invites_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Invites_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Invites_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_invites" */
export type Course_Invites_Arr_Rel_Insert_Input = {
  data: Array<Course_Invites_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Invites_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Invites_Avg_Fields = {
  __typename?: 'course_invites_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_invites" */
export type Course_Invites_Avg_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_invites". All fields are combined with a logical 'AND'. */
export type Course_Invites_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Invites_Bool_Exp>>;
  _not?: InputMaybe<Course_Invites_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Invites_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  expiresIn?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invited_after_course_end?: InputMaybe<Boolean_Comparison_Exp>;
  inviter?: InputMaybe<Profile_Bool_Exp>;
  inviter_id?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  participant?: InputMaybe<Course_Participant_Bool_Exp>;
  status?: InputMaybe<Course_Invite_Status_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_invites" */
export enum Course_Invites_Constraint {
  /** unique or primary key constraint on columns "email", "course_id" */
  CourseInvitesEmailCourseIdKey = 'course_invites_email_course_id_key',
  /** unique or primary key constraint on columns "id" */
  CourseInvitesPkey = 'course_invites_pkey'
}

/** input type for incrementing numeric columns in table "course_invites" */
export type Course_Invites_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_invites" */
export type Course_Invites_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  expiresIn?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_after_course_end?: InputMaybe<Scalars['Boolean']>;
  inviter?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  inviter_id?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<Scalars['String']>;
  participant?: InputMaybe<Course_Participant_Obj_Rel_Insert_Input>;
  status?: InputMaybe<Course_Invite_Status_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Invites_Max_Fields = {
  __typename?: 'course_invites_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  inviter_id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_invites" */
export type Course_Invites_Max_Order_By = {
  course_id?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expiresIn?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inviter_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Invites_Min_Fields = {
  __typename?: 'course_invites_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  expiresIn?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  inviter_id?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_invites" */
export type Course_Invites_Min_Order_By = {
  course_id?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expiresIn?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  inviter_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_invites" */
export type Course_Invites_Mutation_Response = {
  __typename?: 'course_invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Invites>;
};

/** input type for inserting object relation for remote table "course_invites" */
export type Course_Invites_Obj_Rel_Insert_Input = {
  data: Course_Invites_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Invites_On_Conflict>;
};

/** on_conflict condition type for table "course_invites" */
export type Course_Invites_On_Conflict = {
  constraint: Course_Invites_Constraint;
  update_columns?: Array<Course_Invites_Update_Column>;
  where?: InputMaybe<Course_Invites_Bool_Exp>;
};

/** Ordering options when selecting data from "course_invites". */
export type Course_Invites_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  course_id?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expiresIn?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_after_course_end?: InputMaybe<Order_By>;
  inviter?: InputMaybe<Profile_Order_By>;
  inviter_id?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  participant?: InputMaybe<Course_Participant_Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_invites */
export type Course_Invites_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_invites" */
export enum Course_Invites_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  ExpiresIn = 'expiresIn',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedAfterCourseEnd = 'invited_after_course_end',
  /** column name */
  InviterId = 'inviter_id',
  /** column name */
  Note = 'note',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "course_invites_aggregate_bool_exp_bool_and_arguments_columns" columns of table "course_invites" */
export enum Course_Invites_Select_Column_Course_Invites_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  InvitedAfterCourseEnd = 'invited_after_course_end'
}

/** select "course_invites_aggregate_bool_exp_bool_or_arguments_columns" columns of table "course_invites" */
export enum Course_Invites_Select_Column_Course_Invites_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  InvitedAfterCourseEnd = 'invited_after_course_end'
}

/** input type for updating data in table "course_invites" */
export type Course_Invites_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  expiresIn?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_after_course_end?: InputMaybe<Scalars['Boolean']>;
  inviter_id?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Course_Invite_Status_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Invites_Stddev_Fields = {
  __typename?: 'course_invites_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_invites" */
export type Course_Invites_Stddev_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Invites_Stddev_Pop_Fields = {
  __typename?: 'course_invites_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_invites" */
export type Course_Invites_Stddev_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Invites_Stddev_Samp_Fields = {
  __typename?: 'course_invites_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_invites" */
export type Course_Invites_Stddev_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_invites" */
export type Course_Invites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Invites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Invites_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  expiresIn?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_after_course_end?: InputMaybe<Scalars['Boolean']>;
  inviter_id?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<Scalars['String']>;
  status?: InputMaybe<Course_Invite_Status_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Invites_Sum_Fields = {
  __typename?: 'course_invites_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_invites" */
export type Course_Invites_Sum_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** update columns of table "course_invites" */
export enum Course_Invites_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  ExpiresIn = 'expiresIn',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedAfterCourseEnd = 'invited_after_course_end',
  /** column name */
  InviterId = 'inviter_id',
  /** column name */
  Note = 'note',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Course_Invites_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Invites_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Invites_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Invites_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Invites_Var_Pop_Fields = {
  __typename?: 'course_invites_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_invites" */
export type Course_Invites_Var_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Invites_Var_Samp_Fields = {
  __typename?: 'course_invites_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_invites" */
export type Course_Invites_Var_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Invites_Variance_Fields = {
  __typename?: 'course_invites_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_invites" */
export type Course_Invites_Variance_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_level" */
export type Course_Level = {
  __typename?: 'course_level';
  name: Scalars['String'];
};

/** aggregated selection of "course_level" */
export type Course_Level_Aggregate = {
  __typename?: 'course_level_aggregate';
  aggregate?: Maybe<Course_Level_Aggregate_Fields>;
  nodes: Array<Course_Level>;
};

/** aggregate fields of "course_level" */
export type Course_Level_Aggregate_Fields = {
  __typename?: 'course_level_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Level_Max_Fields>;
  min?: Maybe<Course_Level_Min_Fields>;
};


/** aggregate fields of "course_level" */
export type Course_Level_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Level_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_level". All fields are combined with a logical 'AND'. */
export type Course_Level_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Level_Bool_Exp>>;
  _not?: InputMaybe<Course_Level_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Level_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_level" */
export enum Course_Level_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseLevelPkey = 'course_level_pkey'
}

export enum Course_Level_Enum {
  Advanced = 'ADVANCED',
  AdvancedModulesEverydayObjectsAndGroundAssaults = 'ADVANCED_MODULES_EVERYDAY_OBJECTS_AND_GROUND_ASSAULTS',
  AdvancedModulesGroundSupportAndResponseToDeadWeight = 'ADVANCED_MODULES_GROUND_SUPPORT_AND_RESPONSE_TO_DEAD_WEIGHT',
  AdvancedTrainer = 'ADVANCED_TRAINER',
  AdvancedTrainerEverydayObjectsAndGroundAssaults = 'ADVANCED_TRAINER_EVERYDAY_OBJECTS_AND_GROUND_ASSAULTS',
  AdvancedTrainerGroundSupport = 'ADVANCED_TRAINER_GROUND_SUPPORT',
  AdvancedTrainerGroundSupportAndResponseToDeadWeight = 'ADVANCED_TRAINER_GROUND_SUPPORT_AND_RESPONSE_TO_DEAD_WEIGHT',
  AdvancedTrainerObjectsUsedAsWeapons = 'ADVANCED_TRAINER_OBJECTS_USED_AS_WEAPONS',
  BildAdvancedTrainer = 'BILD_ADVANCED_TRAINER',
  BildIntermediateTrainer = 'BILD_INTERMEDIATE_TRAINER',
  BildRegular = 'BILD_REGULAR',
  FoundationTrainer = 'FOUNDATION_TRAINER',
  FoundationTrainerPlus = 'FOUNDATION_TRAINER_PLUS',
  InclusionPracticesAdhd = 'INCLUSION_PRACTICES_ADHD',
  InclusionPracticesAutism = 'INCLUSION_PRACTICES_AUTISM',
  IntermediateTrainer = 'INTERMEDIATE_TRAINER',
  Level_1 = 'LEVEL_1',
  Level_1Bs = 'LEVEL_1_BS',
  Level_1Np = 'LEVEL_1_NP',
  Level_2 = 'LEVEL_2'
}

/** Boolean expression to compare columns of type "course_level_enum". All fields are combined with logical 'AND'. */
export type Course_Level_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Level_Enum>;
  _in?: InputMaybe<Array<Course_Level_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Level_Enum>;
  _nin?: InputMaybe<Array<Course_Level_Enum>>;
};

/** input type for inserting data into table "course_level" */
export type Course_Level_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Level_Max_Fields = {
  __typename?: 'course_level_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Level_Min_Fields = {
  __typename?: 'course_level_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_level" */
export type Course_Level_Mutation_Response = {
  __typename?: 'course_level_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Level>;
};

/** on_conflict condition type for table "course_level" */
export type Course_Level_On_Conflict = {
  constraint: Course_Level_Constraint;
  update_columns?: Array<Course_Level_Update_Column>;
  where?: InputMaybe<Course_Level_Bool_Exp>;
};

/** Ordering options when selecting data from "course_level". */
export type Course_Level_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_level */
export type Course_Level_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** Course levels with their prefixes (used to generate course codes) */
export type Course_Level_Prefix = {
  __typename?: 'course_level_prefix';
  id: Scalars['uuid'];
  name: Scalars['String'];
  prefix: Scalars['String'];
};

/** aggregated selection of "course_level_prefix" */
export type Course_Level_Prefix_Aggregate = {
  __typename?: 'course_level_prefix_aggregate';
  aggregate?: Maybe<Course_Level_Prefix_Aggregate_Fields>;
  nodes: Array<Course_Level_Prefix>;
};

/** aggregate fields of "course_level_prefix" */
export type Course_Level_Prefix_Aggregate_Fields = {
  __typename?: 'course_level_prefix_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Level_Prefix_Max_Fields>;
  min?: Maybe<Course_Level_Prefix_Min_Fields>;
};


/** aggregate fields of "course_level_prefix" */
export type Course_Level_Prefix_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Level_Prefix_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_level_prefix". All fields are combined with a logical 'AND'. */
export type Course_Level_Prefix_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Level_Prefix_Bool_Exp>>;
  _not?: InputMaybe<Course_Level_Prefix_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Level_Prefix_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  prefix?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_level_prefix" */
export enum Course_Level_Prefix_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseLevelPrefixNameKey = 'course_level_prefix_name_key',
  /** unique or primary key constraint on columns "id" */
  CourseLevelPrefixPkey = 'course_level_prefix_pkey',
  /** unique or primary key constraint on columns "prefix" */
  CourseLevelPrefixPrefixKey = 'course_level_prefix_prefix_key'
}

/** input type for inserting data into table "course_level_prefix" */
export type Course_Level_Prefix_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Level_Prefix_Max_Fields = {
  __typename?: 'course_level_prefix_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Level_Prefix_Min_Fields = {
  __typename?: 'course_level_prefix_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_level_prefix" */
export type Course_Level_Prefix_Mutation_Response = {
  __typename?: 'course_level_prefix_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Level_Prefix>;
};

/** on_conflict condition type for table "course_level_prefix" */
export type Course_Level_Prefix_On_Conflict = {
  constraint: Course_Level_Prefix_Constraint;
  update_columns?: Array<Course_Level_Prefix_Update_Column>;
  where?: InputMaybe<Course_Level_Prefix_Bool_Exp>;
};

/** Ordering options when selecting data from "course_level_prefix". */
export type Course_Level_Prefix_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  prefix?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_level_prefix */
export type Course_Level_Prefix_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_level_prefix" */
export enum Course_Level_Prefix_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Prefix = 'prefix'
}

/** input type for updating data in table "course_level_prefix" */
export type Course_Level_Prefix_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_level_prefix" */
export type Course_Level_Prefix_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Level_Prefix_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Level_Prefix_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_level_prefix" */
export enum Course_Level_Prefix_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Prefix = 'prefix'
}

export type Course_Level_Prefix_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Level_Prefix_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Level_Prefix_Bool_Exp;
};

/** select columns of table "course_level" */
export enum Course_Level_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_level" */
export type Course_Level_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_level" */
export type Course_Level_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Level_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Level_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_level" */
export enum Course_Level_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Level_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Level_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Level_Bool_Exp;
};

/** aggregate max on columns */
export type Course_Max_Fields = {
  __typename?: 'course_max_fields';
  accountCode?: Maybe<Scalars['String']>;
  aolCostOfCourse?: Maybe<Scalars['numeric']>;
  aolCountry?: Maybe<Scalars['String']>;
  aolRegion?: Maybe<Scalars['String']>;
  arloReferenceId?: Maybe<Scalars['String']>;
  bookingContactProfileId?: Maybe<Scalars['uuid']>;
  cancellationFee?: Maybe<Scalars['Float']>;
  cancellationReason?: Maybe<Scalars['String']>;
  /** A computed field, executes function "course_code" */
  course_code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdById?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  end_date?: Maybe<Scalars['date']>;
  /** A computed field, executes function "course_free_slots" */
  freeSlots?: Maybe<Scalars['Int']>;
  freeSpaces?: Maybe<Scalars['Int']>;
  free_course_materials?: Maybe<Scalars['Int']>;
  grading_completed_on?: Maybe<Scalars['timestamptz']>;
  hubspot_deal_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  materials_organization_id?: Maybe<Scalars['uuid']>;
  max_participants?: Maybe<Scalars['Int']>;
  min_participants?: Maybe<Scalars['Int']>;
  modulesDuration?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationKeyContactProfileId?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  parking_instructions?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  priceCurrency?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  /** A computed field, executes function "course_reserved_go1_licenses" */
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  /** A computed field returns the total count of reserved resource packs for a course, derived from resource pack reservation events in the organization's resource pack management history. */
  reservedResourcePacks?: Maybe<Scalars['Int']>;
  residingCountry?: Maybe<Scalars['String']>;
  search_fields?: Maybe<Scalars['String']>;
  special_instructions?: Maybe<Scalars['String']>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  start_date?: Maybe<Scalars['date']>;
  /** A computed field, executes function "course_state" */
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course" */
export type Course_Max_Order_By = {
  accountCode?: InputMaybe<Order_By>;
  aolCostOfCourse?: InputMaybe<Order_By>;
  aolCountry?: InputMaybe<Order_By>;
  aolRegion?: InputMaybe<Order_By>;
  arloReferenceId?: InputMaybe<Order_By>;
  bookingContactProfileId?: InputMaybe<Order_By>;
  cancellationFee?: InputMaybe<Order_By>;
  cancellationReason?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  end_date?: InputMaybe<Order_By>;
  freeSpaces?: InputMaybe<Order_By>;
  free_course_materials?: InputMaybe<Order_By>;
  grading_completed_on?: InputMaybe<Order_By>;
  hubspot_deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  materials_organization_id?: InputMaybe<Order_By>;
  max_participants?: InputMaybe<Order_By>;
  min_participants?: InputMaybe<Order_By>;
  modulesDuration?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationKeyContactProfileId?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parking_instructions?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceCurrency?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  residingCountry?: InputMaybe<Order_By>;
  search_fields?: InputMaybe<Order_By>;
  special_instructions?: InputMaybe<Order_By>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  start_date?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Min_Fields = {
  __typename?: 'course_min_fields';
  accountCode?: Maybe<Scalars['String']>;
  aolCostOfCourse?: Maybe<Scalars['numeric']>;
  aolCountry?: Maybe<Scalars['String']>;
  aolRegion?: Maybe<Scalars['String']>;
  arloReferenceId?: Maybe<Scalars['String']>;
  bookingContactProfileId?: Maybe<Scalars['uuid']>;
  cancellationFee?: Maybe<Scalars['Float']>;
  cancellationReason?: Maybe<Scalars['String']>;
  /** A computed field, executes function "course_code" */
  course_code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdById?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  end_date?: Maybe<Scalars['date']>;
  /** A computed field, executes function "course_free_slots" */
  freeSlots?: Maybe<Scalars['Int']>;
  freeSpaces?: Maybe<Scalars['Int']>;
  free_course_materials?: Maybe<Scalars['Int']>;
  grading_completed_on?: Maybe<Scalars['timestamptz']>;
  hubspot_deal_id?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  materials_organization_id?: Maybe<Scalars['uuid']>;
  max_participants?: Maybe<Scalars['Int']>;
  min_participants?: Maybe<Scalars['Int']>;
  modulesDuration?: Maybe<Scalars['Int']>;
  name?: Maybe<Scalars['String']>;
  organizationKeyContactProfileId?: Maybe<Scalars['uuid']>;
  organization_id?: Maybe<Scalars['uuid']>;
  parking_instructions?: Maybe<Scalars['String']>;
  price?: Maybe<Scalars['numeric']>;
  priceCurrency?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  /** A computed field, executes function "course_reserved_go1_licenses" */
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  /** A computed field returns the total count of reserved resource packs for a course, derived from resource pack reservation events in the organization's resource pack management history. */
  reservedResourcePacks?: Maybe<Scalars['Int']>;
  residingCountry?: Maybe<Scalars['String']>;
  search_fields?: Maybe<Scalars['String']>;
  special_instructions?: Maybe<Scalars['String']>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  start_date?: Maybe<Scalars['date']>;
  /** A computed field, executes function "course_state" */
  state?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course" */
export type Course_Min_Order_By = {
  accountCode?: InputMaybe<Order_By>;
  aolCostOfCourse?: InputMaybe<Order_By>;
  aolCountry?: InputMaybe<Order_By>;
  aolRegion?: InputMaybe<Order_By>;
  arloReferenceId?: InputMaybe<Order_By>;
  bookingContactProfileId?: InputMaybe<Order_By>;
  cancellationFee?: InputMaybe<Order_By>;
  cancellationReason?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdById?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  end_date?: InputMaybe<Order_By>;
  freeSpaces?: InputMaybe<Order_By>;
  free_course_materials?: InputMaybe<Order_By>;
  grading_completed_on?: InputMaybe<Order_By>;
  hubspot_deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  materials_organization_id?: InputMaybe<Order_By>;
  max_participants?: InputMaybe<Order_By>;
  min_participants?: InputMaybe<Order_By>;
  modulesDuration?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organizationKeyContactProfileId?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parking_instructions?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  priceCurrency?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  residingCountry?: InputMaybe<Order_By>;
  search_fields?: InputMaybe<Order_By>;
  special_instructions?: InputMaybe<Order_By>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  start_date?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_module" */
export type Course_Module = {
  __typename?: 'course_module';
  /** An object relationship */
  course: Course;
  courseId: Scalars['Int'];
  covered?: Maybe<Scalars['Boolean']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  module: Module;
  moduleId: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "course_module" */
export type Course_Module_Aggregate = {
  __typename?: 'course_module_aggregate';
  aggregate?: Maybe<Course_Module_Aggregate_Fields>;
  nodes: Array<Course_Module>;
};

export type Course_Module_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Course_Module_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Course_Module_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Course_Module_Aggregate_Bool_Exp_Count>;
};

export type Course_Module_Aggregate_Bool_Exp_Bool_And = {
  arguments: Course_Module_Select_Column_Course_Module_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Module_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Module_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Course_Module_Select_Column_Course_Module_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Module_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Module_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Module_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Module_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_module" */
export type Course_Module_Aggregate_Fields = {
  __typename?: 'course_module_aggregate_fields';
  avg?: Maybe<Course_Module_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Module_Max_Fields>;
  min?: Maybe<Course_Module_Min_Fields>;
  stddev?: Maybe<Course_Module_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Module_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Module_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Module_Sum_Fields>;
  var_pop?: Maybe<Course_Module_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Module_Var_Samp_Fields>;
  variance?: Maybe<Course_Module_Variance_Fields>;
};


/** aggregate fields of "course_module" */
export type Course_Module_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Module_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_module" */
export type Course_Module_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Module_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Module_Max_Order_By>;
  min?: InputMaybe<Course_Module_Min_Order_By>;
  stddev?: InputMaybe<Course_Module_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Module_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Module_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Module_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Module_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Module_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Module_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_module" */
export type Course_Module_Arr_Rel_Insert_Input = {
  data: Array<Course_Module_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Module_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Module_Avg_Fields = {
  __typename?: 'course_module_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_module" */
export type Course_Module_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_module". All fields are combined with a logical 'AND'. */
export type Course_Module_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Module_Bool_Exp>>;
  _not?: InputMaybe<Course_Module_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Module_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  covered?: InputMaybe<Boolean_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  module?: InputMaybe<Module_Bool_Exp>;
  moduleId?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_module" */
export enum Course_Module_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseModulePkey = 'course_module_pkey'
}

/** input type for incrementing numeric columns in table "course_module" */
export type Course_Module_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_module" */
export type Course_Module_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  covered?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  module?: InputMaybe<Module_Obj_Rel_Insert_Input>;
  moduleId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Module_Max_Fields = {
  __typename?: 'course_module_max_fields';
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  moduleId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_module" */
export type Course_Module_Max_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moduleId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Module_Min_Fields = {
  __typename?: 'course_module_min_fields';
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  moduleId?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_module" */
export type Course_Module_Min_Order_By = {
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moduleId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_module" */
export type Course_Module_Mutation_Response = {
  __typename?: 'course_module_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Module>;
};

/** on_conflict condition type for table "course_module" */
export type Course_Module_On_Conflict = {
  constraint: Course_Module_Constraint;
  update_columns?: Array<Course_Module_Update_Column>;
  where?: InputMaybe<Course_Module_Bool_Exp>;
};

/** Ordering options when selecting data from "course_module". */
export type Course_Module_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  covered?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module?: InputMaybe<Module_Order_By>;
  moduleId?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_module */
export type Course_Module_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_module" */
export enum Course_Module_Select_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Covered = 'covered',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleId = 'moduleId',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "course_module_aggregate_bool_exp_bool_and_arguments_columns" columns of table "course_module" */
export enum Course_Module_Select_Column_Course_Module_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Covered = 'covered'
}

/** select "course_module_aggregate_bool_exp_bool_or_arguments_columns" columns of table "course_module" */
export enum Course_Module_Select_Column_Course_Module_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Covered = 'covered'
}

/** input type for updating data in table "course_module" */
export type Course_Module_Set_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  covered?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  moduleId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Module_Stddev_Fields = {
  __typename?: 'course_module_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_module" */
export type Course_Module_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Module_Stddev_Pop_Fields = {
  __typename?: 'course_module_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_module" */
export type Course_Module_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Module_Stddev_Samp_Fields = {
  __typename?: 'course_module_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_module" */
export type Course_Module_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_module" */
export type Course_Module_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Module_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Module_Stream_Cursor_Value_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  covered?: InputMaybe<Scalars['Boolean']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  moduleId?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Module_Sum_Fields = {
  __typename?: 'course_module_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_module" */
export type Course_Module_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** update columns of table "course_module" */
export enum Course_Module_Update_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Covered = 'covered',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleId = 'moduleId',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Course_Module_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Module_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Module_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Module_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Module_Var_Pop_Fields = {
  __typename?: 'course_module_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_module" */
export type Course_Module_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Module_Var_Samp_Fields = {
  __typename?: 'course_module_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_module" */
export type Course_Module_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Module_Variance_Fields = {
  __typename?: 'course_module_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_module" */
export type Course_Module_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course" */
export type Course_Mutation_Response = {
  __typename?: 'course_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course>;
};

/** input type for inserting object relation for remote table "course" */
export type Course_Obj_Rel_Insert_Input = {
  data: Course_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_On_Conflict>;
};

/** on_conflict condition type for table "course" */
export type Course_On_Conflict = {
  constraint: Course_Constraint;
  update_columns?: Array<Course_Update_Column>;
  where?: InputMaybe<Course_Bool_Exp>;
};

/** columns and relationships of "course_order" */
export type Course_Order = {
  __typename?: 'course_order';
  /** An object relationship */
  course?: Maybe<Course>;
  course_id?: Maybe<Scalars['Int']>;
  /** An object relationship */
  order?: Maybe<Order>;
  order_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** aggregated selection of "course_order" */
export type Course_Order_Aggregate = {
  __typename?: 'course_order_aggregate';
  aggregate?: Maybe<Course_Order_Aggregate_Fields>;
  nodes: Array<Course_Order>;
};

export type Course_Order_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Order_Aggregate_Bool_Exp_Count>;
};

export type Course_Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_order" */
export type Course_Order_Aggregate_Fields = {
  __typename?: 'course_order_aggregate_fields';
  avg?: Maybe<Course_Order_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Order_Max_Fields>;
  min?: Maybe<Course_Order_Min_Fields>;
  stddev?: Maybe<Course_Order_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Order_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Order_Sum_Fields>;
  var_pop?: Maybe<Course_Order_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Order_Var_Samp_Fields>;
  variance?: Maybe<Course_Order_Variance_Fields>;
};


/** aggregate fields of "course_order" */
export type Course_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_order" */
export type Course_Order_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Order_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Order_Max_Order_By>;
  min?: InputMaybe<Course_Order_Min_Order_By>;
  stddev?: InputMaybe<Course_Order_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Order_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Order_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Order_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Order_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Order_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Order_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_order" */
export type Course_Order_Arr_Rel_Insert_Input = {
  data: Array<Course_Order_Insert_Input>;
};

/** aggregate avg on columns */
export type Course_Order_Avg_Fields = {
  __typename?: 'course_order_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_order" */
export type Course_Order_Avg_Order_By = {
  course_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_order". All fields are combined with a logical 'AND'. */
export type Course_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Order_Bool_Exp>>;
  _not?: InputMaybe<Course_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Order_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  order_id?: InputMaybe<Uuid_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
};

/** Ordering options when selecting data from "course". */
export type Course_Order_By = {
  accountCode?: InputMaybe<Order_By>;
  accreditedBy?: InputMaybe<Order_By>;
  aolCostOfCourse?: InputMaybe<Order_By>;
  aolCountry?: InputMaybe<Order_By>;
  aolRegion?: InputMaybe<Order_By>;
  arloReferenceId?: InputMaybe<Order_By>;
  bildModules_aggregate?: InputMaybe<Course_Bild_Module_Aggregate_Order_By>;
  bildStrategies_aggregate?: InputMaybe<Course_Bild_Strategy_Aggregate_Order_By>;
  bookingContact?: InputMaybe<Profile_Order_By>;
  bookingContactInviteData?: InputMaybe<Order_By>;
  bookingContactProfileId?: InputMaybe<Order_By>;
  cancellationFee?: InputMaybe<Order_By>;
  cancellationFeeType?: InputMaybe<Order_By>;
  cancellationReason?: InputMaybe<Order_By>;
  cancellationRequest?: InputMaybe<Course_Cancellation_Request_Order_By>;
  certificates_aggregate?: InputMaybe<Course_Certificate_Aggregate_Order_By>;
  conversion?: InputMaybe<Order_By>;
  courseExceptions_aggregate?: InputMaybe<Course_Exceptions_Aggregate_Order_By>;
  course_audits_aggregate?: InputMaybe<Course_Audit_Aggregate_Order_By>;
  course_code?: InputMaybe<Order_By>;
  course_course_participant_audits_aggregate?: InputMaybe<Course_Participant_Audit_Aggregate_Order_By>;
  course_invites_aggregate?: InputMaybe<Course_Invites_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Profile_Order_By>;
  createdById?: InputMaybe<Order_By>;
  curriculum?: InputMaybe<Order_By>;
  deliveryType?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  displayOnWebsite?: InputMaybe<Order_By>;
  end_date?: InputMaybe<Order_By>;
  evaluation_answers_aggregate?: InputMaybe<Course_Evaluation_Answers_Aggregate_Order_By>;
  exceptionsPending?: InputMaybe<Order_By>;
  expenses_aggregate?: InputMaybe<Course_Expenses_Aggregate_Order_By>;
  freeSlots?: InputMaybe<Order_By>;
  freeSpaces?: InputMaybe<Order_By>;
  free_course_materials?: InputMaybe<Order_By>;
  go1Integration?: InputMaybe<Order_By>;
  gradingConfirmed?: InputMaybe<Order_By>;
  gradingStarted?: InputMaybe<Order_By>;
  grading_completed_on?: InputMaybe<Order_By>;
  hubspot_deal_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  includeVAT?: InputMaybe<Order_By>;
  isDraft?: InputMaybe<Order_By>;
  is_tender?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  materials_organization?: InputMaybe<Organization_Order_By>;
  materials_organization_id?: InputMaybe<Order_By>;
  max_participants?: InputMaybe<Order_By>;
  min_participants?: InputMaybe<Order_By>;
  modulesDuration?: InputMaybe<Order_By>;
  modules_aggregate?: InputMaybe<Course_Module_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  orders_aggregate?: InputMaybe<Course_Order_Aggregate_Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationKeyContact?: InputMaybe<Profile_Order_By>;
  organizationKeyContactInviteData?: InputMaybe<Order_By>;
  organizationKeyContactProfileId?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  parking_instructions?: InputMaybe<Order_By>;
  participants_aggregate?: InputMaybe<Course_Participant_Aggregate_Order_By>;
  price?: InputMaybe<Order_By>;
  priceCurrency?: InputMaybe<Order_By>;
  promo_codes_aggregate?: InputMaybe<Course_Promo_Code_Aggregate_Order_By>;
  reaccreditation?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  renewalCycle?: InputMaybe<Order_By>;
  reservedGo1Licenses?: InputMaybe<Order_By>;
  reservedResourcePacks?: InputMaybe<Order_By>;
  residingCountry?: InputMaybe<Order_By>;
  resourcePacksDeliveryType?: InputMaybe<Order_By>;
  resourcePacksType?: InputMaybe<Order_By>;
  schedule_aggregate?: InputMaybe<Course_Schedule_Aggregate_Order_By>;
  search_fields?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  special_instructions?: InputMaybe<Order_By>;
  start_date?: InputMaybe<Order_By>;
  state?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tempOrders_aggregate?: InputMaybe<Order_Temp_Aggregate_Order_By>;
  trainers_aggregate?: InputMaybe<Course_Trainer_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  waitlists_aggregate?: InputMaybe<Waitlist_Aggregate_Order_By>;
};

/** input type for incrementing numeric columns in table "course_order" */
export type Course_Order_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_order" */
export type Course_Order_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['Int']>;
  order?: InputMaybe<Order_Obj_Rel_Insert_Input>;
  order_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Course_Order_Max_Fields = {
  __typename?: 'course_order_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "course_order" */
export type Course_Order_Max_Order_By = {
  course_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Order_Min_Fields = {
  __typename?: 'course_order_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  order_id?: Maybe<Scalars['uuid']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "course_order" */
export type Course_Order_Min_Order_By = {
  course_id?: InputMaybe<Order_By>;
  order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_order" */
export type Course_Order_Mutation_Response = {
  __typename?: 'course_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Order>;
};

/** Ordering options when selecting data from "course_order". */
export type Course_Order_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  course_id?: InputMaybe<Order_By>;
  order?: InputMaybe<Order_Order_By>;
  order_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** select columns of table "course_order" */
export enum Course_Order_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  OrderId = 'order_id',
  /** column name */
  Quantity = 'quantity'
}

/** input type for updating data in table "course_order" */
export type Course_Order_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Course_Order_Stddev_Fields = {
  __typename?: 'course_order_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_order" */
export type Course_Order_Stddev_Order_By = {
  course_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Order_Stddev_Pop_Fields = {
  __typename?: 'course_order_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_order" */
export type Course_Order_Stddev_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Order_Stddev_Samp_Fields = {
  __typename?: 'course_order_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_order" */
export type Course_Order_Stddev_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_order" */
export type Course_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Order_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  order_id?: InputMaybe<Scalars['uuid']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Course_Order_Sum_Fields = {
  __typename?: 'course_order_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_order" */
export type Course_Order_Sum_Order_By = {
  course_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

export type Course_Order_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Order_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Order_Var_Pop_Fields = {
  __typename?: 'course_order_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_order" */
export type Course_Order_Var_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Order_Var_Samp_Fields = {
  __typename?: 'course_order_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_order" */
export type Course_Order_Var_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Order_Variance_Fields = {
  __typename?: 'course_order_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_order" */
export type Course_Order_Variance_Order_By = {
  course_id?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_participant" */
export type Course_Participant = {
  __typename?: 'course_participant';
  attended?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  bildGradingModules?: Maybe<Course_Participant_Bild_Module>;
  bookingDate?: Maybe<Scalars['timestamptz']>;
  /** An object relationship */
  certificate?: Maybe<Course_Certificate>;
  /** An array relationship */
  certificateChanges: Array<Course_Certificate_Changelog>;
  /** An aggregate relationship */
  certificateChanges_aggregate: Course_Certificate_Changelog_Aggregate;
  certificate_id?: Maybe<Scalars['uuid']>;
  completed: Scalars['Boolean'];
  completed_at?: Maybe<Scalars['timestamptz']>;
  completed_evaluation?: Maybe<Scalars['Boolean']>;
  /** An object relationship */
  course: Course;
  course_id: Scalars['Int'];
  /** An object relationship */
  course_participant_about_training_email_scheduled_event?: Maybe<About_Training_Email_Scheduled_Events>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dateGraded?: Maybe<Scalars['timestamptz']>;
  go1EnrolmentId?: Maybe<Scalars['Int']>;
  go1EnrolmentProgress?: Maybe<Scalars['numeric']>;
  go1EnrolmentStarted: Scalars['Boolean'];
  go1EnrolmentStatus?: Maybe<Blended_Learning_Status_Enum>;
  grade?: Maybe<Grade_Enum>;
  gradedOn?: Maybe<Scalars['jsonb']>;
  /** An array relationship */
  gradingModules: Array<Course_Participant_Module>;
  /** An aggregate relationship */
  gradingModules_aggregate: Course_Participant_Module_Aggregate;
  grading_feedback?: Maybe<Scalars['String']>;
  healthSafetyConsent: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  invite?: Maybe<Course_Invites>;
  invite_id?: Maybe<Scalars['uuid']>;
  invoiceID?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  notes: Array<Course_Participant_Note>;
  /** An aggregate relationship */
  notes_aggregate: Course_Participant_Note_Aggregate;
  /** An object relationship */
  order?: Maybe<Order>;
  orderId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  profile: Profile;
  profile_id: Scalars['uuid'];
  registration_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "course_participant" */
export type Course_ParticipantCertificateChangesArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Changelog_Order_By>>;
  where?: InputMaybe<Course_Certificate_Changelog_Bool_Exp>;
};


/** columns and relationships of "course_participant" */
export type Course_ParticipantCertificateChanges_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Changelog_Order_By>>;
  where?: InputMaybe<Course_Certificate_Changelog_Bool_Exp>;
};


/** columns and relationships of "course_participant" */
export type Course_ParticipantGradedOnArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "course_participant" */
export type Course_ParticipantGradingModulesArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Module_Order_By>>;
  where?: InputMaybe<Course_Participant_Module_Bool_Exp>;
};


/** columns and relationships of "course_participant" */
export type Course_ParticipantGradingModules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Module_Order_By>>;
  where?: InputMaybe<Course_Participant_Module_Bool_Exp>;
};


/** columns and relationships of "course_participant" */
export type Course_ParticipantNotesArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Note_Order_By>>;
  where?: InputMaybe<Course_Participant_Note_Bool_Exp>;
};


/** columns and relationships of "course_participant" */
export type Course_ParticipantNotes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Note_Order_By>>;
  where?: InputMaybe<Course_Participant_Note_Bool_Exp>;
};

/** aggregated selection of "course_participant" */
export type Course_Participant_Aggregate = {
  __typename?: 'course_participant_aggregate';
  aggregate?: Maybe<Course_Participant_Aggregate_Fields>;
  nodes: Array<Course_Participant>;
};

export type Course_Participant_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Course_Participant_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Course_Participant_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Course_Participant_Aggregate_Bool_Exp_Count>;
};

export type Course_Participant_Aggregate_Bool_Exp_Bool_And = {
  arguments: Course_Participant_Select_Column_Course_Participant_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Participant_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Participant_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Course_Participant_Select_Column_Course_Participant_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Participant_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Participant_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Participant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Participant_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_participant" */
export type Course_Participant_Aggregate_Fields = {
  __typename?: 'course_participant_aggregate_fields';
  avg?: Maybe<Course_Participant_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Participant_Max_Fields>;
  min?: Maybe<Course_Participant_Min_Fields>;
  stddev?: Maybe<Course_Participant_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Participant_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Participant_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Participant_Sum_Fields>;
  var_pop?: Maybe<Course_Participant_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Participant_Var_Samp_Fields>;
  variance?: Maybe<Course_Participant_Variance_Fields>;
};


/** aggregate fields of "course_participant" */
export type Course_Participant_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Participant_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_participant" */
export type Course_Participant_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Participant_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Participant_Max_Order_By>;
  min?: InputMaybe<Course_Participant_Min_Order_By>;
  stddev?: InputMaybe<Course_Participant_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Participant_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Participant_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Participant_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Participant_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Participant_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Participant_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Course_Participant_Append_Input = {
  gradedOn?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "course_participant" */
export type Course_Participant_Arr_Rel_Insert_Input = {
  data: Array<Course_Participant_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Participant_On_Conflict>;
};

/** columns and relationships of "course_participant_audit" */
export type Course_Participant_Audit = {
  __typename?: 'course_participant_audit';
  /** An object relationship */
  authorizedBy: Profile;
  authorized_by: Scalars['uuid'];
  /** An object relationship */
  course: Course;
  course_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  /** A computed field, executes function "course_participant_audit_from_course" */
  fromCourse?: Maybe<Array<Course>>;
  id: Scalars['uuid'];
  /** A computed field, executes function "course_participant_audit_new_attendee" */
  newAttendeeEmail?: Maybe<Scalars['String']>;
  payload: Scalars['jsonb'];
  /** An object relationship */
  profile: Profile;
  profile_id: Scalars['uuid'];
  /** A computed field, executes function "merge_course_participant_audit_rows" */
  searchFields?: Maybe<Scalars['String']>;
  /** A computed field, executes function "course_participant_audit_to_course" */
  toCourse?: Maybe<Array<Course>>;
  type: Course_Participant_Audit_Type_Enum;
  updated_at: Scalars['timestamptz'];
  xero_invoice_number?: Maybe<Scalars['String']>;
};


/** columns and relationships of "course_participant_audit" */
export type Course_Participant_AuditFromCourseArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


/** columns and relationships of "course_participant_audit" */
export type Course_Participant_AuditPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "course_participant_audit" */
export type Course_Participant_AuditToCourseArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};

/** aggregated selection of "course_participant_audit" */
export type Course_Participant_Audit_Aggregate = {
  __typename?: 'course_participant_audit_aggregate';
  aggregate?: Maybe<Course_Participant_Audit_Aggregate_Fields>;
  nodes: Array<Course_Participant_Audit>;
};

export type Course_Participant_Audit_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Participant_Audit_Aggregate_Bool_Exp_Count>;
};

export type Course_Participant_Audit_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Participant_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_participant_audit" */
export type Course_Participant_Audit_Aggregate_Fields = {
  __typename?: 'course_participant_audit_aggregate_fields';
  avg?: Maybe<Course_Participant_Audit_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Participant_Audit_Max_Fields>;
  min?: Maybe<Course_Participant_Audit_Min_Fields>;
  stddev?: Maybe<Course_Participant_Audit_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Participant_Audit_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Participant_Audit_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Participant_Audit_Sum_Fields>;
  var_pop?: Maybe<Course_Participant_Audit_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Participant_Audit_Var_Samp_Fields>;
  variance?: Maybe<Course_Participant_Audit_Variance_Fields>;
};


/** aggregate fields of "course_participant_audit" */
export type Course_Participant_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Participant_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_participant_audit" */
export type Course_Participant_Audit_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Participant_Audit_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Participant_Audit_Max_Order_By>;
  min?: InputMaybe<Course_Participant_Audit_Min_Order_By>;
  stddev?: InputMaybe<Course_Participant_Audit_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Participant_Audit_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Participant_Audit_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Participant_Audit_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Participant_Audit_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Participant_Audit_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Participant_Audit_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Course_Participant_Audit_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "course_participant_audit" */
export type Course_Participant_Audit_Arr_Rel_Insert_Input = {
  data: Array<Course_Participant_Audit_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Participant_Audit_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Participant_Audit_Avg_Fields = {
  __typename?: 'course_participant_audit_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_participant_audit" */
export type Course_Participant_Audit_Avg_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_participant_audit". All fields are combined with a logical 'AND'. */
export type Course_Participant_Audit_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Participant_Audit_Bool_Exp>>;
  _not?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Participant_Audit_Bool_Exp>>;
  authorizedBy?: InputMaybe<Profile_Bool_Exp>;
  authorized_by?: InputMaybe<Uuid_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  fromCourse?: InputMaybe<Course_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  newAttendeeEmail?: InputMaybe<String_Comparison_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  searchFields?: InputMaybe<String_Comparison_Exp>;
  toCourse?: InputMaybe<Course_Bool_Exp>;
  type?: InputMaybe<Course_Participant_Audit_Type_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  xero_invoice_number?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_participant_audit" */
export enum Course_Participant_Audit_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseParticipantAuditPkey = 'course_participant_audit_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Course_Participant_Audit_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Course_Participant_Audit_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Course_Participant_Audit_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "course_participant_audit" */
export type Course_Participant_Audit_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_participant_audit" */
export type Course_Participant_Audit_Insert_Input = {
  authorizedBy?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  authorized_by?: InputMaybe<Scalars['uuid']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Course_Participant_Audit_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  xero_invoice_number?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Participant_Audit_Max_Fields = {
  __typename?: 'course_participant_audit_max_fields';
  authorized_by?: Maybe<Scalars['uuid']>;
  course_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "course_participant_audit_new_attendee" */
  newAttendeeEmail?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "merge_course_participant_audit_rows" */
  searchFields?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  xero_invoice_number?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "course_participant_audit" */
export type Course_Participant_Audit_Max_Order_By = {
  authorized_by?: InputMaybe<Order_By>;
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xero_invoice_number?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Participant_Audit_Min_Fields = {
  __typename?: 'course_participant_audit_min_fields';
  authorized_by?: Maybe<Scalars['uuid']>;
  course_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "course_participant_audit_new_attendee" */
  newAttendeeEmail?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['uuid']>;
  /** A computed field, executes function "merge_course_participant_audit_rows" */
  searchFields?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  xero_invoice_number?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "course_participant_audit" */
export type Course_Participant_Audit_Min_Order_By = {
  authorized_by?: InputMaybe<Order_By>;
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xero_invoice_number?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_participant_audit" */
export type Course_Participant_Audit_Mutation_Response = {
  __typename?: 'course_participant_audit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Participant_Audit>;
};

/** on_conflict condition type for table "course_participant_audit" */
export type Course_Participant_Audit_On_Conflict = {
  constraint: Course_Participant_Audit_Constraint;
  update_columns?: Array<Course_Participant_Audit_Update_Column>;
  where?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
};

/** Ordering options when selecting data from "course_participant_audit". */
export type Course_Participant_Audit_Order_By = {
  authorizedBy?: InputMaybe<Profile_Order_By>;
  authorized_by?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  fromCourse_aggregate?: InputMaybe<Course_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  newAttendeeEmail?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  searchFields?: InputMaybe<Order_By>;
  toCourse_aggregate?: InputMaybe<Course_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xero_invoice_number?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_participant_audit */
export type Course_Participant_Audit_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Course_Participant_Audit_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "course_participant_audit" */
export enum Course_Participant_Audit_Select_Column {
  /** column name */
  AuthorizedBy = 'authorized_by',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  XeroInvoiceNumber = 'xero_invoice_number'
}

/** input type for updating data in table "course_participant_audit" */
export type Course_Participant_Audit_Set_Input = {
  authorized_by?: InputMaybe<Scalars['uuid']>;
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Course_Participant_Audit_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  xero_invoice_number?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Course_Participant_Audit_Stddev_Fields = {
  __typename?: 'course_participant_audit_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_participant_audit" */
export type Course_Participant_Audit_Stddev_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Participant_Audit_Stddev_Pop_Fields = {
  __typename?: 'course_participant_audit_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_participant_audit" */
export type Course_Participant_Audit_Stddev_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Participant_Audit_Stddev_Samp_Fields = {
  __typename?: 'course_participant_audit_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_participant_audit" */
export type Course_Participant_Audit_Stddev_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_participant_audit" */
export type Course_Participant_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Participant_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Participant_Audit_Stream_Cursor_Value_Input = {
  authorized_by?: InputMaybe<Scalars['uuid']>;
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  type?: InputMaybe<Course_Participant_Audit_Type_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  xero_invoice_number?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Course_Participant_Audit_Sum_Fields = {
  __typename?: 'course_participant_audit_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_participant_audit" */
export type Course_Participant_Audit_Sum_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_participant_audit_type" */
export type Course_Participant_Audit_Type = {
  __typename?: 'course_participant_audit_type';
  name: Scalars['String'];
};

/** aggregated selection of "course_participant_audit_type" */
export type Course_Participant_Audit_Type_Aggregate = {
  __typename?: 'course_participant_audit_type_aggregate';
  aggregate?: Maybe<Course_Participant_Audit_Type_Aggregate_Fields>;
  nodes: Array<Course_Participant_Audit_Type>;
};

/** aggregate fields of "course_participant_audit_type" */
export type Course_Participant_Audit_Type_Aggregate_Fields = {
  __typename?: 'course_participant_audit_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Participant_Audit_Type_Max_Fields>;
  min?: Maybe<Course_Participant_Audit_Type_Min_Fields>;
};


/** aggregate fields of "course_participant_audit_type" */
export type Course_Participant_Audit_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Participant_Audit_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_participant_audit_type". All fields are combined with a logical 'AND'. */
export type Course_Participant_Audit_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Participant_Audit_Type_Bool_Exp>>;
  _not?: InputMaybe<Course_Participant_Audit_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Participant_Audit_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_participant_audit_type" */
export enum Course_Participant_Audit_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseParticipantAuditTypePkey = 'course_participant_audit_type_pkey'
}

export enum Course_Participant_Audit_Type_Enum {
  Attended = 'ATTENDED',
  Cancellation = 'CANCELLATION',
  NotAttended = 'NOT_ATTENDED',
  Replacement = 'REPLACEMENT',
  Transfer = 'TRANSFER'
}

/** Boolean expression to compare columns of type "course_participant_audit_type_enum". All fields are combined with logical 'AND'. */
export type Course_Participant_Audit_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Participant_Audit_Type_Enum>;
  _in?: InputMaybe<Array<Course_Participant_Audit_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Participant_Audit_Type_Enum>;
  _nin?: InputMaybe<Array<Course_Participant_Audit_Type_Enum>>;
};

/** input type for inserting data into table "course_participant_audit_type" */
export type Course_Participant_Audit_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Participant_Audit_Type_Max_Fields = {
  __typename?: 'course_participant_audit_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Participant_Audit_Type_Min_Fields = {
  __typename?: 'course_participant_audit_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_participant_audit_type" */
export type Course_Participant_Audit_Type_Mutation_Response = {
  __typename?: 'course_participant_audit_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Participant_Audit_Type>;
};

/** on_conflict condition type for table "course_participant_audit_type" */
export type Course_Participant_Audit_Type_On_Conflict = {
  constraint: Course_Participant_Audit_Type_Constraint;
  update_columns?: Array<Course_Participant_Audit_Type_Update_Column>;
  where?: InputMaybe<Course_Participant_Audit_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "course_participant_audit_type". */
export type Course_Participant_Audit_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_participant_audit_type */
export type Course_Participant_Audit_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "course_participant_audit_type" */
export enum Course_Participant_Audit_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_participant_audit_type" */
export type Course_Participant_Audit_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_participant_audit_type" */
export type Course_Participant_Audit_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Participant_Audit_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Participant_Audit_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_participant_audit_type" */
export enum Course_Participant_Audit_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Participant_Audit_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Participant_Audit_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Participant_Audit_Type_Bool_Exp;
};

/** update columns of table "course_participant_audit" */
export enum Course_Participant_Audit_Update_Column {
  /** column name */
  AuthorizedBy = 'authorized_by',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Payload = 'payload',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  XeroInvoiceNumber = 'xero_invoice_number'
}

export type Course_Participant_Audit_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Course_Participant_Audit_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Course_Participant_Audit_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Course_Participant_Audit_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Course_Participant_Audit_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Participant_Audit_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Course_Participant_Audit_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Participant_Audit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Participant_Audit_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Participant_Audit_Var_Pop_Fields = {
  __typename?: 'course_participant_audit_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_participant_audit" */
export type Course_Participant_Audit_Var_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Participant_Audit_Var_Samp_Fields = {
  __typename?: 'course_participant_audit_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_participant_audit" */
export type Course_Participant_Audit_Var_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Participant_Audit_Variance_Fields = {
  __typename?: 'course_participant_audit_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_participant_audit" */
export type Course_Participant_Audit_Variance_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate avg on columns */
export type Course_Participant_Avg_Fields = {
  __typename?: 'course_participant_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
  go1EnrolmentId?: Maybe<Scalars['Float']>;
  go1EnrolmentProgress?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_participant" */
export type Course_Participant_Avg_Order_By = {
  course_id?: InputMaybe<Order_By>;
  go1EnrolmentId?: InputMaybe<Order_By>;
  go1EnrolmentProgress?: InputMaybe<Order_By>;
};

/** Graded BILD modules for a course participant */
export type Course_Participant_Bild_Module = {
  __typename?: 'course_participant_bild_module';
  /** An object relationship */
  course_participant: Course_Participant;
  id: Scalars['uuid'];
  modules: Scalars['jsonb'];
  participant_id: Scalars['uuid'];
};


/** Graded BILD modules for a course participant */
export type Course_Participant_Bild_ModuleModulesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "course_participant_bild_module" */
export type Course_Participant_Bild_Module_Aggregate = {
  __typename?: 'course_participant_bild_module_aggregate';
  aggregate?: Maybe<Course_Participant_Bild_Module_Aggregate_Fields>;
  nodes: Array<Course_Participant_Bild_Module>;
};

/** aggregate fields of "course_participant_bild_module" */
export type Course_Participant_Bild_Module_Aggregate_Fields = {
  __typename?: 'course_participant_bild_module_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Participant_Bild_Module_Max_Fields>;
  min?: Maybe<Course_Participant_Bild_Module_Min_Fields>;
};


/** aggregate fields of "course_participant_bild_module" */
export type Course_Participant_Bild_Module_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Participant_Bild_Module_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Course_Participant_Bild_Module_Append_Input = {
  modules?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "course_participant_bild_module". All fields are combined with a logical 'AND'. */
export type Course_Participant_Bild_Module_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Participant_Bild_Module_Bool_Exp>>;
  _not?: InputMaybe<Course_Participant_Bild_Module_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Participant_Bild_Module_Bool_Exp>>;
  course_participant?: InputMaybe<Course_Participant_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  modules?: InputMaybe<Jsonb_Comparison_Exp>;
  participant_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_participant_bild_module" */
export enum Course_Participant_Bild_Module_Constraint {
  /** unique or primary key constraint on columns "participant_id" */
  CourseParticipantBildModuleParticipantIdKey = 'course_participant_bild_module_participant_id_key',
  /** unique or primary key constraint on columns "id" */
  CourseParticipantBildModulePkey = 'course_participant_bild_module_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Course_Participant_Bild_Module_Delete_At_Path_Input = {
  modules?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Course_Participant_Bild_Module_Delete_Elem_Input = {
  modules?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Course_Participant_Bild_Module_Delete_Key_Input = {
  modules?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "course_participant_bild_module" */
export type Course_Participant_Bild_Module_Insert_Input = {
  course_participant?: InputMaybe<Course_Participant_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  modules?: InputMaybe<Scalars['jsonb']>;
  participant_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Course_Participant_Bild_Module_Max_Fields = {
  __typename?: 'course_participant_bild_module_max_fields';
  id?: Maybe<Scalars['uuid']>;
  participant_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Course_Participant_Bild_Module_Min_Fields = {
  __typename?: 'course_participant_bild_module_min_fields';
  id?: Maybe<Scalars['uuid']>;
  participant_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "course_participant_bild_module" */
export type Course_Participant_Bild_Module_Mutation_Response = {
  __typename?: 'course_participant_bild_module_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Participant_Bild_Module>;
};

/** input type for inserting object relation for remote table "course_participant_bild_module" */
export type Course_Participant_Bild_Module_Obj_Rel_Insert_Input = {
  data: Course_Participant_Bild_Module_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Participant_Bild_Module_On_Conflict>;
};

/** on_conflict condition type for table "course_participant_bild_module" */
export type Course_Participant_Bild_Module_On_Conflict = {
  constraint: Course_Participant_Bild_Module_Constraint;
  update_columns?: Array<Course_Participant_Bild_Module_Update_Column>;
  where?: InputMaybe<Course_Participant_Bild_Module_Bool_Exp>;
};

/** Ordering options when selecting data from "course_participant_bild_module". */
export type Course_Participant_Bild_Module_Order_By = {
  course_participant?: InputMaybe<Course_Participant_Order_By>;
  id?: InputMaybe<Order_By>;
  modules?: InputMaybe<Order_By>;
  participant_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_participant_bild_module */
export type Course_Participant_Bild_Module_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Course_Participant_Bild_Module_Prepend_Input = {
  modules?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "course_participant_bild_module" */
export enum Course_Participant_Bild_Module_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Modules = 'modules',
  /** column name */
  ParticipantId = 'participant_id'
}

/** input type for updating data in table "course_participant_bild_module" */
export type Course_Participant_Bild_Module_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  modules?: InputMaybe<Scalars['jsonb']>;
  participant_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "course_participant_bild_module" */
export type Course_Participant_Bild_Module_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Participant_Bild_Module_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Participant_Bild_Module_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  modules?: InputMaybe<Scalars['jsonb']>;
  participant_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "course_participant_bild_module" */
export enum Course_Participant_Bild_Module_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Modules = 'modules',
  /** column name */
  ParticipantId = 'participant_id'
}

export type Course_Participant_Bild_Module_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Course_Participant_Bild_Module_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Course_Participant_Bild_Module_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Course_Participant_Bild_Module_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Course_Participant_Bild_Module_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Course_Participant_Bild_Module_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Participant_Bild_Module_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Participant_Bild_Module_Bool_Exp;
};

/** Boolean expression to filter rows from the table "course_participant". All fields are combined with a logical 'AND'. */
export type Course_Participant_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Participant_Bool_Exp>>;
  _not?: InputMaybe<Course_Participant_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Participant_Bool_Exp>>;
  attended?: InputMaybe<Boolean_Comparison_Exp>;
  bildGradingModules?: InputMaybe<Course_Participant_Bild_Module_Bool_Exp>;
  bookingDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  certificate?: InputMaybe<Course_Certificate_Bool_Exp>;
  certificateChanges?: InputMaybe<Course_Certificate_Changelog_Bool_Exp>;
  certificateChanges_aggregate?: InputMaybe<Course_Certificate_Changelog_Aggregate_Bool_Exp>;
  certificate_id?: InputMaybe<Uuid_Comparison_Exp>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  completed_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  completed_evaluation?: InputMaybe<Boolean_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  course_participant_about_training_email_scheduled_event?: InputMaybe<About_Training_Email_Scheduled_Events_Bool_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  dateGraded?: InputMaybe<Timestamptz_Comparison_Exp>;
  go1EnrolmentId?: InputMaybe<Int_Comparison_Exp>;
  go1EnrolmentProgress?: InputMaybe<Numeric_Comparison_Exp>;
  go1EnrolmentStarted?: InputMaybe<Boolean_Comparison_Exp>;
  go1EnrolmentStatus?: InputMaybe<Blended_Learning_Status_Enum_Comparison_Exp>;
  grade?: InputMaybe<Grade_Enum_Comparison_Exp>;
  gradedOn?: InputMaybe<Jsonb_Comparison_Exp>;
  gradingModules?: InputMaybe<Course_Participant_Module_Bool_Exp>;
  gradingModules_aggregate?: InputMaybe<Course_Participant_Module_Aggregate_Bool_Exp>;
  grading_feedback?: InputMaybe<String_Comparison_Exp>;
  healthSafetyConsent?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invite?: InputMaybe<Course_Invites_Bool_Exp>;
  invite_id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiceID?: InputMaybe<Uuid_Comparison_Exp>;
  notes?: InputMaybe<Course_Participant_Note_Bool_Exp>;
  notes_aggregate?: InputMaybe<Course_Participant_Note_Aggregate_Bool_Exp>;
  order?: InputMaybe<Order_Bool_Exp>;
  orderId?: InputMaybe<Uuid_Comparison_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  registration_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "course_participant_cancellation" */
export type Course_Participant_Cancellation = {
  __typename?: 'course_participant_cancellation';
  cancellation_fee_percent: Scalars['Int'];
  cancellation_reason: Scalars['String'];
  course_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  profile_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "course_participant_cancellation" */
export type Course_Participant_Cancellation_Aggregate = {
  __typename?: 'course_participant_cancellation_aggregate';
  aggregate?: Maybe<Course_Participant_Cancellation_Aggregate_Fields>;
  nodes: Array<Course_Participant_Cancellation>;
};

/** aggregate fields of "course_participant_cancellation" */
export type Course_Participant_Cancellation_Aggregate_Fields = {
  __typename?: 'course_participant_cancellation_aggregate_fields';
  avg?: Maybe<Course_Participant_Cancellation_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Participant_Cancellation_Max_Fields>;
  min?: Maybe<Course_Participant_Cancellation_Min_Fields>;
  stddev?: Maybe<Course_Participant_Cancellation_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Participant_Cancellation_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Participant_Cancellation_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Participant_Cancellation_Sum_Fields>;
  var_pop?: Maybe<Course_Participant_Cancellation_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Participant_Cancellation_Var_Samp_Fields>;
  variance?: Maybe<Course_Participant_Cancellation_Variance_Fields>;
};


/** aggregate fields of "course_participant_cancellation" */
export type Course_Participant_Cancellation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Participant_Cancellation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Course_Participant_Cancellation_Avg_Fields = {
  __typename?: 'course_participant_cancellation_avg_fields';
  cancellation_fee_percent?: Maybe<Scalars['Float']>;
  course_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "course_participant_cancellation". All fields are combined with a logical 'AND'. */
export type Course_Participant_Cancellation_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Participant_Cancellation_Bool_Exp>>;
  _not?: InputMaybe<Course_Participant_Cancellation_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Participant_Cancellation_Bool_Exp>>;
  cancellation_fee_percent?: InputMaybe<Int_Comparison_Exp>;
  cancellation_reason?: InputMaybe<String_Comparison_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_participant_cancellation" */
export enum Course_Participant_Cancellation_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseParticipantCancellationPkey = 'course_participant_cancellation_pkey'
}

/** input type for incrementing numeric columns in table "course_participant_cancellation" */
export type Course_Participant_Cancellation_Inc_Input = {
  cancellation_fee_percent?: InputMaybe<Scalars['Int']>;
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_participant_cancellation" */
export type Course_Participant_Cancellation_Insert_Input = {
  cancellation_fee_percent?: InputMaybe<Scalars['Int']>;
  cancellation_reason?: InputMaybe<Scalars['String']>;
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Participant_Cancellation_Max_Fields = {
  __typename?: 'course_participant_cancellation_max_fields';
  cancellation_fee_percent?: Maybe<Scalars['Int']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  course_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Course_Participant_Cancellation_Min_Fields = {
  __typename?: 'course_participant_cancellation_min_fields';
  cancellation_fee_percent?: Maybe<Scalars['Int']>;
  cancellation_reason?: Maybe<Scalars['String']>;
  course_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "course_participant_cancellation" */
export type Course_Participant_Cancellation_Mutation_Response = {
  __typename?: 'course_participant_cancellation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Participant_Cancellation>;
};

/** on_conflict condition type for table "course_participant_cancellation" */
export type Course_Participant_Cancellation_On_Conflict = {
  constraint: Course_Participant_Cancellation_Constraint;
  update_columns?: Array<Course_Participant_Cancellation_Update_Column>;
  where?: InputMaybe<Course_Participant_Cancellation_Bool_Exp>;
};

/** Ordering options when selecting data from "course_participant_cancellation". */
export type Course_Participant_Cancellation_Order_By = {
  cancellation_fee_percent?: InputMaybe<Order_By>;
  cancellation_reason?: InputMaybe<Order_By>;
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_participant_cancellation */
export type Course_Participant_Cancellation_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_participant_cancellation" */
export enum Course_Participant_Cancellation_Select_Column {
  /** column name */
  CancellationFeePercent = 'cancellation_fee_percent',
  /** column name */
  CancellationReason = 'cancellation_reason',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "course_participant_cancellation" */
export type Course_Participant_Cancellation_Set_Input = {
  cancellation_fee_percent?: InputMaybe<Scalars['Int']>;
  cancellation_reason?: InputMaybe<Scalars['String']>;
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Participant_Cancellation_Stddev_Fields = {
  __typename?: 'course_participant_cancellation_stddev_fields';
  cancellation_fee_percent?: Maybe<Scalars['Float']>;
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Course_Participant_Cancellation_Stddev_Pop_Fields = {
  __typename?: 'course_participant_cancellation_stddev_pop_fields';
  cancellation_fee_percent?: Maybe<Scalars['Float']>;
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Course_Participant_Cancellation_Stddev_Samp_Fields = {
  __typename?: 'course_participant_cancellation_stddev_samp_fields';
  cancellation_fee_percent?: Maybe<Scalars['Float']>;
  course_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "course_participant_cancellation" */
export type Course_Participant_Cancellation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Participant_Cancellation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Participant_Cancellation_Stream_Cursor_Value_Input = {
  cancellation_fee_percent?: InputMaybe<Scalars['Int']>;
  cancellation_reason?: InputMaybe<Scalars['String']>;
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Participant_Cancellation_Sum_Fields = {
  __typename?: 'course_participant_cancellation_sum_fields';
  cancellation_fee_percent?: Maybe<Scalars['Int']>;
  course_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "course_participant_cancellation" */
export enum Course_Participant_Cancellation_Update_Column {
  /** column name */
  CancellationFeePercent = 'cancellation_fee_percent',
  /** column name */
  CancellationReason = 'cancellation_reason',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Course_Participant_Cancellation_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Participant_Cancellation_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Participant_Cancellation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Participant_Cancellation_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Participant_Cancellation_Var_Pop_Fields = {
  __typename?: 'course_participant_cancellation_var_pop_fields';
  cancellation_fee_percent?: Maybe<Scalars['Float']>;
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Course_Participant_Cancellation_Var_Samp_Fields = {
  __typename?: 'course_participant_cancellation_var_samp_fields';
  cancellation_fee_percent?: Maybe<Scalars['Float']>;
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Course_Participant_Cancellation_Variance_Fields = {
  __typename?: 'course_participant_cancellation_variance_fields';
  cancellation_fee_percent?: Maybe<Scalars['Float']>;
  course_id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "course_participant" */
export enum Course_Participant_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseParticipantPkey = 'course_participant_pkey',
  /** unique or primary key constraint on columns "course_id", "profile_id" */
  CourseParticipantProfileIdCourseIdKey = 'course_participant_profile_id_course_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Course_Participant_Delete_At_Path_Input = {
  gradedOn?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Course_Participant_Delete_Elem_Input = {
  gradedOn?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Course_Participant_Delete_Key_Input = {
  gradedOn?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "course_participant" */
export type Course_Participant_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  go1EnrolmentId?: InputMaybe<Scalars['Int']>;
  go1EnrolmentProgress?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "course_participant" */
export type Course_Participant_Insert_Input = {
  attended?: InputMaybe<Scalars['Boolean']>;
  bildGradingModules?: InputMaybe<Course_Participant_Bild_Module_Obj_Rel_Insert_Input>;
  bookingDate?: InputMaybe<Scalars['timestamptz']>;
  certificate?: InputMaybe<Course_Certificate_Obj_Rel_Insert_Input>;
  certificateChanges?: InputMaybe<Course_Certificate_Changelog_Arr_Rel_Insert_Input>;
  certificate_id?: InputMaybe<Scalars['uuid']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  completed_evaluation?: InputMaybe<Scalars['Boolean']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['Int']>;
  course_participant_about_training_email_scheduled_event?: InputMaybe<About_Training_Email_Scheduled_Events_Obj_Rel_Insert_Input>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dateGraded?: InputMaybe<Scalars['timestamptz']>;
  go1EnrolmentId?: InputMaybe<Scalars['Int']>;
  go1EnrolmentProgress?: InputMaybe<Scalars['numeric']>;
  go1EnrolmentStarted?: InputMaybe<Scalars['Boolean']>;
  go1EnrolmentStatus?: InputMaybe<Blended_Learning_Status_Enum>;
  grade?: InputMaybe<Grade_Enum>;
  gradedOn?: InputMaybe<Scalars['jsonb']>;
  gradingModules?: InputMaybe<Course_Participant_Module_Arr_Rel_Insert_Input>;
  grading_feedback?: InputMaybe<Scalars['String']>;
  healthSafetyConsent?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  invite?: InputMaybe<Course_Invites_Obj_Rel_Insert_Input>;
  invite_id?: InputMaybe<Scalars['uuid']>;
  invoiceID?: InputMaybe<Scalars['uuid']>;
  notes?: InputMaybe<Course_Participant_Note_Arr_Rel_Insert_Input>;
  order?: InputMaybe<Order_Obj_Rel_Insert_Input>;
  orderId?: InputMaybe<Scalars['uuid']>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  registration_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Participant_Max_Fields = {
  __typename?: 'course_participant_max_fields';
  bookingDate?: Maybe<Scalars['timestamptz']>;
  certificate_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  course_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dateGraded?: Maybe<Scalars['timestamptz']>;
  go1EnrolmentId?: Maybe<Scalars['Int']>;
  go1EnrolmentProgress?: Maybe<Scalars['numeric']>;
  grading_feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invite_id?: Maybe<Scalars['uuid']>;
  invoiceID?: Maybe<Scalars['uuid']>;
  orderId?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  registration_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_participant" */
export type Course_Participant_Max_Order_By = {
  bookingDate?: InputMaybe<Order_By>;
  certificate_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dateGraded?: InputMaybe<Order_By>;
  go1EnrolmentId?: InputMaybe<Order_By>;
  go1EnrolmentProgress?: InputMaybe<Order_By>;
  grading_feedback?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_id?: InputMaybe<Order_By>;
  invoiceID?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  registration_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Participant_Min_Fields = {
  __typename?: 'course_participant_min_fields';
  bookingDate?: Maybe<Scalars['timestamptz']>;
  certificate_id?: Maybe<Scalars['uuid']>;
  completed_at?: Maybe<Scalars['timestamptz']>;
  course_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  dateGraded?: Maybe<Scalars['timestamptz']>;
  go1EnrolmentId?: Maybe<Scalars['Int']>;
  go1EnrolmentProgress?: Maybe<Scalars['numeric']>;
  grading_feedback?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invite_id?: Maybe<Scalars['uuid']>;
  invoiceID?: Maybe<Scalars['uuid']>;
  orderId?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  registration_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_participant" */
export type Course_Participant_Min_Order_By = {
  bookingDate?: InputMaybe<Order_By>;
  certificate_id?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  dateGraded?: InputMaybe<Order_By>;
  go1EnrolmentId?: InputMaybe<Order_By>;
  go1EnrolmentProgress?: InputMaybe<Order_By>;
  grading_feedback?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite_id?: InputMaybe<Order_By>;
  invoiceID?: InputMaybe<Order_By>;
  orderId?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  registration_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** Course modules that course participant completed */
export type Course_Participant_Module = {
  __typename?: 'course_participant_module';
  completed: Scalars['Boolean'];
  /** An object relationship */
  course_participant: Course_Participant;
  course_participant_id: Scalars['uuid'];
  id: Scalars['uuid'];
  /** An object relationship */
  module: Module;
  module_id: Scalars['uuid'];
};

/** aggregated selection of "course_participant_module" */
export type Course_Participant_Module_Aggregate = {
  __typename?: 'course_participant_module_aggregate';
  aggregate?: Maybe<Course_Participant_Module_Aggregate_Fields>;
  nodes: Array<Course_Participant_Module>;
};

export type Course_Participant_Module_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Course_Participant_Module_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Course_Participant_Module_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Course_Participant_Module_Aggregate_Bool_Exp_Count>;
};

export type Course_Participant_Module_Aggregate_Bool_Exp_Bool_And = {
  arguments: Course_Participant_Module_Select_Column_Course_Participant_Module_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Participant_Module_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Participant_Module_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Course_Participant_Module_Select_Column_Course_Participant_Module_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Participant_Module_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Course_Participant_Module_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Participant_Module_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Participant_Module_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_participant_module" */
export type Course_Participant_Module_Aggregate_Fields = {
  __typename?: 'course_participant_module_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Participant_Module_Max_Fields>;
  min?: Maybe<Course_Participant_Module_Min_Fields>;
};


/** aggregate fields of "course_participant_module" */
export type Course_Participant_Module_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Participant_Module_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_participant_module" */
export type Course_Participant_Module_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Participant_Module_Max_Order_By>;
  min?: InputMaybe<Course_Participant_Module_Min_Order_By>;
};

/** input type for inserting array relation for remote table "course_participant_module" */
export type Course_Participant_Module_Arr_Rel_Insert_Input = {
  data: Array<Course_Participant_Module_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Participant_Module_On_Conflict>;
};

/** Boolean expression to filter rows from the table "course_participant_module". All fields are combined with a logical 'AND'. */
export type Course_Participant_Module_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Participant_Module_Bool_Exp>>;
  _not?: InputMaybe<Course_Participant_Module_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Participant_Module_Bool_Exp>>;
  completed?: InputMaybe<Boolean_Comparison_Exp>;
  course_participant?: InputMaybe<Course_Participant_Bool_Exp>;
  course_participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  module?: InputMaybe<Module_Bool_Exp>;
  module_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_participant_module" */
export enum Course_Participant_Module_Constraint {
  /** unique or primary key constraint on columns "course_participant_id", "module_id" */
  CourseParticipantModuleCourseParticipantIdModuleIdKey = 'course_participant_module_course_participant_id_module_id_key',
  /** unique or primary key constraint on columns "id" */
  CourseParticipantModulePkey = 'course_participant_module_pkey'
}

/** input type for inserting data into table "course_participant_module" */
export type Course_Participant_Module_Insert_Input = {
  completed?: InputMaybe<Scalars['Boolean']>;
  course_participant?: InputMaybe<Course_Participant_Obj_Rel_Insert_Input>;
  course_participant_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  module?: InputMaybe<Module_Obj_Rel_Insert_Input>;
  module_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Course_Participant_Module_Max_Fields = {
  __typename?: 'course_participant_module_max_fields';
  course_participant_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  module_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "course_participant_module" */
export type Course_Participant_Module_Max_Order_By = {
  course_participant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Participant_Module_Min_Fields = {
  __typename?: 'course_participant_module_min_fields';
  course_participant_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  module_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "course_participant_module" */
export type Course_Participant_Module_Min_Order_By = {
  course_participant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_participant_module" */
export type Course_Participant_Module_Mutation_Response = {
  __typename?: 'course_participant_module_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Participant_Module>;
};

/** on_conflict condition type for table "course_participant_module" */
export type Course_Participant_Module_On_Conflict = {
  constraint: Course_Participant_Module_Constraint;
  update_columns?: Array<Course_Participant_Module_Update_Column>;
  where?: InputMaybe<Course_Participant_Module_Bool_Exp>;
};

/** Ordering options when selecting data from "course_participant_module". */
export type Course_Participant_Module_Order_By = {
  completed?: InputMaybe<Order_By>;
  course_participant?: InputMaybe<Course_Participant_Order_By>;
  course_participant_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module?: InputMaybe<Module_Order_By>;
  module_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_participant_module */
export type Course_Participant_Module_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_participant_module" */
export enum Course_Participant_Module_Select_Column {
  /** column name */
  Completed = 'completed',
  /** column name */
  CourseParticipantId = 'course_participant_id',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleId = 'module_id'
}

/** select "course_participant_module_aggregate_bool_exp_bool_and_arguments_columns" columns of table "course_participant_module" */
export enum Course_Participant_Module_Select_Column_Course_Participant_Module_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Completed = 'completed'
}

/** select "course_participant_module_aggregate_bool_exp_bool_or_arguments_columns" columns of table "course_participant_module" */
export enum Course_Participant_Module_Select_Column_Course_Participant_Module_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Completed = 'completed'
}

/** input type for updating data in table "course_participant_module" */
export type Course_Participant_Module_Set_Input = {
  completed?: InputMaybe<Scalars['Boolean']>;
  course_participant_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  module_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "course_participant_module" */
export type Course_Participant_Module_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Participant_Module_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Participant_Module_Stream_Cursor_Value_Input = {
  completed?: InputMaybe<Scalars['Boolean']>;
  course_participant_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  module_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "course_participant_module" */
export enum Course_Participant_Module_Update_Column {
  /** column name */
  Completed = 'completed',
  /** column name */
  CourseParticipantId = 'course_participant_id',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleId = 'module_id'
}

export type Course_Participant_Module_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Participant_Module_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Participant_Module_Bool_Exp;
};

/** response of any mutation on the table "course_participant" */
export type Course_Participant_Mutation_Response = {
  __typename?: 'course_participant_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Participant>;
};

/** Notes for each module group participant was graded for */
export type Course_Participant_Note = {
  __typename?: 'course_participant_note';
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  moduleGroupId: Scalars['uuid'];
  note: Scalars['String'];
  /** An object relationship */
  participant: Course_Participant;
  participantId: Scalars['uuid'];
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "course_participant_note" */
export type Course_Participant_Note_Aggregate = {
  __typename?: 'course_participant_note_aggregate';
  aggregate?: Maybe<Course_Participant_Note_Aggregate_Fields>;
  nodes: Array<Course_Participant_Note>;
};

export type Course_Participant_Note_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Participant_Note_Aggregate_Bool_Exp_Count>;
};

export type Course_Participant_Note_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Participant_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Participant_Note_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_participant_note" */
export type Course_Participant_Note_Aggregate_Fields = {
  __typename?: 'course_participant_note_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Participant_Note_Max_Fields>;
  min?: Maybe<Course_Participant_Note_Min_Fields>;
};


/** aggregate fields of "course_participant_note" */
export type Course_Participant_Note_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Participant_Note_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_participant_note" */
export type Course_Participant_Note_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Participant_Note_Max_Order_By>;
  min?: InputMaybe<Course_Participant_Note_Min_Order_By>;
};

/** input type for inserting array relation for remote table "course_participant_note" */
export type Course_Participant_Note_Arr_Rel_Insert_Input = {
  data: Array<Course_Participant_Note_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Participant_Note_On_Conflict>;
};

/** Boolean expression to filter rows from the table "course_participant_note". All fields are combined with a logical 'AND'. */
export type Course_Participant_Note_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Participant_Note_Bool_Exp>>;
  _not?: InputMaybe<Course_Participant_Note_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Participant_Note_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  moduleGroupId?: InputMaybe<Uuid_Comparison_Exp>;
  note?: InputMaybe<String_Comparison_Exp>;
  participant?: InputMaybe<Course_Participant_Bool_Exp>;
  participantId?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_participant_note" */
export enum Course_Participant_Note_Constraint {
  /** unique or primary key constraint on columns "participant_id", "module_group_id" */
  CourseParticipantNoteParticipantIdModuleGroupIdKey = 'course_participant_note_participant_id_module_group_id_key',
  /** unique or primary key constraint on columns "id" */
  CourseParticipantNotePkey = 'course_participant_note_pkey'
}

/** input type for inserting data into table "course_participant_note" */
export type Course_Participant_Note_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  moduleGroupId?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<Scalars['String']>;
  participant?: InputMaybe<Course_Participant_Obj_Rel_Insert_Input>;
  participantId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Participant_Note_Max_Fields = {
  __typename?: 'course_participant_note_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  moduleGroupId?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  participantId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_participant_note" */
export type Course_Participant_Note_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moduleGroupId?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  participantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Participant_Note_Min_Fields = {
  __typename?: 'course_participant_note_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  moduleGroupId?: Maybe<Scalars['uuid']>;
  note?: Maybe<Scalars['String']>;
  participantId?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_participant_note" */
export type Course_Participant_Note_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moduleGroupId?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  participantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_participant_note" */
export type Course_Participant_Note_Mutation_Response = {
  __typename?: 'course_participant_note_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Participant_Note>;
};

/** on_conflict condition type for table "course_participant_note" */
export type Course_Participant_Note_On_Conflict = {
  constraint: Course_Participant_Note_Constraint;
  update_columns?: Array<Course_Participant_Note_Update_Column>;
  where?: InputMaybe<Course_Participant_Note_Bool_Exp>;
};

/** Ordering options when selecting data from "course_participant_note". */
export type Course_Participant_Note_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moduleGroupId?: InputMaybe<Order_By>;
  note?: InputMaybe<Order_By>;
  participant?: InputMaybe<Course_Participant_Order_By>;
  participantId?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_participant_note */
export type Course_Participant_Note_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_participant_note" */
export enum Course_Participant_Note_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleGroupId = 'moduleGroupId',
  /** column name */
  Note = 'note',
  /** column name */
  ParticipantId = 'participantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "course_participant_note" */
export type Course_Participant_Note_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  moduleGroupId?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<Scalars['String']>;
  participantId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "course_participant_note" */
export type Course_Participant_Note_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Participant_Note_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Participant_Note_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  moduleGroupId?: InputMaybe<Scalars['uuid']>;
  note?: InputMaybe<Scalars['String']>;
  participantId?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "course_participant_note" */
export enum Course_Participant_Note_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleGroupId = 'moduleGroupId',
  /** column name */
  Note = 'note',
  /** column name */
  ParticipantId = 'participantId',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Course_Participant_Note_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Participant_Note_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Participant_Note_Bool_Exp;
};

/** input type for inserting object relation for remote table "course_participant" */
export type Course_Participant_Obj_Rel_Insert_Input = {
  data: Course_Participant_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Participant_On_Conflict>;
};

/** on_conflict condition type for table "course_participant" */
export type Course_Participant_On_Conflict = {
  constraint: Course_Participant_Constraint;
  update_columns?: Array<Course_Participant_Update_Column>;
  where?: InputMaybe<Course_Participant_Bool_Exp>;
};

/** Ordering options when selecting data from "course_participant". */
export type Course_Participant_Order_By = {
  attended?: InputMaybe<Order_By>;
  bildGradingModules?: InputMaybe<Course_Participant_Bild_Module_Order_By>;
  bookingDate?: InputMaybe<Order_By>;
  certificate?: InputMaybe<Course_Certificate_Order_By>;
  certificateChanges_aggregate?: InputMaybe<Course_Certificate_Changelog_Aggregate_Order_By>;
  certificate_id?: InputMaybe<Order_By>;
  completed?: InputMaybe<Order_By>;
  completed_at?: InputMaybe<Order_By>;
  completed_evaluation?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  course_id?: InputMaybe<Order_By>;
  course_participant_about_training_email_scheduled_event?: InputMaybe<About_Training_Email_Scheduled_Events_Order_By>;
  created_at?: InputMaybe<Order_By>;
  dateGraded?: InputMaybe<Order_By>;
  go1EnrolmentId?: InputMaybe<Order_By>;
  go1EnrolmentProgress?: InputMaybe<Order_By>;
  go1EnrolmentStarted?: InputMaybe<Order_By>;
  go1EnrolmentStatus?: InputMaybe<Order_By>;
  grade?: InputMaybe<Order_By>;
  gradedOn?: InputMaybe<Order_By>;
  gradingModules_aggregate?: InputMaybe<Course_Participant_Module_Aggregate_Order_By>;
  grading_feedback?: InputMaybe<Order_By>;
  healthSafetyConsent?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invite?: InputMaybe<Course_Invites_Order_By>;
  invite_id?: InputMaybe<Order_By>;
  invoiceID?: InputMaybe<Order_By>;
  notes_aggregate?: InputMaybe<Course_Participant_Note_Aggregate_Order_By>;
  order?: InputMaybe<Order_Order_By>;
  orderId?: InputMaybe<Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  registration_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_participant */
export type Course_Participant_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Course_Participant_Prepend_Input = {
  gradedOn?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "course_participant" */
export enum Course_Participant_Select_Column {
  /** column name */
  Attended = 'attended',
  /** column name */
  BookingDate = 'bookingDate',
  /** column name */
  CertificateId = 'certificate_id',
  /** column name */
  Completed = 'completed',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CompletedEvaluation = 'completed_evaluation',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateGraded = 'dateGraded',
  /** column name */
  Go1EnrolmentId = 'go1EnrolmentId',
  /** column name */
  Go1EnrolmentProgress = 'go1EnrolmentProgress',
  /** column name */
  Go1EnrolmentStarted = 'go1EnrolmentStarted',
  /** column name */
  Go1EnrolmentStatus = 'go1EnrolmentStatus',
  /** column name */
  Grade = 'grade',
  /** column name */
  GradedOn = 'gradedOn',
  /** column name */
  GradingFeedback = 'grading_feedback',
  /** column name */
  HealthSafetyConsent = 'healthSafetyConsent',
  /** column name */
  Id = 'id',
  /** column name */
  InviteId = 'invite_id',
  /** column name */
  InvoiceId = 'invoiceID',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  RegistrationId = 'registration_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** select "course_participant_aggregate_bool_exp_bool_and_arguments_columns" columns of table "course_participant" */
export enum Course_Participant_Select_Column_Course_Participant_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Attended = 'attended',
  /** column name */
  Completed = 'completed',
  /** column name */
  CompletedEvaluation = 'completed_evaluation',
  /** column name */
  Go1EnrolmentStarted = 'go1EnrolmentStarted',
  /** column name */
  HealthSafetyConsent = 'healthSafetyConsent'
}

/** select "course_participant_aggregate_bool_exp_bool_or_arguments_columns" columns of table "course_participant" */
export enum Course_Participant_Select_Column_Course_Participant_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Attended = 'attended',
  /** column name */
  Completed = 'completed',
  /** column name */
  CompletedEvaluation = 'completed_evaluation',
  /** column name */
  Go1EnrolmentStarted = 'go1EnrolmentStarted',
  /** column name */
  HealthSafetyConsent = 'healthSafetyConsent'
}

/** input type for updating data in table "course_participant" */
export type Course_Participant_Set_Input = {
  attended?: InputMaybe<Scalars['Boolean']>;
  bookingDate?: InputMaybe<Scalars['timestamptz']>;
  certificate_id?: InputMaybe<Scalars['uuid']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  completed_evaluation?: InputMaybe<Scalars['Boolean']>;
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dateGraded?: InputMaybe<Scalars['timestamptz']>;
  go1EnrolmentId?: InputMaybe<Scalars['Int']>;
  go1EnrolmentProgress?: InputMaybe<Scalars['numeric']>;
  go1EnrolmentStarted?: InputMaybe<Scalars['Boolean']>;
  go1EnrolmentStatus?: InputMaybe<Blended_Learning_Status_Enum>;
  grade?: InputMaybe<Grade_Enum>;
  gradedOn?: InputMaybe<Scalars['jsonb']>;
  grading_feedback?: InputMaybe<Scalars['String']>;
  healthSafetyConsent?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  invite_id?: InputMaybe<Scalars['uuid']>;
  invoiceID?: InputMaybe<Scalars['uuid']>;
  orderId?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  registration_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Participant_Stddev_Fields = {
  __typename?: 'course_participant_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
  go1EnrolmentId?: Maybe<Scalars['Float']>;
  go1EnrolmentProgress?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_participant" */
export type Course_Participant_Stddev_Order_By = {
  course_id?: InputMaybe<Order_By>;
  go1EnrolmentId?: InputMaybe<Order_By>;
  go1EnrolmentProgress?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Participant_Stddev_Pop_Fields = {
  __typename?: 'course_participant_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
  go1EnrolmentId?: Maybe<Scalars['Float']>;
  go1EnrolmentProgress?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_participant" */
export type Course_Participant_Stddev_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
  go1EnrolmentId?: InputMaybe<Order_By>;
  go1EnrolmentProgress?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Participant_Stddev_Samp_Fields = {
  __typename?: 'course_participant_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
  go1EnrolmentId?: Maybe<Scalars['Float']>;
  go1EnrolmentProgress?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_participant" */
export type Course_Participant_Stddev_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
  go1EnrolmentId?: InputMaybe<Order_By>;
  go1EnrolmentProgress?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_participant" */
export type Course_Participant_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Participant_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Participant_Stream_Cursor_Value_Input = {
  attended?: InputMaybe<Scalars['Boolean']>;
  bookingDate?: InputMaybe<Scalars['timestamptz']>;
  certificate_id?: InputMaybe<Scalars['uuid']>;
  completed?: InputMaybe<Scalars['Boolean']>;
  completed_at?: InputMaybe<Scalars['timestamptz']>;
  completed_evaluation?: InputMaybe<Scalars['Boolean']>;
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  dateGraded?: InputMaybe<Scalars['timestamptz']>;
  go1EnrolmentId?: InputMaybe<Scalars['Int']>;
  go1EnrolmentProgress?: InputMaybe<Scalars['numeric']>;
  go1EnrolmentStarted?: InputMaybe<Scalars['Boolean']>;
  go1EnrolmentStatus?: InputMaybe<Blended_Learning_Status_Enum>;
  grade?: InputMaybe<Grade_Enum>;
  gradedOn?: InputMaybe<Scalars['jsonb']>;
  grading_feedback?: InputMaybe<Scalars['String']>;
  healthSafetyConsent?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  invite_id?: InputMaybe<Scalars['uuid']>;
  invoiceID?: InputMaybe<Scalars['uuid']>;
  orderId?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  registration_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Participant_Sum_Fields = {
  __typename?: 'course_participant_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
  go1EnrolmentId?: Maybe<Scalars['Int']>;
  go1EnrolmentProgress?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "course_participant" */
export type Course_Participant_Sum_Order_By = {
  course_id?: InputMaybe<Order_By>;
  go1EnrolmentId?: InputMaybe<Order_By>;
  go1EnrolmentProgress?: InputMaybe<Order_By>;
};

/** update columns of table "course_participant" */
export enum Course_Participant_Update_Column {
  /** column name */
  Attended = 'attended',
  /** column name */
  BookingDate = 'bookingDate',
  /** column name */
  CertificateId = 'certificate_id',
  /** column name */
  Completed = 'completed',
  /** column name */
  CompletedAt = 'completed_at',
  /** column name */
  CompletedEvaluation = 'completed_evaluation',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DateGraded = 'dateGraded',
  /** column name */
  Go1EnrolmentId = 'go1EnrolmentId',
  /** column name */
  Go1EnrolmentProgress = 'go1EnrolmentProgress',
  /** column name */
  Go1EnrolmentStarted = 'go1EnrolmentStarted',
  /** column name */
  Go1EnrolmentStatus = 'go1EnrolmentStatus',
  /** column name */
  Grade = 'grade',
  /** column name */
  GradedOn = 'gradedOn',
  /** column name */
  GradingFeedback = 'grading_feedback',
  /** column name */
  HealthSafetyConsent = 'healthSafetyConsent',
  /** column name */
  Id = 'id',
  /** column name */
  InviteId = 'invite_id',
  /** column name */
  InvoiceId = 'invoiceID',
  /** column name */
  OrderId = 'orderId',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  RegistrationId = 'registration_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Course_Participant_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Course_Participant_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Course_Participant_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Course_Participant_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Course_Participant_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Participant_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Course_Participant_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Participant_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Participant_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Participant_Var_Pop_Fields = {
  __typename?: 'course_participant_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
  go1EnrolmentId?: Maybe<Scalars['Float']>;
  go1EnrolmentProgress?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_participant" */
export type Course_Participant_Var_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
  go1EnrolmentId?: InputMaybe<Order_By>;
  go1EnrolmentProgress?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Participant_Var_Samp_Fields = {
  __typename?: 'course_participant_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
  go1EnrolmentId?: Maybe<Scalars['Float']>;
  go1EnrolmentProgress?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_participant" */
export type Course_Participant_Var_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
  go1EnrolmentId?: InputMaybe<Order_By>;
  go1EnrolmentProgress?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Participant_Variance_Fields = {
  __typename?: 'course_participant_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
  go1EnrolmentId?: Maybe<Scalars['Float']>;
  go1EnrolmentProgress?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_participant" */
export type Course_Participant_Variance_Order_By = {
  course_id?: InputMaybe<Order_By>;
  go1EnrolmentId?: InputMaybe<Order_By>;
  go1EnrolmentProgress?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course */
export type Course_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Course_Prepend_Input = {
  bookingContactInviteData?: InputMaybe<Scalars['jsonb']>;
  curriculum?: InputMaybe<Scalars['jsonb']>;
  organizationKeyContactInviteData?: InputMaybe<Scalars['jsonb']>;
};

/** Prices per participant for various course variants */
export type Course_Pricing = {
  __typename?: 'course_pricing';
  blended: Scalars['Boolean'];
  createdAt?: Maybe<Scalars['timestamptz']>;
  id: Scalars['uuid'];
  level: Course_Level_Enum;
  /** Price per participant without any discounts */
  priceAmount: Scalars['numeric'];
  priceCurrency: Scalars['String'];
  /** An array relationship */
  pricingSchedules: Array<Course_Pricing_Schedule>;
  /** An aggregate relationship */
  pricingSchedules_aggregate: Course_Pricing_Schedule_Aggregate;
  reaccreditation: Scalars['Boolean'];
  type: Course_Type_Enum;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  xeroCode: Scalars['String'];
};


/** Prices per participant for various course variants */
export type Course_PricingPricingSchedulesArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Schedule_Order_By>>;
  where?: InputMaybe<Course_Pricing_Schedule_Bool_Exp>;
};


/** Prices per participant for various course variants */
export type Course_PricingPricingSchedules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Schedule_Order_By>>;
  where?: InputMaybe<Course_Pricing_Schedule_Bool_Exp>;
};

/** aggregated selection of "course_pricing" */
export type Course_Pricing_Aggregate = {
  __typename?: 'course_pricing_aggregate';
  aggregate?: Maybe<Course_Pricing_Aggregate_Fields>;
  nodes: Array<Course_Pricing>;
};

/** aggregate fields of "course_pricing" */
export type Course_Pricing_Aggregate_Fields = {
  __typename?: 'course_pricing_aggregate_fields';
  avg?: Maybe<Course_Pricing_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Pricing_Max_Fields>;
  min?: Maybe<Course_Pricing_Min_Fields>;
  stddev?: Maybe<Course_Pricing_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Pricing_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Pricing_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Pricing_Sum_Fields>;
  var_pop?: Maybe<Course_Pricing_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Pricing_Var_Samp_Fields>;
  variance?: Maybe<Course_Pricing_Variance_Fields>;
};


/** aggregate fields of "course_pricing" */
export type Course_Pricing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Pricing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Course_Pricing_Avg_Fields = {
  __typename?: 'course_pricing_avg_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "course_pricing". All fields are combined with a logical 'AND'. */
export type Course_Pricing_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Pricing_Bool_Exp>>;
  _not?: InputMaybe<Course_Pricing_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Pricing_Bool_Exp>>;
  blended?: InputMaybe<Boolean_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  level?: InputMaybe<Course_Level_Enum_Comparison_Exp>;
  priceAmount?: InputMaybe<Numeric_Comparison_Exp>;
  priceCurrency?: InputMaybe<String_Comparison_Exp>;
  pricingSchedules?: InputMaybe<Course_Pricing_Schedule_Bool_Exp>;
  pricingSchedules_aggregate?: InputMaybe<Course_Pricing_Schedule_Aggregate_Bool_Exp>;
  reaccreditation?: InputMaybe<Boolean_Comparison_Exp>;
  type?: InputMaybe<Course_Type_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  xeroCode?: InputMaybe<String_Comparison_Exp>;
};

/** Changelog for course pricing */
export type Course_Pricing_Changelog = {
  __typename?: 'course_pricing_changelog';
  /** An object relationship */
  author?: Maybe<Profile>;
  authorId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  coursePricing: Course_Pricing;
  coursePricingId: Scalars['uuid'];
  coursePricingScheduleId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  courseSchedulePrice?: Maybe<Course_Pricing_Schedule>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  indefiniteEffectiveTo: Scalars['Boolean'];
  newEffectiveFrom?: Maybe<Scalars['timestamptz']>;
  newEffectiveTo?: Maybe<Scalars['timestamptz']>;
  newPrice?: Maybe<Scalars['numeric']>;
  oldEffectiveFrom?: Maybe<Scalars['timestamptz']>;
  oldEffectiveTo?: Maybe<Scalars['timestamptz']>;
  oldPrice?: Maybe<Scalars['numeric']>;
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "course_pricing_changelog" */
export type Course_Pricing_Changelog_Aggregate = {
  __typename?: 'course_pricing_changelog_aggregate';
  aggregate?: Maybe<Course_Pricing_Changelog_Aggregate_Fields>;
  nodes: Array<Course_Pricing_Changelog>;
};

/** aggregate fields of "course_pricing_changelog" */
export type Course_Pricing_Changelog_Aggregate_Fields = {
  __typename?: 'course_pricing_changelog_aggregate_fields';
  avg?: Maybe<Course_Pricing_Changelog_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Pricing_Changelog_Max_Fields>;
  min?: Maybe<Course_Pricing_Changelog_Min_Fields>;
  stddev?: Maybe<Course_Pricing_Changelog_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Pricing_Changelog_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Pricing_Changelog_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Pricing_Changelog_Sum_Fields>;
  var_pop?: Maybe<Course_Pricing_Changelog_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Pricing_Changelog_Var_Samp_Fields>;
  variance?: Maybe<Course_Pricing_Changelog_Variance_Fields>;
};


/** aggregate fields of "course_pricing_changelog" */
export type Course_Pricing_Changelog_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Pricing_Changelog_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Course_Pricing_Changelog_Avg_Fields = {
  __typename?: 'course_pricing_changelog_avg_fields';
  newPrice?: Maybe<Scalars['Float']>;
  oldPrice?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "course_pricing_changelog". All fields are combined with a logical 'AND'. */
export type Course_Pricing_Changelog_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Pricing_Changelog_Bool_Exp>>;
  _not?: InputMaybe<Course_Pricing_Changelog_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Pricing_Changelog_Bool_Exp>>;
  author?: InputMaybe<Profile_Bool_Exp>;
  authorId?: InputMaybe<Uuid_Comparison_Exp>;
  coursePricing?: InputMaybe<Course_Pricing_Bool_Exp>;
  coursePricingId?: InputMaybe<Uuid_Comparison_Exp>;
  coursePricingScheduleId?: InputMaybe<Uuid_Comparison_Exp>;
  courseSchedulePrice?: InputMaybe<Course_Pricing_Schedule_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  indefiniteEffectiveTo?: InputMaybe<Boolean_Comparison_Exp>;
  newEffectiveFrom?: InputMaybe<Timestamptz_Comparison_Exp>;
  newEffectiveTo?: InputMaybe<Timestamptz_Comparison_Exp>;
  newPrice?: InputMaybe<Numeric_Comparison_Exp>;
  oldEffectiveFrom?: InputMaybe<Timestamptz_Comparison_Exp>;
  oldEffectiveTo?: InputMaybe<Timestamptz_Comparison_Exp>;
  oldPrice?: InputMaybe<Numeric_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_pricing_changelog" */
export enum Course_Pricing_Changelog_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoursePricingChangelogPkey = 'course_pricing_changelog_pkey'
}

/** input type for incrementing numeric columns in table "course_pricing_changelog" */
export type Course_Pricing_Changelog_Inc_Input = {
  newPrice?: InputMaybe<Scalars['numeric']>;
  oldPrice?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "course_pricing_changelog" */
export type Course_Pricing_Changelog_Insert_Input = {
  author?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  authorId?: InputMaybe<Scalars['uuid']>;
  coursePricing?: InputMaybe<Course_Pricing_Obj_Rel_Insert_Input>;
  coursePricingId?: InputMaybe<Scalars['uuid']>;
  coursePricingScheduleId?: InputMaybe<Scalars['uuid']>;
  courseSchedulePrice?: InputMaybe<Course_Pricing_Schedule_Obj_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  indefiniteEffectiveTo?: InputMaybe<Scalars['Boolean']>;
  newEffectiveFrom?: InputMaybe<Scalars['timestamptz']>;
  newEffectiveTo?: InputMaybe<Scalars['timestamptz']>;
  newPrice?: InputMaybe<Scalars['numeric']>;
  oldEffectiveFrom?: InputMaybe<Scalars['timestamptz']>;
  oldEffectiveTo?: InputMaybe<Scalars['timestamptz']>;
  oldPrice?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Pricing_Changelog_Max_Fields = {
  __typename?: 'course_pricing_changelog_max_fields';
  authorId?: Maybe<Scalars['uuid']>;
  coursePricingId?: Maybe<Scalars['uuid']>;
  coursePricingScheduleId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  newEffectiveFrom?: Maybe<Scalars['timestamptz']>;
  newEffectiveTo?: Maybe<Scalars['timestamptz']>;
  newPrice?: Maybe<Scalars['numeric']>;
  oldEffectiveFrom?: Maybe<Scalars['timestamptz']>;
  oldEffectiveTo?: Maybe<Scalars['timestamptz']>;
  oldPrice?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Course_Pricing_Changelog_Min_Fields = {
  __typename?: 'course_pricing_changelog_min_fields';
  authorId?: Maybe<Scalars['uuid']>;
  coursePricingId?: Maybe<Scalars['uuid']>;
  coursePricingScheduleId?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  newEffectiveFrom?: Maybe<Scalars['timestamptz']>;
  newEffectiveTo?: Maybe<Scalars['timestamptz']>;
  newPrice?: Maybe<Scalars['numeric']>;
  oldEffectiveFrom?: Maybe<Scalars['timestamptz']>;
  oldEffectiveTo?: Maybe<Scalars['timestamptz']>;
  oldPrice?: Maybe<Scalars['numeric']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "course_pricing_changelog" */
export type Course_Pricing_Changelog_Mutation_Response = {
  __typename?: 'course_pricing_changelog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Pricing_Changelog>;
};

/** on_conflict condition type for table "course_pricing_changelog" */
export type Course_Pricing_Changelog_On_Conflict = {
  constraint: Course_Pricing_Changelog_Constraint;
  update_columns?: Array<Course_Pricing_Changelog_Update_Column>;
  where?: InputMaybe<Course_Pricing_Changelog_Bool_Exp>;
};

/** Ordering options when selecting data from "course_pricing_changelog". */
export type Course_Pricing_Changelog_Order_By = {
  author?: InputMaybe<Profile_Order_By>;
  authorId?: InputMaybe<Order_By>;
  coursePricing?: InputMaybe<Course_Pricing_Order_By>;
  coursePricingId?: InputMaybe<Order_By>;
  coursePricingScheduleId?: InputMaybe<Order_By>;
  courseSchedulePrice?: InputMaybe<Course_Pricing_Schedule_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  indefiniteEffectiveTo?: InputMaybe<Order_By>;
  newEffectiveFrom?: InputMaybe<Order_By>;
  newEffectiveTo?: InputMaybe<Order_By>;
  newPrice?: InputMaybe<Order_By>;
  oldEffectiveFrom?: InputMaybe<Order_By>;
  oldEffectiveTo?: InputMaybe<Order_By>;
  oldPrice?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_pricing_changelog */
export type Course_Pricing_Changelog_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_pricing_changelog" */
export enum Course_Pricing_Changelog_Select_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CoursePricingId = 'coursePricingId',
  /** column name */
  CoursePricingScheduleId = 'coursePricingScheduleId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IndefiniteEffectiveTo = 'indefiniteEffectiveTo',
  /** column name */
  NewEffectiveFrom = 'newEffectiveFrom',
  /** column name */
  NewEffectiveTo = 'newEffectiveTo',
  /** column name */
  NewPrice = 'newPrice',
  /** column name */
  OldEffectiveFrom = 'oldEffectiveFrom',
  /** column name */
  OldEffectiveTo = 'oldEffectiveTo',
  /** column name */
  OldPrice = 'oldPrice',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "course_pricing_changelog" */
export type Course_Pricing_Changelog_Set_Input = {
  authorId?: InputMaybe<Scalars['uuid']>;
  coursePricingId?: InputMaybe<Scalars['uuid']>;
  coursePricingScheduleId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  indefiniteEffectiveTo?: InputMaybe<Scalars['Boolean']>;
  newEffectiveFrom?: InputMaybe<Scalars['timestamptz']>;
  newEffectiveTo?: InputMaybe<Scalars['timestamptz']>;
  newPrice?: InputMaybe<Scalars['numeric']>;
  oldEffectiveFrom?: InputMaybe<Scalars['timestamptz']>;
  oldEffectiveTo?: InputMaybe<Scalars['timestamptz']>;
  oldPrice?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Pricing_Changelog_Stddev_Fields = {
  __typename?: 'course_pricing_changelog_stddev_fields';
  newPrice?: Maybe<Scalars['Float']>;
  oldPrice?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Course_Pricing_Changelog_Stddev_Pop_Fields = {
  __typename?: 'course_pricing_changelog_stddev_pop_fields';
  newPrice?: Maybe<Scalars['Float']>;
  oldPrice?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Course_Pricing_Changelog_Stddev_Samp_Fields = {
  __typename?: 'course_pricing_changelog_stddev_samp_fields';
  newPrice?: Maybe<Scalars['Float']>;
  oldPrice?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "course_pricing_changelog" */
export type Course_Pricing_Changelog_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Pricing_Changelog_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Pricing_Changelog_Stream_Cursor_Value_Input = {
  authorId?: InputMaybe<Scalars['uuid']>;
  coursePricingId?: InputMaybe<Scalars['uuid']>;
  coursePricingScheduleId?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  indefiniteEffectiveTo?: InputMaybe<Scalars['Boolean']>;
  newEffectiveFrom?: InputMaybe<Scalars['timestamptz']>;
  newEffectiveTo?: InputMaybe<Scalars['timestamptz']>;
  newPrice?: InputMaybe<Scalars['numeric']>;
  oldEffectiveFrom?: InputMaybe<Scalars['timestamptz']>;
  oldEffectiveTo?: InputMaybe<Scalars['timestamptz']>;
  oldPrice?: InputMaybe<Scalars['numeric']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Pricing_Changelog_Sum_Fields = {
  __typename?: 'course_pricing_changelog_sum_fields';
  newPrice?: Maybe<Scalars['numeric']>;
  oldPrice?: Maybe<Scalars['numeric']>;
};

/** update columns of table "course_pricing_changelog" */
export enum Course_Pricing_Changelog_Update_Column {
  /** column name */
  AuthorId = 'authorId',
  /** column name */
  CoursePricingId = 'coursePricingId',
  /** column name */
  CoursePricingScheduleId = 'coursePricingScheduleId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IndefiniteEffectiveTo = 'indefiniteEffectiveTo',
  /** column name */
  NewEffectiveFrom = 'newEffectiveFrom',
  /** column name */
  NewEffectiveTo = 'newEffectiveTo',
  /** column name */
  NewPrice = 'newPrice',
  /** column name */
  OldEffectiveFrom = 'oldEffectiveFrom',
  /** column name */
  OldEffectiveTo = 'oldEffectiveTo',
  /** column name */
  OldPrice = 'oldPrice',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Course_Pricing_Changelog_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Pricing_Changelog_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Pricing_Changelog_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Pricing_Changelog_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Pricing_Changelog_Var_Pop_Fields = {
  __typename?: 'course_pricing_changelog_var_pop_fields';
  newPrice?: Maybe<Scalars['Float']>;
  oldPrice?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Course_Pricing_Changelog_Var_Samp_Fields = {
  __typename?: 'course_pricing_changelog_var_samp_fields';
  newPrice?: Maybe<Scalars['Float']>;
  oldPrice?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Course_Pricing_Changelog_Variance_Fields = {
  __typename?: 'course_pricing_changelog_variance_fields';
  newPrice?: Maybe<Scalars['Float']>;
  oldPrice?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "course_pricing" */
export enum Course_Pricing_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoursePricingPkey = 'course_pricing_pkey',
  /** unique or primary key constraint on columns "type", "reaccreditation", "level", "blended", "price_currency" */
  CoursePricingTypeReaccreditationBlendedLevelPriceCurrenc = 'course_pricing_type_reaccreditation_blended_level_price_currenc'
}

/** input type for incrementing numeric columns in table "course_pricing" */
export type Course_Pricing_Inc_Input = {
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "course_pricing" */
export type Course_Pricing_Insert_Input = {
  blended?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Course_Level_Enum>;
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Scalars['numeric']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  pricingSchedules?: InputMaybe<Course_Pricing_Schedule_Arr_Rel_Insert_Input>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Course_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  xeroCode?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Pricing_Max_Fields = {
  __typename?: 'course_pricing_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['numeric']>;
  priceCurrency?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  xeroCode?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Pricing_Min_Fields = {
  __typename?: 'course_pricing_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['numeric']>;
  priceCurrency?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  xeroCode?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_pricing" */
export type Course_Pricing_Mutation_Response = {
  __typename?: 'course_pricing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Pricing>;
};

/** input type for inserting object relation for remote table "course_pricing" */
export type Course_Pricing_Obj_Rel_Insert_Input = {
  data: Course_Pricing_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Pricing_On_Conflict>;
};

/** on_conflict condition type for table "course_pricing" */
export type Course_Pricing_On_Conflict = {
  constraint: Course_Pricing_Constraint;
  update_columns?: Array<Course_Pricing_Update_Column>;
  where?: InputMaybe<Course_Pricing_Bool_Exp>;
};

/** Ordering options when selecting data from "course_pricing". */
export type Course_Pricing_Order_By = {
  blended?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  priceAmount?: InputMaybe<Order_By>;
  priceCurrency?: InputMaybe<Order_By>;
  pricingSchedules_aggregate?: InputMaybe<Course_Pricing_Schedule_Aggregate_Order_By>;
  reaccreditation?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  xeroCode?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_pricing */
export type Course_Pricing_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** Schedules for course pricing per participant */
export type Course_Pricing_Schedule = {
  __typename?: 'course_pricing_schedule';
  coursePricingId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  effectiveFrom: Scalars['date'];
  effectiveTo?: Maybe<Scalars['date']>;
  id: Scalars['uuid'];
  /** Price per participant without any discounts */
  priceAmount: Scalars['numeric'];
  priceCurrency: Scalars['String'];
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "course_pricing_schedule" */
export type Course_Pricing_Schedule_Aggregate = {
  __typename?: 'course_pricing_schedule_aggregate';
  aggregate?: Maybe<Course_Pricing_Schedule_Aggregate_Fields>;
  nodes: Array<Course_Pricing_Schedule>;
};

export type Course_Pricing_Schedule_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Pricing_Schedule_Aggregate_Bool_Exp_Count>;
};

export type Course_Pricing_Schedule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Pricing_Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Pricing_Schedule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_pricing_schedule" */
export type Course_Pricing_Schedule_Aggregate_Fields = {
  __typename?: 'course_pricing_schedule_aggregate_fields';
  avg?: Maybe<Course_Pricing_Schedule_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Pricing_Schedule_Max_Fields>;
  min?: Maybe<Course_Pricing_Schedule_Min_Fields>;
  stddev?: Maybe<Course_Pricing_Schedule_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Pricing_Schedule_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Pricing_Schedule_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Pricing_Schedule_Sum_Fields>;
  var_pop?: Maybe<Course_Pricing_Schedule_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Pricing_Schedule_Var_Samp_Fields>;
  variance?: Maybe<Course_Pricing_Schedule_Variance_Fields>;
};


/** aggregate fields of "course_pricing_schedule" */
export type Course_Pricing_Schedule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Pricing_Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Pricing_Schedule_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Pricing_Schedule_Max_Order_By>;
  min?: InputMaybe<Course_Pricing_Schedule_Min_Order_By>;
  stddev?: InputMaybe<Course_Pricing_Schedule_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Pricing_Schedule_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Pricing_Schedule_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Pricing_Schedule_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Pricing_Schedule_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Pricing_Schedule_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Pricing_Schedule_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Arr_Rel_Insert_Input = {
  data: Array<Course_Pricing_Schedule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Pricing_Schedule_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Pricing_Schedule_Avg_Fields = {
  __typename?: 'course_pricing_schedule_avg_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Avg_Order_By = {
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_pricing_schedule". All fields are combined with a logical 'AND'. */
export type Course_Pricing_Schedule_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Pricing_Schedule_Bool_Exp>>;
  _not?: InputMaybe<Course_Pricing_Schedule_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Pricing_Schedule_Bool_Exp>>;
  coursePricingId?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  effectiveFrom?: InputMaybe<Date_Comparison_Exp>;
  effectiveTo?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  priceAmount?: InputMaybe<Numeric_Comparison_Exp>;
  priceCurrency?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_pricing_schedule" */
export enum Course_Pricing_Schedule_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoursePricingSchedulePkey = 'course_pricing_schedule_pkey'
}

/** input type for incrementing numeric columns in table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Inc_Input = {
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Insert_Input = {
  coursePricingId?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  effectiveFrom?: InputMaybe<Scalars['date']>;
  effectiveTo?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Scalars['numeric']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Course_Pricing_Schedule_Max_Fields = {
  __typename?: 'course_pricing_schedule_max_fields';
  coursePricingId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  effectiveFrom?: Maybe<Scalars['date']>;
  effectiveTo?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['numeric']>;
  priceCurrency?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Max_Order_By = {
  coursePricingId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  effectiveFrom?: InputMaybe<Order_By>;
  effectiveTo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Order_By>;
  priceCurrency?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Pricing_Schedule_Min_Fields = {
  __typename?: 'course_pricing_schedule_min_fields';
  coursePricingId?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  effectiveFrom?: Maybe<Scalars['date']>;
  effectiveTo?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['numeric']>;
  priceCurrency?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Min_Order_By = {
  coursePricingId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  effectiveFrom?: InputMaybe<Order_By>;
  effectiveTo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Order_By>;
  priceCurrency?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Mutation_Response = {
  __typename?: 'course_pricing_schedule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Pricing_Schedule>;
};

/** input type for inserting object relation for remote table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Obj_Rel_Insert_Input = {
  data: Course_Pricing_Schedule_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Pricing_Schedule_On_Conflict>;
};

/** on_conflict condition type for table "course_pricing_schedule" */
export type Course_Pricing_Schedule_On_Conflict = {
  constraint: Course_Pricing_Schedule_Constraint;
  update_columns?: Array<Course_Pricing_Schedule_Update_Column>;
  where?: InputMaybe<Course_Pricing_Schedule_Bool_Exp>;
};

/** Ordering options when selecting data from "course_pricing_schedule". */
export type Course_Pricing_Schedule_Order_By = {
  coursePricingId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  effectiveFrom?: InputMaybe<Order_By>;
  effectiveTo?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  priceAmount?: InputMaybe<Order_By>;
  priceCurrency?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_pricing_schedule */
export type Course_Pricing_Schedule_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_pricing_schedule" */
export enum Course_Pricing_Schedule_Select_Column {
  /** column name */
  CoursePricingId = 'coursePricingId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EffectiveFrom = 'effectiveFrom',
  /** column name */
  EffectiveTo = 'effectiveTo',
  /** column name */
  Id = 'id',
  /** column name */
  PriceAmount = 'priceAmount',
  /** column name */
  PriceCurrency = 'priceCurrency',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Set_Input = {
  coursePricingId?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  effectiveFrom?: InputMaybe<Scalars['date']>;
  effectiveTo?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Scalars['numeric']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Course_Pricing_Schedule_Stddev_Fields = {
  __typename?: 'course_pricing_schedule_stddev_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Stddev_Order_By = {
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Pricing_Schedule_Stddev_Pop_Fields = {
  __typename?: 'course_pricing_schedule_stddev_pop_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Stddev_Pop_Order_By = {
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Pricing_Schedule_Stddev_Samp_Fields = {
  __typename?: 'course_pricing_schedule_stddev_samp_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Stddev_Samp_Order_By = {
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Pricing_Schedule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Pricing_Schedule_Stream_Cursor_Value_Input = {
  coursePricingId?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  effectiveFrom?: InputMaybe<Scalars['date']>;
  effectiveTo?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Scalars['numeric']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Pricing_Schedule_Sum_Fields = {
  __typename?: 'course_pricing_schedule_sum_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Sum_Order_By = {
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Order_By>;
};

/** update columns of table "course_pricing_schedule" */
export enum Course_Pricing_Schedule_Update_Column {
  /** column name */
  CoursePricingId = 'coursePricingId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EffectiveFrom = 'effectiveFrom',
  /** column name */
  EffectiveTo = 'effectiveTo',
  /** column name */
  Id = 'id',
  /** column name */
  PriceAmount = 'priceAmount',
  /** column name */
  PriceCurrency = 'priceCurrency',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Course_Pricing_Schedule_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Pricing_Schedule_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Pricing_Schedule_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Pricing_Schedule_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Pricing_Schedule_Var_Pop_Fields = {
  __typename?: 'course_pricing_schedule_var_pop_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Var_Pop_Order_By = {
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Pricing_Schedule_Var_Samp_Fields = {
  __typename?: 'course_pricing_schedule_var_samp_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Var_Samp_Order_By = {
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Pricing_Schedule_Variance_Fields = {
  __typename?: 'course_pricing_schedule_variance_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_pricing_schedule" */
export type Course_Pricing_Schedule_Variance_Order_By = {
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Order_By>;
};

/** select columns of table "course_pricing" */
export enum Course_Pricing_Select_Column {
  /** column name */
  Blended = 'blended',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  PriceAmount = 'priceAmount',
  /** column name */
  PriceCurrency = 'priceCurrency',
  /** column name */
  Reaccreditation = 'reaccreditation',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  XeroCode = 'xeroCode'
}

/** input type for updating data in table "course_pricing" */
export type Course_Pricing_Set_Input = {
  blended?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Course_Level_Enum>;
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Scalars['numeric']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Course_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  xeroCode?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Course_Pricing_Stddev_Fields = {
  __typename?: 'course_pricing_stddev_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Course_Pricing_Stddev_Pop_Fields = {
  __typename?: 'course_pricing_stddev_pop_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Course_Pricing_Stddev_Samp_Fields = {
  __typename?: 'course_pricing_stddev_samp_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "course_pricing" */
export type Course_Pricing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Pricing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Pricing_Stream_Cursor_Value_Input = {
  blended?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Course_Level_Enum>;
  /** Price per participant without any discounts */
  priceAmount?: InputMaybe<Scalars['numeric']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  type?: InputMaybe<Course_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  xeroCode?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Course_Pricing_Sum_Fields = {
  __typename?: 'course_pricing_sum_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['numeric']>;
};

/** update columns of table "course_pricing" */
export enum Course_Pricing_Update_Column {
  /** column name */
  Blended = 'blended',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  PriceAmount = 'priceAmount',
  /** column name */
  PriceCurrency = 'priceCurrency',
  /** column name */
  Reaccreditation = 'reaccreditation',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  XeroCode = 'xeroCode'
}

export type Course_Pricing_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Pricing_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Pricing_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Pricing_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Pricing_Var_Pop_Fields = {
  __typename?: 'course_pricing_var_pop_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Course_Pricing_Var_Samp_Fields = {
  __typename?: 'course_pricing_var_samp_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Course_Pricing_Variance_Fields = {
  __typename?: 'course_pricing_variance_fields';
  /** Price per participant without any discounts */
  priceAmount?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "course_promo_code" */
export type Course_Promo_Code = {
  __typename?: 'course_promo_code';
  /** An object relationship */
  course?: Maybe<Course>;
  course_id?: Maybe<Scalars['Int']>;
  id: Scalars['uuid'];
  /** An object relationship */
  promo_code?: Maybe<Promo_Code>;
  promo_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "course_promo_code" */
export type Course_Promo_Code_Aggregate = {
  __typename?: 'course_promo_code_aggregate';
  aggregate?: Maybe<Course_Promo_Code_Aggregate_Fields>;
  nodes: Array<Course_Promo_Code>;
};

export type Course_Promo_Code_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Promo_Code_Aggregate_Bool_Exp_Count>;
};

export type Course_Promo_Code_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Promo_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Promo_Code_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_promo_code" */
export type Course_Promo_Code_Aggregate_Fields = {
  __typename?: 'course_promo_code_aggregate_fields';
  avg?: Maybe<Course_Promo_Code_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Promo_Code_Max_Fields>;
  min?: Maybe<Course_Promo_Code_Min_Fields>;
  stddev?: Maybe<Course_Promo_Code_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Promo_Code_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Promo_Code_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Promo_Code_Sum_Fields>;
  var_pop?: Maybe<Course_Promo_Code_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Promo_Code_Var_Samp_Fields>;
  variance?: Maybe<Course_Promo_Code_Variance_Fields>;
};


/** aggregate fields of "course_promo_code" */
export type Course_Promo_Code_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Promo_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_promo_code" */
export type Course_Promo_Code_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Promo_Code_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Promo_Code_Max_Order_By>;
  min?: InputMaybe<Course_Promo_Code_Min_Order_By>;
  stddev?: InputMaybe<Course_Promo_Code_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Promo_Code_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Promo_Code_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Promo_Code_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Promo_Code_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Promo_Code_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Promo_Code_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_promo_code" */
export type Course_Promo_Code_Arr_Rel_Insert_Input = {
  data: Array<Course_Promo_Code_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Promo_Code_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Promo_Code_Avg_Fields = {
  __typename?: 'course_promo_code_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_promo_code" */
export type Course_Promo_Code_Avg_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_promo_code". All fields are combined with a logical 'AND'. */
export type Course_Promo_Code_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Promo_Code_Bool_Exp>>;
  _not?: InputMaybe<Course_Promo_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Promo_Code_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  promo_code?: InputMaybe<Promo_Code_Bool_Exp>;
  promo_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_promo_code" */
export enum Course_Promo_Code_Constraint {
  /** unique or primary key constraint on columns "id" */
  CoursePromoCodePkey = 'course_promo_code_pkey'
}

/** input type for incrementing numeric columns in table "course_promo_code" */
export type Course_Promo_Code_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_promo_code" */
export type Course_Promo_Code_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  promo_code?: InputMaybe<Promo_Code_Obj_Rel_Insert_Input>;
  promo_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Course_Promo_Code_Max_Fields = {
  __typename?: 'course_promo_code_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  promo_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "course_promo_code" */
export type Course_Promo_Code_Max_Order_By = {
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  promo_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Promo_Code_Min_Fields = {
  __typename?: 'course_promo_code_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  promo_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "course_promo_code" */
export type Course_Promo_Code_Min_Order_By = {
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  promo_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_promo_code" */
export type Course_Promo_Code_Mutation_Response = {
  __typename?: 'course_promo_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Promo_Code>;
};

/** on_conflict condition type for table "course_promo_code" */
export type Course_Promo_Code_On_Conflict = {
  constraint: Course_Promo_Code_Constraint;
  update_columns?: Array<Course_Promo_Code_Update_Column>;
  where?: InputMaybe<Course_Promo_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "course_promo_code". */
export type Course_Promo_Code_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  promo_code?: InputMaybe<Promo_Code_Order_By>;
  promo_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_promo_code */
export type Course_Promo_Code_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_promo_code" */
export enum Course_Promo_Code_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  PromoId = 'promo_id'
}

/** input type for updating data in table "course_promo_code" */
export type Course_Promo_Code_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  promo_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Course_Promo_Code_Stddev_Fields = {
  __typename?: 'course_promo_code_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_promo_code" */
export type Course_Promo_Code_Stddev_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Promo_Code_Stddev_Pop_Fields = {
  __typename?: 'course_promo_code_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_promo_code" */
export type Course_Promo_Code_Stddev_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Promo_Code_Stddev_Samp_Fields = {
  __typename?: 'course_promo_code_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_promo_code" */
export type Course_Promo_Code_Stddev_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_promo_code" */
export type Course_Promo_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Promo_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Promo_Code_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  promo_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Course_Promo_Code_Sum_Fields = {
  __typename?: 'course_promo_code_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_promo_code" */
export type Course_Promo_Code_Sum_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** update columns of table "course_promo_code" */
export enum Course_Promo_Code_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  PromoId = 'promo_id'
}

export type Course_Promo_Code_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Promo_Code_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Promo_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Promo_Code_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Promo_Code_Var_Pop_Fields = {
  __typename?: 'course_promo_code_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_promo_code" */
export type Course_Promo_Code_Var_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Promo_Code_Var_Samp_Fields = {
  __typename?: 'course_promo_code_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_promo_code" */
export type Course_Promo_Code_Var_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Promo_Code_Variance_Fields = {
  __typename?: 'course_promo_code_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_promo_code" */
export type Course_Promo_Code_Variance_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Enum table for available course renewal cycles */
export type Course_Renewal_Cycle = {
  __typename?: 'course_renewal_cycle';
  value: Scalars['String'];
};

/** aggregated selection of "course_renewal_cycle" */
export type Course_Renewal_Cycle_Aggregate = {
  __typename?: 'course_renewal_cycle_aggregate';
  aggregate?: Maybe<Course_Renewal_Cycle_Aggregate_Fields>;
  nodes: Array<Course_Renewal_Cycle>;
};

/** aggregate fields of "course_renewal_cycle" */
export type Course_Renewal_Cycle_Aggregate_Fields = {
  __typename?: 'course_renewal_cycle_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Renewal_Cycle_Max_Fields>;
  min?: Maybe<Course_Renewal_Cycle_Min_Fields>;
};


/** aggregate fields of "course_renewal_cycle" */
export type Course_Renewal_Cycle_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Renewal_Cycle_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_renewal_cycle". All fields are combined with a logical 'AND'. */
export type Course_Renewal_Cycle_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Renewal_Cycle_Bool_Exp>>;
  _not?: InputMaybe<Course_Renewal_Cycle_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Renewal_Cycle_Bool_Exp>>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_renewal_cycle" */
export enum Course_Renewal_Cycle_Constraint {
  /** unique or primary key constraint on columns "value" */
  CourseRenewalCyclePkey = 'course_renewal_cycle_pkey'
}

export enum Course_Renewal_Cycle_Enum {
  One = 'ONE',
  Three = 'THREE',
  Two = 'TWO'
}

/** Boolean expression to compare columns of type "course_renewal_cycle_enum". All fields are combined with logical 'AND'. */
export type Course_Renewal_Cycle_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Renewal_Cycle_Enum>;
  _in?: InputMaybe<Array<Course_Renewal_Cycle_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Renewal_Cycle_Enum>;
  _nin?: InputMaybe<Array<Course_Renewal_Cycle_Enum>>;
};

/** input type for inserting data into table "course_renewal_cycle" */
export type Course_Renewal_Cycle_Insert_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Renewal_Cycle_Max_Fields = {
  __typename?: 'course_renewal_cycle_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Renewal_Cycle_Min_Fields = {
  __typename?: 'course_renewal_cycle_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_renewal_cycle" */
export type Course_Renewal_Cycle_Mutation_Response = {
  __typename?: 'course_renewal_cycle_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Renewal_Cycle>;
};

/** on_conflict condition type for table "course_renewal_cycle" */
export type Course_Renewal_Cycle_On_Conflict = {
  constraint: Course_Renewal_Cycle_Constraint;
  update_columns?: Array<Course_Renewal_Cycle_Update_Column>;
  where?: InputMaybe<Course_Renewal_Cycle_Bool_Exp>;
};

/** Ordering options when selecting data from "course_renewal_cycle". */
export type Course_Renewal_Cycle_Order_By = {
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_renewal_cycle */
export type Course_Renewal_Cycle_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "course_renewal_cycle" */
export enum Course_Renewal_Cycle_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "course_renewal_cycle" */
export type Course_Renewal_Cycle_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_renewal_cycle" */
export type Course_Renewal_Cycle_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Renewal_Cycle_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Renewal_Cycle_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_renewal_cycle" */
export enum Course_Renewal_Cycle_Update_Column {
  /** column name */
  Value = 'value'
}

export type Course_Renewal_Cycle_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Renewal_Cycle_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Renewal_Cycle_Bool_Exp;
};

/** columns and relationships of "course_schedule" */
export type Course_Schedule = {
  __typename?: 'course_schedule';
  /** An object relationship */
  course: Course;
  course_id: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  end: Scalars['timestamptz'];
  id: Scalars['uuid'];
  start: Scalars['timestamptz'];
  timeZone: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
  /** An object relationship */
  venue?: Maybe<Venue>;
  venue_id?: Maybe<Scalars['uuid']>;
  virtualAccountId?: Maybe<Scalars['String']>;
  virtualLink?: Maybe<Scalars['String']>;
};

/** aggregated selection of "course_schedule" */
export type Course_Schedule_Aggregate = {
  __typename?: 'course_schedule_aggregate';
  aggregate?: Maybe<Course_Schedule_Aggregate_Fields>;
  nodes: Array<Course_Schedule>;
};

export type Course_Schedule_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Schedule_Aggregate_Bool_Exp_Count>;
};

export type Course_Schedule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Schedule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_schedule" */
export type Course_Schedule_Aggregate_Fields = {
  __typename?: 'course_schedule_aggregate_fields';
  avg?: Maybe<Course_Schedule_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Schedule_Max_Fields>;
  min?: Maybe<Course_Schedule_Min_Fields>;
  stddev?: Maybe<Course_Schedule_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Schedule_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Schedule_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Schedule_Sum_Fields>;
  var_pop?: Maybe<Course_Schedule_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Schedule_Var_Samp_Fields>;
  variance?: Maybe<Course_Schedule_Variance_Fields>;
};


/** aggregate fields of "course_schedule" */
export type Course_Schedule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Schedule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_schedule" */
export type Course_Schedule_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Schedule_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Schedule_Max_Order_By>;
  min?: InputMaybe<Course_Schedule_Min_Order_By>;
  stddev?: InputMaybe<Course_Schedule_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Schedule_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Schedule_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Schedule_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Schedule_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Schedule_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Schedule_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_schedule" */
export type Course_Schedule_Arr_Rel_Insert_Input = {
  data: Array<Course_Schedule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Schedule_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Schedule_Avg_Fields = {
  __typename?: 'course_schedule_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_schedule" */
export type Course_Schedule_Avg_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_schedule". All fields are combined with a logical 'AND'. */
export type Course_Schedule_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Schedule_Bool_Exp>>;
  _not?: InputMaybe<Course_Schedule_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Schedule_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  end?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  start?: InputMaybe<Timestamptz_Comparison_Exp>;
  timeZone?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  venue?: InputMaybe<Venue_Bool_Exp>;
  venue_id?: InputMaybe<Uuid_Comparison_Exp>;
  virtualAccountId?: InputMaybe<String_Comparison_Exp>;
  virtualLink?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_schedule" */
export enum Course_Schedule_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseSchedulePkey = 'course_schedule_pkey'
}

/** input type for incrementing numeric columns in table "course_schedule" */
export type Course_Schedule_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_schedule" */
export type Course_Schedule_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  timeZone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue?: InputMaybe<Venue_Obj_Rel_Insert_Input>;
  venue_id?: InputMaybe<Scalars['uuid']>;
  virtualAccountId?: InputMaybe<Scalars['String']>;
  virtualLink?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Schedule_Max_Fields = {
  __typename?: 'course_schedule_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  timeZone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venue_id?: Maybe<Scalars['uuid']>;
  virtualAccountId?: Maybe<Scalars['String']>;
  virtualLink?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "course_schedule" */
export type Course_Schedule_Max_Order_By = {
  course_id?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  venue_id?: InputMaybe<Order_By>;
  virtualAccountId?: InputMaybe<Order_By>;
  virtualLink?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Schedule_Min_Fields = {
  __typename?: 'course_schedule_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  end?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  start?: Maybe<Scalars['timestamptz']>;
  timeZone?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  venue_id?: Maybe<Scalars['uuid']>;
  virtualAccountId?: Maybe<Scalars['String']>;
  virtualLink?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "course_schedule" */
export type Course_Schedule_Min_Order_By = {
  course_id?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  venue_id?: InputMaybe<Order_By>;
  virtualAccountId?: InputMaybe<Order_By>;
  virtualLink?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_schedule" */
export type Course_Schedule_Mutation_Response = {
  __typename?: 'course_schedule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Schedule>;
};

/** on_conflict condition type for table "course_schedule" */
export type Course_Schedule_On_Conflict = {
  constraint: Course_Schedule_Constraint;
  update_columns?: Array<Course_Schedule_Update_Column>;
  where?: InputMaybe<Course_Schedule_Bool_Exp>;
};

/** Ordering options when selecting data from "course_schedule". */
export type Course_Schedule_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  course_id?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  end?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  start?: InputMaybe<Order_By>;
  timeZone?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  venue?: InputMaybe<Venue_Order_By>;
  venue_id?: InputMaybe<Order_By>;
  virtualAccountId?: InputMaybe<Order_By>;
  virtualLink?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_schedule */
export type Course_Schedule_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_schedule" */
export enum Course_Schedule_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  Start = 'start',
  /** column name */
  TimeZone = 'timeZone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venue_id',
  /** column name */
  VirtualAccountId = 'virtualAccountId',
  /** column name */
  VirtualLink = 'virtualLink'
}

/** input type for updating data in table "course_schedule" */
export type Course_Schedule_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  timeZone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue_id?: InputMaybe<Scalars['uuid']>;
  virtualAccountId?: InputMaybe<Scalars['String']>;
  virtualLink?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Course_Schedule_Stddev_Fields = {
  __typename?: 'course_schedule_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_schedule" */
export type Course_Schedule_Stddev_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Schedule_Stddev_Pop_Fields = {
  __typename?: 'course_schedule_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_schedule" */
export type Course_Schedule_Stddev_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Schedule_Stddev_Samp_Fields = {
  __typename?: 'course_schedule_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_schedule" */
export type Course_Schedule_Stddev_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_schedule" */
export type Course_Schedule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Schedule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Schedule_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  end?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  start?: InputMaybe<Scalars['timestamptz']>;
  timeZone?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  venue_id?: InputMaybe<Scalars['uuid']>;
  virtualAccountId?: InputMaybe<Scalars['String']>;
  virtualLink?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Course_Schedule_Sum_Fields = {
  __typename?: 'course_schedule_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_schedule" */
export type Course_Schedule_Sum_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** update columns of table "course_schedule" */
export enum Course_Schedule_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  End = 'end',
  /** column name */
  Id = 'id',
  /** column name */
  Start = 'start',
  /** column name */
  TimeZone = 'timeZone',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  VenueId = 'venue_id',
  /** column name */
  VirtualAccountId = 'virtualAccountId',
  /** column name */
  VirtualLink = 'virtualLink'
}

export type Course_Schedule_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Schedule_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Schedule_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Schedule_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Schedule_Var_Pop_Fields = {
  __typename?: 'course_schedule_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_schedule" */
export type Course_Schedule_Var_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Schedule_Var_Samp_Fields = {
  __typename?: 'course_schedule_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_schedule" */
export type Course_Schedule_Var_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Schedule_Variance_Fields = {
  __typename?: 'course_schedule_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_schedule" */
export type Course_Schedule_Variance_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** select columns of table "course" */
export enum Course_Select_Column {
  /** column name */
  AccountCode = 'accountCode',
  /** column name */
  AccreditedBy = 'accreditedBy',
  /** column name */
  AolCostOfCourse = 'aolCostOfCourse',
  /** column name */
  AolCountry = 'aolCountry',
  /** column name */
  AolRegion = 'aolRegion',
  /** column name */
  ArloReferenceId = 'arloReferenceId',
  /** column name */
  BookingContactInviteData = 'bookingContactInviteData',
  /** column name */
  BookingContactProfileId = 'bookingContactProfileId',
  /** column name */
  CancellationFee = 'cancellationFee',
  /** column name */
  CancellationFeeType = 'cancellationFeeType',
  /** column name */
  CancellationReason = 'cancellationReason',
  /** column name */
  Conversion = 'conversion',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  Curriculum = 'curriculum',
  /** column name */
  DeliveryType = 'deliveryType',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOnWebsite = 'displayOnWebsite',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  ExceptionsPending = 'exceptionsPending',
  /** column name */
  FreeSpaces = 'freeSpaces',
  /** column name */
  FreeCourseMaterials = 'free_course_materials',
  /** column name */
  Go1Integration = 'go1Integration',
  /** column name */
  GradingConfirmed = 'gradingConfirmed',
  /** column name */
  GradingStarted = 'gradingStarted',
  /** column name */
  GradingCompletedOn = 'grading_completed_on',
  /** column name */
  HubspotDealId = 'hubspot_deal_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeVat = 'includeVAT',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  IsTender = 'is_tender',
  /** column name */
  Level = 'level',
  /** column name */
  MaterialsOrganizationId = 'materials_organization_id',
  /** column name */
  MaxParticipants = 'max_participants',
  /** column name */
  MinParticipants = 'min_participants',
  /** column name */
  ModulesDuration = 'modulesDuration',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationKeyContactInviteData = 'organizationKeyContactInviteData',
  /** column name */
  OrganizationKeyContactProfileId = 'organizationKeyContactProfileId',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ParkingInstructions = 'parking_instructions',
  /** column name */
  Price = 'price',
  /** column name */
  PriceCurrency = 'priceCurrency',
  /** column name */
  Reaccreditation = 'reaccreditation',
  /** column name */
  Region = 'region',
  /** column name */
  RenewalCycle = 'renewalCycle',
  /** column name */
  ResidingCountry = 'residingCountry',
  /** column name */
  ResourcePacksDeliveryType = 'resourcePacksDeliveryType',
  /** column name */
  ResourcePacksType = 'resourcePacksType',
  /** column name */
  SearchFields = 'search_fields',
  /** column name */
  Source = 'source',
  /** column name */
  SpecialInstructions = 'special_instructions',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "course_aggregate_bool_exp_bool_and_arguments_columns" columns of table "course" */
export enum Course_Select_Column_Course_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Conversion = 'conversion',
  /** column name */
  DisplayOnWebsite = 'displayOnWebsite',
  /** column name */
  ExceptionsPending = 'exceptionsPending',
  /** column name */
  Go1Integration = 'go1Integration',
  /** column name */
  GradingConfirmed = 'gradingConfirmed',
  /** column name */
  GradingStarted = 'gradingStarted',
  /** column name */
  IncludeVat = 'includeVAT',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  IsTender = 'is_tender',
  /** column name */
  Reaccreditation = 'reaccreditation'
}

/** select "course_aggregate_bool_exp_bool_or_arguments_columns" columns of table "course" */
export enum Course_Select_Column_Course_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Conversion = 'conversion',
  /** column name */
  DisplayOnWebsite = 'displayOnWebsite',
  /** column name */
  ExceptionsPending = 'exceptionsPending',
  /** column name */
  Go1Integration = 'go1Integration',
  /** column name */
  GradingConfirmed = 'gradingConfirmed',
  /** column name */
  GradingStarted = 'gradingStarted',
  /** column name */
  IncludeVat = 'includeVAT',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  IsTender = 'is_tender',
  /** column name */
  Reaccreditation = 'reaccreditation'
}

/** input type for updating data in table "course" */
export type Course_Set_Input = {
  accountCode?: InputMaybe<Scalars['String']>;
  accreditedBy?: InputMaybe<Accreditors_Enum>;
  aolCostOfCourse?: InputMaybe<Scalars['numeric']>;
  aolCountry?: InputMaybe<Scalars['String']>;
  aolRegion?: InputMaybe<Scalars['String']>;
  arloReferenceId?: InputMaybe<Scalars['String']>;
  bookingContactInviteData?: InputMaybe<Scalars['jsonb']>;
  bookingContactProfileId?: InputMaybe<Scalars['uuid']>;
  cancellationFee?: InputMaybe<Scalars['Float']>;
  cancellationFeeType?: InputMaybe<Course_Cancellation_Fee_Type_Enum>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  conversion?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdById?: InputMaybe<Scalars['uuid']>;
  curriculum?: InputMaybe<Scalars['jsonb']>;
  deliveryType?: InputMaybe<Course_Delivery_Type_Enum>;
  description?: InputMaybe<Scalars['String']>;
  displayOnWebsite?: InputMaybe<Scalars['Boolean']>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  end_date?: InputMaybe<Scalars['date']>;
  exceptionsPending?: InputMaybe<Scalars['Boolean']>;
  freeSpaces?: InputMaybe<Scalars['Int']>;
  free_course_materials?: InputMaybe<Scalars['Int']>;
  go1Integration?: InputMaybe<Scalars['Boolean']>;
  gradingConfirmed?: InputMaybe<Scalars['Boolean']>;
  gradingStarted?: InputMaybe<Scalars['Boolean']>;
  grading_completed_on?: InputMaybe<Scalars['timestamptz']>;
  hubspot_deal_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  includeVAT?: InputMaybe<Scalars['Boolean']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  is_tender?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Course_Level_Enum>;
  materials_organization_id?: InputMaybe<Scalars['uuid']>;
  max_participants?: InputMaybe<Scalars['Int']>;
  min_participants?: InputMaybe<Scalars['Int']>;
  modulesDuration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationKeyContactInviteData?: InputMaybe<Scalars['jsonb']>;
  organizationKeyContactProfileId?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  parking_instructions?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Scalars['String']>;
  renewalCycle?: InputMaybe<Course_Renewal_Cycle_Enum>;
  residingCountry?: InputMaybe<Scalars['String']>;
  resourcePacksDeliveryType?: InputMaybe<Resource_Packs_Delivery_Type_Enum>;
  resourcePacksType?: InputMaybe<Resource_Packs_Type_Enum>;
  search_fields?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Course_Source_Enum>;
  special_instructions?: InputMaybe<Scalars['String']>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  start_date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Course_Status_Enum>;
  type?: InputMaybe<Course_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Enum table for different course sales sources */
export type Course_Source = {
  __typename?: 'course_source';
  name: Scalars['String'];
};

/** aggregated selection of "course_source" */
export type Course_Source_Aggregate = {
  __typename?: 'course_source_aggregate';
  aggregate?: Maybe<Course_Source_Aggregate_Fields>;
  nodes: Array<Course_Source>;
};

/** aggregate fields of "course_source" */
export type Course_Source_Aggregate_Fields = {
  __typename?: 'course_source_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Source_Max_Fields>;
  min?: Maybe<Course_Source_Min_Fields>;
};


/** aggregate fields of "course_source" */
export type Course_Source_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Source_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_source". All fields are combined with a logical 'AND'. */
export type Course_Source_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Source_Bool_Exp>>;
  _not?: InputMaybe<Course_Source_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Source_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_source" */
export enum Course_Source_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseSourcePkey = 'course_source_pkey'
}

export enum Course_Source_Enum {
  BlogOrPublication = 'BLOG_OR_PUBLICATION',
  Email = 'EMAIL',
  EmailEnquiry = 'EMAIL_ENQUIRY',
  EmailEnquiryCentral = 'EMAIL_ENQUIRY_CENTRAL',
  Event = 'EVENT',
  ExistingClient = 'EXISTING_CLIENT',
  MarketingCampaign = 'MARKETING_CAMPAIGN',
  Ndis = 'NDIS',
  OnlineAdvertisement = 'ONLINE_ADVERTISEMENT',
  Other = 'OTHER',
  Recommendation = 'RECOMMENDATION',
  ReturningCustomer = 'RETURNING_CUSTOMER',
  SalesCall = 'SALES_CALL',
  SalesMailer = 'SALES_MAILER',
  SearchEngine = 'SEARCH_ENGINE',
  SocialMedia = 'SOCIAL_MEDIA',
  TelephoneEnquiry = 'TELEPHONE_ENQUIRY',
  Tender = 'TENDER',
  Webinar = 'WEBINAR',
  WebsiteEnquiry = 'WEBSITE_ENQUIRY'
}

/** Boolean expression to compare columns of type "course_source_enum". All fields are combined with logical 'AND'. */
export type Course_Source_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Source_Enum>;
  _in?: InputMaybe<Array<Course_Source_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Source_Enum>;
  _nin?: InputMaybe<Array<Course_Source_Enum>>;
};

/** input type for inserting data into table "course_source" */
export type Course_Source_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Source_Max_Fields = {
  __typename?: 'course_source_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Source_Min_Fields = {
  __typename?: 'course_source_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_source" */
export type Course_Source_Mutation_Response = {
  __typename?: 'course_source_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Source>;
};

/** on_conflict condition type for table "course_source" */
export type Course_Source_On_Conflict = {
  constraint: Course_Source_Constraint;
  update_columns?: Array<Course_Source_Update_Column>;
  where?: InputMaybe<Course_Source_Bool_Exp>;
};

/** Ordering options when selecting data from "course_source". */
export type Course_Source_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_source */
export type Course_Source_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "course_source" */
export enum Course_Source_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_source" */
export type Course_Source_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_source" */
export type Course_Source_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Source_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Source_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_source" */
export enum Course_Source_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Source_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Source_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Source_Bool_Exp;
};

/** columns and relationships of "course_status" */
export type Course_Status = {
  __typename?: 'course_status';
  name: Scalars['String'];
};

/** aggregated selection of "course_status" */
export type Course_Status_Aggregate = {
  __typename?: 'course_status_aggregate';
  aggregate?: Maybe<Course_Status_Aggregate_Fields>;
  nodes: Array<Course_Status>;
};

/** aggregate fields of "course_status" */
export type Course_Status_Aggregate_Fields = {
  __typename?: 'course_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Status_Max_Fields>;
  min?: Maybe<Course_Status_Min_Fields>;
};


/** aggregate fields of "course_status" */
export type Course_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_status". All fields are combined with a logical 'AND'. */
export type Course_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Status_Bool_Exp>>;
  _not?: InputMaybe<Course_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_status" */
export enum Course_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseStatusPkey = 'course_status_pkey'
}

export enum Course_Status_Enum {
  Cancelled = 'CANCELLED',
  Completed = 'COMPLETED',
  ConfirmModules = 'CONFIRM_MODULES',
  Declined = 'DECLINED',
  Draft = 'DRAFT',
  EvaluationMissing = 'EVALUATION_MISSING',
  ExceptionsApprovalPending = 'EXCEPTIONS_APPROVAL_PENDING',
  GradeMissing = 'GRADE_MISSING',
  Scheduled = 'SCHEDULED',
  TrainerDeclined = 'TRAINER_DECLINED',
  TrainerMissing = 'TRAINER_MISSING',
  TrainerPending = 'TRAINER_PENDING',
  VenueMissing = 'VENUE_MISSING'
}

/** Boolean expression to compare columns of type "course_status_enum". All fields are combined with logical 'AND'. */
export type Course_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Status_Enum>;
  _in?: InputMaybe<Array<Course_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Status_Enum>;
  _nin?: InputMaybe<Array<Course_Status_Enum>>;
};

/** input type for inserting data into table "course_status" */
export type Course_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Status_Max_Fields = {
  __typename?: 'course_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Status_Min_Fields = {
  __typename?: 'course_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_status" */
export type Course_Status_Mutation_Response = {
  __typename?: 'course_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Status>;
};

/** on_conflict condition type for table "course_status" */
export type Course_Status_On_Conflict = {
  constraint: Course_Status_Constraint;
  update_columns?: Array<Course_Status_Update_Column>;
  where?: InputMaybe<Course_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "course_status". */
export type Course_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_status */
export type Course_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "course_status" */
export enum Course_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_status" */
export type Course_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_status" */
export type Course_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Status_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_status" */
export enum Course_Status_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Course_Stddev_Fields = {
  __typename?: 'course_stddev_fields';
  aolCostOfCourse?: Maybe<Scalars['Float']>;
  cancellationFee?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_free_slots" */
  freeSlots?: Maybe<Scalars['Int']>;
  freeSpaces?: Maybe<Scalars['Float']>;
  free_course_materials?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
  modulesDuration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_reserved_go1_licenses" */
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  /** A computed field returns the total count of reserved resource packs for a course, derived from resource pack reservation events in the organization's resource pack management history. */
  reservedResourcePacks?: Maybe<Scalars['Int']>;
};

/** order by stddev() on columns of table "course" */
export type Course_Stddev_Order_By = {
  aolCostOfCourse?: InputMaybe<Order_By>;
  cancellationFee?: InputMaybe<Order_By>;
  freeSpaces?: InputMaybe<Order_By>;
  free_course_materials?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_participants?: InputMaybe<Order_By>;
  min_participants?: InputMaybe<Order_By>;
  modulesDuration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Stddev_Pop_Fields = {
  __typename?: 'course_stddev_pop_fields';
  aolCostOfCourse?: Maybe<Scalars['Float']>;
  cancellationFee?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_free_slots" */
  freeSlots?: Maybe<Scalars['Int']>;
  freeSpaces?: Maybe<Scalars['Float']>;
  free_course_materials?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
  modulesDuration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_reserved_go1_licenses" */
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  /** A computed field returns the total count of reserved resource packs for a course, derived from resource pack reservation events in the organization's resource pack management history. */
  reservedResourcePacks?: Maybe<Scalars['Int']>;
};

/** order by stddev_pop() on columns of table "course" */
export type Course_Stddev_Pop_Order_By = {
  aolCostOfCourse?: InputMaybe<Order_By>;
  cancellationFee?: InputMaybe<Order_By>;
  freeSpaces?: InputMaybe<Order_By>;
  free_course_materials?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_participants?: InputMaybe<Order_By>;
  min_participants?: InputMaybe<Order_By>;
  modulesDuration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Stddev_Samp_Fields = {
  __typename?: 'course_stddev_samp_fields';
  aolCostOfCourse?: Maybe<Scalars['Float']>;
  cancellationFee?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_free_slots" */
  freeSlots?: Maybe<Scalars['Int']>;
  freeSpaces?: Maybe<Scalars['Float']>;
  free_course_materials?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
  modulesDuration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_reserved_go1_licenses" */
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  /** A computed field returns the total count of reserved resource packs for a course, derived from resource pack reservation events in the organization's resource pack management history. */
  reservedResourcePacks?: Maybe<Scalars['Int']>;
};

/** order by stddev_samp() on columns of table "course" */
export type Course_Stddev_Samp_Order_By = {
  aolCostOfCourse?: InputMaybe<Order_By>;
  cancellationFee?: InputMaybe<Order_By>;
  freeSpaces?: InputMaybe<Order_By>;
  free_course_materials?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_participants?: InputMaybe<Order_By>;
  min_participants?: InputMaybe<Order_By>;
  modulesDuration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course" */
export type Course_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Stream_Cursor_Value_Input = {
  accountCode?: InputMaybe<Scalars['String']>;
  accreditedBy?: InputMaybe<Accreditors_Enum>;
  aolCostOfCourse?: InputMaybe<Scalars['numeric']>;
  aolCountry?: InputMaybe<Scalars['String']>;
  aolRegion?: InputMaybe<Scalars['String']>;
  arloReferenceId?: InputMaybe<Scalars['String']>;
  bookingContactInviteData?: InputMaybe<Scalars['jsonb']>;
  bookingContactProfileId?: InputMaybe<Scalars['uuid']>;
  cancellationFee?: InputMaybe<Scalars['Float']>;
  cancellationFeeType?: InputMaybe<Course_Cancellation_Fee_Type_Enum>;
  cancellationReason?: InputMaybe<Scalars['String']>;
  conversion?: InputMaybe<Scalars['Boolean']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdById?: InputMaybe<Scalars['uuid']>;
  curriculum?: InputMaybe<Scalars['jsonb']>;
  deliveryType?: InputMaybe<Course_Delivery_Type_Enum>;
  description?: InputMaybe<Scalars['String']>;
  displayOnWebsite?: InputMaybe<Scalars['Boolean']>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  end_date?: InputMaybe<Scalars['date']>;
  exceptionsPending?: InputMaybe<Scalars['Boolean']>;
  freeSpaces?: InputMaybe<Scalars['Int']>;
  free_course_materials?: InputMaybe<Scalars['Int']>;
  go1Integration?: InputMaybe<Scalars['Boolean']>;
  gradingConfirmed?: InputMaybe<Scalars['Boolean']>;
  gradingStarted?: InputMaybe<Scalars['Boolean']>;
  grading_completed_on?: InputMaybe<Scalars['timestamptz']>;
  hubspot_deal_id?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  includeVAT?: InputMaybe<Scalars['Boolean']>;
  isDraft?: InputMaybe<Scalars['Boolean']>;
  is_tender?: InputMaybe<Scalars['Boolean']>;
  level?: InputMaybe<Course_Level_Enum>;
  materials_organization_id?: InputMaybe<Scalars['uuid']>;
  max_participants?: InputMaybe<Scalars['Int']>;
  min_participants?: InputMaybe<Scalars['Int']>;
  modulesDuration?: InputMaybe<Scalars['Int']>;
  name?: InputMaybe<Scalars['String']>;
  organizationKeyContactInviteData?: InputMaybe<Scalars['jsonb']>;
  organizationKeyContactProfileId?: InputMaybe<Scalars['uuid']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  parking_instructions?: InputMaybe<Scalars['String']>;
  price?: InputMaybe<Scalars['numeric']>;
  priceCurrency?: InputMaybe<Scalars['String']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  region?: InputMaybe<Scalars['String']>;
  renewalCycle?: InputMaybe<Course_Renewal_Cycle_Enum>;
  residingCountry?: InputMaybe<Scalars['String']>;
  resourcePacksDeliveryType?: InputMaybe<Resource_Packs_Delivery_Type_Enum>;
  resourcePacksType?: InputMaybe<Resource_Packs_Type_Enum>;
  search_fields?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Course_Source_Enum>;
  special_instructions?: InputMaybe<Scalars['String']>;
  /** Column used only for querying courses in a sorted order as having this column here queries data quicker than relying on course_schedule values. This column is updated automatically via course_schedule triggers */
  start_date?: InputMaybe<Scalars['date']>;
  status?: InputMaybe<Course_Status_Enum>;
  type?: InputMaybe<Course_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Course_Sum_Fields = {
  __typename?: 'course_sum_fields';
  aolCostOfCourse?: Maybe<Scalars['numeric']>;
  cancellationFee?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_free_slots" */
  freeSlots?: Maybe<Scalars['Int']>;
  freeSpaces?: Maybe<Scalars['Int']>;
  free_course_materials?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  max_participants?: Maybe<Scalars['Int']>;
  min_participants?: Maybe<Scalars['Int']>;
  modulesDuration?: Maybe<Scalars['Int']>;
  price?: Maybe<Scalars['numeric']>;
  /** A computed field, executes function "course_reserved_go1_licenses" */
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  /** A computed field returns the total count of reserved resource packs for a course, derived from resource pack reservation events in the organization's resource pack management history. */
  reservedResourcePacks?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course" */
export type Course_Sum_Order_By = {
  aolCostOfCourse?: InputMaybe<Order_By>;
  cancellationFee?: InputMaybe<Order_By>;
  freeSpaces?: InputMaybe<Order_By>;
  free_course_materials?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_participants?: InputMaybe<Order_By>;
  min_participants?: InputMaybe<Order_By>;
  modulesDuration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_trainer" */
export type Course_Trainer = {
  __typename?: 'course_trainer';
  /** An object relationship */
  course: Course;
  course_id: Scalars['Int'];
  id: Scalars['uuid'];
  /** An object relationship */
  profile: Profile;
  profile_id: Scalars['uuid'];
  status?: Maybe<Course_Invite_Status_Enum>;
  type: Course_Trainer_Type_Enum;
};

/** aggregated selection of "course_trainer" */
export type Course_Trainer_Aggregate = {
  __typename?: 'course_trainer_aggregate';
  aggregate?: Maybe<Course_Trainer_Aggregate_Fields>;
  nodes: Array<Course_Trainer>;
};

export type Course_Trainer_Aggregate_Bool_Exp = {
  count?: InputMaybe<Course_Trainer_Aggregate_Bool_Exp_Count>;
};

export type Course_Trainer_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Course_Trainer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Course_Trainer_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "course_trainer" */
export type Course_Trainer_Aggregate_Fields = {
  __typename?: 'course_trainer_aggregate_fields';
  avg?: Maybe<Course_Trainer_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Course_Trainer_Max_Fields>;
  min?: Maybe<Course_Trainer_Min_Fields>;
  stddev?: Maybe<Course_Trainer_Stddev_Fields>;
  stddev_pop?: Maybe<Course_Trainer_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Course_Trainer_Stddev_Samp_Fields>;
  sum?: Maybe<Course_Trainer_Sum_Fields>;
  var_pop?: Maybe<Course_Trainer_Var_Pop_Fields>;
  var_samp?: Maybe<Course_Trainer_Var_Samp_Fields>;
  variance?: Maybe<Course_Trainer_Variance_Fields>;
};


/** aggregate fields of "course_trainer" */
export type Course_Trainer_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Trainer_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "course_trainer" */
export type Course_Trainer_Aggregate_Order_By = {
  avg?: InputMaybe<Course_Trainer_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Course_Trainer_Max_Order_By>;
  min?: InputMaybe<Course_Trainer_Min_Order_By>;
  stddev?: InputMaybe<Course_Trainer_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Course_Trainer_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Course_Trainer_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Course_Trainer_Sum_Order_By>;
  var_pop?: InputMaybe<Course_Trainer_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Course_Trainer_Var_Samp_Order_By>;
  variance?: InputMaybe<Course_Trainer_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "course_trainer" */
export type Course_Trainer_Arr_Rel_Insert_Input = {
  data: Array<Course_Trainer_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Course_Trainer_On_Conflict>;
};

/** aggregate avg on columns */
export type Course_Trainer_Avg_Fields = {
  __typename?: 'course_trainer_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "course_trainer" */
export type Course_Trainer_Avg_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "course_trainer". All fields are combined with a logical 'AND'. */
export type Course_Trainer_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Trainer_Bool_Exp>>;
  _not?: InputMaybe<Course_Trainer_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Trainer_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<Course_Invite_Status_Enum_Comparison_Exp>;
  type?: InputMaybe<Course_Trainer_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_trainer" */
export enum Course_Trainer_Constraint {
  /** unique or primary key constraint on columns "id" */
  CourseLeaderPkey = 'course_leader_pkey',
  /** unique or primary key constraint on columns "course_id", "profile_id" */
  CourseTrainerCourseIdProfileIdKey = 'course_trainer_course_id_profile_id_key',
  /** unique or primary key constraint on columns "course_id" */
  CourseTrainerUniqueLeader = 'course_trainer_unique_leader'
}

/** input type for incrementing numeric columns in table "course_trainer" */
export type Course_Trainer_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "course_trainer" */
export type Course_Trainer_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Course_Invite_Status_Enum>;
  type?: InputMaybe<Course_Trainer_Type_Enum>;
};

/** aggregate max on columns */
export type Course_Trainer_Max_Fields = {
  __typename?: 'course_trainer_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "course_trainer" */
export type Course_Trainer_Max_Order_By = {
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Course_Trainer_Min_Fields = {
  __typename?: 'course_trainer_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "course_trainer" */
export type Course_Trainer_Min_Order_By = {
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "course_trainer" */
export type Course_Trainer_Mutation_Response = {
  __typename?: 'course_trainer_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Trainer>;
};

/** on_conflict condition type for table "course_trainer" */
export type Course_Trainer_On_Conflict = {
  constraint: Course_Trainer_Constraint;
  update_columns?: Array<Course_Trainer_Update_Column>;
  where?: InputMaybe<Course_Trainer_Bool_Exp>;
};

/** Ordering options when selecting data from "course_trainer". */
export type Course_Trainer_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_trainer */
export type Course_Trainer_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_trainer" */
export enum Course_Trainer_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "course_trainer" */
export type Course_Trainer_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Course_Invite_Status_Enum>;
  type?: InputMaybe<Course_Trainer_Type_Enum>;
};

/** aggregate stddev on columns */
export type Course_Trainer_Stddev_Fields = {
  __typename?: 'course_trainer_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "course_trainer" */
export type Course_Trainer_Stddev_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Course_Trainer_Stddev_Pop_Fields = {
  __typename?: 'course_trainer_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "course_trainer" */
export type Course_Trainer_Stddev_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Course_Trainer_Stddev_Samp_Fields = {
  __typename?: 'course_trainer_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "course_trainer" */
export type Course_Trainer_Stddev_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "course_trainer" */
export type Course_Trainer_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Trainer_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Trainer_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Course_Invite_Status_Enum>;
  type?: InputMaybe<Course_Trainer_Type_Enum>;
};

/** aggregate sum on columns */
export type Course_Trainer_Sum_Fields = {
  __typename?: 'course_trainer_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "course_trainer" */
export type Course_Trainer_Sum_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_trainer_type" */
export type Course_Trainer_Type = {
  __typename?: 'course_trainer_type';
  name: Scalars['String'];
};

/** aggregated selection of "course_trainer_type" */
export type Course_Trainer_Type_Aggregate = {
  __typename?: 'course_trainer_type_aggregate';
  aggregate?: Maybe<Course_Trainer_Type_Aggregate_Fields>;
  nodes: Array<Course_Trainer_Type>;
};

/** aggregate fields of "course_trainer_type" */
export type Course_Trainer_Type_Aggregate_Fields = {
  __typename?: 'course_trainer_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Trainer_Type_Max_Fields>;
  min?: Maybe<Course_Trainer_Type_Min_Fields>;
};


/** aggregate fields of "course_trainer_type" */
export type Course_Trainer_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Trainer_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_trainer_type". All fields are combined with a logical 'AND'. */
export type Course_Trainer_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Trainer_Type_Bool_Exp>>;
  _not?: InputMaybe<Course_Trainer_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Trainer_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_trainer_type" */
export enum Course_Trainer_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseTrainerTypePkey = 'course_trainer_type_pkey'
}

export enum Course_Trainer_Type_Enum {
  Assistant = 'ASSISTANT',
  Leader = 'LEADER',
  Moderator = 'MODERATOR'
}

/** Boolean expression to compare columns of type "course_trainer_type_enum". All fields are combined with logical 'AND'. */
export type Course_Trainer_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Trainer_Type_Enum>;
  _in?: InputMaybe<Array<Course_Trainer_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Trainer_Type_Enum>;
  _nin?: InputMaybe<Array<Course_Trainer_Type_Enum>>;
};

/** input type for inserting data into table "course_trainer_type" */
export type Course_Trainer_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Trainer_Type_Max_Fields = {
  __typename?: 'course_trainer_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Trainer_Type_Min_Fields = {
  __typename?: 'course_trainer_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_trainer_type" */
export type Course_Trainer_Type_Mutation_Response = {
  __typename?: 'course_trainer_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Trainer_Type>;
};

/** on_conflict condition type for table "course_trainer_type" */
export type Course_Trainer_Type_On_Conflict = {
  constraint: Course_Trainer_Type_Constraint;
  update_columns?: Array<Course_Trainer_Type_Update_Column>;
  where?: InputMaybe<Course_Trainer_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "course_trainer_type". */
export type Course_Trainer_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_trainer_type */
export type Course_Trainer_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "course_trainer_type" */
export enum Course_Trainer_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_trainer_type" */
export type Course_Trainer_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_trainer_type" */
export type Course_Trainer_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Trainer_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Trainer_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_trainer_type" */
export enum Course_Trainer_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Trainer_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Trainer_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Trainer_Type_Bool_Exp;
};

/** update columns of table "course_trainer" */
export enum Course_Trainer_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

export type Course_Trainer_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Trainer_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Trainer_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Trainer_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Trainer_Var_Pop_Fields = {
  __typename?: 'course_trainer_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "course_trainer" */
export type Course_Trainer_Var_Pop_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Trainer_Var_Samp_Fields = {
  __typename?: 'course_trainer_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "course_trainer" */
export type Course_Trainer_Var_Samp_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Trainer_Variance_Fields = {
  __typename?: 'course_trainer_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "course_trainer" */
export type Course_Trainer_Variance_Order_By = {
  course_id?: InputMaybe<Order_By>;
};

/** columns and relationships of "course_type" */
export type Course_Type = {
  __typename?: 'course_type';
  name: Scalars['String'];
};

/** aggregated selection of "course_type" */
export type Course_Type_Aggregate = {
  __typename?: 'course_type_aggregate';
  aggregate?: Maybe<Course_Type_Aggregate_Fields>;
  nodes: Array<Course_Type>;
};

/** aggregate fields of "course_type" */
export type Course_Type_Aggregate_Fields = {
  __typename?: 'course_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Type_Max_Fields>;
  min?: Maybe<Course_Type_Min_Fields>;
};


/** aggregate fields of "course_type" */
export type Course_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_type". All fields are combined with a logical 'AND'. */
export type Course_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Type_Bool_Exp>>;
  _not?: InputMaybe<Course_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_type" */
export enum Course_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseTypePkey = 'course_type_pkey'
}

export enum Course_Type_Enum {
  Closed = 'CLOSED',
  Indirect = 'INDIRECT',
  Open = 'OPEN'
}

/** Boolean expression to compare columns of type "course_type_enum". All fields are combined with logical 'AND'. */
export type Course_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Course_Type_Enum>;
  _in?: InputMaybe<Array<Course_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Course_Type_Enum>;
  _nin?: InputMaybe<Array<Course_Type_Enum>>;
};

/** input type for inserting data into table "course_type" */
export type Course_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Type_Max_Fields = {
  __typename?: 'course_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Type_Min_Fields = {
  __typename?: 'course_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_type" */
export type Course_Type_Mutation_Response = {
  __typename?: 'course_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Type>;
};

/** on_conflict condition type for table "course_type" */
export type Course_Type_On_Conflict = {
  constraint: Course_Type_Constraint;
  update_columns?: Array<Course_Type_Update_Column>;
  where?: InputMaybe<Course_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "course_type". */
export type Course_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_type */
export type Course_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** Course types with their prefixes (used to generate course codes) */
export type Course_Type_Prefix = {
  __typename?: 'course_type_prefix';
  id: Scalars['uuid'];
  name: Scalars['String'];
  prefix: Scalars['String'];
};

/** aggregated selection of "course_type_prefix" */
export type Course_Type_Prefix_Aggregate = {
  __typename?: 'course_type_prefix_aggregate';
  aggregate?: Maybe<Course_Type_Prefix_Aggregate_Fields>;
  nodes: Array<Course_Type_Prefix>;
};

/** aggregate fields of "course_type_prefix" */
export type Course_Type_Prefix_Aggregate_Fields = {
  __typename?: 'course_type_prefix_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Course_Type_Prefix_Max_Fields>;
  min?: Maybe<Course_Type_Prefix_Min_Fields>;
};


/** aggregate fields of "course_type_prefix" */
export type Course_Type_Prefix_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Course_Type_Prefix_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "course_type_prefix". All fields are combined with a logical 'AND'. */
export type Course_Type_Prefix_Bool_Exp = {
  _and?: InputMaybe<Array<Course_Type_Prefix_Bool_Exp>>;
  _not?: InputMaybe<Course_Type_Prefix_Bool_Exp>;
  _or?: InputMaybe<Array<Course_Type_Prefix_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  prefix?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "course_type_prefix" */
export enum Course_Type_Prefix_Constraint {
  /** unique or primary key constraint on columns "name" */
  CourseTypePrefixNameKey = 'course_type_prefix_name_key',
  /** unique or primary key constraint on columns "id" */
  CourseTypePrefixPkey = 'course_type_prefix_pkey',
  /** unique or primary key constraint on columns "prefix" */
  CourseTypePrefixPrefixKey = 'course_type_prefix_prefix_key'
}

/** input type for inserting data into table "course_type_prefix" */
export type Course_Type_Prefix_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Course_Type_Prefix_Max_Fields = {
  __typename?: 'course_type_prefix_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Course_Type_Prefix_Min_Fields = {
  __typename?: 'course_type_prefix_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  prefix?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "course_type_prefix" */
export type Course_Type_Prefix_Mutation_Response = {
  __typename?: 'course_type_prefix_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Course_Type_Prefix>;
};

/** on_conflict condition type for table "course_type_prefix" */
export type Course_Type_Prefix_On_Conflict = {
  constraint: Course_Type_Prefix_Constraint;
  update_columns?: Array<Course_Type_Prefix_Update_Column>;
  where?: InputMaybe<Course_Type_Prefix_Bool_Exp>;
};

/** Ordering options when selecting data from "course_type_prefix". */
export type Course_Type_Prefix_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  prefix?: InputMaybe<Order_By>;
};

/** primary key columns input for table: course_type_prefix */
export type Course_Type_Prefix_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "course_type_prefix" */
export enum Course_Type_Prefix_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Prefix = 'prefix'
}

/** input type for updating data in table "course_type_prefix" */
export type Course_Type_Prefix_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_type_prefix" */
export type Course_Type_Prefix_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Type_Prefix_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Type_Prefix_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  prefix?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_type_prefix" */
export enum Course_Type_Prefix_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Prefix = 'prefix'
}

export type Course_Type_Prefix_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Type_Prefix_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Type_Prefix_Bool_Exp;
};

/** select columns of table "course_type" */
export enum Course_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "course_type" */
export type Course_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "course_type" */
export type Course_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Course_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Course_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "course_type" */
export enum Course_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Course_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Type_Bool_Exp;
};

/** update columns of table "course" */
export enum Course_Update_Column {
  /** column name */
  AccountCode = 'accountCode',
  /** column name */
  AccreditedBy = 'accreditedBy',
  /** column name */
  AolCostOfCourse = 'aolCostOfCourse',
  /** column name */
  AolCountry = 'aolCountry',
  /** column name */
  AolRegion = 'aolRegion',
  /** column name */
  ArloReferenceId = 'arloReferenceId',
  /** column name */
  BookingContactInviteData = 'bookingContactInviteData',
  /** column name */
  BookingContactProfileId = 'bookingContactProfileId',
  /** column name */
  CancellationFee = 'cancellationFee',
  /** column name */
  CancellationFeeType = 'cancellationFeeType',
  /** column name */
  CancellationReason = 'cancellationReason',
  /** column name */
  Conversion = 'conversion',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedById = 'createdById',
  /** column name */
  Curriculum = 'curriculum',
  /** column name */
  DeliveryType = 'deliveryType',
  /** column name */
  Description = 'description',
  /** column name */
  DisplayOnWebsite = 'displayOnWebsite',
  /** column name */
  EndDate = 'end_date',
  /** column name */
  ExceptionsPending = 'exceptionsPending',
  /** column name */
  FreeSpaces = 'freeSpaces',
  /** column name */
  FreeCourseMaterials = 'free_course_materials',
  /** column name */
  Go1Integration = 'go1Integration',
  /** column name */
  GradingConfirmed = 'gradingConfirmed',
  /** column name */
  GradingStarted = 'gradingStarted',
  /** column name */
  GradingCompletedOn = 'grading_completed_on',
  /** column name */
  HubspotDealId = 'hubspot_deal_id',
  /** column name */
  Id = 'id',
  /** column name */
  IncludeVat = 'includeVAT',
  /** column name */
  IsDraft = 'isDraft',
  /** column name */
  IsTender = 'is_tender',
  /** column name */
  Level = 'level',
  /** column name */
  MaterialsOrganizationId = 'materials_organization_id',
  /** column name */
  MaxParticipants = 'max_participants',
  /** column name */
  MinParticipants = 'min_participants',
  /** column name */
  ModulesDuration = 'modulesDuration',
  /** column name */
  Name = 'name',
  /** column name */
  OrganizationKeyContactInviteData = 'organizationKeyContactInviteData',
  /** column name */
  OrganizationKeyContactProfileId = 'organizationKeyContactProfileId',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  ParkingInstructions = 'parking_instructions',
  /** column name */
  Price = 'price',
  /** column name */
  PriceCurrency = 'priceCurrency',
  /** column name */
  Reaccreditation = 'reaccreditation',
  /** column name */
  Region = 'region',
  /** column name */
  RenewalCycle = 'renewalCycle',
  /** column name */
  ResidingCountry = 'residingCountry',
  /** column name */
  ResourcePacksDeliveryType = 'resourcePacksDeliveryType',
  /** column name */
  ResourcePacksType = 'resourcePacksType',
  /** column name */
  SearchFields = 'search_fields',
  /** column name */
  Source = 'source',
  /** column name */
  SpecialInstructions = 'special_instructions',
  /** column name */
  StartDate = 'start_date',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Course_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Course_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Course_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Course_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Course_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Course_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Course_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Course_Set_Input>;
  /** filter the rows which have to be updated */
  where: Course_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Course_Var_Pop_Fields = {
  __typename?: 'course_var_pop_fields';
  aolCostOfCourse?: Maybe<Scalars['Float']>;
  cancellationFee?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_free_slots" */
  freeSlots?: Maybe<Scalars['Int']>;
  freeSpaces?: Maybe<Scalars['Float']>;
  free_course_materials?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
  modulesDuration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_reserved_go1_licenses" */
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  /** A computed field returns the total count of reserved resource packs for a course, derived from resource pack reservation events in the organization's resource pack management history. */
  reservedResourcePacks?: Maybe<Scalars['Int']>;
};

/** order by var_pop() on columns of table "course" */
export type Course_Var_Pop_Order_By = {
  aolCostOfCourse?: InputMaybe<Order_By>;
  cancellationFee?: InputMaybe<Order_By>;
  freeSpaces?: InputMaybe<Order_By>;
  free_course_materials?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_participants?: InputMaybe<Order_By>;
  min_participants?: InputMaybe<Order_By>;
  modulesDuration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Course_Var_Samp_Fields = {
  __typename?: 'course_var_samp_fields';
  aolCostOfCourse?: Maybe<Scalars['Float']>;
  cancellationFee?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_free_slots" */
  freeSlots?: Maybe<Scalars['Int']>;
  freeSpaces?: Maybe<Scalars['Float']>;
  free_course_materials?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
  modulesDuration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_reserved_go1_licenses" */
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  /** A computed field returns the total count of reserved resource packs for a course, derived from resource pack reservation events in the organization's resource pack management history. */
  reservedResourcePacks?: Maybe<Scalars['Int']>;
};

/** order by var_samp() on columns of table "course" */
export type Course_Var_Samp_Order_By = {
  aolCostOfCourse?: InputMaybe<Order_By>;
  cancellationFee?: InputMaybe<Order_By>;
  freeSpaces?: InputMaybe<Order_By>;
  free_course_materials?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_participants?: InputMaybe<Order_By>;
  min_participants?: InputMaybe<Order_By>;
  modulesDuration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Course_Variance_Fields = {
  __typename?: 'course_variance_fields';
  aolCostOfCourse?: Maybe<Scalars['Float']>;
  cancellationFee?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_free_slots" */
  freeSlots?: Maybe<Scalars['Int']>;
  freeSpaces?: Maybe<Scalars['Float']>;
  free_course_materials?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  max_participants?: Maybe<Scalars['Float']>;
  min_participants?: Maybe<Scalars['Float']>;
  modulesDuration?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  /** A computed field, executes function "course_reserved_go1_licenses" */
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  /** A computed field returns the total count of reserved resource packs for a course, derived from resource pack reservation events in the organization's resource pack management history. */
  reservedResourcePacks?: Maybe<Scalars['Int']>;
};

/** order by variance() on columns of table "course" */
export type Course_Variance_Order_By = {
  aolCostOfCourse?: InputMaybe<Order_By>;
  cancellationFee?: InputMaybe<Order_By>;
  freeSpaces?: InputMaybe<Order_By>;
  free_course_materials?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  max_participants?: InputMaybe<Order_By>;
  min_participants?: InputMaybe<Order_By>;
  modulesDuration?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
};

/** columns and relationships of "cqc_establishment" */
export type Cqc_Establishment = {
  __typename?: 'cqc_establishment';
  address: Scalars['String'];
  id: Scalars['uuid'];
  known_as?: Maybe<Scalars['String']>;
  last_check_date?: Maybe<Scalars['String']>;
  local_authority?: Maybe<Scalars['String']>;
  location_id: Scalars['String'];
  location_url: Scalars['String'];
  name: Scalars['String'];
  phone_number?: Maybe<Scalars['String']>;
  postcode: Scalars['String'];
  provider_id: Scalars['String'];
  provider_name: Scalars['String'];
  region?: Maybe<Scalars['String']>;
  service_type: Scalars['String'];
  specialisms?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregated selection of "cqc_establishment" */
export type Cqc_Establishment_Aggregate = {
  __typename?: 'cqc_establishment_aggregate';
  aggregate?: Maybe<Cqc_Establishment_Aggregate_Fields>;
  nodes: Array<Cqc_Establishment>;
};

/** aggregate fields of "cqc_establishment" */
export type Cqc_Establishment_Aggregate_Fields = {
  __typename?: 'cqc_establishment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Cqc_Establishment_Max_Fields>;
  min?: Maybe<Cqc_Establishment_Min_Fields>;
};


/** aggregate fields of "cqc_establishment" */
export type Cqc_Establishment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cqc_Establishment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cqc_establishment". All fields are combined with a logical 'AND'. */
export type Cqc_Establishment_Bool_Exp = {
  _and?: InputMaybe<Array<Cqc_Establishment_Bool_Exp>>;
  _not?: InputMaybe<Cqc_Establishment_Bool_Exp>;
  _or?: InputMaybe<Array<Cqc_Establishment_Bool_Exp>>;
  address?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  known_as?: InputMaybe<String_Comparison_Exp>;
  last_check_date?: InputMaybe<String_Comparison_Exp>;
  local_authority?: InputMaybe<String_Comparison_Exp>;
  location_id?: InputMaybe<String_Comparison_Exp>;
  location_url?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phone_number?: InputMaybe<String_Comparison_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
  provider_name?: InputMaybe<String_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  service_type?: InputMaybe<String_Comparison_Exp>;
  specialisms?: InputMaybe<String_Comparison_Exp>;
  website?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cqc_establishment" */
export enum Cqc_Establishment_Constraint {
  /** unique or primary key constraint on columns "id" */
  CqcEstablishmentPkey = 'cqc_establishment_pkey'
}

/** input type for inserting data into table "cqc_establishment" */
export type Cqc_Establishment_Insert_Input = {
  address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  known_as?: InputMaybe<Scalars['String']>;
  last_check_date?: InputMaybe<Scalars['String']>;
  local_authority?: InputMaybe<Scalars['String']>;
  location_id?: InputMaybe<Scalars['String']>;
  location_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  provider_name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  service_type?: InputMaybe<Scalars['String']>;
  specialisms?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cqc_Establishment_Max_Fields = {
  __typename?: 'cqc_establishment_max_fields';
  address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  known_as?: Maybe<Scalars['String']>;
  last_check_date?: Maybe<Scalars['String']>;
  local_authority?: Maybe<Scalars['String']>;
  location_id?: Maybe<Scalars['String']>;
  location_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  service_type?: Maybe<Scalars['String']>;
  specialisms?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Cqc_Establishment_Min_Fields = {
  __typename?: 'cqc_establishment_min_fields';
  address?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  known_as?: Maybe<Scalars['String']>;
  last_check_date?: Maybe<Scalars['String']>;
  local_authority?: Maybe<Scalars['String']>;
  location_id?: Maybe<Scalars['String']>;
  location_url?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  phone_number?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  provider_id?: Maybe<Scalars['String']>;
  provider_name?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  service_type?: Maybe<Scalars['String']>;
  specialisms?: Maybe<Scalars['String']>;
  website?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cqc_establishment" */
export type Cqc_Establishment_Mutation_Response = {
  __typename?: 'cqc_establishment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cqc_Establishment>;
};

/** on_conflict condition type for table "cqc_establishment" */
export type Cqc_Establishment_On_Conflict = {
  constraint: Cqc_Establishment_Constraint;
  update_columns?: Array<Cqc_Establishment_Update_Column>;
  where?: InputMaybe<Cqc_Establishment_Bool_Exp>;
};

/** Ordering options when selecting data from "cqc_establishment". */
export type Cqc_Establishment_Order_By = {
  address?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  known_as?: InputMaybe<Order_By>;
  last_check_date?: InputMaybe<Order_By>;
  local_authority?: InputMaybe<Order_By>;
  location_id?: InputMaybe<Order_By>;
  location_url?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phone_number?: InputMaybe<Order_By>;
  postcode?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  provider_name?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  service_type?: InputMaybe<Order_By>;
  specialisms?: InputMaybe<Order_By>;
  website?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cqc_establishment */
export type Cqc_Establishment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "cqc_establishment" */
export enum Cqc_Establishment_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Id = 'id',
  /** column name */
  KnownAs = 'known_as',
  /** column name */
  LastCheckDate = 'last_check_date',
  /** column name */
  LocalAuthority = 'local_authority',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  LocationUrl = 'location_url',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderName = 'provider_name',
  /** column name */
  Region = 'region',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  Specialisms = 'specialisms',
  /** column name */
  Website = 'website'
}

/** input type for updating data in table "cqc_establishment" */
export type Cqc_Establishment_Set_Input = {
  address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  known_as?: InputMaybe<Scalars['String']>;
  last_check_date?: InputMaybe<Scalars['String']>;
  local_authority?: InputMaybe<Scalars['String']>;
  location_id?: InputMaybe<Scalars['String']>;
  location_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  provider_name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  service_type?: InputMaybe<Scalars['String']>;
  specialisms?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cqc_establishment" */
export type Cqc_Establishment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cqc_Establishment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cqc_Establishment_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  known_as?: InputMaybe<Scalars['String']>;
  last_check_date?: InputMaybe<Scalars['String']>;
  local_authority?: InputMaybe<Scalars['String']>;
  location_id?: InputMaybe<Scalars['String']>;
  location_url?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phone_number?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  provider_id?: InputMaybe<Scalars['String']>;
  provider_name?: InputMaybe<Scalars['String']>;
  region?: InputMaybe<Scalars['String']>;
  service_type?: InputMaybe<Scalars['String']>;
  specialisms?: InputMaybe<Scalars['String']>;
  website?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cqc_establishment" */
export enum Cqc_Establishment_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Id = 'id',
  /** column name */
  KnownAs = 'known_as',
  /** column name */
  LastCheckDate = 'last_check_date',
  /** column name */
  LocalAuthority = 'local_authority',
  /** column name */
  LocationId = 'location_id',
  /** column name */
  LocationUrl = 'location_url',
  /** column name */
  Name = 'name',
  /** column name */
  PhoneNumber = 'phone_number',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  ProviderName = 'provider_name',
  /** column name */
  Region = 'region',
  /** column name */
  ServiceType = 'service_type',
  /** column name */
  Specialisms = 'specialisms',
  /** column name */
  Website = 'website'
}

export type Cqc_Establishment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cqc_Establishment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cqc_Establishment_Bool_Exp;
};

export type CreateSubscriptionOutput = {
  __typename?: 'createSubscriptionOutput';
  clientSecret: Scalars['String'];
  subscriptionId: Scalars['String'];
};

/** columns and relationships of "cud_operation" */
export type Cud_Operation = {
  __typename?: 'cud_operation';
  name: Scalars['String'];
};

/** aggregated selection of "cud_operation" */
export type Cud_Operation_Aggregate = {
  __typename?: 'cud_operation_aggregate';
  aggregate?: Maybe<Cud_Operation_Aggregate_Fields>;
  nodes: Array<Cud_Operation>;
};

/** aggregate fields of "cud_operation" */
export type Cud_Operation_Aggregate_Fields = {
  __typename?: 'cud_operation_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Cud_Operation_Max_Fields>;
  min?: Maybe<Cud_Operation_Min_Fields>;
};


/** aggregate fields of "cud_operation" */
export type Cud_Operation_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Cud_Operation_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "cud_operation". All fields are combined with a logical 'AND'. */
export type Cud_Operation_Bool_Exp = {
  _and?: InputMaybe<Array<Cud_Operation_Bool_Exp>>;
  _not?: InputMaybe<Cud_Operation_Bool_Exp>;
  _or?: InputMaybe<Array<Cud_Operation_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "cud_operation" */
export enum Cud_Operation_Constraint {
  /** unique or primary key constraint on columns "name" */
  CudOperationPkey = 'cud_operation_pkey'
}

export enum Cud_Operation_Enum {
  Create = 'CREATE',
  Delete = 'DELETE',
  Update = 'UPDATE'
}

/** Boolean expression to compare columns of type "cud_operation_enum". All fields are combined with logical 'AND'. */
export type Cud_Operation_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Cud_Operation_Enum>;
  _in?: InputMaybe<Array<Cud_Operation_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Cud_Operation_Enum>;
  _nin?: InputMaybe<Array<Cud_Operation_Enum>>;
};

/** input type for inserting data into table "cud_operation" */
export type Cud_Operation_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Cud_Operation_Max_Fields = {
  __typename?: 'cud_operation_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Cud_Operation_Min_Fields = {
  __typename?: 'cud_operation_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "cud_operation" */
export type Cud_Operation_Mutation_Response = {
  __typename?: 'cud_operation_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Cud_Operation>;
};

/** on_conflict condition type for table "cud_operation" */
export type Cud_Operation_On_Conflict = {
  constraint: Cud_Operation_Constraint;
  update_columns?: Array<Cud_Operation_Update_Column>;
  where?: InputMaybe<Cud_Operation_Bool_Exp>;
};

/** Ordering options when selecting data from "cud_operation". */
export type Cud_Operation_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: cud_operation */
export type Cud_Operation_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "cud_operation" */
export enum Cud_Operation_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "cud_operation" */
export type Cud_Operation_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "cud_operation" */
export type Cud_Operation_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Cud_Operation_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Cud_Operation_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "cud_operation" */
export enum Cud_Operation_Update_Column {
  /** column name */
  Name = 'name'
}

export type Cud_Operation_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Cud_Operation_Set_Input>;
  /** filter the rows which have to be updated */
  where: Cud_Operation_Bool_Exp;
};

/** ordering argument of a cursor */
export enum Cursor_Ordering {
  /** ascending ordering of the cursor */
  Asc = 'ASC',
  /** descending ordering of the cursor */
  Desc = 'DESC'
}

/** Boolean expression to compare columns of type "date". All fields are combined with logical 'AND'. */
export type Date_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['date']>;
  _gt?: InputMaybe<Scalars['date']>;
  _gte?: InputMaybe<Scalars['date']>;
  _in?: InputMaybe<Array<Scalars['date']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['date']>;
  _lte?: InputMaybe<Scalars['date']>;
  _neq?: InputMaybe<Scalars['date']>;
  _nin?: InputMaybe<Array<Scalars['date']>>;
};

/** columns and relationships of "deleted_organizations_backup" */
export type Deleted_Organizations_Backup = {
  __typename?: 'deleted_organizations_backup';
  address?: Maybe<Scalars['jsonb']>;
  attributes?: Maybe<Scalars['jsonb']>;
  contact_details?: Maybe<Scalars['jsonb']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  geo_coordinates?: Maybe<Scalars['point']>;
  go1_licenses?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organisation_type?: Maybe<Scalars['String']>;
  original_record?: Maybe<Scalars['jsonb']>;
  preferences?: Maybe<Scalars['jsonb']>;
  region?: Maybe<Scalars['String']>;
  reserved_go1_licenses?: Maybe<Scalars['Int']>;
  sector?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  xero_contact_id?: Maybe<Scalars['String']>;
};


/** columns and relationships of "deleted_organizations_backup" */
export type Deleted_Organizations_BackupAddressArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "deleted_organizations_backup" */
export type Deleted_Organizations_BackupAttributesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "deleted_organizations_backup" */
export type Deleted_Organizations_BackupContact_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "deleted_organizations_backup" */
export type Deleted_Organizations_BackupOriginal_RecordArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "deleted_organizations_backup" */
export type Deleted_Organizations_BackupPreferencesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "deleted_organizations_backup" */
export type Deleted_Organizations_BackupTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "deleted_organizations_backup" */
export type Deleted_Organizations_Backup_Aggregate = {
  __typename?: 'deleted_organizations_backup_aggregate';
  aggregate?: Maybe<Deleted_Organizations_Backup_Aggregate_Fields>;
  nodes: Array<Deleted_Organizations_Backup>;
};

/** aggregate fields of "deleted_organizations_backup" */
export type Deleted_Organizations_Backup_Aggregate_Fields = {
  __typename?: 'deleted_organizations_backup_aggregate_fields';
  avg?: Maybe<Deleted_Organizations_Backup_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Deleted_Organizations_Backup_Max_Fields>;
  min?: Maybe<Deleted_Organizations_Backup_Min_Fields>;
  stddev?: Maybe<Deleted_Organizations_Backup_Stddev_Fields>;
  stddev_pop?: Maybe<Deleted_Organizations_Backup_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Deleted_Organizations_Backup_Stddev_Samp_Fields>;
  sum?: Maybe<Deleted_Organizations_Backup_Sum_Fields>;
  var_pop?: Maybe<Deleted_Organizations_Backup_Var_Pop_Fields>;
  var_samp?: Maybe<Deleted_Organizations_Backup_Var_Samp_Fields>;
  variance?: Maybe<Deleted_Organizations_Backup_Variance_Fields>;
};


/** aggregate fields of "deleted_organizations_backup" */
export type Deleted_Organizations_Backup_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Deleted_Organizations_Backup_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Deleted_Organizations_Backup_Append_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  contact_details?: InputMaybe<Scalars['jsonb']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Deleted_Organizations_Backup_Avg_Fields = {
  __typename?: 'deleted_organizations_backup_avg_fields';
  go1_licenses?: Maybe<Scalars['Float']>;
  reserved_go1_licenses?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "deleted_organizations_backup". All fields are combined with a logical 'AND'. */
export type Deleted_Organizations_Backup_Bool_Exp = {
  _and?: InputMaybe<Array<Deleted_Organizations_Backup_Bool_Exp>>;
  _not?: InputMaybe<Deleted_Organizations_Backup_Bool_Exp>;
  _or?: InputMaybe<Array<Deleted_Organizations_Backup_Bool_Exp>>;
  address?: InputMaybe<Jsonb_Comparison_Exp>;
  attributes?: InputMaybe<Jsonb_Comparison_Exp>;
  contact_details?: InputMaybe<Jsonb_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  geo_coordinates?: InputMaybe<Point_Comparison_Exp>;
  go1_licenses?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisation_type?: InputMaybe<String_Comparison_Exp>;
  original_record?: InputMaybe<Jsonb_Comparison_Exp>;
  preferences?: InputMaybe<Jsonb_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  reserved_go1_licenses?: InputMaybe<Int_Comparison_Exp>;
  sector?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  xero_contact_id?: InputMaybe<String_Comparison_Exp>;
};

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Deleted_Organizations_Backup_Delete_At_Path_Input = {
  address?: InputMaybe<Array<Scalars['String']>>;
  attributes?: InputMaybe<Array<Scalars['String']>>;
  contact_details?: InputMaybe<Array<Scalars['String']>>;
  original_record?: InputMaybe<Array<Scalars['String']>>;
  preferences?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Deleted_Organizations_Backup_Delete_Elem_Input = {
  address?: InputMaybe<Scalars['Int']>;
  attributes?: InputMaybe<Scalars['Int']>;
  contact_details?: InputMaybe<Scalars['Int']>;
  original_record?: InputMaybe<Scalars['Int']>;
  preferences?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Deleted_Organizations_Backup_Delete_Key_Input = {
  address?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Scalars['String']>;
  contact_details?: InputMaybe<Scalars['String']>;
  original_record?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "deleted_organizations_backup" */
export type Deleted_Organizations_Backup_Inc_Input = {
  go1_licenses?: InputMaybe<Scalars['Int']>;
  reserved_go1_licenses?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "deleted_organizations_backup" */
export type Deleted_Organizations_Backup_Insert_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  contact_details?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  geo_coordinates?: InputMaybe<Scalars['point']>;
  go1_licenses?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_type?: InputMaybe<Scalars['String']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  region?: InputMaybe<Scalars['String']>;
  reserved_go1_licenses?: InputMaybe<Scalars['Int']>;
  sector?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  xero_contact_id?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Deleted_Organizations_Backup_Max_Fields = {
  __typename?: 'deleted_organizations_backup_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  go1_licenses?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organisation_type?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  reserved_go1_licenses?: Maybe<Scalars['Int']>;
  sector?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  xero_contact_id?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Deleted_Organizations_Backup_Min_Fields = {
  __typename?: 'deleted_organizations_backup_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  go1_licenses?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organisation_type?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  reserved_go1_licenses?: Maybe<Scalars['Int']>;
  sector?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
  xero_contact_id?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "deleted_organizations_backup" */
export type Deleted_Organizations_Backup_Mutation_Response = {
  __typename?: 'deleted_organizations_backup_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Deleted_Organizations_Backup>;
};

/** Ordering options when selecting data from "deleted_organizations_backup". */
export type Deleted_Organizations_Backup_Order_By = {
  address?: InputMaybe<Order_By>;
  attributes?: InputMaybe<Order_By>;
  contact_details?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  geo_coordinates?: InputMaybe<Order_By>;
  go1_licenses?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisation_type?: InputMaybe<Order_By>;
  original_record?: InputMaybe<Order_By>;
  preferences?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  reserved_go1_licenses?: InputMaybe<Order_By>;
  sector?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
  xero_contact_id?: InputMaybe<Order_By>;
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Deleted_Organizations_Backup_Prepend_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  contact_details?: InputMaybe<Scalars['jsonb']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "deleted_organizations_backup" */
export enum Deleted_Organizations_Backup_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Attributes = 'attributes',
  /** column name */
  ContactDetails = 'contact_details',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  GeoCoordinates = 'geo_coordinates',
  /** column name */
  Go1Licenses = 'go1_licenses',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationType = 'organisation_type',
  /** column name */
  OriginalRecord = 'original_record',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  Region = 'region',
  /** column name */
  ReservedGo1Licenses = 'reserved_go1_licenses',
  /** column name */
  Sector = 'sector',
  /** column name */
  Tags = 'tags',
  /** column name */
  UpdatedAt = 'updated_at',
  /** column name */
  XeroContactId = 'xero_contact_id'
}

/** input type for updating data in table "deleted_organizations_backup" */
export type Deleted_Organizations_Backup_Set_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  contact_details?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  geo_coordinates?: InputMaybe<Scalars['point']>;
  go1_licenses?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_type?: InputMaybe<Scalars['String']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  region?: InputMaybe<Scalars['String']>;
  reserved_go1_licenses?: InputMaybe<Scalars['Int']>;
  sector?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  xero_contact_id?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Deleted_Organizations_Backup_Stddev_Fields = {
  __typename?: 'deleted_organizations_backup_stddev_fields';
  go1_licenses?: Maybe<Scalars['Float']>;
  reserved_go1_licenses?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Deleted_Organizations_Backup_Stddev_Pop_Fields = {
  __typename?: 'deleted_organizations_backup_stddev_pop_fields';
  go1_licenses?: Maybe<Scalars['Float']>;
  reserved_go1_licenses?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Deleted_Organizations_Backup_Stddev_Samp_Fields = {
  __typename?: 'deleted_organizations_backup_stddev_samp_fields';
  go1_licenses?: Maybe<Scalars['Float']>;
  reserved_go1_licenses?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "deleted_organizations_backup" */
export type Deleted_Organizations_Backup_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Deleted_Organizations_Backup_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Deleted_Organizations_Backup_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  contact_details?: InputMaybe<Scalars['jsonb']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  geo_coordinates?: InputMaybe<Scalars['point']>;
  go1_licenses?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organisation_type?: InputMaybe<Scalars['String']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  region?: InputMaybe<Scalars['String']>;
  reserved_go1_licenses?: InputMaybe<Scalars['Int']>;
  sector?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
  xero_contact_id?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Deleted_Organizations_Backup_Sum_Fields = {
  __typename?: 'deleted_organizations_backup_sum_fields';
  go1_licenses?: Maybe<Scalars['Int']>;
  reserved_go1_licenses?: Maybe<Scalars['Int']>;
};

export type Deleted_Organizations_Backup_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Deleted_Organizations_Backup_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Deleted_Organizations_Backup_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Deleted_Organizations_Backup_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Deleted_Organizations_Backup_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Deleted_Organizations_Backup_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Deleted_Organizations_Backup_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Deleted_Organizations_Backup_Set_Input>;
  /** filter the rows which have to be updated */
  where: Deleted_Organizations_Backup_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Deleted_Organizations_Backup_Var_Pop_Fields = {
  __typename?: 'deleted_organizations_backup_var_pop_fields';
  go1_licenses?: Maybe<Scalars['Float']>;
  reserved_go1_licenses?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Deleted_Organizations_Backup_Var_Samp_Fields = {
  __typename?: 'deleted_organizations_backup_var_samp_fields';
  go1_licenses?: Maybe<Scalars['Float']>;
  reserved_go1_licenses?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Deleted_Organizations_Backup_Variance_Fields = {
  __typename?: 'deleted_organizations_backup_variance_fields';
  go1_licenses?: Maybe<Scalars['Float']>;
  reserved_go1_licenses?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "dfe_establishment" */
export type Dfe_Establishment = {
  __typename?: 'dfe_establishment';
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineThree?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  headFirstName?: Maybe<Scalars['String']>;
  headJobTitle?: Maybe<Scalars['String']>;
  headLastName?: Maybe<Scalars['String']>;
  headTitle?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  localAuthority: Scalars['String'];
  name: Scalars['String'];
  ofstedLastInspection?: Maybe<Scalars['String']>;
  ofstedRating?: Maybe<Scalars['String']>;
  /** An array relationship */
  organizations: Array<Organization>;
  /** An aggregate relationship */
  organizations_aggregate: Organization_Aggregate;
  postcode?: Maybe<Scalars['String']>;
  registered: Scalars['Boolean'];
  searchable?: Maybe<Scalars['String']>;
  searchable_postcode?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
  trustName?: Maybe<Scalars['String']>;
  trustType?: Maybe<Scalars['String']>;
  urn: Scalars['String'];
};


/** columns and relationships of "dfe_establishment" */
export type Dfe_EstablishmentOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** columns and relationships of "dfe_establishment" */
export type Dfe_EstablishmentOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};

/** aggregated selection of "dfe_establishment" */
export type Dfe_Establishment_Aggregate = {
  __typename?: 'dfe_establishment_aggregate';
  aggregate?: Maybe<Dfe_Establishment_Aggregate_Fields>;
  nodes: Array<Dfe_Establishment>;
};

/** aggregate fields of "dfe_establishment" */
export type Dfe_Establishment_Aggregate_Fields = {
  __typename?: 'dfe_establishment_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Dfe_Establishment_Max_Fields>;
  min?: Maybe<Dfe_Establishment_Min_Fields>;
};


/** aggregate fields of "dfe_establishment" */
export type Dfe_Establishment_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Dfe_Establishment_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "dfe_establishment". All fields are combined with a logical 'AND'. */
export type Dfe_Establishment_Bool_Exp = {
  _and?: InputMaybe<Array<Dfe_Establishment_Bool_Exp>>;
  _not?: InputMaybe<Dfe_Establishment_Bool_Exp>;
  _or?: InputMaybe<Array<Dfe_Establishment_Bool_Exp>>;
  addressLineOne?: InputMaybe<String_Comparison_Exp>;
  addressLineThree?: InputMaybe<String_Comparison_Exp>;
  addressLineTwo?: InputMaybe<String_Comparison_Exp>;
  county?: InputMaybe<String_Comparison_Exp>;
  headFirstName?: InputMaybe<String_Comparison_Exp>;
  headJobTitle?: InputMaybe<String_Comparison_Exp>;
  headLastName?: InputMaybe<String_Comparison_Exp>;
  headTitle?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  localAuthority?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  ofstedLastInspection?: InputMaybe<String_Comparison_Exp>;
  ofstedRating?: InputMaybe<String_Comparison_Exp>;
  organizations?: InputMaybe<Organization_Bool_Exp>;
  organizations_aggregate?: InputMaybe<Organization_Aggregate_Bool_Exp>;
  postcode?: InputMaybe<String_Comparison_Exp>;
  registered?: InputMaybe<Boolean_Comparison_Exp>;
  searchable?: InputMaybe<String_Comparison_Exp>;
  searchable_postcode?: InputMaybe<String_Comparison_Exp>;
  town?: InputMaybe<String_Comparison_Exp>;
  trustName?: InputMaybe<String_Comparison_Exp>;
  trustType?: InputMaybe<String_Comparison_Exp>;
  urn?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "dfe_establishment" */
export enum Dfe_Establishment_Constraint {
  /** unique or primary key constraint on columns "id" */
  DfeEstablishmentPkey = 'dfe_establishment_pkey'
}

/** input type for inserting data into table "dfe_establishment" */
export type Dfe_Establishment_Insert_Input = {
  addressLineOne?: InputMaybe<Scalars['String']>;
  addressLineThree?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  headFirstName?: InputMaybe<Scalars['String']>;
  headJobTitle?: InputMaybe<Scalars['String']>;
  headLastName?: InputMaybe<Scalars['String']>;
  headTitle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  localAuthority?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ofstedLastInspection?: InputMaybe<Scalars['String']>;
  ofstedRating?: InputMaybe<Scalars['String']>;
  organizations?: InputMaybe<Organization_Arr_Rel_Insert_Input>;
  postcode?: InputMaybe<Scalars['String']>;
  registered?: InputMaybe<Scalars['Boolean']>;
  town?: InputMaybe<Scalars['String']>;
  trustName?: InputMaybe<Scalars['String']>;
  trustType?: InputMaybe<Scalars['String']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Dfe_Establishment_Max_Fields = {
  __typename?: 'dfe_establishment_max_fields';
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineThree?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  headFirstName?: Maybe<Scalars['String']>;
  headJobTitle?: Maybe<Scalars['String']>;
  headLastName?: Maybe<Scalars['String']>;
  headTitle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  localAuthority?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ofstedLastInspection?: Maybe<Scalars['String']>;
  ofstedRating?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  searchable?: Maybe<Scalars['String']>;
  searchable_postcode?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
  trustName?: Maybe<Scalars['String']>;
  trustType?: Maybe<Scalars['String']>;
  urn?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Dfe_Establishment_Min_Fields = {
  __typename?: 'dfe_establishment_min_fields';
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineThree?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  county?: Maybe<Scalars['String']>;
  headFirstName?: Maybe<Scalars['String']>;
  headJobTitle?: Maybe<Scalars['String']>;
  headLastName?: Maybe<Scalars['String']>;
  headTitle?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  localAuthority?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  ofstedLastInspection?: Maybe<Scalars['String']>;
  ofstedRating?: Maybe<Scalars['String']>;
  postcode?: Maybe<Scalars['String']>;
  searchable?: Maybe<Scalars['String']>;
  searchable_postcode?: Maybe<Scalars['String']>;
  town?: Maybe<Scalars['String']>;
  trustName?: Maybe<Scalars['String']>;
  trustType?: Maybe<Scalars['String']>;
  urn?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "dfe_establishment" */
export type Dfe_Establishment_Mutation_Response = {
  __typename?: 'dfe_establishment_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Dfe_Establishment>;
};

/** input type for inserting object relation for remote table "dfe_establishment" */
export type Dfe_Establishment_Obj_Rel_Insert_Input = {
  data: Dfe_Establishment_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Dfe_Establishment_On_Conflict>;
};

/** on_conflict condition type for table "dfe_establishment" */
export type Dfe_Establishment_On_Conflict = {
  constraint: Dfe_Establishment_Constraint;
  update_columns?: Array<Dfe_Establishment_Update_Column>;
  where?: InputMaybe<Dfe_Establishment_Bool_Exp>;
};

/** Ordering options when selecting data from "dfe_establishment". */
export type Dfe_Establishment_Order_By = {
  addressLineOne?: InputMaybe<Order_By>;
  addressLineThree?: InputMaybe<Order_By>;
  addressLineTwo?: InputMaybe<Order_By>;
  county?: InputMaybe<Order_By>;
  headFirstName?: InputMaybe<Order_By>;
  headJobTitle?: InputMaybe<Order_By>;
  headLastName?: InputMaybe<Order_By>;
  headTitle?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  localAuthority?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  ofstedLastInspection?: InputMaybe<Order_By>;
  ofstedRating?: InputMaybe<Order_By>;
  organizations_aggregate?: InputMaybe<Organization_Aggregate_Order_By>;
  postcode?: InputMaybe<Order_By>;
  registered?: InputMaybe<Order_By>;
  searchable?: InputMaybe<Order_By>;
  searchable_postcode?: InputMaybe<Order_By>;
  town?: InputMaybe<Order_By>;
  trustName?: InputMaybe<Order_By>;
  trustType?: InputMaybe<Order_By>;
  urn?: InputMaybe<Order_By>;
};

/** primary key columns input for table: dfe_establishment */
export type Dfe_Establishment_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "dfe_establishment" */
export enum Dfe_Establishment_Select_Column {
  /** column name */
  AddressLineOne = 'addressLineOne',
  /** column name */
  AddressLineThree = 'addressLineThree',
  /** column name */
  AddressLineTwo = 'addressLineTwo',
  /** column name */
  County = 'county',
  /** column name */
  HeadFirstName = 'headFirstName',
  /** column name */
  HeadJobTitle = 'headJobTitle',
  /** column name */
  HeadLastName = 'headLastName',
  /** column name */
  HeadTitle = 'headTitle',
  /** column name */
  Id = 'id',
  /** column name */
  LocalAuthority = 'localAuthority',
  /** column name */
  Name = 'name',
  /** column name */
  OfstedLastInspection = 'ofstedLastInspection',
  /** column name */
  OfstedRating = 'ofstedRating',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Registered = 'registered',
  /** column name */
  Searchable = 'searchable',
  /** column name */
  SearchablePostcode = 'searchable_postcode',
  /** column name */
  Town = 'town',
  /** column name */
  TrustName = 'trustName',
  /** column name */
  TrustType = 'trustType',
  /** column name */
  Urn = 'urn'
}

/** input type for updating data in table "dfe_establishment" */
export type Dfe_Establishment_Set_Input = {
  addressLineOne?: InputMaybe<Scalars['String']>;
  addressLineThree?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  headFirstName?: InputMaybe<Scalars['String']>;
  headJobTitle?: InputMaybe<Scalars['String']>;
  headLastName?: InputMaybe<Scalars['String']>;
  headTitle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  localAuthority?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ofstedLastInspection?: InputMaybe<Scalars['String']>;
  ofstedRating?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  registered?: InputMaybe<Scalars['Boolean']>;
  town?: InputMaybe<Scalars['String']>;
  trustName?: InputMaybe<Scalars['String']>;
  trustType?: InputMaybe<Scalars['String']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "dfe_establishment" */
export type Dfe_Establishment_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Dfe_Establishment_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Dfe_Establishment_Stream_Cursor_Value_Input = {
  addressLineOne?: InputMaybe<Scalars['String']>;
  addressLineThree?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  county?: InputMaybe<Scalars['String']>;
  headFirstName?: InputMaybe<Scalars['String']>;
  headJobTitle?: InputMaybe<Scalars['String']>;
  headLastName?: InputMaybe<Scalars['String']>;
  headTitle?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  localAuthority?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  ofstedLastInspection?: InputMaybe<Scalars['String']>;
  ofstedRating?: InputMaybe<Scalars['String']>;
  postcode?: InputMaybe<Scalars['String']>;
  registered?: InputMaybe<Scalars['Boolean']>;
  searchable?: InputMaybe<Scalars['String']>;
  searchable_postcode?: InputMaybe<Scalars['String']>;
  town?: InputMaybe<Scalars['String']>;
  trustName?: InputMaybe<Scalars['String']>;
  trustType?: InputMaybe<Scalars['String']>;
  urn?: InputMaybe<Scalars['String']>;
};

/** update columns of table "dfe_establishment" */
export enum Dfe_Establishment_Update_Column {
  /** column name */
  AddressLineOne = 'addressLineOne',
  /** column name */
  AddressLineThree = 'addressLineThree',
  /** column name */
  AddressLineTwo = 'addressLineTwo',
  /** column name */
  County = 'county',
  /** column name */
  HeadFirstName = 'headFirstName',
  /** column name */
  HeadJobTitle = 'headJobTitle',
  /** column name */
  HeadLastName = 'headLastName',
  /** column name */
  HeadTitle = 'headTitle',
  /** column name */
  Id = 'id',
  /** column name */
  LocalAuthority = 'localAuthority',
  /** column name */
  Name = 'name',
  /** column name */
  OfstedLastInspection = 'ofstedLastInspection',
  /** column name */
  OfstedRating = 'ofstedRating',
  /** column name */
  Postcode = 'postcode',
  /** column name */
  Registered = 'registered',
  /** column name */
  Town = 'town',
  /** column name */
  TrustName = 'trustName',
  /** column name */
  TrustType = 'trustType',
  /** column name */
  Urn = 'urn'
}

export type Dfe_Establishment_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Dfe_Establishment_Set_Input>;
  /** filter the rows which have to be updated */
  where: Dfe_Establishment_Bool_Exp;
};

/** email notifications */
export type Email_Notifications = {
  __typename?: 'email_notifications';
  course_id: Scalars['Int'];
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  status: Scalars['String'];
  template_data: Scalars['String'];
  template_name: Scalars['String'];
  user_email: Scalars['jsonb'];
};


/** email notifications */
export type Email_NotificationsUser_EmailArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "email_notifications" */
export type Email_Notifications_Aggregate = {
  __typename?: 'email_notifications_aggregate';
  aggregate?: Maybe<Email_Notifications_Aggregate_Fields>;
  nodes: Array<Email_Notifications>;
};

/** aggregate fields of "email_notifications" */
export type Email_Notifications_Aggregate_Fields = {
  __typename?: 'email_notifications_aggregate_fields';
  avg?: Maybe<Email_Notifications_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Email_Notifications_Max_Fields>;
  min?: Maybe<Email_Notifications_Min_Fields>;
  stddev?: Maybe<Email_Notifications_Stddev_Fields>;
  stddev_pop?: Maybe<Email_Notifications_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Email_Notifications_Stddev_Samp_Fields>;
  sum?: Maybe<Email_Notifications_Sum_Fields>;
  var_pop?: Maybe<Email_Notifications_Var_Pop_Fields>;
  var_samp?: Maybe<Email_Notifications_Var_Samp_Fields>;
  variance?: Maybe<Email_Notifications_Variance_Fields>;
};


/** aggregate fields of "email_notifications" */
export type Email_Notifications_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Email_Notifications_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Email_Notifications_Append_Input = {
  user_email?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Email_Notifications_Avg_Fields = {
  __typename?: 'email_notifications_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "email_notifications". All fields are combined with a logical 'AND'. */
export type Email_Notifications_Bool_Exp = {
  _and?: InputMaybe<Array<Email_Notifications_Bool_Exp>>;
  _not?: InputMaybe<Email_Notifications_Bool_Exp>;
  _or?: InputMaybe<Array<Email_Notifications_Bool_Exp>>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  template_data?: InputMaybe<String_Comparison_Exp>;
  template_name?: InputMaybe<String_Comparison_Exp>;
  user_email?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "email_notifications" */
export enum Email_Notifications_Constraint {
  /** unique or primary key constraint on columns "id" */
  EmailNotificationsPkey = 'email_notifications_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Email_Notifications_Delete_At_Path_Input = {
  user_email?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Email_Notifications_Delete_Elem_Input = {
  user_email?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Email_Notifications_Delete_Key_Input = {
  user_email?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "email_notifications" */
export type Email_Notifications_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "email_notifications" */
export type Email_Notifications_Insert_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  template_data?: InputMaybe<Scalars['String']>;
  template_name?: InputMaybe<Scalars['String']>;
  user_email?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Email_Notifications_Max_Fields = {
  __typename?: 'email_notifications_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  template_data?: Maybe<Scalars['String']>;
  template_name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Email_Notifications_Min_Fields = {
  __typename?: 'email_notifications_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  template_data?: Maybe<Scalars['String']>;
  template_name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "email_notifications" */
export type Email_Notifications_Mutation_Response = {
  __typename?: 'email_notifications_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Email_Notifications>;
};

/** on_conflict condition type for table "email_notifications" */
export type Email_Notifications_On_Conflict = {
  constraint: Email_Notifications_Constraint;
  update_columns?: Array<Email_Notifications_Update_Column>;
  where?: InputMaybe<Email_Notifications_Bool_Exp>;
};

/** Ordering options when selecting data from "email_notifications". */
export type Email_Notifications_Order_By = {
  course_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  template_data?: InputMaybe<Order_By>;
  template_name?: InputMaybe<Order_By>;
  user_email?: InputMaybe<Order_By>;
};

/** primary key columns input for table: email_notifications */
export type Email_Notifications_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Email_Notifications_Prepend_Input = {
  user_email?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "email_notifications" */
export enum Email_Notifications_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TemplateData = 'template_data',
  /** column name */
  TemplateName = 'template_name',
  /** column name */
  UserEmail = 'user_email'
}

/** input type for updating data in table "email_notifications" */
export type Email_Notifications_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  template_data?: InputMaybe<Scalars['String']>;
  template_name?: InputMaybe<Scalars['String']>;
  user_email?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate stddev on columns */
export type Email_Notifications_Stddev_Fields = {
  __typename?: 'email_notifications_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Email_Notifications_Stddev_Pop_Fields = {
  __typename?: 'email_notifications_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Email_Notifications_Stddev_Samp_Fields = {
  __typename?: 'email_notifications_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "email_notifications" */
export type Email_Notifications_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Email_Notifications_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Email_Notifications_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  template_data?: InputMaybe<Scalars['String']>;
  template_name?: InputMaybe<Scalars['String']>;
  user_email?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate sum on columns */
export type Email_Notifications_Sum_Fields = {
  __typename?: 'email_notifications_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "email_notifications" */
export enum Email_Notifications_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Status = 'status',
  /** column name */
  TemplateData = 'template_data',
  /** column name */
  TemplateName = 'template_name',
  /** column name */
  UserEmail = 'user_email'
}

export type Email_Notifications_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Email_Notifications_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Email_Notifications_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Email_Notifications_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Email_Notifications_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Email_Notifications_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Email_Notifications_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Email_Notifications_Set_Input>;
  /** filter the rows which have to be updated */
  where: Email_Notifications_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Email_Notifications_Var_Pop_Fields = {
  __typename?: 'email_notifications_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Email_Notifications_Var_Samp_Fields = {
  __typename?: 'email_notifications_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Email_Notifications_Variance_Fields = {
  __typename?: 'email_notifications_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Stores scheduled jobs ids for expiring Go1 licenses */
export type Expire_Go1_License_Jobs = {
  __typename?: 'expire_go1_license_jobs';
  id: Scalars['uuid'];
  jobId: Scalars['uuid'];
  licenseId: Scalars['uuid'];
  profile_id?: Maybe<Scalars['uuid']>;
};

/** aggregated selection of "expire_go1_license_jobs" */
export type Expire_Go1_License_Jobs_Aggregate = {
  __typename?: 'expire_go1_license_jobs_aggregate';
  aggregate?: Maybe<Expire_Go1_License_Jobs_Aggregate_Fields>;
  nodes: Array<Expire_Go1_License_Jobs>;
};

export type Expire_Go1_License_Jobs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Expire_Go1_License_Jobs_Aggregate_Bool_Exp_Count>;
};

export type Expire_Go1_License_Jobs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Expire_Go1_License_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Expire_Go1_License_Jobs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "expire_go1_license_jobs" */
export type Expire_Go1_License_Jobs_Aggregate_Fields = {
  __typename?: 'expire_go1_license_jobs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Expire_Go1_License_Jobs_Max_Fields>;
  min?: Maybe<Expire_Go1_License_Jobs_Min_Fields>;
};


/** aggregate fields of "expire_go1_license_jobs" */
export type Expire_Go1_License_Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Expire_Go1_License_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "expire_go1_license_jobs" */
export type Expire_Go1_License_Jobs_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Expire_Go1_License_Jobs_Max_Order_By>;
  min?: InputMaybe<Expire_Go1_License_Jobs_Min_Order_By>;
};

/** input type for inserting array relation for remote table "expire_go1_license_jobs" */
export type Expire_Go1_License_Jobs_Arr_Rel_Insert_Input = {
  data: Array<Expire_Go1_License_Jobs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Expire_Go1_License_Jobs_On_Conflict>;
};

/** Boolean expression to filter rows from the table "expire_go1_license_jobs". All fields are combined with a logical 'AND'. */
export type Expire_Go1_License_Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Expire_Go1_License_Jobs_Bool_Exp>>;
  _not?: InputMaybe<Expire_Go1_License_Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Expire_Go1_License_Jobs_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  jobId?: InputMaybe<Uuid_Comparison_Exp>;
  licenseId?: InputMaybe<Uuid_Comparison_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "expire_go1_license_jobs" */
export enum Expire_Go1_License_Jobs_Constraint {
  /** unique or primary key constraint on columns "license_id", "job_id", "profile_id" */
  ExpireGo1LicenseJobsJobIdLicenseIdProfileIdKey = 'expire_go1_license_jobs_job_id_license_id_profile_id_key',
  /** unique or primary key constraint on columns "id" */
  ExpireGo1LicenseJobsPkey = 'expire_go1_license_jobs_pkey'
}

/** input type for inserting data into table "expire_go1_license_jobs" */
export type Expire_Go1_License_Jobs_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  jobId?: InputMaybe<Scalars['uuid']>;
  licenseId?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Expire_Go1_License_Jobs_Max_Fields = {
  __typename?: 'expire_go1_license_jobs_max_fields';
  id?: Maybe<Scalars['uuid']>;
  jobId?: Maybe<Scalars['uuid']>;
  licenseId?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "expire_go1_license_jobs" */
export type Expire_Go1_License_Jobs_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  licenseId?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Expire_Go1_License_Jobs_Min_Fields = {
  __typename?: 'expire_go1_license_jobs_min_fields';
  id?: Maybe<Scalars['uuid']>;
  jobId?: Maybe<Scalars['uuid']>;
  licenseId?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "expire_go1_license_jobs" */
export type Expire_Go1_License_Jobs_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  licenseId?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "expire_go1_license_jobs" */
export type Expire_Go1_License_Jobs_Mutation_Response = {
  __typename?: 'expire_go1_license_jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Expire_Go1_License_Jobs>;
};

/** on_conflict condition type for table "expire_go1_license_jobs" */
export type Expire_Go1_License_Jobs_On_Conflict = {
  constraint: Expire_Go1_License_Jobs_Constraint;
  update_columns?: Array<Expire_Go1_License_Jobs_Update_Column>;
  where?: InputMaybe<Expire_Go1_License_Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "expire_go1_license_jobs". */
export type Expire_Go1_License_Jobs_Order_By = {
  id?: InputMaybe<Order_By>;
  jobId?: InputMaybe<Order_By>;
  licenseId?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: expire_go1_license_jobs */
export type Expire_Go1_License_Jobs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "expire_go1_license_jobs" */
export enum Expire_Go1_License_Jobs_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'jobId',
  /** column name */
  LicenseId = 'licenseId',
  /** column name */
  ProfileId = 'profile_id'
}

/** input type for updating data in table "expire_go1_license_jobs" */
export type Expire_Go1_License_Jobs_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  jobId?: InputMaybe<Scalars['uuid']>;
  licenseId?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "expire_go1_license_jobs" */
export type Expire_Go1_License_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Expire_Go1_License_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Expire_Go1_License_Jobs_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  jobId?: InputMaybe<Scalars['uuid']>;
  licenseId?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "expire_go1_license_jobs" */
export enum Expire_Go1_License_Jobs_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'jobId',
  /** column name */
  LicenseId = 'licenseId',
  /** column name */
  ProfileId = 'profile_id'
}

export type Expire_Go1_License_Jobs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Expire_Go1_License_Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Expire_Go1_License_Jobs_Bool_Exp;
};

/** Boolean expression to compare columns of type "float8". All fields are combined with logical 'AND'. */
export type Float8_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['float8']>;
  _gt?: InputMaybe<Scalars['float8']>;
  _gte?: InputMaybe<Scalars['float8']>;
  _in?: InputMaybe<Array<Scalars['float8']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['float8']>;
  _lte?: InputMaybe<Scalars['float8']>;
  _neq?: InputMaybe<Scalars['float8']>;
  _nin?: InputMaybe<Array<Scalars['float8']>>;
};

export type Get_Organisation_By_Email_Args = {
  email?: InputMaybe<Scalars['String']>;
};

/** Enum table for Go1 licensing changes events */
export type Go1_History_Events = {
  __typename?: 'go1_history_events';
  name: Scalars['String'];
};

/** aggregated selection of "go1_history_events" */
export type Go1_History_Events_Aggregate = {
  __typename?: 'go1_history_events_aggregate';
  aggregate?: Maybe<Go1_History_Events_Aggregate_Fields>;
  nodes: Array<Go1_History_Events>;
};

/** aggregate fields of "go1_history_events" */
export type Go1_History_Events_Aggregate_Fields = {
  __typename?: 'go1_history_events_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Go1_History_Events_Max_Fields>;
  min?: Maybe<Go1_History_Events_Min_Fields>;
};


/** aggregate fields of "go1_history_events" */
export type Go1_History_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Go1_History_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "go1_history_events". All fields are combined with a logical 'AND'. */
export type Go1_History_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Go1_History_Events_Bool_Exp>>;
  _not?: InputMaybe<Go1_History_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Go1_History_Events_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "go1_history_events" */
export enum Go1_History_Events_Constraint {
  /** unique or primary key constraint on columns "name" */
  Go1HistoryEventsPkey = 'go1_history_events_pkey'
}

export enum Go1_History_Events_Enum {
  LicensesAdded = 'LICENSES_ADDED',
  LicensesCancelled = 'LICENSES_CANCELLED',
  LicensesDeclined = 'LICENSES_DECLINED',
  LicensesPurchased = 'LICENSES_PURCHASED',
  LicensesReleased = 'LICENSES_RELEASED',
  LicensesRemoved = 'LICENSES_REMOVED',
  LicensesReserved = 'LICENSES_RESERVED',
  LicensesTransferredFromAffiliateOrg = 'LICENSES_TRANSFERRED_FROM_AFFILIATE_ORG',
  LicensesTransferredToMainOrg = 'LICENSES_TRANSFERRED_TO_MAIN_ORG',
  LicenseIssued = 'LICENSE_ISSUED',
  LicenseRevoked = 'LICENSE_REVOKED',
  ReservedLicensesTransferredFromAffiliateOrg = 'RESERVED_LICENSES_TRANSFERRED_FROM_AFFILIATE_ORG',
  ReservedLicensesTransferredToMainOrg = 'RESERVED_LICENSES_TRANSFERRED_TO_MAIN_ORG'
}

/** Boolean expression to compare columns of type "go1_history_events_enum". All fields are combined with logical 'AND'. */
export type Go1_History_Events_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Go1_History_Events_Enum>;
  _in?: InputMaybe<Array<Go1_History_Events_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Go1_History_Events_Enum>;
  _nin?: InputMaybe<Array<Go1_History_Events_Enum>>;
};

/** input type for inserting data into table "go1_history_events" */
export type Go1_History_Events_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Go1_History_Events_Max_Fields = {
  __typename?: 'go1_history_events_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Go1_History_Events_Min_Fields = {
  __typename?: 'go1_history_events_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "go1_history_events" */
export type Go1_History_Events_Mutation_Response = {
  __typename?: 'go1_history_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Go1_History_Events>;
};

/** on_conflict condition type for table "go1_history_events" */
export type Go1_History_Events_On_Conflict = {
  constraint: Go1_History_Events_Constraint;
  update_columns?: Array<Go1_History_Events_Update_Column>;
  where?: InputMaybe<Go1_History_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "go1_history_events". */
export type Go1_History_Events_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: go1_history_events */
export type Go1_History_Events_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "go1_history_events" */
export enum Go1_History_Events_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "go1_history_events" */
export type Go1_History_Events_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "go1_history_events" */
export type Go1_History_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Go1_History_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Go1_History_Events_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "go1_history_events" */
export enum Go1_History_Events_Update_Column {
  /** column name */
  Name = 'name'
}

export type Go1_History_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Go1_History_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Go1_History_Events_Bool_Exp;
};

/** Organization's users Go1 licenses */
export type Go1_Licenses = {
  __typename?: 'go1_licenses';
  /** An object relationship */
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']>;
  enrolledOn: Scalars['timestamptz'];
  expireDate: Scalars['timestamptz'];
  /** An array relationship */
  expire_go1_license_jobs: Array<Expire_Go1_License_Jobs>;
  /** An aggregate relationship */
  expire_go1_license_jobs_aggregate: Expire_Go1_License_Jobs_Aggregate;
  id: Scalars['uuid'];
  orgId: Scalars['uuid'];
  /** An object relationship */
  organization: Organization;
  /** An object relationship */
  profile: Profile;
  profileId: Scalars['uuid'];
};


/** Organization's users Go1 licenses */
export type Go1_LicensesExpire_Go1_License_JobsArgs = {
  distinct_on?: InputMaybe<Array<Expire_Go1_License_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expire_Go1_License_Jobs_Order_By>>;
  where?: InputMaybe<Expire_Go1_License_Jobs_Bool_Exp>;
};


/** Organization's users Go1 licenses */
export type Go1_LicensesExpire_Go1_License_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expire_Go1_License_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expire_Go1_License_Jobs_Order_By>>;
  where?: InputMaybe<Expire_Go1_License_Jobs_Bool_Exp>;
};

/** aggregated selection of "go1_licenses" */
export type Go1_Licenses_Aggregate = {
  __typename?: 'go1_licenses_aggregate';
  aggregate?: Maybe<Go1_Licenses_Aggregate_Fields>;
  nodes: Array<Go1_Licenses>;
};

export type Go1_Licenses_Aggregate_Bool_Exp = {
  count?: InputMaybe<Go1_Licenses_Aggregate_Bool_Exp_Count>;
};

export type Go1_Licenses_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Go1_Licenses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Go1_Licenses_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "go1_licenses" */
export type Go1_Licenses_Aggregate_Fields = {
  __typename?: 'go1_licenses_aggregate_fields';
  avg?: Maybe<Go1_Licenses_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Go1_Licenses_Max_Fields>;
  min?: Maybe<Go1_Licenses_Min_Fields>;
  stddev?: Maybe<Go1_Licenses_Stddev_Fields>;
  stddev_pop?: Maybe<Go1_Licenses_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Go1_Licenses_Stddev_Samp_Fields>;
  sum?: Maybe<Go1_Licenses_Sum_Fields>;
  var_pop?: Maybe<Go1_Licenses_Var_Pop_Fields>;
  var_samp?: Maybe<Go1_Licenses_Var_Samp_Fields>;
  variance?: Maybe<Go1_Licenses_Variance_Fields>;
};


/** aggregate fields of "go1_licenses" */
export type Go1_Licenses_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Go1_Licenses_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "go1_licenses" */
export type Go1_Licenses_Aggregate_Order_By = {
  avg?: InputMaybe<Go1_Licenses_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Go1_Licenses_Max_Order_By>;
  min?: InputMaybe<Go1_Licenses_Min_Order_By>;
  stddev?: InputMaybe<Go1_Licenses_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Go1_Licenses_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Go1_Licenses_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Go1_Licenses_Sum_Order_By>;
  var_pop?: InputMaybe<Go1_Licenses_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Go1_Licenses_Var_Samp_Order_By>;
  variance?: InputMaybe<Go1_Licenses_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "go1_licenses" */
export type Go1_Licenses_Arr_Rel_Insert_Input = {
  data: Array<Go1_Licenses_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Go1_Licenses_On_Conflict>;
};

/** aggregate avg on columns */
export type Go1_Licenses_Avg_Fields = {
  __typename?: 'go1_licenses_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "go1_licenses" */
export type Go1_Licenses_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "go1_licenses". All fields are combined with a logical 'AND'. */
export type Go1_Licenses_Bool_Exp = {
  _and?: InputMaybe<Array<Go1_Licenses_Bool_Exp>>;
  _not?: InputMaybe<Go1_Licenses_Bool_Exp>;
  _or?: InputMaybe<Array<Go1_Licenses_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  enrolledOn?: InputMaybe<Timestamptz_Comparison_Exp>;
  expireDate?: InputMaybe<Timestamptz_Comparison_Exp>;
  expire_go1_license_jobs?: InputMaybe<Expire_Go1_License_Jobs_Bool_Exp>;
  expire_go1_license_jobs_aggregate?: InputMaybe<Expire_Go1_License_Jobs_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orgId?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profileId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "go1_licenses" */
export enum Go1_Licenses_Constraint {
  /** unique or primary key constraint on columns "id" */
  Go1LicensesPkey = 'go1_licenses_pkey',
  /** unique or primary key constraint on columns "course_id", "profile_id" */
  Go1LicensesProfileIdCourseIdKey = 'go1_licenses_profile_id_course_id_key'
}

/** How organization's licenses number is changing in time */
export type Go1_Licenses_History = {
  __typename?: 'go1_licenses_history';
  balance: Scalars['Int'];
  captured_at: Scalars['timestamptz'];
  change: Scalars['Int'];
  /** An object relationship */
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']>;
  event: Go1_History_Events_Enum;
  id: Scalars['uuid'];
  org_id: Scalars['uuid'];
  /** An object relationship */
  organization: Organization;
  payload?: Maybe<Scalars['jsonb']>;
  reservedBalance: Scalars['Int'];
};


/** How organization's licenses number is changing in time */
export type Go1_Licenses_HistoryPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "go1_licenses_history" */
export type Go1_Licenses_History_Aggregate = {
  __typename?: 'go1_licenses_history_aggregate';
  aggregate?: Maybe<Go1_Licenses_History_Aggregate_Fields>;
  nodes: Array<Go1_Licenses_History>;
};

export type Go1_Licenses_History_Aggregate_Bool_Exp = {
  count?: InputMaybe<Go1_Licenses_History_Aggregate_Bool_Exp_Count>;
};

export type Go1_Licenses_History_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Go1_Licenses_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Go1_Licenses_History_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "go1_licenses_history" */
export type Go1_Licenses_History_Aggregate_Fields = {
  __typename?: 'go1_licenses_history_aggregate_fields';
  avg?: Maybe<Go1_Licenses_History_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Go1_Licenses_History_Max_Fields>;
  min?: Maybe<Go1_Licenses_History_Min_Fields>;
  stddev?: Maybe<Go1_Licenses_History_Stddev_Fields>;
  stddev_pop?: Maybe<Go1_Licenses_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Go1_Licenses_History_Stddev_Samp_Fields>;
  sum?: Maybe<Go1_Licenses_History_Sum_Fields>;
  var_pop?: Maybe<Go1_Licenses_History_Var_Pop_Fields>;
  var_samp?: Maybe<Go1_Licenses_History_Var_Samp_Fields>;
  variance?: Maybe<Go1_Licenses_History_Variance_Fields>;
};


/** aggregate fields of "go1_licenses_history" */
export type Go1_Licenses_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Go1_Licenses_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "go1_licenses_history" */
export type Go1_Licenses_History_Aggregate_Order_By = {
  avg?: InputMaybe<Go1_Licenses_History_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Go1_Licenses_History_Max_Order_By>;
  min?: InputMaybe<Go1_Licenses_History_Min_Order_By>;
  stddev?: InputMaybe<Go1_Licenses_History_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Go1_Licenses_History_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Go1_Licenses_History_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Go1_Licenses_History_Sum_Order_By>;
  var_pop?: InputMaybe<Go1_Licenses_History_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Go1_Licenses_History_Var_Samp_Order_By>;
  variance?: InputMaybe<Go1_Licenses_History_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Go1_Licenses_History_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "go1_licenses_history" */
export type Go1_Licenses_History_Arr_Rel_Insert_Input = {
  data: Array<Go1_Licenses_History_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Go1_Licenses_History_On_Conflict>;
};

/** aggregate avg on columns */
export type Go1_Licenses_History_Avg_Fields = {
  __typename?: 'go1_licenses_history_avg_fields';
  balance?: Maybe<Scalars['Float']>;
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "go1_licenses_history" */
export type Go1_Licenses_History_Avg_Order_By = {
  balance?: InputMaybe<Order_By>;
  change?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  reservedBalance?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "go1_licenses_history". All fields are combined with a logical 'AND'. */
export type Go1_Licenses_History_Bool_Exp = {
  _and?: InputMaybe<Array<Go1_Licenses_History_Bool_Exp>>;
  _not?: InputMaybe<Go1_Licenses_History_Bool_Exp>;
  _or?: InputMaybe<Array<Go1_Licenses_History_Bool_Exp>>;
  balance?: InputMaybe<Int_Comparison_Exp>;
  captured_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  change?: InputMaybe<Int_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  event?: InputMaybe<Go1_History_Events_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  reservedBalance?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "go1_licenses_history" */
export enum Go1_Licenses_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  Go1LicensesHistoryPkey = 'go1_licenses_history_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Go1_Licenses_History_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Go1_Licenses_History_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Go1_Licenses_History_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "go1_licenses_history" */
export type Go1_Licenses_History_Inc_Input = {
  balance?: InputMaybe<Scalars['Int']>;
  change?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  reservedBalance?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "go1_licenses_history" */
export type Go1_Licenses_History_Insert_Input = {
  balance?: InputMaybe<Scalars['Int']>;
  captured_at?: InputMaybe<Scalars['timestamptz']>;
  change?: InputMaybe<Scalars['Int']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  event?: InputMaybe<Go1_History_Events_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  payload?: InputMaybe<Scalars['jsonb']>;
  reservedBalance?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Go1_Licenses_History_Max_Fields = {
  __typename?: 'go1_licenses_history_max_fields';
  balance?: Maybe<Scalars['Int']>;
  captured_at?: Maybe<Scalars['timestamptz']>;
  change?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  reservedBalance?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "go1_licenses_history" */
export type Go1_Licenses_History_Max_Order_By = {
  balance?: InputMaybe<Order_By>;
  captured_at?: InputMaybe<Order_By>;
  change?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  reservedBalance?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Go1_Licenses_History_Min_Fields = {
  __typename?: 'go1_licenses_history_min_fields';
  balance?: Maybe<Scalars['Int']>;
  captured_at?: Maybe<Scalars['timestamptz']>;
  change?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  reservedBalance?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "go1_licenses_history" */
export type Go1_Licenses_History_Min_Order_By = {
  balance?: InputMaybe<Order_By>;
  captured_at?: InputMaybe<Order_By>;
  change?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  reservedBalance?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "go1_licenses_history" */
export type Go1_Licenses_History_Mutation_Response = {
  __typename?: 'go1_licenses_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Go1_Licenses_History>;
};

/** on_conflict condition type for table "go1_licenses_history" */
export type Go1_Licenses_History_On_Conflict = {
  constraint: Go1_Licenses_History_Constraint;
  update_columns?: Array<Go1_Licenses_History_Update_Column>;
  where?: InputMaybe<Go1_Licenses_History_Bool_Exp>;
};

/** Ordering options when selecting data from "go1_licenses_history". */
export type Go1_Licenses_History_Order_By = {
  balance?: InputMaybe<Order_By>;
  captured_at?: InputMaybe<Order_By>;
  change?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  event?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  payload?: InputMaybe<Order_By>;
  reservedBalance?: InputMaybe<Order_By>;
};

/** primary key columns input for table: go1_licenses_history */
export type Go1_Licenses_History_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Go1_Licenses_History_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "go1_licenses_history" */
export enum Go1_Licenses_History_Select_Column {
  /** column name */
  Balance = 'balance',
  /** column name */
  CapturedAt = 'captured_at',
  /** column name */
  Change = 'change',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Event = 'event',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Payload = 'payload',
  /** column name */
  ReservedBalance = 'reservedBalance'
}

/** input type for updating data in table "go1_licenses_history" */
export type Go1_Licenses_History_Set_Input = {
  balance?: InputMaybe<Scalars['Int']>;
  captured_at?: InputMaybe<Scalars['timestamptz']>;
  change?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  event?: InputMaybe<Go1_History_Events_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  reservedBalance?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Go1_Licenses_History_Stddev_Fields = {
  __typename?: 'go1_licenses_history_stddev_fields';
  balance?: Maybe<Scalars['Float']>;
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "go1_licenses_history" */
export type Go1_Licenses_History_Stddev_Order_By = {
  balance?: InputMaybe<Order_By>;
  change?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  reservedBalance?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Go1_Licenses_History_Stddev_Pop_Fields = {
  __typename?: 'go1_licenses_history_stddev_pop_fields';
  balance?: Maybe<Scalars['Float']>;
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "go1_licenses_history" */
export type Go1_Licenses_History_Stddev_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  change?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  reservedBalance?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Go1_Licenses_History_Stddev_Samp_Fields = {
  __typename?: 'go1_licenses_history_stddev_samp_fields';
  balance?: Maybe<Scalars['Float']>;
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "go1_licenses_history" */
export type Go1_Licenses_History_Stddev_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  change?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  reservedBalance?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "go1_licenses_history" */
export type Go1_Licenses_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Go1_Licenses_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Go1_Licenses_History_Stream_Cursor_Value_Input = {
  balance?: InputMaybe<Scalars['Int']>;
  captured_at?: InputMaybe<Scalars['timestamptz']>;
  change?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  event?: InputMaybe<Go1_History_Events_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  org_id?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  reservedBalance?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Go1_Licenses_History_Sum_Fields = {
  __typename?: 'go1_licenses_history_sum_fields';
  balance?: Maybe<Scalars['Int']>;
  change?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  reservedBalance?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "go1_licenses_history" */
export type Go1_Licenses_History_Sum_Order_By = {
  balance?: InputMaybe<Order_By>;
  change?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  reservedBalance?: InputMaybe<Order_By>;
};

/** update columns of table "go1_licenses_history" */
export enum Go1_Licenses_History_Update_Column {
  /** column name */
  Balance = 'balance',
  /** column name */
  CapturedAt = 'captured_at',
  /** column name */
  Change = 'change',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  Event = 'event',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  Payload = 'payload',
  /** column name */
  ReservedBalance = 'reservedBalance'
}

export type Go1_Licenses_History_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Go1_Licenses_History_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Go1_Licenses_History_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Go1_Licenses_History_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Go1_Licenses_History_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Go1_Licenses_History_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Go1_Licenses_History_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Go1_Licenses_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: Go1_Licenses_History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Go1_Licenses_History_Var_Pop_Fields = {
  __typename?: 'go1_licenses_history_var_pop_fields';
  balance?: Maybe<Scalars['Float']>;
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "go1_licenses_history" */
export type Go1_Licenses_History_Var_Pop_Order_By = {
  balance?: InputMaybe<Order_By>;
  change?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  reservedBalance?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Go1_Licenses_History_Var_Samp_Fields = {
  __typename?: 'go1_licenses_history_var_samp_fields';
  balance?: Maybe<Scalars['Float']>;
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "go1_licenses_history" */
export type Go1_Licenses_History_Var_Samp_Order_By = {
  balance?: InputMaybe<Order_By>;
  change?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  reservedBalance?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Go1_Licenses_History_Variance_Fields = {
  __typename?: 'go1_licenses_history_variance_fields';
  balance?: Maybe<Scalars['Float']>;
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "go1_licenses_history" */
export type Go1_Licenses_History_Variance_Order_By = {
  balance?: InputMaybe<Order_By>;
  change?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  reservedBalance?: InputMaybe<Order_By>;
};

/** input type for incrementing numeric columns in table "go1_licenses" */
export type Go1_Licenses_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "go1_licenses" */
export type Go1_Licenses_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  enrolledOn?: InputMaybe<Scalars['timestamptz']>;
  expireDate?: InputMaybe<Scalars['timestamptz']>;
  expire_go1_license_jobs?: InputMaybe<Expire_Go1_License_Jobs_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  orgId?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profileId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Go1_Licenses_Max_Fields = {
  __typename?: 'go1_licenses_max_fields';
  courseId?: Maybe<Scalars['Int']>;
  enrolledOn?: Maybe<Scalars['timestamptz']>;
  expireDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  orgId?: Maybe<Scalars['uuid']>;
  profileId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "go1_licenses" */
export type Go1_Licenses_Max_Order_By = {
  courseId?: InputMaybe<Order_By>;
  enrolledOn?: InputMaybe<Order_By>;
  expireDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Go1_Licenses_Min_Fields = {
  __typename?: 'go1_licenses_min_fields';
  courseId?: Maybe<Scalars['Int']>;
  enrolledOn?: Maybe<Scalars['timestamptz']>;
  expireDate?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  orgId?: Maybe<Scalars['uuid']>;
  profileId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "go1_licenses" */
export type Go1_Licenses_Min_Order_By = {
  courseId?: InputMaybe<Order_By>;
  enrolledOn?: InputMaybe<Order_By>;
  expireDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "go1_licenses" */
export type Go1_Licenses_Mutation_Response = {
  __typename?: 'go1_licenses_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Go1_Licenses>;
};

/** on_conflict condition type for table "go1_licenses" */
export type Go1_Licenses_On_Conflict = {
  constraint: Go1_Licenses_Constraint;
  update_columns?: Array<Go1_Licenses_Update_Column>;
  where?: InputMaybe<Go1_Licenses_Bool_Exp>;
};

/** Ordering options when selecting data from "go1_licenses". */
export type Go1_Licenses_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  enrolledOn?: InputMaybe<Order_By>;
  expireDate?: InputMaybe<Order_By>;
  expire_go1_license_jobs_aggregate?: InputMaybe<Expire_Go1_License_Jobs_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profileId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: go1_licenses */
export type Go1_Licenses_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "go1_licenses" */
export enum Go1_Licenses_Select_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  EnrolledOn = 'enrolledOn',
  /** column name */
  ExpireDate = 'expireDate',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  ProfileId = 'profileId'
}

/** input type for updating data in table "go1_licenses" */
export type Go1_Licenses_Set_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  enrolledOn?: InputMaybe<Scalars['timestamptz']>;
  expireDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  orgId?: InputMaybe<Scalars['uuid']>;
  profileId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Go1_Licenses_Stddev_Fields = {
  __typename?: 'go1_licenses_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "go1_licenses" */
export type Go1_Licenses_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Go1_Licenses_Stddev_Pop_Fields = {
  __typename?: 'go1_licenses_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "go1_licenses" */
export type Go1_Licenses_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Go1_Licenses_Stddev_Samp_Fields = {
  __typename?: 'go1_licenses_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "go1_licenses" */
export type Go1_Licenses_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "go1_licenses" */
export type Go1_Licenses_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Go1_Licenses_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Go1_Licenses_Stream_Cursor_Value_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  enrolledOn?: InputMaybe<Scalars['timestamptz']>;
  expireDate?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  orgId?: InputMaybe<Scalars['uuid']>;
  profileId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Go1_Licenses_Sum_Fields = {
  __typename?: 'go1_licenses_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "go1_licenses" */
export type Go1_Licenses_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** update columns of table "go1_licenses" */
export enum Go1_Licenses_Update_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  EnrolledOn = 'enrolledOn',
  /** column name */
  ExpireDate = 'expireDate',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  ProfileId = 'profileId'
}

export type Go1_Licenses_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Go1_Licenses_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Go1_Licenses_Set_Input>;
  /** filter the rows which have to be updated */
  where: Go1_Licenses_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Go1_Licenses_Var_Pop_Fields = {
  __typename?: 'go1_licenses_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "go1_licenses" */
export type Go1_Licenses_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Go1_Licenses_Var_Samp_Fields = {
  __typename?: 'go1_licenses_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "go1_licenses" */
export type Go1_Licenses_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Go1_Licenses_Variance_Fields = {
  __typename?: 'go1_licenses_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "go1_licenses" */
export type Go1_Licenses_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Enum table for possible course grades */
export type Grade = {
  __typename?: 'grade';
  name: Scalars['String'];
};

/** aggregated selection of "grade" */
export type Grade_Aggregate = {
  __typename?: 'grade_aggregate';
  aggregate?: Maybe<Grade_Aggregate_Fields>;
  nodes: Array<Grade>;
};

/** aggregate fields of "grade" */
export type Grade_Aggregate_Fields = {
  __typename?: 'grade_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Grade_Max_Fields>;
  min?: Maybe<Grade_Min_Fields>;
};


/** aggregate fields of "grade" */
export type Grade_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Grade_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "grade". All fields are combined with a logical 'AND'. */
export type Grade_Bool_Exp = {
  _and?: InputMaybe<Array<Grade_Bool_Exp>>;
  _not?: InputMaybe<Grade_Bool_Exp>;
  _or?: InputMaybe<Array<Grade_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "grade" */
export enum Grade_Constraint {
  /** unique or primary key constraint on columns "name" */
  GradePkey = 'grade_pkey'
}

export enum Grade_Enum {
  AssistOnly = 'ASSIST_ONLY',
  Fail = 'FAIL',
  ObserveOnly = 'OBSERVE_ONLY',
  Pass = 'PASS'
}

/** Boolean expression to compare columns of type "grade_enum". All fields are combined with logical 'AND'. */
export type Grade_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Grade_Enum>;
  _in?: InputMaybe<Array<Grade_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Grade_Enum>;
  _nin?: InputMaybe<Array<Grade_Enum>>;
};

/** input type for inserting data into table "grade" */
export type Grade_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Grade_Max_Fields = {
  __typename?: 'grade_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Grade_Min_Fields = {
  __typename?: 'grade_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "grade" */
export type Grade_Mutation_Response = {
  __typename?: 'grade_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Grade>;
};

/** on_conflict condition type for table "grade" */
export type Grade_On_Conflict = {
  constraint: Grade_Constraint;
  update_columns?: Array<Grade_Update_Column>;
  where?: InputMaybe<Grade_Bool_Exp>;
};

/** Ordering options when selecting data from "grade". */
export type Grade_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: grade */
export type Grade_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "grade" */
export enum Grade_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "grade" */
export type Grade_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "grade" */
export type Grade_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Grade_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Grade_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "grade" */
export enum Grade_Update_Column {
  /** column name */
  Name = 'name'
}

export type Grade_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Grade_Set_Input>;
  /** filter the rows which have to be updated */
  where: Grade_Bool_Exp;
};

/** This table stores hubspot related logs */
export type Hubspot_Audit = {
  __typename?: 'hubspot_audit';
  authentication_mode: Scalars['String'];
  created_at: Scalars['timestamptz'];
  error?: Maybe<Scalars['jsonb']>;
  hubspot_cookie?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  page_details?: Maybe<Scalars['jsonb']>;
  profile_id?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
};


/** This table stores hubspot related logs */
export type Hubspot_AuditErrorArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table stores hubspot related logs */
export type Hubspot_AuditPage_DetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "hubspot_audit" */
export type Hubspot_Audit_Aggregate = {
  __typename?: 'hubspot_audit_aggregate';
  aggregate?: Maybe<Hubspot_Audit_Aggregate_Fields>;
  nodes: Array<Hubspot_Audit>;
};

/** aggregate fields of "hubspot_audit" */
export type Hubspot_Audit_Aggregate_Fields = {
  __typename?: 'hubspot_audit_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Hubspot_Audit_Max_Fields>;
  min?: Maybe<Hubspot_Audit_Min_Fields>;
};


/** aggregate fields of "hubspot_audit" */
export type Hubspot_Audit_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Hubspot_Audit_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Hubspot_Audit_Append_Input = {
  error?: InputMaybe<Scalars['jsonb']>;
  page_details?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "hubspot_audit". All fields are combined with a logical 'AND'. */
export type Hubspot_Audit_Bool_Exp = {
  _and?: InputMaybe<Array<Hubspot_Audit_Bool_Exp>>;
  _not?: InputMaybe<Hubspot_Audit_Bool_Exp>;
  _or?: InputMaybe<Array<Hubspot_Audit_Bool_Exp>>;
  authentication_mode?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  error?: InputMaybe<Jsonb_Comparison_Exp>;
  hubspot_cookie?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  page_details?: InputMaybe<Jsonb_Comparison_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "hubspot_audit" */
export enum Hubspot_Audit_Constraint {
  /** unique or primary key constraint on columns "id" */
  HubspotAuditPkey = 'hubspot_audit_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Hubspot_Audit_Delete_At_Path_Input = {
  error?: InputMaybe<Array<Scalars['String']>>;
  page_details?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Hubspot_Audit_Delete_Elem_Input = {
  error?: InputMaybe<Scalars['Int']>;
  page_details?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Hubspot_Audit_Delete_Key_Input = {
  error?: InputMaybe<Scalars['String']>;
  page_details?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "hubspot_audit" */
export type Hubspot_Audit_Insert_Input = {
  authentication_mode?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['jsonb']>;
  hubspot_cookie?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  page_details?: InputMaybe<Scalars['jsonb']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Hubspot_Audit_Max_Fields = {
  __typename?: 'hubspot_audit_max_fields';
  authentication_mode?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hubspot_cookie?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Hubspot_Audit_Min_Fields = {
  __typename?: 'hubspot_audit_min_fields';
  authentication_mode?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  hubspot_cookie?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "hubspot_audit" */
export type Hubspot_Audit_Mutation_Response = {
  __typename?: 'hubspot_audit_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Hubspot_Audit>;
};

/** on_conflict condition type for table "hubspot_audit" */
export type Hubspot_Audit_On_Conflict = {
  constraint: Hubspot_Audit_Constraint;
  update_columns?: Array<Hubspot_Audit_Update_Column>;
  where?: InputMaybe<Hubspot_Audit_Bool_Exp>;
};

/** Ordering options when selecting data from "hubspot_audit". */
export type Hubspot_Audit_Order_By = {
  authentication_mode?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  error?: InputMaybe<Order_By>;
  hubspot_cookie?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  page_details?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
};

/** primary key columns input for table: hubspot_audit */
export type Hubspot_Audit_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Hubspot_Audit_Prepend_Input = {
  error?: InputMaybe<Scalars['jsonb']>;
  page_details?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "hubspot_audit" */
export enum Hubspot_Audit_Select_Column {
  /** column name */
  AuthenticationMode = 'authentication_mode',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Error = 'error',
  /** column name */
  HubspotCookie = 'hubspot_cookie',
  /** column name */
  Id = 'id',
  /** column name */
  PageDetails = 'page_details',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Status = 'status'
}

/** input type for updating data in table "hubspot_audit" */
export type Hubspot_Audit_Set_Input = {
  authentication_mode?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['jsonb']>;
  hubspot_cookie?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  page_details?: InputMaybe<Scalars['jsonb']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "hubspot_audit" */
export type Hubspot_Audit_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Hubspot_Audit_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Hubspot_Audit_Stream_Cursor_Value_Input = {
  authentication_mode?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  error?: InputMaybe<Scalars['jsonb']>;
  hubspot_cookie?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  page_details?: InputMaybe<Scalars['jsonb']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
};

/** update columns of table "hubspot_audit" */
export enum Hubspot_Audit_Update_Column {
  /** column name */
  AuthenticationMode = 'authentication_mode',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Error = 'error',
  /** column name */
  HubspotCookie = 'hubspot_cookie',
  /** column name */
  Id = 'id',
  /** column name */
  PageDetails = 'page_details',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Status = 'status'
}

export type Hubspot_Audit_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Hubspot_Audit_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Hubspot_Audit_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Hubspot_Audit_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Hubspot_Audit_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Hubspot_Audit_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Hubspot_Audit_Set_Input>;
  /** filter the rows which have to be updated */
  where: Hubspot_Audit_Bool_Exp;
};

/** columns and relationships of "identity" */
export type Identity = {
  __typename?: 'identity';
  id: Scalars['uuid'];
  /** An object relationship */
  identity_type: Identity_Type;
  /** An object relationship */
  profile: Profile;
  profile_id: Scalars['uuid'];
  provider_id: Scalars['String'];
  type: Identity_Type_Enum;
};

/** aggregated selection of "identity" */
export type Identity_Aggregate = {
  __typename?: 'identity_aggregate';
  aggregate?: Maybe<Identity_Aggregate_Fields>;
  nodes: Array<Identity>;
};

export type Identity_Aggregate_Bool_Exp = {
  count?: InputMaybe<Identity_Aggregate_Bool_Exp_Count>;
};

export type Identity_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Identity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Identity_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "identity" */
export type Identity_Aggregate_Fields = {
  __typename?: 'identity_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Identity_Max_Fields>;
  min?: Maybe<Identity_Min_Fields>;
};


/** aggregate fields of "identity" */
export type Identity_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Identity_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "identity" */
export type Identity_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Identity_Max_Order_By>;
  min?: InputMaybe<Identity_Min_Order_By>;
};

/** input type for inserting array relation for remote table "identity" */
export type Identity_Arr_Rel_Insert_Input = {
  data: Array<Identity_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Identity_On_Conflict>;
};

/** Boolean expression to filter rows from the table "identity". All fields are combined with a logical 'AND'. */
export type Identity_Bool_Exp = {
  _and?: InputMaybe<Array<Identity_Bool_Exp>>;
  _not?: InputMaybe<Identity_Bool_Exp>;
  _or?: InputMaybe<Array<Identity_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identity_type?: InputMaybe<Identity_Type_Bool_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  provider_id?: InputMaybe<String_Comparison_Exp>;
  type?: InputMaybe<Identity_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "identity" */
export enum Identity_Constraint {
  /** unique or primary key constraint on columns "id" */
  IdentityPkey = 'identity_pkey',
  /** unique or primary key constraint on columns "provider_id" */
  IdentityProviderIdKey = 'identity_provider_id_key'
}

/** input type for inserting data into table "identity" */
export type Identity_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  identity_type?: InputMaybe<Identity_Type_Obj_Rel_Insert_Input>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Identity_Type_Enum>;
};

/** aggregate max on columns */
export type Identity_Max_Fields = {
  __typename?: 'identity_max_fields';
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "identity" */
export type Identity_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Identity_Min_Fields = {
  __typename?: 'identity_min_fields';
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  provider_id?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "identity" */
export type Identity_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "identity" */
export type Identity_Mutation_Response = {
  __typename?: 'identity_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Identity>;
};

/** input type for inserting object relation for remote table "identity" */
export type Identity_Obj_Rel_Insert_Input = {
  data: Identity_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Identity_On_Conflict>;
};

/** on_conflict condition type for table "identity" */
export type Identity_On_Conflict = {
  constraint: Identity_Constraint;
  update_columns?: Array<Identity_Update_Column>;
  where?: InputMaybe<Identity_Bool_Exp>;
};

/** Ordering options when selecting data from "identity". */
export type Identity_Order_By = {
  id?: InputMaybe<Order_By>;
  identity_type?: InputMaybe<Identity_Type_Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  provider_id?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: identity */
export type Identity_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "identity" */
export enum Identity_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "identity" */
export type Identity_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Identity_Type_Enum>;
};

/** Streaming cursor of the table "identity" */
export type Identity_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Identity_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Identity_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  provider_id?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Identity_Type_Enum>;
};

/** columns and relationships of "identity_type" */
export type Identity_Type = {
  __typename?: 'identity_type';
  /** An array relationship */
  identities: Array<Identity>;
  /** An aggregate relationship */
  identities_aggregate: Identity_Aggregate;
  value: Scalars['String'];
};


/** columns and relationships of "identity_type" */
export type Identity_TypeIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


/** columns and relationships of "identity_type" */
export type Identity_TypeIdentities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};

/** aggregated selection of "identity_type" */
export type Identity_Type_Aggregate = {
  __typename?: 'identity_type_aggregate';
  aggregate?: Maybe<Identity_Type_Aggregate_Fields>;
  nodes: Array<Identity_Type>;
};

/** aggregate fields of "identity_type" */
export type Identity_Type_Aggregate_Fields = {
  __typename?: 'identity_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Identity_Type_Max_Fields>;
  min?: Maybe<Identity_Type_Min_Fields>;
};


/** aggregate fields of "identity_type" */
export type Identity_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Identity_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "identity_type". All fields are combined with a logical 'AND'. */
export type Identity_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Identity_Type_Bool_Exp>>;
  _not?: InputMaybe<Identity_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Identity_Type_Bool_Exp>>;
  identities?: InputMaybe<Identity_Bool_Exp>;
  identities_aggregate?: InputMaybe<Identity_Aggregate_Bool_Exp>;
  value?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "identity_type" */
export enum Identity_Type_Constraint {
  /** unique or primary key constraint on columns "value" */
  IdentityTypePkey = 'identity_type_pkey'
}

export enum Identity_Type_Enum {
  Cognito = 'cognito',
  SsoCognito = 'sso_cognito'
}

/** Boolean expression to compare columns of type "identity_type_enum". All fields are combined with logical 'AND'. */
export type Identity_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Identity_Type_Enum>;
  _in?: InputMaybe<Array<Identity_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Identity_Type_Enum>;
  _nin?: InputMaybe<Array<Identity_Type_Enum>>;
};

/** input type for inserting data into table "identity_type" */
export type Identity_Type_Insert_Input = {
  identities?: InputMaybe<Identity_Arr_Rel_Insert_Input>;
  value?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Identity_Type_Max_Fields = {
  __typename?: 'identity_type_max_fields';
  value?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Identity_Type_Min_Fields = {
  __typename?: 'identity_type_min_fields';
  value?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "identity_type" */
export type Identity_Type_Mutation_Response = {
  __typename?: 'identity_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Identity_Type>;
};

/** input type for inserting object relation for remote table "identity_type" */
export type Identity_Type_Obj_Rel_Insert_Input = {
  data: Identity_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Identity_Type_On_Conflict>;
};

/** on_conflict condition type for table "identity_type" */
export type Identity_Type_On_Conflict = {
  constraint: Identity_Type_Constraint;
  update_columns?: Array<Identity_Type_Update_Column>;
  where?: InputMaybe<Identity_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "identity_type". */
export type Identity_Type_Order_By = {
  identities_aggregate?: InputMaybe<Identity_Aggregate_Order_By>;
  value?: InputMaybe<Order_By>;
};

/** primary key columns input for table: identity_type */
export type Identity_Type_Pk_Columns_Input = {
  value: Scalars['String'];
};

/** select columns of table "identity_type" */
export enum Identity_Type_Select_Column {
  /** column name */
  Value = 'value'
}

/** input type for updating data in table "identity_type" */
export type Identity_Type_Set_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "identity_type" */
export type Identity_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Identity_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Identity_Type_Stream_Cursor_Value_Input = {
  value?: InputMaybe<Scalars['String']>;
};

/** update columns of table "identity_type" */
export enum Identity_Type_Update_Column {
  /** column name */
  Value = 'value'
}

export type Identity_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Identity_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Identity_Type_Bool_Exp;
};

/** update columns of table "identity" */
export enum Identity_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  ProviderId = 'provider_id',
  /** column name */
  Type = 'type'
}

export type Identity_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Identity_Set_Input>;
  /** filter the rows which have to be updated */
  where: Identity_Bool_Exp;
};

/** fields of action: "importArloCertificates" */
export type ImportArloCertificates = {
  __typename?: 'importArloCertificates';
  /** the time at which this action was created */
  created_at: Scalars['timestamptz'];
  /** errors related to the invocation */
  errors?: Maybe<Scalars['json']>;
  /** the unique id of an action */
  id: Scalars['uuid'];
  /** the output fields of this action */
  output?: Maybe<ImportArloCertificatesOutput>;
};

/** Tracks an import job */
export type Import_Job = {
  __typename?: 'import_job';
  config?: Maybe<Scalars['jsonb']>;
  data?: Maybe<Scalars['String']>;
  finishedOn?: Maybe<Scalars['timestamp']>;
  id: Scalars['uuid'];
  result: Scalars['jsonb'];
  startedBy?: Maybe<Scalars['uuid']>;
  startedOn: Scalars['timestamp'];
  status?: Maybe<Import_Job_Status_Enum>;
  type?: Maybe<Import_Job_Type_Enum>;
};


/** Tracks an import job */
export type Import_JobConfigArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Tracks an import job */
export type Import_JobResultArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "import_job" */
export type Import_Job_Aggregate = {
  __typename?: 'import_job_aggregate';
  aggregate?: Maybe<Import_Job_Aggregate_Fields>;
  nodes: Array<Import_Job>;
};

/** aggregate fields of "import_job" */
export type Import_Job_Aggregate_Fields = {
  __typename?: 'import_job_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Import_Job_Max_Fields>;
  min?: Maybe<Import_Job_Min_Fields>;
};


/** aggregate fields of "import_job" */
export type Import_Job_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Import_Job_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Import_Job_Append_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  result?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "import_job". All fields are combined with a logical 'AND'. */
export type Import_Job_Bool_Exp = {
  _and?: InputMaybe<Array<Import_Job_Bool_Exp>>;
  _not?: InputMaybe<Import_Job_Bool_Exp>;
  _or?: InputMaybe<Array<Import_Job_Bool_Exp>>;
  config?: InputMaybe<Jsonb_Comparison_Exp>;
  data?: InputMaybe<String_Comparison_Exp>;
  finishedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  result?: InputMaybe<Jsonb_Comparison_Exp>;
  startedBy?: InputMaybe<Uuid_Comparison_Exp>;
  startedOn?: InputMaybe<Timestamp_Comparison_Exp>;
  status?: InputMaybe<Import_Job_Status_Enum_Comparison_Exp>;
  type?: InputMaybe<Import_Job_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "import_job" */
export enum Import_Job_Constraint {
  /** unique or primary key constraint on columns "id" */
  ImportUsersJobPkey = 'import_users_job_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Import_Job_Delete_At_Path_Input = {
  config?: InputMaybe<Array<Scalars['String']>>;
  result?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Import_Job_Delete_Elem_Input = {
  config?: InputMaybe<Scalars['Int']>;
  result?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Import_Job_Delete_Key_Input = {
  config?: InputMaybe<Scalars['String']>;
  result?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "import_job" */
export type Import_Job_Insert_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  data?: InputMaybe<Scalars['String']>;
  finishedOn?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  result?: InputMaybe<Scalars['jsonb']>;
  startedBy?: InputMaybe<Scalars['uuid']>;
  startedOn?: InputMaybe<Scalars['timestamp']>;
  status?: InputMaybe<Import_Job_Status_Enum>;
  type?: InputMaybe<Import_Job_Type_Enum>;
};

/** aggregate max on columns */
export type Import_Job_Max_Fields = {
  __typename?: 'import_job_max_fields';
  data?: Maybe<Scalars['String']>;
  finishedOn?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  startedBy?: Maybe<Scalars['uuid']>;
  startedOn?: Maybe<Scalars['timestamp']>;
};

/** aggregate min on columns */
export type Import_Job_Min_Fields = {
  __typename?: 'import_job_min_fields';
  data?: Maybe<Scalars['String']>;
  finishedOn?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  startedBy?: Maybe<Scalars['uuid']>;
  startedOn?: Maybe<Scalars['timestamp']>;
};

/** response of any mutation on the table "import_job" */
export type Import_Job_Mutation_Response = {
  __typename?: 'import_job_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Import_Job>;
};

/** on_conflict condition type for table "import_job" */
export type Import_Job_On_Conflict = {
  constraint: Import_Job_Constraint;
  update_columns?: Array<Import_Job_Update_Column>;
  where?: InputMaybe<Import_Job_Bool_Exp>;
};

/** Ordering options when selecting data from "import_job". */
export type Import_Job_Order_By = {
  config?: InputMaybe<Order_By>;
  data?: InputMaybe<Order_By>;
  finishedOn?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  result?: InputMaybe<Order_By>;
  startedBy?: InputMaybe<Order_By>;
  startedOn?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: import_job */
export type Import_Job_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Import_Job_Prepend_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  result?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "import_job" */
export enum Import_Job_Select_Column {
  /** column name */
  Config = 'config',
  /** column name */
  Data = 'data',
  /** column name */
  FinishedOn = 'finishedOn',
  /** column name */
  Id = 'id',
  /** column name */
  Result = 'result',
  /** column name */
  StartedBy = 'startedBy',
  /** column name */
  StartedOn = 'startedOn',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

/** input type for updating data in table "import_job" */
export type Import_Job_Set_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  data?: InputMaybe<Scalars['String']>;
  finishedOn?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  result?: InputMaybe<Scalars['jsonb']>;
  startedBy?: InputMaybe<Scalars['uuid']>;
  startedOn?: InputMaybe<Scalars['timestamp']>;
  status?: InputMaybe<Import_Job_Status_Enum>;
  type?: InputMaybe<Import_Job_Type_Enum>;
};

/** Enum table of import users job status */
export type Import_Job_Status = {
  __typename?: 'import_job_status';
  name: Scalars['String'];
};

/** aggregated selection of "import_job_status" */
export type Import_Job_Status_Aggregate = {
  __typename?: 'import_job_status_aggregate';
  aggregate?: Maybe<Import_Job_Status_Aggregate_Fields>;
  nodes: Array<Import_Job_Status>;
};

/** aggregate fields of "import_job_status" */
export type Import_Job_Status_Aggregate_Fields = {
  __typename?: 'import_job_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Import_Job_Status_Max_Fields>;
  min?: Maybe<Import_Job_Status_Min_Fields>;
};


/** aggregate fields of "import_job_status" */
export type Import_Job_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Import_Job_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "import_job_status". All fields are combined with a logical 'AND'. */
export type Import_Job_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Import_Job_Status_Bool_Exp>>;
  _not?: InputMaybe<Import_Job_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Import_Job_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "import_job_status" */
export enum Import_Job_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  ImportUsersJobStatusPkey = 'import_users_job_status_pkey'
}

export enum Import_Job_Status_Enum {
  Failed = 'FAILED',
  InProgress = 'IN_PROGRESS',
  PartiallySucceeded = 'PARTIALLY_SUCCEEDED',
  Succeeded = 'SUCCEEDED'
}

/** Boolean expression to compare columns of type "import_job_status_enum". All fields are combined with logical 'AND'. */
export type Import_Job_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Import_Job_Status_Enum>;
  _in?: InputMaybe<Array<Import_Job_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Import_Job_Status_Enum>;
  _nin?: InputMaybe<Array<Import_Job_Status_Enum>>;
};

/** input type for inserting data into table "import_job_status" */
export type Import_Job_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Import_Job_Status_Max_Fields = {
  __typename?: 'import_job_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Import_Job_Status_Min_Fields = {
  __typename?: 'import_job_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "import_job_status" */
export type Import_Job_Status_Mutation_Response = {
  __typename?: 'import_job_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Import_Job_Status>;
};

/** on_conflict condition type for table "import_job_status" */
export type Import_Job_Status_On_Conflict = {
  constraint: Import_Job_Status_Constraint;
  update_columns?: Array<Import_Job_Status_Update_Column>;
  where?: InputMaybe<Import_Job_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "import_job_status". */
export type Import_Job_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: import_job_status */
export type Import_Job_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "import_job_status" */
export enum Import_Job_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "import_job_status" */
export type Import_Job_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "import_job_status" */
export type Import_Job_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Import_Job_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Import_Job_Status_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "import_job_status" */
export enum Import_Job_Status_Update_Column {
  /** column name */
  Name = 'name'
}

export type Import_Job_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Import_Job_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Import_Job_Status_Bool_Exp;
};

/** Streaming cursor of the table "import_job" */
export type Import_Job_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Import_Job_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Import_Job_Stream_Cursor_Value_Input = {
  config?: InputMaybe<Scalars['jsonb']>;
  data?: InputMaybe<Scalars['String']>;
  finishedOn?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  result?: InputMaybe<Scalars['jsonb']>;
  startedBy?: InputMaybe<Scalars['uuid']>;
  startedOn?: InputMaybe<Scalars['timestamp']>;
  status?: InputMaybe<Import_Job_Status_Enum>;
  type?: InputMaybe<Import_Job_Type_Enum>;
};

/** columns and relationships of "import_job_type" */
export type Import_Job_Type = {
  __typename?: 'import_job_type';
  name: Scalars['String'];
};

/** aggregated selection of "import_job_type" */
export type Import_Job_Type_Aggregate = {
  __typename?: 'import_job_type_aggregate';
  aggregate?: Maybe<Import_Job_Type_Aggregate_Fields>;
  nodes: Array<Import_Job_Type>;
};

/** aggregate fields of "import_job_type" */
export type Import_Job_Type_Aggregate_Fields = {
  __typename?: 'import_job_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Import_Job_Type_Max_Fields>;
  min?: Maybe<Import_Job_Type_Min_Fields>;
};


/** aggregate fields of "import_job_type" */
export type Import_Job_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Import_Job_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "import_job_type". All fields are combined with a logical 'AND'. */
export type Import_Job_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Import_Job_Type_Bool_Exp>>;
  _not?: InputMaybe<Import_Job_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Import_Job_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "import_job_type" */
export enum Import_Job_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  ImportJobTypePkey = 'import_job_type_pkey'
}

export enum Import_Job_Type_Enum {
  Organisations = 'ORGANISATIONS',
  Users = 'USERS'
}

/** Boolean expression to compare columns of type "import_job_type_enum". All fields are combined with logical 'AND'. */
export type Import_Job_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Import_Job_Type_Enum>;
  _in?: InputMaybe<Array<Import_Job_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Import_Job_Type_Enum>;
  _nin?: InputMaybe<Array<Import_Job_Type_Enum>>;
};

/** input type for inserting data into table "import_job_type" */
export type Import_Job_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Import_Job_Type_Max_Fields = {
  __typename?: 'import_job_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Import_Job_Type_Min_Fields = {
  __typename?: 'import_job_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "import_job_type" */
export type Import_Job_Type_Mutation_Response = {
  __typename?: 'import_job_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Import_Job_Type>;
};

/** on_conflict condition type for table "import_job_type" */
export type Import_Job_Type_On_Conflict = {
  constraint: Import_Job_Type_Constraint;
  update_columns?: Array<Import_Job_Type_Update_Column>;
  where?: InputMaybe<Import_Job_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "import_job_type". */
export type Import_Job_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: import_job_type */
export type Import_Job_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "import_job_type" */
export enum Import_Job_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "import_job_type" */
export type Import_Job_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "import_job_type" */
export type Import_Job_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Import_Job_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Import_Job_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "import_job_type" */
export enum Import_Job_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Import_Job_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Import_Job_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Import_Job_Type_Bool_Exp;
};

/** update columns of table "import_job" */
export enum Import_Job_Update_Column {
  /** column name */
  Config = 'config',
  /** column name */
  Data = 'data',
  /** column name */
  FinishedOn = 'finishedOn',
  /** column name */
  Id = 'id',
  /** column name */
  Result = 'result',
  /** column name */
  StartedBy = 'startedBy',
  /** column name */
  StartedOn = 'startedOn',
  /** column name */
  Status = 'status',
  /** column name */
  Type = 'type'
}

export type Import_Job_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Import_Job_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Import_Job_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Import_Job_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Import_Job_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Import_Job_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Import_Job_Set_Input>;
  /** filter the rows which have to be updated */
  where: Import_Job_Bool_Exp;
};

export type IsUserSubscribedToMembershipResponse = {
  __typename?: 'isUserSubscribedToMembershipResponse';
  isSubscribed: Scalars['Boolean'];
};

/** columns and relationships of "job_title" */
export type Job_Title = {
  __typename?: 'job_title';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  shard: Scalars['String'];
  title: Scalars['String'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "job_title" */
export type Job_Title_Aggregate = {
  __typename?: 'job_title_aggregate';
  aggregate?: Maybe<Job_Title_Aggregate_Fields>;
  nodes: Array<Job_Title>;
};

/** aggregate fields of "job_title" */
export type Job_Title_Aggregate_Fields = {
  __typename?: 'job_title_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Job_Title_Max_Fields>;
  min?: Maybe<Job_Title_Min_Fields>;
};


/** aggregate fields of "job_title" */
export type Job_Title_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Job_Title_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "job_title". All fields are combined with a logical 'AND'. */
export type Job_Title_Bool_Exp = {
  _and?: InputMaybe<Array<Job_Title_Bool_Exp>>;
  _not?: InputMaybe<Job_Title_Bool_Exp>;
  _or?: InputMaybe<Array<Job_Title_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  shard?: InputMaybe<String_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "job_title" */
export enum Job_Title_Constraint {
  /** unique or primary key constraint on columns "id" */
  JobTitlePkey = 'job_title_pkey'
}

/** input type for inserting data into table "job_title" */
export type Job_Title_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  shard?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Job_Title_Max_Fields = {
  __typename?: 'job_title_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  shard?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Job_Title_Min_Fields = {
  __typename?: 'job_title_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  shard?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "job_title" */
export type Job_Title_Mutation_Response = {
  __typename?: 'job_title_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Job_Title>;
};

/** on_conflict condition type for table "job_title" */
export type Job_Title_On_Conflict = {
  constraint: Job_Title_Constraint;
  update_columns?: Array<Job_Title_Update_Column>;
  where?: InputMaybe<Job_Title_Bool_Exp>;
};

/** Ordering options when selecting data from "job_title". */
export type Job_Title_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  shard?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: job_title */
export type Job_Title_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "job_title" */
export enum Job_Title_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Shard = 'shard',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "job_title" */
export type Job_Title_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  shard?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "job_title" */
export type Job_Title_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Job_Title_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Job_Title_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  shard?: InputMaybe<Scalars['String']>;
  title?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "job_title" */
export enum Job_Title_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  Shard = 'shard',
  /** column name */
  Title = 'title',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Job_Title_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Job_Title_Set_Input>;
  /** filter the rows which have to be updated */
  where: Job_Title_Bool_Exp;
};

/** Boolean expression to compare columns of type "json". All fields are combined with logical 'AND'. */
export type Json_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['json']>;
  _gt?: InputMaybe<Scalars['json']>;
  _gte?: InputMaybe<Scalars['json']>;
  _in?: InputMaybe<Array<Scalars['json']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['json']>;
  _lte?: InputMaybe<Scalars['json']>;
  _neq?: InputMaybe<Scalars['json']>;
  _nin?: InputMaybe<Array<Scalars['json']>>;
};

export type Jsonb_Cast_Exp = {
  String?: InputMaybe<String_Comparison_Exp>;
};

/** Boolean expression to compare columns of type "jsonb". All fields are combined with logical 'AND'. */
export type Jsonb_Comparison_Exp = {
  _cast?: InputMaybe<Jsonb_Cast_Exp>;
  /** is the column contained in the given json value */
  _contained_in?: InputMaybe<Scalars['jsonb']>;
  /** does the column contain the given json value at the top level */
  _contains?: InputMaybe<Scalars['jsonb']>;
  _eq?: InputMaybe<Scalars['jsonb']>;
  _gt?: InputMaybe<Scalars['jsonb']>;
  _gte?: InputMaybe<Scalars['jsonb']>;
  /** does the string exist as a top-level key in the column */
  _has_key?: InputMaybe<Scalars['String']>;
  /** do all of these strings exist as top-level keys in the column */
  _has_keys_all?: InputMaybe<Array<Scalars['String']>>;
  /** do any of these strings exist as top-level keys in the column */
  _has_keys_any?: InputMaybe<Array<Scalars['String']>>;
  _in?: InputMaybe<Array<Scalars['jsonb']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['jsonb']>;
  _lte?: InputMaybe<Scalars['jsonb']>;
  _neq?: InputMaybe<Scalars['jsonb']>;
  _nin?: InputMaybe<Array<Scalars['jsonb']>>;
};

/** columns and relationships of "legacy_certificate" */
export type Legacy_Certificate = {
  __typename?: 'legacy_certificate';
  certificationDate: Scalars['date'];
  /** An object relationship */
  courseCertificate?: Maybe<Course_Certificate>;
  courseCertificateId?: Maybe<Scalars['uuid']>;
  courseCode: Scalars['String'];
  courseName: Scalars['String'];
  createdAt: Scalars['timestamptz'];
  email: Scalars['String'];
  expiryDate: Scalars['date'];
  firstName: Scalars['String'];
  id: Scalars['uuid'];
  lastName: Scalars['String'];
  legacyId: Scalars['Int'];
  number: Scalars['String'];
  originalRecord: Scalars['jsonb'];
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "legacy_certificate" */
export type Legacy_CertificateOriginalRecordArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "legacy_certificate" */
export type Legacy_Certificate_Aggregate = {
  __typename?: 'legacy_certificate_aggregate';
  aggregate?: Maybe<Legacy_Certificate_Aggregate_Fields>;
  nodes: Array<Legacy_Certificate>;
};

/** aggregate fields of "legacy_certificate" */
export type Legacy_Certificate_Aggregate_Fields = {
  __typename?: 'legacy_certificate_aggregate_fields';
  avg?: Maybe<Legacy_Certificate_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Legacy_Certificate_Max_Fields>;
  min?: Maybe<Legacy_Certificate_Min_Fields>;
  stddev?: Maybe<Legacy_Certificate_Stddev_Fields>;
  stddev_pop?: Maybe<Legacy_Certificate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Legacy_Certificate_Stddev_Samp_Fields>;
  sum?: Maybe<Legacy_Certificate_Sum_Fields>;
  var_pop?: Maybe<Legacy_Certificate_Var_Pop_Fields>;
  var_samp?: Maybe<Legacy_Certificate_Var_Samp_Fields>;
  variance?: Maybe<Legacy_Certificate_Variance_Fields>;
};


/** aggregate fields of "legacy_certificate" */
export type Legacy_Certificate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Legacy_Certificate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Legacy_Certificate_Append_Input = {
  originalRecord?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Legacy_Certificate_Avg_Fields = {
  __typename?: 'legacy_certificate_avg_fields';
  legacyId?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "legacy_certificate". All fields are combined with a logical 'AND'. */
export type Legacy_Certificate_Bool_Exp = {
  _and?: InputMaybe<Array<Legacy_Certificate_Bool_Exp>>;
  _not?: InputMaybe<Legacy_Certificate_Bool_Exp>;
  _or?: InputMaybe<Array<Legacy_Certificate_Bool_Exp>>;
  certificationDate?: InputMaybe<Date_Comparison_Exp>;
  courseCertificate?: InputMaybe<Course_Certificate_Bool_Exp>;
  courseCertificateId?: InputMaybe<Uuid_Comparison_Exp>;
  courseCode?: InputMaybe<String_Comparison_Exp>;
  courseName?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  expiryDate?: InputMaybe<Date_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  legacyId?: InputMaybe<Int_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  originalRecord?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "legacy_certificate" */
export enum Legacy_Certificate_Constraint {
  /** unique or primary key constraint on columns "number" */
  LegacyCertificateNumberKey = 'legacy_certificate_number_key',
  /** unique or primary key constraint on columns "id" */
  LegacyCertificatePkey = 'legacy_certificate_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Legacy_Certificate_Delete_At_Path_Input = {
  originalRecord?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Legacy_Certificate_Delete_Elem_Input = {
  originalRecord?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Legacy_Certificate_Delete_Key_Input = {
  originalRecord?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "legacy_certificate" */
export type Legacy_Certificate_Inc_Input = {
  legacyId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "legacy_certificate" */
export type Legacy_Certificate_Insert_Input = {
  certificationDate?: InputMaybe<Scalars['date']>;
  courseCertificate?: InputMaybe<Course_Certificate_Obj_Rel_Insert_Input>;
  courseCertificateId?: InputMaybe<Scalars['uuid']>;
  courseCode?: InputMaybe<Scalars['String']>;
  courseName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  expiryDate?: InputMaybe<Scalars['date']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  originalRecord?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Legacy_Certificate_Max_Fields = {
  __typename?: 'legacy_certificate_max_fields';
  certificationDate?: Maybe<Scalars['date']>;
  courseCertificateId?: Maybe<Scalars['uuid']>;
  courseCode?: Maybe<Scalars['String']>;
  courseName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['date']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Legacy_Certificate_Min_Fields = {
  __typename?: 'legacy_certificate_min_fields';
  certificationDate?: Maybe<Scalars['date']>;
  courseCertificateId?: Maybe<Scalars['uuid']>;
  courseCode?: Maybe<Scalars['String']>;
  courseName?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  expiryDate?: Maybe<Scalars['date']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  legacyId?: Maybe<Scalars['Int']>;
  number?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "legacy_certificate" */
export type Legacy_Certificate_Mutation_Response = {
  __typename?: 'legacy_certificate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Legacy_Certificate>;
};

/** on_conflict condition type for table "legacy_certificate" */
export type Legacy_Certificate_On_Conflict = {
  constraint: Legacy_Certificate_Constraint;
  update_columns?: Array<Legacy_Certificate_Update_Column>;
  where?: InputMaybe<Legacy_Certificate_Bool_Exp>;
};

/** Ordering options when selecting data from "legacy_certificate". */
export type Legacy_Certificate_Order_By = {
  certificationDate?: InputMaybe<Order_By>;
  courseCertificate?: InputMaybe<Course_Certificate_Order_By>;
  courseCertificateId?: InputMaybe<Order_By>;
  courseCode?: InputMaybe<Order_By>;
  courseName?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  expiryDate?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  legacyId?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  originalRecord?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: legacy_certificate */
export type Legacy_Certificate_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Legacy_Certificate_Prepend_Input = {
  originalRecord?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "legacy_certificate" */
export enum Legacy_Certificate_Select_Column {
  /** column name */
  CertificationDate = 'certificationDate',
  /** column name */
  CourseCertificateId = 'courseCertificateId',
  /** column name */
  CourseCode = 'courseCode',
  /** column name */
  CourseName = 'courseName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  ExpiryDate = 'expiryDate',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LegacyId = 'legacyId',
  /** column name */
  Number = 'number',
  /** column name */
  OriginalRecord = 'originalRecord',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "legacy_certificate" */
export type Legacy_Certificate_Set_Input = {
  certificationDate?: InputMaybe<Scalars['date']>;
  courseCertificateId?: InputMaybe<Scalars['uuid']>;
  courseCode?: InputMaybe<Scalars['String']>;
  courseName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  expiryDate?: InputMaybe<Scalars['date']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  originalRecord?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Legacy_Certificate_Stddev_Fields = {
  __typename?: 'legacy_certificate_stddev_fields';
  legacyId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Legacy_Certificate_Stddev_Pop_Fields = {
  __typename?: 'legacy_certificate_stddev_pop_fields';
  legacyId?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Legacy_Certificate_Stddev_Samp_Fields = {
  __typename?: 'legacy_certificate_stddev_samp_fields';
  legacyId?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "legacy_certificate" */
export type Legacy_Certificate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Legacy_Certificate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Legacy_Certificate_Stream_Cursor_Value_Input = {
  certificationDate?: InputMaybe<Scalars['date']>;
  courseCertificateId?: InputMaybe<Scalars['uuid']>;
  courseCode?: InputMaybe<Scalars['String']>;
  courseName?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  expiryDate?: InputMaybe<Scalars['date']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  legacyId?: InputMaybe<Scalars['Int']>;
  number?: InputMaybe<Scalars['String']>;
  originalRecord?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Legacy_Certificate_Sum_Fields = {
  __typename?: 'legacy_certificate_sum_fields';
  legacyId?: Maybe<Scalars['Int']>;
};

/** update columns of table "legacy_certificate" */
export enum Legacy_Certificate_Update_Column {
  /** column name */
  CertificationDate = 'certificationDate',
  /** column name */
  CourseCertificateId = 'courseCertificateId',
  /** column name */
  CourseCode = 'courseCode',
  /** column name */
  CourseName = 'courseName',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  ExpiryDate = 'expiryDate',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'lastName',
  /** column name */
  LegacyId = 'legacyId',
  /** column name */
  Number = 'number',
  /** column name */
  OriginalRecord = 'originalRecord',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Legacy_Certificate_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Legacy_Certificate_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Legacy_Certificate_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Legacy_Certificate_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Legacy_Certificate_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Legacy_Certificate_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Legacy_Certificate_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Legacy_Certificate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Legacy_Certificate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Legacy_Certificate_Var_Pop_Fields = {
  __typename?: 'legacy_certificate_var_pop_fields';
  legacyId?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Legacy_Certificate_Var_Samp_Fields = {
  __typename?: 'legacy_certificate_var_samp_fields';
  legacyId?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Legacy_Certificate_Variance_Fields = {
  __typename?: 'legacy_certificate_variance_fields';
  legacyId?: Maybe<Scalars['Float']>;
};

/** This table holds course materials order data such as bought resource packs bundles */
export type Materials_Order = {
  __typename?: 'materials_order';
  amount_of_materials_purchased?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['date']>;
  currency?: Maybe<Scalars['String']>;
  delivery_city?: Maybe<Scalars['String']>;
  delivery_country?: Maybe<Scalars['String']>;
  delivery_email?: Maybe<Scalars['String']>;
  delivery_first_name?: Maybe<Scalars['String']>;
  delivery_last_name?: Maybe<Scalars['String']>;
  delivery_line1?: Maybe<Scalars['String']>;
  delivery_line2?: Maybe<Scalars['String']>;
  delivery_postcode?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  invoice_email?: Maybe<Scalars['String']>;
  invoice_first_name?: Maybe<Scalars['String']>;
  invoice_last_name?: Maybe<Scalars['String']>;
  /** An object relationship */
  invoice_organization?: Maybe<Organization>;
  invoice_organization_id?: Maybe<Scalars['uuid']>;
  invoice_phone?: Maybe<Scalars['String']>;
  invoice_purchase_order?: Maybe<Scalars['String']>;
  materials_total_price?: Maybe<Scalars['float8']>;
  order_due?: Maybe<Scalars['float8']>;
  /** An object relationship */
  organization?: Maybe<Organization>;
  organization_id?: Maybe<Scalars['uuid']>;
  payment_method?: Maybe<Payment_Methods_Enum>;
  placed_by?: Maybe<Scalars['uuid']>;
  postage_and_packaging_total?: Maybe<Scalars['float8']>;
  precision_order_status?: Maybe<Precision_Order_Status_Enum>;
  precision_payload?: Maybe<Scalars['jsonb']>;
  precision_webhook_events?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  profile?: Maybe<Profile>;
  purchased: Scalars['jsonb'];
  reference: Scalars['String'];
  stripe_payment_id?: Maybe<Scalars['String']>;
  /** An object relationship */
  xero_invoice?: Maybe<Xero_Invoice>;
  xero_invoice_number?: Maybe<Scalars['String']>;
};


/** This table holds course materials order data such as bought resource packs bundles */
export type Materials_OrderPrecision_PayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table holds course materials order data such as bought resource packs bundles */
export type Materials_OrderPrecision_Webhook_EventsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** This table holds course materials order data such as bought resource packs bundles */
export type Materials_OrderPurchasedArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "materials_order" */
export type Materials_Order_Aggregate = {
  __typename?: 'materials_order_aggregate';
  aggregate?: Maybe<Materials_Order_Aggregate_Fields>;
  nodes: Array<Materials_Order>;
};

/** aggregate fields of "materials_order" */
export type Materials_Order_Aggregate_Fields = {
  __typename?: 'materials_order_aggregate_fields';
  avg?: Maybe<Materials_Order_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Materials_Order_Max_Fields>;
  min?: Maybe<Materials_Order_Min_Fields>;
  stddev?: Maybe<Materials_Order_Stddev_Fields>;
  stddev_pop?: Maybe<Materials_Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Materials_Order_Stddev_Samp_Fields>;
  sum?: Maybe<Materials_Order_Sum_Fields>;
  var_pop?: Maybe<Materials_Order_Var_Pop_Fields>;
  var_samp?: Maybe<Materials_Order_Var_Samp_Fields>;
  variance?: Maybe<Materials_Order_Variance_Fields>;
};


/** aggregate fields of "materials_order" */
export type Materials_Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Materials_Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Materials_Order_Append_Input = {
  precision_payload?: InputMaybe<Scalars['jsonb']>;
  precision_webhook_events?: InputMaybe<Scalars['jsonb']>;
  purchased?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Materials_Order_Avg_Fields = {
  __typename?: 'materials_order_avg_fields';
  amount_of_materials_purchased?: Maybe<Scalars['Float']>;
  materials_total_price?: Maybe<Scalars['Float']>;
  order_due?: Maybe<Scalars['Float']>;
  postage_and_packaging_total?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "materials_order". All fields are combined with a logical 'AND'. */
export type Materials_Order_Bool_Exp = {
  _and?: InputMaybe<Array<Materials_Order_Bool_Exp>>;
  _not?: InputMaybe<Materials_Order_Bool_Exp>;
  _or?: InputMaybe<Array<Materials_Order_Bool_Exp>>;
  amount_of_materials_purchased?: InputMaybe<Numeric_Comparison_Exp>;
  created_at?: InputMaybe<Date_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  delivery_city?: InputMaybe<String_Comparison_Exp>;
  delivery_country?: InputMaybe<String_Comparison_Exp>;
  delivery_email?: InputMaybe<String_Comparison_Exp>;
  delivery_first_name?: InputMaybe<String_Comparison_Exp>;
  delivery_last_name?: InputMaybe<String_Comparison_Exp>;
  delivery_line1?: InputMaybe<String_Comparison_Exp>;
  delivery_line2?: InputMaybe<String_Comparison_Exp>;
  delivery_postcode?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_email?: InputMaybe<String_Comparison_Exp>;
  invoice_first_name?: InputMaybe<String_Comparison_Exp>;
  invoice_last_name?: InputMaybe<String_Comparison_Exp>;
  invoice_organization?: InputMaybe<Organization_Bool_Exp>;
  invoice_organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  invoice_phone?: InputMaybe<String_Comparison_Exp>;
  invoice_purchase_order?: InputMaybe<String_Comparison_Exp>;
  materials_total_price?: InputMaybe<Float8_Comparison_Exp>;
  order_due?: InputMaybe<Float8_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  payment_method?: InputMaybe<Payment_Methods_Enum_Comparison_Exp>;
  placed_by?: InputMaybe<Uuid_Comparison_Exp>;
  postage_and_packaging_total?: InputMaybe<Float8_Comparison_Exp>;
  precision_order_status?: InputMaybe<Precision_Order_Status_Enum_Comparison_Exp>;
  precision_payload?: InputMaybe<Jsonb_Comparison_Exp>;
  precision_webhook_events?: InputMaybe<Jsonb_Comparison_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  purchased?: InputMaybe<Jsonb_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  stripe_payment_id?: InputMaybe<String_Comparison_Exp>;
  xero_invoice?: InputMaybe<Xero_Invoice_Bool_Exp>;
  xero_invoice_number?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "materials_order" */
export enum Materials_Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  MaterialsOrderPkey = 'materials_order_pkey',
  /** unique or primary key constraint on columns "reference" */
  MaterialsOrderReferenceKey = 'materials_order_reference_key',
  /** unique or primary key constraint on columns "xero_invoice_number" */
  MaterialsOrderXeroInvoiceNumberKey = 'materials_order_xero_invoice_number_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Materials_Order_Delete_At_Path_Input = {
  precision_payload?: InputMaybe<Array<Scalars['String']>>;
  precision_webhook_events?: InputMaybe<Array<Scalars['String']>>;
  purchased?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Materials_Order_Delete_Elem_Input = {
  precision_payload?: InputMaybe<Scalars['Int']>;
  precision_webhook_events?: InputMaybe<Scalars['Int']>;
  purchased?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Materials_Order_Delete_Key_Input = {
  precision_payload?: InputMaybe<Scalars['String']>;
  precision_webhook_events?: InputMaybe<Scalars['String']>;
  purchased?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "materials_order" */
export type Materials_Order_Inc_Input = {
  amount_of_materials_purchased?: InputMaybe<Scalars['numeric']>;
  materials_total_price?: InputMaybe<Scalars['float8']>;
  order_due?: InputMaybe<Scalars['float8']>;
  postage_and_packaging_total?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "materials_order" */
export type Materials_Order_Insert_Input = {
  amount_of_materials_purchased?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['date']>;
  currency?: InputMaybe<Scalars['String']>;
  delivery_city?: InputMaybe<Scalars['String']>;
  delivery_country?: InputMaybe<Scalars['String']>;
  delivery_email?: InputMaybe<Scalars['String']>;
  delivery_first_name?: InputMaybe<Scalars['String']>;
  delivery_last_name?: InputMaybe<Scalars['String']>;
  delivery_line1?: InputMaybe<Scalars['String']>;
  delivery_line2?: InputMaybe<Scalars['String']>;
  delivery_postcode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoice_email?: InputMaybe<Scalars['String']>;
  invoice_first_name?: InputMaybe<Scalars['String']>;
  invoice_last_name?: InputMaybe<Scalars['String']>;
  invoice_organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  invoice_organization_id?: InputMaybe<Scalars['uuid']>;
  invoice_phone?: InputMaybe<Scalars['String']>;
  invoice_purchase_order?: InputMaybe<Scalars['String']>;
  materials_total_price?: InputMaybe<Scalars['float8']>;
  order_due?: InputMaybe<Scalars['float8']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  payment_method?: InputMaybe<Payment_Methods_Enum>;
  placed_by?: InputMaybe<Scalars['uuid']>;
  postage_and_packaging_total?: InputMaybe<Scalars['float8']>;
  precision_order_status?: InputMaybe<Precision_Order_Status_Enum>;
  precision_payload?: InputMaybe<Scalars['jsonb']>;
  precision_webhook_events?: InputMaybe<Scalars['jsonb']>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  purchased?: InputMaybe<Scalars['jsonb']>;
  reference?: InputMaybe<Scalars['String']>;
  stripe_payment_id?: InputMaybe<Scalars['String']>;
  xero_invoice?: InputMaybe<Xero_Invoice_Obj_Rel_Insert_Input>;
  xero_invoice_number?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Materials_Order_Max_Fields = {
  __typename?: 'materials_order_max_fields';
  amount_of_materials_purchased?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['date']>;
  currency?: Maybe<Scalars['String']>;
  delivery_city?: Maybe<Scalars['String']>;
  delivery_country?: Maybe<Scalars['String']>;
  delivery_email?: Maybe<Scalars['String']>;
  delivery_first_name?: Maybe<Scalars['String']>;
  delivery_last_name?: Maybe<Scalars['String']>;
  delivery_line1?: Maybe<Scalars['String']>;
  delivery_line2?: Maybe<Scalars['String']>;
  delivery_postcode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_email?: Maybe<Scalars['String']>;
  invoice_first_name?: Maybe<Scalars['String']>;
  invoice_last_name?: Maybe<Scalars['String']>;
  invoice_organization_id?: Maybe<Scalars['uuid']>;
  invoice_phone?: Maybe<Scalars['String']>;
  invoice_purchase_order?: Maybe<Scalars['String']>;
  materials_total_price?: Maybe<Scalars['float8']>;
  order_due?: Maybe<Scalars['float8']>;
  organization_id?: Maybe<Scalars['uuid']>;
  placed_by?: Maybe<Scalars['uuid']>;
  postage_and_packaging_total?: Maybe<Scalars['float8']>;
  reference?: Maybe<Scalars['String']>;
  stripe_payment_id?: Maybe<Scalars['String']>;
  xero_invoice_number?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Materials_Order_Min_Fields = {
  __typename?: 'materials_order_min_fields';
  amount_of_materials_purchased?: Maybe<Scalars['numeric']>;
  created_at?: Maybe<Scalars['date']>;
  currency?: Maybe<Scalars['String']>;
  delivery_city?: Maybe<Scalars['String']>;
  delivery_country?: Maybe<Scalars['String']>;
  delivery_email?: Maybe<Scalars['String']>;
  delivery_first_name?: Maybe<Scalars['String']>;
  delivery_last_name?: Maybe<Scalars['String']>;
  delivery_line1?: Maybe<Scalars['String']>;
  delivery_line2?: Maybe<Scalars['String']>;
  delivery_postcode?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  invoice_email?: Maybe<Scalars['String']>;
  invoice_first_name?: Maybe<Scalars['String']>;
  invoice_last_name?: Maybe<Scalars['String']>;
  invoice_organization_id?: Maybe<Scalars['uuid']>;
  invoice_phone?: Maybe<Scalars['String']>;
  invoice_purchase_order?: Maybe<Scalars['String']>;
  materials_total_price?: Maybe<Scalars['float8']>;
  order_due?: Maybe<Scalars['float8']>;
  organization_id?: Maybe<Scalars['uuid']>;
  placed_by?: Maybe<Scalars['uuid']>;
  postage_and_packaging_total?: Maybe<Scalars['float8']>;
  reference?: Maybe<Scalars['String']>;
  stripe_payment_id?: Maybe<Scalars['String']>;
  xero_invoice_number?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "materials_order" */
export type Materials_Order_Mutation_Response = {
  __typename?: 'materials_order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Materials_Order>;
};

/** on_conflict condition type for table "materials_order" */
export type Materials_Order_On_Conflict = {
  constraint: Materials_Order_Constraint;
  update_columns?: Array<Materials_Order_Update_Column>;
  where?: InputMaybe<Materials_Order_Bool_Exp>;
};

/** Ordering options when selecting data from "materials_order". */
export type Materials_Order_Order_By = {
  amount_of_materials_purchased?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  delivery_city?: InputMaybe<Order_By>;
  delivery_country?: InputMaybe<Order_By>;
  delivery_email?: InputMaybe<Order_By>;
  delivery_first_name?: InputMaybe<Order_By>;
  delivery_last_name?: InputMaybe<Order_By>;
  delivery_line1?: InputMaybe<Order_By>;
  delivery_line2?: InputMaybe<Order_By>;
  delivery_postcode?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoice_email?: InputMaybe<Order_By>;
  invoice_first_name?: InputMaybe<Order_By>;
  invoice_last_name?: InputMaybe<Order_By>;
  invoice_organization?: InputMaybe<Organization_Order_By>;
  invoice_organization_id?: InputMaybe<Order_By>;
  invoice_phone?: InputMaybe<Order_By>;
  invoice_purchase_order?: InputMaybe<Order_By>;
  materials_total_price?: InputMaybe<Order_By>;
  order_due?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  payment_method?: InputMaybe<Order_By>;
  placed_by?: InputMaybe<Order_By>;
  postage_and_packaging_total?: InputMaybe<Order_By>;
  precision_order_status?: InputMaybe<Order_By>;
  precision_payload?: InputMaybe<Order_By>;
  precision_webhook_events?: InputMaybe<Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  purchased?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  stripe_payment_id?: InputMaybe<Order_By>;
  xero_invoice?: InputMaybe<Xero_Invoice_Order_By>;
  xero_invoice_number?: InputMaybe<Order_By>;
};

/** primary key columns input for table: materials_order */
export type Materials_Order_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Materials_Order_Prepend_Input = {
  precision_payload?: InputMaybe<Scalars['jsonb']>;
  precision_webhook_events?: InputMaybe<Scalars['jsonb']>;
  purchased?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "materials_order" */
export enum Materials_Order_Select_Column {
  /** column name */
  AmountOfMaterialsPurchased = 'amount_of_materials_purchased',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeliveryCity = 'delivery_city',
  /** column name */
  DeliveryCountry = 'delivery_country',
  /** column name */
  DeliveryEmail = 'delivery_email',
  /** column name */
  DeliveryFirstName = 'delivery_first_name',
  /** column name */
  DeliveryLastName = 'delivery_last_name',
  /** column name */
  DeliveryLine1 = 'delivery_line1',
  /** column name */
  DeliveryLine2 = 'delivery_line2',
  /** column name */
  DeliveryPostcode = 'delivery_postcode',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceEmail = 'invoice_email',
  /** column name */
  InvoiceFirstName = 'invoice_first_name',
  /** column name */
  InvoiceLastName = 'invoice_last_name',
  /** column name */
  InvoiceOrganizationId = 'invoice_organization_id',
  /** column name */
  InvoicePhone = 'invoice_phone',
  /** column name */
  InvoicePurchaseOrder = 'invoice_purchase_order',
  /** column name */
  MaterialsTotalPrice = 'materials_total_price',
  /** column name */
  OrderDue = 'order_due',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  PlacedBy = 'placed_by',
  /** column name */
  PostageAndPackagingTotal = 'postage_and_packaging_total',
  /** column name */
  PrecisionOrderStatus = 'precision_order_status',
  /** column name */
  PrecisionPayload = 'precision_payload',
  /** column name */
  PrecisionWebhookEvents = 'precision_webhook_events',
  /** column name */
  Purchased = 'purchased',
  /** column name */
  Reference = 'reference',
  /** column name */
  StripePaymentId = 'stripe_payment_id',
  /** column name */
  XeroInvoiceNumber = 'xero_invoice_number'
}

/** input type for updating data in table "materials_order" */
export type Materials_Order_Set_Input = {
  amount_of_materials_purchased?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['date']>;
  currency?: InputMaybe<Scalars['String']>;
  delivery_city?: InputMaybe<Scalars['String']>;
  delivery_country?: InputMaybe<Scalars['String']>;
  delivery_email?: InputMaybe<Scalars['String']>;
  delivery_first_name?: InputMaybe<Scalars['String']>;
  delivery_last_name?: InputMaybe<Scalars['String']>;
  delivery_line1?: InputMaybe<Scalars['String']>;
  delivery_line2?: InputMaybe<Scalars['String']>;
  delivery_postcode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoice_email?: InputMaybe<Scalars['String']>;
  invoice_first_name?: InputMaybe<Scalars['String']>;
  invoice_last_name?: InputMaybe<Scalars['String']>;
  invoice_organization_id?: InputMaybe<Scalars['uuid']>;
  invoice_phone?: InputMaybe<Scalars['String']>;
  invoice_purchase_order?: InputMaybe<Scalars['String']>;
  materials_total_price?: InputMaybe<Scalars['float8']>;
  order_due?: InputMaybe<Scalars['float8']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  payment_method?: InputMaybe<Payment_Methods_Enum>;
  placed_by?: InputMaybe<Scalars['uuid']>;
  postage_and_packaging_total?: InputMaybe<Scalars['float8']>;
  precision_order_status?: InputMaybe<Precision_Order_Status_Enum>;
  precision_payload?: InputMaybe<Scalars['jsonb']>;
  precision_webhook_events?: InputMaybe<Scalars['jsonb']>;
  purchased?: InputMaybe<Scalars['jsonb']>;
  reference?: InputMaybe<Scalars['String']>;
  stripe_payment_id?: InputMaybe<Scalars['String']>;
  xero_invoice_number?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Materials_Order_Stddev_Fields = {
  __typename?: 'materials_order_stddev_fields';
  amount_of_materials_purchased?: Maybe<Scalars['Float']>;
  materials_total_price?: Maybe<Scalars['Float']>;
  order_due?: Maybe<Scalars['Float']>;
  postage_and_packaging_total?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Materials_Order_Stddev_Pop_Fields = {
  __typename?: 'materials_order_stddev_pop_fields';
  amount_of_materials_purchased?: Maybe<Scalars['Float']>;
  materials_total_price?: Maybe<Scalars['Float']>;
  order_due?: Maybe<Scalars['Float']>;
  postage_and_packaging_total?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Materials_Order_Stddev_Samp_Fields = {
  __typename?: 'materials_order_stddev_samp_fields';
  amount_of_materials_purchased?: Maybe<Scalars['Float']>;
  materials_total_price?: Maybe<Scalars['Float']>;
  order_due?: Maybe<Scalars['Float']>;
  postage_and_packaging_total?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "materials_order" */
export type Materials_Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Materials_Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Materials_Order_Stream_Cursor_Value_Input = {
  amount_of_materials_purchased?: InputMaybe<Scalars['numeric']>;
  created_at?: InputMaybe<Scalars['date']>;
  currency?: InputMaybe<Scalars['String']>;
  delivery_city?: InputMaybe<Scalars['String']>;
  delivery_country?: InputMaybe<Scalars['String']>;
  delivery_email?: InputMaybe<Scalars['String']>;
  delivery_first_name?: InputMaybe<Scalars['String']>;
  delivery_last_name?: InputMaybe<Scalars['String']>;
  delivery_line1?: InputMaybe<Scalars['String']>;
  delivery_line2?: InputMaybe<Scalars['String']>;
  delivery_postcode?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoice_email?: InputMaybe<Scalars['String']>;
  invoice_first_name?: InputMaybe<Scalars['String']>;
  invoice_last_name?: InputMaybe<Scalars['String']>;
  invoice_organization_id?: InputMaybe<Scalars['uuid']>;
  invoice_phone?: InputMaybe<Scalars['String']>;
  invoice_purchase_order?: InputMaybe<Scalars['String']>;
  materials_total_price?: InputMaybe<Scalars['float8']>;
  order_due?: InputMaybe<Scalars['float8']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  payment_method?: InputMaybe<Payment_Methods_Enum>;
  placed_by?: InputMaybe<Scalars['uuid']>;
  postage_and_packaging_total?: InputMaybe<Scalars['float8']>;
  precision_order_status?: InputMaybe<Precision_Order_Status_Enum>;
  precision_payload?: InputMaybe<Scalars['jsonb']>;
  precision_webhook_events?: InputMaybe<Scalars['jsonb']>;
  purchased?: InputMaybe<Scalars['jsonb']>;
  reference?: InputMaybe<Scalars['String']>;
  stripe_payment_id?: InputMaybe<Scalars['String']>;
  xero_invoice_number?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Materials_Order_Sum_Fields = {
  __typename?: 'materials_order_sum_fields';
  amount_of_materials_purchased?: Maybe<Scalars['numeric']>;
  materials_total_price?: Maybe<Scalars['float8']>;
  order_due?: Maybe<Scalars['float8']>;
  postage_and_packaging_total?: Maybe<Scalars['float8']>;
};

/** update columns of table "materials_order" */
export enum Materials_Order_Update_Column {
  /** column name */
  AmountOfMaterialsPurchased = 'amount_of_materials_purchased',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Currency = 'currency',
  /** column name */
  DeliveryCity = 'delivery_city',
  /** column name */
  DeliveryCountry = 'delivery_country',
  /** column name */
  DeliveryEmail = 'delivery_email',
  /** column name */
  DeliveryFirstName = 'delivery_first_name',
  /** column name */
  DeliveryLastName = 'delivery_last_name',
  /** column name */
  DeliveryLine1 = 'delivery_line1',
  /** column name */
  DeliveryLine2 = 'delivery_line2',
  /** column name */
  DeliveryPostcode = 'delivery_postcode',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceEmail = 'invoice_email',
  /** column name */
  InvoiceFirstName = 'invoice_first_name',
  /** column name */
  InvoiceLastName = 'invoice_last_name',
  /** column name */
  InvoiceOrganizationId = 'invoice_organization_id',
  /** column name */
  InvoicePhone = 'invoice_phone',
  /** column name */
  InvoicePurchaseOrder = 'invoice_purchase_order',
  /** column name */
  MaterialsTotalPrice = 'materials_total_price',
  /** column name */
  OrderDue = 'order_due',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  PaymentMethod = 'payment_method',
  /** column name */
  PlacedBy = 'placed_by',
  /** column name */
  PostageAndPackagingTotal = 'postage_and_packaging_total',
  /** column name */
  PrecisionOrderStatus = 'precision_order_status',
  /** column name */
  PrecisionPayload = 'precision_payload',
  /** column name */
  PrecisionWebhookEvents = 'precision_webhook_events',
  /** column name */
  Purchased = 'purchased',
  /** column name */
  Reference = 'reference',
  /** column name */
  StripePaymentId = 'stripe_payment_id',
  /** column name */
  XeroInvoiceNumber = 'xero_invoice_number'
}

export type Materials_Order_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Materials_Order_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Materials_Order_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Materials_Order_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Materials_Order_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Materials_Order_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Materials_Order_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Materials_Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Materials_Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Materials_Order_Var_Pop_Fields = {
  __typename?: 'materials_order_var_pop_fields';
  amount_of_materials_purchased?: Maybe<Scalars['Float']>;
  materials_total_price?: Maybe<Scalars['Float']>;
  order_due?: Maybe<Scalars['Float']>;
  postage_and_packaging_total?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Materials_Order_Var_Samp_Fields = {
  __typename?: 'materials_order_var_samp_fields';
  amount_of_materials_purchased?: Maybe<Scalars['Float']>;
  materials_total_price?: Maybe<Scalars['Float']>;
  order_due?: Maybe<Scalars['Float']>;
  postage_and_packaging_total?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Materials_Order_Variance_Fields = {
  __typename?: 'materials_order_variance_fields';
  amount_of_materials_purchased?: Maybe<Scalars['Float']>;
  materials_total_price?: Maybe<Scalars['Float']>;
  order_due?: Maybe<Scalars['Float']>;
  postage_and_packaging_total?: Maybe<Scalars['Float']>;
};

/** This table records data related to organization merge actions. */
export type Merge_Organizations_Logs = {
  __typename?: 'merge_organizations_logs';
  /** An object relationship */
  actionedBy: Profile;
  actionedById: Scalars['uuid'];
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An array relationship */
  mergedOrganizations: Array<Merged_Organizations>;
  /** An aggregate relationship */
  mergedOrganizations_aggregate: Merged_Organizations_Aggregate;
  primaryOrganizationId: Scalars['uuid'];
  primaryOrganizationName: Scalars['String'];
  primaryOrganizationUrn?: Maybe<Scalars['String']>;
  updated_at: Scalars['timestamptz'];
};


/** This table records data related to organization merge actions. */
export type Merge_Organizations_LogsMergedOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Merged_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Merged_Organizations_Order_By>>;
  where?: InputMaybe<Merged_Organizations_Bool_Exp>;
};


/** This table records data related to organization merge actions. */
export type Merge_Organizations_LogsMergedOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Merged_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Merged_Organizations_Order_By>>;
  where?: InputMaybe<Merged_Organizations_Bool_Exp>;
};

/** aggregated selection of "merge_organizations_logs" */
export type Merge_Organizations_Logs_Aggregate = {
  __typename?: 'merge_organizations_logs_aggregate';
  aggregate?: Maybe<Merge_Organizations_Logs_Aggregate_Fields>;
  nodes: Array<Merge_Organizations_Logs>;
};

/** aggregate fields of "merge_organizations_logs" */
export type Merge_Organizations_Logs_Aggregate_Fields = {
  __typename?: 'merge_organizations_logs_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Merge_Organizations_Logs_Max_Fields>;
  min?: Maybe<Merge_Organizations_Logs_Min_Fields>;
};


/** aggregate fields of "merge_organizations_logs" */
export type Merge_Organizations_Logs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Merge_Organizations_Logs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "merge_organizations_logs". All fields are combined with a logical 'AND'. */
export type Merge_Organizations_Logs_Bool_Exp = {
  _and?: InputMaybe<Array<Merge_Organizations_Logs_Bool_Exp>>;
  _not?: InputMaybe<Merge_Organizations_Logs_Bool_Exp>;
  _or?: InputMaybe<Array<Merge_Organizations_Logs_Bool_Exp>>;
  actionedBy?: InputMaybe<Profile_Bool_Exp>;
  actionedById?: InputMaybe<Uuid_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mergedOrganizations?: InputMaybe<Merged_Organizations_Bool_Exp>;
  mergedOrganizations_aggregate?: InputMaybe<Merged_Organizations_Aggregate_Bool_Exp>;
  primaryOrganizationId?: InputMaybe<Uuid_Comparison_Exp>;
  primaryOrganizationName?: InputMaybe<String_Comparison_Exp>;
  primaryOrganizationUrn?: InputMaybe<String_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "merge_organizations_logs" */
export enum Merge_Organizations_Logs_Constraint {
  /** unique or primary key constraint on columns "id" */
  MergeOrganizationsLogsPkey = 'merge_organizations_logs_pkey'
}

/** input type for inserting data into table "merge_organizations_logs" */
export type Merge_Organizations_Logs_Insert_Input = {
  actionedBy?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  actionedById?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  mergedOrganizations?: InputMaybe<Merged_Organizations_Arr_Rel_Insert_Input>;
  primaryOrganizationId?: InputMaybe<Scalars['uuid']>;
  primaryOrganizationName?: InputMaybe<Scalars['String']>;
  primaryOrganizationUrn?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Merge_Organizations_Logs_Max_Fields = {
  __typename?: 'merge_organizations_logs_max_fields';
  actionedById?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  primaryOrganizationId?: Maybe<Scalars['uuid']>;
  primaryOrganizationName?: Maybe<Scalars['String']>;
  primaryOrganizationUrn?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Merge_Organizations_Logs_Min_Fields = {
  __typename?: 'merge_organizations_logs_min_fields';
  actionedById?: Maybe<Scalars['uuid']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  primaryOrganizationId?: Maybe<Scalars['uuid']>;
  primaryOrganizationName?: Maybe<Scalars['String']>;
  primaryOrganizationUrn?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "merge_organizations_logs" */
export type Merge_Organizations_Logs_Mutation_Response = {
  __typename?: 'merge_organizations_logs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Merge_Organizations_Logs>;
};

/** input type for inserting object relation for remote table "merge_organizations_logs" */
export type Merge_Organizations_Logs_Obj_Rel_Insert_Input = {
  data: Merge_Organizations_Logs_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Merge_Organizations_Logs_On_Conflict>;
};

/** on_conflict condition type for table "merge_organizations_logs" */
export type Merge_Organizations_Logs_On_Conflict = {
  constraint: Merge_Organizations_Logs_Constraint;
  update_columns?: Array<Merge_Organizations_Logs_Update_Column>;
  where?: InputMaybe<Merge_Organizations_Logs_Bool_Exp>;
};

/** Ordering options when selecting data from "merge_organizations_logs". */
export type Merge_Organizations_Logs_Order_By = {
  actionedBy?: InputMaybe<Profile_Order_By>;
  actionedById?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mergedOrganizations_aggregate?: InputMaybe<Merged_Organizations_Aggregate_Order_By>;
  primaryOrganizationId?: InputMaybe<Order_By>;
  primaryOrganizationName?: InputMaybe<Order_By>;
  primaryOrganizationUrn?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: merge_organizations_logs */
export type Merge_Organizations_Logs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "merge_organizations_logs" */
export enum Merge_Organizations_Logs_Select_Column {
  /** column name */
  ActionedById = 'actionedById',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PrimaryOrganizationId = 'primaryOrganizationId',
  /** column name */
  PrimaryOrganizationName = 'primaryOrganizationName',
  /** column name */
  PrimaryOrganizationUrn = 'primaryOrganizationUrn',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "merge_organizations_logs" */
export type Merge_Organizations_Logs_Set_Input = {
  actionedById?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  primaryOrganizationId?: InputMaybe<Scalars['uuid']>;
  primaryOrganizationName?: InputMaybe<Scalars['String']>;
  primaryOrganizationUrn?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "merge_organizations_logs" */
export type Merge_Organizations_Logs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Merge_Organizations_Logs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Merge_Organizations_Logs_Stream_Cursor_Value_Input = {
  actionedById?: InputMaybe<Scalars['uuid']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  primaryOrganizationId?: InputMaybe<Scalars['uuid']>;
  primaryOrganizationName?: InputMaybe<Scalars['String']>;
  primaryOrganizationUrn?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "merge_organizations_logs" */
export enum Merge_Organizations_Logs_Update_Column {
  /** column name */
  ActionedById = 'actionedById',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  PrimaryOrganizationId = 'primaryOrganizationId',
  /** column name */
  PrimaryOrganizationName = 'primaryOrganizationName',
  /** column name */
  PrimaryOrganizationUrn = 'primaryOrganizationUrn',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Merge_Organizations_Logs_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Merge_Organizations_Logs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Merge_Organizations_Logs_Bool_Exp;
};

/** This table contains records of all organizations that have been merged, each associated with a specific merge event. */
export type Merged_Organizations = {
  __typename?: 'merged_organizations';
  dfeUrn?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  /** An object relationship */
  mergeOrganizationsLog: Merge_Organizations_Logs;
  merge_organizations_log_id: Scalars['uuid'];
  organizationData: Scalars['jsonb'];
  organizationId: Scalars['uuid'];
  organizationName: Scalars['String'];
};


/** This table contains records of all organizations that have been merged, each associated with a specific merge event. */
export type Merged_OrganizationsOrganizationDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "merged_organizations" */
export type Merged_Organizations_Aggregate = {
  __typename?: 'merged_organizations_aggregate';
  aggregate?: Maybe<Merged_Organizations_Aggregate_Fields>;
  nodes: Array<Merged_Organizations>;
};

export type Merged_Organizations_Aggregate_Bool_Exp = {
  count?: InputMaybe<Merged_Organizations_Aggregate_Bool_Exp_Count>;
};

export type Merged_Organizations_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Merged_Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Merged_Organizations_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "merged_organizations" */
export type Merged_Organizations_Aggregate_Fields = {
  __typename?: 'merged_organizations_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Merged_Organizations_Max_Fields>;
  min?: Maybe<Merged_Organizations_Min_Fields>;
};


/** aggregate fields of "merged_organizations" */
export type Merged_Organizations_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Merged_Organizations_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "merged_organizations" */
export type Merged_Organizations_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Merged_Organizations_Max_Order_By>;
  min?: InputMaybe<Merged_Organizations_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Merged_Organizations_Append_Input = {
  organizationData?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "merged_organizations" */
export type Merged_Organizations_Arr_Rel_Insert_Input = {
  data: Array<Merged_Organizations_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Merged_Organizations_On_Conflict>;
};

/** Boolean expression to filter rows from the table "merged_organizations". All fields are combined with a logical 'AND'. */
export type Merged_Organizations_Bool_Exp = {
  _and?: InputMaybe<Array<Merged_Organizations_Bool_Exp>>;
  _not?: InputMaybe<Merged_Organizations_Bool_Exp>;
  _or?: InputMaybe<Array<Merged_Organizations_Bool_Exp>>;
  dfeUrn?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mergeOrganizationsLog?: InputMaybe<Merge_Organizations_Logs_Bool_Exp>;
  merge_organizations_log_id?: InputMaybe<Uuid_Comparison_Exp>;
  organizationData?: InputMaybe<Jsonb_Comparison_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  organizationName?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "merged_organizations" */
export enum Merged_Organizations_Constraint {
  /** unique or primary key constraint on columns "organization_id" */
  MergedOrganizationsOrganizationIdKey = 'merged_organizations_organization_id_key',
  /** unique or primary key constraint on columns "id" */
  MergedOrganizationsPkey = 'merged_organizations_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Merged_Organizations_Delete_At_Path_Input = {
  organizationData?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Merged_Organizations_Delete_Elem_Input = {
  organizationData?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Merged_Organizations_Delete_Key_Input = {
  organizationData?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "merged_organizations" */
export type Merged_Organizations_Insert_Input = {
  dfeUrn?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  mergeOrganizationsLog?: InputMaybe<Merge_Organizations_Logs_Obj_Rel_Insert_Input>;
  merge_organizations_log_id?: InputMaybe<Scalars['uuid']>;
  organizationData?: InputMaybe<Scalars['jsonb']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  organizationName?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Merged_Organizations_Max_Fields = {
  __typename?: 'merged_organizations_max_fields';
  dfeUrn?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  merge_organizations_log_id?: Maybe<Scalars['uuid']>;
  organizationId?: Maybe<Scalars['uuid']>;
  organizationName?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "merged_organizations" */
export type Merged_Organizations_Max_Order_By = {
  dfeUrn?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  merge_organizations_log_id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  organizationName?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Merged_Organizations_Min_Fields = {
  __typename?: 'merged_organizations_min_fields';
  dfeUrn?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  merge_organizations_log_id?: Maybe<Scalars['uuid']>;
  organizationId?: Maybe<Scalars['uuid']>;
  organizationName?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "merged_organizations" */
export type Merged_Organizations_Min_Order_By = {
  dfeUrn?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  merge_organizations_log_id?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  organizationName?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "merged_organizations" */
export type Merged_Organizations_Mutation_Response = {
  __typename?: 'merged_organizations_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Merged_Organizations>;
};

/** on_conflict condition type for table "merged_organizations" */
export type Merged_Organizations_On_Conflict = {
  constraint: Merged_Organizations_Constraint;
  update_columns?: Array<Merged_Organizations_Update_Column>;
  where?: InputMaybe<Merged_Organizations_Bool_Exp>;
};

/** Ordering options when selecting data from "merged_organizations". */
export type Merged_Organizations_Order_By = {
  dfeUrn?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mergeOrganizationsLog?: InputMaybe<Merge_Organizations_Logs_Order_By>;
  merge_organizations_log_id?: InputMaybe<Order_By>;
  organizationData?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  organizationName?: InputMaybe<Order_By>;
};

/** primary key columns input for table: merged_organizations */
export type Merged_Organizations_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Merged_Organizations_Prepend_Input = {
  organizationData?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "merged_organizations" */
export enum Merged_Organizations_Select_Column {
  /** column name */
  DfeUrn = 'dfeUrn',
  /** column name */
  Id = 'id',
  /** column name */
  MergeOrganizationsLogId = 'merge_organizations_log_id',
  /** column name */
  OrganizationData = 'organizationData',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  OrganizationName = 'organizationName'
}

/** input type for updating data in table "merged_organizations" */
export type Merged_Organizations_Set_Input = {
  dfeUrn?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  merge_organizations_log_id?: InputMaybe<Scalars['uuid']>;
  organizationData?: InputMaybe<Scalars['jsonb']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  organizationName?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "merged_organizations" */
export type Merged_Organizations_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Merged_Organizations_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Merged_Organizations_Stream_Cursor_Value_Input = {
  dfeUrn?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  merge_organizations_log_id?: InputMaybe<Scalars['uuid']>;
  organizationData?: InputMaybe<Scalars['jsonb']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  organizationName?: InputMaybe<Scalars['String']>;
};

/** update columns of table "merged_organizations" */
export enum Merged_Organizations_Update_Column {
  /** column name */
  DfeUrn = 'dfeUrn',
  /** column name */
  Id = 'id',
  /** column name */
  MergeOrganizationsLogId = 'merge_organizations_log_id',
  /** column name */
  OrganizationData = 'organizationData',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  OrganizationName = 'organizationName'
}

export type Merged_Organizations_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Merged_Organizations_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Merged_Organizations_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Merged_Organizations_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Merged_Organizations_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Merged_Organizations_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Merged_Organizations_Set_Input>;
  /** filter the rows which have to be updated */
  where: Merged_Organizations_Bool_Exp;
};

/** columns and relationships of "module" */
export type Module = {
  __typename?: 'module';
  createdAt: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['uuid']>;
  id: Scalars['uuid'];
  level: Course_Level_Enum;
  /** An object relationship */
  moduleGroup?: Maybe<Module_Group>;
  name: Scalars['String'];
  /** An array relationship */
  submodules: Array<Submodule>;
  /** An aggregate relationship */
  submodules_aggregate: Submodule_Aggregate;
  type: Module_Category_Enum;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "module" */
export type ModuleSubmodulesArgs = {
  distinct_on?: InputMaybe<Array<Submodule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submodule_Order_By>>;
  where?: InputMaybe<Submodule_Bool_Exp>;
};


/** columns and relationships of "module" */
export type ModuleSubmodules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Submodule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submodule_Order_By>>;
  where?: InputMaybe<Submodule_Bool_Exp>;
};

/** aggregated selection of "module" */
export type Module_Aggregate = {
  __typename?: 'module_aggregate';
  aggregate?: Maybe<Module_Aggregate_Fields>;
  nodes: Array<Module>;
};

export type Module_Aggregate_Bool_Exp = {
  count?: InputMaybe<Module_Aggregate_Bool_Exp_Count>;
};

export type Module_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Module_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Module_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "module" */
export type Module_Aggregate_Fields = {
  __typename?: 'module_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Module_Max_Fields>;
  min?: Maybe<Module_Min_Fields>;
};


/** aggregate fields of "module" */
export type Module_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Module_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "module" */
export type Module_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Module_Max_Order_By>;
  min?: InputMaybe<Module_Min_Order_By>;
};

/** input type for inserting array relation for remote table "module" */
export type Module_Arr_Rel_Insert_Input = {
  data: Array<Module_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Module_On_Conflict>;
};

/** Boolean expression to filter rows from the table "module". All fields are combined with a logical 'AND'. */
export type Module_Bool_Exp = {
  _and?: InputMaybe<Array<Module_Bool_Exp>>;
  _not?: InputMaybe<Module_Bool_Exp>;
  _or?: InputMaybe<Array<Module_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  group?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  level?: InputMaybe<Course_Level_Enum_Comparison_Exp>;
  moduleGroup?: InputMaybe<Module_Group_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  submodules?: InputMaybe<Submodule_Bool_Exp>;
  submodules_aggregate?: InputMaybe<Submodule_Aggregate_Bool_Exp>;
  type?: InputMaybe<Module_Category_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** columns and relationships of "module_category" */
export type Module_Category = {
  __typename?: 'module_category';
  name: Scalars['String'];
};

/** aggregated selection of "module_category" */
export type Module_Category_Aggregate = {
  __typename?: 'module_category_aggregate';
  aggregate?: Maybe<Module_Category_Aggregate_Fields>;
  nodes: Array<Module_Category>;
};

/** aggregate fields of "module_category" */
export type Module_Category_Aggregate_Fields = {
  __typename?: 'module_category_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Module_Category_Max_Fields>;
  min?: Maybe<Module_Category_Min_Fields>;
};


/** aggregate fields of "module_category" */
export type Module_Category_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Module_Category_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "module_category". All fields are combined with a logical 'AND'. */
export type Module_Category_Bool_Exp = {
  _and?: InputMaybe<Array<Module_Category_Bool_Exp>>;
  _not?: InputMaybe<Module_Category_Bool_Exp>;
  _or?: InputMaybe<Array<Module_Category_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "module_category" */
export enum Module_Category_Constraint {
  /** unique or primary key constraint on columns "name" */
  ModuleCategoryPkey = 'module_category_pkey'
}

export enum Module_Category_Enum {
  Physical = 'PHYSICAL',
  Theory = 'THEORY'
}

/** Boolean expression to compare columns of type "module_category_enum". All fields are combined with logical 'AND'. */
export type Module_Category_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Module_Category_Enum>;
  _in?: InputMaybe<Array<Module_Category_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Module_Category_Enum>;
  _nin?: InputMaybe<Array<Module_Category_Enum>>;
};

/** input type for inserting data into table "module_category" */
export type Module_Category_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Module_Category_Max_Fields = {
  __typename?: 'module_category_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Module_Category_Min_Fields = {
  __typename?: 'module_category_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "module_category" */
export type Module_Category_Mutation_Response = {
  __typename?: 'module_category_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Module_Category>;
};

/** on_conflict condition type for table "module_category" */
export type Module_Category_On_Conflict = {
  constraint: Module_Category_Constraint;
  update_columns?: Array<Module_Category_Update_Column>;
  where?: InputMaybe<Module_Category_Bool_Exp>;
};

/** Ordering options when selecting data from "module_category". */
export type Module_Category_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: module_category */
export type Module_Category_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "module_category" */
export enum Module_Category_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "module_category" */
export type Module_Category_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "module_category" */
export type Module_Category_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Module_Category_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Module_Category_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "module_category" */
export enum Module_Category_Update_Column {
  /** column name */
  Name = 'name'
}

export type Module_Category_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Module_Category_Set_Input>;
  /** filter the rows which have to be updated */
  where: Module_Category_Bool_Exp;
};

/** unique or primary key constraints on table "module" */
export enum Module_Constraint {
  /** unique or primary key constraint on columns "id" */
  ModulePkey = 'module_pkey'
}

/** columns and relationships of "module_group" */
export type Module_Group = {
  __typename?: 'module_group';
  color: Color_Enum;
  createdAt: Scalars['timestamptz'];
  /** An array relationship */
  durations: Array<Module_Group_Duration>;
  /** An aggregate relationship */
  durations_aggregate: Module_Group_Duration_Aggregate;
  id: Scalars['uuid'];
  level: Course_Level_Enum;
  mandatory: Scalars['Boolean'];
  /** An array relationship */
  modules: Array<Module>;
  /** An aggregate relationship */
  modules_aggregate: Module_Aggregate;
  name: Scalars['String'];
  requires?: Maybe<Scalars['jsonb']>;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "module_group" */
export type Module_GroupDurationsArgs = {
  distinct_on?: InputMaybe<Array<Module_Group_Duration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Group_Duration_Order_By>>;
  where?: InputMaybe<Module_Group_Duration_Bool_Exp>;
};


/** columns and relationships of "module_group" */
export type Module_GroupDurations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Group_Duration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Group_Duration_Order_By>>;
  where?: InputMaybe<Module_Group_Duration_Bool_Exp>;
};


/** columns and relationships of "module_group" */
export type Module_GroupModulesArgs = {
  distinct_on?: InputMaybe<Array<Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Order_By>>;
  where?: InputMaybe<Module_Bool_Exp>;
};


/** columns and relationships of "module_group" */
export type Module_GroupModules_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Order_By>>;
  where?: InputMaybe<Module_Bool_Exp>;
};


/** columns and relationships of "module_group" */
export type Module_GroupRequiresArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "module_group" */
export type Module_Group_Aggregate = {
  __typename?: 'module_group_aggregate';
  aggregate?: Maybe<Module_Group_Aggregate_Fields>;
  nodes: Array<Module_Group>;
};

/** aggregate fields of "module_group" */
export type Module_Group_Aggregate_Fields = {
  __typename?: 'module_group_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Module_Group_Max_Fields>;
  min?: Maybe<Module_Group_Min_Fields>;
};


/** aggregate fields of "module_group" */
export type Module_Group_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Module_Group_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Module_Group_Append_Input = {
  requires?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "module_group". All fields are combined with a logical 'AND'. */
export type Module_Group_Bool_Exp = {
  _and?: InputMaybe<Array<Module_Group_Bool_Exp>>;
  _not?: InputMaybe<Module_Group_Bool_Exp>;
  _or?: InputMaybe<Array<Module_Group_Bool_Exp>>;
  color?: InputMaybe<Color_Enum_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  durations?: InputMaybe<Module_Group_Duration_Bool_Exp>;
  durations_aggregate?: InputMaybe<Module_Group_Duration_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  level?: InputMaybe<Course_Level_Enum_Comparison_Exp>;
  mandatory?: InputMaybe<Boolean_Comparison_Exp>;
  modules?: InputMaybe<Module_Bool_Exp>;
  modules_aggregate?: InputMaybe<Module_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  requires?: InputMaybe<Jsonb_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "module_group" */
export enum Module_Group_Constraint {
  /** unique or primary key constraint on columns "id" */
  ModuleGroupPkey = 'module_group_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Module_Group_Delete_At_Path_Input = {
  requires?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Module_Group_Delete_Elem_Input = {
  requires?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Module_Group_Delete_Key_Input = {
  requires?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "module_group_duration" */
export type Module_Group_Duration = {
  __typename?: 'module_group_duration';
  courseDeliveryType: Course_Delivery_Type_Enum;
  createdAt: Scalars['timestamptz'];
  duration: Scalars['Int'];
  go1Integration: Scalars['Boolean'];
  id: Scalars['uuid'];
  /** An object relationship */
  moduleGroup: Module_Group;
  module_group_id: Scalars['uuid'];
  reaccreditation: Scalars['Boolean'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "module_group_duration" */
export type Module_Group_Duration_Aggregate = {
  __typename?: 'module_group_duration_aggregate';
  aggregate?: Maybe<Module_Group_Duration_Aggregate_Fields>;
  nodes: Array<Module_Group_Duration>;
};

export type Module_Group_Duration_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Module_Group_Duration_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Module_Group_Duration_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Module_Group_Duration_Aggregate_Bool_Exp_Count>;
};

export type Module_Group_Duration_Aggregate_Bool_Exp_Bool_And = {
  arguments: Module_Group_Duration_Select_Column_Module_Group_Duration_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Module_Group_Duration_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Module_Group_Duration_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Module_Group_Duration_Select_Column_Module_Group_Duration_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Module_Group_Duration_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Module_Group_Duration_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Module_Group_Duration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Module_Group_Duration_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "module_group_duration" */
export type Module_Group_Duration_Aggregate_Fields = {
  __typename?: 'module_group_duration_aggregate_fields';
  avg?: Maybe<Module_Group_Duration_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Module_Group_Duration_Max_Fields>;
  min?: Maybe<Module_Group_Duration_Min_Fields>;
  stddev?: Maybe<Module_Group_Duration_Stddev_Fields>;
  stddev_pop?: Maybe<Module_Group_Duration_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Module_Group_Duration_Stddev_Samp_Fields>;
  sum?: Maybe<Module_Group_Duration_Sum_Fields>;
  var_pop?: Maybe<Module_Group_Duration_Var_Pop_Fields>;
  var_samp?: Maybe<Module_Group_Duration_Var_Samp_Fields>;
  variance?: Maybe<Module_Group_Duration_Variance_Fields>;
};


/** aggregate fields of "module_group_duration" */
export type Module_Group_Duration_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Module_Group_Duration_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "module_group_duration" */
export type Module_Group_Duration_Aggregate_Order_By = {
  avg?: InputMaybe<Module_Group_Duration_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Module_Group_Duration_Max_Order_By>;
  min?: InputMaybe<Module_Group_Duration_Min_Order_By>;
  stddev?: InputMaybe<Module_Group_Duration_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Module_Group_Duration_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Module_Group_Duration_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Module_Group_Duration_Sum_Order_By>;
  var_pop?: InputMaybe<Module_Group_Duration_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Module_Group_Duration_Var_Samp_Order_By>;
  variance?: InputMaybe<Module_Group_Duration_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "module_group_duration" */
export type Module_Group_Duration_Arr_Rel_Insert_Input = {
  data: Array<Module_Group_Duration_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Module_Group_Duration_On_Conflict>;
};

/** aggregate avg on columns */
export type Module_Group_Duration_Avg_Fields = {
  __typename?: 'module_group_duration_avg_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "module_group_duration" */
export type Module_Group_Duration_Avg_Order_By = {
  duration?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "module_group_duration". All fields are combined with a logical 'AND'. */
export type Module_Group_Duration_Bool_Exp = {
  _and?: InputMaybe<Array<Module_Group_Duration_Bool_Exp>>;
  _not?: InputMaybe<Module_Group_Duration_Bool_Exp>;
  _or?: InputMaybe<Array<Module_Group_Duration_Bool_Exp>>;
  courseDeliveryType?: InputMaybe<Course_Delivery_Type_Enum_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  go1Integration?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  moduleGroup?: InputMaybe<Module_Group_Bool_Exp>;
  module_group_id?: InputMaybe<Uuid_Comparison_Exp>;
  reaccreditation?: InputMaybe<Boolean_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "module_group_duration" */
export enum Module_Group_Duration_Constraint {
  /** unique or primary key constraint on columns "id" */
  ModuleGroupDurationPkey = 'module_group_duration_pkey'
}

/** input type for incrementing numeric columns in table "module_group_duration" */
export type Module_Group_Duration_Inc_Input = {
  duration?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "module_group_duration" */
export type Module_Group_Duration_Insert_Input = {
  courseDeliveryType?: InputMaybe<Course_Delivery_Type_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['Int']>;
  go1Integration?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  moduleGroup?: InputMaybe<Module_Group_Obj_Rel_Insert_Input>;
  module_group_id?: InputMaybe<Scalars['uuid']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Module_Group_Duration_Max_Fields = {
  __typename?: 'module_group_duration_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  module_group_id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "module_group_duration" */
export type Module_Group_Duration_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module_group_id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Module_Group_Duration_Min_Fields = {
  __typename?: 'module_group_duration_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  module_group_id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "module_group_duration" */
export type Module_Group_Duration_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module_group_id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "module_group_duration" */
export type Module_Group_Duration_Mutation_Response = {
  __typename?: 'module_group_duration_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Module_Group_Duration>;
};

/** on_conflict condition type for table "module_group_duration" */
export type Module_Group_Duration_On_Conflict = {
  constraint: Module_Group_Duration_Constraint;
  update_columns?: Array<Module_Group_Duration_Update_Column>;
  where?: InputMaybe<Module_Group_Duration_Bool_Exp>;
};

/** Ordering options when selecting data from "module_group_duration". */
export type Module_Group_Duration_Order_By = {
  courseDeliveryType?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  duration?: InputMaybe<Order_By>;
  go1Integration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moduleGroup?: InputMaybe<Module_Group_Order_By>;
  module_group_id?: InputMaybe<Order_By>;
  reaccreditation?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: module_group_duration */
export type Module_Group_Duration_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "module_group_duration" */
export enum Module_Group_Duration_Select_Column {
  /** column name */
  CourseDeliveryType = 'courseDeliveryType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Duration = 'duration',
  /** column name */
  Go1Integration = 'go1Integration',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleGroupId = 'module_group_id',
  /** column name */
  Reaccreditation = 'reaccreditation',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "module_group_duration_aggregate_bool_exp_bool_and_arguments_columns" columns of table "module_group_duration" */
export enum Module_Group_Duration_Select_Column_Module_Group_Duration_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Go1Integration = 'go1Integration',
  /** column name */
  Reaccreditation = 'reaccreditation'
}

/** select "module_group_duration_aggregate_bool_exp_bool_or_arguments_columns" columns of table "module_group_duration" */
export enum Module_Group_Duration_Select_Column_Module_Group_Duration_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Go1Integration = 'go1Integration',
  /** column name */
  Reaccreditation = 'reaccreditation'
}

/** input type for updating data in table "module_group_duration" */
export type Module_Group_Duration_Set_Input = {
  courseDeliveryType?: InputMaybe<Course_Delivery_Type_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['Int']>;
  go1Integration?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  module_group_id?: InputMaybe<Scalars['uuid']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Module_Group_Duration_Stddev_Fields = {
  __typename?: 'module_group_duration_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "module_group_duration" */
export type Module_Group_Duration_Stddev_Order_By = {
  duration?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Module_Group_Duration_Stddev_Pop_Fields = {
  __typename?: 'module_group_duration_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "module_group_duration" */
export type Module_Group_Duration_Stddev_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Module_Group_Duration_Stddev_Samp_Fields = {
  __typename?: 'module_group_duration_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "module_group_duration" */
export type Module_Group_Duration_Stddev_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "module_group_duration" */
export type Module_Group_Duration_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Module_Group_Duration_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Module_Group_Duration_Stream_Cursor_Value_Input = {
  courseDeliveryType?: InputMaybe<Course_Delivery_Type_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  duration?: InputMaybe<Scalars['Int']>;
  go1Integration?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  module_group_id?: InputMaybe<Scalars['uuid']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Module_Group_Duration_Sum_Fields = {
  __typename?: 'module_group_duration_sum_fields';
  duration?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "module_group_duration" */
export type Module_Group_Duration_Sum_Order_By = {
  duration?: InputMaybe<Order_By>;
};

/** update columns of table "module_group_duration" */
export enum Module_Group_Duration_Update_Column {
  /** column name */
  CourseDeliveryType = 'courseDeliveryType',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Duration = 'duration',
  /** column name */
  Go1Integration = 'go1Integration',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleGroupId = 'module_group_id',
  /** column name */
  Reaccreditation = 'reaccreditation',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Module_Group_Duration_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Module_Group_Duration_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Module_Group_Duration_Set_Input>;
  /** filter the rows which have to be updated */
  where: Module_Group_Duration_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Module_Group_Duration_Var_Pop_Fields = {
  __typename?: 'module_group_duration_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "module_group_duration" */
export type Module_Group_Duration_Var_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Module_Group_Duration_Var_Samp_Fields = {
  __typename?: 'module_group_duration_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "module_group_duration" */
export type Module_Group_Duration_Var_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Module_Group_Duration_Variance_Fields = {
  __typename?: 'module_group_duration_variance_fields';
  duration?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "module_group_duration" */
export type Module_Group_Duration_Variance_Order_By = {
  duration?: InputMaybe<Order_By>;
};

/** input type for inserting data into table "module_group" */
export type Module_Group_Insert_Input = {
  color?: InputMaybe<Color_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  durations?: InputMaybe<Module_Group_Duration_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Course_Level_Enum>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  modules?: InputMaybe<Module_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  requires?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Module_Group_Max_Fields = {
  __typename?: 'module_group_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Module_Group_Min_Fields = {
  __typename?: 'module_group_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "module_group" */
export type Module_Group_Mutation_Response = {
  __typename?: 'module_group_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Module_Group>;
};

/** input type for inserting object relation for remote table "module_group" */
export type Module_Group_Obj_Rel_Insert_Input = {
  data: Module_Group_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Module_Group_On_Conflict>;
};

/** on_conflict condition type for table "module_group" */
export type Module_Group_On_Conflict = {
  constraint: Module_Group_Constraint;
  update_columns?: Array<Module_Group_Update_Column>;
  where?: InputMaybe<Module_Group_Bool_Exp>;
};

/** Ordering options when selecting data from "module_group". */
export type Module_Group_Order_By = {
  color?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  durations_aggregate?: InputMaybe<Module_Group_Duration_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  mandatory?: InputMaybe<Order_By>;
  modules_aggregate?: InputMaybe<Module_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  requires?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: module_group */
export type Module_Group_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Module_Group_Prepend_Input = {
  requires?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "module_group" */
export enum Module_Group_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  Name = 'name',
  /** column name */
  Requires = 'requires',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "module_group" */
export type Module_Group_Set_Input = {
  color?: InputMaybe<Color_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Course_Level_Enum>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  requires?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "module_group" */
export type Module_Group_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Module_Group_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Module_Group_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Color_Enum>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Course_Level_Enum>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  name?: InputMaybe<Scalars['String']>;
  requires?: InputMaybe<Scalars['jsonb']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "module_group" */
export enum Module_Group_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  Name = 'name',
  /** column name */
  Requires = 'requires',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Module_Group_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Module_Group_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Module_Group_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Module_Group_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Module_Group_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Module_Group_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Module_Group_Set_Input>;
  /** filter the rows which have to be updated */
  where: Module_Group_Bool_Exp;
};

/** input type for inserting data into table "module" */
export type Module_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Course_Level_Enum>;
  moduleGroup?: InputMaybe<Module_Group_Obj_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  submodules?: InputMaybe<Submodule_Arr_Rel_Insert_Input>;
  type?: InputMaybe<Module_Category_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Module_Max_Fields = {
  __typename?: 'module_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "module" */
export type Module_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Module_Min_Fields = {
  __typename?: 'module_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  group?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "module" */
export type Module_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "module" */
export type Module_Mutation_Response = {
  __typename?: 'module_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Module>;
};

/** input type for inserting object relation for remote table "module" */
export type Module_Obj_Rel_Insert_Input = {
  data: Module_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Module_On_Conflict>;
};

/** on_conflict condition type for table "module" */
export type Module_On_Conflict = {
  constraint: Module_Constraint;
  update_columns?: Array<Module_Update_Column>;
  where?: InputMaybe<Module_Bool_Exp>;
};

/** Ordering options when selecting data from "module". */
export type Module_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  group?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  level?: InputMaybe<Order_By>;
  moduleGroup?: InputMaybe<Module_Group_Order_By>;
  name?: InputMaybe<Order_By>;
  submodules_aggregate?: InputMaybe<Submodule_Aggregate_Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: module */
export type Module_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "module" */
export enum Module_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Group = 'group',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "module" */
export type Module_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Course_Level_Enum>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Module_Category_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Settings for a module */
export type Module_Setting = {
  __typename?: 'module_setting';
  color: Color_Enum;
  conversion?: Maybe<Scalars['Boolean']>;
  courseDeliveryType: Course_Delivery_Type_Enum;
  courseLevel: Course_Level_Enum;
  courseType: Course_Type_Enum;
  /** An array relationship */
  dependencies: Array<Module_Setting_Dependency>;
  /** An aggregate relationship */
  dependencies_aggregate: Module_Setting_Dependency_Aggregate;
  duration?: Maybe<Scalars['Int']>;
  go1Integration: Scalars['Boolean'];
  id: Scalars['uuid'];
  mandatory: Scalars['Boolean'];
  /** An object relationship */
  module: Module_V2;
  moduleName: Scalars['String'];
  reaccreditation: Scalars['Boolean'];
  shard: Scalars['String'];
  sort: Scalars['Int'];
};


/** Settings for a module */
export type Module_SettingDependenciesArgs = {
  distinct_on?: InputMaybe<Array<Module_Setting_Dependency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Setting_Dependency_Order_By>>;
  where?: InputMaybe<Module_Setting_Dependency_Bool_Exp>;
};


/** Settings for a module */
export type Module_SettingDependencies_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Setting_Dependency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Setting_Dependency_Order_By>>;
  where?: InputMaybe<Module_Setting_Dependency_Bool_Exp>;
};

/** aggregated selection of "module_setting" */
export type Module_Setting_Aggregate = {
  __typename?: 'module_setting_aggregate';
  aggregate?: Maybe<Module_Setting_Aggregate_Fields>;
  nodes: Array<Module_Setting>;
};

export type Module_Setting_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Module_Setting_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Module_Setting_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Module_Setting_Aggregate_Bool_Exp_Count>;
};

export type Module_Setting_Aggregate_Bool_Exp_Bool_And = {
  arguments: Module_Setting_Select_Column_Module_Setting_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Module_Setting_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Module_Setting_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Module_Setting_Select_Column_Module_Setting_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Module_Setting_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Module_Setting_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Module_Setting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Module_Setting_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "module_setting" */
export type Module_Setting_Aggregate_Fields = {
  __typename?: 'module_setting_aggregate_fields';
  avg?: Maybe<Module_Setting_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Module_Setting_Max_Fields>;
  min?: Maybe<Module_Setting_Min_Fields>;
  stddev?: Maybe<Module_Setting_Stddev_Fields>;
  stddev_pop?: Maybe<Module_Setting_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Module_Setting_Stddev_Samp_Fields>;
  sum?: Maybe<Module_Setting_Sum_Fields>;
  var_pop?: Maybe<Module_Setting_Var_Pop_Fields>;
  var_samp?: Maybe<Module_Setting_Var_Samp_Fields>;
  variance?: Maybe<Module_Setting_Variance_Fields>;
};


/** aggregate fields of "module_setting" */
export type Module_Setting_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Module_Setting_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "module_setting" */
export type Module_Setting_Aggregate_Order_By = {
  avg?: InputMaybe<Module_Setting_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Module_Setting_Max_Order_By>;
  min?: InputMaybe<Module_Setting_Min_Order_By>;
  stddev?: InputMaybe<Module_Setting_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Module_Setting_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Module_Setting_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Module_Setting_Sum_Order_By>;
  var_pop?: InputMaybe<Module_Setting_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Module_Setting_Var_Samp_Order_By>;
  variance?: InputMaybe<Module_Setting_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "module_setting" */
export type Module_Setting_Arr_Rel_Insert_Input = {
  data: Array<Module_Setting_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Module_Setting_On_Conflict>;
};

/** aggregate avg on columns */
export type Module_Setting_Avg_Fields = {
  __typename?: 'module_setting_avg_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "module_setting" */
export type Module_Setting_Avg_Order_By = {
  duration?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "module_setting". All fields are combined with a logical 'AND'. */
export type Module_Setting_Bool_Exp = {
  _and?: InputMaybe<Array<Module_Setting_Bool_Exp>>;
  _not?: InputMaybe<Module_Setting_Bool_Exp>;
  _or?: InputMaybe<Array<Module_Setting_Bool_Exp>>;
  color?: InputMaybe<Color_Enum_Comparison_Exp>;
  conversion?: InputMaybe<Boolean_Comparison_Exp>;
  courseDeliveryType?: InputMaybe<Course_Delivery_Type_Enum_Comparison_Exp>;
  courseLevel?: InputMaybe<Course_Level_Enum_Comparison_Exp>;
  courseType?: InputMaybe<Course_Type_Enum_Comparison_Exp>;
  dependencies?: InputMaybe<Module_Setting_Dependency_Bool_Exp>;
  dependencies_aggregate?: InputMaybe<Module_Setting_Dependency_Aggregate_Bool_Exp>;
  duration?: InputMaybe<Int_Comparison_Exp>;
  go1Integration?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  mandatory?: InputMaybe<Boolean_Comparison_Exp>;
  module?: InputMaybe<Module_V2_Bool_Exp>;
  moduleName?: InputMaybe<String_Comparison_Exp>;
  reaccreditation?: InputMaybe<Boolean_Comparison_Exp>;
  shard?: InputMaybe<String_Comparison_Exp>;
  sort?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "module_setting" */
export enum Module_Setting_Constraint {
  /** unique or primary key constraint on columns "shard", "sort", "duration", "color", "course_level", "conversion", "go1_integration", "reaccreditation", "mandatory", "course_delivery_type", "module_name", "course_type" */
  ModuleSettingColorCourseTypeSortDurationModuleNameCour = 'module_setting_color_course_type_sort_duration_module_name_cour',
  /** unique or primary key constraint on columns "sort", "duration", "color", "course_level", "go1_integration", "reaccreditation", "mandatory", "course_delivery_type", "module_name", "course_type" */
  ModuleSettingGo1IntegrationCourseLevelReaccreditationCou = 'module_setting_go1_integration_course_level_reaccreditation_cou',
  /** unique or primary key constraint on columns "id" */
  ModuleSettingPkey = 'module_setting_pkey'
}

/** Dependencies between module settings */
export type Module_Setting_Dependency = {
  __typename?: 'module_setting_dependency';
  /** An object relationship */
  dependency: Module_Setting;
  id: Scalars['uuid'];
  moduleSettingDependencyId: Scalars['uuid'];
  moduleSettingId: Scalars['uuid'];
};

/** aggregated selection of "module_setting_dependency" */
export type Module_Setting_Dependency_Aggregate = {
  __typename?: 'module_setting_dependency_aggregate';
  aggregate?: Maybe<Module_Setting_Dependency_Aggregate_Fields>;
  nodes: Array<Module_Setting_Dependency>;
};

export type Module_Setting_Dependency_Aggregate_Bool_Exp = {
  count?: InputMaybe<Module_Setting_Dependency_Aggregate_Bool_Exp_Count>;
};

export type Module_Setting_Dependency_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Module_Setting_Dependency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Module_Setting_Dependency_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "module_setting_dependency" */
export type Module_Setting_Dependency_Aggregate_Fields = {
  __typename?: 'module_setting_dependency_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Module_Setting_Dependency_Max_Fields>;
  min?: Maybe<Module_Setting_Dependency_Min_Fields>;
};


/** aggregate fields of "module_setting_dependency" */
export type Module_Setting_Dependency_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Module_Setting_Dependency_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "module_setting_dependency" */
export type Module_Setting_Dependency_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Module_Setting_Dependency_Max_Order_By>;
  min?: InputMaybe<Module_Setting_Dependency_Min_Order_By>;
};

/** input type for inserting array relation for remote table "module_setting_dependency" */
export type Module_Setting_Dependency_Arr_Rel_Insert_Input = {
  data: Array<Module_Setting_Dependency_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Module_Setting_Dependency_On_Conflict>;
};

/** Boolean expression to filter rows from the table "module_setting_dependency". All fields are combined with a logical 'AND'. */
export type Module_Setting_Dependency_Bool_Exp = {
  _and?: InputMaybe<Array<Module_Setting_Dependency_Bool_Exp>>;
  _not?: InputMaybe<Module_Setting_Dependency_Bool_Exp>;
  _or?: InputMaybe<Array<Module_Setting_Dependency_Bool_Exp>>;
  dependency?: InputMaybe<Module_Setting_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  moduleSettingDependencyId?: InputMaybe<Uuid_Comparison_Exp>;
  moduleSettingId?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "module_setting_dependency" */
export enum Module_Setting_Dependency_Constraint {
  /** unique or primary key constraint on columns "module_setting_id", "module_setting_dependency_id" */
  ModuleSettingDependencyModuleSettingIdModuleSettingDepe = 'module_setting_dependency_module_setting_id_module_setting_depe',
  /** unique or primary key constraint on columns "id" */
  ModuleSettingDependencyPkey = 'module_setting_dependency_pkey'
}

/** input type for inserting data into table "module_setting_dependency" */
export type Module_Setting_Dependency_Insert_Input = {
  dependency?: InputMaybe<Module_Setting_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  moduleSettingDependencyId?: InputMaybe<Scalars['uuid']>;
  moduleSettingId?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Module_Setting_Dependency_Max_Fields = {
  __typename?: 'module_setting_dependency_max_fields';
  id?: Maybe<Scalars['uuid']>;
  moduleSettingDependencyId?: Maybe<Scalars['uuid']>;
  moduleSettingId?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "module_setting_dependency" */
export type Module_Setting_Dependency_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  moduleSettingDependencyId?: InputMaybe<Order_By>;
  moduleSettingId?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Module_Setting_Dependency_Min_Fields = {
  __typename?: 'module_setting_dependency_min_fields';
  id?: Maybe<Scalars['uuid']>;
  moduleSettingDependencyId?: Maybe<Scalars['uuid']>;
  moduleSettingId?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "module_setting_dependency" */
export type Module_Setting_Dependency_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  moduleSettingDependencyId?: InputMaybe<Order_By>;
  moduleSettingId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "module_setting_dependency" */
export type Module_Setting_Dependency_Mutation_Response = {
  __typename?: 'module_setting_dependency_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Module_Setting_Dependency>;
};

/** on_conflict condition type for table "module_setting_dependency" */
export type Module_Setting_Dependency_On_Conflict = {
  constraint: Module_Setting_Dependency_Constraint;
  update_columns?: Array<Module_Setting_Dependency_Update_Column>;
  where?: InputMaybe<Module_Setting_Dependency_Bool_Exp>;
};

/** Ordering options when selecting data from "module_setting_dependency". */
export type Module_Setting_Dependency_Order_By = {
  dependency?: InputMaybe<Module_Setting_Order_By>;
  id?: InputMaybe<Order_By>;
  moduleSettingDependencyId?: InputMaybe<Order_By>;
  moduleSettingId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: module_setting_dependency */
export type Module_Setting_Dependency_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "module_setting_dependency" */
export enum Module_Setting_Dependency_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ModuleSettingDependencyId = 'moduleSettingDependencyId',
  /** column name */
  ModuleSettingId = 'moduleSettingId'
}

/** input type for updating data in table "module_setting_dependency" */
export type Module_Setting_Dependency_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  moduleSettingDependencyId?: InputMaybe<Scalars['uuid']>;
  moduleSettingId?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "module_setting_dependency" */
export type Module_Setting_Dependency_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Module_Setting_Dependency_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Module_Setting_Dependency_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  moduleSettingDependencyId?: InputMaybe<Scalars['uuid']>;
  moduleSettingId?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "module_setting_dependency" */
export enum Module_Setting_Dependency_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  ModuleSettingDependencyId = 'moduleSettingDependencyId',
  /** column name */
  ModuleSettingId = 'moduleSettingId'
}

export type Module_Setting_Dependency_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Module_Setting_Dependency_Set_Input>;
  /** filter the rows which have to be updated */
  where: Module_Setting_Dependency_Bool_Exp;
};

/** input type for incrementing numeric columns in table "module_setting" */
export type Module_Setting_Inc_Input = {
  duration?: InputMaybe<Scalars['Int']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "module_setting" */
export type Module_Setting_Insert_Input = {
  color?: InputMaybe<Color_Enum>;
  conversion?: InputMaybe<Scalars['Boolean']>;
  courseDeliveryType?: InputMaybe<Course_Delivery_Type_Enum>;
  courseLevel?: InputMaybe<Course_Level_Enum>;
  courseType?: InputMaybe<Course_Type_Enum>;
  dependencies?: InputMaybe<Module_Setting_Dependency_Arr_Rel_Insert_Input>;
  duration?: InputMaybe<Scalars['Int']>;
  go1Integration?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  module?: InputMaybe<Module_V2_Obj_Rel_Insert_Input>;
  moduleName?: InputMaybe<Scalars['String']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  shard?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Module_Setting_Max_Fields = {
  __typename?: 'module_setting_max_fields';
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  moduleName?: Maybe<Scalars['String']>;
  shard?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
};

/** order by max() on columns of table "module_setting" */
export type Module_Setting_Max_Order_By = {
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moduleName?: InputMaybe<Order_By>;
  shard?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Module_Setting_Min_Fields = {
  __typename?: 'module_setting_min_fields';
  duration?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  moduleName?: Maybe<Scalars['String']>;
  shard?: Maybe<Scalars['String']>;
  sort?: Maybe<Scalars['Int']>;
};

/** order by min() on columns of table "module_setting" */
export type Module_Setting_Min_Order_By = {
  duration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  moduleName?: InputMaybe<Order_By>;
  shard?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "module_setting" */
export type Module_Setting_Mutation_Response = {
  __typename?: 'module_setting_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Module_Setting>;
};

/** input type for inserting object relation for remote table "module_setting" */
export type Module_Setting_Obj_Rel_Insert_Input = {
  data: Module_Setting_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Module_Setting_On_Conflict>;
};

/** on_conflict condition type for table "module_setting" */
export type Module_Setting_On_Conflict = {
  constraint: Module_Setting_Constraint;
  update_columns?: Array<Module_Setting_Update_Column>;
  where?: InputMaybe<Module_Setting_Bool_Exp>;
};

/** Ordering options when selecting data from "module_setting". */
export type Module_Setting_Order_By = {
  color?: InputMaybe<Order_By>;
  conversion?: InputMaybe<Order_By>;
  courseDeliveryType?: InputMaybe<Order_By>;
  courseLevel?: InputMaybe<Order_By>;
  courseType?: InputMaybe<Order_By>;
  dependencies_aggregate?: InputMaybe<Module_Setting_Dependency_Aggregate_Order_By>;
  duration?: InputMaybe<Order_By>;
  go1Integration?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  mandatory?: InputMaybe<Order_By>;
  module?: InputMaybe<Module_V2_Order_By>;
  moduleName?: InputMaybe<Order_By>;
  reaccreditation?: InputMaybe<Order_By>;
  shard?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** primary key columns input for table: module_setting */
export type Module_Setting_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "module_setting" */
export enum Module_Setting_Select_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Conversion = 'conversion',
  /** column name */
  CourseDeliveryType = 'courseDeliveryType',
  /** column name */
  CourseLevel = 'courseLevel',
  /** column name */
  CourseType = 'courseType',
  /** column name */
  Duration = 'duration',
  /** column name */
  Go1Integration = 'go1Integration',
  /** column name */
  Id = 'id',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  ModuleName = 'moduleName',
  /** column name */
  Reaccreditation = 'reaccreditation',
  /** column name */
  Shard = 'shard',
  /** column name */
  Sort = 'sort'
}

/** select "module_setting_aggregate_bool_exp_bool_and_arguments_columns" columns of table "module_setting" */
export enum Module_Setting_Select_Column_Module_Setting_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Conversion = 'conversion',
  /** column name */
  Go1Integration = 'go1Integration',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  Reaccreditation = 'reaccreditation'
}

/** select "module_setting_aggregate_bool_exp_bool_or_arguments_columns" columns of table "module_setting" */
export enum Module_Setting_Select_Column_Module_Setting_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Conversion = 'conversion',
  /** column name */
  Go1Integration = 'go1Integration',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  Reaccreditation = 'reaccreditation'
}

/** input type for updating data in table "module_setting" */
export type Module_Setting_Set_Input = {
  color?: InputMaybe<Color_Enum>;
  conversion?: InputMaybe<Scalars['Boolean']>;
  courseDeliveryType?: InputMaybe<Course_Delivery_Type_Enum>;
  courseLevel?: InputMaybe<Course_Level_Enum>;
  courseType?: InputMaybe<Course_Type_Enum>;
  duration?: InputMaybe<Scalars['Int']>;
  go1Integration?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  moduleName?: InputMaybe<Scalars['String']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  shard?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Module_Setting_Stddev_Fields = {
  __typename?: 'module_setting_stddev_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "module_setting" */
export type Module_Setting_Stddev_Order_By = {
  duration?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Module_Setting_Stddev_Pop_Fields = {
  __typename?: 'module_setting_stddev_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "module_setting" */
export type Module_Setting_Stddev_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Module_Setting_Stddev_Samp_Fields = {
  __typename?: 'module_setting_stddev_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "module_setting" */
export type Module_Setting_Stddev_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "module_setting" */
export type Module_Setting_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Module_Setting_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Module_Setting_Stream_Cursor_Value_Input = {
  color?: InputMaybe<Color_Enum>;
  conversion?: InputMaybe<Scalars['Boolean']>;
  courseDeliveryType?: InputMaybe<Course_Delivery_Type_Enum>;
  courseLevel?: InputMaybe<Course_Level_Enum>;
  courseType?: InputMaybe<Course_Type_Enum>;
  duration?: InputMaybe<Scalars['Int']>;
  go1Integration?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  mandatory?: InputMaybe<Scalars['Boolean']>;
  moduleName?: InputMaybe<Scalars['String']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  shard?: InputMaybe<Scalars['String']>;
  sort?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Module_Setting_Sum_Fields = {
  __typename?: 'module_setting_sum_fields';
  duration?: Maybe<Scalars['Int']>;
  sort?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "module_setting" */
export type Module_Setting_Sum_Order_By = {
  duration?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** update columns of table "module_setting" */
export enum Module_Setting_Update_Column {
  /** column name */
  Color = 'color',
  /** column name */
  Conversion = 'conversion',
  /** column name */
  CourseDeliveryType = 'courseDeliveryType',
  /** column name */
  CourseLevel = 'courseLevel',
  /** column name */
  CourseType = 'courseType',
  /** column name */
  Duration = 'duration',
  /** column name */
  Go1Integration = 'go1Integration',
  /** column name */
  Id = 'id',
  /** column name */
  Mandatory = 'mandatory',
  /** column name */
  ModuleName = 'moduleName',
  /** column name */
  Reaccreditation = 'reaccreditation',
  /** column name */
  Shard = 'shard',
  /** column name */
  Sort = 'sort'
}

export type Module_Setting_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Module_Setting_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Module_Setting_Set_Input>;
  /** filter the rows which have to be updated */
  where: Module_Setting_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Module_Setting_Var_Pop_Fields = {
  __typename?: 'module_setting_var_pop_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "module_setting" */
export type Module_Setting_Var_Pop_Order_By = {
  duration?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Module_Setting_Var_Samp_Fields = {
  __typename?: 'module_setting_var_samp_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "module_setting" */
export type Module_Setting_Var_Samp_Order_By = {
  duration?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Module_Setting_Variance_Fields = {
  __typename?: 'module_setting_variance_fields';
  duration?: Maybe<Scalars['Float']>;
  sort?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "module_setting" */
export type Module_Setting_Variance_Order_By = {
  duration?: InputMaybe<Order_By>;
  sort?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "module" */
export type Module_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Module_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Module_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  group?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  level?: InputMaybe<Course_Level_Enum>;
  name?: InputMaybe<Scalars['String']>;
  type?: InputMaybe<Module_Category_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "module" */
export enum Module_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Description = 'description',
  /** column name */
  Group = 'group',
  /** column name */
  Id = 'id',
  /** column name */
  Level = 'level',
  /** column name */
  Name = 'name',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Module_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Module_Set_Input>;
  /** filter the rows which have to be updated */
  where: Module_Bool_Exp;
};

/** Holds information about modules with their lessons */
export type Module_V2 = {
  __typename?: 'module_v2';
  created_at: Scalars['timestamptz'];
  displayName?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  lessons: Scalars['jsonb'];
  name: Scalars['String'];
  /** An array relationship */
  settings: Array<Module_Setting>;
  /** An aggregate relationship */
  settings_aggregate: Module_Setting_Aggregate;
  updated_at: Scalars['timestamptz'];
};


/** Holds information about modules with their lessons */
export type Module_V2LessonsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Holds information about modules with their lessons */
export type Module_V2SettingsArgs = {
  distinct_on?: InputMaybe<Array<Module_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Setting_Order_By>>;
  where?: InputMaybe<Module_Setting_Bool_Exp>;
};


/** Holds information about modules with their lessons */
export type Module_V2Settings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Setting_Order_By>>;
  where?: InputMaybe<Module_Setting_Bool_Exp>;
};

/** aggregated selection of "module_v2" */
export type Module_V2_Aggregate = {
  __typename?: 'module_v2_aggregate';
  aggregate?: Maybe<Module_V2_Aggregate_Fields>;
  nodes: Array<Module_V2>;
};

/** aggregate fields of "module_v2" */
export type Module_V2_Aggregate_Fields = {
  __typename?: 'module_v2_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Module_V2_Max_Fields>;
  min?: Maybe<Module_V2_Min_Fields>;
};


/** aggregate fields of "module_v2" */
export type Module_V2_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Module_V2_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Module_V2_Append_Input = {
  lessons?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "module_v2". All fields are combined with a logical 'AND'. */
export type Module_V2_Bool_Exp = {
  _and?: InputMaybe<Array<Module_V2_Bool_Exp>>;
  _not?: InputMaybe<Module_V2_Bool_Exp>;
  _or?: InputMaybe<Array<Module_V2_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  displayName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lessons?: InputMaybe<Jsonb_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  settings?: InputMaybe<Module_Setting_Bool_Exp>;
  settings_aggregate?: InputMaybe<Module_Setting_Aggregate_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "module_v2" */
export enum Module_V2_Constraint {
  /** unique or primary key constraint on columns "name" */
  ModuleV2NameKey = 'module_v2_name_key',
  /** unique or primary key constraint on columns "id" */
  ModuleV2Pkey = 'module_v2_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Module_V2_Delete_At_Path_Input = {
  lessons?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Module_V2_Delete_Elem_Input = {
  lessons?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Module_V2_Delete_Key_Input = {
  lessons?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "module_v2" */
export type Module_V2_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessons?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  settings?: InputMaybe<Module_Setting_Arr_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Module_V2_Max_Fields = {
  __typename?: 'module_v2_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Module_V2_Min_Fields = {
  __typename?: 'module_v2_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  displayName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "module_v2" */
export type Module_V2_Mutation_Response = {
  __typename?: 'module_v2_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Module_V2>;
};

/** input type for inserting object relation for remote table "module_v2" */
export type Module_V2_Obj_Rel_Insert_Input = {
  data: Module_V2_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Module_V2_On_Conflict>;
};

/** on_conflict condition type for table "module_v2" */
export type Module_V2_On_Conflict = {
  constraint: Module_V2_Constraint;
  update_columns?: Array<Module_V2_Update_Column>;
  where?: InputMaybe<Module_V2_Bool_Exp>;
};

/** Ordering options when selecting data from "module_v2". */
export type Module_V2_Order_By = {
  created_at?: InputMaybe<Order_By>;
  displayName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lessons?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  settings_aggregate?: InputMaybe<Module_Setting_Aggregate_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: module_v2 */
export type Module_V2_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Module_V2_Prepend_Input = {
  lessons?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "module_v2" */
export enum Module_V2_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  Lessons = 'lessons',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "module_v2" */
export type Module_V2_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessons?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "module_v2" */
export type Module_V2_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Module_V2_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Module_V2_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  displayName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lessons?: InputMaybe<Scalars['jsonb']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "module_v2" */
export enum Module_V2_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  DisplayName = 'displayName',
  /** column name */
  Id = 'id',
  /** column name */
  Lessons = 'lessons',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Module_V2_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Module_V2_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Module_V2_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Module_V2_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Module_V2_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Module_V2_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Module_V2_Set_Input>;
  /** filter the rows which have to be updated */
  where: Module_V2_Bool_Exp;
};

/** mutation root */
export type Mutation_Root = {
  __typename?: 'mutation_root';
  acceptOrgInvite?: Maybe<AcceptOrgInviteOutput>;
  /** Manually add resource packs to organisation */
  addResourcePacks?: Maybe<ResourcePacksAddOutput>;
  approveCourse: ApproveCourseOutput;
  arloCallback?: Maybe<ArloCallbackOutput>;
  cancelIndividualFromCourse?: Maybe<CancelIndividualFromCourseOutput>;
  /** Removes another user from course waitlist */
  cancelIndividualFromCourseWaitlist?: Maybe<CancelIndividualFromCourseWaitlistOutput>;
  cancelMyselfFromCourse: Scalars['Boolean'];
  /** Removes current anonymous user from course waitlist */
  cancelMyselfFromCourseWaitlist?: Maybe<CancelMyselfFromCourseWaitlistOutput>;
  /** execute VOLATILE function "consume_license_and_log" which returns "org_resource_packs_history" */
  consume_license_and_log: Array<Org_Resource_Packs_History>;
  content?: Maybe<ContentRootMutation>;
  /** Attempts to create a new Order */
  createOrder?: Maybe<CreateOrderOutput>;
  /** Creates a membership subscription */
  createStripeSubscription?: Maybe<CreateSubscriptionOutput>;
  createUser: CreateUserOutput;
  declineInvite?: Maybe<DeclineInviteOutput>;
  declineOrgInvite: Scalars['Boolean'];
  deleteMeeting: DeleteMeetingOutput;
  deleteOrganisation?: Maybe<DeleteOrganisationOutput>;
  /** Delete users */
  deleteUser: DeleteUserOutput;
  /** delete data from the table: "about_training_email_scheduled_events" */
  delete_about_training_email_scheduled_events?: Maybe<About_Training_Email_Scheduled_Events_Mutation_Response>;
  /** delete single row from the table: "about_training_email_scheduled_events" */
  delete_about_training_email_scheduled_events_by_pk?: Maybe<About_Training_Email_Scheduled_Events>;
  /** delete data from the table: "absorb_enrolment" */
  delete_absorb_enrolment?: Maybe<Absorb_Enrolment_Mutation_Response>;
  /** delete single row from the table: "absorb_enrolment" */
  delete_absorb_enrolment_by_pk?: Maybe<Absorb_Enrolment>;
  /** delete data from the table: "accreditors" */
  delete_accreditors?: Maybe<Accreditors_Mutation_Response>;
  /** delete single row from the table: "accreditors" */
  delete_accreditors_by_pk?: Maybe<Accreditors>;
  /** delete data from the table: "availability" */
  delete_availability?: Maybe<Availability_Mutation_Response>;
  /** delete single row from the table: "availability" */
  delete_availability_by_pk?: Maybe<Availability>;
  /** delete data from the table: "bild_strategy" */
  delete_bild_strategy?: Maybe<Bild_Strategy_Mutation_Response>;
  /** delete single row from the table: "bild_strategy" */
  delete_bild_strategy_by_pk?: Maybe<Bild_Strategy>;
  /** delete data from the table: "blended_learning_status" */
  delete_blended_learning_status?: Maybe<Blended_Learning_Status_Mutation_Response>;
  /** delete single row from the table: "blended_learning_status" */
  delete_blended_learning_status_by_pk?: Maybe<Blended_Learning_Status>;
  /** delete data from the table: "certificate_expired_notification_jobs" */
  delete_certificate_expired_notification_jobs?: Maybe<Certificate_Expired_Notification_Jobs_Mutation_Response>;
  /** delete single row from the table: "certificate_expired_notification_jobs" */
  delete_certificate_expired_notification_jobs_by_pk?: Maybe<Certificate_Expired_Notification_Jobs>;
  /** delete data from the table: "certificate_expiry_notification_jobs" */
  delete_certificate_expiry_notification_jobs?: Maybe<Certificate_Expiry_Notification_Jobs_Mutation_Response>;
  /** delete single row from the table: "certificate_expiry_notification_jobs" */
  delete_certificate_expiry_notification_jobs_by_pk?: Maybe<Certificate_Expiry_Notification_Jobs>;
  /** delete data from the table: "certificate_expiry_notification_timeframe" */
  delete_certificate_expiry_notification_timeframe?: Maybe<Certificate_Expiry_Notification_Timeframe_Mutation_Response>;
  /** delete single row from the table: "certificate_expiry_notification_timeframe" */
  delete_certificate_expiry_notification_timeframe_by_pk?: Maybe<Certificate_Expiry_Notification_Timeframe>;
  /** delete data from the table: "certificate_status" */
  delete_certificate_status?: Maybe<Certificate_Status_Mutation_Response>;
  /** delete single row from the table: "certificate_status" */
  delete_certificate_status_by_pk?: Maybe<Certificate_Status>;
  /** delete data from the table: "color" */
  delete_color?: Maybe<Color_Mutation_Response>;
  /** delete single row from the table: "color" */
  delete_color_by_pk?: Maybe<Color>;
  /** delete data from the table: "country" */
  delete_country?: Maybe<Country_Mutation_Response>;
  /** delete single row from the table: "country" */
  delete_country_by_pk?: Maybe<Country>;
  /** delete data from the table: "country_region" */
  delete_country_region?: Maybe<Country_Region_Mutation_Response>;
  /** delete single row from the table: "country_region" */
  delete_country_region_by_pk?: Maybe<Country_Region>;
  /** delete data from the table: "course" */
  delete_course?: Maybe<Course_Mutation_Response>;
  /** delete data from the table: "course_audit" */
  delete_course_audit?: Maybe<Course_Audit_Mutation_Response>;
  /** delete single row from the table: "course_audit" */
  delete_course_audit_by_pk?: Maybe<Course_Audit>;
  /** delete data from the table: "course_audit_type" */
  delete_course_audit_type?: Maybe<Course_Audit_Type_Mutation_Response>;
  /** delete single row from the table: "course_audit_type" */
  delete_course_audit_type_by_pk?: Maybe<Course_Audit_Type>;
  /** delete data from the table: "course_bild_module" */
  delete_course_bild_module?: Maybe<Course_Bild_Module_Mutation_Response>;
  /** delete single row from the table: "course_bild_module" */
  delete_course_bild_module_by_pk?: Maybe<Course_Bild_Module>;
  /** delete data from the table: "course_bild_strategy" */
  delete_course_bild_strategy?: Maybe<Course_Bild_Strategy_Mutation_Response>;
  /** delete single row from the table: "course_bild_strategy" */
  delete_course_bild_strategy_by_pk?: Maybe<Course_Bild_Strategy>;
  /** delete single row from the table: "course" */
  delete_course_by_pk?: Maybe<Course>;
  /** delete data from the table: "course_cancellation_fee_type" */
  delete_course_cancellation_fee_type?: Maybe<Course_Cancellation_Fee_Type_Mutation_Response>;
  /** delete single row from the table: "course_cancellation_fee_type" */
  delete_course_cancellation_fee_type_by_pk?: Maybe<Course_Cancellation_Fee_Type>;
  /** delete data from the table: "course_cancellation_request" */
  delete_course_cancellation_request?: Maybe<Course_Cancellation_Request_Mutation_Response>;
  /** delete single row from the table: "course_cancellation_request" */
  delete_course_cancellation_request_by_pk?: Maybe<Course_Cancellation_Request>;
  /** delete data from the table: "course_certificate" */
  delete_course_certificate?: Maybe<Course_Certificate_Mutation_Response>;
  /** delete single row from the table: "course_certificate" */
  delete_course_certificate_by_pk?: Maybe<Course_Certificate>;
  /** delete data from the table: "course_certificate_changelog" */
  delete_course_certificate_changelog?: Maybe<Course_Certificate_Changelog_Mutation_Response>;
  /** delete single row from the table: "course_certificate_changelog" */
  delete_course_certificate_changelog_by_pk?: Maybe<Course_Certificate_Changelog>;
  /** delete data from the table: "course_certificate_changelog_type" */
  delete_course_certificate_changelog_type?: Maybe<Course_Certificate_Changelog_Type_Mutation_Response>;
  /** delete single row from the table: "course_certificate_changelog_type" */
  delete_course_certificate_changelog_type_by_pk?: Maybe<Course_Certificate_Changelog_Type>;
  /** delete data from the table: "course_certificate_hold_request" */
  delete_course_certificate_hold_request?: Maybe<Course_Certificate_Hold_Request_Mutation_Response>;
  /** delete single row from the table: "course_certificate_hold_request" */
  delete_course_certificate_hold_request_by_pk?: Maybe<Course_Certificate_Hold_Request>;
  /** delete data from the table: "course_delivery_type" */
  delete_course_delivery_type?: Maybe<Course_Delivery_Type_Mutation_Response>;
  /** delete single row from the table: "course_delivery_type" */
  delete_course_delivery_type_by_pk?: Maybe<Course_Delivery_Type>;
  /** delete data from the table: "course_delivery_type_prefix" */
  delete_course_delivery_type_prefix?: Maybe<Course_Delivery_Type_Prefix_Mutation_Response>;
  /** delete single row from the table: "course_delivery_type_prefix" */
  delete_course_delivery_type_prefix_by_pk?: Maybe<Course_Delivery_Type_Prefix>;
  /** delete data from the table: "course_draft" */
  delete_course_draft?: Maybe<Course_Draft_Mutation_Response>;
  /** delete single row from the table: "course_draft" */
  delete_course_draft_by_pk?: Maybe<Course_Draft>;
  /** delete data from the table: "course_end_jobs" */
  delete_course_end_jobs?: Maybe<Course_End_Jobs_Mutation_Response>;
  /** delete single row from the table: "course_end_jobs" */
  delete_course_end_jobs_by_pk?: Maybe<Course_End_Jobs>;
  /** delete data from the table: "course_enquiry" */
  delete_course_enquiry?: Maybe<Course_Enquiry_Mutation_Response>;
  /** delete single row from the table: "course_enquiry" */
  delete_course_enquiry_by_pk?: Maybe<Course_Enquiry>;
  /** delete data from the table: "course_evaluation_answers" */
  delete_course_evaluation_answers?: Maybe<Course_Evaluation_Answers_Mutation_Response>;
  /** delete single row from the table: "course_evaluation_answers" */
  delete_course_evaluation_answers_by_pk?: Maybe<Course_Evaluation_Answers>;
  /** delete data from the table: "course_evaluation_question_group" */
  delete_course_evaluation_question_group?: Maybe<Course_Evaluation_Question_Group_Mutation_Response>;
  /** delete single row from the table: "course_evaluation_question_group" */
  delete_course_evaluation_question_group_by_pk?: Maybe<Course_Evaluation_Question_Group>;
  /** delete data from the table: "course_evaluation_question_type" */
  delete_course_evaluation_question_type?: Maybe<Course_Evaluation_Question_Type_Mutation_Response>;
  /** delete single row from the table: "course_evaluation_question_type" */
  delete_course_evaluation_question_type_by_pk?: Maybe<Course_Evaluation_Question_Type>;
  /** delete data from the table: "course_evaluation_questions" */
  delete_course_evaluation_questions?: Maybe<Course_Evaluation_Questions_Mutation_Response>;
  /** delete single row from the table: "course_evaluation_questions" */
  delete_course_evaluation_questions_by_pk?: Maybe<Course_Evaluation_Questions>;
  /** delete data from the table: "course_evaluation_scheduled_event" */
  delete_course_evaluation_scheduled_event?: Maybe<Course_Evaluation_Scheduled_Event_Mutation_Response>;
  /** delete single row from the table: "course_evaluation_scheduled_event" */
  delete_course_evaluation_scheduled_event_by_pk?: Maybe<Course_Evaluation_Scheduled_Event>;
  /** delete data from the table: "course_exception" */
  delete_course_exception?: Maybe<Course_Exception_Mutation_Response>;
  /** delete single row from the table: "course_exception" */
  delete_course_exception_by_pk?: Maybe<Course_Exception>;
  /** delete data from the table: "course_exceptions" */
  delete_course_exceptions?: Maybe<Course_Exceptions_Mutation_Response>;
  /** delete single row from the table: "course_exceptions" */
  delete_course_exceptions_by_pk?: Maybe<Course_Exceptions>;
  /** delete data from the table: "course_expenses" */
  delete_course_expenses?: Maybe<Course_Expenses_Mutation_Response>;
  /** delete single row from the table: "course_expenses" */
  delete_course_expenses_by_pk?: Maybe<Course_Expenses>;
  /** delete data from the table: "course_invite_status" */
  delete_course_invite_status?: Maybe<Course_Invite_Status_Mutation_Response>;
  /** delete single row from the table: "course_invite_status" */
  delete_course_invite_status_by_pk?: Maybe<Course_Invite_Status>;
  /** delete data from the table: "course_invites" */
  delete_course_invites?: Maybe<Course_Invites_Mutation_Response>;
  /** delete single row from the table: "course_invites" */
  delete_course_invites_by_pk?: Maybe<Course_Invites>;
  /** delete data from the table: "course_level" */
  delete_course_level?: Maybe<Course_Level_Mutation_Response>;
  /** delete single row from the table: "course_level" */
  delete_course_level_by_pk?: Maybe<Course_Level>;
  /** delete data from the table: "course_level_prefix" */
  delete_course_level_prefix?: Maybe<Course_Level_Prefix_Mutation_Response>;
  /** delete single row from the table: "course_level_prefix" */
  delete_course_level_prefix_by_pk?: Maybe<Course_Level_Prefix>;
  /** delete data from the table: "course_module" */
  delete_course_module?: Maybe<Course_Module_Mutation_Response>;
  /** delete single row from the table: "course_module" */
  delete_course_module_by_pk?: Maybe<Course_Module>;
  /** delete data from the table: "course_order" */
  delete_course_order?: Maybe<Course_Order_Mutation_Response>;
  /** delete data from the table: "course_participant" */
  delete_course_participant?: Maybe<Course_Participant_Mutation_Response>;
  /** delete data from the table: "course_participant_audit" */
  delete_course_participant_audit?: Maybe<Course_Participant_Audit_Mutation_Response>;
  /** delete single row from the table: "course_participant_audit" */
  delete_course_participant_audit_by_pk?: Maybe<Course_Participant_Audit>;
  /** delete data from the table: "course_participant_audit_type" */
  delete_course_participant_audit_type?: Maybe<Course_Participant_Audit_Type_Mutation_Response>;
  /** delete single row from the table: "course_participant_audit_type" */
  delete_course_participant_audit_type_by_pk?: Maybe<Course_Participant_Audit_Type>;
  /** delete data from the table: "course_participant_bild_module" */
  delete_course_participant_bild_module?: Maybe<Course_Participant_Bild_Module_Mutation_Response>;
  /** delete single row from the table: "course_participant_bild_module" */
  delete_course_participant_bild_module_by_pk?: Maybe<Course_Participant_Bild_Module>;
  /** delete single row from the table: "course_participant" */
  delete_course_participant_by_pk?: Maybe<Course_Participant>;
  /** delete data from the table: "course_participant_cancellation" */
  delete_course_participant_cancellation?: Maybe<Course_Participant_Cancellation_Mutation_Response>;
  /** delete single row from the table: "course_participant_cancellation" */
  delete_course_participant_cancellation_by_pk?: Maybe<Course_Participant_Cancellation>;
  /** delete data from the table: "course_participant_module" */
  delete_course_participant_module?: Maybe<Course_Participant_Module_Mutation_Response>;
  /** delete single row from the table: "course_participant_module" */
  delete_course_participant_module_by_pk?: Maybe<Course_Participant_Module>;
  /** delete data from the table: "course_participant_note" */
  delete_course_participant_note?: Maybe<Course_Participant_Note_Mutation_Response>;
  /** delete single row from the table: "course_participant_note" */
  delete_course_participant_note_by_pk?: Maybe<Course_Participant_Note>;
  /** delete data from the table: "course_pricing" */
  delete_course_pricing?: Maybe<Course_Pricing_Mutation_Response>;
  /** delete single row from the table: "course_pricing" */
  delete_course_pricing_by_pk?: Maybe<Course_Pricing>;
  /** delete data from the table: "course_pricing_changelog" */
  delete_course_pricing_changelog?: Maybe<Course_Pricing_Changelog_Mutation_Response>;
  /** delete single row from the table: "course_pricing_changelog" */
  delete_course_pricing_changelog_by_pk?: Maybe<Course_Pricing_Changelog>;
  /** delete data from the table: "course_pricing_schedule" */
  delete_course_pricing_schedule?: Maybe<Course_Pricing_Schedule_Mutation_Response>;
  /** delete single row from the table: "course_pricing_schedule" */
  delete_course_pricing_schedule_by_pk?: Maybe<Course_Pricing_Schedule>;
  /** delete data from the table: "course_promo_code" */
  delete_course_promo_code?: Maybe<Course_Promo_Code_Mutation_Response>;
  /** delete single row from the table: "course_promo_code" */
  delete_course_promo_code_by_pk?: Maybe<Course_Promo_Code>;
  /** delete data from the table: "course_renewal_cycle" */
  delete_course_renewal_cycle?: Maybe<Course_Renewal_Cycle_Mutation_Response>;
  /** delete single row from the table: "course_renewal_cycle" */
  delete_course_renewal_cycle_by_pk?: Maybe<Course_Renewal_Cycle>;
  /** delete data from the table: "course_schedule" */
  delete_course_schedule?: Maybe<Course_Schedule_Mutation_Response>;
  /** delete single row from the table: "course_schedule" */
  delete_course_schedule_by_pk?: Maybe<Course_Schedule>;
  /** delete data from the table: "course_source" */
  delete_course_source?: Maybe<Course_Source_Mutation_Response>;
  /** delete single row from the table: "course_source" */
  delete_course_source_by_pk?: Maybe<Course_Source>;
  /** delete data from the table: "course_status" */
  delete_course_status?: Maybe<Course_Status_Mutation_Response>;
  /** delete single row from the table: "course_status" */
  delete_course_status_by_pk?: Maybe<Course_Status>;
  /** delete data from the table: "course_trainer" */
  delete_course_trainer?: Maybe<Course_Trainer_Mutation_Response>;
  /** delete single row from the table: "course_trainer" */
  delete_course_trainer_by_pk?: Maybe<Course_Trainer>;
  /** delete data from the table: "course_trainer_type" */
  delete_course_trainer_type?: Maybe<Course_Trainer_Type_Mutation_Response>;
  /** delete single row from the table: "course_trainer_type" */
  delete_course_trainer_type_by_pk?: Maybe<Course_Trainer_Type>;
  /** delete data from the table: "course_type" */
  delete_course_type?: Maybe<Course_Type_Mutation_Response>;
  /** delete single row from the table: "course_type" */
  delete_course_type_by_pk?: Maybe<Course_Type>;
  /** delete data from the table: "course_type_prefix" */
  delete_course_type_prefix?: Maybe<Course_Type_Prefix_Mutation_Response>;
  /** delete single row from the table: "course_type_prefix" */
  delete_course_type_prefix_by_pk?: Maybe<Course_Type_Prefix>;
  /** delete data from the table: "cqc_establishment" */
  delete_cqc_establishment?: Maybe<Cqc_Establishment_Mutation_Response>;
  /** delete single row from the table: "cqc_establishment" */
  delete_cqc_establishment_by_pk?: Maybe<Cqc_Establishment>;
  /** delete data from the table: "cud_operation" */
  delete_cud_operation?: Maybe<Cud_Operation_Mutation_Response>;
  /** delete single row from the table: "cud_operation" */
  delete_cud_operation_by_pk?: Maybe<Cud_Operation>;
  /** delete data from the table: "deleted_organizations_backup" */
  delete_deleted_organizations_backup?: Maybe<Deleted_Organizations_Backup_Mutation_Response>;
  /** delete data from the table: "dfe_establishment" */
  delete_dfe_establishment?: Maybe<Dfe_Establishment_Mutation_Response>;
  /** delete single row from the table: "dfe_establishment" */
  delete_dfe_establishment_by_pk?: Maybe<Dfe_Establishment>;
  /** delete data from the table: "email_notifications" */
  delete_email_notifications?: Maybe<Email_Notifications_Mutation_Response>;
  /** delete single row from the table: "email_notifications" */
  delete_email_notifications_by_pk?: Maybe<Email_Notifications>;
  /** delete data from the table: "expire_go1_license_jobs" */
  delete_expire_go1_license_jobs?: Maybe<Expire_Go1_License_Jobs_Mutation_Response>;
  /** delete single row from the table: "expire_go1_license_jobs" */
  delete_expire_go1_license_jobs_by_pk?: Maybe<Expire_Go1_License_Jobs>;
  /** delete data from the table: "go1_history_events" */
  delete_go1_history_events?: Maybe<Go1_History_Events_Mutation_Response>;
  /** delete single row from the table: "go1_history_events" */
  delete_go1_history_events_by_pk?: Maybe<Go1_History_Events>;
  /** delete data from the table: "go1_licenses" */
  delete_go1_licenses?: Maybe<Go1_Licenses_Mutation_Response>;
  /** delete single row from the table: "go1_licenses" */
  delete_go1_licenses_by_pk?: Maybe<Go1_Licenses>;
  /** delete data from the table: "go1_licenses_history" */
  delete_go1_licenses_history?: Maybe<Go1_Licenses_History_Mutation_Response>;
  /** delete single row from the table: "go1_licenses_history" */
  delete_go1_licenses_history_by_pk?: Maybe<Go1_Licenses_History>;
  /** delete data from the table: "grade" */
  delete_grade?: Maybe<Grade_Mutation_Response>;
  /** delete single row from the table: "grade" */
  delete_grade_by_pk?: Maybe<Grade>;
  /** delete data from the table: "hubspot_audit" */
  delete_hubspot_audit?: Maybe<Hubspot_Audit_Mutation_Response>;
  /** delete single row from the table: "hubspot_audit" */
  delete_hubspot_audit_by_pk?: Maybe<Hubspot_Audit>;
  /** delete data from the table: "identity" */
  delete_identity?: Maybe<Identity_Mutation_Response>;
  /** delete single row from the table: "identity" */
  delete_identity_by_pk?: Maybe<Identity>;
  /** delete data from the table: "identity_type" */
  delete_identity_type?: Maybe<Identity_Type_Mutation_Response>;
  /** delete single row from the table: "identity_type" */
  delete_identity_type_by_pk?: Maybe<Identity_Type>;
  /** delete data from the table: "import_job" */
  delete_import_job?: Maybe<Import_Job_Mutation_Response>;
  /** delete single row from the table: "import_job" */
  delete_import_job_by_pk?: Maybe<Import_Job>;
  /** delete data from the table: "import_job_status" */
  delete_import_job_status?: Maybe<Import_Job_Status_Mutation_Response>;
  /** delete single row from the table: "import_job_status" */
  delete_import_job_status_by_pk?: Maybe<Import_Job_Status>;
  /** delete data from the table: "import_job_type" */
  delete_import_job_type?: Maybe<Import_Job_Type_Mutation_Response>;
  /** delete single row from the table: "import_job_type" */
  delete_import_job_type_by_pk?: Maybe<Import_Job_Type>;
  /** delete data from the table: "job_title" */
  delete_job_title?: Maybe<Job_Title_Mutation_Response>;
  /** delete single row from the table: "job_title" */
  delete_job_title_by_pk?: Maybe<Job_Title>;
  /** delete data from the table: "legacy_certificate" */
  delete_legacy_certificate?: Maybe<Legacy_Certificate_Mutation_Response>;
  /** delete single row from the table: "legacy_certificate" */
  delete_legacy_certificate_by_pk?: Maybe<Legacy_Certificate>;
  /** delete data from the table: "materials_order" */
  delete_materials_order?: Maybe<Materials_Order_Mutation_Response>;
  /** delete single row from the table: "materials_order" */
  delete_materials_order_by_pk?: Maybe<Materials_Order>;
  /** delete data from the table: "merge_organizations_logs" */
  delete_merge_organizations_logs?: Maybe<Merge_Organizations_Logs_Mutation_Response>;
  /** delete single row from the table: "merge_organizations_logs" */
  delete_merge_organizations_logs_by_pk?: Maybe<Merge_Organizations_Logs>;
  /** delete data from the table: "merged_organizations" */
  delete_merged_organizations?: Maybe<Merged_Organizations_Mutation_Response>;
  /** delete single row from the table: "merged_organizations" */
  delete_merged_organizations_by_pk?: Maybe<Merged_Organizations>;
  /** delete data from the table: "module" */
  delete_module?: Maybe<Module_Mutation_Response>;
  /** delete single row from the table: "module" */
  delete_module_by_pk?: Maybe<Module>;
  /** delete data from the table: "module_category" */
  delete_module_category?: Maybe<Module_Category_Mutation_Response>;
  /** delete single row from the table: "module_category" */
  delete_module_category_by_pk?: Maybe<Module_Category>;
  /** delete data from the table: "module_group" */
  delete_module_group?: Maybe<Module_Group_Mutation_Response>;
  /** delete single row from the table: "module_group" */
  delete_module_group_by_pk?: Maybe<Module_Group>;
  /** delete data from the table: "module_group_duration" */
  delete_module_group_duration?: Maybe<Module_Group_Duration_Mutation_Response>;
  /** delete single row from the table: "module_group_duration" */
  delete_module_group_duration_by_pk?: Maybe<Module_Group_Duration>;
  /** delete data from the table: "module_setting" */
  delete_module_setting?: Maybe<Module_Setting_Mutation_Response>;
  /** delete single row from the table: "module_setting" */
  delete_module_setting_by_pk?: Maybe<Module_Setting>;
  /** delete data from the table: "module_setting_dependency" */
  delete_module_setting_dependency?: Maybe<Module_Setting_Dependency_Mutation_Response>;
  /** delete single row from the table: "module_setting_dependency" */
  delete_module_setting_dependency_by_pk?: Maybe<Module_Setting_Dependency>;
  /** delete data from the table: "module_v2" */
  delete_module_v2?: Maybe<Module_V2_Mutation_Response>;
  /** delete single row from the table: "module_v2" */
  delete_module_v2_by_pk?: Maybe<Module_V2>;
  /** delete data from the table: "non_graded_certificate" */
  delete_non_graded_certificate?: Maybe<Non_Graded_Certificate_Mutation_Response>;
  /** delete single row from the table: "non_graded_certificate" */
  delete_non_graded_certificate_by_pk?: Maybe<Non_Graded_Certificate>;
  /** delete data from the table: "order" */
  delete_order?: Maybe<Order_Mutation_Response>;
  /** delete single row from the table: "order" */
  delete_order_by_pk?: Maybe<Order>;
  /** delete data from the table: "order_temp" */
  delete_order_temp?: Maybe<Order_Temp_Mutation_Response>;
  /** delete single row from the table: "order_temp" */
  delete_order_temp_by_pk?: Maybe<Order_Temp>;
  /** delete data from the table: "org_created_from" */
  delete_org_created_from?: Maybe<Org_Created_From_Mutation_Response>;
  /** delete single row from the table: "org_created_from" */
  delete_org_created_from_by_pk?: Maybe<Org_Created_From>;
  /** delete data from the table: "org_resource_packs_history" */
  delete_org_resource_packs_history?: Maybe<Org_Resource_Packs_History_Mutation_Response>;
  /** delete single row from the table: "org_resource_packs_history" */
  delete_org_resource_packs_history_by_pk?: Maybe<Org_Resource_Packs_History>;
  /** delete data from the table: "org_resource_packs_pricing" */
  delete_org_resource_packs_pricing?: Maybe<Org_Resource_Packs_Pricing_Mutation_Response>;
  /** delete single row from the table: "org_resource_packs_pricing" */
  delete_org_resource_packs_pricing_by_pk?: Maybe<Org_Resource_Packs_Pricing>;
  /** delete data from the table: "org_resource_packs_pricing_changelog" */
  delete_org_resource_packs_pricing_changelog?: Maybe<Org_Resource_Packs_Pricing_Changelog_Mutation_Response>;
  /** delete single row from the table: "org_resource_packs_pricing_changelog" */
  delete_org_resource_packs_pricing_changelog_by_pk?: Maybe<Org_Resource_Packs_Pricing_Changelog>;
  /** delete data from the table: "organisation_log" */
  delete_organisation_log?: Maybe<Organisation_Log_Mutation_Response>;
  /** delete single row from the table: "organisation_log" */
  delete_organisation_log_by_pk?: Maybe<Organisation_Log>;
  /** delete data from the table: "organisation_sector" */
  delete_organisation_sector?: Maybe<Organisation_Sector_Mutation_Response>;
  /** delete single row from the table: "organisation_sector" */
  delete_organisation_sector_by_pk?: Maybe<Organisation_Sector>;
  /** delete data from the table: "organization" */
  delete_organization?: Maybe<Organization_Mutation_Response>;
  /** delete single row from the table: "organization" */
  delete_organization_by_pk?: Maybe<Organization>;
  /** delete data from the table: "organization_invites" */
  delete_organization_invites?: Maybe<Organization_Invites_Mutation_Response>;
  /** delete single row from the table: "organization_invites" */
  delete_organization_invites_by_pk?: Maybe<Organization_Invites>;
  /** delete data from the table: "organization_member" */
  delete_organization_member?: Maybe<Organization_Member_Mutation_Response>;
  /** delete single row from the table: "organization_member" */
  delete_organization_member_by_pk?: Maybe<Organization_Member>;
  /** delete data from the table: "organization_resource_packs" */
  delete_organization_resource_packs?: Maybe<Organization_Resource_Packs_Mutation_Response>;
  /** delete single row from the table: "organization_resource_packs" */
  delete_organization_resource_packs_by_pk?: Maybe<Organization_Resource_Packs>;
  /** delete data from the table: "organization_type" */
  delete_organization_type?: Maybe<Organization_Type_Mutation_Response>;
  /** delete single row from the table: "organization_type" */
  delete_organization_type_by_pk?: Maybe<Organization_Type>;
  /** delete data from the table: "organizations_statistics" */
  delete_organizations_statistics?: Maybe<Organizations_Statistics_Mutation_Response>;
  /** delete single row from the table: "organizations_statistics" */
  delete_organizations_statistics_by_pk?: Maybe<Organizations_Statistics>;
  /** delete data from the table: "payment_methods" */
  delete_payment_methods?: Maybe<Payment_Methods_Mutation_Response>;
  /** delete single row from the table: "payment_methods" */
  delete_payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** delete data from the table: "post_training_email_scheduled_events" */
  delete_post_training_email_scheduled_events?: Maybe<Post_Training_Email_Scheduled_Events_Mutation_Response>;
  /** delete single row from the table: "post_training_email_scheduled_events" */
  delete_post_training_email_scheduled_events_by_pk?: Maybe<Post_Training_Email_Scheduled_Events>;
  /** delete data from the table: "pre_training_email_scheduled_events" */
  delete_pre_training_email_scheduled_events?: Maybe<Pre_Training_Email_Scheduled_Events_Mutation_Response>;
  /** delete single row from the table: "pre_training_email_scheduled_events" */
  delete_pre_training_email_scheduled_events_by_pk?: Maybe<Pre_Training_Email_Scheduled_Events>;
  /** delete data from the table: "precision_order_status" */
  delete_precision_order_status?: Maybe<Precision_Order_Status_Mutation_Response>;
  /** delete single row from the table: "precision_order_status" */
  delete_precision_order_status_by_pk?: Maybe<Precision_Order_Status>;
  /** delete data from the table: "private_course_booking" */
  delete_private_course_booking?: Maybe<Private_Course_Booking_Mutation_Response>;
  /** delete single row from the table: "private_course_booking" */
  delete_private_course_booking_by_pk?: Maybe<Private_Course_Booking>;
  /** delete data from the table: "profile" */
  delete_profile?: Maybe<Profile_Mutation_Response>;
  /** delete single row from the table: "profile" */
  delete_profile_by_pk?: Maybe<Profile>;
  /** delete data from the table: "profile_role" */
  delete_profile_role?: Maybe<Profile_Role_Mutation_Response>;
  /** delete single row from the table: "profile_role" */
  delete_profile_role_by_pk?: Maybe<Profile_Role>;
  /** delete data from the table: "profile_temp" */
  delete_profile_temp?: Maybe<Profile_Temp_Mutation_Response>;
  /** delete single row from the table: "profile_temp" */
  delete_profile_temp_by_pk?: Maybe<Profile_Temp>;
  /** delete data from the table: "profile_trainer_agreement_type" */
  delete_profile_trainer_agreement_type?: Maybe<Profile_Trainer_Agreement_Type_Mutation_Response>;
  /** delete single row from the table: "profile_trainer_agreement_type" */
  delete_profile_trainer_agreement_type_by_pk?: Maybe<Profile_Trainer_Agreement_Type>;
  /** delete data from the table: "profile_trainer_role_type" */
  delete_profile_trainer_role_type?: Maybe<Profile_Trainer_Role_Type_Mutation_Response>;
  /** delete single row from the table: "profile_trainer_role_type" */
  delete_profile_trainer_role_type_by_pk?: Maybe<Profile_Trainer_Role_Type>;
  /** delete data from the table: "promo_code" */
  delete_promo_code?: Maybe<Promo_Code_Mutation_Response>;
  /** delete single row from the table: "promo_code" */
  delete_promo_code_by_pk?: Maybe<Promo_Code>;
  /** delete data from the table: "promo_code_type" */
  delete_promo_code_type?: Maybe<Promo_Code_Type_Mutation_Response>;
  /** delete single row from the table: "promo_code_type" */
  delete_promo_code_type_by_pk?: Maybe<Promo_Code_Type>;
  /** delete data from the table: "resource_pack_bundle_course_level" */
  delete_resource_pack_bundle_course_level?: Maybe<Resource_Pack_Bundle_Course_Level_Mutation_Response>;
  /** delete single row from the table: "resource_pack_bundle_course_level" */
  delete_resource_pack_bundle_course_level_by_pk?: Maybe<Resource_Pack_Bundle_Course_Level>;
  /** delete data from the table: "resource_pack_bundle_option" */
  delete_resource_pack_bundle_option?: Maybe<Resource_Pack_Bundle_Option_Mutation_Response>;
  /** delete single row from the table: "resource_pack_bundle_option" */
  delete_resource_pack_bundle_option_by_pk?: Maybe<Resource_Pack_Bundle_Option>;
  /** delete data from the table: "resource_pack_bundle_price" */
  delete_resource_pack_bundle_price?: Maybe<Resource_Pack_Bundle_Price_Mutation_Response>;
  /** delete single row from the table: "resource_pack_bundle_price" */
  delete_resource_pack_bundle_price_by_pk?: Maybe<Resource_Pack_Bundle_Price>;
  /** delete data from the table: "resource_packs_delivery_type" */
  delete_resource_packs_delivery_type?: Maybe<Resource_Packs_Delivery_Type_Mutation_Response>;
  /** delete single row from the table: "resource_packs_delivery_type" */
  delete_resource_packs_delivery_type_by_pk?: Maybe<Resource_Packs_Delivery_Type>;
  /** delete data from the table: "resource_packs_events" */
  delete_resource_packs_events?: Maybe<Resource_Packs_Events_Mutation_Response>;
  /** delete single row from the table: "resource_packs_events" */
  delete_resource_packs_events_by_pk?: Maybe<Resource_Packs_Events>;
  /** delete data from the table: "resource_packs_pricing" */
  delete_resource_packs_pricing?: Maybe<Resource_Packs_Pricing_Mutation_Response>;
  /** delete single row from the table: "resource_packs_pricing" */
  delete_resource_packs_pricing_by_pk?: Maybe<Resource_Packs_Pricing>;
  /** delete data from the table: "resource_packs_type" */
  delete_resource_packs_type?: Maybe<Resource_Packs_Type_Mutation_Response>;
  /** delete single row from the table: "resource_packs_type" */
  delete_resource_packs_type_by_pk?: Maybe<Resource_Packs_Type>;
  /** delete data from the table: "role" */
  delete_role?: Maybe<Role_Mutation_Response>;
  /** delete single row from the table: "role" */
  delete_role_by_pk?: Maybe<Role>;
  /** delete data from the table: "scheduled_events_view" */
  delete_scheduled_events_view?: Maybe<Scheduled_Events_View_Mutation_Response>;
  /** delete data from the table: "splash_screens" */
  delete_splash_screens?: Maybe<Splash_Screens_Mutation_Response>;
  /** delete single row from the table: "splash_screens" */
  delete_splash_screens_by_pk?: Maybe<Splash_Screens>;
  /** delete data from the table: "submission_of_splash_screens" */
  delete_submission_of_splash_screens?: Maybe<Submission_Of_Splash_Screens_Mutation_Response>;
  /** delete single row from the table: "submission_of_splash_screens" */
  delete_submission_of_splash_screens_by_pk?: Maybe<Submission_Of_Splash_Screens>;
  /** delete data from the table: "submodule" */
  delete_submodule?: Maybe<Submodule_Mutation_Response>;
  /** delete single row from the table: "submodule" */
  delete_submodule_by_pk?: Maybe<Submodule>;
  /** delete data from the table: "trainer_agreement_type" */
  delete_trainer_agreement_type?: Maybe<Trainer_Agreement_Type_Mutation_Response>;
  /** delete single row from the table: "trainer_agreement_type" */
  delete_trainer_agreement_type_by_pk?: Maybe<Trainer_Agreement_Type>;
  /** delete data from the table: "trainer_role_type" */
  delete_trainer_role_type?: Maybe<Trainer_Role_Type_Mutation_Response>;
  /** delete single row from the table: "trainer_role_type" */
  delete_trainer_role_type_by_pk?: Maybe<Trainer_Role_Type>;
  /** delete data from the table: "trust_type" */
  delete_trust_type?: Maybe<Trust_Type_Mutation_Response>;
  /** delete single row from the table: "trust_type" */
  delete_trust_type_by_pk?: Maybe<Trust_Type>;
  /** delete data from the table: "tt_client_invite_log" */
  delete_tt_client_invite_log?: Maybe<Tt_Client_Invite_Log_Mutation_Response>;
  /** delete single row from the table: "tt_client_invite_log" */
  delete_tt_client_invite_log_by_pk?: Maybe<Tt_Client_Invite_Log>;
  /** delete data from the table: "user_auth_audit_type" */
  delete_user_auth_audit_type?: Maybe<User_Auth_Audit_Type_Mutation_Response>;
  /** delete single row from the table: "user_auth_audit_type" */
  delete_user_auth_audit_type_by_pk?: Maybe<User_Auth_Audit_Type>;
  /** delete data from the table: "user_auth_audits" */
  delete_user_auth_audits?: Maybe<User_Auth_Audits_Mutation_Response>;
  /** delete single row from the table: "user_auth_audits" */
  delete_user_auth_audits_by_pk?: Maybe<User_Auth_Audits>;
  /** delete data from the table: "venue" */
  delete_venue?: Maybe<Venue_Mutation_Response>;
  /** delete single row from the table: "venue" */
  delete_venue_by_pk?: Maybe<Venue>;
  /** delete data from the table: "venue_check_jobs" */
  delete_venue_check_jobs?: Maybe<Venue_Check_Jobs_Mutation_Response>;
  /** delete single row from the table: "venue_check_jobs" */
  delete_venue_check_jobs_by_pk?: Maybe<Venue_Check_Jobs>;
  /** delete data from the table: "waitlist" */
  delete_waitlist?: Maybe<Waitlist_Mutation_Response>;
  /** delete single row from the table: "waitlist" */
  delete_waitlist_by_pk?: Maybe<Waitlist>;
  /** delete data from the table: "xero_contact" */
  delete_xero_contact?: Maybe<Xero_Contact_Mutation_Response>;
  /** delete single row from the table: "xero_contact" */
  delete_xero_contact_by_pk?: Maybe<Xero_Contact>;
  /** delete data from the table: "xero_credential" */
  delete_xero_credential?: Maybe<Xero_Credential_Mutation_Response>;
  /** delete single row from the table: "xero_credential" */
  delete_xero_credential_by_pk?: Maybe<Xero_Credential>;
  /** delete data from the table: "xero_invoice" */
  delete_xero_invoice?: Maybe<Xero_Invoice_Mutation_Response>;
  /** delete single row from the table: "xero_invoice" */
  delete_xero_invoice_by_pk?: Maybe<Xero_Invoice>;
  /** delete data from the table: "xero_invoice_status" */
  delete_xero_invoice_status?: Maybe<Xero_Invoice_Status_Mutation_Response>;
  /** delete single row from the table: "xero_invoice_status" */
  delete_xero_invoice_status_by_pk?: Maybe<Xero_Invoice_Status>;
  /** execute VOLATILE function "get_organisation_by_email" which returns "organization" */
  get_organisation_by_email: Array<Organization>;
  /** go1LicensesChange */
  go1LicensesChange?: Maybe<Go1LicensesChangeOutput>;
  /** gradedOnSync */
  gradedOnSync?: Maybe<GradedOnSyncOutput>;
  importArloCertificates: Scalars['uuid'];
  importLegacyCertificate?: Maybe<ImportLegacyCertificateOutput>;
  /** importOrganisations */
  importOrganisations?: Maybe<ImportOrganisationsOutput>;
  /** importUsers */
  importUsers?: Maybe<ImportUsersOutput>;
  /** insert data into the table: "about_training_email_scheduled_events" */
  insert_about_training_email_scheduled_events?: Maybe<About_Training_Email_Scheduled_Events_Mutation_Response>;
  /** insert a single row into the table: "about_training_email_scheduled_events" */
  insert_about_training_email_scheduled_events_one?: Maybe<About_Training_Email_Scheduled_Events>;
  /** insert data into the table: "absorb_enrolment" */
  insert_absorb_enrolment?: Maybe<Absorb_Enrolment_Mutation_Response>;
  /** insert a single row into the table: "absorb_enrolment" */
  insert_absorb_enrolment_one?: Maybe<Absorb_Enrolment>;
  /** insert data into the table: "accreditors" */
  insert_accreditors?: Maybe<Accreditors_Mutation_Response>;
  /** insert a single row into the table: "accreditors" */
  insert_accreditors_one?: Maybe<Accreditors>;
  /** insert data into the table: "availability" */
  insert_availability?: Maybe<Availability_Mutation_Response>;
  /** insert a single row into the table: "availability" */
  insert_availability_one?: Maybe<Availability>;
  /** insert data into the table: "bild_strategy" */
  insert_bild_strategy?: Maybe<Bild_Strategy_Mutation_Response>;
  /** insert a single row into the table: "bild_strategy" */
  insert_bild_strategy_one?: Maybe<Bild_Strategy>;
  /** insert data into the table: "blended_learning_status" */
  insert_blended_learning_status?: Maybe<Blended_Learning_Status_Mutation_Response>;
  /** insert a single row into the table: "blended_learning_status" */
  insert_blended_learning_status_one?: Maybe<Blended_Learning_Status>;
  /** insert data into the table: "certificate_expired_notification_jobs" */
  insert_certificate_expired_notification_jobs?: Maybe<Certificate_Expired_Notification_Jobs_Mutation_Response>;
  /** insert a single row into the table: "certificate_expired_notification_jobs" */
  insert_certificate_expired_notification_jobs_one?: Maybe<Certificate_Expired_Notification_Jobs>;
  /** insert data into the table: "certificate_expiry_notification_jobs" */
  insert_certificate_expiry_notification_jobs?: Maybe<Certificate_Expiry_Notification_Jobs_Mutation_Response>;
  /** insert a single row into the table: "certificate_expiry_notification_jobs" */
  insert_certificate_expiry_notification_jobs_one?: Maybe<Certificate_Expiry_Notification_Jobs>;
  /** insert data into the table: "certificate_expiry_notification_timeframe" */
  insert_certificate_expiry_notification_timeframe?: Maybe<Certificate_Expiry_Notification_Timeframe_Mutation_Response>;
  /** insert a single row into the table: "certificate_expiry_notification_timeframe" */
  insert_certificate_expiry_notification_timeframe_one?: Maybe<Certificate_Expiry_Notification_Timeframe>;
  /** insert data into the table: "certificate_status" */
  insert_certificate_status?: Maybe<Certificate_Status_Mutation_Response>;
  /** insert a single row into the table: "certificate_status" */
  insert_certificate_status_one?: Maybe<Certificate_Status>;
  /** insert data into the table: "color" */
  insert_color?: Maybe<Color_Mutation_Response>;
  /** insert a single row into the table: "color" */
  insert_color_one?: Maybe<Color>;
  /** insert data into the table: "country" */
  insert_country?: Maybe<Country_Mutation_Response>;
  /** insert a single row into the table: "country" */
  insert_country_one?: Maybe<Country>;
  /** insert data into the table: "country_region" */
  insert_country_region?: Maybe<Country_Region_Mutation_Response>;
  /** insert a single row into the table: "country_region" */
  insert_country_region_one?: Maybe<Country_Region>;
  /** insert data into the table: "course" */
  insert_course?: Maybe<Course_Mutation_Response>;
  /** insert data into the table: "course_audit" */
  insert_course_audit?: Maybe<Course_Audit_Mutation_Response>;
  /** insert a single row into the table: "course_audit" */
  insert_course_audit_one?: Maybe<Course_Audit>;
  /** insert data into the table: "course_audit_type" */
  insert_course_audit_type?: Maybe<Course_Audit_Type_Mutation_Response>;
  /** insert a single row into the table: "course_audit_type" */
  insert_course_audit_type_one?: Maybe<Course_Audit_Type>;
  /** insert data into the table: "course_bild_module" */
  insert_course_bild_module?: Maybe<Course_Bild_Module_Mutation_Response>;
  /** insert a single row into the table: "course_bild_module" */
  insert_course_bild_module_one?: Maybe<Course_Bild_Module>;
  /** insert data into the table: "course_bild_strategy" */
  insert_course_bild_strategy?: Maybe<Course_Bild_Strategy_Mutation_Response>;
  /** insert a single row into the table: "course_bild_strategy" */
  insert_course_bild_strategy_one?: Maybe<Course_Bild_Strategy>;
  /** insert data into the table: "course_cancellation_fee_type" */
  insert_course_cancellation_fee_type?: Maybe<Course_Cancellation_Fee_Type_Mutation_Response>;
  /** insert a single row into the table: "course_cancellation_fee_type" */
  insert_course_cancellation_fee_type_one?: Maybe<Course_Cancellation_Fee_Type>;
  /** insert data into the table: "course_cancellation_request" */
  insert_course_cancellation_request?: Maybe<Course_Cancellation_Request_Mutation_Response>;
  /** insert a single row into the table: "course_cancellation_request" */
  insert_course_cancellation_request_one?: Maybe<Course_Cancellation_Request>;
  /** insert data into the table: "course_certificate" */
  insert_course_certificate?: Maybe<Course_Certificate_Mutation_Response>;
  /** insert data into the table: "course_certificate_changelog" */
  insert_course_certificate_changelog?: Maybe<Course_Certificate_Changelog_Mutation_Response>;
  /** insert a single row into the table: "course_certificate_changelog" */
  insert_course_certificate_changelog_one?: Maybe<Course_Certificate_Changelog>;
  /** insert data into the table: "course_certificate_changelog_type" */
  insert_course_certificate_changelog_type?: Maybe<Course_Certificate_Changelog_Type_Mutation_Response>;
  /** insert a single row into the table: "course_certificate_changelog_type" */
  insert_course_certificate_changelog_type_one?: Maybe<Course_Certificate_Changelog_Type>;
  /** insert data into the table: "course_certificate_hold_request" */
  insert_course_certificate_hold_request?: Maybe<Course_Certificate_Hold_Request_Mutation_Response>;
  /** insert a single row into the table: "course_certificate_hold_request" */
  insert_course_certificate_hold_request_one?: Maybe<Course_Certificate_Hold_Request>;
  /** insert a single row into the table: "course_certificate" */
  insert_course_certificate_one?: Maybe<Course_Certificate>;
  /** insert data into the table: "course_delivery_type" */
  insert_course_delivery_type?: Maybe<Course_Delivery_Type_Mutation_Response>;
  /** insert a single row into the table: "course_delivery_type" */
  insert_course_delivery_type_one?: Maybe<Course_Delivery_Type>;
  /** insert data into the table: "course_delivery_type_prefix" */
  insert_course_delivery_type_prefix?: Maybe<Course_Delivery_Type_Prefix_Mutation_Response>;
  /** insert a single row into the table: "course_delivery_type_prefix" */
  insert_course_delivery_type_prefix_one?: Maybe<Course_Delivery_Type_Prefix>;
  /** insert data into the table: "course_draft" */
  insert_course_draft?: Maybe<Course_Draft_Mutation_Response>;
  /** insert a single row into the table: "course_draft" */
  insert_course_draft_one?: Maybe<Course_Draft>;
  /** insert data into the table: "course_end_jobs" */
  insert_course_end_jobs?: Maybe<Course_End_Jobs_Mutation_Response>;
  /** insert a single row into the table: "course_end_jobs" */
  insert_course_end_jobs_one?: Maybe<Course_End_Jobs>;
  /** insert data into the table: "course_enquiry" */
  insert_course_enquiry?: Maybe<Course_Enquiry_Mutation_Response>;
  /** insert a single row into the table: "course_enquiry" */
  insert_course_enquiry_one?: Maybe<Course_Enquiry>;
  /** insert data into the table: "course_evaluation_answers" */
  insert_course_evaluation_answers?: Maybe<Course_Evaluation_Answers_Mutation_Response>;
  /** insert a single row into the table: "course_evaluation_answers" */
  insert_course_evaluation_answers_one?: Maybe<Course_Evaluation_Answers>;
  /** insert data into the table: "course_evaluation_question_group" */
  insert_course_evaluation_question_group?: Maybe<Course_Evaluation_Question_Group_Mutation_Response>;
  /** insert a single row into the table: "course_evaluation_question_group" */
  insert_course_evaluation_question_group_one?: Maybe<Course_Evaluation_Question_Group>;
  /** insert data into the table: "course_evaluation_question_type" */
  insert_course_evaluation_question_type?: Maybe<Course_Evaluation_Question_Type_Mutation_Response>;
  /** insert a single row into the table: "course_evaluation_question_type" */
  insert_course_evaluation_question_type_one?: Maybe<Course_Evaluation_Question_Type>;
  /** insert data into the table: "course_evaluation_questions" */
  insert_course_evaluation_questions?: Maybe<Course_Evaluation_Questions_Mutation_Response>;
  /** insert a single row into the table: "course_evaluation_questions" */
  insert_course_evaluation_questions_one?: Maybe<Course_Evaluation_Questions>;
  /** insert data into the table: "course_evaluation_scheduled_event" */
  insert_course_evaluation_scheduled_event?: Maybe<Course_Evaluation_Scheduled_Event_Mutation_Response>;
  /** insert a single row into the table: "course_evaluation_scheduled_event" */
  insert_course_evaluation_scheduled_event_one?: Maybe<Course_Evaluation_Scheduled_Event>;
  /** insert data into the table: "course_exception" */
  insert_course_exception?: Maybe<Course_Exception_Mutation_Response>;
  /** insert a single row into the table: "course_exception" */
  insert_course_exception_one?: Maybe<Course_Exception>;
  /** insert data into the table: "course_exceptions" */
  insert_course_exceptions?: Maybe<Course_Exceptions_Mutation_Response>;
  /** insert a single row into the table: "course_exceptions" */
  insert_course_exceptions_one?: Maybe<Course_Exceptions>;
  /** insert data into the table: "course_expenses" */
  insert_course_expenses?: Maybe<Course_Expenses_Mutation_Response>;
  /** insert a single row into the table: "course_expenses" */
  insert_course_expenses_one?: Maybe<Course_Expenses>;
  /** insert data into the table: "course_invite_status" */
  insert_course_invite_status?: Maybe<Course_Invite_Status_Mutation_Response>;
  /** insert a single row into the table: "course_invite_status" */
  insert_course_invite_status_one?: Maybe<Course_Invite_Status>;
  /** insert data into the table: "course_invites" */
  insert_course_invites?: Maybe<Course_Invites_Mutation_Response>;
  /** insert a single row into the table: "course_invites" */
  insert_course_invites_one?: Maybe<Course_Invites>;
  /** insert data into the table: "course_level" */
  insert_course_level?: Maybe<Course_Level_Mutation_Response>;
  /** insert a single row into the table: "course_level" */
  insert_course_level_one?: Maybe<Course_Level>;
  /** insert data into the table: "course_level_prefix" */
  insert_course_level_prefix?: Maybe<Course_Level_Prefix_Mutation_Response>;
  /** insert a single row into the table: "course_level_prefix" */
  insert_course_level_prefix_one?: Maybe<Course_Level_Prefix>;
  /** insert data into the table: "course_module" */
  insert_course_module?: Maybe<Course_Module_Mutation_Response>;
  /** insert a single row into the table: "course_module" */
  insert_course_module_one?: Maybe<Course_Module>;
  /** insert a single row into the table: "course" */
  insert_course_one?: Maybe<Course>;
  /** insert data into the table: "course_order" */
  insert_course_order?: Maybe<Course_Order_Mutation_Response>;
  /** insert a single row into the table: "course_order" */
  insert_course_order_one?: Maybe<Course_Order>;
  /** insert data into the table: "course_participant" */
  insert_course_participant?: Maybe<Course_Participant_Mutation_Response>;
  /** insert data into the table: "course_participant_audit" */
  insert_course_participant_audit?: Maybe<Course_Participant_Audit_Mutation_Response>;
  /** insert a single row into the table: "course_participant_audit" */
  insert_course_participant_audit_one?: Maybe<Course_Participant_Audit>;
  /** insert data into the table: "course_participant_audit_type" */
  insert_course_participant_audit_type?: Maybe<Course_Participant_Audit_Type_Mutation_Response>;
  /** insert a single row into the table: "course_participant_audit_type" */
  insert_course_participant_audit_type_one?: Maybe<Course_Participant_Audit_Type>;
  /** insert data into the table: "course_participant_bild_module" */
  insert_course_participant_bild_module?: Maybe<Course_Participant_Bild_Module_Mutation_Response>;
  /** insert a single row into the table: "course_participant_bild_module" */
  insert_course_participant_bild_module_one?: Maybe<Course_Participant_Bild_Module>;
  /** insert data into the table: "course_participant_cancellation" */
  insert_course_participant_cancellation?: Maybe<Course_Participant_Cancellation_Mutation_Response>;
  /** insert a single row into the table: "course_participant_cancellation" */
  insert_course_participant_cancellation_one?: Maybe<Course_Participant_Cancellation>;
  /** insert data into the table: "course_participant_module" */
  insert_course_participant_module?: Maybe<Course_Participant_Module_Mutation_Response>;
  /** insert a single row into the table: "course_participant_module" */
  insert_course_participant_module_one?: Maybe<Course_Participant_Module>;
  /** insert data into the table: "course_participant_note" */
  insert_course_participant_note?: Maybe<Course_Participant_Note_Mutation_Response>;
  /** insert a single row into the table: "course_participant_note" */
  insert_course_participant_note_one?: Maybe<Course_Participant_Note>;
  /** insert a single row into the table: "course_participant" */
  insert_course_participant_one?: Maybe<Course_Participant>;
  /** insert data into the table: "course_pricing" */
  insert_course_pricing?: Maybe<Course_Pricing_Mutation_Response>;
  /** insert data into the table: "course_pricing_changelog" */
  insert_course_pricing_changelog?: Maybe<Course_Pricing_Changelog_Mutation_Response>;
  /** insert a single row into the table: "course_pricing_changelog" */
  insert_course_pricing_changelog_one?: Maybe<Course_Pricing_Changelog>;
  /** insert a single row into the table: "course_pricing" */
  insert_course_pricing_one?: Maybe<Course_Pricing>;
  /** insert data into the table: "course_pricing_schedule" */
  insert_course_pricing_schedule?: Maybe<Course_Pricing_Schedule_Mutation_Response>;
  /** insert a single row into the table: "course_pricing_schedule" */
  insert_course_pricing_schedule_one?: Maybe<Course_Pricing_Schedule>;
  /** insert data into the table: "course_promo_code" */
  insert_course_promo_code?: Maybe<Course_Promo_Code_Mutation_Response>;
  /** insert a single row into the table: "course_promo_code" */
  insert_course_promo_code_one?: Maybe<Course_Promo_Code>;
  /** insert data into the table: "course_renewal_cycle" */
  insert_course_renewal_cycle?: Maybe<Course_Renewal_Cycle_Mutation_Response>;
  /** insert a single row into the table: "course_renewal_cycle" */
  insert_course_renewal_cycle_one?: Maybe<Course_Renewal_Cycle>;
  /** insert data into the table: "course_schedule" */
  insert_course_schedule?: Maybe<Course_Schedule_Mutation_Response>;
  /** insert a single row into the table: "course_schedule" */
  insert_course_schedule_one?: Maybe<Course_Schedule>;
  /** insert data into the table: "course_source" */
  insert_course_source?: Maybe<Course_Source_Mutation_Response>;
  /** insert a single row into the table: "course_source" */
  insert_course_source_one?: Maybe<Course_Source>;
  /** insert data into the table: "course_status" */
  insert_course_status?: Maybe<Course_Status_Mutation_Response>;
  /** insert a single row into the table: "course_status" */
  insert_course_status_one?: Maybe<Course_Status>;
  /** insert data into the table: "course_trainer" */
  insert_course_trainer?: Maybe<Course_Trainer_Mutation_Response>;
  /** insert a single row into the table: "course_trainer" */
  insert_course_trainer_one?: Maybe<Course_Trainer>;
  /** insert data into the table: "course_trainer_type" */
  insert_course_trainer_type?: Maybe<Course_Trainer_Type_Mutation_Response>;
  /** insert a single row into the table: "course_trainer_type" */
  insert_course_trainer_type_one?: Maybe<Course_Trainer_Type>;
  /** insert data into the table: "course_type" */
  insert_course_type?: Maybe<Course_Type_Mutation_Response>;
  /** insert a single row into the table: "course_type" */
  insert_course_type_one?: Maybe<Course_Type>;
  /** insert data into the table: "course_type_prefix" */
  insert_course_type_prefix?: Maybe<Course_Type_Prefix_Mutation_Response>;
  /** insert a single row into the table: "course_type_prefix" */
  insert_course_type_prefix_one?: Maybe<Course_Type_Prefix>;
  /** insert data into the table: "cqc_establishment" */
  insert_cqc_establishment?: Maybe<Cqc_Establishment_Mutation_Response>;
  /** insert a single row into the table: "cqc_establishment" */
  insert_cqc_establishment_one?: Maybe<Cqc_Establishment>;
  /** insert data into the table: "cud_operation" */
  insert_cud_operation?: Maybe<Cud_Operation_Mutation_Response>;
  /** insert a single row into the table: "cud_operation" */
  insert_cud_operation_one?: Maybe<Cud_Operation>;
  /** insert data into the table: "deleted_organizations_backup" */
  insert_deleted_organizations_backup?: Maybe<Deleted_Organizations_Backup_Mutation_Response>;
  /** insert a single row into the table: "deleted_organizations_backup" */
  insert_deleted_organizations_backup_one?: Maybe<Deleted_Organizations_Backup>;
  /** insert data into the table: "dfe_establishment" */
  insert_dfe_establishment?: Maybe<Dfe_Establishment_Mutation_Response>;
  /** insert a single row into the table: "dfe_establishment" */
  insert_dfe_establishment_one?: Maybe<Dfe_Establishment>;
  /** insert data into the table: "email_notifications" */
  insert_email_notifications?: Maybe<Email_Notifications_Mutation_Response>;
  /** insert a single row into the table: "email_notifications" */
  insert_email_notifications_one?: Maybe<Email_Notifications>;
  /** insert data into the table: "expire_go1_license_jobs" */
  insert_expire_go1_license_jobs?: Maybe<Expire_Go1_License_Jobs_Mutation_Response>;
  /** insert a single row into the table: "expire_go1_license_jobs" */
  insert_expire_go1_license_jobs_one?: Maybe<Expire_Go1_License_Jobs>;
  /** insert data into the table: "go1_history_events" */
  insert_go1_history_events?: Maybe<Go1_History_Events_Mutation_Response>;
  /** insert a single row into the table: "go1_history_events" */
  insert_go1_history_events_one?: Maybe<Go1_History_Events>;
  /** insert data into the table: "go1_licenses" */
  insert_go1_licenses?: Maybe<Go1_Licenses_Mutation_Response>;
  /** insert data into the table: "go1_licenses_history" */
  insert_go1_licenses_history?: Maybe<Go1_Licenses_History_Mutation_Response>;
  /** insert a single row into the table: "go1_licenses_history" */
  insert_go1_licenses_history_one?: Maybe<Go1_Licenses_History>;
  /** insert a single row into the table: "go1_licenses" */
  insert_go1_licenses_one?: Maybe<Go1_Licenses>;
  /** insert data into the table: "grade" */
  insert_grade?: Maybe<Grade_Mutation_Response>;
  /** insert a single row into the table: "grade" */
  insert_grade_one?: Maybe<Grade>;
  /** insert data into the table: "hubspot_audit" */
  insert_hubspot_audit?: Maybe<Hubspot_Audit_Mutation_Response>;
  /** insert a single row into the table: "hubspot_audit" */
  insert_hubspot_audit_one?: Maybe<Hubspot_Audit>;
  /** insert data into the table: "identity" */
  insert_identity?: Maybe<Identity_Mutation_Response>;
  /** insert a single row into the table: "identity" */
  insert_identity_one?: Maybe<Identity>;
  /** insert data into the table: "identity_type" */
  insert_identity_type?: Maybe<Identity_Type_Mutation_Response>;
  /** insert a single row into the table: "identity_type" */
  insert_identity_type_one?: Maybe<Identity_Type>;
  /** insert data into the table: "import_job" */
  insert_import_job?: Maybe<Import_Job_Mutation_Response>;
  /** insert a single row into the table: "import_job" */
  insert_import_job_one?: Maybe<Import_Job>;
  /** insert data into the table: "import_job_status" */
  insert_import_job_status?: Maybe<Import_Job_Status_Mutation_Response>;
  /** insert a single row into the table: "import_job_status" */
  insert_import_job_status_one?: Maybe<Import_Job_Status>;
  /** insert data into the table: "import_job_type" */
  insert_import_job_type?: Maybe<Import_Job_Type_Mutation_Response>;
  /** insert a single row into the table: "import_job_type" */
  insert_import_job_type_one?: Maybe<Import_Job_Type>;
  /** insert data into the table: "job_title" */
  insert_job_title?: Maybe<Job_Title_Mutation_Response>;
  /** insert a single row into the table: "job_title" */
  insert_job_title_one?: Maybe<Job_Title>;
  /** insert data into the table: "legacy_certificate" */
  insert_legacy_certificate?: Maybe<Legacy_Certificate_Mutation_Response>;
  /** insert a single row into the table: "legacy_certificate" */
  insert_legacy_certificate_one?: Maybe<Legacy_Certificate>;
  /** insert data into the table: "materials_order" */
  insert_materials_order?: Maybe<Materials_Order_Mutation_Response>;
  /** insert a single row into the table: "materials_order" */
  insert_materials_order_one?: Maybe<Materials_Order>;
  /** insert data into the table: "merge_organizations_logs" */
  insert_merge_organizations_logs?: Maybe<Merge_Organizations_Logs_Mutation_Response>;
  /** insert a single row into the table: "merge_organizations_logs" */
  insert_merge_organizations_logs_one?: Maybe<Merge_Organizations_Logs>;
  /** insert data into the table: "merged_organizations" */
  insert_merged_organizations?: Maybe<Merged_Organizations_Mutation_Response>;
  /** insert a single row into the table: "merged_organizations" */
  insert_merged_organizations_one?: Maybe<Merged_Organizations>;
  /** insert data into the table: "module" */
  insert_module?: Maybe<Module_Mutation_Response>;
  /** insert data into the table: "module_category" */
  insert_module_category?: Maybe<Module_Category_Mutation_Response>;
  /** insert a single row into the table: "module_category" */
  insert_module_category_one?: Maybe<Module_Category>;
  /** insert data into the table: "module_group" */
  insert_module_group?: Maybe<Module_Group_Mutation_Response>;
  /** insert data into the table: "module_group_duration" */
  insert_module_group_duration?: Maybe<Module_Group_Duration_Mutation_Response>;
  /** insert a single row into the table: "module_group_duration" */
  insert_module_group_duration_one?: Maybe<Module_Group_Duration>;
  /** insert a single row into the table: "module_group" */
  insert_module_group_one?: Maybe<Module_Group>;
  /** insert a single row into the table: "module" */
  insert_module_one?: Maybe<Module>;
  /** insert data into the table: "module_setting" */
  insert_module_setting?: Maybe<Module_Setting_Mutation_Response>;
  /** insert data into the table: "module_setting_dependency" */
  insert_module_setting_dependency?: Maybe<Module_Setting_Dependency_Mutation_Response>;
  /** insert a single row into the table: "module_setting_dependency" */
  insert_module_setting_dependency_one?: Maybe<Module_Setting_Dependency>;
  /** insert a single row into the table: "module_setting" */
  insert_module_setting_one?: Maybe<Module_Setting>;
  /** insert data into the table: "module_v2" */
  insert_module_v2?: Maybe<Module_V2_Mutation_Response>;
  /** insert a single row into the table: "module_v2" */
  insert_module_v2_one?: Maybe<Module_V2>;
  /** insert data into the table: "non_graded_certificate" */
  insert_non_graded_certificate?: Maybe<Non_Graded_Certificate_Mutation_Response>;
  /** insert a single row into the table: "non_graded_certificate" */
  insert_non_graded_certificate_one?: Maybe<Non_Graded_Certificate>;
  /** insert data into the table: "order" */
  insert_order?: Maybe<Order_Mutation_Response>;
  /** insert a single row into the table: "order" */
  insert_order_one?: Maybe<Order>;
  /** insert data into the table: "order_temp" */
  insert_order_temp?: Maybe<Order_Temp_Mutation_Response>;
  /** insert a single row into the table: "order_temp" */
  insert_order_temp_one?: Maybe<Order_Temp>;
  /** insert data into the table: "org_created_from" */
  insert_org_created_from?: Maybe<Org_Created_From_Mutation_Response>;
  /** insert a single row into the table: "org_created_from" */
  insert_org_created_from_one?: Maybe<Org_Created_From>;
  /** insert data into the table: "org_resource_packs_history" */
  insert_org_resource_packs_history?: Maybe<Org_Resource_Packs_History_Mutation_Response>;
  /** insert a single row into the table: "org_resource_packs_history" */
  insert_org_resource_packs_history_one?: Maybe<Org_Resource_Packs_History>;
  /** insert data into the table: "org_resource_packs_pricing" */
  insert_org_resource_packs_pricing?: Maybe<Org_Resource_Packs_Pricing_Mutation_Response>;
  /** insert data into the table: "org_resource_packs_pricing_changelog" */
  insert_org_resource_packs_pricing_changelog?: Maybe<Org_Resource_Packs_Pricing_Changelog_Mutation_Response>;
  /** insert a single row into the table: "org_resource_packs_pricing_changelog" */
  insert_org_resource_packs_pricing_changelog_one?: Maybe<Org_Resource_Packs_Pricing_Changelog>;
  /** insert a single row into the table: "org_resource_packs_pricing" */
  insert_org_resource_packs_pricing_one?: Maybe<Org_Resource_Packs_Pricing>;
  /** insert data into the table: "organisation_log" */
  insert_organisation_log?: Maybe<Organisation_Log_Mutation_Response>;
  /** insert a single row into the table: "organisation_log" */
  insert_organisation_log_one?: Maybe<Organisation_Log>;
  /** insert data into the table: "organisation_sector" */
  insert_organisation_sector?: Maybe<Organisation_Sector_Mutation_Response>;
  /** insert a single row into the table: "organisation_sector" */
  insert_organisation_sector_one?: Maybe<Organisation_Sector>;
  /** insert data into the table: "organization" */
  insert_organization?: Maybe<Organization_Mutation_Response>;
  /** insert data into the table: "organization_invites" */
  insert_organization_invites?: Maybe<Organization_Invites_Mutation_Response>;
  /** insert a single row into the table: "organization_invites" */
  insert_organization_invites_one?: Maybe<Organization_Invites>;
  /** insert data into the table: "organization_member" */
  insert_organization_member?: Maybe<Organization_Member_Mutation_Response>;
  /** insert a single row into the table: "organization_member" */
  insert_organization_member_one?: Maybe<Organization_Member>;
  /** insert a single row into the table: "organization" */
  insert_organization_one?: Maybe<Organization>;
  /** insert data into the table: "organization_resource_packs" */
  insert_organization_resource_packs?: Maybe<Organization_Resource_Packs_Mutation_Response>;
  /** insert a single row into the table: "organization_resource_packs" */
  insert_organization_resource_packs_one?: Maybe<Organization_Resource_Packs>;
  /** insert data into the table: "organization_type" */
  insert_organization_type?: Maybe<Organization_Type_Mutation_Response>;
  /** insert a single row into the table: "organization_type" */
  insert_organization_type_one?: Maybe<Organization_Type>;
  /** insert data into the table: "organizations_statistics" */
  insert_organizations_statistics?: Maybe<Organizations_Statistics_Mutation_Response>;
  /** insert a single row into the table: "organizations_statistics" */
  insert_organizations_statistics_one?: Maybe<Organizations_Statistics>;
  /** insert data into the table: "payment_methods" */
  insert_payment_methods?: Maybe<Payment_Methods_Mutation_Response>;
  /** insert a single row into the table: "payment_methods" */
  insert_payment_methods_one?: Maybe<Payment_Methods>;
  /** insert data into the table: "post_training_email_scheduled_events" */
  insert_post_training_email_scheduled_events?: Maybe<Post_Training_Email_Scheduled_Events_Mutation_Response>;
  /** insert a single row into the table: "post_training_email_scheduled_events" */
  insert_post_training_email_scheduled_events_one?: Maybe<Post_Training_Email_Scheduled_Events>;
  /** insert data into the table: "pre_training_email_scheduled_events" */
  insert_pre_training_email_scheduled_events?: Maybe<Pre_Training_Email_Scheduled_Events_Mutation_Response>;
  /** insert a single row into the table: "pre_training_email_scheduled_events" */
  insert_pre_training_email_scheduled_events_one?: Maybe<Pre_Training_Email_Scheduled_Events>;
  /** insert data into the table: "precision_order_status" */
  insert_precision_order_status?: Maybe<Precision_Order_Status_Mutation_Response>;
  /** insert a single row into the table: "precision_order_status" */
  insert_precision_order_status_one?: Maybe<Precision_Order_Status>;
  /** insert data into the table: "private_course_booking" */
  insert_private_course_booking?: Maybe<Private_Course_Booking_Mutation_Response>;
  /** insert a single row into the table: "private_course_booking" */
  insert_private_course_booking_one?: Maybe<Private_Course_Booking>;
  /** insert data into the table: "profile" */
  insert_profile?: Maybe<Profile_Mutation_Response>;
  /** insert a single row into the table: "profile" */
  insert_profile_one?: Maybe<Profile>;
  /** insert data into the table: "profile_role" */
  insert_profile_role?: Maybe<Profile_Role_Mutation_Response>;
  /** insert a single row into the table: "profile_role" */
  insert_profile_role_one?: Maybe<Profile_Role>;
  /** insert data into the table: "profile_temp" */
  insert_profile_temp?: Maybe<Profile_Temp_Mutation_Response>;
  /** insert a single row into the table: "profile_temp" */
  insert_profile_temp_one?: Maybe<Profile_Temp>;
  /** insert data into the table: "profile_trainer_agreement_type" */
  insert_profile_trainer_agreement_type?: Maybe<Profile_Trainer_Agreement_Type_Mutation_Response>;
  /** insert a single row into the table: "profile_trainer_agreement_type" */
  insert_profile_trainer_agreement_type_one?: Maybe<Profile_Trainer_Agreement_Type>;
  /** insert data into the table: "profile_trainer_role_type" */
  insert_profile_trainer_role_type?: Maybe<Profile_Trainer_Role_Type_Mutation_Response>;
  /** insert a single row into the table: "profile_trainer_role_type" */
  insert_profile_trainer_role_type_one?: Maybe<Profile_Trainer_Role_Type>;
  /** insert data into the table: "promo_code" */
  insert_promo_code?: Maybe<Promo_Code_Mutation_Response>;
  /** insert a single row into the table: "promo_code" */
  insert_promo_code_one?: Maybe<Promo_Code>;
  /** insert data into the table: "promo_code_type" */
  insert_promo_code_type?: Maybe<Promo_Code_Type_Mutation_Response>;
  /** insert a single row into the table: "promo_code_type" */
  insert_promo_code_type_one?: Maybe<Promo_Code_Type>;
  /** insert data into the table: "resource_pack_bundle_course_level" */
  insert_resource_pack_bundle_course_level?: Maybe<Resource_Pack_Bundle_Course_Level_Mutation_Response>;
  /** insert a single row into the table: "resource_pack_bundle_course_level" */
  insert_resource_pack_bundle_course_level_one?: Maybe<Resource_Pack_Bundle_Course_Level>;
  /** insert data into the table: "resource_pack_bundle_option" */
  insert_resource_pack_bundle_option?: Maybe<Resource_Pack_Bundle_Option_Mutation_Response>;
  /** insert a single row into the table: "resource_pack_bundle_option" */
  insert_resource_pack_bundle_option_one?: Maybe<Resource_Pack_Bundle_Option>;
  /** insert data into the table: "resource_pack_bundle_price" */
  insert_resource_pack_bundle_price?: Maybe<Resource_Pack_Bundle_Price_Mutation_Response>;
  /** insert a single row into the table: "resource_pack_bundle_price" */
  insert_resource_pack_bundle_price_one?: Maybe<Resource_Pack_Bundle_Price>;
  /** insert data into the table: "resource_packs_delivery_type" */
  insert_resource_packs_delivery_type?: Maybe<Resource_Packs_Delivery_Type_Mutation_Response>;
  /** insert a single row into the table: "resource_packs_delivery_type" */
  insert_resource_packs_delivery_type_one?: Maybe<Resource_Packs_Delivery_Type>;
  /** insert data into the table: "resource_packs_events" */
  insert_resource_packs_events?: Maybe<Resource_Packs_Events_Mutation_Response>;
  /** insert a single row into the table: "resource_packs_events" */
  insert_resource_packs_events_one?: Maybe<Resource_Packs_Events>;
  /** insert data into the table: "resource_packs_pricing" */
  insert_resource_packs_pricing?: Maybe<Resource_Packs_Pricing_Mutation_Response>;
  /** insert a single row into the table: "resource_packs_pricing" */
  insert_resource_packs_pricing_one?: Maybe<Resource_Packs_Pricing>;
  /** insert data into the table: "resource_packs_type" */
  insert_resource_packs_type?: Maybe<Resource_Packs_Type_Mutation_Response>;
  /** insert a single row into the table: "resource_packs_type" */
  insert_resource_packs_type_one?: Maybe<Resource_Packs_Type>;
  /** insert data into the table: "role" */
  insert_role?: Maybe<Role_Mutation_Response>;
  /** insert a single row into the table: "role" */
  insert_role_one?: Maybe<Role>;
  /** insert data into the table: "scheduled_events_view" */
  insert_scheduled_events_view?: Maybe<Scheduled_Events_View_Mutation_Response>;
  /** insert a single row into the table: "scheduled_events_view" */
  insert_scheduled_events_view_one?: Maybe<Scheduled_Events_View>;
  /** insert data into the table: "splash_screens" */
  insert_splash_screens?: Maybe<Splash_Screens_Mutation_Response>;
  /** insert a single row into the table: "splash_screens" */
  insert_splash_screens_one?: Maybe<Splash_Screens>;
  /** insert data into the table: "submission_of_splash_screens" */
  insert_submission_of_splash_screens?: Maybe<Submission_Of_Splash_Screens_Mutation_Response>;
  /** insert a single row into the table: "submission_of_splash_screens" */
  insert_submission_of_splash_screens_one?: Maybe<Submission_Of_Splash_Screens>;
  /** insert data into the table: "submodule" */
  insert_submodule?: Maybe<Submodule_Mutation_Response>;
  /** insert a single row into the table: "submodule" */
  insert_submodule_one?: Maybe<Submodule>;
  /** insert data into the table: "trainer_agreement_type" */
  insert_trainer_agreement_type?: Maybe<Trainer_Agreement_Type_Mutation_Response>;
  /** insert a single row into the table: "trainer_agreement_type" */
  insert_trainer_agreement_type_one?: Maybe<Trainer_Agreement_Type>;
  /** insert data into the table: "trainer_role_type" */
  insert_trainer_role_type?: Maybe<Trainer_Role_Type_Mutation_Response>;
  /** insert a single row into the table: "trainer_role_type" */
  insert_trainer_role_type_one?: Maybe<Trainer_Role_Type>;
  /** insert data into the table: "trust_type" */
  insert_trust_type?: Maybe<Trust_Type_Mutation_Response>;
  /** insert a single row into the table: "trust_type" */
  insert_trust_type_one?: Maybe<Trust_Type>;
  /** insert data into the table: "tt_client_invite_log" */
  insert_tt_client_invite_log?: Maybe<Tt_Client_Invite_Log_Mutation_Response>;
  /** insert a single row into the table: "tt_client_invite_log" */
  insert_tt_client_invite_log_one?: Maybe<Tt_Client_Invite_Log>;
  /** insert data into the table: "user_auth_audit_type" */
  insert_user_auth_audit_type?: Maybe<User_Auth_Audit_Type_Mutation_Response>;
  /** insert a single row into the table: "user_auth_audit_type" */
  insert_user_auth_audit_type_one?: Maybe<User_Auth_Audit_Type>;
  /** insert data into the table: "user_auth_audits" */
  insert_user_auth_audits?: Maybe<User_Auth_Audits_Mutation_Response>;
  /** insert a single row into the table: "user_auth_audits" */
  insert_user_auth_audits_one?: Maybe<User_Auth_Audits>;
  /** insert data into the table: "venue" */
  insert_venue?: Maybe<Venue_Mutation_Response>;
  /** insert data into the table: "venue_check_jobs" */
  insert_venue_check_jobs?: Maybe<Venue_Check_Jobs_Mutation_Response>;
  /** insert a single row into the table: "venue_check_jobs" */
  insert_venue_check_jobs_one?: Maybe<Venue_Check_Jobs>;
  /** insert a single row into the table: "venue" */
  insert_venue_one?: Maybe<Venue>;
  /** insert data into the table: "waitlist" */
  insert_waitlist?: Maybe<Waitlist_Mutation_Response>;
  /** insert a single row into the table: "waitlist" */
  insert_waitlist_one?: Maybe<Waitlist>;
  /** insert data into the table: "xero_contact" */
  insert_xero_contact?: Maybe<Xero_Contact_Mutation_Response>;
  /** insert a single row into the table: "xero_contact" */
  insert_xero_contact_one?: Maybe<Xero_Contact>;
  /** insert data into the table: "xero_credential" */
  insert_xero_credential?: Maybe<Xero_Credential_Mutation_Response>;
  /** insert a single row into the table: "xero_credential" */
  insert_xero_credential_one?: Maybe<Xero_Credential>;
  /** insert data into the table: "xero_invoice" */
  insert_xero_invoice?: Maybe<Xero_Invoice_Mutation_Response>;
  /** insert a single row into the table: "xero_invoice" */
  insert_xero_invoice_one?: Maybe<Xero_Invoice>;
  /** insert data into the table: "xero_invoice_status" */
  insert_xero_invoice_status?: Maybe<Xero_Invoice_Status_Mutation_Response>;
  /** insert a single row into the table: "xero_invoice_status" */
  insert_xero_invoice_status_one?: Maybe<Xero_Invoice_Status>;
  /** joinWaitlist */
  joinWaitlist: JoinWaitlistOutput;
  /** This actions manages the merging of two or more organisations */
  mergeOrganisations?: Maybe<MergeOrganisationsOutput>;
  /** Merge users */
  mergeUser: MergeUserOutput;
  /** Notify course's trainer(s) and attendees about course editing */
  notifyCourseEdit: NotifyCourseEditOutput;
  /** notifyInternalUsersOfInviteAttempt */
  notifyInternalUsersOfInviteAttempt?: Maybe<NotifyInternalUsersOfInviteAttemptOutput>;
  /** Creates a membership plan */
  plansCreate?: Maybe<PlansCreateResult>;
  purchaseMaterials: PurchaseMaterialsOutput;
  /** This action is called when a Admin / LD role Rejects a course in status Exceptions Approval Pending */
  rejectCourse?: Maybe<RejectCourseOutput>;
  /** replaceParticipant */
  replaceParticipant?: Maybe<ReplaceParticipantOutput>;
  resendPassword: Scalars['Boolean'];
  /** Used to reserve additional resource packs for an Indirect course without requiring the organization to purchase more. */
  reserveResourcePacks?: Maybe<ResourcePacksReserveOutput>;
  /** saveOrgInvites */
  saveOrgInvites?: Maybe<SampleOutput>;
  /** The action will create a schedule event for sending about training surveys to certified attendees */
  scheduleAboutTrainingSurveys?: Maybe<ScheduleAboutTrainingSurveysOutput>;
  /** Send course evaluation reminders to individual attendees or to all participants at once. */
  sendCourseEvaluationReminder: SendCourseEvaluationReminderOutput;
  /** Send course information to the specified course attendees */
  sendCourseInformation: SendCourseInformationOutput;
  /** Creates a temporary profile */
  signUp?: Maybe<SignUpOutput>;
  stripeCreatePaymentIntent?: Maybe<StripeCreatePaymentIntentOutput>;
  /** transferParticipant */
  transferParticipant?: Maybe<TransferParticipantOutput>;
  updateAvatar?: Maybe<UpdateAvatarResponse>;
  updateUserProfile: Scalars['Boolean'];
  /** update data of the table: "about_training_email_scheduled_events" */
  update_about_training_email_scheduled_events?: Maybe<About_Training_Email_Scheduled_Events_Mutation_Response>;
  /** update single row of the table: "about_training_email_scheduled_events" */
  update_about_training_email_scheduled_events_by_pk?: Maybe<About_Training_Email_Scheduled_Events>;
  /** update multiples rows of table: "about_training_email_scheduled_events" */
  update_about_training_email_scheduled_events_many?: Maybe<Array<Maybe<About_Training_Email_Scheduled_Events_Mutation_Response>>>;
  /** update data of the table: "absorb_enrolment" */
  update_absorb_enrolment?: Maybe<Absorb_Enrolment_Mutation_Response>;
  /** update single row of the table: "absorb_enrolment" */
  update_absorb_enrolment_by_pk?: Maybe<Absorb_Enrolment>;
  /** update multiples rows of table: "absorb_enrolment" */
  update_absorb_enrolment_many?: Maybe<Array<Maybe<Absorb_Enrolment_Mutation_Response>>>;
  /** update data of the table: "accreditors" */
  update_accreditors?: Maybe<Accreditors_Mutation_Response>;
  /** update single row of the table: "accreditors" */
  update_accreditors_by_pk?: Maybe<Accreditors>;
  /** update multiples rows of table: "accreditors" */
  update_accreditors_many?: Maybe<Array<Maybe<Accreditors_Mutation_Response>>>;
  /** execute VOLATILE function "update_all_organizations_statistics" which returns "organizations_statistics" */
  update_all_organizations_statistics: Array<Organizations_Statistics>;
  /** update data of the table: "availability" */
  update_availability?: Maybe<Availability_Mutation_Response>;
  /** update single row of the table: "availability" */
  update_availability_by_pk?: Maybe<Availability>;
  /** update multiples rows of table: "availability" */
  update_availability_many?: Maybe<Array<Maybe<Availability_Mutation_Response>>>;
  /** update data of the table: "bild_strategy" */
  update_bild_strategy?: Maybe<Bild_Strategy_Mutation_Response>;
  /** update single row of the table: "bild_strategy" */
  update_bild_strategy_by_pk?: Maybe<Bild_Strategy>;
  /** update multiples rows of table: "bild_strategy" */
  update_bild_strategy_many?: Maybe<Array<Maybe<Bild_Strategy_Mutation_Response>>>;
  /** update data of the table: "blended_learning_status" */
  update_blended_learning_status?: Maybe<Blended_Learning_Status_Mutation_Response>;
  /** update single row of the table: "blended_learning_status" */
  update_blended_learning_status_by_pk?: Maybe<Blended_Learning_Status>;
  /** update multiples rows of table: "blended_learning_status" */
  update_blended_learning_status_many?: Maybe<Array<Maybe<Blended_Learning_Status_Mutation_Response>>>;
  /** update data of the table: "certificate_expired_notification_jobs" */
  update_certificate_expired_notification_jobs?: Maybe<Certificate_Expired_Notification_Jobs_Mutation_Response>;
  /** update single row of the table: "certificate_expired_notification_jobs" */
  update_certificate_expired_notification_jobs_by_pk?: Maybe<Certificate_Expired_Notification_Jobs>;
  /** update multiples rows of table: "certificate_expired_notification_jobs" */
  update_certificate_expired_notification_jobs_many?: Maybe<Array<Maybe<Certificate_Expired_Notification_Jobs_Mutation_Response>>>;
  /** update data of the table: "certificate_expiry_notification_jobs" */
  update_certificate_expiry_notification_jobs?: Maybe<Certificate_Expiry_Notification_Jobs_Mutation_Response>;
  /** update single row of the table: "certificate_expiry_notification_jobs" */
  update_certificate_expiry_notification_jobs_by_pk?: Maybe<Certificate_Expiry_Notification_Jobs>;
  /** update multiples rows of table: "certificate_expiry_notification_jobs" */
  update_certificate_expiry_notification_jobs_many?: Maybe<Array<Maybe<Certificate_Expiry_Notification_Jobs_Mutation_Response>>>;
  /** update data of the table: "certificate_expiry_notification_timeframe" */
  update_certificate_expiry_notification_timeframe?: Maybe<Certificate_Expiry_Notification_Timeframe_Mutation_Response>;
  /** update single row of the table: "certificate_expiry_notification_timeframe" */
  update_certificate_expiry_notification_timeframe_by_pk?: Maybe<Certificate_Expiry_Notification_Timeframe>;
  /** update multiples rows of table: "certificate_expiry_notification_timeframe" */
  update_certificate_expiry_notification_timeframe_many?: Maybe<Array<Maybe<Certificate_Expiry_Notification_Timeframe_Mutation_Response>>>;
  /** update data of the table: "certificate_status" */
  update_certificate_status?: Maybe<Certificate_Status_Mutation_Response>;
  /** update single row of the table: "certificate_status" */
  update_certificate_status_by_pk?: Maybe<Certificate_Status>;
  /** update multiples rows of table: "certificate_status" */
  update_certificate_status_many?: Maybe<Array<Maybe<Certificate_Status_Mutation_Response>>>;
  /** execute VOLATILE function "update_certification_statuses" which returns "course_certificate" */
  update_certification_statuses: Array<Course_Certificate>;
  /** update data of the table: "color" */
  update_color?: Maybe<Color_Mutation_Response>;
  /** update single row of the table: "color" */
  update_color_by_pk?: Maybe<Color>;
  /** update multiples rows of table: "color" */
  update_color_many?: Maybe<Array<Maybe<Color_Mutation_Response>>>;
  /** update data of the table: "country" */
  update_country?: Maybe<Country_Mutation_Response>;
  /** update single row of the table: "country" */
  update_country_by_pk?: Maybe<Country>;
  /** update multiples rows of table: "country" */
  update_country_many?: Maybe<Array<Maybe<Country_Mutation_Response>>>;
  /** update data of the table: "country_region" */
  update_country_region?: Maybe<Country_Region_Mutation_Response>;
  /** update single row of the table: "country_region" */
  update_country_region_by_pk?: Maybe<Country_Region>;
  /** update multiples rows of table: "country_region" */
  update_country_region_many?: Maybe<Array<Maybe<Country_Region_Mutation_Response>>>;
  /** update data of the table: "course" */
  update_course?: Maybe<Course_Mutation_Response>;
  /** update data of the table: "course_audit" */
  update_course_audit?: Maybe<Course_Audit_Mutation_Response>;
  /** update single row of the table: "course_audit" */
  update_course_audit_by_pk?: Maybe<Course_Audit>;
  /** update multiples rows of table: "course_audit" */
  update_course_audit_many?: Maybe<Array<Maybe<Course_Audit_Mutation_Response>>>;
  /** update data of the table: "course_audit_type" */
  update_course_audit_type?: Maybe<Course_Audit_Type_Mutation_Response>;
  /** update single row of the table: "course_audit_type" */
  update_course_audit_type_by_pk?: Maybe<Course_Audit_Type>;
  /** update multiples rows of table: "course_audit_type" */
  update_course_audit_type_many?: Maybe<Array<Maybe<Course_Audit_Type_Mutation_Response>>>;
  /** update data of the table: "course_bild_module" */
  update_course_bild_module?: Maybe<Course_Bild_Module_Mutation_Response>;
  /** update single row of the table: "course_bild_module" */
  update_course_bild_module_by_pk?: Maybe<Course_Bild_Module>;
  /** update multiples rows of table: "course_bild_module" */
  update_course_bild_module_many?: Maybe<Array<Maybe<Course_Bild_Module_Mutation_Response>>>;
  /** update data of the table: "course_bild_strategy" */
  update_course_bild_strategy?: Maybe<Course_Bild_Strategy_Mutation_Response>;
  /** update single row of the table: "course_bild_strategy" */
  update_course_bild_strategy_by_pk?: Maybe<Course_Bild_Strategy>;
  /** update multiples rows of table: "course_bild_strategy" */
  update_course_bild_strategy_many?: Maybe<Array<Maybe<Course_Bild_Strategy_Mutation_Response>>>;
  /** update single row of the table: "course" */
  update_course_by_pk?: Maybe<Course>;
  /** update data of the table: "course_cancellation_fee_type" */
  update_course_cancellation_fee_type?: Maybe<Course_Cancellation_Fee_Type_Mutation_Response>;
  /** update single row of the table: "course_cancellation_fee_type" */
  update_course_cancellation_fee_type_by_pk?: Maybe<Course_Cancellation_Fee_Type>;
  /** update multiples rows of table: "course_cancellation_fee_type" */
  update_course_cancellation_fee_type_many?: Maybe<Array<Maybe<Course_Cancellation_Fee_Type_Mutation_Response>>>;
  /** update data of the table: "course_cancellation_request" */
  update_course_cancellation_request?: Maybe<Course_Cancellation_Request_Mutation_Response>;
  /** update single row of the table: "course_cancellation_request" */
  update_course_cancellation_request_by_pk?: Maybe<Course_Cancellation_Request>;
  /** update multiples rows of table: "course_cancellation_request" */
  update_course_cancellation_request_many?: Maybe<Array<Maybe<Course_Cancellation_Request_Mutation_Response>>>;
  /** update data of the table: "course_certificate" */
  update_course_certificate?: Maybe<Course_Certificate_Mutation_Response>;
  /** update single row of the table: "course_certificate" */
  update_course_certificate_by_pk?: Maybe<Course_Certificate>;
  /** update data of the table: "course_certificate_changelog" */
  update_course_certificate_changelog?: Maybe<Course_Certificate_Changelog_Mutation_Response>;
  /** update single row of the table: "course_certificate_changelog" */
  update_course_certificate_changelog_by_pk?: Maybe<Course_Certificate_Changelog>;
  /** update multiples rows of table: "course_certificate_changelog" */
  update_course_certificate_changelog_many?: Maybe<Array<Maybe<Course_Certificate_Changelog_Mutation_Response>>>;
  /** update data of the table: "course_certificate_changelog_type" */
  update_course_certificate_changelog_type?: Maybe<Course_Certificate_Changelog_Type_Mutation_Response>;
  /** update single row of the table: "course_certificate_changelog_type" */
  update_course_certificate_changelog_type_by_pk?: Maybe<Course_Certificate_Changelog_Type>;
  /** update multiples rows of table: "course_certificate_changelog_type" */
  update_course_certificate_changelog_type_many?: Maybe<Array<Maybe<Course_Certificate_Changelog_Type_Mutation_Response>>>;
  /** update data of the table: "course_certificate_hold_request" */
  update_course_certificate_hold_request?: Maybe<Course_Certificate_Hold_Request_Mutation_Response>;
  /** update single row of the table: "course_certificate_hold_request" */
  update_course_certificate_hold_request_by_pk?: Maybe<Course_Certificate_Hold_Request>;
  /** update multiples rows of table: "course_certificate_hold_request" */
  update_course_certificate_hold_request_many?: Maybe<Array<Maybe<Course_Certificate_Hold_Request_Mutation_Response>>>;
  /** update multiples rows of table: "course_certificate" */
  update_course_certificate_many?: Maybe<Array<Maybe<Course_Certificate_Mutation_Response>>>;
  /** update data of the table: "course_delivery_type" */
  update_course_delivery_type?: Maybe<Course_Delivery_Type_Mutation_Response>;
  /** update single row of the table: "course_delivery_type" */
  update_course_delivery_type_by_pk?: Maybe<Course_Delivery_Type>;
  /** update multiples rows of table: "course_delivery_type" */
  update_course_delivery_type_many?: Maybe<Array<Maybe<Course_Delivery_Type_Mutation_Response>>>;
  /** update data of the table: "course_delivery_type_prefix" */
  update_course_delivery_type_prefix?: Maybe<Course_Delivery_Type_Prefix_Mutation_Response>;
  /** update single row of the table: "course_delivery_type_prefix" */
  update_course_delivery_type_prefix_by_pk?: Maybe<Course_Delivery_Type_Prefix>;
  /** update multiples rows of table: "course_delivery_type_prefix" */
  update_course_delivery_type_prefix_many?: Maybe<Array<Maybe<Course_Delivery_Type_Prefix_Mutation_Response>>>;
  /** update data of the table: "course_draft" */
  update_course_draft?: Maybe<Course_Draft_Mutation_Response>;
  /** update single row of the table: "course_draft" */
  update_course_draft_by_pk?: Maybe<Course_Draft>;
  /** update multiples rows of table: "course_draft" */
  update_course_draft_many?: Maybe<Array<Maybe<Course_Draft_Mutation_Response>>>;
  /** update data of the table: "course_end_jobs" */
  update_course_end_jobs?: Maybe<Course_End_Jobs_Mutation_Response>;
  /** update single row of the table: "course_end_jobs" */
  update_course_end_jobs_by_pk?: Maybe<Course_End_Jobs>;
  /** update multiples rows of table: "course_end_jobs" */
  update_course_end_jobs_many?: Maybe<Array<Maybe<Course_End_Jobs_Mutation_Response>>>;
  /** update data of the table: "course_enquiry" */
  update_course_enquiry?: Maybe<Course_Enquiry_Mutation_Response>;
  /** update single row of the table: "course_enquiry" */
  update_course_enquiry_by_pk?: Maybe<Course_Enquiry>;
  /** update multiples rows of table: "course_enquiry" */
  update_course_enquiry_many?: Maybe<Array<Maybe<Course_Enquiry_Mutation_Response>>>;
  /** update data of the table: "course_evaluation_answers" */
  update_course_evaluation_answers?: Maybe<Course_Evaluation_Answers_Mutation_Response>;
  /** update single row of the table: "course_evaluation_answers" */
  update_course_evaluation_answers_by_pk?: Maybe<Course_Evaluation_Answers>;
  /** update multiples rows of table: "course_evaluation_answers" */
  update_course_evaluation_answers_many?: Maybe<Array<Maybe<Course_Evaluation_Answers_Mutation_Response>>>;
  /** update data of the table: "course_evaluation_question_group" */
  update_course_evaluation_question_group?: Maybe<Course_Evaluation_Question_Group_Mutation_Response>;
  /** update single row of the table: "course_evaluation_question_group" */
  update_course_evaluation_question_group_by_pk?: Maybe<Course_Evaluation_Question_Group>;
  /** update multiples rows of table: "course_evaluation_question_group" */
  update_course_evaluation_question_group_many?: Maybe<Array<Maybe<Course_Evaluation_Question_Group_Mutation_Response>>>;
  /** update data of the table: "course_evaluation_question_type" */
  update_course_evaluation_question_type?: Maybe<Course_Evaluation_Question_Type_Mutation_Response>;
  /** update single row of the table: "course_evaluation_question_type" */
  update_course_evaluation_question_type_by_pk?: Maybe<Course_Evaluation_Question_Type>;
  /** update multiples rows of table: "course_evaluation_question_type" */
  update_course_evaluation_question_type_many?: Maybe<Array<Maybe<Course_Evaluation_Question_Type_Mutation_Response>>>;
  /** update data of the table: "course_evaluation_questions" */
  update_course_evaluation_questions?: Maybe<Course_Evaluation_Questions_Mutation_Response>;
  /** update single row of the table: "course_evaluation_questions" */
  update_course_evaluation_questions_by_pk?: Maybe<Course_Evaluation_Questions>;
  /** update multiples rows of table: "course_evaluation_questions" */
  update_course_evaluation_questions_many?: Maybe<Array<Maybe<Course_Evaluation_Questions_Mutation_Response>>>;
  /** update data of the table: "course_evaluation_scheduled_event" */
  update_course_evaluation_scheduled_event?: Maybe<Course_Evaluation_Scheduled_Event_Mutation_Response>;
  /** update single row of the table: "course_evaluation_scheduled_event" */
  update_course_evaluation_scheduled_event_by_pk?: Maybe<Course_Evaluation_Scheduled_Event>;
  /** update multiples rows of table: "course_evaluation_scheduled_event" */
  update_course_evaluation_scheduled_event_many?: Maybe<Array<Maybe<Course_Evaluation_Scheduled_Event_Mutation_Response>>>;
  /** update data of the table: "course_exception" */
  update_course_exception?: Maybe<Course_Exception_Mutation_Response>;
  /** update single row of the table: "course_exception" */
  update_course_exception_by_pk?: Maybe<Course_Exception>;
  /** update multiples rows of table: "course_exception" */
  update_course_exception_many?: Maybe<Array<Maybe<Course_Exception_Mutation_Response>>>;
  /** update data of the table: "course_exceptions" */
  update_course_exceptions?: Maybe<Course_Exceptions_Mutation_Response>;
  /** update single row of the table: "course_exceptions" */
  update_course_exceptions_by_pk?: Maybe<Course_Exceptions>;
  /** update multiples rows of table: "course_exceptions" */
  update_course_exceptions_many?: Maybe<Array<Maybe<Course_Exceptions_Mutation_Response>>>;
  /** update data of the table: "course_expenses" */
  update_course_expenses?: Maybe<Course_Expenses_Mutation_Response>;
  /** update single row of the table: "course_expenses" */
  update_course_expenses_by_pk?: Maybe<Course_Expenses>;
  /** update multiples rows of table: "course_expenses" */
  update_course_expenses_many?: Maybe<Array<Maybe<Course_Expenses_Mutation_Response>>>;
  /** update data of the table: "course_invite_status" */
  update_course_invite_status?: Maybe<Course_Invite_Status_Mutation_Response>;
  /** update single row of the table: "course_invite_status" */
  update_course_invite_status_by_pk?: Maybe<Course_Invite_Status>;
  /** update multiples rows of table: "course_invite_status" */
  update_course_invite_status_many?: Maybe<Array<Maybe<Course_Invite_Status_Mutation_Response>>>;
  /** update data of the table: "course_invites" */
  update_course_invites?: Maybe<Course_Invites_Mutation_Response>;
  /** update single row of the table: "course_invites" */
  update_course_invites_by_pk?: Maybe<Course_Invites>;
  /** update multiples rows of table: "course_invites" */
  update_course_invites_many?: Maybe<Array<Maybe<Course_Invites_Mutation_Response>>>;
  /** update data of the table: "course_level" */
  update_course_level?: Maybe<Course_Level_Mutation_Response>;
  /** update single row of the table: "course_level" */
  update_course_level_by_pk?: Maybe<Course_Level>;
  /** update multiples rows of table: "course_level" */
  update_course_level_many?: Maybe<Array<Maybe<Course_Level_Mutation_Response>>>;
  /** update data of the table: "course_level_prefix" */
  update_course_level_prefix?: Maybe<Course_Level_Prefix_Mutation_Response>;
  /** update single row of the table: "course_level_prefix" */
  update_course_level_prefix_by_pk?: Maybe<Course_Level_Prefix>;
  /** update multiples rows of table: "course_level_prefix" */
  update_course_level_prefix_many?: Maybe<Array<Maybe<Course_Level_Prefix_Mutation_Response>>>;
  /** update multiples rows of table: "course" */
  update_course_many?: Maybe<Array<Maybe<Course_Mutation_Response>>>;
  /** update data of the table: "course_module" */
  update_course_module?: Maybe<Course_Module_Mutation_Response>;
  /** update single row of the table: "course_module" */
  update_course_module_by_pk?: Maybe<Course_Module>;
  /** update multiples rows of table: "course_module" */
  update_course_module_many?: Maybe<Array<Maybe<Course_Module_Mutation_Response>>>;
  /** update data of the table: "course_order" */
  update_course_order?: Maybe<Course_Order_Mutation_Response>;
  /** update multiples rows of table: "course_order" */
  update_course_order_many?: Maybe<Array<Maybe<Course_Order_Mutation_Response>>>;
  /** update data of the table: "course_participant" */
  update_course_participant?: Maybe<Course_Participant_Mutation_Response>;
  /** update data of the table: "course_participant_audit" */
  update_course_participant_audit?: Maybe<Course_Participant_Audit_Mutation_Response>;
  /** update single row of the table: "course_participant_audit" */
  update_course_participant_audit_by_pk?: Maybe<Course_Participant_Audit>;
  /** update multiples rows of table: "course_participant_audit" */
  update_course_participant_audit_many?: Maybe<Array<Maybe<Course_Participant_Audit_Mutation_Response>>>;
  /** update data of the table: "course_participant_audit_type" */
  update_course_participant_audit_type?: Maybe<Course_Participant_Audit_Type_Mutation_Response>;
  /** update single row of the table: "course_participant_audit_type" */
  update_course_participant_audit_type_by_pk?: Maybe<Course_Participant_Audit_Type>;
  /** update multiples rows of table: "course_participant_audit_type" */
  update_course_participant_audit_type_many?: Maybe<Array<Maybe<Course_Participant_Audit_Type_Mutation_Response>>>;
  /** update data of the table: "course_participant_bild_module" */
  update_course_participant_bild_module?: Maybe<Course_Participant_Bild_Module_Mutation_Response>;
  /** update single row of the table: "course_participant_bild_module" */
  update_course_participant_bild_module_by_pk?: Maybe<Course_Participant_Bild_Module>;
  /** update multiples rows of table: "course_participant_bild_module" */
  update_course_participant_bild_module_many?: Maybe<Array<Maybe<Course_Participant_Bild_Module_Mutation_Response>>>;
  /** update single row of the table: "course_participant" */
  update_course_participant_by_pk?: Maybe<Course_Participant>;
  /** update data of the table: "course_participant_cancellation" */
  update_course_participant_cancellation?: Maybe<Course_Participant_Cancellation_Mutation_Response>;
  /** update single row of the table: "course_participant_cancellation" */
  update_course_participant_cancellation_by_pk?: Maybe<Course_Participant_Cancellation>;
  /** update multiples rows of table: "course_participant_cancellation" */
  update_course_participant_cancellation_many?: Maybe<Array<Maybe<Course_Participant_Cancellation_Mutation_Response>>>;
  /** update multiples rows of table: "course_participant" */
  update_course_participant_many?: Maybe<Array<Maybe<Course_Participant_Mutation_Response>>>;
  /** update data of the table: "course_participant_module" */
  update_course_participant_module?: Maybe<Course_Participant_Module_Mutation_Response>;
  /** update single row of the table: "course_participant_module" */
  update_course_participant_module_by_pk?: Maybe<Course_Participant_Module>;
  /** update multiples rows of table: "course_participant_module" */
  update_course_participant_module_many?: Maybe<Array<Maybe<Course_Participant_Module_Mutation_Response>>>;
  /** update data of the table: "course_participant_note" */
  update_course_participant_note?: Maybe<Course_Participant_Note_Mutation_Response>;
  /** update single row of the table: "course_participant_note" */
  update_course_participant_note_by_pk?: Maybe<Course_Participant_Note>;
  /** update multiples rows of table: "course_participant_note" */
  update_course_participant_note_many?: Maybe<Array<Maybe<Course_Participant_Note_Mutation_Response>>>;
  /** update data of the table: "course_pricing" */
  update_course_pricing?: Maybe<Course_Pricing_Mutation_Response>;
  /** update single row of the table: "course_pricing" */
  update_course_pricing_by_pk?: Maybe<Course_Pricing>;
  /** update data of the table: "course_pricing_changelog" */
  update_course_pricing_changelog?: Maybe<Course_Pricing_Changelog_Mutation_Response>;
  /** update single row of the table: "course_pricing_changelog" */
  update_course_pricing_changelog_by_pk?: Maybe<Course_Pricing_Changelog>;
  /** update multiples rows of table: "course_pricing_changelog" */
  update_course_pricing_changelog_many?: Maybe<Array<Maybe<Course_Pricing_Changelog_Mutation_Response>>>;
  /** update multiples rows of table: "course_pricing" */
  update_course_pricing_many?: Maybe<Array<Maybe<Course_Pricing_Mutation_Response>>>;
  /** update data of the table: "course_pricing_schedule" */
  update_course_pricing_schedule?: Maybe<Course_Pricing_Schedule_Mutation_Response>;
  /** update single row of the table: "course_pricing_schedule" */
  update_course_pricing_schedule_by_pk?: Maybe<Course_Pricing_Schedule>;
  /** update multiples rows of table: "course_pricing_schedule" */
  update_course_pricing_schedule_many?: Maybe<Array<Maybe<Course_Pricing_Schedule_Mutation_Response>>>;
  /** update data of the table: "course_promo_code" */
  update_course_promo_code?: Maybe<Course_Promo_Code_Mutation_Response>;
  /** update single row of the table: "course_promo_code" */
  update_course_promo_code_by_pk?: Maybe<Course_Promo_Code>;
  /** update multiples rows of table: "course_promo_code" */
  update_course_promo_code_many?: Maybe<Array<Maybe<Course_Promo_Code_Mutation_Response>>>;
  /** update data of the table: "course_renewal_cycle" */
  update_course_renewal_cycle?: Maybe<Course_Renewal_Cycle_Mutation_Response>;
  /** update single row of the table: "course_renewal_cycle" */
  update_course_renewal_cycle_by_pk?: Maybe<Course_Renewal_Cycle>;
  /** update multiples rows of table: "course_renewal_cycle" */
  update_course_renewal_cycle_many?: Maybe<Array<Maybe<Course_Renewal_Cycle_Mutation_Response>>>;
  /** update data of the table: "course_schedule" */
  update_course_schedule?: Maybe<Course_Schedule_Mutation_Response>;
  /** update single row of the table: "course_schedule" */
  update_course_schedule_by_pk?: Maybe<Course_Schedule>;
  /** update multiples rows of table: "course_schedule" */
  update_course_schedule_many?: Maybe<Array<Maybe<Course_Schedule_Mutation_Response>>>;
  /** update data of the table: "course_source" */
  update_course_source?: Maybe<Course_Source_Mutation_Response>;
  /** update single row of the table: "course_source" */
  update_course_source_by_pk?: Maybe<Course_Source>;
  /** update multiples rows of table: "course_source" */
  update_course_source_many?: Maybe<Array<Maybe<Course_Source_Mutation_Response>>>;
  /** update data of the table: "course_status" */
  update_course_status?: Maybe<Course_Status_Mutation_Response>;
  /** update single row of the table: "course_status" */
  update_course_status_by_pk?: Maybe<Course_Status>;
  /** update multiples rows of table: "course_status" */
  update_course_status_many?: Maybe<Array<Maybe<Course_Status_Mutation_Response>>>;
  /** update data of the table: "course_trainer" */
  update_course_trainer?: Maybe<Course_Trainer_Mutation_Response>;
  /** update single row of the table: "course_trainer" */
  update_course_trainer_by_pk?: Maybe<Course_Trainer>;
  /** update multiples rows of table: "course_trainer" */
  update_course_trainer_many?: Maybe<Array<Maybe<Course_Trainer_Mutation_Response>>>;
  /** update data of the table: "course_trainer_type" */
  update_course_trainer_type?: Maybe<Course_Trainer_Type_Mutation_Response>;
  /** update single row of the table: "course_trainer_type" */
  update_course_trainer_type_by_pk?: Maybe<Course_Trainer_Type>;
  /** update multiples rows of table: "course_trainer_type" */
  update_course_trainer_type_many?: Maybe<Array<Maybe<Course_Trainer_Type_Mutation_Response>>>;
  /** update data of the table: "course_type" */
  update_course_type?: Maybe<Course_Type_Mutation_Response>;
  /** update single row of the table: "course_type" */
  update_course_type_by_pk?: Maybe<Course_Type>;
  /** update multiples rows of table: "course_type" */
  update_course_type_many?: Maybe<Array<Maybe<Course_Type_Mutation_Response>>>;
  /** update data of the table: "course_type_prefix" */
  update_course_type_prefix?: Maybe<Course_Type_Prefix_Mutation_Response>;
  /** update single row of the table: "course_type_prefix" */
  update_course_type_prefix_by_pk?: Maybe<Course_Type_Prefix>;
  /** update multiples rows of table: "course_type_prefix" */
  update_course_type_prefix_many?: Maybe<Array<Maybe<Course_Type_Prefix_Mutation_Response>>>;
  /** update data of the table: "cqc_establishment" */
  update_cqc_establishment?: Maybe<Cqc_Establishment_Mutation_Response>;
  /** update single row of the table: "cqc_establishment" */
  update_cqc_establishment_by_pk?: Maybe<Cqc_Establishment>;
  /** update multiples rows of table: "cqc_establishment" */
  update_cqc_establishment_many?: Maybe<Array<Maybe<Cqc_Establishment_Mutation_Response>>>;
  /** update data of the table: "cud_operation" */
  update_cud_operation?: Maybe<Cud_Operation_Mutation_Response>;
  /** update single row of the table: "cud_operation" */
  update_cud_operation_by_pk?: Maybe<Cud_Operation>;
  /** update multiples rows of table: "cud_operation" */
  update_cud_operation_many?: Maybe<Array<Maybe<Cud_Operation_Mutation_Response>>>;
  /** update data of the table: "deleted_organizations_backup" */
  update_deleted_organizations_backup?: Maybe<Deleted_Organizations_Backup_Mutation_Response>;
  /** update multiples rows of table: "deleted_organizations_backup" */
  update_deleted_organizations_backup_many?: Maybe<Array<Maybe<Deleted_Organizations_Backup_Mutation_Response>>>;
  /** update data of the table: "dfe_establishment" */
  update_dfe_establishment?: Maybe<Dfe_Establishment_Mutation_Response>;
  /** update single row of the table: "dfe_establishment" */
  update_dfe_establishment_by_pk?: Maybe<Dfe_Establishment>;
  /** update multiples rows of table: "dfe_establishment" */
  update_dfe_establishment_many?: Maybe<Array<Maybe<Dfe_Establishment_Mutation_Response>>>;
  /** update data of the table: "email_notifications" */
  update_email_notifications?: Maybe<Email_Notifications_Mutation_Response>;
  /** update single row of the table: "email_notifications" */
  update_email_notifications_by_pk?: Maybe<Email_Notifications>;
  /** update multiples rows of table: "email_notifications" */
  update_email_notifications_many?: Maybe<Array<Maybe<Email_Notifications_Mutation_Response>>>;
  /** update data of the table: "expire_go1_license_jobs" */
  update_expire_go1_license_jobs?: Maybe<Expire_Go1_License_Jobs_Mutation_Response>;
  /** update single row of the table: "expire_go1_license_jobs" */
  update_expire_go1_license_jobs_by_pk?: Maybe<Expire_Go1_License_Jobs>;
  /** update multiples rows of table: "expire_go1_license_jobs" */
  update_expire_go1_license_jobs_many?: Maybe<Array<Maybe<Expire_Go1_License_Jobs_Mutation_Response>>>;
  /** update data of the table: "go1_history_events" */
  update_go1_history_events?: Maybe<Go1_History_Events_Mutation_Response>;
  /** update single row of the table: "go1_history_events" */
  update_go1_history_events_by_pk?: Maybe<Go1_History_Events>;
  /** update multiples rows of table: "go1_history_events" */
  update_go1_history_events_many?: Maybe<Array<Maybe<Go1_History_Events_Mutation_Response>>>;
  /** update data of the table: "go1_licenses" */
  update_go1_licenses?: Maybe<Go1_Licenses_Mutation_Response>;
  /** update single row of the table: "go1_licenses" */
  update_go1_licenses_by_pk?: Maybe<Go1_Licenses>;
  /** update data of the table: "go1_licenses_history" */
  update_go1_licenses_history?: Maybe<Go1_Licenses_History_Mutation_Response>;
  /** update single row of the table: "go1_licenses_history" */
  update_go1_licenses_history_by_pk?: Maybe<Go1_Licenses_History>;
  /** update multiples rows of table: "go1_licenses_history" */
  update_go1_licenses_history_many?: Maybe<Array<Maybe<Go1_Licenses_History_Mutation_Response>>>;
  /** update multiples rows of table: "go1_licenses" */
  update_go1_licenses_many?: Maybe<Array<Maybe<Go1_Licenses_Mutation_Response>>>;
  /** update data of the table: "grade" */
  update_grade?: Maybe<Grade_Mutation_Response>;
  /** update single row of the table: "grade" */
  update_grade_by_pk?: Maybe<Grade>;
  /** update multiples rows of table: "grade" */
  update_grade_many?: Maybe<Array<Maybe<Grade_Mutation_Response>>>;
  /** update data of the table: "hubspot_audit" */
  update_hubspot_audit?: Maybe<Hubspot_Audit_Mutation_Response>;
  /** update single row of the table: "hubspot_audit" */
  update_hubspot_audit_by_pk?: Maybe<Hubspot_Audit>;
  /** update multiples rows of table: "hubspot_audit" */
  update_hubspot_audit_many?: Maybe<Array<Maybe<Hubspot_Audit_Mutation_Response>>>;
  /** update data of the table: "identity" */
  update_identity?: Maybe<Identity_Mutation_Response>;
  /** update single row of the table: "identity" */
  update_identity_by_pk?: Maybe<Identity>;
  /** update multiples rows of table: "identity" */
  update_identity_many?: Maybe<Array<Maybe<Identity_Mutation_Response>>>;
  /** update data of the table: "identity_type" */
  update_identity_type?: Maybe<Identity_Type_Mutation_Response>;
  /** update single row of the table: "identity_type" */
  update_identity_type_by_pk?: Maybe<Identity_Type>;
  /** update multiples rows of table: "identity_type" */
  update_identity_type_many?: Maybe<Array<Maybe<Identity_Type_Mutation_Response>>>;
  /** update data of the table: "import_job" */
  update_import_job?: Maybe<Import_Job_Mutation_Response>;
  /** update single row of the table: "import_job" */
  update_import_job_by_pk?: Maybe<Import_Job>;
  /** update multiples rows of table: "import_job" */
  update_import_job_many?: Maybe<Array<Maybe<Import_Job_Mutation_Response>>>;
  /** update data of the table: "import_job_status" */
  update_import_job_status?: Maybe<Import_Job_Status_Mutation_Response>;
  /** update single row of the table: "import_job_status" */
  update_import_job_status_by_pk?: Maybe<Import_Job_Status>;
  /** update multiples rows of table: "import_job_status" */
  update_import_job_status_many?: Maybe<Array<Maybe<Import_Job_Status_Mutation_Response>>>;
  /** update data of the table: "import_job_type" */
  update_import_job_type?: Maybe<Import_Job_Type_Mutation_Response>;
  /** update single row of the table: "import_job_type" */
  update_import_job_type_by_pk?: Maybe<Import_Job_Type>;
  /** update multiples rows of table: "import_job_type" */
  update_import_job_type_many?: Maybe<Array<Maybe<Import_Job_Type_Mutation_Response>>>;
  /** update data of the table: "job_title" */
  update_job_title?: Maybe<Job_Title_Mutation_Response>;
  /** update single row of the table: "job_title" */
  update_job_title_by_pk?: Maybe<Job_Title>;
  /** update multiples rows of table: "job_title" */
  update_job_title_many?: Maybe<Array<Maybe<Job_Title_Mutation_Response>>>;
  /** update data of the table: "legacy_certificate" */
  update_legacy_certificate?: Maybe<Legacy_Certificate_Mutation_Response>;
  /** update single row of the table: "legacy_certificate" */
  update_legacy_certificate_by_pk?: Maybe<Legacy_Certificate>;
  /** update multiples rows of table: "legacy_certificate" */
  update_legacy_certificate_many?: Maybe<Array<Maybe<Legacy_Certificate_Mutation_Response>>>;
  /** update data of the table: "materials_order" */
  update_materials_order?: Maybe<Materials_Order_Mutation_Response>;
  /** update single row of the table: "materials_order" */
  update_materials_order_by_pk?: Maybe<Materials_Order>;
  /** update multiples rows of table: "materials_order" */
  update_materials_order_many?: Maybe<Array<Maybe<Materials_Order_Mutation_Response>>>;
  /** update data of the table: "merge_organizations_logs" */
  update_merge_organizations_logs?: Maybe<Merge_Organizations_Logs_Mutation_Response>;
  /** update single row of the table: "merge_organizations_logs" */
  update_merge_organizations_logs_by_pk?: Maybe<Merge_Organizations_Logs>;
  /** update multiples rows of table: "merge_organizations_logs" */
  update_merge_organizations_logs_many?: Maybe<Array<Maybe<Merge_Organizations_Logs_Mutation_Response>>>;
  /** update data of the table: "merged_organizations" */
  update_merged_organizations?: Maybe<Merged_Organizations_Mutation_Response>;
  /** update single row of the table: "merged_organizations" */
  update_merged_organizations_by_pk?: Maybe<Merged_Organizations>;
  /** update multiples rows of table: "merged_organizations" */
  update_merged_organizations_many?: Maybe<Array<Maybe<Merged_Organizations_Mutation_Response>>>;
  /** update data of the table: "module" */
  update_module?: Maybe<Module_Mutation_Response>;
  /** update single row of the table: "module" */
  update_module_by_pk?: Maybe<Module>;
  /** update data of the table: "module_category" */
  update_module_category?: Maybe<Module_Category_Mutation_Response>;
  /** update single row of the table: "module_category" */
  update_module_category_by_pk?: Maybe<Module_Category>;
  /** update multiples rows of table: "module_category" */
  update_module_category_many?: Maybe<Array<Maybe<Module_Category_Mutation_Response>>>;
  /** update data of the table: "module_group" */
  update_module_group?: Maybe<Module_Group_Mutation_Response>;
  /** update single row of the table: "module_group" */
  update_module_group_by_pk?: Maybe<Module_Group>;
  /** update data of the table: "module_group_duration" */
  update_module_group_duration?: Maybe<Module_Group_Duration_Mutation_Response>;
  /** update single row of the table: "module_group_duration" */
  update_module_group_duration_by_pk?: Maybe<Module_Group_Duration>;
  /** update multiples rows of table: "module_group_duration" */
  update_module_group_duration_many?: Maybe<Array<Maybe<Module_Group_Duration_Mutation_Response>>>;
  /** update multiples rows of table: "module_group" */
  update_module_group_many?: Maybe<Array<Maybe<Module_Group_Mutation_Response>>>;
  /** update multiples rows of table: "module" */
  update_module_many?: Maybe<Array<Maybe<Module_Mutation_Response>>>;
  /** update data of the table: "module_setting" */
  update_module_setting?: Maybe<Module_Setting_Mutation_Response>;
  /** update single row of the table: "module_setting" */
  update_module_setting_by_pk?: Maybe<Module_Setting>;
  /** update data of the table: "module_setting_dependency" */
  update_module_setting_dependency?: Maybe<Module_Setting_Dependency_Mutation_Response>;
  /** update single row of the table: "module_setting_dependency" */
  update_module_setting_dependency_by_pk?: Maybe<Module_Setting_Dependency>;
  /** update multiples rows of table: "module_setting_dependency" */
  update_module_setting_dependency_many?: Maybe<Array<Maybe<Module_Setting_Dependency_Mutation_Response>>>;
  /** update multiples rows of table: "module_setting" */
  update_module_setting_many?: Maybe<Array<Maybe<Module_Setting_Mutation_Response>>>;
  /** update data of the table: "module_v2" */
  update_module_v2?: Maybe<Module_V2_Mutation_Response>;
  /** update single row of the table: "module_v2" */
  update_module_v2_by_pk?: Maybe<Module_V2>;
  /** update multiples rows of table: "module_v2" */
  update_module_v2_many?: Maybe<Array<Maybe<Module_V2_Mutation_Response>>>;
  /** update data of the table: "non_graded_certificate" */
  update_non_graded_certificate?: Maybe<Non_Graded_Certificate_Mutation_Response>;
  /** update single row of the table: "non_graded_certificate" */
  update_non_graded_certificate_by_pk?: Maybe<Non_Graded_Certificate>;
  /** update multiples rows of table: "non_graded_certificate" */
  update_non_graded_certificate_many?: Maybe<Array<Maybe<Non_Graded_Certificate_Mutation_Response>>>;
  /** update data of the table: "order" */
  update_order?: Maybe<Order_Mutation_Response>;
  /** update single row of the table: "order" */
  update_order_by_pk?: Maybe<Order>;
  /** update multiples rows of table: "order" */
  update_order_many?: Maybe<Array<Maybe<Order_Mutation_Response>>>;
  /** update data of the table: "order_temp" */
  update_order_temp?: Maybe<Order_Temp_Mutation_Response>;
  /** update single row of the table: "order_temp" */
  update_order_temp_by_pk?: Maybe<Order_Temp>;
  /** update multiples rows of table: "order_temp" */
  update_order_temp_many?: Maybe<Array<Maybe<Order_Temp_Mutation_Response>>>;
  /** update data of the table: "org_created_from" */
  update_org_created_from?: Maybe<Org_Created_From_Mutation_Response>;
  /** update single row of the table: "org_created_from" */
  update_org_created_from_by_pk?: Maybe<Org_Created_From>;
  /** update multiples rows of table: "org_created_from" */
  update_org_created_from_many?: Maybe<Array<Maybe<Org_Created_From_Mutation_Response>>>;
  /** update data of the table: "org_resource_packs_history" */
  update_org_resource_packs_history?: Maybe<Org_Resource_Packs_History_Mutation_Response>;
  /** update single row of the table: "org_resource_packs_history" */
  update_org_resource_packs_history_by_pk?: Maybe<Org_Resource_Packs_History>;
  /** update multiples rows of table: "org_resource_packs_history" */
  update_org_resource_packs_history_many?: Maybe<Array<Maybe<Org_Resource_Packs_History_Mutation_Response>>>;
  /** update data of the table: "org_resource_packs_pricing" */
  update_org_resource_packs_pricing?: Maybe<Org_Resource_Packs_Pricing_Mutation_Response>;
  /** update single row of the table: "org_resource_packs_pricing" */
  update_org_resource_packs_pricing_by_pk?: Maybe<Org_Resource_Packs_Pricing>;
  /** update data of the table: "org_resource_packs_pricing_changelog" */
  update_org_resource_packs_pricing_changelog?: Maybe<Org_Resource_Packs_Pricing_Changelog_Mutation_Response>;
  /** update single row of the table: "org_resource_packs_pricing_changelog" */
  update_org_resource_packs_pricing_changelog_by_pk?: Maybe<Org_Resource_Packs_Pricing_Changelog>;
  /** update multiples rows of table: "org_resource_packs_pricing_changelog" */
  update_org_resource_packs_pricing_changelog_many?: Maybe<Array<Maybe<Org_Resource_Packs_Pricing_Changelog_Mutation_Response>>>;
  /** update multiples rows of table: "org_resource_packs_pricing" */
  update_org_resource_packs_pricing_many?: Maybe<Array<Maybe<Org_Resource_Packs_Pricing_Mutation_Response>>>;
  /** update data of the table: "organisation_log" */
  update_organisation_log?: Maybe<Organisation_Log_Mutation_Response>;
  /** update single row of the table: "organisation_log" */
  update_organisation_log_by_pk?: Maybe<Organisation_Log>;
  /** update multiples rows of table: "organisation_log" */
  update_organisation_log_many?: Maybe<Array<Maybe<Organisation_Log_Mutation_Response>>>;
  /** update data of the table: "organisation_sector" */
  update_organisation_sector?: Maybe<Organisation_Sector_Mutation_Response>;
  /** update single row of the table: "organisation_sector" */
  update_organisation_sector_by_pk?: Maybe<Organisation_Sector>;
  /** update multiples rows of table: "organisation_sector" */
  update_organisation_sector_many?: Maybe<Array<Maybe<Organisation_Sector_Mutation_Response>>>;
  /** update data of the table: "organization" */
  update_organization?: Maybe<Organization_Mutation_Response>;
  /** update single row of the table: "organization" */
  update_organization_by_pk?: Maybe<Organization>;
  /** update data of the table: "organization_invites" */
  update_organization_invites?: Maybe<Organization_Invites_Mutation_Response>;
  /** update single row of the table: "organization_invites" */
  update_organization_invites_by_pk?: Maybe<Organization_Invites>;
  /** update multiples rows of table: "organization_invites" */
  update_organization_invites_many?: Maybe<Array<Maybe<Organization_Invites_Mutation_Response>>>;
  /** update multiples rows of table: "organization" */
  update_organization_many?: Maybe<Array<Maybe<Organization_Mutation_Response>>>;
  /** update data of the table: "organization_member" */
  update_organization_member?: Maybe<Organization_Member_Mutation_Response>;
  /** update single row of the table: "organization_member" */
  update_organization_member_by_pk?: Maybe<Organization_Member>;
  /** update multiples rows of table: "organization_member" */
  update_organization_member_many?: Maybe<Array<Maybe<Organization_Member_Mutation_Response>>>;
  /** update data of the table: "organization_resource_packs" */
  update_organization_resource_packs?: Maybe<Organization_Resource_Packs_Mutation_Response>;
  /** update single row of the table: "organization_resource_packs" */
  update_organization_resource_packs_by_pk?: Maybe<Organization_Resource_Packs>;
  /** update multiples rows of table: "organization_resource_packs" */
  update_organization_resource_packs_many?: Maybe<Array<Maybe<Organization_Resource_Packs_Mutation_Response>>>;
  /** update data of the table: "organization_type" */
  update_organization_type?: Maybe<Organization_Type_Mutation_Response>;
  /** update single row of the table: "organization_type" */
  update_organization_type_by_pk?: Maybe<Organization_Type>;
  /** update multiples rows of table: "organization_type" */
  update_organization_type_many?: Maybe<Array<Maybe<Organization_Type_Mutation_Response>>>;
  /** update data of the table: "organizations_statistics" */
  update_organizations_statistics?: Maybe<Organizations_Statistics_Mutation_Response>;
  /** update single row of the table: "organizations_statistics" */
  update_organizations_statistics_by_pk?: Maybe<Organizations_Statistics>;
  /** update multiples rows of table: "organizations_statistics" */
  update_organizations_statistics_many?: Maybe<Array<Maybe<Organizations_Statistics_Mutation_Response>>>;
  /** update data of the table: "payment_methods" */
  update_payment_methods?: Maybe<Payment_Methods_Mutation_Response>;
  /** update single row of the table: "payment_methods" */
  update_payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** update multiples rows of table: "payment_methods" */
  update_payment_methods_many?: Maybe<Array<Maybe<Payment_Methods_Mutation_Response>>>;
  /** update data of the table: "post_training_email_scheduled_events" */
  update_post_training_email_scheduled_events?: Maybe<Post_Training_Email_Scheduled_Events_Mutation_Response>;
  /** update single row of the table: "post_training_email_scheduled_events" */
  update_post_training_email_scheduled_events_by_pk?: Maybe<Post_Training_Email_Scheduled_Events>;
  /** update multiples rows of table: "post_training_email_scheduled_events" */
  update_post_training_email_scheduled_events_many?: Maybe<Array<Maybe<Post_Training_Email_Scheduled_Events_Mutation_Response>>>;
  /** update data of the table: "pre_training_email_scheduled_events" */
  update_pre_training_email_scheduled_events?: Maybe<Pre_Training_Email_Scheduled_Events_Mutation_Response>;
  /** update single row of the table: "pre_training_email_scheduled_events" */
  update_pre_training_email_scheduled_events_by_pk?: Maybe<Pre_Training_Email_Scheduled_Events>;
  /** update multiples rows of table: "pre_training_email_scheduled_events" */
  update_pre_training_email_scheduled_events_many?: Maybe<Array<Maybe<Pre_Training_Email_Scheduled_Events_Mutation_Response>>>;
  /** update data of the table: "precision_order_status" */
  update_precision_order_status?: Maybe<Precision_Order_Status_Mutation_Response>;
  /** update single row of the table: "precision_order_status" */
  update_precision_order_status_by_pk?: Maybe<Precision_Order_Status>;
  /** update multiples rows of table: "precision_order_status" */
  update_precision_order_status_many?: Maybe<Array<Maybe<Precision_Order_Status_Mutation_Response>>>;
  /** update data of the table: "private_course_booking" */
  update_private_course_booking?: Maybe<Private_Course_Booking_Mutation_Response>;
  /** update single row of the table: "private_course_booking" */
  update_private_course_booking_by_pk?: Maybe<Private_Course_Booking>;
  /** update multiples rows of table: "private_course_booking" */
  update_private_course_booking_many?: Maybe<Array<Maybe<Private_Course_Booking_Mutation_Response>>>;
  /** update data of the table: "profile" */
  update_profile?: Maybe<Profile_Mutation_Response>;
  /** update single row of the table: "profile" */
  update_profile_by_pk?: Maybe<Profile>;
  /** update multiples rows of table: "profile" */
  update_profile_many?: Maybe<Array<Maybe<Profile_Mutation_Response>>>;
  /** update data of the table: "profile_role" */
  update_profile_role?: Maybe<Profile_Role_Mutation_Response>;
  /** update single row of the table: "profile_role" */
  update_profile_role_by_pk?: Maybe<Profile_Role>;
  /** update multiples rows of table: "profile_role" */
  update_profile_role_many?: Maybe<Array<Maybe<Profile_Role_Mutation_Response>>>;
  /** update data of the table: "profile_temp" */
  update_profile_temp?: Maybe<Profile_Temp_Mutation_Response>;
  /** update single row of the table: "profile_temp" */
  update_profile_temp_by_pk?: Maybe<Profile_Temp>;
  /** update multiples rows of table: "profile_temp" */
  update_profile_temp_many?: Maybe<Array<Maybe<Profile_Temp_Mutation_Response>>>;
  /** update data of the table: "profile_trainer_agreement_type" */
  update_profile_trainer_agreement_type?: Maybe<Profile_Trainer_Agreement_Type_Mutation_Response>;
  /** update single row of the table: "profile_trainer_agreement_type" */
  update_profile_trainer_agreement_type_by_pk?: Maybe<Profile_Trainer_Agreement_Type>;
  /** update multiples rows of table: "profile_trainer_agreement_type" */
  update_profile_trainer_agreement_type_many?: Maybe<Array<Maybe<Profile_Trainer_Agreement_Type_Mutation_Response>>>;
  /** update data of the table: "profile_trainer_role_type" */
  update_profile_trainer_role_type?: Maybe<Profile_Trainer_Role_Type_Mutation_Response>;
  /** update single row of the table: "profile_trainer_role_type" */
  update_profile_trainer_role_type_by_pk?: Maybe<Profile_Trainer_Role_Type>;
  /** update multiples rows of table: "profile_trainer_role_type" */
  update_profile_trainer_role_type_many?: Maybe<Array<Maybe<Profile_Trainer_Role_Type_Mutation_Response>>>;
  /** update data of the table: "promo_code" */
  update_promo_code?: Maybe<Promo_Code_Mutation_Response>;
  /** update single row of the table: "promo_code" */
  update_promo_code_by_pk?: Maybe<Promo_Code>;
  /** update multiples rows of table: "promo_code" */
  update_promo_code_many?: Maybe<Array<Maybe<Promo_Code_Mutation_Response>>>;
  /** update data of the table: "promo_code_type" */
  update_promo_code_type?: Maybe<Promo_Code_Type_Mutation_Response>;
  /** update single row of the table: "promo_code_type" */
  update_promo_code_type_by_pk?: Maybe<Promo_Code_Type>;
  /** update multiples rows of table: "promo_code_type" */
  update_promo_code_type_many?: Maybe<Array<Maybe<Promo_Code_Type_Mutation_Response>>>;
  /** update data of the table: "resource_pack_bundle_course_level" */
  update_resource_pack_bundle_course_level?: Maybe<Resource_Pack_Bundle_Course_Level_Mutation_Response>;
  /** update single row of the table: "resource_pack_bundle_course_level" */
  update_resource_pack_bundle_course_level_by_pk?: Maybe<Resource_Pack_Bundle_Course_Level>;
  /** update multiples rows of table: "resource_pack_bundle_course_level" */
  update_resource_pack_bundle_course_level_many?: Maybe<Array<Maybe<Resource_Pack_Bundle_Course_Level_Mutation_Response>>>;
  /** update data of the table: "resource_pack_bundle_option" */
  update_resource_pack_bundle_option?: Maybe<Resource_Pack_Bundle_Option_Mutation_Response>;
  /** update single row of the table: "resource_pack_bundle_option" */
  update_resource_pack_bundle_option_by_pk?: Maybe<Resource_Pack_Bundle_Option>;
  /** update multiples rows of table: "resource_pack_bundle_option" */
  update_resource_pack_bundle_option_many?: Maybe<Array<Maybe<Resource_Pack_Bundle_Option_Mutation_Response>>>;
  /** update data of the table: "resource_pack_bundle_price" */
  update_resource_pack_bundle_price?: Maybe<Resource_Pack_Bundle_Price_Mutation_Response>;
  /** update single row of the table: "resource_pack_bundle_price" */
  update_resource_pack_bundle_price_by_pk?: Maybe<Resource_Pack_Bundle_Price>;
  /** update multiples rows of table: "resource_pack_bundle_price" */
  update_resource_pack_bundle_price_many?: Maybe<Array<Maybe<Resource_Pack_Bundle_Price_Mutation_Response>>>;
  /** update data of the table: "resource_packs_delivery_type" */
  update_resource_packs_delivery_type?: Maybe<Resource_Packs_Delivery_Type_Mutation_Response>;
  /** update single row of the table: "resource_packs_delivery_type" */
  update_resource_packs_delivery_type_by_pk?: Maybe<Resource_Packs_Delivery_Type>;
  /** update multiples rows of table: "resource_packs_delivery_type" */
  update_resource_packs_delivery_type_many?: Maybe<Array<Maybe<Resource_Packs_Delivery_Type_Mutation_Response>>>;
  /** update data of the table: "resource_packs_events" */
  update_resource_packs_events?: Maybe<Resource_Packs_Events_Mutation_Response>;
  /** update single row of the table: "resource_packs_events" */
  update_resource_packs_events_by_pk?: Maybe<Resource_Packs_Events>;
  /** update multiples rows of table: "resource_packs_events" */
  update_resource_packs_events_many?: Maybe<Array<Maybe<Resource_Packs_Events_Mutation_Response>>>;
  /** update data of the table: "resource_packs_pricing" */
  update_resource_packs_pricing?: Maybe<Resource_Packs_Pricing_Mutation_Response>;
  /** update single row of the table: "resource_packs_pricing" */
  update_resource_packs_pricing_by_pk?: Maybe<Resource_Packs_Pricing>;
  /** update multiples rows of table: "resource_packs_pricing" */
  update_resource_packs_pricing_many?: Maybe<Array<Maybe<Resource_Packs_Pricing_Mutation_Response>>>;
  /** update data of the table: "resource_packs_type" */
  update_resource_packs_type?: Maybe<Resource_Packs_Type_Mutation_Response>;
  /** update single row of the table: "resource_packs_type" */
  update_resource_packs_type_by_pk?: Maybe<Resource_Packs_Type>;
  /** update multiples rows of table: "resource_packs_type" */
  update_resource_packs_type_many?: Maybe<Array<Maybe<Resource_Packs_Type_Mutation_Response>>>;
  /** update data of the table: "role" */
  update_role?: Maybe<Role_Mutation_Response>;
  /** update single row of the table: "role" */
  update_role_by_pk?: Maybe<Role>;
  /** update multiples rows of table: "role" */
  update_role_many?: Maybe<Array<Maybe<Role_Mutation_Response>>>;
  /** update data of the table: "scheduled_events_view" */
  update_scheduled_events_view?: Maybe<Scheduled_Events_View_Mutation_Response>;
  /** update multiples rows of table: "scheduled_events_view" */
  update_scheduled_events_view_many?: Maybe<Array<Maybe<Scheduled_Events_View_Mutation_Response>>>;
  /** update data of the table: "splash_screens" */
  update_splash_screens?: Maybe<Splash_Screens_Mutation_Response>;
  /** update single row of the table: "splash_screens" */
  update_splash_screens_by_pk?: Maybe<Splash_Screens>;
  /** update multiples rows of table: "splash_screens" */
  update_splash_screens_many?: Maybe<Array<Maybe<Splash_Screens_Mutation_Response>>>;
  /** update data of the table: "submission_of_splash_screens" */
  update_submission_of_splash_screens?: Maybe<Submission_Of_Splash_Screens_Mutation_Response>;
  /** update single row of the table: "submission_of_splash_screens" */
  update_submission_of_splash_screens_by_pk?: Maybe<Submission_Of_Splash_Screens>;
  /** update multiples rows of table: "submission_of_splash_screens" */
  update_submission_of_splash_screens_many?: Maybe<Array<Maybe<Submission_Of_Splash_Screens_Mutation_Response>>>;
  /** update data of the table: "submodule" */
  update_submodule?: Maybe<Submodule_Mutation_Response>;
  /** update single row of the table: "submodule" */
  update_submodule_by_pk?: Maybe<Submodule>;
  /** update multiples rows of table: "submodule" */
  update_submodule_many?: Maybe<Array<Maybe<Submodule_Mutation_Response>>>;
  /** update data of the table: "trainer_agreement_type" */
  update_trainer_agreement_type?: Maybe<Trainer_Agreement_Type_Mutation_Response>;
  /** update single row of the table: "trainer_agreement_type" */
  update_trainer_agreement_type_by_pk?: Maybe<Trainer_Agreement_Type>;
  /** update multiples rows of table: "trainer_agreement_type" */
  update_trainer_agreement_type_many?: Maybe<Array<Maybe<Trainer_Agreement_Type_Mutation_Response>>>;
  /** update data of the table: "trainer_role_type" */
  update_trainer_role_type?: Maybe<Trainer_Role_Type_Mutation_Response>;
  /** update single row of the table: "trainer_role_type" */
  update_trainer_role_type_by_pk?: Maybe<Trainer_Role_Type>;
  /** update multiples rows of table: "trainer_role_type" */
  update_trainer_role_type_many?: Maybe<Array<Maybe<Trainer_Role_Type_Mutation_Response>>>;
  /** update data of the table: "trust_type" */
  update_trust_type?: Maybe<Trust_Type_Mutation_Response>;
  /** update single row of the table: "trust_type" */
  update_trust_type_by_pk?: Maybe<Trust_Type>;
  /** update multiples rows of table: "trust_type" */
  update_trust_type_many?: Maybe<Array<Maybe<Trust_Type_Mutation_Response>>>;
  /** update data of the table: "tt_client_invite_log" */
  update_tt_client_invite_log?: Maybe<Tt_Client_Invite_Log_Mutation_Response>;
  /** update single row of the table: "tt_client_invite_log" */
  update_tt_client_invite_log_by_pk?: Maybe<Tt_Client_Invite_Log>;
  /** update multiples rows of table: "tt_client_invite_log" */
  update_tt_client_invite_log_many?: Maybe<Array<Maybe<Tt_Client_Invite_Log_Mutation_Response>>>;
  /** update data of the table: "user_auth_audit_type" */
  update_user_auth_audit_type?: Maybe<User_Auth_Audit_Type_Mutation_Response>;
  /** update single row of the table: "user_auth_audit_type" */
  update_user_auth_audit_type_by_pk?: Maybe<User_Auth_Audit_Type>;
  /** update multiples rows of table: "user_auth_audit_type" */
  update_user_auth_audit_type_many?: Maybe<Array<Maybe<User_Auth_Audit_Type_Mutation_Response>>>;
  /** update data of the table: "user_auth_audits" */
  update_user_auth_audits?: Maybe<User_Auth_Audits_Mutation_Response>;
  /** update single row of the table: "user_auth_audits" */
  update_user_auth_audits_by_pk?: Maybe<User_Auth_Audits>;
  /** update multiples rows of table: "user_auth_audits" */
  update_user_auth_audits_many?: Maybe<Array<Maybe<User_Auth_Audits_Mutation_Response>>>;
  /** update data of the table: "venue" */
  update_venue?: Maybe<Venue_Mutation_Response>;
  /** update single row of the table: "venue" */
  update_venue_by_pk?: Maybe<Venue>;
  /** update data of the table: "venue_check_jobs" */
  update_venue_check_jobs?: Maybe<Venue_Check_Jobs_Mutation_Response>;
  /** update single row of the table: "venue_check_jobs" */
  update_venue_check_jobs_by_pk?: Maybe<Venue_Check_Jobs>;
  /** update multiples rows of table: "venue_check_jobs" */
  update_venue_check_jobs_many?: Maybe<Array<Maybe<Venue_Check_Jobs_Mutation_Response>>>;
  /** update multiples rows of table: "venue" */
  update_venue_many?: Maybe<Array<Maybe<Venue_Mutation_Response>>>;
  /** update data of the table: "waitlist" */
  update_waitlist?: Maybe<Waitlist_Mutation_Response>;
  /** update single row of the table: "waitlist" */
  update_waitlist_by_pk?: Maybe<Waitlist>;
  /** update multiples rows of table: "waitlist" */
  update_waitlist_many?: Maybe<Array<Maybe<Waitlist_Mutation_Response>>>;
  /** update data of the table: "xero_contact" */
  update_xero_contact?: Maybe<Xero_Contact_Mutation_Response>;
  /** update single row of the table: "xero_contact" */
  update_xero_contact_by_pk?: Maybe<Xero_Contact>;
  /** update multiples rows of table: "xero_contact" */
  update_xero_contact_many?: Maybe<Array<Maybe<Xero_Contact_Mutation_Response>>>;
  /** update data of the table: "xero_credential" */
  update_xero_credential?: Maybe<Xero_Credential_Mutation_Response>;
  /** update single row of the table: "xero_credential" */
  update_xero_credential_by_pk?: Maybe<Xero_Credential>;
  /** update multiples rows of table: "xero_credential" */
  update_xero_credential_many?: Maybe<Array<Maybe<Xero_Credential_Mutation_Response>>>;
  /** update data of the table: "xero_invoice" */
  update_xero_invoice?: Maybe<Xero_Invoice_Mutation_Response>;
  /** update single row of the table: "xero_invoice" */
  update_xero_invoice_by_pk?: Maybe<Xero_Invoice>;
  /** update multiples rows of table: "xero_invoice" */
  update_xero_invoice_many?: Maybe<Array<Maybe<Xero_Invoice_Mutation_Response>>>;
  /** update data of the table: "xero_invoice_status" */
  update_xero_invoice_status?: Maybe<Xero_Invoice_Status_Mutation_Response>;
  /** update single row of the table: "xero_invoice_status" */
  update_xero_invoice_status_by_pk?: Maybe<Xero_Invoice_Status>;
  /** update multiples rows of table: "xero_invoice_status" */
  update_xero_invoice_status_many?: Maybe<Array<Maybe<Xero_Invoice_Status_Mutation_Response>>>;
  /** Creates or updates Zoom meeting with start date */
  upsertZoomMeeting?: Maybe<UpsertZoomMeetingPayload>;
  /** This action is triggered when inviting attendees to an Indirect course. It checks the availability of blended learning licenses (if the course is of the blended learning type) as well as the resource packs stock of the course's associated organization. Its primary use is for inviting participants after the course has been completed. */
  validateAndDispatchInvitesForIndirectCourse?: Maybe<ValidateAndDispatchInvitesForIndirectCourseOutput>;
  verifyUser: Scalars['Boolean'];
  xeroCallback?: Maybe<XeroCallbackOutput>;
  xeroDisconnect?: Maybe<XeroDisconnectOutput>;
};


/** mutation root */
export type Mutation_RootAcceptOrgInviteArgs = {
  profileId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootAddResourcePacksArgs = {
  input: ResourcePacksAddInput;
};


/** mutation root */
export type Mutation_RootApproveCourseArgs = {
  input: ApproveCourseInput;
};


/** mutation root */
export type Mutation_RootArloCallbackArgs = {
  input: ArloCallbackInput;
};


/** mutation root */
export type Mutation_RootCancelIndividualFromCourseArgs = {
  courseId: Scalars['Int'];
  fee: Scalars['Float'];
  feeType: CancellationFeeType;
  profileId: Scalars['uuid'];
  reason: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCancelIndividualFromCourseWaitlistArgs = {
  input: CancelIndividualFromCourseWaitlistInput;
};


/** mutation root */
export type Mutation_RootCancelMyselfFromCourseArgs = {
  courseId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootCancelMyselfFromCourseWaitlistArgs = {
  input: CancelMyselfFromCourseWaitlistInput;
};


/** mutation root */
export type Mutation_RootConsume_License_And_LogArgs = {
  args: Consume_License_And_Log_Args;
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_History_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_History_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootCreateOrderArgs = {
  input: CreateOrderInput;
};


/** mutation root */
export type Mutation_RootCreateStripeSubscriptionArgs = {
  customerId: Scalars['String'];
  priceId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootCreateUserArgs = {
  input: CreateAppUserInput;
};


/** mutation root */
export type Mutation_RootDeclineInviteArgs = {
  note?: InputMaybe<Scalars['String']>;
};


/** mutation root */
export type Mutation_RootDeclineOrgInviteArgs = {
  inviteId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteMeetingArgs = {
  meetingId: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDeleteOrganisationArgs = {
  orgId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDeleteUserArgs = {
  dryRun?: InputMaybe<Scalars['Boolean']>;
  profileId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_About_Training_Email_Scheduled_EventsArgs = {
  where: About_Training_Email_Scheduled_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_About_Training_Email_Scheduled_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Absorb_EnrolmentArgs = {
  where: Absorb_Enrolment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Absorb_Enrolment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_AccreditorsArgs = {
  where: Accreditors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Accreditors_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_AvailabilityArgs = {
  where: Availability_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Availability_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Bild_StrategyArgs = {
  where: Bild_Strategy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Bild_Strategy_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Blended_Learning_StatusArgs = {
  where: Blended_Learning_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Blended_Learning_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Certificate_Expired_Notification_JobsArgs = {
  where: Certificate_Expired_Notification_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Certificate_Expired_Notification_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Certificate_Expiry_Notification_JobsArgs = {
  where: Certificate_Expiry_Notification_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Certificate_Expiry_Notification_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Certificate_Expiry_Notification_TimeframeArgs = {
  where: Certificate_Expiry_Notification_Timeframe_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Certificate_Expiry_Notification_Timeframe_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Certificate_StatusArgs = {
  where: Certificate_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Certificate_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_ColorArgs = {
  where: Color_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Color_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_CountryArgs = {
  where: Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Country_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Country_RegionArgs = {
  where: Country_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Country_Region_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_CourseArgs = {
  where: Course_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_AuditArgs = {
  where: Course_Audit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Audit_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Audit_TypeArgs = {
  where: Course_Audit_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Audit_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Bild_ModuleArgs = {
  where: Course_Bild_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Bild_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Bild_StrategyArgs = {
  where: Course_Bild_Strategy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Bild_Strategy_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Cancellation_Fee_TypeArgs = {
  where: Course_Cancellation_Fee_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Cancellation_Fee_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Cancellation_RequestArgs = {
  where: Course_Cancellation_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Cancellation_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_CertificateArgs = {
  where: Course_Certificate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Certificate_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Certificate_ChangelogArgs = {
  where: Course_Certificate_Changelog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Certificate_Changelog_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Certificate_Changelog_TypeArgs = {
  where: Course_Certificate_Changelog_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Certificate_Changelog_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Certificate_Hold_RequestArgs = {
  where: Course_Certificate_Hold_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Certificate_Hold_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Delivery_TypeArgs = {
  where: Course_Delivery_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Delivery_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Delivery_Type_PrefixArgs = {
  where: Course_Delivery_Type_Prefix_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Delivery_Type_Prefix_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_DraftArgs = {
  where: Course_Draft_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Draft_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_End_JobsArgs = {
  where: Course_End_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_End_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_EnquiryArgs = {
  where: Course_Enquiry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Enquiry_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Evaluation_AnswersArgs = {
  where: Course_Evaluation_Answers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Evaluation_Answers_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Evaluation_Question_GroupArgs = {
  where: Course_Evaluation_Question_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Evaluation_Question_Group_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Evaluation_Question_TypeArgs = {
  where: Course_Evaluation_Question_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Evaluation_Question_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Evaluation_QuestionsArgs = {
  where: Course_Evaluation_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Evaluation_Questions_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Evaluation_Scheduled_EventArgs = {
  where: Course_Evaluation_Scheduled_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Evaluation_Scheduled_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_ExceptionArgs = {
  where: Course_Exception_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Exception_By_PkArgs = {
  exception: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_ExceptionsArgs = {
  where: Course_Exceptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Exceptions_By_PkArgs = {
  courseId: Scalars['Int'];
  exception: Course_Exception_Enum;
};


/** mutation root */
export type Mutation_RootDelete_Course_ExpensesArgs = {
  where: Course_Expenses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Expenses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Invite_StatusArgs = {
  where: Course_Invite_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Invite_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_InvitesArgs = {
  where: Course_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_LevelArgs = {
  where: Course_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Level_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Level_PrefixArgs = {
  where: Course_Level_Prefix_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Level_Prefix_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_ModuleArgs = {
  where: Course_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_OrderArgs = {
  where: Course_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_ParticipantArgs = {
  where: Course_Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_AuditArgs = {
  where: Course_Participant_Audit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_Audit_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_Audit_TypeArgs = {
  where: Course_Participant_Audit_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_Audit_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_Bild_ModuleArgs = {
  where: Course_Participant_Bild_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_Bild_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_CancellationArgs = {
  where: Course_Participant_Cancellation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_Cancellation_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_ModuleArgs = {
  where: Course_Participant_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_NoteArgs = {
  where: Course_Participant_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Participant_Note_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_PricingArgs = {
  where: Course_Pricing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Pricing_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Pricing_ChangelogArgs = {
  where: Course_Pricing_Changelog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Pricing_Changelog_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Pricing_ScheduleArgs = {
  where: Course_Pricing_Schedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Pricing_Schedule_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Promo_CodeArgs = {
  where: Course_Promo_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Promo_Code_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Renewal_CycleArgs = {
  where: Course_Renewal_Cycle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Renewal_Cycle_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_ScheduleArgs = {
  where: Course_Schedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Schedule_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_SourceArgs = {
  where: Course_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Source_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_StatusArgs = {
  where: Course_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_TrainerArgs = {
  where: Course_Trainer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Trainer_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Trainer_TypeArgs = {
  where: Course_Trainer_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Trainer_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_TypeArgs = {
  where: Course_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Course_Type_PrefixArgs = {
  where: Course_Type_Prefix_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Course_Type_Prefix_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Cqc_EstablishmentArgs = {
  where: Cqc_Establishment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cqc_Establishment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Cud_OperationArgs = {
  where: Cud_Operation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Cud_Operation_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Deleted_Organizations_BackupArgs = {
  where: Deleted_Organizations_Backup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dfe_EstablishmentArgs = {
  where: Dfe_Establishment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Dfe_Establishment_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Email_NotificationsArgs = {
  where: Email_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Email_Notifications_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Expire_Go1_License_JobsArgs = {
  where: Expire_Go1_License_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Expire_Go1_License_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Go1_History_EventsArgs = {
  where: Go1_History_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Go1_History_Events_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Go1_LicensesArgs = {
  where: Go1_Licenses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Go1_Licenses_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Go1_Licenses_HistoryArgs = {
  where: Go1_Licenses_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Go1_Licenses_History_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_GradeArgs = {
  where: Grade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Grade_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Hubspot_AuditArgs = {
  where: Hubspot_Audit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Hubspot_Audit_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_IdentityArgs = {
  where: Identity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Identity_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Identity_TypeArgs = {
  where: Identity_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Identity_Type_By_PkArgs = {
  value: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Import_JobArgs = {
  where: Import_Job_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Import_Job_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Import_Job_StatusArgs = {
  where: Import_Job_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Import_Job_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Import_Job_TypeArgs = {
  where: Import_Job_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Import_Job_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Job_TitleArgs = {
  where: Job_Title_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Job_Title_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Legacy_CertificateArgs = {
  where: Legacy_Certificate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Legacy_Certificate_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Materials_OrderArgs = {
  where: Materials_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Materials_Order_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Merge_Organizations_LogsArgs = {
  where: Merge_Organizations_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Merge_Organizations_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Merged_OrganizationsArgs = {
  where: Merged_Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Merged_Organizations_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ModuleArgs = {
  where: Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Module_CategoryArgs = {
  where: Module_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Module_Category_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Module_GroupArgs = {
  where: Module_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Module_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Module_Group_DurationArgs = {
  where: Module_Group_Duration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Module_Group_Duration_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Module_SettingArgs = {
  where: Module_Setting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Module_Setting_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Module_Setting_DependencyArgs = {
  where: Module_Setting_Dependency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Module_Setting_Dependency_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Module_V2Args = {
  where: Module_V2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Module_V2_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Non_Graded_CertificateArgs = {
  where: Non_Graded_Certificate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Non_Graded_Certificate_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_OrderArgs = {
  where: Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Order_TempArgs = {
  where: Order_Temp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Order_Temp_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Org_Created_FromArgs = {
  where: Org_Created_From_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_Created_From_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Org_Resource_Packs_HistoryArgs = {
  where: Org_Resource_Packs_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_Resource_Packs_History_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Org_Resource_Packs_PricingArgs = {
  where: Org_Resource_Packs_Pricing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_Resource_Packs_Pricing_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Org_Resource_Packs_Pricing_ChangelogArgs = {
  where: Org_Resource_Packs_Pricing_Changelog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Org_Resource_Packs_Pricing_Changelog_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_LogArgs = {
  where: Organisation_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Log_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Organisation_SectorArgs = {
  where: Organisation_Sector_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organisation_Sector_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_OrganizationArgs = {
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_InvitesArgs = {
  where: Organization_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_MemberArgs = {
  where: Organization_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Member_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_Resource_PacksArgs = {
  where: Organization_Resource_Packs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Resource_Packs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Organization_TypeArgs = {
  where: Organization_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organization_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Organizations_StatisticsArgs = {
  where: Organizations_Statistics_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Organizations_Statistics_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Payment_MethodsArgs = {
  where: Payment_Methods_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Payment_Methods_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Post_Training_Email_Scheduled_EventsArgs = {
  where: Post_Training_Email_Scheduled_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Post_Training_Email_Scheduled_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Pre_Training_Email_Scheduled_EventsArgs = {
  where: Pre_Training_Email_Scheduled_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Pre_Training_Email_Scheduled_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Precision_Order_StatusArgs = {
  where: Precision_Order_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Precision_Order_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Private_Course_BookingArgs = {
  where: Private_Course_Booking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Private_Course_Booking_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_ProfileArgs = {
  where: Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Profile_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Profile_RoleArgs = {
  where: Profile_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Profile_Role_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Profile_TempArgs = {
  where: Profile_Temp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Profile_Temp_By_PkArgs = {
  id: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootDelete_Profile_Trainer_Agreement_TypeArgs = {
  where: Profile_Trainer_Agreement_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Profile_Trainer_Agreement_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Profile_Trainer_Role_TypeArgs = {
  where: Profile_Trainer_Role_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Profile_Trainer_Role_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Promo_CodeArgs = {
  where: Promo_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Promo_Code_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Promo_Code_TypeArgs = {
  where: Promo_Code_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Promo_Code_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Resource_Pack_Bundle_Course_LevelArgs = {
  where: Resource_Pack_Bundle_Course_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Resource_Pack_Bundle_Course_Level_By_PkArgs = {
  course_level: Course_Level_Enum;
  resource_pack_bundle: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Resource_Pack_Bundle_OptionArgs = {
  where: Resource_Pack_Bundle_Option_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Resource_Pack_Bundle_Option_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Resource_Pack_Bundle_PriceArgs = {
  where: Resource_Pack_Bundle_Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Resource_Pack_Bundle_Price_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Resource_Packs_Delivery_TypeArgs = {
  where: Resource_Packs_Delivery_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Resource_Packs_Delivery_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Resource_Packs_EventsArgs = {
  where: Resource_Packs_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Resource_Packs_Events_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Resource_Packs_PricingArgs = {
  where: Resource_Packs_Pricing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Resource_Packs_Pricing_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Resource_Packs_TypeArgs = {
  where: Resource_Packs_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Resource_Packs_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_RoleArgs = {
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Role_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Scheduled_Events_ViewArgs = {
  where: Scheduled_Events_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Splash_ScreensArgs = {
  where: Splash_Screens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Splash_Screens_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Submission_Of_Splash_ScreensArgs = {
  where: Submission_Of_Splash_Screens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Submission_Of_Splash_Screens_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_SubmoduleArgs = {
  where: Submodule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Submodule_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trainer_Agreement_TypeArgs = {
  where: Trainer_Agreement_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trainer_Agreement_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Trainer_Role_TypeArgs = {
  where: Trainer_Role_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trainer_Role_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Trust_TypeArgs = {
  where: Trust_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Trust_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Tt_Client_Invite_LogArgs = {
  where: Tt_Client_Invite_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Tt_Client_Invite_Log_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_Audit_TypeArgs = {
  where: User_Auth_Audit_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_Audit_Type_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_AuditsArgs = {
  where: User_Auth_Audits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_User_Auth_Audits_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_VenueArgs = {
  where: Venue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Venue_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Venue_Check_JobsArgs = {
  where: Venue_Check_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Venue_Check_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_WaitlistArgs = {
  where: Waitlist_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Waitlist_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Xero_ContactArgs = {
  where: Xero_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Xero_Contact_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Xero_CredentialArgs = {
  where: Xero_Credential_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Xero_Credential_By_PkArgs = {
  client_id: Scalars['String'];
};


/** mutation root */
export type Mutation_RootDelete_Xero_InvoiceArgs = {
  where: Xero_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Xero_Invoice_By_PkArgs = {
  id: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootDelete_Xero_Invoice_StatusArgs = {
  where: Xero_Invoice_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootDelete_Xero_Invoice_Status_By_PkArgs = {
  name: Scalars['String'];
};


/** mutation root */
export type Mutation_RootGet_Organisation_By_EmailArgs = {
  args: Get_Organisation_By_Email_Args;
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootGo1LicensesChangeArgs = {
  input: Go1LicensesChangeInput;
};


/** mutation root */
export type Mutation_RootGradedOnSyncArgs = {
  input: GradedOnSyncInput;
};


/** mutation root */
export type Mutation_RootImportArloCertificatesArgs = {
  report: Scalars['String'];
};


/** mutation root */
export type Mutation_RootImportLegacyCertificateArgs = {
  input: ImportLegacyCertificateInput;
};


/** mutation root */
export type Mutation_RootImportOrganisationsArgs = {
  input: ImportOrganisationsInput;
};


/** mutation root */
export type Mutation_RootImportUsersArgs = {
  input: ImportUsersInput;
};


/** mutation root */
export type Mutation_RootInsert_About_Training_Email_Scheduled_EventsArgs = {
  objects: Array<About_Training_Email_Scheduled_Events_Insert_Input>;
  on_conflict?: InputMaybe<About_Training_Email_Scheduled_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_About_Training_Email_Scheduled_Events_OneArgs = {
  object: About_Training_Email_Scheduled_Events_Insert_Input;
  on_conflict?: InputMaybe<About_Training_Email_Scheduled_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Absorb_EnrolmentArgs = {
  objects: Array<Absorb_Enrolment_Insert_Input>;
  on_conflict?: InputMaybe<Absorb_Enrolment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Absorb_Enrolment_OneArgs = {
  object: Absorb_Enrolment_Insert_Input;
  on_conflict?: InputMaybe<Absorb_Enrolment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AccreditorsArgs = {
  objects: Array<Accreditors_Insert_Input>;
  on_conflict?: InputMaybe<Accreditors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Accreditors_OneArgs = {
  object: Accreditors_Insert_Input;
  on_conflict?: InputMaybe<Accreditors_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_AvailabilityArgs = {
  objects: Array<Availability_Insert_Input>;
  on_conflict?: InputMaybe<Availability_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Availability_OneArgs = {
  object: Availability_Insert_Input;
  on_conflict?: InputMaybe<Availability_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bild_StrategyArgs = {
  objects: Array<Bild_Strategy_Insert_Input>;
  on_conflict?: InputMaybe<Bild_Strategy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Bild_Strategy_OneArgs = {
  object: Bild_Strategy_Insert_Input;
  on_conflict?: InputMaybe<Bild_Strategy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blended_Learning_StatusArgs = {
  objects: Array<Blended_Learning_Status_Insert_Input>;
  on_conflict?: InputMaybe<Blended_Learning_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Blended_Learning_Status_OneArgs = {
  object: Blended_Learning_Status_Insert_Input;
  on_conflict?: InputMaybe<Blended_Learning_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certificate_Expired_Notification_JobsArgs = {
  objects: Array<Certificate_Expired_Notification_Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Certificate_Expired_Notification_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certificate_Expired_Notification_Jobs_OneArgs = {
  object: Certificate_Expired_Notification_Jobs_Insert_Input;
  on_conflict?: InputMaybe<Certificate_Expired_Notification_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certificate_Expiry_Notification_JobsArgs = {
  objects: Array<Certificate_Expiry_Notification_Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Certificate_Expiry_Notification_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certificate_Expiry_Notification_Jobs_OneArgs = {
  object: Certificate_Expiry_Notification_Jobs_Insert_Input;
  on_conflict?: InputMaybe<Certificate_Expiry_Notification_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certificate_Expiry_Notification_TimeframeArgs = {
  objects: Array<Certificate_Expiry_Notification_Timeframe_Insert_Input>;
  on_conflict?: InputMaybe<Certificate_Expiry_Notification_Timeframe_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certificate_Expiry_Notification_Timeframe_OneArgs = {
  object: Certificate_Expiry_Notification_Timeframe_Insert_Input;
  on_conflict?: InputMaybe<Certificate_Expiry_Notification_Timeframe_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certificate_StatusArgs = {
  objects: Array<Certificate_Status_Insert_Input>;
  on_conflict?: InputMaybe<Certificate_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Certificate_Status_OneArgs = {
  object: Certificate_Status_Insert_Input;
  on_conflict?: InputMaybe<Certificate_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ColorArgs = {
  objects: Array<Color_Insert_Input>;
  on_conflict?: InputMaybe<Color_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Color_OneArgs = {
  object: Color_Insert_Input;
  on_conflict?: InputMaybe<Color_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CountryArgs = {
  objects: Array<Country_Insert_Input>;
  on_conflict?: InputMaybe<Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Country_OneArgs = {
  object: Country_Insert_Input;
  on_conflict?: InputMaybe<Country_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Country_RegionArgs = {
  objects: Array<Country_Region_Insert_Input>;
  on_conflict?: InputMaybe<Country_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Country_Region_OneArgs = {
  object: Country_Region_Insert_Input;
  on_conflict?: InputMaybe<Country_Region_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_CourseArgs = {
  objects: Array<Course_Insert_Input>;
  on_conflict?: InputMaybe<Course_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_AuditArgs = {
  objects: Array<Course_Audit_Insert_Input>;
  on_conflict?: InputMaybe<Course_Audit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Audit_OneArgs = {
  object: Course_Audit_Insert_Input;
  on_conflict?: InputMaybe<Course_Audit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Audit_TypeArgs = {
  objects: Array<Course_Audit_Type_Insert_Input>;
  on_conflict?: InputMaybe<Course_Audit_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Audit_Type_OneArgs = {
  object: Course_Audit_Type_Insert_Input;
  on_conflict?: InputMaybe<Course_Audit_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Bild_ModuleArgs = {
  objects: Array<Course_Bild_Module_Insert_Input>;
  on_conflict?: InputMaybe<Course_Bild_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Bild_Module_OneArgs = {
  object: Course_Bild_Module_Insert_Input;
  on_conflict?: InputMaybe<Course_Bild_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Bild_StrategyArgs = {
  objects: Array<Course_Bild_Strategy_Insert_Input>;
  on_conflict?: InputMaybe<Course_Bild_Strategy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Bild_Strategy_OneArgs = {
  object: Course_Bild_Strategy_Insert_Input;
  on_conflict?: InputMaybe<Course_Bild_Strategy_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Cancellation_Fee_TypeArgs = {
  objects: Array<Course_Cancellation_Fee_Type_Insert_Input>;
  on_conflict?: InputMaybe<Course_Cancellation_Fee_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Cancellation_Fee_Type_OneArgs = {
  object: Course_Cancellation_Fee_Type_Insert_Input;
  on_conflict?: InputMaybe<Course_Cancellation_Fee_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Cancellation_RequestArgs = {
  objects: Array<Course_Cancellation_Request_Insert_Input>;
  on_conflict?: InputMaybe<Course_Cancellation_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Cancellation_Request_OneArgs = {
  object: Course_Cancellation_Request_Insert_Input;
  on_conflict?: InputMaybe<Course_Cancellation_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_CertificateArgs = {
  objects: Array<Course_Certificate_Insert_Input>;
  on_conflict?: InputMaybe<Course_Certificate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Certificate_ChangelogArgs = {
  objects: Array<Course_Certificate_Changelog_Insert_Input>;
  on_conflict?: InputMaybe<Course_Certificate_Changelog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Certificate_Changelog_OneArgs = {
  object: Course_Certificate_Changelog_Insert_Input;
  on_conflict?: InputMaybe<Course_Certificate_Changelog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Certificate_Changelog_TypeArgs = {
  objects: Array<Course_Certificate_Changelog_Type_Insert_Input>;
  on_conflict?: InputMaybe<Course_Certificate_Changelog_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Certificate_Changelog_Type_OneArgs = {
  object: Course_Certificate_Changelog_Type_Insert_Input;
  on_conflict?: InputMaybe<Course_Certificate_Changelog_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Certificate_Hold_RequestArgs = {
  objects: Array<Course_Certificate_Hold_Request_Insert_Input>;
  on_conflict?: InputMaybe<Course_Certificate_Hold_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Certificate_Hold_Request_OneArgs = {
  object: Course_Certificate_Hold_Request_Insert_Input;
  on_conflict?: InputMaybe<Course_Certificate_Hold_Request_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Certificate_OneArgs = {
  object: Course_Certificate_Insert_Input;
  on_conflict?: InputMaybe<Course_Certificate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Delivery_TypeArgs = {
  objects: Array<Course_Delivery_Type_Insert_Input>;
  on_conflict?: InputMaybe<Course_Delivery_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Delivery_Type_OneArgs = {
  object: Course_Delivery_Type_Insert_Input;
  on_conflict?: InputMaybe<Course_Delivery_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Delivery_Type_PrefixArgs = {
  objects: Array<Course_Delivery_Type_Prefix_Insert_Input>;
  on_conflict?: InputMaybe<Course_Delivery_Type_Prefix_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Delivery_Type_Prefix_OneArgs = {
  object: Course_Delivery_Type_Prefix_Insert_Input;
  on_conflict?: InputMaybe<Course_Delivery_Type_Prefix_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_DraftArgs = {
  objects: Array<Course_Draft_Insert_Input>;
  on_conflict?: InputMaybe<Course_Draft_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Draft_OneArgs = {
  object: Course_Draft_Insert_Input;
  on_conflict?: InputMaybe<Course_Draft_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_End_JobsArgs = {
  objects: Array<Course_End_Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Course_End_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_End_Jobs_OneArgs = {
  object: Course_End_Jobs_Insert_Input;
  on_conflict?: InputMaybe<Course_End_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_EnquiryArgs = {
  objects: Array<Course_Enquiry_Insert_Input>;
  on_conflict?: InputMaybe<Course_Enquiry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Enquiry_OneArgs = {
  object: Course_Enquiry_Insert_Input;
  on_conflict?: InputMaybe<Course_Enquiry_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Evaluation_AnswersArgs = {
  objects: Array<Course_Evaluation_Answers_Insert_Input>;
  on_conflict?: InputMaybe<Course_Evaluation_Answers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Evaluation_Answers_OneArgs = {
  object: Course_Evaluation_Answers_Insert_Input;
  on_conflict?: InputMaybe<Course_Evaluation_Answers_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Evaluation_Question_GroupArgs = {
  objects: Array<Course_Evaluation_Question_Group_Insert_Input>;
  on_conflict?: InputMaybe<Course_Evaluation_Question_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Evaluation_Question_Group_OneArgs = {
  object: Course_Evaluation_Question_Group_Insert_Input;
  on_conflict?: InputMaybe<Course_Evaluation_Question_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Evaluation_Question_TypeArgs = {
  objects: Array<Course_Evaluation_Question_Type_Insert_Input>;
  on_conflict?: InputMaybe<Course_Evaluation_Question_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Evaluation_Question_Type_OneArgs = {
  object: Course_Evaluation_Question_Type_Insert_Input;
  on_conflict?: InputMaybe<Course_Evaluation_Question_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Evaluation_QuestionsArgs = {
  objects: Array<Course_Evaluation_Questions_Insert_Input>;
  on_conflict?: InputMaybe<Course_Evaluation_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Evaluation_Questions_OneArgs = {
  object: Course_Evaluation_Questions_Insert_Input;
  on_conflict?: InputMaybe<Course_Evaluation_Questions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Evaluation_Scheduled_EventArgs = {
  objects: Array<Course_Evaluation_Scheduled_Event_Insert_Input>;
  on_conflict?: InputMaybe<Course_Evaluation_Scheduled_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Evaluation_Scheduled_Event_OneArgs = {
  object: Course_Evaluation_Scheduled_Event_Insert_Input;
  on_conflict?: InputMaybe<Course_Evaluation_Scheduled_Event_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_ExceptionArgs = {
  objects: Array<Course_Exception_Insert_Input>;
  on_conflict?: InputMaybe<Course_Exception_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Exception_OneArgs = {
  object: Course_Exception_Insert_Input;
  on_conflict?: InputMaybe<Course_Exception_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_ExceptionsArgs = {
  objects: Array<Course_Exceptions_Insert_Input>;
  on_conflict?: InputMaybe<Course_Exceptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Exceptions_OneArgs = {
  object: Course_Exceptions_Insert_Input;
  on_conflict?: InputMaybe<Course_Exceptions_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_ExpensesArgs = {
  objects: Array<Course_Expenses_Insert_Input>;
  on_conflict?: InputMaybe<Course_Expenses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Expenses_OneArgs = {
  object: Course_Expenses_Insert_Input;
  on_conflict?: InputMaybe<Course_Expenses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Invite_StatusArgs = {
  objects: Array<Course_Invite_Status_Insert_Input>;
  on_conflict?: InputMaybe<Course_Invite_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Invite_Status_OneArgs = {
  object: Course_Invite_Status_Insert_Input;
  on_conflict?: InputMaybe<Course_Invite_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_InvitesArgs = {
  objects: Array<Course_Invites_Insert_Input>;
  on_conflict?: InputMaybe<Course_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Invites_OneArgs = {
  object: Course_Invites_Insert_Input;
  on_conflict?: InputMaybe<Course_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_LevelArgs = {
  objects: Array<Course_Level_Insert_Input>;
  on_conflict?: InputMaybe<Course_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Level_OneArgs = {
  object: Course_Level_Insert_Input;
  on_conflict?: InputMaybe<Course_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Level_PrefixArgs = {
  objects: Array<Course_Level_Prefix_Insert_Input>;
  on_conflict?: InputMaybe<Course_Level_Prefix_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Level_Prefix_OneArgs = {
  object: Course_Level_Prefix_Insert_Input;
  on_conflict?: InputMaybe<Course_Level_Prefix_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_ModuleArgs = {
  objects: Array<Course_Module_Insert_Input>;
  on_conflict?: InputMaybe<Course_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Module_OneArgs = {
  object: Course_Module_Insert_Input;
  on_conflict?: InputMaybe<Course_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_OneArgs = {
  object: Course_Insert_Input;
  on_conflict?: InputMaybe<Course_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_OrderArgs = {
  objects: Array<Course_Order_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Order_OneArgs = {
  object: Course_Order_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Course_ParticipantArgs = {
  objects: Array<Course_Participant_Insert_Input>;
  on_conflict?: InputMaybe<Course_Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_AuditArgs = {
  objects: Array<Course_Participant_Audit_Insert_Input>;
  on_conflict?: InputMaybe<Course_Participant_Audit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_Audit_OneArgs = {
  object: Course_Participant_Audit_Insert_Input;
  on_conflict?: InputMaybe<Course_Participant_Audit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_Audit_TypeArgs = {
  objects: Array<Course_Participant_Audit_Type_Insert_Input>;
  on_conflict?: InputMaybe<Course_Participant_Audit_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_Audit_Type_OneArgs = {
  object: Course_Participant_Audit_Type_Insert_Input;
  on_conflict?: InputMaybe<Course_Participant_Audit_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_Bild_ModuleArgs = {
  objects: Array<Course_Participant_Bild_Module_Insert_Input>;
  on_conflict?: InputMaybe<Course_Participant_Bild_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_Bild_Module_OneArgs = {
  object: Course_Participant_Bild_Module_Insert_Input;
  on_conflict?: InputMaybe<Course_Participant_Bild_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_CancellationArgs = {
  objects: Array<Course_Participant_Cancellation_Insert_Input>;
  on_conflict?: InputMaybe<Course_Participant_Cancellation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_Cancellation_OneArgs = {
  object: Course_Participant_Cancellation_Insert_Input;
  on_conflict?: InputMaybe<Course_Participant_Cancellation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_ModuleArgs = {
  objects: Array<Course_Participant_Module_Insert_Input>;
  on_conflict?: InputMaybe<Course_Participant_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_Module_OneArgs = {
  object: Course_Participant_Module_Insert_Input;
  on_conflict?: InputMaybe<Course_Participant_Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_NoteArgs = {
  objects: Array<Course_Participant_Note_Insert_Input>;
  on_conflict?: InputMaybe<Course_Participant_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_Note_OneArgs = {
  object: Course_Participant_Note_Insert_Input;
  on_conflict?: InputMaybe<Course_Participant_Note_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Participant_OneArgs = {
  object: Course_Participant_Insert_Input;
  on_conflict?: InputMaybe<Course_Participant_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_PricingArgs = {
  objects: Array<Course_Pricing_Insert_Input>;
  on_conflict?: InputMaybe<Course_Pricing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Pricing_ChangelogArgs = {
  objects: Array<Course_Pricing_Changelog_Insert_Input>;
  on_conflict?: InputMaybe<Course_Pricing_Changelog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Pricing_Changelog_OneArgs = {
  object: Course_Pricing_Changelog_Insert_Input;
  on_conflict?: InputMaybe<Course_Pricing_Changelog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Pricing_OneArgs = {
  object: Course_Pricing_Insert_Input;
  on_conflict?: InputMaybe<Course_Pricing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Pricing_ScheduleArgs = {
  objects: Array<Course_Pricing_Schedule_Insert_Input>;
  on_conflict?: InputMaybe<Course_Pricing_Schedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Pricing_Schedule_OneArgs = {
  object: Course_Pricing_Schedule_Insert_Input;
  on_conflict?: InputMaybe<Course_Pricing_Schedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Promo_CodeArgs = {
  objects: Array<Course_Promo_Code_Insert_Input>;
  on_conflict?: InputMaybe<Course_Promo_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Promo_Code_OneArgs = {
  object: Course_Promo_Code_Insert_Input;
  on_conflict?: InputMaybe<Course_Promo_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Renewal_CycleArgs = {
  objects: Array<Course_Renewal_Cycle_Insert_Input>;
  on_conflict?: InputMaybe<Course_Renewal_Cycle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Renewal_Cycle_OneArgs = {
  object: Course_Renewal_Cycle_Insert_Input;
  on_conflict?: InputMaybe<Course_Renewal_Cycle_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_ScheduleArgs = {
  objects: Array<Course_Schedule_Insert_Input>;
  on_conflict?: InputMaybe<Course_Schedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Schedule_OneArgs = {
  object: Course_Schedule_Insert_Input;
  on_conflict?: InputMaybe<Course_Schedule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_SourceArgs = {
  objects: Array<Course_Source_Insert_Input>;
  on_conflict?: InputMaybe<Course_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Source_OneArgs = {
  object: Course_Source_Insert_Input;
  on_conflict?: InputMaybe<Course_Source_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_StatusArgs = {
  objects: Array<Course_Status_Insert_Input>;
  on_conflict?: InputMaybe<Course_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Status_OneArgs = {
  object: Course_Status_Insert_Input;
  on_conflict?: InputMaybe<Course_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_TrainerArgs = {
  objects: Array<Course_Trainer_Insert_Input>;
  on_conflict?: InputMaybe<Course_Trainer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Trainer_OneArgs = {
  object: Course_Trainer_Insert_Input;
  on_conflict?: InputMaybe<Course_Trainer_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Trainer_TypeArgs = {
  objects: Array<Course_Trainer_Type_Insert_Input>;
  on_conflict?: InputMaybe<Course_Trainer_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Trainer_Type_OneArgs = {
  object: Course_Trainer_Type_Insert_Input;
  on_conflict?: InputMaybe<Course_Trainer_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_TypeArgs = {
  objects: Array<Course_Type_Insert_Input>;
  on_conflict?: InputMaybe<Course_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Type_OneArgs = {
  object: Course_Type_Insert_Input;
  on_conflict?: InputMaybe<Course_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Type_PrefixArgs = {
  objects: Array<Course_Type_Prefix_Insert_Input>;
  on_conflict?: InputMaybe<Course_Type_Prefix_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Course_Type_Prefix_OneArgs = {
  object: Course_Type_Prefix_Insert_Input;
  on_conflict?: InputMaybe<Course_Type_Prefix_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cqc_EstablishmentArgs = {
  objects: Array<Cqc_Establishment_Insert_Input>;
  on_conflict?: InputMaybe<Cqc_Establishment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cqc_Establishment_OneArgs = {
  object: Cqc_Establishment_Insert_Input;
  on_conflict?: InputMaybe<Cqc_Establishment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cud_OperationArgs = {
  objects: Array<Cud_Operation_Insert_Input>;
  on_conflict?: InputMaybe<Cud_Operation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Cud_Operation_OneArgs = {
  object: Cud_Operation_Insert_Input;
  on_conflict?: InputMaybe<Cud_Operation_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Deleted_Organizations_BackupArgs = {
  objects: Array<Deleted_Organizations_Backup_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Deleted_Organizations_Backup_OneArgs = {
  object: Deleted_Organizations_Backup_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Dfe_EstablishmentArgs = {
  objects: Array<Dfe_Establishment_Insert_Input>;
  on_conflict?: InputMaybe<Dfe_Establishment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Dfe_Establishment_OneArgs = {
  object: Dfe_Establishment_Insert_Input;
  on_conflict?: InputMaybe<Dfe_Establishment_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_NotificationsArgs = {
  objects: Array<Email_Notifications_Insert_Input>;
  on_conflict?: InputMaybe<Email_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Email_Notifications_OneArgs = {
  object: Email_Notifications_Insert_Input;
  on_conflict?: InputMaybe<Email_Notifications_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expire_Go1_License_JobsArgs = {
  objects: Array<Expire_Go1_License_Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Expire_Go1_License_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Expire_Go1_License_Jobs_OneArgs = {
  object: Expire_Go1_License_Jobs_Insert_Input;
  on_conflict?: InputMaybe<Expire_Go1_License_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Go1_History_EventsArgs = {
  objects: Array<Go1_History_Events_Insert_Input>;
  on_conflict?: InputMaybe<Go1_History_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Go1_History_Events_OneArgs = {
  object: Go1_History_Events_Insert_Input;
  on_conflict?: InputMaybe<Go1_History_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Go1_LicensesArgs = {
  objects: Array<Go1_Licenses_Insert_Input>;
  on_conflict?: InputMaybe<Go1_Licenses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Go1_Licenses_HistoryArgs = {
  objects: Array<Go1_Licenses_History_Insert_Input>;
  on_conflict?: InputMaybe<Go1_Licenses_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Go1_Licenses_History_OneArgs = {
  object: Go1_Licenses_History_Insert_Input;
  on_conflict?: InputMaybe<Go1_Licenses_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Go1_Licenses_OneArgs = {
  object: Go1_Licenses_Insert_Input;
  on_conflict?: InputMaybe<Go1_Licenses_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_GradeArgs = {
  objects: Array<Grade_Insert_Input>;
  on_conflict?: InputMaybe<Grade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Grade_OneArgs = {
  object: Grade_Insert_Input;
  on_conflict?: InputMaybe<Grade_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hubspot_AuditArgs = {
  objects: Array<Hubspot_Audit_Insert_Input>;
  on_conflict?: InputMaybe<Hubspot_Audit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Hubspot_Audit_OneArgs = {
  object: Hubspot_Audit_Insert_Input;
  on_conflict?: InputMaybe<Hubspot_Audit_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_IdentityArgs = {
  objects: Array<Identity_Insert_Input>;
  on_conflict?: InputMaybe<Identity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Identity_OneArgs = {
  object: Identity_Insert_Input;
  on_conflict?: InputMaybe<Identity_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Identity_TypeArgs = {
  objects: Array<Identity_Type_Insert_Input>;
  on_conflict?: InputMaybe<Identity_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Identity_Type_OneArgs = {
  object: Identity_Type_Insert_Input;
  on_conflict?: InputMaybe<Identity_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Import_JobArgs = {
  objects: Array<Import_Job_Insert_Input>;
  on_conflict?: InputMaybe<Import_Job_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Import_Job_OneArgs = {
  object: Import_Job_Insert_Input;
  on_conflict?: InputMaybe<Import_Job_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Import_Job_StatusArgs = {
  objects: Array<Import_Job_Status_Insert_Input>;
  on_conflict?: InputMaybe<Import_Job_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Import_Job_Status_OneArgs = {
  object: Import_Job_Status_Insert_Input;
  on_conflict?: InputMaybe<Import_Job_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Import_Job_TypeArgs = {
  objects: Array<Import_Job_Type_Insert_Input>;
  on_conflict?: InputMaybe<Import_Job_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Import_Job_Type_OneArgs = {
  object: Import_Job_Type_Insert_Input;
  on_conflict?: InputMaybe<Import_Job_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_TitleArgs = {
  objects: Array<Job_Title_Insert_Input>;
  on_conflict?: InputMaybe<Job_Title_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Job_Title_OneArgs = {
  object: Job_Title_Insert_Input;
  on_conflict?: InputMaybe<Job_Title_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legacy_CertificateArgs = {
  objects: Array<Legacy_Certificate_Insert_Input>;
  on_conflict?: InputMaybe<Legacy_Certificate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Legacy_Certificate_OneArgs = {
  object: Legacy_Certificate_Insert_Input;
  on_conflict?: InputMaybe<Legacy_Certificate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Materials_OrderArgs = {
  objects: Array<Materials_Order_Insert_Input>;
  on_conflict?: InputMaybe<Materials_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Materials_Order_OneArgs = {
  object: Materials_Order_Insert_Input;
  on_conflict?: InputMaybe<Materials_Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Merge_Organizations_LogsArgs = {
  objects: Array<Merge_Organizations_Logs_Insert_Input>;
  on_conflict?: InputMaybe<Merge_Organizations_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Merge_Organizations_Logs_OneArgs = {
  object: Merge_Organizations_Logs_Insert_Input;
  on_conflict?: InputMaybe<Merge_Organizations_Logs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Merged_OrganizationsArgs = {
  objects: Array<Merged_Organizations_Insert_Input>;
  on_conflict?: InputMaybe<Merged_Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Merged_Organizations_OneArgs = {
  object: Merged_Organizations_Insert_Input;
  on_conflict?: InputMaybe<Merged_Organizations_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ModuleArgs = {
  objects: Array<Module_Insert_Input>;
  on_conflict?: InputMaybe<Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_CategoryArgs = {
  objects: Array<Module_Category_Insert_Input>;
  on_conflict?: InputMaybe<Module_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_Category_OneArgs = {
  object: Module_Category_Insert_Input;
  on_conflict?: InputMaybe<Module_Category_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_GroupArgs = {
  objects: Array<Module_Group_Insert_Input>;
  on_conflict?: InputMaybe<Module_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_Group_DurationArgs = {
  objects: Array<Module_Group_Duration_Insert_Input>;
  on_conflict?: InputMaybe<Module_Group_Duration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_Group_Duration_OneArgs = {
  object: Module_Group_Duration_Insert_Input;
  on_conflict?: InputMaybe<Module_Group_Duration_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_Group_OneArgs = {
  object: Module_Group_Insert_Input;
  on_conflict?: InputMaybe<Module_Group_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_OneArgs = {
  object: Module_Insert_Input;
  on_conflict?: InputMaybe<Module_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_SettingArgs = {
  objects: Array<Module_Setting_Insert_Input>;
  on_conflict?: InputMaybe<Module_Setting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_Setting_DependencyArgs = {
  objects: Array<Module_Setting_Dependency_Insert_Input>;
  on_conflict?: InputMaybe<Module_Setting_Dependency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_Setting_Dependency_OneArgs = {
  object: Module_Setting_Dependency_Insert_Input;
  on_conflict?: InputMaybe<Module_Setting_Dependency_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_Setting_OneArgs = {
  object: Module_Setting_Insert_Input;
  on_conflict?: InputMaybe<Module_Setting_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_V2Args = {
  objects: Array<Module_V2_Insert_Input>;
  on_conflict?: InputMaybe<Module_V2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Module_V2_OneArgs = {
  object: Module_V2_Insert_Input;
  on_conflict?: InputMaybe<Module_V2_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Non_Graded_CertificateArgs = {
  objects: Array<Non_Graded_Certificate_Insert_Input>;
  on_conflict?: InputMaybe<Non_Graded_Certificate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Non_Graded_Certificate_OneArgs = {
  object: Non_Graded_Certificate_Insert_Input;
  on_conflict?: InputMaybe<Non_Graded_Certificate_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrderArgs = {
  objects: Array<Order_Insert_Input>;
  on_conflict?: InputMaybe<Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_OneArgs = {
  object: Order_Insert_Input;
  on_conflict?: InputMaybe<Order_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_TempArgs = {
  objects: Array<Order_Temp_Insert_Input>;
  on_conflict?: InputMaybe<Order_Temp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Order_Temp_OneArgs = {
  object: Order_Temp_Insert_Input;
  on_conflict?: InputMaybe<Order_Temp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Created_FromArgs = {
  objects: Array<Org_Created_From_Insert_Input>;
  on_conflict?: InputMaybe<Org_Created_From_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Created_From_OneArgs = {
  object: Org_Created_From_Insert_Input;
  on_conflict?: InputMaybe<Org_Created_From_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Resource_Packs_HistoryArgs = {
  objects: Array<Org_Resource_Packs_History_Insert_Input>;
  on_conflict?: InputMaybe<Org_Resource_Packs_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Resource_Packs_History_OneArgs = {
  object: Org_Resource_Packs_History_Insert_Input;
  on_conflict?: InputMaybe<Org_Resource_Packs_History_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Resource_Packs_PricingArgs = {
  objects: Array<Org_Resource_Packs_Pricing_Insert_Input>;
  on_conflict?: InputMaybe<Org_Resource_Packs_Pricing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Resource_Packs_Pricing_ChangelogArgs = {
  objects: Array<Org_Resource_Packs_Pricing_Changelog_Insert_Input>;
  on_conflict?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Resource_Packs_Pricing_Changelog_OneArgs = {
  object: Org_Resource_Packs_Pricing_Changelog_Insert_Input;
  on_conflict?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Org_Resource_Packs_Pricing_OneArgs = {
  object: Org_Resource_Packs_Pricing_Insert_Input;
  on_conflict?: InputMaybe<Org_Resource_Packs_Pricing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_LogArgs = {
  objects: Array<Organisation_Log_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Log_OneArgs = {
  object: Organisation_Log_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_SectorArgs = {
  objects: Array<Organisation_Sector_Insert_Input>;
  on_conflict?: InputMaybe<Organisation_Sector_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organisation_Sector_OneArgs = {
  object: Organisation_Sector_Insert_Input;
  on_conflict?: InputMaybe<Organisation_Sector_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_OrganizationArgs = {
  objects: Array<Organization_Insert_Input>;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_InvitesArgs = {
  objects: Array<Organization_Invites_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Invites_OneArgs = {
  object: Organization_Invites_Insert_Input;
  on_conflict?: InputMaybe<Organization_Invites_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_MemberArgs = {
  objects: Array<Organization_Member_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Member_OneArgs = {
  object: Organization_Member_Insert_Input;
  on_conflict?: InputMaybe<Organization_Member_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_OneArgs = {
  object: Organization_Insert_Input;
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Resource_PacksArgs = {
  objects: Array<Organization_Resource_Packs_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Resource_Packs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Resource_Packs_OneArgs = {
  object: Organization_Resource_Packs_Insert_Input;
  on_conflict?: InputMaybe<Organization_Resource_Packs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_TypeArgs = {
  objects: Array<Organization_Type_Insert_Input>;
  on_conflict?: InputMaybe<Organization_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organization_Type_OneArgs = {
  object: Organization_Type_Insert_Input;
  on_conflict?: InputMaybe<Organization_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organizations_StatisticsArgs = {
  objects: Array<Organizations_Statistics_Insert_Input>;
  on_conflict?: InputMaybe<Organizations_Statistics_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Organizations_Statistics_OneArgs = {
  object: Organizations_Statistics_Insert_Input;
  on_conflict?: InputMaybe<Organizations_Statistics_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_MethodsArgs = {
  objects: Array<Payment_Methods_Insert_Input>;
  on_conflict?: InputMaybe<Payment_Methods_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Payment_Methods_OneArgs = {
  object: Payment_Methods_Insert_Input;
  on_conflict?: InputMaybe<Payment_Methods_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Post_Training_Email_Scheduled_EventsArgs = {
  objects: Array<Post_Training_Email_Scheduled_Events_Insert_Input>;
  on_conflict?: InputMaybe<Post_Training_Email_Scheduled_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Post_Training_Email_Scheduled_Events_OneArgs = {
  object: Post_Training_Email_Scheduled_Events_Insert_Input;
  on_conflict?: InputMaybe<Post_Training_Email_Scheduled_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pre_Training_Email_Scheduled_EventsArgs = {
  objects: Array<Pre_Training_Email_Scheduled_Events_Insert_Input>;
  on_conflict?: InputMaybe<Pre_Training_Email_Scheduled_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Pre_Training_Email_Scheduled_Events_OneArgs = {
  object: Pre_Training_Email_Scheduled_Events_Insert_Input;
  on_conflict?: InputMaybe<Pre_Training_Email_Scheduled_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Precision_Order_StatusArgs = {
  objects: Array<Precision_Order_Status_Insert_Input>;
  on_conflict?: InputMaybe<Precision_Order_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Precision_Order_Status_OneArgs = {
  object: Precision_Order_Status_Insert_Input;
  on_conflict?: InputMaybe<Precision_Order_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Private_Course_BookingArgs = {
  objects: Array<Private_Course_Booking_Insert_Input>;
  on_conflict?: InputMaybe<Private_Course_Booking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Private_Course_Booking_OneArgs = {
  object: Private_Course_Booking_Insert_Input;
  on_conflict?: InputMaybe<Private_Course_Booking_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_ProfileArgs = {
  objects: Array<Profile_Insert_Input>;
  on_conflict?: InputMaybe<Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_OneArgs = {
  object: Profile_Insert_Input;
  on_conflict?: InputMaybe<Profile_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_RoleArgs = {
  objects: Array<Profile_Role_Insert_Input>;
  on_conflict?: InputMaybe<Profile_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_Role_OneArgs = {
  object: Profile_Role_Insert_Input;
  on_conflict?: InputMaybe<Profile_Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_TempArgs = {
  objects: Array<Profile_Temp_Insert_Input>;
  on_conflict?: InputMaybe<Profile_Temp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_Temp_OneArgs = {
  object: Profile_Temp_Insert_Input;
  on_conflict?: InputMaybe<Profile_Temp_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_Trainer_Agreement_TypeArgs = {
  objects: Array<Profile_Trainer_Agreement_Type_Insert_Input>;
  on_conflict?: InputMaybe<Profile_Trainer_Agreement_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_Trainer_Agreement_Type_OneArgs = {
  object: Profile_Trainer_Agreement_Type_Insert_Input;
  on_conflict?: InputMaybe<Profile_Trainer_Agreement_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_Trainer_Role_TypeArgs = {
  objects: Array<Profile_Trainer_Role_Type_Insert_Input>;
  on_conflict?: InputMaybe<Profile_Trainer_Role_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Profile_Trainer_Role_Type_OneArgs = {
  object: Profile_Trainer_Role_Type_Insert_Input;
  on_conflict?: InputMaybe<Profile_Trainer_Role_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Promo_CodeArgs = {
  objects: Array<Promo_Code_Insert_Input>;
  on_conflict?: InputMaybe<Promo_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Promo_Code_OneArgs = {
  object: Promo_Code_Insert_Input;
  on_conflict?: InputMaybe<Promo_Code_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Promo_Code_TypeArgs = {
  objects: Array<Promo_Code_Type_Insert_Input>;
  on_conflict?: InputMaybe<Promo_Code_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Promo_Code_Type_OneArgs = {
  object: Promo_Code_Type_Insert_Input;
  on_conflict?: InputMaybe<Promo_Code_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Pack_Bundle_Course_LevelArgs = {
  objects: Array<Resource_Pack_Bundle_Course_Level_Insert_Input>;
  on_conflict?: InputMaybe<Resource_Pack_Bundle_Course_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Pack_Bundle_Course_Level_OneArgs = {
  object: Resource_Pack_Bundle_Course_Level_Insert_Input;
  on_conflict?: InputMaybe<Resource_Pack_Bundle_Course_Level_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Pack_Bundle_OptionArgs = {
  objects: Array<Resource_Pack_Bundle_Option_Insert_Input>;
  on_conflict?: InputMaybe<Resource_Pack_Bundle_Option_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Pack_Bundle_Option_OneArgs = {
  object: Resource_Pack_Bundle_Option_Insert_Input;
  on_conflict?: InputMaybe<Resource_Pack_Bundle_Option_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Pack_Bundle_PriceArgs = {
  objects: Array<Resource_Pack_Bundle_Price_Insert_Input>;
  on_conflict?: InputMaybe<Resource_Pack_Bundle_Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Pack_Bundle_Price_OneArgs = {
  object: Resource_Pack_Bundle_Price_Insert_Input;
  on_conflict?: InputMaybe<Resource_Pack_Bundle_Price_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Packs_Delivery_TypeArgs = {
  objects: Array<Resource_Packs_Delivery_Type_Insert_Input>;
  on_conflict?: InputMaybe<Resource_Packs_Delivery_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Packs_Delivery_Type_OneArgs = {
  object: Resource_Packs_Delivery_Type_Insert_Input;
  on_conflict?: InputMaybe<Resource_Packs_Delivery_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Packs_EventsArgs = {
  objects: Array<Resource_Packs_Events_Insert_Input>;
  on_conflict?: InputMaybe<Resource_Packs_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Packs_Events_OneArgs = {
  object: Resource_Packs_Events_Insert_Input;
  on_conflict?: InputMaybe<Resource_Packs_Events_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Packs_PricingArgs = {
  objects: Array<Resource_Packs_Pricing_Insert_Input>;
  on_conflict?: InputMaybe<Resource_Packs_Pricing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Packs_Pricing_OneArgs = {
  object: Resource_Packs_Pricing_Insert_Input;
  on_conflict?: InputMaybe<Resource_Packs_Pricing_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Packs_TypeArgs = {
  objects: Array<Resource_Packs_Type_Insert_Input>;
  on_conflict?: InputMaybe<Resource_Packs_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Resource_Packs_Type_OneArgs = {
  object: Resource_Packs_Type_Insert_Input;
  on_conflict?: InputMaybe<Resource_Packs_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_RoleArgs = {
  objects: Array<Role_Insert_Input>;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Role_OneArgs = {
  object: Role_Insert_Input;
  on_conflict?: InputMaybe<Role_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Scheduled_Events_ViewArgs = {
  objects: Array<Scheduled_Events_View_Insert_Input>;
};


/** mutation root */
export type Mutation_RootInsert_Scheduled_Events_View_OneArgs = {
  object: Scheduled_Events_View_Insert_Input;
};


/** mutation root */
export type Mutation_RootInsert_Splash_ScreensArgs = {
  objects: Array<Splash_Screens_Insert_Input>;
  on_conflict?: InputMaybe<Splash_Screens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Splash_Screens_OneArgs = {
  object: Splash_Screens_Insert_Input;
  on_conflict?: InputMaybe<Splash_Screens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Submission_Of_Splash_ScreensArgs = {
  objects: Array<Submission_Of_Splash_Screens_Insert_Input>;
  on_conflict?: InputMaybe<Submission_Of_Splash_Screens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Submission_Of_Splash_Screens_OneArgs = {
  object: Submission_Of_Splash_Screens_Insert_Input;
  on_conflict?: InputMaybe<Submission_Of_Splash_Screens_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_SubmoduleArgs = {
  objects: Array<Submodule_Insert_Input>;
  on_conflict?: InputMaybe<Submodule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Submodule_OneArgs = {
  object: Submodule_Insert_Input;
  on_conflict?: InputMaybe<Submodule_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trainer_Agreement_TypeArgs = {
  objects: Array<Trainer_Agreement_Type_Insert_Input>;
  on_conflict?: InputMaybe<Trainer_Agreement_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trainer_Agreement_Type_OneArgs = {
  object: Trainer_Agreement_Type_Insert_Input;
  on_conflict?: InputMaybe<Trainer_Agreement_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trainer_Role_TypeArgs = {
  objects: Array<Trainer_Role_Type_Insert_Input>;
  on_conflict?: InputMaybe<Trainer_Role_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trainer_Role_Type_OneArgs = {
  object: Trainer_Role_Type_Insert_Input;
  on_conflict?: InputMaybe<Trainer_Role_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trust_TypeArgs = {
  objects: Array<Trust_Type_Insert_Input>;
  on_conflict?: InputMaybe<Trust_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Trust_Type_OneArgs = {
  object: Trust_Type_Insert_Input;
  on_conflict?: InputMaybe<Trust_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tt_Client_Invite_LogArgs = {
  objects: Array<Tt_Client_Invite_Log_Insert_Input>;
  on_conflict?: InputMaybe<Tt_Client_Invite_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Tt_Client_Invite_Log_OneArgs = {
  object: Tt_Client_Invite_Log_Insert_Input;
  on_conflict?: InputMaybe<Tt_Client_Invite_Log_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_Audit_TypeArgs = {
  objects: Array<User_Auth_Audit_Type_Insert_Input>;
  on_conflict?: InputMaybe<User_Auth_Audit_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_Audit_Type_OneArgs = {
  object: User_Auth_Audit_Type_Insert_Input;
  on_conflict?: InputMaybe<User_Auth_Audit_Type_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_AuditsArgs = {
  objects: Array<User_Auth_Audits_Insert_Input>;
  on_conflict?: InputMaybe<User_Auth_Audits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_User_Auth_Audits_OneArgs = {
  object: User_Auth_Audits_Insert_Input;
  on_conflict?: InputMaybe<User_Auth_Audits_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_VenueArgs = {
  objects: Array<Venue_Insert_Input>;
  on_conflict?: InputMaybe<Venue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Venue_Check_JobsArgs = {
  objects: Array<Venue_Check_Jobs_Insert_Input>;
  on_conflict?: InputMaybe<Venue_Check_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Venue_Check_Jobs_OneArgs = {
  object: Venue_Check_Jobs_Insert_Input;
  on_conflict?: InputMaybe<Venue_Check_Jobs_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Venue_OneArgs = {
  object: Venue_Insert_Input;
  on_conflict?: InputMaybe<Venue_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_WaitlistArgs = {
  objects: Array<Waitlist_Insert_Input>;
  on_conflict?: InputMaybe<Waitlist_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Waitlist_OneArgs = {
  object: Waitlist_Insert_Input;
  on_conflict?: InputMaybe<Waitlist_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Xero_ContactArgs = {
  objects: Array<Xero_Contact_Insert_Input>;
  on_conflict?: InputMaybe<Xero_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Xero_Contact_OneArgs = {
  object: Xero_Contact_Insert_Input;
  on_conflict?: InputMaybe<Xero_Contact_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Xero_CredentialArgs = {
  objects: Array<Xero_Credential_Insert_Input>;
  on_conflict?: InputMaybe<Xero_Credential_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Xero_Credential_OneArgs = {
  object: Xero_Credential_Insert_Input;
  on_conflict?: InputMaybe<Xero_Credential_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Xero_InvoiceArgs = {
  objects: Array<Xero_Invoice_Insert_Input>;
  on_conflict?: InputMaybe<Xero_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Xero_Invoice_OneArgs = {
  object: Xero_Invoice_Insert_Input;
  on_conflict?: InputMaybe<Xero_Invoice_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Xero_Invoice_StatusArgs = {
  objects: Array<Xero_Invoice_Status_Insert_Input>;
  on_conflict?: InputMaybe<Xero_Invoice_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootInsert_Xero_Invoice_Status_OneArgs = {
  object: Xero_Invoice_Status_Insert_Input;
  on_conflict?: InputMaybe<Xero_Invoice_Status_On_Conflict>;
};


/** mutation root */
export type Mutation_RootJoinWaitlistArgs = {
  input: JoinWaitlistInput;
};


/** mutation root */
export type Mutation_RootMergeOrganisationsArgs = {
  input: MergeOrganisationsInput;
};


/** mutation root */
export type Mutation_RootMergeUserArgs = {
  mergeWith: Scalars['uuid'];
  primaryUser: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootNotifyCourseEditArgs = {
  oldCourse: NotifyCourseInput;
  oldTrainers: Array<InputMaybe<NotifyCourseTrainerInput>>;
};


/** mutation root */
export type Mutation_RootNotifyInternalUsersOfInviteAttemptArgs = {
  input: NotifyInternalUsersOfInviteAttemptInput;
};


/** mutation root */
export type Mutation_RootPlansCreateArgs = {
  data: PlansCreateInput;
};


/** mutation root */
export type Mutation_RootPurchaseMaterialsArgs = {
  input: PurchaseMaterialsInput;
};


/** mutation root */
export type Mutation_RootRejectCourseArgs = {
  input: RejectCourseInput;
};


/** mutation root */
export type Mutation_RootReplaceParticipantArgs = {
  input: ReplaceParticipantInput;
};


/** mutation root */
export type Mutation_RootResendPasswordArgs = {
  email: Scalars['String'];
};


/** mutation root */
export type Mutation_RootReserveResourcePacksArgs = {
  input: ResourcePacksReserveInput;
};


/** mutation root */
export type Mutation_RootSaveOrgInvitesArgs = {
  invites: Array<SaveOrgInviteInput>;
};


/** mutation root */
export type Mutation_RootSendCourseEvaluationReminderArgs = {
  attendeeIds?: InputMaybe<Array<Scalars['uuid']>>;
  courseId: Scalars['Int'];
};


/** mutation root */
export type Mutation_RootSendCourseInformationArgs = {
  attendeeIds?: InputMaybe<Array<Scalars['uuid']>>;
  courseId: Scalars['Int'];
  hsConsentReminder?: InputMaybe<Scalars['Boolean']>;
};


/** mutation root */
export type Mutation_RootSignUpArgs = {
  input: SignUpInput;
};


/** mutation root */
export type Mutation_RootStripeCreatePaymentIntentArgs = {
  input: StripeCreatePaymentIntentInput;
};


/** mutation root */
export type Mutation_RootTransferParticipantArgs = {
  input: TransferInput;
};


/** mutation root */
export type Mutation_RootUpdateAvatarArgs = {
  avatar: Scalars['bytea'];
  profileId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootUpdateUserProfileArgs = {
  input: UpdateUserProfileInput;
};


/** mutation root */
export type Mutation_RootUpdate_About_Training_Email_Scheduled_EventsArgs = {
  _set?: InputMaybe<About_Training_Email_Scheduled_Events_Set_Input>;
  where: About_Training_Email_Scheduled_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_About_Training_Email_Scheduled_Events_By_PkArgs = {
  _set?: InputMaybe<About_Training_Email_Scheduled_Events_Set_Input>;
  pk_columns: About_Training_Email_Scheduled_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_About_Training_Email_Scheduled_Events_ManyArgs = {
  updates: Array<About_Training_Email_Scheduled_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Absorb_EnrolmentArgs = {
  _append?: InputMaybe<Absorb_Enrolment_Append_Input>;
  _delete_at_path?: InputMaybe<Absorb_Enrolment_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Absorb_Enrolment_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Absorb_Enrolment_Delete_Key_Input>;
  _prepend?: InputMaybe<Absorb_Enrolment_Prepend_Input>;
  _set?: InputMaybe<Absorb_Enrolment_Set_Input>;
  where: Absorb_Enrolment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Absorb_Enrolment_By_PkArgs = {
  _append?: InputMaybe<Absorb_Enrolment_Append_Input>;
  _delete_at_path?: InputMaybe<Absorb_Enrolment_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Absorb_Enrolment_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Absorb_Enrolment_Delete_Key_Input>;
  _prepend?: InputMaybe<Absorb_Enrolment_Prepend_Input>;
  _set?: InputMaybe<Absorb_Enrolment_Set_Input>;
  pk_columns: Absorb_Enrolment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Absorb_Enrolment_ManyArgs = {
  updates: Array<Absorb_Enrolment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_AccreditorsArgs = {
  _set?: InputMaybe<Accreditors_Set_Input>;
  where: Accreditors_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Accreditors_By_PkArgs = {
  _set?: InputMaybe<Accreditors_Set_Input>;
  pk_columns: Accreditors_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Accreditors_ManyArgs = {
  updates: Array<Accreditors_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_All_Organizations_StatisticsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Statistics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Statistics_Order_By>>;
  where?: InputMaybe<Organizations_Statistics_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpdate_AvailabilityArgs = {
  _set?: InputMaybe<Availability_Set_Input>;
  where: Availability_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Availability_By_PkArgs = {
  _set?: InputMaybe<Availability_Set_Input>;
  pk_columns: Availability_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Availability_ManyArgs = {
  updates: Array<Availability_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Bild_StrategyArgs = {
  _append?: InputMaybe<Bild_Strategy_Append_Input>;
  _delete_at_path?: InputMaybe<Bild_Strategy_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Bild_Strategy_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Bild_Strategy_Delete_Key_Input>;
  _inc?: InputMaybe<Bild_Strategy_Inc_Input>;
  _prepend?: InputMaybe<Bild_Strategy_Prepend_Input>;
  _set?: InputMaybe<Bild_Strategy_Set_Input>;
  where: Bild_Strategy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Bild_Strategy_By_PkArgs = {
  _append?: InputMaybe<Bild_Strategy_Append_Input>;
  _delete_at_path?: InputMaybe<Bild_Strategy_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Bild_Strategy_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Bild_Strategy_Delete_Key_Input>;
  _inc?: InputMaybe<Bild_Strategy_Inc_Input>;
  _prepend?: InputMaybe<Bild_Strategy_Prepend_Input>;
  _set?: InputMaybe<Bild_Strategy_Set_Input>;
  pk_columns: Bild_Strategy_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Bild_Strategy_ManyArgs = {
  updates: Array<Bild_Strategy_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Blended_Learning_StatusArgs = {
  _set?: InputMaybe<Blended_Learning_Status_Set_Input>;
  where: Blended_Learning_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Blended_Learning_Status_By_PkArgs = {
  _set?: InputMaybe<Blended_Learning_Status_Set_Input>;
  pk_columns: Blended_Learning_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Blended_Learning_Status_ManyArgs = {
  updates: Array<Blended_Learning_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Expired_Notification_JobsArgs = {
  _set?: InputMaybe<Certificate_Expired_Notification_Jobs_Set_Input>;
  where: Certificate_Expired_Notification_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Expired_Notification_Jobs_By_PkArgs = {
  _set?: InputMaybe<Certificate_Expired_Notification_Jobs_Set_Input>;
  pk_columns: Certificate_Expired_Notification_Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Expired_Notification_Jobs_ManyArgs = {
  updates: Array<Certificate_Expired_Notification_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Expiry_Notification_JobsArgs = {
  _set?: InputMaybe<Certificate_Expiry_Notification_Jobs_Set_Input>;
  where: Certificate_Expiry_Notification_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Expiry_Notification_Jobs_By_PkArgs = {
  _set?: InputMaybe<Certificate_Expiry_Notification_Jobs_Set_Input>;
  pk_columns: Certificate_Expiry_Notification_Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Expiry_Notification_Jobs_ManyArgs = {
  updates: Array<Certificate_Expiry_Notification_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Expiry_Notification_TimeframeArgs = {
  _set?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Set_Input>;
  where: Certificate_Expiry_Notification_Timeframe_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Expiry_Notification_Timeframe_By_PkArgs = {
  _set?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Set_Input>;
  pk_columns: Certificate_Expiry_Notification_Timeframe_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Expiry_Notification_Timeframe_ManyArgs = {
  updates: Array<Certificate_Expiry_Notification_Timeframe_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_StatusArgs = {
  _set?: InputMaybe<Certificate_Status_Set_Input>;
  where: Certificate_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Status_By_PkArgs = {
  _set?: InputMaybe<Certificate_Status_Set_Input>;
  pk_columns: Certificate_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Certificate_Status_ManyArgs = {
  updates: Array<Certificate_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Certification_StatusesArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Order_By>>;
  where?: InputMaybe<Course_Certificate_Bool_Exp>;
};


/** mutation root */
export type Mutation_RootUpdate_ColorArgs = {
  _set?: InputMaybe<Color_Set_Input>;
  where: Color_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Color_By_PkArgs = {
  _set?: InputMaybe<Color_Set_Input>;
  pk_columns: Color_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Color_ManyArgs = {
  updates: Array<Color_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CountryArgs = {
  _set?: InputMaybe<Country_Set_Input>;
  where: Country_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Country_By_PkArgs = {
  _set?: InputMaybe<Country_Set_Input>;
  pk_columns: Country_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Country_ManyArgs = {
  updates: Array<Country_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Country_RegionArgs = {
  _set?: InputMaybe<Country_Region_Set_Input>;
  where: Country_Region_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Country_Region_By_PkArgs = {
  _set?: InputMaybe<Country_Region_Set_Input>;
  pk_columns: Country_Region_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Country_Region_ManyArgs = {
  updates: Array<Country_Region_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_CourseArgs = {
  _append?: InputMaybe<Course_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Delete_Key_Input>;
  _inc?: InputMaybe<Course_Inc_Input>;
  _prepend?: InputMaybe<Course_Prepend_Input>;
  _set?: InputMaybe<Course_Set_Input>;
  where: Course_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_AuditArgs = {
  _append?: InputMaybe<Course_Audit_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Audit_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Audit_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Audit_Delete_Key_Input>;
  _inc?: InputMaybe<Course_Audit_Inc_Input>;
  _prepend?: InputMaybe<Course_Audit_Prepend_Input>;
  _set?: InputMaybe<Course_Audit_Set_Input>;
  where: Course_Audit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Audit_By_PkArgs = {
  _append?: InputMaybe<Course_Audit_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Audit_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Audit_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Audit_Delete_Key_Input>;
  _inc?: InputMaybe<Course_Audit_Inc_Input>;
  _prepend?: InputMaybe<Course_Audit_Prepend_Input>;
  _set?: InputMaybe<Course_Audit_Set_Input>;
  pk_columns: Course_Audit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Audit_ManyArgs = {
  updates: Array<Course_Audit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Audit_TypeArgs = {
  _set?: InputMaybe<Course_Audit_Type_Set_Input>;
  where: Course_Audit_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Audit_Type_By_PkArgs = {
  _set?: InputMaybe<Course_Audit_Type_Set_Input>;
  pk_columns: Course_Audit_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Audit_Type_ManyArgs = {
  updates: Array<Course_Audit_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Bild_ModuleArgs = {
  _append?: InputMaybe<Course_Bild_Module_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Bild_Module_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Bild_Module_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Bild_Module_Delete_Key_Input>;
  _inc?: InputMaybe<Course_Bild_Module_Inc_Input>;
  _prepend?: InputMaybe<Course_Bild_Module_Prepend_Input>;
  _set?: InputMaybe<Course_Bild_Module_Set_Input>;
  where: Course_Bild_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Bild_Module_By_PkArgs = {
  _append?: InputMaybe<Course_Bild_Module_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Bild_Module_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Bild_Module_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Bild_Module_Delete_Key_Input>;
  _inc?: InputMaybe<Course_Bild_Module_Inc_Input>;
  _prepend?: InputMaybe<Course_Bild_Module_Prepend_Input>;
  _set?: InputMaybe<Course_Bild_Module_Set_Input>;
  pk_columns: Course_Bild_Module_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Bild_Module_ManyArgs = {
  updates: Array<Course_Bild_Module_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Bild_StrategyArgs = {
  _inc?: InputMaybe<Course_Bild_Strategy_Inc_Input>;
  _set?: InputMaybe<Course_Bild_Strategy_Set_Input>;
  where: Course_Bild_Strategy_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Bild_Strategy_By_PkArgs = {
  _inc?: InputMaybe<Course_Bild_Strategy_Inc_Input>;
  _set?: InputMaybe<Course_Bild_Strategy_Set_Input>;
  pk_columns: Course_Bild_Strategy_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Bild_Strategy_ManyArgs = {
  updates: Array<Course_Bild_Strategy_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_By_PkArgs = {
  _append?: InputMaybe<Course_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Delete_Key_Input>;
  _inc?: InputMaybe<Course_Inc_Input>;
  _prepend?: InputMaybe<Course_Prepend_Input>;
  _set?: InputMaybe<Course_Set_Input>;
  pk_columns: Course_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Cancellation_Fee_TypeArgs = {
  _set?: InputMaybe<Course_Cancellation_Fee_Type_Set_Input>;
  where: Course_Cancellation_Fee_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Cancellation_Fee_Type_By_PkArgs = {
  _set?: InputMaybe<Course_Cancellation_Fee_Type_Set_Input>;
  pk_columns: Course_Cancellation_Fee_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Cancellation_Fee_Type_ManyArgs = {
  updates: Array<Course_Cancellation_Fee_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Cancellation_RequestArgs = {
  _inc?: InputMaybe<Course_Cancellation_Request_Inc_Input>;
  _set?: InputMaybe<Course_Cancellation_Request_Set_Input>;
  where: Course_Cancellation_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Cancellation_Request_By_PkArgs = {
  _inc?: InputMaybe<Course_Cancellation_Request_Inc_Input>;
  _set?: InputMaybe<Course_Cancellation_Request_Set_Input>;
  pk_columns: Course_Cancellation_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Cancellation_Request_ManyArgs = {
  updates: Array<Course_Cancellation_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_CertificateArgs = {
  _inc?: InputMaybe<Course_Certificate_Inc_Input>;
  _set?: InputMaybe<Course_Certificate_Set_Input>;
  where: Course_Certificate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Certificate_By_PkArgs = {
  _inc?: InputMaybe<Course_Certificate_Inc_Input>;
  _set?: InputMaybe<Course_Certificate_Set_Input>;
  pk_columns: Course_Certificate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Certificate_ChangelogArgs = {
  _append?: InputMaybe<Course_Certificate_Changelog_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Certificate_Changelog_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Certificate_Changelog_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Certificate_Changelog_Delete_Key_Input>;
  _prepend?: InputMaybe<Course_Certificate_Changelog_Prepend_Input>;
  _set?: InputMaybe<Course_Certificate_Changelog_Set_Input>;
  where: Course_Certificate_Changelog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Certificate_Changelog_By_PkArgs = {
  _append?: InputMaybe<Course_Certificate_Changelog_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Certificate_Changelog_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Certificate_Changelog_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Certificate_Changelog_Delete_Key_Input>;
  _prepend?: InputMaybe<Course_Certificate_Changelog_Prepend_Input>;
  _set?: InputMaybe<Course_Certificate_Changelog_Set_Input>;
  pk_columns: Course_Certificate_Changelog_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Certificate_Changelog_ManyArgs = {
  updates: Array<Course_Certificate_Changelog_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Certificate_Changelog_TypeArgs = {
  _set?: InputMaybe<Course_Certificate_Changelog_Type_Set_Input>;
  where: Course_Certificate_Changelog_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Certificate_Changelog_Type_By_PkArgs = {
  _set?: InputMaybe<Course_Certificate_Changelog_Type_Set_Input>;
  pk_columns: Course_Certificate_Changelog_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Certificate_Changelog_Type_ManyArgs = {
  updates: Array<Course_Certificate_Changelog_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Certificate_Hold_RequestArgs = {
  _set?: InputMaybe<Course_Certificate_Hold_Request_Set_Input>;
  where: Course_Certificate_Hold_Request_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Certificate_Hold_Request_By_PkArgs = {
  _set?: InputMaybe<Course_Certificate_Hold_Request_Set_Input>;
  pk_columns: Course_Certificate_Hold_Request_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Certificate_Hold_Request_ManyArgs = {
  updates: Array<Course_Certificate_Hold_Request_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Certificate_ManyArgs = {
  updates: Array<Course_Certificate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Delivery_TypeArgs = {
  _set?: InputMaybe<Course_Delivery_Type_Set_Input>;
  where: Course_Delivery_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Delivery_Type_By_PkArgs = {
  _set?: InputMaybe<Course_Delivery_Type_Set_Input>;
  pk_columns: Course_Delivery_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Delivery_Type_ManyArgs = {
  updates: Array<Course_Delivery_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Delivery_Type_PrefixArgs = {
  _set?: InputMaybe<Course_Delivery_Type_Prefix_Set_Input>;
  where: Course_Delivery_Type_Prefix_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Delivery_Type_Prefix_By_PkArgs = {
  _set?: InputMaybe<Course_Delivery_Type_Prefix_Set_Input>;
  pk_columns: Course_Delivery_Type_Prefix_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Delivery_Type_Prefix_ManyArgs = {
  updates: Array<Course_Delivery_Type_Prefix_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_DraftArgs = {
  _append?: InputMaybe<Course_Draft_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Draft_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Draft_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Draft_Delete_Key_Input>;
  _prepend?: InputMaybe<Course_Draft_Prepend_Input>;
  _set?: InputMaybe<Course_Draft_Set_Input>;
  where: Course_Draft_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Draft_By_PkArgs = {
  _append?: InputMaybe<Course_Draft_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Draft_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Draft_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Draft_Delete_Key_Input>;
  _prepend?: InputMaybe<Course_Draft_Prepend_Input>;
  _set?: InputMaybe<Course_Draft_Set_Input>;
  pk_columns: Course_Draft_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Draft_ManyArgs = {
  updates: Array<Course_Draft_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_End_JobsArgs = {
  _inc?: InputMaybe<Course_End_Jobs_Inc_Input>;
  _set?: InputMaybe<Course_End_Jobs_Set_Input>;
  where: Course_End_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_End_Jobs_By_PkArgs = {
  _inc?: InputMaybe<Course_End_Jobs_Inc_Input>;
  _set?: InputMaybe<Course_End_Jobs_Set_Input>;
  pk_columns: Course_End_Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_End_Jobs_ManyArgs = {
  updates: Array<Course_End_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_EnquiryArgs = {
  _inc?: InputMaybe<Course_Enquiry_Inc_Input>;
  _set?: InputMaybe<Course_Enquiry_Set_Input>;
  where: Course_Enquiry_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Enquiry_By_PkArgs = {
  _inc?: InputMaybe<Course_Enquiry_Inc_Input>;
  _set?: InputMaybe<Course_Enquiry_Set_Input>;
  pk_columns: Course_Enquiry_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Enquiry_ManyArgs = {
  updates: Array<Course_Enquiry_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_AnswersArgs = {
  _inc?: InputMaybe<Course_Evaluation_Answers_Inc_Input>;
  _set?: InputMaybe<Course_Evaluation_Answers_Set_Input>;
  where: Course_Evaluation_Answers_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Answers_By_PkArgs = {
  _inc?: InputMaybe<Course_Evaluation_Answers_Inc_Input>;
  _set?: InputMaybe<Course_Evaluation_Answers_Set_Input>;
  pk_columns: Course_Evaluation_Answers_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Answers_ManyArgs = {
  updates: Array<Course_Evaluation_Answers_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Question_GroupArgs = {
  _set?: InputMaybe<Course_Evaluation_Question_Group_Set_Input>;
  where: Course_Evaluation_Question_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Question_Group_By_PkArgs = {
  _set?: InputMaybe<Course_Evaluation_Question_Group_Set_Input>;
  pk_columns: Course_Evaluation_Question_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Question_Group_ManyArgs = {
  updates: Array<Course_Evaluation_Question_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Question_TypeArgs = {
  _set?: InputMaybe<Course_Evaluation_Question_Type_Set_Input>;
  where: Course_Evaluation_Question_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Question_Type_By_PkArgs = {
  _set?: InputMaybe<Course_Evaluation_Question_Type_Set_Input>;
  pk_columns: Course_Evaluation_Question_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Question_Type_ManyArgs = {
  updates: Array<Course_Evaluation_Question_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_QuestionsArgs = {
  _inc?: InputMaybe<Course_Evaluation_Questions_Inc_Input>;
  _set?: InputMaybe<Course_Evaluation_Questions_Set_Input>;
  where: Course_Evaluation_Questions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Questions_By_PkArgs = {
  _inc?: InputMaybe<Course_Evaluation_Questions_Inc_Input>;
  _set?: InputMaybe<Course_Evaluation_Questions_Set_Input>;
  pk_columns: Course_Evaluation_Questions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Questions_ManyArgs = {
  updates: Array<Course_Evaluation_Questions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Scheduled_EventArgs = {
  _inc?: InputMaybe<Course_Evaluation_Scheduled_Event_Inc_Input>;
  _set?: InputMaybe<Course_Evaluation_Scheduled_Event_Set_Input>;
  where: Course_Evaluation_Scheduled_Event_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Scheduled_Event_By_PkArgs = {
  _inc?: InputMaybe<Course_Evaluation_Scheduled_Event_Inc_Input>;
  _set?: InputMaybe<Course_Evaluation_Scheduled_Event_Set_Input>;
  pk_columns: Course_Evaluation_Scheduled_Event_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Evaluation_Scheduled_Event_ManyArgs = {
  updates: Array<Course_Evaluation_Scheduled_Event_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_ExceptionArgs = {
  _set?: InputMaybe<Course_Exception_Set_Input>;
  where: Course_Exception_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Exception_By_PkArgs = {
  _set?: InputMaybe<Course_Exception_Set_Input>;
  pk_columns: Course_Exception_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Exception_ManyArgs = {
  updates: Array<Course_Exception_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_ExceptionsArgs = {
  _inc?: InputMaybe<Course_Exceptions_Inc_Input>;
  _set?: InputMaybe<Course_Exceptions_Set_Input>;
  where: Course_Exceptions_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Exceptions_By_PkArgs = {
  _inc?: InputMaybe<Course_Exceptions_Inc_Input>;
  _set?: InputMaybe<Course_Exceptions_Set_Input>;
  pk_columns: Course_Exceptions_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Exceptions_ManyArgs = {
  updates: Array<Course_Exceptions_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_ExpensesArgs = {
  _append?: InputMaybe<Course_Expenses_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Expenses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Expenses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Expenses_Delete_Key_Input>;
  _inc?: InputMaybe<Course_Expenses_Inc_Input>;
  _prepend?: InputMaybe<Course_Expenses_Prepend_Input>;
  _set?: InputMaybe<Course_Expenses_Set_Input>;
  where: Course_Expenses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Expenses_By_PkArgs = {
  _append?: InputMaybe<Course_Expenses_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Expenses_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Expenses_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Expenses_Delete_Key_Input>;
  _inc?: InputMaybe<Course_Expenses_Inc_Input>;
  _prepend?: InputMaybe<Course_Expenses_Prepend_Input>;
  _set?: InputMaybe<Course_Expenses_Set_Input>;
  pk_columns: Course_Expenses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Expenses_ManyArgs = {
  updates: Array<Course_Expenses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Invite_StatusArgs = {
  _set?: InputMaybe<Course_Invite_Status_Set_Input>;
  where: Course_Invite_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Invite_Status_By_PkArgs = {
  _set?: InputMaybe<Course_Invite_Status_Set_Input>;
  pk_columns: Course_Invite_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Invite_Status_ManyArgs = {
  updates: Array<Course_Invite_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_InvitesArgs = {
  _inc?: InputMaybe<Course_Invites_Inc_Input>;
  _set?: InputMaybe<Course_Invites_Set_Input>;
  where: Course_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Invites_By_PkArgs = {
  _inc?: InputMaybe<Course_Invites_Inc_Input>;
  _set?: InputMaybe<Course_Invites_Set_Input>;
  pk_columns: Course_Invites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Invites_ManyArgs = {
  updates: Array<Course_Invites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_LevelArgs = {
  _set?: InputMaybe<Course_Level_Set_Input>;
  where: Course_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Level_By_PkArgs = {
  _set?: InputMaybe<Course_Level_Set_Input>;
  pk_columns: Course_Level_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Level_ManyArgs = {
  updates: Array<Course_Level_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Level_PrefixArgs = {
  _set?: InputMaybe<Course_Level_Prefix_Set_Input>;
  where: Course_Level_Prefix_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Level_Prefix_By_PkArgs = {
  _set?: InputMaybe<Course_Level_Prefix_Set_Input>;
  pk_columns: Course_Level_Prefix_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Level_Prefix_ManyArgs = {
  updates: Array<Course_Level_Prefix_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_ManyArgs = {
  updates: Array<Course_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_ModuleArgs = {
  _inc?: InputMaybe<Course_Module_Inc_Input>;
  _set?: InputMaybe<Course_Module_Set_Input>;
  where: Course_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Module_By_PkArgs = {
  _inc?: InputMaybe<Course_Module_Inc_Input>;
  _set?: InputMaybe<Course_Module_Set_Input>;
  pk_columns: Course_Module_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Module_ManyArgs = {
  updates: Array<Course_Module_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_OrderArgs = {
  _inc?: InputMaybe<Course_Order_Inc_Input>;
  _set?: InputMaybe<Course_Order_Set_Input>;
  where: Course_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Order_ManyArgs = {
  updates: Array<Course_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_ParticipantArgs = {
  _append?: InputMaybe<Course_Participant_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Participant_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Participant_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Participant_Delete_Key_Input>;
  _inc?: InputMaybe<Course_Participant_Inc_Input>;
  _prepend?: InputMaybe<Course_Participant_Prepend_Input>;
  _set?: InputMaybe<Course_Participant_Set_Input>;
  where: Course_Participant_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_AuditArgs = {
  _append?: InputMaybe<Course_Participant_Audit_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Participant_Audit_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Participant_Audit_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Participant_Audit_Delete_Key_Input>;
  _inc?: InputMaybe<Course_Participant_Audit_Inc_Input>;
  _prepend?: InputMaybe<Course_Participant_Audit_Prepend_Input>;
  _set?: InputMaybe<Course_Participant_Audit_Set_Input>;
  where: Course_Participant_Audit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Audit_By_PkArgs = {
  _append?: InputMaybe<Course_Participant_Audit_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Participant_Audit_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Participant_Audit_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Participant_Audit_Delete_Key_Input>;
  _inc?: InputMaybe<Course_Participant_Audit_Inc_Input>;
  _prepend?: InputMaybe<Course_Participant_Audit_Prepend_Input>;
  _set?: InputMaybe<Course_Participant_Audit_Set_Input>;
  pk_columns: Course_Participant_Audit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Audit_ManyArgs = {
  updates: Array<Course_Participant_Audit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Audit_TypeArgs = {
  _set?: InputMaybe<Course_Participant_Audit_Type_Set_Input>;
  where: Course_Participant_Audit_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Audit_Type_By_PkArgs = {
  _set?: InputMaybe<Course_Participant_Audit_Type_Set_Input>;
  pk_columns: Course_Participant_Audit_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Audit_Type_ManyArgs = {
  updates: Array<Course_Participant_Audit_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Bild_ModuleArgs = {
  _append?: InputMaybe<Course_Participant_Bild_Module_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Participant_Bild_Module_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Participant_Bild_Module_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Participant_Bild_Module_Delete_Key_Input>;
  _prepend?: InputMaybe<Course_Participant_Bild_Module_Prepend_Input>;
  _set?: InputMaybe<Course_Participant_Bild_Module_Set_Input>;
  where: Course_Participant_Bild_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Bild_Module_By_PkArgs = {
  _append?: InputMaybe<Course_Participant_Bild_Module_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Participant_Bild_Module_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Participant_Bild_Module_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Participant_Bild_Module_Delete_Key_Input>;
  _prepend?: InputMaybe<Course_Participant_Bild_Module_Prepend_Input>;
  _set?: InputMaybe<Course_Participant_Bild_Module_Set_Input>;
  pk_columns: Course_Participant_Bild_Module_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Bild_Module_ManyArgs = {
  updates: Array<Course_Participant_Bild_Module_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_By_PkArgs = {
  _append?: InputMaybe<Course_Participant_Append_Input>;
  _delete_at_path?: InputMaybe<Course_Participant_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Course_Participant_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Course_Participant_Delete_Key_Input>;
  _inc?: InputMaybe<Course_Participant_Inc_Input>;
  _prepend?: InputMaybe<Course_Participant_Prepend_Input>;
  _set?: InputMaybe<Course_Participant_Set_Input>;
  pk_columns: Course_Participant_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_CancellationArgs = {
  _inc?: InputMaybe<Course_Participant_Cancellation_Inc_Input>;
  _set?: InputMaybe<Course_Participant_Cancellation_Set_Input>;
  where: Course_Participant_Cancellation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Cancellation_By_PkArgs = {
  _inc?: InputMaybe<Course_Participant_Cancellation_Inc_Input>;
  _set?: InputMaybe<Course_Participant_Cancellation_Set_Input>;
  pk_columns: Course_Participant_Cancellation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Cancellation_ManyArgs = {
  updates: Array<Course_Participant_Cancellation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_ManyArgs = {
  updates: Array<Course_Participant_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_ModuleArgs = {
  _set?: InputMaybe<Course_Participant_Module_Set_Input>;
  where: Course_Participant_Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Module_By_PkArgs = {
  _set?: InputMaybe<Course_Participant_Module_Set_Input>;
  pk_columns: Course_Participant_Module_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Module_ManyArgs = {
  updates: Array<Course_Participant_Module_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_NoteArgs = {
  _set?: InputMaybe<Course_Participant_Note_Set_Input>;
  where: Course_Participant_Note_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Note_By_PkArgs = {
  _set?: InputMaybe<Course_Participant_Note_Set_Input>;
  pk_columns: Course_Participant_Note_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Participant_Note_ManyArgs = {
  updates: Array<Course_Participant_Note_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_PricingArgs = {
  _inc?: InputMaybe<Course_Pricing_Inc_Input>;
  _set?: InputMaybe<Course_Pricing_Set_Input>;
  where: Course_Pricing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Pricing_By_PkArgs = {
  _inc?: InputMaybe<Course_Pricing_Inc_Input>;
  _set?: InputMaybe<Course_Pricing_Set_Input>;
  pk_columns: Course_Pricing_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Pricing_ChangelogArgs = {
  _inc?: InputMaybe<Course_Pricing_Changelog_Inc_Input>;
  _set?: InputMaybe<Course_Pricing_Changelog_Set_Input>;
  where: Course_Pricing_Changelog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Pricing_Changelog_By_PkArgs = {
  _inc?: InputMaybe<Course_Pricing_Changelog_Inc_Input>;
  _set?: InputMaybe<Course_Pricing_Changelog_Set_Input>;
  pk_columns: Course_Pricing_Changelog_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Pricing_Changelog_ManyArgs = {
  updates: Array<Course_Pricing_Changelog_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Pricing_ManyArgs = {
  updates: Array<Course_Pricing_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Pricing_ScheduleArgs = {
  _inc?: InputMaybe<Course_Pricing_Schedule_Inc_Input>;
  _set?: InputMaybe<Course_Pricing_Schedule_Set_Input>;
  where: Course_Pricing_Schedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Pricing_Schedule_By_PkArgs = {
  _inc?: InputMaybe<Course_Pricing_Schedule_Inc_Input>;
  _set?: InputMaybe<Course_Pricing_Schedule_Set_Input>;
  pk_columns: Course_Pricing_Schedule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Pricing_Schedule_ManyArgs = {
  updates: Array<Course_Pricing_Schedule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Promo_CodeArgs = {
  _inc?: InputMaybe<Course_Promo_Code_Inc_Input>;
  _set?: InputMaybe<Course_Promo_Code_Set_Input>;
  where: Course_Promo_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Promo_Code_By_PkArgs = {
  _inc?: InputMaybe<Course_Promo_Code_Inc_Input>;
  _set?: InputMaybe<Course_Promo_Code_Set_Input>;
  pk_columns: Course_Promo_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Promo_Code_ManyArgs = {
  updates: Array<Course_Promo_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Renewal_CycleArgs = {
  _set?: InputMaybe<Course_Renewal_Cycle_Set_Input>;
  where: Course_Renewal_Cycle_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Renewal_Cycle_By_PkArgs = {
  _set?: InputMaybe<Course_Renewal_Cycle_Set_Input>;
  pk_columns: Course_Renewal_Cycle_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Renewal_Cycle_ManyArgs = {
  updates: Array<Course_Renewal_Cycle_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_ScheduleArgs = {
  _inc?: InputMaybe<Course_Schedule_Inc_Input>;
  _set?: InputMaybe<Course_Schedule_Set_Input>;
  where: Course_Schedule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Schedule_By_PkArgs = {
  _inc?: InputMaybe<Course_Schedule_Inc_Input>;
  _set?: InputMaybe<Course_Schedule_Set_Input>;
  pk_columns: Course_Schedule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Schedule_ManyArgs = {
  updates: Array<Course_Schedule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_SourceArgs = {
  _set?: InputMaybe<Course_Source_Set_Input>;
  where: Course_Source_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Source_By_PkArgs = {
  _set?: InputMaybe<Course_Source_Set_Input>;
  pk_columns: Course_Source_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Source_ManyArgs = {
  updates: Array<Course_Source_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_StatusArgs = {
  _set?: InputMaybe<Course_Status_Set_Input>;
  where: Course_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Status_By_PkArgs = {
  _set?: InputMaybe<Course_Status_Set_Input>;
  pk_columns: Course_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Status_ManyArgs = {
  updates: Array<Course_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_TrainerArgs = {
  _inc?: InputMaybe<Course_Trainer_Inc_Input>;
  _set?: InputMaybe<Course_Trainer_Set_Input>;
  where: Course_Trainer_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Trainer_By_PkArgs = {
  _inc?: InputMaybe<Course_Trainer_Inc_Input>;
  _set?: InputMaybe<Course_Trainer_Set_Input>;
  pk_columns: Course_Trainer_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Trainer_ManyArgs = {
  updates: Array<Course_Trainer_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Trainer_TypeArgs = {
  _set?: InputMaybe<Course_Trainer_Type_Set_Input>;
  where: Course_Trainer_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Trainer_Type_By_PkArgs = {
  _set?: InputMaybe<Course_Trainer_Type_Set_Input>;
  pk_columns: Course_Trainer_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Trainer_Type_ManyArgs = {
  updates: Array<Course_Trainer_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_TypeArgs = {
  _set?: InputMaybe<Course_Type_Set_Input>;
  where: Course_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Type_By_PkArgs = {
  _set?: InputMaybe<Course_Type_Set_Input>;
  pk_columns: Course_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Type_ManyArgs = {
  updates: Array<Course_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Type_PrefixArgs = {
  _set?: InputMaybe<Course_Type_Prefix_Set_Input>;
  where: Course_Type_Prefix_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Type_Prefix_By_PkArgs = {
  _set?: InputMaybe<Course_Type_Prefix_Set_Input>;
  pk_columns: Course_Type_Prefix_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Course_Type_Prefix_ManyArgs = {
  updates: Array<Course_Type_Prefix_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cqc_EstablishmentArgs = {
  _set?: InputMaybe<Cqc_Establishment_Set_Input>;
  where: Cqc_Establishment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cqc_Establishment_By_PkArgs = {
  _set?: InputMaybe<Cqc_Establishment_Set_Input>;
  pk_columns: Cqc_Establishment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cqc_Establishment_ManyArgs = {
  updates: Array<Cqc_Establishment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Cud_OperationArgs = {
  _set?: InputMaybe<Cud_Operation_Set_Input>;
  where: Cud_Operation_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Cud_Operation_By_PkArgs = {
  _set?: InputMaybe<Cud_Operation_Set_Input>;
  pk_columns: Cud_Operation_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Cud_Operation_ManyArgs = {
  updates: Array<Cud_Operation_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Deleted_Organizations_BackupArgs = {
  _append?: InputMaybe<Deleted_Organizations_Backup_Append_Input>;
  _delete_at_path?: InputMaybe<Deleted_Organizations_Backup_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Deleted_Organizations_Backup_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Deleted_Organizations_Backup_Delete_Key_Input>;
  _inc?: InputMaybe<Deleted_Organizations_Backup_Inc_Input>;
  _prepend?: InputMaybe<Deleted_Organizations_Backup_Prepend_Input>;
  _set?: InputMaybe<Deleted_Organizations_Backup_Set_Input>;
  where: Deleted_Organizations_Backup_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Deleted_Organizations_Backup_ManyArgs = {
  updates: Array<Deleted_Organizations_Backup_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Dfe_EstablishmentArgs = {
  _set?: InputMaybe<Dfe_Establishment_Set_Input>;
  where: Dfe_Establishment_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Dfe_Establishment_By_PkArgs = {
  _set?: InputMaybe<Dfe_Establishment_Set_Input>;
  pk_columns: Dfe_Establishment_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Dfe_Establishment_ManyArgs = {
  updates: Array<Dfe_Establishment_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Email_NotificationsArgs = {
  _append?: InputMaybe<Email_Notifications_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Notifications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Notifications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Notifications_Delete_Key_Input>;
  _inc?: InputMaybe<Email_Notifications_Inc_Input>;
  _prepend?: InputMaybe<Email_Notifications_Prepend_Input>;
  _set?: InputMaybe<Email_Notifications_Set_Input>;
  where: Email_Notifications_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Notifications_By_PkArgs = {
  _append?: InputMaybe<Email_Notifications_Append_Input>;
  _delete_at_path?: InputMaybe<Email_Notifications_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Email_Notifications_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Email_Notifications_Delete_Key_Input>;
  _inc?: InputMaybe<Email_Notifications_Inc_Input>;
  _prepend?: InputMaybe<Email_Notifications_Prepend_Input>;
  _set?: InputMaybe<Email_Notifications_Set_Input>;
  pk_columns: Email_Notifications_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Email_Notifications_ManyArgs = {
  updates: Array<Email_Notifications_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Expire_Go1_License_JobsArgs = {
  _set?: InputMaybe<Expire_Go1_License_Jobs_Set_Input>;
  where: Expire_Go1_License_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Expire_Go1_License_Jobs_By_PkArgs = {
  _set?: InputMaybe<Expire_Go1_License_Jobs_Set_Input>;
  pk_columns: Expire_Go1_License_Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Expire_Go1_License_Jobs_ManyArgs = {
  updates: Array<Expire_Go1_License_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Go1_History_EventsArgs = {
  _set?: InputMaybe<Go1_History_Events_Set_Input>;
  where: Go1_History_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Go1_History_Events_By_PkArgs = {
  _set?: InputMaybe<Go1_History_Events_Set_Input>;
  pk_columns: Go1_History_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Go1_History_Events_ManyArgs = {
  updates: Array<Go1_History_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Go1_LicensesArgs = {
  _inc?: InputMaybe<Go1_Licenses_Inc_Input>;
  _set?: InputMaybe<Go1_Licenses_Set_Input>;
  where: Go1_Licenses_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Go1_Licenses_By_PkArgs = {
  _inc?: InputMaybe<Go1_Licenses_Inc_Input>;
  _set?: InputMaybe<Go1_Licenses_Set_Input>;
  pk_columns: Go1_Licenses_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Go1_Licenses_HistoryArgs = {
  _append?: InputMaybe<Go1_Licenses_History_Append_Input>;
  _delete_at_path?: InputMaybe<Go1_Licenses_History_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Go1_Licenses_History_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Go1_Licenses_History_Delete_Key_Input>;
  _inc?: InputMaybe<Go1_Licenses_History_Inc_Input>;
  _prepend?: InputMaybe<Go1_Licenses_History_Prepend_Input>;
  _set?: InputMaybe<Go1_Licenses_History_Set_Input>;
  where: Go1_Licenses_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Go1_Licenses_History_By_PkArgs = {
  _append?: InputMaybe<Go1_Licenses_History_Append_Input>;
  _delete_at_path?: InputMaybe<Go1_Licenses_History_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Go1_Licenses_History_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Go1_Licenses_History_Delete_Key_Input>;
  _inc?: InputMaybe<Go1_Licenses_History_Inc_Input>;
  _prepend?: InputMaybe<Go1_Licenses_History_Prepend_Input>;
  _set?: InputMaybe<Go1_Licenses_History_Set_Input>;
  pk_columns: Go1_Licenses_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Go1_Licenses_History_ManyArgs = {
  updates: Array<Go1_Licenses_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Go1_Licenses_ManyArgs = {
  updates: Array<Go1_Licenses_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_GradeArgs = {
  _set?: InputMaybe<Grade_Set_Input>;
  where: Grade_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_By_PkArgs = {
  _set?: InputMaybe<Grade_Set_Input>;
  pk_columns: Grade_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Grade_ManyArgs = {
  updates: Array<Grade_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Hubspot_AuditArgs = {
  _append?: InputMaybe<Hubspot_Audit_Append_Input>;
  _delete_at_path?: InputMaybe<Hubspot_Audit_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Hubspot_Audit_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Hubspot_Audit_Delete_Key_Input>;
  _prepend?: InputMaybe<Hubspot_Audit_Prepend_Input>;
  _set?: InputMaybe<Hubspot_Audit_Set_Input>;
  where: Hubspot_Audit_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Hubspot_Audit_By_PkArgs = {
  _append?: InputMaybe<Hubspot_Audit_Append_Input>;
  _delete_at_path?: InputMaybe<Hubspot_Audit_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Hubspot_Audit_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Hubspot_Audit_Delete_Key_Input>;
  _prepend?: InputMaybe<Hubspot_Audit_Prepend_Input>;
  _set?: InputMaybe<Hubspot_Audit_Set_Input>;
  pk_columns: Hubspot_Audit_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Hubspot_Audit_ManyArgs = {
  updates: Array<Hubspot_Audit_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_IdentityArgs = {
  _set?: InputMaybe<Identity_Set_Input>;
  where: Identity_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Identity_By_PkArgs = {
  _set?: InputMaybe<Identity_Set_Input>;
  pk_columns: Identity_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Identity_ManyArgs = {
  updates: Array<Identity_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Identity_TypeArgs = {
  _set?: InputMaybe<Identity_Type_Set_Input>;
  where: Identity_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Identity_Type_By_PkArgs = {
  _set?: InputMaybe<Identity_Type_Set_Input>;
  pk_columns: Identity_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Identity_Type_ManyArgs = {
  updates: Array<Identity_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Import_JobArgs = {
  _append?: InputMaybe<Import_Job_Append_Input>;
  _delete_at_path?: InputMaybe<Import_Job_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Import_Job_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Import_Job_Delete_Key_Input>;
  _prepend?: InputMaybe<Import_Job_Prepend_Input>;
  _set?: InputMaybe<Import_Job_Set_Input>;
  where: Import_Job_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Import_Job_By_PkArgs = {
  _append?: InputMaybe<Import_Job_Append_Input>;
  _delete_at_path?: InputMaybe<Import_Job_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Import_Job_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Import_Job_Delete_Key_Input>;
  _prepend?: InputMaybe<Import_Job_Prepend_Input>;
  _set?: InputMaybe<Import_Job_Set_Input>;
  pk_columns: Import_Job_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Import_Job_ManyArgs = {
  updates: Array<Import_Job_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Import_Job_StatusArgs = {
  _set?: InputMaybe<Import_Job_Status_Set_Input>;
  where: Import_Job_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Import_Job_Status_By_PkArgs = {
  _set?: InputMaybe<Import_Job_Status_Set_Input>;
  pk_columns: Import_Job_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Import_Job_Status_ManyArgs = {
  updates: Array<Import_Job_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Import_Job_TypeArgs = {
  _set?: InputMaybe<Import_Job_Type_Set_Input>;
  where: Import_Job_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Import_Job_Type_By_PkArgs = {
  _set?: InputMaybe<Import_Job_Type_Set_Input>;
  pk_columns: Import_Job_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Import_Job_Type_ManyArgs = {
  updates: Array<Import_Job_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Job_TitleArgs = {
  _set?: InputMaybe<Job_Title_Set_Input>;
  where: Job_Title_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Title_By_PkArgs = {
  _set?: InputMaybe<Job_Title_Set_Input>;
  pk_columns: Job_Title_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Job_Title_ManyArgs = {
  updates: Array<Job_Title_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_CertificateArgs = {
  _append?: InputMaybe<Legacy_Certificate_Append_Input>;
  _delete_at_path?: InputMaybe<Legacy_Certificate_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Legacy_Certificate_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Legacy_Certificate_Delete_Key_Input>;
  _inc?: InputMaybe<Legacy_Certificate_Inc_Input>;
  _prepend?: InputMaybe<Legacy_Certificate_Prepend_Input>;
  _set?: InputMaybe<Legacy_Certificate_Set_Input>;
  where: Legacy_Certificate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Certificate_By_PkArgs = {
  _append?: InputMaybe<Legacy_Certificate_Append_Input>;
  _delete_at_path?: InputMaybe<Legacy_Certificate_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Legacy_Certificate_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Legacy_Certificate_Delete_Key_Input>;
  _inc?: InputMaybe<Legacy_Certificate_Inc_Input>;
  _prepend?: InputMaybe<Legacy_Certificate_Prepend_Input>;
  _set?: InputMaybe<Legacy_Certificate_Set_Input>;
  pk_columns: Legacy_Certificate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Legacy_Certificate_ManyArgs = {
  updates: Array<Legacy_Certificate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Materials_OrderArgs = {
  _append?: InputMaybe<Materials_Order_Append_Input>;
  _delete_at_path?: InputMaybe<Materials_Order_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Materials_Order_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Materials_Order_Delete_Key_Input>;
  _inc?: InputMaybe<Materials_Order_Inc_Input>;
  _prepend?: InputMaybe<Materials_Order_Prepend_Input>;
  _set?: InputMaybe<Materials_Order_Set_Input>;
  where: Materials_Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Materials_Order_By_PkArgs = {
  _append?: InputMaybe<Materials_Order_Append_Input>;
  _delete_at_path?: InputMaybe<Materials_Order_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Materials_Order_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Materials_Order_Delete_Key_Input>;
  _inc?: InputMaybe<Materials_Order_Inc_Input>;
  _prepend?: InputMaybe<Materials_Order_Prepend_Input>;
  _set?: InputMaybe<Materials_Order_Set_Input>;
  pk_columns: Materials_Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Materials_Order_ManyArgs = {
  updates: Array<Materials_Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Merge_Organizations_LogsArgs = {
  _set?: InputMaybe<Merge_Organizations_Logs_Set_Input>;
  where: Merge_Organizations_Logs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Merge_Organizations_Logs_By_PkArgs = {
  _set?: InputMaybe<Merge_Organizations_Logs_Set_Input>;
  pk_columns: Merge_Organizations_Logs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Merge_Organizations_Logs_ManyArgs = {
  updates: Array<Merge_Organizations_Logs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Merged_OrganizationsArgs = {
  _append?: InputMaybe<Merged_Organizations_Append_Input>;
  _delete_at_path?: InputMaybe<Merged_Organizations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Merged_Organizations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Merged_Organizations_Delete_Key_Input>;
  _prepend?: InputMaybe<Merged_Organizations_Prepend_Input>;
  _set?: InputMaybe<Merged_Organizations_Set_Input>;
  where: Merged_Organizations_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Merged_Organizations_By_PkArgs = {
  _append?: InputMaybe<Merged_Organizations_Append_Input>;
  _delete_at_path?: InputMaybe<Merged_Organizations_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Merged_Organizations_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Merged_Organizations_Delete_Key_Input>;
  _prepend?: InputMaybe<Merged_Organizations_Prepend_Input>;
  _set?: InputMaybe<Merged_Organizations_Set_Input>;
  pk_columns: Merged_Organizations_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Merged_Organizations_ManyArgs = {
  updates: Array<Merged_Organizations_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ModuleArgs = {
  _set?: InputMaybe<Module_Set_Input>;
  where: Module_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Module_By_PkArgs = {
  _set?: InputMaybe<Module_Set_Input>;
  pk_columns: Module_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Module_CategoryArgs = {
  _set?: InputMaybe<Module_Category_Set_Input>;
  where: Module_Category_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Category_By_PkArgs = {
  _set?: InputMaybe<Module_Category_Set_Input>;
  pk_columns: Module_Category_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Category_ManyArgs = {
  updates: Array<Module_Category_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Module_GroupArgs = {
  _append?: InputMaybe<Module_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Module_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Module_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Module_Group_Delete_Key_Input>;
  _prepend?: InputMaybe<Module_Group_Prepend_Input>;
  _set?: InputMaybe<Module_Group_Set_Input>;
  where: Module_Group_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Group_By_PkArgs = {
  _append?: InputMaybe<Module_Group_Append_Input>;
  _delete_at_path?: InputMaybe<Module_Group_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Module_Group_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Module_Group_Delete_Key_Input>;
  _prepend?: InputMaybe<Module_Group_Prepend_Input>;
  _set?: InputMaybe<Module_Group_Set_Input>;
  pk_columns: Module_Group_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Group_DurationArgs = {
  _inc?: InputMaybe<Module_Group_Duration_Inc_Input>;
  _set?: InputMaybe<Module_Group_Duration_Set_Input>;
  where: Module_Group_Duration_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Group_Duration_By_PkArgs = {
  _inc?: InputMaybe<Module_Group_Duration_Inc_Input>;
  _set?: InputMaybe<Module_Group_Duration_Set_Input>;
  pk_columns: Module_Group_Duration_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Group_Duration_ManyArgs = {
  updates: Array<Module_Group_Duration_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Group_ManyArgs = {
  updates: Array<Module_Group_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Module_ManyArgs = {
  updates: Array<Module_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Module_SettingArgs = {
  _inc?: InputMaybe<Module_Setting_Inc_Input>;
  _set?: InputMaybe<Module_Setting_Set_Input>;
  where: Module_Setting_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Setting_By_PkArgs = {
  _inc?: InputMaybe<Module_Setting_Inc_Input>;
  _set?: InputMaybe<Module_Setting_Set_Input>;
  pk_columns: Module_Setting_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Setting_DependencyArgs = {
  _set?: InputMaybe<Module_Setting_Dependency_Set_Input>;
  where: Module_Setting_Dependency_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Setting_Dependency_By_PkArgs = {
  _set?: InputMaybe<Module_Setting_Dependency_Set_Input>;
  pk_columns: Module_Setting_Dependency_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Setting_Dependency_ManyArgs = {
  updates: Array<Module_Setting_Dependency_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Module_Setting_ManyArgs = {
  updates: Array<Module_Setting_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Module_V2Args = {
  _append?: InputMaybe<Module_V2_Append_Input>;
  _delete_at_path?: InputMaybe<Module_V2_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Module_V2_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Module_V2_Delete_Key_Input>;
  _prepend?: InputMaybe<Module_V2_Prepend_Input>;
  _set?: InputMaybe<Module_V2_Set_Input>;
  where: Module_V2_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Module_V2_By_PkArgs = {
  _append?: InputMaybe<Module_V2_Append_Input>;
  _delete_at_path?: InputMaybe<Module_V2_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Module_V2_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Module_V2_Delete_Key_Input>;
  _prepend?: InputMaybe<Module_V2_Prepend_Input>;
  _set?: InputMaybe<Module_V2_Set_Input>;
  pk_columns: Module_V2_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Module_V2_ManyArgs = {
  updates: Array<Module_V2_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Non_Graded_CertificateArgs = {
  _inc?: InputMaybe<Non_Graded_Certificate_Inc_Input>;
  _set?: InputMaybe<Non_Graded_Certificate_Set_Input>;
  where: Non_Graded_Certificate_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Non_Graded_Certificate_By_PkArgs = {
  _inc?: InputMaybe<Non_Graded_Certificate_Inc_Input>;
  _set?: InputMaybe<Non_Graded_Certificate_Set_Input>;
  pk_columns: Non_Graded_Certificate_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Non_Graded_Certificate_ManyArgs = {
  updates: Array<Non_Graded_Certificate_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrderArgs = {
  _append?: InputMaybe<Order_Append_Input>;
  _delete_at_path?: InputMaybe<Order_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Order_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Order_Delete_Key_Input>;
  _inc?: InputMaybe<Order_Inc_Input>;
  _prepend?: InputMaybe<Order_Prepend_Input>;
  _set?: InputMaybe<Order_Set_Input>;
  where: Order_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_By_PkArgs = {
  _append?: InputMaybe<Order_Append_Input>;
  _delete_at_path?: InputMaybe<Order_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Order_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Order_Delete_Key_Input>;
  _inc?: InputMaybe<Order_Inc_Input>;
  _prepend?: InputMaybe<Order_Prepend_Input>;
  _set?: InputMaybe<Order_Set_Input>;
  pk_columns: Order_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_ManyArgs = {
  updates: Array<Order_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Order_TempArgs = {
  _append?: InputMaybe<Order_Temp_Append_Input>;
  _delete_at_path?: InputMaybe<Order_Temp_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Order_Temp_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Order_Temp_Delete_Key_Input>;
  _inc?: InputMaybe<Order_Temp_Inc_Input>;
  _prepend?: InputMaybe<Order_Temp_Prepend_Input>;
  _set?: InputMaybe<Order_Temp_Set_Input>;
  where: Order_Temp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Temp_By_PkArgs = {
  _append?: InputMaybe<Order_Temp_Append_Input>;
  _delete_at_path?: InputMaybe<Order_Temp_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Order_Temp_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Order_Temp_Delete_Key_Input>;
  _inc?: InputMaybe<Order_Temp_Inc_Input>;
  _prepend?: InputMaybe<Order_Temp_Prepend_Input>;
  _set?: InputMaybe<Order_Temp_Set_Input>;
  pk_columns: Order_Temp_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Order_Temp_ManyArgs = {
  updates: Array<Order_Temp_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Created_FromArgs = {
  _set?: InputMaybe<Org_Created_From_Set_Input>;
  where: Org_Created_From_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Created_From_By_PkArgs = {
  _set?: InputMaybe<Org_Created_From_Set_Input>;
  pk_columns: Org_Created_From_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Created_From_ManyArgs = {
  updates: Array<Org_Created_From_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Resource_Packs_HistoryArgs = {
  _append?: InputMaybe<Org_Resource_Packs_History_Append_Input>;
  _delete_at_path?: InputMaybe<Org_Resource_Packs_History_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Org_Resource_Packs_History_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Org_Resource_Packs_History_Delete_Key_Input>;
  _inc?: InputMaybe<Org_Resource_Packs_History_Inc_Input>;
  _prepend?: InputMaybe<Org_Resource_Packs_History_Prepend_Input>;
  _set?: InputMaybe<Org_Resource_Packs_History_Set_Input>;
  where: Org_Resource_Packs_History_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Resource_Packs_History_By_PkArgs = {
  _append?: InputMaybe<Org_Resource_Packs_History_Append_Input>;
  _delete_at_path?: InputMaybe<Org_Resource_Packs_History_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Org_Resource_Packs_History_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Org_Resource_Packs_History_Delete_Key_Input>;
  _inc?: InputMaybe<Org_Resource_Packs_History_Inc_Input>;
  _prepend?: InputMaybe<Org_Resource_Packs_History_Prepend_Input>;
  _set?: InputMaybe<Org_Resource_Packs_History_Set_Input>;
  pk_columns: Org_Resource_Packs_History_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Resource_Packs_History_ManyArgs = {
  updates: Array<Org_Resource_Packs_History_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Resource_Packs_PricingArgs = {
  _inc?: InputMaybe<Org_Resource_Packs_Pricing_Inc_Input>;
  _set?: InputMaybe<Org_Resource_Packs_Pricing_Set_Input>;
  where: Org_Resource_Packs_Pricing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Resource_Packs_Pricing_By_PkArgs = {
  _inc?: InputMaybe<Org_Resource_Packs_Pricing_Inc_Input>;
  _set?: InputMaybe<Org_Resource_Packs_Pricing_Set_Input>;
  pk_columns: Org_Resource_Packs_Pricing_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Resource_Packs_Pricing_ChangelogArgs = {
  _append?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Append_Input>;
  _delete_at_path?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Delete_Key_Input>;
  _prepend?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Prepend_Input>;
  _set?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Set_Input>;
  where: Org_Resource_Packs_Pricing_Changelog_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Resource_Packs_Pricing_Changelog_By_PkArgs = {
  _append?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Append_Input>;
  _delete_at_path?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Delete_Key_Input>;
  _prepend?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Prepend_Input>;
  _set?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Set_Input>;
  pk_columns: Org_Resource_Packs_Pricing_Changelog_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Resource_Packs_Pricing_Changelog_ManyArgs = {
  updates: Array<Org_Resource_Packs_Pricing_Changelog_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Org_Resource_Packs_Pricing_ManyArgs = {
  updates: Array<Org_Resource_Packs_Pricing_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_LogArgs = {
  _append?: InputMaybe<Organisation_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Organisation_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organisation_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organisation_Log_Delete_Key_Input>;
  _prepend?: InputMaybe<Organisation_Log_Prepend_Input>;
  _set?: InputMaybe<Organisation_Log_Set_Input>;
  where: Organisation_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Log_By_PkArgs = {
  _append?: InputMaybe<Organisation_Log_Append_Input>;
  _delete_at_path?: InputMaybe<Organisation_Log_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organisation_Log_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organisation_Log_Delete_Key_Input>;
  _prepend?: InputMaybe<Organisation_Log_Prepend_Input>;
  _set?: InputMaybe<Organisation_Log_Set_Input>;
  pk_columns: Organisation_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Log_ManyArgs = {
  updates: Array<Organisation_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_SectorArgs = {
  _set?: InputMaybe<Organisation_Sector_Set_Input>;
  where: Organisation_Sector_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Sector_By_PkArgs = {
  _set?: InputMaybe<Organisation_Sector_Set_Input>;
  pk_columns: Organisation_Sector_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organisation_Sector_ManyArgs = {
  updates: Array<Organisation_Sector_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_OrganizationArgs = {
  _append?: InputMaybe<Organization_Append_Input>;
  _delete_at_path?: InputMaybe<Organization_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organization_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organization_Delete_Key_Input>;
  _inc?: InputMaybe<Organization_Inc_Input>;
  _prepend?: InputMaybe<Organization_Prepend_Input>;
  _set?: InputMaybe<Organization_Set_Input>;
  where: Organization_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_By_PkArgs = {
  _append?: InputMaybe<Organization_Append_Input>;
  _delete_at_path?: InputMaybe<Organization_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Organization_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Organization_Delete_Key_Input>;
  _inc?: InputMaybe<Organization_Inc_Input>;
  _prepend?: InputMaybe<Organization_Prepend_Input>;
  _set?: InputMaybe<Organization_Set_Input>;
  pk_columns: Organization_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_InvitesArgs = {
  _set?: InputMaybe<Organization_Invites_Set_Input>;
  where: Organization_Invites_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Invites_By_PkArgs = {
  _set?: InputMaybe<Organization_Invites_Set_Input>;
  pk_columns: Organization_Invites_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Invites_ManyArgs = {
  updates: Array<Organization_Invites_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_ManyArgs = {
  updates: Array<Organization_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_MemberArgs = {
  _set?: InputMaybe<Organization_Member_Set_Input>;
  where: Organization_Member_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Member_By_PkArgs = {
  _set?: InputMaybe<Organization_Member_Set_Input>;
  pk_columns: Organization_Member_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Member_ManyArgs = {
  updates: Array<Organization_Member_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Resource_PacksArgs = {
  _inc?: InputMaybe<Organization_Resource_Packs_Inc_Input>;
  _set?: InputMaybe<Organization_Resource_Packs_Set_Input>;
  where: Organization_Resource_Packs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Resource_Packs_By_PkArgs = {
  _inc?: InputMaybe<Organization_Resource_Packs_Inc_Input>;
  _set?: InputMaybe<Organization_Resource_Packs_Set_Input>;
  pk_columns: Organization_Resource_Packs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Resource_Packs_ManyArgs = {
  updates: Array<Organization_Resource_Packs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_TypeArgs = {
  _set?: InputMaybe<Organization_Type_Set_Input>;
  where: Organization_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Type_By_PkArgs = {
  _set?: InputMaybe<Organization_Type_Set_Input>;
  pk_columns: Organization_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organization_Type_ManyArgs = {
  updates: Array<Organization_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_StatisticsArgs = {
  _inc?: InputMaybe<Organizations_Statistics_Inc_Input>;
  _set?: InputMaybe<Organizations_Statistics_Set_Input>;
  where: Organizations_Statistics_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_Statistics_By_PkArgs = {
  _inc?: InputMaybe<Organizations_Statistics_Inc_Input>;
  _set?: InputMaybe<Organizations_Statistics_Set_Input>;
  pk_columns: Organizations_Statistics_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Organizations_Statistics_ManyArgs = {
  updates: Array<Organizations_Statistics_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_MethodsArgs = {
  _set?: InputMaybe<Payment_Methods_Set_Input>;
  where: Payment_Methods_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Methods_By_PkArgs = {
  _set?: InputMaybe<Payment_Methods_Set_Input>;
  pk_columns: Payment_Methods_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Payment_Methods_ManyArgs = {
  updates: Array<Payment_Methods_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Post_Training_Email_Scheduled_EventsArgs = {
  _set?: InputMaybe<Post_Training_Email_Scheduled_Events_Set_Input>;
  where: Post_Training_Email_Scheduled_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Post_Training_Email_Scheduled_Events_By_PkArgs = {
  _set?: InputMaybe<Post_Training_Email_Scheduled_Events_Set_Input>;
  pk_columns: Post_Training_Email_Scheduled_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Post_Training_Email_Scheduled_Events_ManyArgs = {
  updates: Array<Post_Training_Email_Scheduled_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Pre_Training_Email_Scheduled_EventsArgs = {
  _set?: InputMaybe<Pre_Training_Email_Scheduled_Events_Set_Input>;
  where: Pre_Training_Email_Scheduled_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Pre_Training_Email_Scheduled_Events_By_PkArgs = {
  _set?: InputMaybe<Pre_Training_Email_Scheduled_Events_Set_Input>;
  pk_columns: Pre_Training_Email_Scheduled_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Pre_Training_Email_Scheduled_Events_ManyArgs = {
  updates: Array<Pre_Training_Email_Scheduled_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Precision_Order_StatusArgs = {
  _set?: InputMaybe<Precision_Order_Status_Set_Input>;
  where: Precision_Order_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Precision_Order_Status_By_PkArgs = {
  _set?: InputMaybe<Precision_Order_Status_Set_Input>;
  pk_columns: Precision_Order_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Precision_Order_Status_ManyArgs = {
  updates: Array<Precision_Order_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Private_Course_BookingArgs = {
  _inc?: InputMaybe<Private_Course_Booking_Inc_Input>;
  _set?: InputMaybe<Private_Course_Booking_Set_Input>;
  where: Private_Course_Booking_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Private_Course_Booking_By_PkArgs = {
  _inc?: InputMaybe<Private_Course_Booking_Inc_Input>;
  _set?: InputMaybe<Private_Course_Booking_Set_Input>;
  pk_columns: Private_Course_Booking_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Private_Course_Booking_ManyArgs = {
  updates: Array<Private_Course_Booking_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_ProfileArgs = {
  _append?: InputMaybe<Profile_Append_Input>;
  _delete_at_path?: InputMaybe<Profile_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Profile_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Profile_Delete_Key_Input>;
  _inc?: InputMaybe<Profile_Inc_Input>;
  _prepend?: InputMaybe<Profile_Prepend_Input>;
  _set?: InputMaybe<Profile_Set_Input>;
  where: Profile_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_By_PkArgs = {
  _append?: InputMaybe<Profile_Append_Input>;
  _delete_at_path?: InputMaybe<Profile_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Profile_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Profile_Delete_Key_Input>;
  _inc?: InputMaybe<Profile_Inc_Input>;
  _prepend?: InputMaybe<Profile_Prepend_Input>;
  _set?: InputMaybe<Profile_Set_Input>;
  pk_columns: Profile_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_ManyArgs = {
  updates: Array<Profile_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_RoleArgs = {
  _set?: InputMaybe<Profile_Role_Set_Input>;
  where: Profile_Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_Role_By_PkArgs = {
  _set?: InputMaybe<Profile_Role_Set_Input>;
  pk_columns: Profile_Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_Role_ManyArgs = {
  updates: Array<Profile_Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_TempArgs = {
  _inc?: InputMaybe<Profile_Temp_Inc_Input>;
  _set?: InputMaybe<Profile_Temp_Set_Input>;
  where: Profile_Temp_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_Temp_By_PkArgs = {
  _inc?: InputMaybe<Profile_Temp_Inc_Input>;
  _set?: InputMaybe<Profile_Temp_Set_Input>;
  pk_columns: Profile_Temp_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_Temp_ManyArgs = {
  updates: Array<Profile_Temp_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_Trainer_Agreement_TypeArgs = {
  _set?: InputMaybe<Profile_Trainer_Agreement_Type_Set_Input>;
  where: Profile_Trainer_Agreement_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_Trainer_Agreement_Type_By_PkArgs = {
  _set?: InputMaybe<Profile_Trainer_Agreement_Type_Set_Input>;
  pk_columns: Profile_Trainer_Agreement_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_Trainer_Agreement_Type_ManyArgs = {
  updates: Array<Profile_Trainer_Agreement_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_Trainer_Role_TypeArgs = {
  _set?: InputMaybe<Profile_Trainer_Role_Type_Set_Input>;
  where: Profile_Trainer_Role_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_Trainer_Role_Type_By_PkArgs = {
  _set?: InputMaybe<Profile_Trainer_Role_Type_Set_Input>;
  pk_columns: Profile_Trainer_Role_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Profile_Trainer_Role_Type_ManyArgs = {
  updates: Array<Profile_Trainer_Role_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Promo_CodeArgs = {
  _append?: InputMaybe<Promo_Code_Append_Input>;
  _delete_at_path?: InputMaybe<Promo_Code_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Promo_Code_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Promo_Code_Delete_Key_Input>;
  _inc?: InputMaybe<Promo_Code_Inc_Input>;
  _prepend?: InputMaybe<Promo_Code_Prepend_Input>;
  _set?: InputMaybe<Promo_Code_Set_Input>;
  where: Promo_Code_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Promo_Code_By_PkArgs = {
  _append?: InputMaybe<Promo_Code_Append_Input>;
  _delete_at_path?: InputMaybe<Promo_Code_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Promo_Code_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Promo_Code_Delete_Key_Input>;
  _inc?: InputMaybe<Promo_Code_Inc_Input>;
  _prepend?: InputMaybe<Promo_Code_Prepend_Input>;
  _set?: InputMaybe<Promo_Code_Set_Input>;
  pk_columns: Promo_Code_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Promo_Code_ManyArgs = {
  updates: Array<Promo_Code_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Promo_Code_TypeArgs = {
  _set?: InputMaybe<Promo_Code_Type_Set_Input>;
  where: Promo_Code_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Promo_Code_Type_By_PkArgs = {
  _set?: InputMaybe<Promo_Code_Type_Set_Input>;
  pk_columns: Promo_Code_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Promo_Code_Type_ManyArgs = {
  updates: Array<Promo_Code_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Pack_Bundle_Course_LevelArgs = {
  _set?: InputMaybe<Resource_Pack_Bundle_Course_Level_Set_Input>;
  where: Resource_Pack_Bundle_Course_Level_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Pack_Bundle_Course_Level_By_PkArgs = {
  _set?: InputMaybe<Resource_Pack_Bundle_Course_Level_Set_Input>;
  pk_columns: Resource_Pack_Bundle_Course_Level_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Pack_Bundle_Course_Level_ManyArgs = {
  updates: Array<Resource_Pack_Bundle_Course_Level_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Pack_Bundle_OptionArgs = {
  _set?: InputMaybe<Resource_Pack_Bundle_Option_Set_Input>;
  where: Resource_Pack_Bundle_Option_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Pack_Bundle_Option_By_PkArgs = {
  _set?: InputMaybe<Resource_Pack_Bundle_Option_Set_Input>;
  pk_columns: Resource_Pack_Bundle_Option_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Pack_Bundle_Option_ManyArgs = {
  updates: Array<Resource_Pack_Bundle_Option_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Pack_Bundle_PriceArgs = {
  _inc?: InputMaybe<Resource_Pack_Bundle_Price_Inc_Input>;
  _set?: InputMaybe<Resource_Pack_Bundle_Price_Set_Input>;
  where: Resource_Pack_Bundle_Price_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Pack_Bundle_Price_By_PkArgs = {
  _inc?: InputMaybe<Resource_Pack_Bundle_Price_Inc_Input>;
  _set?: InputMaybe<Resource_Pack_Bundle_Price_Set_Input>;
  pk_columns: Resource_Pack_Bundle_Price_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Pack_Bundle_Price_ManyArgs = {
  updates: Array<Resource_Pack_Bundle_Price_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Packs_Delivery_TypeArgs = {
  _set?: InputMaybe<Resource_Packs_Delivery_Type_Set_Input>;
  where: Resource_Packs_Delivery_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Packs_Delivery_Type_By_PkArgs = {
  _set?: InputMaybe<Resource_Packs_Delivery_Type_Set_Input>;
  pk_columns: Resource_Packs_Delivery_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Packs_Delivery_Type_ManyArgs = {
  updates: Array<Resource_Packs_Delivery_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Packs_EventsArgs = {
  _set?: InputMaybe<Resource_Packs_Events_Set_Input>;
  where: Resource_Packs_Events_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Packs_Events_By_PkArgs = {
  _set?: InputMaybe<Resource_Packs_Events_Set_Input>;
  pk_columns: Resource_Packs_Events_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Packs_Events_ManyArgs = {
  updates: Array<Resource_Packs_Events_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Packs_PricingArgs = {
  _inc?: InputMaybe<Resource_Packs_Pricing_Inc_Input>;
  _set?: InputMaybe<Resource_Packs_Pricing_Set_Input>;
  where: Resource_Packs_Pricing_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Packs_Pricing_By_PkArgs = {
  _inc?: InputMaybe<Resource_Packs_Pricing_Inc_Input>;
  _set?: InputMaybe<Resource_Packs_Pricing_Set_Input>;
  pk_columns: Resource_Packs_Pricing_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Packs_Pricing_ManyArgs = {
  updates: Array<Resource_Packs_Pricing_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Packs_TypeArgs = {
  _set?: InputMaybe<Resource_Packs_Type_Set_Input>;
  where: Resource_Packs_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Packs_Type_By_PkArgs = {
  _set?: InputMaybe<Resource_Packs_Type_Set_Input>;
  pk_columns: Resource_Packs_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Resource_Packs_Type_ManyArgs = {
  updates: Array<Resource_Packs_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_RoleArgs = {
  _append?: InputMaybe<Role_Append_Input>;
  _delete_at_path?: InputMaybe<Role_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Role_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Role_Delete_Key_Input>;
  _inc?: InputMaybe<Role_Inc_Input>;
  _prepend?: InputMaybe<Role_Prepend_Input>;
  _set?: InputMaybe<Role_Set_Input>;
  where: Role_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Role_By_PkArgs = {
  _append?: InputMaybe<Role_Append_Input>;
  _delete_at_path?: InputMaybe<Role_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Role_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Role_Delete_Key_Input>;
  _inc?: InputMaybe<Role_Inc_Input>;
  _prepend?: InputMaybe<Role_Prepend_Input>;
  _set?: InputMaybe<Role_Set_Input>;
  pk_columns: Role_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Role_ManyArgs = {
  updates: Array<Role_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Scheduled_Events_ViewArgs = {
  _inc?: InputMaybe<Scheduled_Events_View_Inc_Input>;
  _set?: InputMaybe<Scheduled_Events_View_Set_Input>;
  where: Scheduled_Events_View_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Scheduled_Events_View_ManyArgs = {
  updates: Array<Scheduled_Events_View_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Splash_ScreensArgs = {
  _set?: InputMaybe<Splash_Screens_Set_Input>;
  where: Splash_Screens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Splash_Screens_By_PkArgs = {
  _set?: InputMaybe<Splash_Screens_Set_Input>;
  pk_columns: Splash_Screens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Splash_Screens_ManyArgs = {
  updates: Array<Splash_Screens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Submission_Of_Splash_ScreensArgs = {
  _inc?: InputMaybe<Submission_Of_Splash_Screens_Inc_Input>;
  _set?: InputMaybe<Submission_Of_Splash_Screens_Set_Input>;
  where: Submission_Of_Splash_Screens_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Submission_Of_Splash_Screens_By_PkArgs = {
  _inc?: InputMaybe<Submission_Of_Splash_Screens_Inc_Input>;
  _set?: InputMaybe<Submission_Of_Splash_Screens_Set_Input>;
  pk_columns: Submission_Of_Splash_Screens_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Submission_Of_Splash_Screens_ManyArgs = {
  updates: Array<Submission_Of_Splash_Screens_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_SubmoduleArgs = {
  _set?: InputMaybe<Submodule_Set_Input>;
  where: Submodule_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Submodule_By_PkArgs = {
  _set?: InputMaybe<Submodule_Set_Input>;
  pk_columns: Submodule_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Submodule_ManyArgs = {
  updates: Array<Submodule_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trainer_Agreement_TypeArgs = {
  _set?: InputMaybe<Trainer_Agreement_Type_Set_Input>;
  where: Trainer_Agreement_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trainer_Agreement_Type_By_PkArgs = {
  _set?: InputMaybe<Trainer_Agreement_Type_Set_Input>;
  pk_columns: Trainer_Agreement_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trainer_Agreement_Type_ManyArgs = {
  updates: Array<Trainer_Agreement_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trainer_Role_TypeArgs = {
  _set?: InputMaybe<Trainer_Role_Type_Set_Input>;
  where: Trainer_Role_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trainer_Role_Type_By_PkArgs = {
  _set?: InputMaybe<Trainer_Role_Type_Set_Input>;
  pk_columns: Trainer_Role_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trainer_Role_Type_ManyArgs = {
  updates: Array<Trainer_Role_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Trust_TypeArgs = {
  _set?: InputMaybe<Trust_Type_Set_Input>;
  where: Trust_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Trust_Type_By_PkArgs = {
  _set?: InputMaybe<Trust_Type_Set_Input>;
  pk_columns: Trust_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Trust_Type_ManyArgs = {
  updates: Array<Trust_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Tt_Client_Invite_LogArgs = {
  _inc?: InputMaybe<Tt_Client_Invite_Log_Inc_Input>;
  _set?: InputMaybe<Tt_Client_Invite_Log_Set_Input>;
  where: Tt_Client_Invite_Log_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Tt_Client_Invite_Log_By_PkArgs = {
  _inc?: InputMaybe<Tt_Client_Invite_Log_Inc_Input>;
  _set?: InputMaybe<Tt_Client_Invite_Log_Set_Input>;
  pk_columns: Tt_Client_Invite_Log_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Tt_Client_Invite_Log_ManyArgs = {
  updates: Array<Tt_Client_Invite_Log_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Audit_TypeArgs = {
  _set?: InputMaybe<User_Auth_Audit_Type_Set_Input>;
  where: User_Auth_Audit_Type_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Audit_Type_By_PkArgs = {
  _set?: InputMaybe<User_Auth_Audit_Type_Set_Input>;
  pk_columns: User_Auth_Audit_Type_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Audit_Type_ManyArgs = {
  updates: Array<User_Auth_Audit_Type_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_AuditsArgs = {
  _set?: InputMaybe<User_Auth_Audits_Set_Input>;
  where: User_Auth_Audits_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Audits_By_PkArgs = {
  _set?: InputMaybe<User_Auth_Audits_Set_Input>;
  pk_columns: User_Auth_Audits_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_User_Auth_Audits_ManyArgs = {
  updates: Array<User_Auth_Audits_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_VenueArgs = {
  _set?: InputMaybe<Venue_Set_Input>;
  where: Venue_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Venue_By_PkArgs = {
  _set?: InputMaybe<Venue_Set_Input>;
  pk_columns: Venue_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Venue_Check_JobsArgs = {
  _inc?: InputMaybe<Venue_Check_Jobs_Inc_Input>;
  _set?: InputMaybe<Venue_Check_Jobs_Set_Input>;
  where: Venue_Check_Jobs_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Venue_Check_Jobs_By_PkArgs = {
  _inc?: InputMaybe<Venue_Check_Jobs_Inc_Input>;
  _set?: InputMaybe<Venue_Check_Jobs_Set_Input>;
  pk_columns: Venue_Check_Jobs_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Venue_Check_Jobs_ManyArgs = {
  updates: Array<Venue_Check_Jobs_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Venue_ManyArgs = {
  updates: Array<Venue_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_WaitlistArgs = {
  _inc?: InputMaybe<Waitlist_Inc_Input>;
  _set?: InputMaybe<Waitlist_Set_Input>;
  where: Waitlist_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Waitlist_By_PkArgs = {
  _inc?: InputMaybe<Waitlist_Inc_Input>;
  _set?: InputMaybe<Waitlist_Set_Input>;
  pk_columns: Waitlist_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Waitlist_ManyArgs = {
  updates: Array<Waitlist_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Xero_ContactArgs = {
  _append?: InputMaybe<Xero_Contact_Append_Input>;
  _delete_at_path?: InputMaybe<Xero_Contact_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Xero_Contact_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Xero_Contact_Delete_Key_Input>;
  _prepend?: InputMaybe<Xero_Contact_Prepend_Input>;
  _set?: InputMaybe<Xero_Contact_Set_Input>;
  where: Xero_Contact_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Xero_Contact_By_PkArgs = {
  _append?: InputMaybe<Xero_Contact_Append_Input>;
  _delete_at_path?: InputMaybe<Xero_Contact_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Xero_Contact_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Xero_Contact_Delete_Key_Input>;
  _prepend?: InputMaybe<Xero_Contact_Prepend_Input>;
  _set?: InputMaybe<Xero_Contact_Set_Input>;
  pk_columns: Xero_Contact_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Xero_Contact_ManyArgs = {
  updates: Array<Xero_Contact_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Xero_CredentialArgs = {
  _set?: InputMaybe<Xero_Credential_Set_Input>;
  where: Xero_Credential_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Xero_Credential_By_PkArgs = {
  _set?: InputMaybe<Xero_Credential_Set_Input>;
  pk_columns: Xero_Credential_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Xero_Credential_ManyArgs = {
  updates: Array<Xero_Credential_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Xero_InvoiceArgs = {
  _append?: InputMaybe<Xero_Invoice_Append_Input>;
  _delete_at_path?: InputMaybe<Xero_Invoice_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Xero_Invoice_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Xero_Invoice_Delete_Key_Input>;
  _inc?: InputMaybe<Xero_Invoice_Inc_Input>;
  _prepend?: InputMaybe<Xero_Invoice_Prepend_Input>;
  _set?: InputMaybe<Xero_Invoice_Set_Input>;
  where: Xero_Invoice_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Xero_Invoice_By_PkArgs = {
  _append?: InputMaybe<Xero_Invoice_Append_Input>;
  _delete_at_path?: InputMaybe<Xero_Invoice_Delete_At_Path_Input>;
  _delete_elem?: InputMaybe<Xero_Invoice_Delete_Elem_Input>;
  _delete_key?: InputMaybe<Xero_Invoice_Delete_Key_Input>;
  _inc?: InputMaybe<Xero_Invoice_Inc_Input>;
  _prepend?: InputMaybe<Xero_Invoice_Prepend_Input>;
  _set?: InputMaybe<Xero_Invoice_Set_Input>;
  pk_columns: Xero_Invoice_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Xero_Invoice_ManyArgs = {
  updates: Array<Xero_Invoice_Updates>;
};


/** mutation root */
export type Mutation_RootUpdate_Xero_Invoice_StatusArgs = {
  _set?: InputMaybe<Xero_Invoice_Status_Set_Input>;
  where: Xero_Invoice_Status_Bool_Exp;
};


/** mutation root */
export type Mutation_RootUpdate_Xero_Invoice_Status_By_PkArgs = {
  _set?: InputMaybe<Xero_Invoice_Status_Set_Input>;
  pk_columns: Xero_Invoice_Status_Pk_Columns_Input;
};


/** mutation root */
export type Mutation_RootUpdate_Xero_Invoice_Status_ManyArgs = {
  updates: Array<Xero_Invoice_Status_Updates>;
};


/** mutation root */
export type Mutation_RootUpsertZoomMeetingArgs = {
  input?: InputMaybe<UpsertZoomMeetingInput>;
};


/** mutation root */
export type Mutation_RootValidateAndDispatchInvitesForIndirectCourseArgs = {
  input: ValidateAndDispatchInvitesForIndirectCourseInput;
};


/** mutation root */
export type Mutation_RootVerifyUserArgs = {
  inviteId: Scalars['uuid'];
};


/** mutation root */
export type Mutation_RootXeroCallbackArgs = {
  input: XeroCallbackInput;
};

/** Temporary table to backup certificates that were issued for non-graded participants by mistake */
export type Non_Graded_Certificate = {
  __typename?: 'non_graded_certificate';
  blended_learning?: Maybe<Scalars['Boolean']>;
  certification_date: Scalars['date'];
  course_accredited_by?: Maybe<Scalars['String']>;
  course_id?: Maybe<Scalars['Int']>;
  course_level: Scalars['String'];
  course_name: Scalars['String'];
  created_at: Scalars['timestamptz'];
  expiry_date: Scalars['date'];
  id: Scalars['uuid'];
  is_revoked: Scalars['Boolean'];
  legacy_course_code?: Maybe<Scalars['String']>;
  number: Scalars['String'];
  profile_id: Scalars['uuid'];
  reaccreditation?: Maybe<Scalars['Boolean']>;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "non_graded_certificate" */
export type Non_Graded_Certificate_Aggregate = {
  __typename?: 'non_graded_certificate_aggregate';
  aggregate?: Maybe<Non_Graded_Certificate_Aggregate_Fields>;
  nodes: Array<Non_Graded_Certificate>;
};

/** aggregate fields of "non_graded_certificate" */
export type Non_Graded_Certificate_Aggregate_Fields = {
  __typename?: 'non_graded_certificate_aggregate_fields';
  avg?: Maybe<Non_Graded_Certificate_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Non_Graded_Certificate_Max_Fields>;
  min?: Maybe<Non_Graded_Certificate_Min_Fields>;
  stddev?: Maybe<Non_Graded_Certificate_Stddev_Fields>;
  stddev_pop?: Maybe<Non_Graded_Certificate_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Non_Graded_Certificate_Stddev_Samp_Fields>;
  sum?: Maybe<Non_Graded_Certificate_Sum_Fields>;
  var_pop?: Maybe<Non_Graded_Certificate_Var_Pop_Fields>;
  var_samp?: Maybe<Non_Graded_Certificate_Var_Samp_Fields>;
  variance?: Maybe<Non_Graded_Certificate_Variance_Fields>;
};


/** aggregate fields of "non_graded_certificate" */
export type Non_Graded_Certificate_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Non_Graded_Certificate_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Non_Graded_Certificate_Avg_Fields = {
  __typename?: 'non_graded_certificate_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "non_graded_certificate". All fields are combined with a logical 'AND'. */
export type Non_Graded_Certificate_Bool_Exp = {
  _and?: InputMaybe<Array<Non_Graded_Certificate_Bool_Exp>>;
  _not?: InputMaybe<Non_Graded_Certificate_Bool_Exp>;
  _or?: InputMaybe<Array<Non_Graded_Certificate_Bool_Exp>>;
  blended_learning?: InputMaybe<Boolean_Comparison_Exp>;
  certification_date?: InputMaybe<Date_Comparison_Exp>;
  course_accredited_by?: InputMaybe<String_Comparison_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  course_level?: InputMaybe<String_Comparison_Exp>;
  course_name?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  expiry_date?: InputMaybe<Date_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  is_revoked?: InputMaybe<Boolean_Comparison_Exp>;
  legacy_course_code?: InputMaybe<String_Comparison_Exp>;
  number?: InputMaybe<String_Comparison_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  reaccreditation?: InputMaybe<Boolean_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "non_graded_certificate" */
export enum Non_Graded_Certificate_Constraint {
  /** unique or primary key constraint on columns "number" */
  NonGradedCertificateNumberKey = 'non_graded_certificate_number_key',
  /** unique or primary key constraint on columns "id" */
  NonGradedCertificatePkey = 'non_graded_certificate_pkey'
}

/** input type for incrementing numeric columns in table "non_graded_certificate" */
export type Non_Graded_Certificate_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "non_graded_certificate" */
export type Non_Graded_Certificate_Insert_Input = {
  blended_learning?: InputMaybe<Scalars['Boolean']>;
  certification_date?: InputMaybe<Scalars['date']>;
  course_accredited_by?: InputMaybe<Scalars['String']>;
  course_id?: InputMaybe<Scalars['Int']>;
  course_level?: InputMaybe<Scalars['String']>;
  course_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiry_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_revoked?: InputMaybe<Scalars['Boolean']>;
  legacy_course_code?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Non_Graded_Certificate_Max_Fields = {
  __typename?: 'non_graded_certificate_max_fields';
  certification_date?: Maybe<Scalars['date']>;
  course_accredited_by?: Maybe<Scalars['String']>;
  course_id?: Maybe<Scalars['Int']>;
  course_level?: Maybe<Scalars['String']>;
  course_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expiry_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  legacy_course_code?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Non_Graded_Certificate_Min_Fields = {
  __typename?: 'non_graded_certificate_min_fields';
  certification_date?: Maybe<Scalars['date']>;
  course_accredited_by?: Maybe<Scalars['String']>;
  course_id?: Maybe<Scalars['Int']>;
  course_level?: Maybe<Scalars['String']>;
  course_name?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  expiry_date?: Maybe<Scalars['date']>;
  id?: Maybe<Scalars['uuid']>;
  legacy_course_code?: Maybe<Scalars['String']>;
  number?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "non_graded_certificate" */
export type Non_Graded_Certificate_Mutation_Response = {
  __typename?: 'non_graded_certificate_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Non_Graded_Certificate>;
};

/** on_conflict condition type for table "non_graded_certificate" */
export type Non_Graded_Certificate_On_Conflict = {
  constraint: Non_Graded_Certificate_Constraint;
  update_columns?: Array<Non_Graded_Certificate_Update_Column>;
  where?: InputMaybe<Non_Graded_Certificate_Bool_Exp>;
};

/** Ordering options when selecting data from "non_graded_certificate". */
export type Non_Graded_Certificate_Order_By = {
  blended_learning?: InputMaybe<Order_By>;
  certification_date?: InputMaybe<Order_By>;
  course_accredited_by?: InputMaybe<Order_By>;
  course_id?: InputMaybe<Order_By>;
  course_level?: InputMaybe<Order_By>;
  course_name?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  expiry_date?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  is_revoked?: InputMaybe<Order_By>;
  legacy_course_code?: InputMaybe<Order_By>;
  number?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  reaccreditation?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: non_graded_certificate */
export type Non_Graded_Certificate_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "non_graded_certificate" */
export enum Non_Graded_Certificate_Select_Column {
  /** column name */
  BlendedLearning = 'blended_learning',
  /** column name */
  CertificationDate = 'certification_date',
  /** column name */
  CourseAccreditedBy = 'course_accredited_by',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CourseLevel = 'course_level',
  /** column name */
  CourseName = 'course_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsRevoked = 'is_revoked',
  /** column name */
  LegacyCourseCode = 'legacy_course_code',
  /** column name */
  Number = 'number',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Reaccreditation = 'reaccreditation',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "non_graded_certificate" */
export type Non_Graded_Certificate_Set_Input = {
  blended_learning?: InputMaybe<Scalars['Boolean']>;
  certification_date?: InputMaybe<Scalars['date']>;
  course_accredited_by?: InputMaybe<Scalars['String']>;
  course_id?: InputMaybe<Scalars['Int']>;
  course_level?: InputMaybe<Scalars['String']>;
  course_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiry_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_revoked?: InputMaybe<Scalars['Boolean']>;
  legacy_course_code?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Non_Graded_Certificate_Stddev_Fields = {
  __typename?: 'non_graded_certificate_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Non_Graded_Certificate_Stddev_Pop_Fields = {
  __typename?: 'non_graded_certificate_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Non_Graded_Certificate_Stddev_Samp_Fields = {
  __typename?: 'non_graded_certificate_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "non_graded_certificate" */
export type Non_Graded_Certificate_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Non_Graded_Certificate_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Non_Graded_Certificate_Stream_Cursor_Value_Input = {
  blended_learning?: InputMaybe<Scalars['Boolean']>;
  certification_date?: InputMaybe<Scalars['date']>;
  course_accredited_by?: InputMaybe<Scalars['String']>;
  course_id?: InputMaybe<Scalars['Int']>;
  course_level?: InputMaybe<Scalars['String']>;
  course_name?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  expiry_date?: InputMaybe<Scalars['date']>;
  id?: InputMaybe<Scalars['uuid']>;
  is_revoked?: InputMaybe<Scalars['Boolean']>;
  legacy_course_code?: InputMaybe<Scalars['String']>;
  number?: InputMaybe<Scalars['String']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  reaccreditation?: InputMaybe<Scalars['Boolean']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Non_Graded_Certificate_Sum_Fields = {
  __typename?: 'non_graded_certificate_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "non_graded_certificate" */
export enum Non_Graded_Certificate_Update_Column {
  /** column name */
  BlendedLearning = 'blended_learning',
  /** column name */
  CertificationDate = 'certification_date',
  /** column name */
  CourseAccreditedBy = 'course_accredited_by',
  /** column name */
  CourseId = 'course_id',
  /** column name */
  CourseLevel = 'course_level',
  /** column name */
  CourseName = 'course_name',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  ExpiryDate = 'expiry_date',
  /** column name */
  Id = 'id',
  /** column name */
  IsRevoked = 'is_revoked',
  /** column name */
  LegacyCourseCode = 'legacy_course_code',
  /** column name */
  Number = 'number',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  Reaccreditation = 'reaccreditation',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Non_Graded_Certificate_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Non_Graded_Certificate_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Non_Graded_Certificate_Set_Input>;
  /** filter the rows which have to be updated */
  where: Non_Graded_Certificate_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Non_Graded_Certificate_Var_Pop_Fields = {
  __typename?: 'non_graded_certificate_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Non_Graded_Certificate_Var_Samp_Fields = {
  __typename?: 'non_graded_certificate_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Non_Graded_Certificate_Variance_Fields = {
  __typename?: 'non_graded_certificate_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to compare columns of type "numeric". All fields are combined with logical 'AND'. */
export type Numeric_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['numeric']>;
  _gt?: InputMaybe<Scalars['numeric']>;
  _gte?: InputMaybe<Scalars['numeric']>;
  _in?: InputMaybe<Array<Scalars['numeric']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['numeric']>;
  _lte?: InputMaybe<Scalars['numeric']>;
  _neq?: InputMaybe<Scalars['numeric']>;
  _nin?: InputMaybe<Array<Scalars['numeric']>>;
};

/** columns and relationships of "order" */
export type Order = {
  __typename?: 'order';
  attendeesQuantity: Scalars['Int'];
  billingAddress: Scalars['String'];
  billingEmail: Scalars['String'];
  billingFamilyName: Scalars['String'];
  billingGivenName: Scalars['String'];
  billingPhone: Scalars['String'];
  bookingContact?: Maybe<Scalars['jsonb']>;
  /** A computed field, executes function "order_booking_contact_profile_id" */
  bookingContactProfileId?: Maybe<Scalars['uuid']>;
  clientPurchaseOrder?: Maybe<Scalars['String']>;
  /** An array relationship */
  courses: Array<Course_Order>;
  /** An aggregate relationship */
  courses_aggregate: Course_Order_Aggregate;
  createdAt: Scalars['timestamptz'];
  currency?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  invitees?: Maybe<Scalars['jsonb']>;
  /** An object relationship */
  invoice?: Maybe<Xero_Invoice>;
  orderDue?: Maybe<Scalars['float8']>;
  orderTotal?: Maybe<Scalars['float8']>;
  /** An object relationship */
  organization: Organization;
  organizationId: Scalars['uuid'];
  paymentMethod: Payment_Methods_Enum;
  price?: Maybe<Scalars['float8']>;
  profileId?: Maybe<Scalars['uuid']>;
  promoCodes?: Maybe<Scalars['jsonb']>;
  registrants: Scalars['json'];
  resourcePacksQuantity?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  salesRepresentative?: Maybe<Profile>;
  salesRepresentativeId?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  stripePaymentId?: Maybe<Scalars['String']>;
  user: Scalars['jsonb'];
  vat?: Maybe<Scalars['float8']>;
  workbookDeliveryAddress?: Maybe<Scalars['jsonb']>;
  xeroInvoiceNumber?: Maybe<Scalars['String']>;
};


/** columns and relationships of "order" */
export type OrderBookingContactArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "order" */
export type OrderCoursesArgs = {
  distinct_on?: InputMaybe<Array<Course_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_Order_By>>;
  where?: InputMaybe<Course_Order_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_Order_By>>;
  where?: InputMaybe<Course_Order_Bool_Exp>;
};


/** columns and relationships of "order" */
export type OrderInviteesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "order" */
export type OrderPromoCodesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "order" */
export type OrderRegistrantsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "order" */
export type OrderUserArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "order" */
export type OrderWorkbookDeliveryAddressArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "order" */
export type Order_Aggregate = {
  __typename?: 'order_aggregate';
  aggregate?: Maybe<Order_Aggregate_Fields>;
  nodes: Array<Order>;
};

export type Order_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Order_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Order_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Order_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Order_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Order_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Order_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Order_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Order_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Order_Aggregate_Bool_Exp_Var_Samp>;
};

export type Order_Aggregate_Bool_Exp_Avg = {
  arguments: Order_Select_Column_Order_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Corr = {
  arguments: Order_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Order_Select_Column_Order_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Order_Select_Column_Order_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Order_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Order_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Order_Select_Column_Order_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Order_Select_Column_Order_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Order_Aggregate_Bool_Exp_Max = {
  arguments: Order_Select_Column_Order_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Min = {
  arguments: Order_Select_Column_Order_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Order_Select_Column_Order_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Sum = {
  arguments: Order_Select_Column_Order_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Order_Select_Column_Order_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "order" */
export type Order_Aggregate_Fields = {
  __typename?: 'order_aggregate_fields';
  avg?: Maybe<Order_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Max_Fields>;
  min?: Maybe<Order_Min_Fields>;
  stddev?: Maybe<Order_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Sum_Fields>;
  var_pop?: Maybe<Order_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Var_Samp_Fields>;
  variance?: Maybe<Order_Variance_Fields>;
};


/** aggregate fields of "order" */
export type Order_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order" */
export type Order_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Max_Order_By>;
  min?: InputMaybe<Order_Min_Order_By>;
  stddev?: InputMaybe<Order_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Order_Append_Input = {
  bookingContact?: InputMaybe<Scalars['jsonb']>;
  invitees?: InputMaybe<Scalars['jsonb']>;
  promoCodes?: InputMaybe<Scalars['jsonb']>;
  user?: InputMaybe<Scalars['jsonb']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "order" */
export type Order_Arr_Rel_Insert_Input = {
  data: Array<Order_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Avg_Fields = {
  __typename?: 'order_avg_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  resourcePacksQuantity?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order" */
export type Order_Avg_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  resourcePacksQuantity?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order". All fields are combined with a logical 'AND'. */
export type Order_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Bool_Exp>>;
  _not?: InputMaybe<Order_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Bool_Exp>>;
  attendeesQuantity?: InputMaybe<Int_Comparison_Exp>;
  billingAddress?: InputMaybe<String_Comparison_Exp>;
  billingEmail?: InputMaybe<String_Comparison_Exp>;
  billingFamilyName?: InputMaybe<String_Comparison_Exp>;
  billingGivenName?: InputMaybe<String_Comparison_Exp>;
  billingPhone?: InputMaybe<String_Comparison_Exp>;
  bookingContact?: InputMaybe<Jsonb_Comparison_Exp>;
  bookingContactProfileId?: InputMaybe<Uuid_Comparison_Exp>;
  clientPurchaseOrder?: InputMaybe<String_Comparison_Exp>;
  courses?: InputMaybe<Course_Order_Bool_Exp>;
  courses_aggregate?: InputMaybe<Course_Order_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invitees?: InputMaybe<Jsonb_Comparison_Exp>;
  invoice?: InputMaybe<Xero_Invoice_Bool_Exp>;
  orderDue?: InputMaybe<Float8_Comparison_Exp>;
  orderTotal?: InputMaybe<Float8_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  paymentMethod?: InputMaybe<Payment_Methods_Enum_Comparison_Exp>;
  price?: InputMaybe<Float8_Comparison_Exp>;
  profileId?: InputMaybe<Uuid_Comparison_Exp>;
  promoCodes?: InputMaybe<Jsonb_Comparison_Exp>;
  registrants?: InputMaybe<Json_Comparison_Exp>;
  resourcePacksQuantity?: InputMaybe<Numeric_Comparison_Exp>;
  salesRepresentative?: InputMaybe<Profile_Bool_Exp>;
  salesRepresentativeId?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  stripePaymentId?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Jsonb_Comparison_Exp>;
  vat?: InputMaybe<Float8_Comparison_Exp>;
  workbookDeliveryAddress?: InputMaybe<Jsonb_Comparison_Exp>;
  xeroInvoiceNumber?: InputMaybe<String_Comparison_Exp>;
};

/** column ordering options */
export enum Order_By {
  /** in ascending order, nulls last */
  Asc = 'asc',
  /** in ascending order, nulls first */
  AscNullsFirst = 'asc_nulls_first',
  /** in ascending order, nulls last */
  AscNullsLast = 'asc_nulls_last',
  /** in descending order, nulls first */
  Desc = 'desc',
  /** in descending order, nulls first */
  DescNullsFirst = 'desc_nulls_first',
  /** in descending order, nulls last */
  DescNullsLast = 'desc_nulls_last'
}

/** unique or primary key constraints on table "order" */
export enum Order_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderPkey = 'order_pkey',
  /** unique or primary key constraint on columns "xero_invoice_number" */
  OrderXeroInvoiceNumberKey = 'order_xero_invoice_number_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Order_Delete_At_Path_Input = {
  bookingContact?: InputMaybe<Array<Scalars['String']>>;
  invitees?: InputMaybe<Array<Scalars['String']>>;
  promoCodes?: InputMaybe<Array<Scalars['String']>>;
  user?: InputMaybe<Array<Scalars['String']>>;
  workbookDeliveryAddress?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Order_Delete_Elem_Input = {
  bookingContact?: InputMaybe<Scalars['Int']>;
  invitees?: InputMaybe<Scalars['Int']>;
  promoCodes?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Scalars['Int']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Order_Delete_Key_Input = {
  bookingContact?: InputMaybe<Scalars['String']>;
  invitees?: InputMaybe<Scalars['String']>;
  promoCodes?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['String']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "order" */
export type Order_Inc_Input = {
  attendeesQuantity?: InputMaybe<Scalars['Int']>;
  orderDue?: InputMaybe<Scalars['float8']>;
  orderTotal?: InputMaybe<Scalars['float8']>;
  price?: InputMaybe<Scalars['float8']>;
  resourcePacksQuantity?: InputMaybe<Scalars['numeric']>;
  vat?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "order" */
export type Order_Insert_Input = {
  attendeesQuantity?: InputMaybe<Scalars['Int']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingFamilyName?: InputMaybe<Scalars['String']>;
  billingGivenName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  bookingContact?: InputMaybe<Scalars['jsonb']>;
  clientPurchaseOrder?: InputMaybe<Scalars['String']>;
  courses?: InputMaybe<Course_Order_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitees?: InputMaybe<Scalars['jsonb']>;
  invoice?: InputMaybe<Xero_Invoice_Obj_Rel_Insert_Input>;
  orderDue?: InputMaybe<Scalars['float8']>;
  orderTotal?: InputMaybe<Scalars['float8']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  paymentMethod?: InputMaybe<Payment_Methods_Enum>;
  price?: InputMaybe<Scalars['float8']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  promoCodes?: InputMaybe<Scalars['jsonb']>;
  registrants?: InputMaybe<Scalars['json']>;
  resourcePacksQuantity?: InputMaybe<Scalars['numeric']>;
  salesRepresentative?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  salesRepresentativeId?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  stripePaymentId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['jsonb']>;
  vat?: InputMaybe<Scalars['float8']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['jsonb']>;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Order_Max_Fields = {
  __typename?: 'order_max_fields';
  attendeesQuantity?: Maybe<Scalars['Int']>;
  billingAddress?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingFamilyName?: Maybe<Scalars['String']>;
  billingGivenName?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  /** A computed field, executes function "order_booking_contact_profile_id" */
  bookingContactProfileId?: Maybe<Scalars['uuid']>;
  clientPurchaseOrder?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  orderDue?: Maybe<Scalars['float8']>;
  orderTotal?: Maybe<Scalars['float8']>;
  organizationId?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['float8']>;
  profileId?: Maybe<Scalars['uuid']>;
  resourcePacksQuantity?: Maybe<Scalars['numeric']>;
  salesRepresentativeId?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  stripePaymentId?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['float8']>;
  xeroInvoiceNumber?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "order" */
export type Order_Max_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  billingAddress?: InputMaybe<Order_By>;
  billingEmail?: InputMaybe<Order_By>;
  billingFamilyName?: InputMaybe<Order_By>;
  billingGivenName?: InputMaybe<Order_By>;
  billingPhone?: InputMaybe<Order_By>;
  clientPurchaseOrder?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  resourcePacksQuantity?: InputMaybe<Order_By>;
  salesRepresentativeId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stripePaymentId?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
  xeroInvoiceNumber?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Min_Fields = {
  __typename?: 'order_min_fields';
  attendeesQuantity?: Maybe<Scalars['Int']>;
  billingAddress?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingFamilyName?: Maybe<Scalars['String']>;
  billingGivenName?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  /** A computed field, executes function "order_booking_contact_profile_id" */
  bookingContactProfileId?: Maybe<Scalars['uuid']>;
  clientPurchaseOrder?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  orderDue?: Maybe<Scalars['float8']>;
  orderTotal?: Maybe<Scalars['float8']>;
  organizationId?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['float8']>;
  profileId?: Maybe<Scalars['uuid']>;
  resourcePacksQuantity?: Maybe<Scalars['numeric']>;
  salesRepresentativeId?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  stripePaymentId?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['float8']>;
  xeroInvoiceNumber?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "order" */
export type Order_Min_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  billingAddress?: InputMaybe<Order_By>;
  billingEmail?: InputMaybe<Order_By>;
  billingFamilyName?: InputMaybe<Order_By>;
  billingGivenName?: InputMaybe<Order_By>;
  billingPhone?: InputMaybe<Order_By>;
  clientPurchaseOrder?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  resourcePacksQuantity?: InputMaybe<Order_By>;
  salesRepresentativeId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stripePaymentId?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
  xeroInvoiceNumber?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order" */
export type Order_Mutation_Response = {
  __typename?: 'order_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order>;
};

/** input type for inserting object relation for remote table "order" */
export type Order_Obj_Rel_Insert_Input = {
  data: Order_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_On_Conflict>;
};

/** on_conflict condition type for table "order" */
export type Order_On_Conflict = {
  constraint: Order_Constraint;
  update_columns?: Array<Order_Update_Column>;
  where?: InputMaybe<Order_Bool_Exp>;
};

/** Ordering options when selecting data from "order". */
export type Order_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  billingAddress?: InputMaybe<Order_By>;
  billingEmail?: InputMaybe<Order_By>;
  billingFamilyName?: InputMaybe<Order_By>;
  billingGivenName?: InputMaybe<Order_By>;
  billingPhone?: InputMaybe<Order_By>;
  bookingContact?: InputMaybe<Order_By>;
  bookingContactProfileId?: InputMaybe<Order_By>;
  clientPurchaseOrder?: InputMaybe<Order_By>;
  courses_aggregate?: InputMaybe<Course_Order_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invitees?: InputMaybe<Order_By>;
  invoice?: InputMaybe<Xero_Invoice_Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paymentMethod?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  promoCodes?: InputMaybe<Order_By>;
  registrants?: InputMaybe<Order_By>;
  resourcePacksQuantity?: InputMaybe<Order_By>;
  salesRepresentative?: InputMaybe<Profile_Order_By>;
  salesRepresentativeId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stripePaymentId?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
  workbookDeliveryAddress?: InputMaybe<Order_By>;
  xeroInvoiceNumber?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order */
export type Order_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Order_Prepend_Input = {
  bookingContact?: InputMaybe<Scalars['jsonb']>;
  invitees?: InputMaybe<Scalars['jsonb']>;
  promoCodes?: InputMaybe<Scalars['jsonb']>;
  user?: InputMaybe<Scalars['jsonb']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "order" */
export enum Order_Select_Column {
  /** column name */
  AttendeesQuantity = 'attendeesQuantity',
  /** column name */
  BillingAddress = 'billingAddress',
  /** column name */
  BillingEmail = 'billingEmail',
  /** column name */
  BillingFamilyName = 'billingFamilyName',
  /** column name */
  BillingGivenName = 'billingGivenName',
  /** column name */
  BillingPhone = 'billingPhone',
  /** column name */
  BookingContact = 'bookingContact',
  /** column name */
  ClientPurchaseOrder = 'clientPurchaseOrder',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  Invitees = 'invitees',
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  Price = 'price',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  PromoCodes = 'promoCodes',
  /** column name */
  Registrants = 'registrants',
  /** column name */
  ResourcePacksQuantity = 'resourcePacksQuantity',
  /** column name */
  SalesRepresentativeId = 'salesRepresentativeId',
  /** column name */
  Source = 'source',
  /** column name */
  StripePaymentId = 'stripePaymentId',
  /** column name */
  User = 'user',
  /** column name */
  Vat = 'vat',
  /** column name */
  WorkbookDeliveryAddress = 'workbookDeliveryAddress',
  /** column name */
  XeroInvoiceNumber = 'xeroInvoiceNumber'
}

/** select "order_aggregate_bool_exp_avg_arguments_columns" columns of table "order" */
export enum Order_Select_Column_Order_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_aggregate_bool_exp_corr_arguments_columns" columns of table "order" */
export enum Order_Select_Column_Order_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "order" */
export enum Order_Select_Column_Order_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_aggregate_bool_exp_max_arguments_columns" columns of table "order" */
export enum Order_Select_Column_Order_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_aggregate_bool_exp_min_arguments_columns" columns of table "order" */
export enum Order_Select_Column_Order_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "order" */
export enum Order_Select_Column_Order_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_aggregate_bool_exp_sum_arguments_columns" columns of table "order" */
export enum Order_Select_Column_Order_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_aggregate_bool_exp_var_samp_arguments_columns" columns of table "order" */
export enum Order_Select_Column_Order_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** input type for updating data in table "order" */
export type Order_Set_Input = {
  attendeesQuantity?: InputMaybe<Scalars['Int']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingFamilyName?: InputMaybe<Scalars['String']>;
  billingGivenName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  bookingContact?: InputMaybe<Scalars['jsonb']>;
  clientPurchaseOrder?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitees?: InputMaybe<Scalars['jsonb']>;
  orderDue?: InputMaybe<Scalars['float8']>;
  orderTotal?: InputMaybe<Scalars['float8']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  paymentMethod?: InputMaybe<Payment_Methods_Enum>;
  price?: InputMaybe<Scalars['float8']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  promoCodes?: InputMaybe<Scalars['jsonb']>;
  registrants?: InputMaybe<Scalars['json']>;
  resourcePacksQuantity?: InputMaybe<Scalars['numeric']>;
  salesRepresentativeId?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  stripePaymentId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['jsonb']>;
  vat?: InputMaybe<Scalars['float8']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['jsonb']>;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Order_Stddev_Fields = {
  __typename?: 'order_stddev_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  resourcePacksQuantity?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order" */
export type Order_Stddev_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  resourcePacksQuantity?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Stddev_Pop_Fields = {
  __typename?: 'order_stddev_pop_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  resourcePacksQuantity?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order" */
export type Order_Stddev_Pop_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  resourcePacksQuantity?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Stddev_Samp_Fields = {
  __typename?: 'order_stddev_samp_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  resourcePacksQuantity?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order" */
export type Order_Stddev_Samp_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  resourcePacksQuantity?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order" */
export type Order_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Stream_Cursor_Value_Input = {
  attendeesQuantity?: InputMaybe<Scalars['Int']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingFamilyName?: InputMaybe<Scalars['String']>;
  billingGivenName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  bookingContact?: InputMaybe<Scalars['jsonb']>;
  clientPurchaseOrder?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  invitees?: InputMaybe<Scalars['jsonb']>;
  orderDue?: InputMaybe<Scalars['float8']>;
  orderTotal?: InputMaybe<Scalars['float8']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  paymentMethod?: InputMaybe<Payment_Methods_Enum>;
  price?: InputMaybe<Scalars['float8']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  promoCodes?: InputMaybe<Scalars['jsonb']>;
  registrants?: InputMaybe<Scalars['json']>;
  resourcePacksQuantity?: InputMaybe<Scalars['numeric']>;
  salesRepresentativeId?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  stripePaymentId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['jsonb']>;
  vat?: InputMaybe<Scalars['float8']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['jsonb']>;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Order_Sum_Fields = {
  __typename?: 'order_sum_fields';
  attendeesQuantity?: Maybe<Scalars['Int']>;
  orderDue?: Maybe<Scalars['float8']>;
  orderTotal?: Maybe<Scalars['float8']>;
  price?: Maybe<Scalars['float8']>;
  resourcePacksQuantity?: Maybe<Scalars['numeric']>;
  vat?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "order" */
export type Order_Sum_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  resourcePacksQuantity?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** columns and relationships of "order_temp" */
export type Order_Temp = {
  __typename?: 'order_temp';
  attendeesQuantity: Scalars['Int'];
  billingAddress: Scalars['String'];
  billingEmail: Scalars['String'];
  billingFamilyName: Scalars['String'];
  billingGivenName: Scalars['String'];
  billingPhone: Scalars['String'];
  booking_contact?: Maybe<Scalars['jsonb']>;
  clientPurchaseOrder?: Maybe<Scalars['String']>;
  courseId: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  currency?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  orderDue?: Maybe<Scalars['float8']>;
  orderTotal?: Maybe<Scalars['float8']>;
  organizationId: Scalars['uuid'];
  paymentMethod: Payment_Methods_Enum;
  price?: Maybe<Scalars['float8']>;
  profileId?: Maybe<Scalars['uuid']>;
  promoCodes?: Maybe<Scalars['jsonb']>;
  registrants: Scalars['json'];
  salesRepresentativeId?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  stripePaymentId?: Maybe<Scalars['String']>;
  user: Scalars['jsonb'];
  vat?: Maybe<Scalars['float8']>;
  workbookDeliveryAddress?: Maybe<Scalars['jsonb']>;
  xeroInvoiceNumber?: Maybe<Scalars['String']>;
};


/** columns and relationships of "order_temp" */
export type Order_TempBooking_ContactArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "order_temp" */
export type Order_TempPromoCodesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "order_temp" */
export type Order_TempRegistrantsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "order_temp" */
export type Order_TempUserArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "order_temp" */
export type Order_TempWorkbookDeliveryAddressArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "order_temp" */
export type Order_Temp_Aggregate = {
  __typename?: 'order_temp_aggregate';
  aggregate?: Maybe<Order_Temp_Aggregate_Fields>;
  nodes: Array<Order_Temp>;
};

export type Order_Temp_Aggregate_Bool_Exp = {
  avg?: InputMaybe<Order_Temp_Aggregate_Bool_Exp_Avg>;
  corr?: InputMaybe<Order_Temp_Aggregate_Bool_Exp_Corr>;
  count?: InputMaybe<Order_Temp_Aggregate_Bool_Exp_Count>;
  covar_samp?: InputMaybe<Order_Temp_Aggregate_Bool_Exp_Covar_Samp>;
  max?: InputMaybe<Order_Temp_Aggregate_Bool_Exp_Max>;
  min?: InputMaybe<Order_Temp_Aggregate_Bool_Exp_Min>;
  stddev_samp?: InputMaybe<Order_Temp_Aggregate_Bool_Exp_Stddev_Samp>;
  sum?: InputMaybe<Order_Temp_Aggregate_Bool_Exp_Sum>;
  var_samp?: InputMaybe<Order_Temp_Aggregate_Bool_Exp_Var_Samp>;
};

export type Order_Temp_Aggregate_Bool_Exp_Avg = {
  arguments: Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Avg_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Temp_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Temp_Aggregate_Bool_Exp_Corr = {
  arguments: Order_Temp_Aggregate_Bool_Exp_Corr_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Temp_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Temp_Aggregate_Bool_Exp_Corr_Arguments = {
  X: Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Corr_Arguments_Columns;
  Y: Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Corr_Arguments_Columns;
};

export type Order_Temp_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Order_Temp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Temp_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

export type Order_Temp_Aggregate_Bool_Exp_Covar_Samp = {
  arguments: Order_Temp_Aggregate_Bool_Exp_Covar_Samp_Arguments;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Temp_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Temp_Aggregate_Bool_Exp_Covar_Samp_Arguments = {
  X: Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
  Y: Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns;
};

export type Order_Temp_Aggregate_Bool_Exp_Max = {
  arguments: Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Max_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Temp_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Temp_Aggregate_Bool_Exp_Min = {
  arguments: Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Min_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Temp_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Temp_Aggregate_Bool_Exp_Stddev_Samp = {
  arguments: Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Temp_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Temp_Aggregate_Bool_Exp_Sum = {
  arguments: Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Sum_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Temp_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

export type Order_Temp_Aggregate_Bool_Exp_Var_Samp = {
  arguments: Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Order_Temp_Bool_Exp>;
  predicate: Float8_Comparison_Exp;
};

/** aggregate fields of "order_temp" */
export type Order_Temp_Aggregate_Fields = {
  __typename?: 'order_temp_aggregate_fields';
  avg?: Maybe<Order_Temp_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Order_Temp_Max_Fields>;
  min?: Maybe<Order_Temp_Min_Fields>;
  stddev?: Maybe<Order_Temp_Stddev_Fields>;
  stddev_pop?: Maybe<Order_Temp_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Order_Temp_Stddev_Samp_Fields>;
  sum?: Maybe<Order_Temp_Sum_Fields>;
  var_pop?: Maybe<Order_Temp_Var_Pop_Fields>;
  var_samp?: Maybe<Order_Temp_Var_Samp_Fields>;
  variance?: Maybe<Order_Temp_Variance_Fields>;
};


/** aggregate fields of "order_temp" */
export type Order_Temp_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Order_Temp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "order_temp" */
export type Order_Temp_Aggregate_Order_By = {
  avg?: InputMaybe<Order_Temp_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Order_Temp_Max_Order_By>;
  min?: InputMaybe<Order_Temp_Min_Order_By>;
  stddev?: InputMaybe<Order_Temp_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Order_Temp_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Order_Temp_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Order_Temp_Sum_Order_By>;
  var_pop?: InputMaybe<Order_Temp_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Order_Temp_Var_Samp_Order_By>;
  variance?: InputMaybe<Order_Temp_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Order_Temp_Append_Input = {
  booking_contact?: InputMaybe<Scalars['jsonb']>;
  promoCodes?: InputMaybe<Scalars['jsonb']>;
  user?: InputMaybe<Scalars['jsonb']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "order_temp" */
export type Order_Temp_Arr_Rel_Insert_Input = {
  data: Array<Order_Temp_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Order_Temp_On_Conflict>;
};

/** aggregate avg on columns */
export type Order_Temp_Avg_Fields = {
  __typename?: 'order_temp_avg_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "order_temp" */
export type Order_Temp_Avg_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "order_temp". All fields are combined with a logical 'AND'. */
export type Order_Temp_Bool_Exp = {
  _and?: InputMaybe<Array<Order_Temp_Bool_Exp>>;
  _not?: InputMaybe<Order_Temp_Bool_Exp>;
  _or?: InputMaybe<Array<Order_Temp_Bool_Exp>>;
  attendeesQuantity?: InputMaybe<Int_Comparison_Exp>;
  billingAddress?: InputMaybe<String_Comparison_Exp>;
  billingEmail?: InputMaybe<String_Comparison_Exp>;
  billingFamilyName?: InputMaybe<String_Comparison_Exp>;
  billingGivenName?: InputMaybe<String_Comparison_Exp>;
  billingPhone?: InputMaybe<String_Comparison_Exp>;
  booking_contact?: InputMaybe<Jsonb_Comparison_Exp>;
  clientPurchaseOrder?: InputMaybe<String_Comparison_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orderDue?: InputMaybe<Float8_Comparison_Exp>;
  orderTotal?: InputMaybe<Float8_Comparison_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  paymentMethod?: InputMaybe<Payment_Methods_Enum_Comparison_Exp>;
  price?: InputMaybe<Float8_Comparison_Exp>;
  profileId?: InputMaybe<Uuid_Comparison_Exp>;
  promoCodes?: InputMaybe<Jsonb_Comparison_Exp>;
  registrants?: InputMaybe<Json_Comparison_Exp>;
  salesRepresentativeId?: InputMaybe<Uuid_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
  stripePaymentId?: InputMaybe<String_Comparison_Exp>;
  user?: InputMaybe<Jsonb_Comparison_Exp>;
  vat?: InputMaybe<Float8_Comparison_Exp>;
  workbookDeliveryAddress?: InputMaybe<Jsonb_Comparison_Exp>;
  xeroInvoiceNumber?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "order_temp" */
export enum Order_Temp_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrderTempPkey = 'order_temp_pkey',
  /** unique or primary key constraint on columns "xero_invoice_number" */
  OrderTempXeroInvoiceNumberKey = 'order_temp_xero_invoice_number_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Order_Temp_Delete_At_Path_Input = {
  booking_contact?: InputMaybe<Array<Scalars['String']>>;
  promoCodes?: InputMaybe<Array<Scalars['String']>>;
  user?: InputMaybe<Array<Scalars['String']>>;
  workbookDeliveryAddress?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Order_Temp_Delete_Elem_Input = {
  booking_contact?: InputMaybe<Scalars['Int']>;
  promoCodes?: InputMaybe<Scalars['Int']>;
  user?: InputMaybe<Scalars['Int']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Order_Temp_Delete_Key_Input = {
  booking_contact?: InputMaybe<Scalars['String']>;
  promoCodes?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['String']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "order_temp" */
export type Order_Temp_Inc_Input = {
  attendeesQuantity?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  orderDue?: InputMaybe<Scalars['float8']>;
  orderTotal?: InputMaybe<Scalars['float8']>;
  price?: InputMaybe<Scalars['float8']>;
  vat?: InputMaybe<Scalars['float8']>;
};

/** input type for inserting data into table "order_temp" */
export type Order_Temp_Insert_Input = {
  attendeesQuantity?: InputMaybe<Scalars['Int']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingFamilyName?: InputMaybe<Scalars['String']>;
  billingGivenName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  booking_contact?: InputMaybe<Scalars['jsonb']>;
  clientPurchaseOrder?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  orderDue?: InputMaybe<Scalars['float8']>;
  orderTotal?: InputMaybe<Scalars['float8']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  paymentMethod?: InputMaybe<Payment_Methods_Enum>;
  price?: InputMaybe<Scalars['float8']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  promoCodes?: InputMaybe<Scalars['jsonb']>;
  registrants?: InputMaybe<Scalars['json']>;
  salesRepresentativeId?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  stripePaymentId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['jsonb']>;
  vat?: InputMaybe<Scalars['float8']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['jsonb']>;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Order_Temp_Max_Fields = {
  __typename?: 'order_temp_max_fields';
  attendeesQuantity?: Maybe<Scalars['Int']>;
  billingAddress?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingFamilyName?: Maybe<Scalars['String']>;
  billingGivenName?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  clientPurchaseOrder?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  orderDue?: Maybe<Scalars['float8']>;
  orderTotal?: Maybe<Scalars['float8']>;
  organizationId?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['float8']>;
  profileId?: Maybe<Scalars['uuid']>;
  salesRepresentativeId?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  stripePaymentId?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['float8']>;
  xeroInvoiceNumber?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "order_temp" */
export type Order_Temp_Max_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  billingAddress?: InputMaybe<Order_By>;
  billingEmail?: InputMaybe<Order_By>;
  billingFamilyName?: InputMaybe<Order_By>;
  billingGivenName?: InputMaybe<Order_By>;
  billingPhone?: InputMaybe<Order_By>;
  clientPurchaseOrder?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  salesRepresentativeId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stripePaymentId?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
  xeroInvoiceNumber?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Order_Temp_Min_Fields = {
  __typename?: 'order_temp_min_fields';
  attendeesQuantity?: Maybe<Scalars['Int']>;
  billingAddress?: Maybe<Scalars['String']>;
  billingEmail?: Maybe<Scalars['String']>;
  billingFamilyName?: Maybe<Scalars['String']>;
  billingGivenName?: Maybe<Scalars['String']>;
  billingPhone?: Maybe<Scalars['String']>;
  clientPurchaseOrder?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  orderDue?: Maybe<Scalars['float8']>;
  orderTotal?: Maybe<Scalars['float8']>;
  organizationId?: Maybe<Scalars['uuid']>;
  price?: Maybe<Scalars['float8']>;
  profileId?: Maybe<Scalars['uuid']>;
  salesRepresentativeId?: Maybe<Scalars['uuid']>;
  source?: Maybe<Scalars['String']>;
  stripePaymentId?: Maybe<Scalars['String']>;
  vat?: Maybe<Scalars['float8']>;
  xeroInvoiceNumber?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "order_temp" */
export type Order_Temp_Min_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  billingAddress?: InputMaybe<Order_By>;
  billingEmail?: InputMaybe<Order_By>;
  billingFamilyName?: InputMaybe<Order_By>;
  billingGivenName?: InputMaybe<Order_By>;
  billingPhone?: InputMaybe<Order_By>;
  clientPurchaseOrder?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  salesRepresentativeId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stripePaymentId?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
  xeroInvoiceNumber?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "order_temp" */
export type Order_Temp_Mutation_Response = {
  __typename?: 'order_temp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Order_Temp>;
};

/** on_conflict condition type for table "order_temp" */
export type Order_Temp_On_Conflict = {
  constraint: Order_Temp_Constraint;
  update_columns?: Array<Order_Temp_Update_Column>;
  where?: InputMaybe<Order_Temp_Bool_Exp>;
};

/** Ordering options when selecting data from "order_temp". */
export type Order_Temp_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  billingAddress?: InputMaybe<Order_By>;
  billingEmail?: InputMaybe<Order_By>;
  billingFamilyName?: InputMaybe<Order_By>;
  billingGivenName?: InputMaybe<Order_By>;
  billingPhone?: InputMaybe<Order_By>;
  booking_contact?: InputMaybe<Order_By>;
  clientPurchaseOrder?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  paymentMethod?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  promoCodes?: InputMaybe<Order_By>;
  registrants?: InputMaybe<Order_By>;
  salesRepresentativeId?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
  stripePaymentId?: InputMaybe<Order_By>;
  user?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
  workbookDeliveryAddress?: InputMaybe<Order_By>;
  xeroInvoiceNumber?: InputMaybe<Order_By>;
};

/** primary key columns input for table: order_temp */
export type Order_Temp_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Order_Temp_Prepend_Input = {
  booking_contact?: InputMaybe<Scalars['jsonb']>;
  promoCodes?: InputMaybe<Scalars['jsonb']>;
  user?: InputMaybe<Scalars['jsonb']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "order_temp" */
export enum Order_Temp_Select_Column {
  /** column name */
  AttendeesQuantity = 'attendeesQuantity',
  /** column name */
  BillingAddress = 'billingAddress',
  /** column name */
  BillingEmail = 'billingEmail',
  /** column name */
  BillingFamilyName = 'billingFamilyName',
  /** column name */
  BillingGivenName = 'billingGivenName',
  /** column name */
  BillingPhone = 'billingPhone',
  /** column name */
  BookingContact = 'booking_contact',
  /** column name */
  ClientPurchaseOrder = 'clientPurchaseOrder',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  Price = 'price',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  PromoCodes = 'promoCodes',
  /** column name */
  Registrants = 'registrants',
  /** column name */
  SalesRepresentativeId = 'salesRepresentativeId',
  /** column name */
  Source = 'source',
  /** column name */
  StripePaymentId = 'stripePaymentId',
  /** column name */
  User = 'user',
  /** column name */
  Vat = 'vat',
  /** column name */
  WorkbookDeliveryAddress = 'workbookDeliveryAddress',
  /** column name */
  XeroInvoiceNumber = 'xeroInvoiceNumber'
}

/** select "order_temp_aggregate_bool_exp_avg_arguments_columns" columns of table "order_temp" */
export enum Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Avg_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_temp_aggregate_bool_exp_corr_arguments_columns" columns of table "order_temp" */
export enum Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Corr_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_temp_aggregate_bool_exp_covar_samp_arguments_columns" columns of table "order_temp" */
export enum Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Covar_Samp_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_temp_aggregate_bool_exp_max_arguments_columns" columns of table "order_temp" */
export enum Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Max_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_temp_aggregate_bool_exp_min_arguments_columns" columns of table "order_temp" */
export enum Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Min_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_temp_aggregate_bool_exp_stddev_samp_arguments_columns" columns of table "order_temp" */
export enum Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Stddev_Samp_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_temp_aggregate_bool_exp_sum_arguments_columns" columns of table "order_temp" */
export enum Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Sum_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** select "order_temp_aggregate_bool_exp_var_samp_arguments_columns" columns of table "order_temp" */
export enum Order_Temp_Select_Column_Order_Temp_Aggregate_Bool_Exp_Var_Samp_Arguments_Columns {
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  Price = 'price',
  /** column name */
  Vat = 'vat'
}

/** input type for updating data in table "order_temp" */
export type Order_Temp_Set_Input = {
  attendeesQuantity?: InputMaybe<Scalars['Int']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingFamilyName?: InputMaybe<Scalars['String']>;
  billingGivenName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  booking_contact?: InputMaybe<Scalars['jsonb']>;
  clientPurchaseOrder?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  orderDue?: InputMaybe<Scalars['float8']>;
  orderTotal?: InputMaybe<Scalars['float8']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  paymentMethod?: InputMaybe<Payment_Methods_Enum>;
  price?: InputMaybe<Scalars['float8']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  promoCodes?: InputMaybe<Scalars['jsonb']>;
  registrants?: InputMaybe<Scalars['json']>;
  salesRepresentativeId?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  stripePaymentId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['jsonb']>;
  vat?: InputMaybe<Scalars['float8']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['jsonb']>;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Order_Temp_Stddev_Fields = {
  __typename?: 'order_temp_stddev_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "order_temp" */
export type Order_Temp_Stddev_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Order_Temp_Stddev_Pop_Fields = {
  __typename?: 'order_temp_stddev_pop_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "order_temp" */
export type Order_Temp_Stddev_Pop_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Order_Temp_Stddev_Samp_Fields = {
  __typename?: 'order_temp_stddev_samp_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "order_temp" */
export type Order_Temp_Stddev_Samp_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "order_temp" */
export type Order_Temp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Order_Temp_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Order_Temp_Stream_Cursor_Value_Input = {
  attendeesQuantity?: InputMaybe<Scalars['Int']>;
  billingAddress?: InputMaybe<Scalars['String']>;
  billingEmail?: InputMaybe<Scalars['String']>;
  billingFamilyName?: InputMaybe<Scalars['String']>;
  billingGivenName?: InputMaybe<Scalars['String']>;
  billingPhone?: InputMaybe<Scalars['String']>;
  booking_contact?: InputMaybe<Scalars['jsonb']>;
  clientPurchaseOrder?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  orderDue?: InputMaybe<Scalars['float8']>;
  orderTotal?: InputMaybe<Scalars['float8']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  paymentMethod?: InputMaybe<Payment_Methods_Enum>;
  price?: InputMaybe<Scalars['float8']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  promoCodes?: InputMaybe<Scalars['jsonb']>;
  registrants?: InputMaybe<Scalars['json']>;
  salesRepresentativeId?: InputMaybe<Scalars['uuid']>;
  source?: InputMaybe<Scalars['String']>;
  stripePaymentId?: InputMaybe<Scalars['String']>;
  user?: InputMaybe<Scalars['jsonb']>;
  vat?: InputMaybe<Scalars['float8']>;
  workbookDeliveryAddress?: InputMaybe<Scalars['jsonb']>;
  xeroInvoiceNumber?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Order_Temp_Sum_Fields = {
  __typename?: 'order_temp_sum_fields';
  attendeesQuantity?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  orderDue?: Maybe<Scalars['float8']>;
  orderTotal?: Maybe<Scalars['float8']>;
  price?: Maybe<Scalars['float8']>;
  vat?: Maybe<Scalars['float8']>;
};

/** order by sum() on columns of table "order_temp" */
export type Order_Temp_Sum_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** update columns of table "order_temp" */
export enum Order_Temp_Update_Column {
  /** column name */
  AttendeesQuantity = 'attendeesQuantity',
  /** column name */
  BillingAddress = 'billingAddress',
  /** column name */
  BillingEmail = 'billingEmail',
  /** column name */
  BillingFamilyName = 'billingFamilyName',
  /** column name */
  BillingGivenName = 'billingGivenName',
  /** column name */
  BillingPhone = 'billingPhone',
  /** column name */
  BookingContact = 'booking_contact',
  /** column name */
  ClientPurchaseOrder = 'clientPurchaseOrder',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  Price = 'price',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  PromoCodes = 'promoCodes',
  /** column name */
  Registrants = 'registrants',
  /** column name */
  SalesRepresentativeId = 'salesRepresentativeId',
  /** column name */
  Source = 'source',
  /** column name */
  StripePaymentId = 'stripePaymentId',
  /** column name */
  User = 'user',
  /** column name */
  Vat = 'vat',
  /** column name */
  WorkbookDeliveryAddress = 'workbookDeliveryAddress',
  /** column name */
  XeroInvoiceNumber = 'xeroInvoiceNumber'
}

export type Order_Temp_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Order_Temp_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Order_Temp_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Order_Temp_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Order_Temp_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Temp_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Order_Temp_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Temp_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Temp_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Temp_Var_Pop_Fields = {
  __typename?: 'order_temp_var_pop_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order_temp" */
export type Order_Temp_Var_Pop_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Temp_Var_Samp_Fields = {
  __typename?: 'order_temp_var_samp_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order_temp" */
export type Order_Temp_Var_Samp_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Temp_Variance_Fields = {
  __typename?: 'order_temp_variance_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order_temp" */
export type Order_Temp_Variance_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** update columns of table "order" */
export enum Order_Update_Column {
  /** column name */
  AttendeesQuantity = 'attendeesQuantity',
  /** column name */
  BillingAddress = 'billingAddress',
  /** column name */
  BillingEmail = 'billingEmail',
  /** column name */
  BillingFamilyName = 'billingFamilyName',
  /** column name */
  BillingGivenName = 'billingGivenName',
  /** column name */
  BillingPhone = 'billingPhone',
  /** column name */
  BookingContact = 'bookingContact',
  /** column name */
  ClientPurchaseOrder = 'clientPurchaseOrder',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  Invitees = 'invitees',
  /** column name */
  OrderDue = 'orderDue',
  /** column name */
  OrderTotal = 'orderTotal',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  PaymentMethod = 'paymentMethod',
  /** column name */
  Price = 'price',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  PromoCodes = 'promoCodes',
  /** column name */
  Registrants = 'registrants',
  /** column name */
  ResourcePacksQuantity = 'resourcePacksQuantity',
  /** column name */
  SalesRepresentativeId = 'salesRepresentativeId',
  /** column name */
  Source = 'source',
  /** column name */
  StripePaymentId = 'stripePaymentId',
  /** column name */
  User = 'user',
  /** column name */
  Vat = 'vat',
  /** column name */
  WorkbookDeliveryAddress = 'workbookDeliveryAddress',
  /** column name */
  XeroInvoiceNumber = 'xeroInvoiceNumber'
}

export type Order_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Order_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Order_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Order_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Order_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Order_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Order_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Order_Set_Input>;
  /** filter the rows which have to be updated */
  where: Order_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Order_Var_Pop_Fields = {
  __typename?: 'order_var_pop_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  resourcePacksQuantity?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "order" */
export type Order_Var_Pop_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  resourcePacksQuantity?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Order_Var_Samp_Fields = {
  __typename?: 'order_var_samp_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  resourcePacksQuantity?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "order" */
export type Order_Var_Samp_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  resourcePacksQuantity?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Order_Variance_Fields = {
  __typename?: 'order_variance_fields';
  attendeesQuantity?: Maybe<Scalars['Float']>;
  orderDue?: Maybe<Scalars['Float']>;
  orderTotal?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  resourcePacksQuantity?: Maybe<Scalars['Float']>;
  vat?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "order" */
export type Order_Variance_Order_By = {
  attendeesQuantity?: InputMaybe<Order_By>;
  orderDue?: InputMaybe<Order_By>;
  orderTotal?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  resourcePacksQuantity?: InputMaybe<Order_By>;
  vat?: InputMaybe<Order_By>;
};

/** columns and relationships of "org_created_from" */
export type Org_Created_From = {
  __typename?: 'org_created_from';
  name: Scalars['String'];
};

/** aggregated selection of "org_created_from" */
export type Org_Created_From_Aggregate = {
  __typename?: 'org_created_from_aggregate';
  aggregate?: Maybe<Org_Created_From_Aggregate_Fields>;
  nodes: Array<Org_Created_From>;
};

/** aggregate fields of "org_created_from" */
export type Org_Created_From_Aggregate_Fields = {
  __typename?: 'org_created_from_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Org_Created_From_Max_Fields>;
  min?: Maybe<Org_Created_From_Min_Fields>;
};


/** aggregate fields of "org_created_from" */
export type Org_Created_From_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Created_From_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "org_created_from". All fields are combined with a logical 'AND'. */
export type Org_Created_From_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Created_From_Bool_Exp>>;
  _not?: InputMaybe<Org_Created_From_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Created_From_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_created_from" */
export enum Org_Created_From_Constraint {
  /** unique or primary key constraint on columns "name" */
  OrgCreatedFromPkey = 'org_created_from_pkey'
}

export enum Org_Created_From_Enum {
  AutoregisterPage = 'AUTOREGISTER_PAGE',
  BookingPage = 'BOOKING_PAGE',
  CreateCoursePage = 'CREATE_COURSE_PAGE',
  EditProfilePage = 'EDIT_PROFILE_PAGE',
  InvoiceDetailsPage = 'INVOICE_DETAILS_PAGE',
  OnboardingPage = 'ONBOARDING_PAGE',
  OrganisationPage = 'ORGANISATION_PAGE',
  RegisterPage = 'REGISTER_PAGE'
}

/** Boolean expression to compare columns of type "org_created_from_enum". All fields are combined with logical 'AND'. */
export type Org_Created_From_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Org_Created_From_Enum>;
  _in?: InputMaybe<Array<Org_Created_From_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Org_Created_From_Enum>;
  _nin?: InputMaybe<Array<Org_Created_From_Enum>>;
};

/** input type for inserting data into table "org_created_from" */
export type Org_Created_From_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Org_Created_From_Max_Fields = {
  __typename?: 'org_created_from_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Org_Created_From_Min_Fields = {
  __typename?: 'org_created_from_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "org_created_from" */
export type Org_Created_From_Mutation_Response = {
  __typename?: 'org_created_from_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_Created_From>;
};

/** on_conflict condition type for table "org_created_from" */
export type Org_Created_From_On_Conflict = {
  constraint: Org_Created_From_Constraint;
  update_columns?: Array<Org_Created_From_Update_Column>;
  where?: InputMaybe<Org_Created_From_Bool_Exp>;
};

/** Ordering options when selecting data from "org_created_from". */
export type Org_Created_From_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_created_from */
export type Org_Created_From_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "org_created_from" */
export enum Org_Created_From_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "org_created_from" */
export type Org_Created_From_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "org_created_from" */
export type Org_Created_From_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Created_From_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Created_From_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "org_created_from" */
export enum Org_Created_From_Update_Column {
  /** column name */
  Name = 'name'
}

export type Org_Created_From_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_Created_From_Set_Input>;
  /** filter the rows which have to be updated */
  where: Org_Created_From_Bool_Exp;
};

/** columns and relationships of "org_distinct_country_codes" */
export type Org_Distinct_Country_Codes = {
  __typename?: 'org_distinct_country_codes';
  countrycode?: Maybe<Scalars['String']>;
};

/** aggregated selection of "org_distinct_country_codes" */
export type Org_Distinct_Country_Codes_Aggregate = {
  __typename?: 'org_distinct_country_codes_aggregate';
  aggregate?: Maybe<Org_Distinct_Country_Codes_Aggregate_Fields>;
  nodes: Array<Org_Distinct_Country_Codes>;
};

/** aggregate fields of "org_distinct_country_codes" */
export type Org_Distinct_Country_Codes_Aggregate_Fields = {
  __typename?: 'org_distinct_country_codes_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Org_Distinct_Country_Codes_Max_Fields>;
  min?: Maybe<Org_Distinct_Country_Codes_Min_Fields>;
};


/** aggregate fields of "org_distinct_country_codes" */
export type Org_Distinct_Country_Codes_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Distinct_Country_Codes_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "org_distinct_country_codes". All fields are combined with a logical 'AND'. */
export type Org_Distinct_Country_Codes_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Distinct_Country_Codes_Bool_Exp>>;
  _not?: InputMaybe<Org_Distinct_Country_Codes_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Distinct_Country_Codes_Bool_Exp>>;
  countrycode?: InputMaybe<String_Comparison_Exp>;
};

/** aggregate max on columns */
export type Org_Distinct_Country_Codes_Max_Fields = {
  __typename?: 'org_distinct_country_codes_max_fields';
  countrycode?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Org_Distinct_Country_Codes_Min_Fields = {
  __typename?: 'org_distinct_country_codes_min_fields';
  countrycode?: Maybe<Scalars['String']>;
};

/** Ordering options when selecting data from "org_distinct_country_codes". */
export type Org_Distinct_Country_Codes_Order_By = {
  countrycode?: InputMaybe<Order_By>;
};

/** select columns of table "org_distinct_country_codes" */
export enum Org_Distinct_Country_Codes_Select_Column {
  /** column name */
  Countrycode = 'countrycode'
}

/** Streaming cursor of the table "org_distinct_country_codes" */
export type Org_Distinct_Country_Codes_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Distinct_Country_Codes_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Distinct_Country_Codes_Stream_Cursor_Value_Input = {
  countrycode?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "org_resource_packs_history" */
export type Org_Resource_Packs_History = {
  __typename?: 'org_resource_packs_history';
  change: Scalars['Int'];
  /** An object relationship */
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']>;
  created_at: Scalars['timestamp'];
  event: Resource_Packs_Events_Enum;
  id: Scalars['uuid'];
  orgId?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  organization?: Maybe<Organization>;
  payload?: Maybe<Scalars['jsonb']>;
  reservedBalance: Scalars['Int'];
  resourcePacksType: Resource_Packs_Type_Enum;
  totalBalance: Scalars['Int'];
};


/** columns and relationships of "org_resource_packs_history" */
export type Org_Resource_Packs_HistoryPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "org_resource_packs_history" */
export type Org_Resource_Packs_History_Aggregate = {
  __typename?: 'org_resource_packs_history_aggregate';
  aggregate?: Maybe<Org_Resource_Packs_History_Aggregate_Fields>;
  nodes: Array<Org_Resource_Packs_History>;
};

/** aggregate fields of "org_resource_packs_history" */
export type Org_Resource_Packs_History_Aggregate_Fields = {
  __typename?: 'org_resource_packs_history_aggregate_fields';
  avg?: Maybe<Org_Resource_Packs_History_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Org_Resource_Packs_History_Max_Fields>;
  min?: Maybe<Org_Resource_Packs_History_Min_Fields>;
  stddev?: Maybe<Org_Resource_Packs_History_Stddev_Fields>;
  stddev_pop?: Maybe<Org_Resource_Packs_History_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Org_Resource_Packs_History_Stddev_Samp_Fields>;
  sum?: Maybe<Org_Resource_Packs_History_Sum_Fields>;
  var_pop?: Maybe<Org_Resource_Packs_History_Var_Pop_Fields>;
  var_samp?: Maybe<Org_Resource_Packs_History_Var_Samp_Fields>;
  variance?: Maybe<Org_Resource_Packs_History_Variance_Fields>;
};


/** aggregate fields of "org_resource_packs_history" */
export type Org_Resource_Packs_History_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Resource_Packs_History_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Org_Resource_Packs_History_Append_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Org_Resource_Packs_History_Avg_Fields = {
  __typename?: 'org_resource_packs_history_avg_fields';
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
  totalBalance?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "org_resource_packs_history". All fields are combined with a logical 'AND'. */
export type Org_Resource_Packs_History_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Resource_Packs_History_Bool_Exp>>;
  _not?: InputMaybe<Org_Resource_Packs_History_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Resource_Packs_History_Bool_Exp>>;
  change?: InputMaybe<Int_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  created_at?: InputMaybe<Timestamp_Comparison_Exp>;
  event?: InputMaybe<Resource_Packs_Events_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orgId?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  payload?: InputMaybe<Jsonb_Comparison_Exp>;
  reservedBalance?: InputMaybe<Int_Comparison_Exp>;
  resourcePacksType?: InputMaybe<Resource_Packs_Type_Enum_Comparison_Exp>;
  totalBalance?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_resource_packs_history" */
export enum Org_Resource_Packs_History_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrgResourcePacksHistoryPkey = 'org_resource_packs_history_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Org_Resource_Packs_History_Delete_At_Path_Input = {
  payload?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Org_Resource_Packs_History_Delete_Elem_Input = {
  payload?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Org_Resource_Packs_History_Delete_Key_Input = {
  payload?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "org_resource_packs_history" */
export type Org_Resource_Packs_History_Inc_Input = {
  change?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  reservedBalance?: InputMaybe<Scalars['Int']>;
  totalBalance?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "org_resource_packs_history" */
export type Org_Resource_Packs_History_Insert_Input = {
  change?: InputMaybe<Scalars['Int']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  event?: InputMaybe<Resource_Packs_Events_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  orgId?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  payload?: InputMaybe<Scalars['jsonb']>;
  reservedBalance?: InputMaybe<Scalars['Int']>;
  resourcePacksType?: InputMaybe<Resource_Packs_Type_Enum>;
  totalBalance?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Org_Resource_Packs_History_Max_Fields = {
  __typename?: 'org_resource_packs_history_max_fields';
  change?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  orgId?: Maybe<Scalars['uuid']>;
  reservedBalance?: Maybe<Scalars['Int']>;
  totalBalance?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Org_Resource_Packs_History_Min_Fields = {
  __typename?: 'org_resource_packs_history_min_fields';
  change?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  created_at?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  orgId?: Maybe<Scalars['uuid']>;
  reservedBalance?: Maybe<Scalars['Int']>;
  totalBalance?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "org_resource_packs_history" */
export type Org_Resource_Packs_History_Mutation_Response = {
  __typename?: 'org_resource_packs_history_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_Resource_Packs_History>;
};

/** on_conflict condition type for table "org_resource_packs_history" */
export type Org_Resource_Packs_History_On_Conflict = {
  constraint: Org_Resource_Packs_History_Constraint;
  update_columns?: Array<Org_Resource_Packs_History_Update_Column>;
  where?: InputMaybe<Org_Resource_Packs_History_Bool_Exp>;
};

/** Ordering options when selecting data from "org_resource_packs_history". */
export type Org_Resource_Packs_History_Order_By = {
  change?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  payload?: InputMaybe<Order_By>;
  reservedBalance?: InputMaybe<Order_By>;
  resourcePacksType?: InputMaybe<Order_By>;
  totalBalance?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_resource_packs_history */
export type Org_Resource_Packs_History_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Org_Resource_Packs_History_Prepend_Input = {
  payload?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "org_resource_packs_history" */
export enum Org_Resource_Packs_History_Select_Column {
  /** column name */
  Change = 'change',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Event = 'event',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  Payload = 'payload',
  /** column name */
  ReservedBalance = 'reservedBalance',
  /** column name */
  ResourcePacksType = 'resourcePacksType',
  /** column name */
  TotalBalance = 'totalBalance'
}

/** input type for updating data in table "org_resource_packs_history" */
export type Org_Resource_Packs_History_Set_Input = {
  change?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  event?: InputMaybe<Resource_Packs_Events_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  orgId?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  reservedBalance?: InputMaybe<Scalars['Int']>;
  resourcePacksType?: InputMaybe<Resource_Packs_Type_Enum>;
  totalBalance?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Org_Resource_Packs_History_Stddev_Fields = {
  __typename?: 'org_resource_packs_history_stddev_fields';
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
  totalBalance?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Org_Resource_Packs_History_Stddev_Pop_Fields = {
  __typename?: 'org_resource_packs_history_stddev_pop_fields';
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
  totalBalance?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Org_Resource_Packs_History_Stddev_Samp_Fields = {
  __typename?: 'org_resource_packs_history_stddev_samp_fields';
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
  totalBalance?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "org_resource_packs_history" */
export type Org_Resource_Packs_History_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Resource_Packs_History_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Resource_Packs_History_Stream_Cursor_Value_Input = {
  change?: InputMaybe<Scalars['Int']>;
  courseId?: InputMaybe<Scalars['Int']>;
  created_at?: InputMaybe<Scalars['timestamp']>;
  event?: InputMaybe<Resource_Packs_Events_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  orgId?: InputMaybe<Scalars['uuid']>;
  payload?: InputMaybe<Scalars['jsonb']>;
  reservedBalance?: InputMaybe<Scalars['Int']>;
  resourcePacksType?: InputMaybe<Resource_Packs_Type_Enum>;
  totalBalance?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Org_Resource_Packs_History_Sum_Fields = {
  __typename?: 'org_resource_packs_history_sum_fields';
  change?: Maybe<Scalars['Int']>;
  courseId?: Maybe<Scalars['Int']>;
  reservedBalance?: Maybe<Scalars['Int']>;
  totalBalance?: Maybe<Scalars['Int']>;
};

/** update columns of table "org_resource_packs_history" */
export enum Org_Resource_Packs_History_Update_Column {
  /** column name */
  Change = 'change',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Event = 'event',
  /** column name */
  Id = 'id',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  Payload = 'payload',
  /** column name */
  ReservedBalance = 'reservedBalance',
  /** column name */
  ResourcePacksType = 'resourcePacksType',
  /** column name */
  TotalBalance = 'totalBalance'
}

export type Org_Resource_Packs_History_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Org_Resource_Packs_History_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Org_Resource_Packs_History_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Org_Resource_Packs_History_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Org_Resource_Packs_History_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_Resource_Packs_History_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Org_Resource_Packs_History_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_Resource_Packs_History_Set_Input>;
  /** filter the rows which have to be updated */
  where: Org_Resource_Packs_History_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_Resource_Packs_History_Var_Pop_Fields = {
  __typename?: 'org_resource_packs_history_var_pop_fields';
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
  totalBalance?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Org_Resource_Packs_History_Var_Samp_Fields = {
  __typename?: 'org_resource_packs_history_var_samp_fields';
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
  totalBalance?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Org_Resource_Packs_History_Variance_Fields = {
  __typename?: 'org_resource_packs_history_variance_fields';
  change?: Maybe<Scalars['Float']>;
  courseId?: Maybe<Scalars['Float']>;
  reservedBalance?: Maybe<Scalars['Float']>;
  totalBalance?: Maybe<Scalars['Float']>;
};

/** Holds information regarding the pricing for resource packs corresponding to specific organisations. */
export type Org_Resource_Packs_Pricing = {
  __typename?: 'org_resource_packs_pricing';
  AUD_price: Scalars['numeric'];
  NZD_price: Scalars['numeric'];
  id: Scalars['uuid'];
  organisation_id: Scalars['uuid'];
  /** An object relationship */
  organization: Organization;
  /** An object relationship */
  resource_packs_pricing: Resource_Packs_Pricing;
  resource_packs_pricing_id: Scalars['uuid'];
  synced_from_main: Scalars['Boolean'];
};

/** aggregated selection of "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Aggregate = {
  __typename?: 'org_resource_packs_pricing_aggregate';
  aggregate?: Maybe<Org_Resource_Packs_Pricing_Aggregate_Fields>;
  nodes: Array<Org_Resource_Packs_Pricing>;
};

export type Org_Resource_Packs_Pricing_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Org_Resource_Packs_Pricing_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Org_Resource_Packs_Pricing_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Org_Resource_Packs_Pricing_Aggregate_Bool_Exp_Count>;
};

export type Org_Resource_Packs_Pricing_Aggregate_Bool_Exp_Bool_And = {
  arguments: Org_Resource_Packs_Pricing_Select_Column_Org_Resource_Packs_Pricing_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Org_Resource_Packs_Pricing_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Org_Resource_Packs_Pricing_Select_Column_Org_Resource_Packs_Pricing_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Org_Resource_Packs_Pricing_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Org_Resource_Packs_Pricing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Aggregate_Fields = {
  __typename?: 'org_resource_packs_pricing_aggregate_fields';
  avg?: Maybe<Org_Resource_Packs_Pricing_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Org_Resource_Packs_Pricing_Max_Fields>;
  min?: Maybe<Org_Resource_Packs_Pricing_Min_Fields>;
  stddev?: Maybe<Org_Resource_Packs_Pricing_Stddev_Fields>;
  stddev_pop?: Maybe<Org_Resource_Packs_Pricing_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Org_Resource_Packs_Pricing_Stddev_Samp_Fields>;
  sum?: Maybe<Org_Resource_Packs_Pricing_Sum_Fields>;
  var_pop?: Maybe<Org_Resource_Packs_Pricing_Var_Pop_Fields>;
  var_samp?: Maybe<Org_Resource_Packs_Pricing_Var_Samp_Fields>;
  variance?: Maybe<Org_Resource_Packs_Pricing_Variance_Fields>;
};


/** aggregate fields of "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Resource_Packs_Pricing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Aggregate_Order_By = {
  avg?: InputMaybe<Org_Resource_Packs_Pricing_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Org_Resource_Packs_Pricing_Max_Order_By>;
  min?: InputMaybe<Org_Resource_Packs_Pricing_Min_Order_By>;
  stddev?: InputMaybe<Org_Resource_Packs_Pricing_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Org_Resource_Packs_Pricing_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Org_Resource_Packs_Pricing_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Org_Resource_Packs_Pricing_Sum_Order_By>;
  var_pop?: InputMaybe<Org_Resource_Packs_Pricing_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Org_Resource_Packs_Pricing_Var_Samp_Order_By>;
  variance?: InputMaybe<Org_Resource_Packs_Pricing_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Arr_Rel_Insert_Input = {
  data: Array<Org_Resource_Packs_Pricing_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Org_Resource_Packs_Pricing_On_Conflict>;
};

/** aggregate avg on columns */
export type Org_Resource_Packs_Pricing_Avg_Fields = {
  __typename?: 'org_resource_packs_pricing_avg_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Avg_Order_By = {
  AUD_price?: InputMaybe<Order_By>;
  NZD_price?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "org_resource_packs_pricing". All fields are combined with a logical 'AND'. */
export type Org_Resource_Packs_Pricing_Bool_Exp = {
  AUD_price?: InputMaybe<Numeric_Comparison_Exp>;
  NZD_price?: InputMaybe<Numeric_Comparison_Exp>;
  _and?: InputMaybe<Array<Org_Resource_Packs_Pricing_Bool_Exp>>;
  _not?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Resource_Packs_Pricing_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  resource_packs_pricing?: InputMaybe<Resource_Packs_Pricing_Bool_Exp>;
  resource_packs_pricing_id?: InputMaybe<Uuid_Comparison_Exp>;
  synced_from_main?: InputMaybe<Boolean_Comparison_Exp>;
};

/** Hold information regarding the changes for RP pricings for specific organisations */
export type Org_Resource_Packs_Pricing_Changelog = {
  __typename?: 'org_resource_packs_pricing_changelog';
  actioned_at: Scalars['timestamptz'];
  actioned_by?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  actioned_by_profile?: Maybe<Profile>;
  id: Scalars['uuid'];
  operation: Cud_Operation_Enum;
  org_id?: Maybe<Scalars['uuid']>;
  org_resource_packs_pricing_id: Scalars['uuid'];
  /** An object relationship */
  organization?: Maybe<Organization>;
  /** An object relationship */
  resource_packs_pricing?: Maybe<Resource_Packs_Pricing>;
  resource_packs_pricing_id?: Maybe<Scalars['uuid']>;
  updated_columns?: Maybe<Scalars['jsonb']>;
};


/** Hold information regarding the changes for RP pricings for specific organisations */
export type Org_Resource_Packs_Pricing_ChangelogUpdated_ColumnsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "org_resource_packs_pricing_changelog" */
export type Org_Resource_Packs_Pricing_Changelog_Aggregate = {
  __typename?: 'org_resource_packs_pricing_changelog_aggregate';
  aggregate?: Maybe<Org_Resource_Packs_Pricing_Changelog_Aggregate_Fields>;
  nodes: Array<Org_Resource_Packs_Pricing_Changelog>;
};

/** aggregate fields of "org_resource_packs_pricing_changelog" */
export type Org_Resource_Packs_Pricing_Changelog_Aggregate_Fields = {
  __typename?: 'org_resource_packs_pricing_changelog_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Org_Resource_Packs_Pricing_Changelog_Max_Fields>;
  min?: Maybe<Org_Resource_Packs_Pricing_Changelog_Min_Fields>;
};


/** aggregate fields of "org_resource_packs_pricing_changelog" */
export type Org_Resource_Packs_Pricing_Changelog_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Org_Resource_Packs_Pricing_Changelog_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Org_Resource_Packs_Pricing_Changelog_Append_Input = {
  updated_columns?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "org_resource_packs_pricing_changelog". All fields are combined with a logical 'AND'. */
export type Org_Resource_Packs_Pricing_Changelog_Bool_Exp = {
  _and?: InputMaybe<Array<Org_Resource_Packs_Pricing_Changelog_Bool_Exp>>;
  _not?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Bool_Exp>;
  _or?: InputMaybe<Array<Org_Resource_Packs_Pricing_Changelog_Bool_Exp>>;
  actioned_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  actioned_by?: InputMaybe<Uuid_Comparison_Exp>;
  actioned_by_profile?: InputMaybe<Profile_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  operation?: InputMaybe<Cud_Operation_Enum_Comparison_Exp>;
  org_id?: InputMaybe<Uuid_Comparison_Exp>;
  org_resource_packs_pricing_id?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  resource_packs_pricing?: InputMaybe<Resource_Packs_Pricing_Bool_Exp>;
  resource_packs_pricing_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_columns?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "org_resource_packs_pricing_changelog" */
export enum Org_Resource_Packs_Pricing_Changelog_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrgResourcePacksPricingChangelogPkey = 'org_resource_packs_pricing_changelog_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Org_Resource_Packs_Pricing_Changelog_Delete_At_Path_Input = {
  updated_columns?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Org_Resource_Packs_Pricing_Changelog_Delete_Elem_Input = {
  updated_columns?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Org_Resource_Packs_Pricing_Changelog_Delete_Key_Input = {
  updated_columns?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "org_resource_packs_pricing_changelog" */
export type Org_Resource_Packs_Pricing_Changelog_Insert_Input = {
  actioned_at?: InputMaybe<Scalars['timestamptz']>;
  actioned_by?: InputMaybe<Scalars['uuid']>;
  actioned_by_profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Cud_Operation_Enum>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_resource_packs_pricing_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  resource_packs_pricing?: InputMaybe<Resource_Packs_Pricing_Obj_Rel_Insert_Input>;
  resource_packs_pricing_id?: InputMaybe<Scalars['uuid']>;
  updated_columns?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Org_Resource_Packs_Pricing_Changelog_Max_Fields = {
  __typename?: 'org_resource_packs_pricing_changelog_max_fields';
  actioned_at?: Maybe<Scalars['timestamptz']>;
  actioned_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  org_resource_packs_pricing_id?: Maybe<Scalars['uuid']>;
  resource_packs_pricing_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Org_Resource_Packs_Pricing_Changelog_Min_Fields = {
  __typename?: 'org_resource_packs_pricing_changelog_min_fields';
  actioned_at?: Maybe<Scalars['timestamptz']>;
  actioned_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  org_id?: Maybe<Scalars['uuid']>;
  org_resource_packs_pricing_id?: Maybe<Scalars['uuid']>;
  resource_packs_pricing_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "org_resource_packs_pricing_changelog" */
export type Org_Resource_Packs_Pricing_Changelog_Mutation_Response = {
  __typename?: 'org_resource_packs_pricing_changelog_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_Resource_Packs_Pricing_Changelog>;
};

/** on_conflict condition type for table "org_resource_packs_pricing_changelog" */
export type Org_Resource_Packs_Pricing_Changelog_On_Conflict = {
  constraint: Org_Resource_Packs_Pricing_Changelog_Constraint;
  update_columns?: Array<Org_Resource_Packs_Pricing_Changelog_Update_Column>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Bool_Exp>;
};

/** Ordering options when selecting data from "org_resource_packs_pricing_changelog". */
export type Org_Resource_Packs_Pricing_Changelog_Order_By = {
  actioned_at?: InputMaybe<Order_By>;
  actioned_by?: InputMaybe<Order_By>;
  actioned_by_profile?: InputMaybe<Profile_Order_By>;
  id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  org_id?: InputMaybe<Order_By>;
  org_resource_packs_pricing_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  resource_packs_pricing?: InputMaybe<Resource_Packs_Pricing_Order_By>;
  resource_packs_pricing_id?: InputMaybe<Order_By>;
  updated_columns?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_resource_packs_pricing_changelog */
export type Org_Resource_Packs_Pricing_Changelog_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Org_Resource_Packs_Pricing_Changelog_Prepend_Input = {
  updated_columns?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "org_resource_packs_pricing_changelog" */
export enum Org_Resource_Packs_Pricing_Changelog_Select_Column {
  /** column name */
  ActionedAt = 'actioned_at',
  /** column name */
  ActionedBy = 'actioned_by',
  /** column name */
  Id = 'id',
  /** column name */
  Operation = 'operation',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgResourcePacksPricingId = 'org_resource_packs_pricing_id',
  /** column name */
  ResourcePacksPricingId = 'resource_packs_pricing_id',
  /** column name */
  UpdatedColumns = 'updated_columns'
}

/** input type for updating data in table "org_resource_packs_pricing_changelog" */
export type Org_Resource_Packs_Pricing_Changelog_Set_Input = {
  actioned_at?: InputMaybe<Scalars['timestamptz']>;
  actioned_by?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Cud_Operation_Enum>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_resource_packs_pricing_id?: InputMaybe<Scalars['uuid']>;
  resource_packs_pricing_id?: InputMaybe<Scalars['uuid']>;
  updated_columns?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "org_resource_packs_pricing_changelog" */
export type Org_Resource_Packs_Pricing_Changelog_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Resource_Packs_Pricing_Changelog_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Resource_Packs_Pricing_Changelog_Stream_Cursor_Value_Input = {
  actioned_at?: InputMaybe<Scalars['timestamptz']>;
  actioned_by?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Cud_Operation_Enum>;
  org_id?: InputMaybe<Scalars['uuid']>;
  org_resource_packs_pricing_id?: InputMaybe<Scalars['uuid']>;
  resource_packs_pricing_id?: InputMaybe<Scalars['uuid']>;
  updated_columns?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "org_resource_packs_pricing_changelog" */
export enum Org_Resource_Packs_Pricing_Changelog_Update_Column {
  /** column name */
  ActionedAt = 'actioned_at',
  /** column name */
  ActionedBy = 'actioned_by',
  /** column name */
  Id = 'id',
  /** column name */
  Operation = 'operation',
  /** column name */
  OrgId = 'org_id',
  /** column name */
  OrgResourcePacksPricingId = 'org_resource_packs_pricing_id',
  /** column name */
  ResourcePacksPricingId = 'resource_packs_pricing_id',
  /** column name */
  UpdatedColumns = 'updated_columns'
}

export type Org_Resource_Packs_Pricing_Changelog_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Set_Input>;
  /** filter the rows which have to be updated */
  where: Org_Resource_Packs_Pricing_Changelog_Bool_Exp;
};

/** unique or primary key constraints on table "org_resource_packs_pricing" */
export enum Org_Resource_Packs_Pricing_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrgResourcePacksPricingPkey = 'org_resource_packs_pricing_pkey',
  /** unique or primary key constraint on columns "organisation_id", "resource_packs_pricing_id" */
  OrgResourcePacksPricingResourcePacksPricingIdOrganiKey = 'org_resource_packs_pricing_resource_packs_pricing_id_organi_key'
}

/** input type for incrementing numeric columns in table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Inc_Input = {
  AUD_price?: InputMaybe<Scalars['numeric']>;
  NZD_price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Insert_Input = {
  AUD_price?: InputMaybe<Scalars['numeric']>;
  NZD_price?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  organisation_id?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  resource_packs_pricing?: InputMaybe<Resource_Packs_Pricing_Obj_Rel_Insert_Input>;
  resource_packs_pricing_id?: InputMaybe<Scalars['uuid']>;
  synced_from_main?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate max on columns */
export type Org_Resource_Packs_Pricing_Max_Fields = {
  __typename?: 'org_resource_packs_pricing_max_fields';
  AUD_price?: Maybe<Scalars['numeric']>;
  NZD_price?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  organisation_id?: Maybe<Scalars['uuid']>;
  resource_packs_pricing_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Max_Order_By = {
  AUD_price?: InputMaybe<Order_By>;
  NZD_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  resource_packs_pricing_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Org_Resource_Packs_Pricing_Min_Fields = {
  __typename?: 'org_resource_packs_pricing_min_fields';
  AUD_price?: Maybe<Scalars['numeric']>;
  NZD_price?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
  organisation_id?: Maybe<Scalars['uuid']>;
  resource_packs_pricing_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Min_Order_By = {
  AUD_price?: InputMaybe<Order_By>;
  NZD_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  resource_packs_pricing_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Mutation_Response = {
  __typename?: 'org_resource_packs_pricing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Org_Resource_Packs_Pricing>;
};

/** on_conflict condition type for table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_On_Conflict = {
  constraint: Org_Resource_Packs_Pricing_Constraint;
  update_columns?: Array<Org_Resource_Packs_Pricing_Update_Column>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
};

/** Ordering options when selecting data from "org_resource_packs_pricing". */
export type Org_Resource_Packs_Pricing_Order_By = {
  AUD_price?: InputMaybe<Order_By>;
  NZD_price?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  resource_packs_pricing?: InputMaybe<Resource_Packs_Pricing_Order_By>;
  resource_packs_pricing_id?: InputMaybe<Order_By>;
  synced_from_main?: InputMaybe<Order_By>;
};

/** primary key columns input for table: org_resource_packs_pricing */
export type Org_Resource_Packs_Pricing_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "org_resource_packs_pricing" */
export enum Org_Resource_Packs_Pricing_Select_Column {
  /** column name */
  AudPrice = 'AUD_price',
  /** column name */
  NzdPrice = 'NZD_price',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ResourcePacksPricingId = 'resource_packs_pricing_id',
  /** column name */
  SyncedFromMain = 'synced_from_main'
}

/** select "org_resource_packs_pricing_aggregate_bool_exp_bool_and_arguments_columns" columns of table "org_resource_packs_pricing" */
export enum Org_Resource_Packs_Pricing_Select_Column_Org_Resource_Packs_Pricing_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  SyncedFromMain = 'synced_from_main'
}

/** select "org_resource_packs_pricing_aggregate_bool_exp_bool_or_arguments_columns" columns of table "org_resource_packs_pricing" */
export enum Org_Resource_Packs_Pricing_Select_Column_Org_Resource_Packs_Pricing_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  SyncedFromMain = 'synced_from_main'
}

/** input type for updating data in table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Set_Input = {
  AUD_price?: InputMaybe<Scalars['numeric']>;
  NZD_price?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  organisation_id?: InputMaybe<Scalars['uuid']>;
  resource_packs_pricing_id?: InputMaybe<Scalars['uuid']>;
  synced_from_main?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate stddev on columns */
export type Org_Resource_Packs_Pricing_Stddev_Fields = {
  __typename?: 'org_resource_packs_pricing_stddev_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Stddev_Order_By = {
  AUD_price?: InputMaybe<Order_By>;
  NZD_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Org_Resource_Packs_Pricing_Stddev_Pop_Fields = {
  __typename?: 'org_resource_packs_pricing_stddev_pop_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Stddev_Pop_Order_By = {
  AUD_price?: InputMaybe<Order_By>;
  NZD_price?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Org_Resource_Packs_Pricing_Stddev_Samp_Fields = {
  __typename?: 'org_resource_packs_pricing_stddev_samp_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Stddev_Samp_Order_By = {
  AUD_price?: InputMaybe<Order_By>;
  NZD_price?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Org_Resource_Packs_Pricing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Org_Resource_Packs_Pricing_Stream_Cursor_Value_Input = {
  AUD_price?: InputMaybe<Scalars['numeric']>;
  NZD_price?: InputMaybe<Scalars['numeric']>;
  id?: InputMaybe<Scalars['uuid']>;
  organisation_id?: InputMaybe<Scalars['uuid']>;
  resource_packs_pricing_id?: InputMaybe<Scalars['uuid']>;
  synced_from_main?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate sum on columns */
export type Org_Resource_Packs_Pricing_Sum_Fields = {
  __typename?: 'org_resource_packs_pricing_sum_fields';
  AUD_price?: Maybe<Scalars['numeric']>;
  NZD_price?: Maybe<Scalars['numeric']>;
};

/** order by sum() on columns of table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Sum_Order_By = {
  AUD_price?: InputMaybe<Order_By>;
  NZD_price?: InputMaybe<Order_By>;
};

/** update columns of table "org_resource_packs_pricing" */
export enum Org_Resource_Packs_Pricing_Update_Column {
  /** column name */
  AudPrice = 'AUD_price',
  /** column name */
  NzdPrice = 'NZD_price',
  /** column name */
  Id = 'id',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  ResourcePacksPricingId = 'resource_packs_pricing_id',
  /** column name */
  SyncedFromMain = 'synced_from_main'
}

export type Org_Resource_Packs_Pricing_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Org_Resource_Packs_Pricing_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Org_Resource_Packs_Pricing_Set_Input>;
  /** filter the rows which have to be updated */
  where: Org_Resource_Packs_Pricing_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Org_Resource_Packs_Pricing_Var_Pop_Fields = {
  __typename?: 'org_resource_packs_pricing_var_pop_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Var_Pop_Order_By = {
  AUD_price?: InputMaybe<Order_By>;
  NZD_price?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Org_Resource_Packs_Pricing_Var_Samp_Fields = {
  __typename?: 'org_resource_packs_pricing_var_samp_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Var_Samp_Order_By = {
  AUD_price?: InputMaybe<Order_By>;
  NZD_price?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Org_Resource_Packs_Pricing_Variance_Fields = {
  __typename?: 'org_resource_packs_pricing_variance_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "org_resource_packs_pricing" */
export type Org_Resource_Packs_Pricing_Variance_Order_By = {
  AUD_price?: InputMaybe<Order_By>;
  NZD_price?: InputMaybe<Order_By>;
};

/** Keep track of changes made on organisations */
export type Organisation_Log = {
  __typename?: 'organisation_log';
  actioned_at: Scalars['timestamp'];
  actioned_by?: Maybe<Scalars['uuid']>;
  actioned_from: Org_Created_From_Enum;
  id: Scalars['uuid'];
  operation: Cud_Operation_Enum;
  organisation_id?: Maybe<Scalars['uuid']>;
  updated_columns?: Maybe<Scalars['jsonb']>;
};


/** Keep track of changes made on organisations */
export type Organisation_LogUpdated_ColumnsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "organisation_log" */
export type Organisation_Log_Aggregate = {
  __typename?: 'organisation_log_aggregate';
  aggregate?: Maybe<Organisation_Log_Aggregate_Fields>;
  nodes: Array<Organisation_Log>;
};

export type Organisation_Log_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organisation_Log_Aggregate_Bool_Exp_Count>;
};

export type Organisation_Log_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organisation_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organisation_Log_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organisation_log" */
export type Organisation_Log_Aggregate_Fields = {
  __typename?: 'organisation_log_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organisation_Log_Max_Fields>;
  min?: Maybe<Organisation_Log_Min_Fields>;
};


/** aggregate fields of "organisation_log" */
export type Organisation_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organisation_log" */
export type Organisation_Log_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organisation_Log_Max_Order_By>;
  min?: InputMaybe<Organisation_Log_Min_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Organisation_Log_Append_Input = {
  updated_columns?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "organisation_log" */
export type Organisation_Log_Arr_Rel_Insert_Input = {
  data: Array<Organisation_Log_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Log_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organisation_log". All fields are combined with a logical 'AND'. */
export type Organisation_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Log_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Log_Bool_Exp>>;
  actioned_at?: InputMaybe<Timestamp_Comparison_Exp>;
  actioned_by?: InputMaybe<Uuid_Comparison_Exp>;
  actioned_from?: InputMaybe<Org_Created_From_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  operation?: InputMaybe<Cud_Operation_Enum_Comparison_Exp>;
  organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_columns?: InputMaybe<Jsonb_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_log" */
export enum Organisation_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganisationLogPkey = 'organisation_log_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Organisation_Log_Delete_At_Path_Input = {
  updated_columns?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Organisation_Log_Delete_Elem_Input = {
  updated_columns?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Organisation_Log_Delete_Key_Input = {
  updated_columns?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "organisation_log" */
export type Organisation_Log_Insert_Input = {
  actioned_at?: InputMaybe<Scalars['timestamp']>;
  actioned_by?: InputMaybe<Scalars['uuid']>;
  actioned_from?: InputMaybe<Org_Created_From_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Cud_Operation_Enum>;
  organisation_id?: InputMaybe<Scalars['uuid']>;
  updated_columns?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate max on columns */
export type Organisation_Log_Max_Fields = {
  __typename?: 'organisation_log_max_fields';
  actioned_at?: Maybe<Scalars['timestamp']>;
  actioned_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  organisation_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "organisation_log" */
export type Organisation_Log_Max_Order_By = {
  actioned_at?: InputMaybe<Order_By>;
  actioned_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organisation_Log_Min_Fields = {
  __typename?: 'organisation_log_min_fields';
  actioned_at?: Maybe<Scalars['timestamp']>;
  actioned_by?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
  organisation_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "organisation_log" */
export type Organisation_Log_Min_Order_By = {
  actioned_at?: InputMaybe<Order_By>;
  actioned_by?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organisation_log" */
export type Organisation_Log_Mutation_Response = {
  __typename?: 'organisation_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Log>;
};

/** on_conflict condition type for table "organisation_log" */
export type Organisation_Log_On_Conflict = {
  constraint: Organisation_Log_Constraint;
  update_columns?: Array<Organisation_Log_Update_Column>;
  where?: InputMaybe<Organisation_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_log". */
export type Organisation_Log_Order_By = {
  actioned_at?: InputMaybe<Order_By>;
  actioned_by?: InputMaybe<Order_By>;
  actioned_from?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  operation?: InputMaybe<Order_By>;
  organisation_id?: InputMaybe<Order_By>;
  updated_columns?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_log */
export type Organisation_Log_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Organisation_Log_Prepend_Input = {
  updated_columns?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "organisation_log" */
export enum Organisation_Log_Select_Column {
  /** column name */
  ActionedAt = 'actioned_at',
  /** column name */
  ActionedBy = 'actioned_by',
  /** column name */
  ActionedFrom = 'actioned_from',
  /** column name */
  Id = 'id',
  /** column name */
  Operation = 'operation',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UpdatedColumns = 'updated_columns'
}

/** input type for updating data in table "organisation_log" */
export type Organisation_Log_Set_Input = {
  actioned_at?: InputMaybe<Scalars['timestamp']>;
  actioned_by?: InputMaybe<Scalars['uuid']>;
  actioned_from?: InputMaybe<Org_Created_From_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Cud_Operation_Enum>;
  organisation_id?: InputMaybe<Scalars['uuid']>;
  updated_columns?: InputMaybe<Scalars['jsonb']>;
};

/** Streaming cursor of the table "organisation_log" */
export type Organisation_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Log_Stream_Cursor_Value_Input = {
  actioned_at?: InputMaybe<Scalars['timestamp']>;
  actioned_by?: InputMaybe<Scalars['uuid']>;
  actioned_from?: InputMaybe<Org_Created_From_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  operation?: InputMaybe<Cud_Operation_Enum>;
  organisation_id?: InputMaybe<Scalars['uuid']>;
  updated_columns?: InputMaybe<Scalars['jsonb']>;
};

/** update columns of table "organisation_log" */
export enum Organisation_Log_Update_Column {
  /** column name */
  ActionedAt = 'actioned_at',
  /** column name */
  ActionedBy = 'actioned_by',
  /** column name */
  ActionedFrom = 'actioned_from',
  /** column name */
  Id = 'id',
  /** column name */
  Operation = 'operation',
  /** column name */
  OrganisationId = 'organisation_id',
  /** column name */
  UpdatedColumns = 'updated_columns'
}

export type Organisation_Log_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organisation_Log_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organisation_Log_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organisation_Log_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organisation_Log_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organisation_Log_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_Log_Bool_Exp;
};

/** columns and relationships of "organisation_sector" */
export type Organisation_Sector = {
  __typename?: 'organisation_sector';
  name: Scalars['String'];
};

/** aggregated selection of "organisation_sector" */
export type Organisation_Sector_Aggregate = {
  __typename?: 'organisation_sector_aggregate';
  aggregate?: Maybe<Organisation_Sector_Aggregate_Fields>;
  nodes: Array<Organisation_Sector>;
};

/** aggregate fields of "organisation_sector" */
export type Organisation_Sector_Aggregate_Fields = {
  __typename?: 'organisation_sector_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organisation_Sector_Max_Fields>;
  min?: Maybe<Organisation_Sector_Min_Fields>;
};


/** aggregate fields of "organisation_sector" */
export type Organisation_Sector_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organisation_Sector_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "organisation_sector". All fields are combined with a logical 'AND'. */
export type Organisation_Sector_Bool_Exp = {
  _and?: InputMaybe<Array<Organisation_Sector_Bool_Exp>>;
  _not?: InputMaybe<Organisation_Sector_Bool_Exp>;
  _or?: InputMaybe<Array<Organisation_Sector_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organisation_sector" */
export enum Organisation_Sector_Constraint {
  /** unique or primary key constraint on columns "name" */
  OrganisationSectorPkey = 'organisation_sector_pkey'
}

export enum Organisation_Sector_Enum {
  AnzEdu = 'ANZ_EDU',
  AnzHealth = 'ANZ_HEALTH',
  AnzSs = 'ANZ_SS',
  Edu = 'EDU',
  HscAdult = 'HSC_ADULT',
  HscChildren = 'HSC_CHILDREN'
}

/** Boolean expression to compare columns of type "organisation_sector_enum". All fields are combined with logical 'AND'. */
export type Organisation_Sector_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Organisation_Sector_Enum>;
  _in?: InputMaybe<Array<Organisation_Sector_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Organisation_Sector_Enum>;
  _nin?: InputMaybe<Array<Organisation_Sector_Enum>>;
};

/** input type for inserting data into table "organisation_sector" */
export type Organisation_Sector_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Organisation_Sector_Max_Fields = {
  __typename?: 'organisation_sector_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Organisation_Sector_Min_Fields = {
  __typename?: 'organisation_sector_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "organisation_sector" */
export type Organisation_Sector_Mutation_Response = {
  __typename?: 'organisation_sector_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organisation_Sector>;
};

/** input type for inserting object relation for remote table "organisation_sector" */
export type Organisation_Sector_Obj_Rel_Insert_Input = {
  data: Organisation_Sector_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organisation_Sector_On_Conflict>;
};

/** on_conflict condition type for table "organisation_sector" */
export type Organisation_Sector_On_Conflict = {
  constraint: Organisation_Sector_Constraint;
  update_columns?: Array<Organisation_Sector_Update_Column>;
  where?: InputMaybe<Organisation_Sector_Bool_Exp>;
};

/** Ordering options when selecting data from "organisation_sector". */
export type Organisation_Sector_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organisation_sector */
export type Organisation_Sector_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "organisation_sector" */
export enum Organisation_Sector_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "organisation_sector" */
export type Organisation_Sector_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "organisation_sector" */
export type Organisation_Sector_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organisation_Sector_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organisation_Sector_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "organisation_sector" */
export enum Organisation_Sector_Update_Column {
  /** column name */
  Name = 'name'
}

export type Organisation_Sector_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organisation_Sector_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organisation_Sector_Bool_Exp;
};

/** columns and relationships of "organization" */
export type Organization = {
  __typename?: 'organization';
  address: Scalars['jsonb'];
  /** An array relationship */
  affiliated_organisations: Array<Organization>;
  /** An aggregate relationship */
  affiliated_organisations_aggregate: Organization_Aggregate;
  attributes: Scalars['jsonb'];
  canAccessKnowledgeHub?: Maybe<Scalars['Boolean']>;
  contactDetails: Scalars['jsonb'];
  createdAt: Scalars['timestamptz'];
  dfeEstablishmentId?: Maybe<Scalars['uuid']>;
  external_dashboard_url?: Maybe<Scalars['String']>;
  geoCoordinates?: Maybe<Scalars['point']>;
  go1Licenses?: Maybe<Scalars['Int']>;
  /** An array relationship */
  go1LicensesHistory: Array<Go1_Licenses_History>;
  /** An aggregate relationship */
  go1LicensesHistory_aggregate: Go1_Licenses_History_Aggregate;
  id: Scalars['uuid'];
  /** An array relationship */
  invites: Array<Organization_Invites>;
  /** An aggregate relationship */
  invites_aggregate: Organization_Invites_Aggregate;
  /** An object relationship */
  main_organisation?: Maybe<Organization>;
  main_organisation_id?: Maybe<Scalars['uuid']>;
  /** An array relationship */
  members: Array<Organization_Member>;
  /** An aggregate relationship */
  members_aggregate: Organization_Member_Aggregate;
  name: Scalars['String'];
  organisationType?: Maybe<Scalars['String']>;
  /** An array relationship */
  organisation_logs: Array<Organisation_Log>;
  /** An aggregate relationship */
  organisation_logs_aggregate: Organisation_Log_Aggregate;
  /** An array relationship */
  organization_courses: Array<Course>;
  /** An aggregate relationship */
  organization_courses_aggregate: Course_Aggregate;
  /** An object relationship */
  organization_dfe_establishment?: Maybe<Dfe_Establishment>;
  /** An array relationship */
  organization_go1_licenses: Array<Go1_Licenses>;
  /** An aggregate relationship */
  organization_go1_licenses_aggregate: Go1_Licenses_Aggregate;
  /** An array relationship */
  organization_orders: Array<Order>;
  /** An aggregate relationship */
  organization_orders_aggregate: Order_Aggregate;
  /** An array relationship */
  organization_resource_packs: Array<Organization_Resource_Packs>;
  /** An aggregate relationship */
  organization_resource_packs_aggregate: Organization_Resource_Packs_Aggregate;
  original_record?: Maybe<Scalars['jsonb']>;
  preferences: Scalars['jsonb'];
  region?: Maybe<Scalars['String']>;
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  searchable?: Maybe<Scalars['String']>;
  searchable_postcode?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  tags?: Maybe<Scalars['jsonb']>;
  tt_connect_id?: Maybe<Scalars['String']>;
  updatedAt: Scalars['timestamptz'];
  urn?: Maybe<Scalars['String']>;
  xeroContactId?: Maybe<Scalars['String']>;
};


/** columns and relationships of "organization" */
export type OrganizationAddressArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organization" */
export type OrganizationAffiliated_OrganisationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationAffiliated_Organisations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationAttributesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organization" */
export type OrganizationContactDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organization" */
export type OrganizationGo1LicensesHistoryArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_History_Order_By>>;
  where?: InputMaybe<Go1_Licenses_History_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationGo1LicensesHistory_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_History_Order_By>>;
  where?: InputMaybe<Go1_Licenses_History_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationInvitesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Invites_Order_By>>;
  where?: InputMaybe<Organization_Invites_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationInvites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Invites_Order_By>>;
  where?: InputMaybe<Organization_Invites_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationMembersArgs = {
  distinct_on?: InputMaybe<Array<Organization_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Member_Order_By>>;
  where?: InputMaybe<Organization_Member_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationMembers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Member_Order_By>>;
  where?: InputMaybe<Organization_Member_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganisation_LogsArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Log_Order_By>>;
  where?: InputMaybe<Organisation_Log_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganisation_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Log_Order_By>>;
  where?: InputMaybe<Organisation_Log_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_CoursesArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Courses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Go1_LicensesArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_Order_By>>;
  where?: InputMaybe<Go1_Licenses_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Go1_Licenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_Order_By>>;
  where?: InputMaybe<Go1_Licenses_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_OrdersArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Orders_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Resource_PacksArgs = {
  distinct_on?: InputMaybe<Array<Organization_Resource_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Resource_Packs_Order_By>>;
  where?: InputMaybe<Organization_Resource_Packs_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOrganization_Resource_Packs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Resource_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Resource_Packs_Order_By>>;
  where?: InputMaybe<Organization_Resource_Packs_Bool_Exp>;
};


/** columns and relationships of "organization" */
export type OrganizationOriginal_RecordArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organization" */
export type OrganizationPreferencesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "organization" */
export type OrganizationTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "organization" */
export type Organization_Aggregate = {
  __typename?: 'organization_aggregate';
  aggregate?: Maybe<Organization_Aggregate_Fields>;
  nodes: Array<Organization>;
};

export type Organization_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Aggregate_Bool_Exp_Count>;
};

export type Organization_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization" */
export type Organization_Aggregate_Fields = {
  __typename?: 'organization_aggregate_fields';
  avg?: Maybe<Organization_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organization_Max_Fields>;
  min?: Maybe<Organization_Min_Fields>;
  stddev?: Maybe<Organization_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Sum_Fields>;
  var_pop?: Maybe<Organization_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Var_Samp_Fields>;
  variance?: Maybe<Organization_Variance_Fields>;
};


/** aggregate fields of "organization" */
export type Organization_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organization" */
export type Organization_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Max_Order_By>;
  min?: InputMaybe<Organization_Min_Order_By>;
  stddev?: InputMaybe<Organization_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Variance_Order_By>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Organization_Append_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  contactDetails?: InputMaybe<Scalars['jsonb']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** input type for inserting array relation for remote table "organization" */
export type Organization_Arr_Rel_Insert_Input = {
  data: Array<Organization_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_Avg_Fields = {
  __typename?: 'organization_avg_fields';
  go1Licenses?: Maybe<Scalars['Float']>;
  reservedGo1Licenses?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "organization" */
export type Organization_Avg_Order_By = {
  go1Licenses?: InputMaybe<Order_By>;
  reservedGo1Licenses?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization". All fields are combined with a logical 'AND'. */
export type Organization_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Bool_Exp>>;
  _not?: InputMaybe<Organization_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Bool_Exp>>;
  address?: InputMaybe<Jsonb_Comparison_Exp>;
  affiliated_organisations?: InputMaybe<Organization_Bool_Exp>;
  affiliated_organisations_aggregate?: InputMaybe<Organization_Aggregate_Bool_Exp>;
  attributes?: InputMaybe<Jsonb_Comparison_Exp>;
  canAccessKnowledgeHub?: InputMaybe<Boolean_Comparison_Exp>;
  contactDetails?: InputMaybe<Jsonb_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dfeEstablishmentId?: InputMaybe<Uuid_Comparison_Exp>;
  external_dashboard_url?: InputMaybe<String_Comparison_Exp>;
  geoCoordinates?: InputMaybe<Point_Comparison_Exp>;
  go1Licenses?: InputMaybe<Int_Comparison_Exp>;
  go1LicensesHistory?: InputMaybe<Go1_Licenses_History_Bool_Exp>;
  go1LicensesHistory_aggregate?: InputMaybe<Go1_Licenses_History_Aggregate_Bool_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invites?: InputMaybe<Organization_Invites_Bool_Exp>;
  invites_aggregate?: InputMaybe<Organization_Invites_Aggregate_Bool_Exp>;
  main_organisation?: InputMaybe<Organization_Bool_Exp>;
  main_organisation_id?: InputMaybe<Uuid_Comparison_Exp>;
  members?: InputMaybe<Organization_Member_Bool_Exp>;
  members_aggregate?: InputMaybe<Organization_Member_Aggregate_Bool_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  organisationType?: InputMaybe<String_Comparison_Exp>;
  organisation_logs?: InputMaybe<Organisation_Log_Bool_Exp>;
  organisation_logs_aggregate?: InputMaybe<Organisation_Log_Aggregate_Bool_Exp>;
  organization_courses?: InputMaybe<Course_Bool_Exp>;
  organization_courses_aggregate?: InputMaybe<Course_Aggregate_Bool_Exp>;
  organization_dfe_establishment?: InputMaybe<Dfe_Establishment_Bool_Exp>;
  organization_go1_licenses?: InputMaybe<Go1_Licenses_Bool_Exp>;
  organization_go1_licenses_aggregate?: InputMaybe<Go1_Licenses_Aggregate_Bool_Exp>;
  organization_orders?: InputMaybe<Order_Bool_Exp>;
  organization_orders_aggregate?: InputMaybe<Order_Aggregate_Bool_Exp>;
  organization_resource_packs?: InputMaybe<Organization_Resource_Packs_Bool_Exp>;
  organization_resource_packs_aggregate?: InputMaybe<Organization_Resource_Packs_Aggregate_Bool_Exp>;
  original_record?: InputMaybe<Jsonb_Comparison_Exp>;
  preferences?: InputMaybe<Jsonb_Comparison_Exp>;
  region?: InputMaybe<String_Comparison_Exp>;
  reservedGo1Licenses?: InputMaybe<Int_Comparison_Exp>;
  searchable?: InputMaybe<String_Comparison_Exp>;
  searchable_postcode?: InputMaybe<String_Comparison_Exp>;
  sector?: InputMaybe<String_Comparison_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  tt_connect_id?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  urn?: InputMaybe<String_Comparison_Exp>;
  xeroContactId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization" */
export enum Organization_Constraint {
  /** unique or primary key constraint on columns "dfe_establishment_id" */
  OrganizationDfeEstablishmentIdKey = 'organization_dfe_establishment_id_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationPkey = 'organization_pkey',
  /** unique or primary key constraint on columns "tt_connect_id" */
  OrganizationTtConnectIdKey = 'organization_tt_connect_id_key',
  /** unique or primary key constraint on columns "urn" */
  OrganizationUrnKey = 'organization_urn_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Organization_Delete_At_Path_Input = {
  address?: InputMaybe<Array<Scalars['String']>>;
  attributes?: InputMaybe<Array<Scalars['String']>>;
  contactDetails?: InputMaybe<Array<Scalars['String']>>;
  original_record?: InputMaybe<Array<Scalars['String']>>;
  preferences?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Organization_Delete_Elem_Input = {
  address?: InputMaybe<Scalars['Int']>;
  attributes?: InputMaybe<Scalars['Int']>;
  contactDetails?: InputMaybe<Scalars['Int']>;
  original_record?: InputMaybe<Scalars['Int']>;
  preferences?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Organization_Delete_Key_Input = {
  address?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Scalars['String']>;
  contactDetails?: InputMaybe<Scalars['String']>;
  original_record?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "organization" */
export type Organization_Inc_Input = {
  go1Licenses?: InputMaybe<Scalars['Int']>;
  reservedGo1Licenses?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organization" */
export type Organization_Insert_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  affiliated_organisations?: InputMaybe<Organization_Arr_Rel_Insert_Input>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  canAccessKnowledgeHub?: InputMaybe<Scalars['Boolean']>;
  contactDetails?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dfeEstablishmentId?: InputMaybe<Scalars['uuid']>;
  external_dashboard_url?: InputMaybe<Scalars['String']>;
  geoCoordinates?: InputMaybe<Scalars['point']>;
  go1Licenses?: InputMaybe<Scalars['Int']>;
  go1LicensesHistory?: InputMaybe<Go1_Licenses_History_Arr_Rel_Insert_Input>;
  id?: InputMaybe<Scalars['uuid']>;
  invites?: InputMaybe<Organization_Invites_Arr_Rel_Insert_Input>;
  main_organisation?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  main_organisation_id?: InputMaybe<Scalars['uuid']>;
  members?: InputMaybe<Organization_Member_Arr_Rel_Insert_Input>;
  name?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<Scalars['String']>;
  organisation_logs?: InputMaybe<Organisation_Log_Arr_Rel_Insert_Input>;
  organization_courses?: InputMaybe<Course_Arr_Rel_Insert_Input>;
  organization_dfe_establishment?: InputMaybe<Dfe_Establishment_Obj_Rel_Insert_Input>;
  organization_go1_licenses?: InputMaybe<Go1_Licenses_Arr_Rel_Insert_Input>;
  organization_orders?: InputMaybe<Order_Arr_Rel_Insert_Input>;
  organization_resource_packs?: InputMaybe<Organization_Resource_Packs_Arr_Rel_Insert_Input>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  region?: InputMaybe<Scalars['String']>;
  reservedGo1Licenses?: InputMaybe<Scalars['Int']>;
  sector?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  tt_connect_id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  urn?: InputMaybe<Scalars['String']>;
  xeroContactId?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "organization_invites" */
export type Organization_Invites = {
  __typename?: 'organization_invites';
  createdAt: Scalars['timestamptz'];
  email: Scalars['String'];
  id: Scalars['uuid'];
  isAdmin: Scalars['Boolean'];
  orgId: Scalars['uuid'];
  /** An object relationship */
  organization: Organization;
  /** An object relationship */
  profile?: Maybe<Profile>;
  profileId?: Maybe<Scalars['uuid']>;
  status: Scalars['String'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "organization_invites" */
export type Organization_Invites_Aggregate = {
  __typename?: 'organization_invites_aggregate';
  aggregate?: Maybe<Organization_Invites_Aggregate_Fields>;
  nodes: Array<Organization_Invites>;
};

export type Organization_Invites_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Invites_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Invites_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Invites_Aggregate_Bool_Exp_Count>;
};

export type Organization_Invites_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Invites_Select_Column_Organization_Invites_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Invites_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Invites_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Invites_Select_Column_Organization_Invites_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Invites_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Invites_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Invites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Invites_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_invites" */
export type Organization_Invites_Aggregate_Fields = {
  __typename?: 'organization_invites_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organization_Invites_Max_Fields>;
  min?: Maybe<Organization_Invites_Min_Fields>;
};


/** aggregate fields of "organization_invites" */
export type Organization_Invites_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Invites_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organization_invites" */
export type Organization_Invites_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Invites_Max_Order_By>;
  min?: InputMaybe<Organization_Invites_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_invites" */
export type Organization_Invites_Arr_Rel_Insert_Input = {
  data: Array<Organization_Invites_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Invites_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_invites". All fields are combined with a logical 'AND'. */
export type Organization_Invites_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Invites_Bool_Exp>>;
  _not?: InputMaybe<Organization_Invites_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Invites_Bool_Exp>>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isAdmin?: InputMaybe<Boolean_Comparison_Exp>;
  orgId?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profileId?: InputMaybe<Uuid_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_invites" */
export enum Organization_Invites_Constraint {
  /** unique or primary key constraint on columns "email", "org_id" */
  OrganizationInvitesOrgIdEmailKey = 'organization_invites_org_id_email_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationInvitesPkey = 'organization_invites_pkey'
}

/** input type for inserting data into table "organization_invites" */
export type Organization_Invites_Insert_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  orgId?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profileId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Organization_Invites_Max_Fields = {
  __typename?: 'organization_invites_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  orgId?: Maybe<Scalars['uuid']>;
  profileId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "organization_invites" */
export type Organization_Invites_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Invites_Min_Fields = {
  __typename?: 'organization_invites_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  orgId?: Maybe<Scalars['uuid']>;
  profileId?: Maybe<Scalars['uuid']>;
  status?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "organization_invites" */
export type Organization_Invites_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_invites" */
export type Organization_Invites_Mutation_Response = {
  __typename?: 'organization_invites_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Invites>;
};

/** on_conflict condition type for table "organization_invites" */
export type Organization_Invites_On_Conflict = {
  constraint: Organization_Invites_Constraint;
  update_columns?: Array<Organization_Invites_Update_Column>;
  where?: InputMaybe<Organization_Invites_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_invites". */
export type Organization_Invites_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isAdmin?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profileId?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_invites */
export type Organization_Invites_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "organization_invites" */
export enum Organization_Invites_Select_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "organization_invites_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_invites" */
export enum Organization_Invites_Select_Column_Organization_Invites_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAdmin = 'isAdmin'
}

/** select "organization_invites_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_invites" */
export enum Organization_Invites_Select_Column_Organization_Invites_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAdmin = 'isAdmin'
}

/** input type for updating data in table "organization_invites" */
export type Organization_Invites_Set_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  orgId?: InputMaybe<Scalars['uuid']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "organization_invites" */
export type Organization_Invites_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Invites_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Invites_Stream_Cursor_Value_Input = {
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  orgId?: InputMaybe<Scalars['uuid']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  status?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "organization_invites" */
export enum Organization_Invites_Update_Column {
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  Status = 'status',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Organization_Invites_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Invites_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Invites_Bool_Exp;
};

/** aggregate max on columns */
export type Organization_Max_Fields = {
  __typename?: 'organization_max_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  dfeEstablishmentId?: Maybe<Scalars['uuid']>;
  external_dashboard_url?: Maybe<Scalars['String']>;
  go1Licenses?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  main_organisation_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organisationType?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  searchable?: Maybe<Scalars['String']>;
  searchable_postcode?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  tt_connect_id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  urn?: Maybe<Scalars['String']>;
  xeroContactId?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "organization" */
export type Organization_Max_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  dfeEstablishmentId?: InputMaybe<Order_By>;
  external_dashboard_url?: InputMaybe<Order_By>;
  go1Licenses?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  main_organisation_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisationType?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  reservedGo1Licenses?: InputMaybe<Order_By>;
  searchable?: InputMaybe<Order_By>;
  searchable_postcode?: InputMaybe<Order_By>;
  sector?: InputMaybe<Order_By>;
  tt_connect_id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  urn?: InputMaybe<Order_By>;
  xeroContactId?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization_member" */
export type Organization_Member = {
  __typename?: 'organization_member';
  _source?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  id: Scalars['uuid'];
  isAdmin?: Maybe<Scalars['Boolean']>;
  memberType?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid'];
  position?: Maybe<Scalars['String']>;
  /** An object relationship */
  profile: Profile;
  profile_id: Scalars['uuid'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "organization_member" */
export type Organization_Member_Aggregate = {
  __typename?: 'organization_member_aggregate';
  aggregate?: Maybe<Organization_Member_Aggregate_Fields>;
  nodes: Array<Organization_Member>;
};

export type Organization_Member_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Organization_Member_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Organization_Member_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Organization_Member_Aggregate_Bool_Exp_Count>;
};

export type Organization_Member_Aggregate_Bool_Exp_Bool_And = {
  arguments: Organization_Member_Select_Column_Organization_Member_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Member_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Member_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Organization_Member_Select_Column_Organization_Member_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Member_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Organization_Member_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Member_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_member" */
export type Organization_Member_Aggregate_Fields = {
  __typename?: 'organization_member_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organization_Member_Max_Fields>;
  min?: Maybe<Organization_Member_Min_Fields>;
};


/** aggregate fields of "organization_member" */
export type Organization_Member_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Member_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organization_member" */
export type Organization_Member_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Member_Max_Order_By>;
  min?: InputMaybe<Organization_Member_Min_Order_By>;
};

/** input type for inserting array relation for remote table "organization_member" */
export type Organization_Member_Arr_Rel_Insert_Input = {
  data: Array<Organization_Member_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Member_On_Conflict>;
};

/** Boolean expression to filter rows from the table "organization_member". All fields are combined with a logical 'AND'. */
export type Organization_Member_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Member_Bool_Exp>>;
  _not?: InputMaybe<Organization_Member_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Member_Bool_Exp>>;
  _source?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  isAdmin?: InputMaybe<Boolean_Comparison_Exp>;
  memberType?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
  position?: InputMaybe<String_Comparison_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_member" */
export enum Organization_Member_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationMemberPkey = 'organization_member_pkey',
  /** unique or primary key constraint on columns "organization_id", "profile_id" */
  OrganizationMemberProfileIdOrganizationIdKey = 'organization_member_profile_id_organization_id_key'
}

/** input type for inserting data into table "organization_member" */
export type Organization_Member_Insert_Input = {
  _source?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  memberType?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  position?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Organization_Member_Max_Fields = {
  __typename?: 'organization_member_max_fields';
  _source?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  memberType?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  position?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "organization_member" */
export type Organization_Member_Max_Order_By = {
  _source?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  memberType?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Member_Min_Fields = {
  __typename?: 'organization_member_min_fields';
  _source?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  memberType?: Maybe<Scalars['String']>;
  organization_id?: Maybe<Scalars['uuid']>;
  position?: Maybe<Scalars['String']>;
  profile_id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "organization_member" */
export type Organization_Member_Min_Order_By = {
  _source?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  memberType?: InputMaybe<Order_By>;
  organization_id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_member" */
export type Organization_Member_Mutation_Response = {
  __typename?: 'organization_member_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Member>;
};

/** on_conflict condition type for table "organization_member" */
export type Organization_Member_On_Conflict = {
  constraint: Organization_Member_Constraint;
  update_columns?: Array<Organization_Member_Update_Column>;
  where?: InputMaybe<Organization_Member_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_member". */
export type Organization_Member_Order_By = {
  _source?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  isAdmin?: InputMaybe<Order_By>;
  memberType?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
  position?: InputMaybe<Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_member */
export type Organization_Member_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "organization_member" */
export enum Organization_Member_Select_Column {
  /** column name */
  Source = '_source',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  MemberType = 'memberType',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Position = 'position',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** select "organization_member_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization_member" */
export enum Organization_Member_Select_Column_Organization_Member_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  IsAdmin = 'isAdmin'
}

/** select "organization_member_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization_member" */
export enum Organization_Member_Select_Column_Organization_Member_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  IsAdmin = 'isAdmin'
}

/** input type for updating data in table "organization_member" */
export type Organization_Member_Set_Input = {
  _source?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  memberType?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  position?: InputMaybe<Scalars['String']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "organization_member" */
export type Organization_Member_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Member_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Member_Stream_Cursor_Value_Input = {
  _source?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  isAdmin?: InputMaybe<Scalars['Boolean']>;
  memberType?: InputMaybe<Scalars['String']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
  position?: InputMaybe<Scalars['String']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "organization_member" */
export enum Organization_Member_Update_Column {
  /** column name */
  Source = '_source',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Id = 'id',
  /** column name */
  IsAdmin = 'isAdmin',
  /** column name */
  MemberType = 'memberType',
  /** column name */
  OrganizationId = 'organization_id',
  /** column name */
  Position = 'position',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Organization_Member_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Member_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Member_Bool_Exp;
};

/** aggregate min on columns */
export type Organization_Min_Fields = {
  __typename?: 'organization_min_fields';
  createdAt?: Maybe<Scalars['timestamptz']>;
  dfeEstablishmentId?: Maybe<Scalars['uuid']>;
  external_dashboard_url?: Maybe<Scalars['String']>;
  go1Licenses?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  main_organisation_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  organisationType?: Maybe<Scalars['String']>;
  region?: Maybe<Scalars['String']>;
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
  searchable?: Maybe<Scalars['String']>;
  searchable_postcode?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  tt_connect_id?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  urn?: Maybe<Scalars['String']>;
  xeroContactId?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "organization" */
export type Organization_Min_Order_By = {
  createdAt?: InputMaybe<Order_By>;
  dfeEstablishmentId?: InputMaybe<Order_By>;
  external_dashboard_url?: InputMaybe<Order_By>;
  go1Licenses?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  main_organisation_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  organisationType?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  reservedGo1Licenses?: InputMaybe<Order_By>;
  searchable?: InputMaybe<Order_By>;
  searchable_postcode?: InputMaybe<Order_By>;
  sector?: InputMaybe<Order_By>;
  tt_connect_id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  urn?: InputMaybe<Order_By>;
  xeroContactId?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization" */
export type Organization_Mutation_Response = {
  __typename?: 'organization_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization>;
};

/** input type for inserting object relation for remote table "organization" */
export type Organization_Obj_Rel_Insert_Input = {
  data: Organization_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_On_Conflict>;
};

/** on_conflict condition type for table "organization" */
export type Organization_On_Conflict = {
  constraint: Organization_Constraint;
  update_columns?: Array<Organization_Update_Column>;
  where?: InputMaybe<Organization_Bool_Exp>;
};

/** Ordering options when selecting data from "organization". */
export type Organization_Order_By = {
  address?: InputMaybe<Order_By>;
  affiliated_organisations_aggregate?: InputMaybe<Organization_Aggregate_Order_By>;
  attributes?: InputMaybe<Order_By>;
  canAccessKnowledgeHub?: InputMaybe<Order_By>;
  contactDetails?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dfeEstablishmentId?: InputMaybe<Order_By>;
  external_dashboard_url?: InputMaybe<Order_By>;
  geoCoordinates?: InputMaybe<Order_By>;
  go1Licenses?: InputMaybe<Order_By>;
  go1LicensesHistory_aggregate?: InputMaybe<Go1_Licenses_History_Aggregate_Order_By>;
  id?: InputMaybe<Order_By>;
  invites_aggregate?: InputMaybe<Organization_Invites_Aggregate_Order_By>;
  main_organisation?: InputMaybe<Organization_Order_By>;
  main_organisation_id?: InputMaybe<Order_By>;
  members_aggregate?: InputMaybe<Organization_Member_Aggregate_Order_By>;
  name?: InputMaybe<Order_By>;
  organisationType?: InputMaybe<Order_By>;
  organisation_logs_aggregate?: InputMaybe<Organisation_Log_Aggregate_Order_By>;
  organization_courses_aggregate?: InputMaybe<Course_Aggregate_Order_By>;
  organization_dfe_establishment?: InputMaybe<Dfe_Establishment_Order_By>;
  organization_go1_licenses_aggregate?: InputMaybe<Go1_Licenses_Aggregate_Order_By>;
  organization_orders_aggregate?: InputMaybe<Order_Aggregate_Order_By>;
  organization_resource_packs_aggregate?: InputMaybe<Organization_Resource_Packs_Aggregate_Order_By>;
  original_record?: InputMaybe<Order_By>;
  preferences?: InputMaybe<Order_By>;
  region?: InputMaybe<Order_By>;
  reservedGo1Licenses?: InputMaybe<Order_By>;
  searchable?: InputMaybe<Order_By>;
  searchable_postcode?: InputMaybe<Order_By>;
  sector?: InputMaybe<Order_By>;
  tags?: InputMaybe<Order_By>;
  tt_connect_id?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  urn?: InputMaybe<Order_By>;
  xeroContactId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization */
export type Organization_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Organization_Prepend_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  contactDetails?: InputMaybe<Scalars['jsonb']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "organization_resource_packs" */
export type Organization_Resource_Packs = {
  __typename?: 'organization_resource_packs';
  id: Scalars['uuid'];
  levels_applicable?: Maybe<Array<Scalars['String']>>;
  orgId: Scalars['uuid'];
  /** An object relationship */
  organization: Organization;
  reservedResourcePacks: Scalars['Int'];
  resourcePacksType: Resource_Packs_Type_Enum;
  totalResourcePacks: Scalars['Int'];
  updatedAt: Scalars['timestamptz'];
};

/** aggregated selection of "organization_resource_packs" */
export type Organization_Resource_Packs_Aggregate = {
  __typename?: 'organization_resource_packs_aggregate';
  aggregate?: Maybe<Organization_Resource_Packs_Aggregate_Fields>;
  nodes: Array<Organization_Resource_Packs>;
};

export type Organization_Resource_Packs_Aggregate_Bool_Exp = {
  count?: InputMaybe<Organization_Resource_Packs_Aggregate_Bool_Exp_Count>;
};

export type Organization_Resource_Packs_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Organization_Resource_Packs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Organization_Resource_Packs_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "organization_resource_packs" */
export type Organization_Resource_Packs_Aggregate_Fields = {
  __typename?: 'organization_resource_packs_aggregate_fields';
  avg?: Maybe<Organization_Resource_Packs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organization_Resource_Packs_Max_Fields>;
  min?: Maybe<Organization_Resource_Packs_Min_Fields>;
  stddev?: Maybe<Organization_Resource_Packs_Stddev_Fields>;
  stddev_pop?: Maybe<Organization_Resource_Packs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organization_Resource_Packs_Stddev_Samp_Fields>;
  sum?: Maybe<Organization_Resource_Packs_Sum_Fields>;
  var_pop?: Maybe<Organization_Resource_Packs_Var_Pop_Fields>;
  var_samp?: Maybe<Organization_Resource_Packs_Var_Samp_Fields>;
  variance?: Maybe<Organization_Resource_Packs_Variance_Fields>;
};


/** aggregate fields of "organization_resource_packs" */
export type Organization_Resource_Packs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Resource_Packs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "organization_resource_packs" */
export type Organization_Resource_Packs_Aggregate_Order_By = {
  avg?: InputMaybe<Organization_Resource_Packs_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Organization_Resource_Packs_Max_Order_By>;
  min?: InputMaybe<Organization_Resource_Packs_Min_Order_By>;
  stddev?: InputMaybe<Organization_Resource_Packs_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Organization_Resource_Packs_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Organization_Resource_Packs_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Organization_Resource_Packs_Sum_Order_By>;
  var_pop?: InputMaybe<Organization_Resource_Packs_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Organization_Resource_Packs_Var_Samp_Order_By>;
  variance?: InputMaybe<Organization_Resource_Packs_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "organization_resource_packs" */
export type Organization_Resource_Packs_Arr_Rel_Insert_Input = {
  data: Array<Organization_Resource_Packs_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Organization_Resource_Packs_On_Conflict>;
};

/** aggregate avg on columns */
export type Organization_Resource_Packs_Avg_Fields = {
  __typename?: 'organization_resource_packs_avg_fields';
  reservedResourcePacks?: Maybe<Scalars['Float']>;
  totalResourcePacks?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "organization_resource_packs" */
export type Organization_Resource_Packs_Avg_Order_By = {
  reservedResourcePacks?: InputMaybe<Order_By>;
  totalResourcePacks?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "organization_resource_packs". All fields are combined with a logical 'AND'. */
export type Organization_Resource_Packs_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Resource_Packs_Bool_Exp>>;
  _not?: InputMaybe<Organization_Resource_Packs_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Resource_Packs_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  levels_applicable?: InputMaybe<String_Array_Comparison_Exp>;
  orgId?: InputMaybe<Uuid_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  reservedResourcePacks?: InputMaybe<Int_Comparison_Exp>;
  resourcePacksType?: InputMaybe<Resource_Packs_Type_Enum_Comparison_Exp>;
  totalResourcePacks?: InputMaybe<Int_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_resource_packs" */
export enum Organization_Resource_Packs_Constraint {
  /** unique or primary key constraint on columns "resource_packs_type", "org_id" */
  OrganizationResourcePacksOrgIdResourcePacksTypeKey = 'organization_resource_packs_org_id_resource_packs_type_key',
  /** unique or primary key constraint on columns "id" */
  OrganizationResourcePacksPkey = 'organization_resource_packs_pkey'
}

/** input type for incrementing numeric columns in table "organization_resource_packs" */
export type Organization_Resource_Packs_Inc_Input = {
  reservedResourcePacks?: InputMaybe<Scalars['Int']>;
  totalResourcePacks?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organization_resource_packs" */
export type Organization_Resource_Packs_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  levels_applicable?: InputMaybe<Array<Scalars['String']>>;
  orgId?: InputMaybe<Scalars['uuid']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  reservedResourcePacks?: InputMaybe<Scalars['Int']>;
  resourcePacksType?: InputMaybe<Resource_Packs_Type_Enum>;
  totalResourcePacks?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Organization_Resource_Packs_Max_Fields = {
  __typename?: 'organization_resource_packs_max_fields';
  id?: Maybe<Scalars['uuid']>;
  levels_applicable?: Maybe<Array<Scalars['String']>>;
  orgId?: Maybe<Scalars['uuid']>;
  reservedResourcePacks?: Maybe<Scalars['Int']>;
  totalResourcePacks?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "organization_resource_packs" */
export type Organization_Resource_Packs_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  levels_applicable?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  reservedResourcePacks?: InputMaybe<Order_By>;
  totalResourcePacks?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Organization_Resource_Packs_Min_Fields = {
  __typename?: 'organization_resource_packs_min_fields';
  id?: Maybe<Scalars['uuid']>;
  levels_applicable?: Maybe<Array<Scalars['String']>>;
  orgId?: Maybe<Scalars['uuid']>;
  reservedResourcePacks?: Maybe<Scalars['Int']>;
  totalResourcePacks?: Maybe<Scalars['Int']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "organization_resource_packs" */
export type Organization_Resource_Packs_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  levels_applicable?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  reservedResourcePacks?: InputMaybe<Order_By>;
  totalResourcePacks?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "organization_resource_packs" */
export type Organization_Resource_Packs_Mutation_Response = {
  __typename?: 'organization_resource_packs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Resource_Packs>;
};

/** on_conflict condition type for table "organization_resource_packs" */
export type Organization_Resource_Packs_On_Conflict = {
  constraint: Organization_Resource_Packs_Constraint;
  update_columns?: Array<Organization_Resource_Packs_Update_Column>;
  where?: InputMaybe<Organization_Resource_Packs_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_resource_packs". */
export type Organization_Resource_Packs_Order_By = {
  id?: InputMaybe<Order_By>;
  levels_applicable?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  reservedResourcePacks?: InputMaybe<Order_By>;
  resourcePacksType?: InputMaybe<Order_By>;
  totalResourcePacks?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_resource_packs */
export type Organization_Resource_Packs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "organization_resource_packs" */
export enum Organization_Resource_Packs_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LevelsApplicable = 'levels_applicable',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  ReservedResourcePacks = 'reservedResourcePacks',
  /** column name */
  ResourcePacksType = 'resourcePacksType',
  /** column name */
  TotalResourcePacks = 'totalResourcePacks',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "organization_resource_packs" */
export type Organization_Resource_Packs_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  levels_applicable?: InputMaybe<Array<Scalars['String']>>;
  orgId?: InputMaybe<Scalars['uuid']>;
  reservedResourcePacks?: InputMaybe<Scalars['Int']>;
  resourcePacksType?: InputMaybe<Resource_Packs_Type_Enum>;
  totalResourcePacks?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Organization_Resource_Packs_Stddev_Fields = {
  __typename?: 'organization_resource_packs_stddev_fields';
  reservedResourcePacks?: Maybe<Scalars['Float']>;
  totalResourcePacks?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "organization_resource_packs" */
export type Organization_Resource_Packs_Stddev_Order_By = {
  reservedResourcePacks?: InputMaybe<Order_By>;
  totalResourcePacks?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Resource_Packs_Stddev_Pop_Fields = {
  __typename?: 'organization_resource_packs_stddev_pop_fields';
  reservedResourcePacks?: Maybe<Scalars['Float']>;
  totalResourcePacks?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "organization_resource_packs" */
export type Organization_Resource_Packs_Stddev_Pop_Order_By = {
  reservedResourcePacks?: InputMaybe<Order_By>;
  totalResourcePacks?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Resource_Packs_Stddev_Samp_Fields = {
  __typename?: 'organization_resource_packs_stddev_samp_fields';
  reservedResourcePacks?: Maybe<Scalars['Float']>;
  totalResourcePacks?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "organization_resource_packs" */
export type Organization_Resource_Packs_Stddev_Samp_Order_By = {
  reservedResourcePacks?: InputMaybe<Order_By>;
  totalResourcePacks?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization_resource_packs" */
export type Organization_Resource_Packs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Resource_Packs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Resource_Packs_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  levels_applicable?: InputMaybe<Array<Scalars['String']>>;
  orgId?: InputMaybe<Scalars['uuid']>;
  reservedResourcePacks?: InputMaybe<Scalars['Int']>;
  resourcePacksType?: InputMaybe<Resource_Packs_Type_Enum>;
  totalResourcePacks?: InputMaybe<Scalars['Int']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Organization_Resource_Packs_Sum_Fields = {
  __typename?: 'organization_resource_packs_sum_fields';
  reservedResourcePacks?: Maybe<Scalars['Int']>;
  totalResourcePacks?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "organization_resource_packs" */
export type Organization_Resource_Packs_Sum_Order_By = {
  reservedResourcePacks?: InputMaybe<Order_By>;
  totalResourcePacks?: InputMaybe<Order_By>;
};

/** update columns of table "organization_resource_packs" */
export enum Organization_Resource_Packs_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  LevelsApplicable = 'levels_applicable',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  ReservedResourcePacks = 'reservedResourcePacks',
  /** column name */
  ResourcePacksType = 'resourcePacksType',
  /** column name */
  TotalResourcePacks = 'totalResourcePacks',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Organization_Resource_Packs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Resource_Packs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Resource_Packs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Resource_Packs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Resource_Packs_Var_Pop_Fields = {
  __typename?: 'organization_resource_packs_var_pop_fields';
  reservedResourcePacks?: Maybe<Scalars['Float']>;
  totalResourcePacks?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "organization_resource_packs" */
export type Organization_Resource_Packs_Var_Pop_Order_By = {
  reservedResourcePacks?: InputMaybe<Order_By>;
  totalResourcePacks?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Resource_Packs_Var_Samp_Fields = {
  __typename?: 'organization_resource_packs_var_samp_fields';
  reservedResourcePacks?: Maybe<Scalars['Float']>;
  totalResourcePacks?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "organization_resource_packs" */
export type Organization_Resource_Packs_Var_Samp_Order_By = {
  reservedResourcePacks?: InputMaybe<Order_By>;
  totalResourcePacks?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Resource_Packs_Variance_Fields = {
  __typename?: 'organization_resource_packs_variance_fields';
  reservedResourcePacks?: Maybe<Scalars['Float']>;
  totalResourcePacks?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "organization_resource_packs" */
export type Organization_Resource_Packs_Variance_Order_By = {
  reservedResourcePacks?: InputMaybe<Order_By>;
  totalResourcePacks?: InputMaybe<Order_By>;
};

/** select columns of table "organization" */
export enum Organization_Select_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Attributes = 'attributes',
  /** column name */
  CanAccessKnowledgeHub = 'canAccessKnowledgeHub',
  /** column name */
  ContactDetails = 'contactDetails',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DfeEstablishmentId = 'dfeEstablishmentId',
  /** column name */
  ExternalDashboardUrl = 'external_dashboard_url',
  /** column name */
  GeoCoordinates = 'geoCoordinates',
  /** column name */
  Go1Licenses = 'go1Licenses',
  /** column name */
  Id = 'id',
  /** column name */
  MainOrganisationId = 'main_organisation_id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationType = 'organisationType',
  /** column name */
  OriginalRecord = 'original_record',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  Region = 'region',
  /** column name */
  ReservedGo1Licenses = 'reservedGo1Licenses',
  /** column name */
  Searchable = 'searchable',
  /** column name */
  SearchablePostcode = 'searchable_postcode',
  /** column name */
  Sector = 'sector',
  /** column name */
  Tags = 'tags',
  /** column name */
  TtConnectId = 'tt_connect_id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Urn = 'urn',
  /** column name */
  XeroContactId = 'xeroContactId'
}

/** select "organization_aggregate_bool_exp_bool_and_arguments_columns" columns of table "organization" */
export enum Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  CanAccessKnowledgeHub = 'canAccessKnowledgeHub'
}

/** select "organization_aggregate_bool_exp_bool_or_arguments_columns" columns of table "organization" */
export enum Organization_Select_Column_Organization_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  CanAccessKnowledgeHub = 'canAccessKnowledgeHub'
}

/** input type for updating data in table "organization" */
export type Organization_Set_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  canAccessKnowledgeHub?: InputMaybe<Scalars['Boolean']>;
  contactDetails?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dfeEstablishmentId?: InputMaybe<Scalars['uuid']>;
  external_dashboard_url?: InputMaybe<Scalars['String']>;
  geoCoordinates?: InputMaybe<Scalars['point']>;
  go1Licenses?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  main_organisation_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<Scalars['String']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  region?: InputMaybe<Scalars['String']>;
  reservedGo1Licenses?: InputMaybe<Scalars['Int']>;
  sector?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  tt_connect_id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  urn?: InputMaybe<Scalars['String']>;
  xeroContactId?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Organization_Stddev_Fields = {
  __typename?: 'organization_stddev_fields';
  go1Licenses?: Maybe<Scalars['Float']>;
  reservedGo1Licenses?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "organization" */
export type Organization_Stddev_Order_By = {
  go1Licenses?: InputMaybe<Order_By>;
  reservedGo1Licenses?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Organization_Stddev_Pop_Fields = {
  __typename?: 'organization_stddev_pop_fields';
  go1Licenses?: Maybe<Scalars['Float']>;
  reservedGo1Licenses?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "organization" */
export type Organization_Stddev_Pop_Order_By = {
  go1Licenses?: InputMaybe<Order_By>;
  reservedGo1Licenses?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Organization_Stddev_Samp_Fields = {
  __typename?: 'organization_stddev_samp_fields';
  go1Licenses?: Maybe<Scalars['Float']>;
  reservedGo1Licenses?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "organization" */
export type Organization_Stddev_Samp_Order_By = {
  go1Licenses?: InputMaybe<Order_By>;
  reservedGo1Licenses?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "organization" */
export type Organization_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Stream_Cursor_Value_Input = {
  address?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  canAccessKnowledgeHub?: InputMaybe<Scalars['Boolean']>;
  contactDetails?: InputMaybe<Scalars['jsonb']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dfeEstablishmentId?: InputMaybe<Scalars['uuid']>;
  external_dashboard_url?: InputMaybe<Scalars['String']>;
  geoCoordinates?: InputMaybe<Scalars['point']>;
  go1Licenses?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  main_organisation_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  organisationType?: InputMaybe<Scalars['String']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  region?: InputMaybe<Scalars['String']>;
  reservedGo1Licenses?: InputMaybe<Scalars['Int']>;
  searchable?: InputMaybe<Scalars['String']>;
  searchable_postcode?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  tt_connect_id?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  urn?: InputMaybe<Scalars['String']>;
  xeroContactId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Organization_Sum_Fields = {
  __typename?: 'organization_sum_fields';
  go1Licenses?: Maybe<Scalars['Int']>;
  reservedGo1Licenses?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "organization" */
export type Organization_Sum_Order_By = {
  go1Licenses?: InputMaybe<Order_By>;
  reservedGo1Licenses?: InputMaybe<Order_By>;
};

/** columns and relationships of "organization_type" */
export type Organization_Type = {
  __typename?: 'organization_type';
  id: Scalars['uuid'];
  name: Scalars['String'];
  nonUK: Scalars['Boolean'];
  /** An object relationship */
  organisation_sector: Organisation_Sector;
  sector: Organisation_Sector_Enum;
};

/** aggregated selection of "organization_type" */
export type Organization_Type_Aggregate = {
  __typename?: 'organization_type_aggregate';
  aggregate?: Maybe<Organization_Type_Aggregate_Fields>;
  nodes: Array<Organization_Type>;
};

/** aggregate fields of "organization_type" */
export type Organization_Type_Aggregate_Fields = {
  __typename?: 'organization_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Organization_Type_Max_Fields>;
  min?: Maybe<Organization_Type_Min_Fields>;
};


/** aggregate fields of "organization_type" */
export type Organization_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organization_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "organization_type". All fields are combined with a logical 'AND'. */
export type Organization_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Organization_Type_Bool_Exp>>;
  _not?: InputMaybe<Organization_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Organization_Type_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  nonUK?: InputMaybe<Boolean_Comparison_Exp>;
  organisation_sector?: InputMaybe<Organisation_Sector_Bool_Exp>;
  sector?: InputMaybe<Organisation_Sector_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "organization_type" */
export enum Organization_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationTypePkey = 'organization_type_pkey'
}

/** input type for inserting data into table "organization_type" */
export type Organization_Type_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  nonUK?: InputMaybe<Scalars['Boolean']>;
  organisation_sector?: InputMaybe<Organisation_Sector_Obj_Rel_Insert_Input>;
  sector?: InputMaybe<Organisation_Sector_Enum>;
};

/** aggregate max on columns */
export type Organization_Type_Max_Fields = {
  __typename?: 'organization_type_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Organization_Type_Min_Fields = {
  __typename?: 'organization_type_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "organization_type" */
export type Organization_Type_Mutation_Response = {
  __typename?: 'organization_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organization_Type>;
};

/** on_conflict condition type for table "organization_type" */
export type Organization_Type_On_Conflict = {
  constraint: Organization_Type_Constraint;
  update_columns?: Array<Organization_Type_Update_Column>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "organization_type". */
export type Organization_Type_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  nonUK?: InputMaybe<Order_By>;
  organisation_sector?: InputMaybe<Organisation_Sector_Order_By>;
  sector?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organization_type */
export type Organization_Type_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "organization_type" */
export enum Organization_Type_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NonUk = 'nonUK',
  /** column name */
  Sector = 'sector'
}

/** input type for updating data in table "organization_type" */
export type Organization_Type_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  nonUK?: InputMaybe<Scalars['Boolean']>;
  sector?: InputMaybe<Organisation_Sector_Enum>;
};

/** Streaming cursor of the table "organization_type" */
export type Organization_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organization_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organization_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  nonUK?: InputMaybe<Scalars['Boolean']>;
  sector?: InputMaybe<Organisation_Sector_Enum>;
};

/** update columns of table "organization_type" */
export enum Organization_Type_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  NonUk = 'nonUK',
  /** column name */
  Sector = 'sector'
}

export type Organization_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Type_Bool_Exp;
};

/** update columns of table "organization" */
export enum Organization_Update_Column {
  /** column name */
  Address = 'address',
  /** column name */
  Attributes = 'attributes',
  /** column name */
  CanAccessKnowledgeHub = 'canAccessKnowledgeHub',
  /** column name */
  ContactDetails = 'contactDetails',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DfeEstablishmentId = 'dfeEstablishmentId',
  /** column name */
  ExternalDashboardUrl = 'external_dashboard_url',
  /** column name */
  GeoCoordinates = 'geoCoordinates',
  /** column name */
  Go1Licenses = 'go1Licenses',
  /** column name */
  Id = 'id',
  /** column name */
  MainOrganisationId = 'main_organisation_id',
  /** column name */
  Name = 'name',
  /** column name */
  OrganisationType = 'organisationType',
  /** column name */
  OriginalRecord = 'original_record',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  Region = 'region',
  /** column name */
  ReservedGo1Licenses = 'reservedGo1Licenses',
  /** column name */
  Sector = 'sector',
  /** column name */
  Tags = 'tags',
  /** column name */
  TtConnectId = 'tt_connect_id',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  Urn = 'urn',
  /** column name */
  XeroContactId = 'xeroContactId'
}

export type Organization_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Organization_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Organization_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Organization_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Organization_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organization_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Organization_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organization_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organization_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organization_Var_Pop_Fields = {
  __typename?: 'organization_var_pop_fields';
  go1Licenses?: Maybe<Scalars['Float']>;
  reservedGo1Licenses?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "organization" */
export type Organization_Var_Pop_Order_By = {
  go1Licenses?: InputMaybe<Order_By>;
  reservedGo1Licenses?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Organization_Var_Samp_Fields = {
  __typename?: 'organization_var_samp_fields';
  go1Licenses?: Maybe<Scalars['Float']>;
  reservedGo1Licenses?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "organization" */
export type Organization_Var_Samp_Order_By = {
  go1Licenses?: InputMaybe<Order_By>;
  reservedGo1Licenses?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Organization_Variance_Fields = {
  __typename?: 'organization_variance_fields';
  go1Licenses?: Maybe<Scalars['Float']>;
  reservedGo1Licenses?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "organization" */
export type Organization_Variance_Order_By = {
  go1Licenses?: InputMaybe<Order_By>;
  reservedGo1Licenses?: InputMaybe<Order_By>;
};

/** columns and relationships of "organizations_statistics" */
export type Organizations_Statistics = {
  __typename?: 'organizations_statistics';
  active_certifications: Scalars['Int'];
  expired_recently_certifications: Scalars['Int'];
  expiring_soon_certifications: Scalars['Int'];
  id: Scalars['uuid'];
  individuals: Scalars['Int'];
  on_hold_certifications: Scalars['Int'];
  /** An object relationship */
  organization: Organization;
  organization_id: Scalars['uuid'];
};

/** aggregated selection of "organizations_statistics" */
export type Organizations_Statistics_Aggregate = {
  __typename?: 'organizations_statistics_aggregate';
  aggregate?: Maybe<Organizations_Statistics_Aggregate_Fields>;
  nodes: Array<Organizations_Statistics>;
};

/** aggregate fields of "organizations_statistics" */
export type Organizations_Statistics_Aggregate_Fields = {
  __typename?: 'organizations_statistics_aggregate_fields';
  avg?: Maybe<Organizations_Statistics_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Organizations_Statistics_Max_Fields>;
  min?: Maybe<Organizations_Statistics_Min_Fields>;
  stddev?: Maybe<Organizations_Statistics_Stddev_Fields>;
  stddev_pop?: Maybe<Organizations_Statistics_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Organizations_Statistics_Stddev_Samp_Fields>;
  sum?: Maybe<Organizations_Statistics_Sum_Fields>;
  var_pop?: Maybe<Organizations_Statistics_Var_Pop_Fields>;
  var_samp?: Maybe<Organizations_Statistics_Var_Samp_Fields>;
  variance?: Maybe<Organizations_Statistics_Variance_Fields>;
};


/** aggregate fields of "organizations_statistics" */
export type Organizations_Statistics_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Organizations_Statistics_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Organizations_Statistics_Avg_Fields = {
  __typename?: 'organizations_statistics_avg_fields';
  active_certifications?: Maybe<Scalars['Float']>;
  expired_recently_certifications?: Maybe<Scalars['Float']>;
  expiring_soon_certifications?: Maybe<Scalars['Float']>;
  individuals?: Maybe<Scalars['Float']>;
  on_hold_certifications?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "organizations_statistics". All fields are combined with a logical 'AND'. */
export type Organizations_Statistics_Bool_Exp = {
  _and?: InputMaybe<Array<Organizations_Statistics_Bool_Exp>>;
  _not?: InputMaybe<Organizations_Statistics_Bool_Exp>;
  _or?: InputMaybe<Array<Organizations_Statistics_Bool_Exp>>;
  active_certifications?: InputMaybe<Int_Comparison_Exp>;
  expired_recently_certifications?: InputMaybe<Int_Comparison_Exp>;
  expiring_soon_certifications?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  individuals?: InputMaybe<Int_Comparison_Exp>;
  on_hold_certifications?: InputMaybe<Int_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  organization_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "organizations_statistics" */
export enum Organizations_Statistics_Constraint {
  /** unique or primary key constraint on columns "id" */
  OrganizationsStatisticsPkey = 'organizations_statistics_pkey'
}

/** input type for incrementing numeric columns in table "organizations_statistics" */
export type Organizations_Statistics_Inc_Input = {
  active_certifications?: InputMaybe<Scalars['Int']>;
  expired_recently_certifications?: InputMaybe<Scalars['Int']>;
  expiring_soon_certifications?: InputMaybe<Scalars['Int']>;
  individuals?: InputMaybe<Scalars['Int']>;
  on_hold_certifications?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "organizations_statistics" */
export type Organizations_Statistics_Insert_Input = {
  active_certifications?: InputMaybe<Scalars['Int']>;
  expired_recently_certifications?: InputMaybe<Scalars['Int']>;
  expiring_soon_certifications?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  individuals?: InputMaybe<Scalars['Int']>;
  on_hold_certifications?: InputMaybe<Scalars['Int']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Organizations_Statistics_Max_Fields = {
  __typename?: 'organizations_statistics_max_fields';
  active_certifications?: Maybe<Scalars['Int']>;
  expired_recently_certifications?: Maybe<Scalars['Int']>;
  expiring_soon_certifications?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  individuals?: Maybe<Scalars['Int']>;
  on_hold_certifications?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Organizations_Statistics_Min_Fields = {
  __typename?: 'organizations_statistics_min_fields';
  active_certifications?: Maybe<Scalars['Int']>;
  expired_recently_certifications?: Maybe<Scalars['Int']>;
  expiring_soon_certifications?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  individuals?: Maybe<Scalars['Int']>;
  on_hold_certifications?: Maybe<Scalars['Int']>;
  organization_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "organizations_statistics" */
export type Organizations_Statistics_Mutation_Response = {
  __typename?: 'organizations_statistics_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Organizations_Statistics>;
};

/** on_conflict condition type for table "organizations_statistics" */
export type Organizations_Statistics_On_Conflict = {
  constraint: Organizations_Statistics_Constraint;
  update_columns?: Array<Organizations_Statistics_Update_Column>;
  where?: InputMaybe<Organizations_Statistics_Bool_Exp>;
};

/** Ordering options when selecting data from "organizations_statistics". */
export type Organizations_Statistics_Order_By = {
  active_certifications?: InputMaybe<Order_By>;
  expired_recently_certifications?: InputMaybe<Order_By>;
  expiring_soon_certifications?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  individuals?: InputMaybe<Order_By>;
  on_hold_certifications?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  organization_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: organizations_statistics */
export type Organizations_Statistics_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "organizations_statistics" */
export enum Organizations_Statistics_Select_Column {
  /** column name */
  ActiveCertifications = 'active_certifications',
  /** column name */
  ExpiredRecentlyCertifications = 'expired_recently_certifications',
  /** column name */
  ExpiringSoonCertifications = 'expiring_soon_certifications',
  /** column name */
  Id = 'id',
  /** column name */
  Individuals = 'individuals',
  /** column name */
  OnHoldCertifications = 'on_hold_certifications',
  /** column name */
  OrganizationId = 'organization_id'
}

/** input type for updating data in table "organizations_statistics" */
export type Organizations_Statistics_Set_Input = {
  active_certifications?: InputMaybe<Scalars['Int']>;
  expired_recently_certifications?: InputMaybe<Scalars['Int']>;
  expiring_soon_certifications?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  individuals?: InputMaybe<Scalars['Int']>;
  on_hold_certifications?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Organizations_Statistics_Stddev_Fields = {
  __typename?: 'organizations_statistics_stddev_fields';
  active_certifications?: Maybe<Scalars['Float']>;
  expired_recently_certifications?: Maybe<Scalars['Float']>;
  expiring_soon_certifications?: Maybe<Scalars['Float']>;
  individuals?: Maybe<Scalars['Float']>;
  on_hold_certifications?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Organizations_Statistics_Stddev_Pop_Fields = {
  __typename?: 'organizations_statistics_stddev_pop_fields';
  active_certifications?: Maybe<Scalars['Float']>;
  expired_recently_certifications?: Maybe<Scalars['Float']>;
  expiring_soon_certifications?: Maybe<Scalars['Float']>;
  individuals?: Maybe<Scalars['Float']>;
  on_hold_certifications?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Organizations_Statistics_Stddev_Samp_Fields = {
  __typename?: 'organizations_statistics_stddev_samp_fields';
  active_certifications?: Maybe<Scalars['Float']>;
  expired_recently_certifications?: Maybe<Scalars['Float']>;
  expiring_soon_certifications?: Maybe<Scalars['Float']>;
  individuals?: Maybe<Scalars['Float']>;
  on_hold_certifications?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "organizations_statistics" */
export type Organizations_Statistics_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Organizations_Statistics_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Organizations_Statistics_Stream_Cursor_Value_Input = {
  active_certifications?: InputMaybe<Scalars['Int']>;
  expired_recently_certifications?: InputMaybe<Scalars['Int']>;
  expiring_soon_certifications?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  individuals?: InputMaybe<Scalars['Int']>;
  on_hold_certifications?: InputMaybe<Scalars['Int']>;
  organization_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Organizations_Statistics_Sum_Fields = {
  __typename?: 'organizations_statistics_sum_fields';
  active_certifications?: Maybe<Scalars['Int']>;
  expired_recently_certifications?: Maybe<Scalars['Int']>;
  expiring_soon_certifications?: Maybe<Scalars['Int']>;
  individuals?: Maybe<Scalars['Int']>;
  on_hold_certifications?: Maybe<Scalars['Int']>;
};

/** update columns of table "organizations_statistics" */
export enum Organizations_Statistics_Update_Column {
  /** column name */
  ActiveCertifications = 'active_certifications',
  /** column name */
  ExpiredRecentlyCertifications = 'expired_recently_certifications',
  /** column name */
  ExpiringSoonCertifications = 'expiring_soon_certifications',
  /** column name */
  Id = 'id',
  /** column name */
  Individuals = 'individuals',
  /** column name */
  OnHoldCertifications = 'on_hold_certifications',
  /** column name */
  OrganizationId = 'organization_id'
}

export type Organizations_Statistics_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Organizations_Statistics_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Organizations_Statistics_Set_Input>;
  /** filter the rows which have to be updated */
  where: Organizations_Statistics_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Organizations_Statistics_Var_Pop_Fields = {
  __typename?: 'organizations_statistics_var_pop_fields';
  active_certifications?: Maybe<Scalars['Float']>;
  expired_recently_certifications?: Maybe<Scalars['Float']>;
  expiring_soon_certifications?: Maybe<Scalars['Float']>;
  individuals?: Maybe<Scalars['Float']>;
  on_hold_certifications?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Organizations_Statistics_Var_Samp_Fields = {
  __typename?: 'organizations_statistics_var_samp_fields';
  active_certifications?: Maybe<Scalars['Float']>;
  expired_recently_certifications?: Maybe<Scalars['Float']>;
  expiring_soon_certifications?: Maybe<Scalars['Float']>;
  individuals?: Maybe<Scalars['Float']>;
  on_hold_certifications?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Organizations_Statistics_Variance_Fields = {
  __typename?: 'organizations_statistics_variance_fields';
  active_certifications?: Maybe<Scalars['Float']>;
  expired_recently_certifications?: Maybe<Scalars['Float']>;
  expiring_soon_certifications?: Maybe<Scalars['Float']>;
  individuals?: Maybe<Scalars['Float']>;
  on_hold_certifications?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "payment_methods" */
export type Payment_Methods = {
  __typename?: 'payment_methods';
  name: Scalars['String'];
};

/** aggregated selection of "payment_methods" */
export type Payment_Methods_Aggregate = {
  __typename?: 'payment_methods_aggregate';
  aggregate?: Maybe<Payment_Methods_Aggregate_Fields>;
  nodes: Array<Payment_Methods>;
};

/** aggregate fields of "payment_methods" */
export type Payment_Methods_Aggregate_Fields = {
  __typename?: 'payment_methods_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Payment_Methods_Max_Fields>;
  min?: Maybe<Payment_Methods_Min_Fields>;
};


/** aggregate fields of "payment_methods" */
export type Payment_Methods_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "payment_methods". All fields are combined with a logical 'AND'. */
export type Payment_Methods_Bool_Exp = {
  _and?: InputMaybe<Array<Payment_Methods_Bool_Exp>>;
  _not?: InputMaybe<Payment_Methods_Bool_Exp>;
  _or?: InputMaybe<Array<Payment_Methods_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "payment_methods" */
export enum Payment_Methods_Constraint {
  /** unique or primary key constraint on columns "name" */
  PaymentMethodsPkey = 'payment_methods_pkey'
}

export enum Payment_Methods_Enum {
  Cc = 'CC',
  Invoice = 'INVOICE'
}

/** Boolean expression to compare columns of type "payment_methods_enum". All fields are combined with logical 'AND'. */
export type Payment_Methods_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Payment_Methods_Enum>;
  _in?: InputMaybe<Array<Payment_Methods_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Payment_Methods_Enum>;
  _nin?: InputMaybe<Array<Payment_Methods_Enum>>;
};

/** input type for inserting data into table "payment_methods" */
export type Payment_Methods_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Payment_Methods_Max_Fields = {
  __typename?: 'payment_methods_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Payment_Methods_Min_Fields = {
  __typename?: 'payment_methods_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "payment_methods" */
export type Payment_Methods_Mutation_Response = {
  __typename?: 'payment_methods_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Payment_Methods>;
};

/** on_conflict condition type for table "payment_methods" */
export type Payment_Methods_On_Conflict = {
  constraint: Payment_Methods_Constraint;
  update_columns?: Array<Payment_Methods_Update_Column>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};

/** Ordering options when selecting data from "payment_methods". */
export type Payment_Methods_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: payment_methods */
export type Payment_Methods_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "payment_methods" */
export enum Payment_Methods_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "payment_methods" */
export type Payment_Methods_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "payment_methods" */
export type Payment_Methods_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Payment_Methods_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Payment_Methods_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "payment_methods" */
export enum Payment_Methods_Update_Column {
  /** column name */
  Name = 'name'
}

export type Payment_Methods_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Payment_Methods_Set_Input>;
  /** filter the rows which have to be updated */
  where: Payment_Methods_Bool_Exp;
};

/** Boolean expression to compare columns of type "point". All fields are combined with logical 'AND'. */
export type Point_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['point']>;
  _gt?: InputMaybe<Scalars['point']>;
  _gte?: InputMaybe<Scalars['point']>;
  _in?: InputMaybe<Array<Scalars['point']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['point']>;
  _lte?: InputMaybe<Scalars['point']>;
  _neq?: InputMaybe<Scalars['point']>;
  _nin?: InputMaybe<Array<Scalars['point']>>;
};

/** Scheduled events for sending post training survey email to graded users */
export type Post_Training_Email_Scheduled_Events = {
  __typename?: 'post_training_email_scheduled_events';
  course_participant_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  event_id: Scalars['uuid'];
  id: Scalars['uuid'];
};

/** aggregated selection of "post_training_email_scheduled_events" */
export type Post_Training_Email_Scheduled_Events_Aggregate = {
  __typename?: 'post_training_email_scheduled_events_aggregate';
  aggregate?: Maybe<Post_Training_Email_Scheduled_Events_Aggregate_Fields>;
  nodes: Array<Post_Training_Email_Scheduled_Events>;
};

/** aggregate fields of "post_training_email_scheduled_events" */
export type Post_Training_Email_Scheduled_Events_Aggregate_Fields = {
  __typename?: 'post_training_email_scheduled_events_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Post_Training_Email_Scheduled_Events_Max_Fields>;
  min?: Maybe<Post_Training_Email_Scheduled_Events_Min_Fields>;
};


/** aggregate fields of "post_training_email_scheduled_events" */
export type Post_Training_Email_Scheduled_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Post_Training_Email_Scheduled_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "post_training_email_scheduled_events". All fields are combined with a logical 'AND'. */
export type Post_Training_Email_Scheduled_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Post_Training_Email_Scheduled_Events_Bool_Exp>>;
  _not?: InputMaybe<Post_Training_Email_Scheduled_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Post_Training_Email_Scheduled_Events_Bool_Exp>>;
  course_participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "post_training_email_scheduled_events" */
export enum Post_Training_Email_Scheduled_Events_Constraint {
  /** unique or primary key constraint on columns "course_participant_id", "event_id" */
  PostTrainingEmailScheduledCourseParticipantIdEventIKey = 'post_training_email_scheduled_course_participant_id_event_i_key',
  /** unique or primary key constraint on columns "course_participant_id" */
  PostTrainingEmailScheduledEventsCourseParticipantIdKey = 'post_training_email_scheduled_events_course_participant_id_key',
  /** unique or primary key constraint on columns "event_id" */
  PostTrainingEmailScheduledEventsEventIdKey = 'post_training_email_scheduled_events_event_id_key',
  /** unique or primary key constraint on columns "id" */
  PostTrainingEmailScheduledEventsPkey = 'post_training_email_scheduled_events_pkey'
}

/** input type for inserting data into table "post_training_email_scheduled_events" */
export type Post_Training_Email_Scheduled_Events_Insert_Input = {
  course_participant_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Post_Training_Email_Scheduled_Events_Max_Fields = {
  __typename?: 'post_training_email_scheduled_events_max_fields';
  course_participant_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Post_Training_Email_Scheduled_Events_Min_Fields = {
  __typename?: 'post_training_email_scheduled_events_min_fields';
  course_participant_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "post_training_email_scheduled_events" */
export type Post_Training_Email_Scheduled_Events_Mutation_Response = {
  __typename?: 'post_training_email_scheduled_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Post_Training_Email_Scheduled_Events>;
};

/** on_conflict condition type for table "post_training_email_scheduled_events" */
export type Post_Training_Email_Scheduled_Events_On_Conflict = {
  constraint: Post_Training_Email_Scheduled_Events_Constraint;
  update_columns?: Array<Post_Training_Email_Scheduled_Events_Update_Column>;
  where?: InputMaybe<Post_Training_Email_Scheduled_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "post_training_email_scheduled_events". */
export type Post_Training_Email_Scheduled_Events_Order_By = {
  course_participant_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: post_training_email_scheduled_events */
export type Post_Training_Email_Scheduled_Events_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "post_training_email_scheduled_events" */
export enum Post_Training_Email_Scheduled_Events_Select_Column {
  /** column name */
  CourseParticipantId = 'course_participant_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "post_training_email_scheduled_events" */
export type Post_Training_Email_Scheduled_Events_Set_Input = {
  course_participant_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "post_training_email_scheduled_events" */
export type Post_Training_Email_Scheduled_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Post_Training_Email_Scheduled_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Post_Training_Email_Scheduled_Events_Stream_Cursor_Value_Input = {
  course_participant_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "post_training_email_scheduled_events" */
export enum Post_Training_Email_Scheduled_Events_Update_Column {
  /** column name */
  CourseParticipantId = 'course_participant_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id'
}

export type Post_Training_Email_Scheduled_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Post_Training_Email_Scheduled_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Post_Training_Email_Scheduled_Events_Bool_Exp;
};

/** columns and relationships of "pre_training_email_scheduled_events" */
export type Pre_Training_Email_Scheduled_Events = {
  __typename?: 'pre_training_email_scheduled_events';
  course_participant_id: Scalars['uuid'];
  created_at: Scalars['timestamptz'];
  event_id: Scalars['uuid'];
  id: Scalars['uuid'];
};

/** aggregated selection of "pre_training_email_scheduled_events" */
export type Pre_Training_Email_Scheduled_Events_Aggregate = {
  __typename?: 'pre_training_email_scheduled_events_aggregate';
  aggregate?: Maybe<Pre_Training_Email_Scheduled_Events_Aggregate_Fields>;
  nodes: Array<Pre_Training_Email_Scheduled_Events>;
};

/** aggregate fields of "pre_training_email_scheduled_events" */
export type Pre_Training_Email_Scheduled_Events_Aggregate_Fields = {
  __typename?: 'pre_training_email_scheduled_events_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Pre_Training_Email_Scheduled_Events_Max_Fields>;
  min?: Maybe<Pre_Training_Email_Scheduled_Events_Min_Fields>;
};


/** aggregate fields of "pre_training_email_scheduled_events" */
export type Pre_Training_Email_Scheduled_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Pre_Training_Email_Scheduled_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "pre_training_email_scheduled_events". All fields are combined with a logical 'AND'. */
export type Pre_Training_Email_Scheduled_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Pre_Training_Email_Scheduled_Events_Bool_Exp>>;
  _not?: InputMaybe<Pre_Training_Email_Scheduled_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Pre_Training_Email_Scheduled_Events_Bool_Exp>>;
  course_participant_id?: InputMaybe<Uuid_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_id?: InputMaybe<Uuid_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "pre_training_email_scheduled_events" */
export enum Pre_Training_Email_Scheduled_Events_Constraint {
  /** unique or primary key constraint on columns "course_participant_id" */
  PreTrainingEmailScheduledEventsCourseParticipantIdKey = 'pre_training_email_scheduled_events_course_participant_id_key',
  /** unique or primary key constraint on columns "event_id" */
  PreTrainingEmailScheduledEventsEventIdKey = 'pre_training_email_scheduled_events_event_id_key',
  /** unique or primary key constraint on columns "id" */
  PreTrainingEmailScheduledEventsPkey = 'pre_training_email_scheduled_events_pkey'
}

/** input type for inserting data into table "pre_training_email_scheduled_events" */
export type Pre_Training_Email_Scheduled_Events_Insert_Input = {
  course_participant_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Pre_Training_Email_Scheduled_Events_Max_Fields = {
  __typename?: 'pre_training_email_scheduled_events_max_fields';
  course_participant_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Pre_Training_Email_Scheduled_Events_Min_Fields = {
  __typename?: 'pre_training_email_scheduled_events_min_fields';
  course_participant_id?: Maybe<Scalars['uuid']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  event_id?: Maybe<Scalars['uuid']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "pre_training_email_scheduled_events" */
export type Pre_Training_Email_Scheduled_Events_Mutation_Response = {
  __typename?: 'pre_training_email_scheduled_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Pre_Training_Email_Scheduled_Events>;
};

/** on_conflict condition type for table "pre_training_email_scheduled_events" */
export type Pre_Training_Email_Scheduled_Events_On_Conflict = {
  constraint: Pre_Training_Email_Scheduled_Events_Constraint;
  update_columns?: Array<Pre_Training_Email_Scheduled_Events_Update_Column>;
  where?: InputMaybe<Pre_Training_Email_Scheduled_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "pre_training_email_scheduled_events". */
export type Pre_Training_Email_Scheduled_Events_Order_By = {
  course_participant_id?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  event_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: pre_training_email_scheduled_events */
export type Pre_Training_Email_Scheduled_Events_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "pre_training_email_scheduled_events" */
export enum Pre_Training_Email_Scheduled_Events_Select_Column {
  /** column name */
  CourseParticipantId = 'course_participant_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id'
}

/** input type for updating data in table "pre_training_email_scheduled_events" */
export type Pre_Training_Email_Scheduled_Events_Set_Input = {
  course_participant_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "pre_training_email_scheduled_events" */
export type Pre_Training_Email_Scheduled_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Pre_Training_Email_Scheduled_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Pre_Training_Email_Scheduled_Events_Stream_Cursor_Value_Input = {
  course_participant_id?: InputMaybe<Scalars['uuid']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_id?: InputMaybe<Scalars['uuid']>;
  id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "pre_training_email_scheduled_events" */
export enum Pre_Training_Email_Scheduled_Events_Update_Column {
  /** column name */
  CourseParticipantId = 'course_participant_id',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventId = 'event_id',
  /** column name */
  Id = 'id'
}

export type Pre_Training_Email_Scheduled_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Pre_Training_Email_Scheduled_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Pre_Training_Email_Scheduled_Events_Bool_Exp;
};

/** columns and relationships of "precision_order_status" */
export type Precision_Order_Status = {
  __typename?: 'precision_order_status';
  name: Scalars['String'];
};

/** aggregated selection of "precision_order_status" */
export type Precision_Order_Status_Aggregate = {
  __typename?: 'precision_order_status_aggregate';
  aggregate?: Maybe<Precision_Order_Status_Aggregate_Fields>;
  nodes: Array<Precision_Order_Status>;
};

/** aggregate fields of "precision_order_status" */
export type Precision_Order_Status_Aggregate_Fields = {
  __typename?: 'precision_order_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Precision_Order_Status_Max_Fields>;
  min?: Maybe<Precision_Order_Status_Min_Fields>;
};


/** aggregate fields of "precision_order_status" */
export type Precision_Order_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Precision_Order_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "precision_order_status". All fields are combined with a logical 'AND'. */
export type Precision_Order_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Precision_Order_Status_Bool_Exp>>;
  _not?: InputMaybe<Precision_Order_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Precision_Order_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "precision_order_status" */
export enum Precision_Order_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  PrecisionOrderStatusPkey = 'precision_order_status_pkey'
}

export enum Precision_Order_Status_Enum {
  Cancelled = 'cancelled',
  Draft = 'draft',
  Errored = 'errored',
  Received = 'received',
  Shipped = 'shipped'
}

/** Boolean expression to compare columns of type "precision_order_status_enum". All fields are combined with logical 'AND'. */
export type Precision_Order_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Precision_Order_Status_Enum>;
  _in?: InputMaybe<Array<Precision_Order_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Precision_Order_Status_Enum>;
  _nin?: InputMaybe<Array<Precision_Order_Status_Enum>>;
};

/** input type for inserting data into table "precision_order_status" */
export type Precision_Order_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Precision_Order_Status_Max_Fields = {
  __typename?: 'precision_order_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Precision_Order_Status_Min_Fields = {
  __typename?: 'precision_order_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "precision_order_status" */
export type Precision_Order_Status_Mutation_Response = {
  __typename?: 'precision_order_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Precision_Order_Status>;
};

/** on_conflict condition type for table "precision_order_status" */
export type Precision_Order_Status_On_Conflict = {
  constraint: Precision_Order_Status_Constraint;
  update_columns?: Array<Precision_Order_Status_Update_Column>;
  where?: InputMaybe<Precision_Order_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "precision_order_status". */
export type Precision_Order_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: precision_order_status */
export type Precision_Order_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "precision_order_status" */
export enum Precision_Order_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "precision_order_status" */
export type Precision_Order_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "precision_order_status" */
export type Precision_Order_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Precision_Order_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Precision_Order_Status_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "precision_order_status" */
export enum Precision_Order_Status_Update_Column {
  /** column name */
  Name = 'name'
}

export type Precision_Order_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Precision_Order_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Precision_Order_Status_Bool_Exp;
};

/** Private course booking enquiry */
export type Private_Course_Booking = {
  __typename?: 'private_course_booking';
  courseId: Scalars['Int'];
  createdAt?: Maybe<Scalars['timestamptz']>;
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['uuid'];
  message?: Maybe<Scalars['String']>;
  numParticipants: Scalars['Int'];
  orgName: Scalars['String'];
  phone: Scalars['String'];
  sector: Scalars['String'];
  source?: Maybe<Scalars['String']>;
};

/** aggregated selection of "private_course_booking" */
export type Private_Course_Booking_Aggregate = {
  __typename?: 'private_course_booking_aggregate';
  aggregate?: Maybe<Private_Course_Booking_Aggregate_Fields>;
  nodes: Array<Private_Course_Booking>;
};

/** aggregate fields of "private_course_booking" */
export type Private_Course_Booking_Aggregate_Fields = {
  __typename?: 'private_course_booking_aggregate_fields';
  avg?: Maybe<Private_Course_Booking_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Private_Course_Booking_Max_Fields>;
  min?: Maybe<Private_Course_Booking_Min_Fields>;
  stddev?: Maybe<Private_Course_Booking_Stddev_Fields>;
  stddev_pop?: Maybe<Private_Course_Booking_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Private_Course_Booking_Stddev_Samp_Fields>;
  sum?: Maybe<Private_Course_Booking_Sum_Fields>;
  var_pop?: Maybe<Private_Course_Booking_Var_Pop_Fields>;
  var_samp?: Maybe<Private_Course_Booking_Var_Samp_Fields>;
  variance?: Maybe<Private_Course_Booking_Variance_Fields>;
};


/** aggregate fields of "private_course_booking" */
export type Private_Course_Booking_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Private_Course_Booking_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Private_Course_Booking_Avg_Fields = {
  __typename?: 'private_course_booking_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
  numParticipants?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "private_course_booking". All fields are combined with a logical 'AND'. */
export type Private_Course_Booking_Bool_Exp = {
  _and?: InputMaybe<Array<Private_Course_Booking_Bool_Exp>>;
  _not?: InputMaybe<Private_Course_Booking_Bool_Exp>;
  _or?: InputMaybe<Array<Private_Course_Booking_Bool_Exp>>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  familyName?: InputMaybe<String_Comparison_Exp>;
  givenName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  message?: InputMaybe<String_Comparison_Exp>;
  numParticipants?: InputMaybe<Int_Comparison_Exp>;
  orgName?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  sector?: InputMaybe<String_Comparison_Exp>;
  source?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "private_course_booking" */
export enum Private_Course_Booking_Constraint {
  /** unique or primary key constraint on columns "email", "course_id" */
  PrivateCourseBookingCourseIdEmailKey = 'private_course_booking_course_id_email_key',
  /** unique or primary key constraint on columns "id" */
  PrivateCourseBookingPkey = 'private_course_booking_pkey'
}

/** input type for incrementing numeric columns in table "private_course_booking" */
export type Private_Course_Booking_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  numParticipants?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "private_course_booking" */
export type Private_Course_Booking_Insert_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  numParticipants?: InputMaybe<Scalars['Int']>;
  orgName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Private_Course_Booking_Max_Fields = {
  __typename?: 'private_course_booking_max_fields';
  courseId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  numParticipants?: Maybe<Scalars['Int']>;
  orgName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Private_Course_Booking_Min_Fields = {
  __typename?: 'private_course_booking_min_fields';
  courseId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  message?: Maybe<Scalars['String']>;
  numParticipants?: Maybe<Scalars['Int']>;
  orgName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
  sector?: Maybe<Scalars['String']>;
  source?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "private_course_booking" */
export type Private_Course_Booking_Mutation_Response = {
  __typename?: 'private_course_booking_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Private_Course_Booking>;
};

/** on_conflict condition type for table "private_course_booking" */
export type Private_Course_Booking_On_Conflict = {
  constraint: Private_Course_Booking_Constraint;
  update_columns?: Array<Private_Course_Booking_Update_Column>;
  where?: InputMaybe<Private_Course_Booking_Bool_Exp>;
};

/** Ordering options when selecting data from "private_course_booking". */
export type Private_Course_Booking_Order_By = {
  courseId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  familyName?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  message?: InputMaybe<Order_By>;
  numParticipants?: InputMaybe<Order_By>;
  orgName?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  sector?: InputMaybe<Order_By>;
  source?: InputMaybe<Order_By>;
};

/** primary key columns input for table: private_course_booking */
export type Private_Course_Booking_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "private_course_booking" */
export enum Private_Course_Booking_Select_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  NumParticipants = 'numParticipants',
  /** column name */
  OrgName = 'orgName',
  /** column name */
  Phone = 'phone',
  /** column name */
  Sector = 'sector',
  /** column name */
  Source = 'source'
}

/** input type for updating data in table "private_course_booking" */
export type Private_Course_Booking_Set_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  numParticipants?: InputMaybe<Scalars['Int']>;
  orgName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Private_Course_Booking_Stddev_Fields = {
  __typename?: 'private_course_booking_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
  numParticipants?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Private_Course_Booking_Stddev_Pop_Fields = {
  __typename?: 'private_course_booking_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  numParticipants?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Private_Course_Booking_Stddev_Samp_Fields = {
  __typename?: 'private_course_booking_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  numParticipants?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "private_course_booking" */
export type Private_Course_Booking_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Private_Course_Booking_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Private_Course_Booking_Stream_Cursor_Value_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  message?: InputMaybe<Scalars['String']>;
  numParticipants?: InputMaybe<Scalars['Int']>;
  orgName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
  sector?: InputMaybe<Scalars['String']>;
  source?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Private_Course_Booking_Sum_Fields = {
  __typename?: 'private_course_booking_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
  numParticipants?: Maybe<Scalars['Int']>;
};

/** update columns of table "private_course_booking" */
export enum Private_Course_Booking_Update_Column {
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  Message = 'message',
  /** column name */
  NumParticipants = 'numParticipants',
  /** column name */
  OrgName = 'orgName',
  /** column name */
  Phone = 'phone',
  /** column name */
  Sector = 'sector',
  /** column name */
  Source = 'source'
}

export type Private_Course_Booking_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Private_Course_Booking_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Private_Course_Booking_Set_Input>;
  /** filter the rows which have to be updated */
  where: Private_Course_Booking_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Private_Course_Booking_Var_Pop_Fields = {
  __typename?: 'private_course_booking_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  numParticipants?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Private_Course_Booking_Var_Samp_Fields = {
  __typename?: 'private_course_booking_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  numParticipants?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Private_Course_Booking_Variance_Fields = {
  __typename?: 'private_course_booking_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
  numParticipants?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "profile" */
export type Profile = {
  __typename?: 'profile';
  _email?: Maybe<Scalars['String']>;
  _family_name?: Maybe<Scalars['String']>;
  _given_name?: Maybe<Scalars['String']>;
  _phone?: Maybe<Scalars['String']>;
  account_confirmed?: Maybe<Scalars['Boolean']>;
  addresses: Scalars['jsonb'];
  archived?: Maybe<Scalars['Boolean']>;
  attributes: Scalars['jsonb'];
  avatar?: Maybe<Scalars['String']>;
  canAccessKnowledgeHub?: Maybe<Scalars['Boolean']>;
  /** An array relationship */
  certificates: Array<Course_Certificate>;
  /** An aggregate relationship */
  certificates_aggregate: Course_Certificate_Aggregate;
  contactDetails: Scalars['jsonb'];
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  /** An array relationship */
  course_evaluation_answers: Array<Course_Evaluation_Answers>;
  /** An aggregate relationship */
  course_evaluation_answers_aggregate: Course_Evaluation_Answers_Aggregate;
  /** An array relationship */
  course_trainer: Array<Course_Trainer>;
  /** An aggregate relationship */
  course_trainer_aggregate: Course_Trainer_Aggregate;
  /** An array relationship */
  courses: Array<Course_Participant>;
  /** An aggregate relationship */
  courses_aggregate: Course_Participant_Aggregate;
  createdAt: Scalars['timestamptz'];
  dietaryRestrictions?: Maybe<Scalars['String']>;
  disabilities?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['date']>;
  /** A computed field, executes function "profile_email" */
  email?: Maybe<Scalars['String']>;
  /** A computed field, executes function "profile_family_name" */
  familyName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  /** A computed field, executes function "profile_given_name" */
  givenName?: Maybe<Scalars['String']>;
  go1Id?: Maybe<Scalars['Int']>;
  /** An array relationship */
  go1Licenses: Array<Go1_Licenses>;
  /** An aggregate relationship */
  go1Licenses_aggregate: Go1_Licenses_Aggregate;
  go1_profile?: Maybe<Scalars['jsonb']>;
  id: Scalars['uuid'];
  /** An array relationship */
  identities: Array<Identity>;
  /** An aggregate relationship */
  identities_aggregate: Identity_Aggregate;
  imported?: Maybe<Scalars['Boolean']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastActivity?: Maybe<Scalars['timestamptz']>;
  /** An array relationship */
  organizations: Array<Organization_Member>;
  /** An aggregate relationship */
  organizations_aggregate: Organization_Member_Aggregate;
  original_record: Scalars['jsonb'];
  /** An array relationship */
  participant_audits: Array<Course_Participant_Audit>;
  /** An aggregate relationship */
  participant_audits_aggregate: Course_Participant_Audit_Aggregate;
  /** A computed field, executes function "profile_phone" */
  phone?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  preferences: Scalars['jsonb'];
  /** An array relationship */
  profile_trainer_agreement_types: Array<Profile_Trainer_Agreement_Type>;
  /** An aggregate relationship */
  profile_trainer_agreement_types_aggregate: Profile_Trainer_Agreement_Type_Aggregate;
  /** An array relationship */
  roles: Array<Profile_Role>;
  /** An aggregate relationship */
  roles_aggregate: Profile_Role_Aggregate;
  stripe_customer_id?: Maybe<Scalars['String']>;
  /** An array relationship */
  submission_of_splash_screens: Array<Submission_Of_Splash_Screens>;
  /** An aggregate relationship */
  submission_of_splash_screens_aggregate: Submission_Of_Splash_Screens_Aggregate;
  tags?: Maybe<Scalars['jsonb']>;
  title?: Maybe<Scalars['String']>;
  /** An array relationship */
  trainer_role_types: Array<Profile_Trainer_Role_Type>;
  /** An aggregate relationship */
  trainer_role_types_aggregate: Profile_Trainer_Role_Type_Aggregate;
  /** A computed field, executes function "profile_translated_family_name" */
  translatedFamilyName?: Maybe<Scalars['String']>;
  /** A computed field, executes function "profile_translated_given_name" */
  translatedGivenName?: Maybe<Scalars['String']>;
  translated_family_name?: Maybe<Scalars['String']>;
  translated_given_name?: Maybe<Scalars['String']>;
  /** An array relationship */
  upcomingEnrollments: Array<Upcoming_Enrollments>;
  /** An aggregate relationship */
  upcomingEnrollments_aggregate: Upcoming_Enrollments_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "profile" */
export type ProfileAddressesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "profile" */
export type ProfileAttributesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "profile" */
export type ProfileCertificatesArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Order_By>>;
  where?: InputMaybe<Course_Certificate_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileCertificates_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Order_By>>;
  where?: InputMaybe<Course_Certificate_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileContactDetailsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "profile" */
export type ProfileCourse_Evaluation_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Answers_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileCourse_Evaluation_Answers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Answers_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileCourse_TrainerArgs = {
  distinct_on?: InputMaybe<Array<Course_Trainer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Trainer_Order_By>>;
  where?: InputMaybe<Course_Trainer_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileCourse_Trainer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Trainer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Trainer_Order_By>>;
  where?: InputMaybe<Course_Trainer_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileCoursesArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Order_By>>;
  where?: InputMaybe<Course_Participant_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Order_By>>;
  where?: InputMaybe<Course_Participant_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileGo1LicensesArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_Order_By>>;
  where?: InputMaybe<Go1_Licenses_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileGo1Licenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_Order_By>>;
  where?: InputMaybe<Go1_Licenses_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileGo1_ProfileArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "profile" */
export type ProfileIdentitiesArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileIdentities_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileOrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Organization_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Member_Order_By>>;
  where?: InputMaybe<Organization_Member_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileOrganizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Member_Order_By>>;
  where?: InputMaybe<Organization_Member_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileOriginal_RecordArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "profile" */
export type ProfileParticipant_AuditsArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Audit_Order_By>>;
  where?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileParticipant_Audits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Audit_Order_By>>;
  where?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfilePreferencesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "profile" */
export type ProfileProfile_Trainer_Agreement_TypesArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Agreement_Type_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileProfile_Trainer_Agreement_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Agreement_Type_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileRolesArgs = {
  distinct_on?: InputMaybe<Array<Profile_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Role_Order_By>>;
  where?: InputMaybe<Profile_Role_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileRoles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Role_Order_By>>;
  where?: InputMaybe<Profile_Role_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileSubmission_Of_Splash_ScreensArgs = {
  distinct_on?: InputMaybe<Array<Submission_Of_Splash_Screens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submission_Of_Splash_Screens_Order_By>>;
  where?: InputMaybe<Submission_Of_Splash_Screens_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileSubmission_Of_Splash_Screens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Submission_Of_Splash_Screens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submission_Of_Splash_Screens_Order_By>>;
  where?: InputMaybe<Submission_Of_Splash_Screens_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileTagsArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "profile" */
export type ProfileTrainer_Role_TypesArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Role_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileTrainer_Role_Types_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Role_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileUpcomingEnrollmentsArgs = {
  distinct_on?: InputMaybe<Array<Upcoming_Enrollments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Upcoming_Enrollments_Order_By>>;
  where?: InputMaybe<Upcoming_Enrollments_Bool_Exp>;
};


/** columns and relationships of "profile" */
export type ProfileUpcomingEnrollments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Upcoming_Enrollments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Upcoming_Enrollments_Order_By>>;
  where?: InputMaybe<Upcoming_Enrollments_Bool_Exp>;
};

/** aggregated selection of "profile" */
export type Profile_Aggregate = {
  __typename?: 'profile_aggregate';
  aggregate?: Maybe<Profile_Aggregate_Fields>;
  nodes: Array<Profile>;
};

/** aggregate fields of "profile" */
export type Profile_Aggregate_Fields = {
  __typename?: 'profile_aggregate_fields';
  avg?: Maybe<Profile_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Profile_Max_Fields>;
  min?: Maybe<Profile_Min_Fields>;
  stddev?: Maybe<Profile_Stddev_Fields>;
  stddev_pop?: Maybe<Profile_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Profile_Stddev_Samp_Fields>;
  sum?: Maybe<Profile_Sum_Fields>;
  var_pop?: Maybe<Profile_Var_Pop_Fields>;
  var_samp?: Maybe<Profile_Var_Samp_Fields>;
  variance?: Maybe<Profile_Variance_Fields>;
};


/** aggregate fields of "profile" */
export type Profile_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Profile_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Profile_Append_Input = {
  addresses?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  contactDetails?: InputMaybe<Scalars['jsonb']>;
  go1_profile?: InputMaybe<Scalars['jsonb']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Profile_Avg_Fields = {
  __typename?: 'profile_avg_fields';
  go1Id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "profile". All fields are combined with a logical 'AND'. */
export type Profile_Bool_Exp = {
  _and?: InputMaybe<Array<Profile_Bool_Exp>>;
  _email?: InputMaybe<String_Comparison_Exp>;
  _family_name?: InputMaybe<String_Comparison_Exp>;
  _given_name?: InputMaybe<String_Comparison_Exp>;
  _not?: InputMaybe<Profile_Bool_Exp>;
  _or?: InputMaybe<Array<Profile_Bool_Exp>>;
  _phone?: InputMaybe<String_Comparison_Exp>;
  account_confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  addresses?: InputMaybe<Jsonb_Comparison_Exp>;
  archived?: InputMaybe<Boolean_Comparison_Exp>;
  attributes?: InputMaybe<Jsonb_Comparison_Exp>;
  avatar?: InputMaybe<String_Comparison_Exp>;
  canAccessKnowledgeHub?: InputMaybe<Boolean_Comparison_Exp>;
  certificates?: InputMaybe<Course_Certificate_Bool_Exp>;
  certificates_aggregate?: InputMaybe<Course_Certificate_Aggregate_Bool_Exp>;
  contactDetails?: InputMaybe<Jsonb_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  countryCode?: InputMaybe<String_Comparison_Exp>;
  course_evaluation_answers?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
  course_evaluation_answers_aggregate?: InputMaybe<Course_Evaluation_Answers_Aggregate_Bool_Exp>;
  course_trainer?: InputMaybe<Course_Trainer_Bool_Exp>;
  course_trainer_aggregate?: InputMaybe<Course_Trainer_Aggregate_Bool_Exp>;
  courses?: InputMaybe<Course_Participant_Bool_Exp>;
  courses_aggregate?: InputMaybe<Course_Participant_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dietaryRestrictions?: InputMaybe<String_Comparison_Exp>;
  disabilities?: InputMaybe<String_Comparison_Exp>;
  dob?: InputMaybe<Date_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  familyName?: InputMaybe<String_Comparison_Exp>;
  fullName?: InputMaybe<String_Comparison_Exp>;
  givenName?: InputMaybe<String_Comparison_Exp>;
  go1Id?: InputMaybe<Int_Comparison_Exp>;
  go1Licenses?: InputMaybe<Go1_Licenses_Bool_Exp>;
  go1Licenses_aggregate?: InputMaybe<Go1_Licenses_Aggregate_Bool_Exp>;
  go1_profile?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  identities?: InputMaybe<Identity_Bool_Exp>;
  identities_aggregate?: InputMaybe<Identity_Aggregate_Bool_Exp>;
  imported?: InputMaybe<Boolean_Comparison_Exp>;
  jobTitle?: InputMaybe<String_Comparison_Exp>;
  lastActivity?: InputMaybe<Timestamptz_Comparison_Exp>;
  organizations?: InputMaybe<Organization_Member_Bool_Exp>;
  organizations_aggregate?: InputMaybe<Organization_Member_Aggregate_Bool_Exp>;
  original_record?: InputMaybe<Jsonb_Comparison_Exp>;
  participant_audits?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
  participant_audits_aggregate?: InputMaybe<Course_Participant_Audit_Aggregate_Bool_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  phoneCountryCode?: InputMaybe<String_Comparison_Exp>;
  preferences?: InputMaybe<Jsonb_Comparison_Exp>;
  profile_trainer_agreement_types?: InputMaybe<Profile_Trainer_Agreement_Type_Bool_Exp>;
  profile_trainer_agreement_types_aggregate?: InputMaybe<Profile_Trainer_Agreement_Type_Aggregate_Bool_Exp>;
  roles?: InputMaybe<Profile_Role_Bool_Exp>;
  roles_aggregate?: InputMaybe<Profile_Role_Aggregate_Bool_Exp>;
  stripe_customer_id?: InputMaybe<String_Comparison_Exp>;
  submission_of_splash_screens?: InputMaybe<Submission_Of_Splash_Screens_Bool_Exp>;
  submission_of_splash_screens_aggregate?: InputMaybe<Submission_Of_Splash_Screens_Aggregate_Bool_Exp>;
  tags?: InputMaybe<Jsonb_Comparison_Exp>;
  title?: InputMaybe<String_Comparison_Exp>;
  trainer_role_types?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
  trainer_role_types_aggregate?: InputMaybe<Profile_Trainer_Role_Type_Aggregate_Bool_Exp>;
  translatedFamilyName?: InputMaybe<String_Comparison_Exp>;
  translatedGivenName?: InputMaybe<String_Comparison_Exp>;
  translated_family_name?: InputMaybe<String_Comparison_Exp>;
  translated_given_name?: InputMaybe<String_Comparison_Exp>;
  upcomingEnrollments?: InputMaybe<Upcoming_Enrollments_Bool_Exp>;
  upcomingEnrollments_aggregate?: InputMaybe<Upcoming_Enrollments_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "profile" */
export enum Profile_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProfilePkey = 'profile_pkey',
  /** unique or primary key constraint on columns "stripe_customer_id" */
  ProfileStripeCustomerIdKey = 'profile_stripe_customer_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Profile_Delete_At_Path_Input = {
  addresses?: InputMaybe<Array<Scalars['String']>>;
  attributes?: InputMaybe<Array<Scalars['String']>>;
  contactDetails?: InputMaybe<Array<Scalars['String']>>;
  go1_profile?: InputMaybe<Array<Scalars['String']>>;
  original_record?: InputMaybe<Array<Scalars['String']>>;
  preferences?: InputMaybe<Array<Scalars['String']>>;
  tags?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Profile_Delete_Elem_Input = {
  addresses?: InputMaybe<Scalars['Int']>;
  attributes?: InputMaybe<Scalars['Int']>;
  contactDetails?: InputMaybe<Scalars['Int']>;
  go1_profile?: InputMaybe<Scalars['Int']>;
  original_record?: InputMaybe<Scalars['Int']>;
  preferences?: InputMaybe<Scalars['Int']>;
  tags?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Profile_Delete_Key_Input = {
  addresses?: InputMaybe<Scalars['String']>;
  attributes?: InputMaybe<Scalars['String']>;
  contactDetails?: InputMaybe<Scalars['String']>;
  go1_profile?: InputMaybe<Scalars['String']>;
  original_record?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "profile" */
export type Profile_Inc_Input = {
  go1Id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "profile" */
export type Profile_Insert_Input = {
  _email?: InputMaybe<Scalars['String']>;
  _family_name?: InputMaybe<Scalars['String']>;
  _given_name?: InputMaybe<Scalars['String']>;
  _phone?: InputMaybe<Scalars['String']>;
  account_confirmed?: InputMaybe<Scalars['Boolean']>;
  addresses?: InputMaybe<Scalars['jsonb']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  avatar?: InputMaybe<Scalars['String']>;
  canAccessKnowledgeHub?: InputMaybe<Scalars['Boolean']>;
  certificates?: InputMaybe<Course_Certificate_Arr_Rel_Insert_Input>;
  contactDetails?: InputMaybe<Scalars['jsonb']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  course_evaluation_answers?: InputMaybe<Course_Evaluation_Answers_Arr_Rel_Insert_Input>;
  course_trainer?: InputMaybe<Course_Trainer_Arr_Rel_Insert_Input>;
  courses?: InputMaybe<Course_Participant_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dietaryRestrictions?: InputMaybe<Scalars['String']>;
  disabilities?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['date']>;
  go1Id?: InputMaybe<Scalars['Int']>;
  go1Licenses?: InputMaybe<Go1_Licenses_Arr_Rel_Insert_Input>;
  go1_profile?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  identities?: InputMaybe<Identity_Arr_Rel_Insert_Input>;
  imported?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastActivity?: InputMaybe<Scalars['timestamptz']>;
  organizations?: InputMaybe<Organization_Member_Arr_Rel_Insert_Input>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  participant_audits?: InputMaybe<Course_Participant_Audit_Arr_Rel_Insert_Input>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  profile_trainer_agreement_types?: InputMaybe<Profile_Trainer_Agreement_Type_Arr_Rel_Insert_Input>;
  roles?: InputMaybe<Profile_Role_Arr_Rel_Insert_Input>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  submission_of_splash_screens?: InputMaybe<Submission_Of_Splash_Screens_Arr_Rel_Insert_Input>;
  tags?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
  trainer_role_types?: InputMaybe<Profile_Trainer_Role_Type_Arr_Rel_Insert_Input>;
  translated_family_name?: InputMaybe<Scalars['String']>;
  translated_given_name?: InputMaybe<Scalars['String']>;
  upcomingEnrollments?: InputMaybe<Upcoming_Enrollments_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Profile_Max_Fields = {
  __typename?: 'profile_max_fields';
  _email?: Maybe<Scalars['String']>;
  _family_name?: Maybe<Scalars['String']>;
  _given_name?: Maybe<Scalars['String']>;
  _phone?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dietaryRestrictions?: Maybe<Scalars['String']>;
  disabilities?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['date']>;
  /** A computed field, executes function "profile_email" */
  email?: Maybe<Scalars['String']>;
  /** A computed field, executes function "profile_family_name" */
  familyName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  /** A computed field, executes function "profile_given_name" */
  givenName?: Maybe<Scalars['String']>;
  go1Id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastActivity?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "profile_phone" */
  phone?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** A computed field, executes function "profile_translated_family_name" */
  translatedFamilyName?: Maybe<Scalars['String']>;
  /** A computed field, executes function "profile_translated_given_name" */
  translatedGivenName?: Maybe<Scalars['String']>;
  translated_family_name?: Maybe<Scalars['String']>;
  translated_given_name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Profile_Min_Fields = {
  __typename?: 'profile_min_fields';
  _email?: Maybe<Scalars['String']>;
  _family_name?: Maybe<Scalars['String']>;
  _given_name?: Maybe<Scalars['String']>;
  _phone?: Maybe<Scalars['String']>;
  avatar?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dietaryRestrictions?: Maybe<Scalars['String']>;
  disabilities?: Maybe<Scalars['String']>;
  dob?: Maybe<Scalars['date']>;
  /** A computed field, executes function "profile_email" */
  email?: Maybe<Scalars['String']>;
  /** A computed field, executes function "profile_family_name" */
  familyName?: Maybe<Scalars['String']>;
  fullName?: Maybe<Scalars['String']>;
  /** A computed field, executes function "profile_given_name" */
  givenName?: Maybe<Scalars['String']>;
  go1Id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  jobTitle?: Maybe<Scalars['String']>;
  lastActivity?: Maybe<Scalars['timestamptz']>;
  /** A computed field, executes function "profile_phone" */
  phone?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  stripe_customer_id?: Maybe<Scalars['String']>;
  title?: Maybe<Scalars['String']>;
  /** A computed field, executes function "profile_translated_family_name" */
  translatedFamilyName?: Maybe<Scalars['String']>;
  /** A computed field, executes function "profile_translated_given_name" */
  translatedGivenName?: Maybe<Scalars['String']>;
  translated_family_name?: Maybe<Scalars['String']>;
  translated_given_name?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "profile" */
export type Profile_Mutation_Response = {
  __typename?: 'profile_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Profile>;
};

/** input type for inserting object relation for remote table "profile" */
export type Profile_Obj_Rel_Insert_Input = {
  data: Profile_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Profile_On_Conflict>;
};

/** on_conflict condition type for table "profile" */
export type Profile_On_Conflict = {
  constraint: Profile_Constraint;
  update_columns?: Array<Profile_Update_Column>;
  where?: InputMaybe<Profile_Bool_Exp>;
};

/** Ordering options when selecting data from "profile". */
export type Profile_Order_By = {
  _email?: InputMaybe<Order_By>;
  _family_name?: InputMaybe<Order_By>;
  _given_name?: InputMaybe<Order_By>;
  _phone?: InputMaybe<Order_By>;
  account_confirmed?: InputMaybe<Order_By>;
  addresses?: InputMaybe<Order_By>;
  archived?: InputMaybe<Order_By>;
  attributes?: InputMaybe<Order_By>;
  avatar?: InputMaybe<Order_By>;
  canAccessKnowledgeHub?: InputMaybe<Order_By>;
  certificates_aggregate?: InputMaybe<Course_Certificate_Aggregate_Order_By>;
  contactDetails?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  countryCode?: InputMaybe<Order_By>;
  course_evaluation_answers_aggregate?: InputMaybe<Course_Evaluation_Answers_Aggregate_Order_By>;
  course_trainer_aggregate?: InputMaybe<Course_Trainer_Aggregate_Order_By>;
  courses_aggregate?: InputMaybe<Course_Participant_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dietaryRestrictions?: InputMaybe<Order_By>;
  disabilities?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  familyName?: InputMaybe<Order_By>;
  fullName?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  go1Id?: InputMaybe<Order_By>;
  go1Licenses_aggregate?: InputMaybe<Go1_Licenses_Aggregate_Order_By>;
  go1_profile?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  identities_aggregate?: InputMaybe<Identity_Aggregate_Order_By>;
  imported?: InputMaybe<Order_By>;
  jobTitle?: InputMaybe<Order_By>;
  lastActivity?: InputMaybe<Order_By>;
  organizations_aggregate?: InputMaybe<Organization_Member_Aggregate_Order_By>;
  original_record?: InputMaybe<Order_By>;
  participant_audits_aggregate?: InputMaybe<Course_Participant_Audit_Aggregate_Order_By>;
  phone?: InputMaybe<Order_By>;
  phoneCountryCode?: InputMaybe<Order_By>;
  preferences?: InputMaybe<Order_By>;
  profile_trainer_agreement_types_aggregate?: InputMaybe<Profile_Trainer_Agreement_Type_Aggregate_Order_By>;
  roles_aggregate?: InputMaybe<Profile_Role_Aggregate_Order_By>;
  stripe_customer_id?: InputMaybe<Order_By>;
  submission_of_splash_screens_aggregate?: InputMaybe<Submission_Of_Splash_Screens_Aggregate_Order_By>;
  tags?: InputMaybe<Order_By>;
  title?: InputMaybe<Order_By>;
  trainer_role_types_aggregate?: InputMaybe<Profile_Trainer_Role_Type_Aggregate_Order_By>;
  translatedFamilyName?: InputMaybe<Order_By>;
  translatedGivenName?: InputMaybe<Order_By>;
  translated_family_name?: InputMaybe<Order_By>;
  translated_given_name?: InputMaybe<Order_By>;
  upcomingEnrollments_aggregate?: InputMaybe<Upcoming_Enrollments_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: profile */
export type Profile_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Profile_Prepend_Input = {
  addresses?: InputMaybe<Scalars['jsonb']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  contactDetails?: InputMaybe<Scalars['jsonb']>;
  go1_profile?: InputMaybe<Scalars['jsonb']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  tags?: InputMaybe<Scalars['jsonb']>;
};

/** columns and relationships of "profile_role" */
export type Profile_Role = {
  __typename?: 'profile_role';
  _source?: Maybe<Scalars['String']>;
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  /** An object relationship */
  profile: Profile;
  profile_id: Scalars['uuid'];
  /** An object relationship */
  role: Role;
  role_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "profile_role" */
export type Profile_Role_Aggregate = {
  __typename?: 'profile_role_aggregate';
  aggregate?: Maybe<Profile_Role_Aggregate_Fields>;
  nodes: Array<Profile_Role>;
};

export type Profile_Role_Aggregate_Bool_Exp = {
  count?: InputMaybe<Profile_Role_Aggregate_Bool_Exp_Count>;
};

export type Profile_Role_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Profile_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Profile_Role_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "profile_role" */
export type Profile_Role_Aggregate_Fields = {
  __typename?: 'profile_role_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Profile_Role_Max_Fields>;
  min?: Maybe<Profile_Role_Min_Fields>;
};


/** aggregate fields of "profile_role" */
export type Profile_Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Profile_Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "profile_role" */
export type Profile_Role_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Profile_Role_Max_Order_By>;
  min?: InputMaybe<Profile_Role_Min_Order_By>;
};

/** input type for inserting array relation for remote table "profile_role" */
export type Profile_Role_Arr_Rel_Insert_Input = {
  data: Array<Profile_Role_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Profile_Role_On_Conflict>;
};

/** Boolean expression to filter rows from the table "profile_role". All fields are combined with a logical 'AND'. */
export type Profile_Role_Bool_Exp = {
  _and?: InputMaybe<Array<Profile_Role_Bool_Exp>>;
  _not?: InputMaybe<Profile_Role_Bool_Exp>;
  _or?: InputMaybe<Array<Profile_Role_Bool_Exp>>;
  _source?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  role?: InputMaybe<Role_Bool_Exp>;
  role_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "profile_role" */
export enum Profile_Role_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProfileRolePkey = 'profile_role_pkey',
  /** unique or primary key constraint on columns "role_id", "profile_id" */
  ProfileRoleProfileIdRoleIdKey = 'profile_role_profile_id_role_id_key'
}

/** input type for inserting data into table "profile_role" */
export type Profile_Role_Insert_Input = {
  _source?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  role?: InputMaybe<Role_Obj_Rel_Insert_Input>;
  role_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Profile_Role_Max_Fields = {
  __typename?: 'profile_role_max_fields';
  _source?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "profile_role" */
export type Profile_Role_Max_Order_By = {
  _source?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Profile_Role_Min_Fields = {
  __typename?: 'profile_role_min_fields';
  _source?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  role_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "profile_role" */
export type Profile_Role_Min_Order_By = {
  _source?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "profile_role" */
export type Profile_Role_Mutation_Response = {
  __typename?: 'profile_role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Profile_Role>;
};

/** on_conflict condition type for table "profile_role" */
export type Profile_Role_On_Conflict = {
  constraint: Profile_Role_Constraint;
  update_columns?: Array<Profile_Role_Update_Column>;
  where?: InputMaybe<Profile_Role_Bool_Exp>;
};

/** Ordering options when selecting data from "profile_role". */
export type Profile_Role_Order_By = {
  _source?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profile_id?: InputMaybe<Order_By>;
  role?: InputMaybe<Role_Order_By>;
  role_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: profile_role */
export type Profile_Role_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "profile_role" */
export enum Profile_Role_Select_Column {
  /** column name */
  Source = '_source',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "profile_role" */
export type Profile_Role_Set_Input = {
  _source?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "profile_role" */
export type Profile_Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Profile_Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Profile_Role_Stream_Cursor_Value_Input = {
  _source?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  role_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "profile_role" */
export enum Profile_Role_Update_Column {
  /** column name */
  Source = '_source',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  RoleId = 'role_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Profile_Role_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Profile_Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Profile_Role_Bool_Exp;
};

/** select columns of table "profile" */
export enum Profile_Select_Column {
  /** column name */
  Email = '_email',
  /** column name */
  FamilyName = '_family_name',
  /** column name */
  GivenName = '_given_name',
  /** column name */
  Phone = '_phone',
  /** column name */
  AccountConfirmed = 'account_confirmed',
  /** column name */
  Addresses = 'addresses',
  /** column name */
  Archived = 'archived',
  /** column name */
  Attributes = 'attributes',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  CanAccessKnowledgeHub = 'canAccessKnowledgeHub',
  /** column name */
  ContactDetails = 'contactDetails',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DietaryRestrictions = 'dietaryRestrictions',
  /** column name */
  Disabilities = 'disabilities',
  /** column name */
  Dob = 'dob',
  /** column name */
  Go1Id = 'go1Id',
  /** column name */
  Go1Profile = 'go1_profile',
  /** column name */
  Id = 'id',
  /** column name */
  Imported = 'imported',
  /** column name */
  JobTitle = 'jobTitle',
  /** column name */
  LastActivity = 'lastActivity',
  /** column name */
  OriginalRecord = 'original_record',
  /** column name */
  PhoneCountryCode = 'phoneCountryCode',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  Tags = 'tags',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedFamilyName = 'translated_family_name',
  /** column name */
  TranslatedGivenName = 'translated_given_name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "profile" */
export type Profile_Set_Input = {
  _email?: InputMaybe<Scalars['String']>;
  _family_name?: InputMaybe<Scalars['String']>;
  _given_name?: InputMaybe<Scalars['String']>;
  _phone?: InputMaybe<Scalars['String']>;
  account_confirmed?: InputMaybe<Scalars['Boolean']>;
  addresses?: InputMaybe<Scalars['jsonb']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  avatar?: InputMaybe<Scalars['String']>;
  canAccessKnowledgeHub?: InputMaybe<Scalars['Boolean']>;
  contactDetails?: InputMaybe<Scalars['jsonb']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dietaryRestrictions?: InputMaybe<Scalars['String']>;
  disabilities?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['date']>;
  go1Id?: InputMaybe<Scalars['Int']>;
  go1_profile?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  imported?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastActivity?: InputMaybe<Scalars['timestamptz']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
  translated_family_name?: InputMaybe<Scalars['String']>;
  translated_given_name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Profile_Stddev_Fields = {
  __typename?: 'profile_stddev_fields';
  go1Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Profile_Stddev_Pop_Fields = {
  __typename?: 'profile_stddev_pop_fields';
  go1Id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Profile_Stddev_Samp_Fields = {
  __typename?: 'profile_stddev_samp_fields';
  go1Id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "profile" */
export type Profile_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Profile_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Profile_Stream_Cursor_Value_Input = {
  _email?: InputMaybe<Scalars['String']>;
  _family_name?: InputMaybe<Scalars['String']>;
  _given_name?: InputMaybe<Scalars['String']>;
  _phone?: InputMaybe<Scalars['String']>;
  account_confirmed?: InputMaybe<Scalars['Boolean']>;
  addresses?: InputMaybe<Scalars['jsonb']>;
  archived?: InputMaybe<Scalars['Boolean']>;
  attributes?: InputMaybe<Scalars['jsonb']>;
  avatar?: InputMaybe<Scalars['String']>;
  canAccessKnowledgeHub?: InputMaybe<Scalars['Boolean']>;
  contactDetails?: InputMaybe<Scalars['jsonb']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dietaryRestrictions?: InputMaybe<Scalars['String']>;
  disabilities?: InputMaybe<Scalars['String']>;
  dob?: InputMaybe<Scalars['date']>;
  go1Id?: InputMaybe<Scalars['Int']>;
  go1_profile?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  imported?: InputMaybe<Scalars['Boolean']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  lastActivity?: InputMaybe<Scalars['timestamptz']>;
  original_record?: InputMaybe<Scalars['jsonb']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  preferences?: InputMaybe<Scalars['jsonb']>;
  stripe_customer_id?: InputMaybe<Scalars['String']>;
  tags?: InputMaybe<Scalars['jsonb']>;
  title?: InputMaybe<Scalars['String']>;
  translated_family_name?: InputMaybe<Scalars['String']>;
  translated_given_name?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Profile_Sum_Fields = {
  __typename?: 'profile_sum_fields';
  go1Id?: Maybe<Scalars['Int']>;
};

/** Contains partial temporary profiles until account in cognito is confirmed */
export type Profile_Temp = {
  __typename?: 'profile_temp';
  acceptTnc: Scalars['Boolean'];
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  /** An object relationship */
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']>;
  createdAt: Scalars['timestamptz'];
  dob?: Maybe<Scalars['date']>;
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['Int'];
  jobTitle?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  sector?: Maybe<Scalars['String']>;
};

/** aggregated selection of "profile_temp" */
export type Profile_Temp_Aggregate = {
  __typename?: 'profile_temp_aggregate';
  aggregate?: Maybe<Profile_Temp_Aggregate_Fields>;
  nodes: Array<Profile_Temp>;
};

/** aggregate fields of "profile_temp" */
export type Profile_Temp_Aggregate_Fields = {
  __typename?: 'profile_temp_aggregate_fields';
  avg?: Maybe<Profile_Temp_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Profile_Temp_Max_Fields>;
  min?: Maybe<Profile_Temp_Min_Fields>;
  stddev?: Maybe<Profile_Temp_Stddev_Fields>;
  stddev_pop?: Maybe<Profile_Temp_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Profile_Temp_Stddev_Samp_Fields>;
  sum?: Maybe<Profile_Temp_Sum_Fields>;
  var_pop?: Maybe<Profile_Temp_Var_Pop_Fields>;
  var_samp?: Maybe<Profile_Temp_Var_Samp_Fields>;
  variance?: Maybe<Profile_Temp_Variance_Fields>;
};


/** aggregate fields of "profile_temp" */
export type Profile_Temp_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Profile_Temp_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Profile_Temp_Avg_Fields = {
  __typename?: 'profile_temp_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "profile_temp". All fields are combined with a logical 'AND'. */
export type Profile_Temp_Bool_Exp = {
  _and?: InputMaybe<Array<Profile_Temp_Bool_Exp>>;
  _not?: InputMaybe<Profile_Temp_Bool_Exp>;
  _or?: InputMaybe<Array<Profile_Temp_Bool_Exp>>;
  acceptTnc?: InputMaybe<Boolean_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  countryCode?: InputMaybe<String_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  dob?: InputMaybe<Date_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  familyName?: InputMaybe<String_Comparison_Exp>;
  givenName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Int_Comparison_Exp>;
  jobTitle?: InputMaybe<String_Comparison_Exp>;
  organizationId?: InputMaybe<Uuid_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
  phoneCountryCode?: InputMaybe<String_Comparison_Exp>;
  quantity?: InputMaybe<Int_Comparison_Exp>;
  sector?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "profile_temp" */
export enum Profile_Temp_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProfileTempPkey = 'profile_temp_pkey'
}

/** input type for incrementing numeric columns in table "profile_temp" */
export type Profile_Temp_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['Int']>;
  quantity?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "profile_temp" */
export type Profile_Temp_Insert_Input = {
  acceptTnc?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dob?: InputMaybe<Scalars['date']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sector?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Profile_Temp_Max_Fields = {
  __typename?: 'profile_temp_max_fields';
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dob?: Maybe<Scalars['date']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jobTitle?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  sector?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Profile_Temp_Min_Fields = {
  __typename?: 'profile_temp_min_fields';
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  dob?: Maybe<Scalars['date']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['Int']>;
  jobTitle?: Maybe<Scalars['String']>;
  organizationId?: Maybe<Scalars['uuid']>;
  phone?: Maybe<Scalars['String']>;
  phoneCountryCode?: Maybe<Scalars['String']>;
  quantity?: Maybe<Scalars['Int']>;
  sector?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "profile_temp" */
export type Profile_Temp_Mutation_Response = {
  __typename?: 'profile_temp_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Profile_Temp>;
};

/** on_conflict condition type for table "profile_temp" */
export type Profile_Temp_On_Conflict = {
  constraint: Profile_Temp_Constraint;
  update_columns?: Array<Profile_Temp_Update_Column>;
  where?: InputMaybe<Profile_Temp_Bool_Exp>;
};

/** Ordering options when selecting data from "profile_temp". */
export type Profile_Temp_Order_By = {
  acceptTnc?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  countryCode?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  dob?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  familyName?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  jobTitle?: InputMaybe<Order_By>;
  organizationId?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
  phoneCountryCode?: InputMaybe<Order_By>;
  quantity?: InputMaybe<Order_By>;
  sector?: InputMaybe<Order_By>;
};

/** primary key columns input for table: profile_temp */
export type Profile_Temp_Pk_Columns_Input = {
  id: Scalars['Int'];
};

/** select columns of table "profile_temp" */
export enum Profile_Temp_Select_Column {
  /** column name */
  AcceptTnc = 'acceptTnc',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitle = 'jobTitle',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhoneCountryCode = 'phoneCountryCode',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Sector = 'sector'
}

/** input type for updating data in table "profile_temp" */
export type Profile_Temp_Set_Input = {
  acceptTnc?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dob?: InputMaybe<Scalars['date']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sector?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Profile_Temp_Stddev_Fields = {
  __typename?: 'profile_temp_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Profile_Temp_Stddev_Pop_Fields = {
  __typename?: 'profile_temp_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Profile_Temp_Stddev_Samp_Fields = {
  __typename?: 'profile_temp_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "profile_temp" */
export type Profile_Temp_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Profile_Temp_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Profile_Temp_Stream_Cursor_Value_Input = {
  acceptTnc?: InputMaybe<Scalars['Boolean']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  dob?: InputMaybe<Scalars['date']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['Int']>;
  jobTitle?: InputMaybe<Scalars['String']>;
  organizationId?: InputMaybe<Scalars['uuid']>;
  phone?: InputMaybe<Scalars['String']>;
  phoneCountryCode?: InputMaybe<Scalars['String']>;
  quantity?: InputMaybe<Scalars['Int']>;
  sector?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Profile_Temp_Sum_Fields = {
  __typename?: 'profile_temp_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['Int']>;
  quantity?: Maybe<Scalars['Int']>;
};

/** update columns of table "profile_temp" */
export enum Profile_Temp_Update_Column {
  /** column name */
  AcceptTnc = 'acceptTnc',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Dob = 'dob',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  JobTitle = 'jobTitle',
  /** column name */
  OrganizationId = 'organizationId',
  /** column name */
  Phone = 'phone',
  /** column name */
  PhoneCountryCode = 'phoneCountryCode',
  /** column name */
  Quantity = 'quantity',
  /** column name */
  Sector = 'sector'
}

export type Profile_Temp_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Profile_Temp_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Profile_Temp_Set_Input>;
  /** filter the rows which have to be updated */
  where: Profile_Temp_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Profile_Temp_Var_Pop_Fields = {
  __typename?: 'profile_temp_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Profile_Temp_Var_Samp_Fields = {
  __typename?: 'profile_temp_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Profile_Temp_Variance_Fields = {
  __typename?: 'profile_temp_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
  id?: Maybe<Scalars['Float']>;
  quantity?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type = {
  __typename?: 'profile_trainer_agreement_type';
  agreement_type: Trainer_Agreement_Type_Enum;
  id: Scalars['uuid'];
  profile_id: Scalars['uuid'];
};

/** aggregated selection of "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type_Aggregate = {
  __typename?: 'profile_trainer_agreement_type_aggregate';
  aggregate?: Maybe<Profile_Trainer_Agreement_Type_Aggregate_Fields>;
  nodes: Array<Profile_Trainer_Agreement_Type>;
};

export type Profile_Trainer_Agreement_Type_Aggregate_Bool_Exp = {
  count?: InputMaybe<Profile_Trainer_Agreement_Type_Aggregate_Bool_Exp_Count>;
};

export type Profile_Trainer_Agreement_Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Profile_Trainer_Agreement_Type_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type_Aggregate_Fields = {
  __typename?: 'profile_trainer_agreement_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Profile_Trainer_Agreement_Type_Max_Fields>;
  min?: Maybe<Profile_Trainer_Agreement_Type_Min_Fields>;
};


/** aggregate fields of "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Profile_Trainer_Agreement_Type_Max_Order_By>;
  min?: InputMaybe<Profile_Trainer_Agreement_Type_Min_Order_By>;
};

/** input type for inserting array relation for remote table "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type_Arr_Rel_Insert_Input = {
  data: Array<Profile_Trainer_Agreement_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Profile_Trainer_Agreement_Type_On_Conflict>;
};

/** Boolean expression to filter rows from the table "profile_trainer_agreement_type". All fields are combined with a logical 'AND'. */
export type Profile_Trainer_Agreement_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Bool_Exp>>;
  _not?: InputMaybe<Profile_Trainer_Agreement_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Bool_Exp>>;
  agreement_type?: InputMaybe<Trainer_Agreement_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "profile_trainer_agreement_type" */
export enum Profile_Trainer_Agreement_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProfileTrainerAgreementTypePkey = 'profile_trainer_agreement_type_pkey'
}

/** input type for inserting data into table "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type_Insert_Input = {
  agreement_type?: InputMaybe<Trainer_Agreement_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Profile_Trainer_Agreement_Type_Max_Fields = {
  __typename?: 'profile_trainer_agreement_type_max_fields';
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type_Max_Order_By = {
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Profile_Trainer_Agreement_Type_Min_Fields = {
  __typename?: 'profile_trainer_agreement_type_min_fields';
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type_Min_Order_By = {
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type_Mutation_Response = {
  __typename?: 'profile_trainer_agreement_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Profile_Trainer_Agreement_Type>;
};

/** on_conflict condition type for table "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type_On_Conflict = {
  constraint: Profile_Trainer_Agreement_Type_Constraint;
  update_columns?: Array<Profile_Trainer_Agreement_Type_Update_Column>;
  where?: InputMaybe<Profile_Trainer_Agreement_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "profile_trainer_agreement_type". */
export type Profile_Trainer_Agreement_Type_Order_By = {
  agreement_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: profile_trainer_agreement_type */
export type Profile_Trainer_Agreement_Type_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "profile_trainer_agreement_type" */
export enum Profile_Trainer_Agreement_Type_Select_Column {
  /** column name */
  AgreementType = 'agreement_type',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id'
}

/** input type for updating data in table "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type_Set_Input = {
  agreement_type?: InputMaybe<Trainer_Agreement_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "profile_trainer_agreement_type" */
export type Profile_Trainer_Agreement_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Profile_Trainer_Agreement_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Profile_Trainer_Agreement_Type_Stream_Cursor_Value_Input = {
  agreement_type?: InputMaybe<Trainer_Agreement_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "profile_trainer_agreement_type" */
export enum Profile_Trainer_Agreement_Type_Update_Column {
  /** column name */
  AgreementType = 'agreement_type',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id'
}

export type Profile_Trainer_Agreement_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Profile_Trainer_Agreement_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Profile_Trainer_Agreement_Type_Bool_Exp;
};

/** columns and relationships of "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type = {
  __typename?: 'profile_trainer_role_type';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  profile_id: Scalars['uuid'];
  /** An object relationship */
  trainer_role_type: Trainer_Role_Type;
  trainer_role_type_id: Scalars['uuid'];
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type_Aggregate = {
  __typename?: 'profile_trainer_role_type_aggregate';
  aggregate?: Maybe<Profile_Trainer_Role_Type_Aggregate_Fields>;
  nodes: Array<Profile_Trainer_Role_Type>;
};

export type Profile_Trainer_Role_Type_Aggregate_Bool_Exp = {
  count?: InputMaybe<Profile_Trainer_Role_Type_Aggregate_Bool_Exp_Count>;
};

export type Profile_Trainer_Role_Type_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Profile_Trainer_Role_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type_Aggregate_Fields = {
  __typename?: 'profile_trainer_role_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Profile_Trainer_Role_Type_Max_Fields>;
  min?: Maybe<Profile_Trainer_Role_Type_Min_Fields>;
};


/** aggregate fields of "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Profile_Trainer_Role_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Profile_Trainer_Role_Type_Max_Order_By>;
  min?: InputMaybe<Profile_Trainer_Role_Type_Min_Order_By>;
};

/** input type for inserting array relation for remote table "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type_Arr_Rel_Insert_Input = {
  data: Array<Profile_Trainer_Role_Type_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Profile_Trainer_Role_Type_On_Conflict>;
};

/** Boolean expression to filter rows from the table "profile_trainer_role_type". All fields are combined with a logical 'AND'. */
export type Profile_Trainer_Role_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Profile_Trainer_Role_Type_Bool_Exp>>;
  _not?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Profile_Trainer_Role_Type_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  trainer_role_type?: InputMaybe<Trainer_Role_Type_Bool_Exp>;
  trainer_role_type_id?: InputMaybe<Uuid_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "profile_trainer_role_type" */
export enum Profile_Trainer_Role_Type_Constraint {
  /** unique or primary key constraint on columns "id" */
  ProfileTrainerRoleTypePkey = 'profile_trainer_role_type_pkey'
}

/** input type for inserting data into table "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  trainer_role_type?: InputMaybe<Trainer_Role_Type_Obj_Rel_Insert_Input>;
  trainer_role_type_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Profile_Trainer_Role_Type_Max_Fields = {
  __typename?: 'profile_trainer_role_type_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  trainer_role_type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  trainer_role_type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Profile_Trainer_Role_Type_Min_Fields = {
  __typename?: 'profile_trainer_role_type_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  trainer_role_type_id?: Maybe<Scalars['uuid']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  trainer_role_type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type_Mutation_Response = {
  __typename?: 'profile_trainer_role_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Profile_Trainer_Role_Type>;
};

/** on_conflict condition type for table "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type_On_Conflict = {
  constraint: Profile_Trainer_Role_Type_Constraint;
  update_columns?: Array<Profile_Trainer_Role_Type_Update_Column>;
  where?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "profile_trainer_role_type". */
export type Profile_Trainer_Role_Type_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  trainer_role_type?: InputMaybe<Trainer_Role_Type_Order_By>;
  trainer_role_type_id?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: profile_trainer_role_type */
export type Profile_Trainer_Role_Type_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "profile_trainer_role_type" */
export enum Profile_Trainer_Role_Type_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  TrainerRoleTypeId = 'trainer_role_type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  trainer_role_type_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "profile_trainer_role_type" */
export type Profile_Trainer_Role_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Profile_Trainer_Role_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Profile_Trainer_Role_Type_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  trainer_role_type_id?: InputMaybe<Scalars['uuid']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "profile_trainer_role_type" */
export enum Profile_Trainer_Role_Type_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  TrainerRoleTypeId = 'trainer_role_type_id',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Profile_Trainer_Role_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Profile_Trainer_Role_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Profile_Trainer_Role_Type_Bool_Exp;
};

/** update columns of table "profile" */
export enum Profile_Update_Column {
  /** column name */
  Email = '_email',
  /** column name */
  FamilyName = '_family_name',
  /** column name */
  GivenName = '_given_name',
  /** column name */
  Phone = '_phone',
  /** column name */
  AccountConfirmed = 'account_confirmed',
  /** column name */
  Addresses = 'addresses',
  /** column name */
  Archived = 'archived',
  /** column name */
  Attributes = 'attributes',
  /** column name */
  Avatar = 'avatar',
  /** column name */
  CanAccessKnowledgeHub = 'canAccessKnowledgeHub',
  /** column name */
  ContactDetails = 'contactDetails',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  DietaryRestrictions = 'dietaryRestrictions',
  /** column name */
  Disabilities = 'disabilities',
  /** column name */
  Dob = 'dob',
  /** column name */
  Go1Id = 'go1Id',
  /** column name */
  Go1Profile = 'go1_profile',
  /** column name */
  Id = 'id',
  /** column name */
  Imported = 'imported',
  /** column name */
  JobTitle = 'jobTitle',
  /** column name */
  LastActivity = 'lastActivity',
  /** column name */
  OriginalRecord = 'original_record',
  /** column name */
  PhoneCountryCode = 'phoneCountryCode',
  /** column name */
  Preferences = 'preferences',
  /** column name */
  StripeCustomerId = 'stripe_customer_id',
  /** column name */
  Tags = 'tags',
  /** column name */
  Title = 'title',
  /** column name */
  TranslatedFamilyName = 'translated_family_name',
  /** column name */
  TranslatedGivenName = 'translated_given_name',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Profile_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Profile_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Profile_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Profile_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Profile_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Profile_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Profile_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Profile_Set_Input>;
  /** filter the rows which have to be updated */
  where: Profile_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Profile_Var_Pop_Fields = {
  __typename?: 'profile_var_pop_fields';
  go1Id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Profile_Var_Samp_Fields = {
  __typename?: 'profile_var_samp_fields';
  go1Id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Profile_Variance_Fields = {
  __typename?: 'profile_variance_fields';
  go1Id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "promo_code" */
export type Promo_Code = {
  __typename?: 'promo_code';
  amount: Scalars['numeric'];
  approvedBy?: Maybe<Scalars['uuid']>;
  /** An object relationship */
  approver?: Maybe<Profile>;
  bookerSingleUse: Scalars['Boolean'];
  code: Scalars['String'];
  /** An array relationship */
  courses: Array<Course_Promo_Code>;
  /** An aggregate relationship */
  courses_aggregate: Course_Promo_Code_Aggregate;
  createdAt: Scalars['timestamptz'];
  createdBy: Scalars['uuid'];
  /** An object relationship */
  creator: Profile;
  deniedBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  disabled: Scalars['Boolean'];
  enabled: Scalars['Boolean'];
  id: Scalars['uuid'];
  levels: Scalars['jsonb'];
  type: Promo_Code_Type_Enum;
  updatedAt: Scalars['timestamptz'];
  usesMax?: Maybe<Scalars['numeric']>;
  validFrom: Scalars['timestamptz'];
  validTo?: Maybe<Scalars['timestamptz']>;
};


/** columns and relationships of "promo_code" */
export type Promo_CodeCoursesArgs = {
  distinct_on?: InputMaybe<Array<Course_Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Promo_Code_Order_By>>;
  where?: InputMaybe<Course_Promo_Code_Bool_Exp>;
};


/** columns and relationships of "promo_code" */
export type Promo_CodeCourses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Promo_Code_Order_By>>;
  where?: InputMaybe<Course_Promo_Code_Bool_Exp>;
};


/** columns and relationships of "promo_code" */
export type Promo_CodeLevelsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "promo_code" */
export type Promo_Code_Aggregate = {
  __typename?: 'promo_code_aggregate';
  aggregate?: Maybe<Promo_Code_Aggregate_Fields>;
  nodes: Array<Promo_Code>;
};

/** aggregate fields of "promo_code" */
export type Promo_Code_Aggregate_Fields = {
  __typename?: 'promo_code_aggregate_fields';
  avg?: Maybe<Promo_Code_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Promo_Code_Max_Fields>;
  min?: Maybe<Promo_Code_Min_Fields>;
  stddev?: Maybe<Promo_Code_Stddev_Fields>;
  stddev_pop?: Maybe<Promo_Code_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Promo_Code_Stddev_Samp_Fields>;
  sum?: Maybe<Promo_Code_Sum_Fields>;
  var_pop?: Maybe<Promo_Code_Var_Pop_Fields>;
  var_samp?: Maybe<Promo_Code_Var_Samp_Fields>;
  variance?: Maybe<Promo_Code_Variance_Fields>;
};


/** aggregate fields of "promo_code" */
export type Promo_Code_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Promo_Code_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Promo_Code_Append_Input = {
  levels?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Promo_Code_Avg_Fields = {
  __typename?: 'promo_code_avg_fields';
  amount?: Maybe<Scalars['Float']>;
  usesMax?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "promo_code". All fields are combined with a logical 'AND'. */
export type Promo_Code_Bool_Exp = {
  _and?: InputMaybe<Array<Promo_Code_Bool_Exp>>;
  _not?: InputMaybe<Promo_Code_Bool_Exp>;
  _or?: InputMaybe<Array<Promo_Code_Bool_Exp>>;
  amount?: InputMaybe<Numeric_Comparison_Exp>;
  approvedBy?: InputMaybe<Uuid_Comparison_Exp>;
  approver?: InputMaybe<Profile_Bool_Exp>;
  bookerSingleUse?: InputMaybe<Boolean_Comparison_Exp>;
  code?: InputMaybe<String_Comparison_Exp>;
  courses?: InputMaybe<Course_Promo_Code_Bool_Exp>;
  courses_aggregate?: InputMaybe<Course_Promo_Code_Aggregate_Bool_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  createdBy?: InputMaybe<Uuid_Comparison_Exp>;
  creator?: InputMaybe<Profile_Bool_Exp>;
  deniedBy?: InputMaybe<Uuid_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  disabled?: InputMaybe<Boolean_Comparison_Exp>;
  enabled?: InputMaybe<Boolean_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  levels?: InputMaybe<Jsonb_Comparison_Exp>;
  type?: InputMaybe<Promo_Code_Type_Enum_Comparison_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  usesMax?: InputMaybe<Numeric_Comparison_Exp>;
  validFrom?: InputMaybe<Timestamptz_Comparison_Exp>;
  validTo?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "promo_code" */
export enum Promo_Code_Constraint {
  /** unique or primary key constraint on columns "code" */
  PromoCodeCodeKey = 'promo_code_code_key',
  /** unique or primary key constraint on columns "id" */
  PromoCodePkey = 'promo_code_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Promo_Code_Delete_At_Path_Input = {
  levels?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Promo_Code_Delete_Elem_Input = {
  levels?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Promo_Code_Delete_Key_Input = {
  levels?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "promo_code" */
export type Promo_Code_Inc_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  usesMax?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "promo_code" */
export type Promo_Code_Insert_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  approvedBy?: InputMaybe<Scalars['uuid']>;
  approver?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  bookerSingleUse?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  courses?: InputMaybe<Course_Promo_Code_Arr_Rel_Insert_Input>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  creator?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  deniedBy?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  levels?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Promo_Code_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usesMax?: InputMaybe<Scalars['numeric']>;
  validFrom?: InputMaybe<Scalars['timestamptz']>;
  validTo?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Promo_Code_Max_Fields = {
  __typename?: 'promo_code_max_fields';
  amount?: Maybe<Scalars['numeric']>;
  approvedBy?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  deniedBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usesMax?: Maybe<Scalars['numeric']>;
  validFrom?: Maybe<Scalars['timestamptz']>;
  validTo?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Promo_Code_Min_Fields = {
  __typename?: 'promo_code_min_fields';
  amount?: Maybe<Scalars['numeric']>;
  approvedBy?: Maybe<Scalars['uuid']>;
  code?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  createdBy?: Maybe<Scalars['uuid']>;
  deniedBy?: Maybe<Scalars['uuid']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
  usesMax?: Maybe<Scalars['numeric']>;
  validFrom?: Maybe<Scalars['timestamptz']>;
  validTo?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "promo_code" */
export type Promo_Code_Mutation_Response = {
  __typename?: 'promo_code_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Promo_Code>;
};

/** input type for inserting object relation for remote table "promo_code" */
export type Promo_Code_Obj_Rel_Insert_Input = {
  data: Promo_Code_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Promo_Code_On_Conflict>;
};

/** on_conflict condition type for table "promo_code" */
export type Promo_Code_On_Conflict = {
  constraint: Promo_Code_Constraint;
  update_columns?: Array<Promo_Code_Update_Column>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};

/** Ordering options when selecting data from "promo_code". */
export type Promo_Code_Order_By = {
  amount?: InputMaybe<Order_By>;
  approvedBy?: InputMaybe<Order_By>;
  approver?: InputMaybe<Profile_Order_By>;
  bookerSingleUse?: InputMaybe<Order_By>;
  code?: InputMaybe<Order_By>;
  courses_aggregate?: InputMaybe<Course_Promo_Code_Aggregate_Order_By>;
  createdAt?: InputMaybe<Order_By>;
  createdBy?: InputMaybe<Order_By>;
  creator?: InputMaybe<Profile_Order_By>;
  deniedBy?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  disabled?: InputMaybe<Order_By>;
  enabled?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  levels?: InputMaybe<Order_By>;
  type?: InputMaybe<Order_By>;
  updatedAt?: InputMaybe<Order_By>;
  usesMax?: InputMaybe<Order_By>;
  validFrom?: InputMaybe<Order_By>;
  validTo?: InputMaybe<Order_By>;
};

/** primary key columns input for table: promo_code */
export type Promo_Code_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Promo_Code_Prepend_Input = {
  levels?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "promo_code" */
export enum Promo_Code_Select_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ApprovedBy = 'approvedBy',
  /** column name */
  BookerSingleUse = 'bookerSingleUse',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeniedBy = 'deniedBy',
  /** column name */
  Description = 'description',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Levels = 'levels',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsesMax = 'usesMax',
  /** column name */
  ValidFrom = 'validFrom',
  /** column name */
  ValidTo = 'validTo'
}

/** input type for updating data in table "promo_code" */
export type Promo_Code_Set_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  approvedBy?: InputMaybe<Scalars['uuid']>;
  bookerSingleUse?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  deniedBy?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  levels?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Promo_Code_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usesMax?: InputMaybe<Scalars['numeric']>;
  validFrom?: InputMaybe<Scalars['timestamptz']>;
  validTo?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Promo_Code_Stddev_Fields = {
  __typename?: 'promo_code_stddev_fields';
  amount?: Maybe<Scalars['Float']>;
  usesMax?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Promo_Code_Stddev_Pop_Fields = {
  __typename?: 'promo_code_stddev_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  usesMax?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Promo_Code_Stddev_Samp_Fields = {
  __typename?: 'promo_code_stddev_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  usesMax?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "promo_code" */
export type Promo_Code_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Promo_Code_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Promo_Code_Stream_Cursor_Value_Input = {
  amount?: InputMaybe<Scalars['numeric']>;
  approvedBy?: InputMaybe<Scalars['uuid']>;
  bookerSingleUse?: InputMaybe<Scalars['Boolean']>;
  code?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  createdBy?: InputMaybe<Scalars['uuid']>;
  deniedBy?: InputMaybe<Scalars['uuid']>;
  description?: InputMaybe<Scalars['String']>;
  disabled?: InputMaybe<Scalars['Boolean']>;
  enabled?: InputMaybe<Scalars['Boolean']>;
  id?: InputMaybe<Scalars['uuid']>;
  levels?: InputMaybe<Scalars['jsonb']>;
  type?: InputMaybe<Promo_Code_Type_Enum>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
  usesMax?: InputMaybe<Scalars['numeric']>;
  validFrom?: InputMaybe<Scalars['timestamptz']>;
  validTo?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Promo_Code_Sum_Fields = {
  __typename?: 'promo_code_sum_fields';
  amount?: Maybe<Scalars['numeric']>;
  usesMax?: Maybe<Scalars['numeric']>;
};

/** columns and relationships of "promo_code_type" */
export type Promo_Code_Type = {
  __typename?: 'promo_code_type';
  name: Scalars['String'];
};

/** aggregated selection of "promo_code_type" */
export type Promo_Code_Type_Aggregate = {
  __typename?: 'promo_code_type_aggregate';
  aggregate?: Maybe<Promo_Code_Type_Aggregate_Fields>;
  nodes: Array<Promo_Code_Type>;
};

/** aggregate fields of "promo_code_type" */
export type Promo_Code_Type_Aggregate_Fields = {
  __typename?: 'promo_code_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Promo_Code_Type_Max_Fields>;
  min?: Maybe<Promo_Code_Type_Min_Fields>;
};


/** aggregate fields of "promo_code_type" */
export type Promo_Code_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Promo_Code_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "promo_code_type". All fields are combined with a logical 'AND'. */
export type Promo_Code_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Promo_Code_Type_Bool_Exp>>;
  _not?: InputMaybe<Promo_Code_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Promo_Code_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "promo_code_type" */
export enum Promo_Code_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  PromoCodeTypePkey = 'promo_code_type_pkey'
}

export enum Promo_Code_Type_Enum {
  FreePlaces = 'FREE_PLACES',
  Percent = 'PERCENT'
}

/** Boolean expression to compare columns of type "promo_code_type_enum". All fields are combined with logical 'AND'. */
export type Promo_Code_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Promo_Code_Type_Enum>;
  _in?: InputMaybe<Array<Promo_Code_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Promo_Code_Type_Enum>;
  _nin?: InputMaybe<Array<Promo_Code_Type_Enum>>;
};

/** input type for inserting data into table "promo_code_type" */
export type Promo_Code_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Promo_Code_Type_Max_Fields = {
  __typename?: 'promo_code_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Promo_Code_Type_Min_Fields = {
  __typename?: 'promo_code_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "promo_code_type" */
export type Promo_Code_Type_Mutation_Response = {
  __typename?: 'promo_code_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Promo_Code_Type>;
};

/** on_conflict condition type for table "promo_code_type" */
export type Promo_Code_Type_On_Conflict = {
  constraint: Promo_Code_Type_Constraint;
  update_columns?: Array<Promo_Code_Type_Update_Column>;
  where?: InputMaybe<Promo_Code_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "promo_code_type". */
export type Promo_Code_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: promo_code_type */
export type Promo_Code_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "promo_code_type" */
export enum Promo_Code_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "promo_code_type" */
export type Promo_Code_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "promo_code_type" */
export type Promo_Code_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Promo_Code_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Promo_Code_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "promo_code_type" */
export enum Promo_Code_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Promo_Code_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Promo_Code_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Promo_Code_Type_Bool_Exp;
};

/** update columns of table "promo_code" */
export enum Promo_Code_Update_Column {
  /** column name */
  Amount = 'amount',
  /** column name */
  ApprovedBy = 'approvedBy',
  /** column name */
  BookerSingleUse = 'bookerSingleUse',
  /** column name */
  Code = 'code',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  CreatedBy = 'createdBy',
  /** column name */
  DeniedBy = 'deniedBy',
  /** column name */
  Description = 'description',
  /** column name */
  Disabled = 'disabled',
  /** column name */
  Enabled = 'enabled',
  /** column name */
  Id = 'id',
  /** column name */
  Levels = 'levels',
  /** column name */
  Type = 'type',
  /** column name */
  UpdatedAt = 'updatedAt',
  /** column name */
  UsesMax = 'usesMax',
  /** column name */
  ValidFrom = 'validFrom',
  /** column name */
  ValidTo = 'validTo'
}

export type Promo_Code_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Promo_Code_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Promo_Code_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Promo_Code_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Promo_Code_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Promo_Code_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Promo_Code_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Promo_Code_Set_Input>;
  /** filter the rows which have to be updated */
  where: Promo_Code_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Promo_Code_Var_Pop_Fields = {
  __typename?: 'promo_code_var_pop_fields';
  amount?: Maybe<Scalars['Float']>;
  usesMax?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Promo_Code_Var_Samp_Fields = {
  __typename?: 'promo_code_var_samp_fields';
  amount?: Maybe<Scalars['Float']>;
  usesMax?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Promo_Code_Variance_Fields = {
  __typename?: 'promo_code_variance_fields';
  amount?: Maybe<Scalars['Float']>;
  usesMax?: Maybe<Scalars['Float']>;
};

export type Query_Root = {
  __typename?: 'query_root';
  /** fetch data from the table: "about_training_email_scheduled_events" */
  about_training_email_scheduled_events: Array<About_Training_Email_Scheduled_Events>;
  /** fetch aggregated fields from the table: "about_training_email_scheduled_events" */
  about_training_email_scheduled_events_aggregate: About_Training_Email_Scheduled_Events_Aggregate;
  /** fetch data from the table: "about_training_email_scheduled_events" using primary key columns */
  about_training_email_scheduled_events_by_pk?: Maybe<About_Training_Email_Scheduled_Events>;
  /** fetch data from the table: "absorb_enrolment" */
  absorb_enrolment: Array<Absorb_Enrolment>;
  /** fetch aggregated fields from the table: "absorb_enrolment" */
  absorb_enrolment_aggregate: Absorb_Enrolment_Aggregate;
  /** fetch data from the table: "absorb_enrolment" using primary key columns */
  absorb_enrolment_by_pk?: Maybe<Absorb_Enrolment>;
  /** fetch data from the table: "accreditors" */
  accreditors: Array<Accreditors>;
  /** fetch aggregated fields from the table: "accreditors" */
  accreditors_aggregate: Accreditors_Aggregate;
  /** fetch data from the table: "accreditors" using primary key columns */
  accreditors_by_pk?: Maybe<Accreditors>;
  /** fetch data from the table: "availability" */
  availability: Array<Availability>;
  /** fetch aggregated fields from the table: "availability" */
  availability_aggregate: Availability_Aggregate;
  /** fetch data from the table: "availability" using primary key columns */
  availability_by_pk?: Maybe<Availability>;
  /** fetch data from the table: "bild_strategy" */
  bild_strategy: Array<Bild_Strategy>;
  /** fetch aggregated fields from the table: "bild_strategy" */
  bild_strategy_aggregate: Bild_Strategy_Aggregate;
  /** fetch data from the table: "bild_strategy" using primary key columns */
  bild_strategy_by_pk?: Maybe<Bild_Strategy>;
  /** fetch data from the table: "blended_learning_status" */
  blended_learning_status: Array<Blended_Learning_Status>;
  /** fetch aggregated fields from the table: "blended_learning_status" */
  blended_learning_status_aggregate: Blended_Learning_Status_Aggregate;
  /** fetch data from the table: "blended_learning_status" using primary key columns */
  blended_learning_status_by_pk?: Maybe<Blended_Learning_Status>;
  /** Checks whether a promo code can be applied to a given course by the current user */
  canApplyPromoCode: CanApplyPromoCodeOutput;
  /** fetch data from the table: "certificate_expired_notification_jobs" */
  certificate_expired_notification_jobs: Array<Certificate_Expired_Notification_Jobs>;
  /** fetch aggregated fields from the table: "certificate_expired_notification_jobs" */
  certificate_expired_notification_jobs_aggregate: Certificate_Expired_Notification_Jobs_Aggregate;
  /** fetch data from the table: "certificate_expired_notification_jobs" using primary key columns */
  certificate_expired_notification_jobs_by_pk?: Maybe<Certificate_Expired_Notification_Jobs>;
  /** fetch data from the table: "certificate_expiry_notification_jobs" */
  certificate_expiry_notification_jobs: Array<Certificate_Expiry_Notification_Jobs>;
  /** fetch aggregated fields from the table: "certificate_expiry_notification_jobs" */
  certificate_expiry_notification_jobs_aggregate: Certificate_Expiry_Notification_Jobs_Aggregate;
  /** fetch data from the table: "certificate_expiry_notification_jobs" using primary key columns */
  certificate_expiry_notification_jobs_by_pk?: Maybe<Certificate_Expiry_Notification_Jobs>;
  /** fetch data from the table: "certificate_expiry_notification_timeframe" */
  certificate_expiry_notification_timeframe: Array<Certificate_Expiry_Notification_Timeframe>;
  /** fetch aggregated fields from the table: "certificate_expiry_notification_timeframe" */
  certificate_expiry_notification_timeframe_aggregate: Certificate_Expiry_Notification_Timeframe_Aggregate;
  /** fetch data from the table: "certificate_expiry_notification_timeframe" using primary key columns */
  certificate_expiry_notification_timeframe_by_pk?: Maybe<Certificate_Expiry_Notification_Timeframe>;
  /** fetch data from the table: "certificate_status" */
  certificate_status: Array<Certificate_Status>;
  /** fetch aggregated fields from the table: "certificate_status" */
  certificate_status_aggregate: Certificate_Status_Aggregate;
  /** fetch data from the table: "certificate_status" using primary key columns */
  certificate_status_by_pk?: Maybe<Certificate_Status>;
  /** This action will check which emails are TT clients and which are not out of a list of given emails */
  checkTTClients?: Maybe<CheckTtClientsOutput>;
  /** fetch data from the table: "color" */
  color: Array<Color>;
  /** fetch aggregated fields from the table: "color" */
  color_aggregate: Color_Aggregate;
  /** fetch data from the table: "color" using primary key columns */
  color_by_pk?: Maybe<Color>;
  content?: Maybe<ContentRootQuery>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "country_region" */
  country_region: Array<Country_Region>;
  /** fetch aggregated fields from the table: "country_region" */
  country_region_aggregate: Country_Region_Aggregate;
  /** fetch data from the table: "country_region" using primary key columns */
  country_region_by_pk?: Maybe<Country_Region>;
  /** fetch data from the table: "course" */
  course: Array<Course>;
  /** fetch aggregated fields from the table: "course" */
  course_aggregate: Course_Aggregate;
  /** fetch data from the table: "course_audit" */
  course_audit: Array<Course_Audit>;
  /** fetch aggregated fields from the table: "course_audit" */
  course_audit_aggregate: Course_Audit_Aggregate;
  /** fetch data from the table: "course_audit" using primary key columns */
  course_audit_by_pk?: Maybe<Course_Audit>;
  /** fetch data from the table: "course_audit_type" */
  course_audit_type: Array<Course_Audit_Type>;
  /** fetch aggregated fields from the table: "course_audit_type" */
  course_audit_type_aggregate: Course_Audit_Type_Aggregate;
  /** fetch data from the table: "course_audit_type" using primary key columns */
  course_audit_type_by_pk?: Maybe<Course_Audit_Type>;
  /** fetch data from the table: "course_bild_module" */
  course_bild_module: Array<Course_Bild_Module>;
  /** fetch aggregated fields from the table: "course_bild_module" */
  course_bild_module_aggregate: Course_Bild_Module_Aggregate;
  /** fetch data from the table: "course_bild_module" using primary key columns */
  course_bild_module_by_pk?: Maybe<Course_Bild_Module>;
  /** fetch data from the table: "course_bild_strategy" */
  course_bild_strategy: Array<Course_Bild_Strategy>;
  /** fetch aggregated fields from the table: "course_bild_strategy" */
  course_bild_strategy_aggregate: Course_Bild_Strategy_Aggregate;
  /** fetch data from the table: "course_bild_strategy" using primary key columns */
  course_bild_strategy_by_pk?: Maybe<Course_Bild_Strategy>;
  /** fetch data from the table: "course" using primary key columns */
  course_by_pk?: Maybe<Course>;
  /** fetch data from the table: "course_cancellation_fee_type" */
  course_cancellation_fee_type: Array<Course_Cancellation_Fee_Type>;
  /** fetch aggregated fields from the table: "course_cancellation_fee_type" */
  course_cancellation_fee_type_aggregate: Course_Cancellation_Fee_Type_Aggregate;
  /** fetch data from the table: "course_cancellation_fee_type" using primary key columns */
  course_cancellation_fee_type_by_pk?: Maybe<Course_Cancellation_Fee_Type>;
  /** fetch data from the table: "course_cancellation_request" */
  course_cancellation_request: Array<Course_Cancellation_Request>;
  /** fetch aggregated fields from the table: "course_cancellation_request" */
  course_cancellation_request_aggregate: Course_Cancellation_Request_Aggregate;
  /** fetch data from the table: "course_cancellation_request" using primary key columns */
  course_cancellation_request_by_pk?: Maybe<Course_Cancellation_Request>;
  /** fetch data from the table: "course_certificate" */
  course_certificate: Array<Course_Certificate>;
  /** fetch aggregated fields from the table: "course_certificate" */
  course_certificate_aggregate: Course_Certificate_Aggregate;
  /** fetch data from the table: "course_certificate" using primary key columns */
  course_certificate_by_pk?: Maybe<Course_Certificate>;
  /** fetch data from the table: "course_certificate_changelog" */
  course_certificate_changelog: Array<Course_Certificate_Changelog>;
  /** fetch aggregated fields from the table: "course_certificate_changelog" */
  course_certificate_changelog_aggregate: Course_Certificate_Changelog_Aggregate;
  /** fetch data from the table: "course_certificate_changelog" using primary key columns */
  course_certificate_changelog_by_pk?: Maybe<Course_Certificate_Changelog>;
  /** fetch data from the table: "course_certificate_changelog_type" */
  course_certificate_changelog_type: Array<Course_Certificate_Changelog_Type>;
  /** fetch aggregated fields from the table: "course_certificate_changelog_type" */
  course_certificate_changelog_type_aggregate: Course_Certificate_Changelog_Type_Aggregate;
  /** fetch data from the table: "course_certificate_changelog_type" using primary key columns */
  course_certificate_changelog_type_by_pk?: Maybe<Course_Certificate_Changelog_Type>;
  /** fetch data from the table: "course_certificate_hold_request" */
  course_certificate_hold_request: Array<Course_Certificate_Hold_Request>;
  /** fetch aggregated fields from the table: "course_certificate_hold_request" */
  course_certificate_hold_request_aggregate: Course_Certificate_Hold_Request_Aggregate;
  /** fetch data from the table: "course_certificate_hold_request" using primary key columns */
  course_certificate_hold_request_by_pk?: Maybe<Course_Certificate_Hold_Request>;
  /** fetch data from the table: "course_delivery_type" */
  course_delivery_type: Array<Course_Delivery_Type>;
  /** fetch aggregated fields from the table: "course_delivery_type" */
  course_delivery_type_aggregate: Course_Delivery_Type_Aggregate;
  /** fetch data from the table: "course_delivery_type" using primary key columns */
  course_delivery_type_by_pk?: Maybe<Course_Delivery_Type>;
  /** fetch data from the table: "course_delivery_type_prefix" */
  course_delivery_type_prefix: Array<Course_Delivery_Type_Prefix>;
  /** fetch aggregated fields from the table: "course_delivery_type_prefix" */
  course_delivery_type_prefix_aggregate: Course_Delivery_Type_Prefix_Aggregate;
  /** fetch data from the table: "course_delivery_type_prefix" using primary key columns */
  course_delivery_type_prefix_by_pk?: Maybe<Course_Delivery_Type_Prefix>;
  /** fetch data from the table: "course_draft" */
  course_draft: Array<Course_Draft>;
  /** fetch aggregated fields from the table: "course_draft" */
  course_draft_aggregate: Course_Draft_Aggregate;
  /** fetch data from the table: "course_draft" using primary key columns */
  course_draft_by_pk?: Maybe<Course_Draft>;
  /** fetch data from the table: "course_end_jobs" */
  course_end_jobs: Array<Course_End_Jobs>;
  /** fetch aggregated fields from the table: "course_end_jobs" */
  course_end_jobs_aggregate: Course_End_Jobs_Aggregate;
  /** fetch data from the table: "course_end_jobs" using primary key columns */
  course_end_jobs_by_pk?: Maybe<Course_End_Jobs>;
  /** fetch data from the table: "course_enquiry" */
  course_enquiry: Array<Course_Enquiry>;
  /** fetch aggregated fields from the table: "course_enquiry" */
  course_enquiry_aggregate: Course_Enquiry_Aggregate;
  /** fetch data from the table: "course_enquiry" using primary key columns */
  course_enquiry_by_pk?: Maybe<Course_Enquiry>;
  /** An array relationship */
  course_evaluation_answers: Array<Course_Evaluation_Answers>;
  /** An aggregate relationship */
  course_evaluation_answers_aggregate: Course_Evaluation_Answers_Aggregate;
  /** fetch data from the table: "course_evaluation_answers" using primary key columns */
  course_evaluation_answers_by_pk?: Maybe<Course_Evaluation_Answers>;
  /** fetch data from the table: "course_evaluation_question_group" */
  course_evaluation_question_group: Array<Course_Evaluation_Question_Group>;
  /** fetch aggregated fields from the table: "course_evaluation_question_group" */
  course_evaluation_question_group_aggregate: Course_Evaluation_Question_Group_Aggregate;
  /** fetch data from the table: "course_evaluation_question_group" using primary key columns */
  course_evaluation_question_group_by_pk?: Maybe<Course_Evaluation_Question_Group>;
  /** fetch data from the table: "course_evaluation_question_type" */
  course_evaluation_question_type: Array<Course_Evaluation_Question_Type>;
  /** fetch aggregated fields from the table: "course_evaluation_question_type" */
  course_evaluation_question_type_aggregate: Course_Evaluation_Question_Type_Aggregate;
  /** fetch data from the table: "course_evaluation_question_type" using primary key columns */
  course_evaluation_question_type_by_pk?: Maybe<Course_Evaluation_Question_Type>;
  /** fetch data from the table: "course_evaluation_questions" */
  course_evaluation_questions: Array<Course_Evaluation_Questions>;
  /** fetch aggregated fields from the table: "course_evaluation_questions" */
  course_evaluation_questions_aggregate: Course_Evaluation_Questions_Aggregate;
  /** fetch data from the table: "course_evaluation_questions" using primary key columns */
  course_evaluation_questions_by_pk?: Maybe<Course_Evaluation_Questions>;
  /** fetch data from the table: "course_evaluation_scheduled_event" */
  course_evaluation_scheduled_event: Array<Course_Evaluation_Scheduled_Event>;
  /** fetch aggregated fields from the table: "course_evaluation_scheduled_event" */
  course_evaluation_scheduled_event_aggregate: Course_Evaluation_Scheduled_Event_Aggregate;
  /** fetch data from the table: "course_evaluation_scheduled_event" using primary key columns */
  course_evaluation_scheduled_event_by_pk?: Maybe<Course_Evaluation_Scheduled_Event>;
  /** fetch data from the table: "course_exception" */
  course_exception: Array<Course_Exception>;
  /** fetch aggregated fields from the table: "course_exception" */
  course_exception_aggregate: Course_Exception_Aggregate;
  /** fetch data from the table: "course_exception" using primary key columns */
  course_exception_by_pk?: Maybe<Course_Exception>;
  /** fetch data from the table: "course_exceptions" */
  course_exceptions: Array<Course_Exceptions>;
  /** fetch aggregated fields from the table: "course_exceptions" */
  course_exceptions_aggregate: Course_Exceptions_Aggregate;
  /** fetch data from the table: "course_exceptions" using primary key columns */
  course_exceptions_by_pk?: Maybe<Course_Exceptions>;
  /** fetch data from the table: "course_expenses" */
  course_expenses: Array<Course_Expenses>;
  /** fetch aggregated fields from the table: "course_expenses" */
  course_expenses_aggregate: Course_Expenses_Aggregate;
  /** fetch data from the table: "course_expenses" using primary key columns */
  course_expenses_by_pk?: Maybe<Course_Expenses>;
  /** fetch data from the table: "course_invite_status" */
  course_invite_status: Array<Course_Invite_Status>;
  /** fetch aggregated fields from the table: "course_invite_status" */
  course_invite_status_aggregate: Course_Invite_Status_Aggregate;
  /** fetch data from the table: "course_invite_status" using primary key columns */
  course_invite_status_by_pk?: Maybe<Course_Invite_Status>;
  /** An array relationship */
  course_invites: Array<Course_Invites>;
  /** An aggregate relationship */
  course_invites_aggregate: Course_Invites_Aggregate;
  /** fetch data from the table: "course_invites" using primary key columns */
  course_invites_by_pk?: Maybe<Course_Invites>;
  /** fetch data from the table: "course_level" */
  course_level: Array<Course_Level>;
  /** fetch aggregated fields from the table: "course_level" */
  course_level_aggregate: Course_Level_Aggregate;
  /** fetch data from the table: "course_level" using primary key columns */
  course_level_by_pk?: Maybe<Course_Level>;
  /** fetch data from the table: "course_level_prefix" */
  course_level_prefix: Array<Course_Level_Prefix>;
  /** fetch aggregated fields from the table: "course_level_prefix" */
  course_level_prefix_aggregate: Course_Level_Prefix_Aggregate;
  /** fetch data from the table: "course_level_prefix" using primary key columns */
  course_level_prefix_by_pk?: Maybe<Course_Level_Prefix>;
  /** fetch data from the table: "course_module" */
  course_module: Array<Course_Module>;
  /** fetch aggregated fields from the table: "course_module" */
  course_module_aggregate: Course_Module_Aggregate;
  /** fetch data from the table: "course_module" using primary key columns */
  course_module_by_pk?: Maybe<Course_Module>;
  /** fetch data from the table: "course_order" */
  course_order: Array<Course_Order>;
  /** fetch aggregated fields from the table: "course_order" */
  course_order_aggregate: Course_Order_Aggregate;
  /** fetch data from the table: "course_participant" */
  course_participant: Array<Course_Participant>;
  /** fetch aggregated fields from the table: "course_participant" */
  course_participant_aggregate: Course_Participant_Aggregate;
  /** fetch data from the table: "course_participant_audit" */
  course_participant_audit: Array<Course_Participant_Audit>;
  /** fetch aggregated fields from the table: "course_participant_audit" */
  course_participant_audit_aggregate: Course_Participant_Audit_Aggregate;
  /** fetch data from the table: "course_participant_audit" using primary key columns */
  course_participant_audit_by_pk?: Maybe<Course_Participant_Audit>;
  /** fetch data from the table: "course_participant_audit_type" */
  course_participant_audit_type: Array<Course_Participant_Audit_Type>;
  /** fetch aggregated fields from the table: "course_participant_audit_type" */
  course_participant_audit_type_aggregate: Course_Participant_Audit_Type_Aggregate;
  /** fetch data from the table: "course_participant_audit_type" using primary key columns */
  course_participant_audit_type_by_pk?: Maybe<Course_Participant_Audit_Type>;
  /** fetch data from the table: "course_participant_bild_module" */
  course_participant_bild_module: Array<Course_Participant_Bild_Module>;
  /** fetch aggregated fields from the table: "course_participant_bild_module" */
  course_participant_bild_module_aggregate: Course_Participant_Bild_Module_Aggregate;
  /** fetch data from the table: "course_participant_bild_module" using primary key columns */
  course_participant_bild_module_by_pk?: Maybe<Course_Participant_Bild_Module>;
  /** fetch data from the table: "course_participant" using primary key columns */
  course_participant_by_pk?: Maybe<Course_Participant>;
  /** fetch data from the table: "course_participant_cancellation" */
  course_participant_cancellation: Array<Course_Participant_Cancellation>;
  /** fetch aggregated fields from the table: "course_participant_cancellation" */
  course_participant_cancellation_aggregate: Course_Participant_Cancellation_Aggregate;
  /** fetch data from the table: "course_participant_cancellation" using primary key columns */
  course_participant_cancellation_by_pk?: Maybe<Course_Participant_Cancellation>;
  /** fetch data from the table: "course_participant_module" */
  course_participant_module: Array<Course_Participant_Module>;
  /** fetch aggregated fields from the table: "course_participant_module" */
  course_participant_module_aggregate: Course_Participant_Module_Aggregate;
  /** fetch data from the table: "course_participant_module" using primary key columns */
  course_participant_module_by_pk?: Maybe<Course_Participant_Module>;
  /** fetch data from the table: "course_participant_note" */
  course_participant_note: Array<Course_Participant_Note>;
  /** fetch aggregated fields from the table: "course_participant_note" */
  course_participant_note_aggregate: Course_Participant_Note_Aggregate;
  /** fetch data from the table: "course_participant_note" using primary key columns */
  course_participant_note_by_pk?: Maybe<Course_Participant_Note>;
  /** fetch data from the table: "course_pricing" */
  course_pricing: Array<Course_Pricing>;
  /** fetch aggregated fields from the table: "course_pricing" */
  course_pricing_aggregate: Course_Pricing_Aggregate;
  /** fetch data from the table: "course_pricing" using primary key columns */
  course_pricing_by_pk?: Maybe<Course_Pricing>;
  /** fetch data from the table: "course_pricing_changelog" */
  course_pricing_changelog: Array<Course_Pricing_Changelog>;
  /** fetch aggregated fields from the table: "course_pricing_changelog" */
  course_pricing_changelog_aggregate: Course_Pricing_Changelog_Aggregate;
  /** fetch data from the table: "course_pricing_changelog" using primary key columns */
  course_pricing_changelog_by_pk?: Maybe<Course_Pricing_Changelog>;
  /** fetch data from the table: "course_pricing_schedule" */
  course_pricing_schedule: Array<Course_Pricing_Schedule>;
  /** fetch aggregated fields from the table: "course_pricing_schedule" */
  course_pricing_schedule_aggregate: Course_Pricing_Schedule_Aggregate;
  /** fetch data from the table: "course_pricing_schedule" using primary key columns */
  course_pricing_schedule_by_pk?: Maybe<Course_Pricing_Schedule>;
  /** fetch data from the table: "course_promo_code" */
  course_promo_code: Array<Course_Promo_Code>;
  /** fetch aggregated fields from the table: "course_promo_code" */
  course_promo_code_aggregate: Course_Promo_Code_Aggregate;
  /** fetch data from the table: "course_promo_code" using primary key columns */
  course_promo_code_by_pk?: Maybe<Course_Promo_Code>;
  /** fetch data from the table: "course_renewal_cycle" */
  course_renewal_cycle: Array<Course_Renewal_Cycle>;
  /** fetch aggregated fields from the table: "course_renewal_cycle" */
  course_renewal_cycle_aggregate: Course_Renewal_Cycle_Aggregate;
  /** fetch data from the table: "course_renewal_cycle" using primary key columns */
  course_renewal_cycle_by_pk?: Maybe<Course_Renewal_Cycle>;
  /** fetch data from the table: "course_schedule" */
  course_schedule: Array<Course_Schedule>;
  /** fetch aggregated fields from the table: "course_schedule" */
  course_schedule_aggregate: Course_Schedule_Aggregate;
  /** fetch data from the table: "course_schedule" using primary key columns */
  course_schedule_by_pk?: Maybe<Course_Schedule>;
  /** fetch data from the table: "course_source" */
  course_source: Array<Course_Source>;
  /** fetch aggregated fields from the table: "course_source" */
  course_source_aggregate: Course_Source_Aggregate;
  /** fetch data from the table: "course_source" using primary key columns */
  course_source_by_pk?: Maybe<Course_Source>;
  /** fetch data from the table: "course_status" */
  course_status: Array<Course_Status>;
  /** fetch aggregated fields from the table: "course_status" */
  course_status_aggregate: Course_Status_Aggregate;
  /** fetch data from the table: "course_status" using primary key columns */
  course_status_by_pk?: Maybe<Course_Status>;
  /** An array relationship */
  course_trainer: Array<Course_Trainer>;
  /** An aggregate relationship */
  course_trainer_aggregate: Course_Trainer_Aggregate;
  /** fetch data from the table: "course_trainer" using primary key columns */
  course_trainer_by_pk?: Maybe<Course_Trainer>;
  /** fetch data from the table: "course_trainer_type" */
  course_trainer_type: Array<Course_Trainer_Type>;
  /** fetch aggregated fields from the table: "course_trainer_type" */
  course_trainer_type_aggregate: Course_Trainer_Type_Aggregate;
  /** fetch data from the table: "course_trainer_type" using primary key columns */
  course_trainer_type_by_pk?: Maybe<Course_Trainer_Type>;
  /** fetch data from the table: "course_type" */
  course_type: Array<Course_Type>;
  /** fetch aggregated fields from the table: "course_type" */
  course_type_aggregate: Course_Type_Aggregate;
  /** fetch data from the table: "course_type" using primary key columns */
  course_type_by_pk?: Maybe<Course_Type>;
  /** fetch data from the table: "course_type_prefix" */
  course_type_prefix: Array<Course_Type_Prefix>;
  /** fetch aggregated fields from the table: "course_type_prefix" */
  course_type_prefix_aggregate: Course_Type_Prefix_Aggregate;
  /** fetch data from the table: "course_type_prefix" using primary key columns */
  course_type_prefix_by_pk?: Maybe<Course_Type_Prefix>;
  /** fetch data from the table: "cqc_establishment" */
  cqc_establishment: Array<Cqc_Establishment>;
  /** fetch aggregated fields from the table: "cqc_establishment" */
  cqc_establishment_aggregate: Cqc_Establishment_Aggregate;
  /** fetch data from the table: "cqc_establishment" using primary key columns */
  cqc_establishment_by_pk?: Maybe<Cqc_Establishment>;
  /** fetch data from the table: "cud_operation" */
  cud_operation: Array<Cud_Operation>;
  /** fetch aggregated fields from the table: "cud_operation" */
  cud_operation_aggregate: Cud_Operation_Aggregate;
  /** fetch data from the table: "cud_operation" using primary key columns */
  cud_operation_by_pk?: Maybe<Cud_Operation>;
  /** Thorough cleanup to remove all irrelevant data for both app versions (UK and Australia) */
  dbClean?: Maybe<DbCleanOutput>;
  /** fetch data from the table: "deleted_organizations_backup" */
  deleted_organizations_backup: Array<Deleted_Organizations_Backup>;
  /** fetch aggregated fields from the table: "deleted_organizations_backup" */
  deleted_organizations_backup_aggregate: Deleted_Organizations_Backup_Aggregate;
  /** fetch data from the table: "dfe_establishment" */
  dfe_establishment: Array<Dfe_Establishment>;
  /** fetch aggregated fields from the table: "dfe_establishment" */
  dfe_establishment_aggregate: Dfe_Establishment_Aggregate;
  /** fetch data from the table: "dfe_establishment" using primary key columns */
  dfe_establishment_by_pk?: Maybe<Dfe_Establishment>;
  /** eligibleTransferCourses */
  eligibleTransferCourses: Array<TransferCourse>;
  /** fetch data from the table: "email_notifications" */
  email_notifications: Array<Email_Notifications>;
  /** fetch aggregated fields from the table: "email_notifications" */
  email_notifications_aggregate: Email_Notifications_Aggregate;
  /** fetch data from the table: "email_notifications" using primary key columns */
  email_notifications_by_pk?: Maybe<Email_Notifications>;
  /** An array relationship */
  expire_go1_license_jobs: Array<Expire_Go1_License_Jobs>;
  /** An aggregate relationship */
  expire_go1_license_jobs_aggregate: Expire_Go1_License_Jobs_Aggregate;
  /** fetch data from the table: "expire_go1_license_jobs" using primary key columns */
  expire_go1_license_jobs_by_pk?: Maybe<Expire_Go1_License_Jobs>;
  exportBlendedLearningCourseData?: Maybe<BlendedLearningExportDataOutput>;
  /** Fetches membership plans */
  fetchPlans?: Maybe<Array<Maybe<PlanObject>>>;
  /** getCoursePricing */
  getCoursePricing?: Maybe<GetCoursePricingOutput>;
  getInvite?: Maybe<CourseInvite>;
  getOrgInvite?: Maybe<OrgInvite>;
  /** Get user data for SSO. The response includes the user profile in Connect and the user profile in Central-API if they exist. */
  getSSOUserData?: Maybe<GetSsoUserDataOutput>;
  getUserGO1Enrollments: GetUserGo1EnrollmentsOutput;
  getXeroInvoicesForOrders: Array<Maybe<XeroInvoice>>;
  /** Sync participants' go1 enrollment status */
  go1EnrollmentsStatusSync?: Maybe<Go1EnrollmentsSyncOutput>;
  /** fetch data from the table: "go1_history_events" */
  go1_history_events: Array<Go1_History_Events>;
  /** fetch aggregated fields from the table: "go1_history_events" */
  go1_history_events_aggregate: Go1_History_Events_Aggregate;
  /** fetch data from the table: "go1_history_events" using primary key columns */
  go1_history_events_by_pk?: Maybe<Go1_History_Events>;
  /** fetch data from the table: "go1_licenses" */
  go1_licenses: Array<Go1_Licenses>;
  /** fetch aggregated fields from the table: "go1_licenses" */
  go1_licenses_aggregate: Go1_Licenses_Aggregate;
  /** fetch data from the table: "go1_licenses" using primary key columns */
  go1_licenses_by_pk?: Maybe<Go1_Licenses>;
  /** fetch data from the table: "go1_licenses_history" */
  go1_licenses_history: Array<Go1_Licenses_History>;
  /** fetch aggregated fields from the table: "go1_licenses_history" */
  go1_licenses_history_aggregate: Go1_Licenses_History_Aggregate;
  /** fetch data from the table: "go1_licenses_history" using primary key columns */
  go1_licenses_history_by_pk?: Maybe<Go1_Licenses_History>;
  /** fetch data from the table: "grade" */
  grade: Array<Grade>;
  /** fetch aggregated fields from the table: "grade" */
  grade_aggregate: Grade_Aggregate;
  /** fetch data from the table: "grade" using primary key columns */
  grade_by_pk?: Maybe<Grade>;
  /** fetch data from the table: "hubspot_audit" */
  hubspot_audit: Array<Hubspot_Audit>;
  /** fetch aggregated fields from the table: "hubspot_audit" */
  hubspot_audit_aggregate: Hubspot_Audit_Aggregate;
  /** fetch data from the table: "hubspot_audit" using primary key columns */
  hubspot_audit_by_pk?: Maybe<Hubspot_Audit>;
  /** fetch data from the table: "identity" */
  identity: Array<Identity>;
  /** fetch aggregated fields from the table: "identity" */
  identity_aggregate: Identity_Aggregate;
  /** fetch data from the table: "identity" using primary key columns */
  identity_by_pk?: Maybe<Identity>;
  /** fetch data from the table: "identity_type" */
  identity_type: Array<Identity_Type>;
  /** fetch aggregated fields from the table: "identity_type" */
  identity_type_aggregate: Identity_Type_Aggregate;
  /** fetch data from the table: "identity_type" using primary key columns */
  identity_type_by_pk?: Maybe<Identity_Type>;
  importArloCertificates?: Maybe<ImportArloCertificates>;
  /** fetch data from the table: "import_job" */
  import_job: Array<Import_Job>;
  /** fetch aggregated fields from the table: "import_job" */
  import_job_aggregate: Import_Job_Aggregate;
  /** fetch data from the table: "import_job" using primary key columns */
  import_job_by_pk?: Maybe<Import_Job>;
  /** fetch data from the table: "import_job_status" */
  import_job_status: Array<Import_Job_Status>;
  /** fetch aggregated fields from the table: "import_job_status" */
  import_job_status_aggregate: Import_Job_Status_Aggregate;
  /** fetch data from the table: "import_job_status" using primary key columns */
  import_job_status_by_pk?: Maybe<Import_Job_Status>;
  /** fetch data from the table: "import_job_type" */
  import_job_type: Array<Import_Job_Type>;
  /** fetch aggregated fields from the table: "import_job_type" */
  import_job_type_aggregate: Import_Job_Type_Aggregate;
  /** fetch data from the table: "import_job_type" using primary key columns */
  import_job_type_by_pk?: Maybe<Import_Job_Type>;
  initAuth: InitAuthOutput;
  /** Checks whether user is subscribed to membership */
  isUserSubscribedToMembership?: Maybe<IsUserSubscribedToMembershipResponse>;
  /** fetch data from the table: "job_title" */
  job_title: Array<Job_Title>;
  /** fetch aggregated fields from the table: "job_title" */
  job_title_aggregate: Job_Title_Aggregate;
  /** fetch data from the table: "job_title" using primary key columns */
  job_title_by_pk?: Maybe<Job_Title>;
  /** knowledgeHubResources */
  knowledgeHubResources?: Maybe<KnowledgeHubResourcesOutput>;
  /** fetch data from the table: "legacy_certificate" */
  legacy_certificate: Array<Legacy_Certificate>;
  /** fetch aggregated fields from the table: "legacy_certificate" */
  legacy_certificate_aggregate: Legacy_Certificate_Aggregate;
  /** fetch data from the table: "legacy_certificate" using primary key columns */
  legacy_certificate_by_pk?: Maybe<Legacy_Certificate>;
  /** fetch data from the table: "materials_order" */
  materials_order: Array<Materials_Order>;
  /** fetch aggregated fields from the table: "materials_order" */
  materials_order_aggregate: Materials_Order_Aggregate;
  /** fetch data from the table: "materials_order" using primary key columns */
  materials_order_by_pk?: Maybe<Materials_Order>;
  /** fetch data from the table: "merge_organizations_logs" */
  merge_organizations_logs: Array<Merge_Organizations_Logs>;
  /** fetch aggregated fields from the table: "merge_organizations_logs" */
  merge_organizations_logs_aggregate: Merge_Organizations_Logs_Aggregate;
  /** fetch data from the table: "merge_organizations_logs" using primary key columns */
  merge_organizations_logs_by_pk?: Maybe<Merge_Organizations_Logs>;
  /** fetch data from the table: "merged_organizations" */
  merged_organizations: Array<Merged_Organizations>;
  /** fetch aggregated fields from the table: "merged_organizations" */
  merged_organizations_aggregate: Merged_Organizations_Aggregate;
  /** fetch data from the table: "merged_organizations" using primary key columns */
  merged_organizations_by_pk?: Maybe<Merged_Organizations>;
  /** fetch data from the table: "module" */
  module: Array<Module>;
  /** fetch aggregated fields from the table: "module" */
  module_aggregate: Module_Aggregate;
  /** fetch data from the table: "module" using primary key columns */
  module_by_pk?: Maybe<Module>;
  /** fetch data from the table: "module_category" */
  module_category: Array<Module_Category>;
  /** fetch aggregated fields from the table: "module_category" */
  module_category_aggregate: Module_Category_Aggregate;
  /** fetch data from the table: "module_category" using primary key columns */
  module_category_by_pk?: Maybe<Module_Category>;
  /** fetch data from the table: "module_group" */
  module_group: Array<Module_Group>;
  /** fetch aggregated fields from the table: "module_group" */
  module_group_aggregate: Module_Group_Aggregate;
  /** fetch data from the table: "module_group" using primary key columns */
  module_group_by_pk?: Maybe<Module_Group>;
  /** fetch data from the table: "module_group_duration" */
  module_group_duration: Array<Module_Group_Duration>;
  /** fetch aggregated fields from the table: "module_group_duration" */
  module_group_duration_aggregate: Module_Group_Duration_Aggregate;
  /** fetch data from the table: "module_group_duration" using primary key columns */
  module_group_duration_by_pk?: Maybe<Module_Group_Duration>;
  /** fetch data from the table: "module_setting" */
  module_setting: Array<Module_Setting>;
  /** fetch aggregated fields from the table: "module_setting" */
  module_setting_aggregate: Module_Setting_Aggregate;
  /** fetch data from the table: "module_setting" using primary key columns */
  module_setting_by_pk?: Maybe<Module_Setting>;
  /** fetch data from the table: "module_setting_dependency" */
  module_setting_dependency: Array<Module_Setting_Dependency>;
  /** fetch aggregated fields from the table: "module_setting_dependency" */
  module_setting_dependency_aggregate: Module_Setting_Dependency_Aggregate;
  /** fetch data from the table: "module_setting_dependency" using primary key columns */
  module_setting_dependency_by_pk?: Maybe<Module_Setting_Dependency>;
  /** fetch data from the table: "module_v2" */
  module_v2: Array<Module_V2>;
  /** fetch aggregated fields from the table: "module_v2" */
  module_v2_aggregate: Module_V2_Aggregate;
  /** fetch data from the table: "module_v2" using primary key columns */
  module_v2_by_pk?: Maybe<Module_V2>;
  /** fetch data from the table: "non_graded_certificate" */
  non_graded_certificate: Array<Non_Graded_Certificate>;
  /** fetch aggregated fields from the table: "non_graded_certificate" */
  non_graded_certificate_aggregate: Non_Graded_Certificate_Aggregate;
  /** fetch data from the table: "non_graded_certificate" using primary key columns */
  non_graded_certificate_by_pk?: Maybe<Non_Graded_Certificate>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table: "order_temp" */
  order_temp: Array<Order_Temp>;
  /** fetch aggregated fields from the table: "order_temp" */
  order_temp_aggregate: Order_Temp_Aggregate;
  /** fetch data from the table: "order_temp" using primary key columns */
  order_temp_by_pk?: Maybe<Order_Temp>;
  /** fetch data from the table: "org_created_from" */
  org_created_from: Array<Org_Created_From>;
  /** fetch aggregated fields from the table: "org_created_from" */
  org_created_from_aggregate: Org_Created_From_Aggregate;
  /** fetch data from the table: "org_created_from" using primary key columns */
  org_created_from_by_pk?: Maybe<Org_Created_From>;
  /** fetch data from the table: "org_distinct_country_codes" */
  org_distinct_country_codes: Array<Org_Distinct_Country_Codes>;
  /** fetch aggregated fields from the table: "org_distinct_country_codes" */
  org_distinct_country_codes_aggregate: Org_Distinct_Country_Codes_Aggregate;
  /** fetch data from the table: "org_resource_packs_history" */
  org_resource_packs_history: Array<Org_Resource_Packs_History>;
  /** fetch aggregated fields from the table: "org_resource_packs_history" */
  org_resource_packs_history_aggregate: Org_Resource_Packs_History_Aggregate;
  /** fetch data from the table: "org_resource_packs_history" using primary key columns */
  org_resource_packs_history_by_pk?: Maybe<Org_Resource_Packs_History>;
  /** fetch data from the table: "org_resource_packs_pricing" */
  org_resource_packs_pricing: Array<Org_Resource_Packs_Pricing>;
  /** fetch aggregated fields from the table: "org_resource_packs_pricing" */
  org_resource_packs_pricing_aggregate: Org_Resource_Packs_Pricing_Aggregate;
  /** fetch data from the table: "org_resource_packs_pricing" using primary key columns */
  org_resource_packs_pricing_by_pk?: Maybe<Org_Resource_Packs_Pricing>;
  /** fetch data from the table: "org_resource_packs_pricing_changelog" */
  org_resource_packs_pricing_changelog: Array<Org_Resource_Packs_Pricing_Changelog>;
  /** fetch aggregated fields from the table: "org_resource_packs_pricing_changelog" */
  org_resource_packs_pricing_changelog_aggregate: Org_Resource_Packs_Pricing_Changelog_Aggregate;
  /** fetch data from the table: "org_resource_packs_pricing_changelog" using primary key columns */
  org_resource_packs_pricing_changelog_by_pk?: Maybe<Org_Resource_Packs_Pricing_Changelog>;
  /** fetch data from the table: "organisation_log" */
  organisation_log: Array<Organisation_Log>;
  /** fetch aggregated fields from the table: "organisation_log" */
  organisation_log_aggregate: Organisation_Log_Aggregate;
  /** fetch data from the table: "organisation_log" using primary key columns */
  organisation_log_by_pk?: Maybe<Organisation_Log>;
  /** fetch data from the table: "organisation_sector" */
  organisation_sector: Array<Organisation_Sector>;
  /** fetch aggregated fields from the table: "organisation_sector" */
  organisation_sector_aggregate: Organisation_Sector_Aggregate;
  /** fetch data from the table: "organisation_sector" using primary key columns */
  organisation_sector_by_pk?: Maybe<Organisation_Sector>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table: "organization_invites" */
  organization_invites: Array<Organization_Invites>;
  /** fetch aggregated fields from the table: "organization_invites" */
  organization_invites_aggregate: Organization_Invites_Aggregate;
  /** fetch data from the table: "organization_invites" using primary key columns */
  organization_invites_by_pk?: Maybe<Organization_Invites>;
  /** fetch data from the table: "organization_member" */
  organization_member: Array<Organization_Member>;
  /** fetch aggregated fields from the table: "organization_member" */
  organization_member_aggregate: Organization_Member_Aggregate;
  /** fetch data from the table: "organization_member" using primary key columns */
  organization_member_by_pk?: Maybe<Organization_Member>;
  /** An array relationship */
  organization_resource_packs: Array<Organization_Resource_Packs>;
  /** An aggregate relationship */
  organization_resource_packs_aggregate: Organization_Resource_Packs_Aggregate;
  /** fetch data from the table: "organization_resource_packs" using primary key columns */
  organization_resource_packs_by_pk?: Maybe<Organization_Resource_Packs>;
  /** fetch data from the table: "organization_type" */
  organization_type: Array<Organization_Type>;
  /** fetch aggregated fields from the table: "organization_type" */
  organization_type_aggregate: Organization_Type_Aggregate;
  /** fetch data from the table: "organization_type" using primary key columns */
  organization_type_by_pk?: Maybe<Organization_Type>;
  /** fetch data from the table: "organizations_statistics" */
  organizations_statistics: Array<Organizations_Statistics>;
  /** fetch aggregated fields from the table: "organizations_statistics" */
  organizations_statistics_aggregate: Organizations_Statistics_Aggregate;
  /** fetch data from the table: "organizations_statistics" using primary key columns */
  organizations_statistics_by_pk?: Maybe<Organizations_Statistics>;
  /** fetch data from the table: "payment_methods" */
  payment_methods: Array<Payment_Methods>;
  /** fetch aggregated fields from the table: "payment_methods" */
  payment_methods_aggregate: Payment_Methods_Aggregate;
  /** fetch data from the table: "payment_methods" using primary key columns */
  payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** Podcast */
  podcast?: Maybe<PodcastPayload>;
  /** Podcasts list */
  podcasts?: Maybe<PodcastsPayload>;
  /** fetch data from the table: "post_training_email_scheduled_events" */
  post_training_email_scheduled_events: Array<Post_Training_Email_Scheduled_Events>;
  /** fetch aggregated fields from the table: "post_training_email_scheduled_events" */
  post_training_email_scheduled_events_aggregate: Post_Training_Email_Scheduled_Events_Aggregate;
  /** fetch data from the table: "post_training_email_scheduled_events" using primary key columns */
  post_training_email_scheduled_events_by_pk?: Maybe<Post_Training_Email_Scheduled_Events>;
  /** fetch data from the table: "pre_training_email_scheduled_events" */
  pre_training_email_scheduled_events: Array<Pre_Training_Email_Scheduled_Events>;
  /** fetch aggregated fields from the table: "pre_training_email_scheduled_events" */
  pre_training_email_scheduled_events_aggregate: Pre_Training_Email_Scheduled_Events_Aggregate;
  /** fetch data from the table: "pre_training_email_scheduled_events" using primary key columns */
  pre_training_email_scheduled_events_by_pk?: Maybe<Pre_Training_Email_Scheduled_Events>;
  /** fetch data from the table: "precision_order_status" */
  precision_order_status: Array<Precision_Order_Status>;
  /** fetch aggregated fields from the table: "precision_order_status" */
  precision_order_status_aggregate: Precision_Order_Status_Aggregate;
  /** fetch data from the table: "precision_order_status" using primary key columns */
  precision_order_status_by_pk?: Maybe<Precision_Order_Status>;
  /** fetch data from the table: "private_course_booking" */
  private_course_booking: Array<Private_Course_Booking>;
  /** fetch aggregated fields from the table: "private_course_booking" */
  private_course_booking_aggregate: Private_Course_Booking_Aggregate;
  /** fetch data from the table: "private_course_booking" using primary key columns */
  private_course_booking_by_pk?: Maybe<Private_Course_Booking>;
  /** fetch data from the table: "profile" */
  profile: Array<Profile>;
  /** fetch aggregated fields from the table: "profile" */
  profile_aggregate: Profile_Aggregate;
  /** fetch data from the table: "profile" using primary key columns */
  profile_by_pk?: Maybe<Profile>;
  /** fetch data from the table: "profile_role" */
  profile_role: Array<Profile_Role>;
  /** fetch aggregated fields from the table: "profile_role" */
  profile_role_aggregate: Profile_Role_Aggregate;
  /** fetch data from the table: "profile_role" using primary key columns */
  profile_role_by_pk?: Maybe<Profile_Role>;
  /** fetch data from the table: "profile_temp" */
  profile_temp: Array<Profile_Temp>;
  /** fetch aggregated fields from the table: "profile_temp" */
  profile_temp_aggregate: Profile_Temp_Aggregate;
  /** fetch data from the table: "profile_temp" using primary key columns */
  profile_temp_by_pk?: Maybe<Profile_Temp>;
  /** fetch data from the table: "profile_trainer_agreement_type" */
  profile_trainer_agreement_type: Array<Profile_Trainer_Agreement_Type>;
  /** fetch aggregated fields from the table: "profile_trainer_agreement_type" */
  profile_trainer_agreement_type_aggregate: Profile_Trainer_Agreement_Type_Aggregate;
  /** fetch data from the table: "profile_trainer_agreement_type" using primary key columns */
  profile_trainer_agreement_type_by_pk?: Maybe<Profile_Trainer_Agreement_Type>;
  /** fetch data from the table: "profile_trainer_role_type" */
  profile_trainer_role_type: Array<Profile_Trainer_Role_Type>;
  /** fetch aggregated fields from the table: "profile_trainer_role_type" */
  profile_trainer_role_type_aggregate: Profile_Trainer_Role_Type_Aggregate;
  /** fetch data from the table: "profile_trainer_role_type" using primary key columns */
  profile_trainer_role_type_by_pk?: Maybe<Profile_Trainer_Role_Type>;
  /** fetch data from the table: "promo_code" */
  promo_code: Array<Promo_Code>;
  /** fetch aggregated fields from the table: "promo_code" */
  promo_code_aggregate: Promo_Code_Aggregate;
  /** fetch data from the table: "promo_code" using primary key columns */
  promo_code_by_pk?: Maybe<Promo_Code>;
  /** fetch data from the table: "promo_code_type" */
  promo_code_type: Array<Promo_Code_Type>;
  /** fetch aggregated fields from the table: "promo_code_type" */
  promo_code_type_aggregate: Promo_Code_Type_Aggregate;
  /** fetch data from the table: "promo_code_type" using primary key columns */
  promo_code_type_by_pk?: Maybe<Promo_Code_Type>;
  /** fetch data from the table: "resource_pack_bundle_course_level" */
  resource_pack_bundle_course_level: Array<Resource_Pack_Bundle_Course_Level>;
  /** fetch aggregated fields from the table: "resource_pack_bundle_course_level" */
  resource_pack_bundle_course_level_aggregate: Resource_Pack_Bundle_Course_Level_Aggregate;
  /** fetch data from the table: "resource_pack_bundle_course_level" using primary key columns */
  resource_pack_bundle_course_level_by_pk?: Maybe<Resource_Pack_Bundle_Course_Level>;
  /** fetch data from the table: "resource_pack_bundle_option" */
  resource_pack_bundle_option: Array<Resource_Pack_Bundle_Option>;
  /** fetch aggregated fields from the table: "resource_pack_bundle_option" */
  resource_pack_bundle_option_aggregate: Resource_Pack_Bundle_Option_Aggregate;
  /** fetch data from the table: "resource_pack_bundle_option" using primary key columns */
  resource_pack_bundle_option_by_pk?: Maybe<Resource_Pack_Bundle_Option>;
  /** fetch data from the table: "resource_pack_bundle_price" */
  resource_pack_bundle_price: Array<Resource_Pack_Bundle_Price>;
  /** fetch aggregated fields from the table: "resource_pack_bundle_price" */
  resource_pack_bundle_price_aggregate: Resource_Pack_Bundle_Price_Aggregate;
  /** fetch data from the table: "resource_pack_bundle_price" using primary key columns */
  resource_pack_bundle_price_by_pk?: Maybe<Resource_Pack_Bundle_Price>;
  /** fetch data from the table: "resource_packs_delivery_type" */
  resource_packs_delivery_type: Array<Resource_Packs_Delivery_Type>;
  /** fetch aggregated fields from the table: "resource_packs_delivery_type" */
  resource_packs_delivery_type_aggregate: Resource_Packs_Delivery_Type_Aggregate;
  /** fetch data from the table: "resource_packs_delivery_type" using primary key columns */
  resource_packs_delivery_type_by_pk?: Maybe<Resource_Packs_Delivery_Type>;
  /** fetch data from the table: "resource_packs_events" */
  resource_packs_events: Array<Resource_Packs_Events>;
  /** fetch aggregated fields from the table: "resource_packs_events" */
  resource_packs_events_aggregate: Resource_Packs_Events_Aggregate;
  /** fetch data from the table: "resource_packs_events" using primary key columns */
  resource_packs_events_by_pk?: Maybe<Resource_Packs_Events>;
  /** fetch data from the table: "resource_packs_pricing" */
  resource_packs_pricing: Array<Resource_Packs_Pricing>;
  /** fetch aggregated fields from the table: "resource_packs_pricing" */
  resource_packs_pricing_aggregate: Resource_Packs_Pricing_Aggregate;
  /** fetch data from the table: "resource_packs_pricing" using primary key columns */
  resource_packs_pricing_by_pk?: Maybe<Resource_Packs_Pricing>;
  /** fetch data from the table: "resource_packs_type" */
  resource_packs_type: Array<Resource_Packs_Type>;
  /** fetch aggregated fields from the table: "resource_packs_type" */
  resource_packs_type_aggregate: Resource_Packs_Type_Aggregate;
  /** fetch data from the table: "resource_packs_type" using primary key columns */
  resource_packs_type_by_pk?: Maybe<Resource_Packs_Type>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table: "scheduled_events_view" */
  scheduled_events_view: Array<Scheduled_Events_View>;
  /** fetch aggregated fields from the table: "scheduled_events_view" */
  scheduled_events_view_aggregate: Scheduled_Events_View_Aggregate;
  searchTrainers?: Maybe<Array<Maybe<SearchTrainer>>>;
  /** execute function "search_dfe_establishments" which returns "dfe_establishment" */
  search_dfe_establishments: Array<Dfe_Establishment>;
  /** execute function "search_dfe_establishments" and query aggregates on result of table type "dfe_establishment" */
  search_dfe_establishments_aggregate: Dfe_Establishment_Aggregate;
  /** execute function "search_organizations" which returns "organization" */
  search_organizations: Array<Organization>;
  /** execute function "search_organizations" and query aggregates on result of table type "organization" */
  search_organizations_aggregate: Organization_Aggregate;
  /** fetch data from the table: "splash_screens" */
  splash_screens: Array<Splash_Screens>;
  /** fetch aggregated fields from the table: "splash_screens" */
  splash_screens_aggregate: Splash_Screens_Aggregate;
  /** fetch data from the table: "splash_screens" using primary key columns */
  splash_screens_by_pk?: Maybe<Splash_Screens>;
  /** An array relationship */
  submission_of_splash_screens: Array<Submission_Of_Splash_Screens>;
  /** An aggregate relationship */
  submission_of_splash_screens_aggregate: Submission_Of_Splash_Screens_Aggregate;
  /** fetch data from the table: "submission_of_splash_screens" using primary key columns */
  submission_of_splash_screens_by_pk?: Maybe<Submission_Of_Splash_Screens>;
  /** fetch data from the table: "submodule" */
  submodule: Array<Submodule>;
  /** fetch aggregated fields from the table: "submodule" */
  submodule_aggregate: Submodule_Aggregate;
  /** fetch data from the table: "submodule" using primary key columns */
  submodule_by_pk?: Maybe<Submodule>;
  /** fetch data from the table: "trainer_agreement_type" */
  trainer_agreement_type: Array<Trainer_Agreement_Type>;
  /** fetch aggregated fields from the table: "trainer_agreement_type" */
  trainer_agreement_type_aggregate: Trainer_Agreement_Type_Aggregate;
  /** fetch data from the table: "trainer_agreement_type" using primary key columns */
  trainer_agreement_type_by_pk?: Maybe<Trainer_Agreement_Type>;
  /** fetch data from the table: "trainer_role_type" */
  trainer_role_type: Array<Trainer_Role_Type>;
  /** fetch aggregated fields from the table: "trainer_role_type" */
  trainer_role_type_aggregate: Trainer_Role_Type_Aggregate;
  /** fetch data from the table: "trainer_role_type" using primary key columns */
  trainer_role_type_by_pk?: Maybe<Trainer_Role_Type>;
  /** fetch data from the table: "trust_type" */
  trust_type: Array<Trust_Type>;
  /** fetch aggregated fields from the table: "trust_type" */
  trust_type_aggregate: Trust_Type_Aggregate;
  /** fetch data from the table: "trust_type" using primary key columns */
  trust_type_by_pk?: Maybe<Trust_Type>;
  /** fetch data from the table: "tt_client_invite_log" */
  tt_client_invite_log: Array<Tt_Client_Invite_Log>;
  /** fetch aggregated fields from the table: "tt_client_invite_log" */
  tt_client_invite_log_aggregate: Tt_Client_Invite_Log_Aggregate;
  /** fetch data from the table: "tt_client_invite_log" using primary key columns */
  tt_client_invite_log_by_pk?: Maybe<Tt_Client_Invite_Log>;
  /** fetch data from the table: "upcoming_enrollments" */
  upcoming_enrollments: Array<Upcoming_Enrollments>;
  /** fetch aggregated fields from the table: "upcoming_enrollments" */
  upcoming_enrollments_aggregate: Upcoming_Enrollments_Aggregate;
  /** fetch data from the table: "user_auth_audit_type" */
  user_auth_audit_type: Array<User_Auth_Audit_Type>;
  /** fetch aggregated fields from the table: "user_auth_audit_type" */
  user_auth_audit_type_aggregate: User_Auth_Audit_Type_Aggregate;
  /** fetch data from the table: "user_auth_audit_type" using primary key columns */
  user_auth_audit_type_by_pk?: Maybe<User_Auth_Audit_Type>;
  /** fetch data from the table: "user_auth_audits" */
  user_auth_audits: Array<User_Auth_Audits>;
  /** fetch aggregated fields from the table: "user_auth_audits" */
  user_auth_audits_aggregate: User_Auth_Audits_Aggregate;
  /** fetch data from the table: "user_auth_audits" using primary key columns */
  user_auth_audits_by_pk?: Maybe<User_Auth_Audits>;
  /** fetch data from the table: "venue" */
  venue: Array<Venue>;
  /** fetch aggregated fields from the table: "venue" */
  venue_aggregate: Venue_Aggregate;
  /** fetch data from the table: "venue" using primary key columns */
  venue_by_pk?: Maybe<Venue>;
  /** fetch data from the table: "venue_check_jobs" */
  venue_check_jobs: Array<Venue_Check_Jobs>;
  /** fetch aggregated fields from the table: "venue_check_jobs" */
  venue_check_jobs_aggregate: Venue_Check_Jobs_Aggregate;
  /** fetch data from the table: "venue_check_jobs" using primary key columns */
  venue_check_jobs_by_pk?: Maybe<Venue_Check_Jobs>;
  /** fetch data from the table: "waitlist" */
  waitlist: Array<Waitlist>;
  /** fetch aggregated fields from the table: "waitlist" */
  waitlist_aggregate: Waitlist_Aggregate;
  /** fetch data from the table: "waitlist" using primary key columns */
  waitlist_by_pk?: Maybe<Waitlist>;
  xeroConnect?: Maybe<XeroConnectOutput>;
  xeroContactSearch?: Maybe<XeroContactSearchOutput>;
  xeroInvoicesStatus?: Maybe<XeroInvoicesStatusOutput>;
  /** Sync Xero Invoices with the hub invoices */
  xeroSync?: Maybe<XeroInvoiceSyncOutput>;
  /** fetch data from the table: "xero_contact" */
  xero_contact: Array<Xero_Contact>;
  /** fetch aggregated fields from the table: "xero_contact" */
  xero_contact_aggregate: Xero_Contact_Aggregate;
  /** fetch data from the table: "xero_contact" using primary key columns */
  xero_contact_by_pk?: Maybe<Xero_Contact>;
  /** fetch data from the table: "xero_credential" */
  xero_credential: Array<Xero_Credential>;
  /** fetch aggregated fields from the table: "xero_credential" */
  xero_credential_aggregate: Xero_Credential_Aggregate;
  /** fetch data from the table: "xero_credential" using primary key columns */
  xero_credential_by_pk?: Maybe<Xero_Credential>;
  /** fetch data from the table: "xero_invoice" */
  xero_invoice: Array<Xero_Invoice>;
  /** fetch aggregated fields from the table: "xero_invoice" */
  xero_invoice_aggregate: Xero_Invoice_Aggregate;
  /** fetch data from the table: "xero_invoice" using primary key columns */
  xero_invoice_by_pk?: Maybe<Xero_Invoice>;
  /** fetch data from the table: "xero_invoice_status" */
  xero_invoice_status: Array<Xero_Invoice_Status>;
  /** fetch aggregated fields from the table: "xero_invoice_status" */
  xero_invoice_status_aggregate: Xero_Invoice_Status_Aggregate;
  /** fetch data from the table: "xero_invoice_status" using primary key columns */
  xero_invoice_status_by_pk?: Maybe<Xero_Invoice_Status>;
  /** Zoom Users list */
  zoomUsers?: Maybe<ZoomUsersResponse>;
};


export type Query_RootAbout_Training_Email_Scheduled_EventsArgs = {
  distinct_on?: InputMaybe<Array<About_Training_Email_Scheduled_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<About_Training_Email_Scheduled_Events_Order_By>>;
  where?: InputMaybe<About_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Query_RootAbout_Training_Email_Scheduled_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<About_Training_Email_Scheduled_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<About_Training_Email_Scheduled_Events_Order_By>>;
  where?: InputMaybe<About_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Query_RootAbout_Training_Email_Scheduled_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAbsorb_EnrolmentArgs = {
  distinct_on?: InputMaybe<Array<Absorb_Enrolment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Absorb_Enrolment_Order_By>>;
  where?: InputMaybe<Absorb_Enrolment_Bool_Exp>;
};


export type Query_RootAbsorb_Enrolment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Absorb_Enrolment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Absorb_Enrolment_Order_By>>;
  where?: InputMaybe<Absorb_Enrolment_Bool_Exp>;
};


export type Query_RootAbsorb_Enrolment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootAccreditorsArgs = {
  distinct_on?: InputMaybe<Array<Accreditors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditors_Order_By>>;
  where?: InputMaybe<Accreditors_Bool_Exp>;
};


export type Query_RootAccreditors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accreditors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditors_Order_By>>;
  where?: InputMaybe<Accreditors_Bool_Exp>;
};


export type Query_RootAccreditors_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootAvailabilityArgs = {
  distinct_on?: InputMaybe<Array<Availability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Availability_Order_By>>;
  where?: InputMaybe<Availability_Bool_Exp>;
};


export type Query_RootAvailability_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Availability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Availability_Order_By>>;
  where?: InputMaybe<Availability_Bool_Exp>;
};


export type Query_RootAvailability_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBild_StrategyArgs = {
  distinct_on?: InputMaybe<Array<Bild_Strategy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bild_Strategy_Order_By>>;
  where?: InputMaybe<Bild_Strategy_Bool_Exp>;
};


export type Query_RootBild_Strategy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bild_Strategy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bild_Strategy_Order_By>>;
  where?: InputMaybe<Bild_Strategy_Bool_Exp>;
};


export type Query_RootBild_Strategy_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootBlended_Learning_StatusArgs = {
  distinct_on?: InputMaybe<Array<Blended_Learning_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Blended_Learning_Status_Order_By>>;
  where?: InputMaybe<Blended_Learning_Status_Bool_Exp>;
};


export type Query_RootBlended_Learning_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blended_Learning_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Blended_Learning_Status_Order_By>>;
  where?: InputMaybe<Blended_Learning_Status_Bool_Exp>;
};


export type Query_RootBlended_Learning_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCanApplyPromoCodeArgs = {
  input: CanApplyPromoCodeInput;
};


export type Query_RootCertificate_Expired_Notification_JobsArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Expired_Notification_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Expired_Notification_Jobs_Order_By>>;
  where?: InputMaybe<Certificate_Expired_Notification_Jobs_Bool_Exp>;
};


export type Query_RootCertificate_Expired_Notification_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Expired_Notification_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Expired_Notification_Jobs_Order_By>>;
  where?: InputMaybe<Certificate_Expired_Notification_Jobs_Bool_Exp>;
};


export type Query_RootCertificate_Expired_Notification_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCertificate_Expiry_Notification_JobsArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Expiry_Notification_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Expiry_Notification_Jobs_Order_By>>;
  where?: InputMaybe<Certificate_Expiry_Notification_Jobs_Bool_Exp>;
};


export type Query_RootCertificate_Expiry_Notification_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Expiry_Notification_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Expiry_Notification_Jobs_Order_By>>;
  where?: InputMaybe<Certificate_Expiry_Notification_Jobs_Bool_Exp>;
};


export type Query_RootCertificate_Expiry_Notification_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCertificate_Expiry_Notification_TimeframeArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Order_By>>;
  where?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Bool_Exp>;
};


export type Query_RootCertificate_Expiry_Notification_Timeframe_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Order_By>>;
  where?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Bool_Exp>;
};


export type Query_RootCertificate_Expiry_Notification_Timeframe_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCertificate_StatusArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Status_Order_By>>;
  where?: InputMaybe<Certificate_Status_Bool_Exp>;
};


export type Query_RootCertificate_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Status_Order_By>>;
  where?: InputMaybe<Certificate_Status_Bool_Exp>;
};


export type Query_RootCertificate_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCheckTtClientsArgs = {
  input: CheckTtClientsInput;
};


export type Query_RootColorArgs = {
  distinct_on?: InputMaybe<Array<Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Color_Order_By>>;
  where?: InputMaybe<Color_Bool_Exp>;
};


export type Query_RootColor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Color_Order_By>>;
  where?: InputMaybe<Color_Bool_Exp>;
};


export type Query_RootColor_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Query_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Query_RootCountry_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCountry_RegionArgs = {
  distinct_on?: InputMaybe<Array<Country_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Country_Region_Order_By>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


export type Query_RootCountry_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Country_Region_Order_By>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


export type Query_RootCountry_Region_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourseArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


export type Query_RootCourse_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


export type Query_RootCourse_AuditArgs = {
  distinct_on?: InputMaybe<Array<Course_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Audit_Order_By>>;
  where?: InputMaybe<Course_Audit_Bool_Exp>;
};


export type Query_RootCourse_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Audit_Order_By>>;
  where?: InputMaybe<Course_Audit_Bool_Exp>;
};


export type Query_RootCourse_Audit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Audit_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Audit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Audit_Type_Order_By>>;
  where?: InputMaybe<Course_Audit_Type_Bool_Exp>;
};


export type Query_RootCourse_Audit_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Audit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Audit_Type_Order_By>>;
  where?: InputMaybe<Course_Audit_Type_Bool_Exp>;
};


export type Query_RootCourse_Audit_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_Bild_ModuleArgs = {
  distinct_on?: InputMaybe<Array<Course_Bild_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Bild_Module_Order_By>>;
  where?: InputMaybe<Course_Bild_Module_Bool_Exp>;
};


export type Query_RootCourse_Bild_Module_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Bild_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Bild_Module_Order_By>>;
  where?: InputMaybe<Course_Bild_Module_Bool_Exp>;
};


export type Query_RootCourse_Bild_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Bild_StrategyArgs = {
  distinct_on?: InputMaybe<Array<Course_Bild_Strategy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Bild_Strategy_Order_By>>;
  where?: InputMaybe<Course_Bild_Strategy_Bool_Exp>;
};


export type Query_RootCourse_Bild_Strategy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Bild_Strategy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Bild_Strategy_Order_By>>;
  where?: InputMaybe<Course_Bild_Strategy_Bool_Exp>;
};


export type Query_RootCourse_Bild_Strategy_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootCourse_Cancellation_Fee_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Cancellation_Fee_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Cancellation_Fee_Type_Order_By>>;
  where?: InputMaybe<Course_Cancellation_Fee_Type_Bool_Exp>;
};


export type Query_RootCourse_Cancellation_Fee_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Cancellation_Fee_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Cancellation_Fee_Type_Order_By>>;
  where?: InputMaybe<Course_Cancellation_Fee_Type_Bool_Exp>;
};


export type Query_RootCourse_Cancellation_Fee_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_Cancellation_RequestArgs = {
  distinct_on?: InputMaybe<Array<Course_Cancellation_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Cancellation_Request_Order_By>>;
  where?: InputMaybe<Course_Cancellation_Request_Bool_Exp>;
};


export type Query_RootCourse_Cancellation_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Cancellation_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Cancellation_Request_Order_By>>;
  where?: InputMaybe<Course_Cancellation_Request_Bool_Exp>;
};


export type Query_RootCourse_Cancellation_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_CertificateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Order_By>>;
  where?: InputMaybe<Course_Certificate_Bool_Exp>;
};


export type Query_RootCourse_Certificate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Order_By>>;
  where?: InputMaybe<Course_Certificate_Bool_Exp>;
};


export type Query_RootCourse_Certificate_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Certificate_ChangelogArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Changelog_Order_By>>;
  where?: InputMaybe<Course_Certificate_Changelog_Bool_Exp>;
};


export type Query_RootCourse_Certificate_Changelog_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Changelog_Order_By>>;
  where?: InputMaybe<Course_Certificate_Changelog_Bool_Exp>;
};


export type Query_RootCourse_Certificate_Changelog_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Certificate_Changelog_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Changelog_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Changelog_Type_Order_By>>;
  where?: InputMaybe<Course_Certificate_Changelog_Type_Bool_Exp>;
};


export type Query_RootCourse_Certificate_Changelog_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Changelog_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Changelog_Type_Order_By>>;
  where?: InputMaybe<Course_Certificate_Changelog_Type_Bool_Exp>;
};


export type Query_RootCourse_Certificate_Changelog_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_Certificate_Hold_RequestArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Hold_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Hold_Request_Order_By>>;
  where?: InputMaybe<Course_Certificate_Hold_Request_Bool_Exp>;
};


export type Query_RootCourse_Certificate_Hold_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Hold_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Hold_Request_Order_By>>;
  where?: InputMaybe<Course_Certificate_Hold_Request_Bool_Exp>;
};


export type Query_RootCourse_Certificate_Hold_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Delivery_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Delivery_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Delivery_Type_Order_By>>;
  where?: InputMaybe<Course_Delivery_Type_Bool_Exp>;
};


export type Query_RootCourse_Delivery_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Delivery_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Delivery_Type_Order_By>>;
  where?: InputMaybe<Course_Delivery_Type_Bool_Exp>;
};


export type Query_RootCourse_Delivery_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_Delivery_Type_PrefixArgs = {
  distinct_on?: InputMaybe<Array<Course_Delivery_Type_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Delivery_Type_Prefix_Order_By>>;
  where?: InputMaybe<Course_Delivery_Type_Prefix_Bool_Exp>;
};


export type Query_RootCourse_Delivery_Type_Prefix_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Delivery_Type_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Delivery_Type_Prefix_Order_By>>;
  where?: InputMaybe<Course_Delivery_Type_Prefix_Bool_Exp>;
};


export type Query_RootCourse_Delivery_Type_Prefix_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_DraftArgs = {
  distinct_on?: InputMaybe<Array<Course_Draft_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Draft_Order_By>>;
  where?: InputMaybe<Course_Draft_Bool_Exp>;
};


export type Query_RootCourse_Draft_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Draft_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Draft_Order_By>>;
  where?: InputMaybe<Course_Draft_Bool_Exp>;
};


export type Query_RootCourse_Draft_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_End_JobsArgs = {
  distinct_on?: InputMaybe<Array<Course_End_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_End_Jobs_Order_By>>;
  where?: InputMaybe<Course_End_Jobs_Bool_Exp>;
};


export type Query_RootCourse_End_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_End_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_End_Jobs_Order_By>>;
  where?: InputMaybe<Course_End_Jobs_Bool_Exp>;
};


export type Query_RootCourse_End_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_EnquiryArgs = {
  distinct_on?: InputMaybe<Array<Course_Enquiry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Enquiry_Order_By>>;
  where?: InputMaybe<Course_Enquiry_Bool_Exp>;
};


export type Query_RootCourse_Enquiry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Enquiry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Enquiry_Order_By>>;
  where?: InputMaybe<Course_Enquiry_Bool_Exp>;
};


export type Query_RootCourse_Enquiry_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Evaluation_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Answers_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
};


export type Query_RootCourse_Evaluation_Answers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Answers_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
};


export type Query_RootCourse_Evaluation_Answers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Evaluation_Question_GroupArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Question_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Question_Group_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Question_Group_Bool_Exp>;
};


export type Query_RootCourse_Evaluation_Question_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Question_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Question_Group_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Question_Group_Bool_Exp>;
};


export type Query_RootCourse_Evaluation_Question_Group_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_Evaluation_Question_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Question_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Question_Type_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Question_Type_Bool_Exp>;
};


export type Query_RootCourse_Evaluation_Question_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Question_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Question_Type_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Question_Type_Bool_Exp>;
};


export type Query_RootCourse_Evaluation_Question_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_Evaluation_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Questions_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Questions_Bool_Exp>;
};


export type Query_RootCourse_Evaluation_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Questions_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Questions_Bool_Exp>;
};


export type Query_RootCourse_Evaluation_Questions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Evaluation_Scheduled_EventArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Scheduled_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Scheduled_Event_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Scheduled_Event_Bool_Exp>;
};


export type Query_RootCourse_Evaluation_Scheduled_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Scheduled_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Scheduled_Event_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Scheduled_Event_Bool_Exp>;
};


export type Query_RootCourse_Evaluation_Scheduled_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_ExceptionArgs = {
  distinct_on?: InputMaybe<Array<Course_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Exception_Order_By>>;
  where?: InputMaybe<Course_Exception_Bool_Exp>;
};


export type Query_RootCourse_Exception_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Exception_Order_By>>;
  where?: InputMaybe<Course_Exception_Bool_Exp>;
};


export type Query_RootCourse_Exception_By_PkArgs = {
  exception: Scalars['String'];
};


export type Query_RootCourse_ExceptionsArgs = {
  distinct_on?: InputMaybe<Array<Course_Exceptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Exceptions_Order_By>>;
  where?: InputMaybe<Course_Exceptions_Bool_Exp>;
};


export type Query_RootCourse_Exceptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Exceptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Exceptions_Order_By>>;
  where?: InputMaybe<Course_Exceptions_Bool_Exp>;
};


export type Query_RootCourse_Exceptions_By_PkArgs = {
  courseId: Scalars['Int'];
  exception: Course_Exception_Enum;
};


export type Query_RootCourse_ExpensesArgs = {
  distinct_on?: InputMaybe<Array<Course_Expenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Expenses_Order_By>>;
  where?: InputMaybe<Course_Expenses_Bool_Exp>;
};


export type Query_RootCourse_Expenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Expenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Expenses_Order_By>>;
  where?: InputMaybe<Course_Expenses_Bool_Exp>;
};


export type Query_RootCourse_Expenses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Invite_StatusArgs = {
  distinct_on?: InputMaybe<Array<Course_Invite_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Invite_Status_Order_By>>;
  where?: InputMaybe<Course_Invite_Status_Bool_Exp>;
};


export type Query_RootCourse_Invite_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Invite_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Invite_Status_Order_By>>;
  where?: InputMaybe<Course_Invite_Status_Bool_Exp>;
};


export type Query_RootCourse_Invite_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_InvitesArgs = {
  distinct_on?: InputMaybe<Array<Course_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Invites_Order_By>>;
  where?: InputMaybe<Course_Invites_Bool_Exp>;
};


export type Query_RootCourse_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Invites_Order_By>>;
  where?: InputMaybe<Course_Invites_Bool_Exp>;
};


export type Query_RootCourse_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_LevelArgs = {
  distinct_on?: InputMaybe<Array<Course_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Level_Order_By>>;
  where?: InputMaybe<Course_Level_Bool_Exp>;
};


export type Query_RootCourse_Level_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Level_Order_By>>;
  where?: InputMaybe<Course_Level_Bool_Exp>;
};


export type Query_RootCourse_Level_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_Level_PrefixArgs = {
  distinct_on?: InputMaybe<Array<Course_Level_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Level_Prefix_Order_By>>;
  where?: InputMaybe<Course_Level_Prefix_Bool_Exp>;
};


export type Query_RootCourse_Level_Prefix_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Level_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Level_Prefix_Order_By>>;
  where?: InputMaybe<Course_Level_Prefix_Bool_Exp>;
};


export type Query_RootCourse_Level_Prefix_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_ModuleArgs = {
  distinct_on?: InputMaybe<Array<Course_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Module_Order_By>>;
  where?: InputMaybe<Course_Module_Bool_Exp>;
};


export type Query_RootCourse_Module_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Module_Order_By>>;
  where?: InputMaybe<Course_Module_Bool_Exp>;
};


export type Query_RootCourse_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_OrderArgs = {
  distinct_on?: InputMaybe<Array<Course_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_Order_By>>;
  where?: InputMaybe<Course_Order_Bool_Exp>;
};


export type Query_RootCourse_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_Order_By>>;
  where?: InputMaybe<Course_Order_Bool_Exp>;
};


export type Query_RootCourse_ParticipantArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Order_By>>;
  where?: InputMaybe<Course_Participant_Bool_Exp>;
};


export type Query_RootCourse_Participant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Order_By>>;
  where?: InputMaybe<Course_Participant_Bool_Exp>;
};


export type Query_RootCourse_Participant_AuditArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Audit_Order_By>>;
  where?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
};


export type Query_RootCourse_Participant_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Audit_Order_By>>;
  where?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
};


export type Query_RootCourse_Participant_Audit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Participant_Audit_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Audit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Audit_Type_Order_By>>;
  where?: InputMaybe<Course_Participant_Audit_Type_Bool_Exp>;
};


export type Query_RootCourse_Participant_Audit_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Audit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Audit_Type_Order_By>>;
  where?: InputMaybe<Course_Participant_Audit_Type_Bool_Exp>;
};


export type Query_RootCourse_Participant_Audit_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_Participant_Bild_ModuleArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Bild_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Bild_Module_Order_By>>;
  where?: InputMaybe<Course_Participant_Bild_Module_Bool_Exp>;
};


export type Query_RootCourse_Participant_Bild_Module_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Bild_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Bild_Module_Order_By>>;
  where?: InputMaybe<Course_Participant_Bild_Module_Bool_Exp>;
};


export type Query_RootCourse_Participant_Bild_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Participant_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Participant_CancellationArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Cancellation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Cancellation_Order_By>>;
  where?: InputMaybe<Course_Participant_Cancellation_Bool_Exp>;
};


export type Query_RootCourse_Participant_Cancellation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Cancellation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Cancellation_Order_By>>;
  where?: InputMaybe<Course_Participant_Cancellation_Bool_Exp>;
};


export type Query_RootCourse_Participant_Cancellation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Participant_ModuleArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Module_Order_By>>;
  where?: InputMaybe<Course_Participant_Module_Bool_Exp>;
};


export type Query_RootCourse_Participant_Module_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Module_Order_By>>;
  where?: InputMaybe<Course_Participant_Module_Bool_Exp>;
};


export type Query_RootCourse_Participant_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Participant_NoteArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Note_Order_By>>;
  where?: InputMaybe<Course_Participant_Note_Bool_Exp>;
};


export type Query_RootCourse_Participant_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Note_Order_By>>;
  where?: InputMaybe<Course_Participant_Note_Bool_Exp>;
};


export type Query_RootCourse_Participant_Note_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_PricingArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Order_By>>;
  where?: InputMaybe<Course_Pricing_Bool_Exp>;
};


export type Query_RootCourse_Pricing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Order_By>>;
  where?: InputMaybe<Course_Pricing_Bool_Exp>;
};


export type Query_RootCourse_Pricing_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Pricing_ChangelogArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Changelog_Order_By>>;
  where?: InputMaybe<Course_Pricing_Changelog_Bool_Exp>;
};


export type Query_RootCourse_Pricing_Changelog_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Changelog_Order_By>>;
  where?: InputMaybe<Course_Pricing_Changelog_Bool_Exp>;
};


export type Query_RootCourse_Pricing_Changelog_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Pricing_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Schedule_Order_By>>;
  where?: InputMaybe<Course_Pricing_Schedule_Bool_Exp>;
};


export type Query_RootCourse_Pricing_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Schedule_Order_By>>;
  where?: InputMaybe<Course_Pricing_Schedule_Bool_Exp>;
};


export type Query_RootCourse_Pricing_Schedule_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Promo_CodeArgs = {
  distinct_on?: InputMaybe<Array<Course_Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Promo_Code_Order_By>>;
  where?: InputMaybe<Course_Promo_Code_Bool_Exp>;
};


export type Query_RootCourse_Promo_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Promo_Code_Order_By>>;
  where?: InputMaybe<Course_Promo_Code_Bool_Exp>;
};


export type Query_RootCourse_Promo_Code_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Renewal_CycleArgs = {
  distinct_on?: InputMaybe<Array<Course_Renewal_Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Renewal_Cycle_Order_By>>;
  where?: InputMaybe<Course_Renewal_Cycle_Bool_Exp>;
};


export type Query_RootCourse_Renewal_Cycle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Renewal_Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Renewal_Cycle_Order_By>>;
  where?: InputMaybe<Course_Renewal_Cycle_Bool_Exp>;
};


export type Query_RootCourse_Renewal_Cycle_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootCourse_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Course_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Schedule_Order_By>>;
  where?: InputMaybe<Course_Schedule_Bool_Exp>;
};


export type Query_RootCourse_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Schedule_Order_By>>;
  where?: InputMaybe<Course_Schedule_Bool_Exp>;
};


export type Query_RootCourse_Schedule_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_SourceArgs = {
  distinct_on?: InputMaybe<Array<Course_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Source_Order_By>>;
  where?: InputMaybe<Course_Source_Bool_Exp>;
};


export type Query_RootCourse_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Source_Order_By>>;
  where?: InputMaybe<Course_Source_Bool_Exp>;
};


export type Query_RootCourse_Source_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_StatusArgs = {
  distinct_on?: InputMaybe<Array<Course_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Status_Order_By>>;
  where?: InputMaybe<Course_Status_Bool_Exp>;
};


export type Query_RootCourse_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Status_Order_By>>;
  where?: InputMaybe<Course_Status_Bool_Exp>;
};


export type Query_RootCourse_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_TrainerArgs = {
  distinct_on?: InputMaybe<Array<Course_Trainer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Trainer_Order_By>>;
  where?: InputMaybe<Course_Trainer_Bool_Exp>;
};


export type Query_RootCourse_Trainer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Trainer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Trainer_Order_By>>;
  where?: InputMaybe<Course_Trainer_Bool_Exp>;
};


export type Query_RootCourse_Trainer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCourse_Trainer_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Trainer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Trainer_Type_Order_By>>;
  where?: InputMaybe<Course_Trainer_Type_Bool_Exp>;
};


export type Query_RootCourse_Trainer_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Trainer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Trainer_Type_Order_By>>;
  where?: InputMaybe<Course_Trainer_Type_Bool_Exp>;
};


export type Query_RootCourse_Trainer_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Type_Order_By>>;
  where?: InputMaybe<Course_Type_Bool_Exp>;
};


export type Query_RootCourse_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Type_Order_By>>;
  where?: InputMaybe<Course_Type_Bool_Exp>;
};


export type Query_RootCourse_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootCourse_Type_PrefixArgs = {
  distinct_on?: InputMaybe<Array<Course_Type_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Type_Prefix_Order_By>>;
  where?: InputMaybe<Course_Type_Prefix_Bool_Exp>;
};


export type Query_RootCourse_Type_Prefix_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Type_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Type_Prefix_Order_By>>;
  where?: InputMaybe<Course_Type_Prefix_Bool_Exp>;
};


export type Query_RootCourse_Type_Prefix_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCqc_EstablishmentArgs = {
  distinct_on?: InputMaybe<Array<Cqc_Establishment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cqc_Establishment_Order_By>>;
  where?: InputMaybe<Cqc_Establishment_Bool_Exp>;
};


export type Query_RootCqc_Establishment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cqc_Establishment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cqc_Establishment_Order_By>>;
  where?: InputMaybe<Cqc_Establishment_Bool_Exp>;
};


export type Query_RootCqc_Establishment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootCud_OperationArgs = {
  distinct_on?: InputMaybe<Array<Cud_Operation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cud_Operation_Order_By>>;
  where?: InputMaybe<Cud_Operation_Bool_Exp>;
};


export type Query_RootCud_Operation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cud_Operation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cud_Operation_Order_By>>;
  where?: InputMaybe<Cud_Operation_Bool_Exp>;
};


export type Query_RootCud_Operation_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootDeleted_Organizations_BackupArgs = {
  distinct_on?: InputMaybe<Array<Deleted_Organizations_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deleted_Organizations_Backup_Order_By>>;
  where?: InputMaybe<Deleted_Organizations_Backup_Bool_Exp>;
};


export type Query_RootDeleted_Organizations_Backup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deleted_Organizations_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deleted_Organizations_Backup_Order_By>>;
  where?: InputMaybe<Deleted_Organizations_Backup_Bool_Exp>;
};


export type Query_RootDfe_EstablishmentArgs = {
  distinct_on?: InputMaybe<Array<Dfe_Establishment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dfe_Establishment_Order_By>>;
  where?: InputMaybe<Dfe_Establishment_Bool_Exp>;
};


export type Query_RootDfe_Establishment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dfe_Establishment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dfe_Establishment_Order_By>>;
  where?: InputMaybe<Dfe_Establishment_Bool_Exp>;
};


export type Query_RootDfe_Establishment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootEligibleTransferCoursesArgs = {
  fromCourseId: Scalars['Int'];
  participantId: Scalars['uuid'];
};


export type Query_RootEmail_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Email_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Notifications_Order_By>>;
  where?: InputMaybe<Email_Notifications_Bool_Exp>;
};


export type Query_RootEmail_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Notifications_Order_By>>;
  where?: InputMaybe<Email_Notifications_Bool_Exp>;
};


export type Query_RootEmail_Notifications_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootExpire_Go1_License_JobsArgs = {
  distinct_on?: InputMaybe<Array<Expire_Go1_License_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expire_Go1_License_Jobs_Order_By>>;
  where?: InputMaybe<Expire_Go1_License_Jobs_Bool_Exp>;
};


export type Query_RootExpire_Go1_License_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expire_Go1_License_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expire_Go1_License_Jobs_Order_By>>;
  where?: InputMaybe<Expire_Go1_License_Jobs_Bool_Exp>;
};


export type Query_RootExpire_Go1_License_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootExportBlendedLearningCourseDataArgs = {
  input: BlendedLearningExportDataInput;
};


export type Query_RootGetCoursePricingArgs = {
  input: GetCoursePricingInput;
};


export type Query_RootGetSsoUserDataArgs = {
  input: GetSsoUserDataInput;
};


export type Query_RootGetUserGo1EnrollmentsArgs = {
  email: Scalars['String'];
};


export type Query_RootGetXeroInvoicesForOrdersArgs = {
  invoiceNumbers: Array<Scalars['String']>;
};


export type Query_RootGo1_History_EventsArgs = {
  distinct_on?: InputMaybe<Array<Go1_History_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_History_Events_Order_By>>;
  where?: InputMaybe<Go1_History_Events_Bool_Exp>;
};


export type Query_RootGo1_History_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Go1_History_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_History_Events_Order_By>>;
  where?: InputMaybe<Go1_History_Events_Bool_Exp>;
};


export type Query_RootGo1_History_Events_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootGo1_LicensesArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_Order_By>>;
  where?: InputMaybe<Go1_Licenses_Bool_Exp>;
};


export type Query_RootGo1_Licenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_Order_By>>;
  where?: InputMaybe<Go1_Licenses_Bool_Exp>;
};


export type Query_RootGo1_Licenses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGo1_Licenses_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_History_Order_By>>;
  where?: InputMaybe<Go1_Licenses_History_Bool_Exp>;
};


export type Query_RootGo1_Licenses_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_History_Order_By>>;
  where?: InputMaybe<Go1_Licenses_History_Bool_Exp>;
};


export type Query_RootGo1_Licenses_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootGradeArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Query_RootGrade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Query_RootGrade_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootHubspot_AuditArgs = {
  distinct_on?: InputMaybe<Array<Hubspot_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hubspot_Audit_Order_By>>;
  where?: InputMaybe<Hubspot_Audit_Bool_Exp>;
};


export type Query_RootHubspot_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hubspot_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hubspot_Audit_Order_By>>;
  where?: InputMaybe<Hubspot_Audit_Bool_Exp>;
};


export type Query_RootHubspot_Audit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootIdentityArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


export type Query_RootIdentity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


export type Query_RootIdentity_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootIdentity_TypeArgs = {
  distinct_on?: InputMaybe<Array<Identity_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Type_Order_By>>;
  where?: InputMaybe<Identity_Type_Bool_Exp>;
};


export type Query_RootIdentity_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identity_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Type_Order_By>>;
  where?: InputMaybe<Identity_Type_Bool_Exp>;
};


export type Query_RootIdentity_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Query_RootImportArloCertificatesArgs = {
  id: Scalars['uuid'];
};


export type Query_RootImport_JobArgs = {
  distinct_on?: InputMaybe<Array<Import_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_Job_Order_By>>;
  where?: InputMaybe<Import_Job_Bool_Exp>;
};


export type Query_RootImport_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_Job_Order_By>>;
  where?: InputMaybe<Import_Job_Bool_Exp>;
};


export type Query_RootImport_Job_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootImport_Job_StatusArgs = {
  distinct_on?: InputMaybe<Array<Import_Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_Job_Status_Order_By>>;
  where?: InputMaybe<Import_Job_Status_Bool_Exp>;
};


export type Query_RootImport_Job_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_Job_Status_Order_By>>;
  where?: InputMaybe<Import_Job_Status_Bool_Exp>;
};


export type Query_RootImport_Job_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootImport_Job_TypeArgs = {
  distinct_on?: InputMaybe<Array<Import_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_Job_Type_Order_By>>;
  where?: InputMaybe<Import_Job_Type_Bool_Exp>;
};


export type Query_RootImport_Job_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_Job_Type_Order_By>>;
  where?: InputMaybe<Import_Job_Type_Bool_Exp>;
};


export type Query_RootImport_Job_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootIsUserSubscribedToMembershipArgs = {
  customerId: Scalars['String'];
};


export type Query_RootJob_TitleArgs = {
  distinct_on?: InputMaybe<Array<Job_Title_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Title_Order_By>>;
  where?: InputMaybe<Job_Title_Bool_Exp>;
};


export type Query_RootJob_Title_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Title_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Title_Order_By>>;
  where?: InputMaybe<Job_Title_Bool_Exp>;
};


export type Query_RootJob_Title_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootLegacy_CertificateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Certificate_Order_By>>;
  where?: InputMaybe<Legacy_Certificate_Bool_Exp>;
};


export type Query_RootLegacy_Certificate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Certificate_Order_By>>;
  where?: InputMaybe<Legacy_Certificate_Bool_Exp>;
};


export type Query_RootLegacy_Certificate_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMaterials_OrderArgs = {
  distinct_on?: InputMaybe<Array<Materials_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Materials_Order_Order_By>>;
  where?: InputMaybe<Materials_Order_Bool_Exp>;
};


export type Query_RootMaterials_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Materials_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Materials_Order_Order_By>>;
  where?: InputMaybe<Materials_Order_Bool_Exp>;
};


export type Query_RootMaterials_Order_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMerge_Organizations_LogsArgs = {
  distinct_on?: InputMaybe<Array<Merge_Organizations_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Merge_Organizations_Logs_Order_By>>;
  where?: InputMaybe<Merge_Organizations_Logs_Bool_Exp>;
};


export type Query_RootMerge_Organizations_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Merge_Organizations_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Merge_Organizations_Logs_Order_By>>;
  where?: InputMaybe<Merge_Organizations_Logs_Bool_Exp>;
};


export type Query_RootMerge_Organizations_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootMerged_OrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Merged_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Merged_Organizations_Order_By>>;
  where?: InputMaybe<Merged_Organizations_Bool_Exp>;
};


export type Query_RootMerged_Organizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Merged_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Merged_Organizations_Order_By>>;
  where?: InputMaybe<Merged_Organizations_Bool_Exp>;
};


export type Query_RootMerged_Organizations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootModuleArgs = {
  distinct_on?: InputMaybe<Array<Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Order_By>>;
  where?: InputMaybe<Module_Bool_Exp>;
};


export type Query_RootModule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Order_By>>;
  where?: InputMaybe<Module_Bool_Exp>;
};


export type Query_RootModule_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootModule_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Module_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Category_Order_By>>;
  where?: InputMaybe<Module_Category_Bool_Exp>;
};


export type Query_RootModule_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Category_Order_By>>;
  where?: InputMaybe<Module_Category_Bool_Exp>;
};


export type Query_RootModule_Category_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootModule_GroupArgs = {
  distinct_on?: InputMaybe<Array<Module_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Group_Order_By>>;
  where?: InputMaybe<Module_Group_Bool_Exp>;
};


export type Query_RootModule_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Group_Order_By>>;
  where?: InputMaybe<Module_Group_Bool_Exp>;
};


export type Query_RootModule_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootModule_Group_DurationArgs = {
  distinct_on?: InputMaybe<Array<Module_Group_Duration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Group_Duration_Order_By>>;
  where?: InputMaybe<Module_Group_Duration_Bool_Exp>;
};


export type Query_RootModule_Group_Duration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Group_Duration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Group_Duration_Order_By>>;
  where?: InputMaybe<Module_Group_Duration_Bool_Exp>;
};


export type Query_RootModule_Group_Duration_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootModule_SettingArgs = {
  distinct_on?: InputMaybe<Array<Module_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Setting_Order_By>>;
  where?: InputMaybe<Module_Setting_Bool_Exp>;
};


export type Query_RootModule_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Setting_Order_By>>;
  where?: InputMaybe<Module_Setting_Bool_Exp>;
};


export type Query_RootModule_Setting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootModule_Setting_DependencyArgs = {
  distinct_on?: InputMaybe<Array<Module_Setting_Dependency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Setting_Dependency_Order_By>>;
  where?: InputMaybe<Module_Setting_Dependency_Bool_Exp>;
};


export type Query_RootModule_Setting_Dependency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Setting_Dependency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Setting_Dependency_Order_By>>;
  where?: InputMaybe<Module_Setting_Dependency_Bool_Exp>;
};


export type Query_RootModule_Setting_Dependency_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootModule_V2Args = {
  distinct_on?: InputMaybe<Array<Module_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_V2_Order_By>>;
  where?: InputMaybe<Module_V2_Bool_Exp>;
};


export type Query_RootModule_V2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_V2_Order_By>>;
  where?: InputMaybe<Module_V2_Bool_Exp>;
};


export type Query_RootModule_V2_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootNon_Graded_CertificateArgs = {
  distinct_on?: InputMaybe<Array<Non_Graded_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Non_Graded_Certificate_Order_By>>;
  where?: InputMaybe<Non_Graded_Certificate_Bool_Exp>;
};


export type Query_RootNon_Graded_Certificate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Non_Graded_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Non_Graded_Certificate_Order_By>>;
  where?: InputMaybe<Non_Graded_Certificate_Bool_Exp>;
};


export type Query_RootNon_Graded_Certificate_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Query_RootOrder_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrder_TempArgs = {
  distinct_on?: InputMaybe<Array<Order_Temp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Temp_Order_By>>;
  where?: InputMaybe<Order_Temp_Bool_Exp>;
};


export type Query_RootOrder_Temp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Temp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Temp_Order_By>>;
  where?: InputMaybe<Order_Temp_Bool_Exp>;
};


export type Query_RootOrder_Temp_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrg_Created_FromArgs = {
  distinct_on?: InputMaybe<Array<Org_Created_From_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Created_From_Order_By>>;
  where?: InputMaybe<Org_Created_From_Bool_Exp>;
};


export type Query_RootOrg_Created_From_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Created_From_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Created_From_Order_By>>;
  where?: InputMaybe<Org_Created_From_Bool_Exp>;
};


export type Query_RootOrg_Created_From_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootOrg_Distinct_Country_CodesArgs = {
  distinct_on?: InputMaybe<Array<Org_Distinct_Country_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Distinct_Country_Codes_Order_By>>;
  where?: InputMaybe<Org_Distinct_Country_Codes_Bool_Exp>;
};


export type Query_RootOrg_Distinct_Country_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Distinct_Country_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Distinct_Country_Codes_Order_By>>;
  where?: InputMaybe<Org_Distinct_Country_Codes_Bool_Exp>;
};


export type Query_RootOrg_Resource_Packs_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_History_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_History_Bool_Exp>;
};


export type Query_RootOrg_Resource_Packs_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_History_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_History_Bool_Exp>;
};


export type Query_RootOrg_Resource_Packs_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrg_Resource_Packs_PricingArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_Pricing_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
};


export type Query_RootOrg_Resource_Packs_Pricing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_Pricing_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
};


export type Query_RootOrg_Resource_Packs_Pricing_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrg_Resource_Packs_Pricing_ChangelogArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_Pricing_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_Pricing_Changelog_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Bool_Exp>;
};


export type Query_RootOrg_Resource_Packs_Pricing_Changelog_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_Pricing_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_Pricing_Changelog_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Bool_Exp>;
};


export type Query_RootOrg_Resource_Packs_Pricing_Changelog_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganisation_LogArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Log_Order_By>>;
  where?: InputMaybe<Organisation_Log_Bool_Exp>;
};


export type Query_RootOrganisation_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Log_Order_By>>;
  where?: InputMaybe<Organisation_Log_Bool_Exp>;
};


export type Query_RootOrganisation_Log_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganisation_SectorArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Sector_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Sector_Order_By>>;
  where?: InputMaybe<Organisation_Sector_Bool_Exp>;
};


export type Query_RootOrganisation_Sector_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Sector_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Sector_Order_By>>;
  where?: InputMaybe<Organisation_Sector_Bool_Exp>;
};


export type Query_RootOrganisation_Sector_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootOrganization_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganization_InvitesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Invites_Order_By>>;
  where?: InputMaybe<Organization_Invites_Bool_Exp>;
};


export type Query_RootOrganization_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Invites_Order_By>>;
  where?: InputMaybe<Organization_Invites_Bool_Exp>;
};


export type Query_RootOrganization_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganization_MemberArgs = {
  distinct_on?: InputMaybe<Array<Organization_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Member_Order_By>>;
  where?: InputMaybe<Organization_Member_Bool_Exp>;
};


export type Query_RootOrganization_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Member_Order_By>>;
  where?: InputMaybe<Organization_Member_Bool_Exp>;
};


export type Query_RootOrganization_Member_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganization_Resource_PacksArgs = {
  distinct_on?: InputMaybe<Array<Organization_Resource_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Resource_Packs_Order_By>>;
  where?: InputMaybe<Organization_Resource_Packs_Bool_Exp>;
};


export type Query_RootOrganization_Resource_Packs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Resource_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Resource_Packs_Order_By>>;
  where?: InputMaybe<Organization_Resource_Packs_Bool_Exp>;
};


export type Query_RootOrganization_Resource_Packs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganization_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Type_Order_By>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Query_RootOrganization_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Type_Order_By>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Query_RootOrganization_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootOrganizations_StatisticsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Statistics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Statistics_Order_By>>;
  where?: InputMaybe<Organizations_Statistics_Bool_Exp>;
};


export type Query_RootOrganizations_Statistics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Statistics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Statistics_Order_By>>;
  where?: InputMaybe<Organizations_Statistics_Bool_Exp>;
};


export type Query_RootOrganizations_Statistics_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Query_RootPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Query_RootPayment_Methods_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootPodcastArgs = {
  id: Scalars['ID'];
};


export type Query_RootPodcastsArgs = {
  input?: InputMaybe<PodcastsInput>;
};


export type Query_RootPost_Training_Email_Scheduled_EventsArgs = {
  distinct_on?: InputMaybe<Array<Post_Training_Email_Scheduled_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Post_Training_Email_Scheduled_Events_Order_By>>;
  where?: InputMaybe<Post_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Query_RootPost_Training_Email_Scheduled_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Post_Training_Email_Scheduled_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Post_Training_Email_Scheduled_Events_Order_By>>;
  where?: InputMaybe<Post_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Query_RootPost_Training_Email_Scheduled_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPre_Training_Email_Scheduled_EventsArgs = {
  distinct_on?: InputMaybe<Array<Pre_Training_Email_Scheduled_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Training_Email_Scheduled_Events_Order_By>>;
  where?: InputMaybe<Pre_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Query_RootPre_Training_Email_Scheduled_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pre_Training_Email_Scheduled_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Training_Email_Scheduled_Events_Order_By>>;
  where?: InputMaybe<Pre_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Query_RootPre_Training_Email_Scheduled_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPrecision_Order_StatusArgs = {
  distinct_on?: InputMaybe<Array<Precision_Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Precision_Order_Status_Order_By>>;
  where?: InputMaybe<Precision_Order_Status_Bool_Exp>;
};


export type Query_RootPrecision_Order_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Precision_Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Precision_Order_Status_Order_By>>;
  where?: InputMaybe<Precision_Order_Status_Bool_Exp>;
};


export type Query_RootPrecision_Order_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootPrivate_Course_BookingArgs = {
  distinct_on?: InputMaybe<Array<Private_Course_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Private_Course_Booking_Order_By>>;
  where?: InputMaybe<Private_Course_Booking_Bool_Exp>;
};


export type Query_RootPrivate_Course_Booking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Private_Course_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Private_Course_Booking_Order_By>>;
  where?: InputMaybe<Private_Course_Booking_Bool_Exp>;
};


export type Query_RootPrivate_Course_Booking_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProfileArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Query_RootProfile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Query_RootProfile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProfile_RoleArgs = {
  distinct_on?: InputMaybe<Array<Profile_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Role_Order_By>>;
  where?: InputMaybe<Profile_Role_Bool_Exp>;
};


export type Query_RootProfile_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Role_Order_By>>;
  where?: InputMaybe<Profile_Role_Bool_Exp>;
};


export type Query_RootProfile_Role_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProfile_TempArgs = {
  distinct_on?: InputMaybe<Array<Profile_Temp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Temp_Order_By>>;
  where?: InputMaybe<Profile_Temp_Bool_Exp>;
};


export type Query_RootProfile_Temp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Temp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Temp_Order_By>>;
  where?: InputMaybe<Profile_Temp_Bool_Exp>;
};


export type Query_RootProfile_Temp_By_PkArgs = {
  id: Scalars['Int'];
};


export type Query_RootProfile_Trainer_Agreement_TypeArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Agreement_Type_Bool_Exp>;
};


export type Query_RootProfile_Trainer_Agreement_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Agreement_Type_Bool_Exp>;
};


export type Query_RootProfile_Trainer_Agreement_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootProfile_Trainer_Role_TypeArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Role_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
};


export type Query_RootProfile_Trainer_Role_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Role_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
};


export type Query_RootProfile_Trainer_Role_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPromo_CodeArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Order_By>>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};


export type Query_RootPromo_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Order_By>>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};


export type Query_RootPromo_Code_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootPromo_Code_TypeArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Type_Order_By>>;
  where?: InputMaybe<Promo_Code_Type_Bool_Exp>;
};


export type Query_RootPromo_Code_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Type_Order_By>>;
  where?: InputMaybe<Promo_Code_Type_Bool_Exp>;
};


export type Query_RootPromo_Code_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootResource_Pack_Bundle_Course_LevelArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Course_Level_Bool_Exp>;
};


export type Query_RootResource_Pack_Bundle_Course_Level_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Course_Level_Bool_Exp>;
};


export type Query_RootResource_Pack_Bundle_Course_Level_By_PkArgs = {
  course_level: Course_Level_Enum;
  resource_pack_bundle: Scalars['uuid'];
};


export type Query_RootResource_Pack_Bundle_OptionArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Option_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Option_Bool_Exp>;
};


export type Query_RootResource_Pack_Bundle_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Option_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Option_Bool_Exp>;
};


export type Query_RootResource_Pack_Bundle_Option_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootResource_Pack_Bundle_PriceArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Price_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Price_Bool_Exp>;
};


export type Query_RootResource_Pack_Bundle_Price_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Price_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Price_Bool_Exp>;
};


export type Query_RootResource_Pack_Bundle_Price_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootResource_Packs_Delivery_TypeArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Delivery_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Delivery_Type_Order_By>>;
  where?: InputMaybe<Resource_Packs_Delivery_Type_Bool_Exp>;
};


export type Query_RootResource_Packs_Delivery_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Delivery_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Delivery_Type_Order_By>>;
  where?: InputMaybe<Resource_Packs_Delivery_Type_Bool_Exp>;
};


export type Query_RootResource_Packs_Delivery_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootResource_Packs_EventsArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Events_Order_By>>;
  where?: InputMaybe<Resource_Packs_Events_Bool_Exp>;
};


export type Query_RootResource_Packs_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Events_Order_By>>;
  where?: InputMaybe<Resource_Packs_Events_Bool_Exp>;
};


export type Query_RootResource_Packs_Events_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootResource_Packs_PricingArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Pricing_Order_By>>;
  where?: InputMaybe<Resource_Packs_Pricing_Bool_Exp>;
};


export type Query_RootResource_Packs_Pricing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Pricing_Order_By>>;
  where?: InputMaybe<Resource_Packs_Pricing_Bool_Exp>;
};


export type Query_RootResource_Packs_Pricing_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootResource_Packs_TypeArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Type_Order_By>>;
  where?: InputMaybe<Resource_Packs_Type_Bool_Exp>;
};


export type Query_RootResource_Packs_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Type_Order_By>>;
  where?: InputMaybe<Resource_Packs_Type_Bool_Exp>;
};


export type Query_RootResource_Packs_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootRoleArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Query_RootRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Query_RootRole_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootScheduled_Events_ViewArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Events_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scheduled_Events_View_Order_By>>;
  where?: InputMaybe<Scheduled_Events_View_Bool_Exp>;
};


export type Query_RootScheduled_Events_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Events_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scheduled_Events_View_Order_By>>;
  where?: InputMaybe<Scheduled_Events_View_Bool_Exp>;
};


export type Query_RootSearchTrainersArgs = {
  input: SearchTrainersInput;
};


export type Query_RootSearch_Dfe_EstablishmentsArgs = {
  args: Search_Dfe_Establishments_Args;
  distinct_on?: InputMaybe<Array<Dfe_Establishment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dfe_Establishment_Order_By>>;
  where?: InputMaybe<Dfe_Establishment_Bool_Exp>;
};


export type Query_RootSearch_Dfe_Establishments_AggregateArgs = {
  args: Search_Dfe_Establishments_Args;
  distinct_on?: InputMaybe<Array<Dfe_Establishment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dfe_Establishment_Order_By>>;
  where?: InputMaybe<Dfe_Establishment_Bool_Exp>;
};


export type Query_RootSearch_OrganizationsArgs = {
  args: Search_Organizations_Args;
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootSearch_Organizations_AggregateArgs = {
  args: Search_Organizations_Args;
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Query_RootSplash_ScreensArgs = {
  distinct_on?: InputMaybe<Array<Splash_Screens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Splash_Screens_Order_By>>;
  where?: InputMaybe<Splash_Screens_Bool_Exp>;
};


export type Query_RootSplash_Screens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Splash_Screens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Splash_Screens_Order_By>>;
  where?: InputMaybe<Splash_Screens_Bool_Exp>;
};


export type Query_RootSplash_Screens_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootSubmission_Of_Splash_ScreensArgs = {
  distinct_on?: InputMaybe<Array<Submission_Of_Splash_Screens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submission_Of_Splash_Screens_Order_By>>;
  where?: InputMaybe<Submission_Of_Splash_Screens_Bool_Exp>;
};


export type Query_RootSubmission_Of_Splash_Screens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Submission_Of_Splash_Screens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submission_Of_Splash_Screens_Order_By>>;
  where?: InputMaybe<Submission_Of_Splash_Screens_Bool_Exp>;
};


export type Query_RootSubmission_Of_Splash_Screens_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootSubmoduleArgs = {
  distinct_on?: InputMaybe<Array<Submodule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submodule_Order_By>>;
  where?: InputMaybe<Submodule_Bool_Exp>;
};


export type Query_RootSubmodule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Submodule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submodule_Order_By>>;
  where?: InputMaybe<Submodule_Bool_Exp>;
};


export type Query_RootSubmodule_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTrainer_Agreement_TypeArgs = {
  distinct_on?: InputMaybe<Array<Trainer_Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trainer_Agreement_Type_Order_By>>;
  where?: InputMaybe<Trainer_Agreement_Type_Bool_Exp>;
};


export type Query_RootTrainer_Agreement_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trainer_Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trainer_Agreement_Type_Order_By>>;
  where?: InputMaybe<Trainer_Agreement_Type_Bool_Exp>;
};


export type Query_RootTrainer_Agreement_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootTrainer_Role_TypeArgs = {
  distinct_on?: InputMaybe<Array<Trainer_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trainer_Role_Type_Order_By>>;
  where?: InputMaybe<Trainer_Role_Type_Bool_Exp>;
};


export type Query_RootTrainer_Role_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trainer_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trainer_Role_Type_Order_By>>;
  where?: InputMaybe<Trainer_Role_Type_Bool_Exp>;
};


export type Query_RootTrainer_Role_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootTrust_TypeArgs = {
  distinct_on?: InputMaybe<Array<Trust_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trust_Type_Order_By>>;
  where?: InputMaybe<Trust_Type_Bool_Exp>;
};


export type Query_RootTrust_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trust_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trust_Type_Order_By>>;
  where?: InputMaybe<Trust_Type_Bool_Exp>;
};


export type Query_RootTrust_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootTt_Client_Invite_LogArgs = {
  distinct_on?: InputMaybe<Array<Tt_Client_Invite_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tt_Client_Invite_Log_Order_By>>;
  where?: InputMaybe<Tt_Client_Invite_Log_Bool_Exp>;
};


export type Query_RootTt_Client_Invite_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tt_Client_Invite_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tt_Client_Invite_Log_Order_By>>;
  where?: InputMaybe<Tt_Client_Invite_Log_Bool_Exp>;
};


export type Query_RootTt_Client_Invite_Log_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootUpcoming_EnrollmentsArgs = {
  distinct_on?: InputMaybe<Array<Upcoming_Enrollments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Upcoming_Enrollments_Order_By>>;
  where?: InputMaybe<Upcoming_Enrollments_Bool_Exp>;
};


export type Query_RootUpcoming_Enrollments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Upcoming_Enrollments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Upcoming_Enrollments_Order_By>>;
  where?: InputMaybe<Upcoming_Enrollments_Bool_Exp>;
};


export type Query_RootUser_Auth_Audit_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Audit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Audit_Type_Order_By>>;
  where?: InputMaybe<User_Auth_Audit_Type_Bool_Exp>;
};


export type Query_RootUser_Auth_Audit_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Audit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Audit_Type_Order_By>>;
  where?: InputMaybe<User_Auth_Audit_Type_Bool_Exp>;
};


export type Query_RootUser_Auth_Audit_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Query_RootUser_Auth_AuditsArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Audits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Audits_Order_By>>;
  where?: InputMaybe<User_Auth_Audits_Bool_Exp>;
};


export type Query_RootUser_Auth_Audits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Audits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Audits_Order_By>>;
  where?: InputMaybe<User_Auth_Audits_Bool_Exp>;
};


export type Query_RootUser_Auth_Audits_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenueArgs = {
  distinct_on?: InputMaybe<Array<Venue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Venue_Order_By>>;
  where?: InputMaybe<Venue_Bool_Exp>;
};


export type Query_RootVenue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Venue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Venue_Order_By>>;
  where?: InputMaybe<Venue_Bool_Exp>;
};


export type Query_RootVenue_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootVenue_Check_JobsArgs = {
  distinct_on?: InputMaybe<Array<Venue_Check_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Venue_Check_Jobs_Order_By>>;
  where?: InputMaybe<Venue_Check_Jobs_Bool_Exp>;
};


export type Query_RootVenue_Check_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Venue_Check_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Venue_Check_Jobs_Order_By>>;
  where?: InputMaybe<Venue_Check_Jobs_Bool_Exp>;
};


export type Query_RootVenue_Check_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootWaitlistArgs = {
  distinct_on?: InputMaybe<Array<Waitlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Waitlist_Order_By>>;
  where?: InputMaybe<Waitlist_Bool_Exp>;
};


export type Query_RootWaitlist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Waitlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Waitlist_Order_By>>;
  where?: InputMaybe<Waitlist_Bool_Exp>;
};


export type Query_RootWaitlist_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootXeroContactSearchArgs = {
  input: XeroContactSearchInput;
};


export type Query_RootXeroInvoicesStatusArgs = {
  input: XeroInvoicesStatusInput;
};


export type Query_RootXero_ContactArgs = {
  distinct_on?: InputMaybe<Array<Xero_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Contact_Order_By>>;
  where?: InputMaybe<Xero_Contact_Bool_Exp>;
};


export type Query_RootXero_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Xero_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Contact_Order_By>>;
  where?: InputMaybe<Xero_Contact_Bool_Exp>;
};


export type Query_RootXero_Contact_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootXero_CredentialArgs = {
  distinct_on?: InputMaybe<Array<Xero_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Credential_Order_By>>;
  where?: InputMaybe<Xero_Credential_Bool_Exp>;
};


export type Query_RootXero_Credential_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Xero_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Credential_Order_By>>;
  where?: InputMaybe<Xero_Credential_Bool_Exp>;
};


export type Query_RootXero_Credential_By_PkArgs = {
  client_id: Scalars['String'];
};


export type Query_RootXero_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Xero_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Invoice_Order_By>>;
  where?: InputMaybe<Xero_Invoice_Bool_Exp>;
};


export type Query_RootXero_Invoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Xero_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Invoice_Order_By>>;
  where?: InputMaybe<Xero_Invoice_Bool_Exp>;
};


export type Query_RootXero_Invoice_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Query_RootXero_Invoice_StatusArgs = {
  distinct_on?: InputMaybe<Array<Xero_Invoice_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Invoice_Status_Order_By>>;
  where?: InputMaybe<Xero_Invoice_Status_Bool_Exp>;
};


export type Query_RootXero_Invoice_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Xero_Invoice_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Invoice_Status_Order_By>>;
  where?: InputMaybe<Xero_Invoice_Status_Bool_Exp>;
};


export type Query_RootXero_Invoice_Status_By_PkArgs = {
  name: Scalars['String'];
};

/** This table keeps track of what resource pack bundle is applicable for which level. */
export type Resource_Pack_Bundle_Course_Level = {
  __typename?: 'resource_pack_bundle_course_level';
  course_level: Course_Level_Enum;
  resource_pack_bundle: Scalars['uuid'];
};

/** aggregated selection of "resource_pack_bundle_course_level" */
export type Resource_Pack_Bundle_Course_Level_Aggregate = {
  __typename?: 'resource_pack_bundle_course_level_aggregate';
  aggregate?: Maybe<Resource_Pack_Bundle_Course_Level_Aggregate_Fields>;
  nodes: Array<Resource_Pack_Bundle_Course_Level>;
};

export type Resource_Pack_Bundle_Course_Level_Aggregate_Bool_Exp = {
  count?: InputMaybe<Resource_Pack_Bundle_Course_Level_Aggregate_Bool_Exp_Count>;
};

export type Resource_Pack_Bundle_Course_Level_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Resource_Pack_Bundle_Course_Level_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "resource_pack_bundle_course_level" */
export type Resource_Pack_Bundle_Course_Level_Aggregate_Fields = {
  __typename?: 'resource_pack_bundle_course_level_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Resource_Pack_Bundle_Course_Level_Max_Fields>;
  min?: Maybe<Resource_Pack_Bundle_Course_Level_Min_Fields>;
};


/** aggregate fields of "resource_pack_bundle_course_level" */
export type Resource_Pack_Bundle_Course_Level_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "resource_pack_bundle_course_level" */
export type Resource_Pack_Bundle_Course_Level_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Resource_Pack_Bundle_Course_Level_Max_Order_By>;
  min?: InputMaybe<Resource_Pack_Bundle_Course_Level_Min_Order_By>;
};

/** input type for inserting array relation for remote table "resource_pack_bundle_course_level" */
export type Resource_Pack_Bundle_Course_Level_Arr_Rel_Insert_Input = {
  data: Array<Resource_Pack_Bundle_Course_Level_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Resource_Pack_Bundle_Course_Level_On_Conflict>;
};

/** Boolean expression to filter rows from the table "resource_pack_bundle_course_level". All fields are combined with a logical 'AND'. */
export type Resource_Pack_Bundle_Course_Level_Bool_Exp = {
  _and?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Bool_Exp>>;
  _not?: InputMaybe<Resource_Pack_Bundle_Course_Level_Bool_Exp>;
  _or?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Bool_Exp>>;
  course_level?: InputMaybe<Course_Level_Enum_Comparison_Exp>;
  resource_pack_bundle?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "resource_pack_bundle_course_level" */
export enum Resource_Pack_Bundle_Course_Level_Constraint {
  /** unique or primary key constraint on columns "course_level", "resource_pack_bundle" */
  ResourcePackBundleCourseLevelPkey = 'resource_pack_bundle_course_level_pkey'
}

/** input type for inserting data into table "resource_pack_bundle_course_level" */
export type Resource_Pack_Bundle_Course_Level_Insert_Input = {
  course_level?: InputMaybe<Course_Level_Enum>;
  resource_pack_bundle?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Resource_Pack_Bundle_Course_Level_Max_Fields = {
  __typename?: 'resource_pack_bundle_course_level_max_fields';
  resource_pack_bundle?: Maybe<Scalars['uuid']>;
};

/** order by max() on columns of table "resource_pack_bundle_course_level" */
export type Resource_Pack_Bundle_Course_Level_Max_Order_By = {
  resource_pack_bundle?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Resource_Pack_Bundle_Course_Level_Min_Fields = {
  __typename?: 'resource_pack_bundle_course_level_min_fields';
  resource_pack_bundle?: Maybe<Scalars['uuid']>;
};

/** order by min() on columns of table "resource_pack_bundle_course_level" */
export type Resource_Pack_Bundle_Course_Level_Min_Order_By = {
  resource_pack_bundle?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "resource_pack_bundle_course_level" */
export type Resource_Pack_Bundle_Course_Level_Mutation_Response = {
  __typename?: 'resource_pack_bundle_course_level_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Resource_Pack_Bundle_Course_Level>;
};

/** on_conflict condition type for table "resource_pack_bundle_course_level" */
export type Resource_Pack_Bundle_Course_Level_On_Conflict = {
  constraint: Resource_Pack_Bundle_Course_Level_Constraint;
  update_columns?: Array<Resource_Pack_Bundle_Course_Level_Update_Column>;
  where?: InputMaybe<Resource_Pack_Bundle_Course_Level_Bool_Exp>;
};

/** Ordering options when selecting data from "resource_pack_bundle_course_level". */
export type Resource_Pack_Bundle_Course_Level_Order_By = {
  course_level?: InputMaybe<Order_By>;
  resource_pack_bundle?: InputMaybe<Order_By>;
};

/** primary key columns input for table: resource_pack_bundle_course_level */
export type Resource_Pack_Bundle_Course_Level_Pk_Columns_Input = {
  course_level: Course_Level_Enum;
  resource_pack_bundle: Scalars['uuid'];
};

/** select columns of table "resource_pack_bundle_course_level" */
export enum Resource_Pack_Bundle_Course_Level_Select_Column {
  /** column name */
  CourseLevel = 'course_level',
  /** column name */
  ResourcePackBundle = 'resource_pack_bundle'
}

/** input type for updating data in table "resource_pack_bundle_course_level" */
export type Resource_Pack_Bundle_Course_Level_Set_Input = {
  course_level?: InputMaybe<Course_Level_Enum>;
  resource_pack_bundle?: InputMaybe<Scalars['uuid']>;
};

/** Streaming cursor of the table "resource_pack_bundle_course_level" */
export type Resource_Pack_Bundle_Course_Level_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Resource_Pack_Bundle_Course_Level_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Resource_Pack_Bundle_Course_Level_Stream_Cursor_Value_Input = {
  course_level?: InputMaybe<Course_Level_Enum>;
  resource_pack_bundle?: InputMaybe<Scalars['uuid']>;
};

/** update columns of table "resource_pack_bundle_course_level" */
export enum Resource_Pack_Bundle_Course_Level_Update_Column {
  /** column name */
  CourseLevel = 'course_level',
  /** column name */
  ResourcePackBundle = 'resource_pack_bundle'
}

export type Resource_Pack_Bundle_Course_Level_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Resource_Pack_Bundle_Course_Level_Set_Input>;
  /** filter the rows which have to be updated */
  where: Resource_Pack_Bundle_Course_Level_Bool_Exp;
};

/** columns and relationships of "resource_pack_bundle_option" */
export type Resource_Pack_Bundle_Option = {
  __typename?: 'resource_pack_bundle_option';
  name: Scalars['String'];
};

/** aggregated selection of "resource_pack_bundle_option" */
export type Resource_Pack_Bundle_Option_Aggregate = {
  __typename?: 'resource_pack_bundle_option_aggregate';
  aggregate?: Maybe<Resource_Pack_Bundle_Option_Aggregate_Fields>;
  nodes: Array<Resource_Pack_Bundle_Option>;
};

/** aggregate fields of "resource_pack_bundle_option" */
export type Resource_Pack_Bundle_Option_Aggregate_Fields = {
  __typename?: 'resource_pack_bundle_option_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Resource_Pack_Bundle_Option_Max_Fields>;
  min?: Maybe<Resource_Pack_Bundle_Option_Min_Fields>;
};


/** aggregate fields of "resource_pack_bundle_option" */
export type Resource_Pack_Bundle_Option_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Resource_Pack_Bundle_Option_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "resource_pack_bundle_option". All fields are combined with a logical 'AND'. */
export type Resource_Pack_Bundle_Option_Bool_Exp = {
  _and?: InputMaybe<Array<Resource_Pack_Bundle_Option_Bool_Exp>>;
  _not?: InputMaybe<Resource_Pack_Bundle_Option_Bool_Exp>;
  _or?: InputMaybe<Array<Resource_Pack_Bundle_Option_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "resource_pack_bundle_option" */
export enum Resource_Pack_Bundle_Option_Constraint {
  /** unique or primary key constraint on columns "name" */
  ResourcePackBundleOptionPkey = 'resource_pack_bundle_option_pkey'
}

export enum Resource_Pack_Bundle_Option_Enum {
  FourtyEightPack = 'FOURTY_EIGHT_PACK',
  NinetySixPack = 'NINETY_SIX_PACK',
  OneHundredFortyFourPack = 'ONE_HUNDRED_FORTY_FOUR_PACK',
  OneHundredNinetyTwoPack = 'ONE_HUNDRED_NINETY_TWO_PACK',
  OnePack = 'ONE_PACK',
  ThirtySixPack = 'THIRTY_SIX_PACK',
  TwelvePack = 'TWELVE_PACK',
  TwentyFourPack = 'TWENTY_FOUR_PACK'
}

/** Boolean expression to compare columns of type "resource_pack_bundle_option_enum". All fields are combined with logical 'AND'. */
export type Resource_Pack_Bundle_Option_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Resource_Pack_Bundle_Option_Enum>;
  _in?: InputMaybe<Array<Resource_Pack_Bundle_Option_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Resource_Pack_Bundle_Option_Enum>;
  _nin?: InputMaybe<Array<Resource_Pack_Bundle_Option_Enum>>;
};

/** input type for inserting data into table "resource_pack_bundle_option" */
export type Resource_Pack_Bundle_Option_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Resource_Pack_Bundle_Option_Max_Fields = {
  __typename?: 'resource_pack_bundle_option_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Resource_Pack_Bundle_Option_Min_Fields = {
  __typename?: 'resource_pack_bundle_option_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "resource_pack_bundle_option" */
export type Resource_Pack_Bundle_Option_Mutation_Response = {
  __typename?: 'resource_pack_bundle_option_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Resource_Pack_Bundle_Option>;
};

/** on_conflict condition type for table "resource_pack_bundle_option" */
export type Resource_Pack_Bundle_Option_On_Conflict = {
  constraint: Resource_Pack_Bundle_Option_Constraint;
  update_columns?: Array<Resource_Pack_Bundle_Option_Update_Column>;
  where?: InputMaybe<Resource_Pack_Bundle_Option_Bool_Exp>;
};

/** Ordering options when selecting data from "resource_pack_bundle_option". */
export type Resource_Pack_Bundle_Option_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: resource_pack_bundle_option */
export type Resource_Pack_Bundle_Option_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "resource_pack_bundle_option" */
export enum Resource_Pack_Bundle_Option_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "resource_pack_bundle_option" */
export type Resource_Pack_Bundle_Option_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "resource_pack_bundle_option" */
export type Resource_Pack_Bundle_Option_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Resource_Pack_Bundle_Option_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Resource_Pack_Bundle_Option_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "resource_pack_bundle_option" */
export enum Resource_Pack_Bundle_Option_Update_Column {
  /** column name */
  Name = 'name'
}

export type Resource_Pack_Bundle_Option_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Resource_Pack_Bundle_Option_Set_Input>;
  /** filter the rows which have to be updated */
  where: Resource_Pack_Bundle_Option_Bool_Exp;
};

/** columns and relationships of "resource_pack_bundle_price" */
export type Resource_Pack_Bundle_Price = {
  __typename?: 'resource_pack_bundle_price';
  bundle_option: Resource_Pack_Bundle_Option_Enum;
  currency?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  postage_and_packing: Scalars['numeric'];
  price: Scalars['numeric'];
  qty: Scalars['numeric'];
  /** An array relationship */
  resource_pack_bundle_course_levels: Array<Resource_Pack_Bundle_Course_Level>;
  /** An aggregate relationship */
  resource_pack_bundle_course_levels_aggregate: Resource_Pack_Bundle_Course_Level_Aggregate;
  sku: Scalars['String'];
  total: Scalars['numeric'];
};


/** columns and relationships of "resource_pack_bundle_price" */
export type Resource_Pack_Bundle_PriceResource_Pack_Bundle_Course_LevelsArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Course_Level_Bool_Exp>;
};


/** columns and relationships of "resource_pack_bundle_price" */
export type Resource_Pack_Bundle_PriceResource_Pack_Bundle_Course_Levels_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Course_Level_Bool_Exp>;
};

/** aggregated selection of "resource_pack_bundle_price" */
export type Resource_Pack_Bundle_Price_Aggregate = {
  __typename?: 'resource_pack_bundle_price_aggregate';
  aggregate?: Maybe<Resource_Pack_Bundle_Price_Aggregate_Fields>;
  nodes: Array<Resource_Pack_Bundle_Price>;
};

/** aggregate fields of "resource_pack_bundle_price" */
export type Resource_Pack_Bundle_Price_Aggregate_Fields = {
  __typename?: 'resource_pack_bundle_price_aggregate_fields';
  avg?: Maybe<Resource_Pack_Bundle_Price_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Resource_Pack_Bundle_Price_Max_Fields>;
  min?: Maybe<Resource_Pack_Bundle_Price_Min_Fields>;
  stddev?: Maybe<Resource_Pack_Bundle_Price_Stddev_Fields>;
  stddev_pop?: Maybe<Resource_Pack_Bundle_Price_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Resource_Pack_Bundle_Price_Stddev_Samp_Fields>;
  sum?: Maybe<Resource_Pack_Bundle_Price_Sum_Fields>;
  var_pop?: Maybe<Resource_Pack_Bundle_Price_Var_Pop_Fields>;
  var_samp?: Maybe<Resource_Pack_Bundle_Price_Var_Samp_Fields>;
  variance?: Maybe<Resource_Pack_Bundle_Price_Variance_Fields>;
};


/** aggregate fields of "resource_pack_bundle_price" */
export type Resource_Pack_Bundle_Price_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Resource_Pack_Bundle_Price_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Resource_Pack_Bundle_Price_Avg_Fields = {
  __typename?: 'resource_pack_bundle_price_avg_fields';
  postage_and_packing?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "resource_pack_bundle_price". All fields are combined with a logical 'AND'. */
export type Resource_Pack_Bundle_Price_Bool_Exp = {
  _and?: InputMaybe<Array<Resource_Pack_Bundle_Price_Bool_Exp>>;
  _not?: InputMaybe<Resource_Pack_Bundle_Price_Bool_Exp>;
  _or?: InputMaybe<Array<Resource_Pack_Bundle_Price_Bool_Exp>>;
  bundle_option?: InputMaybe<Resource_Pack_Bundle_Option_Enum_Comparison_Exp>;
  currency?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  postage_and_packing?: InputMaybe<Numeric_Comparison_Exp>;
  price?: InputMaybe<Numeric_Comparison_Exp>;
  qty?: InputMaybe<Numeric_Comparison_Exp>;
  resource_pack_bundle_course_levels?: InputMaybe<Resource_Pack_Bundle_Course_Level_Bool_Exp>;
  resource_pack_bundle_course_levels_aggregate?: InputMaybe<Resource_Pack_Bundle_Course_Level_Aggregate_Bool_Exp>;
  sku?: InputMaybe<String_Comparison_Exp>;
  total?: InputMaybe<Numeric_Comparison_Exp>;
};

/** unique or primary key constraints on table "resource_pack_bundle_price" */
export enum Resource_Pack_Bundle_Price_Constraint {
  /** unique or primary key constraint on columns "id" */
  ResourcePackBundlePricePkey = 'resource_pack_bundle_price_pkey'
}

/** input type for incrementing numeric columns in table "resource_pack_bundle_price" */
export type Resource_Pack_Bundle_Price_Inc_Input = {
  postage_and_packing?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  qty?: InputMaybe<Scalars['numeric']>;
  total?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "resource_pack_bundle_price" */
export type Resource_Pack_Bundle_Price_Insert_Input = {
  bundle_option?: InputMaybe<Resource_Pack_Bundle_Option_Enum>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  postage_and_packing?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  qty?: InputMaybe<Scalars['numeric']>;
  resource_pack_bundle_course_levels?: InputMaybe<Resource_Pack_Bundle_Course_Level_Arr_Rel_Insert_Input>;
  sku?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['numeric']>;
};

/** aggregate max on columns */
export type Resource_Pack_Bundle_Price_Max_Fields = {
  __typename?: 'resource_pack_bundle_price_max_fields';
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  postage_and_packing?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  qty?: Maybe<Scalars['numeric']>;
  sku?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['numeric']>;
};

/** aggregate min on columns */
export type Resource_Pack_Bundle_Price_Min_Fields = {
  __typename?: 'resource_pack_bundle_price_min_fields';
  currency?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  postage_and_packing?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  qty?: Maybe<Scalars['numeric']>;
  sku?: Maybe<Scalars['String']>;
  total?: Maybe<Scalars['numeric']>;
};

/** response of any mutation on the table "resource_pack_bundle_price" */
export type Resource_Pack_Bundle_Price_Mutation_Response = {
  __typename?: 'resource_pack_bundle_price_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Resource_Pack_Bundle_Price>;
};

/** on_conflict condition type for table "resource_pack_bundle_price" */
export type Resource_Pack_Bundle_Price_On_Conflict = {
  constraint: Resource_Pack_Bundle_Price_Constraint;
  update_columns?: Array<Resource_Pack_Bundle_Price_Update_Column>;
  where?: InputMaybe<Resource_Pack_Bundle_Price_Bool_Exp>;
};

/** Ordering options when selecting data from "resource_pack_bundle_price". */
export type Resource_Pack_Bundle_Price_Order_By = {
  bundle_option?: InputMaybe<Order_By>;
  currency?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  postage_and_packing?: InputMaybe<Order_By>;
  price?: InputMaybe<Order_By>;
  qty?: InputMaybe<Order_By>;
  resource_pack_bundle_course_levels_aggregate?: InputMaybe<Resource_Pack_Bundle_Course_Level_Aggregate_Order_By>;
  sku?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
};

/** primary key columns input for table: resource_pack_bundle_price */
export type Resource_Pack_Bundle_Price_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "resource_pack_bundle_price" */
export enum Resource_Pack_Bundle_Price_Select_Column {
  /** column name */
  BundleOption = 'bundle_option',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  PostageAndPacking = 'postage_and_packing',
  /** column name */
  Price = 'price',
  /** column name */
  Qty = 'qty',
  /** column name */
  Sku = 'sku',
  /** column name */
  Total = 'total'
}

/** input type for updating data in table "resource_pack_bundle_price" */
export type Resource_Pack_Bundle_Price_Set_Input = {
  bundle_option?: InputMaybe<Resource_Pack_Bundle_Option_Enum>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  postage_and_packing?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  qty?: InputMaybe<Scalars['numeric']>;
  sku?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['numeric']>;
};

/** aggregate stddev on columns */
export type Resource_Pack_Bundle_Price_Stddev_Fields = {
  __typename?: 'resource_pack_bundle_price_stddev_fields';
  postage_and_packing?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Resource_Pack_Bundle_Price_Stddev_Pop_Fields = {
  __typename?: 'resource_pack_bundle_price_stddev_pop_fields';
  postage_and_packing?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Resource_Pack_Bundle_Price_Stddev_Samp_Fields = {
  __typename?: 'resource_pack_bundle_price_stddev_samp_fields';
  postage_and_packing?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "resource_pack_bundle_price" */
export type Resource_Pack_Bundle_Price_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Resource_Pack_Bundle_Price_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Resource_Pack_Bundle_Price_Stream_Cursor_Value_Input = {
  bundle_option?: InputMaybe<Resource_Pack_Bundle_Option_Enum>;
  currency?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  postage_and_packing?: InputMaybe<Scalars['numeric']>;
  price?: InputMaybe<Scalars['numeric']>;
  qty?: InputMaybe<Scalars['numeric']>;
  sku?: InputMaybe<Scalars['String']>;
  total?: InputMaybe<Scalars['numeric']>;
};

/** aggregate sum on columns */
export type Resource_Pack_Bundle_Price_Sum_Fields = {
  __typename?: 'resource_pack_bundle_price_sum_fields';
  postage_and_packing?: Maybe<Scalars['numeric']>;
  price?: Maybe<Scalars['numeric']>;
  qty?: Maybe<Scalars['numeric']>;
  total?: Maybe<Scalars['numeric']>;
};

/** update columns of table "resource_pack_bundle_price" */
export enum Resource_Pack_Bundle_Price_Update_Column {
  /** column name */
  BundleOption = 'bundle_option',
  /** column name */
  Currency = 'currency',
  /** column name */
  Id = 'id',
  /** column name */
  PostageAndPacking = 'postage_and_packing',
  /** column name */
  Price = 'price',
  /** column name */
  Qty = 'qty',
  /** column name */
  Sku = 'sku',
  /** column name */
  Total = 'total'
}

export type Resource_Pack_Bundle_Price_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Resource_Pack_Bundle_Price_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Resource_Pack_Bundle_Price_Set_Input>;
  /** filter the rows which have to be updated */
  where: Resource_Pack_Bundle_Price_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Resource_Pack_Bundle_Price_Var_Pop_Fields = {
  __typename?: 'resource_pack_bundle_price_var_pop_fields';
  postage_and_packing?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Resource_Pack_Bundle_Price_Var_Samp_Fields = {
  __typename?: 'resource_pack_bundle_price_var_samp_fields';
  postage_and_packing?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Resource_Pack_Bundle_Price_Variance_Fields = {
  __typename?: 'resource_pack_bundle_price_variance_fields';
  postage_and_packing?: Maybe<Scalars['Float']>;
  price?: Maybe<Scalars['Float']>;
  qty?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "resource_packs_delivery_type" */
export type Resource_Packs_Delivery_Type = {
  __typename?: 'resource_packs_delivery_type';
  name: Scalars['String'];
};

/** aggregated selection of "resource_packs_delivery_type" */
export type Resource_Packs_Delivery_Type_Aggregate = {
  __typename?: 'resource_packs_delivery_type_aggregate';
  aggregate?: Maybe<Resource_Packs_Delivery_Type_Aggregate_Fields>;
  nodes: Array<Resource_Packs_Delivery_Type>;
};

/** aggregate fields of "resource_packs_delivery_type" */
export type Resource_Packs_Delivery_Type_Aggregate_Fields = {
  __typename?: 'resource_packs_delivery_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Resource_Packs_Delivery_Type_Max_Fields>;
  min?: Maybe<Resource_Packs_Delivery_Type_Min_Fields>;
};


/** aggregate fields of "resource_packs_delivery_type" */
export type Resource_Packs_Delivery_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Resource_Packs_Delivery_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "resource_packs_delivery_type". All fields are combined with a logical 'AND'. */
export type Resource_Packs_Delivery_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Resource_Packs_Delivery_Type_Bool_Exp>>;
  _not?: InputMaybe<Resource_Packs_Delivery_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Resource_Packs_Delivery_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "resource_packs_delivery_type" */
export enum Resource_Packs_Delivery_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  ResourcePacksDeliveryTypePkey = 'resource_packs_delivery_type_pkey'
}

export enum Resource_Packs_Delivery_Type_Enum {
  Express = 'EXPRESS',
  Precision = 'PRECISION',
  Standard = 'STANDARD'
}

/** Boolean expression to compare columns of type "resource_packs_delivery_type_enum". All fields are combined with logical 'AND'. */
export type Resource_Packs_Delivery_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Resource_Packs_Delivery_Type_Enum>;
  _in?: InputMaybe<Array<Resource_Packs_Delivery_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Resource_Packs_Delivery_Type_Enum>;
  _nin?: InputMaybe<Array<Resource_Packs_Delivery_Type_Enum>>;
};

/** input type for inserting data into table "resource_packs_delivery_type" */
export type Resource_Packs_Delivery_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Resource_Packs_Delivery_Type_Max_Fields = {
  __typename?: 'resource_packs_delivery_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Resource_Packs_Delivery_Type_Min_Fields = {
  __typename?: 'resource_packs_delivery_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "resource_packs_delivery_type" */
export type Resource_Packs_Delivery_Type_Mutation_Response = {
  __typename?: 'resource_packs_delivery_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Resource_Packs_Delivery_Type>;
};

/** on_conflict condition type for table "resource_packs_delivery_type" */
export type Resource_Packs_Delivery_Type_On_Conflict = {
  constraint: Resource_Packs_Delivery_Type_Constraint;
  update_columns?: Array<Resource_Packs_Delivery_Type_Update_Column>;
  where?: InputMaybe<Resource_Packs_Delivery_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "resource_packs_delivery_type". */
export type Resource_Packs_Delivery_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: resource_packs_delivery_type */
export type Resource_Packs_Delivery_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "resource_packs_delivery_type" */
export enum Resource_Packs_Delivery_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "resource_packs_delivery_type" */
export type Resource_Packs_Delivery_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "resource_packs_delivery_type" */
export type Resource_Packs_Delivery_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Resource_Packs_Delivery_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Resource_Packs_Delivery_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "resource_packs_delivery_type" */
export enum Resource_Packs_Delivery_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Resource_Packs_Delivery_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Resource_Packs_Delivery_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Resource_Packs_Delivery_Type_Bool_Exp;
};

/** columns and relationships of "resource_packs_events" */
export type Resource_Packs_Events = {
  __typename?: 'resource_packs_events';
  name: Scalars['String'];
};

/** aggregated selection of "resource_packs_events" */
export type Resource_Packs_Events_Aggregate = {
  __typename?: 'resource_packs_events_aggregate';
  aggregate?: Maybe<Resource_Packs_Events_Aggregate_Fields>;
  nodes: Array<Resource_Packs_Events>;
};

/** aggregate fields of "resource_packs_events" */
export type Resource_Packs_Events_Aggregate_Fields = {
  __typename?: 'resource_packs_events_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Resource_Packs_Events_Max_Fields>;
  min?: Maybe<Resource_Packs_Events_Min_Fields>;
};


/** aggregate fields of "resource_packs_events" */
export type Resource_Packs_Events_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Resource_Packs_Events_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "resource_packs_events". All fields are combined with a logical 'AND'. */
export type Resource_Packs_Events_Bool_Exp = {
  _and?: InputMaybe<Array<Resource_Packs_Events_Bool_Exp>>;
  _not?: InputMaybe<Resource_Packs_Events_Bool_Exp>;
  _or?: InputMaybe<Array<Resource_Packs_Events_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "resource_packs_events" */
export enum Resource_Packs_Events_Constraint {
  /** unique or primary key constraint on columns "name" */
  ResourcePacksEventsPkey = 'resource_packs_events_pkey'
}

export enum Resource_Packs_Events_Enum {
  CourseDeleted = 'COURSE_DELETED',
  CourseReservedResourcePacksRevert = 'COURSE_RESERVED_RESOURCE_PACKS_REVERT',
  IssuedResourcePackRevert = 'ISSUED_RESOURCE_PACK_REVERT',
  ParticipantsDecreased = 'PARTICIPANTS_DECREASED',
  ResourcePacksAdded = 'RESOURCE_PACKS_ADDED',
  ResourcePacksPurchased = 'RESOURCE_PACKS_PURCHASED',
  ResourcePacksReleased = 'RESOURCE_PACKS_RELEASED',
  ResourcePacksRemoved = 'RESOURCE_PACKS_REMOVED',
  ResourcePacksReserved = 'RESOURCE_PACKS_RESERVED',
  ResourcePacksReserveSettled = 'RESOURCE_PACKS_RESERVE_SETTLED',
  ResourcePackIssued = 'RESOURCE_PACK_ISSUED'
}

/** Boolean expression to compare columns of type "resource_packs_events_enum". All fields are combined with logical 'AND'. */
export type Resource_Packs_Events_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Resource_Packs_Events_Enum>;
  _in?: InputMaybe<Array<Resource_Packs_Events_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Resource_Packs_Events_Enum>;
  _nin?: InputMaybe<Array<Resource_Packs_Events_Enum>>;
};

/** input type for inserting data into table "resource_packs_events" */
export type Resource_Packs_Events_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Resource_Packs_Events_Max_Fields = {
  __typename?: 'resource_packs_events_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Resource_Packs_Events_Min_Fields = {
  __typename?: 'resource_packs_events_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "resource_packs_events" */
export type Resource_Packs_Events_Mutation_Response = {
  __typename?: 'resource_packs_events_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Resource_Packs_Events>;
};

/** on_conflict condition type for table "resource_packs_events" */
export type Resource_Packs_Events_On_Conflict = {
  constraint: Resource_Packs_Events_Constraint;
  update_columns?: Array<Resource_Packs_Events_Update_Column>;
  where?: InputMaybe<Resource_Packs_Events_Bool_Exp>;
};

/** Ordering options when selecting data from "resource_packs_events". */
export type Resource_Packs_Events_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: resource_packs_events */
export type Resource_Packs_Events_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "resource_packs_events" */
export enum Resource_Packs_Events_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "resource_packs_events" */
export type Resource_Packs_Events_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "resource_packs_events" */
export type Resource_Packs_Events_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Resource_Packs_Events_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Resource_Packs_Events_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "resource_packs_events" */
export enum Resource_Packs_Events_Update_Column {
  /** column name */
  Name = 'name'
}

export type Resource_Packs_Events_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Resource_Packs_Events_Set_Input>;
  /** filter the rows which have to be updated */
  where: Resource_Packs_Events_Bool_Exp;
};

/** Updated version of resource pack pricings */
export type Resource_Packs_Pricing = {
  __typename?: 'resource_packs_pricing';
  AUD_price: Scalars['numeric'];
  NZD_price: Scalars['numeric'];
  course_level: Course_Level_Enum;
  course_type: Course_Type_Enum;
  id: Scalars['uuid'];
  /** An array relationship */
  org_resource_packs_pricings: Array<Org_Resource_Packs_Pricing>;
  /** An aggregate relationship */
  org_resource_packs_pricings_aggregate: Org_Resource_Packs_Pricing_Aggregate;
  reaccred: Scalars['Boolean'];
  resource_packs_delivery_type?: Maybe<Resource_Packs_Delivery_Type_Enum>;
  resource_packs_type: Resource_Packs_Type_Enum;
};


/** Updated version of resource pack pricings */
export type Resource_Packs_PricingOrg_Resource_Packs_PricingsArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_Pricing_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
};


/** Updated version of resource pack pricings */
export type Resource_Packs_PricingOrg_Resource_Packs_Pricings_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_Pricing_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
};

/** aggregated selection of "resource_packs_pricing" */
export type Resource_Packs_Pricing_Aggregate = {
  __typename?: 'resource_packs_pricing_aggregate';
  aggregate?: Maybe<Resource_Packs_Pricing_Aggregate_Fields>;
  nodes: Array<Resource_Packs_Pricing>;
};

/** aggregate fields of "resource_packs_pricing" */
export type Resource_Packs_Pricing_Aggregate_Fields = {
  __typename?: 'resource_packs_pricing_aggregate_fields';
  avg?: Maybe<Resource_Packs_Pricing_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Resource_Packs_Pricing_Max_Fields>;
  min?: Maybe<Resource_Packs_Pricing_Min_Fields>;
  stddev?: Maybe<Resource_Packs_Pricing_Stddev_Fields>;
  stddev_pop?: Maybe<Resource_Packs_Pricing_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Resource_Packs_Pricing_Stddev_Samp_Fields>;
  sum?: Maybe<Resource_Packs_Pricing_Sum_Fields>;
  var_pop?: Maybe<Resource_Packs_Pricing_Var_Pop_Fields>;
  var_samp?: Maybe<Resource_Packs_Pricing_Var_Samp_Fields>;
  variance?: Maybe<Resource_Packs_Pricing_Variance_Fields>;
};


/** aggregate fields of "resource_packs_pricing" */
export type Resource_Packs_Pricing_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Resource_Packs_Pricing_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Resource_Packs_Pricing_Avg_Fields = {
  __typename?: 'resource_packs_pricing_avg_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "resource_packs_pricing". All fields are combined with a logical 'AND'. */
export type Resource_Packs_Pricing_Bool_Exp = {
  AUD_price?: InputMaybe<Numeric_Comparison_Exp>;
  NZD_price?: InputMaybe<Numeric_Comparison_Exp>;
  _and?: InputMaybe<Array<Resource_Packs_Pricing_Bool_Exp>>;
  _not?: InputMaybe<Resource_Packs_Pricing_Bool_Exp>;
  _or?: InputMaybe<Array<Resource_Packs_Pricing_Bool_Exp>>;
  course_level?: InputMaybe<Course_Level_Enum_Comparison_Exp>;
  course_type?: InputMaybe<Course_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  org_resource_packs_pricings?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
  org_resource_packs_pricings_aggregate?: InputMaybe<Org_Resource_Packs_Pricing_Aggregate_Bool_Exp>;
  reaccred?: InputMaybe<Boolean_Comparison_Exp>;
  resource_packs_delivery_type?: InputMaybe<Resource_Packs_Delivery_Type_Enum_Comparison_Exp>;
  resource_packs_type?: InputMaybe<Resource_Packs_Type_Enum_Comparison_Exp>;
};

/** unique or primary key constraints on table "resource_packs_pricing" */
export enum Resource_Packs_Pricing_Constraint {
  /** unique or primary key constraint on columns "resource_packs_type", "course_level", "resource_packs_delivery_type", "course_type", "reaccred" */
  ResourcePacksPricingCourseTypeCourseLevelReaccredReKey = 'resource_packs_pricing_course_type_course_level_reaccred_re_key',
  /** unique or primary key constraint on columns "id" */
  ResourcePacksPricingPkey = 'resource_packs_pricing_pkey'
}

/** input type for incrementing numeric columns in table "resource_packs_pricing" */
export type Resource_Packs_Pricing_Inc_Input = {
  AUD_price?: InputMaybe<Scalars['numeric']>;
  NZD_price?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "resource_packs_pricing" */
export type Resource_Packs_Pricing_Insert_Input = {
  AUD_price?: InputMaybe<Scalars['numeric']>;
  NZD_price?: InputMaybe<Scalars['numeric']>;
  course_level?: InputMaybe<Course_Level_Enum>;
  course_type?: InputMaybe<Course_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  org_resource_packs_pricings?: InputMaybe<Org_Resource_Packs_Pricing_Arr_Rel_Insert_Input>;
  reaccred?: InputMaybe<Scalars['Boolean']>;
  resource_packs_delivery_type?: InputMaybe<Resource_Packs_Delivery_Type_Enum>;
  resource_packs_type?: InputMaybe<Resource_Packs_Type_Enum>;
};

/** aggregate max on columns */
export type Resource_Packs_Pricing_Max_Fields = {
  __typename?: 'resource_packs_pricing_max_fields';
  AUD_price?: Maybe<Scalars['numeric']>;
  NZD_price?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Resource_Packs_Pricing_Min_Fields = {
  __typename?: 'resource_packs_pricing_min_fields';
  AUD_price?: Maybe<Scalars['numeric']>;
  NZD_price?: Maybe<Scalars['numeric']>;
  id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "resource_packs_pricing" */
export type Resource_Packs_Pricing_Mutation_Response = {
  __typename?: 'resource_packs_pricing_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Resource_Packs_Pricing>;
};

/** input type for inserting object relation for remote table "resource_packs_pricing" */
export type Resource_Packs_Pricing_Obj_Rel_Insert_Input = {
  data: Resource_Packs_Pricing_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Resource_Packs_Pricing_On_Conflict>;
};

/** on_conflict condition type for table "resource_packs_pricing" */
export type Resource_Packs_Pricing_On_Conflict = {
  constraint: Resource_Packs_Pricing_Constraint;
  update_columns?: Array<Resource_Packs_Pricing_Update_Column>;
  where?: InputMaybe<Resource_Packs_Pricing_Bool_Exp>;
};

/** Ordering options when selecting data from "resource_packs_pricing". */
export type Resource_Packs_Pricing_Order_By = {
  AUD_price?: InputMaybe<Order_By>;
  NZD_price?: InputMaybe<Order_By>;
  course_level?: InputMaybe<Order_By>;
  course_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  org_resource_packs_pricings_aggregate?: InputMaybe<Org_Resource_Packs_Pricing_Aggregate_Order_By>;
  reaccred?: InputMaybe<Order_By>;
  resource_packs_delivery_type?: InputMaybe<Order_By>;
  resource_packs_type?: InputMaybe<Order_By>;
};

/** primary key columns input for table: resource_packs_pricing */
export type Resource_Packs_Pricing_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "resource_packs_pricing" */
export enum Resource_Packs_Pricing_Select_Column {
  /** column name */
  AudPrice = 'AUD_price',
  /** column name */
  NzdPrice = 'NZD_price',
  /** column name */
  CourseLevel = 'course_level',
  /** column name */
  CourseType = 'course_type',
  /** column name */
  Id = 'id',
  /** column name */
  Reaccred = 'reaccred',
  /** column name */
  ResourcePacksDeliveryType = 'resource_packs_delivery_type',
  /** column name */
  ResourcePacksType = 'resource_packs_type'
}

/** input type for updating data in table "resource_packs_pricing" */
export type Resource_Packs_Pricing_Set_Input = {
  AUD_price?: InputMaybe<Scalars['numeric']>;
  NZD_price?: InputMaybe<Scalars['numeric']>;
  course_level?: InputMaybe<Course_Level_Enum>;
  course_type?: InputMaybe<Course_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  reaccred?: InputMaybe<Scalars['Boolean']>;
  resource_packs_delivery_type?: InputMaybe<Resource_Packs_Delivery_Type_Enum>;
  resource_packs_type?: InputMaybe<Resource_Packs_Type_Enum>;
};

/** aggregate stddev on columns */
export type Resource_Packs_Pricing_Stddev_Fields = {
  __typename?: 'resource_packs_pricing_stddev_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Resource_Packs_Pricing_Stddev_Pop_Fields = {
  __typename?: 'resource_packs_pricing_stddev_pop_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Resource_Packs_Pricing_Stddev_Samp_Fields = {
  __typename?: 'resource_packs_pricing_stddev_samp_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "resource_packs_pricing" */
export type Resource_Packs_Pricing_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Resource_Packs_Pricing_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Resource_Packs_Pricing_Stream_Cursor_Value_Input = {
  AUD_price?: InputMaybe<Scalars['numeric']>;
  NZD_price?: InputMaybe<Scalars['numeric']>;
  course_level?: InputMaybe<Course_Level_Enum>;
  course_type?: InputMaybe<Course_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  reaccred?: InputMaybe<Scalars['Boolean']>;
  resource_packs_delivery_type?: InputMaybe<Resource_Packs_Delivery_Type_Enum>;
  resource_packs_type?: InputMaybe<Resource_Packs_Type_Enum>;
};

/** aggregate sum on columns */
export type Resource_Packs_Pricing_Sum_Fields = {
  __typename?: 'resource_packs_pricing_sum_fields';
  AUD_price?: Maybe<Scalars['numeric']>;
  NZD_price?: Maybe<Scalars['numeric']>;
};

/** update columns of table "resource_packs_pricing" */
export enum Resource_Packs_Pricing_Update_Column {
  /** column name */
  AudPrice = 'AUD_price',
  /** column name */
  NzdPrice = 'NZD_price',
  /** column name */
  CourseLevel = 'course_level',
  /** column name */
  CourseType = 'course_type',
  /** column name */
  Id = 'id',
  /** column name */
  Reaccred = 'reaccred',
  /** column name */
  ResourcePacksDeliveryType = 'resource_packs_delivery_type',
  /** column name */
  ResourcePacksType = 'resource_packs_type'
}

export type Resource_Packs_Pricing_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Resource_Packs_Pricing_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Resource_Packs_Pricing_Set_Input>;
  /** filter the rows which have to be updated */
  where: Resource_Packs_Pricing_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Resource_Packs_Pricing_Var_Pop_Fields = {
  __typename?: 'resource_packs_pricing_var_pop_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Resource_Packs_Pricing_Var_Samp_Fields = {
  __typename?: 'resource_packs_pricing_var_samp_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Resource_Packs_Pricing_Variance_Fields = {
  __typename?: 'resource_packs_pricing_variance_fields';
  AUD_price?: Maybe<Scalars['Float']>;
  NZD_price?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "resource_packs_type" */
export type Resource_Packs_Type = {
  __typename?: 'resource_packs_type';
  name: Scalars['String'];
};

/** aggregated selection of "resource_packs_type" */
export type Resource_Packs_Type_Aggregate = {
  __typename?: 'resource_packs_type_aggregate';
  aggregate?: Maybe<Resource_Packs_Type_Aggregate_Fields>;
  nodes: Array<Resource_Packs_Type>;
};

/** aggregate fields of "resource_packs_type" */
export type Resource_Packs_Type_Aggregate_Fields = {
  __typename?: 'resource_packs_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Resource_Packs_Type_Max_Fields>;
  min?: Maybe<Resource_Packs_Type_Min_Fields>;
};


/** aggregate fields of "resource_packs_type" */
export type Resource_Packs_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Resource_Packs_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "resource_packs_type". All fields are combined with a logical 'AND'. */
export type Resource_Packs_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Resource_Packs_Type_Bool_Exp>>;
  _not?: InputMaybe<Resource_Packs_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Resource_Packs_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "resource_packs_type" */
export enum Resource_Packs_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  ResourcePacksTypePkey = 'resource_packs_type_pkey'
}

export enum Resource_Packs_Type_Enum {
  DigitalWorkbook = 'DIGITAL_WORKBOOK',
  PrintWorkbook = 'PRINT_WORKBOOK'
}

/** Boolean expression to compare columns of type "resource_packs_type_enum". All fields are combined with logical 'AND'. */
export type Resource_Packs_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Resource_Packs_Type_Enum>;
  _in?: InputMaybe<Array<Resource_Packs_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Resource_Packs_Type_Enum>;
  _nin?: InputMaybe<Array<Resource_Packs_Type_Enum>>;
};

/** input type for inserting data into table "resource_packs_type" */
export type Resource_Packs_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Resource_Packs_Type_Max_Fields = {
  __typename?: 'resource_packs_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Resource_Packs_Type_Min_Fields = {
  __typename?: 'resource_packs_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "resource_packs_type" */
export type Resource_Packs_Type_Mutation_Response = {
  __typename?: 'resource_packs_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Resource_Packs_Type>;
};

/** on_conflict condition type for table "resource_packs_type" */
export type Resource_Packs_Type_On_Conflict = {
  constraint: Resource_Packs_Type_Constraint;
  update_columns?: Array<Resource_Packs_Type_Update_Column>;
  where?: InputMaybe<Resource_Packs_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "resource_packs_type". */
export type Resource_Packs_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: resource_packs_type */
export type Resource_Packs_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "resource_packs_type" */
export enum Resource_Packs_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "resource_packs_type" */
export type Resource_Packs_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "resource_packs_type" */
export type Resource_Packs_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Resource_Packs_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Resource_Packs_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "resource_packs_type" */
export enum Resource_Packs_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Resource_Packs_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Resource_Packs_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Resource_Packs_Type_Bool_Exp;
};

/** columns and relationships of "role" */
export type Role = {
  __typename?: 'role';
  data: Scalars['jsonb'];
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  profile_roles: Array<Profile_Role>;
  /** An aggregate relationship */
  profile_roles_aggregate: Profile_Role_Aggregate;
  rank?: Maybe<Scalars['Int']>;
};


/** columns and relationships of "role" */
export type RoleDataArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "role" */
export type RoleProfile_RolesArgs = {
  distinct_on?: InputMaybe<Array<Profile_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Role_Order_By>>;
  where?: InputMaybe<Profile_Role_Bool_Exp>;
};


/** columns and relationships of "role" */
export type RoleProfile_Roles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Role_Order_By>>;
  where?: InputMaybe<Profile_Role_Bool_Exp>;
};

/** aggregated selection of "role" */
export type Role_Aggregate = {
  __typename?: 'role_aggregate';
  aggregate?: Maybe<Role_Aggregate_Fields>;
  nodes: Array<Role>;
};

/** aggregate fields of "role" */
export type Role_Aggregate_Fields = {
  __typename?: 'role_aggregate_fields';
  avg?: Maybe<Role_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Role_Max_Fields>;
  min?: Maybe<Role_Min_Fields>;
  stddev?: Maybe<Role_Stddev_Fields>;
  stddev_pop?: Maybe<Role_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Role_Stddev_Samp_Fields>;
  sum?: Maybe<Role_Sum_Fields>;
  var_pop?: Maybe<Role_Var_Pop_Fields>;
  var_samp?: Maybe<Role_Var_Samp_Fields>;
  variance?: Maybe<Role_Variance_Fields>;
};


/** aggregate fields of "role" */
export type Role_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Role_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Role_Append_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Role_Avg_Fields = {
  __typename?: 'role_avg_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "role". All fields are combined with a logical 'AND'. */
export type Role_Bool_Exp = {
  _and?: InputMaybe<Array<Role_Bool_Exp>>;
  _not?: InputMaybe<Role_Bool_Exp>;
  _or?: InputMaybe<Array<Role_Bool_Exp>>;
  data?: InputMaybe<Jsonb_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  profile_roles?: InputMaybe<Profile_Role_Bool_Exp>;
  profile_roles_aggregate?: InputMaybe<Profile_Role_Aggregate_Bool_Exp>;
  rank?: InputMaybe<Int_Comparison_Exp>;
};

/** unique or primary key constraints on table "role" */
export enum Role_Constraint {
  /** unique or primary key constraint on columns "name" */
  RoleNameKey = 'role_name_key',
  /** unique or primary key constraint on columns "id" */
  RolePkey = 'role_pkey'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Role_Delete_At_Path_Input = {
  data?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Role_Delete_Elem_Input = {
  data?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Role_Delete_Key_Input = {
  data?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "role" */
export type Role_Inc_Input = {
  rank?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "role" */
export type Role_Insert_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  profile_roles?: InputMaybe<Profile_Role_Arr_Rel_Insert_Input>;
  rank?: InputMaybe<Scalars['Int']>;
};

/** aggregate max on columns */
export type Role_Max_Fields = {
  __typename?: 'role_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Role_Min_Fields = {
  __typename?: 'role_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  rank?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "role" */
export type Role_Mutation_Response = {
  __typename?: 'role_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Role>;
};

/** input type for inserting object relation for remote table "role" */
export type Role_Obj_Rel_Insert_Input = {
  data: Role_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Role_On_Conflict>;
};

/** on_conflict condition type for table "role" */
export type Role_On_Conflict = {
  constraint: Role_Constraint;
  update_columns?: Array<Role_Update_Column>;
  where?: InputMaybe<Role_Bool_Exp>;
};

/** Ordering options when selecting data from "role". */
export type Role_Order_By = {
  data?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  profile_roles_aggregate?: InputMaybe<Profile_Role_Aggregate_Order_By>;
  rank?: InputMaybe<Order_By>;
};

/** primary key columns input for table: role */
export type Role_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Role_Prepend_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "role" */
export enum Role_Select_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Rank = 'rank'
}

/** input type for updating data in table "role" */
export type Role_Set_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['Int']>;
};

/** aggregate stddev on columns */
export type Role_Stddev_Fields = {
  __typename?: 'role_stddev_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Role_Stddev_Pop_Fields = {
  __typename?: 'role_stddev_pop_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Role_Stddev_Samp_Fields = {
  __typename?: 'role_stddev_samp_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "role" */
export type Role_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Role_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Role_Stream_Cursor_Value_Input = {
  data?: InputMaybe<Scalars['jsonb']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  rank?: InputMaybe<Scalars['Int']>;
};

/** aggregate sum on columns */
export type Role_Sum_Fields = {
  __typename?: 'role_sum_fields';
  rank?: Maybe<Scalars['Int']>;
};

/** update columns of table "role" */
export enum Role_Update_Column {
  /** column name */
  Data = 'data',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  Rank = 'rank'
}

export type Role_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Role_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Role_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Role_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Role_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Role_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Role_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Role_Set_Input>;
  /** filter the rows which have to be updated */
  where: Role_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Role_Var_Pop_Fields = {
  __typename?: 'role_var_pop_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Role_Var_Samp_Fields = {
  __typename?: 'role_var_samp_fields';
  rank?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Role_Variance_Fields = {
  __typename?: 'role_variance_fields';
  rank?: Maybe<Scalars['Float']>;
};

export type ScheduleAboutTrainingSurveysOutput = {
  __typename?: 'scheduleAboutTrainingSurveysOutput';
  message?: Maybe<Scalars['String']>;
};

/** columns and relationships of "scheduled_events_view" */
export type Scheduled_Events_View = {
  __typename?: 'scheduled_events_view';
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  header_conf?: Maybe<Scalars['json']>;
  id?: Maybe<Scalars['String']>;
  next_retry_at?: Maybe<Scalars['timestamptz']>;
  payload?: Maybe<Scalars['json']>;
  retry_conf?: Maybe<Scalars['json']>;
  scheduled_time?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  tries?: Maybe<Scalars['Int']>;
  webhook_conf?: Maybe<Scalars['json']>;
};


/** columns and relationships of "scheduled_events_view" */
export type Scheduled_Events_ViewHeader_ConfArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "scheduled_events_view" */
export type Scheduled_Events_ViewPayloadArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "scheduled_events_view" */
export type Scheduled_Events_ViewRetry_ConfArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** columns and relationships of "scheduled_events_view" */
export type Scheduled_Events_ViewWebhook_ConfArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "scheduled_events_view" */
export type Scheduled_Events_View_Aggregate = {
  __typename?: 'scheduled_events_view_aggregate';
  aggregate?: Maybe<Scheduled_Events_View_Aggregate_Fields>;
  nodes: Array<Scheduled_Events_View>;
};

/** aggregate fields of "scheduled_events_view" */
export type Scheduled_Events_View_Aggregate_Fields = {
  __typename?: 'scheduled_events_view_aggregate_fields';
  avg?: Maybe<Scheduled_Events_View_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Scheduled_Events_View_Max_Fields>;
  min?: Maybe<Scheduled_Events_View_Min_Fields>;
  stddev?: Maybe<Scheduled_Events_View_Stddev_Fields>;
  stddev_pop?: Maybe<Scheduled_Events_View_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Scheduled_Events_View_Stddev_Samp_Fields>;
  sum?: Maybe<Scheduled_Events_View_Sum_Fields>;
  var_pop?: Maybe<Scheduled_Events_View_Var_Pop_Fields>;
  var_samp?: Maybe<Scheduled_Events_View_Var_Samp_Fields>;
  variance?: Maybe<Scheduled_Events_View_Variance_Fields>;
};


/** aggregate fields of "scheduled_events_view" */
export type Scheduled_Events_View_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Scheduled_Events_View_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Scheduled_Events_View_Avg_Fields = {
  __typename?: 'scheduled_events_view_avg_fields';
  tries?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "scheduled_events_view". All fields are combined with a logical 'AND'. */
export type Scheduled_Events_View_Bool_Exp = {
  _and?: InputMaybe<Array<Scheduled_Events_View_Bool_Exp>>;
  _not?: InputMaybe<Scheduled_Events_View_Bool_Exp>;
  _or?: InputMaybe<Array<Scheduled_Events_View_Bool_Exp>>;
  comment?: InputMaybe<String_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  header_conf?: InputMaybe<Json_Comparison_Exp>;
  id?: InputMaybe<String_Comparison_Exp>;
  next_retry_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  payload?: InputMaybe<Json_Comparison_Exp>;
  retry_conf?: InputMaybe<Json_Comparison_Exp>;
  scheduled_time?: InputMaybe<Timestamptz_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  tries?: InputMaybe<Int_Comparison_Exp>;
  webhook_conf?: InputMaybe<Json_Comparison_Exp>;
};

/** input type for incrementing numeric columns in table "scheduled_events_view" */
export type Scheduled_Events_View_Inc_Input = {
  tries?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "scheduled_events_view" */
export type Scheduled_Events_View_Insert_Input = {
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  header_conf?: InputMaybe<Scalars['json']>;
  id?: InputMaybe<Scalars['String']>;
  next_retry_at?: InputMaybe<Scalars['timestamptz']>;
  payload?: InputMaybe<Scalars['json']>;
  retry_conf?: InputMaybe<Scalars['json']>;
  scheduled_time?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  tries?: InputMaybe<Scalars['Int']>;
  webhook_conf?: InputMaybe<Scalars['json']>;
};

/** aggregate max on columns */
export type Scheduled_Events_View_Max_Fields = {
  __typename?: 'scheduled_events_view_max_fields';
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  next_retry_at?: Maybe<Scalars['timestamptz']>;
  scheduled_time?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  tries?: Maybe<Scalars['Int']>;
};

/** aggregate min on columns */
export type Scheduled_Events_View_Min_Fields = {
  __typename?: 'scheduled_events_view_min_fields';
  comment?: Maybe<Scalars['String']>;
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['String']>;
  next_retry_at?: Maybe<Scalars['timestamptz']>;
  scheduled_time?: Maybe<Scalars['timestamptz']>;
  status?: Maybe<Scalars['String']>;
  tries?: Maybe<Scalars['Int']>;
};

/** response of any mutation on the table "scheduled_events_view" */
export type Scheduled_Events_View_Mutation_Response = {
  __typename?: 'scheduled_events_view_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Scheduled_Events_View>;
};

/** Ordering options when selecting data from "scheduled_events_view". */
export type Scheduled_Events_View_Order_By = {
  comment?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  header_conf?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  next_retry_at?: InputMaybe<Order_By>;
  payload?: InputMaybe<Order_By>;
  retry_conf?: InputMaybe<Order_By>;
  scheduled_time?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  tries?: InputMaybe<Order_By>;
  webhook_conf?: InputMaybe<Order_By>;
};

/** select columns of table "scheduled_events_view" */
export enum Scheduled_Events_View_Select_Column {
  /** column name */
  Comment = 'comment',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  HeaderConf = 'header_conf',
  /** column name */
  Id = 'id',
  /** column name */
  NextRetryAt = 'next_retry_at',
  /** column name */
  Payload = 'payload',
  /** column name */
  RetryConf = 'retry_conf',
  /** column name */
  ScheduledTime = 'scheduled_time',
  /** column name */
  Status = 'status',
  /** column name */
  Tries = 'tries',
  /** column name */
  WebhookConf = 'webhook_conf'
}

/** input type for updating data in table "scheduled_events_view" */
export type Scheduled_Events_View_Set_Input = {
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  header_conf?: InputMaybe<Scalars['json']>;
  id?: InputMaybe<Scalars['String']>;
  next_retry_at?: InputMaybe<Scalars['timestamptz']>;
  payload?: InputMaybe<Scalars['json']>;
  retry_conf?: InputMaybe<Scalars['json']>;
  scheduled_time?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  tries?: InputMaybe<Scalars['Int']>;
  webhook_conf?: InputMaybe<Scalars['json']>;
};

/** aggregate stddev on columns */
export type Scheduled_Events_View_Stddev_Fields = {
  __typename?: 'scheduled_events_view_stddev_fields';
  tries?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Scheduled_Events_View_Stddev_Pop_Fields = {
  __typename?: 'scheduled_events_view_stddev_pop_fields';
  tries?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Scheduled_Events_View_Stddev_Samp_Fields = {
  __typename?: 'scheduled_events_view_stddev_samp_fields';
  tries?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "scheduled_events_view" */
export type Scheduled_Events_View_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Scheduled_Events_View_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Scheduled_Events_View_Stream_Cursor_Value_Input = {
  comment?: InputMaybe<Scalars['String']>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  header_conf?: InputMaybe<Scalars['json']>;
  id?: InputMaybe<Scalars['String']>;
  next_retry_at?: InputMaybe<Scalars['timestamptz']>;
  payload?: InputMaybe<Scalars['json']>;
  retry_conf?: InputMaybe<Scalars['json']>;
  scheduled_time?: InputMaybe<Scalars['timestamptz']>;
  status?: InputMaybe<Scalars['String']>;
  tries?: InputMaybe<Scalars['Int']>;
  webhook_conf?: InputMaybe<Scalars['json']>;
};

/** aggregate sum on columns */
export type Scheduled_Events_View_Sum_Fields = {
  __typename?: 'scheduled_events_view_sum_fields';
  tries?: Maybe<Scalars['Int']>;
};

export type Scheduled_Events_View_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Scheduled_Events_View_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Scheduled_Events_View_Set_Input>;
  /** filter the rows which have to be updated */
  where: Scheduled_Events_View_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Scheduled_Events_View_Var_Pop_Fields = {
  __typename?: 'scheduled_events_view_var_pop_fields';
  tries?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Scheduled_Events_View_Var_Samp_Fields = {
  __typename?: 'scheduled_events_view_var_samp_fields';
  tries?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Scheduled_Events_View_Variance_Fields = {
  __typename?: 'scheduled_events_view_variance_fields';
  tries?: Maybe<Scalars['Float']>;
};

export type Search_Dfe_Establishments_Args = {
  search_term?: InputMaybe<Scalars['String']>;
};

export type Search_Organizations_Args = {
  search_term?: InputMaybe<Scalars['String']>;
};

/** Stores the enum representing splash screens used to highlight specific features to the user */
export type Splash_Screens = {
  __typename?: 'splash_screens';
  name: Scalars['String'];
};

/** aggregated selection of "splash_screens" */
export type Splash_Screens_Aggregate = {
  __typename?: 'splash_screens_aggregate';
  aggregate?: Maybe<Splash_Screens_Aggregate_Fields>;
  nodes: Array<Splash_Screens>;
};

/** aggregate fields of "splash_screens" */
export type Splash_Screens_Aggregate_Fields = {
  __typename?: 'splash_screens_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Splash_Screens_Max_Fields>;
  min?: Maybe<Splash_Screens_Min_Fields>;
};


/** aggregate fields of "splash_screens" */
export type Splash_Screens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Splash_Screens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "splash_screens". All fields are combined with a logical 'AND'. */
export type Splash_Screens_Bool_Exp = {
  _and?: InputMaybe<Array<Splash_Screens_Bool_Exp>>;
  _not?: InputMaybe<Splash_Screens_Bool_Exp>;
  _or?: InputMaybe<Array<Splash_Screens_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "splash_screens" */
export enum Splash_Screens_Constraint {
  /** unique or primary key constraint on columns "name" */
  SplashScreensPkey = 'splash_screens_pkey'
}

export enum Splash_Screens_Enum {
  KnowledgeHubCertificate = 'KNOWLEDGE_HUB_CERTIFICATE',
  KnowledgeHubCourseInvite = 'KNOWLEDGE_HUB_COURSE_INVITE',
  OrganisationsInsightReports = 'ORGANISATIONS_INSIGHT_REPORTS',
  OrganisationAdminNomination = 'ORGANISATION_ADMIN_NOMINATION'
}

/** Boolean expression to compare columns of type "splash_screens_enum". All fields are combined with logical 'AND'. */
export type Splash_Screens_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Splash_Screens_Enum>;
  _in?: InputMaybe<Array<Splash_Screens_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Splash_Screens_Enum>;
  _nin?: InputMaybe<Array<Splash_Screens_Enum>>;
};

/** input type for inserting data into table "splash_screens" */
export type Splash_Screens_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Splash_Screens_Max_Fields = {
  __typename?: 'splash_screens_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Splash_Screens_Min_Fields = {
  __typename?: 'splash_screens_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "splash_screens" */
export type Splash_Screens_Mutation_Response = {
  __typename?: 'splash_screens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Splash_Screens>;
};

/** on_conflict condition type for table "splash_screens" */
export type Splash_Screens_On_Conflict = {
  constraint: Splash_Screens_Constraint;
  update_columns?: Array<Splash_Screens_Update_Column>;
  where?: InputMaybe<Splash_Screens_Bool_Exp>;
};

/** Ordering options when selecting data from "splash_screens". */
export type Splash_Screens_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: splash_screens */
export type Splash_Screens_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "splash_screens" */
export enum Splash_Screens_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "splash_screens" */
export type Splash_Screens_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "splash_screens" */
export type Splash_Screens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Splash_Screens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Splash_Screens_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "splash_screens" */
export enum Splash_Screens_Update_Column {
  /** column name */
  Name = 'name'
}

export type Splash_Screens_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Splash_Screens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Splash_Screens_Bool_Exp;
};

/** This table is used to store the user submissions of a splash screen. */
export type Submission_Of_Splash_Screens = {
  __typename?: 'submission_of_splash_screens';
  created_at: Scalars['timestamptz'];
  id: Scalars['uuid'];
  profile_id: Scalars['uuid'];
  seen_count?: Maybe<Scalars['Int']>;
  splash_screen: Splash_Screens_Enum;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Aggregate = {
  __typename?: 'submission_of_splash_screens_aggregate';
  aggregate?: Maybe<Submission_Of_Splash_Screens_Aggregate_Fields>;
  nodes: Array<Submission_Of_Splash_Screens>;
};

export type Submission_Of_Splash_Screens_Aggregate_Bool_Exp = {
  count?: InputMaybe<Submission_Of_Splash_Screens_Aggregate_Bool_Exp_Count>;
};

export type Submission_Of_Splash_Screens_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Submission_Of_Splash_Screens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Submission_Of_Splash_Screens_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Aggregate_Fields = {
  __typename?: 'submission_of_splash_screens_aggregate_fields';
  avg?: Maybe<Submission_Of_Splash_Screens_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Submission_Of_Splash_Screens_Max_Fields>;
  min?: Maybe<Submission_Of_Splash_Screens_Min_Fields>;
  stddev?: Maybe<Submission_Of_Splash_Screens_Stddev_Fields>;
  stddev_pop?: Maybe<Submission_Of_Splash_Screens_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Submission_Of_Splash_Screens_Stddev_Samp_Fields>;
  sum?: Maybe<Submission_Of_Splash_Screens_Sum_Fields>;
  var_pop?: Maybe<Submission_Of_Splash_Screens_Var_Pop_Fields>;
  var_samp?: Maybe<Submission_Of_Splash_Screens_Var_Samp_Fields>;
  variance?: Maybe<Submission_Of_Splash_Screens_Variance_Fields>;
};


/** aggregate fields of "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Submission_Of_Splash_Screens_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Aggregate_Order_By = {
  avg?: InputMaybe<Submission_Of_Splash_Screens_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Submission_Of_Splash_Screens_Max_Order_By>;
  min?: InputMaybe<Submission_Of_Splash_Screens_Min_Order_By>;
  stddev?: InputMaybe<Submission_Of_Splash_Screens_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Submission_Of_Splash_Screens_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Submission_Of_Splash_Screens_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Submission_Of_Splash_Screens_Sum_Order_By>;
  var_pop?: InputMaybe<Submission_Of_Splash_Screens_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Submission_Of_Splash_Screens_Var_Samp_Order_By>;
  variance?: InputMaybe<Submission_Of_Splash_Screens_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Arr_Rel_Insert_Input = {
  data: Array<Submission_Of_Splash_Screens_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Submission_Of_Splash_Screens_On_Conflict>;
};

/** aggregate avg on columns */
export type Submission_Of_Splash_Screens_Avg_Fields = {
  __typename?: 'submission_of_splash_screens_avg_fields';
  seen_count?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Avg_Order_By = {
  seen_count?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "submission_of_splash_screens". All fields are combined with a logical 'AND'. */
export type Submission_Of_Splash_Screens_Bool_Exp = {
  _and?: InputMaybe<Array<Submission_Of_Splash_Screens_Bool_Exp>>;
  _not?: InputMaybe<Submission_Of_Splash_Screens_Bool_Exp>;
  _or?: InputMaybe<Array<Submission_Of_Splash_Screens_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  profile_id?: InputMaybe<Uuid_Comparison_Exp>;
  seen_count?: InputMaybe<Int_Comparison_Exp>;
  splash_screen?: InputMaybe<Splash_Screens_Enum_Comparison_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "submission_of_splash_screens" */
export enum Submission_Of_Splash_Screens_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubmissionOfSplashScreensPkey = 'submission_of_splash_screens_pkey',
  /** unique or primary key constraint on columns "splash_screen", "profile_id" */
  SubmissionOfSplashScreensSplashScreenProfileIdKey = 'submission_of_splash_screens_splash_screen_profile_id_key'
}

/** input type for incrementing numeric columns in table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Inc_Input = {
  seen_count?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  seen_count?: InputMaybe<Scalars['Int']>;
  splash_screen?: InputMaybe<Splash_Screens_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Submission_Of_Splash_Screens_Max_Fields = {
  __typename?: 'submission_of_splash_screens_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  seen_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  seen_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Submission_Of_Splash_Screens_Min_Fields = {
  __typename?: 'submission_of_splash_screens_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  profile_id?: Maybe<Scalars['uuid']>;
  seen_count?: Maybe<Scalars['Int']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  seen_count?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Mutation_Response = {
  __typename?: 'submission_of_splash_screens_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Submission_Of_Splash_Screens>;
};

/** on_conflict condition type for table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_On_Conflict = {
  constraint: Submission_Of_Splash_Screens_Constraint;
  update_columns?: Array<Submission_Of_Splash_Screens_Update_Column>;
  where?: InputMaybe<Submission_Of_Splash_Screens_Bool_Exp>;
};

/** Ordering options when selecting data from "submission_of_splash_screens". */
export type Submission_Of_Splash_Screens_Order_By = {
  created_at?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  profile_id?: InputMaybe<Order_By>;
  seen_count?: InputMaybe<Order_By>;
  splash_screen?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: submission_of_splash_screens */
export type Submission_Of_Splash_Screens_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "submission_of_splash_screens" */
export enum Submission_Of_Splash_Screens_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SeenCount = 'seen_count',
  /** column name */
  SplashScreen = 'splash_screen',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  seen_count?: InputMaybe<Scalars['Int']>;
  splash_screen?: InputMaybe<Splash_Screens_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate stddev on columns */
export type Submission_Of_Splash_Screens_Stddev_Fields = {
  __typename?: 'submission_of_splash_screens_stddev_fields';
  seen_count?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Stddev_Order_By = {
  seen_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Submission_Of_Splash_Screens_Stddev_Pop_Fields = {
  __typename?: 'submission_of_splash_screens_stddev_pop_fields';
  seen_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Stddev_Pop_Order_By = {
  seen_count?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Submission_Of_Splash_Screens_Stddev_Samp_Fields = {
  __typename?: 'submission_of_splash_screens_stddev_samp_fields';
  seen_count?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Stddev_Samp_Order_By = {
  seen_count?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Submission_Of_Splash_Screens_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Submission_Of_Splash_Screens_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  id?: InputMaybe<Scalars['uuid']>;
  profile_id?: InputMaybe<Scalars['uuid']>;
  seen_count?: InputMaybe<Scalars['Int']>;
  splash_screen?: InputMaybe<Splash_Screens_Enum>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Submission_Of_Splash_Screens_Sum_Fields = {
  __typename?: 'submission_of_splash_screens_sum_fields';
  seen_count?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Sum_Order_By = {
  seen_count?: InputMaybe<Order_By>;
};

/** update columns of table "submission_of_splash_screens" */
export enum Submission_Of_Splash_Screens_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Id = 'id',
  /** column name */
  ProfileId = 'profile_id',
  /** column name */
  SeenCount = 'seen_count',
  /** column name */
  SplashScreen = 'splash_screen',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Submission_Of_Splash_Screens_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Submission_Of_Splash_Screens_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Submission_Of_Splash_Screens_Set_Input>;
  /** filter the rows which have to be updated */
  where: Submission_Of_Splash_Screens_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Submission_Of_Splash_Screens_Var_Pop_Fields = {
  __typename?: 'submission_of_splash_screens_var_pop_fields';
  seen_count?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Var_Pop_Order_By = {
  seen_count?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Submission_Of_Splash_Screens_Var_Samp_Fields = {
  __typename?: 'submission_of_splash_screens_var_samp_fields';
  seen_count?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Var_Samp_Order_By = {
  seen_count?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Submission_Of_Splash_Screens_Variance_Fields = {
  __typename?: 'submission_of_splash_screens_variance_fields';
  seen_count?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "submission_of_splash_screens" */
export type Submission_Of_Splash_Screens_Variance_Order_By = {
  seen_count?: InputMaybe<Order_By>;
};

/** columns and relationships of "submodule" */
export type Submodule = {
  __typename?: 'submodule';
  course_level: Course_Level_Enum;
  created_at: Scalars['timestamptz'];
  description?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  module_category: Module_Category_Enum;
  module_id: Scalars['uuid'];
  name: Scalars['String'];
  /** An object relationship */
  submodule_module: Module;
  updated_at: Scalars['timestamptz'];
};

/** aggregated selection of "submodule" */
export type Submodule_Aggregate = {
  __typename?: 'submodule_aggregate';
  aggregate?: Maybe<Submodule_Aggregate_Fields>;
  nodes: Array<Submodule>;
};

export type Submodule_Aggregate_Bool_Exp = {
  count?: InputMaybe<Submodule_Aggregate_Bool_Exp_Count>;
};

export type Submodule_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Submodule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Submodule_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "submodule" */
export type Submodule_Aggregate_Fields = {
  __typename?: 'submodule_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Submodule_Max_Fields>;
  min?: Maybe<Submodule_Min_Fields>;
};


/** aggregate fields of "submodule" */
export type Submodule_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Submodule_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "submodule" */
export type Submodule_Aggregate_Order_By = {
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Submodule_Max_Order_By>;
  min?: InputMaybe<Submodule_Min_Order_By>;
};

/** input type for inserting array relation for remote table "submodule" */
export type Submodule_Arr_Rel_Insert_Input = {
  data: Array<Submodule_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Submodule_On_Conflict>;
};

/** Boolean expression to filter rows from the table "submodule". All fields are combined with a logical 'AND'. */
export type Submodule_Bool_Exp = {
  _and?: InputMaybe<Array<Submodule_Bool_Exp>>;
  _not?: InputMaybe<Submodule_Bool_Exp>;
  _or?: InputMaybe<Array<Submodule_Bool_Exp>>;
  course_level?: InputMaybe<Course_Level_Enum_Comparison_Exp>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  description?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  module_category?: InputMaybe<Module_Category_Enum_Comparison_Exp>;
  module_id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  submodule_module?: InputMaybe<Module_Bool_Exp>;
  updated_at?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** unique or primary key constraints on table "submodule" */
export enum Submodule_Constraint {
  /** unique or primary key constraint on columns "id" */
  SubmodulePkey = 'submodule_pkey'
}

/** input type for inserting data into table "submodule" */
export type Submodule_Insert_Input = {
  course_level?: InputMaybe<Course_Level_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  module_category?: InputMaybe<Module_Category_Enum>;
  module_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  submodule_module?: InputMaybe<Module_Obj_Rel_Insert_Input>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Submodule_Max_Fields = {
  __typename?: 'submodule_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  module_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "submodule" */
export type Submodule_Max_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Submodule_Min_Fields = {
  __typename?: 'submodule_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  description?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  module_id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  updated_at?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "submodule" */
export type Submodule_Min_Order_By = {
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "submodule" */
export type Submodule_Mutation_Response = {
  __typename?: 'submodule_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Submodule>;
};

/** on_conflict condition type for table "submodule" */
export type Submodule_On_Conflict = {
  constraint: Submodule_Constraint;
  update_columns?: Array<Submodule_Update_Column>;
  where?: InputMaybe<Submodule_Bool_Exp>;
};

/** Ordering options when selecting data from "submodule". */
export type Submodule_Order_By = {
  course_level?: InputMaybe<Order_By>;
  created_at?: InputMaybe<Order_By>;
  description?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  module_category?: InputMaybe<Order_By>;
  module_id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  submodule_module?: InputMaybe<Module_Order_By>;
  updated_at?: InputMaybe<Order_By>;
};

/** primary key columns input for table: submodule */
export type Submodule_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "submodule" */
export enum Submodule_Select_Column {
  /** column name */
  CourseLevel = 'course_level',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleCategory = 'module_category',
  /** column name */
  ModuleId = 'module_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

/** input type for updating data in table "submodule" */
export type Submodule_Set_Input = {
  course_level?: InputMaybe<Course_Level_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  module_category?: InputMaybe<Module_Category_Enum>;
  module_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "submodule" */
export type Submodule_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Submodule_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Submodule_Stream_Cursor_Value_Input = {
  course_level?: InputMaybe<Course_Level_Enum>;
  created_at?: InputMaybe<Scalars['timestamptz']>;
  description?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  module_category?: InputMaybe<Module_Category_Enum>;
  module_id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  updated_at?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "submodule" */
export enum Submodule_Update_Column {
  /** column name */
  CourseLevel = 'course_level',
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  Description = 'description',
  /** column name */
  Id = 'id',
  /** column name */
  ModuleCategory = 'module_category',
  /** column name */
  ModuleId = 'module_id',
  /** column name */
  Name = 'name',
  /** column name */
  UpdatedAt = 'updated_at'
}

export type Submodule_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Submodule_Set_Input>;
  /** filter the rows which have to be updated */
  where: Submodule_Bool_Exp;
};

export type Subscription_Root = {
  __typename?: 'subscription_root';
  /** fetch data from the table: "about_training_email_scheduled_events" */
  about_training_email_scheduled_events: Array<About_Training_Email_Scheduled_Events>;
  /** fetch aggregated fields from the table: "about_training_email_scheduled_events" */
  about_training_email_scheduled_events_aggregate: About_Training_Email_Scheduled_Events_Aggregate;
  /** fetch data from the table: "about_training_email_scheduled_events" using primary key columns */
  about_training_email_scheduled_events_by_pk?: Maybe<About_Training_Email_Scheduled_Events>;
  /** fetch data from the table in a streaming manner: "about_training_email_scheduled_events" */
  about_training_email_scheduled_events_stream: Array<About_Training_Email_Scheduled_Events>;
  /** fetch data from the table: "absorb_enrolment" */
  absorb_enrolment: Array<Absorb_Enrolment>;
  /** fetch aggregated fields from the table: "absorb_enrolment" */
  absorb_enrolment_aggregate: Absorb_Enrolment_Aggregate;
  /** fetch data from the table: "absorb_enrolment" using primary key columns */
  absorb_enrolment_by_pk?: Maybe<Absorb_Enrolment>;
  /** fetch data from the table in a streaming manner: "absorb_enrolment" */
  absorb_enrolment_stream: Array<Absorb_Enrolment>;
  /** fetch data from the table: "accreditors" */
  accreditors: Array<Accreditors>;
  /** fetch aggregated fields from the table: "accreditors" */
  accreditors_aggregate: Accreditors_Aggregate;
  /** fetch data from the table: "accreditors" using primary key columns */
  accreditors_by_pk?: Maybe<Accreditors>;
  /** fetch data from the table in a streaming manner: "accreditors" */
  accreditors_stream: Array<Accreditors>;
  /** fetch data from the table: "availability" */
  availability: Array<Availability>;
  /** fetch aggregated fields from the table: "availability" */
  availability_aggregate: Availability_Aggregate;
  /** fetch data from the table: "availability" using primary key columns */
  availability_by_pk?: Maybe<Availability>;
  /** fetch data from the table in a streaming manner: "availability" */
  availability_stream: Array<Availability>;
  /** fetch data from the table: "bild_strategy" */
  bild_strategy: Array<Bild_Strategy>;
  /** fetch aggregated fields from the table: "bild_strategy" */
  bild_strategy_aggregate: Bild_Strategy_Aggregate;
  /** fetch data from the table: "bild_strategy" using primary key columns */
  bild_strategy_by_pk?: Maybe<Bild_Strategy>;
  /** fetch data from the table in a streaming manner: "bild_strategy" */
  bild_strategy_stream: Array<Bild_Strategy>;
  /** fetch data from the table: "blended_learning_status" */
  blended_learning_status: Array<Blended_Learning_Status>;
  /** fetch aggregated fields from the table: "blended_learning_status" */
  blended_learning_status_aggregate: Blended_Learning_Status_Aggregate;
  /** fetch data from the table: "blended_learning_status" using primary key columns */
  blended_learning_status_by_pk?: Maybe<Blended_Learning_Status>;
  /** fetch data from the table in a streaming manner: "blended_learning_status" */
  blended_learning_status_stream: Array<Blended_Learning_Status>;
  /** fetch data from the table: "certificate_expired_notification_jobs" */
  certificate_expired_notification_jobs: Array<Certificate_Expired_Notification_Jobs>;
  /** fetch aggregated fields from the table: "certificate_expired_notification_jobs" */
  certificate_expired_notification_jobs_aggregate: Certificate_Expired_Notification_Jobs_Aggregate;
  /** fetch data from the table: "certificate_expired_notification_jobs" using primary key columns */
  certificate_expired_notification_jobs_by_pk?: Maybe<Certificate_Expired_Notification_Jobs>;
  /** fetch data from the table in a streaming manner: "certificate_expired_notification_jobs" */
  certificate_expired_notification_jobs_stream: Array<Certificate_Expired_Notification_Jobs>;
  /** fetch data from the table: "certificate_expiry_notification_jobs" */
  certificate_expiry_notification_jobs: Array<Certificate_Expiry_Notification_Jobs>;
  /** fetch aggregated fields from the table: "certificate_expiry_notification_jobs" */
  certificate_expiry_notification_jobs_aggregate: Certificate_Expiry_Notification_Jobs_Aggregate;
  /** fetch data from the table: "certificate_expiry_notification_jobs" using primary key columns */
  certificate_expiry_notification_jobs_by_pk?: Maybe<Certificate_Expiry_Notification_Jobs>;
  /** fetch data from the table in a streaming manner: "certificate_expiry_notification_jobs" */
  certificate_expiry_notification_jobs_stream: Array<Certificate_Expiry_Notification_Jobs>;
  /** fetch data from the table: "certificate_expiry_notification_timeframe" */
  certificate_expiry_notification_timeframe: Array<Certificate_Expiry_Notification_Timeframe>;
  /** fetch aggregated fields from the table: "certificate_expiry_notification_timeframe" */
  certificate_expiry_notification_timeframe_aggregate: Certificate_Expiry_Notification_Timeframe_Aggregate;
  /** fetch data from the table: "certificate_expiry_notification_timeframe" using primary key columns */
  certificate_expiry_notification_timeframe_by_pk?: Maybe<Certificate_Expiry_Notification_Timeframe>;
  /** fetch data from the table in a streaming manner: "certificate_expiry_notification_timeframe" */
  certificate_expiry_notification_timeframe_stream: Array<Certificate_Expiry_Notification_Timeframe>;
  /** fetch data from the table: "certificate_status" */
  certificate_status: Array<Certificate_Status>;
  /** fetch aggregated fields from the table: "certificate_status" */
  certificate_status_aggregate: Certificate_Status_Aggregate;
  /** fetch data from the table: "certificate_status" using primary key columns */
  certificate_status_by_pk?: Maybe<Certificate_Status>;
  /** fetch data from the table in a streaming manner: "certificate_status" */
  certificate_status_stream: Array<Certificate_Status>;
  /** fetch data from the table: "color" */
  color: Array<Color>;
  /** fetch aggregated fields from the table: "color" */
  color_aggregate: Color_Aggregate;
  /** fetch data from the table: "color" using primary key columns */
  color_by_pk?: Maybe<Color>;
  /** fetch data from the table in a streaming manner: "color" */
  color_stream: Array<Color>;
  /** fetch data from the table: "country" */
  country: Array<Country>;
  /** fetch aggregated fields from the table: "country" */
  country_aggregate: Country_Aggregate;
  /** fetch data from the table: "country" using primary key columns */
  country_by_pk?: Maybe<Country>;
  /** fetch data from the table: "country_region" */
  country_region: Array<Country_Region>;
  /** fetch aggregated fields from the table: "country_region" */
  country_region_aggregate: Country_Region_Aggregate;
  /** fetch data from the table: "country_region" using primary key columns */
  country_region_by_pk?: Maybe<Country_Region>;
  /** fetch data from the table in a streaming manner: "country_region" */
  country_region_stream: Array<Country_Region>;
  /** fetch data from the table in a streaming manner: "country" */
  country_stream: Array<Country>;
  /** fetch data from the table: "course" */
  course: Array<Course>;
  /** fetch aggregated fields from the table: "course" */
  course_aggregate: Course_Aggregate;
  /** fetch data from the table: "course_audit" */
  course_audit: Array<Course_Audit>;
  /** fetch aggregated fields from the table: "course_audit" */
  course_audit_aggregate: Course_Audit_Aggregate;
  /** fetch data from the table: "course_audit" using primary key columns */
  course_audit_by_pk?: Maybe<Course_Audit>;
  /** fetch data from the table in a streaming manner: "course_audit" */
  course_audit_stream: Array<Course_Audit>;
  /** fetch data from the table: "course_audit_type" */
  course_audit_type: Array<Course_Audit_Type>;
  /** fetch aggregated fields from the table: "course_audit_type" */
  course_audit_type_aggregate: Course_Audit_Type_Aggregate;
  /** fetch data from the table: "course_audit_type" using primary key columns */
  course_audit_type_by_pk?: Maybe<Course_Audit_Type>;
  /** fetch data from the table in a streaming manner: "course_audit_type" */
  course_audit_type_stream: Array<Course_Audit_Type>;
  /** fetch data from the table: "course_bild_module" */
  course_bild_module: Array<Course_Bild_Module>;
  /** fetch aggregated fields from the table: "course_bild_module" */
  course_bild_module_aggregate: Course_Bild_Module_Aggregate;
  /** fetch data from the table: "course_bild_module" using primary key columns */
  course_bild_module_by_pk?: Maybe<Course_Bild_Module>;
  /** fetch data from the table in a streaming manner: "course_bild_module" */
  course_bild_module_stream: Array<Course_Bild_Module>;
  /** fetch data from the table: "course_bild_strategy" */
  course_bild_strategy: Array<Course_Bild_Strategy>;
  /** fetch aggregated fields from the table: "course_bild_strategy" */
  course_bild_strategy_aggregate: Course_Bild_Strategy_Aggregate;
  /** fetch data from the table: "course_bild_strategy" using primary key columns */
  course_bild_strategy_by_pk?: Maybe<Course_Bild_Strategy>;
  /** fetch data from the table in a streaming manner: "course_bild_strategy" */
  course_bild_strategy_stream: Array<Course_Bild_Strategy>;
  /** fetch data from the table: "course" using primary key columns */
  course_by_pk?: Maybe<Course>;
  /** fetch data from the table: "course_cancellation_fee_type" */
  course_cancellation_fee_type: Array<Course_Cancellation_Fee_Type>;
  /** fetch aggregated fields from the table: "course_cancellation_fee_type" */
  course_cancellation_fee_type_aggregate: Course_Cancellation_Fee_Type_Aggregate;
  /** fetch data from the table: "course_cancellation_fee_type" using primary key columns */
  course_cancellation_fee_type_by_pk?: Maybe<Course_Cancellation_Fee_Type>;
  /** fetch data from the table in a streaming manner: "course_cancellation_fee_type" */
  course_cancellation_fee_type_stream: Array<Course_Cancellation_Fee_Type>;
  /** fetch data from the table: "course_cancellation_request" */
  course_cancellation_request: Array<Course_Cancellation_Request>;
  /** fetch aggregated fields from the table: "course_cancellation_request" */
  course_cancellation_request_aggregate: Course_Cancellation_Request_Aggregate;
  /** fetch data from the table: "course_cancellation_request" using primary key columns */
  course_cancellation_request_by_pk?: Maybe<Course_Cancellation_Request>;
  /** fetch data from the table in a streaming manner: "course_cancellation_request" */
  course_cancellation_request_stream: Array<Course_Cancellation_Request>;
  /** fetch data from the table: "course_certificate" */
  course_certificate: Array<Course_Certificate>;
  /** fetch aggregated fields from the table: "course_certificate" */
  course_certificate_aggregate: Course_Certificate_Aggregate;
  /** fetch data from the table: "course_certificate" using primary key columns */
  course_certificate_by_pk?: Maybe<Course_Certificate>;
  /** fetch data from the table: "course_certificate_changelog" */
  course_certificate_changelog: Array<Course_Certificate_Changelog>;
  /** fetch aggregated fields from the table: "course_certificate_changelog" */
  course_certificate_changelog_aggregate: Course_Certificate_Changelog_Aggregate;
  /** fetch data from the table: "course_certificate_changelog" using primary key columns */
  course_certificate_changelog_by_pk?: Maybe<Course_Certificate_Changelog>;
  /** fetch data from the table in a streaming manner: "course_certificate_changelog" */
  course_certificate_changelog_stream: Array<Course_Certificate_Changelog>;
  /** fetch data from the table: "course_certificate_changelog_type" */
  course_certificate_changelog_type: Array<Course_Certificate_Changelog_Type>;
  /** fetch aggregated fields from the table: "course_certificate_changelog_type" */
  course_certificate_changelog_type_aggregate: Course_Certificate_Changelog_Type_Aggregate;
  /** fetch data from the table: "course_certificate_changelog_type" using primary key columns */
  course_certificate_changelog_type_by_pk?: Maybe<Course_Certificate_Changelog_Type>;
  /** fetch data from the table in a streaming manner: "course_certificate_changelog_type" */
  course_certificate_changelog_type_stream: Array<Course_Certificate_Changelog_Type>;
  /** fetch data from the table: "course_certificate_hold_request" */
  course_certificate_hold_request: Array<Course_Certificate_Hold_Request>;
  /** fetch aggregated fields from the table: "course_certificate_hold_request" */
  course_certificate_hold_request_aggregate: Course_Certificate_Hold_Request_Aggregate;
  /** fetch data from the table: "course_certificate_hold_request" using primary key columns */
  course_certificate_hold_request_by_pk?: Maybe<Course_Certificate_Hold_Request>;
  /** fetch data from the table in a streaming manner: "course_certificate_hold_request" */
  course_certificate_hold_request_stream: Array<Course_Certificate_Hold_Request>;
  /** fetch data from the table in a streaming manner: "course_certificate" */
  course_certificate_stream: Array<Course_Certificate>;
  /** fetch data from the table: "course_delivery_type" */
  course_delivery_type: Array<Course_Delivery_Type>;
  /** fetch aggregated fields from the table: "course_delivery_type" */
  course_delivery_type_aggregate: Course_Delivery_Type_Aggregate;
  /** fetch data from the table: "course_delivery_type" using primary key columns */
  course_delivery_type_by_pk?: Maybe<Course_Delivery_Type>;
  /** fetch data from the table: "course_delivery_type_prefix" */
  course_delivery_type_prefix: Array<Course_Delivery_Type_Prefix>;
  /** fetch aggregated fields from the table: "course_delivery_type_prefix" */
  course_delivery_type_prefix_aggregate: Course_Delivery_Type_Prefix_Aggregate;
  /** fetch data from the table: "course_delivery_type_prefix" using primary key columns */
  course_delivery_type_prefix_by_pk?: Maybe<Course_Delivery_Type_Prefix>;
  /** fetch data from the table in a streaming manner: "course_delivery_type_prefix" */
  course_delivery_type_prefix_stream: Array<Course_Delivery_Type_Prefix>;
  /** fetch data from the table in a streaming manner: "course_delivery_type" */
  course_delivery_type_stream: Array<Course_Delivery_Type>;
  /** fetch data from the table: "course_draft" */
  course_draft: Array<Course_Draft>;
  /** fetch aggregated fields from the table: "course_draft" */
  course_draft_aggregate: Course_Draft_Aggregate;
  /** fetch data from the table: "course_draft" using primary key columns */
  course_draft_by_pk?: Maybe<Course_Draft>;
  /** fetch data from the table in a streaming manner: "course_draft" */
  course_draft_stream: Array<Course_Draft>;
  /** fetch data from the table: "course_end_jobs" */
  course_end_jobs: Array<Course_End_Jobs>;
  /** fetch aggregated fields from the table: "course_end_jobs" */
  course_end_jobs_aggregate: Course_End_Jobs_Aggregate;
  /** fetch data from the table: "course_end_jobs" using primary key columns */
  course_end_jobs_by_pk?: Maybe<Course_End_Jobs>;
  /** fetch data from the table in a streaming manner: "course_end_jobs" */
  course_end_jobs_stream: Array<Course_End_Jobs>;
  /** fetch data from the table: "course_enquiry" */
  course_enquiry: Array<Course_Enquiry>;
  /** fetch aggregated fields from the table: "course_enquiry" */
  course_enquiry_aggregate: Course_Enquiry_Aggregate;
  /** fetch data from the table: "course_enquiry" using primary key columns */
  course_enquiry_by_pk?: Maybe<Course_Enquiry>;
  /** fetch data from the table in a streaming manner: "course_enquiry" */
  course_enquiry_stream: Array<Course_Enquiry>;
  /** An array relationship */
  course_evaluation_answers: Array<Course_Evaluation_Answers>;
  /** An aggregate relationship */
  course_evaluation_answers_aggregate: Course_Evaluation_Answers_Aggregate;
  /** fetch data from the table: "course_evaluation_answers" using primary key columns */
  course_evaluation_answers_by_pk?: Maybe<Course_Evaluation_Answers>;
  /** fetch data from the table in a streaming manner: "course_evaluation_answers" */
  course_evaluation_answers_stream: Array<Course_Evaluation_Answers>;
  /** fetch data from the table: "course_evaluation_question_group" */
  course_evaluation_question_group: Array<Course_Evaluation_Question_Group>;
  /** fetch aggregated fields from the table: "course_evaluation_question_group" */
  course_evaluation_question_group_aggregate: Course_Evaluation_Question_Group_Aggregate;
  /** fetch data from the table: "course_evaluation_question_group" using primary key columns */
  course_evaluation_question_group_by_pk?: Maybe<Course_Evaluation_Question_Group>;
  /** fetch data from the table in a streaming manner: "course_evaluation_question_group" */
  course_evaluation_question_group_stream: Array<Course_Evaluation_Question_Group>;
  /** fetch data from the table: "course_evaluation_question_type" */
  course_evaluation_question_type: Array<Course_Evaluation_Question_Type>;
  /** fetch aggregated fields from the table: "course_evaluation_question_type" */
  course_evaluation_question_type_aggregate: Course_Evaluation_Question_Type_Aggregate;
  /** fetch data from the table: "course_evaluation_question_type" using primary key columns */
  course_evaluation_question_type_by_pk?: Maybe<Course_Evaluation_Question_Type>;
  /** fetch data from the table in a streaming manner: "course_evaluation_question_type" */
  course_evaluation_question_type_stream: Array<Course_Evaluation_Question_Type>;
  /** fetch data from the table: "course_evaluation_questions" */
  course_evaluation_questions: Array<Course_Evaluation_Questions>;
  /** fetch aggregated fields from the table: "course_evaluation_questions" */
  course_evaluation_questions_aggregate: Course_Evaluation_Questions_Aggregate;
  /** fetch data from the table: "course_evaluation_questions" using primary key columns */
  course_evaluation_questions_by_pk?: Maybe<Course_Evaluation_Questions>;
  /** fetch data from the table in a streaming manner: "course_evaluation_questions" */
  course_evaluation_questions_stream: Array<Course_Evaluation_Questions>;
  /** fetch data from the table: "course_evaluation_scheduled_event" */
  course_evaluation_scheduled_event: Array<Course_Evaluation_Scheduled_Event>;
  /** fetch aggregated fields from the table: "course_evaluation_scheduled_event" */
  course_evaluation_scheduled_event_aggregate: Course_Evaluation_Scheduled_Event_Aggregate;
  /** fetch data from the table: "course_evaluation_scheduled_event" using primary key columns */
  course_evaluation_scheduled_event_by_pk?: Maybe<Course_Evaluation_Scheduled_Event>;
  /** fetch data from the table in a streaming manner: "course_evaluation_scheduled_event" */
  course_evaluation_scheduled_event_stream: Array<Course_Evaluation_Scheduled_Event>;
  /** fetch data from the table: "course_exception" */
  course_exception: Array<Course_Exception>;
  /** fetch aggregated fields from the table: "course_exception" */
  course_exception_aggregate: Course_Exception_Aggregate;
  /** fetch data from the table: "course_exception" using primary key columns */
  course_exception_by_pk?: Maybe<Course_Exception>;
  /** fetch data from the table in a streaming manner: "course_exception" */
  course_exception_stream: Array<Course_Exception>;
  /** fetch data from the table: "course_exceptions" */
  course_exceptions: Array<Course_Exceptions>;
  /** fetch aggregated fields from the table: "course_exceptions" */
  course_exceptions_aggregate: Course_Exceptions_Aggregate;
  /** fetch data from the table: "course_exceptions" using primary key columns */
  course_exceptions_by_pk?: Maybe<Course_Exceptions>;
  /** fetch data from the table in a streaming manner: "course_exceptions" */
  course_exceptions_stream: Array<Course_Exceptions>;
  /** fetch data from the table: "course_expenses" */
  course_expenses: Array<Course_Expenses>;
  /** fetch aggregated fields from the table: "course_expenses" */
  course_expenses_aggregate: Course_Expenses_Aggregate;
  /** fetch data from the table: "course_expenses" using primary key columns */
  course_expenses_by_pk?: Maybe<Course_Expenses>;
  /** fetch data from the table in a streaming manner: "course_expenses" */
  course_expenses_stream: Array<Course_Expenses>;
  /** fetch data from the table: "course_invite_status" */
  course_invite_status: Array<Course_Invite_Status>;
  /** fetch aggregated fields from the table: "course_invite_status" */
  course_invite_status_aggregate: Course_Invite_Status_Aggregate;
  /** fetch data from the table: "course_invite_status" using primary key columns */
  course_invite_status_by_pk?: Maybe<Course_Invite_Status>;
  /** fetch data from the table in a streaming manner: "course_invite_status" */
  course_invite_status_stream: Array<Course_Invite_Status>;
  /** An array relationship */
  course_invites: Array<Course_Invites>;
  /** An aggregate relationship */
  course_invites_aggregate: Course_Invites_Aggregate;
  /** fetch data from the table: "course_invites" using primary key columns */
  course_invites_by_pk?: Maybe<Course_Invites>;
  /** fetch data from the table in a streaming manner: "course_invites" */
  course_invites_stream: Array<Course_Invites>;
  /** fetch data from the table: "course_level" */
  course_level: Array<Course_Level>;
  /** fetch aggregated fields from the table: "course_level" */
  course_level_aggregate: Course_Level_Aggregate;
  /** fetch data from the table: "course_level" using primary key columns */
  course_level_by_pk?: Maybe<Course_Level>;
  /** fetch data from the table: "course_level_prefix" */
  course_level_prefix: Array<Course_Level_Prefix>;
  /** fetch aggregated fields from the table: "course_level_prefix" */
  course_level_prefix_aggregate: Course_Level_Prefix_Aggregate;
  /** fetch data from the table: "course_level_prefix" using primary key columns */
  course_level_prefix_by_pk?: Maybe<Course_Level_Prefix>;
  /** fetch data from the table in a streaming manner: "course_level_prefix" */
  course_level_prefix_stream: Array<Course_Level_Prefix>;
  /** fetch data from the table in a streaming manner: "course_level" */
  course_level_stream: Array<Course_Level>;
  /** fetch data from the table: "course_module" */
  course_module: Array<Course_Module>;
  /** fetch aggregated fields from the table: "course_module" */
  course_module_aggregate: Course_Module_Aggregate;
  /** fetch data from the table: "course_module" using primary key columns */
  course_module_by_pk?: Maybe<Course_Module>;
  /** fetch data from the table in a streaming manner: "course_module" */
  course_module_stream: Array<Course_Module>;
  /** fetch data from the table: "course_order" */
  course_order: Array<Course_Order>;
  /** fetch aggregated fields from the table: "course_order" */
  course_order_aggregate: Course_Order_Aggregate;
  /** fetch data from the table in a streaming manner: "course_order" */
  course_order_stream: Array<Course_Order>;
  /** fetch data from the table: "course_participant" */
  course_participant: Array<Course_Participant>;
  /** fetch aggregated fields from the table: "course_participant" */
  course_participant_aggregate: Course_Participant_Aggregate;
  /** fetch data from the table: "course_participant_audit" */
  course_participant_audit: Array<Course_Participant_Audit>;
  /** fetch aggregated fields from the table: "course_participant_audit" */
  course_participant_audit_aggregate: Course_Participant_Audit_Aggregate;
  /** fetch data from the table: "course_participant_audit" using primary key columns */
  course_participant_audit_by_pk?: Maybe<Course_Participant_Audit>;
  /** fetch data from the table in a streaming manner: "course_participant_audit" */
  course_participant_audit_stream: Array<Course_Participant_Audit>;
  /** fetch data from the table: "course_participant_audit_type" */
  course_participant_audit_type: Array<Course_Participant_Audit_Type>;
  /** fetch aggregated fields from the table: "course_participant_audit_type" */
  course_participant_audit_type_aggregate: Course_Participant_Audit_Type_Aggregate;
  /** fetch data from the table: "course_participant_audit_type" using primary key columns */
  course_participant_audit_type_by_pk?: Maybe<Course_Participant_Audit_Type>;
  /** fetch data from the table in a streaming manner: "course_participant_audit_type" */
  course_participant_audit_type_stream: Array<Course_Participant_Audit_Type>;
  /** fetch data from the table: "course_participant_bild_module" */
  course_participant_bild_module: Array<Course_Participant_Bild_Module>;
  /** fetch aggregated fields from the table: "course_participant_bild_module" */
  course_participant_bild_module_aggregate: Course_Participant_Bild_Module_Aggregate;
  /** fetch data from the table: "course_participant_bild_module" using primary key columns */
  course_participant_bild_module_by_pk?: Maybe<Course_Participant_Bild_Module>;
  /** fetch data from the table in a streaming manner: "course_participant_bild_module" */
  course_participant_bild_module_stream: Array<Course_Participant_Bild_Module>;
  /** fetch data from the table: "course_participant" using primary key columns */
  course_participant_by_pk?: Maybe<Course_Participant>;
  /** fetch data from the table: "course_participant_cancellation" */
  course_participant_cancellation: Array<Course_Participant_Cancellation>;
  /** fetch aggregated fields from the table: "course_participant_cancellation" */
  course_participant_cancellation_aggregate: Course_Participant_Cancellation_Aggregate;
  /** fetch data from the table: "course_participant_cancellation" using primary key columns */
  course_participant_cancellation_by_pk?: Maybe<Course_Participant_Cancellation>;
  /** fetch data from the table in a streaming manner: "course_participant_cancellation" */
  course_participant_cancellation_stream: Array<Course_Participant_Cancellation>;
  /** fetch data from the table: "course_participant_module" */
  course_participant_module: Array<Course_Participant_Module>;
  /** fetch aggregated fields from the table: "course_participant_module" */
  course_participant_module_aggregate: Course_Participant_Module_Aggregate;
  /** fetch data from the table: "course_participant_module" using primary key columns */
  course_participant_module_by_pk?: Maybe<Course_Participant_Module>;
  /** fetch data from the table in a streaming manner: "course_participant_module" */
  course_participant_module_stream: Array<Course_Participant_Module>;
  /** fetch data from the table: "course_participant_note" */
  course_participant_note: Array<Course_Participant_Note>;
  /** fetch aggregated fields from the table: "course_participant_note" */
  course_participant_note_aggregate: Course_Participant_Note_Aggregate;
  /** fetch data from the table: "course_participant_note" using primary key columns */
  course_participant_note_by_pk?: Maybe<Course_Participant_Note>;
  /** fetch data from the table in a streaming manner: "course_participant_note" */
  course_participant_note_stream: Array<Course_Participant_Note>;
  /** fetch data from the table in a streaming manner: "course_participant" */
  course_participant_stream: Array<Course_Participant>;
  /** fetch data from the table: "course_pricing" */
  course_pricing: Array<Course_Pricing>;
  /** fetch aggregated fields from the table: "course_pricing" */
  course_pricing_aggregate: Course_Pricing_Aggregate;
  /** fetch data from the table: "course_pricing" using primary key columns */
  course_pricing_by_pk?: Maybe<Course_Pricing>;
  /** fetch data from the table: "course_pricing_changelog" */
  course_pricing_changelog: Array<Course_Pricing_Changelog>;
  /** fetch aggregated fields from the table: "course_pricing_changelog" */
  course_pricing_changelog_aggregate: Course_Pricing_Changelog_Aggregate;
  /** fetch data from the table: "course_pricing_changelog" using primary key columns */
  course_pricing_changelog_by_pk?: Maybe<Course_Pricing_Changelog>;
  /** fetch data from the table in a streaming manner: "course_pricing_changelog" */
  course_pricing_changelog_stream: Array<Course_Pricing_Changelog>;
  /** fetch data from the table: "course_pricing_schedule" */
  course_pricing_schedule: Array<Course_Pricing_Schedule>;
  /** fetch aggregated fields from the table: "course_pricing_schedule" */
  course_pricing_schedule_aggregate: Course_Pricing_Schedule_Aggregate;
  /** fetch data from the table: "course_pricing_schedule" using primary key columns */
  course_pricing_schedule_by_pk?: Maybe<Course_Pricing_Schedule>;
  /** fetch data from the table in a streaming manner: "course_pricing_schedule" */
  course_pricing_schedule_stream: Array<Course_Pricing_Schedule>;
  /** fetch data from the table in a streaming manner: "course_pricing" */
  course_pricing_stream: Array<Course_Pricing>;
  /** fetch data from the table: "course_promo_code" */
  course_promo_code: Array<Course_Promo_Code>;
  /** fetch aggregated fields from the table: "course_promo_code" */
  course_promo_code_aggregate: Course_Promo_Code_Aggregate;
  /** fetch data from the table: "course_promo_code" using primary key columns */
  course_promo_code_by_pk?: Maybe<Course_Promo_Code>;
  /** fetch data from the table in a streaming manner: "course_promo_code" */
  course_promo_code_stream: Array<Course_Promo_Code>;
  /** fetch data from the table: "course_renewal_cycle" */
  course_renewal_cycle: Array<Course_Renewal_Cycle>;
  /** fetch aggregated fields from the table: "course_renewal_cycle" */
  course_renewal_cycle_aggregate: Course_Renewal_Cycle_Aggregate;
  /** fetch data from the table: "course_renewal_cycle" using primary key columns */
  course_renewal_cycle_by_pk?: Maybe<Course_Renewal_Cycle>;
  /** fetch data from the table in a streaming manner: "course_renewal_cycle" */
  course_renewal_cycle_stream: Array<Course_Renewal_Cycle>;
  /** fetch data from the table: "course_schedule" */
  course_schedule: Array<Course_Schedule>;
  /** fetch aggregated fields from the table: "course_schedule" */
  course_schedule_aggregate: Course_Schedule_Aggregate;
  /** fetch data from the table: "course_schedule" using primary key columns */
  course_schedule_by_pk?: Maybe<Course_Schedule>;
  /** fetch data from the table in a streaming manner: "course_schedule" */
  course_schedule_stream: Array<Course_Schedule>;
  /** fetch data from the table: "course_source" */
  course_source: Array<Course_Source>;
  /** fetch aggregated fields from the table: "course_source" */
  course_source_aggregate: Course_Source_Aggregate;
  /** fetch data from the table: "course_source" using primary key columns */
  course_source_by_pk?: Maybe<Course_Source>;
  /** fetch data from the table in a streaming manner: "course_source" */
  course_source_stream: Array<Course_Source>;
  /** fetch data from the table: "course_status" */
  course_status: Array<Course_Status>;
  /** fetch aggregated fields from the table: "course_status" */
  course_status_aggregate: Course_Status_Aggregate;
  /** fetch data from the table: "course_status" using primary key columns */
  course_status_by_pk?: Maybe<Course_Status>;
  /** fetch data from the table in a streaming manner: "course_status" */
  course_status_stream: Array<Course_Status>;
  /** fetch data from the table in a streaming manner: "course" */
  course_stream: Array<Course>;
  /** An array relationship */
  course_trainer: Array<Course_Trainer>;
  /** An aggregate relationship */
  course_trainer_aggregate: Course_Trainer_Aggregate;
  /** fetch data from the table: "course_trainer" using primary key columns */
  course_trainer_by_pk?: Maybe<Course_Trainer>;
  /** fetch data from the table in a streaming manner: "course_trainer" */
  course_trainer_stream: Array<Course_Trainer>;
  /** fetch data from the table: "course_trainer_type" */
  course_trainer_type: Array<Course_Trainer_Type>;
  /** fetch aggregated fields from the table: "course_trainer_type" */
  course_trainer_type_aggregate: Course_Trainer_Type_Aggregate;
  /** fetch data from the table: "course_trainer_type" using primary key columns */
  course_trainer_type_by_pk?: Maybe<Course_Trainer_Type>;
  /** fetch data from the table in a streaming manner: "course_trainer_type" */
  course_trainer_type_stream: Array<Course_Trainer_Type>;
  /** fetch data from the table: "course_type" */
  course_type: Array<Course_Type>;
  /** fetch aggregated fields from the table: "course_type" */
  course_type_aggregate: Course_Type_Aggregate;
  /** fetch data from the table: "course_type" using primary key columns */
  course_type_by_pk?: Maybe<Course_Type>;
  /** fetch data from the table: "course_type_prefix" */
  course_type_prefix: Array<Course_Type_Prefix>;
  /** fetch aggregated fields from the table: "course_type_prefix" */
  course_type_prefix_aggregate: Course_Type_Prefix_Aggregate;
  /** fetch data from the table: "course_type_prefix" using primary key columns */
  course_type_prefix_by_pk?: Maybe<Course_Type_Prefix>;
  /** fetch data from the table in a streaming manner: "course_type_prefix" */
  course_type_prefix_stream: Array<Course_Type_Prefix>;
  /** fetch data from the table in a streaming manner: "course_type" */
  course_type_stream: Array<Course_Type>;
  /** fetch data from the table: "cqc_establishment" */
  cqc_establishment: Array<Cqc_Establishment>;
  /** fetch aggregated fields from the table: "cqc_establishment" */
  cqc_establishment_aggregate: Cqc_Establishment_Aggregate;
  /** fetch data from the table: "cqc_establishment" using primary key columns */
  cqc_establishment_by_pk?: Maybe<Cqc_Establishment>;
  /** fetch data from the table in a streaming manner: "cqc_establishment" */
  cqc_establishment_stream: Array<Cqc_Establishment>;
  /** fetch data from the table: "cud_operation" */
  cud_operation: Array<Cud_Operation>;
  /** fetch aggregated fields from the table: "cud_operation" */
  cud_operation_aggregate: Cud_Operation_Aggregate;
  /** fetch data from the table: "cud_operation" using primary key columns */
  cud_operation_by_pk?: Maybe<Cud_Operation>;
  /** fetch data from the table in a streaming manner: "cud_operation" */
  cud_operation_stream: Array<Cud_Operation>;
  /** fetch data from the table: "deleted_organizations_backup" */
  deleted_organizations_backup: Array<Deleted_Organizations_Backup>;
  /** fetch aggregated fields from the table: "deleted_organizations_backup" */
  deleted_organizations_backup_aggregate: Deleted_Organizations_Backup_Aggregate;
  /** fetch data from the table in a streaming manner: "deleted_organizations_backup" */
  deleted_organizations_backup_stream: Array<Deleted_Organizations_Backup>;
  /** fetch data from the table: "dfe_establishment" */
  dfe_establishment: Array<Dfe_Establishment>;
  /** fetch aggregated fields from the table: "dfe_establishment" */
  dfe_establishment_aggregate: Dfe_Establishment_Aggregate;
  /** fetch data from the table: "dfe_establishment" using primary key columns */
  dfe_establishment_by_pk?: Maybe<Dfe_Establishment>;
  /** fetch data from the table in a streaming manner: "dfe_establishment" */
  dfe_establishment_stream: Array<Dfe_Establishment>;
  /** fetch data from the table: "email_notifications" */
  email_notifications: Array<Email_Notifications>;
  /** fetch aggregated fields from the table: "email_notifications" */
  email_notifications_aggregate: Email_Notifications_Aggregate;
  /** fetch data from the table: "email_notifications" using primary key columns */
  email_notifications_by_pk?: Maybe<Email_Notifications>;
  /** fetch data from the table in a streaming manner: "email_notifications" */
  email_notifications_stream: Array<Email_Notifications>;
  /** An array relationship */
  expire_go1_license_jobs: Array<Expire_Go1_License_Jobs>;
  /** An aggregate relationship */
  expire_go1_license_jobs_aggregate: Expire_Go1_License_Jobs_Aggregate;
  /** fetch data from the table: "expire_go1_license_jobs" using primary key columns */
  expire_go1_license_jobs_by_pk?: Maybe<Expire_Go1_License_Jobs>;
  /** fetch data from the table in a streaming manner: "expire_go1_license_jobs" */
  expire_go1_license_jobs_stream: Array<Expire_Go1_License_Jobs>;
  /** fetch data from the table: "go1_history_events" */
  go1_history_events: Array<Go1_History_Events>;
  /** fetch aggregated fields from the table: "go1_history_events" */
  go1_history_events_aggregate: Go1_History_Events_Aggregate;
  /** fetch data from the table: "go1_history_events" using primary key columns */
  go1_history_events_by_pk?: Maybe<Go1_History_Events>;
  /** fetch data from the table in a streaming manner: "go1_history_events" */
  go1_history_events_stream: Array<Go1_History_Events>;
  /** fetch data from the table: "go1_licenses" */
  go1_licenses: Array<Go1_Licenses>;
  /** fetch aggregated fields from the table: "go1_licenses" */
  go1_licenses_aggregate: Go1_Licenses_Aggregate;
  /** fetch data from the table: "go1_licenses" using primary key columns */
  go1_licenses_by_pk?: Maybe<Go1_Licenses>;
  /** fetch data from the table: "go1_licenses_history" */
  go1_licenses_history: Array<Go1_Licenses_History>;
  /** fetch aggregated fields from the table: "go1_licenses_history" */
  go1_licenses_history_aggregate: Go1_Licenses_History_Aggregate;
  /** fetch data from the table: "go1_licenses_history" using primary key columns */
  go1_licenses_history_by_pk?: Maybe<Go1_Licenses_History>;
  /** fetch data from the table in a streaming manner: "go1_licenses_history" */
  go1_licenses_history_stream: Array<Go1_Licenses_History>;
  /** fetch data from the table in a streaming manner: "go1_licenses" */
  go1_licenses_stream: Array<Go1_Licenses>;
  /** fetch data from the table: "grade" */
  grade: Array<Grade>;
  /** fetch aggregated fields from the table: "grade" */
  grade_aggregate: Grade_Aggregate;
  /** fetch data from the table: "grade" using primary key columns */
  grade_by_pk?: Maybe<Grade>;
  /** fetch data from the table in a streaming manner: "grade" */
  grade_stream: Array<Grade>;
  /** fetch data from the table: "hubspot_audit" */
  hubspot_audit: Array<Hubspot_Audit>;
  /** fetch aggregated fields from the table: "hubspot_audit" */
  hubspot_audit_aggregate: Hubspot_Audit_Aggregate;
  /** fetch data from the table: "hubspot_audit" using primary key columns */
  hubspot_audit_by_pk?: Maybe<Hubspot_Audit>;
  /** fetch data from the table in a streaming manner: "hubspot_audit" */
  hubspot_audit_stream: Array<Hubspot_Audit>;
  /** fetch data from the table: "identity" */
  identity: Array<Identity>;
  /** fetch aggregated fields from the table: "identity" */
  identity_aggregate: Identity_Aggregate;
  /** fetch data from the table: "identity" using primary key columns */
  identity_by_pk?: Maybe<Identity>;
  /** fetch data from the table in a streaming manner: "identity" */
  identity_stream: Array<Identity>;
  /** fetch data from the table: "identity_type" */
  identity_type: Array<Identity_Type>;
  /** fetch aggregated fields from the table: "identity_type" */
  identity_type_aggregate: Identity_Type_Aggregate;
  /** fetch data from the table: "identity_type" using primary key columns */
  identity_type_by_pk?: Maybe<Identity_Type>;
  /** fetch data from the table in a streaming manner: "identity_type" */
  identity_type_stream: Array<Identity_Type>;
  importArloCertificates?: Maybe<ImportArloCertificates>;
  /** fetch data from the table: "import_job" */
  import_job: Array<Import_Job>;
  /** fetch aggregated fields from the table: "import_job" */
  import_job_aggregate: Import_Job_Aggregate;
  /** fetch data from the table: "import_job" using primary key columns */
  import_job_by_pk?: Maybe<Import_Job>;
  /** fetch data from the table: "import_job_status" */
  import_job_status: Array<Import_Job_Status>;
  /** fetch aggregated fields from the table: "import_job_status" */
  import_job_status_aggregate: Import_Job_Status_Aggregate;
  /** fetch data from the table: "import_job_status" using primary key columns */
  import_job_status_by_pk?: Maybe<Import_Job_Status>;
  /** fetch data from the table in a streaming manner: "import_job_status" */
  import_job_status_stream: Array<Import_Job_Status>;
  /** fetch data from the table in a streaming manner: "import_job" */
  import_job_stream: Array<Import_Job>;
  /** fetch data from the table: "import_job_type" */
  import_job_type: Array<Import_Job_Type>;
  /** fetch aggregated fields from the table: "import_job_type" */
  import_job_type_aggregate: Import_Job_Type_Aggregate;
  /** fetch data from the table: "import_job_type" using primary key columns */
  import_job_type_by_pk?: Maybe<Import_Job_Type>;
  /** fetch data from the table in a streaming manner: "import_job_type" */
  import_job_type_stream: Array<Import_Job_Type>;
  /** fetch data from the table: "job_title" */
  job_title: Array<Job_Title>;
  /** fetch aggregated fields from the table: "job_title" */
  job_title_aggregate: Job_Title_Aggregate;
  /** fetch data from the table: "job_title" using primary key columns */
  job_title_by_pk?: Maybe<Job_Title>;
  /** fetch data from the table in a streaming manner: "job_title" */
  job_title_stream: Array<Job_Title>;
  /** fetch data from the table: "legacy_certificate" */
  legacy_certificate: Array<Legacy_Certificate>;
  /** fetch aggregated fields from the table: "legacy_certificate" */
  legacy_certificate_aggregate: Legacy_Certificate_Aggregate;
  /** fetch data from the table: "legacy_certificate" using primary key columns */
  legacy_certificate_by_pk?: Maybe<Legacy_Certificate>;
  /** fetch data from the table in a streaming manner: "legacy_certificate" */
  legacy_certificate_stream: Array<Legacy_Certificate>;
  /** fetch data from the table: "materials_order" */
  materials_order: Array<Materials_Order>;
  /** fetch aggregated fields from the table: "materials_order" */
  materials_order_aggregate: Materials_Order_Aggregate;
  /** fetch data from the table: "materials_order" using primary key columns */
  materials_order_by_pk?: Maybe<Materials_Order>;
  /** fetch data from the table in a streaming manner: "materials_order" */
  materials_order_stream: Array<Materials_Order>;
  /** fetch data from the table: "merge_organizations_logs" */
  merge_organizations_logs: Array<Merge_Organizations_Logs>;
  /** fetch aggregated fields from the table: "merge_organizations_logs" */
  merge_organizations_logs_aggregate: Merge_Organizations_Logs_Aggregate;
  /** fetch data from the table: "merge_organizations_logs" using primary key columns */
  merge_organizations_logs_by_pk?: Maybe<Merge_Organizations_Logs>;
  /** fetch data from the table in a streaming manner: "merge_organizations_logs" */
  merge_organizations_logs_stream: Array<Merge_Organizations_Logs>;
  /** fetch data from the table: "merged_organizations" */
  merged_organizations: Array<Merged_Organizations>;
  /** fetch aggregated fields from the table: "merged_organizations" */
  merged_organizations_aggregate: Merged_Organizations_Aggregate;
  /** fetch data from the table: "merged_organizations" using primary key columns */
  merged_organizations_by_pk?: Maybe<Merged_Organizations>;
  /** fetch data from the table in a streaming manner: "merged_organizations" */
  merged_organizations_stream: Array<Merged_Organizations>;
  /** fetch data from the table: "module" */
  module: Array<Module>;
  /** fetch aggregated fields from the table: "module" */
  module_aggregate: Module_Aggregate;
  /** fetch data from the table: "module" using primary key columns */
  module_by_pk?: Maybe<Module>;
  /** fetch data from the table: "module_category" */
  module_category: Array<Module_Category>;
  /** fetch aggregated fields from the table: "module_category" */
  module_category_aggregate: Module_Category_Aggregate;
  /** fetch data from the table: "module_category" using primary key columns */
  module_category_by_pk?: Maybe<Module_Category>;
  /** fetch data from the table in a streaming manner: "module_category" */
  module_category_stream: Array<Module_Category>;
  /** fetch data from the table: "module_group" */
  module_group: Array<Module_Group>;
  /** fetch aggregated fields from the table: "module_group" */
  module_group_aggregate: Module_Group_Aggregate;
  /** fetch data from the table: "module_group" using primary key columns */
  module_group_by_pk?: Maybe<Module_Group>;
  /** fetch data from the table: "module_group_duration" */
  module_group_duration: Array<Module_Group_Duration>;
  /** fetch aggregated fields from the table: "module_group_duration" */
  module_group_duration_aggregate: Module_Group_Duration_Aggregate;
  /** fetch data from the table: "module_group_duration" using primary key columns */
  module_group_duration_by_pk?: Maybe<Module_Group_Duration>;
  /** fetch data from the table in a streaming manner: "module_group_duration" */
  module_group_duration_stream: Array<Module_Group_Duration>;
  /** fetch data from the table in a streaming manner: "module_group" */
  module_group_stream: Array<Module_Group>;
  /** fetch data from the table: "module_setting" */
  module_setting: Array<Module_Setting>;
  /** fetch aggregated fields from the table: "module_setting" */
  module_setting_aggregate: Module_Setting_Aggregate;
  /** fetch data from the table: "module_setting" using primary key columns */
  module_setting_by_pk?: Maybe<Module_Setting>;
  /** fetch data from the table: "module_setting_dependency" */
  module_setting_dependency: Array<Module_Setting_Dependency>;
  /** fetch aggregated fields from the table: "module_setting_dependency" */
  module_setting_dependency_aggregate: Module_Setting_Dependency_Aggregate;
  /** fetch data from the table: "module_setting_dependency" using primary key columns */
  module_setting_dependency_by_pk?: Maybe<Module_Setting_Dependency>;
  /** fetch data from the table in a streaming manner: "module_setting_dependency" */
  module_setting_dependency_stream: Array<Module_Setting_Dependency>;
  /** fetch data from the table in a streaming manner: "module_setting" */
  module_setting_stream: Array<Module_Setting>;
  /** fetch data from the table in a streaming manner: "module" */
  module_stream: Array<Module>;
  /** fetch data from the table: "module_v2" */
  module_v2: Array<Module_V2>;
  /** fetch aggregated fields from the table: "module_v2" */
  module_v2_aggregate: Module_V2_Aggregate;
  /** fetch data from the table: "module_v2" using primary key columns */
  module_v2_by_pk?: Maybe<Module_V2>;
  /** fetch data from the table in a streaming manner: "module_v2" */
  module_v2_stream: Array<Module_V2>;
  /** fetch data from the table: "non_graded_certificate" */
  non_graded_certificate: Array<Non_Graded_Certificate>;
  /** fetch aggregated fields from the table: "non_graded_certificate" */
  non_graded_certificate_aggregate: Non_Graded_Certificate_Aggregate;
  /** fetch data from the table: "non_graded_certificate" using primary key columns */
  non_graded_certificate_by_pk?: Maybe<Non_Graded_Certificate>;
  /** fetch data from the table in a streaming manner: "non_graded_certificate" */
  non_graded_certificate_stream: Array<Non_Graded_Certificate>;
  /** fetch data from the table: "order" */
  order: Array<Order>;
  /** fetch aggregated fields from the table: "order" */
  order_aggregate: Order_Aggregate;
  /** fetch data from the table: "order" using primary key columns */
  order_by_pk?: Maybe<Order>;
  /** fetch data from the table in a streaming manner: "order" */
  order_stream: Array<Order>;
  /** fetch data from the table: "order_temp" */
  order_temp: Array<Order_Temp>;
  /** fetch aggregated fields from the table: "order_temp" */
  order_temp_aggregate: Order_Temp_Aggregate;
  /** fetch data from the table: "order_temp" using primary key columns */
  order_temp_by_pk?: Maybe<Order_Temp>;
  /** fetch data from the table in a streaming manner: "order_temp" */
  order_temp_stream: Array<Order_Temp>;
  /** fetch data from the table: "org_created_from" */
  org_created_from: Array<Org_Created_From>;
  /** fetch aggregated fields from the table: "org_created_from" */
  org_created_from_aggregate: Org_Created_From_Aggregate;
  /** fetch data from the table: "org_created_from" using primary key columns */
  org_created_from_by_pk?: Maybe<Org_Created_From>;
  /** fetch data from the table in a streaming manner: "org_created_from" */
  org_created_from_stream: Array<Org_Created_From>;
  /** fetch data from the table: "org_distinct_country_codes" */
  org_distinct_country_codes: Array<Org_Distinct_Country_Codes>;
  /** fetch aggregated fields from the table: "org_distinct_country_codes" */
  org_distinct_country_codes_aggregate: Org_Distinct_Country_Codes_Aggregate;
  /** fetch data from the table in a streaming manner: "org_distinct_country_codes" */
  org_distinct_country_codes_stream: Array<Org_Distinct_Country_Codes>;
  /** fetch data from the table: "org_resource_packs_history" */
  org_resource_packs_history: Array<Org_Resource_Packs_History>;
  /** fetch aggregated fields from the table: "org_resource_packs_history" */
  org_resource_packs_history_aggregate: Org_Resource_Packs_History_Aggregate;
  /** fetch data from the table: "org_resource_packs_history" using primary key columns */
  org_resource_packs_history_by_pk?: Maybe<Org_Resource_Packs_History>;
  /** fetch data from the table in a streaming manner: "org_resource_packs_history" */
  org_resource_packs_history_stream: Array<Org_Resource_Packs_History>;
  /** fetch data from the table: "org_resource_packs_pricing" */
  org_resource_packs_pricing: Array<Org_Resource_Packs_Pricing>;
  /** fetch aggregated fields from the table: "org_resource_packs_pricing" */
  org_resource_packs_pricing_aggregate: Org_Resource_Packs_Pricing_Aggregate;
  /** fetch data from the table: "org_resource_packs_pricing" using primary key columns */
  org_resource_packs_pricing_by_pk?: Maybe<Org_Resource_Packs_Pricing>;
  /** fetch data from the table: "org_resource_packs_pricing_changelog" */
  org_resource_packs_pricing_changelog: Array<Org_Resource_Packs_Pricing_Changelog>;
  /** fetch aggregated fields from the table: "org_resource_packs_pricing_changelog" */
  org_resource_packs_pricing_changelog_aggregate: Org_Resource_Packs_Pricing_Changelog_Aggregate;
  /** fetch data from the table: "org_resource_packs_pricing_changelog" using primary key columns */
  org_resource_packs_pricing_changelog_by_pk?: Maybe<Org_Resource_Packs_Pricing_Changelog>;
  /** fetch data from the table in a streaming manner: "org_resource_packs_pricing_changelog" */
  org_resource_packs_pricing_changelog_stream: Array<Org_Resource_Packs_Pricing_Changelog>;
  /** fetch data from the table in a streaming manner: "org_resource_packs_pricing" */
  org_resource_packs_pricing_stream: Array<Org_Resource_Packs_Pricing>;
  /** fetch data from the table: "organisation_log" */
  organisation_log: Array<Organisation_Log>;
  /** fetch aggregated fields from the table: "organisation_log" */
  organisation_log_aggregate: Organisation_Log_Aggregate;
  /** fetch data from the table: "organisation_log" using primary key columns */
  organisation_log_by_pk?: Maybe<Organisation_Log>;
  /** fetch data from the table in a streaming manner: "organisation_log" */
  organisation_log_stream: Array<Organisation_Log>;
  /** fetch data from the table: "organisation_sector" */
  organisation_sector: Array<Organisation_Sector>;
  /** fetch aggregated fields from the table: "organisation_sector" */
  organisation_sector_aggregate: Organisation_Sector_Aggregate;
  /** fetch data from the table: "organisation_sector" using primary key columns */
  organisation_sector_by_pk?: Maybe<Organisation_Sector>;
  /** fetch data from the table in a streaming manner: "organisation_sector" */
  organisation_sector_stream: Array<Organisation_Sector>;
  /** fetch data from the table: "organization" */
  organization: Array<Organization>;
  /** fetch aggregated fields from the table: "organization" */
  organization_aggregate: Organization_Aggregate;
  /** fetch data from the table: "organization" using primary key columns */
  organization_by_pk?: Maybe<Organization>;
  /** fetch data from the table: "organization_invites" */
  organization_invites: Array<Organization_Invites>;
  /** fetch aggregated fields from the table: "organization_invites" */
  organization_invites_aggregate: Organization_Invites_Aggregate;
  /** fetch data from the table: "organization_invites" using primary key columns */
  organization_invites_by_pk?: Maybe<Organization_Invites>;
  /** fetch data from the table in a streaming manner: "organization_invites" */
  organization_invites_stream: Array<Organization_Invites>;
  /** fetch data from the table: "organization_member" */
  organization_member: Array<Organization_Member>;
  /** fetch aggregated fields from the table: "organization_member" */
  organization_member_aggregate: Organization_Member_Aggregate;
  /** fetch data from the table: "organization_member" using primary key columns */
  organization_member_by_pk?: Maybe<Organization_Member>;
  /** fetch data from the table in a streaming manner: "organization_member" */
  organization_member_stream: Array<Organization_Member>;
  /** An array relationship */
  organization_resource_packs: Array<Organization_Resource_Packs>;
  /** An aggregate relationship */
  organization_resource_packs_aggregate: Organization_Resource_Packs_Aggregate;
  /** fetch data from the table: "organization_resource_packs" using primary key columns */
  organization_resource_packs_by_pk?: Maybe<Organization_Resource_Packs>;
  /** fetch data from the table in a streaming manner: "organization_resource_packs" */
  organization_resource_packs_stream: Array<Organization_Resource_Packs>;
  /** fetch data from the table in a streaming manner: "organization" */
  organization_stream: Array<Organization>;
  /** fetch data from the table: "organization_type" */
  organization_type: Array<Organization_Type>;
  /** fetch aggregated fields from the table: "organization_type" */
  organization_type_aggregate: Organization_Type_Aggregate;
  /** fetch data from the table: "organization_type" using primary key columns */
  organization_type_by_pk?: Maybe<Organization_Type>;
  /** fetch data from the table in a streaming manner: "organization_type" */
  organization_type_stream: Array<Organization_Type>;
  /** fetch data from the table: "organizations_statistics" */
  organizations_statistics: Array<Organizations_Statistics>;
  /** fetch aggregated fields from the table: "organizations_statistics" */
  organizations_statistics_aggregate: Organizations_Statistics_Aggregate;
  /** fetch data from the table: "organizations_statistics" using primary key columns */
  organizations_statistics_by_pk?: Maybe<Organizations_Statistics>;
  /** fetch data from the table in a streaming manner: "organizations_statistics" */
  organizations_statistics_stream: Array<Organizations_Statistics>;
  /** fetch data from the table: "payment_methods" */
  payment_methods: Array<Payment_Methods>;
  /** fetch aggregated fields from the table: "payment_methods" */
  payment_methods_aggregate: Payment_Methods_Aggregate;
  /** fetch data from the table: "payment_methods" using primary key columns */
  payment_methods_by_pk?: Maybe<Payment_Methods>;
  /** fetch data from the table in a streaming manner: "payment_methods" */
  payment_methods_stream: Array<Payment_Methods>;
  /** fetch data from the table: "post_training_email_scheduled_events" */
  post_training_email_scheduled_events: Array<Post_Training_Email_Scheduled_Events>;
  /** fetch aggregated fields from the table: "post_training_email_scheduled_events" */
  post_training_email_scheduled_events_aggregate: Post_Training_Email_Scheduled_Events_Aggregate;
  /** fetch data from the table: "post_training_email_scheduled_events" using primary key columns */
  post_training_email_scheduled_events_by_pk?: Maybe<Post_Training_Email_Scheduled_Events>;
  /** fetch data from the table in a streaming manner: "post_training_email_scheduled_events" */
  post_training_email_scheduled_events_stream: Array<Post_Training_Email_Scheduled_Events>;
  /** fetch data from the table: "pre_training_email_scheduled_events" */
  pre_training_email_scheduled_events: Array<Pre_Training_Email_Scheduled_Events>;
  /** fetch aggregated fields from the table: "pre_training_email_scheduled_events" */
  pre_training_email_scheduled_events_aggregate: Pre_Training_Email_Scheduled_Events_Aggregate;
  /** fetch data from the table: "pre_training_email_scheduled_events" using primary key columns */
  pre_training_email_scheduled_events_by_pk?: Maybe<Pre_Training_Email_Scheduled_Events>;
  /** fetch data from the table in a streaming manner: "pre_training_email_scheduled_events" */
  pre_training_email_scheduled_events_stream: Array<Pre_Training_Email_Scheduled_Events>;
  /** fetch data from the table: "precision_order_status" */
  precision_order_status: Array<Precision_Order_Status>;
  /** fetch aggregated fields from the table: "precision_order_status" */
  precision_order_status_aggregate: Precision_Order_Status_Aggregate;
  /** fetch data from the table: "precision_order_status" using primary key columns */
  precision_order_status_by_pk?: Maybe<Precision_Order_Status>;
  /** fetch data from the table in a streaming manner: "precision_order_status" */
  precision_order_status_stream: Array<Precision_Order_Status>;
  /** fetch data from the table: "private_course_booking" */
  private_course_booking: Array<Private_Course_Booking>;
  /** fetch aggregated fields from the table: "private_course_booking" */
  private_course_booking_aggregate: Private_Course_Booking_Aggregate;
  /** fetch data from the table: "private_course_booking" using primary key columns */
  private_course_booking_by_pk?: Maybe<Private_Course_Booking>;
  /** fetch data from the table in a streaming manner: "private_course_booking" */
  private_course_booking_stream: Array<Private_Course_Booking>;
  /** fetch data from the table: "profile" */
  profile: Array<Profile>;
  /** fetch aggregated fields from the table: "profile" */
  profile_aggregate: Profile_Aggregate;
  /** fetch data from the table: "profile" using primary key columns */
  profile_by_pk?: Maybe<Profile>;
  /** fetch data from the table: "profile_role" */
  profile_role: Array<Profile_Role>;
  /** fetch aggregated fields from the table: "profile_role" */
  profile_role_aggregate: Profile_Role_Aggregate;
  /** fetch data from the table: "profile_role" using primary key columns */
  profile_role_by_pk?: Maybe<Profile_Role>;
  /** fetch data from the table in a streaming manner: "profile_role" */
  profile_role_stream: Array<Profile_Role>;
  /** fetch data from the table in a streaming manner: "profile" */
  profile_stream: Array<Profile>;
  /** fetch data from the table: "profile_temp" */
  profile_temp: Array<Profile_Temp>;
  /** fetch aggregated fields from the table: "profile_temp" */
  profile_temp_aggregate: Profile_Temp_Aggregate;
  /** fetch data from the table: "profile_temp" using primary key columns */
  profile_temp_by_pk?: Maybe<Profile_Temp>;
  /** fetch data from the table in a streaming manner: "profile_temp" */
  profile_temp_stream: Array<Profile_Temp>;
  /** fetch data from the table: "profile_trainer_agreement_type" */
  profile_trainer_agreement_type: Array<Profile_Trainer_Agreement_Type>;
  /** fetch aggregated fields from the table: "profile_trainer_agreement_type" */
  profile_trainer_agreement_type_aggregate: Profile_Trainer_Agreement_Type_Aggregate;
  /** fetch data from the table: "profile_trainer_agreement_type" using primary key columns */
  profile_trainer_agreement_type_by_pk?: Maybe<Profile_Trainer_Agreement_Type>;
  /** fetch data from the table in a streaming manner: "profile_trainer_agreement_type" */
  profile_trainer_agreement_type_stream: Array<Profile_Trainer_Agreement_Type>;
  /** fetch data from the table: "profile_trainer_role_type" */
  profile_trainer_role_type: Array<Profile_Trainer_Role_Type>;
  /** fetch aggregated fields from the table: "profile_trainer_role_type" */
  profile_trainer_role_type_aggregate: Profile_Trainer_Role_Type_Aggregate;
  /** fetch data from the table: "profile_trainer_role_type" using primary key columns */
  profile_trainer_role_type_by_pk?: Maybe<Profile_Trainer_Role_Type>;
  /** fetch data from the table in a streaming manner: "profile_trainer_role_type" */
  profile_trainer_role_type_stream: Array<Profile_Trainer_Role_Type>;
  /** fetch data from the table: "promo_code" */
  promo_code: Array<Promo_Code>;
  /** fetch aggregated fields from the table: "promo_code" */
  promo_code_aggregate: Promo_Code_Aggregate;
  /** fetch data from the table: "promo_code" using primary key columns */
  promo_code_by_pk?: Maybe<Promo_Code>;
  /** fetch data from the table in a streaming manner: "promo_code" */
  promo_code_stream: Array<Promo_Code>;
  /** fetch data from the table: "promo_code_type" */
  promo_code_type: Array<Promo_Code_Type>;
  /** fetch aggregated fields from the table: "promo_code_type" */
  promo_code_type_aggregate: Promo_Code_Type_Aggregate;
  /** fetch data from the table: "promo_code_type" using primary key columns */
  promo_code_type_by_pk?: Maybe<Promo_Code_Type>;
  /** fetch data from the table in a streaming manner: "promo_code_type" */
  promo_code_type_stream: Array<Promo_Code_Type>;
  /** fetch data from the table: "resource_pack_bundle_course_level" */
  resource_pack_bundle_course_level: Array<Resource_Pack_Bundle_Course_Level>;
  /** fetch aggregated fields from the table: "resource_pack_bundle_course_level" */
  resource_pack_bundle_course_level_aggregate: Resource_Pack_Bundle_Course_Level_Aggregate;
  /** fetch data from the table: "resource_pack_bundle_course_level" using primary key columns */
  resource_pack_bundle_course_level_by_pk?: Maybe<Resource_Pack_Bundle_Course_Level>;
  /** fetch data from the table in a streaming manner: "resource_pack_bundle_course_level" */
  resource_pack_bundle_course_level_stream: Array<Resource_Pack_Bundle_Course_Level>;
  /** fetch data from the table: "resource_pack_bundle_option" */
  resource_pack_bundle_option: Array<Resource_Pack_Bundle_Option>;
  /** fetch aggregated fields from the table: "resource_pack_bundle_option" */
  resource_pack_bundle_option_aggregate: Resource_Pack_Bundle_Option_Aggregate;
  /** fetch data from the table: "resource_pack_bundle_option" using primary key columns */
  resource_pack_bundle_option_by_pk?: Maybe<Resource_Pack_Bundle_Option>;
  /** fetch data from the table in a streaming manner: "resource_pack_bundle_option" */
  resource_pack_bundle_option_stream: Array<Resource_Pack_Bundle_Option>;
  /** fetch data from the table: "resource_pack_bundle_price" */
  resource_pack_bundle_price: Array<Resource_Pack_Bundle_Price>;
  /** fetch aggregated fields from the table: "resource_pack_bundle_price" */
  resource_pack_bundle_price_aggregate: Resource_Pack_Bundle_Price_Aggregate;
  /** fetch data from the table: "resource_pack_bundle_price" using primary key columns */
  resource_pack_bundle_price_by_pk?: Maybe<Resource_Pack_Bundle_Price>;
  /** fetch data from the table in a streaming manner: "resource_pack_bundle_price" */
  resource_pack_bundle_price_stream: Array<Resource_Pack_Bundle_Price>;
  /** fetch data from the table: "resource_packs_delivery_type" */
  resource_packs_delivery_type: Array<Resource_Packs_Delivery_Type>;
  /** fetch aggregated fields from the table: "resource_packs_delivery_type" */
  resource_packs_delivery_type_aggregate: Resource_Packs_Delivery_Type_Aggregate;
  /** fetch data from the table: "resource_packs_delivery_type" using primary key columns */
  resource_packs_delivery_type_by_pk?: Maybe<Resource_Packs_Delivery_Type>;
  /** fetch data from the table in a streaming manner: "resource_packs_delivery_type" */
  resource_packs_delivery_type_stream: Array<Resource_Packs_Delivery_Type>;
  /** fetch data from the table: "resource_packs_events" */
  resource_packs_events: Array<Resource_Packs_Events>;
  /** fetch aggregated fields from the table: "resource_packs_events" */
  resource_packs_events_aggregate: Resource_Packs_Events_Aggregate;
  /** fetch data from the table: "resource_packs_events" using primary key columns */
  resource_packs_events_by_pk?: Maybe<Resource_Packs_Events>;
  /** fetch data from the table in a streaming manner: "resource_packs_events" */
  resource_packs_events_stream: Array<Resource_Packs_Events>;
  /** fetch data from the table: "resource_packs_pricing" */
  resource_packs_pricing: Array<Resource_Packs_Pricing>;
  /** fetch aggregated fields from the table: "resource_packs_pricing" */
  resource_packs_pricing_aggregate: Resource_Packs_Pricing_Aggregate;
  /** fetch data from the table: "resource_packs_pricing" using primary key columns */
  resource_packs_pricing_by_pk?: Maybe<Resource_Packs_Pricing>;
  /** fetch data from the table in a streaming manner: "resource_packs_pricing" */
  resource_packs_pricing_stream: Array<Resource_Packs_Pricing>;
  /** fetch data from the table: "resource_packs_type" */
  resource_packs_type: Array<Resource_Packs_Type>;
  /** fetch aggregated fields from the table: "resource_packs_type" */
  resource_packs_type_aggregate: Resource_Packs_Type_Aggregate;
  /** fetch data from the table: "resource_packs_type" using primary key columns */
  resource_packs_type_by_pk?: Maybe<Resource_Packs_Type>;
  /** fetch data from the table in a streaming manner: "resource_packs_type" */
  resource_packs_type_stream: Array<Resource_Packs_Type>;
  /** fetch data from the table: "role" */
  role: Array<Role>;
  /** fetch aggregated fields from the table: "role" */
  role_aggregate: Role_Aggregate;
  /** fetch data from the table: "role" using primary key columns */
  role_by_pk?: Maybe<Role>;
  /** fetch data from the table in a streaming manner: "role" */
  role_stream: Array<Role>;
  /** fetch data from the table: "scheduled_events_view" */
  scheduled_events_view: Array<Scheduled_Events_View>;
  /** fetch aggregated fields from the table: "scheduled_events_view" */
  scheduled_events_view_aggregate: Scheduled_Events_View_Aggregate;
  /** fetch data from the table in a streaming manner: "scheduled_events_view" */
  scheduled_events_view_stream: Array<Scheduled_Events_View>;
  /** execute function "search_dfe_establishments" which returns "dfe_establishment" */
  search_dfe_establishments: Array<Dfe_Establishment>;
  /** execute function "search_dfe_establishments" and query aggregates on result of table type "dfe_establishment" */
  search_dfe_establishments_aggregate: Dfe_Establishment_Aggregate;
  /** execute function "search_organizations" which returns "organization" */
  search_organizations: Array<Organization>;
  /** execute function "search_organizations" and query aggregates on result of table type "organization" */
  search_organizations_aggregate: Organization_Aggregate;
  /** fetch data from the table: "splash_screens" */
  splash_screens: Array<Splash_Screens>;
  /** fetch aggregated fields from the table: "splash_screens" */
  splash_screens_aggregate: Splash_Screens_Aggregate;
  /** fetch data from the table: "splash_screens" using primary key columns */
  splash_screens_by_pk?: Maybe<Splash_Screens>;
  /** fetch data from the table in a streaming manner: "splash_screens" */
  splash_screens_stream: Array<Splash_Screens>;
  /** An array relationship */
  submission_of_splash_screens: Array<Submission_Of_Splash_Screens>;
  /** An aggregate relationship */
  submission_of_splash_screens_aggregate: Submission_Of_Splash_Screens_Aggregate;
  /** fetch data from the table: "submission_of_splash_screens" using primary key columns */
  submission_of_splash_screens_by_pk?: Maybe<Submission_Of_Splash_Screens>;
  /** fetch data from the table in a streaming manner: "submission_of_splash_screens" */
  submission_of_splash_screens_stream: Array<Submission_Of_Splash_Screens>;
  /** fetch data from the table: "submodule" */
  submodule: Array<Submodule>;
  /** fetch aggregated fields from the table: "submodule" */
  submodule_aggregate: Submodule_Aggregate;
  /** fetch data from the table: "submodule" using primary key columns */
  submodule_by_pk?: Maybe<Submodule>;
  /** fetch data from the table in a streaming manner: "submodule" */
  submodule_stream: Array<Submodule>;
  /** fetch data from the table: "trainer_agreement_type" */
  trainer_agreement_type: Array<Trainer_Agreement_Type>;
  /** fetch aggregated fields from the table: "trainer_agreement_type" */
  trainer_agreement_type_aggregate: Trainer_Agreement_Type_Aggregate;
  /** fetch data from the table: "trainer_agreement_type" using primary key columns */
  trainer_agreement_type_by_pk?: Maybe<Trainer_Agreement_Type>;
  /** fetch data from the table in a streaming manner: "trainer_agreement_type" */
  trainer_agreement_type_stream: Array<Trainer_Agreement_Type>;
  /** fetch data from the table: "trainer_role_type" */
  trainer_role_type: Array<Trainer_Role_Type>;
  /** fetch aggregated fields from the table: "trainer_role_type" */
  trainer_role_type_aggregate: Trainer_Role_Type_Aggregate;
  /** fetch data from the table: "trainer_role_type" using primary key columns */
  trainer_role_type_by_pk?: Maybe<Trainer_Role_Type>;
  /** fetch data from the table in a streaming manner: "trainer_role_type" */
  trainer_role_type_stream: Array<Trainer_Role_Type>;
  /** fetch data from the table: "trust_type" */
  trust_type: Array<Trust_Type>;
  /** fetch aggregated fields from the table: "trust_type" */
  trust_type_aggregate: Trust_Type_Aggregate;
  /** fetch data from the table: "trust_type" using primary key columns */
  trust_type_by_pk?: Maybe<Trust_Type>;
  /** fetch data from the table in a streaming manner: "trust_type" */
  trust_type_stream: Array<Trust_Type>;
  /** fetch data from the table: "tt_client_invite_log" */
  tt_client_invite_log: Array<Tt_Client_Invite_Log>;
  /** fetch aggregated fields from the table: "tt_client_invite_log" */
  tt_client_invite_log_aggregate: Tt_Client_Invite_Log_Aggregate;
  /** fetch data from the table: "tt_client_invite_log" using primary key columns */
  tt_client_invite_log_by_pk?: Maybe<Tt_Client_Invite_Log>;
  /** fetch data from the table in a streaming manner: "tt_client_invite_log" */
  tt_client_invite_log_stream: Array<Tt_Client_Invite_Log>;
  /** fetch data from the table: "upcoming_enrollments" */
  upcoming_enrollments: Array<Upcoming_Enrollments>;
  /** fetch aggregated fields from the table: "upcoming_enrollments" */
  upcoming_enrollments_aggregate: Upcoming_Enrollments_Aggregate;
  /** fetch data from the table in a streaming manner: "upcoming_enrollments" */
  upcoming_enrollments_stream: Array<Upcoming_Enrollments>;
  /** fetch data from the table: "user_auth_audit_type" */
  user_auth_audit_type: Array<User_Auth_Audit_Type>;
  /** fetch aggregated fields from the table: "user_auth_audit_type" */
  user_auth_audit_type_aggregate: User_Auth_Audit_Type_Aggregate;
  /** fetch data from the table: "user_auth_audit_type" using primary key columns */
  user_auth_audit_type_by_pk?: Maybe<User_Auth_Audit_Type>;
  /** fetch data from the table in a streaming manner: "user_auth_audit_type" */
  user_auth_audit_type_stream: Array<User_Auth_Audit_Type>;
  /** fetch data from the table: "user_auth_audits" */
  user_auth_audits: Array<User_Auth_Audits>;
  /** fetch aggregated fields from the table: "user_auth_audits" */
  user_auth_audits_aggregate: User_Auth_Audits_Aggregate;
  /** fetch data from the table: "user_auth_audits" using primary key columns */
  user_auth_audits_by_pk?: Maybe<User_Auth_Audits>;
  /** fetch data from the table in a streaming manner: "user_auth_audits" */
  user_auth_audits_stream: Array<User_Auth_Audits>;
  /** fetch data from the table: "venue" */
  venue: Array<Venue>;
  /** fetch aggregated fields from the table: "venue" */
  venue_aggregate: Venue_Aggregate;
  /** fetch data from the table: "venue" using primary key columns */
  venue_by_pk?: Maybe<Venue>;
  /** fetch data from the table: "venue_check_jobs" */
  venue_check_jobs: Array<Venue_Check_Jobs>;
  /** fetch aggregated fields from the table: "venue_check_jobs" */
  venue_check_jobs_aggregate: Venue_Check_Jobs_Aggregate;
  /** fetch data from the table: "venue_check_jobs" using primary key columns */
  venue_check_jobs_by_pk?: Maybe<Venue_Check_Jobs>;
  /** fetch data from the table in a streaming manner: "venue_check_jobs" */
  venue_check_jobs_stream: Array<Venue_Check_Jobs>;
  /** fetch data from the table in a streaming manner: "venue" */
  venue_stream: Array<Venue>;
  /** fetch data from the table: "waitlist" */
  waitlist: Array<Waitlist>;
  /** fetch aggregated fields from the table: "waitlist" */
  waitlist_aggregate: Waitlist_Aggregate;
  /** fetch data from the table: "waitlist" using primary key columns */
  waitlist_by_pk?: Maybe<Waitlist>;
  /** fetch data from the table in a streaming manner: "waitlist" */
  waitlist_stream: Array<Waitlist>;
  /** fetch data from the table: "xero_contact" */
  xero_contact: Array<Xero_Contact>;
  /** fetch aggregated fields from the table: "xero_contact" */
  xero_contact_aggregate: Xero_Contact_Aggregate;
  /** fetch data from the table: "xero_contact" using primary key columns */
  xero_contact_by_pk?: Maybe<Xero_Contact>;
  /** fetch data from the table in a streaming manner: "xero_contact" */
  xero_contact_stream: Array<Xero_Contact>;
  /** fetch data from the table: "xero_credential" */
  xero_credential: Array<Xero_Credential>;
  /** fetch aggregated fields from the table: "xero_credential" */
  xero_credential_aggregate: Xero_Credential_Aggregate;
  /** fetch data from the table: "xero_credential" using primary key columns */
  xero_credential_by_pk?: Maybe<Xero_Credential>;
  /** fetch data from the table in a streaming manner: "xero_credential" */
  xero_credential_stream: Array<Xero_Credential>;
  /** fetch data from the table: "xero_invoice" */
  xero_invoice: Array<Xero_Invoice>;
  /** fetch aggregated fields from the table: "xero_invoice" */
  xero_invoice_aggregate: Xero_Invoice_Aggregate;
  /** fetch data from the table: "xero_invoice" using primary key columns */
  xero_invoice_by_pk?: Maybe<Xero_Invoice>;
  /** fetch data from the table: "xero_invoice_status" */
  xero_invoice_status: Array<Xero_Invoice_Status>;
  /** fetch aggregated fields from the table: "xero_invoice_status" */
  xero_invoice_status_aggregate: Xero_Invoice_Status_Aggregate;
  /** fetch data from the table: "xero_invoice_status" using primary key columns */
  xero_invoice_status_by_pk?: Maybe<Xero_Invoice_Status>;
  /** fetch data from the table in a streaming manner: "xero_invoice_status" */
  xero_invoice_status_stream: Array<Xero_Invoice_Status>;
  /** fetch data from the table in a streaming manner: "xero_invoice" */
  xero_invoice_stream: Array<Xero_Invoice>;
};


export type Subscription_RootAbout_Training_Email_Scheduled_EventsArgs = {
  distinct_on?: InputMaybe<Array<About_Training_Email_Scheduled_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<About_Training_Email_Scheduled_Events_Order_By>>;
  where?: InputMaybe<About_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Subscription_RootAbout_Training_Email_Scheduled_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<About_Training_Email_Scheduled_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<About_Training_Email_Scheduled_Events_Order_By>>;
  where?: InputMaybe<About_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Subscription_RootAbout_Training_Email_Scheduled_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAbout_Training_Email_Scheduled_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<About_Training_Email_Scheduled_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<About_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Subscription_RootAbsorb_EnrolmentArgs = {
  distinct_on?: InputMaybe<Array<Absorb_Enrolment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Absorb_Enrolment_Order_By>>;
  where?: InputMaybe<Absorb_Enrolment_Bool_Exp>;
};


export type Subscription_RootAbsorb_Enrolment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Absorb_Enrolment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Absorb_Enrolment_Order_By>>;
  where?: InputMaybe<Absorb_Enrolment_Bool_Exp>;
};


export type Subscription_RootAbsorb_Enrolment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAbsorb_Enrolment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Absorb_Enrolment_Stream_Cursor_Input>>;
  where?: InputMaybe<Absorb_Enrolment_Bool_Exp>;
};


export type Subscription_RootAccreditorsArgs = {
  distinct_on?: InputMaybe<Array<Accreditors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditors_Order_By>>;
  where?: InputMaybe<Accreditors_Bool_Exp>;
};


export type Subscription_RootAccreditors_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Accreditors_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Accreditors_Order_By>>;
  where?: InputMaybe<Accreditors_Bool_Exp>;
};


export type Subscription_RootAccreditors_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootAccreditors_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Accreditors_Stream_Cursor_Input>>;
  where?: InputMaybe<Accreditors_Bool_Exp>;
};


export type Subscription_RootAvailabilityArgs = {
  distinct_on?: InputMaybe<Array<Availability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Availability_Order_By>>;
  where?: InputMaybe<Availability_Bool_Exp>;
};


export type Subscription_RootAvailability_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Availability_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Availability_Order_By>>;
  where?: InputMaybe<Availability_Bool_Exp>;
};


export type Subscription_RootAvailability_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootAvailability_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Availability_Stream_Cursor_Input>>;
  where?: InputMaybe<Availability_Bool_Exp>;
};


export type Subscription_RootBild_StrategyArgs = {
  distinct_on?: InputMaybe<Array<Bild_Strategy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bild_Strategy_Order_By>>;
  where?: InputMaybe<Bild_Strategy_Bool_Exp>;
};


export type Subscription_RootBild_Strategy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Bild_Strategy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Bild_Strategy_Order_By>>;
  where?: InputMaybe<Bild_Strategy_Bool_Exp>;
};


export type Subscription_RootBild_Strategy_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootBild_Strategy_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Bild_Strategy_Stream_Cursor_Input>>;
  where?: InputMaybe<Bild_Strategy_Bool_Exp>;
};


export type Subscription_RootBlended_Learning_StatusArgs = {
  distinct_on?: InputMaybe<Array<Blended_Learning_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Blended_Learning_Status_Order_By>>;
  where?: InputMaybe<Blended_Learning_Status_Bool_Exp>;
};


export type Subscription_RootBlended_Learning_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Blended_Learning_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Blended_Learning_Status_Order_By>>;
  where?: InputMaybe<Blended_Learning_Status_Bool_Exp>;
};


export type Subscription_RootBlended_Learning_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootBlended_Learning_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Blended_Learning_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Blended_Learning_Status_Bool_Exp>;
};


export type Subscription_RootCertificate_Expired_Notification_JobsArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Expired_Notification_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Expired_Notification_Jobs_Order_By>>;
  where?: InputMaybe<Certificate_Expired_Notification_Jobs_Bool_Exp>;
};


export type Subscription_RootCertificate_Expired_Notification_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Expired_Notification_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Expired_Notification_Jobs_Order_By>>;
  where?: InputMaybe<Certificate_Expired_Notification_Jobs_Bool_Exp>;
};


export type Subscription_RootCertificate_Expired_Notification_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCertificate_Expired_Notification_Jobs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Certificate_Expired_Notification_Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Certificate_Expired_Notification_Jobs_Bool_Exp>;
};


export type Subscription_RootCertificate_Expiry_Notification_JobsArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Expiry_Notification_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Expiry_Notification_Jobs_Order_By>>;
  where?: InputMaybe<Certificate_Expiry_Notification_Jobs_Bool_Exp>;
};


export type Subscription_RootCertificate_Expiry_Notification_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Expiry_Notification_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Expiry_Notification_Jobs_Order_By>>;
  where?: InputMaybe<Certificate_Expiry_Notification_Jobs_Bool_Exp>;
};


export type Subscription_RootCertificate_Expiry_Notification_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCertificate_Expiry_Notification_Jobs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Certificate_Expiry_Notification_Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Certificate_Expiry_Notification_Jobs_Bool_Exp>;
};


export type Subscription_RootCertificate_Expiry_Notification_TimeframeArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Order_By>>;
  where?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Bool_Exp>;
};


export type Subscription_RootCertificate_Expiry_Notification_Timeframe_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Expiry_Notification_Timeframe_Order_By>>;
  where?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Bool_Exp>;
};


export type Subscription_RootCertificate_Expiry_Notification_Timeframe_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCertificate_Expiry_Notification_Timeframe_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Certificate_Expiry_Notification_Timeframe_Stream_Cursor_Input>>;
  where?: InputMaybe<Certificate_Expiry_Notification_Timeframe_Bool_Exp>;
};


export type Subscription_RootCertificate_StatusArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Status_Order_By>>;
  where?: InputMaybe<Certificate_Status_Bool_Exp>;
};


export type Subscription_RootCertificate_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Certificate_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Certificate_Status_Order_By>>;
  where?: InputMaybe<Certificate_Status_Bool_Exp>;
};


export type Subscription_RootCertificate_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCertificate_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Certificate_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Certificate_Status_Bool_Exp>;
};


export type Subscription_RootColorArgs = {
  distinct_on?: InputMaybe<Array<Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Color_Order_By>>;
  where?: InputMaybe<Color_Bool_Exp>;
};


export type Subscription_RootColor_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Color_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Color_Order_By>>;
  where?: InputMaybe<Color_Bool_Exp>;
};


export type Subscription_RootColor_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootColor_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Color_Stream_Cursor_Input>>;
  where?: InputMaybe<Color_Bool_Exp>;
};


export type Subscription_RootCountryArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Country_Order_By>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCountry_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCountry_RegionArgs = {
  distinct_on?: InputMaybe<Array<Country_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Country_Region_Order_By>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


export type Subscription_RootCountry_Region_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Country_Region_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Country_Region_Order_By>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


export type Subscription_RootCountry_Region_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCountry_Region_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Country_Region_Stream_Cursor_Input>>;
  where?: InputMaybe<Country_Region_Bool_Exp>;
};


export type Subscription_RootCountry_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Country_Stream_Cursor_Input>>;
  where?: InputMaybe<Country_Bool_Exp>;
};


export type Subscription_RootCourseArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


export type Subscription_RootCourse_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_By>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


export type Subscription_RootCourse_AuditArgs = {
  distinct_on?: InputMaybe<Array<Course_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Audit_Order_By>>;
  where?: InputMaybe<Course_Audit_Bool_Exp>;
};


export type Subscription_RootCourse_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Audit_Order_By>>;
  where?: InputMaybe<Course_Audit_Bool_Exp>;
};


export type Subscription_RootCourse_Audit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Audit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Audit_Bool_Exp>;
};


export type Subscription_RootCourse_Audit_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Audit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Audit_Type_Order_By>>;
  where?: InputMaybe<Course_Audit_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Audit_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Audit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Audit_Type_Order_By>>;
  where?: InputMaybe<Course_Audit_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Audit_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Audit_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Audit_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Audit_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Bild_ModuleArgs = {
  distinct_on?: InputMaybe<Array<Course_Bild_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Bild_Module_Order_By>>;
  where?: InputMaybe<Course_Bild_Module_Bool_Exp>;
};


export type Subscription_RootCourse_Bild_Module_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Bild_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Bild_Module_Order_By>>;
  where?: InputMaybe<Course_Bild_Module_Bool_Exp>;
};


export type Subscription_RootCourse_Bild_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Bild_Module_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Bild_Module_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Bild_Module_Bool_Exp>;
};


export type Subscription_RootCourse_Bild_StrategyArgs = {
  distinct_on?: InputMaybe<Array<Course_Bild_Strategy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Bild_Strategy_Order_By>>;
  where?: InputMaybe<Course_Bild_Strategy_Bool_Exp>;
};


export type Subscription_RootCourse_Bild_Strategy_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Bild_Strategy_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Bild_Strategy_Order_By>>;
  where?: InputMaybe<Course_Bild_Strategy_Bool_Exp>;
};


export type Subscription_RootCourse_Bild_Strategy_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Bild_Strategy_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Bild_Strategy_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Bild_Strategy_Bool_Exp>;
};


export type Subscription_RootCourse_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootCourse_Cancellation_Fee_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Cancellation_Fee_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Cancellation_Fee_Type_Order_By>>;
  where?: InputMaybe<Course_Cancellation_Fee_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Cancellation_Fee_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Cancellation_Fee_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Cancellation_Fee_Type_Order_By>>;
  where?: InputMaybe<Course_Cancellation_Fee_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Cancellation_Fee_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Cancellation_Fee_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Cancellation_Fee_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Cancellation_Fee_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Cancellation_RequestArgs = {
  distinct_on?: InputMaybe<Array<Course_Cancellation_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Cancellation_Request_Order_By>>;
  where?: InputMaybe<Course_Cancellation_Request_Bool_Exp>;
};


export type Subscription_RootCourse_Cancellation_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Cancellation_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Cancellation_Request_Order_By>>;
  where?: InputMaybe<Course_Cancellation_Request_Bool_Exp>;
};


export type Subscription_RootCourse_Cancellation_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Cancellation_Request_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Cancellation_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Cancellation_Request_Bool_Exp>;
};


export type Subscription_RootCourse_CertificateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Order_By>>;
  where?: InputMaybe<Course_Certificate_Bool_Exp>;
};


export type Subscription_RootCourse_Certificate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Order_By>>;
  where?: InputMaybe<Course_Certificate_Bool_Exp>;
};


export type Subscription_RootCourse_Certificate_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Certificate_ChangelogArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Changelog_Order_By>>;
  where?: InputMaybe<Course_Certificate_Changelog_Bool_Exp>;
};


export type Subscription_RootCourse_Certificate_Changelog_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Changelog_Order_By>>;
  where?: InputMaybe<Course_Certificate_Changelog_Bool_Exp>;
};


export type Subscription_RootCourse_Certificate_Changelog_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Certificate_Changelog_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Certificate_Changelog_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Certificate_Changelog_Bool_Exp>;
};


export type Subscription_RootCourse_Certificate_Changelog_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Changelog_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Changelog_Type_Order_By>>;
  where?: InputMaybe<Course_Certificate_Changelog_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Certificate_Changelog_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Changelog_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Changelog_Type_Order_By>>;
  where?: InputMaybe<Course_Certificate_Changelog_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Certificate_Changelog_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Certificate_Changelog_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Certificate_Changelog_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Certificate_Changelog_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Certificate_Hold_RequestArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Hold_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Hold_Request_Order_By>>;
  where?: InputMaybe<Course_Certificate_Hold_Request_Bool_Exp>;
};


export type Subscription_RootCourse_Certificate_Hold_Request_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Certificate_Hold_Request_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Certificate_Hold_Request_Order_By>>;
  where?: InputMaybe<Course_Certificate_Hold_Request_Bool_Exp>;
};


export type Subscription_RootCourse_Certificate_Hold_Request_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Certificate_Hold_Request_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Certificate_Hold_Request_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Certificate_Hold_Request_Bool_Exp>;
};


export type Subscription_RootCourse_Certificate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Certificate_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Certificate_Bool_Exp>;
};


export type Subscription_RootCourse_Delivery_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Delivery_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Delivery_Type_Order_By>>;
  where?: InputMaybe<Course_Delivery_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Delivery_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Delivery_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Delivery_Type_Order_By>>;
  where?: InputMaybe<Course_Delivery_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Delivery_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Delivery_Type_PrefixArgs = {
  distinct_on?: InputMaybe<Array<Course_Delivery_Type_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Delivery_Type_Prefix_Order_By>>;
  where?: InputMaybe<Course_Delivery_Type_Prefix_Bool_Exp>;
};


export type Subscription_RootCourse_Delivery_Type_Prefix_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Delivery_Type_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Delivery_Type_Prefix_Order_By>>;
  where?: InputMaybe<Course_Delivery_Type_Prefix_Bool_Exp>;
};


export type Subscription_RootCourse_Delivery_Type_Prefix_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Delivery_Type_Prefix_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Delivery_Type_Prefix_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Delivery_Type_Prefix_Bool_Exp>;
};


export type Subscription_RootCourse_Delivery_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Delivery_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Delivery_Type_Bool_Exp>;
};


export type Subscription_RootCourse_DraftArgs = {
  distinct_on?: InputMaybe<Array<Course_Draft_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Draft_Order_By>>;
  where?: InputMaybe<Course_Draft_Bool_Exp>;
};


export type Subscription_RootCourse_Draft_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Draft_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Draft_Order_By>>;
  where?: InputMaybe<Course_Draft_Bool_Exp>;
};


export type Subscription_RootCourse_Draft_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Draft_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Draft_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Draft_Bool_Exp>;
};


export type Subscription_RootCourse_End_JobsArgs = {
  distinct_on?: InputMaybe<Array<Course_End_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_End_Jobs_Order_By>>;
  where?: InputMaybe<Course_End_Jobs_Bool_Exp>;
};


export type Subscription_RootCourse_End_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_End_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_End_Jobs_Order_By>>;
  where?: InputMaybe<Course_End_Jobs_Bool_Exp>;
};


export type Subscription_RootCourse_End_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_End_Jobs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_End_Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_End_Jobs_Bool_Exp>;
};


export type Subscription_RootCourse_EnquiryArgs = {
  distinct_on?: InputMaybe<Array<Course_Enquiry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Enquiry_Order_By>>;
  where?: InputMaybe<Course_Enquiry_Bool_Exp>;
};


export type Subscription_RootCourse_Enquiry_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Enquiry_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Enquiry_Order_By>>;
  where?: InputMaybe<Course_Enquiry_Bool_Exp>;
};


export type Subscription_RootCourse_Enquiry_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Enquiry_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Enquiry_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Enquiry_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_AnswersArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Answers_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Answers_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Answers_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Answers_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Answers_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Evaluation_Answers_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Evaluation_Answers_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Evaluation_Answers_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Question_GroupArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Question_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Question_Group_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Question_Group_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Question_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Question_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Question_Group_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Question_Group_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Question_Group_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Evaluation_Question_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Evaluation_Question_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Evaluation_Question_Group_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Question_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Question_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Question_Type_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Question_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Question_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Question_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Question_Type_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Question_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Question_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Evaluation_Question_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Evaluation_Question_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Evaluation_Question_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_QuestionsArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Questions_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Questions_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Questions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Questions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Questions_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Questions_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Questions_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Evaluation_Questions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Evaluation_Questions_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Evaluation_Questions_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Scheduled_EventArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Scheduled_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Scheduled_Event_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Scheduled_Event_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Scheduled_Event_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Evaluation_Scheduled_Event_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Evaluation_Scheduled_Event_Order_By>>;
  where?: InputMaybe<Course_Evaluation_Scheduled_Event_Bool_Exp>;
};


export type Subscription_RootCourse_Evaluation_Scheduled_Event_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Evaluation_Scheduled_Event_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Evaluation_Scheduled_Event_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Evaluation_Scheduled_Event_Bool_Exp>;
};


export type Subscription_RootCourse_ExceptionArgs = {
  distinct_on?: InputMaybe<Array<Course_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Exception_Order_By>>;
  where?: InputMaybe<Course_Exception_Bool_Exp>;
};


export type Subscription_RootCourse_Exception_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Exception_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Exception_Order_By>>;
  where?: InputMaybe<Course_Exception_Bool_Exp>;
};


export type Subscription_RootCourse_Exception_By_PkArgs = {
  exception: Scalars['String'];
};


export type Subscription_RootCourse_Exception_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Exception_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Exception_Bool_Exp>;
};


export type Subscription_RootCourse_ExceptionsArgs = {
  distinct_on?: InputMaybe<Array<Course_Exceptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Exceptions_Order_By>>;
  where?: InputMaybe<Course_Exceptions_Bool_Exp>;
};


export type Subscription_RootCourse_Exceptions_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Exceptions_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Exceptions_Order_By>>;
  where?: InputMaybe<Course_Exceptions_Bool_Exp>;
};


export type Subscription_RootCourse_Exceptions_By_PkArgs = {
  courseId: Scalars['Int'];
  exception: Course_Exception_Enum;
};


export type Subscription_RootCourse_Exceptions_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Exceptions_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Exceptions_Bool_Exp>;
};


export type Subscription_RootCourse_ExpensesArgs = {
  distinct_on?: InputMaybe<Array<Course_Expenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Expenses_Order_By>>;
  where?: InputMaybe<Course_Expenses_Bool_Exp>;
};


export type Subscription_RootCourse_Expenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Expenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Expenses_Order_By>>;
  where?: InputMaybe<Course_Expenses_Bool_Exp>;
};


export type Subscription_RootCourse_Expenses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Expenses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Expenses_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Expenses_Bool_Exp>;
};


export type Subscription_RootCourse_Invite_StatusArgs = {
  distinct_on?: InputMaybe<Array<Course_Invite_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Invite_Status_Order_By>>;
  where?: InputMaybe<Course_Invite_Status_Bool_Exp>;
};


export type Subscription_RootCourse_Invite_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Invite_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Invite_Status_Order_By>>;
  where?: InputMaybe<Course_Invite_Status_Bool_Exp>;
};


export type Subscription_RootCourse_Invite_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Invite_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Invite_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Invite_Status_Bool_Exp>;
};


export type Subscription_RootCourse_InvitesArgs = {
  distinct_on?: InputMaybe<Array<Course_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Invites_Order_By>>;
  where?: InputMaybe<Course_Invites_Bool_Exp>;
};


export type Subscription_RootCourse_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Invites_Order_By>>;
  where?: InputMaybe<Course_Invites_Bool_Exp>;
};


export type Subscription_RootCourse_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Invites_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Invites_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Invites_Bool_Exp>;
};


export type Subscription_RootCourse_LevelArgs = {
  distinct_on?: InputMaybe<Array<Course_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Level_Order_By>>;
  where?: InputMaybe<Course_Level_Bool_Exp>;
};


export type Subscription_RootCourse_Level_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Level_Order_By>>;
  where?: InputMaybe<Course_Level_Bool_Exp>;
};


export type Subscription_RootCourse_Level_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Level_PrefixArgs = {
  distinct_on?: InputMaybe<Array<Course_Level_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Level_Prefix_Order_By>>;
  where?: InputMaybe<Course_Level_Prefix_Bool_Exp>;
};


export type Subscription_RootCourse_Level_Prefix_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Level_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Level_Prefix_Order_By>>;
  where?: InputMaybe<Course_Level_Prefix_Bool_Exp>;
};


export type Subscription_RootCourse_Level_Prefix_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Level_Prefix_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Level_Prefix_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Level_Prefix_Bool_Exp>;
};


export type Subscription_RootCourse_Level_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Level_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Level_Bool_Exp>;
};


export type Subscription_RootCourse_ModuleArgs = {
  distinct_on?: InputMaybe<Array<Course_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Module_Order_By>>;
  where?: InputMaybe<Course_Module_Bool_Exp>;
};


export type Subscription_RootCourse_Module_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Module_Order_By>>;
  where?: InputMaybe<Course_Module_Bool_Exp>;
};


export type Subscription_RootCourse_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Module_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Module_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Module_Bool_Exp>;
};


export type Subscription_RootCourse_OrderArgs = {
  distinct_on?: InputMaybe<Array<Course_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_Order_By>>;
  where?: InputMaybe<Course_Order_Bool_Exp>;
};


export type Subscription_RootCourse_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Order_Order_By>>;
  where?: InputMaybe<Course_Order_Bool_Exp>;
};


export type Subscription_RootCourse_Order_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Order_Bool_Exp>;
};


export type Subscription_RootCourse_ParticipantArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Order_By>>;
  where?: InputMaybe<Course_Participant_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Order_By>>;
  where?: InputMaybe<Course_Participant_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_AuditArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Audit_Order_By>>;
  where?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Audit_Order_By>>;
  where?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Audit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Participant_Audit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Participant_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Participant_Audit_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Audit_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Audit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Audit_Type_Order_By>>;
  where?: InputMaybe<Course_Participant_Audit_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Audit_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Audit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Audit_Type_Order_By>>;
  where?: InputMaybe<Course_Participant_Audit_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Audit_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Participant_Audit_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Participant_Audit_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Participant_Audit_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Bild_ModuleArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Bild_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Bild_Module_Order_By>>;
  where?: InputMaybe<Course_Participant_Bild_Module_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Bild_Module_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Bild_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Bild_Module_Order_By>>;
  where?: InputMaybe<Course_Participant_Bild_Module_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Bild_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Participant_Bild_Module_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Participant_Bild_Module_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Participant_Bild_Module_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Participant_CancellationArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Cancellation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Cancellation_Order_By>>;
  where?: InputMaybe<Course_Participant_Cancellation_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Cancellation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Cancellation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Cancellation_Order_By>>;
  where?: InputMaybe<Course_Participant_Cancellation_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Cancellation_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Participant_Cancellation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Participant_Cancellation_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Participant_Cancellation_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_ModuleArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Module_Order_By>>;
  where?: InputMaybe<Course_Participant_Module_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Module_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Module_Order_By>>;
  where?: InputMaybe<Course_Participant_Module_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Module_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Participant_Module_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Participant_Module_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Participant_Module_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_NoteArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Note_Order_By>>;
  where?: InputMaybe<Course_Participant_Note_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Note_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Participant_Note_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Participant_Note_Order_By>>;
  where?: InputMaybe<Course_Participant_Note_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_Note_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Participant_Note_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Participant_Note_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Participant_Note_Bool_Exp>;
};


export type Subscription_RootCourse_Participant_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Participant_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Participant_Bool_Exp>;
};


export type Subscription_RootCourse_PricingArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Order_By>>;
  where?: InputMaybe<Course_Pricing_Bool_Exp>;
};


export type Subscription_RootCourse_Pricing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Order_By>>;
  where?: InputMaybe<Course_Pricing_Bool_Exp>;
};


export type Subscription_RootCourse_Pricing_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Pricing_ChangelogArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Changelog_Order_By>>;
  where?: InputMaybe<Course_Pricing_Changelog_Bool_Exp>;
};


export type Subscription_RootCourse_Pricing_Changelog_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Changelog_Order_By>>;
  where?: InputMaybe<Course_Pricing_Changelog_Bool_Exp>;
};


export type Subscription_RootCourse_Pricing_Changelog_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Pricing_Changelog_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Pricing_Changelog_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Pricing_Changelog_Bool_Exp>;
};


export type Subscription_RootCourse_Pricing_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Schedule_Order_By>>;
  where?: InputMaybe<Course_Pricing_Schedule_Bool_Exp>;
};


export type Subscription_RootCourse_Pricing_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Pricing_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Pricing_Schedule_Order_By>>;
  where?: InputMaybe<Course_Pricing_Schedule_Bool_Exp>;
};


export type Subscription_RootCourse_Pricing_Schedule_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Pricing_Schedule_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Pricing_Schedule_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Pricing_Schedule_Bool_Exp>;
};


export type Subscription_RootCourse_Pricing_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Pricing_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Pricing_Bool_Exp>;
};


export type Subscription_RootCourse_Promo_CodeArgs = {
  distinct_on?: InputMaybe<Array<Course_Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Promo_Code_Order_By>>;
  where?: InputMaybe<Course_Promo_Code_Bool_Exp>;
};


export type Subscription_RootCourse_Promo_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Promo_Code_Order_By>>;
  where?: InputMaybe<Course_Promo_Code_Bool_Exp>;
};


export type Subscription_RootCourse_Promo_Code_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Promo_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Promo_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Promo_Code_Bool_Exp>;
};


export type Subscription_RootCourse_Renewal_CycleArgs = {
  distinct_on?: InputMaybe<Array<Course_Renewal_Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Renewal_Cycle_Order_By>>;
  where?: InputMaybe<Course_Renewal_Cycle_Bool_Exp>;
};


export type Subscription_RootCourse_Renewal_Cycle_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Renewal_Cycle_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Renewal_Cycle_Order_By>>;
  where?: InputMaybe<Course_Renewal_Cycle_Bool_Exp>;
};


export type Subscription_RootCourse_Renewal_Cycle_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootCourse_Renewal_Cycle_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Renewal_Cycle_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Renewal_Cycle_Bool_Exp>;
};


export type Subscription_RootCourse_ScheduleArgs = {
  distinct_on?: InputMaybe<Array<Course_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Schedule_Order_By>>;
  where?: InputMaybe<Course_Schedule_Bool_Exp>;
};


export type Subscription_RootCourse_Schedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Schedule_Order_By>>;
  where?: InputMaybe<Course_Schedule_Bool_Exp>;
};


export type Subscription_RootCourse_Schedule_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Schedule_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Schedule_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Schedule_Bool_Exp>;
};


export type Subscription_RootCourse_SourceArgs = {
  distinct_on?: InputMaybe<Array<Course_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Source_Order_By>>;
  where?: InputMaybe<Course_Source_Bool_Exp>;
};


export type Subscription_RootCourse_Source_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Source_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Source_Order_By>>;
  where?: InputMaybe<Course_Source_Bool_Exp>;
};


export type Subscription_RootCourse_Source_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Source_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Source_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Source_Bool_Exp>;
};


export type Subscription_RootCourse_StatusArgs = {
  distinct_on?: InputMaybe<Array<Course_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Status_Order_By>>;
  where?: InputMaybe<Course_Status_Bool_Exp>;
};


export type Subscription_RootCourse_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Status_Order_By>>;
  where?: InputMaybe<Course_Status_Bool_Exp>;
};


export type Subscription_RootCourse_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Status_Bool_Exp>;
};


export type Subscription_RootCourse_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Bool_Exp>;
};


export type Subscription_RootCourse_TrainerArgs = {
  distinct_on?: InputMaybe<Array<Course_Trainer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Trainer_Order_By>>;
  where?: InputMaybe<Course_Trainer_Bool_Exp>;
};


export type Subscription_RootCourse_Trainer_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Trainer_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Trainer_Order_By>>;
  where?: InputMaybe<Course_Trainer_Bool_Exp>;
};


export type Subscription_RootCourse_Trainer_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Trainer_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Trainer_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Trainer_Bool_Exp>;
};


export type Subscription_RootCourse_Trainer_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Trainer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Trainer_Type_Order_By>>;
  where?: InputMaybe<Course_Trainer_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Trainer_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Trainer_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Trainer_Type_Order_By>>;
  where?: InputMaybe<Course_Trainer_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Trainer_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Trainer_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Trainer_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Trainer_Type_Bool_Exp>;
};


export type Subscription_RootCourse_TypeArgs = {
  distinct_on?: InputMaybe<Array<Course_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Type_Order_By>>;
  where?: InputMaybe<Course_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Type_Order_By>>;
  where?: InputMaybe<Course_Type_Bool_Exp>;
};


export type Subscription_RootCourse_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCourse_Type_PrefixArgs = {
  distinct_on?: InputMaybe<Array<Course_Type_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Type_Prefix_Order_By>>;
  where?: InputMaybe<Course_Type_Prefix_Bool_Exp>;
};


export type Subscription_RootCourse_Type_Prefix_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Type_Prefix_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Type_Prefix_Order_By>>;
  where?: InputMaybe<Course_Type_Prefix_Bool_Exp>;
};


export type Subscription_RootCourse_Type_Prefix_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCourse_Type_Prefix_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Type_Prefix_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Type_Prefix_Bool_Exp>;
};


export type Subscription_RootCourse_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Course_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Course_Type_Bool_Exp>;
};


export type Subscription_RootCqc_EstablishmentArgs = {
  distinct_on?: InputMaybe<Array<Cqc_Establishment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cqc_Establishment_Order_By>>;
  where?: InputMaybe<Cqc_Establishment_Bool_Exp>;
};


export type Subscription_RootCqc_Establishment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cqc_Establishment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cqc_Establishment_Order_By>>;
  where?: InputMaybe<Cqc_Establishment_Bool_Exp>;
};


export type Subscription_RootCqc_Establishment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootCqc_Establishment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cqc_Establishment_Stream_Cursor_Input>>;
  where?: InputMaybe<Cqc_Establishment_Bool_Exp>;
};


export type Subscription_RootCud_OperationArgs = {
  distinct_on?: InputMaybe<Array<Cud_Operation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cud_Operation_Order_By>>;
  where?: InputMaybe<Cud_Operation_Bool_Exp>;
};


export type Subscription_RootCud_Operation_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Cud_Operation_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Cud_Operation_Order_By>>;
  where?: InputMaybe<Cud_Operation_Bool_Exp>;
};


export type Subscription_RootCud_Operation_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootCud_Operation_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Cud_Operation_Stream_Cursor_Input>>;
  where?: InputMaybe<Cud_Operation_Bool_Exp>;
};


export type Subscription_RootDeleted_Organizations_BackupArgs = {
  distinct_on?: InputMaybe<Array<Deleted_Organizations_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deleted_Organizations_Backup_Order_By>>;
  where?: InputMaybe<Deleted_Organizations_Backup_Bool_Exp>;
};


export type Subscription_RootDeleted_Organizations_Backup_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Deleted_Organizations_Backup_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Deleted_Organizations_Backup_Order_By>>;
  where?: InputMaybe<Deleted_Organizations_Backup_Bool_Exp>;
};


export type Subscription_RootDeleted_Organizations_Backup_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Deleted_Organizations_Backup_Stream_Cursor_Input>>;
  where?: InputMaybe<Deleted_Organizations_Backup_Bool_Exp>;
};


export type Subscription_RootDfe_EstablishmentArgs = {
  distinct_on?: InputMaybe<Array<Dfe_Establishment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dfe_Establishment_Order_By>>;
  where?: InputMaybe<Dfe_Establishment_Bool_Exp>;
};


export type Subscription_RootDfe_Establishment_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Dfe_Establishment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dfe_Establishment_Order_By>>;
  where?: InputMaybe<Dfe_Establishment_Bool_Exp>;
};


export type Subscription_RootDfe_Establishment_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootDfe_Establishment_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Dfe_Establishment_Stream_Cursor_Input>>;
  where?: InputMaybe<Dfe_Establishment_Bool_Exp>;
};


export type Subscription_RootEmail_NotificationsArgs = {
  distinct_on?: InputMaybe<Array<Email_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Notifications_Order_By>>;
  where?: InputMaybe<Email_Notifications_Bool_Exp>;
};


export type Subscription_RootEmail_Notifications_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Email_Notifications_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Email_Notifications_Order_By>>;
  where?: InputMaybe<Email_Notifications_Bool_Exp>;
};


export type Subscription_RootEmail_Notifications_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootEmail_Notifications_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Email_Notifications_Stream_Cursor_Input>>;
  where?: InputMaybe<Email_Notifications_Bool_Exp>;
};


export type Subscription_RootExpire_Go1_License_JobsArgs = {
  distinct_on?: InputMaybe<Array<Expire_Go1_License_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expire_Go1_License_Jobs_Order_By>>;
  where?: InputMaybe<Expire_Go1_License_Jobs_Bool_Exp>;
};


export type Subscription_RootExpire_Go1_License_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Expire_Go1_License_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Expire_Go1_License_Jobs_Order_By>>;
  where?: InputMaybe<Expire_Go1_License_Jobs_Bool_Exp>;
};


export type Subscription_RootExpire_Go1_License_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootExpire_Go1_License_Jobs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Expire_Go1_License_Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Expire_Go1_License_Jobs_Bool_Exp>;
};


export type Subscription_RootGo1_History_EventsArgs = {
  distinct_on?: InputMaybe<Array<Go1_History_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_History_Events_Order_By>>;
  where?: InputMaybe<Go1_History_Events_Bool_Exp>;
};


export type Subscription_RootGo1_History_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Go1_History_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_History_Events_Order_By>>;
  where?: InputMaybe<Go1_History_Events_Bool_Exp>;
};


export type Subscription_RootGo1_History_Events_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootGo1_History_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Go1_History_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Go1_History_Events_Bool_Exp>;
};


export type Subscription_RootGo1_LicensesArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_Order_By>>;
  where?: InputMaybe<Go1_Licenses_Bool_Exp>;
};


export type Subscription_RootGo1_Licenses_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_Order_By>>;
  where?: InputMaybe<Go1_Licenses_Bool_Exp>;
};


export type Subscription_RootGo1_Licenses_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGo1_Licenses_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_History_Order_By>>;
  where?: InputMaybe<Go1_Licenses_History_Bool_Exp>;
};


export type Subscription_RootGo1_Licenses_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Go1_Licenses_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Go1_Licenses_History_Order_By>>;
  where?: InputMaybe<Go1_Licenses_History_Bool_Exp>;
};


export type Subscription_RootGo1_Licenses_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootGo1_Licenses_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Go1_Licenses_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Go1_Licenses_History_Bool_Exp>;
};


export type Subscription_RootGo1_Licenses_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Go1_Licenses_Stream_Cursor_Input>>;
  where?: InputMaybe<Go1_Licenses_Bool_Exp>;
};


export type Subscription_RootGradeArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Subscription_RootGrade_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Grade_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Grade_Order_By>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Subscription_RootGrade_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootGrade_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Grade_Stream_Cursor_Input>>;
  where?: InputMaybe<Grade_Bool_Exp>;
};


export type Subscription_RootHubspot_AuditArgs = {
  distinct_on?: InputMaybe<Array<Hubspot_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hubspot_Audit_Order_By>>;
  where?: InputMaybe<Hubspot_Audit_Bool_Exp>;
};


export type Subscription_RootHubspot_Audit_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Hubspot_Audit_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Hubspot_Audit_Order_By>>;
  where?: InputMaybe<Hubspot_Audit_Bool_Exp>;
};


export type Subscription_RootHubspot_Audit_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootHubspot_Audit_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Hubspot_Audit_Stream_Cursor_Input>>;
  where?: InputMaybe<Hubspot_Audit_Bool_Exp>;
};


export type Subscription_RootIdentityArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


export type Subscription_RootIdentity_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identity_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Order_By>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


export type Subscription_RootIdentity_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootIdentity_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Identity_Stream_Cursor_Input>>;
  where?: InputMaybe<Identity_Bool_Exp>;
};


export type Subscription_RootIdentity_TypeArgs = {
  distinct_on?: InputMaybe<Array<Identity_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Type_Order_By>>;
  where?: InputMaybe<Identity_Type_Bool_Exp>;
};


export type Subscription_RootIdentity_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Identity_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Identity_Type_Order_By>>;
  where?: InputMaybe<Identity_Type_Bool_Exp>;
};


export type Subscription_RootIdentity_Type_By_PkArgs = {
  value: Scalars['String'];
};


export type Subscription_RootIdentity_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Identity_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Identity_Type_Bool_Exp>;
};


export type Subscription_RootImportArloCertificatesArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootImport_JobArgs = {
  distinct_on?: InputMaybe<Array<Import_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_Job_Order_By>>;
  where?: InputMaybe<Import_Job_Bool_Exp>;
};


export type Subscription_RootImport_Job_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_Job_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_Job_Order_By>>;
  where?: InputMaybe<Import_Job_Bool_Exp>;
};


export type Subscription_RootImport_Job_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootImport_Job_StatusArgs = {
  distinct_on?: InputMaybe<Array<Import_Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_Job_Status_Order_By>>;
  where?: InputMaybe<Import_Job_Status_Bool_Exp>;
};


export type Subscription_RootImport_Job_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_Job_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_Job_Status_Order_By>>;
  where?: InputMaybe<Import_Job_Status_Bool_Exp>;
};


export type Subscription_RootImport_Job_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootImport_Job_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Import_Job_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Import_Job_Status_Bool_Exp>;
};


export type Subscription_RootImport_Job_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Import_Job_Stream_Cursor_Input>>;
  where?: InputMaybe<Import_Job_Bool_Exp>;
};


export type Subscription_RootImport_Job_TypeArgs = {
  distinct_on?: InputMaybe<Array<Import_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_Job_Type_Order_By>>;
  where?: InputMaybe<Import_Job_Type_Bool_Exp>;
};


export type Subscription_RootImport_Job_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Import_Job_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Import_Job_Type_Order_By>>;
  where?: InputMaybe<Import_Job_Type_Bool_Exp>;
};


export type Subscription_RootImport_Job_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootImport_Job_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Import_Job_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Import_Job_Type_Bool_Exp>;
};


export type Subscription_RootJob_TitleArgs = {
  distinct_on?: InputMaybe<Array<Job_Title_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Title_Order_By>>;
  where?: InputMaybe<Job_Title_Bool_Exp>;
};


export type Subscription_RootJob_Title_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Job_Title_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Job_Title_Order_By>>;
  where?: InputMaybe<Job_Title_Bool_Exp>;
};


export type Subscription_RootJob_Title_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootJob_Title_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Job_Title_Stream_Cursor_Input>>;
  where?: InputMaybe<Job_Title_Bool_Exp>;
};


export type Subscription_RootLegacy_CertificateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Certificate_Order_By>>;
  where?: InputMaybe<Legacy_Certificate_Bool_Exp>;
};


export type Subscription_RootLegacy_Certificate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Legacy_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Legacy_Certificate_Order_By>>;
  where?: InputMaybe<Legacy_Certificate_Bool_Exp>;
};


export type Subscription_RootLegacy_Certificate_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootLegacy_Certificate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Legacy_Certificate_Stream_Cursor_Input>>;
  where?: InputMaybe<Legacy_Certificate_Bool_Exp>;
};


export type Subscription_RootMaterials_OrderArgs = {
  distinct_on?: InputMaybe<Array<Materials_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Materials_Order_Order_By>>;
  where?: InputMaybe<Materials_Order_Bool_Exp>;
};


export type Subscription_RootMaterials_Order_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Materials_Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Materials_Order_Order_By>>;
  where?: InputMaybe<Materials_Order_Bool_Exp>;
};


export type Subscription_RootMaterials_Order_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMaterials_Order_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Materials_Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Materials_Order_Bool_Exp>;
};


export type Subscription_RootMerge_Organizations_LogsArgs = {
  distinct_on?: InputMaybe<Array<Merge_Organizations_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Merge_Organizations_Logs_Order_By>>;
  where?: InputMaybe<Merge_Organizations_Logs_Bool_Exp>;
};


export type Subscription_RootMerge_Organizations_Logs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Merge_Organizations_Logs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Merge_Organizations_Logs_Order_By>>;
  where?: InputMaybe<Merge_Organizations_Logs_Bool_Exp>;
};


export type Subscription_RootMerge_Organizations_Logs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMerge_Organizations_Logs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Merge_Organizations_Logs_Stream_Cursor_Input>>;
  where?: InputMaybe<Merge_Organizations_Logs_Bool_Exp>;
};


export type Subscription_RootMerged_OrganizationsArgs = {
  distinct_on?: InputMaybe<Array<Merged_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Merged_Organizations_Order_By>>;
  where?: InputMaybe<Merged_Organizations_Bool_Exp>;
};


export type Subscription_RootMerged_Organizations_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Merged_Organizations_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Merged_Organizations_Order_By>>;
  where?: InputMaybe<Merged_Organizations_Bool_Exp>;
};


export type Subscription_RootMerged_Organizations_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootMerged_Organizations_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Merged_Organizations_Stream_Cursor_Input>>;
  where?: InputMaybe<Merged_Organizations_Bool_Exp>;
};


export type Subscription_RootModuleArgs = {
  distinct_on?: InputMaybe<Array<Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Order_By>>;
  where?: InputMaybe<Module_Bool_Exp>;
};


export type Subscription_RootModule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Order_By>>;
  where?: InputMaybe<Module_Bool_Exp>;
};


export type Subscription_RootModule_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootModule_CategoryArgs = {
  distinct_on?: InputMaybe<Array<Module_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Category_Order_By>>;
  where?: InputMaybe<Module_Category_Bool_Exp>;
};


export type Subscription_RootModule_Category_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Category_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Category_Order_By>>;
  where?: InputMaybe<Module_Category_Bool_Exp>;
};


export type Subscription_RootModule_Category_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootModule_Category_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Module_Category_Stream_Cursor_Input>>;
  where?: InputMaybe<Module_Category_Bool_Exp>;
};


export type Subscription_RootModule_GroupArgs = {
  distinct_on?: InputMaybe<Array<Module_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Group_Order_By>>;
  where?: InputMaybe<Module_Group_Bool_Exp>;
};


export type Subscription_RootModule_Group_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Group_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Group_Order_By>>;
  where?: InputMaybe<Module_Group_Bool_Exp>;
};


export type Subscription_RootModule_Group_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootModule_Group_DurationArgs = {
  distinct_on?: InputMaybe<Array<Module_Group_Duration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Group_Duration_Order_By>>;
  where?: InputMaybe<Module_Group_Duration_Bool_Exp>;
};


export type Subscription_RootModule_Group_Duration_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Group_Duration_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Group_Duration_Order_By>>;
  where?: InputMaybe<Module_Group_Duration_Bool_Exp>;
};


export type Subscription_RootModule_Group_Duration_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootModule_Group_Duration_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Module_Group_Duration_Stream_Cursor_Input>>;
  where?: InputMaybe<Module_Group_Duration_Bool_Exp>;
};


export type Subscription_RootModule_Group_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Module_Group_Stream_Cursor_Input>>;
  where?: InputMaybe<Module_Group_Bool_Exp>;
};


export type Subscription_RootModule_SettingArgs = {
  distinct_on?: InputMaybe<Array<Module_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Setting_Order_By>>;
  where?: InputMaybe<Module_Setting_Bool_Exp>;
};


export type Subscription_RootModule_Setting_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Setting_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Setting_Order_By>>;
  where?: InputMaybe<Module_Setting_Bool_Exp>;
};


export type Subscription_RootModule_Setting_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootModule_Setting_DependencyArgs = {
  distinct_on?: InputMaybe<Array<Module_Setting_Dependency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Setting_Dependency_Order_By>>;
  where?: InputMaybe<Module_Setting_Dependency_Bool_Exp>;
};


export type Subscription_RootModule_Setting_Dependency_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_Setting_Dependency_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_Setting_Dependency_Order_By>>;
  where?: InputMaybe<Module_Setting_Dependency_Bool_Exp>;
};


export type Subscription_RootModule_Setting_Dependency_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootModule_Setting_Dependency_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Module_Setting_Dependency_Stream_Cursor_Input>>;
  where?: InputMaybe<Module_Setting_Dependency_Bool_Exp>;
};


export type Subscription_RootModule_Setting_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Module_Setting_Stream_Cursor_Input>>;
  where?: InputMaybe<Module_Setting_Bool_Exp>;
};


export type Subscription_RootModule_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Module_Stream_Cursor_Input>>;
  where?: InputMaybe<Module_Bool_Exp>;
};


export type Subscription_RootModule_V2Args = {
  distinct_on?: InputMaybe<Array<Module_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_V2_Order_By>>;
  where?: InputMaybe<Module_V2_Bool_Exp>;
};


export type Subscription_RootModule_V2_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Module_V2_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Module_V2_Order_By>>;
  where?: InputMaybe<Module_V2_Bool_Exp>;
};


export type Subscription_RootModule_V2_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootModule_V2_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Module_V2_Stream_Cursor_Input>>;
  where?: InputMaybe<Module_V2_Bool_Exp>;
};


export type Subscription_RootNon_Graded_CertificateArgs = {
  distinct_on?: InputMaybe<Array<Non_Graded_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Non_Graded_Certificate_Order_By>>;
  where?: InputMaybe<Non_Graded_Certificate_Bool_Exp>;
};


export type Subscription_RootNon_Graded_Certificate_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Non_Graded_Certificate_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Non_Graded_Certificate_Order_By>>;
  where?: InputMaybe<Non_Graded_Certificate_Bool_Exp>;
};


export type Subscription_RootNon_Graded_Certificate_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootNon_Graded_Certificate_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Non_Graded_Certificate_Stream_Cursor_Input>>;
  where?: InputMaybe<Non_Graded_Certificate_Bool_Exp>;
};


export type Subscription_RootOrderArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Order_By>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrder_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Bool_Exp>;
};


export type Subscription_RootOrder_TempArgs = {
  distinct_on?: InputMaybe<Array<Order_Temp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Temp_Order_By>>;
  where?: InputMaybe<Order_Temp_Bool_Exp>;
};


export type Subscription_RootOrder_Temp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Order_Temp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Order_Temp_Order_By>>;
  where?: InputMaybe<Order_Temp_Bool_Exp>;
};


export type Subscription_RootOrder_Temp_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrder_Temp_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Order_Temp_Stream_Cursor_Input>>;
  where?: InputMaybe<Order_Temp_Bool_Exp>;
};


export type Subscription_RootOrg_Created_FromArgs = {
  distinct_on?: InputMaybe<Array<Org_Created_From_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Created_From_Order_By>>;
  where?: InputMaybe<Org_Created_From_Bool_Exp>;
};


export type Subscription_RootOrg_Created_From_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Created_From_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Created_From_Order_By>>;
  where?: InputMaybe<Org_Created_From_Bool_Exp>;
};


export type Subscription_RootOrg_Created_From_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootOrg_Created_From_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Created_From_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Created_From_Bool_Exp>;
};


export type Subscription_RootOrg_Distinct_Country_CodesArgs = {
  distinct_on?: InputMaybe<Array<Org_Distinct_Country_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Distinct_Country_Codes_Order_By>>;
  where?: InputMaybe<Org_Distinct_Country_Codes_Bool_Exp>;
};


export type Subscription_RootOrg_Distinct_Country_Codes_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Distinct_Country_Codes_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Distinct_Country_Codes_Order_By>>;
  where?: InputMaybe<Org_Distinct_Country_Codes_Bool_Exp>;
};


export type Subscription_RootOrg_Distinct_Country_Codes_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Distinct_Country_Codes_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Distinct_Country_Codes_Bool_Exp>;
};


export type Subscription_RootOrg_Resource_Packs_HistoryArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_History_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_History_Bool_Exp>;
};


export type Subscription_RootOrg_Resource_Packs_History_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_History_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_History_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_History_Bool_Exp>;
};


export type Subscription_RootOrg_Resource_Packs_History_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrg_Resource_Packs_History_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Resource_Packs_History_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Resource_Packs_History_Bool_Exp>;
};


export type Subscription_RootOrg_Resource_Packs_PricingArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_Pricing_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
};


export type Subscription_RootOrg_Resource_Packs_Pricing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_Pricing_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
};


export type Subscription_RootOrg_Resource_Packs_Pricing_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrg_Resource_Packs_Pricing_ChangelogArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_Pricing_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_Pricing_Changelog_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Bool_Exp>;
};


export type Subscription_RootOrg_Resource_Packs_Pricing_Changelog_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Org_Resource_Packs_Pricing_Changelog_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Org_Resource_Packs_Pricing_Changelog_Order_By>>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Bool_Exp>;
};


export type Subscription_RootOrg_Resource_Packs_Pricing_Changelog_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrg_Resource_Packs_Pricing_Changelog_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Resource_Packs_Pricing_Changelog_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Changelog_Bool_Exp>;
};


export type Subscription_RootOrg_Resource_Packs_Pricing_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Org_Resource_Packs_Pricing_Stream_Cursor_Input>>;
  where?: InputMaybe<Org_Resource_Packs_Pricing_Bool_Exp>;
};


export type Subscription_RootOrganisation_LogArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Log_Order_By>>;
  where?: InputMaybe<Organisation_Log_Bool_Exp>;
};


export type Subscription_RootOrganisation_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Log_Order_By>>;
  where?: InputMaybe<Organisation_Log_Bool_Exp>;
};


export type Subscription_RootOrganisation_Log_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganisation_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Log_Bool_Exp>;
};


export type Subscription_RootOrganisation_SectorArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Sector_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Sector_Order_By>>;
  where?: InputMaybe<Organisation_Sector_Bool_Exp>;
};


export type Subscription_RootOrganisation_Sector_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organisation_Sector_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organisation_Sector_Order_By>>;
  where?: InputMaybe<Organisation_Sector_Bool_Exp>;
};


export type Subscription_RootOrganisation_Sector_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootOrganisation_Sector_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organisation_Sector_Stream_Cursor_Input>>;
  where?: InputMaybe<Organisation_Sector_Bool_Exp>;
};


export type Subscription_RootOrganizationArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganization_InvitesArgs = {
  distinct_on?: InputMaybe<Array<Organization_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Invites_Order_By>>;
  where?: InputMaybe<Organization_Invites_Bool_Exp>;
};


export type Subscription_RootOrganization_Invites_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Invites_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Invites_Order_By>>;
  where?: InputMaybe<Organization_Invites_Bool_Exp>;
};


export type Subscription_RootOrganization_Invites_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganization_Invites_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Invites_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Invites_Bool_Exp>;
};


export type Subscription_RootOrganization_MemberArgs = {
  distinct_on?: InputMaybe<Array<Organization_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Member_Order_By>>;
  where?: InputMaybe<Organization_Member_Bool_Exp>;
};


export type Subscription_RootOrganization_Member_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Member_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Member_Order_By>>;
  where?: InputMaybe<Organization_Member_Bool_Exp>;
};


export type Subscription_RootOrganization_Member_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganization_Member_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Member_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Member_Bool_Exp>;
};


export type Subscription_RootOrganization_Resource_PacksArgs = {
  distinct_on?: InputMaybe<Array<Organization_Resource_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Resource_Packs_Order_By>>;
  where?: InputMaybe<Organization_Resource_Packs_Bool_Exp>;
};


export type Subscription_RootOrganization_Resource_Packs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Resource_Packs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Resource_Packs_Order_By>>;
  where?: InputMaybe<Organization_Resource_Packs_Bool_Exp>;
};


export type Subscription_RootOrganization_Resource_Packs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganization_Resource_Packs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Resource_Packs_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Resource_Packs_Bool_Exp>;
};


export type Subscription_RootOrganization_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootOrganization_TypeArgs = {
  distinct_on?: InputMaybe<Array<Organization_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Type_Order_By>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organization_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Type_Order_By>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Subscription_RootOrganization_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganization_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organization_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Organization_Type_Bool_Exp>;
};


export type Subscription_RootOrganizations_StatisticsArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Statistics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Statistics_Order_By>>;
  where?: InputMaybe<Organizations_Statistics_Bool_Exp>;
};


export type Subscription_RootOrganizations_Statistics_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Organizations_Statistics_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organizations_Statistics_Order_By>>;
  where?: InputMaybe<Organizations_Statistics_Bool_Exp>;
};


export type Subscription_RootOrganizations_Statistics_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootOrganizations_Statistics_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Organizations_Statistics_Stream_Cursor_Input>>;
  where?: InputMaybe<Organizations_Statistics_Bool_Exp>;
};


export type Subscription_RootPayment_MethodsArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Subscription_RootPayment_Methods_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Payment_Methods_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Payment_Methods_Order_By>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Subscription_RootPayment_Methods_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootPayment_Methods_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Payment_Methods_Stream_Cursor_Input>>;
  where?: InputMaybe<Payment_Methods_Bool_Exp>;
};


export type Subscription_RootPost_Training_Email_Scheduled_EventsArgs = {
  distinct_on?: InputMaybe<Array<Post_Training_Email_Scheduled_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Post_Training_Email_Scheduled_Events_Order_By>>;
  where?: InputMaybe<Post_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Subscription_RootPost_Training_Email_Scheduled_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Post_Training_Email_Scheduled_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Post_Training_Email_Scheduled_Events_Order_By>>;
  where?: InputMaybe<Post_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Subscription_RootPost_Training_Email_Scheduled_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPost_Training_Email_Scheduled_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Post_Training_Email_Scheduled_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Post_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Subscription_RootPre_Training_Email_Scheduled_EventsArgs = {
  distinct_on?: InputMaybe<Array<Pre_Training_Email_Scheduled_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Training_Email_Scheduled_Events_Order_By>>;
  where?: InputMaybe<Pre_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Subscription_RootPre_Training_Email_Scheduled_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Pre_Training_Email_Scheduled_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Pre_Training_Email_Scheduled_Events_Order_By>>;
  where?: InputMaybe<Pre_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Subscription_RootPre_Training_Email_Scheduled_Events_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPre_Training_Email_Scheduled_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Pre_Training_Email_Scheduled_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Pre_Training_Email_Scheduled_Events_Bool_Exp>;
};


export type Subscription_RootPrecision_Order_StatusArgs = {
  distinct_on?: InputMaybe<Array<Precision_Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Precision_Order_Status_Order_By>>;
  where?: InputMaybe<Precision_Order_Status_Bool_Exp>;
};


export type Subscription_RootPrecision_Order_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Precision_Order_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Precision_Order_Status_Order_By>>;
  where?: InputMaybe<Precision_Order_Status_Bool_Exp>;
};


export type Subscription_RootPrecision_Order_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootPrecision_Order_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Precision_Order_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Precision_Order_Status_Bool_Exp>;
};


export type Subscription_RootPrivate_Course_BookingArgs = {
  distinct_on?: InputMaybe<Array<Private_Course_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Private_Course_Booking_Order_By>>;
  where?: InputMaybe<Private_Course_Booking_Bool_Exp>;
};


export type Subscription_RootPrivate_Course_Booking_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Private_Course_Booking_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Private_Course_Booking_Order_By>>;
  where?: InputMaybe<Private_Course_Booking_Bool_Exp>;
};


export type Subscription_RootPrivate_Course_Booking_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPrivate_Course_Booking_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Private_Course_Booking_Stream_Cursor_Input>>;
  where?: InputMaybe<Private_Course_Booking_Bool_Exp>;
};


export type Subscription_RootProfileArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Subscription_RootProfile_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Order_By>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Subscription_RootProfile_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProfile_RoleArgs = {
  distinct_on?: InputMaybe<Array<Profile_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Role_Order_By>>;
  where?: InputMaybe<Profile_Role_Bool_Exp>;
};


export type Subscription_RootProfile_Role_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Role_Order_By>>;
  where?: InputMaybe<Profile_Role_Bool_Exp>;
};


export type Subscription_RootProfile_Role_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProfile_Role_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Profile_Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Profile_Role_Bool_Exp>;
};


export type Subscription_RootProfile_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Profile_Stream_Cursor_Input>>;
  where?: InputMaybe<Profile_Bool_Exp>;
};


export type Subscription_RootProfile_TempArgs = {
  distinct_on?: InputMaybe<Array<Profile_Temp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Temp_Order_By>>;
  where?: InputMaybe<Profile_Temp_Bool_Exp>;
};


export type Subscription_RootProfile_Temp_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Temp_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Temp_Order_By>>;
  where?: InputMaybe<Profile_Temp_Bool_Exp>;
};


export type Subscription_RootProfile_Temp_By_PkArgs = {
  id: Scalars['Int'];
};


export type Subscription_RootProfile_Temp_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Profile_Temp_Stream_Cursor_Input>>;
  where?: InputMaybe<Profile_Temp_Bool_Exp>;
};


export type Subscription_RootProfile_Trainer_Agreement_TypeArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Agreement_Type_Bool_Exp>;
};


export type Subscription_RootProfile_Trainer_Agreement_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Agreement_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Agreement_Type_Bool_Exp>;
};


export type Subscription_RootProfile_Trainer_Agreement_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProfile_Trainer_Agreement_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Profile_Trainer_Agreement_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Profile_Trainer_Agreement_Type_Bool_Exp>;
};


export type Subscription_RootProfile_Trainer_Role_TypeArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Role_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
};


export type Subscription_RootProfile_Trainer_Role_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Role_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
};


export type Subscription_RootProfile_Trainer_Role_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootProfile_Trainer_Role_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Profile_Trainer_Role_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
};


export type Subscription_RootPromo_CodeArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Order_By>>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};


export type Subscription_RootPromo_Code_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Order_By>>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};


export type Subscription_RootPromo_Code_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootPromo_Code_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Promo_Code_Stream_Cursor_Input>>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
};


export type Subscription_RootPromo_Code_TypeArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Type_Order_By>>;
  where?: InputMaybe<Promo_Code_Type_Bool_Exp>;
};


export type Subscription_RootPromo_Code_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Promo_Code_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Promo_Code_Type_Order_By>>;
  where?: InputMaybe<Promo_Code_Type_Bool_Exp>;
};


export type Subscription_RootPromo_Code_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootPromo_Code_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Promo_Code_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Promo_Code_Type_Bool_Exp>;
};


export type Subscription_RootResource_Pack_Bundle_Course_LevelArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Course_Level_Bool_Exp>;
};


export type Subscription_RootResource_Pack_Bundle_Course_Level_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Course_Level_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Course_Level_Bool_Exp>;
};


export type Subscription_RootResource_Pack_Bundle_Course_Level_By_PkArgs = {
  course_level: Course_Level_Enum;
  resource_pack_bundle: Scalars['uuid'];
};


export type Subscription_RootResource_Pack_Bundle_Course_Level_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Resource_Pack_Bundle_Course_Level_Stream_Cursor_Input>>;
  where?: InputMaybe<Resource_Pack_Bundle_Course_Level_Bool_Exp>;
};


export type Subscription_RootResource_Pack_Bundle_OptionArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Option_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Option_Bool_Exp>;
};


export type Subscription_RootResource_Pack_Bundle_Option_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Option_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Option_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Option_Bool_Exp>;
};


export type Subscription_RootResource_Pack_Bundle_Option_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootResource_Pack_Bundle_Option_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Resource_Pack_Bundle_Option_Stream_Cursor_Input>>;
  where?: InputMaybe<Resource_Pack_Bundle_Option_Bool_Exp>;
};


export type Subscription_RootResource_Pack_Bundle_PriceArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Price_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Price_Bool_Exp>;
};


export type Subscription_RootResource_Pack_Bundle_Price_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Pack_Bundle_Price_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Pack_Bundle_Price_Order_By>>;
  where?: InputMaybe<Resource_Pack_Bundle_Price_Bool_Exp>;
};


export type Subscription_RootResource_Pack_Bundle_Price_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootResource_Pack_Bundle_Price_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Resource_Pack_Bundle_Price_Stream_Cursor_Input>>;
  where?: InputMaybe<Resource_Pack_Bundle_Price_Bool_Exp>;
};


export type Subscription_RootResource_Packs_Delivery_TypeArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Delivery_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Delivery_Type_Order_By>>;
  where?: InputMaybe<Resource_Packs_Delivery_Type_Bool_Exp>;
};


export type Subscription_RootResource_Packs_Delivery_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Delivery_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Delivery_Type_Order_By>>;
  where?: InputMaybe<Resource_Packs_Delivery_Type_Bool_Exp>;
};


export type Subscription_RootResource_Packs_Delivery_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootResource_Packs_Delivery_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Resource_Packs_Delivery_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Resource_Packs_Delivery_Type_Bool_Exp>;
};


export type Subscription_RootResource_Packs_EventsArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Events_Order_By>>;
  where?: InputMaybe<Resource_Packs_Events_Bool_Exp>;
};


export type Subscription_RootResource_Packs_Events_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Events_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Events_Order_By>>;
  where?: InputMaybe<Resource_Packs_Events_Bool_Exp>;
};


export type Subscription_RootResource_Packs_Events_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootResource_Packs_Events_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Resource_Packs_Events_Stream_Cursor_Input>>;
  where?: InputMaybe<Resource_Packs_Events_Bool_Exp>;
};


export type Subscription_RootResource_Packs_PricingArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Pricing_Order_By>>;
  where?: InputMaybe<Resource_Packs_Pricing_Bool_Exp>;
};


export type Subscription_RootResource_Packs_Pricing_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Pricing_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Pricing_Order_By>>;
  where?: InputMaybe<Resource_Packs_Pricing_Bool_Exp>;
};


export type Subscription_RootResource_Packs_Pricing_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootResource_Packs_Pricing_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Resource_Packs_Pricing_Stream_Cursor_Input>>;
  where?: InputMaybe<Resource_Packs_Pricing_Bool_Exp>;
};


export type Subscription_RootResource_Packs_TypeArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Type_Order_By>>;
  where?: InputMaybe<Resource_Packs_Type_Bool_Exp>;
};


export type Subscription_RootResource_Packs_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Resource_Packs_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Resource_Packs_Type_Order_By>>;
  where?: InputMaybe<Resource_Packs_Type_Bool_Exp>;
};


export type Subscription_RootResource_Packs_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootResource_Packs_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Resource_Packs_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Resource_Packs_Type_Bool_Exp>;
};


export type Subscription_RootRoleArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Role_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Role_Order_By>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootRole_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootRole_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Role_Stream_Cursor_Input>>;
  where?: InputMaybe<Role_Bool_Exp>;
};


export type Subscription_RootScheduled_Events_ViewArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Events_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scheduled_Events_View_Order_By>>;
  where?: InputMaybe<Scheduled_Events_View_Bool_Exp>;
};


export type Subscription_RootScheduled_Events_View_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Scheduled_Events_View_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Scheduled_Events_View_Order_By>>;
  where?: InputMaybe<Scheduled_Events_View_Bool_Exp>;
};


export type Subscription_RootScheduled_Events_View_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Scheduled_Events_View_Stream_Cursor_Input>>;
  where?: InputMaybe<Scheduled_Events_View_Bool_Exp>;
};


export type Subscription_RootSearch_Dfe_EstablishmentsArgs = {
  args: Search_Dfe_Establishments_Args;
  distinct_on?: InputMaybe<Array<Dfe_Establishment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dfe_Establishment_Order_By>>;
  where?: InputMaybe<Dfe_Establishment_Bool_Exp>;
};


export type Subscription_RootSearch_Dfe_Establishments_AggregateArgs = {
  args: Search_Dfe_Establishments_Args;
  distinct_on?: InputMaybe<Array<Dfe_Establishment_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Dfe_Establishment_Order_By>>;
  where?: InputMaybe<Dfe_Establishment_Bool_Exp>;
};


export type Subscription_RootSearch_OrganizationsArgs = {
  args: Search_Organizations_Args;
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootSearch_Organizations_AggregateArgs = {
  args: Search_Organizations_Args;
  distinct_on?: InputMaybe<Array<Organization_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Organization_Order_By>>;
  where?: InputMaybe<Organization_Bool_Exp>;
};


export type Subscription_RootSplash_ScreensArgs = {
  distinct_on?: InputMaybe<Array<Splash_Screens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Splash_Screens_Order_By>>;
  where?: InputMaybe<Splash_Screens_Bool_Exp>;
};


export type Subscription_RootSplash_Screens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Splash_Screens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Splash_Screens_Order_By>>;
  where?: InputMaybe<Splash_Screens_Bool_Exp>;
};


export type Subscription_RootSplash_Screens_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootSplash_Screens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Splash_Screens_Stream_Cursor_Input>>;
  where?: InputMaybe<Splash_Screens_Bool_Exp>;
};


export type Subscription_RootSubmission_Of_Splash_ScreensArgs = {
  distinct_on?: InputMaybe<Array<Submission_Of_Splash_Screens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submission_Of_Splash_Screens_Order_By>>;
  where?: InputMaybe<Submission_Of_Splash_Screens_Bool_Exp>;
};


export type Subscription_RootSubmission_Of_Splash_Screens_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Submission_Of_Splash_Screens_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submission_Of_Splash_Screens_Order_By>>;
  where?: InputMaybe<Submission_Of_Splash_Screens_Bool_Exp>;
};


export type Subscription_RootSubmission_Of_Splash_Screens_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubmission_Of_Splash_Screens_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Submission_Of_Splash_Screens_Stream_Cursor_Input>>;
  where?: InputMaybe<Submission_Of_Splash_Screens_Bool_Exp>;
};


export type Subscription_RootSubmoduleArgs = {
  distinct_on?: InputMaybe<Array<Submodule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submodule_Order_By>>;
  where?: InputMaybe<Submodule_Bool_Exp>;
};


export type Subscription_RootSubmodule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Submodule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Submodule_Order_By>>;
  where?: InputMaybe<Submodule_Bool_Exp>;
};


export type Subscription_RootSubmodule_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootSubmodule_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Submodule_Stream_Cursor_Input>>;
  where?: InputMaybe<Submodule_Bool_Exp>;
};


export type Subscription_RootTrainer_Agreement_TypeArgs = {
  distinct_on?: InputMaybe<Array<Trainer_Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trainer_Agreement_Type_Order_By>>;
  where?: InputMaybe<Trainer_Agreement_Type_Bool_Exp>;
};


export type Subscription_RootTrainer_Agreement_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trainer_Agreement_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trainer_Agreement_Type_Order_By>>;
  where?: InputMaybe<Trainer_Agreement_Type_Bool_Exp>;
};


export type Subscription_RootTrainer_Agreement_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootTrainer_Agreement_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trainer_Agreement_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Trainer_Agreement_Type_Bool_Exp>;
};


export type Subscription_RootTrainer_Role_TypeArgs = {
  distinct_on?: InputMaybe<Array<Trainer_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trainer_Role_Type_Order_By>>;
  where?: InputMaybe<Trainer_Role_Type_Bool_Exp>;
};


export type Subscription_RootTrainer_Role_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trainer_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trainer_Role_Type_Order_By>>;
  where?: InputMaybe<Trainer_Role_Type_Bool_Exp>;
};


export type Subscription_RootTrainer_Role_Type_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTrainer_Role_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trainer_Role_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Trainer_Role_Type_Bool_Exp>;
};


export type Subscription_RootTrust_TypeArgs = {
  distinct_on?: InputMaybe<Array<Trust_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trust_Type_Order_By>>;
  where?: InputMaybe<Trust_Type_Bool_Exp>;
};


export type Subscription_RootTrust_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Trust_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Trust_Type_Order_By>>;
  where?: InputMaybe<Trust_Type_Bool_Exp>;
};


export type Subscription_RootTrust_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootTrust_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Trust_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<Trust_Type_Bool_Exp>;
};


export type Subscription_RootTt_Client_Invite_LogArgs = {
  distinct_on?: InputMaybe<Array<Tt_Client_Invite_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tt_Client_Invite_Log_Order_By>>;
  where?: InputMaybe<Tt_Client_Invite_Log_Bool_Exp>;
};


export type Subscription_RootTt_Client_Invite_Log_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Tt_Client_Invite_Log_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Tt_Client_Invite_Log_Order_By>>;
  where?: InputMaybe<Tt_Client_Invite_Log_Bool_Exp>;
};


export type Subscription_RootTt_Client_Invite_Log_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootTt_Client_Invite_Log_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Tt_Client_Invite_Log_Stream_Cursor_Input>>;
  where?: InputMaybe<Tt_Client_Invite_Log_Bool_Exp>;
};


export type Subscription_RootUpcoming_EnrollmentsArgs = {
  distinct_on?: InputMaybe<Array<Upcoming_Enrollments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Upcoming_Enrollments_Order_By>>;
  where?: InputMaybe<Upcoming_Enrollments_Bool_Exp>;
};


export type Subscription_RootUpcoming_Enrollments_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Upcoming_Enrollments_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Upcoming_Enrollments_Order_By>>;
  where?: InputMaybe<Upcoming_Enrollments_Bool_Exp>;
};


export type Subscription_RootUpcoming_Enrollments_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Upcoming_Enrollments_Stream_Cursor_Input>>;
  where?: InputMaybe<Upcoming_Enrollments_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Audit_TypeArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Audit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Audit_Type_Order_By>>;
  where?: InputMaybe<User_Auth_Audit_Type_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Audit_Type_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Audit_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Audit_Type_Order_By>>;
  where?: InputMaybe<User_Auth_Audit_Type_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Audit_Type_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootUser_Auth_Audit_Type_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Auth_Audit_Type_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Auth_Audit_Type_Bool_Exp>;
};


export type Subscription_RootUser_Auth_AuditsArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Audits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Audits_Order_By>>;
  where?: InputMaybe<User_Auth_Audits_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Audits_AggregateArgs = {
  distinct_on?: InputMaybe<Array<User_Auth_Audits_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<User_Auth_Audits_Order_By>>;
  where?: InputMaybe<User_Auth_Audits_Bool_Exp>;
};


export type Subscription_RootUser_Auth_Audits_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootUser_Auth_Audits_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<User_Auth_Audits_Stream_Cursor_Input>>;
  where?: InputMaybe<User_Auth_Audits_Bool_Exp>;
};


export type Subscription_RootVenueArgs = {
  distinct_on?: InputMaybe<Array<Venue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Venue_Order_By>>;
  where?: InputMaybe<Venue_Bool_Exp>;
};


export type Subscription_RootVenue_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Venue_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Venue_Order_By>>;
  where?: InputMaybe<Venue_Bool_Exp>;
};


export type Subscription_RootVenue_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenue_Check_JobsArgs = {
  distinct_on?: InputMaybe<Array<Venue_Check_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Venue_Check_Jobs_Order_By>>;
  where?: InputMaybe<Venue_Check_Jobs_Bool_Exp>;
};


export type Subscription_RootVenue_Check_Jobs_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Venue_Check_Jobs_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Venue_Check_Jobs_Order_By>>;
  where?: InputMaybe<Venue_Check_Jobs_Bool_Exp>;
};


export type Subscription_RootVenue_Check_Jobs_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootVenue_Check_Jobs_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Venue_Check_Jobs_Stream_Cursor_Input>>;
  where?: InputMaybe<Venue_Check_Jobs_Bool_Exp>;
};


export type Subscription_RootVenue_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Venue_Stream_Cursor_Input>>;
  where?: InputMaybe<Venue_Bool_Exp>;
};


export type Subscription_RootWaitlistArgs = {
  distinct_on?: InputMaybe<Array<Waitlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Waitlist_Order_By>>;
  where?: InputMaybe<Waitlist_Bool_Exp>;
};


export type Subscription_RootWaitlist_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Waitlist_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Waitlist_Order_By>>;
  where?: InputMaybe<Waitlist_Bool_Exp>;
};


export type Subscription_RootWaitlist_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootWaitlist_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Waitlist_Stream_Cursor_Input>>;
  where?: InputMaybe<Waitlist_Bool_Exp>;
};


export type Subscription_RootXero_ContactArgs = {
  distinct_on?: InputMaybe<Array<Xero_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Contact_Order_By>>;
  where?: InputMaybe<Xero_Contact_Bool_Exp>;
};


export type Subscription_RootXero_Contact_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Xero_Contact_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Contact_Order_By>>;
  where?: InputMaybe<Xero_Contact_Bool_Exp>;
};


export type Subscription_RootXero_Contact_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootXero_Contact_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Xero_Contact_Stream_Cursor_Input>>;
  where?: InputMaybe<Xero_Contact_Bool_Exp>;
};


export type Subscription_RootXero_CredentialArgs = {
  distinct_on?: InputMaybe<Array<Xero_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Credential_Order_By>>;
  where?: InputMaybe<Xero_Credential_Bool_Exp>;
};


export type Subscription_RootXero_Credential_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Xero_Credential_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Credential_Order_By>>;
  where?: InputMaybe<Xero_Credential_Bool_Exp>;
};


export type Subscription_RootXero_Credential_By_PkArgs = {
  client_id: Scalars['String'];
};


export type Subscription_RootXero_Credential_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Xero_Credential_Stream_Cursor_Input>>;
  where?: InputMaybe<Xero_Credential_Bool_Exp>;
};


export type Subscription_RootXero_InvoiceArgs = {
  distinct_on?: InputMaybe<Array<Xero_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Invoice_Order_By>>;
  where?: InputMaybe<Xero_Invoice_Bool_Exp>;
};


export type Subscription_RootXero_Invoice_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Xero_Invoice_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Invoice_Order_By>>;
  where?: InputMaybe<Xero_Invoice_Bool_Exp>;
};


export type Subscription_RootXero_Invoice_By_PkArgs = {
  id: Scalars['uuid'];
};


export type Subscription_RootXero_Invoice_StatusArgs = {
  distinct_on?: InputMaybe<Array<Xero_Invoice_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Invoice_Status_Order_By>>;
  where?: InputMaybe<Xero_Invoice_Status_Bool_Exp>;
};


export type Subscription_RootXero_Invoice_Status_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Xero_Invoice_Status_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Xero_Invoice_Status_Order_By>>;
  where?: InputMaybe<Xero_Invoice_Status_Bool_Exp>;
};


export type Subscription_RootXero_Invoice_Status_By_PkArgs = {
  name: Scalars['String'];
};


export type Subscription_RootXero_Invoice_Status_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Xero_Invoice_Status_Stream_Cursor_Input>>;
  where?: InputMaybe<Xero_Invoice_Status_Bool_Exp>;
};


export type Subscription_RootXero_Invoice_StreamArgs = {
  batch_size: Scalars['Int'];
  cursor: Array<InputMaybe<Xero_Invoice_Stream_Cursor_Input>>;
  where?: InputMaybe<Xero_Invoice_Bool_Exp>;
};

/** Boolean expression to compare columns of type "timestamp". All fields are combined with logical 'AND'. */
export type Timestamp_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamp']>;
  _gt?: InputMaybe<Scalars['timestamp']>;
  _gte?: InputMaybe<Scalars['timestamp']>;
  _in?: InputMaybe<Array<Scalars['timestamp']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamp']>;
  _lte?: InputMaybe<Scalars['timestamp']>;
  _neq?: InputMaybe<Scalars['timestamp']>;
  _nin?: InputMaybe<Array<Scalars['timestamp']>>;
};

/** Boolean expression to compare columns of type "timestamptz". All fields are combined with logical 'AND'. */
export type Timestamptz_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['timestamptz']>;
  _gt?: InputMaybe<Scalars['timestamptz']>;
  _gte?: InputMaybe<Scalars['timestamptz']>;
  _in?: InputMaybe<Array<Scalars['timestamptz']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['timestamptz']>;
  _lte?: InputMaybe<Scalars['timestamptz']>;
  _neq?: InputMaybe<Scalars['timestamptz']>;
  _nin?: InputMaybe<Array<Scalars['timestamptz']>>;
};

/** columns and relationships of "trainer_agreement_type" */
export type Trainer_Agreement_Type = {
  __typename?: 'trainer_agreement_type';
  name: Scalars['String'];
};

/** aggregated selection of "trainer_agreement_type" */
export type Trainer_Agreement_Type_Aggregate = {
  __typename?: 'trainer_agreement_type_aggregate';
  aggregate?: Maybe<Trainer_Agreement_Type_Aggregate_Fields>;
  nodes: Array<Trainer_Agreement_Type>;
};

/** aggregate fields of "trainer_agreement_type" */
export type Trainer_Agreement_Type_Aggregate_Fields = {
  __typename?: 'trainer_agreement_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Trainer_Agreement_Type_Max_Fields>;
  min?: Maybe<Trainer_Agreement_Type_Min_Fields>;
};


/** aggregate fields of "trainer_agreement_type" */
export type Trainer_Agreement_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trainer_Agreement_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "trainer_agreement_type". All fields are combined with a logical 'AND'. */
export type Trainer_Agreement_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Trainer_Agreement_Type_Bool_Exp>>;
  _not?: InputMaybe<Trainer_Agreement_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Trainer_Agreement_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trainer_agreement_type" */
export enum Trainer_Agreement_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  TrainerAgreementTypePkey = 'trainer_agreement_type_pkey'
}

export enum Trainer_Agreement_Type_Enum {
  Aol = 'AOL',
  Eta = 'ETA'
}

/** Boolean expression to compare columns of type "trainer_agreement_type_enum". All fields are combined with logical 'AND'. */
export type Trainer_Agreement_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Trainer_Agreement_Type_Enum>;
  _in?: InputMaybe<Array<Trainer_Agreement_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Trainer_Agreement_Type_Enum>;
  _nin?: InputMaybe<Array<Trainer_Agreement_Type_Enum>>;
};

/** input type for inserting data into table "trainer_agreement_type" */
export type Trainer_Agreement_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Trainer_Agreement_Type_Max_Fields = {
  __typename?: 'trainer_agreement_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Trainer_Agreement_Type_Min_Fields = {
  __typename?: 'trainer_agreement_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "trainer_agreement_type" */
export type Trainer_Agreement_Type_Mutation_Response = {
  __typename?: 'trainer_agreement_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trainer_Agreement_Type>;
};

/** on_conflict condition type for table "trainer_agreement_type" */
export type Trainer_Agreement_Type_On_Conflict = {
  constraint: Trainer_Agreement_Type_Constraint;
  update_columns?: Array<Trainer_Agreement_Type_Update_Column>;
  where?: InputMaybe<Trainer_Agreement_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "trainer_agreement_type". */
export type Trainer_Agreement_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trainer_agreement_type */
export type Trainer_Agreement_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "trainer_agreement_type" */
export enum Trainer_Agreement_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "trainer_agreement_type" */
export type Trainer_Agreement_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "trainer_agreement_type" */
export type Trainer_Agreement_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trainer_Agreement_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trainer_Agreement_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "trainer_agreement_type" */
export enum Trainer_Agreement_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Trainer_Agreement_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trainer_Agreement_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trainer_Agreement_Type_Bool_Exp;
};

/** Trainer role types */
export type Trainer_Role_Type = {
  __typename?: 'trainer_role_type';
  id: Scalars['uuid'];
  name: Scalars['String'];
  /** An array relationship */
  profiles: Array<Profile_Trainer_Role_Type>;
  /** An aggregate relationship */
  profiles_aggregate: Profile_Trainer_Role_Type_Aggregate;
};


/** Trainer role types */
export type Trainer_Role_TypeProfilesArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Role_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
};


/** Trainer role types */
export type Trainer_Role_TypeProfiles_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Profile_Trainer_Role_Type_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Profile_Trainer_Role_Type_Order_By>>;
  where?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
};

/** aggregated selection of "trainer_role_type" */
export type Trainer_Role_Type_Aggregate = {
  __typename?: 'trainer_role_type_aggregate';
  aggregate?: Maybe<Trainer_Role_Type_Aggregate_Fields>;
  nodes: Array<Trainer_Role_Type>;
};

/** aggregate fields of "trainer_role_type" */
export type Trainer_Role_Type_Aggregate_Fields = {
  __typename?: 'trainer_role_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Trainer_Role_Type_Max_Fields>;
  min?: Maybe<Trainer_Role_Type_Min_Fields>;
};


/** aggregate fields of "trainer_role_type" */
export type Trainer_Role_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trainer_Role_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "trainer_role_type". All fields are combined with a logical 'AND'. */
export type Trainer_Role_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Trainer_Role_Type_Bool_Exp>>;
  _not?: InputMaybe<Trainer_Role_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Trainer_Role_Type_Bool_Exp>>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  profiles?: InputMaybe<Profile_Trainer_Role_Type_Bool_Exp>;
  profiles_aggregate?: InputMaybe<Profile_Trainer_Role_Type_Aggregate_Bool_Exp>;
};

/** unique or primary key constraints on table "trainer_role_type" */
export enum Trainer_Role_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  TrainerRoleTypeNameKey = 'trainer_role_type_name_key',
  /** unique or primary key constraint on columns "id" */
  TrainerRoleTypePkey = 'trainer_role_type_pkey'
}

/** input type for inserting data into table "trainer_role_type" */
export type Trainer_Role_Type_Insert_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  profiles?: InputMaybe<Profile_Trainer_Role_Type_Arr_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Trainer_Role_Type_Max_Fields = {
  __typename?: 'trainer_role_type_max_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Trainer_Role_Type_Min_Fields = {
  __typename?: 'trainer_role_type_min_fields';
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "trainer_role_type" */
export type Trainer_Role_Type_Mutation_Response = {
  __typename?: 'trainer_role_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trainer_Role_Type>;
};

/** input type for inserting object relation for remote table "trainer_role_type" */
export type Trainer_Role_Type_Obj_Rel_Insert_Input = {
  data: Trainer_Role_Type_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Trainer_Role_Type_On_Conflict>;
};

/** on_conflict condition type for table "trainer_role_type" */
export type Trainer_Role_Type_On_Conflict = {
  constraint: Trainer_Role_Type_Constraint;
  update_columns?: Array<Trainer_Role_Type_Update_Column>;
  where?: InputMaybe<Trainer_Role_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "trainer_role_type". */
export type Trainer_Role_Type_Order_By = {
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  profiles_aggregate?: InputMaybe<Profile_Trainer_Role_Type_Aggregate_Order_By>;
};

/** primary key columns input for table: trainer_role_type */
export type Trainer_Role_Type_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "trainer_role_type" */
export enum Trainer_Role_Type_Select_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "trainer_role_type" */
export type Trainer_Role_Type_Set_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "trainer_role_type" */
export type Trainer_Role_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trainer_Role_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trainer_Role_Type_Stream_Cursor_Value_Input = {
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "trainer_role_type" */
export enum Trainer_Role_Type_Update_Column {
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name'
}

export type Trainer_Role_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trainer_Role_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trainer_Role_Type_Bool_Exp;
};

/** columns and relationships of "trust_type" */
export type Trust_Type = {
  __typename?: 'trust_type';
  name: Scalars['String'];
};

/** aggregated selection of "trust_type" */
export type Trust_Type_Aggregate = {
  __typename?: 'trust_type_aggregate';
  aggregate?: Maybe<Trust_Type_Aggregate_Fields>;
  nodes: Array<Trust_Type>;
};

/** aggregate fields of "trust_type" */
export type Trust_Type_Aggregate_Fields = {
  __typename?: 'trust_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Trust_Type_Max_Fields>;
  min?: Maybe<Trust_Type_Min_Fields>;
};


/** aggregate fields of "trust_type" */
export type Trust_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Trust_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "trust_type". All fields are combined with a logical 'AND'. */
export type Trust_Type_Bool_Exp = {
  _and?: InputMaybe<Array<Trust_Type_Bool_Exp>>;
  _not?: InputMaybe<Trust_Type_Bool_Exp>;
  _or?: InputMaybe<Array<Trust_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "trust_type" */
export enum Trust_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  TrustTypePkey = 'trust_type_pkey'
}

/** input type for inserting data into table "trust_type" */
export type Trust_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Trust_Type_Max_Fields = {
  __typename?: 'trust_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Trust_Type_Min_Fields = {
  __typename?: 'trust_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "trust_type" */
export type Trust_Type_Mutation_Response = {
  __typename?: 'trust_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Trust_Type>;
};

/** on_conflict condition type for table "trust_type" */
export type Trust_Type_On_Conflict = {
  constraint: Trust_Type_Constraint;
  update_columns?: Array<Trust_Type_Update_Column>;
  where?: InputMaybe<Trust_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "trust_type". */
export type Trust_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: trust_type */
export type Trust_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "trust_type" */
export enum Trust_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "trust_type" */
export type Trust_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "trust_type" */
export type Trust_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Trust_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Trust_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "trust_type" */
export enum Trust_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type Trust_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Trust_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: Trust_Type_Bool_Exp;
};

/** This table stores data related to indirect course invitations targeting users marked as TeamTeach Clients ( attempted a Closed or Open course in the past 36 months or attempts on in the future 12 months ) */
export type Tt_Client_Invite_Log = {
  __typename?: 'tt_client_invite_log';
  /** An object relationship */
  course: Course;
  course_id: Scalars['Int'];
  id: Scalars['uuid'];
  invited_at: Scalars['timestamptz'];
  invited_by: Scalars['uuid'];
  invitees_list: Scalars['String'];
  /** An object relationship */
  profile: Profile;
};

/** aggregated selection of "tt_client_invite_log" */
export type Tt_Client_Invite_Log_Aggregate = {
  __typename?: 'tt_client_invite_log_aggregate';
  aggregate?: Maybe<Tt_Client_Invite_Log_Aggregate_Fields>;
  nodes: Array<Tt_Client_Invite_Log>;
};

/** aggregate fields of "tt_client_invite_log" */
export type Tt_Client_Invite_Log_Aggregate_Fields = {
  __typename?: 'tt_client_invite_log_aggregate_fields';
  avg?: Maybe<Tt_Client_Invite_Log_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Tt_Client_Invite_Log_Max_Fields>;
  min?: Maybe<Tt_Client_Invite_Log_Min_Fields>;
  stddev?: Maybe<Tt_Client_Invite_Log_Stddev_Fields>;
  stddev_pop?: Maybe<Tt_Client_Invite_Log_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Tt_Client_Invite_Log_Stddev_Samp_Fields>;
  sum?: Maybe<Tt_Client_Invite_Log_Sum_Fields>;
  var_pop?: Maybe<Tt_Client_Invite_Log_Var_Pop_Fields>;
  var_samp?: Maybe<Tt_Client_Invite_Log_Var_Samp_Fields>;
  variance?: Maybe<Tt_Client_Invite_Log_Variance_Fields>;
};


/** aggregate fields of "tt_client_invite_log" */
export type Tt_Client_Invite_Log_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Tt_Client_Invite_Log_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Tt_Client_Invite_Log_Avg_Fields = {
  __typename?: 'tt_client_invite_log_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "tt_client_invite_log". All fields are combined with a logical 'AND'. */
export type Tt_Client_Invite_Log_Bool_Exp = {
  _and?: InputMaybe<Array<Tt_Client_Invite_Log_Bool_Exp>>;
  _not?: InputMaybe<Tt_Client_Invite_Log_Bool_Exp>;
  _or?: InputMaybe<Array<Tt_Client_Invite_Log_Bool_Exp>>;
  course?: InputMaybe<Course_Bool_Exp>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invited_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  invited_by?: InputMaybe<Uuid_Comparison_Exp>;
  invitees_list?: InputMaybe<String_Comparison_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
};

/** unique or primary key constraints on table "tt_client_invite_log" */
export enum Tt_Client_Invite_Log_Constraint {
  /** unique or primary key constraint on columns "id" */
  TtClientInviteLogPkey = 'tt_client_invite_log_pkey'
}

/** input type for incrementing numeric columns in table "tt_client_invite_log" */
export type Tt_Client_Invite_Log_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "tt_client_invite_log" */
export type Tt_Client_Invite_Log_Insert_Input = {
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_at?: InputMaybe<Scalars['timestamptz']>;
  invited_by?: InputMaybe<Scalars['uuid']>;
  invitees_list?: InputMaybe<Scalars['String']>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type Tt_Client_Invite_Log_Max_Fields = {
  __typename?: 'tt_client_invite_log_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  invited_at?: Maybe<Scalars['timestamptz']>;
  invited_by?: Maybe<Scalars['uuid']>;
  invitees_list?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Tt_Client_Invite_Log_Min_Fields = {
  __typename?: 'tt_client_invite_log_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  invited_at?: Maybe<Scalars['timestamptz']>;
  invited_by?: Maybe<Scalars['uuid']>;
  invitees_list?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "tt_client_invite_log" */
export type Tt_Client_Invite_Log_Mutation_Response = {
  __typename?: 'tt_client_invite_log_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Tt_Client_Invite_Log>;
};

/** on_conflict condition type for table "tt_client_invite_log" */
export type Tt_Client_Invite_Log_On_Conflict = {
  constraint: Tt_Client_Invite_Log_Constraint;
  update_columns?: Array<Tt_Client_Invite_Log_Update_Column>;
  where?: InputMaybe<Tt_Client_Invite_Log_Bool_Exp>;
};

/** Ordering options when selecting data from "tt_client_invite_log". */
export type Tt_Client_Invite_Log_Order_By = {
  course?: InputMaybe<Course_Order_By>;
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invited_at?: InputMaybe<Order_By>;
  invited_by?: InputMaybe<Order_By>;
  invitees_list?: InputMaybe<Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
};

/** primary key columns input for table: tt_client_invite_log */
export type Tt_Client_Invite_Log_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "tt_client_invite_log" */
export enum Tt_Client_Invite_Log_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedAt = 'invited_at',
  /** column name */
  InvitedBy = 'invited_by',
  /** column name */
  InviteesList = 'invitees_list'
}

/** input type for updating data in table "tt_client_invite_log" */
export type Tt_Client_Invite_Log_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_at?: InputMaybe<Scalars['timestamptz']>;
  invited_by?: InputMaybe<Scalars['uuid']>;
  invitees_list?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Tt_Client_Invite_Log_Stddev_Fields = {
  __typename?: 'tt_client_invite_log_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Tt_Client_Invite_Log_Stddev_Pop_Fields = {
  __typename?: 'tt_client_invite_log_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Tt_Client_Invite_Log_Stddev_Samp_Fields = {
  __typename?: 'tt_client_invite_log_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "tt_client_invite_log" */
export type Tt_Client_Invite_Log_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Tt_Client_Invite_Log_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Tt_Client_Invite_Log_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  invited_at?: InputMaybe<Scalars['timestamptz']>;
  invited_by?: InputMaybe<Scalars['uuid']>;
  invitees_list?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Tt_Client_Invite_Log_Sum_Fields = {
  __typename?: 'tt_client_invite_log_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "tt_client_invite_log" */
export enum Tt_Client_Invite_Log_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  InvitedAt = 'invited_at',
  /** column name */
  InvitedBy = 'invited_by',
  /** column name */
  InviteesList = 'invitees_list'
}

export type Tt_Client_Invite_Log_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Tt_Client_Invite_Log_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Tt_Client_Invite_Log_Set_Input>;
  /** filter the rows which have to be updated */
  where: Tt_Client_Invite_Log_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Tt_Client_Invite_Log_Var_Pop_Fields = {
  __typename?: 'tt_client_invite_log_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Tt_Client_Invite_Log_Var_Samp_Fields = {
  __typename?: 'tt_client_invite_log_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Tt_Client_Invite_Log_Variance_Fields = {
  __typename?: 'tt_client_invite_log_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** columns and relationships of "upcoming_enrollments" */
export type Upcoming_Enrollments = {
  __typename?: 'upcoming_enrollments';
  certification_status?: Maybe<Scalars['String']>;
  /** An object relationship */
  course?: Maybe<Course>;
  courseId?: Maybe<Scalars['Int']>;
  courseLevel?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['uuid']>;
  orgName?: Maybe<Scalars['String']>;
  /** An object relationship */
  organization?: Maybe<Organization>;
  /** An object relationship */
  profile?: Maybe<Profile>;
  profileId?: Maybe<Scalars['uuid']>;
  scheduleStart?: Maybe<Scalars['timestamptz']>;
};

/** aggregated selection of "upcoming_enrollments" */
export type Upcoming_Enrollments_Aggregate = {
  __typename?: 'upcoming_enrollments_aggregate';
  aggregate?: Maybe<Upcoming_Enrollments_Aggregate_Fields>;
  nodes: Array<Upcoming_Enrollments>;
};

export type Upcoming_Enrollments_Aggregate_Bool_Exp = {
  count?: InputMaybe<Upcoming_Enrollments_Aggregate_Bool_Exp_Count>;
};

export type Upcoming_Enrollments_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Upcoming_Enrollments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Upcoming_Enrollments_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "upcoming_enrollments" */
export type Upcoming_Enrollments_Aggregate_Fields = {
  __typename?: 'upcoming_enrollments_aggregate_fields';
  avg?: Maybe<Upcoming_Enrollments_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Upcoming_Enrollments_Max_Fields>;
  min?: Maybe<Upcoming_Enrollments_Min_Fields>;
  stddev?: Maybe<Upcoming_Enrollments_Stddev_Fields>;
  stddev_pop?: Maybe<Upcoming_Enrollments_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Upcoming_Enrollments_Stddev_Samp_Fields>;
  sum?: Maybe<Upcoming_Enrollments_Sum_Fields>;
  var_pop?: Maybe<Upcoming_Enrollments_Var_Pop_Fields>;
  var_samp?: Maybe<Upcoming_Enrollments_Var_Samp_Fields>;
  variance?: Maybe<Upcoming_Enrollments_Variance_Fields>;
};


/** aggregate fields of "upcoming_enrollments" */
export type Upcoming_Enrollments_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Upcoming_Enrollments_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "upcoming_enrollments" */
export type Upcoming_Enrollments_Aggregate_Order_By = {
  avg?: InputMaybe<Upcoming_Enrollments_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Upcoming_Enrollments_Max_Order_By>;
  min?: InputMaybe<Upcoming_Enrollments_Min_Order_By>;
  stddev?: InputMaybe<Upcoming_Enrollments_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Upcoming_Enrollments_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Upcoming_Enrollments_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Upcoming_Enrollments_Sum_Order_By>;
  var_pop?: InputMaybe<Upcoming_Enrollments_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Upcoming_Enrollments_Var_Samp_Order_By>;
  variance?: InputMaybe<Upcoming_Enrollments_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "upcoming_enrollments" */
export type Upcoming_Enrollments_Arr_Rel_Insert_Input = {
  data: Array<Upcoming_Enrollments_Insert_Input>;
};

/** aggregate avg on columns */
export type Upcoming_Enrollments_Avg_Fields = {
  __typename?: 'upcoming_enrollments_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "upcoming_enrollments" */
export type Upcoming_Enrollments_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "upcoming_enrollments". All fields are combined with a logical 'AND'. */
export type Upcoming_Enrollments_Bool_Exp = {
  _and?: InputMaybe<Array<Upcoming_Enrollments_Bool_Exp>>;
  _not?: InputMaybe<Upcoming_Enrollments_Bool_Exp>;
  _or?: InputMaybe<Array<Upcoming_Enrollments_Bool_Exp>>;
  certification_status?: InputMaybe<String_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  courseLevel?: InputMaybe<String_Comparison_Exp>;
  orgId?: InputMaybe<Uuid_Comparison_Exp>;
  orgName?: InputMaybe<String_Comparison_Exp>;
  organization?: InputMaybe<Organization_Bool_Exp>;
  profile?: InputMaybe<Profile_Bool_Exp>;
  profileId?: InputMaybe<Uuid_Comparison_Exp>;
  scheduleStart?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** input type for inserting data into table "upcoming_enrollments" */
export type Upcoming_Enrollments_Insert_Input = {
  certification_status?: InputMaybe<Scalars['String']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  courseLevel?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['uuid']>;
  orgName?: InputMaybe<Scalars['String']>;
  organization?: InputMaybe<Organization_Obj_Rel_Insert_Input>;
  profile?: InputMaybe<Profile_Obj_Rel_Insert_Input>;
  profileId?: InputMaybe<Scalars['uuid']>;
  scheduleStart?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Upcoming_Enrollments_Max_Fields = {
  __typename?: 'upcoming_enrollments_max_fields';
  certification_status?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['Int']>;
  courseLevel?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['uuid']>;
  orgName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['uuid']>;
  scheduleStart?: Maybe<Scalars['timestamptz']>;
};

/** order by max() on columns of table "upcoming_enrollments" */
export type Upcoming_Enrollments_Max_Order_By = {
  certification_status?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  courseLevel?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  orgName?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  scheduleStart?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Upcoming_Enrollments_Min_Fields = {
  __typename?: 'upcoming_enrollments_min_fields';
  certification_status?: Maybe<Scalars['String']>;
  courseId?: Maybe<Scalars['Int']>;
  courseLevel?: Maybe<Scalars['String']>;
  orgId?: Maybe<Scalars['uuid']>;
  orgName?: Maybe<Scalars['String']>;
  profileId?: Maybe<Scalars['uuid']>;
  scheduleStart?: Maybe<Scalars['timestamptz']>;
};

/** order by min() on columns of table "upcoming_enrollments" */
export type Upcoming_Enrollments_Min_Order_By = {
  certification_status?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  courseLevel?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  orgName?: InputMaybe<Order_By>;
  profileId?: InputMaybe<Order_By>;
  scheduleStart?: InputMaybe<Order_By>;
};

/** Ordering options when selecting data from "upcoming_enrollments". */
export type Upcoming_Enrollments_Order_By = {
  certification_status?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  courseLevel?: InputMaybe<Order_By>;
  orgId?: InputMaybe<Order_By>;
  orgName?: InputMaybe<Order_By>;
  organization?: InputMaybe<Organization_Order_By>;
  profile?: InputMaybe<Profile_Order_By>;
  profileId?: InputMaybe<Order_By>;
  scheduleStart?: InputMaybe<Order_By>;
};

/** select columns of table "upcoming_enrollments" */
export enum Upcoming_Enrollments_Select_Column {
  /** column name */
  CertificationStatus = 'certification_status',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CourseLevel = 'courseLevel',
  /** column name */
  OrgId = 'orgId',
  /** column name */
  OrgName = 'orgName',
  /** column name */
  ProfileId = 'profileId',
  /** column name */
  ScheduleStart = 'scheduleStart'
}

/** aggregate stddev on columns */
export type Upcoming_Enrollments_Stddev_Fields = {
  __typename?: 'upcoming_enrollments_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "upcoming_enrollments" */
export type Upcoming_Enrollments_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Upcoming_Enrollments_Stddev_Pop_Fields = {
  __typename?: 'upcoming_enrollments_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "upcoming_enrollments" */
export type Upcoming_Enrollments_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Upcoming_Enrollments_Stddev_Samp_Fields = {
  __typename?: 'upcoming_enrollments_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "upcoming_enrollments" */
export type Upcoming_Enrollments_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "upcoming_enrollments" */
export type Upcoming_Enrollments_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Upcoming_Enrollments_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Upcoming_Enrollments_Stream_Cursor_Value_Input = {
  certification_status?: InputMaybe<Scalars['String']>;
  courseId?: InputMaybe<Scalars['Int']>;
  courseLevel?: InputMaybe<Scalars['String']>;
  orgId?: InputMaybe<Scalars['uuid']>;
  orgName?: InputMaybe<Scalars['String']>;
  profileId?: InputMaybe<Scalars['uuid']>;
  scheduleStart?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate sum on columns */
export type Upcoming_Enrollments_Sum_Fields = {
  __typename?: 'upcoming_enrollments_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "upcoming_enrollments" */
export type Upcoming_Enrollments_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate var_pop on columns */
export type Upcoming_Enrollments_Var_Pop_Fields = {
  __typename?: 'upcoming_enrollments_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "upcoming_enrollments" */
export type Upcoming_Enrollments_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Upcoming_Enrollments_Var_Samp_Fields = {
  __typename?: 'upcoming_enrollments_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "upcoming_enrollments" */
export type Upcoming_Enrollments_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Upcoming_Enrollments_Variance_Fields = {
  __typename?: 'upcoming_enrollments_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "upcoming_enrollments" */
export type Upcoming_Enrollments_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** columns and relationships of "user_auth_audit_type" */
export type User_Auth_Audit_Type = {
  __typename?: 'user_auth_audit_type';
  name: Scalars['String'];
};

/** aggregated selection of "user_auth_audit_type" */
export type User_Auth_Audit_Type_Aggregate = {
  __typename?: 'user_auth_audit_type_aggregate';
  aggregate?: Maybe<User_Auth_Audit_Type_Aggregate_Fields>;
  nodes: Array<User_Auth_Audit_Type>;
};

/** aggregate fields of "user_auth_audit_type" */
export type User_Auth_Audit_Type_Aggregate_Fields = {
  __typename?: 'user_auth_audit_type_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Auth_Audit_Type_Max_Fields>;
  min?: Maybe<User_Auth_Audit_Type_Min_Fields>;
};


/** aggregate fields of "user_auth_audit_type" */
export type User_Auth_Audit_Type_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Auth_Audit_Type_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_auth_audit_type". All fields are combined with a logical 'AND'. */
export type User_Auth_Audit_Type_Bool_Exp = {
  _and?: InputMaybe<Array<User_Auth_Audit_Type_Bool_Exp>>;
  _not?: InputMaybe<User_Auth_Audit_Type_Bool_Exp>;
  _or?: InputMaybe<Array<User_Auth_Audit_Type_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "user_auth_audit_type" */
export enum User_Auth_Audit_Type_Constraint {
  /** unique or primary key constraint on columns "name" */
  UserAuthAuditTypePkey = 'user_auth_audit_type_pkey'
}

export enum User_Auth_Audit_Type_Enum {
  ForgotPasswordStart = 'FORGOT_PASSWORD_START',
  ForgotPasswordSuccess = 'FORGOT_PASSWORD_SUCCESS',
  Login = 'LOGIN',
  ResetPassword = 'RESET_PASSWORD',
  SignUp = 'SIGN_UP'
}

/** Boolean expression to compare columns of type "user_auth_audit_type_enum". All fields are combined with logical 'AND'. */
export type User_Auth_Audit_Type_Enum_Comparison_Exp = {
  _eq?: InputMaybe<User_Auth_Audit_Type_Enum>;
  _in?: InputMaybe<Array<User_Auth_Audit_Type_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<User_Auth_Audit_Type_Enum>;
  _nin?: InputMaybe<Array<User_Auth_Audit_Type_Enum>>;
};

/** input type for inserting data into table "user_auth_audit_type" */
export type User_Auth_Audit_Type_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type User_Auth_Audit_Type_Max_Fields = {
  __typename?: 'user_auth_audit_type_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Auth_Audit_Type_Min_Fields = {
  __typename?: 'user_auth_audit_type_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_auth_audit_type" */
export type User_Auth_Audit_Type_Mutation_Response = {
  __typename?: 'user_auth_audit_type_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Auth_Audit_Type>;
};

/** on_conflict condition type for table "user_auth_audit_type" */
export type User_Auth_Audit_Type_On_Conflict = {
  constraint: User_Auth_Audit_Type_Constraint;
  update_columns?: Array<User_Auth_Audit_Type_Update_Column>;
  where?: InputMaybe<User_Auth_Audit_Type_Bool_Exp>;
};

/** Ordering options when selecting data from "user_auth_audit_type". */
export type User_Auth_Audit_Type_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: user_auth_audit_type */
export type User_Auth_Audit_Type_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "user_auth_audit_type" */
export enum User_Auth_Audit_Type_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "user_auth_audit_type" */
export type User_Auth_Audit_Type_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_auth_audit_type" */
export type User_Auth_Audit_Type_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Auth_Audit_Type_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Auth_Audit_Type_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_auth_audit_type" */
export enum User_Auth_Audit_Type_Update_Column {
  /** column name */
  Name = 'name'
}

export type User_Auth_Audit_Type_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Auth_Audit_Type_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Auth_Audit_Type_Bool_Exp;
};

/** columns and relationships of "user_auth_audits" */
export type User_Auth_Audits = {
  __typename?: 'user_auth_audits';
  created_at: Scalars['timestamptz'];
  event_type: User_Auth_Audit_Type_Enum;
  id: Scalars['uuid'];
  sub: Scalars['String'];
  /** An object relationship */
  sub_identity?: Maybe<Identity>;
};

/** aggregated selection of "user_auth_audits" */
export type User_Auth_Audits_Aggregate = {
  __typename?: 'user_auth_audits_aggregate';
  aggregate?: Maybe<User_Auth_Audits_Aggregate_Fields>;
  nodes: Array<User_Auth_Audits>;
};

/** aggregate fields of "user_auth_audits" */
export type User_Auth_Audits_Aggregate_Fields = {
  __typename?: 'user_auth_audits_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<User_Auth_Audits_Max_Fields>;
  min?: Maybe<User_Auth_Audits_Min_Fields>;
};


/** aggregate fields of "user_auth_audits" */
export type User_Auth_Audits_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<User_Auth_Audits_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "user_auth_audits". All fields are combined with a logical 'AND'. */
export type User_Auth_Audits_Bool_Exp = {
  _and?: InputMaybe<Array<User_Auth_Audits_Bool_Exp>>;
  _not?: InputMaybe<User_Auth_Audits_Bool_Exp>;
  _or?: InputMaybe<Array<User_Auth_Audits_Bool_Exp>>;
  created_at?: InputMaybe<Timestamptz_Comparison_Exp>;
  event_type?: InputMaybe<User_Auth_Audit_Type_Enum_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  sub?: InputMaybe<String_Comparison_Exp>;
  sub_identity?: InputMaybe<Identity_Bool_Exp>;
};

/** unique or primary key constraints on table "user_auth_audits" */
export enum User_Auth_Audits_Constraint {
  /** unique or primary key constraint on columns "id" */
  UserAuthAuditsPkey = 'user_auth_audits_pkey'
}

/** input type for inserting data into table "user_auth_audits" */
export type User_Auth_Audits_Insert_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_type?: InputMaybe<User_Auth_Audit_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  sub?: InputMaybe<Scalars['String']>;
  sub_identity?: InputMaybe<Identity_Obj_Rel_Insert_Input>;
};

/** aggregate max on columns */
export type User_Auth_Audits_Max_Fields = {
  __typename?: 'user_auth_audits_max_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  sub?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type User_Auth_Audits_Min_Fields = {
  __typename?: 'user_auth_audits_min_fields';
  created_at?: Maybe<Scalars['timestamptz']>;
  id?: Maybe<Scalars['uuid']>;
  sub?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "user_auth_audits" */
export type User_Auth_Audits_Mutation_Response = {
  __typename?: 'user_auth_audits_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<User_Auth_Audits>;
};

/** on_conflict condition type for table "user_auth_audits" */
export type User_Auth_Audits_On_Conflict = {
  constraint: User_Auth_Audits_Constraint;
  update_columns?: Array<User_Auth_Audits_Update_Column>;
  where?: InputMaybe<User_Auth_Audits_Bool_Exp>;
};

/** Ordering options when selecting data from "user_auth_audits". */
export type User_Auth_Audits_Order_By = {
  created_at?: InputMaybe<Order_By>;
  event_type?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  sub?: InputMaybe<Order_By>;
  sub_identity?: InputMaybe<Identity_Order_By>;
};

/** primary key columns input for table: user_auth_audits */
export type User_Auth_Audits_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "user_auth_audits" */
export enum User_Auth_Audits_Select_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Sub = 'sub'
}

/** input type for updating data in table "user_auth_audits" */
export type User_Auth_Audits_Set_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_type?: InputMaybe<User_Auth_Audit_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  sub?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "user_auth_audits" */
export type User_Auth_Audits_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: User_Auth_Audits_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type User_Auth_Audits_Stream_Cursor_Value_Input = {
  created_at?: InputMaybe<Scalars['timestamptz']>;
  event_type?: InputMaybe<User_Auth_Audit_Type_Enum>;
  id?: InputMaybe<Scalars['uuid']>;
  sub?: InputMaybe<Scalars['String']>;
};

/** update columns of table "user_auth_audits" */
export enum User_Auth_Audits_Update_Column {
  /** column name */
  CreatedAt = 'created_at',
  /** column name */
  EventType = 'event_type',
  /** column name */
  Id = 'id',
  /** column name */
  Sub = 'sub'
}

export type User_Auth_Audits_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<User_Auth_Audits_Set_Input>;
  /** filter the rows which have to be updated */
  where: User_Auth_Audits_Bool_Exp;
};

/** Boolean expression to compare columns of type "uuid". All fields are combined with logical 'AND'. */
export type Uuid_Comparison_Exp = {
  _eq?: InputMaybe<Scalars['uuid']>;
  _gt?: InputMaybe<Scalars['uuid']>;
  _gte?: InputMaybe<Scalars['uuid']>;
  _in?: InputMaybe<Array<Scalars['uuid']>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _lt?: InputMaybe<Scalars['uuid']>;
  _lte?: InputMaybe<Scalars['uuid']>;
  _neq?: InputMaybe<Scalars['uuid']>;
  _nin?: InputMaybe<Array<Scalars['uuid']>>;
};

/** columns and relationships of "venue" */
export type Venue = {
  __typename?: 'venue';
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  city: Scalars['String'];
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt: Scalars['timestamptz'];
  geoCoordinates?: Maybe<Scalars['point']>;
  googlePlacesId?: Maybe<Scalars['String']>;
  id: Scalars['uuid'];
  name: Scalars['String'];
  postCode?: Maybe<Scalars['String']>;
  /** An array relationship */
  schedule: Array<Course_Schedule>;
  /** An aggregate relationship */
  schedule_aggregate: Course_Schedule_Aggregate;
  updatedAt: Scalars['timestamptz'];
};


/** columns and relationships of "venue" */
export type VenueScheduleArgs = {
  distinct_on?: InputMaybe<Array<Course_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Schedule_Order_By>>;
  where?: InputMaybe<Course_Schedule_Bool_Exp>;
};


/** columns and relationships of "venue" */
export type VenueSchedule_AggregateArgs = {
  distinct_on?: InputMaybe<Array<Course_Schedule_Select_Column>>;
  limit?: InputMaybe<Scalars['Int']>;
  offset?: InputMaybe<Scalars['Int']>;
  order_by?: InputMaybe<Array<Course_Schedule_Order_By>>;
  where?: InputMaybe<Course_Schedule_Bool_Exp>;
};

/** aggregated selection of "venue" */
export type Venue_Aggregate = {
  __typename?: 'venue_aggregate';
  aggregate?: Maybe<Venue_Aggregate_Fields>;
  nodes: Array<Venue>;
};

/** aggregate fields of "venue" */
export type Venue_Aggregate_Fields = {
  __typename?: 'venue_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Venue_Max_Fields>;
  min?: Maybe<Venue_Min_Fields>;
};


/** aggregate fields of "venue" */
export type Venue_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Venue_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "venue". All fields are combined with a logical 'AND'. */
export type Venue_Bool_Exp = {
  _and?: InputMaybe<Array<Venue_Bool_Exp>>;
  _not?: InputMaybe<Venue_Bool_Exp>;
  _or?: InputMaybe<Array<Venue_Bool_Exp>>;
  addressLineOne?: InputMaybe<String_Comparison_Exp>;
  addressLineTwo?: InputMaybe<String_Comparison_Exp>;
  city?: InputMaybe<String_Comparison_Exp>;
  country?: InputMaybe<String_Comparison_Exp>;
  countryCode?: InputMaybe<String_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  geoCoordinates?: InputMaybe<Point_Comparison_Exp>;
  googlePlacesId?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  postCode?: InputMaybe<String_Comparison_Exp>;
  schedule?: InputMaybe<Course_Schedule_Bool_Exp>;
  schedule_aggregate?: InputMaybe<Course_Schedule_Aggregate_Bool_Exp>;
  updatedAt?: InputMaybe<Timestamptz_Comparison_Exp>;
};

/** Stores scheduled jobs ids for the venue existence check in the courses. */
export type Venue_Check_Jobs = {
  __typename?: 'venue_check_jobs';
  course_id: Scalars['Int'];
  id: Scalars['uuid'];
  job_id: Scalars['uuid'];
};

/** aggregated selection of "venue_check_jobs" */
export type Venue_Check_Jobs_Aggregate = {
  __typename?: 'venue_check_jobs_aggregate';
  aggregate?: Maybe<Venue_Check_Jobs_Aggregate_Fields>;
  nodes: Array<Venue_Check_Jobs>;
};

/** aggregate fields of "venue_check_jobs" */
export type Venue_Check_Jobs_Aggregate_Fields = {
  __typename?: 'venue_check_jobs_aggregate_fields';
  avg?: Maybe<Venue_Check_Jobs_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Venue_Check_Jobs_Max_Fields>;
  min?: Maybe<Venue_Check_Jobs_Min_Fields>;
  stddev?: Maybe<Venue_Check_Jobs_Stddev_Fields>;
  stddev_pop?: Maybe<Venue_Check_Jobs_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Venue_Check_Jobs_Stddev_Samp_Fields>;
  sum?: Maybe<Venue_Check_Jobs_Sum_Fields>;
  var_pop?: Maybe<Venue_Check_Jobs_Var_Pop_Fields>;
  var_samp?: Maybe<Venue_Check_Jobs_Var_Samp_Fields>;
  variance?: Maybe<Venue_Check_Jobs_Variance_Fields>;
};


/** aggregate fields of "venue_check_jobs" */
export type Venue_Check_Jobs_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Venue_Check_Jobs_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** aggregate avg on columns */
export type Venue_Check_Jobs_Avg_Fields = {
  __typename?: 'venue_check_jobs_avg_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "venue_check_jobs". All fields are combined with a logical 'AND'. */
export type Venue_Check_Jobs_Bool_Exp = {
  _and?: InputMaybe<Array<Venue_Check_Jobs_Bool_Exp>>;
  _not?: InputMaybe<Venue_Check_Jobs_Bool_Exp>;
  _or?: InputMaybe<Array<Venue_Check_Jobs_Bool_Exp>>;
  course_id?: InputMaybe<Int_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  job_id?: InputMaybe<Uuid_Comparison_Exp>;
};

/** unique or primary key constraints on table "venue_check_jobs" */
export enum Venue_Check_Jobs_Constraint {
  /** unique or primary key constraint on columns "job_id", "course_id" */
  VenueCheckJobsCourseIdJobIdKey = 'venue_check_jobs_course_id_job_id_key',
  /** unique or primary key constraint on columns "id" */
  VenueCheckJobsPkey = 'venue_check_jobs_pkey'
}

/** input type for incrementing numeric columns in table "venue_check_jobs" */
export type Venue_Check_Jobs_Inc_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "venue_check_jobs" */
export type Venue_Check_Jobs_Insert_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate max on columns */
export type Venue_Check_Jobs_Max_Fields = {
  __typename?: 'venue_check_jobs_max_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  job_id?: Maybe<Scalars['uuid']>;
};

/** aggregate min on columns */
export type Venue_Check_Jobs_Min_Fields = {
  __typename?: 'venue_check_jobs_min_fields';
  course_id?: Maybe<Scalars['Int']>;
  id?: Maybe<Scalars['uuid']>;
  job_id?: Maybe<Scalars['uuid']>;
};

/** response of any mutation on the table "venue_check_jobs" */
export type Venue_Check_Jobs_Mutation_Response = {
  __typename?: 'venue_check_jobs_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Venue_Check_Jobs>;
};

/** on_conflict condition type for table "venue_check_jobs" */
export type Venue_Check_Jobs_On_Conflict = {
  constraint: Venue_Check_Jobs_Constraint;
  update_columns?: Array<Venue_Check_Jobs_Update_Column>;
  where?: InputMaybe<Venue_Check_Jobs_Bool_Exp>;
};

/** Ordering options when selecting data from "venue_check_jobs". */
export type Venue_Check_Jobs_Order_By = {
  course_id?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  job_id?: InputMaybe<Order_By>;
};

/** primary key columns input for table: venue_check_jobs */
export type Venue_Check_Jobs_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "venue_check_jobs" */
export enum Venue_Check_Jobs_Select_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id'
}

/** input type for updating data in table "venue_check_jobs" */
export type Venue_Check_Jobs_Set_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate stddev on columns */
export type Venue_Check_Jobs_Stddev_Fields = {
  __typename?: 'venue_check_jobs_stddev_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Venue_Check_Jobs_Stddev_Pop_Fields = {
  __typename?: 'venue_check_jobs_stddev_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Venue_Check_Jobs_Stddev_Samp_Fields = {
  __typename?: 'venue_check_jobs_stddev_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "venue_check_jobs" */
export type Venue_Check_Jobs_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Venue_Check_Jobs_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Venue_Check_Jobs_Stream_Cursor_Value_Input = {
  course_id?: InputMaybe<Scalars['Int']>;
  id?: InputMaybe<Scalars['uuid']>;
  job_id?: InputMaybe<Scalars['uuid']>;
};

/** aggregate sum on columns */
export type Venue_Check_Jobs_Sum_Fields = {
  __typename?: 'venue_check_jobs_sum_fields';
  course_id?: Maybe<Scalars['Int']>;
};

/** update columns of table "venue_check_jobs" */
export enum Venue_Check_Jobs_Update_Column {
  /** column name */
  CourseId = 'course_id',
  /** column name */
  Id = 'id',
  /** column name */
  JobId = 'job_id'
}

export type Venue_Check_Jobs_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Venue_Check_Jobs_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Venue_Check_Jobs_Set_Input>;
  /** filter the rows which have to be updated */
  where: Venue_Check_Jobs_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Venue_Check_Jobs_Var_Pop_Fields = {
  __typename?: 'venue_check_jobs_var_pop_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Venue_Check_Jobs_Var_Samp_Fields = {
  __typename?: 'venue_check_jobs_var_samp_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Venue_Check_Jobs_Variance_Fields = {
  __typename?: 'venue_check_jobs_variance_fields';
  course_id?: Maybe<Scalars['Float']>;
};

/** unique or primary key constraints on table "venue" */
export enum Venue_Constraint {
  /** unique or primary key constraint on columns "id" */
  VenuePkey = 'venue_pkey'
}

/** input type for inserting data into table "venue" */
export type Venue_Insert_Input = {
  addressLineOne?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  geoCoordinates?: InputMaybe<Scalars['point']>;
  googlePlacesId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  postCode?: InputMaybe<Scalars['String']>;
  schedule?: InputMaybe<Course_Schedule_Arr_Rel_Insert_Input>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** aggregate max on columns */
export type Venue_Max_Fields = {
  __typename?: 'venue_max_fields';
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  googlePlacesId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** aggregate min on columns */
export type Venue_Min_Fields = {
  __typename?: 'venue_min_fields';
  addressLineOne?: Maybe<Scalars['String']>;
  addressLineTwo?: Maybe<Scalars['String']>;
  city?: Maybe<Scalars['String']>;
  country?: Maybe<Scalars['String']>;
  countryCode?: Maybe<Scalars['String']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  googlePlacesId?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  name?: Maybe<Scalars['String']>;
  postCode?: Maybe<Scalars['String']>;
  updatedAt?: Maybe<Scalars['timestamptz']>;
};

/** response of any mutation on the table "venue" */
export type Venue_Mutation_Response = {
  __typename?: 'venue_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Venue>;
};

/** input type for inserting object relation for remote table "venue" */
export type Venue_Obj_Rel_Insert_Input = {
  data: Venue_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Venue_On_Conflict>;
};

/** on_conflict condition type for table "venue" */
export type Venue_On_Conflict = {
  constraint: Venue_Constraint;
  update_columns?: Array<Venue_Update_Column>;
  where?: InputMaybe<Venue_Bool_Exp>;
};

/** Ordering options when selecting data from "venue". */
export type Venue_Order_By = {
  addressLineOne?: InputMaybe<Order_By>;
  addressLineTwo?: InputMaybe<Order_By>;
  city?: InputMaybe<Order_By>;
  country?: InputMaybe<Order_By>;
  countryCode?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  geoCoordinates?: InputMaybe<Order_By>;
  googlePlacesId?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  postCode?: InputMaybe<Order_By>;
  schedule_aggregate?: InputMaybe<Course_Schedule_Aggregate_Order_By>;
  updatedAt?: InputMaybe<Order_By>;
};

/** primary key columns input for table: venue */
export type Venue_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "venue" */
export enum Venue_Select_Column {
  /** column name */
  AddressLineOne = 'addressLineOne',
  /** column name */
  AddressLineTwo = 'addressLineTwo',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GeoCoordinates = 'geoCoordinates',
  /** column name */
  GooglePlacesId = 'googlePlacesId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PostCode = 'postCode',
  /** column name */
  UpdatedAt = 'updatedAt'
}

/** input type for updating data in table "venue" */
export type Venue_Set_Input = {
  addressLineOne?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  geoCoordinates?: InputMaybe<Scalars['point']>;
  googlePlacesId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  postCode?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** Streaming cursor of the table "venue" */
export type Venue_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Venue_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Venue_Stream_Cursor_Value_Input = {
  addressLineOne?: InputMaybe<Scalars['String']>;
  addressLineTwo?: InputMaybe<Scalars['String']>;
  city?: InputMaybe<Scalars['String']>;
  country?: InputMaybe<Scalars['String']>;
  countryCode?: InputMaybe<Scalars['String']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  geoCoordinates?: InputMaybe<Scalars['point']>;
  googlePlacesId?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  name?: InputMaybe<Scalars['String']>;
  postCode?: InputMaybe<Scalars['String']>;
  updatedAt?: InputMaybe<Scalars['timestamptz']>;
};

/** update columns of table "venue" */
export enum Venue_Update_Column {
  /** column name */
  AddressLineOne = 'addressLineOne',
  /** column name */
  AddressLineTwo = 'addressLineTwo',
  /** column name */
  City = 'city',
  /** column name */
  Country = 'country',
  /** column name */
  CountryCode = 'countryCode',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  GeoCoordinates = 'geoCoordinates',
  /** column name */
  GooglePlacesId = 'googlePlacesId',
  /** column name */
  Id = 'id',
  /** column name */
  Name = 'name',
  /** column name */
  PostCode = 'postCode',
  /** column name */
  UpdatedAt = 'updatedAt'
}

export type Venue_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Venue_Set_Input>;
  /** filter the rows which have to be updated */
  where: Venue_Bool_Exp;
};

/** columns and relationships of "waitlist" */
export type Waitlist = {
  __typename?: 'waitlist';
  cancellationSecret: Scalars['uuid'];
  confirmed: Scalars['Boolean'];
  /** An object relationship */
  course: Course;
  courseId: Scalars['Int'];
  createdAt: Scalars['timestamptz'];
  email: Scalars['String'];
  familyName: Scalars['String'];
  givenName: Scalars['String'];
  id: Scalars['uuid'];
  orgName: Scalars['String'];
  phone: Scalars['String'];
};

/** aggregated selection of "waitlist" */
export type Waitlist_Aggregate = {
  __typename?: 'waitlist_aggregate';
  aggregate?: Maybe<Waitlist_Aggregate_Fields>;
  nodes: Array<Waitlist>;
};

export type Waitlist_Aggregate_Bool_Exp = {
  bool_and?: InputMaybe<Waitlist_Aggregate_Bool_Exp_Bool_And>;
  bool_or?: InputMaybe<Waitlist_Aggregate_Bool_Exp_Bool_Or>;
  count?: InputMaybe<Waitlist_Aggregate_Bool_Exp_Count>;
};

export type Waitlist_Aggregate_Bool_Exp_Bool_And = {
  arguments: Waitlist_Select_Column_Waitlist_Aggregate_Bool_Exp_Bool_And_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Waitlist_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Waitlist_Aggregate_Bool_Exp_Bool_Or = {
  arguments: Waitlist_Select_Column_Waitlist_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Waitlist_Bool_Exp>;
  predicate: Boolean_Comparison_Exp;
};

export type Waitlist_Aggregate_Bool_Exp_Count = {
  arguments?: InputMaybe<Array<Waitlist_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
  filter?: InputMaybe<Waitlist_Bool_Exp>;
  predicate: Int_Comparison_Exp;
};

/** aggregate fields of "waitlist" */
export type Waitlist_Aggregate_Fields = {
  __typename?: 'waitlist_aggregate_fields';
  avg?: Maybe<Waitlist_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Waitlist_Max_Fields>;
  min?: Maybe<Waitlist_Min_Fields>;
  stddev?: Maybe<Waitlist_Stddev_Fields>;
  stddev_pop?: Maybe<Waitlist_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Waitlist_Stddev_Samp_Fields>;
  sum?: Maybe<Waitlist_Sum_Fields>;
  var_pop?: Maybe<Waitlist_Var_Pop_Fields>;
  var_samp?: Maybe<Waitlist_Var_Samp_Fields>;
  variance?: Maybe<Waitlist_Variance_Fields>;
};


/** aggregate fields of "waitlist" */
export type Waitlist_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Waitlist_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** order by aggregate values of table "waitlist" */
export type Waitlist_Aggregate_Order_By = {
  avg?: InputMaybe<Waitlist_Avg_Order_By>;
  count?: InputMaybe<Order_By>;
  max?: InputMaybe<Waitlist_Max_Order_By>;
  min?: InputMaybe<Waitlist_Min_Order_By>;
  stddev?: InputMaybe<Waitlist_Stddev_Order_By>;
  stddev_pop?: InputMaybe<Waitlist_Stddev_Pop_Order_By>;
  stddev_samp?: InputMaybe<Waitlist_Stddev_Samp_Order_By>;
  sum?: InputMaybe<Waitlist_Sum_Order_By>;
  var_pop?: InputMaybe<Waitlist_Var_Pop_Order_By>;
  var_samp?: InputMaybe<Waitlist_Var_Samp_Order_By>;
  variance?: InputMaybe<Waitlist_Variance_Order_By>;
};

/** input type for inserting array relation for remote table "waitlist" */
export type Waitlist_Arr_Rel_Insert_Input = {
  data: Array<Waitlist_Insert_Input>;
  /** upsert condition */
  on_conflict?: InputMaybe<Waitlist_On_Conflict>;
};

/** aggregate avg on columns */
export type Waitlist_Avg_Fields = {
  __typename?: 'waitlist_avg_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by avg() on columns of table "waitlist" */
export type Waitlist_Avg_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Boolean expression to filter rows from the table "waitlist". All fields are combined with a logical 'AND'. */
export type Waitlist_Bool_Exp = {
  _and?: InputMaybe<Array<Waitlist_Bool_Exp>>;
  _not?: InputMaybe<Waitlist_Bool_Exp>;
  _or?: InputMaybe<Array<Waitlist_Bool_Exp>>;
  cancellationSecret?: InputMaybe<Uuid_Comparison_Exp>;
  confirmed?: InputMaybe<Boolean_Comparison_Exp>;
  course?: InputMaybe<Course_Bool_Exp>;
  courseId?: InputMaybe<Int_Comparison_Exp>;
  createdAt?: InputMaybe<Timestamptz_Comparison_Exp>;
  email?: InputMaybe<String_Comparison_Exp>;
  familyName?: InputMaybe<String_Comparison_Exp>;
  givenName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  orgName?: InputMaybe<String_Comparison_Exp>;
  phone?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "waitlist" */
export enum Waitlist_Constraint {
  /** unique or primary key constraint on columns "cancellation_secret" */
  WaitlistCancellationSecretKey = 'waitlist_cancellation_secret_key',
  /** unique or primary key constraint on columns "email", "course_id" */
  WaitlistCourseIdEmailKey = 'waitlist_course_id_email_key',
  /** unique or primary key constraint on columns "id" */
  WaitlistPkey = 'waitlist_pkey'
}

/** input type for incrementing numeric columns in table "waitlist" */
export type Waitlist_Inc_Input = {
  courseId?: InputMaybe<Scalars['Int']>;
};

/** input type for inserting data into table "waitlist" */
export type Waitlist_Insert_Input = {
  cancellationSecret?: InputMaybe<Scalars['uuid']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  course?: InputMaybe<Course_Obj_Rel_Insert_Input>;
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  orgName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Waitlist_Max_Fields = {
  __typename?: 'waitlist_max_fields';
  cancellationSecret?: Maybe<Scalars['uuid']>;
  courseId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  orgName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** order by max() on columns of table "waitlist" */
export type Waitlist_Max_Order_By = {
  cancellationSecret?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  familyName?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgName?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
};

/** aggregate min on columns */
export type Waitlist_Min_Fields = {
  __typename?: 'waitlist_min_fields';
  cancellationSecret?: Maybe<Scalars['uuid']>;
  courseId?: Maybe<Scalars['Int']>;
  createdAt?: Maybe<Scalars['timestamptz']>;
  email?: Maybe<Scalars['String']>;
  familyName?: Maybe<Scalars['String']>;
  givenName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  orgName?: Maybe<Scalars['String']>;
  phone?: Maybe<Scalars['String']>;
};

/** order by min() on columns of table "waitlist" */
export type Waitlist_Min_Order_By = {
  cancellationSecret?: InputMaybe<Order_By>;
  courseId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  familyName?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgName?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
};

/** response of any mutation on the table "waitlist" */
export type Waitlist_Mutation_Response = {
  __typename?: 'waitlist_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Waitlist>;
};

/** on_conflict condition type for table "waitlist" */
export type Waitlist_On_Conflict = {
  constraint: Waitlist_Constraint;
  update_columns?: Array<Waitlist_Update_Column>;
  where?: InputMaybe<Waitlist_Bool_Exp>;
};

/** Ordering options when selecting data from "waitlist". */
export type Waitlist_Order_By = {
  cancellationSecret?: InputMaybe<Order_By>;
  confirmed?: InputMaybe<Order_By>;
  course?: InputMaybe<Course_Order_By>;
  courseId?: InputMaybe<Order_By>;
  createdAt?: InputMaybe<Order_By>;
  email?: InputMaybe<Order_By>;
  familyName?: InputMaybe<Order_By>;
  givenName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  orgName?: InputMaybe<Order_By>;
  phone?: InputMaybe<Order_By>;
};

/** primary key columns input for table: waitlist */
export type Waitlist_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** select columns of table "waitlist" */
export enum Waitlist_Select_Column {
  /** column name */
  CancellationSecret = 'cancellationSecret',
  /** column name */
  Confirmed = 'confirmed',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  OrgName = 'orgName',
  /** column name */
  Phone = 'phone'
}

/** select "waitlist_aggregate_bool_exp_bool_and_arguments_columns" columns of table "waitlist" */
export enum Waitlist_Select_Column_Waitlist_Aggregate_Bool_Exp_Bool_And_Arguments_Columns {
  /** column name */
  Confirmed = 'confirmed'
}

/** select "waitlist_aggregate_bool_exp_bool_or_arguments_columns" columns of table "waitlist" */
export enum Waitlist_Select_Column_Waitlist_Aggregate_Bool_Exp_Bool_Or_Arguments_Columns {
  /** column name */
  Confirmed = 'confirmed'
}

/** input type for updating data in table "waitlist" */
export type Waitlist_Set_Input = {
  cancellationSecret?: InputMaybe<Scalars['uuid']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  orgName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** aggregate stddev on columns */
export type Waitlist_Stddev_Fields = {
  __typename?: 'waitlist_stddev_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev() on columns of table "waitlist" */
export type Waitlist_Stddev_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_pop on columns */
export type Waitlist_Stddev_Pop_Fields = {
  __typename?: 'waitlist_stddev_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_pop() on columns of table "waitlist" */
export type Waitlist_Stddev_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate stddev_samp on columns */
export type Waitlist_Stddev_Samp_Fields = {
  __typename?: 'waitlist_stddev_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by stddev_samp() on columns of table "waitlist" */
export type Waitlist_Stddev_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Streaming cursor of the table "waitlist" */
export type Waitlist_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Waitlist_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Waitlist_Stream_Cursor_Value_Input = {
  cancellationSecret?: InputMaybe<Scalars['uuid']>;
  confirmed?: InputMaybe<Scalars['Boolean']>;
  courseId?: InputMaybe<Scalars['Int']>;
  createdAt?: InputMaybe<Scalars['timestamptz']>;
  email?: InputMaybe<Scalars['String']>;
  familyName?: InputMaybe<Scalars['String']>;
  givenName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  orgName?: InputMaybe<Scalars['String']>;
  phone?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Waitlist_Sum_Fields = {
  __typename?: 'waitlist_sum_fields';
  courseId?: Maybe<Scalars['Int']>;
};

/** order by sum() on columns of table "waitlist" */
export type Waitlist_Sum_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** update columns of table "waitlist" */
export enum Waitlist_Update_Column {
  /** column name */
  CancellationSecret = 'cancellationSecret',
  /** column name */
  Confirmed = 'confirmed',
  /** column name */
  CourseId = 'courseId',
  /** column name */
  CreatedAt = 'createdAt',
  /** column name */
  Email = 'email',
  /** column name */
  FamilyName = 'familyName',
  /** column name */
  GivenName = 'givenName',
  /** column name */
  Id = 'id',
  /** column name */
  OrgName = 'orgName',
  /** column name */
  Phone = 'phone'
}

export type Waitlist_Updates = {
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Waitlist_Inc_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Waitlist_Set_Input>;
  /** filter the rows which have to be updated */
  where: Waitlist_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Waitlist_Var_Pop_Fields = {
  __typename?: 'waitlist_var_pop_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_pop() on columns of table "waitlist" */
export type Waitlist_Var_Pop_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate var_samp on columns */
export type Waitlist_Var_Samp_Fields = {
  __typename?: 'waitlist_var_samp_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by var_samp() on columns of table "waitlist" */
export type Waitlist_Var_Samp_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** aggregate variance on columns */
export type Waitlist_Variance_Fields = {
  __typename?: 'waitlist_variance_fields';
  courseId?: Maybe<Scalars['Float']>;
};

/** order by variance() on columns of table "waitlist" */
export type Waitlist_Variance_Order_By = {
  courseId?: InputMaybe<Order_By>;
};

/** Xero contact stored on our end, and synced from Xero */
export type Xero_Contact = {
  __typename?: 'xero_contact';
  addresses?: Maybe<Scalars['jsonb']>;
  emailAddress?: Maybe<Scalars['String']>;
  firstName: Scalars['String'];
  id: Scalars['uuid'];
  lastName: Scalars['String'];
  name?: Maybe<Scalars['String']>;
  phones?: Maybe<Scalars['jsonb']>;
  xeroId: Scalars['String'];
};


/** Xero contact stored on our end, and synced from Xero */
export type Xero_ContactAddressesArgs = {
  path?: InputMaybe<Scalars['String']>;
};


/** Xero contact stored on our end, and synced from Xero */
export type Xero_ContactPhonesArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "xero_contact" */
export type Xero_Contact_Aggregate = {
  __typename?: 'xero_contact_aggregate';
  aggregate?: Maybe<Xero_Contact_Aggregate_Fields>;
  nodes: Array<Xero_Contact>;
};

/** aggregate fields of "xero_contact" */
export type Xero_Contact_Aggregate_Fields = {
  __typename?: 'xero_contact_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Xero_Contact_Max_Fields>;
  min?: Maybe<Xero_Contact_Min_Fields>;
};


/** aggregate fields of "xero_contact" */
export type Xero_Contact_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Xero_Contact_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Xero_Contact_Append_Input = {
  addresses?: InputMaybe<Scalars['jsonb']>;
  phones?: InputMaybe<Scalars['jsonb']>;
};

/** Boolean expression to filter rows from the table "xero_contact". All fields are combined with a logical 'AND'. */
export type Xero_Contact_Bool_Exp = {
  _and?: InputMaybe<Array<Xero_Contact_Bool_Exp>>;
  _not?: InputMaybe<Xero_Contact_Bool_Exp>;
  _or?: InputMaybe<Array<Xero_Contact_Bool_Exp>>;
  addresses?: InputMaybe<Jsonb_Comparison_Exp>;
  emailAddress?: InputMaybe<String_Comparison_Exp>;
  firstName?: InputMaybe<String_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  lastName?: InputMaybe<String_Comparison_Exp>;
  name?: InputMaybe<String_Comparison_Exp>;
  phones?: InputMaybe<Jsonb_Comparison_Exp>;
  xeroId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "xero_contact" */
export enum Xero_Contact_Constraint {
  /** unique or primary key constraint on columns "id" */
  XeroContactPkey = 'xero_contact_pkey',
  /** unique or primary key constraint on columns "xero_id" */
  XeroContactXeroIdKey = 'xero_contact_xero_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Xero_Contact_Delete_At_Path_Input = {
  addresses?: InputMaybe<Array<Scalars['String']>>;
  phones?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Xero_Contact_Delete_Elem_Input = {
  addresses?: InputMaybe<Scalars['Int']>;
  phones?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Xero_Contact_Delete_Key_Input = {
  addresses?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Scalars['String']>;
};

/** input type for inserting data into table "xero_contact" */
export type Xero_Contact_Insert_Input = {
  addresses?: InputMaybe<Scalars['jsonb']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Scalars['jsonb']>;
  xeroId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Xero_Contact_Max_Fields = {
  __typename?: 'xero_contact_max_fields';
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  xeroId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Xero_Contact_Min_Fields = {
  __typename?: 'xero_contact_min_fields';
  emailAddress?: Maybe<Scalars['String']>;
  firstName?: Maybe<Scalars['String']>;
  id?: Maybe<Scalars['uuid']>;
  lastName?: Maybe<Scalars['String']>;
  name?: Maybe<Scalars['String']>;
  xeroId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "xero_contact" */
export type Xero_Contact_Mutation_Response = {
  __typename?: 'xero_contact_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Xero_Contact>;
};

/** input type for inserting object relation for remote table "xero_contact" */
export type Xero_Contact_Obj_Rel_Insert_Input = {
  data: Xero_Contact_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Xero_Contact_On_Conflict>;
};

/** on_conflict condition type for table "xero_contact" */
export type Xero_Contact_On_Conflict = {
  constraint: Xero_Contact_Constraint;
  update_columns?: Array<Xero_Contact_Update_Column>;
  where?: InputMaybe<Xero_Contact_Bool_Exp>;
};

/** Ordering options when selecting data from "xero_contact". */
export type Xero_Contact_Order_By = {
  addresses?: InputMaybe<Order_By>;
  emailAddress?: InputMaybe<Order_By>;
  firstName?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  lastName?: InputMaybe<Order_By>;
  name?: InputMaybe<Order_By>;
  phones?: InputMaybe<Order_By>;
  xeroId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: xero_contact */
export type Xero_Contact_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Xero_Contact_Prepend_Input = {
  addresses?: InputMaybe<Scalars['jsonb']>;
  phones?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "xero_contact" */
export enum Xero_Contact_Select_Column {
  /** column name */
  Addresses = 'addresses',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Name = 'name',
  /** column name */
  Phones = 'phones',
  /** column name */
  XeroId = 'xeroId'
}

/** input type for updating data in table "xero_contact" */
export type Xero_Contact_Set_Input = {
  addresses?: InputMaybe<Scalars['jsonb']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Scalars['jsonb']>;
  xeroId?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "xero_contact" */
export type Xero_Contact_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Xero_Contact_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Xero_Contact_Stream_Cursor_Value_Input = {
  addresses?: InputMaybe<Scalars['jsonb']>;
  emailAddress?: InputMaybe<Scalars['String']>;
  firstName?: InputMaybe<Scalars['String']>;
  id?: InputMaybe<Scalars['uuid']>;
  lastName?: InputMaybe<Scalars['String']>;
  name?: InputMaybe<Scalars['String']>;
  phones?: InputMaybe<Scalars['jsonb']>;
  xeroId?: InputMaybe<Scalars['String']>;
};

/** update columns of table "xero_contact" */
export enum Xero_Contact_Update_Column {
  /** column name */
  Addresses = 'addresses',
  /** column name */
  EmailAddress = 'emailAddress',
  /** column name */
  FirstName = 'firstName',
  /** column name */
  Id = 'id',
  /** column name */
  LastName = 'lastName',
  /** column name */
  Name = 'name',
  /** column name */
  Phones = 'phones',
  /** column name */
  XeroId = 'xeroId'
}

export type Xero_Contact_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Xero_Contact_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Xero_Contact_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Xero_Contact_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Xero_Contact_Delete_Key_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Xero_Contact_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Xero_Contact_Set_Input>;
  /** filter the rows which have to be updated */
  where: Xero_Contact_Bool_Exp;
};

/** columns and relationships of "xero_credential" */
export type Xero_Credential = {
  __typename?: 'xero_credential';
  client_id: Scalars['String'];
  token: Scalars['String'];
};

/** aggregated selection of "xero_credential" */
export type Xero_Credential_Aggregate = {
  __typename?: 'xero_credential_aggregate';
  aggregate?: Maybe<Xero_Credential_Aggregate_Fields>;
  nodes: Array<Xero_Credential>;
};

/** aggregate fields of "xero_credential" */
export type Xero_Credential_Aggregate_Fields = {
  __typename?: 'xero_credential_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Xero_Credential_Max_Fields>;
  min?: Maybe<Xero_Credential_Min_Fields>;
};


/** aggregate fields of "xero_credential" */
export type Xero_Credential_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Xero_Credential_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "xero_credential". All fields are combined with a logical 'AND'. */
export type Xero_Credential_Bool_Exp = {
  _and?: InputMaybe<Array<Xero_Credential_Bool_Exp>>;
  _not?: InputMaybe<Xero_Credential_Bool_Exp>;
  _or?: InputMaybe<Array<Xero_Credential_Bool_Exp>>;
  client_id?: InputMaybe<String_Comparison_Exp>;
  token?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "xero_credential" */
export enum Xero_Credential_Constraint {
  /** unique or primary key constraint on columns "client_id" */
  XeroCredentialPkey = 'xero_credential_pkey'
}

/** input type for inserting data into table "xero_credential" */
export type Xero_Credential_Insert_Input = {
  client_id?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Xero_Credential_Max_Fields = {
  __typename?: 'xero_credential_max_fields';
  client_id?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Xero_Credential_Min_Fields = {
  __typename?: 'xero_credential_min_fields';
  client_id?: Maybe<Scalars['String']>;
  token?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "xero_credential" */
export type Xero_Credential_Mutation_Response = {
  __typename?: 'xero_credential_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Xero_Credential>;
};

/** on_conflict condition type for table "xero_credential" */
export type Xero_Credential_On_Conflict = {
  constraint: Xero_Credential_Constraint;
  update_columns?: Array<Xero_Credential_Update_Column>;
  where?: InputMaybe<Xero_Credential_Bool_Exp>;
};

/** Ordering options when selecting data from "xero_credential". */
export type Xero_Credential_Order_By = {
  client_id?: InputMaybe<Order_By>;
  token?: InputMaybe<Order_By>;
};

/** primary key columns input for table: xero_credential */
export type Xero_Credential_Pk_Columns_Input = {
  client_id: Scalars['String'];
};

/** select columns of table "xero_credential" */
export enum Xero_Credential_Select_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Token = 'token'
}

/** input type for updating data in table "xero_credential" */
export type Xero_Credential_Set_Input = {
  client_id?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "xero_credential" */
export type Xero_Credential_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Xero_Credential_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Xero_Credential_Stream_Cursor_Value_Input = {
  client_id?: InputMaybe<Scalars['String']>;
  token?: InputMaybe<Scalars['String']>;
};

/** update columns of table "xero_credential" */
export enum Xero_Credential_Update_Column {
  /** column name */
  ClientId = 'client_id',
  /** column name */
  Token = 'token'
}

export type Xero_Credential_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Xero_Credential_Set_Input>;
  /** filter the rows which have to be updated */
  where: Xero_Credential_Bool_Exp;
};

/** Invoice stored on our end, and synced from Xero */
export type Xero_Invoice = {
  __typename?: 'xero_invoice';
  _status: Xero_Invoice_Status_Enum;
  amountDue?: Maybe<Scalars['numeric']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  /** An object relationship */
  contact: Xero_Contact;
  currencyCode: Scalars['String'];
  dueDate: Scalars['timestamp'];
  fullyPaidOnDate?: Maybe<Scalars['timestamp']>;
  id: Scalars['uuid'];
  invoiceNumber?: Maybe<Scalars['String']>;
  issuedDate: Scalars['timestamp'];
  lineItems: Scalars['jsonb'];
  reference: Scalars['String'];
  /** Calculated invoice status that takes due_date into account */
  status?: Maybe<Scalars['String']>;
  subtotal: Scalars['numeric'];
  total: Scalars['numeric'];
  totalTax: Scalars['numeric'];
  xeroContactId: Scalars['String'];
  xeroId: Scalars['String'];
};


/** Invoice stored on our end, and synced from Xero */
export type Xero_InvoiceLineItemsArgs = {
  path?: InputMaybe<Scalars['String']>;
};

/** aggregated selection of "xero_invoice" */
export type Xero_Invoice_Aggregate = {
  __typename?: 'xero_invoice_aggregate';
  aggregate?: Maybe<Xero_Invoice_Aggregate_Fields>;
  nodes: Array<Xero_Invoice>;
};

/** aggregate fields of "xero_invoice" */
export type Xero_Invoice_Aggregate_Fields = {
  __typename?: 'xero_invoice_aggregate_fields';
  avg?: Maybe<Xero_Invoice_Avg_Fields>;
  count: Scalars['Int'];
  max?: Maybe<Xero_Invoice_Max_Fields>;
  min?: Maybe<Xero_Invoice_Min_Fields>;
  stddev?: Maybe<Xero_Invoice_Stddev_Fields>;
  stddev_pop?: Maybe<Xero_Invoice_Stddev_Pop_Fields>;
  stddev_samp?: Maybe<Xero_Invoice_Stddev_Samp_Fields>;
  sum?: Maybe<Xero_Invoice_Sum_Fields>;
  var_pop?: Maybe<Xero_Invoice_Var_Pop_Fields>;
  var_samp?: Maybe<Xero_Invoice_Var_Samp_Fields>;
  variance?: Maybe<Xero_Invoice_Variance_Fields>;
};


/** aggregate fields of "xero_invoice" */
export type Xero_Invoice_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Xero_Invoice_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** append existing jsonb value of filtered columns with new jsonb value */
export type Xero_Invoice_Append_Input = {
  lineItems?: InputMaybe<Scalars['jsonb']>;
};

/** aggregate avg on columns */
export type Xero_Invoice_Avg_Fields = {
  __typename?: 'xero_invoice_avg_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
};

/** Boolean expression to filter rows from the table "xero_invoice". All fields are combined with a logical 'AND'. */
export type Xero_Invoice_Bool_Exp = {
  _and?: InputMaybe<Array<Xero_Invoice_Bool_Exp>>;
  _not?: InputMaybe<Xero_Invoice_Bool_Exp>;
  _or?: InputMaybe<Array<Xero_Invoice_Bool_Exp>>;
  _status?: InputMaybe<Xero_Invoice_Status_Enum_Comparison_Exp>;
  amountDue?: InputMaybe<Numeric_Comparison_Exp>;
  amountPaid?: InputMaybe<Numeric_Comparison_Exp>;
  contact?: InputMaybe<Xero_Contact_Bool_Exp>;
  currencyCode?: InputMaybe<String_Comparison_Exp>;
  dueDate?: InputMaybe<Timestamp_Comparison_Exp>;
  fullyPaidOnDate?: InputMaybe<Timestamp_Comparison_Exp>;
  id?: InputMaybe<Uuid_Comparison_Exp>;
  invoiceNumber?: InputMaybe<String_Comparison_Exp>;
  issuedDate?: InputMaybe<Timestamp_Comparison_Exp>;
  lineItems?: InputMaybe<Jsonb_Comparison_Exp>;
  reference?: InputMaybe<String_Comparison_Exp>;
  status?: InputMaybe<String_Comparison_Exp>;
  subtotal?: InputMaybe<Numeric_Comparison_Exp>;
  total?: InputMaybe<Numeric_Comparison_Exp>;
  totalTax?: InputMaybe<Numeric_Comparison_Exp>;
  xeroContactId?: InputMaybe<String_Comparison_Exp>;
  xeroId?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "xero_invoice" */
export enum Xero_Invoice_Constraint {
  /** unique or primary key constraint on columns "invoice_number" */
  XeroInvoiceInvoiceNumberKey = 'xero_invoice_invoice_number_key',
  /** unique or primary key constraint on columns "id" */
  XeroInvoicePkey = 'xero_invoice_pkey',
  /** unique or primary key constraint on columns "xero_id" */
  XeroInvoiceXeroIdKey = 'xero_invoice_xero_id_key'
}

/** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
export type Xero_Invoice_Delete_At_Path_Input = {
  lineItems?: InputMaybe<Array<Scalars['String']>>;
};

/** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
export type Xero_Invoice_Delete_Elem_Input = {
  lineItems?: InputMaybe<Scalars['Int']>;
};

/** delete key/value pair or string element. key/value pairs are matched based on their key value */
export type Xero_Invoice_Delete_Key_Input = {
  lineItems?: InputMaybe<Scalars['String']>;
};

/** input type for incrementing numeric columns in table "xero_invoice" */
export type Xero_Invoice_Inc_Input = {
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  subtotal?: InputMaybe<Scalars['numeric']>;
  total?: InputMaybe<Scalars['numeric']>;
  totalTax?: InputMaybe<Scalars['numeric']>;
};

/** input type for inserting data into table "xero_invoice" */
export type Xero_Invoice_Insert_Input = {
  _status?: InputMaybe<Xero_Invoice_Status_Enum>;
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  contact?: InputMaybe<Xero_Contact_Obj_Rel_Insert_Input>;
  currencyCode?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['timestamp']>;
  fullyPaidOnDate?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['timestamp']>;
  lineItems?: InputMaybe<Scalars['jsonb']>;
  reference?: InputMaybe<Scalars['String']>;
  subtotal?: InputMaybe<Scalars['numeric']>;
  total?: InputMaybe<Scalars['numeric']>;
  totalTax?: InputMaybe<Scalars['numeric']>;
  xeroContactId?: InputMaybe<Scalars['String']>;
  xeroId?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Xero_Invoice_Max_Fields = {
  __typename?: 'xero_invoice_max_fields';
  amountDue?: Maybe<Scalars['numeric']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  currencyCode?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['timestamp']>;
  fullyPaidOnDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  issuedDate?: Maybe<Scalars['timestamp']>;
  reference?: Maybe<Scalars['String']>;
  /** Calculated invoice status that takes due_date into account */
  status?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['numeric']>;
  total?: Maybe<Scalars['numeric']>;
  totalTax?: Maybe<Scalars['numeric']>;
  xeroContactId?: Maybe<Scalars['String']>;
  xeroId?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Xero_Invoice_Min_Fields = {
  __typename?: 'xero_invoice_min_fields';
  amountDue?: Maybe<Scalars['numeric']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  currencyCode?: Maybe<Scalars['String']>;
  dueDate?: Maybe<Scalars['timestamp']>;
  fullyPaidOnDate?: Maybe<Scalars['timestamp']>;
  id?: Maybe<Scalars['uuid']>;
  invoiceNumber?: Maybe<Scalars['String']>;
  issuedDate?: Maybe<Scalars['timestamp']>;
  reference?: Maybe<Scalars['String']>;
  /** Calculated invoice status that takes due_date into account */
  status?: Maybe<Scalars['String']>;
  subtotal?: Maybe<Scalars['numeric']>;
  total?: Maybe<Scalars['numeric']>;
  totalTax?: Maybe<Scalars['numeric']>;
  xeroContactId?: Maybe<Scalars['String']>;
  xeroId?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "xero_invoice" */
export type Xero_Invoice_Mutation_Response = {
  __typename?: 'xero_invoice_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Xero_Invoice>;
};

/** input type for inserting object relation for remote table "xero_invoice" */
export type Xero_Invoice_Obj_Rel_Insert_Input = {
  data: Xero_Invoice_Insert_Input;
  /** upsert condition */
  on_conflict?: InputMaybe<Xero_Invoice_On_Conflict>;
};

/** on_conflict condition type for table "xero_invoice" */
export type Xero_Invoice_On_Conflict = {
  constraint: Xero_Invoice_Constraint;
  update_columns?: Array<Xero_Invoice_Update_Column>;
  where?: InputMaybe<Xero_Invoice_Bool_Exp>;
};

/** Ordering options when selecting data from "xero_invoice". */
export type Xero_Invoice_Order_By = {
  _status?: InputMaybe<Order_By>;
  amountDue?: InputMaybe<Order_By>;
  amountPaid?: InputMaybe<Order_By>;
  contact?: InputMaybe<Xero_Contact_Order_By>;
  currencyCode?: InputMaybe<Order_By>;
  dueDate?: InputMaybe<Order_By>;
  fullyPaidOnDate?: InputMaybe<Order_By>;
  id?: InputMaybe<Order_By>;
  invoiceNumber?: InputMaybe<Order_By>;
  issuedDate?: InputMaybe<Order_By>;
  lineItems?: InputMaybe<Order_By>;
  reference?: InputMaybe<Order_By>;
  status?: InputMaybe<Order_By>;
  subtotal?: InputMaybe<Order_By>;
  total?: InputMaybe<Order_By>;
  totalTax?: InputMaybe<Order_By>;
  xeroContactId?: InputMaybe<Order_By>;
  xeroId?: InputMaybe<Order_By>;
};

/** primary key columns input for table: xero_invoice */
export type Xero_Invoice_Pk_Columns_Input = {
  id: Scalars['uuid'];
};

/** prepend existing jsonb value of filtered columns with new jsonb value */
export type Xero_Invoice_Prepend_Input = {
  lineItems?: InputMaybe<Scalars['jsonb']>;
};

/** select columns of table "xero_invoice" */
export enum Xero_Invoice_Select_Column {
  /** column name */
  Status = '_status',
  /** column name */
  AmountDue = 'amountDue',
  /** column name */
  AmountPaid = 'amountPaid',
  /** column name */
  CurrencyCode = 'currencyCode',
  /** column name */
  DueDate = 'dueDate',
  /** column name */
  FullyPaidOnDate = 'fullyPaidOnDate',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceNumber = 'invoiceNumber',
  /** column name */
  IssuedDate = 'issuedDate',
  /** column name */
  LineItems = 'lineItems',
  /** column name */
  Reference = 'reference',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Total = 'total',
  /** column name */
  TotalTax = 'totalTax',
  /** column name */
  XeroContactId = 'xeroContactId',
  /** column name */
  XeroId = 'xeroId'
}

/** input type for updating data in table "xero_invoice" */
export type Xero_Invoice_Set_Input = {
  _status?: InputMaybe<Xero_Invoice_Status_Enum>;
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['timestamp']>;
  fullyPaidOnDate?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['timestamp']>;
  lineItems?: InputMaybe<Scalars['jsonb']>;
  reference?: InputMaybe<Scalars['String']>;
  subtotal?: InputMaybe<Scalars['numeric']>;
  total?: InputMaybe<Scalars['numeric']>;
  totalTax?: InputMaybe<Scalars['numeric']>;
  xeroContactId?: InputMaybe<Scalars['String']>;
  xeroId?: InputMaybe<Scalars['String']>;
};

/** columns and relationships of "xero_invoice_status" */
export type Xero_Invoice_Status = {
  __typename?: 'xero_invoice_status';
  name: Scalars['String'];
};

/** aggregated selection of "xero_invoice_status" */
export type Xero_Invoice_Status_Aggregate = {
  __typename?: 'xero_invoice_status_aggregate';
  aggregate?: Maybe<Xero_Invoice_Status_Aggregate_Fields>;
  nodes: Array<Xero_Invoice_Status>;
};

/** aggregate fields of "xero_invoice_status" */
export type Xero_Invoice_Status_Aggregate_Fields = {
  __typename?: 'xero_invoice_status_aggregate_fields';
  count: Scalars['Int'];
  max?: Maybe<Xero_Invoice_Status_Max_Fields>;
  min?: Maybe<Xero_Invoice_Status_Min_Fields>;
};


/** aggregate fields of "xero_invoice_status" */
export type Xero_Invoice_Status_Aggregate_FieldsCountArgs = {
  columns?: InputMaybe<Array<Xero_Invoice_Status_Select_Column>>;
  distinct?: InputMaybe<Scalars['Boolean']>;
};

/** Boolean expression to filter rows from the table "xero_invoice_status". All fields are combined with a logical 'AND'. */
export type Xero_Invoice_Status_Bool_Exp = {
  _and?: InputMaybe<Array<Xero_Invoice_Status_Bool_Exp>>;
  _not?: InputMaybe<Xero_Invoice_Status_Bool_Exp>;
  _or?: InputMaybe<Array<Xero_Invoice_Status_Bool_Exp>>;
  name?: InputMaybe<String_Comparison_Exp>;
};

/** unique or primary key constraints on table "xero_invoice_status" */
export enum Xero_Invoice_Status_Constraint {
  /** unique or primary key constraint on columns "name" */
  XeroInvoiceStatusPkey = 'xero_invoice_status_pkey'
}

export enum Xero_Invoice_Status_Enum {
  Authorised = 'AUTHORISED',
  Deleted = 'DELETED',
  Draft = 'DRAFT',
  Overdue = 'OVERDUE',
  Paid = 'PAID',
  Submitted = 'SUBMITTED',
  Voided = 'VOIDED'
}

/** Boolean expression to compare columns of type "xero_invoice_status_enum". All fields are combined with logical 'AND'. */
export type Xero_Invoice_Status_Enum_Comparison_Exp = {
  _eq?: InputMaybe<Xero_Invoice_Status_Enum>;
  _in?: InputMaybe<Array<Xero_Invoice_Status_Enum>>;
  _is_null?: InputMaybe<Scalars['Boolean']>;
  _neq?: InputMaybe<Xero_Invoice_Status_Enum>;
  _nin?: InputMaybe<Array<Xero_Invoice_Status_Enum>>;
};

/** input type for inserting data into table "xero_invoice_status" */
export type Xero_Invoice_Status_Insert_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** aggregate max on columns */
export type Xero_Invoice_Status_Max_Fields = {
  __typename?: 'xero_invoice_status_max_fields';
  name?: Maybe<Scalars['String']>;
};

/** aggregate min on columns */
export type Xero_Invoice_Status_Min_Fields = {
  __typename?: 'xero_invoice_status_min_fields';
  name?: Maybe<Scalars['String']>;
};

/** response of any mutation on the table "xero_invoice_status" */
export type Xero_Invoice_Status_Mutation_Response = {
  __typename?: 'xero_invoice_status_mutation_response';
  /** number of rows affected by the mutation */
  affected_rows: Scalars['Int'];
  /** data from the rows affected by the mutation */
  returning: Array<Xero_Invoice_Status>;
};

/** on_conflict condition type for table "xero_invoice_status" */
export type Xero_Invoice_Status_On_Conflict = {
  constraint: Xero_Invoice_Status_Constraint;
  update_columns?: Array<Xero_Invoice_Status_Update_Column>;
  where?: InputMaybe<Xero_Invoice_Status_Bool_Exp>;
};

/** Ordering options when selecting data from "xero_invoice_status". */
export type Xero_Invoice_Status_Order_By = {
  name?: InputMaybe<Order_By>;
};

/** primary key columns input for table: xero_invoice_status */
export type Xero_Invoice_Status_Pk_Columns_Input = {
  name: Scalars['String'];
};

/** select columns of table "xero_invoice_status" */
export enum Xero_Invoice_Status_Select_Column {
  /** column name */
  Name = 'name'
}

/** input type for updating data in table "xero_invoice_status" */
export type Xero_Invoice_Status_Set_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** Streaming cursor of the table "xero_invoice_status" */
export type Xero_Invoice_Status_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Xero_Invoice_Status_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Xero_Invoice_Status_Stream_Cursor_Value_Input = {
  name?: InputMaybe<Scalars['String']>;
};

/** update columns of table "xero_invoice_status" */
export enum Xero_Invoice_Status_Update_Column {
  /** column name */
  Name = 'name'
}

export type Xero_Invoice_Status_Updates = {
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Xero_Invoice_Status_Set_Input>;
  /** filter the rows which have to be updated */
  where: Xero_Invoice_Status_Bool_Exp;
};

/** aggregate stddev on columns */
export type Xero_Invoice_Stddev_Fields = {
  __typename?: 'xero_invoice_stddev_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_pop on columns */
export type Xero_Invoice_Stddev_Pop_Fields = {
  __typename?: 'xero_invoice_stddev_pop_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
};

/** aggregate stddev_samp on columns */
export type Xero_Invoice_Stddev_Samp_Fields = {
  __typename?: 'xero_invoice_stddev_samp_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
};

/** Streaming cursor of the table "xero_invoice" */
export type Xero_Invoice_Stream_Cursor_Input = {
  /** Stream column input with initial value */
  initial_value: Xero_Invoice_Stream_Cursor_Value_Input;
  /** cursor ordering */
  ordering?: InputMaybe<Cursor_Ordering>;
};

/** Initial value of the column from where the streaming should start */
export type Xero_Invoice_Stream_Cursor_Value_Input = {
  _status?: InputMaybe<Xero_Invoice_Status_Enum>;
  amountDue?: InputMaybe<Scalars['numeric']>;
  amountPaid?: InputMaybe<Scalars['numeric']>;
  currencyCode?: InputMaybe<Scalars['String']>;
  dueDate?: InputMaybe<Scalars['timestamp']>;
  fullyPaidOnDate?: InputMaybe<Scalars['timestamp']>;
  id?: InputMaybe<Scalars['uuid']>;
  invoiceNumber?: InputMaybe<Scalars['String']>;
  issuedDate?: InputMaybe<Scalars['timestamp']>;
  lineItems?: InputMaybe<Scalars['jsonb']>;
  reference?: InputMaybe<Scalars['String']>;
  subtotal?: InputMaybe<Scalars['numeric']>;
  total?: InputMaybe<Scalars['numeric']>;
  totalTax?: InputMaybe<Scalars['numeric']>;
  xeroContactId?: InputMaybe<Scalars['String']>;
  xeroId?: InputMaybe<Scalars['String']>;
};

/** aggregate sum on columns */
export type Xero_Invoice_Sum_Fields = {
  __typename?: 'xero_invoice_sum_fields';
  amountDue?: Maybe<Scalars['numeric']>;
  amountPaid?: Maybe<Scalars['numeric']>;
  subtotal?: Maybe<Scalars['numeric']>;
  total?: Maybe<Scalars['numeric']>;
  totalTax?: Maybe<Scalars['numeric']>;
};

/** update columns of table "xero_invoice" */
export enum Xero_Invoice_Update_Column {
  /** column name */
  Status = '_status',
  /** column name */
  AmountDue = 'amountDue',
  /** column name */
  AmountPaid = 'amountPaid',
  /** column name */
  CurrencyCode = 'currencyCode',
  /** column name */
  DueDate = 'dueDate',
  /** column name */
  FullyPaidOnDate = 'fullyPaidOnDate',
  /** column name */
  Id = 'id',
  /** column name */
  InvoiceNumber = 'invoiceNumber',
  /** column name */
  IssuedDate = 'issuedDate',
  /** column name */
  LineItems = 'lineItems',
  /** column name */
  Reference = 'reference',
  /** column name */
  Subtotal = 'subtotal',
  /** column name */
  Total = 'total',
  /** column name */
  TotalTax = 'totalTax',
  /** column name */
  XeroContactId = 'xeroContactId',
  /** column name */
  XeroId = 'xeroId'
}

export type Xero_Invoice_Updates = {
  /** append existing jsonb value of filtered columns with new jsonb value */
  _append?: InputMaybe<Xero_Invoice_Append_Input>;
  /** delete the field or element with specified path (for JSON arrays, negative integers count from the end) */
  _delete_at_path?: InputMaybe<Xero_Invoice_Delete_At_Path_Input>;
  /** delete the array element with specified index (negative integers count from the end). throws an error if top level container is not an array */
  _delete_elem?: InputMaybe<Xero_Invoice_Delete_Elem_Input>;
  /** delete key/value pair or string element. key/value pairs are matched based on their key value */
  _delete_key?: InputMaybe<Xero_Invoice_Delete_Key_Input>;
  /** increments the numeric columns with given value of the filtered values */
  _inc?: InputMaybe<Xero_Invoice_Inc_Input>;
  /** prepend existing jsonb value of filtered columns with new jsonb value */
  _prepend?: InputMaybe<Xero_Invoice_Prepend_Input>;
  /** sets the columns of the filtered rows to the given values */
  _set?: InputMaybe<Xero_Invoice_Set_Input>;
  /** filter the rows which have to be updated */
  where: Xero_Invoice_Bool_Exp;
};

/** aggregate var_pop on columns */
export type Xero_Invoice_Var_Pop_Fields = {
  __typename?: 'xero_invoice_var_pop_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
};

/** aggregate var_samp on columns */
export type Xero_Invoice_Var_Samp_Fields = {
  __typename?: 'xero_invoice_var_samp_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
};

/** aggregate variance on columns */
export type Xero_Invoice_Variance_Fields = {
  __typename?: 'xero_invoice_variance_fields';
  amountDue?: Maybe<Scalars['Float']>;
  amountPaid?: Maybe<Scalars['Float']>;
  subtotal?: Maybe<Scalars['Float']>;
  total?: Maybe<Scalars['Float']>;
  totalTax?: Maybe<Scalars['Float']>;
};

export type GetCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCountriesQuery = { __typename?: 'query_root', countries: Array<{ __typename?: 'country', name: string }> };

export type GetJobTitlesQueryVariables = Exact<{
  shard: Scalars['String']['input'];
}>;


export type GetJobTitlesQuery = { __typename?: 'query_root', jobTitles: Array<{ __typename?: 'job_title', title: string }> };

export type GetOrgInvitesQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Organization_Invites_Bool_Exp>;
}>;


export type GetOrgInvitesQuery = { __typename?: 'query_root', orgInvites: Array<{ __typename?: 'organization_invites', id: any, createdAt: any, updatedAt: any, email: string, status: string, isAdmin: boolean, profile?: { __typename?: 'profile', id: any, givenName?: string | null, country?: string | null, countryCode?: string | null, familyName?: string | null, fullName?: string | null, avatar?: string | null, title?: string | null, tags?: any | null, addresses: any, attributes: any, contactDetails: any, dietaryRestrictions?: string | null, disabilities?: string | null, archived?: boolean | null, preferences: any, createdAt: any, updatedAt: any, email?: string | null, phone?: string | null, phoneCountryCode?: string | null, dob?: any | null, jobTitle?: string | null, lastActivity?: any | null, organizations: Array<{ __typename?: 'organization_member', id: any, isAdmin?: boolean | null, position?: string | null, organization: { __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, affiliated_organisations: Array<{ __typename?: 'organization', id: any, name: string, address: any }>, main_organisation?: { __typename?: 'organization', id: any, name: string } | null } }>, roles: Array<{ __typename?: 'profile_role', role: { __typename?: 'role', id: any, name: string } }>, trainer_role_types: Array<{ __typename?: 'profile_trainer_role_type', trainer_role_type: { __typename?: 'trainer_role_type', id: any, name: string } }>, profile_trainer_agreement_types: Array<{ __typename?: 'profile_trainer_agreement_type', agreement_type: Trainer_Agreement_Type_Enum, id: any }> } | null, organization: { __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, main_organisation?: { __typename?: 'organization', id: any, name: string } | null } }>, total: { __typename?: 'organization_invites_aggregate', aggregate?: { __typename?: 'organization_invites_aggregate_fields', count: number } | null } };

export type DeleteOrgInviteMutationVariables = Exact<{
  inviteId: Scalars['uuid']['input'];
}>;


export type DeleteOrgInviteMutation = { __typename?: 'mutation_root', delete_organization_invites_by_pk?: { __typename?: 'organization_invites', id: any } | null };

export type RecreateOrgInviteMutationVariables = Exact<{
  inviteId: Scalars['uuid']['input'];
}>;


export type RecreateOrgInviteMutation = { __typename?: 'mutation_root', update_organization_invites_by_pk?: { __typename?: 'organization_invites', id: any } | null };

export type GetDfeRegisteredOrganisationQueryVariables = Exact<{
  name: Scalars['String']['input'];
  postcode: Scalars['String']['input'];
}>;


export type GetDfeRegisteredOrganisationQuery = { __typename?: 'query_root', dfe_establishment: Array<{ __typename?: 'dfe_establishment', registered: boolean, organizations: Array<{ __typename?: 'organization', id: any }> }> };

export type FindEstablishmentQueryVariables = Exact<{
  searchTerm: Scalars['String']['input'];
  where?: InputMaybe<Dfe_Establishment_Bool_Exp>;
}>;


export type FindEstablishmentQuery = { __typename?: 'query_root', establishments: Array<{ __typename?: 'dfe_establishment', id: any, urn: string, name: string, localAuthority: string, trustType?: string | null, trustName?: string | null, addressLineOne?: string | null, addressLineTwo?: string | null, addressLineThree?: string | null, town?: string | null, county?: string | null, postcode?: string | null, headTitle?: string | null, headFirstName?: string | null, headLastName?: string | null, headJobTitle?: string | null, ofstedRating?: string | null, ofstedLastInspection?: string | null }>, total: { __typename?: 'dfe_establishment_aggregate', aggregate?: { __typename?: 'dfe_establishment_aggregate_fields', count: number } | null } };

export type GetOrganizationsQueryVariables = Exact<{
  isNotShallow?: InputMaybe<Scalars['Boolean']['input']>;
  isShallow?: InputMaybe<Scalars['Boolean']['input']>;
  searchTerm: Scalars['String']['input'];
  where?: InputMaybe<Organization_Bool_Exp>;
}>;


export type GetOrganizationsQuery = { __typename?: 'query_root', orgs: Array<{ __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, members?: Array<{ __typename?: 'organization_member', profile: { __typename?: 'profile', lastActivity?: any | null } }>, main_organisation?: { __typename?: 'organization', id: any, name: string } | null }> };

export type GetRegionsByCountryQueryVariables = Exact<{
  country: Scalars['String']['input'];
}>;


export type GetRegionsByCountryQuery = { __typename?: 'query_root', regions: Array<{ __typename?: 'country_region', name: string }> };

export type GetOrgMembersQueryVariables = Exact<{
  id?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  email: Scalars['String']['input'];
}>;


export type GetOrgMembersQuery = { __typename?: 'query_root', members: Array<{ __typename?: 'organization_member', profile: { __typename?: 'profile', id: any, country?: string | null, countryCode?: string | null, email?: string | null, familyName?: string | null, fullName?: string | null, givenName?: string | null } }> };

export type FindVenuesQueryVariables = Exact<{
  query: Scalars['String']['input'];
  country?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type FindVenuesQuery = { __typename?: 'query_root', venues: Array<{ __typename?: 'venue', id: any, createdAt: any, updatedAt: any, name: string, city: string, addressLineOne?: string | null, addressLineTwo?: string | null, postCode?: string | null, country?: string | null, geoCoordinates?: any | null, googlePlacesId?: string | null }> };

export type InsertVenueMutationVariables = Exact<{
  venue: Venue_Insert_Input;
}>;


export type InsertVenueMutation = { __typename?: 'mutation_root', venue?: { __typename?: 'venue', id: any, createdAt: any, updatedAt: any, name: string, city: string, addressLineOne?: string | null, addressLineTwo?: string | null, postCode?: string | null, country?: string | null, geoCoordinates?: any | null, googlePlacesId?: string | null } | null };

export type LicensesHistoryBetweenDatesQueryVariables = Exact<{
  from: Scalars['timestamptz']['input'];
  to: Scalars['timestamptz']['input'];
}>;


export type LicensesHistoryBetweenDatesQuery = { __typename?: 'query_root', go1LicensesHistory: Array<{ __typename?: 'go1_licenses_history', id: any, captured_at: any, event: Go1_History_Events_Enum, payload?: any | null, balance: number, reservedBalance: number, change: number, organization: { __typename?: 'organization', name: string } }> };

export type GetDistinctCourseResidingCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDistinctCourseResidingCountriesQuery = { __typename?: 'query_root', course: Array<{ __typename?: 'course', residingCountry?: string | null }> };

export type GetDistinctCourseVenueCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDistinctCourseVenueCountriesQuery = { __typename?: 'query_root', venue: Array<{ __typename?: 'venue', countryCode?: string | null }> };

export type GetAnzDistinctCourseResidingCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnzDistinctCourseResidingCountriesQuery = { __typename?: 'query_root', course: Array<{ __typename?: 'course', residingCountry?: string | null }> };

export type GetAnzDistinctCourseVenueCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAnzDistinctCourseVenueCountriesQuery = { __typename?: 'query_root', venue: Array<{ __typename?: 'venue', countryCode?: string | null }> };

export type GetDistinctOrgResidingCountriesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetDistinctOrgResidingCountriesQuery = { __typename?: 'query_root', org_distinct_country_codes: Array<{ __typename?: 'org_distinct_country_codes', countrycode?: string | null }> };

export type InsertHubspotAuditMutationVariables = Exact<{
  object: Hubspot_Audit_Insert_Input;
}>;


export type InsertHubspotAuditMutation = { __typename?: 'mutation_root', insert_hubspot_audit_one?: { __typename?: 'hubspot_audit', id: any } | null };

export type LogUserAuthEventMutationVariables = Exact<{
  event_type: User_Auth_Audit_Type_Enum;
  sub: Scalars['String']['input'];
}>;


export type LogUserAuthEventMutation = { __typename?: 'mutation_root', insert_user_auth_audits_one?: { __typename?: 'user_auth_audits', id: any } | null };

export type GetProfileByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetProfileByIdQuery = { __typename?: 'query_root', profile?: { __typename?: 'profile', id: any, givenName?: string | null, country?: string | null, countryCode?: string | null, familyName?: string | null, fullName?: string | null, avatar?: string | null, title?: string | null, tags?: any | null, addresses: any, attributes: any, contactDetails: any, dietaryRestrictions?: string | null, disabilities?: string | null, archived?: boolean | null, preferences: any, createdAt: any, updatedAt: any, email?: string | null, phone?: string | null, phoneCountryCode?: string | null, dob?: any | null, jobTitle?: string | null, lastActivity?: any | null, managedOrgIds: Array<{ __typename?: 'organization_member', organization_id: any, organization: { __typename?: 'organization', affiliated_organisations: Array<{ __typename?: 'organization', id: any }> } }>, trainerRoles: Array<{ __typename?: 'profile_trainer_role_type', trainer_role_type: { __typename?: 'trainer_role_type', name: string } }>, certificates: Array<{ __typename?: 'course_certificate', courseLevel: string, expiryDate: any, grade?: string | null, isRevoked: boolean, status?: Certificate_Status_Enum | null }>, courses: Array<{ __typename?: 'course_participant', grade?: Grade_Enum | null, course: { __typename?: 'course', level: Course_Level_Enum, start: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', date?: { __typename?: 'course_schedule_max_fields', start?: any | null } | null } | null }, end: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', date?: { __typename?: 'course_schedule_max_fields', end?: any | null } | null } | null } } }>, splashScreens: Array<{ __typename?: 'submission_of_splash_screens', id: any, splash_screen: Splash_Screens_Enum, seen_count?: number | null }>, organizations: Array<{ __typename?: 'organization_member', id: any, isAdmin?: boolean | null, position?: string | null, organization: { __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, affiliated_organisations: Array<{ __typename?: 'organization', id: any, name: string, address: any }>, main_organisation?: { __typename?: 'organization', id: any, name: string } | null } }>, roles: Array<{ __typename?: 'profile_role', role: { __typename?: 'role', id: any, name: string } }>, trainer_role_types: Array<{ __typename?: 'profile_trainer_role_type', trainer_role_type: { __typename?: 'trainer_role_type', id: any, name: string } }>, profile_trainer_agreement_types: Array<{ __typename?: 'profile_trainer_agreement_type', agreement_type: Trainer_Agreement_Type_Enum, id: any }> } | null };

export type InsertOrgLeadMutationVariables = Exact<{
  name: Scalars['String']['input'];
  sector: Scalars['String']['input'];
  orgType: Scalars['String']['input'];
  address: Scalars['jsonb']['input'];
  attributes?: InputMaybe<Scalars['jsonb']['input']>;
  dfeId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type InsertOrgLeadMutation = { __typename?: 'mutation_root', org?: { __typename?: 'organization', id: any, name: string } | null };

export type StripeCreatePaymentMutationVariables = Exact<{
  input: StripeCreatePaymentIntentInput;
}>;


export type StripeCreatePaymentMutation = { __typename?: 'mutation_root', paymentIntent?: { __typename?: 'StripeCreatePaymentIntentOutput', clientSecret: string, amount: number, currency: Currency } | null };

export type AcceptInviteMutationVariables = Exact<{
  inviteId: Scalars['uuid']['input'];
  courseId: Scalars['Int']['input'];
}>;


export type AcceptInviteMutation = { __typename?: 'mutation_root', acceptInvite?: { __typename?: 'course_invites', status?: Course_Invite_Status_Enum | null } | null, addParticipant?: { __typename?: 'course_participant', id: any } | null };

export type GetCourseParticipantByInviteQueryVariables = Exact<{
  inviteId: Scalars['uuid']['input'];
  courseId: Scalars['Int']['input'];
}>;


export type GetCourseParticipantByInviteQuery = { __typename?: 'query_root', course_participant: Array<{ __typename?: 'course_participant', id: any }> };

export type AcceptOrgInviteMutationVariables = Exact<{
  profileId: Scalars['String']['input'];
}>;


export type AcceptOrgInviteMutation = { __typename?: 'mutation_root', invite?: { __typename?: 'AcceptOrgInviteOutput', id?: any | null } | null };

export type ArloCallbackMutationVariables = Exact<{
  input: ArloCallbackInput;
}>;


export type ArloCallbackMutation = { __typename?: 'mutation_root', arloCallback?: { __typename?: 'ArloCallbackOutput', status: boolean } | null };

export type GetAttendeeAuditLogsQueryVariables = Exact<{
  where: Course_Participant_Audit_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Course_Participant_Audit_Order_By> | Course_Participant_Audit_Order_By>;
}>;


export type GetAttendeeAuditLogsQuery = { __typename?: 'query_root', logs: Array<{ __typename?: 'course_participant_audit', id: any, created_at: any, updated_at: any, xero_invoice_number?: string | null, payload: any, newAttendeeEmail?: string | null, authorizedBy: { __typename?: 'profile', id: any, avatar?: string | null, fullName?: string | null, archived?: boolean | null }, profile: { __typename?: 'profile', id: any, avatar?: string | null, fullName?: string | null, email?: string | null, archived?: boolean | null, organizations: Array<{ __typename?: 'organization_member', organization: { __typename?: 'organization', id: any, name: string } }> }, course: { __typename?: 'course', id: number, course_code?: string | null, type: Course_Type_Enum, orders: Array<{ __typename?: 'course_order', order?: { __typename?: 'order', id: any, xeroInvoiceNumber?: string | null } | null }> }, fromCourse?: Array<{ __typename?: 'course', id: number, course_code?: string | null }> | null, toCourse?: Array<{ __typename?: 'course', id: number, course_code?: string | null }> | null }>, logsAggregate: { __typename?: 'course_participant_audit_aggregate', aggregate?: { __typename?: 'course_participant_audit_aggregate_fields', count: number } | null } };

export type GetCourseAuditLogsQueryVariables = Exact<{
  where: Course_Audit_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Course_Audit_Order_By> | Course_Audit_Order_By>;
  fromExceptionsLog?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCourseAuditLogsQuery = { __typename?: 'query_root', logs: Array<{ __typename?: 'course_audit', id: any, created_at: any, updated_at: any, xero_invoice_number?: string | null, payload: any, authorizedBy?: { __typename?: 'profile', id: any, avatar?: string | null, fullName?: string | null } | null, course: { __typename?: 'course', id: number, course_code?: string | null, type: Course_Type_Enum, start?: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', date?: { __typename?: 'course_schedule_max_fields', start?: any | null } | null } | null }, organization?: { __typename?: 'organization', name: string, id: any } | null, trainers?: Array<{ __typename?: 'course_trainer', type: Course_Trainer_Type_Enum, id: any, profile: { __typename?: 'profile', fullName?: string | null, avatar?: string | null, id: any } }>, orders: Array<{ __typename?: 'course_order', order?: { __typename?: 'order', id: any, xeroInvoiceNumber?: string | null } | null }> } }>, logsAggregate: { __typename?: 'course_audit_aggregate', aggregate?: { __typename?: 'course_audit_aggregate_fields', count: number } | null } };

export type GetUserByMailQueryVariables = Exact<{
  email?: InputMaybe<Array<Scalars['String']['input']> | Scalars['String']['input']>;
}>;


export type GetUserByMailQuery = { __typename?: 'query_root', profile: Array<{ __typename?: 'profile', id: any, email?: string | null }> };

export type GetContactsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Profile_Order_By> | Profile_Order_By>;
  where?: InputMaybe<Profile_Bool_Exp>;
}>;


export type GetContactsQuery = { __typename?: 'query_root', profiles: Array<{ __typename?: 'profile', id: any, givenName?: string | null, country?: string | null, countryCode?: string | null, familyName?: string | null, fullName?: string | null, avatar?: string | null, title?: string | null, tags?: any | null, addresses: any, attributes: any, contactDetails: any, dietaryRestrictions?: string | null, disabilities?: string | null, archived?: boolean | null, preferences: any, createdAt: any, updatedAt: any, email?: string | null, phone?: string | null, phoneCountryCode?: string | null, dob?: any | null, jobTitle?: string | null, lastActivity?: any | null, organizations: Array<{ __typename?: 'organization_member', id: any, isAdmin?: boolean | null, position?: string | null, organization: { __typename?: 'organization', name: string, id: any, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, affiliated_organisations: Array<{ __typename?: 'organization', id: any, name: string, address: any }>, main_organisation?: { __typename?: 'organization', id: any, name: string } | null } }>, roles: Array<{ __typename?: 'profile_role', role: { __typename?: 'role', name: string, id: any } }>, trainer_role_types: Array<{ __typename?: 'profile_trainer_role_type', trainer_role_type: { __typename?: 'trainer_role_type', id: any, name: string } }>, profile_trainer_agreement_types: Array<{ __typename?: 'profile_trainer_agreement_type', agreement_type: Trainer_Agreement_Type_Enum, id: any }> }>, profilesAggregation: { __typename?: 'profile_aggregate', aggregate?: { __typename?: 'profile_aggregate_fields', count: number } | null } };

export type SearchCourseFragment = { __typename?: 'course', id: number, name: string, level: Course_Level_Enum, deliveryType: Course_Delivery_Type_Enum, schedule: Array<{ __typename?: 'course_schedule', start: any, venue?: { __typename?: 'venue', city: string } | null }> };

export type SearchCoursesQueryVariables = Exact<{
  where: Course_Bool_Exp;
  selectedIds: Array<Scalars['Int']['input']> | Scalars['Int']['input'];
}>;


export type SearchCoursesQuery = { __typename?: 'query_root', selectedCourses: Array<{ __typename?: 'course', id: number, name: string, level: Course_Level_Enum, deliveryType: Course_Delivery_Type_Enum, schedule: Array<{ __typename?: 'course_schedule', start: any, venue?: { __typename?: 'venue', city: string } | null }> }>, courses: Array<{ __typename?: 'course', id: number, name: string, level: Course_Level_Enum, deliveryType: Course_Delivery_Type_Enum, schedule: Array<{ __typename?: 'course_schedule', start: any, venue?: { __typename?: 'venue', city: string } | null }> }> };

export type ApproveCodeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  approvedBy?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type ApproveCodeMutation = { __typename?: 'mutation_root', update_promo_code_by_pk?: { __typename?: 'promo_code', id: any } | null };

export type DenyCodeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  deniedBy?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type DenyCodeMutation = { __typename?: 'mutation_root', update_promo_code_by_pk?: { __typename?: 'promo_code', id: any } | null };

export type DisablePromoCodeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DisablePromoCodeMutation = { __typename?: 'mutation_root', update_promo_code?: { __typename?: 'promo_code_mutation_response', affected_rows: number } | null };

export type GetPromoCodesPendingApprovalQueryVariables = Exact<{ [key: string]: never; }>;


export type GetPromoCodesPendingApprovalQuery = { __typename?: 'query_root', promoCodes: Array<{ __typename?: 'promo_code', id: any, code: string, description?: string | null, type: Promo_Code_Type_Enum, amount: any, validFrom: any, validTo?: any | null, bookerSingleUse: boolean, usesMax?: any | null, levels: any, disabled: boolean, enabled: boolean, approvedBy?: any | null, createdBy: any, createdAt: any, updatedAt: any, courses: Array<{ __typename?: 'course_promo_code', course?: { __typename?: 'course', id: number, course_code?: string | null } | null }>, creator: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null } }> };

export type UpsertPromoCodeMutationVariables = Exact<{
  promoCondition?: InputMaybe<Promo_Code_Bool_Exp>;
  promoCode: Promo_Code_Insert_Input;
}>;


export type UpsertPromoCodeMutation = { __typename?: 'mutation_root', delete_course_promo_code?: { __typename?: 'course_promo_code_mutation_response', affected_rows: number } | null, insert_promo_code_one?: { __typename?: 'promo_code', id: any } | null };

export type GetPricingQueryVariables = Exact<{
  where?: InputMaybe<Course_Pricing_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  priceCurrency?: InputMaybe<Scalars['String']['input']>;
}>;


export type GetPricingQuery = { __typename?: 'query_root', course_pricing: Array<{ __typename?: 'course_pricing', id: any, level: Course_Level_Enum, priceAmount: any, priceCurrency: string, reaccreditation: boolean, type: Course_Type_Enum, xeroCode: string, blended: boolean, updatedAt?: any | null, pricingSchedules: Array<{ __typename?: 'course_pricing_schedule', id: any, coursePricingId?: any | null, effectiveFrom: any, effectiveTo?: any | null, priceAmount: any, priceCurrency: string }>, pricingSchedules_aggregate: { __typename?: 'course_pricing_schedule_aggregate', aggregate?: { __typename?: 'course_pricing_schedule_aggregate_fields', count: number } | null, nodes: Array<{ __typename?: 'course_pricing_schedule', id: any, coursePricingId?: any | null, effectiveFrom: any, effectiveTo?: any | null, priceAmount: any, priceCurrency: string }> } }>, course_pricing_aggregate: { __typename?: 'course_pricing_aggregate', aggregate?: { __typename?: 'course_pricing_aggregate_fields', count: number } | null } };

export type DeleteCoursePricingScheduleMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteCoursePricingScheduleMutation = { __typename?: 'mutation_root', delete_course_pricing_schedule_by_pk?: { __typename?: 'course_pricing_schedule', id: any } | null };

export type InsertCoursePricingScheduleMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  coursePricingId: Scalars['uuid']['input'];
  priceAmount: Scalars['numeric']['input'];
  effectiveFrom: Scalars['date']['input'];
  effectiveTo?: InputMaybe<Scalars['date']['input']>;
  priceCurrency: Scalars['String']['input'];
}>;


export type InsertCoursePricingScheduleMutation = { __typename?: 'mutation_root', course_pricing_schedule?: { __typename?: 'course_pricing_schedule', id: any } | null };

export type SetCoursePricingScheduleMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  priceAmount: Scalars['numeric']['input'];
  effectiveFrom: Scalars['date']['input'];
  effectiveTo?: InputMaybe<Scalars['date']['input']>;
}>;


export type SetCoursePricingScheduleMutation = { __typename?: 'mutation_root', update_course_pricing_schedule_by_pk?: { __typename?: 'course_pricing_schedule', id: any } | null };

export type SetCoursePricingMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  priceAmount: Scalars['numeric']['input'];
}>;


export type SetCoursePricingMutation = { __typename?: 'mutation_root', update_course_pricing_by_pk?: { __typename?: 'course_pricing', id: any } | null };

export type SetCoursePricingBulkMutationVariables = Exact<{
  newPrice: Scalars['numeric']['input'];
  coursePricingIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type SetCoursePricingBulkMutation = { __typename?: 'mutation_root', update_course_pricing?: { __typename?: 'course_pricing_mutation_response', affected_rows: number } | null };

export type PricingChangelogQueryVariables = Exact<{
  where?: InputMaybe<Course_Pricing_Changelog_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type PricingChangelogQuery = { __typename?: 'query_root', course_pricing_changelog: Array<{ __typename?: 'course_pricing_changelog', id: any, createdAt: any, newEffectiveFrom?: any | null, newEffectiveTo?: any | null, newPrice?: any | null, oldEffectiveFrom?: any | null, oldEffectiveTo?: any | null, oldPrice?: any | null, indefiniteEffectiveTo: boolean, author?: { __typename?: 'profile', id: any, archived?: boolean | null, avatar?: string | null, fullName?: string | null } | null, coursePricing: { __typename?: 'course_pricing', priceCurrency: string }, courseSchedulePrice?: { __typename?: 'course_pricing_schedule', effectiveFrom: any, effectiveTo?: any | null } | null }>, course_pricing_changelog_aggregate: { __typename?: 'course_pricing_changelog_aggregate', aggregate?: { __typename?: 'course_pricing_changelog_aggregate_fields', count: number } | null } };

export type GetCoursesWithPricingQueryVariables = Exact<{
  pricingStartBeforeChange: Scalars['timestamptz']['input'];
  pricingEndBeforeChange: Scalars['timestamptz']['input'];
  pricingStartAfterChange: Scalars['timestamptz']['input'];
  pricingEndAfterChange: Scalars['timestamptz']['input'];
  where?: Course_Bool_Exp;
}>;


export type GetCoursesWithPricingQuery = { __typename?: 'query_root', courses: Array<{ __typename?: 'course', id: number, course_code?: string | null }>, course_aggregate: { __typename?: 'course_aggregate', aggregate?: { __typename?: 'course_aggregate_fields', count: number } | null } };

export type XeroConnectQueryVariables = Exact<{ [key: string]: never; }>;


export type XeroConnectQuery = { __typename?: 'query_root', xeroConnect?: { __typename?: 'XeroConnectOutput', consentUrl?: string | null } | null };

export type XeroCallbackMutationVariables = Exact<{
  input: XeroCallbackInput;
}>;


export type XeroCallbackMutation = { __typename?: 'mutation_root', xeroCallback?: { __typename?: 'XeroCallbackOutput', status: boolean } | null };

export type OrganizationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Organization_Order_By> | Organization_Order_By>;
}>;


export type OrganizationsQuery = { __typename?: 'query_root', organizations: Array<{ __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, members_aggregate: { __typename?: 'organization_member_aggregate', aggregate?: { __typename?: 'organization_member_aggregate_fields', count: number } | null }, main_organisation?: { __typename?: 'organization', id: any, name: string } | null }>, organizationsAggregation: { __typename?: 'organization_aggregate', aggregate?: { __typename?: 'organization_aggregate_fields', count: number } | null } };

export type GetUpcomingCoursesQueryVariables = Exact<{
  courseFilter?: InputMaybe<Course_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetUpcomingCoursesQuery = { __typename?: 'query_root', courses: Array<{ __typename?: 'course', accreditedBy: Accreditors_Enum, id: number, aolCostOfCourse?: any | null, aolCountry?: string | null, aolRegion?: string | null, course_code?: string | null, createdAt: any, deliveryType: Course_Delivery_Type_Enum, go1Integration: boolean, gradingConfirmed: boolean, gradingStarted: boolean, is_tender: boolean, level: Course_Level_Enum, max_participants: number, min_participants: number, modulesDuration: number, name: string, reaccreditation?: boolean | null, region?: string | null, residingCountry?: string | null, status?: Course_Status_Enum | null, type: Course_Type_Enum, updatedAt: any, schedules: Array<{ __typename?: 'course_schedule', start: any, end: any, virtualLink?: string | null, timeZone: string, venue?: { __typename?: 'venue', name: string, addressLineOne?: string | null, addressLineTwo?: string | null, city: string, postCode?: string | null, country?: string | null, geoCoordinates?: any | null } | null }>, participantsCount: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null } }> };

export type ImportArloCertificatesMutationVariables = Exact<{
  report: Scalars['String']['input'];
}>;


export type ImportArloCertificatesMutation = { __typename?: 'mutation_root', importArloCertificates: any };

export type ImportArloCertificatesResultQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ImportArloCertificatesResultQuery = { __typename?: 'query_root', importArloCertificates?: { __typename?: 'importArloCertificates', output?: { __typename?: 'ImportArloCertificatesOutput', processed?: number | null, added?: number | null, invalid?: number | null, error?: string | null, invalidEntries?: Array<{ __typename?: 'InvalidEntries', email: string } | null> | null } | null } | null };

export type InitAuthQueryVariables = Exact<{ [key: string]: never; }>;


export type InitAuthQuery = { __typename?: 'query_root', initAuth: { __typename?: 'InitAuthOutput', email: string, authChallenge: string } };

export type CreateUserMutationVariables = Exact<{
  input: CreateAppUserInput;
}>;


export type CreateUserMutation = { __typename?: 'mutation_root', createUser: { __typename?: 'CreateUserOutput', cognitoId: string, profileId: string, email: string } };

export type GetOrgByIdQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrgByIdQuery = { __typename?: 'query_root', organization: Array<{ __typename?: 'organization', address: any, name: string, id: any }> };

export type GetCertificationsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Course_Certificate_Bool_Exp>;
}>;


export type GetCertificationsQuery = { __typename?: 'query_root', certifications: Array<{ __typename?: 'course_certificate', status?: Certificate_Status_Enum | null, id: any, number: string, expiryDate: any, legacyCourseCode?: string | null, certificationDate: any, courseName: string, courseLevel: string, profile?: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null, email?: string | null, contactDetails: any, organizations: Array<{ __typename?: 'organization_member', organization: { __typename?: 'organization', id: any, name: string } }> } | null, participant?: { __typename?: 'course_participant', id: any, grade?: Grade_Enum | null, certificateChanges: Array<{ __typename?: 'course_certificate_changelog', payload?: any | null }> } | null, course?: { __typename?: 'course', level: Course_Level_Enum, accreditedBy: Accreditors_Enum, go1Integration: boolean, reaccreditation?: boolean | null, course_code?: string | null } | null }>, certificationsAggregation: { __typename?: 'course_certificate_aggregate', aggregate?: { __typename?: 'course_certificate_aggregate_fields', count: number } | null } };

export type GetParticipantGradingDetailsQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  courseId: Scalars['Int']['input'];
}>;


export type GetParticipantGradingDetailsQuery = { __typename?: 'query_root', participants: Array<{ __typename?: 'course_participant', id: any, gradedOn?: any | null, profile: { __typename?: 'profile', fullName?: string | null, avatar?: string | null } }>, course?: { __typename?: 'course', deliveryType: Course_Delivery_Type_Enum, level: Course_Level_Enum, type: Course_Type_Enum, reaccreditation?: boolean | null, conversion?: boolean | null, go1Integration: boolean } | null };

export type UpsertCertificationMutationVariables = Exact<{
  participantIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  gradedOn: Scalars['jsonb']['input'];
}>;


export type UpsertCertificationMutation = { __typename?: 'mutation_root', update_course_participant?: { __typename?: 'course_participant_mutation_response', affected_rows: number } | null };

export type DeleteMeetingMutationVariables = Exact<{
  meetingId: Scalars['String']['input'];
}>;


export type DeleteMeetingMutation = { __typename?: 'mutation_root', deleteMeeting: { __typename?: 'DeleteMeetingOutput', success: boolean } };

export type UpsertZoomMeetingMutationVariables = Exact<{
  input?: InputMaybe<UpsertZoomMeetingInput>;
}>;


export type UpsertZoomMeetingMutation = { __typename?: 'mutation_root', upsertZoomMeeting?: { __typename?: 'UpsertZoomMeetingPayload', success: boolean, meeting?: { __typename?: 'ZoomMeeting', id: number, joinUrl: string } | null } | null };

export type ZoomUsersQueryVariables = Exact<{ [key: string]: never; }>;


export type ZoomUsersQuery = { __typename?: 'query_root', zoomUsers?: { __typename?: 'ZoomUsersResponse', success?: boolean | null, data?: { __typename?: 'ZoomUsersResponseData', current: string, users?: Array<{ __typename?: 'ZoomUser', id: string, displayName: string, firstName: string, lastName: string, email: string }> | null } | null } | null };

export type SearchTrainerDetailsFragment = { __typename?: 'SearchTrainer', id: any, fullName: string, translatedGivenName?: string | null, translatedFamilyName?: string | null, avatar?: string | null, email: string, availability?: SearchTrainerAvailability | null, levels: Array<{ __typename?: 'CourseCertificateLevel', courseLevel: CourseLevel, expiryDate: any }>, trainer_role_types: Array<{ __typename?: 'TrainerRoleType', trainer_role_type?: { __typename?: 'TrainerRoleTypeObj', name: string, id: string } | null }> };

export type SearchTrainersQueryVariables = Exact<{
  input: SearchTrainersInput;
}>;


export type SearchTrainersQuery = { __typename?: 'query_root', trainers?: Array<{ __typename?: 'SearchTrainer', id: any, fullName: string, translatedGivenName?: string | null, translatedFamilyName?: string | null, avatar?: string | null, email: string, availability?: SearchTrainerAvailability | null, levels: Array<{ __typename?: 'CourseCertificateLevel', courseLevel: CourseLevel, expiryDate: any }>, trainer_role_types: Array<{ __typename?: 'TrainerRoleType', trainer_role_type?: { __typename?: 'TrainerRoleTypeObj', name: string, id: string } | null }> } | null> | null };

export type CoursePriceQueryVariables = Exact<{
  startDate?: InputMaybe<Scalars['date']['input']>;
  priceCurrency: Scalars['String']['input'];
}>;


export type CoursePriceQuery = { __typename?: 'query_root', coursePrice: Array<{ __typename?: 'course_pricing', level: Course_Level_Enum, type: Course_Type_Enum, blended: boolean, reaccreditation: boolean, pricingSchedules: Array<{ __typename?: 'course_pricing_schedule', priceAmount: any, priceCurrency: string }> }> };

export type OrgResourcePacksQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type OrgResourcePacksQuery = { __typename?: 'query_root', resourcePacks: Array<{ __typename?: 'organization_resource_packs', id: any, orgId: any, reservedResourcePacks: number, resourcePacksType: Resource_Packs_Type_Enum, totalResourcePacks: number }> };

export type CourseInfoFragment = { __typename?: 'course', name: string, go1Integration: boolean, deliveryType: Course_Delivery_Type_Enum, organization?: { __typename?: 'organization', name: string } | null, schedule: Array<{ __typename?: 'course_schedule', timeZone: string, start: any, end: any, venue?: { __typename?: 'venue', name: string, city: string } | null }> };

export type CourseHeroFragment = { __typename?: 'course', id: number, isDraft?: boolean | null, updatedAt: any, course_code?: string | null, level: Course_Level_Enum, type: Course_Type_Enum, reaccreditation?: boolean | null, conversion?: boolean | null, name: string, go1Integration: boolean, deliveryType: Course_Delivery_Type_Enum, organization?: { __typename?: 'organization', name: string } | null, schedule: Array<{ __typename?: 'course_schedule', timeZone: string, start: any, end: any, venue?: { __typename?: 'venue', name: string, city: string } | null }> };

export type SetCourseAsDraftMutationVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type SetCourseAsDraftMutation = { __typename?: 'mutation_root', update_course_by_pk?: { __typename?: 'course', id: number } | null };

export type ModuleSettingsQueryVariables = Exact<{
  courseType: Course_Type_Enum;
  courseLevel: Course_Level_Enum;
  courseDeliveryType: Course_Delivery_Type_Enum;
  go1Integration: Scalars['Boolean']['input'];
  reaccreditation?: InputMaybe<Scalars['Boolean']['input']>;
  conversion?: InputMaybe<Scalars['Boolean']['input']>;
  shard: Scalars['String']['input'];
}>;


export type ModuleSettingsQuery = { __typename?: 'query_root', moduleSettings: Array<{ __typename?: 'module_setting', id: any, color: Color_Enum, mandatory: boolean, duration?: number | null, sort: number, dependencies: Array<{ __typename?: 'module_setting_dependency', dependency: { __typename?: 'module_setting', id: any, module: { __typename?: 'module_v2', id: any } } }>, module: { __typename?: 'module_v2', id: any, name: string, displayName?: string | null, lessons: any } }> };

export type SaveIcmCourseDraftMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  curriculum?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type SaveIcmCourseDraftMutation = { __typename?: 'mutation_root', update_course_by_pk?: { __typename?: 'course', id: number } | null };

export type SubmitIcmModulesMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  curriculum: Scalars['jsonb']['input'];
  duration: Scalars['Int']['input'];
}>;


export type SubmitIcmModulesMutation = { __typename?: 'mutation_root', update_course_by_pk?: { __typename?: 'course', id: number } | null };

export type CourseToBuildQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  withModules?: InputMaybe<Scalars['Boolean']['input']>;
  withStrategies?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type CourseToBuildQuery = { __typename?: 'query_root', course?: { __typename?: 'course', curriculum?: any | null, conversion?: boolean | null, id: number, isDraft?: boolean | null, updatedAt: any, course_code?: string | null, level: Course_Level_Enum, type: Course_Type_Enum, reaccreditation?: boolean | null, name: string, go1Integration: boolean, deliveryType: Course_Delivery_Type_Enum, moduleGroupIds?: Array<{ __typename?: 'course_module', module: { __typename?: 'module', moduleGroup?: { __typename?: 'module_group', id: any } | null, submodules: Array<{ __typename?: 'submodule', id: any, name: string }> } }>, bildModules?: Array<{ __typename?: 'course_bild_module', id: any, modules: any }>, bildStrategies?: Array<{ __typename?: 'course_bild_strategy', strategyName: string }>, organization?: { __typename?: 'organization', name: string } | null, schedule: Array<{ __typename?: 'course_schedule', timeZone: string, start: any, end: any, venue?: { __typename?: 'venue', name: string, city: string } | null }> } | null };

export type DeleteCourseMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
}>;


export type DeleteCourseMutation = { __typename?: 'mutation_root', delete_course_audit?: { __typename?: 'course_audit_mutation_response', affected_rows: number } | null, delete_course_participant_audit?: { __typename?: 'course_participant_audit_mutation_response', affected_rows: number } | null, delete_course_by_pk?: { __typename?: 'course', id: number, course_code?: string | null, type: Course_Type_Enum, level: Course_Level_Enum, materials_organization?: { __typename?: 'organization', id: any, organization_resource_packs: Array<{ __typename?: 'organization_resource_packs', totalResourcePacks: number, reservedResourcePacks: number }> } | null } | null };

export type FinalizeCourseBuilderMutationVariables = Exact<{
  id: Scalars['Int']['input'];
  duration: Scalars['Int']['input'];
  status?: InputMaybe<Course_Status_Enum>;
}>;


export type FinalizeCourseBuilderMutation = { __typename?: 'mutation_root', update_course_by_pk?: { __typename?: 'course', id: number } | null };

export type GetBildStrategiesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetBildStrategiesQuery = { __typename?: 'query_root', strategies: Array<{ __typename?: 'bild_strategy', id: any, name: string, shortName: string, modules: any, duration?: number | null, sort?: number | null }> };

export type GetCountBookingContactOpenCoursesQueryVariables = Exact<{
  bookingContactEmail: Scalars['String']['input'];
}>;


export type GetCountBookingContactOpenCoursesQuery = { __typename?: 'query_root', course_aggregate: { __typename?: 'course_aggregate', aggregate?: { __typename?: 'course_aggregate_fields', count: number } | null } };

export type GetCourseDraftQueryVariables = Exact<{
  draftId: Scalars['uuid']['input'];
}>;


export type GetCourseDraftQuery = { __typename?: 'query_root', course_draft_by_pk?: { __typename?: 'course_draft', id: any, name?: string | null, data?: any | null, updatedAt: any } | null };

export type GetCoursesSourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCoursesSourcesQuery = { __typename?: 'query_root', sources: Array<{ __typename?: 'course_source', name: string }> };

export type ModuleGroupsQueryVariables = Exact<{
  level: Course_Level_Enum;
  courseDeliveryType: Course_Delivery_Type_Enum;
  reaccreditation: Scalars['Boolean']['input'];
  go1Integration: Scalars['Boolean']['input'];
}>;


export type ModuleGroupsQuery = { __typename?: 'query_root', groups: Array<{ __typename?: 'module_group', id: any, name: string, level: Course_Level_Enum, color: Color_Enum, mandatory: boolean, requires?: any | null, createdAt: any, updatedAt: any, modules: Array<{ __typename?: 'module', id: any, name: string, description?: string | null, level: Course_Level_Enum, type: Module_Category_Enum, createdAt: any, updatedAt: any, submodules: Array<{ __typename?: 'submodule', id: any, name: string }>, submodules_aggregate: { __typename?: 'submodule_aggregate', aggregate?: { __typename?: 'submodule_aggregate_fields', count: number } | null } }>, duration: { __typename?: 'module_group_duration_aggregate', aggregate?: { __typename?: 'module_group_duration_aggregate_fields', sum?: { __typename?: 'module_group_duration_sum_fields', duration?: number | null } | null } | null } }> };

export type GetOrganizationMaterialsStockQueryVariables = Exact<{
  organizationId: Scalars['uuid']['input'];
  level: Scalars['String']['input'];
}>;


export type GetOrganizationMaterialsStockQuery = { __typename?: 'query_root', stock: Array<{ __typename?: 'organization_resource_packs', totalResourcePacks: number }> };

export type InsertCourseMutationVariables = Exact<{
  course: Course_Insert_Input;
}>;


export type InsertCourseMutation = { __typename?: 'mutation_root', insertCourse?: { __typename?: 'course', id: number, course_code?: string | null, name: string, orders: Array<{ __typename?: 'course_order', order?: { __typename?: 'order', id: any } | null }>, expenses: Array<{ __typename?: 'course_expenses', id: any }> } | null };

export type ReInviteTrainerMutationVariables = Exact<{
  courseTrainerToDelete: Scalars['uuid']['input'];
  courseTrainer: Course_Trainer_Insert_Input;
}>;


export type ReInviteTrainerMutation = { __typename?: 'mutation_root', deleteCourseTrainer?: { __typename?: 'course_trainer', id: any } | null, insertCourseTrainer?: { __typename?: 'course_trainer', id: any } | null };

export type RemoveCourseDraftMutationVariables = Exact<{
  draftId: Scalars['uuid']['input'];
}>;


export type RemoveCourseDraftMutation = { __typename?: 'mutation_root', delete_course_draft_by_pk?: { __typename?: 'course_draft', id: any } | null };

export type RevertOrganizationResourcePacksOnCourseDeleteMutationVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  totalResourcePacks: Scalars['Int']['input'];
  reservedResourcePacks: Scalars['Int']['input'];
  audit: Org_Resource_Packs_History_Insert_Input;
}>;


export type RevertOrganizationResourcePacksOnCourseDeleteMutation = { __typename?: 'mutation_root', update_organization_resource_packs?: { __typename?: 'organization_resource_packs_mutation_response', affected_rows: number } | null, insert_org_resource_packs_history_one?: { __typename?: 'org_resource_packs_history', id: any } | null };

export type SaveCourseModulesBildMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  modules: Scalars['jsonb']['input'];
  duration: Scalars['Int']['input'];
  status?: InputMaybe<Course_Status_Enum>;
}>;


export type SaveCourseModulesBildMutation = { __typename?: 'mutation_root', deleted?: { __typename?: 'course_bild_module_mutation_response', count: number } | null, inserted?: { __typename?: 'course_bild_module_mutation_response', count: number } | null, course?: { __typename?: 'course', id: number } | null };

export type SaveCourseModulesMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  modules: Array<Course_Module_Insert_Input> | Course_Module_Insert_Input;
}>;


export type SaveCourseModulesMutation = { __typename?: 'mutation_root', deleted?: { __typename?: 'course_module_mutation_response', count: number } | null, inserted?: { __typename?: 'course_module_mutation_response', count: number } | null };

export type SetCourseDraftMutationVariables = Exact<{
  object: Course_Draft_Insert_Input;
}>;


export type SetCourseDraftMutation = { __typename?: 'mutation_root', insert_course_draft_one?: { __typename?: 'course_draft', id: any } | null };

export type CanApplyPromoCodeQueryVariables = Exact<{
  input: CanApplyPromoCodeInput;
}>;


export type CanApplyPromoCodeQuery = { __typename?: 'query_root', canApplyPromoCode: { __typename?: 'CanApplyPromoCodeOutput', result?: { __typename?: 'PromoCodeOutput', code: string, amount: number, type: string } | null } };

export type GetOrderQueryVariables = Exact<{
  orderId: Scalars['uuid']['input'];
}>;


export type GetOrderQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'course_order', quantity?: number | null, order?: { __typename?: 'order', id: any, profileId?: any | null, registrants: any, paymentMethod: Payment_Methods_Enum, orderDue?: any | null, orderTotal?: any | null, currency?: string | null, source?: string | null, billingAddress: string, billingGivenName: string, billingFamilyName: string, billingEmail: string, billingPhone: string, bookingContact?: any | null, stripePaymentId?: string | null, promoCodes?: any | null, xeroInvoiceNumber?: string | null, organizationId: any, user: any, salesRepresentative?: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null } | null, organization: { __typename?: 'organization', name: string }, invoice?: { __typename?: 'xero_invoice', xeroId: string, invoiceNumber?: string | null, lineItems: any, status?: string | null, fullyPaidOnDate?: any | null, amountDue?: any | null, amountPaid?: any | null, reference: string, currencyCode: string, subtotal: any, totalTax: any, total: any, dueDate: any, issuedDate: any, contact: { __typename?: 'xero_contact', phones?: any | null, addresses?: any | null, name?: string | null, firstName: string, lastName: string, emailAddress?: string | null } } | null } | null, course?: { __typename?: 'course', id: number, course_code?: string | null, level: Course_Level_Enum, name: string, type: Course_Type_Enum, source?: Course_Source_Enum | null, go1Integration: boolean, max_participants: number, freeSpaces?: number | null, deliveryType: Course_Delivery_Type_Enum, bookingContactInviteData?: any | null, reaccreditation?: boolean | null, residingCountry?: string | null, start: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', date?: { __typename?: 'course_schedule_max_fields', start?: any | null } | null } | null }, end: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', date?: { __typename?: 'course_schedule_max_fields', end?: any | null } | null } | null }, bookingContact?: { __typename?: 'profile', fullName?: string | null, email?: string | null, phone?: string | null } | null } | null }> };

export type CreateOrderMutationVariables = Exact<{
  input: CreateOrderInput;
}>;


export type CreateOrderMutation = { __typename?: 'mutation_root', order?: { __typename?: 'CreateOrderOutput', id?: any | null, success: boolean, error?: CreateOrderError | null } | null };

export type GetCoursePricingQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
}>;


export type GetCoursePricingQuery = { __typename?: 'query_root', pricing?: { __typename?: 'GetCoursePricingOutput', priceAmount: number, priceCurrency: Currency, xeroCode: string } | null };

export type GetTempProfileQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTempProfileQuery = { __typename?: 'query_root', tempProfiles: Array<{ __typename?: 'profile_temp', quantity?: number | null, course?: { __typename?: 'course', id: number, name: string, accreditedBy: Accreditors_Enum, price?: any | null, priceCurrency?: string | null, type: Course_Type_Enum, deliveryType: Course_Delivery_Type_Enum, level: Course_Level_Enum, reaccreditation?: boolean | null, conversion?: boolean | null, freeSpaces?: number | null, residingCountry?: string | null, includeVAT?: boolean | null, courseCode?: string | null, maxParticipants: number, dates: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', start?: { __typename?: 'course_schedule_min_fields', date?: any | null } | null, end?: { __typename?: 'course_schedule_max_fields', date?: any | null } | null } | null }, participants: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null }, expenses: Array<{ __typename?: 'course_expenses', id: any, data: any, trainer?: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null } | null }>, schedule: Array<{ __typename?: 'course_schedule', timeZone: string, venue?: { __typename?: 'venue', id: any, createdAt: any, updatedAt: any, name: string, city: string, addressLineOne?: string | null, addressLineTwo?: string | null, postCode?: string | null, country?: string | null, geoCoordinates?: any | null, googlePlacesId?: string | null } | null }> } | null }> };

export type BookPrivateCourseMutationVariables = Exact<{
  booking: Private_Course_Booking_Insert_Input;
}>;


export type BookPrivateCourseMutation = { __typename?: 'mutation_root', insert_private_course_booking?: { __typename?: 'private_course_booking_mutation_response', affected_rows: number } | null };

export type InsertCourseEnquiryMutationVariables = Exact<{
  enquiry: Course_Enquiry_Insert_Input;
}>;


export type InsertCourseEnquiryMutation = { __typename?: 'mutation_root', insert_course_enquiry?: { __typename?: 'course_enquiry_mutation_response', affected_rows: number } | null };

export type SubscribeToOrderUpdatesSubscriptionVariables = Exact<{
  participantId: Scalars['uuid']['input'];
}>;


export type SubscribeToOrderUpdatesSubscription = { __typename?: 'subscription_root', participant?: { __typename?: 'course_participant', order?: { __typename?: 'order', id: any, xeroInvoiceNumber?: string | null } | null } | null };

export type ToggleAttendanceMutationVariables = Exact<{
  participantId: Scalars['uuid']['input'];
  attended: Scalars['Boolean']['input'];
}>;


export type ToggleAttendanceMutation = { __typename?: 'mutation_root', update_course_participant_by_pk?: { __typename?: 'course_participant', attended?: boolean | null } | null };

export type ToggleEvaluationMutationVariables = Exact<{
  participantId: Scalars['uuid']['input'];
  courseId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type ToggleEvaluationMutation = { __typename?: 'mutation_root', delete_course_evaluation_answers?: { __typename?: 'course_evaluation_answers_mutation_response', affected_rows: number } | null };

export type ToggleSelectedParticipantsAttendanceMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  attended: Scalars['Boolean']['input'];
}>;


export type ToggleSelectedParticipantsAttendanceMutation = { __typename?: 'mutation_root', update_course_participant?: { __typename?: 'course_participant_mutation_response', affected_rows: number } | null };

export type BulkToggleEvaluationMutationVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  courseId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type BulkToggleEvaluationMutation = { __typename?: 'mutation_root', delete_course_evaluation_answers?: { __typename?: 'course_evaluation_answers_mutation_response', affected_rows: number } | null };

export type GetCourseInvitesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Course_Invites_Bool_Exp>;
  orderBy?: InputMaybe<Array<Course_Invites_Order_By> | Course_Invites_Order_By>;
}>;


export type GetCourseInvitesQuery = { __typename?: 'query_root', courseInvites: Array<{ __typename?: 'course_invites', id: any, createdAt: any, email?: string | null, expiresIn?: any | null, inviter_id?: any | null, note?: string | null, status?: Course_Invite_Status_Enum | null }>, courseInvitesAggregate: { __typename?: 'course_invites_aggregate', aggregate?: { __typename?: 'course_invites_aggregate_fields', count: number } | null } };

export type SendCourseInvitesMutationVariables = Exact<{
  invites: Array<Course_Invites_Insert_Input> | Course_Invites_Insert_Input;
}>;


export type SendCourseInvitesMutation = { __typename?: 'mutation_root', insert_course_invites?: { __typename?: 'course_invites_mutation_response', returning: Array<{ __typename?: 'course_invites', id: any }> } | null };

export type CancelCourseInviteMutationVariables = Exact<{
  inviteId: Scalars['uuid']['input'];
}>;


export type CancelCourseInviteMutation = { __typename?: 'mutation_root', update_course_invites_by_pk?: { __typename?: 'course_invites', id: any } | null };

export type SaveCourseInvitesMutationVariables = Exact<{
  invites: Array<Course_Invites_Insert_Input> | Course_Invites_Insert_Input;
}>;


export type SaveCourseInvitesMutation = { __typename?: 'mutation_root', insert_course_invites?: { __typename?: 'course_invites_mutation_response', returning: Array<{ __typename?: 'course_invites', id: any }> } | null };

export type ValidateAndDispatchInvitesForIndirectCourseMutationVariables = Exact<{
  input: ValidateAndDispatchInvitesForIndirectCourseInput;
}>;


export type ValidateAndDispatchInvitesForIndirectCourseMutation = { __typename?: 'mutation_root', validateAndDispatchInvitesForIndirectCourse?: { __typename?: 'ValidateAndDispatchInvitesForIndirectCourseOutput', error?: ValidateAndDispatchInvitesForIndirectCourseError | null, extraLicensesRequiredToBuy?: number | null, extraResourcePacksRequiredToBuy?: number | null, success: boolean } | null };

export type CheckTtClientsQueryVariables = Exact<{
  input: CheckTtClientsInput;
}>;


export type CheckTtClientsQuery = { __typename?: 'query_root', checkTTClients?: { __typename?: 'CheckTTClientsOutput', clientEmails: Array<string>, nonClientEmails: Array<string> } | null };

export type NotifyInternalUsersOfInviteAttemptMutationVariables = Exact<{
  input: NotifyInternalUsersOfInviteAttemptInput;
}>;


export type NotifyInternalUsersOfInviteAttemptMutation = { __typename?: 'mutation_root', notifyInternalUsersOfInviteAttempt?: { __typename?: 'NotifyInternalUsersOfInviteAttemptOutput', success: boolean } | null };

export type GetWaitlistQueryVariables = Exact<{
  where: Waitlist_Bool_Exp;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Waitlist_Order_By> | Waitlist_Order_By>;
}>;


export type GetWaitlistQuery = { __typename?: 'query_root', waitlist: Array<{ __typename?: 'waitlist', id: any, email: string, phone: string, orgName: string, courseId: number, confirmed: boolean, createdAt: any, givenName: string, familyName: string }>, waitlistAggregate: { __typename?: 'waitlist_aggregate', aggregate?: { __typename?: 'waitlist_aggregate_fields', count: number } | null } };

export type BlendedLearningExportDataDetailsFragment = { __typename?: 'BlendedLearningExportDataOutput', courseName: string, courseCode: string, courseStartDate: string, courseEndDate: string, commissioningOrganisationName: string, leadTrainerName: string, attendees: Array<{ __typename?: 'BlendedLearningAttendeeExportData', userName: string, email: string, blendedLearningStatus: string, blendedLearningPass: string, blendedLearningStartDate: string, blendedLearningEndDate?: string | null }> };

export type ExportBlendedLearningCourseDataQueryVariables = Exact<{
  input: BlendedLearningExportDataInput;
}>;


export type ExportBlendedLearningCourseDataQuery = { __typename?: 'query_root', attendees?: { __typename?: 'BlendedLearningExportDataOutput', courseName: string, courseCode: string, courseStartDate: string, courseEndDate: string, commissioningOrganisationName: string, leadTrainerName: string, attendees: Array<{ __typename?: 'BlendedLearningAttendeeExportData', userName: string, email: string, blendedLearningStatus: string, blendedLearningPass: string, blendedLearningStartDate: string, blendedLearningEndDate?: string | null }> } | null };

export type CancelIndividualFromCourseWaitlistMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  waitlistId: Scalars['uuid']['input'];
}>;


export type CancelIndividualFromCourseWaitlistMutation = { __typename?: 'mutation_root', cancelIndividualFromCourseWaitlist?: { __typename?: 'CancelIndividualFromCourseWaitlistOutput', success: boolean, error?: CancelIndividualFromCourseWaitlistError | null } | null };

export type CancelIndividualFromCourseMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  profileId: Scalars['uuid']['input'];
  reason: Scalars['String']['input'];
  fee: Scalars['Float']['input'];
  feeType: CancellationFeeType;
}>;


export type CancelIndividualFromCourseMutation = { __typename?: 'mutation_root', cancelIndividualFromCourse?: { __typename?: 'CancelIndividualFromCourseOutput', error?: CancelIndividualFromCourseError | null, success: boolean } | null };

export type GetCourseParticipantOrderQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCourseParticipantOrderQuery = { __typename?: 'query_root', participant?: { __typename?: 'course_participant', order?: { __typename?: 'order', xeroInvoiceNumber?: string | null, id: any } | null } | null };

export type GetCourseParticipantsOrganizationsQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  where?: InputMaybe<Course_Participant_Bool_Exp>;
  withTrainerOrganization?: InputMaybe<Scalars['Boolean']['input']>;
  trainersWithEvaluations?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetCourseParticipantsOrganizationsQuery = { __typename?: 'query_root', course_participant: Array<{ __typename?: 'course_participant', profile: { __typename?: 'profile', organizations: Array<{ __typename?: 'organization_member', organization: { __typename?: 'organization', name: string } }> } }>, course_trainer?: Array<{ __typename?: 'course_trainer', profile: { __typename?: 'profile', organizations: Array<{ __typename?: 'organization_member', organization: { __typename?: 'organization', name: string } }> } }> };

export type ReplaceParticipantMutationVariables = Exact<{
  input: ReplaceParticipantInput;
}>;


export type ReplaceParticipantMutation = { __typename?: 'mutation_root', replaceParticipant?: { __typename?: 'ReplaceParticipantOutput', success: boolean, error?: ReplaceParticipantError | null } | null };

export type SaveCourseAttendanceMutationVariables = Exact<{
  attended: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  notAttended: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  attendedAudit: Array<Course_Participant_Audit_Insert_Input> | Course_Participant_Audit_Insert_Input;
  notAttendedAudit: Array<Course_Participant_Audit_Insert_Input> | Course_Participant_Audit_Insert_Input;
  courseId: Scalars['Int']['input'];
  participantProfileId?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type SaveCourseAttendanceMutation = { __typename?: 'mutation_root', saveAttended?: { __typename?: 'course_participant_mutation_response', affectedRows: number } | null, saveAttendedAudit?: { __typename?: 'course_participant_audit_mutation_response', affectedRows: number } | null, saveNotAttended?: { __typename?: 'course_participant_mutation_response', affectedRows: number } | null, saveNotAttendedAudit?: { __typename?: 'course_participant_audit_mutation_response', affectedRows: number } | null, delete_course_evaluation_answers?: { __typename?: 'course_evaluation_answers_mutation_response', affected_rows: number } | null };

export type SendCourseEvaluationReminderMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  attendeeIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type SendCourseEvaluationReminderMutation = { __typename?: 'mutation_root', sendCourseEvaluationReminder: { __typename?: 'SendCourseEvaluationReminderOutput', success: boolean, error?: SendCourseEvaluationReminderError | null } };

export type SendCourseInformationMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  attendeeIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  hsConsentReminder?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SendCourseInformationMutation = { __typename?: 'mutation_root', sendCourseInformation: { __typename?: 'SendCourseInformationOutput', success: boolean, error?: SendCourseInformationError | null } };

export type GetCertificateQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetCertificateQuery = { __typename?: 'query_root', certificateHoldRequest: Array<{ __typename?: 'course_certificate_hold_request', id: any, expiry_date: any, start_date: any }>, certificate?: { __typename?: 'course_certificate', id: any, createdAt: any, updatedAt: any, number: string, expiryDate: any, certificationDate: any, courseName: string, courseLevel: string, status?: Certificate_Status_Enum | null, legacyCourseCode?: string | null, blendedLearning?: boolean | null, reaccreditation?: boolean | null, courseAccreditedBy?: Accreditors_Enum | null, profile?: { __typename?: 'profile', fullName?: string | null, id: any, avatar?: string | null, archived?: boolean | null } | null, participant?: { __typename?: 'course_participant', id: any, grade?: Grade_Enum | null, dateGraded?: any | null, gradedOn?: any | null, profile: { __typename?: 'profile', fullName?: string | null, avatar?: string | null, archived?: boolean | null }, gradingModules: Array<{ __typename?: 'course_participant_module', completed: boolean, id: any, module: { __typename?: 'module', id: any, name: string, moduleGroup?: { __typename?: 'module_group', id: any, name: string } | null } }>, bildGradingModules?: { __typename?: 'course_participant_bild_module', id: any, modules: any } | null, course: { __typename?: 'course', id: number, name: string, level: Course_Level_Enum, deliveryType: Course_Delivery_Type_Enum, type: Course_Type_Enum, accreditedBy: Accreditors_Enum, go1Integration: boolean, reaccreditation?: boolean | null, bildStrategies: Array<{ __typename?: 'course_bild_strategy', id: any, strategyName: string }> }, certificateChanges: Array<{ __typename?: 'course_certificate_changelog', id: any, createdAt: any, updatedAt: any, payload?: any | null, type: Course_Certificate_Changelog_Type_Enum, author: { __typename?: 'profile', fullName?: string | null, avatar?: string | null, archived?: boolean | null } }> } | null } | null };

export type InsertCourseCertificateChangelogMutationVariables = Exact<{
  participantId: Scalars['uuid']['input'];
  type: Course_Certificate_Changelog_Type_Enum;
  payload: Scalars['jsonb']['input'];
}>;


export type InsertCourseCertificateChangelogMutation = { __typename?: 'mutation_root', insertChangeLog?: { __typename?: 'course_certificate_changelog', id: any } | null };

export type InsertCourseCertificateHoldRequestMutationVariables = Exact<{
  certificateId: Scalars['uuid']['input'];
  changelogId: Scalars['uuid']['input'];
  expireDate: Scalars['timestamp']['input'];
  startDate: Scalars['date']['input'];
  newExpiryDate: Scalars['date']['input'];
}>;


export type InsertCourseCertificateHoldRequestMutation = { __typename?: 'mutation_root', insert_course_certificate_hold_request_one?: { __typename?: 'course_certificate_hold_request', id: any } | null, update_course_certificate_by_pk?: { __typename?: 'course_certificate', expiryDate: any } | null };

export type RevokeCertMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  participantId: Scalars['uuid']['input'];
  payload: Scalars['jsonb']['input'];
}>;


export type RevokeCertMutation = { __typename?: 'mutation_root', insertChangeLog?: { __typename?: 'course_certificate_changelog', id: any } | null, revoked?: { __typename?: 'course_certificate', id: any } | null };

export type UndoRevokeCertMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  participantId: Scalars['uuid']['input'];
}>;


export type UndoRevokeCertMutation = { __typename?: 'mutation_root', undoRevoked?: { __typename?: 'course_certificate', id: any } | null, insertChangeLog?: { __typename?: 'course_certificate_changelog', id: any } | null };

export type GetEvaluationQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  profileId: Scalars['uuid']['input'];
}>;


export type GetEvaluationQuery = { __typename?: 'query_root', answers: Array<{ __typename?: 'course_evaluation_answers', id: any, answer?: string | null, question: { __typename?: 'course_evaluation_questions', id: any, type?: Course_Evaluation_Question_Type_Enum | null }, profile: { __typename?: 'profile', fullName?: string | null, avatar?: string | null, archived?: boolean | null } }> };

export type GetEvaluationsSummaryRestrictedQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  profileCondition?: InputMaybe<Profile_Bool_Exp>;
}>;


export type GetEvaluationsSummaryRestrictedQuery = { __typename?: 'query_root', answers: Array<{ __typename?: 'course_evaluation_answers', id: any, answer?: string | null, profile: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null }, question: { __typename?: 'course_evaluation_questions', questionKey?: string | null, type?: Course_Evaluation_Question_Type_Enum | null, group?: Course_Evaluation_Question_Group_Enum | null } }> };

export type GetEvaluationsSummaryQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  profileCondition?: InputMaybe<Profile_Bool_Exp>;
}>;


export type GetEvaluationsSummaryQuery = { __typename?: 'query_root', answers: Array<{ __typename?: 'course_evaluation_answers', id: any, answer?: string | null, profile: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null }, question: { __typename?: 'course_evaluation_questions', questionKey?: string | null, type?: Course_Evaluation_Question_Type_Enum | null, group?: Course_Evaluation_Question_Group_Enum | null } }> };

export type GetEvaluationsQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  profileCondition?: InputMaybe<Profile_Bool_Exp>;
}>;


export type GetEvaluationsQuery = { __typename?: 'query_root', evaluations: Array<{ __typename?: 'course_evaluation_answers', id: any, profile: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null, email?: string | null, organizations: Array<{ __typename?: 'organization_member', organization: { __typename?: 'organization', name: string } }> } }>, attendees: Array<{ __typename?: 'course_participant', id: any, profile: { __typename?: 'profile', id: any } }>, trainers: Array<{ __typename?: 'course_trainer', id: any, type: Course_Trainer_Type_Enum, profile: { __typename?: 'profile', id: any } }> };

export type GetFeedbackUsersQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
}>;


export type GetFeedbackUsersQuery = { __typename?: 'query_root', users: Array<{ __typename?: 'course_evaluation_answers', profile: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null } }> };

export type GetCourseEvaluationQuestionsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetCourseEvaluationQuestionsQuery = { __typename?: 'query_root', questions: Array<{ __typename?: 'course_evaluation_questions', id: any, type?: Course_Evaluation_Question_Type_Enum | null, questionKey?: string | null, group?: Course_Evaluation_Question_Group_Enum | null, displayOrder: number, required: boolean }> };

export type UserCourseFragment = { __typename?: 'course', id: number, name: string, type: Course_Type_Enum, level: Course_Level_Enum, status?: Course_Status_Enum | null, course_code?: string | null, createdAt: any, max_participants: number, trainers: Array<{ __typename?: 'course_trainer', id: any, status?: Course_Invite_Status_Enum | null, type: Course_Trainer_Type_Enum, profile: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null } }>, schedule: Array<{ __typename?: 'course_schedule', id: any, start: any, end: any, virtualLink?: string | null, timeZone: string, venue?: { __typename?: 'venue', id: any, name: string, city: string } | null }>, participants: Array<{ __typename?: 'course_participant', healthSafetyConsent: boolean, grade?: Grade_Enum | null, attended?: boolean | null }>, organization?: { __typename?: 'organization', id: any, name: string } | null, evaluation_answers_aggregate: { __typename?: 'course_evaluation_answers_aggregate', aggregate?: { __typename?: 'course_evaluation_answers_aggregate_fields', count: number } | null }, dates: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', start?: { __typename?: 'course_schedule_min_fields', date?: any | null } | null, end?: { __typename?: 'course_schedule_max_fields', date?: any | null } | null } | null }, modulesAgg: { __typename?: 'course_module_aggregate', aggregate?: { __typename?: 'course_module_aggregate_fields', count: number } | null }, cancellationRequest?: { __typename?: 'course_cancellation_request', id: any } | null };

export type UserCoursesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<Course_Order_By> | Course_Order_By>;
  where?: InputMaybe<Course_Bool_Exp>;
  profileId: Scalars['uuid']['input'];
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  withParticipantAggregates?: InputMaybe<Scalars['Boolean']['input']>;
  withParticipants?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type UserCoursesQuery = { __typename?: 'query_root', courses: Array<{ __typename?: 'course', id: number, name: string, type: Course_Type_Enum, level: Course_Level_Enum, status?: Course_Status_Enum | null, course_code?: string | null, createdAt: any, max_participants: number, participantsAgg?: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null }, courseParticipants?: Array<{ __typename?: 'course_participant', healthSafetyConsent: boolean, grade?: Grade_Enum | null, attended?: boolean | null }>, waitlistAgg?: { __typename?: 'waitlist_aggregate', aggregate?: { __typename?: 'waitlist_aggregate_fields', count: number } | null }, trainers: Array<{ __typename?: 'course_trainer', id: any, status?: Course_Invite_Status_Enum | null, type: Course_Trainer_Type_Enum, profile: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null } }>, schedule: Array<{ __typename?: 'course_schedule', id: any, start: any, end: any, virtualLink?: string | null, timeZone: string, venue?: { __typename?: 'venue', id: any, name: string, city: string } | null }>, participants: Array<{ __typename?: 'course_participant', healthSafetyConsent: boolean, grade?: Grade_Enum | null, attended?: boolean | null }>, organization?: { __typename?: 'organization', id: any, name: string } | null, evaluation_answers_aggregate: { __typename?: 'course_evaluation_answers_aggregate', aggregate?: { __typename?: 'course_evaluation_answers_aggregate_fields', count: number } | null }, dates: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', start?: { __typename?: 'course_schedule_min_fields', date?: any | null } | null, end?: { __typename?: 'course_schedule_max_fields', date?: any | null } | null } | null }, modulesAgg: { __typename?: 'course_module_aggregate', aggregate?: { __typename?: 'course_module_aggregate_fields', count: number } | null }, cancellationRequest?: { __typename?: 'course_cancellation_request', id: any } | null }>, course_aggregate: { __typename?: 'course_aggregate', aggregate?: { __typename?: 'course_aggregate_fields', count: number } | null } };

export type SaveCourseEvaluationMutationVariables = Exact<{
  answers: Array<Course_Evaluation_Answers_Insert_Input> | Course_Evaluation_Answers_Insert_Input;
  id: Scalars['uuid']['input'];
  completedEvaluation?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaveCourseEvaluationMutation = { __typename?: 'mutation_root', inserted?: { __typename?: 'course_evaluation_answers_mutation_response', rows: Array<{ __typename?: 'course_evaluation_answers', id: any }> } | null, update_course_participant_by_pk?: { __typename?: 'course_participant', completed_evaluation?: boolean | null } | null };

export type SaveTrainerCourseEvaluationMutationVariables = Exact<{
  answers: Array<Course_Evaluation_Answers_Insert_Input> | Course_Evaluation_Answers_Insert_Input;
}>;


export type SaveTrainerCourseEvaluationMutation = { __typename?: 'mutation_root', inserted?: { __typename?: 'course_evaluation_answers_mutation_response', rows: Array<{ __typename?: 'course_evaluation_answers', id: any }> } | null };

export type CourseParticipantsQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orderBy?: InputMaybe<Array<Course_Participant_Order_By> | Course_Participant_Order_By>;
  where?: InputMaybe<Course_Participant_Bool_Exp>;
  withOrder?: InputMaybe<Scalars['Boolean']['input']>;
  courseId?: InputMaybe<Scalars['Int']['input']>;
}>;


export type CourseParticipantsQuery = { __typename?: 'query_root', courseParticipants: Array<{ __typename?: 'course_participant', id: any, attended?: boolean | null, bookingDate?: any | null, completed: boolean, completed_evaluation?: boolean | null, go1EnrolmentProgress?: any | null, go1EnrolmentStarted: boolean, go1EnrolmentStatus?: Blended_Learning_Status_Enum | null, grade?: Grade_Enum | null, healthSafetyConsent: boolean, invoiceID?: any | null, certificate?: { __typename?: 'course_certificate', id: any, createdAt: any, updatedAt: any, number: string, expiryDate: any, certificationDate: any, courseName: string, courseLevel: string, status?: Certificate_Status_Enum | null, legacyCourseCode?: string | null, blendedLearning?: boolean | null, reaccreditation?: boolean | null, courseAccreditedBy?: Accreditors_Enum | null } | null, certificateChanges: Array<{ __typename?: 'course_certificate_changelog', id: any, createdAt: any, updatedAt: any, payload?: any | null, type: Course_Certificate_Changelog_Type_Enum }>, course: { __typename?: 'course', accreditedBy: Accreditors_Enum, resourcePacksType?: Resource_Packs_Type_Enum | null, id: number, aolCostOfCourse?: any | null, aolCountry?: string | null, aolRegion?: string | null, course_code?: string | null, createdAt: any, deliveryType: Course_Delivery_Type_Enum, go1Integration: boolean, gradingConfirmed: boolean, gradingStarted: boolean, is_tender: boolean, level: Course_Level_Enum, max_participants: number, min_participants: number, modulesDuration: number, name: string, reaccreditation?: boolean | null, region?: string | null, residingCountry?: string | null, status?: Course_Status_Enum | null, type: Course_Type_Enum, updatedAt: any, bildStrategies: Array<{ __typename?: 'course_bild_strategy', id: any, strategyName: string }>, organization?: { __typename?: 'organization', id: any, name: string } | null }, order?: { __typename?: 'order', id: any, xeroInvoiceNumber?: string | null } | null, profile: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null, email?: string | null, contactDetails: any, course_evaluation_answers_aggregate: { __typename?: 'course_evaluation_answers_aggregate', aggregate?: { __typename?: 'course_evaluation_answers_aggregate_fields', count: number } | null }, organizations: Array<{ __typename?: 'organization_member', organization: { __typename?: 'organization', id: any, name: string } }> } }>, courseParticipantsAggregation: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null } };

export type CourseParticipantByPkQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type CourseParticipantByPkQuery = { __typename?: 'query_root', courseParticipant?: { __typename?: 'course_participant', id: any, go1EnrolmentId?: number | null, profile: { __typename?: 'profile', id: any, avatar?: string | null, email?: string | null, fullName?: string | null } } | null };

export type GetCourseParticipantDietOrDisabilitiesDataQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  withDietaryRestrictions?: InputMaybe<Scalars['Boolean']['input']>;
  withTrainerData?: InputMaybe<Scalars['Boolean']['input']>;
  withDisabilities?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCourseParticipantDietOrDisabilitiesDataQuery = { __typename?: 'query_root', dietaryRestrictions?: Array<{ __typename?: 'course_participant', profile: { __typename?: 'profile', fullName?: string | null, dietaryRestrictions?: string | null, email?: string | null, id: any, organizations: Array<{ __typename?: 'organization_member', organization: { __typename?: 'organization', name: string, id: any } }> } }>, trainerDietaryRestrictions?: Array<{ __typename?: 'course_trainer', profile: { __typename?: 'profile', fullName?: string | null, dietaryRestrictions?: string | null, email?: string | null, id: any, organizations: Array<{ __typename?: 'organization_member', organization: { __typename?: 'organization', name: string, id: any } }> } }>, disabilities?: Array<{ __typename?: 'course_participant', profile: { __typename?: 'profile', fullName?: string | null, disabilities?: string | null, email?: string | null, id: any, organizations: Array<{ __typename?: 'organization_member', organization: { __typename?: 'organization', name: string, id: any } }> } }>, trainerDisabilities?: Array<{ __typename?: 'course_trainer', profile: { __typename?: 'profile', fullName?: string | null, disabilities?: string | null, email?: string | null, id: any, organizations: Array<{ __typename?: 'organization_member', organization: { __typename?: 'organization', name: string, id: any } }> } }> };

export type GetDietaryAndDisabilitiesCountQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  withTrainerData?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetDietaryAndDisabilitiesCountQuery = { __typename?: 'query_root', participantDietaryRestrictionsCount: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null }, trainerDietaryRestrictionsCount: { __typename?: 'course_trainer_aggregate', aggregate?: { __typename?: 'course_trainer_aggregate_fields', count: number } | null }, participantDisabilitiesCount: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null }, trainerDisabilitiesCount: { __typename?: 'course_trainer_aggregate', aggregate?: { __typename?: 'course_trainer_aggregate_fields', count: number } | null } };

export type GetUserGo1EnrollmentsQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type GetUserGo1EnrollmentsQuery = { __typename?: 'query_root', enrollments: { __typename?: 'GetUserGO1EnrollmentsOutput', enrollments: Array<{ __typename?: 'GetUserGO1Enrollment', id: number, status?: Go1EnrollmentStatus | null, learningObject?: { __typename?: 'GO1LearningObject', id: number, title: string } | null }> } };

export type UpdateCourseParticipantGo1DataMutationVariables = Exact<{
  courseParticipantId: Scalars['uuid']['input'];
  go1EnrolmentId: Scalars['Int']['input'];
  go1EnrolmentStatus: Blended_Learning_Status_Enum;
}>;


export type UpdateCourseParticipantGo1DataMutation = { __typename?: 'mutation_root', update_course_participant_by_pk?: { __typename?: 'course_participant', id: any } | null };

export type ApproveCourseMutationVariables = Exact<{
  input: ApproveCourseInput;
}>;


export type ApproveCourseMutation = { __typename?: 'mutation_root', approveCourse: { __typename?: 'ApproveCourseOutput', success: boolean } };

export type DeleteCourseCancellationRequestMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteCourseCancellationRequestMutation = { __typename?: 'mutation_root', delete_course_cancellation_request_by_pk?: { __typename?: 'course_cancellation_request', id: any } | null };

export type RejectCourseMutationVariables = Exact<{
  input: RejectCourseInput;
}>;


export type RejectCourseMutation = { __typename?: 'mutation_root', rejectCourse?: { __typename?: 'RejectCourseOutput', success: boolean } | null };

export type GetResourcesQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  resourceIds: Array<InputMaybe<Scalars['ID']['input']>> | InputMaybe<Scalars['ID']['input']>;
}>;


export type GetResourcesQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', resourceCategory?: { __typename?: 'ResourceCategory', resources?: { __typename?: 'ResourceCategoryToResourceConnection', nodes?: Array<{ __typename?: 'Resource', id: string, title?: string | null, resourceAttachment?: { __typename?: 'Resource_Resourceattachment', resourcetype?: string | null, videourl?: string | null, file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null, link?: { __typename?: 'AcfLink', url?: string | null } | null } | null, resourcePermissions?: { __typename?: 'Resource_Resourcepermissions', allowAccessDayBeforeCourseStart?: boolean | null, certificateLevels?: Array<string | null> | null, courseInProgress?: boolean | null, etaTrainer?: boolean | null, principalTrainer?: boolean | null, seniorTrainer?: boolean | null } | null } | null> | null } | null } | null } | null };

export type CancelMyselfFromCourseMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
}>;


export type CancelMyselfFromCourseMutation = { __typename?: 'mutation_root', cancelMyselfFromCourse: boolean };

export type GetUserCourseByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  withOrders?: InputMaybe<Scalars['Boolean']['input']>;
  withGo1Data?: InputMaybe<Scalars['Boolean']['input']>;
  profileId: Scalars['uuid']['input'];
  withCancellationRequest?: InputMaybe<Scalars['Boolean']['input']>;
  withParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  withParticipantsOrders?: InputMaybe<Scalars['Boolean']['input']>;
  courseParticipantsWhere?: InputMaybe<Course_Participant_Bool_Exp>;
}>;


export type GetUserCourseByIdQuery = { __typename?: 'query_root', course?: { __typename?: 'course', id: number, name: string, type: Course_Type_Enum, deliveryType: Course_Delivery_Type_Enum, go1Integration?: boolean, level: Course_Level_Enum, course_code?: string | null, reaccreditation?: boolean | null, min_participants: number, max_participants: number, special_instructions?: string | null, parking_instructions?: string | null, status?: Course_Status_Enum | null, accreditedBy: Accreditors_Enum, curriculum?: any | null, cancellationRequest?: { __typename?: 'course_cancellation_request', id: any } | null, organization?: { __typename?: 'organization', id: any, name: string, members: Array<{ __typename?: 'organization_member', isAdmin?: boolean | null, profile_id: any }> } | null, trainers: Array<{ __typename?: 'course_trainer', id: any, type: Course_Trainer_Type_Enum, profile: { __typename?: 'profile', id: any, givenName?: string | null, familyName?: string | null, fullName?: string | null, avatar?: string | null, archived?: boolean | null } }>, participants: Array<{ __typename?: 'course_participant', healthSafetyConsent: boolean, grade?: Grade_Enum | null, attended?: boolean | null }>, courseParticipants?: Array<{ __typename?: 'course_participant', healthSafetyConsent: boolean, grade?: Grade_Enum | null, attended?: boolean | null, order?: { __typename?: 'order', bookingContactProfileId?: any | null } | null }>, evaluation_answers_aggregate: { __typename?: 'course_evaluation_answers_aggregate', aggregate?: { __typename?: 'course_evaluation_answers_aggregate_fields', count: number } | null }, schedule: Array<{ __typename?: 'course_schedule', timeZone: string, id: any, createdAt: any, updatedAt: any, start: any, end: any, virtualLink?: string | null, venue?: { __typename?: 'venue', id: any, createdAt: any, updatedAt: any, name: string, city: string, addressLineOne?: string | null, addressLineTwo?: string | null, postCode?: string | null, country?: string | null, geoCoordinates?: any | null, googlePlacesId?: string | null } | null }>, dates: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', start?: { __typename?: 'course_schedule_min_fields', date?: any | null } | null, end?: { __typename?: 'course_schedule_max_fields', date?: any | null } | null } | null }, bookingContact?: { __typename?: 'profile', id: any, email?: string | null, fullName?: string | null } | null, organizationKeyContact?: { __typename?: 'profile', id: any, email?: string | null, fullName?: string | null } | null, bildModules: Array<{ __typename?: 'course_bild_module', id: any, modules: any }>, bildStrategies: Array<{ __typename?: 'course_bild_strategy', strategyName: string }>, moduleGroupIds: Array<{ __typename?: 'course_module', module: { __typename?: 'module', moduleGroup?: { __typename?: 'module_group', id: any } | null } }>, participantSubmittedEvaluationCount: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null }, certificateCount: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null }, orders?: Array<{ __typename?: 'course_order', order?: { __typename?: 'order', id: any, xeroInvoiceNumber?: string | null, source?: string | null } | null }> } | null };

export type GetCourseParticipantIdQueryVariables = Exact<{
  profileId: Scalars['uuid']['input'];
  courseId: Scalars['Int']['input'];
}>;


export type GetCourseParticipantIdQuery = { __typename?: 'query_root', course_participant: Array<{ __typename?: 'course_participant', attended?: boolean | null, completed_evaluation?: boolean | null, dateGraded?: any | null, go1EnrolmentId?: number | null, go1EnrolmentStatus?: Blended_Learning_Status_Enum | null, grade?: Grade_Enum | null, healthSafetyConsent: boolean, id: any, certificate?: { __typename?: 'course_certificate', id: any, createdAt: any, updatedAt: any, number: string, expiryDate: any, certificationDate: any, courseName: string, courseLevel: string, status?: Certificate_Status_Enum | null, legacyCourseCode?: string | null, blendedLearning?: boolean | null, reaccreditation?: boolean | null, courseAccreditedBy?: Accreditors_Enum | null } | null, gradingModules: Array<{ __typename?: 'course_participant_module', completed: boolean, module: { __typename?: 'module', id: any, name: string, moduleGroup?: { __typename?: 'module_group', id: any, name: string } | null } }>, profile: { __typename?: 'profile', archived?: boolean | null, avatar?: string | null, fullName?: string | null } }> };

export type RequestCourseCancellationMutationVariables = Exact<{
  cancellationRequest: Course_Cancellation_Request_Insert_Input;
}>;


export type RequestCourseCancellationMutation = { __typename?: 'mutation_root', insert_course_cancellation_request?: { __typename?: 'course_cancellation_request_mutation_response', affected_rows: number } | null };

export type SaveHealthSafetyConsentMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  profileId: Scalars['uuid']['input'];
}>;


export type SaveHealthSafetyConsentMutation = { __typename?: 'mutation_root', update_course_participant?: { __typename?: 'course_participant_mutation_response', returning: Array<{ __typename?: 'course_participant', id: any }> } | null };

export type SubscribeToXeroInvoiceSubscriptionVariables = Exact<{
  orderIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type SubscribeToXeroInvoiceSubscription = { __typename?: 'subscription_root', orders: Array<{ __typename?: 'order', id: any, xeroInvoiceNumber?: string | null }> };

export type CancelCourseMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  cancellationFee?: InputMaybe<Scalars['Float']['input']>;
  cancellationReason: Scalars['String']['input'];
  cancellationFeeType?: InputMaybe<Course_Cancellation_Fee_Type_Enum>;
}>;


export type CancelCourseMutation = { __typename?: 'mutation_root', cancelledCourse?: { __typename?: 'course', id: number } | null, delete_course_cancellation_request?: { __typename?: 'course_cancellation_request_mutation_response', affected_rows: number } | null };

export type GetOrderDetailsForReviewQueryVariables = Exact<{
  orderId: Scalars['uuid']['input'];
}>;


export type GetOrderDetailsForReviewQuery = { __typename?: 'query_root', order_by_pk?: { __typename?: 'order', billingAddress: string, workbookDeliveryAddress?: any | null, email: string, firstName: string, phone: string, purchaseOrder?: string | null, surname: string, organization: { __typename?: 'organization', id: any, name: string } } | null };

export type InsertCourseAuditMutationVariables = Exact<{
  object: Course_Audit_Insert_Input;
}>;


export type InsertCourseAuditMutation = { __typename?: 'mutation_root', insert_course_audit?: { __typename?: 'course_audit_mutation_response', affected_rows: number } | null };

export type NotifyCourseEditMutationVariables = Exact<{
  oldCourse: NotifyCourseInput;
  oldTrainers: Array<InputMaybe<NotifyCourseTrainerInput>> | InputMaybe<NotifyCourseTrainerInput>;
}>;


export type NotifyCourseEditMutation = { __typename?: 'mutation_root', notifyCourseEdit: { __typename?: 'NotifyCourseEditOutput', status: number } };

export type UpdateCourseMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  courseInput: Course_Set_Input;
  exceptionsInput?: InputMaybe<Array<Course_Exceptions_Insert_Input> | Course_Exceptions_Insert_Input>;
  orderInput: Order_Set_Input;
  ordersInsertInput?: InputMaybe<Array<Course_Order_Insert_Input> | Course_Order_Insert_Input>;
  scheduleId: Scalars['uuid']['input'];
  scheduleInput: Course_Schedule_Set_Input;
  temporaryOrderInsertInput?: InputMaybe<Array<Order_Temp_Insert_Input> | Order_Temp_Insert_Input>;
  trainers: Array<Course_Trainer_Insert_Input> | Course_Trainer_Insert_Input;
  trainersToDelete?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type UpdateCourseMutation = { __typename?: 'mutation_root', deleteCourseTrainers?: { __typename?: 'course_trainer_mutation_response', returning: Array<{ __typename?: 'course_trainer', id: any }> } | null, deletedExceptions?: { __typename?: 'course_exceptions_mutation_response', affectedRows: number } | null, insertCourseTrainers?: { __typename?: 'course_trainer_mutation_response', returning: Array<{ __typename?: 'course_trainer', id: any }> } | null, insertExceptions?: { __typename?: 'course_exceptions_mutation_response', affectedRows: number } | null, insertOrders?: { __typename?: 'course_order_mutation_response', affectedRows: number } | null, insertTemporaryOrders?: { __typename?: 'order_temp_mutation_response', affectedRows: number } | null, updateCourse?: { __typename?: 'course', id: number, level: Course_Level_Enum } | null, updateOrder?: { __typename?: 'order_mutation_response', affectedRows: number } | null, updateSchedule?: { __typename?: 'course_schedule', id: any } | null };

export type InsertCourseOrderMutationVariables = Exact<{
  orderInput: Course_Order_Insert_Input;
}>;


export type InsertCourseOrderMutation = { __typename?: 'mutation_root', insertOrder?: { __typename?: 'course_order', order_id?: any | null } | null };

export type ReserveGo1LicensesMutationVariables = Exact<{
  go1LicensesOrgIdManage: Scalars['uuid']['input'];
  decrementGo1LicensesFromOrganizationPool?: InputMaybe<Scalars['Int']['input']>;
  incrementGo1LicensesFromOrganizationPool?: InputMaybe<Scalars['Int']['input']>;
  reserveGo1LicensesAudit?: InputMaybe<Array<Go1_Licenses_History_Insert_Input> | Go1_Licenses_History_Insert_Input>;
}>;


export type ReserveGo1LicensesMutation = { __typename?: 'mutation_root', decrementGo1Licenses?: { __typename?: 'organization_mutation_response', affectedRows: number, returning: Array<{ __typename?: 'organization', id: any, go1Licenses?: number | null }> } | null, insertGo1LicensesAudit?: { __typename?: 'go1_licenses_history_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'go1_licenses_history', id: any, org_id: any, event: Go1_History_Events_Enum }> } | null };

export type ResendPasswordMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type ResendPasswordMutation = { __typename?: 'mutation_root', resendPassword: boolean };

export type SaveBildGradeMutationVariables = Exact<{
  modules: Array<Course_Participant_Bild_Module_Insert_Input> | Course_Participant_Bild_Module_Insert_Input;
  participantIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  grade: Grade_Enum;
  feedback?: InputMaybe<Scalars['String']['input']>;
  courseId: Scalars['Int']['input'];
}>;


export type SaveBildGradeMutation = { __typename?: 'mutation_root', saveModules?: { __typename?: 'course_participant_bild_module_mutation_response', affected_rows: number } | null, saveParticipantsGrade?: { __typename?: 'course_participant_mutation_response', affectedRows: number } | null, gradingStarted?: { __typename?: 'course', id: number } | null };

export type SaveCourseGradingV2MutationVariables = Exact<{
  participantIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  gradedOn: Scalars['jsonb']['input'];
  grade: Grade_Enum;
  courseId: Scalars['Int']['input'];
  resourcePackId?: InputMaybe<Scalars['uuid']['input']>;
  updateResourcePacks: Scalars['Boolean']['input'];
  reservedPacksIncrement?: InputMaybe<Scalars['Int']['input']>;
  orgResourcePacksLogEntry: Org_Resource_Packs_History_Insert_Input;
}>;


export type SaveCourseGradingV2Mutation = { __typename?: 'mutation_root', saveParticipantsGrade?: { __typename?: 'course_participant_mutation_response', affectedRows: number } | null, gradingStarted?: { __typename?: 'course', id: number } | null, update_organization_resource_packs?: { __typename?: 'organization_resource_packs_mutation_response', affected_rows: number } | null, logCoursePacksHistory?: { __typename?: 'org_resource_packs_history', id: any } | null };

export type CourseGradingDataQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CourseGradingDataQuery = { __typename?: 'query_root', course?: { __typename?: 'course', id: number, name: string, type: Course_Type_Enum, level: Course_Level_Enum, deliveryType: Course_Delivery_Type_Enum, resourcePacksType?: Resource_Packs_Type_Enum | null, reservedResourcePacks?: number | null, accreditedBy: Accreditors_Enum, curriculum?: any | null, materials_organization?: { __typename?: 'organization', id: any, organization_resource_packs: Array<{ __typename?: 'organization_resource_packs', id: any, reservedResourcePacks: number, totalResourcePacks: number, resourcePacksType: Resource_Packs_Type_Enum }> } | null, participants: Array<{ __typename?: 'course_participant', id: any, attended?: boolean | null, grade?: Grade_Enum | null, profile: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null } }>, modules: Array<{ __typename?: 'course_module', id: any, covered?: boolean | null, module: { __typename?: 'module', id: any, name: string, moduleGroup?: { __typename?: 'module_group', id: any, name: string, mandatory: boolean } | null, submodules: Array<{ __typename?: 'submodule', id: any, name: string }> } }>, bildModules: Array<{ __typename?: 'course_bild_module', id: any, modules: any }>, trainers: Array<{ __typename?: 'course_trainer', profile_id: any, type: Course_Trainer_Type_Enum }> } | null };

export type SaveCourseGradingMutationVariables = Exact<{
  modules: Array<Course_Participant_Module_Insert_Input> | Course_Participant_Module_Insert_Input;
  participantIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
  grade: Grade_Enum;
  feedback?: InputMaybe<Scalars['String']['input']>;
  courseId: Scalars['Int']['input'];
  notes: Array<Course_Participant_Note_Insert_Input> | Course_Participant_Note_Insert_Input;
  evaluationSubmitted?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type SaveCourseGradingMutation = { __typename?: 'mutation_root', saveModules?: { __typename?: 'course_participant_module_mutation_response', affectedRows: number } | null, saveParticipantsGrade?: { __typename?: 'course_participant_mutation_response', affectedRows: number } | null, gradingStarted?: { __typename?: 'course', id: number } | null, insert_course_participant_note?: { __typename?: 'course_participant_note_mutation_response', affected_rows: number } | null };

export type SaveGradingDetailsMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
}>;


export type SaveGradingDetailsMutation = { __typename?: 'mutation_root', update_course_by_pk?: { __typename?: 'course', id: number, gradingConfirmed: boolean } | null };

export type CourseCurriculumQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CourseCurriculumQuery = { __typename?: 'query_root', course?: { __typename?: 'course', id: number, curriculum?: any | null } | null };

export type SaveCurriculumSelectionMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  curriculum: Scalars['jsonb']['input'];
}>;


export type SaveCurriculumSelectionMutation = { __typename?: 'mutation_root', update_course_by_pk?: { __typename?: 'course', id: number } | null };

export type GradedParticipantQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GradedParticipantQuery = { __typename?: 'query_root', participant?: { __typename?: 'course_participant', id: any, grade?: Grade_Enum | null, dateGraded?: any | null, gradedOn?: any | null, course: { __typename?: 'course', accreditedBy: Accreditors_Enum, name: string }, profile: { __typename?: 'profile', fullName?: string | null, avatar?: string | null }, gradingModules: Array<{ __typename?: 'course_participant_module', id: any, completed: boolean, module: { __typename?: 'module', id: any, name: string, moduleGroup?: { __typename?: 'module_group', id: any, name: string } | null, submodules: Array<{ __typename?: 'submodule', id: any, name: string }>, submodules_aggregate: { __typename?: 'submodule_aggregate', aggregate?: { __typename?: 'submodule_aggregate_fields', count: number } | null } } }>, bildGradingModules?: { __typename?: 'course_participant_bild_module', id: any, modules: any } | null, notes: Array<{ __typename?: 'course_participant_note', moduleGroupId: any, note: string }> } | null };

export type CourseModulesQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type CourseModulesQuery = { __typename?: 'query_root', courseModules: Array<{ __typename?: 'course_module', id: any, covered?: boolean | null, module: { __typename?: 'module', id: any, name: string, moduleGroup?: { __typename?: 'module_group', id: any, name: string, mandatory: boolean } | null, submodules: Array<{ __typename?: 'submodule', id: any, name: string }> } }> };

export type SaveModuleSelectionMutationVariables = Exact<{
  coveredModules: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  notCoveredModules: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  courseId: Scalars['Int']['input'];
}>;


export type SaveModuleSelectionMutation = { __typename?: 'mutation_root', saveCovered?: { __typename?: 'course_module_mutation_response', affectedRows: number } | null, saveNotCovered?: { __typename?: 'course_module_mutation_response', affectedRows: number } | null, gradingConfirmed?: { __typename?: 'course', id: number } | null };

export type UpdateGradeMutationVariables = Exact<{
  participantId: Scalars['uuid']['input'];
  newGrade: Grade_Enum;
  type: Course_Certificate_Changelog_Type_Enum;
  payload?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type UpdateGradeMutation = { __typename?: 'mutation_root', updateCourseParticipant?: { __typename?: 'course_participant', id: any } | null, insertChangeLog?: { __typename?: 'course_certificate_changelog', id: any } | null };

export type DeclineInviteMutationVariables = Exact<{
  note?: InputMaybe<Scalars['String']['input']>;
}>;


export type DeclineInviteMutation = { __typename?: 'mutation_root', invite?: { __typename?: 'DeclineInviteOutput', status: boolean } | null };

export type DeclineOrgInviteMutationVariables = Exact<{
  inviteId: Scalars['uuid']['input'];
}>;


export type DeclineOrgInviteMutation = { __typename?: 'mutation_root', invite: boolean };

export type GetInviteQueryVariables = Exact<{ [key: string]: never; }>;


export type GetInviteQuery = { __typename?: 'query_root', invite?: { __typename?: 'CourseInvite', id: string, status: InviteStatus, courseId: string, courseName: string, description?: string | null, trainerName: string, startDate: string, endDate: string, deliveryType?: CourseDeliveryType | null, venueName: string, venueCoordinates?: string | null, timeZone?: string | null, venueAddress?: { __typename?: 'Address', addressLineOne?: string | null, addressLineTwo?: string | null, city?: string | null, postCode?: string | null } | null } | null };

export type GetOrgInviteQueryVariables = Exact<{ [key: string]: never; }>;


export type GetOrgInviteQuery = { __typename?: 'query_root', invite?: { __typename?: 'OrgInvite', id: string, orgName: string, orgId: string } | null };

export type CheckIfUserExistsByMailQueryVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type CheckIfUserExistsByMailQuery = { __typename?: 'query_root', profile_aggregate: { __typename?: 'profile_aggregate', aggregate?: { __typename?: 'profile_aggregate_fields', count: number } | null } };

export type BlogQueryVariables = Exact<{
  orderDirection?: OrderEnum;
  term?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type BlogQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', posts?: { __typename?: 'RootQueryToPostConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } | null, nodes?: Array<{ __typename?: 'Post', id: string, title?: string | null, excerpt?: string | null, content?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, tags?: { __typename?: 'PostToTagConnection', nodes?: Array<{ __typename?: 'Tag', id: string, name?: string | null } | null> | null } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null } | null, customAuthor?: { __typename?: 'Post_Customauthor', displayAuthor?: boolean | null, authorName?: string | null } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type CategoryQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  orderDirection?: InputMaybe<OrderEnum>;
  term?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type CategoryQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', category?: { __typename?: 'Category', id: string, name?: string | null, posts?: { __typename?: 'CategoryToPostConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } | null, nodes?: Array<{ __typename?: 'Post', id: string, title?: string | null, excerpt?: string | null, content?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, tags?: { __typename?: 'PostToTagConnection', nodes?: Array<{ __typename?: 'Tag', id: string, name?: string | null } | null> | null } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null } | null, customAuthor?: { __typename?: 'Post_Customauthor', displayAuthor?: boolean | null, authorName?: string | null } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name?: string | null } | null> | null } | null } | null> | null } | null } | null } | null };

export type EbooksQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<OrderEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type EbooksQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', ebooks?: { __typename?: 'RootQueryToEbookConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } | null, nodes?: Array<{ __typename?: 'Ebook', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, downloads?: { __typename?: 'Ebook_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, ebooksCategories?: { __typename?: 'EbookToEbooksCategoryConnection', nodes?: Array<{ __typename?: 'EbooksCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type MembershipHomeQueryVariables = Exact<{ [key: string]: never; }>;


export type MembershipHomeQuery = { __typename?: 'query_root', podcasts?: { __typename?: 'PodcastsPayload', records: Array<{ __typename?: 'Podcast', id: string, name: string, thumbnail: string, publishedDate: string, mediaUrl: string, author: string, description?: string | null, episodeNumber: number }> } | null, content?: { __typename?: 'contentRootQuery', posts?: { __typename?: 'RootQueryToPostConnection', nodes?: Array<{ __typename?: 'Post', id: string, title?: string | null, excerpt?: string | null, content?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, tags?: { __typename?: 'PostToTagConnection', nodes?: Array<{ __typename?: 'Tag', id: string, name?: string | null } | null> | null } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null } | null, customAuthor?: { __typename?: 'Post_Customauthor', displayAuthor?: boolean | null, authorName?: string | null } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name?: string | null } | null> | null } | null } | null> | null } | null, videoSeriesItems?: { __typename?: 'RootQueryToVideoSeriesItemConnection', nodes?: Array<{ __typename?: 'VideoSeriesItem', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, youtube?: { __typename?: 'VideoSeriesItem_Youtube', url?: string | null, duration?: number | null } | null, downloads?: { __typename?: 'VideoSeriesItem_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, videoSeriesCategories?: { __typename?: 'VideoSeriesItemToVideoSeriesCategoryConnection', nodes?: Array<{ __typename?: 'VideoSeriesCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null, researchSummaries?: { __typename?: 'RootQueryToResearchSummaryConnection', nodes?: Array<{ __typename?: 'ResearchSummary', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, downloads?: { __typename?: 'ResearchSummary_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, researchSummariesCategories?: { __typename?: 'ResearchSummaryToResearchSummariesCategoryConnection', nodes?: Array<{ __typename?: 'ResearchSummariesCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null, webinars?: { __typename?: 'RootQueryToWebinarConnection', nodes?: Array<{ __typename?: 'Webinar', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, youtube?: { __typename?: 'Webinar_Youtube', url?: string | null, duration?: number | null } | null, webinarsCategories?: { __typename?: 'WebinarToWebinarsCategoryConnection', nodes?: Array<{ __typename?: 'WebinarsCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null, ebooks?: { __typename?: 'RootQueryToEbookConnection', nodes?: Array<{ __typename?: 'Ebook', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, downloads?: { __typename?: 'Ebook_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, ebooksCategories?: { __typename?: 'EbookToEbooksCategoryConnection', nodes?: Array<{ __typename?: 'EbooksCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type PodcastQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PodcastQuery = { __typename?: 'query_root', podcast?: { __typename?: 'PodcastPayload', podcast?: { __typename?: 'Podcast', id: string, name: string, thumbnail: string, publishedDate: string, mediaUrl: string, author: string, description?: string | null, episodeNumber: number } | null } | null, recentPodcasts?: { __typename?: 'PodcastsPayload', records: Array<{ __typename?: 'Podcast', id: string, name: string, thumbnail: string, publishedDate: string, mediaUrl: string, author: string, description?: string | null, episodeNumber: number }> } | null };

export type PodcastsQueryVariables = Exact<{
  input: PodcastsInput;
}>;


export type PodcastsQuery = { __typename?: 'query_root', podcasts?: { __typename?: 'PodcastsPayload', total: number, records: Array<{ __typename?: 'Podcast', id: string, name: string, thumbnail: string, publishedDate: string, mediaUrl: string, author: string, description?: string | null, episodeNumber: number }> } | null };

export type PostQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type PostQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', post?: { __typename?: 'Post', id: string, title?: string | null, excerpt?: string | null, content?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, tags?: { __typename?: 'PostToTagConnection', nodes?: Array<{ __typename?: 'Tag', id: string, name?: string | null } | null> | null } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null } | null, customAuthor?: { __typename?: 'Post_Customauthor', displayAuthor?: boolean | null, authorName?: string | null } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name?: string | null } | null> | null } | null } | null, recentPosts?: { __typename?: 'RootQueryToPostConnection', nodes?: Array<{ __typename?: 'Post', id: string, title?: string | null, excerpt?: string | null, content?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, tags?: { __typename?: 'PostToTagConnection', nodes?: Array<{ __typename?: 'Tag', id: string, name?: string | null } | null> | null } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null } | null, customAuthor?: { __typename?: 'Post_Customauthor', displayAuthor?: boolean | null, authorName?: string | null } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type ResearchSummariesQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<OrderEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResearchSummariesQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', researchSummaries?: { __typename?: 'RootQueryToResearchSummaryConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } | null, nodes?: Array<{ __typename?: 'ResearchSummary', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, downloads?: { __typename?: 'ResearchSummary_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, researchSummariesCategories?: { __typename?: 'ResearchSummaryToResearchSummariesCategoryConnection', nodes?: Array<{ __typename?: 'ResearchSummariesCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type TagQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  orderDirection?: InputMaybe<OrderEnum>;
  term?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type TagQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', tag?: { __typename?: 'Tag', id: string, name?: string | null, posts?: { __typename?: 'TagToPostConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } | null, nodes?: Array<{ __typename?: 'Post', id: string, title?: string | null, excerpt?: string | null, content?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, tags?: { __typename?: 'PostToTagConnection', nodes?: Array<{ __typename?: 'Tag', id: string, name?: string | null } | null> | null } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null } | null, customAuthor?: { __typename?: 'Post_Customauthor', displayAuthor?: boolean | null, authorName?: string | null } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name?: string | null } | null> | null } | null } | null> | null } | null } | null } | null };

export type PaginationInfoFragment = { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null };

export type TermQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  orderDirection?: InputMaybe<OrderEnum>;
  term?: InputMaybe<Scalars['String']['input']>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type TermQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', termNode?:
      | { __typename: 'Category', id: string, name?: string | null, posts?: { __typename?: 'CategoryToPostConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } | null, nodes?: Array<{ __typename?: 'Post', id: string, title?: string | null, excerpt?: string | null, content?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, tags?: { __typename?: 'PostToTagConnection', nodes?: Array<{ __typename?: 'Tag', id: string, name?: string | null } | null> | null } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null } | null, customAuthor?: { __typename?: 'Post_Customauthor', displayAuthor?: boolean | null, authorName?: string | null } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name?: string | null } | null> | null } | null } | null> | null } | null }
      | { __typename: 'EbooksCategory', id: string, name?: string | null, ebooks?: { __typename?: 'EbooksCategoryToEbookConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } | null, nodes?: Array<{ __typename?: 'Ebook', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, downloads?: { __typename?: 'Ebook_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, ebooksCategories?: { __typename?: 'EbookToEbooksCategoryConnection', nodes?: Array<{ __typename?: 'EbooksCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null }
      | { __typename: 'PostFormat', id: string, name?: string | null }
      | { __typename: 'ResearchSummariesCategory', id: string, name?: string | null, researchSummaries?: { __typename?: 'ResearchSummariesCategoryToResearchSummaryConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } | null, nodes?: Array<{ __typename?: 'ResearchSummary', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, downloads?: { __typename?: 'ResearchSummary_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, researchSummariesCategories?: { __typename?: 'ResearchSummaryToResearchSummariesCategoryConnection', nodes?: Array<{ __typename?: 'ResearchSummariesCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null }
      | { __typename: 'ResourceCategory', id: string, name?: string | null }
      | { __typename: 'Tag', id: string, name?: string | null, posts?: { __typename?: 'TagToPostConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } | null, nodes?: Array<{ __typename?: 'Post', id: string, title?: string | null, excerpt?: string | null, content?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, tags?: { __typename?: 'PostToTagConnection', nodes?: Array<{ __typename?: 'Tag', id: string, name?: string | null } | null> | null } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null } | null, customAuthor?: { __typename?: 'Post_Customauthor', displayAuthor?: boolean | null, authorName?: string | null } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name?: string | null } | null> | null } | null } | null> | null } | null }
      | { __typename: 'VideoSeriesCategory', id: string, name?: string | null, videoSeriesItems?: { __typename?: 'VideoSeriesCategoryToVideoSeriesItemConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } | null, nodes?: Array<{ __typename?: 'VideoSeriesItem', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, youtube?: { __typename?: 'VideoSeriesItem_Youtube', url?: string | null, duration?: number | null } | null, downloads?: { __typename?: 'VideoSeriesItem_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, videoSeriesCategories?: { __typename?: 'VideoSeriesItemToVideoSeriesCategoryConnection', nodes?: Array<{ __typename?: 'VideoSeriesCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null }
      | { __typename: 'WebinarsCategory', id: string, name?: string | null, webinars?: { __typename?: 'WebinarsCategoryToWebinarConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, startCursor?: string | null, endCursor?: string | null } | null, nodes?: Array<{ __typename?: 'Webinar', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, youtube?: { __typename?: 'Webinar_Youtube', url?: string | null, duration?: number | null } | null, webinarsCategories?: { __typename?: 'WebinarToWebinarsCategoryConnection', nodes?: Array<{ __typename?: 'WebinarsCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null }
     | null } | null };

export type VideoItemQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type VideoItemQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', videoSeriesItem?: { __typename?: 'VideoSeriesItem', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, youtube?: { __typename?: 'VideoSeriesItem_Youtube', url?: string | null, duration?: number | null } | null, downloads?: { __typename?: 'VideoSeriesItem_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, videoSeriesCategories?: { __typename?: 'VideoSeriesItemToVideoSeriesCategoryConnection', nodes?: Array<{ __typename?: 'VideoSeriesCategory', id: string, name?: string | null } | null> | null } | null } | null, recentVideoItems?: { __typename?: 'RootQueryToVideoSeriesItemConnection', nodes?: Array<{ __typename?: 'VideoSeriesItem', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, youtube?: { __typename?: 'VideoSeriesItem_Youtube', url?: string | null, duration?: number | null } | null, downloads?: { __typename?: 'VideoSeriesItem_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, videoSeriesCategories?: { __typename?: 'VideoSeriesItemToVideoSeriesCategoryConnection', nodes?: Array<{ __typename?: 'VideoSeriesCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type VideoSeriesQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<OrderEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type VideoSeriesQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', videoSeriesItems?: { __typename?: 'RootQueryToVideoSeriesItemConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } | null, nodes?: Array<{ __typename?: 'VideoSeriesItem', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, youtube?: { __typename?: 'VideoSeriesItem_Youtube', url?: string | null, duration?: number | null } | null, downloads?: { __typename?: 'VideoSeriesItem_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, videoSeriesCategories?: { __typename?: 'VideoSeriesItemToVideoSeriesCategoryConnection', nodes?: Array<{ __typename?: 'VideoSeriesCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type WebinarQueryVariables = Exact<{
  id: Scalars['ID']['input'];
}>;


export type WebinarQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', webinar?: { __typename?: 'Webinar', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, youtube?: { __typename?: 'Webinar_Youtube', url?: string | null, duration?: number | null } | null, webinarsCategories?: { __typename?: 'WebinarToWebinarsCategoryConnection', nodes?: Array<{ __typename?: 'WebinarsCategory', id: string, name?: string | null } | null> | null } | null } | null, recentWebinars?: { __typename?: 'RootQueryToWebinarConnection', nodes?: Array<{ __typename?: 'Webinar', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, youtube?: { __typename?: 'Webinar_Youtube', url?: string | null, duration?: number | null } | null, webinarsCategories?: { __typename?: 'WebinarToWebinarsCategoryConnection', nodes?: Array<{ __typename?: 'WebinarsCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type WebinarsQueryVariables = Exact<{
  term?: InputMaybe<Scalars['String']['input']>;
  orderDirection?: InputMaybe<OrderEnum>;
  first?: InputMaybe<Scalars['Int']['input']>;
  last?: InputMaybe<Scalars['Int']['input']>;
  after?: InputMaybe<Scalars['String']['input']>;
  before?: InputMaybe<Scalars['String']['input']>;
}>;


export type WebinarsQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', webinars?: { __typename?: 'RootQueryToWebinarConnection', pageInfo?: { __typename?: 'WPPageInfo', hasNextPage: boolean, hasPreviousPage: boolean, endCursor?: string | null, startCursor?: string | null } | null, nodes?: Array<{ __typename?: 'Webinar', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, youtube?: { __typename?: 'Webinar_Youtube', url?: string | null, duration?: number | null } | null, webinarsCategories?: { __typename?: 'WebinarToWebinarsCategoryConnection', nodes?: Array<{ __typename?: 'WebinarsCategory', id: string, name?: string | null } | null> | null } | null } | null> | null } | null } | null };

export type GetOrdersQueryVariables = Exact<{
  orderId: Scalars['uuid']['input'];
}>;


export type GetOrdersQuery = { __typename?: 'query_root', orders: Array<{ __typename?: 'course_order', quantity?: number | null, order?: { __typename?: 'order', id: any, attendeesQuantity: number, registrants: any, resourcePacksQuantity?: any | null, paymentMethod: Payment_Methods_Enum, currency?: string | null, source?: string | null, billingAddress: string, billingGivenName: string, billingFamilyName: string, billingEmail: string, billingPhone: string, bookingContact?: any | null, promoCodes?: any | null, xeroInvoiceNumber?: string | null, organizationId: any, user: any, salesRepresentative?: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null } | null, organization: { __typename?: 'organization', name: string }, invoice?: { __typename?: 'xero_invoice', xeroId: string, invoiceNumber?: string | null, lineItems: any, status?: string | null, fullyPaidOnDate?: any | null, amountDue?: any | null, amountPaid?: any | null, reference: string, currencyCode: string, subtotal: any, totalTax: any, total: any, dueDate: any, issuedDate: any, contact: { __typename?: 'xero_contact', phones?: any | null, addresses?: any | null, name?: string | null, firstName: string, lastName: string, emailAddress?: string | null } } | null } | null, course?: { __typename?: 'course', id: number, course_code?: string | null, level: Course_Level_Enum, name: string, type: Course_Type_Enum, source?: Course_Source_Enum | null, go1Integration: boolean, max_participants: number, freeSpaces?: number | null, deliveryType: Course_Delivery_Type_Enum, resourcePacksType?: Resource_Packs_Type_Enum | null, resourcePacksDeliveryType?: Resource_Packs_Delivery_Type_Enum | null, bookingContactInviteData?: any | null, reaccreditation?: boolean | null, residingCountry?: string | null, bookingContact?: { __typename?: 'profile', fullName?: string | null, email?: string | null, phone?: string | null } | null, dates: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', start?: { __typename?: 'course_schedule_min_fields', date?: any | null } | null, end?: { __typename?: 'course_schedule_max_fields', date?: any | null } | null } | null }, schedule: Array<{ __typename?: 'course_schedule', timeZone: string }> } | null }>, materialsOrder?: { __typename?: 'materials_order', id: any, currency?: string | null, delivery_city?: string | null, delivery_country?: string | null, delivery_email?: string | null, delivery_first_name?: string | null, delivery_last_name?: string | null, delivery_line1?: string | null, delivery_line2?: string | null, delivery_postcode?: string | null, invoice_email?: string | null, invoice_first_name?: string | null, invoice_last_name?: string | null, invoice_phone?: string | null, invoice_purchase_order?: string | null, order_due?: any | null, materials_total_price?: any | null, postage_and_packaging_total?: any | null, payment_method?: Payment_Methods_Enum | null, purchased: any, xero_invoice_number?: string | null, organization?: { __typename?: 'organization', id: any, name: string } | null, invoice_organization?: { __typename?: 'organization', id: any, name: string } | null, xero_invoice?: { __typename?: 'xero_invoice', xeroId: string, invoiceNumber?: string | null, status?: string | null, fullyPaidOnDate?: any | null, amountDue?: any | null, amountPaid?: any | null, reference: string, currencyCode: string, subtotal: any, totalTax: any, total: any, dueDate: any, issuedDate: any } | null } | null };

export type GetShallowAttendeeAuditLogsQueryVariables = Exact<{
  where: Course_Participant_Audit_Bool_Exp;
  xeroInvoiceNumber: Scalars['String']['input'];
}>;


export type GetShallowAttendeeAuditLogsQuery = { __typename?: 'query_root', cancellation: Array<{ __typename?: 'course_participant_audit', id: any, xero_invoice_number?: string | null, course_id: number, profile: { __typename?: 'profile', id: any, fullName?: string | null, email?: string | null } }>, replacement: Array<{ __typename?: 'course_participant_audit', id: any, xero_invoice_number?: string | null, payload: any, profile: { __typename?: 'profile', id: any, fullName?: string | null, email?: string | null } }> };

export type GetOrderForBookingDoneQueryVariables = Exact<{
  orderId: Scalars['uuid']['input'];
}>;


export type GetOrderForBookingDoneQuery = { __typename?: 'query_root', order?: { __typename?: 'order', id: any, xeroInvoiceNumber?: string | null, paymentMethod: Payment_Methods_Enum } | null };

export type ContactInfoFragment = { __typename?: 'xero_contact', firstName: string };

export type InvoiceInfoFragment = { __typename?: 'xero_invoice', status?: string | null, dueDate: any, reference: string, amountDue?: any | null, total: any, contact: { __typename?: 'xero_contact', firstName: string } };

export type OrderOrganizationInfoFragment = { __typename?: 'organization', id: any, name: string, address: any };

export type OrderInfoFragment = { __typename?: 'order', id: any, createdAt: any, orderDue?: any | null, xeroInvoiceNumber?: string | null, paymentMethod: Payment_Methods_Enum, orderTotal?: any | null, currency?: string | null, organization: { __typename?: 'organization', id: any, name: string, address: any }, invoice?: { __typename?: 'xero_invoice', status?: string | null, dueDate: any, reference: string, amountDue?: any | null, total: any, contact: { __typename?: 'xero_contact', firstName: string } } | null, courses: Array<{ __typename?: 'course_order', course?: { __typename?: 'course', course_code?: string | null } | null }> };

export type OrdersQueryVariables = Exact<{
  where?: InputMaybe<Order_Bool_Exp>;
  orderBy?: InputMaybe<Array<Order_Order_By> | Order_Order_By>;
  materialsOrderWhere?: InputMaybe<Materials_Order_Bool_Exp>;
  materialsOrderBy?: InputMaybe<Array<Materials_Order_Order_By> | Materials_Order_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type OrdersQuery = { __typename?: 'query_root', order: Array<{ __typename?: 'order', id: any, createdAt: any, orderDue?: any | null, xeroInvoiceNumber?: string | null, paymentMethod: Payment_Methods_Enum, orderTotal?: any | null, currency?: string | null, organization: { __typename?: 'organization', id: any, name: string, address: any }, invoice?: { __typename?: 'xero_invoice', status?: string | null, dueDate: any, reference: string, amountDue?: any | null, total: any, contact: { __typename?: 'xero_contact', firstName: string } } | null, courses: Array<{ __typename?: 'course_order', course?: { __typename?: 'course', course_code?: string | null } | null }> }>, materials_order: Array<{ __typename?: 'materials_order', id: any, currency?: string | null, createdAt?: any | null, orderDue?: any | null, xeroInvoiceNumber?: string | null, paymentMethod?: Payment_Methods_Enum | null, orderTotal?: any | null, organization?: { __typename?: 'organization', id: any, name: string, address: any } | null, invoice?: { __typename?: 'xero_invoice', status?: string | null, dueDate: any, reference: string, amountDue?: any | null, total: any, contact: { __typename?: 'xero_contact', firstName: string } } | null }>, materials_order_aggregate: { __typename?: 'materials_order_aggregate', aggregate?: { __typename?: 'materials_order_aggregate_fields', count: number } | null }, order_aggregate: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null } };

export type GetOrganisationDetailsForDeleteQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type GetOrganisationDetailsForDeleteQuery = { __typename?: 'query_root', orgs?: { __typename?: 'organization', members: { __typename?: 'organization_member_aggregate', aggregate?: { __typename?: 'organization_member_aggregate_fields', count: number } | null }, courses: { __typename?: 'course_aggregate', aggregate?: { __typename?: 'course_aggregate_fields', count: number } | null }, orders: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null }, affiliatedOrgs: { __typename?: 'organization_aggregate', aggregate?: { __typename?: 'organization_aggregate_fields', count: number } | null } } | null };

export type GetAffiliatedOrganisationsQueryVariables = Exact<{
  mainOrgId: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  withActiveIndirectBLCourses?: InputMaybe<Scalars['Boolean']['input']>;
  withMembers?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetAffiliatedOrganisationsQuery = { __typename?: 'query_root', organizations: Array<{ __typename?: 'organization', id: any, address: any, createdAt: any, name: string, sector?: string | null, activeIndirectBLCourses?: Array<{ __typename?: 'course', id: number, course_code?: string | null, status?: Course_Status_Enum | null, pendingInvites: { __typename?: 'course_invites_aggregate', aggregate?: { __typename?: 'course_invites_aggregate_fields', count: number } | null } }>, members?: Array<{ __typename?: 'organization_member', profile: { __typename?: 'profile', lastActivity?: any | null } }> }> };

export type GetMainOrganisationDetailsQueryVariables = Exact<{
  where?: InputMaybe<Organization_Bool_Exp>;
  affiliatedOrgWhere?: InputMaybe<Organization_Bool_Exp>;
  shallow?: Scalars['Boolean']['input'];
  detailed?: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Organization_Order_By> | Organization_Order_By>;
  specificOrgId?: InputMaybe<Scalars['uuid']['input']>;
  withSpecificOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  withMembers?: InputMaybe<Scalars['Boolean']['input']>;
  withAggregateData?: InputMaybe<Scalars['Boolean']['input']>;
  withDfEEstablishment?: InputMaybe<Scalars['Boolean']['input']>;
  withExternalDashboardUrl?: InputMaybe<Scalars['Boolean']['input']>;
  withMainOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  withAffiliatedOrganisationsCount?: InputMaybe<Scalars['Boolean']['input']>;
  withAffiliatedOrganisations?: InputMaybe<Scalars['Boolean']['input']>;
  withTTConnectId?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetMainOrganisationDetailsQuery = { __typename?: 'query_root', orgs: Array<{ __typename?: 'organization', region?: string | null, dfeEstablishmentId?: any | null, external_dashboard_url?: string | null, tt_connect_id?: string | null, id: any, name: string, address: any, tags?: any | null, contactDetails: any, attributes: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, main_organisation?: { __typename?: 'organization', id: any, name: string } | null, dfeEstablishment?: { __typename?: 'dfe_establishment', id: any, urn: string, name: string, localAuthority: string, trustType?: string | null, trustName?: string | null, addressLineOne?: string | null, addressLineTwo?: string | null, addressLineThree?: string | null, town?: string | null, county?: string | null, postcode?: string | null, headTitle?: string | null, headFirstName?: string | null, headLastName?: string | null, headJobTitle?: string | null, ofstedRating?: string | null, ofstedLastInspection?: string | null } | null, affiliated_organisations?: Array<{ __typename?: 'organization', id: any, name: string, address: any, sector?: string | null, createdAt: any, main_organisation_id?: any | null, external_dashboard_url?: string | null, tt_connect_id?: string | null, dfeEstablishment?: { __typename?: 'dfe_establishment', id: any, urn: string, name: string, localAuthority: string, trustType?: string | null, trustName?: string | null, addressLineOne?: string | null, addressLineTwo?: string | null, addressLineThree?: string | null, town?: string | null, county?: string | null, postcode?: string | null, headTitle?: string | null, headFirstName?: string | null, headLastName?: string | null, headJobTitle?: string | null, ofstedRating?: string | null, ofstedLastInspection?: string | null } | null, members?: Array<{ __typename?: 'organization_member', profile: { __typename?: 'profile', lastActivity?: any | null } }> }>, affiliated_organisations_aggregate?: { __typename?: 'organization_aggregate', aggregate?: { __typename?: 'organization_aggregate_fields', count: number } | null }, members?: Array<{ __typename?: 'organization_member', profile: { __typename?: 'profile', lastActivity?: any | null } }>, members_aggregate?: { __typename?: 'organization_member_aggregate', aggregate?: { __typename?: 'organization_member_aggregate_fields', count: number } | null }, organization_courses_aggregate?: { __typename?: 'course_aggregate', aggregate?: { __typename?: 'course_aggregate_fields', count: number } | null }, organization_orders_aggregate?: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null } }>, specificOrg?: Array<{ __typename?: 'organization', region?: string | null, dfeEstablishmentId?: any | null, external_dashboard_url?: string | null, id: any, name: string, address: any, tags?: any | null, contactDetails: any, attributes: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, dfeEstablishment?: { __typename?: 'dfe_establishment', id: any, urn: string, name: string, localAuthority: string, trustType?: string | null, trustName?: string | null, addressLineOne?: string | null, addressLineTwo?: string | null, addressLineThree?: string | null, town?: string | null, county?: string | null, postcode?: string | null, headTitle?: string | null, headFirstName?: string | null, headLastName?: string | null, headJobTitle?: string | null, ofstedRating?: string | null, ofstedLastInspection?: string | null } | null, main_organisation?: { __typename?: 'organization', id: any, name: string } | null, affiliated_organisations?: Array<{ __typename?: 'organization', id: any, name: string, address: any, sector?: string | null, createdAt: any, members?: Array<{ __typename?: 'organization_member', profile: { __typename?: 'profile', lastActivity?: any | null } }> }>, affiliated_organisations_aggregate?: { __typename?: 'organization_aggregate', aggregate?: { __typename?: 'organization_aggregate_fields', count: number } | null }, members?: Array<{ __typename?: 'organization_member', profile: { __typename?: 'profile', lastActivity?: any | null } }>, members_aggregate?: { __typename?: 'organization_member_aggregate', aggregate?: { __typename?: 'organization_member_aggregate_fields', count: number } | null }, organization_courses_aggregate?: { __typename?: 'course_aggregate', aggregate?: { __typename?: 'course_aggregate_fields', count: number } | null }, organization_orders_aggregate?: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null } }>, orgsCount: { __typename?: 'organization_aggregate', aggregate?: { __typename?: 'organization_aggregate_fields', count: number } | null } };

export type GetOrganisationDetailsQueryVariables = Exact<{
  where?: InputMaybe<Organization_Bool_Exp>;
  shallow?: Scalars['Boolean']['input'];
  detailed?: Scalars['Boolean']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  sort?: InputMaybe<Array<Organization_Order_By> | Organization_Order_By>;
  specificOrgId?: InputMaybe<Scalars['uuid']['input']>;
  withSpecificOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  withMembers?: InputMaybe<Scalars['Boolean']['input']>;
  withAggregateData?: InputMaybe<Scalars['Boolean']['input']>;
  withDfEEstablishment?: InputMaybe<Scalars['Boolean']['input']>;
  withMainOrganisation?: InputMaybe<Scalars['Boolean']['input']>;
  withExternalDashboardUrl?: InputMaybe<Scalars['Boolean']['input']>;
  withTTConnectId?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetOrganisationDetailsQuery = { __typename?: 'query_root', orgs: Array<{ __typename?: 'organization', dfeEstablishmentId?: any | null, external_dashboard_url?: string | null, tt_connect_id?: string | null, region?: string | null, id: any, name: string, address: any, tags?: any | null, contactDetails: any, attributes: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, dfeEstablishment?: { __typename?: 'dfe_establishment', id: any, urn: string, name: string, localAuthority: string, trustType?: string | null, trustName?: string | null, addressLineOne?: string | null, addressLineTwo?: string | null, addressLineThree?: string | null, town?: string | null, county?: string | null, postcode?: string | null, headTitle?: string | null, headFirstName?: string | null, headLastName?: string | null, headJobTitle?: string | null, ofstedRating?: string | null, ofstedLastInspection?: string | null } | null, main_organisation?: { __typename?: 'organization', id: any, name: string } | null, members?: Array<{ __typename?: 'organization_member', profile: { __typename?: 'profile', lastActivity?: any | null } }>, members_aggregate?: { __typename?: 'organization_member_aggregate', aggregate?: { __typename?: 'organization_member_aggregate_fields', count: number } | null }, organization_courses_aggregate?: { __typename?: 'course_aggregate', aggregate?: { __typename?: 'course_aggregate_fields', count: number } | null }, organization_orders_aggregate?: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null } }>, specificOrg?: Array<{ __typename?: 'organization', dfeEstablishmentId?: any | null, external_dashboard_url?: string | null, region?: string | null, id: any, name: string, address: any, tags?: any | null, contactDetails: any, attributes: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, dfeEstablishment?: { __typename?: 'dfe_establishment', id: any, urn: string, name: string, localAuthority: string, trustType?: string | null, trustName?: string | null, addressLineOne?: string | null, addressLineTwo?: string | null, addressLineThree?: string | null, town?: string | null, county?: string | null, postcode?: string | null, headTitle?: string | null, headFirstName?: string | null, headLastName?: string | null, headJobTitle?: string | null, ofstedRating?: string | null, ofstedLastInspection?: string | null } | null, main_organisation?: { __typename?: 'organization', id: any, name: string } | null, members?: Array<{ __typename?: 'organization_member', profile: { __typename?: 'profile', lastActivity?: any | null } }>, members_aggregate?: { __typename?: 'organization_member_aggregate', aggregate?: { __typename?: 'organization_member_aggregate_fields', count: number } | null }, organization_courses_aggregate?: { __typename?: 'course_aggregate', aggregate?: { __typename?: 'course_aggregate_fields', count: number } | null }, organization_orders_aggregate?: { __typename?: 'order_aggregate', aggregate?: { __typename?: 'order_aggregate_fields', count: number } | null } }>, orgsCount: { __typename?: 'organization_aggregate', aggregate?: { __typename?: 'organization_aggregate_fields', count: number } | null } };

export type AllOrganizationProfilesQueryVariables = Exact<{
  org_id: Scalars['uuid']['input'];
}>;


export type AllOrganizationProfilesQuery = { __typename?: 'query_root', organization_member: Array<{ __typename?: 'organization_member', profile_id: any }> };

export type GetAllResourcePacksPricingsForCourseTypeQueryVariables = Exact<{
  courseTypes?: InputMaybe<Array<Course_Type_Enum> | Course_Type_Enum>;
  organisation_id: Scalars['uuid']['input'];
}>;


export type GetAllResourcePacksPricingsForCourseTypeQuery = { __typename?: 'query_root', resource_packs_pricing: Array<{ __typename?: 'resource_packs_pricing', id: any, course_type: Course_Type_Enum, course_level: Course_Level_Enum, resource_packs_type: Resource_Packs_Type_Enum, resource_packs_delivery_type?: Resource_Packs_Delivery_Type_Enum | null, reaccred: boolean, AUD_price: any, NZD_price: any, org_resource_packs_pricings: Array<{ __typename?: 'org_resource_packs_pricing', id: any, AUD_price: any, NZD_price: any }> }> };

export type ApplyMainOrgResourcePacksPricingsToAffiliatesMutationVariables = Exact<{
  affiliatesIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  pricings: Array<Org_Resource_Packs_Pricing_Insert_Input> | Org_Resource_Packs_Pricing_Insert_Input;
  resourcePackPricingIdsForDefaultReset: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type ApplyMainOrgResourcePacksPricingsToAffiliatesMutation = { __typename?: 'mutation_root', delete_org_resource_packs_pricing?: { __typename?: 'org_resource_packs_pricing_mutation_response', affected_rows: number } | null, insert_org_resource_packs_pricing?: { __typename?: 'org_resource_packs_pricing_mutation_response', affected_rows: number } | null };

export type GetAllAffiliatedOrgIdsQueryVariables = Exact<{
  organisation_id: Scalars['uuid']['input'];
}>;


export type GetAllAffiliatedOrgIdsQuery = { __typename?: 'query_root', organization: Array<{ __typename?: 'organization', id: any }> };

export type GetOrganizationStatisticsQueryVariables = Exact<{
  orgIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type GetOrganizationStatisticsQuery = { __typename?: 'query_root', organizations_statistics: Array<{ __typename?: 'organizations_statistics', id: any, organization_id: any, active_certifications: number, expired_recently_certifications: number, expiring_soon_certifications: number, individuals: number, on_hold_certifications: number }> };

export type LinkAffiliatedOrganisationMutationVariables = Exact<{
  mainOrgId: Scalars['uuid']['input'];
  affiliatedOrgId: Scalars['uuid']['input'];
}>;


export type LinkAffiliatedOrganisationMutation = { __typename?: 'mutation_root', update_organization_by_pk?: { __typename?: 'organization', id: any } | null };

export type GetMainOrgIdQueryVariables = Exact<{
  organisation_id: Scalars['uuid']['input'];
}>;


export type GetMainOrgIdQuery = { __typename?: 'query_root', organization_by_pk?: { __typename?: 'organization', main_organisation_id?: any | null } | null };

export type MergeOrganisationsMutationVariables = Exact<{
  input: MergeOrganisationsInput;
}>;


export type MergeOrganisationsMutation = { __typename?: 'mutation_root', mergeOrganisations?: { __typename?: 'MergeOrganisationsOutput', status: MergeOrganisationsStatus, message: string } | null };

export type OrgMembersQueryVariables = Exact<{
  offset: Scalars['Int']['input'];
  limit: Scalars['Int']['input'];
  orgId: Scalars['uuid']['input'];
  orderBy?: InputMaybe<Array<Organization_Member_Order_By> | Organization_Member_Order_By>;
  whereProfile?: InputMaybe<Profile_Bool_Exp>;
  withMembers?: InputMaybe<Scalars['Boolean']['input']>;
  all?: InputMaybe<Scalars['Boolean']['input']>;
  singularOrg?: InputMaybe<Scalars['Boolean']['input']>;
  certStatus?: InputMaybe<Certificate_Status_Enum>;
}>;


export type OrgMembersQuery = { __typename?: 'query_root', members?: Array<{ __typename?: 'organization_member', id: any, isAdmin?: boolean | null, position?: string | null, profile: { __typename?: 'profile', id: any, fullName?: string | null, lastActivity?: any | null, createdAt: any, go1Licenses: Array<{ __typename?: 'go1_licenses', expireDate: any }>, certificates: Array<{ __typename?: 'course_certificate', id: any, courseLevel: string, status?: Certificate_Status_Enum | null, participant?: { __typename?: 'course_participant', certificateChanges: Array<{ __typename?: 'course_certificate_changelog', payload?: any | null }> } | null }> } }>, organization_member_aggregate?: { __typename?: 'organization_member_aggregate', aggregate?: { __typename?: 'organization_member_aggregate_fields', count: number } | null }, single_organization_members_count?: { __typename?: 'organization_member_aggregate', aggregate?: { __typename?: 'organization_member_aggregate_fields', count: number } | null } };

export type UpsertOrgResourcePacksPricingMutationVariables = Exact<{
  input: Org_Resource_Packs_Pricing_Insert_Input;
}>;


export type UpsertOrgResourcePacksPricingMutation = { __typename?: 'mutation_root', insert_org_resource_packs_pricing_one?: { __typename?: 'org_resource_packs_pricing', id: any } | null };

export type GetOrgResourcePacksPricingsByOrgIdQueryVariables = Exact<{
  organisation_id: Scalars['uuid']['input'];
}>;


export type GetOrgResourcePacksPricingsByOrgIdQuery = { __typename?: 'query_root', org_resource_packs_pricing: Array<{ __typename?: 'org_resource_packs_pricing', id: any, resource_packs_pricing_id: any, AUD_price: any, NZD_price: any }> };

export type GetOrganisationByNameQueryVariables = Exact<{
  query: Scalars['String']['input'];
}>;


export type GetOrganisationByNameQuery = { __typename?: 'query_root', organization: Array<{ __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, main_organisation?: { __typename?: 'organization', id: any, name: string } | null }> };

export type GetOrganisationPendingInvitesQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type GetOrganisationPendingInvitesQuery = { __typename?: 'query_root', organization_invites_aggregate: { __typename?: 'organization_invites_aggregate', aggregate?: { __typename?: 'organization_invites_aggregate_fields', count: number } | null } };

export type GetOrganisationPermissionsQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type GetOrganisationPermissionsQuery = { __typename?: 'query_root', organization_by_pk?: { __typename?: 'organization', canAccessKnowledgeHub?: boolean | null } | null };

export type UpdateOrganisationPermissionsMutationVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  canAccessKnowledgeHub: Scalars['Boolean']['input'];
}>;


export type UpdateOrganisationPermissionsMutation = { __typename?: 'mutation_root', update_organization_by_pk?: { __typename?: 'organization', canAccessKnowledgeHub?: boolean | null } | null };

export type GetProfilesWithCertificationsQueryVariables = Exact<{
  whereOrganizations?: InputMaybe<Organization_Bool_Exp>;
  whereProfileCertificates?: InputMaybe<Course_Certificate_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetProfilesWithCertificationsQuery = { __typename?: 'query_root', profiles: Array<{ __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null, certificates: Array<{ __typename?: 'course_certificate', id: any, courseLevel: string, status?: Certificate_Status_Enum | null, expiryDate: any }> }>, profiles_aggregate: { __typename?: 'profile_aggregate', aggregate?: { __typename?: 'profile_aggregate_fields', count: number } | null } };

export type GetAllOrganisationsStatisticsQueryVariables = Exact<{ [key: string]: never; }>;


export type GetAllOrganisationsStatisticsQuery = { __typename?: 'query_root', organizations_statistics_aggregate: { __typename?: 'organizations_statistics_aggregate', aggregate?: { __typename?: 'organizations_statistics_aggregate_fields', sum?: { __typename?: 'organizations_statistics_sum_fields', active_certifications?: number | null, expired_recently_certifications?: number | null, expiring_soon_certifications?: number | null, individuals?: number | null, on_hold_certifications?: number | null } | null } | null } };

export type GetProfilesByOrganisationQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetProfilesByOrganisationQuery = { __typename?: 'query_root', organization: Array<{ __typename?: 'organization', id: any, members: Array<{ __typename?: 'organization_member', profile: { __typename?: 'profile', id: any, fullName?: string | null, archived?: boolean | null, avatar?: string | null } }> }> };

export type GetProfilesWithOrganisationsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  whereOrganizations?: InputMaybe<Organization_Bool_Exp>;
}>;


export type GetProfilesWithOrganisationsQuery = { __typename?: 'query_root', profiles: Array<{ __typename?: 'profile', id: any, organizations: Array<{ __typename?: 'organization_member', id: any, position?: string | null, organization: { __typename?: 'organization', id: any, name: string } }> }> };

export type GetProfilesWithUpcomingEnrollmentsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  enrollmentsCondition?: InputMaybe<Upcoming_Enrollments_Bool_Exp>;
}>;


export type GetProfilesWithUpcomingEnrollmentsQuery = { __typename?: 'query_root', profile: Array<{ __typename?: 'profile', id: any, courses: Array<{ __typename?: 'course_participant', course: { __typename?: 'course', name: string, id: number, course_code?: string | null, type: Course_Type_Enum, courseLevel: Course_Level_Enum } }>, upcomingEnrollments: Array<{ __typename?: 'upcoming_enrollments', course?: { __typename?: 'course', name: string, id: number, course_code?: string | null, type: Course_Type_Enum, courseLevel: Course_Level_Enum } | null }> }> };

export type UnlinkAffiliatedOrganisationMutationVariables = Exact<{
  affiliatedOrgId: Scalars['uuid']['input'];
}>;


export type UnlinkAffiliatedOrganisationMutation = { __typename?: 'mutation_root', update_organization_by_pk?: { __typename?: 'organization', id: any } | null };

export type UnlinkMultipleAffiliatedOrganisationsMutationVariables = Exact<{
  affiliatedOrgsIds?: InputMaybe<Array<Scalars['uuid']['input']> | Scalars['uuid']['input']>;
}>;


export type UnlinkMultipleAffiliatedOrganisationsMutation = { __typename?: 'mutation_root', update_organization_many?: Array<{ __typename?: 'organization_mutation_response', affected_rows: number } | null> | null };

export type GetUpcomingEnrollmentsStatsQueryVariables = Exact<{
  where: Upcoming_Enrollments_Bool_Exp;
}>;


export type GetUpcomingEnrollmentsStatsQuery = { __typename?: 'query_root', active_enrollments: { __typename?: 'upcoming_enrollments_aggregate', aggregate?: { __typename?: 'upcoming_enrollments_aggregate_fields', count: number } | null }, on_hold_enrollments: { __typename?: 'upcoming_enrollments_aggregate', aggregate?: { __typename?: 'upcoming_enrollments_aggregate_fields', count: number } | null }, expired_recently_enrollments: { __typename?: 'upcoming_enrollments_aggregate', aggregate?: { __typename?: 'upcoming_enrollments_aggregate_fields', count: number } | null }, expiring_soon_enrollments: { __typename?: 'upcoming_enrollments_aggregate', aggregate?: { __typename?: 'upcoming_enrollments_aggregate_fields', count: number } | null } };

export type ImportOrganisationsJobSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ImportOrganisationsJobSubscription = { __typename?: 'subscription_root', import_job_by_pk?: { __typename?: 'import_job', id: any, result: any, status?: Import_Job_Status_Enum | null } | null };

export type ImportOrganisationsMutationVariables = Exact<{
  input: ImportOrganisationsInput;
}>;


export type ImportOrganisationsMutation = { __typename?: 'mutation_root', importOrganisations?: { __typename?: 'ImportOrganisationsOutput', jobId?: string | null, error?: string | null } | null };

export type GetMergeOrgsLogsQueryVariables = Exact<{
  limit: Scalars['Int']['input'];
  offset: Scalars['Int']['input'];
  where: Merge_Organizations_Logs_Bool_Exp;
}>;


export type GetMergeOrgsLogsQuery = { __typename?: 'query_root', logs: Array<{ __typename?: 'merge_organizations_logs', id: any, actionedById: any, createdAt: any, primaryOrganizationId: any, primaryOrganizationName: string, primaryOrganizationUrn?: string | null, actionedBy: { __typename?: 'profile', fullName?: string | null }, mergedOrganizations: Array<{ __typename?: 'merged_organizations', id: any, dfeUrn?: string | null, organizationId: any, organizationName: string }> }>, aggregate: { __typename?: 'merge_organizations_logs_aggregate', aggregate?: { __typename?: 'merge_organizations_logs_aggregate_fields', count: number } | null } };

export type GetOrgsByIdsQueryVariables = Exact<{
  ids: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetOrgsByIdsQuery = { __typename?: 'query_root', organization: Array<{ __typename?: 'organization', id: any, name: string }> };

export type DeleteOrgMutationVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type DeleteOrgMutation = { __typename?: 'mutation_root', deleteOrganisation?: { __typename?: 'DeleteOrganisationOutput', success: boolean } | null };

export type GetAllOrgResourcePacksHistoryQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
}>;


export type GetAllOrgResourcePacksHistoryQuery = { __typename?: 'query_root', history: Array<{ __typename?: 'org_resource_packs_history', id: any, change: number, courseId?: number | null, created_at: any, event: Resource_Packs_Events_Enum, payload?: any | null, reservedBalance: number, resourcePacksType: Resource_Packs_Type_Enum, totalBalance: number, course?: { __typename?: 'course', id: number, code?: string | null, createdBy?: { __typename?: 'profile', id: any, fullName?: string | null } | null, schedule: Array<{ __typename?: 'course_schedule', start: any }> } | null }> };

export type GetOrgResourcePacksPricingChangelogsQueryVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  resourcePacksPricingIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetOrgResourcePacksPricingChangelogsQuery = { __typename?: 'query_root', changelogs: Array<{ __typename?: 'org_resource_packs_pricing_changelog', id: any, actioned_at: any, operation: Cud_Operation_Enum, updated_columns?: any | null, actioned_by_profile?: { __typename?: 'profile', id: any, archived?: boolean | null, avatar?: string | null, fullName?: string | null } | null, resource_packs_pricing?: { __typename?: 'resource_packs_pricing', id: any, course_level: Course_Level_Enum, course_type: Course_Type_Enum, reaccred: boolean, resource_packs_delivery_type?: Resource_Packs_Delivery_Type_Enum | null, resource_packs_type: Resource_Packs_Type_Enum } | null }>, resourcePacksPricings: Array<{ __typename?: 'resource_packs_pricing', id: any, course_level: Course_Level_Enum, course_type: Course_Type_Enum, reaccred: boolean }>, totalChangelogs: { __typename?: 'org_resource_packs_pricing_changelog_aggregate', aggregate?: { __typename?: 'org_resource_packs_pricing_changelog_aggregate_fields', count: number } | null } };

export type GetOrgResourcePacksHistoryQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  orgId: Scalars['uuid']['input'];
}>;


export type GetOrgResourcePacksHistoryQuery = { __typename?: 'query_root', history: Array<{ __typename?: 'org_resource_packs_history', id: any, change: number, courseId?: number | null, created_at: any, event: Resource_Packs_Events_Enum, payload?: any | null, reservedBalance: number, resourcePacksType: Resource_Packs_Type_Enum, totalBalance: number, course?: { __typename?: 'course', id: number, code?: string | null, createdBy?: { __typename?: 'profile', id: any, fullName?: string | null } | null } | null }>, total: { __typename?: 'org_resource_packs_history_aggregate', aggregate?: { __typename?: 'org_resource_packs_history_aggregate_fields', count: number } | null } };

export type GetOrgTypesQueryVariables = Exact<{
  where: Organization_Type_Bool_Exp;
}>;


export type GetOrgTypesQuery = { __typename?: 'query_root', organization_type: Array<{ __typename?: 'organization_type', id: any, name: string }> };

export type Go1LicensesChangeMutationVariables = Exact<{
  input: Go1LicensesChangeInput;
}>;


export type Go1LicensesChangeMutation = { __typename?: 'mutation_root', go1LicensesChange?: { __typename?: 'Go1LicensesChangeOutput', success: boolean, error?: Go1ChangeError | null } | null };

export type InsertOrgLogMutationVariables = Exact<{
  orgId: Scalars['uuid']['input'];
  userId: Scalars['uuid']['input'];
  createfrom: Org_Created_From_Enum;
  op: Cud_Operation_Enum;
  updated_columns?: InputMaybe<Scalars['jsonb']['input']>;
}>;


export type InsertOrgLogMutation = { __typename?: 'mutation_root', org_log?: { __typename?: 'organisation_log', id: any } | null };

export type InsertOrgMutationVariables = Exact<{
  name: Scalars['String']['input'];
  sector?: InputMaybe<Scalars['String']['input']>;
  address: Scalars['jsonb']['input'];
  attributes?: InputMaybe<Scalars['jsonb']['input']>;
  xeroId?: InputMaybe<Scalars['String']['input']>;
  organisationType: Scalars['String']['input'];
  invites?: InputMaybe<Array<Organization_Invites_Insert_Input> | Organization_Invites_Insert_Input>;
  dfeEstablishmentId?: InputMaybe<Scalars['uuid']['input']>;
  mainOrgId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type InsertOrgMutation = { __typename?: 'mutation_root', org?: { __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, main_organisation?: { __typename?: 'organization', id: any, name: string } | null } | null };

export type ManageOrgResourcePacksMutationVariables = Exact<{
  input: ResourcePacksAddInput;
}>;


export type ManageOrgResourcePacksMutation = { __typename?: 'mutation_root', addResourcePacks?: { __typename?: 'ResourcePacksAddOutput', success: boolean, error?: ResourcePacksAddErrorEnum | null, totalResourcePacks?: number | null } | null };

export type SaveOrganisationInvitesMutationVariables = Exact<{
  invites: Array<SaveOrgInviteInput> | SaveOrgInviteInput;
}>;


export type SaveOrganisationInvitesMutation = { __typename?: 'mutation_root', saveOrgInvites?: { __typename?: 'SampleOutput', error?: SaveOrgInviteError | null, success: boolean } | null };

export type SearchXeroContactsQueryVariables = Exact<{
  input: XeroContactSearchInput;
}>;


export type SearchXeroContactsQuery = { __typename?: 'query_root', xero?: { __typename?: 'XeroContactSearchOutput', contacts: Array<{ __typename?: 'XeroContact', name: string, contactID: string }> } | null };

export type UpdateOrgMutationVariables = Exact<{
  org?: InputMaybe<Organization_Set_Input>;
  id: Scalars['uuid']['input'];
}>;


export type UpdateOrgMutation = { __typename?: 'mutation_root', updated?: { __typename?: 'organization', id: any } | null };

export type ImportLegacyCertificateMutationVariables = Exact<{
  input: ImportLegacyCertificateInput;
}>;


export type ImportLegacyCertificateMutation = { __typename?: 'mutation_root', importLegacyCertificate?: { __typename?: 'ImportLegacyCertificateOutput', trainerRoleAdded: boolean, success: boolean, error?: ImportLegacyCertificateError | null } | null };

export type GetBulkProfilesRolesByProfileIdQueryVariables = Exact<{
  profileIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetBulkProfilesRolesByProfileIdQuery = { __typename?: 'query_root', profile: Array<{ __typename?: 'profile', id: any, profile_trainer_agreement_types: Array<{ __typename?: 'profile_trainer_agreement_type', id: any, agreement_type: Trainer_Agreement_Type_Enum }>, roles: Array<{ __typename?: 'profile_role', role: { __typename?: 'role', name: string } }>, trainer_role_types: Array<{ __typename?: 'profile_trainer_role_type', trainer_role_type: { __typename?: 'trainer_role_type', name: string } }> }> };

export type GetProfilesQueryVariables = Exact<{
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  where?: InputMaybe<Profile_Bool_Exp>;
}>;


export type GetProfilesQuery = { __typename?: 'query_root', profiles: Array<{ __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null, email?: string | null, countryCode?: string | null }>, profile_aggregate: { __typename?: 'profile_aggregate', aggregate?: { __typename?: 'profile_aggregate_fields', count: number } | null } };

export type GetProfilesOrganisationsByProfileIdQueryVariables = Exact<{
  profileIds: Array<Scalars['uuid']['input']> | Scalars['uuid']['input'];
}>;


export type GetProfilesOrganisationsByProfileIdQuery = { __typename?: 'query_root', profile: Array<{ __typename?: 'profile', id: any, organizations: Array<{ __typename?: 'organization_member', isAdmin?: boolean | null, organization: { __typename?: 'organization', id: any, name: string } }> }> };

export type GetRolesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetRolesQuery = { __typename?: 'query_root', role: Array<{ __typename?: 'role', id: any, name: string }> };

export type GetTrainerAgreementTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrainerAgreementTypesQuery = { __typename?: 'query_root', trainer_agreement_type: Array<{ __typename?: 'trainer_agreement_type', name: string }> };

export type GetTrainerRoleTypesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetTrainerRoleTypesQuery = { __typename?: 'query_root', trainer_role_type: Array<{ __typename?: 'trainer_role_type', id: any, name: string }> };

export type UpdateProfileAccessMutationVariables = Exact<{
  profileId: Scalars['uuid']['input'];
  canAccessKnowledgeHub: Scalars['Boolean']['input'];
}>;


export type UpdateProfileAccessMutation = { __typename?: 'mutation_root', update_profile_by_pk?: { __typename?: 'profile', canAccessKnowledgeHub?: boolean | null } | null };

export type ArchiveProfileMutationVariables = Exact<{
  profileId: Scalars['uuid']['input'];
}>;


export type ArchiveProfileMutation = { __typename?: 'mutation_root', update_profile_by_pk?: { __typename?: 'profile', id: any } | null };

export type DeleteGo1LicenseMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type DeleteGo1LicenseMutation = { __typename?: 'mutation_root', delete_go1_licenses_by_pk?: { __typename?: 'go1_licenses', id: any } | null };

export type DeleteProfileMutationVariables = Exact<{
  profileId: Scalars['uuid']['input'];
  dryRun?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type DeleteProfileMutation = { __typename?: 'mutation_root', deleteUser: { __typename?: 'DeleteUserOutput', success: boolean, error?: DeleteUserError | null, courseIds?: string | null } };

export type DeleteTempProfileMutationVariables = Exact<{
  email: Scalars['String']['input'];
}>;


export type DeleteTempProfileMutation = { __typename?: 'mutation_root', deleted?: { __typename?: 'profile_temp_mutation_response', affectedRows: number } | null };

export type FindProfilesQueryVariables = Exact<{
  where?: InputMaybe<Profile_Bool_Exp>;
}>;


export type FindProfilesQuery = { __typename?: 'query_root', profiles: Array<{ __typename?: 'profile', id: any, givenName?: string | null, country?: string | null, countryCode?: string | null, familyName?: string | null, fullName?: string | null, avatar?: string | null, title?: string | null, tags?: any | null, addresses: any, attributes: any, contactDetails: any, dietaryRestrictions?: string | null, disabilities?: string | null, archived?: boolean | null, preferences: any, createdAt: any, updatedAt: any, email?: string | null, phone?: string | null, phoneCountryCode?: string | null, dob?: any | null, jobTitle?: string | null, lastActivity?: any | null, organizations: Array<{ __typename?: 'organization_member', id: any, isAdmin?: boolean | null, position?: string | null, organization: { __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, affiliated_organisations: Array<{ __typename?: 'organization', id: any, name: string, address: any }>, main_organisation?: { __typename?: 'organization', id: any, name: string } | null } }>, roles: Array<{ __typename?: 'profile_role', role: { __typename?: 'role', id: any, name: string } }>, trainer_role_types: Array<{ __typename?: 'profile_trainer_role_type', trainer_role_type: { __typename?: 'trainer_role_type', id: any, name: string } }>, profile_trainer_agreement_types: Array<{ __typename?: 'profile_trainer_agreement_type', agreement_type: Trainer_Agreement_Type_Enum, id: any }> }> };

export type GetNotDetailedProfileQueryVariables = Exact<{
  where?: InputMaybe<Profile_Bool_Exp>;
}>;


export type GetNotDetailedProfileQuery = { __typename?: 'query_root', profiles: Array<{ __typename?: 'profile', id: any, countryCode?: string | null, email?: string | null, familyName?: string | null, fullName?: string | null, givenName?: string | null }> };

export type GetProfileDetailsQueryVariables = Exact<{
  profileId: Scalars['uuid']['input'];
  withGo1Licenses?: InputMaybe<Scalars['Boolean']['input']>;
  orgId?: InputMaybe<Scalars['uuid']['input']>;
  withCourseHistory?: InputMaybe<Scalars['Boolean']['input']>;
  withCourseTrainerHistory?: InputMaybe<Scalars['Boolean']['input']>;
  withKnowledgeHubAccess?: InputMaybe<Scalars['Boolean']['input']>;
  whereCertificates?: InputMaybe<Course_Certificate_Bool_Exp>;
}>;


export type GetProfileDetailsQuery = { __typename?: 'query_root', profile?: { __typename?: 'profile', canAccessKnowledgeHub?: boolean | null, id: any, givenName?: string | null, country?: string | null, countryCode?: string | null, familyName?: string | null, fullName?: string | null, avatar?: string | null, title?: string | null, tags?: any | null, addresses: any, attributes: any, contactDetails: any, dietaryRestrictions?: string | null, disabilities?: string | null, archived?: boolean | null, preferences: any, createdAt: any, updatedAt: any, email?: string | null, phone?: string | null, phoneCountryCode?: string | null, dob?: any | null, jobTitle?: string | null, lastActivity?: any | null, participantAudits?: Array<{ __typename?: 'course_participant_audit', id: any, course_id: number, type: Course_Participant_Audit_Type_Enum, course: { __typename?: 'course', name: string, status?: Course_Status_Enum | null, dates: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', start?: { __typename?: 'course_schedule_min_fields', date?: any | null } | null, end?: { __typename?: 'course_schedule_max_fields', date?: any | null } | null } | null } } }>, courseAsTrainer?: Array<{ __typename?: 'course_trainer', id: any, course_id: number, type: Course_Trainer_Type_Enum, course: { __typename?: 'course', id: number, name: string, status?: Course_Status_Enum | null, level: Course_Level_Enum, course_code?: string | null, dates: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', start?: { __typename?: 'course_schedule_min_fields', date?: any | null } | null, end?: { __typename?: 'course_schedule_max_fields', date?: any | null } | null } | null } } }>, courses: Array<{ __typename?: 'course_participant', id: any, attended?: boolean | null, course: { __typename?: 'course', id: number, name: string, status?: Course_Status_Enum | null, start: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', date?: { __typename?: 'course_schedule_max_fields', start?: any | null } | null } | null }, end: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', date?: { __typename?: 'course_schedule_max_fields', end?: any | null } | null } | null } } }>, go1Licenses?: Array<{ __typename?: 'go1_licenses', id: any, orgId: any, expireDate: any, enrolledOn: any }>, organizations: Array<{ __typename?: 'organization_member', id: any, isAdmin?: boolean | null, position?: string | null, organization: { __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, affiliated_organisations: Array<{ __typename?: 'organization', id: any, name: string, address: any }>, main_organisation?: { __typename?: 'organization', id: any, name: string } | null } }>, roles: Array<{ __typename?: 'profile_role', role: { __typename?: 'role', id: any, name: string } }>, trainer_role_types: Array<{ __typename?: 'profile_trainer_role_type', trainer_role_type: { __typename?: 'trainer_role_type', id: any, name: string } }>, profile_trainer_agreement_types: Array<{ __typename?: 'profile_trainer_agreement_type', agreement_type: Trainer_Agreement_Type_Enum, id: any }> } | null, certificates: Array<{ __typename?: 'course_certificate', id: any, createdAt: any, updatedAt: any, number: string, expiryDate: any, certificationDate: any, courseName: string, courseLevel: string, status?: Certificate_Status_Enum | null, legacyCourseCode?: string | null, blendedLearning?: boolean | null, reaccreditation?: boolean | null, courseAccreditedBy?: Accreditors_Enum | null, participant?: { __typename?: 'course_participant', grade?: Grade_Enum | null, certificateChanges: Array<{ __typename?: 'course_certificate_changelog', id: any, createdAt: any, updatedAt: any, payload?: any | null, type: Course_Certificate_Changelog_Type_Enum }> } | null }>, upcomingCourses: Array<{ __typename?: 'course', id: number, level: Course_Level_Enum, course_code?: string | null, name: string, status?: Course_Status_Enum | null, reaccreditation?: boolean | null, residingCountry?: string | null }> };

export type GetUserKnowledgeHubAccessQueryVariables = Exact<{
  profileId: Scalars['uuid']['input'];
}>;


export type GetUserKnowledgeHubAccessQuery = { __typename?: 'query_root', organization_member_aggregate: { __typename?: 'organization_member_aggregate', aggregate?: { __typename?: 'organization_member_aggregate_fields', count: number } | null } };

export type InsertProfileTempMutationVariables = Exact<{
  input: Profile_Temp_Insert_Input;
}>;


export type InsertProfileTempMutation = { __typename?: 'mutation_root', profile?: { __typename?: 'profile_temp_mutation_response', affectedRows: number } | null };

export type RemoveOrgMemberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type RemoveOrgMemberMutation = { __typename?: 'mutation_root', delete_organization_member_by_pk?: { __typename?: 'organization_member', id: any } | null };

export type UpdateOrgMemberMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  member: Organization_Member_Set_Input;
}>;


export type UpdateOrgMemberMutation = { __typename?: 'mutation_root', updated?: { __typename?: 'organization_member', id: any } | null };

export type UpdateProfileActivityMutationVariables = Exact<{
  profileId: Scalars['uuid']['input'];
}>;


export type UpdateProfileActivityMutation = { __typename?: 'mutation_root', update_profile_by_pk?: { __typename?: 'profile', id: any } | null };

export type UpdateAvatarMutationVariables = Exact<{
  avatar: Scalars['bytea']['input'];
  profileId: Scalars['uuid']['input'];
}>;


export type UpdateAvatarMutation = { __typename?: 'mutation_root', updateAvatar?: { __typename?: 'UpdateAvatarResponse', avatar: string } | null };

export type UpdateProfileRolesMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  roles: Array<Profile_Role_Insert_Input> | Profile_Role_Insert_Input;
}>;


export type UpdateProfileRolesMutation = { __typename?: 'mutation_root', delete_profile_role?: { __typename?: 'profile_role_mutation_response', affected_rows: number } | null, insert_profile_role?: { __typename?: 'profile_role_mutation_response', affected_rows: number } | null };

export type UpdateProfileMutationVariables = Exact<{
  input: UpdateUserProfileInput;
}>;


export type UpdateProfileMutation = { __typename?: 'mutation_root', updateUserProfile: boolean };

export type UpdateTrainerAgreementTypesMutationVariables = Exact<{
  profile_id: Scalars['uuid']['input'];
  trainerAgreementTypes: Array<Profile_Trainer_Agreement_Type_Insert_Input> | Profile_Trainer_Agreement_Type_Insert_Input;
}>;


export type UpdateTrainerAgreementTypesMutation = { __typename: 'mutation_root', delete_profile_trainer_agreement_type?: { __typename?: 'profile_trainer_agreement_type_mutation_response', affected_rows: number } | null, insert_profile_trainer_agreement_type?: { __typename?: 'profile_trainer_agreement_type_mutation_response', affected_rows: number } | null };

export type UpdateTrainerRoleTypeMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  trainerRoleTypes: Array<Profile_Trainer_Role_Type_Insert_Input> | Profile_Trainer_Role_Type_Insert_Input;
}>;


export type UpdateTrainerRoleTypeMutation = { __typename?: 'mutation_root', delete_profile_trainer_role_type?: { __typename?: 'profile_trainer_role_type_mutation_response', affected_rows: number } | null, insert_profile_trainer_role_type?: { __typename?: 'profile_trainer_role_type_mutation_response', affected_rows: number } | null };

export type VerifyUserMutationVariables = Exact<{
  inviteId: Scalars['uuid']['input'];
}>;


export type VerifyUserMutation = { __typename?: 'mutation_root', verifyUser: boolean };

export type PurchaseMaterialsMutationVariables = Exact<{
  input: PurchaseMaterialsInput;
}>;


export type PurchaseMaterialsMutation = { __typename?: 'mutation_root', createdOrder: { __typename?: 'PurchaseMaterialsOutput', id?: string | null, success: boolean, error?: string | null } };

export type GetMaterialsOrderQueryVariables = Exact<{
  orderId: Scalars['uuid']['input'];
}>;


export type GetMaterialsOrderQuery = { __typename?: 'query_root', materials_order: Array<{ __typename?: 'materials_order', id: any, reference: string, purchased: any, delivery_city?: string | null, delivery_email?: string | null, delivery_line1?: string | null, delivery_line2?: string | null, delivery_country?: string | null, delivery_postcode?: string | null, delivery_first_name?: string | null, delivery_last_name?: string | null, payment_method?: Payment_Methods_Enum | null, invoice_email?: string | null, invoice_phone?: string | null, invoice_first_name?: string | null, invoice_last_name?: string | null, invoice_purchase_order?: string | null, organization?: { __typename?: 'organization', id: any, name: string } | null }> };

export type GetResourcePackBundlesQueryVariables = Exact<{ [key: string]: never; }>;


export type GetResourcePackBundlesQuery = { __typename?: 'query_root', resourcePackBundles: Array<{ __typename?: 'resource_pack_bundle_price', bundle_option: Resource_Pack_Bundle_Option_Enum, currency?: string | null, price: any, postage_and_packing: any, qty: any }> };

export type SignUpMutationVariables = Exact<{
  input: SignUpInput;
}>;


export type SignUpMutation = { __typename?: 'mutation_root', signUp?: { __typename?: 'SignUpOutput', success: boolean } | null };

export type GetResourcePackPricingsQueryVariables = Exact<{
  where: Resource_Packs_Pricing_Bool_Exp;
  organisation_id?: InputMaybe<Scalars['uuid']['input']>;
  forSpecificOrg: Scalars['Boolean']['input'];
}>;


export type GetResourcePackPricingsQuery = { __typename?: 'query_root', resource_packs_pricing: Array<{ __typename?: 'resource_packs_pricing', id: any, AUD_price: any, NZD_price: any, org_resource_packs_pricings?: Array<{ __typename?: 'org_resource_packs_pricing', id: any, AUD_price: any, NZD_price: any }> }> };

export type AllResourceCategoriesQueryVariables = Exact<{ [key: string]: never; }>;


export type AllResourceCategoriesQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', resourceCategories?: { __typename?: 'RootQueryToResourceCategoryConnection', nodes?: Array<{ __typename?: 'ResourceCategory', id: string, name?: string | null, description?: string | null, resouceIcon?: { __typename?: 'ResourceCategory_Resouceicon', resourceicon?: string | null } | null, resourceArea?: { __typename?: 'ResourceCategory_Resourcearea', resourcearea?: string | null } | null, resourcePermissions?: { __typename?: 'ResourceCategory_Resourcepermissions', allowAccessDayBeforeCourseStart?: boolean | null, certificateLevels?: Array<string | null> | null, principalTrainer?: boolean | null, courseInProgress?: boolean | null, seniorTrainer?: boolean | null, etaTrainer?: boolean | null } | null } | null> | null } | null } | null };

export type ResourceDetailsQueryVariables = Exact<{
  id: Scalars['ID']['input'];
  term?: InputMaybe<Scalars['String']['input']>;
}>;


export type ResourceDetailsQuery = { __typename?: 'query_root', content?: { __typename?: 'contentRootQuery', resourceCategory?: { __typename?: 'ResourceCategory', id: string, name?: string | null, description?: string | null, children?: { __typename?: 'ResourceCategoryToResourceCategoryConnection', nodes?: Array<{ __typename?: 'ResourceCategory', id: string, name?: string | null, description?: string | null, children?: { __typename?: 'ResourceCategoryToResourceCategoryConnection', nodes?: Array<{ __typename?: 'ResourceCategory', id: string, name?: string | null, description?: string | null, resourcePermissions?: { __typename?: 'ResourceCategory_Resourcepermissions', allowAccessDayBeforeCourseStart?: boolean | null, certificateLevels?: Array<string | null> | null, courseInProgress?: boolean | null, etaTrainer?: boolean | null, principalTrainer?: boolean | null, seniorTrainer?: boolean | null } | null, resources?: { __typename?: 'ResourceCategoryToResourceConnection', nodes?: Array<{ __typename?: 'Resource', id: string, title?: string | null, resourceAttachment?: { __typename?: 'Resource_Resourceattachment', resourcetype?: string | null, videourl?: string | null, file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null, link?: { __typename?: 'AcfLink', url?: string | null } | null } | null, resourcePermissions?: { __typename?: 'Resource_Resourcepermissions', allowAccessDayBeforeCourseStart?: boolean | null, certificateLevels?: Array<string | null> | null, courseInProgress?: boolean | null, etaTrainer?: boolean | null, principalTrainer?: boolean | null, seniorTrainer?: boolean | null } | null } | null> | null } | null } | null> | null } | null, resourcePermissions?: { __typename?: 'ResourceCategory_Resourcepermissions', allowAccessDayBeforeCourseStart?: boolean | null, certificateLevels?: Array<string | null> | null, courseInProgress?: boolean | null, etaTrainer?: boolean | null, principalTrainer?: boolean | null, seniorTrainer?: boolean | null } | null, resources?: { __typename?: 'ResourceCategoryToResourceConnection', nodes?: Array<{ __typename?: 'Resource', id: string, title?: string | null, resourceAttachment?: { __typename?: 'Resource_Resourceattachment', resourcetype?: string | null, videourl?: string | null, file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null, link?: { __typename?: 'AcfLink', url?: string | null } | null } | null, resourcePermissions?: { __typename?: 'Resource_Resourcepermissions', allowAccessDayBeforeCourseStart?: boolean | null, certificateLevels?: Array<string | null> | null, courseInProgress?: boolean | null, etaTrainer?: boolean | null, principalTrainer?: boolean | null, seniorTrainer?: boolean | null } | null } | null> | null } | null } | null> | null } | null, resourcePermissions?: { __typename?: 'ResourceCategory_Resourcepermissions', allowAccessDayBeforeCourseStart?: boolean | null, certificateLevels?: Array<string | null> | null, courseInProgress?: boolean | null, etaTrainer?: boolean | null, principalTrainer?: boolean | null, seniorTrainer?: boolean | null } | null, resources?: { __typename?: 'ResourceCategoryToResourceConnection', nodes?: Array<{ __typename?: 'Resource', id: string, title?: string | null, resourceAttachment?: { __typename?: 'Resource_Resourceattachment', resourcetype?: string | null, videourl?: string | null, file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null, link?: { __typename?: 'AcfLink', url?: string | null } | null } | null, resourcePermissions?: { __typename?: 'Resource_Resourcepermissions', allowAccessDayBeforeCourseStart?: boolean | null, certificateLevels?: Array<string | null> | null, courseInProgress?: boolean | null, etaTrainer?: boolean | null, principalTrainer?: boolean | null, seniorTrainer?: boolean | null } | null } | null> | null } | null } | null } | null };

export type ResourceCategorySummaryFragment = { __typename?: 'ResourceCategory', id: string, name?: string | null, description?: string | null, resourcePermissions?: { __typename?: 'ResourceCategory_Resourcepermissions', allowAccessDayBeforeCourseStart?: boolean | null, certificateLevels?: Array<string | null> | null, courseInProgress?: boolean | null, etaTrainer?: boolean | null, principalTrainer?: boolean | null, seniorTrainer?: boolean | null } | null, resources?: { __typename?: 'ResourceCategoryToResourceConnection', nodes?: Array<{ __typename?: 'Resource', id: string, title?: string | null, resourceAttachment?: { __typename?: 'Resource_Resourceattachment', resourcetype?: string | null, videourl?: string | null, file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null, link?: { __typename?: 'AcfLink', url?: string | null } | null } | null, resourcePermissions?: { __typename?: 'Resource_Resourcepermissions', allowAccessDayBeforeCourseStart?: boolean | null, certificateLevels?: Array<string | null> | null, courseInProgress?: boolean | null, etaTrainer?: boolean | null, principalTrainer?: boolean | null, seniorTrainer?: boolean | null } | null } | null> | null } | null };

export type ResourceSummaryFragment = { __typename?: 'Resource', id: string, title?: string | null, resourceAttachment?: { __typename?: 'Resource_Resourceattachment', resourcetype?: string | null, videourl?: string | null, file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null, link?: { __typename?: 'AcfLink', url?: string | null } | null } | null, resourcePermissions?: { __typename?: 'Resource_Resourcepermissions', allowAccessDayBeforeCourseStart?: boolean | null, certificateLevels?: Array<string | null> | null, courseInProgress?: boolean | null, etaTrainer?: boolean | null, principalTrainer?: boolean | null, seniorTrainer?: boolean | null } | null };

export type GetEstablishmentByUrnQueryVariables = Exact<{
  urn: Scalars['String']['input'];
}>;


export type GetEstablishmentByUrnQuery = { __typename?: 'query_root', dfe_establishment: Array<{ __typename?: 'dfe_establishment', id: any, urn: string, name: string, organizations: Array<{ __typename?: 'organization', id: any, name: string }> }> };

export type AppMembershipFragment = { __typename?: 'AppMembershipData', id: string, registered: boolean, roles: Array<{ __typename?: 'SSORole', name: string, rank: number }>, organisations: Array<{ __typename?: 'SSOOrganisation', id: string, name: string, urn?: string | null, addressLine1: string, addressLine2?: string | null, addressLine3?: string | null, city: string, country: string, countryCode: string, postcode: string, isPrimary: boolean, isAdmin: boolean }> };

export type GetSsoUserDataQueryVariables = Exact<{
  input: GetSsoUserDataInput;
}>;


export type GetSsoUserDataQuery = { __typename?: 'query_root', getSSOUserData?: { __typename?: 'GetSSOUserDataOutput', connectProfile?: { __typename?: 'ConnectProfile', id: any, _family_name?: string | null, _given_name?: string | null, jobTitle?: string | null, phone?: string | null, country?: string | null, countryCode?: string | null, dob?: any | null, createdAt: any, updatedAt: any, roles: Array<{ __typename?: 'ConnectProfileRole', role: { __typename?: 'ConnectRole', name: string, rank?: number | null } }>, organizations: Array<{ __typename?: 'ConnectProfileOrganization', id: any, isAdmin?: boolean | null, organization: { __typename?: 'ConnectOrganization', id: any, address: any, name: string, urn?: string | null } }> } | null, ssoProfile?: { __typename?: 'SSOUserProfile', id: string, firstName: string, lastName: string, email: string, dateOfBirth?: string | null, jobTitle?: string | null, phone?: string | null, residingCountry?: string | null, appMemberships: { __typename?: 'SSOAppMemberships', beSmart?: { __typename?: 'AppMembershipData', id: string, registered: boolean, roles: Array<{ __typename?: 'SSORole', name: string, rank: number }>, organisations: Array<{ __typename?: 'SSOOrganisation', id: string, name: string, urn?: string | null, addressLine1: string, addressLine2?: string | null, addressLine3?: string | null, city: string, country: string, countryCode: string, postcode: string, isPrimary: boolean, isAdmin: boolean }> } | null, connect?: { __typename?: 'AppMembershipData', id: string, registered: boolean, roles: Array<{ __typename?: 'SSORole', name: string, rank: number }>, organisations: Array<{ __typename?: 'SSOOrganisation', id: string, name: string, urn?: string | null, addressLine1: string, addressLine2?: string | null, addressLine3?: string | null, city: string, country: string, countryCode: string, postcode: string, isPrimary: boolean, isAdmin: boolean }> } | null, knowledgeHub?: { __typename?: 'AppMembershipData', id: string, registered: boolean, roles: Array<{ __typename?: 'SSORole', name: string, rank: number }>, organisations: Array<{ __typename?: 'SSOOrganisation', id: string, name: string, urn?: string | null, addressLine1: string, addressLine2?: string | null, addressLine3?: string | null, city: string, country: string, countryCode: string, postcode: string, isPrimary: boolean, isAdmin: boolean }> } | null } } | null } | null };

export type CompleteProfileMutationVariables = Exact<{
  input: Profile_Insert_Input;
  profileId: Scalars['uuid']['input'];
}>;


export type CompleteProfileMutation = { __typename?: 'mutation_root', profile?: { __typename?: 'profile', id: any, givenName?: string | null, familyName?: string | null, email?: string | null } | null, delete_profile_role?: { __typename?: 'profile_role_mutation_response', affected_rows: number } | null };

export type GetCourseDraftsQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<Course_Draft_Order_By> | Course_Draft_Order_By>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetCourseDraftsQuery = { __typename?: 'query_root', course_draft: Array<{ __typename?: 'course_draft', id: any, name?: string | null, data?: any | null, createdAt: any, updatedAt: any, profile: { __typename?: 'profile', id: any, givenName?: string | null, familyName?: string | null } }>, course_draft_aggregate: { __typename?: 'course_draft_aggregate', aggregate?: { __typename?: 'course_draft_aggregate_fields', count: number } | null } };

export type TrainerCourseFragment = { __typename?: 'course', id: number, name: string, type: Course_Type_Enum, level: Course_Level_Enum, state?: string | null, status?: Course_Status_Enum | null, createdAt: any, course_code?: string | null, go1Integration: boolean, max_participants: number, curriculum?: any | null, isDraft?: boolean | null, organization?: { __typename?: 'organization', name: string } | null, trainers: Array<{ __typename?: 'course_trainer', id: any, type: Course_Trainer_Type_Enum, status?: Course_Invite_Status_Enum | null, profile: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null } }>, participantsAgg: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null }, waitlistAgg: { __typename?: 'waitlist_aggregate', aggregate?: { __typename?: 'waitlist_aggregate_fields', count: number } | null }, modulesAgg: { __typename?: 'course_module_aggregate', aggregate?: { __typename?: 'course_module_aggregate_fields', count: number } | null }, bildModules: Array<{ __typename?: 'course_bild_module', id: any }>, schedule: Array<{ __typename?: 'course_schedule', id: any, start: any, end: any, timeZone: string, virtualLink?: string | null, venue?: { __typename?: 'venue', id: any, name: string, city: string } | null }>, cancellationRequest?: { __typename?: 'course_cancellation_request', id: any } | null };

export type TrainerCoursesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<Course_Order_By> | Course_Order_By>;
  where?: InputMaybe<Course_Bool_Exp>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  withArloRefId?: InputMaybe<Scalars['Boolean']['input']>;
  withParticipants?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type TrainerCoursesQuery = { __typename?: 'query_root', courses: Array<{ __typename?: 'course', arloReferenceId?: string | null, id: number, name: string, type: Course_Type_Enum, level: Course_Level_Enum, state?: string | null, status?: Course_Status_Enum | null, createdAt: any, course_code?: string | null, go1Integration: boolean, max_participants: number, curriculum?: any | null, isDraft?: boolean | null, courseParticipants?: Array<{ __typename?: 'course_participant', healthSafetyConsent: boolean, grade?: Grade_Enum | null, attended?: boolean | null }>, organization?: { __typename?: 'organization', name: string } | null, trainers: Array<{ __typename?: 'course_trainer', id: any, type: Course_Trainer_Type_Enum, status?: Course_Invite_Status_Enum | null, profile: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null } }>, participantsAgg: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null }, waitlistAgg: { __typename?: 'waitlist_aggregate', aggregate?: { __typename?: 'waitlist_aggregate_fields', count: number } | null }, modulesAgg: { __typename?: 'course_module_aggregate', aggregate?: { __typename?: 'course_module_aggregate_fields', count: number } | null }, bildModules: Array<{ __typename?: 'course_bild_module', id: any }>, schedule: Array<{ __typename?: 'course_schedule', id: any, start: any, end: any, timeZone: string, virtualLink?: string | null, venue?: { __typename?: 'venue', id: any, name: string, city: string } | null }>, cancellationRequest?: { __typename?: 'course_cancellation_request', id: any } | null }>, course_aggregate: { __typename?: 'course_aggregate', aggregate?: { __typename?: 'course_aggregate_fields', count: number } | null } };

export type SetCourseTrainerStatusMutationVariables = Exact<{
  id: Scalars['uuid']['input'];
  status: Course_Invite_Status_Enum;
}>;


export type SetCourseTrainerStatusMutation = { __typename?: 'mutation_root', update_course_trainer_by_pk?: { __typename?: 'course_trainer', id: any, status?: Course_Invite_Status_Enum | null } | null };

export type GetCourseParticipantForTransferQueryVariables = Exact<{
  profileId: Scalars['uuid']['input'];
  courseId: Scalars['Int']['input'];
}>;


export type GetCourseParticipantForTransferQuery = { __typename?: 'query_root', course_participant: Array<{ __typename?: 'course_participant', id: any, completed_evaluation?: boolean | null, grade?: Grade_Enum | null, dateGraded?: any | null, attended?: boolean | null, healthSafetyConsent: boolean, profile: { __typename?: 'profile', fullName?: string | null, avatar?: string | null, archived?: boolean | null }, gradingModules: Array<{ __typename?: 'course_participant_module', completed: boolean, module: { __typename?: 'module', id: any, name: string, moduleGroup?: { __typename?: 'module_group', id: any, name: string } | null } }>, certificate?: { __typename?: 'course_certificate', id: any, createdAt: any, updatedAt: any, number: string, expiryDate: any, certificationDate: any, courseName: string, courseLevel: string, status?: Certificate_Status_Enum | null, legacyCourseCode?: string | null, blendedLearning?: boolean | null, reaccreditation?: boolean | null, courseAccreditedBy?: Accreditors_Enum | null } | null }> };

export type ParticipantTransferQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ParticipantTransferQuery = { __typename?: 'query_root', participant?: { __typename?: 'course_participant', id: any, profile: { __typename?: 'profile', fullName?: string | null, avatar?: string | null } } | null };

export type TransferParticipantDetailsQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
  participantId: Scalars['uuid']['input'];
}>;


export type TransferParticipantDetailsQuery = { __typename?: 'query_root', course?: { __typename?: 'course', id: number, level: Course_Level_Enum, type: Course_Type_Enum, status?: Course_Status_Enum | null, reaccreditation?: boolean | null, priceCurrency?: string | null, deliveryType: Course_Delivery_Type_Enum, residingCountry?: string | null, dates: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', start?: { __typename?: 'course_schedule_min_fields', date?: any | null } | null, end?: { __typename?: 'course_schedule_max_fields', date?: any | null } | null } | null } } | null, participant?: { __typename?: 'course_participant', id: any, profile: { __typename?: 'profile', fullName?: string | null, avatar?: string | null } } | null };

export type TransferEligibleCoursesQueryVariables = Exact<{
  fromCourseId: Scalars['Int']['input'];
  participantId: Scalars['uuid']['input'];
}>;


export type TransferEligibleCoursesQuery = { __typename?: 'query_root', eligibleTransferCourses: Array<{ __typename?: 'TransferCourse', id: number, freeSlots: number, courseCode: string, courseResidingCountry?: string | null, startDate: string, endDate: string, virtualLink?: string | null, venue?: string | null, venueName?: string | null, venueCity?: string | null, venueCountry?: string | null, level?: CourseLevel | null, reaccreditation: boolean, type: CourseType, deliveryType: CourseDeliveryType, timezone?: string | null }> };

export type TransferParticipantMutationVariables = Exact<{
  input: TransferInput;
}>;


export type TransferParticipantMutation = { __typename?: 'mutation_root', transferParticipant?: { __typename?: 'TransferParticipantOutput', success: boolean, error?: TransferParticipantError | null } | null };

export type ImportUsersJobSubscriptionVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type ImportUsersJobSubscription = { __typename?: 'subscription_root', import_job_by_pk?: { __typename?: 'import_job', id: any, result: any, status?: Import_Job_Status_Enum | null } | null };

export type StartImportUsersJobMutationVariables = Exact<{
  input: ImportUsersInput;
}>;


export type StartImportUsersJobMutation = { __typename?: 'mutation_root', importUsers?: { __typename?: 'ImportUsersOutput', jobId: string } | null };

export type MergeUserMutationVariables = Exact<{
  primaryUser: Scalars['uuid']['input'];
  mergeWith: Scalars['uuid']['input'];
}>;


export type MergeUserMutation = { __typename?: 'mutation_root', mergeUser: { __typename?: 'MergeUserOutput', success: boolean, error?: MergeUserError | null } };

export type RemoveUnverifiedRoleMutationVariables = Exact<{
  profileId: Scalars['uuid']['input'];
}>;


export type RemoveUnverifiedRoleMutation = { __typename?: 'mutation_root', delete_profile_role?: { __typename?: 'profile_role_mutation_response', affected_rows: number } | null };

export type CancelMyselfFromCourseWaitlistMutationVariables = Exact<{
  courseId: Scalars['Int']['input'];
  cancellationSecret: Scalars['uuid']['input'];
}>;


export type CancelMyselfFromCourseWaitlistMutation = { __typename?: 'mutation_root', cancelMyselfFromCourseWaitlist?: { __typename?: 'CancelMyselfFromCourseWaitlistOutput', success: boolean, error?: CancelMyselfFromCourseWaitlistError | null } | null };

export type GetCourseResidingCountryQueryVariables = Exact<{
  courseId: Scalars['Int']['input'];
}>;


export type GetCourseResidingCountryQuery = { __typename?: 'query_root', course: Array<{ __typename?: 'course', residingCountry?: string | null }> };

export type WaitlistCourseQueryVariables = Exact<{
  id: Scalars['Int']['input'];
}>;


export type WaitlistCourseQuery = { __typename?: 'query_root', courses: Array<{ __typename?: 'course', id: number, name: string, deliveryType: Course_Delivery_Type_Enum, schedule: Array<{ __typename?: 'course_schedule', end: any, start: any, venue?: { __typename?: 'venue', name: string, addressLineOne?: string | null, addressLineTwo?: string | null, city: string, postCode?: string | null } | null }> }> };

export type JoinWaitlistMutationVariables = Exact<{
  input: JoinWaitlistInput;
}>;


export type JoinWaitlistMutation = { __typename?: 'mutation_root', joinWaitlist: { __typename?: 'JoinWaitlistOutput', success: boolean } };

export type KnowledgeHubResourceDetailsFragment = { __typename?: 'KnowledgeHubResource', id: string, title: string, description: string, imageUrl: string, srcSet?: string | null, url: string, publishedDate: string, type: KnowledgeHubResourceType, authors?: Array<string> | null };

export type KnowledgeHubResourcesQueryVariables = Exact<{ [key: string]: never; }>;


export type KnowledgeHubResourcesQuery = { __typename?: 'query_root', knowledgeHubResources?: { __typename?: 'KnowledgeHubResourcesOutput', resources: Array<{ __typename?: 'KnowledgeHubResource', id: string, title: string, description: string, imageUrl: string, srcSet?: string | null, url: string, publishedDate: string, type: KnowledgeHubResourceType, authors?: Array<string> | null }> } | null };

export type GetUserAcceptedCourseInvitesCountWithSplashScreensQueryVariables = Exact<{
  profileId: Scalars['uuid']['input'];
}>;


export type GetUserAcceptedCourseInvitesCountWithSplashScreensQuery = { __typename?: 'query_root', course_invites_aggregate: { __typename?: 'course_invites_aggregate', aggregate?: { __typename?: 'course_invites_aggregate_fields', count: number } | null }, course_invite_splash_screens: Array<{ __typename?: 'submission_of_splash_screens', seen_count?: number | null }> };

export type GetUserQualifyingCertificateCountQueryVariables = Exact<{
  profileId: Scalars['uuid']['input'];
}>;


export type GetUserQualifyingCertificateCountQuery = { __typename?: 'query_root', course_certificate_aggregate: { __typename?: 'course_certificate_aggregate', aggregate?: { __typename?: 'course_certificate_aggregate_fields', count: number } | null } };

export type GetCourseByIdQueryVariables = Exact<{
  id: Scalars['Int']['input'];
  withArloRefId?: InputMaybe<Scalars['Boolean']['input']>;
  withFreeCourseCourseMaterials?: InputMaybe<Scalars['Boolean']['input']>;
  withInternationalFinance?: InputMaybe<Scalars['Boolean']['input']>;
  withModules?: InputMaybe<Scalars['Boolean']['input']>;
  withOrders?: InputMaybe<Scalars['Boolean']['input']>;
  withOrgLicenses?: InputMaybe<Scalars['Boolean']['input']>;
  withParticipants?: InputMaybe<Scalars['Boolean']['input']>;
  withParticipantsPendingInvitesCount?: InputMaybe<Scalars['Boolean']['input']>;
  withResourcePacks?: InputMaybe<Scalars['Boolean']['input']>;
  withExceptionsReason?: InputMaybe<Scalars['Boolean']['input']>;
  withHubspotDealId?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type GetCourseByIdQuery = { __typename?: 'query_root', course?: { __typename?: 'course', isDraft?: boolean | null, arloReferenceId?: string | null, displayOnWebsite?: boolean | null, curriculum?: any | null, accreditedBy: Accreditors_Enum, conversion?: boolean | null, freeSpaces?: number | null, accountCode?: string | null, level: Course_Level_Enum, special_instructions?: string | null, parking_instructions?: string | null, price?: any | null, exceptionsPending: boolean, renewalCycle?: Course_Renewal_Cycle_Enum | null, priceCurrency?: string | null, includeVAT?: boolean | null, free_course_materials?: number | null, reservedResourcePacks?: number | null, resourcePacksDeliveryType?: Resource_Packs_Delivery_Type_Enum | null, resourcePacksType?: Resource_Packs_Type_Enum | null, bookingContactInviteData?: any | null, organizationKeyContactInviteData?: any | null, id: number, aolCostOfCourse?: any | null, aolCountry?: string | null, aolRegion?: string | null, course_code?: string | null, createdAt: any, deliveryType: Course_Delivery_Type_Enum, go1Integration: boolean, gradingConfirmed: boolean, gradingStarted: boolean, is_tender: boolean, max_participants: number, min_participants: number, modulesDuration: number, name: string, reaccreditation?: boolean | null, region?: string | null, residingCountry?: string | null, status?: Course_Status_Enum | null, type: Course_Type_Enum, updatedAt: any, coursesReservedLicenses?: number | null, hubspotDealId?: string | null, bildModules: Array<{ __typename?: 'course_bild_module', id: any, modules: any }>, bildStrategies: Array<{ __typename?: 'course_bild_strategy', strategyName: string }>, cancellationRequest?: { __typename?: 'course_cancellation_request', id: any, reason: string } | null, trainers: Array<{ __typename?: 'course_trainer', id: any, type: Course_Trainer_Type_Enum, status?: Course_Invite_Status_Enum | null, course_id: number, profile: { __typename?: 'profile', id: any, givenName?: string | null, familyName?: string | null, fullName?: string | null, avatar?: string | null, archived?: boolean | null, levels: Array<{ __typename?: 'course_certificate', courseLevel: string, expiryDate: any }>, trainer_role_types: Array<{ __typename?: 'profile_trainer_role_type', trainer_role_type: { __typename?: 'trainer_role_type', id: any, name: string } }> } }>, schedule: Array<{ __typename?: 'course_schedule', virtualAccountId?: string | null, timeZone: string, id: any, createdAt: any, updatedAt: any, start: any, end: any, virtualLink?: string | null, venue?: { __typename?: 'venue', id: any, createdAt: any, updatedAt: any, name: string, city: string, addressLineOne?: string | null, addressLineTwo?: string | null, postCode?: string | null, country?: string | null, geoCoordinates?: any | null, googlePlacesId?: string | null } | null }>, organization?: { __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, go1Licenses?: number | null, reservedGo1Licenses?: number | null, mainOrganizationLicenses?: { __typename?: 'organization', go1Licenses?: number | null, reservedGo1Licenses?: number | null } | null, main_organisation?: { __typename?: 'organization', id: any, name: string } | null } | null, bookingContact?: { __typename?: 'profile', id: any, archived?: boolean | null, avatar?: string | null, country?: string | null, countryCode?: string | null, email?: string | null, familyName?: string | null, fullName?: string | null, givenName?: string | null } | null, organizationKeyContact?: { __typename?: 'profile', id: any, archived?: boolean | null, avatar?: string | null, country?: string | null, countryCode?: string | null, email?: string | null, familyName?: string | null, fullName?: string | null, givenName?: string | null } | null, orders?: Array<{ __typename?: 'course_order', order?: { __typename?: 'order', id: any, xeroInvoiceNumber?: string | null, source?: string | null, salesRepresentative?: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null } | null } | null }>, dates: { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', start?: { __typename?: 'course_schedule_min_fields', date?: any | null } | null, end?: { __typename?: 'course_schedule_max_fields', date?: any | null } | null } | null }, moduleGroupIds: Array<{ __typename?: 'course_module', module: { __typename?: 'module', moduleGroup?: { __typename?: 'module_group', id: any } | null } }>, modules?: Array<{ __typename?: 'course_module', id: any, covered?: boolean | null, module: { __typename?: 'module', id: any, name: string, moduleGroup?: { __typename?: 'module_group', id: any, name: string, mandatory: boolean } | null } }>, courseParticipants?: Array<{ __typename?: 'course_participant', healthSafetyConsent: boolean, grade?: Grade_Enum | null, attended?: boolean | null }>, certificateCount: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null }, participantSubmittedEvaluationCount: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null }, attendeesCount: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null }, courseExceptions: Array<{ __typename?: 'course_exceptions', exception: Course_Exception_Enum, reason?: string | null }>, participantsPendingInvites?: { __typename?: 'course_invites_aggregate', aggregate?: { __typename?: 'course_invites_aggregate_fields', count: number } | null }, materialsOrganization?: { __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, main_organisation?: { __typename?: 'organization', id: any, name: string } | null } | null } | null };

export type ReserveResourcePacksMutationVariables = Exact<{
  input: ResourcePacksReserveInput;
}>;


export type ReserveResourcePacksMutation = { __typename?: 'mutation_root', reserveResourcePacks?: { __typename?: 'ResourcePacksReserveOutput', success: boolean, error?: ResourcePacksReserveErrorEnum | null } | null };

export type OrganizationFragment = { __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, main_organisation?: { __typename?: 'organization', id: any, name: string } | null };

export type ShallowOrganizationFragment = { __typename?: 'organization', id: any, name: string, address: any };

export type ProfileFragment = { __typename?: 'profile', id: any, givenName?: string | null, country?: string | null, countryCode?: string | null, familyName?: string | null, fullName?: string | null, avatar?: string | null, title?: string | null, tags?: any | null, addresses: any, attributes: any, contactDetails: any, dietaryRestrictions?: string | null, disabilities?: string | null, archived?: boolean | null, preferences: any, createdAt: any, updatedAt: any, email?: string | null, phone?: string | null, phoneCountryCode?: string | null, dob?: any | null, jobTitle?: string | null, lastActivity?: any | null, organizations: Array<{ __typename?: 'organization_member', id: any, isAdmin?: boolean | null, position?: string | null, organization: { __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, affiliated_organisations: Array<{ __typename?: 'organization', id: any, name: string, address: any }>, main_organisation?: { __typename?: 'organization', id: any, name: string } | null } }>, roles: Array<{ __typename?: 'profile_role', role: { __typename?: 'role', id: any, name: string } }>, trainer_role_types: Array<{ __typename?: 'profile_trainer_role_type', trainer_role_type: { __typename?: 'trainer_role_type', id: any, name: string } }>, profile_trainer_agreement_types: Array<{ __typename?: 'profile_trainer_agreement_type', agreement_type: Trainer_Agreement_Type_Enum, id: any }> };

export type ModuleFragment = { __typename?: 'module', id: any, name: string, description?: string | null, level: Course_Level_Enum, type: Module_Category_Enum, createdAt: any, updatedAt: any, submodules: Array<{ __typename?: 'submodule', id: any, name: string }>, submodules_aggregate: { __typename?: 'submodule_aggregate', aggregate?: { __typename?: 'submodule_aggregate_fields', count: number } | null } };

export type ModuleGroupFragment = { __typename?: 'module_group', id: any, name: string, level: Course_Level_Enum, color: Color_Enum, mandatory: boolean, requires?: any | null, createdAt: any, updatedAt: any };

export type CourseFragment = { __typename?: 'course', id: number, aolCostOfCourse?: any | null, aolCountry?: string | null, aolRegion?: string | null, course_code?: string | null, createdAt: any, deliveryType: Course_Delivery_Type_Enum, go1Integration: boolean, gradingConfirmed: boolean, gradingStarted: boolean, is_tender: boolean, level: Course_Level_Enum, max_participants: number, min_participants: number, modulesDuration: number, name: string, reaccreditation?: boolean | null, region?: string | null, residingCountry?: string | null, status?: Course_Status_Enum | null, type: Course_Type_Enum, updatedAt: any };

export type CourseDatesFragment = { __typename?: 'course_schedule_aggregate', aggregate?: { __typename?: 'course_schedule_aggregate_fields', start?: { __typename?: 'course_schedule_min_fields', date?: any | null } | null, end?: { __typename?: 'course_schedule_max_fields', date?: any | null } | null } | null };

export type CourseScheduleFragment = { __typename?: 'course_schedule', id: any, createdAt: any, updatedAt: any, start: any, end: any, virtualLink?: string | null };

export type VenueFragment = { __typename?: 'venue', id: any, createdAt: any, updatedAt: any, name: string, city: string, addressLineOne?: string | null, addressLineTwo?: string | null, postCode?: string | null, country?: string | null, geoCoordinates?: any | null, googlePlacesId?: string | null };

export type CertificateFragment = { __typename?: 'course_certificate', id: any, createdAt: any, updatedAt: any, number: string, expiryDate: any, certificationDate: any, courseName: string, courseLevel: string, status?: Certificate_Status_Enum | null, legacyCourseCode?: string | null, blendedLearning?: boolean | null, reaccreditation?: boolean | null, courseAccreditedBy?: Accreditors_Enum | null };

export type CertificateChangelogFragment = { __typename?: 'course_certificate_changelog', id: any, createdAt: any, updatedAt: any, payload?: any | null, type: Course_Certificate_Changelog_Type_Enum };

export type LegacyCertificateFragment = { __typename?: 'legacy_certificate', id: any, number: string, courseName: string, expiryDate: any, certificationDate: any };

export type OrderFragment = { __typename?: 'order', id: any, xeroInvoiceNumber?: string | null };

export type VideoItemSummaryFragment = { __typename?: 'VideoSeriesItem', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, youtube?: { __typename?: 'VideoSeriesItem_Youtube', url?: string | null, duration?: number | null } | null, downloads?: { __typename?: 'VideoSeriesItem_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, videoSeriesCategories?: { __typename?: 'VideoSeriesItemToVideoSeriesCategoryConnection', nodes?: Array<{ __typename?: 'VideoSeriesCategory', id: string, name?: string | null } | null> | null } | null };

export type TagSummaryFragment = { __typename?: 'Tag', id: string, name?: string | null };

export type CategorySummaryFragment = { __typename?: 'Category', id: string, name?: string | null };

export type PostSummaryFragment = { __typename?: 'Post', id: string, title?: string | null, excerpt?: string | null, content?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, tags?: { __typename?: 'PostToTagConnection', nodes?: Array<{ __typename?: 'Tag', id: string, name?: string | null } | null> | null } | null, author?: { __typename?: 'NodeWithAuthorToUserConnectionEdge', node?: { __typename?: 'User', firstName?: string | null, lastName?: string | null } | null } | null, customAuthor?: { __typename?: 'Post_Customauthor', displayAuthor?: boolean | null, authorName?: string | null } | null, categories?: { __typename?: 'PostToCategoryConnection', nodes?: Array<{ __typename?: 'Category', id: string, name?: string | null } | null> | null } | null };

export type PodcastSummaryFragment = { __typename?: 'Podcast', id: string, name: string, thumbnail: string, publishedDate: string, mediaUrl: string, author: string, description?: string | null, episodeNumber: number };

export type EbookSummaryFragment = { __typename?: 'Ebook', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, downloads?: { __typename?: 'Ebook_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, ebooksCategories?: { __typename?: 'EbookToEbooksCategoryConnection', nodes?: Array<{ __typename?: 'EbooksCategory', id: string, name?: string | null } | null> | null } | null };

export type ResearchSummaryDetailsFragment = { __typename?: 'ResearchSummary', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, downloads?: { __typename?: 'ResearchSummary_Downloads', file?: { __typename?: 'MediaItem', mediaItemUrl?: string | null } | null } | null, researchSummariesCategories?: { __typename?: 'ResearchSummaryToResearchSummariesCategoryConnection', nodes?: Array<{ __typename?: 'ResearchSummariesCategory', id: string, name?: string | null } | null> | null } | null };

export type WebinarSummaryFragment = { __typename?: 'Webinar', id: string, title?: string | null, excerpt?: string | null, date?: string | null, featuredImage?: { __typename?: 'NodeWithFeaturedImageToMediaItemConnectionEdge', node?: { __typename?: 'MediaItem', mediaItemUrl?: string | null, srcSet?: string | null } | null } | null, youtube?: { __typename?: 'Webinar_Youtube', url?: string | null, duration?: number | null } | null, webinarsCategories?: { __typename?: 'WebinarToWebinarsCategoryConnection', nodes?: Array<{ __typename?: 'WebinarsCategory', id: string, name?: string | null } | null> | null } | null };

export type CourseTrainerInfoFragment = { __typename?: 'course_trainer', id: any, status?: Course_Invite_Status_Enum | null, type: Course_Trainer_Type_Enum, profile: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null } };

export type WaitlistSummaryFragment = { __typename?: 'waitlist', id: any, email: string, phone: string, orgName: string, courseId: number, confirmed: boolean, createdAt: any, givenName: string, familyName: string };

export type XeroPhoneSummaryFragment = { __typename?: 'XeroPhone', phoneCountryCode?: string | null, phoneAreaCode?: string | null, phoneNumber?: string | null, phoneType: XeroPhoneType };

export type XeroAddressSummaryFragment = { __typename?: 'XeroAddress', addressType?: XeroAddressType | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null };

export type XeroContactSummaryFragment = { __typename?: 'XeroContact', name: string, firstName?: string | null, lastName?: string | null, emailAddress?: string | null, phones?: Array<{ __typename?: 'XeroPhone', phoneCountryCode?: string | null, phoneAreaCode?: string | null, phoneNumber?: string | null, phoneType: XeroPhoneType } | null> | null, addresses?: Array<{ __typename?: 'XeroAddress', addressType?: XeroAddressType | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null } | null> | null };

export type XeroItemSummaryFragment = { __typename?: 'XeroItem', itemID: string, code: string };

export type XeroLineItemSummaryFragment = { __typename?: 'XeroLineItem', description?: string | null, quantity: number, unitAmount: number, itemCode: string, accountCode?: string | null, taxType: string, taxAmount: number, lineAmount: number, item?: { __typename?: 'XeroItem', itemID: string, code: string } | null, tracking?: Array<{ __typename?: 'XeroTrackingCategory', name: string, option: string }> | null };

export type XeroInvoiceSummaryFragment = { __typename?: 'XeroInvoice', date: string, total: number, status: XeroInvoiceStatus, dueDate?: string | null, subTotal?: number | null, totalTax?: number | null, invoiceID: string, amountDue?: string | null, reference?: string | null, amountPaid?: string | null, currencyCode: Currency, invoiceNumber?: string | null, fullyPaidOnDate?: string | null, contact: { __typename?: 'XeroContact', name: string, firstName?: string | null, lastName?: string | null, emailAddress?: string | null, phones?: Array<{ __typename?: 'XeroPhone', phoneCountryCode?: string | null, phoneAreaCode?: string | null, phoneNumber?: string | null, phoneType: XeroPhoneType } | null> | null, addresses?: Array<{ __typename?: 'XeroAddress', addressType?: XeroAddressType | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null } | null> | null }, lineItems: Array<{ __typename?: 'XeroLineItem', description?: string | null, quantity: number, unitAmount: number, itemCode: string, accountCode?: string | null, taxType: string, taxAmount: number, lineAmount: number, item?: { __typename?: 'XeroItem', itemID: string, code: string } | null, tracking?: Array<{ __typename?: 'XeroTrackingCategory', name: string, option: string }> | null } | null> };

export type EstablishmentFragment = { __typename?: 'dfe_establishment', id: any, urn: string, name: string, localAuthority: string, trustType?: string | null, trustName?: string | null, addressLineOne?: string | null, addressLineTwo?: string | null, addressLineThree?: string | null, town?: string | null, county?: string | null, postcode?: string | null, headTitle?: string | null, headFirstName?: string | null, headLastName?: string | null, headJobTitle?: string | null, ofstedRating?: string | null, ofstedLastInspection?: string | null };

export type GetUserCanAccessResourcesQueryVariables = Exact<{
  profileId?: InputMaybe<Scalars['uuid']['input']>;
}>;


export type GetUserCanAccessResourcesQuery = { __typename?: 'query_root', certificates: { __typename?: 'course_certificate_aggregate', aggregate?: { __typename?: 'course_certificate_aggregate_fields', count: number } | null }, participant: { __typename?: 'course_participant_aggregate', aggregate?: { __typename?: 'course_participant_aggregate_fields', count: number } | null } };

export type OrgLicensesWithHistoryQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
  withHistory?: InputMaybe<Scalars['Boolean']['input']>;
  withMainOrg?: InputMaybe<Scalars['Boolean']['input']>;
}>;


export type OrgLicensesWithHistoryQuery = { __typename?: 'query_root', organization_by_pk?: { __typename?: 'organization', id: any, go1Licenses?: number | null, reservedGo1Licenses?: number | null, go1LicensesHistory?: Array<{ __typename?: 'go1_licenses_history', id: any, captured_at: any, event: Go1_History_Events_Enum, payload?: any | null, balance: number, reservedBalance: number, change: number }>, resourcePacks: Array<{ __typename?: 'organization_resource_packs', resourcePacksType: Resource_Packs_Type_Enum, totalResourcePacks: number }>, go1LicensesHistory_aggregate?: { __typename?: 'go1_licenses_history_aggregate', aggregate?: { __typename?: 'go1_licenses_history_aggregate_fields', count: number } | null }, main_organisation?: { __typename?: 'organization', id: any, go1Licenses?: number | null, reservedGo1Licenses?: number | null, go1LicensesHistory?: Array<{ __typename?: 'go1_licenses_history', id: any, captured_at: any, event: Go1_History_Events_Enum, payload?: any | null, balance: number, reservedBalance: number, change: number }>, go1LicensesHistory_aggregate?: { __typename?: 'go1_licenses_history_aggregate', aggregate?: { __typename?: 'go1_licenses_history_aggregate_fields', count: number } | null } } | null } | null };

export type GetOrgWithKeyContactsQueryVariables = Exact<{
  id: Scalars['uuid']['input'];
}>;


export type GetOrgWithKeyContactsQuery = { __typename?: 'query_root', organization?: { __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, members: Array<{ __typename?: 'organization_member', profile: { __typename?: 'profile', id: any, givenName?: string | null, country?: string | null, countryCode?: string | null, familyName?: string | null, fullName?: string | null, avatar?: string | null, title?: string | null, tags?: any | null, addresses: any, attributes: any, contactDetails: any, dietaryRestrictions?: string | null, disabilities?: string | null, archived?: boolean | null, preferences: any, createdAt: any, updatedAt: any, email?: string | null, phone?: string | null, phoneCountryCode?: string | null, dob?: any | null, jobTitle?: string | null, lastActivity?: any | null, organizations: Array<{ __typename?: 'organization_member', id: any, isAdmin?: boolean | null, position?: string | null, organization: { __typename?: 'organization', id: any, name: string, tags?: any | null, contactDetails: any, attributes: any, address: any, preferences: any, createdAt: any, xeroContactId?: string | null, sector?: string | null, geoCoordinates?: any | null, organisationType?: string | null, affiliated_organisations: Array<{ __typename?: 'organization', id: any, name: string, address: any }>, main_organisation?: { __typename?: 'organization', id: any, name: string } | null } }>, roles: Array<{ __typename?: 'profile_role', role: { __typename?: 'role', id: any, name: string } }>, trainer_role_types: Array<{ __typename?: 'profile_trainer_role_type', trainer_role_type: { __typename?: 'trainer_role_type', id: any, name: string } }>, profile_trainer_agreement_types: Array<{ __typename?: 'profile_trainer_agreement_type', agreement_type: Trainer_Agreement_Type_Enum, id: any }> } }>, main_organisation?: { __typename?: 'organization', id: any, name: string } | null } | null };

export type ProfileManagedOrganizationsQueryVariables = Exact<{
  profileId: Scalars['uuid']['input'];
}>;


export type ProfileManagedOrganizationsQuery = { __typename?: 'query_root', organization_member: Array<{ __typename?: 'organization_member', id: any, organization: { __typename?: 'organization', id: any, external_dashboard_url?: string | null, name: string } }> };

export type GetProfileOrgsWithDashboardLinkQueryVariables = Exact<{
  profileId: Scalars['uuid']['input'];
}>;


export type GetProfileOrgsWithDashboardLinkQuery = { __typename?: 'query_root', organization_member: Array<{ __typename?: 'organization_member', id: any, organization: { __typename?: 'organization', id: any, external_dashboard_url?: string | null, name: string } }> };

export type GetPromoCodesQueryVariables = Exact<{
  orderBy?: InputMaybe<Array<Promo_Code_Order_By> | Promo_Code_Order_By>;
  where?: InputMaybe<Promo_Code_Bool_Exp>;
  limit?: InputMaybe<Scalars['Int']['input']>;
  offset?: InputMaybe<Scalars['Int']['input']>;
}>;


export type GetPromoCodesQuery = { __typename?: 'query_root', promoCodes: Array<{ __typename?: 'promo_code', id: any, code: string, description?: string | null, type: Promo_Code_Type_Enum, amount: any, validFrom: any, validTo?: any | null, bookerSingleUse: boolean, usesMax?: any | null, levels: any, disabled: boolean, enabled: boolean, approvedBy?: any | null, deniedBy?: any | null, createdBy: any, createdAt: any, updatedAt: any, courses: Array<{ __typename?: 'course_promo_code', course?: { __typename?: 'course', id: number, course_code?: string | null } | null }>, creator: { __typename?: 'profile', id: any, fullName?: string | null, avatar?: string | null, archived?: boolean | null } }>, promo_code_aggregate: { __typename?: 'promo_code_aggregate', aggregate?: { __typename?: 'promo_code_aggregate_fields', count: number } | null } };

export type InsertSubmissionOfKnowledgeHubCertificateSplashScreenMutationVariables = Exact<{
  profileId: Scalars['uuid']['input'];
  seenCount: Scalars['Int']['input'];
}>;


export type InsertSubmissionOfKnowledgeHubCertificateSplashScreenMutation = { __typename?: 'mutation_root', insert_submission_of_splash_screens_one?: { __typename?: 'submission_of_splash_screens', id: any, seen_count?: number | null } | null };

export type InsertSubmissionOfSplashScreenMutationVariables = Exact<{
  profileId: Scalars['uuid']['input'];
  splashScreen: Splash_Screens_Enum;
  seenCount?: InputMaybe<Scalars['Int']['input']>;
}>;


export type InsertSubmissionOfSplashScreenMutation = { __typename?: 'mutation_root', insert_submission_of_splash_screens_one?: { __typename?: 'submission_of_splash_screens', id: any } | null };

export type GetXeroInvoicesForOrdersQueryVariables = Exact<{
  invoiceNumbers: Array<Scalars['String']['input']> | Scalars['String']['input'];
}>;


export type GetXeroInvoicesForOrdersQuery = { __typename?: 'query_root', invoices: Array<{ __typename?: 'XeroInvoice', date: string, total: number, status: XeroInvoiceStatus, dueDate?: string | null, subTotal?: number | null, totalTax?: number | null, invoiceID: string, amountDue?: string | null, reference?: string | null, amountPaid?: string | null, currencyCode: Currency, invoiceNumber?: string | null, fullyPaidOnDate?: string | null, contact: { __typename?: 'XeroContact', name: string, firstName?: string | null, lastName?: string | null, emailAddress?: string | null, phones?: Array<{ __typename?: 'XeroPhone', phoneCountryCode?: string | null, phoneAreaCode?: string | null, phoneNumber?: string | null, phoneType: XeroPhoneType } | null> | null, addresses?: Array<{ __typename?: 'XeroAddress', addressType?: XeroAddressType | null, addressLine1?: string | null, addressLine2?: string | null, city?: string | null, region?: string | null, postalCode?: string | null, country?: string | null } | null> | null }, lineItems: Array<{ __typename?: 'XeroLineItem', description?: string | null, quantity: number, unitAmount: number, itemCode: string, accountCode?: string | null, taxType: string, taxAmount: number, lineAmount: number, item?: { __typename?: 'XeroItem', itemID: string, code: string } | null, tracking?: Array<{ __typename?: 'XeroTrackingCategory', name: string, option: string }> | null } | null> } | null> };

export type GetXeroInvoicesStatusQueryVariables = Exact<{
  input: XeroInvoicesStatusInput;
}>;


export type GetXeroInvoicesStatusQuery = { __typename?: 'query_root', xeroInvoicesStatus?: { __typename?: 'XeroInvoicesStatusOutput', invoices: Array<{ __typename?: 'XeroInvoiceStatusKV', invoiceNumber: string, status: XeroInvoiceStatus } | null> } | null };
